webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ClassificationCategoriesBase = /** @class */ (function () {
    function ClassificationCategoriesBase(classificationCategoriesService, popupService, $timeout, enumService) {
        var _this = this;
        this.classificationCategoriesService = classificationCategoriesService;
        this.popupService = popupService;
        this.$timeout = $timeout;
        this.enumService = enumService;
        this.categories = [];
        this.isLivel3Exist = false;
        this.selectedCategory = function (category) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var isSelected, confirm_1, parent_1, flatten, liveChildCategories, ids, confirm_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isSelected = category.selected;
                        if (!this.singleSelect) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.confirmSelectedCategoryBrands(category)];
                    case 1:
                        confirm_1 = _a.sent();
                        if (confirm_1) {
                            parent_1 = category.ParentID ? _.find(this.flattenCategories, function (item) {
                                return item.ID === category.ParentID;
                            }) : null;
                            flatten = parent_1 ? this.classificationCategoriesService.flattenCategories(parent_1.Subcategories) :
                                this.flattenCategories;
                            _.forEach(flatten, function (item) {
                                item.selected = false;
                                if (_this.isLiveCategory(item)) {
                                    _this.changeLiveCategory(item);
                                }
                            });
                        }
                        else {
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.updateSiblings(category, isSelected);
                        if (!isSelected) return [3 /*break*/, 3];
                        this.selectedCategoriesToParent(category);
                        if (this.isLiveCategory(category)) {
                            this.changeLiveCategory(category);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        liveChildCategories = this.getLiveCategories(category);
                        ids = _.pluck(liveChildCategories, 'ID');
                        return [4 /*yield*/, this.confirmSelectedCategoryBrands(category, ids)];
                    case 4:
                        confirm_2 = _a.sent();
                        if (confirm_2) {
                            this.unselectChildCategories(category);
                        }
                        else {
                            return [2 /*return*/];
                        }
                        _a.label = 5;
                    case 5:
                        this.validateSelectedNoLiveCategories();
                        this.isLivel3Exist = this.isLevel3Exist();
                        return [2 /*return*/];
                }
            });
        }); };
        this.confirmSelectedCategoryBrands = function (category, liveCategoryIDs) { return __awaiter(_this, void 0, void 0, function () {
            var categoryBrands, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.externalConfirm) {
                            return [2 /*return*/, true];
                        }
                        categoryBrands = _.filter(this.selectedCategories, function (categoryItem) {
                            return false; // _.any(category.Brands);
                        });
                        if (liveCategoryIDs) {
                            categoryBrands = _.filter(categoryBrands, function (categoryItem) {
                                return _.contains(liveCategoryIDs, categoryItem.CategoryID);
                            });
                        }
                        if (!(categoryBrands && !_.isEmpty(categoryBrands))) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: 'Remove category & brands',
                                content: '<p>Are you sure you want to remove this category & brands?</p>'
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        category.selected = !category.selected;
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/, true];
                }
            });
        }); };
        this.validateSelectedNoLiveCategories = function () {
            var selected = _.where(_this.flattenCategories, { selected: true });
            var selectedNoLiveCategories = _.filter(selected, function (category) {
                return !_this.isLiveCategory(category) && _.all(category.Subcategories, function (subCategory) {
                    return !subCategory.selected;
                });
            });
            if (!_this.errors) {
                _this.errors = {
                    selectedNoLiveCategories: null
                };
            }
            if (selectedNoLiveCategories) {
                _this.errors.selectedNoLiveCategories = _.pluck(selectedNoLiveCategories, 'Name');
            }
            else {
                _this.errors.selectedNoLiveCategories = null;
            }
        };
        this.selectedCategoriesToParent = function (category) {
            category.selected = true;
            if (category.ParentID) {
                while (category && category.ParentID) {
                    category = _.findWhere(_this.flattenCategories, { ID: category.ParentID });
                    if (!_.isUndefined(category)) {
                        category.selected = true;
                    }
                }
            }
        };
        this.getUrlFromName = function (category) {
            var split = category.FullName.split(' > ');
            for (var c = 0; c < _.size(split); c++) {
                split[c] = split[c].replace(/[\'\\\/\,\(\)]/g, '')
                    .replace(/&/g, 'and')
                    .replace(/\s{1,2}/g, '-')
                    .replace(/’/g, '').toLowerCase();
            }
            var purpleSplit = split.slice();
            var whiteSplit = split.slice();
            purpleSplit.splice(1, 0, 'purple');
            whiteSplit.splice(1, 0, 'white');
            return {
                purple: purpleSplit.join('/') + '.svg',
                white: whiteSplit.join('/') + '.svg'
            };
        };
    }
    ClassificationCategoriesBase.prototype.$onChanges = function (changes) {
        if (this.businessType) {
            this.adaptData();
        }
    };
    ClassificationCategoriesBase.prototype.isRootSelected = function () {
        return _.any(this.categories, function (category) {
            return category.selected;
        });
    };
    ClassificationCategoriesBase.prototype.isCategorySelected = function () {
        return _.any(this.selectedCategories);
    };
    ClassificationCategoriesBase.prototype.isLevel3Exist = function () {
        return _.any(this.flattenCategories, function (category) {
            return category.selected && category.Level === 2 && _.any(category.Subcategories);
        });
    };
    ClassificationCategoriesBase.prototype.adaptData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, _c, root, _i, _d, level1Value, level1ID, _e, _f, level2Value, level2ID, _g, _h, level3Value, level3ID, addCategories, parentsHide;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _a = this;
                        _c = (_b = angular).copy;
                        return [4 /*yield*/, this.getCategoriesTree()];
                    case 1:
                        _a.categories = _c.apply(_b, [_j.sent()]);
                        if (!this.businessType) {
                            return [2 /*return*/, console.warn('Business type is undefined')];
                        }
                        if (this.enumService.BusinessType.All === this.businessType) {
                            this.isShowAll = true;
                        }
                        else {
                            this.categories = _.filter(this.categories, function (item) { return item.Type === _this.businessType; });
                            if (this.subcategoryId) {
                                _.forEach(this.categories, function (category) {
                                    category.Subcategories = _.filter(category.Subcategories, function (item) { return item.ID === _this.subcategoryId; });
                                });
                            }
                            root = _.first(this.categories);
                            if (root) {
                                root.selected = true;
                            }
                        }
                        this.errors = {
                            selectedNoLiveCategories: null
                        };
                        if (!this.selectedCategories) {
                            this.selectedCategories = [];
                        }
                        /*  _.forEach(this.selectedCategories, (category) => {
                             category.type = this.classificationCategoriesService.categoryType;
                         }); */
                        for (_i = 0, _d = this.categories; _i < _d.length; _i++) {
                            level1Value = _d[_i];
                            level1ID = level1Value.ID;
                            for (_e = 0, _f = level1Value.Subcategories; _e < _f.length; _e++) {
                                level2Value = _f[_e];
                                level2ID = level2Value.ID;
                                if (level2Value.Subcategories && level2Value.Subcategories.length > 0) {
                                    for (_g = 0, _h = level2Value.Subcategories; _g < _h.length; _g++) {
                                        level3Value = _h[_g];
                                        level3ID = level3Value.ID;
                                        level3Value.logoPurple = "/assets/images/classificationCategory/" + level1ID + "/purple/" + level2ID + "/" + level3ID + ".svg";
                                        level3Value.logoWhite = "/assets/images/classificationCategory/" + level1ID + "/white/" + level2ID + "/" + level3ID + ".svg";
                                    }
                                }
                                else {
                                    level2Value.logoPurple = "/assets/images/classificationCategory/" + level1ID + "/purple/" + level2ID + ".svg";
                                    level2Value.logoWhite = "/assets/images/classificationCategory/" + level1ID + "/white/" + level2ID + ".svg";
                                }
                            }
                        }
                        this.flattenCategories = this.classificationCategoriesService.flattenCategories(this.categories);
                        addCategories = [];
                        _.forEach(this.flattenCategories, function (category) {
                            if (category.Level === 2 && _.isEmpty(category.Subcategories)) {
                                category.emulateLiveCategory = true;
                                var copy = angular.copy(category);
                                copy.Level = 3;
                                addCategories.push(copy);
                                category.Subcategories = [copy];
                            }
                        });
                        this.flattenCategories = this.flattenCategories.concat(addCategories);
                        parentsHide = [];
                        _.forEach(this.flattenCategories, function (category) {
                            category.hide = false;
                            if (category.ParentID) {
                                parentsHide.push(category.ParentID);
                            }
                        });
                        parentsHide = _.uniq(parentsHide);
                        _.forEach(parentsHide, function (id) {
                            var parentCategory = _.findWhere(_this.flattenCategories, { ID: id });
                            if (parentCategory) {
                                parentCategory.hide = _.all(parentCategory.Subcategories, function (subcategory) {
                                    return subcategory.hide;
                                });
                            }
                        });
                        this.$timeout();
                        this.setSelectedClassificationCategories();
                        this.isLivel3Exist = this.isLevel3Exist();
                        return [2 /*return*/];
                }
            });
        });
    };
    ClassificationCategoriesBase.prototype.setSelectedClassificationCategories = function () {
        var _this = this;
        var selectedCategoryIDs = _.pluck(this.selectedCategories, 'CategoryID');
        if (selectedCategoryIDs.length === 0) {
            var selectedCategory = _.filter(this.flattenCategories, function (category) {
                return category.ID == null;
            });
            _.forEach(selectedCategory, this.selectedCategoriesToParent);
        }
        else {
            var selectedCategory = _.filter(this.flattenCategories, function (category) {
                return _.contains(selectedCategoryIDs, category.ID);
            });
            _.forEach(selectedCategory, this.selectedCategoriesToParent);
            _.forEach(selectedCategory, function (category) {
                _this.updateSiblings(category, true);
            });
        }
    };
    ClassificationCategoriesBase.prototype.changeLiveCategory = function (category) {
        var _this = this;
        var changeModel = category.selected;
        if (category.selected) {
            if (this.singleSelect) {
                this.selectedCategories.splice(0, this.selectedCategories.length);
            }
            this.selectedCategories.push({
                CategoryID: category.ID,
                CategoryFullName: category.FullName,
                ParentID: category.ParentID
            });
        }
        else {
            this.selectedCategories = _.reject(this.selectedCategories, function (item) {
                var equal = item.CategoryID === category.ID;
                if (equal) {
                    changeModel = true;
                }
                return equal;
            });
        }
        if (changeModel) {
            this.$timeout(function () { return _this.changeCategory({ item: category }); });
        }
    };
    ClassificationCategoriesBase.prototype.unselectChildCategories = function (category) {
        var _this = this;
        category.selected = false;
        if (this.isLiveCategory(category)) {
            this.changeLiveCategory(category);
        }
        _.forEach(category.Subcategories, function (subcategory) {
            subcategory.selected = false;
            if (_this.isLiveCategory(category)) {
                _this.changeLiveCategory(subcategory);
            }
            else {
                _this.unselectChildCategories(subcategory);
            }
        });
    };
    ClassificationCategoriesBase.prototype.getLiveCategories = function (category) {
        var _this = this;
        var result = [];
        if (category.Subcategories || _.isEmpty(category.Subcategories)) {
            result = [category];
        }
        if (category.Subcategories) {
            _.forEach(category.Subcategories, function (subcategory) {
                result = result.concat(_this.getLiveCategories(subcategory));
            });
        }
        return result;
    };
    ClassificationCategoriesBase.prototype.isLiveCategory = function (category) {
        return category.emulateLiveCategory || !category.Subcategories || _.isEmpty(category.Subcategories);
    };
    ClassificationCategoriesBase.prototype.updateSiblings = function (category, isSelected) {
        if (category.emulateLiveCategory) {
            var siblings = _.where(this.flattenCategories, { ID: category.ID });
            _.forEach(siblings, function (item) { item.selected = isSelected; });
        }
    };
    ClassificationCategoriesBase.$inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    return ClassificationCategoriesBase;
}());
exports.ClassificationCategoriesBase = ClassificationCategoriesBase;


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
__webpack_require__(12);
var translation_1 = __webpack_require__(6);
var module = angular.module('app.retailes.common', ['treeControl', 'textAngular', 'pascalprecht.translate']);
translation_1.mixinTranslation(module, ['en', 'no'], 'retailer.common');
var tsContext = __webpack_require__(58);
tsContext.keys().forEach(tsContext);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var ApiServiceBase = /** @class */ (function () {
    function ApiServiceBase(serviceUrl, siteAddressUrl, serviceCdnUrl) {
        this.serviceUrl = serviceUrl;
        this.siteAddressUrl = siteAddressUrl;
        this.serviceCdnUrl = serviceCdnUrl;
        this.images = '/images/';
        this.authToken = 'auth/token';
    }
    ApiServiceBase.prototype.getUrl = function (url) {
        return "" + this.serviceUrl + url;
    };
    ApiServiceBase.prototype.getCDNUrl = function (url) {
        return "" + this.serviceCdnUrl + url;
    };
    ApiServiceBase.prototype.wysiwygImage = function (guid) {
        if (guid) {
            return this.getUrl("image/" + encodeURIComponent(guid));
        }
        else {
            return this.getUrl('image');
        }
    };
    ApiServiceBase.prototype.wysiwygImageCopy = function () {
        return this.getUrl('image/copy');
    };
    ApiServiceBase.prototype.getWysiwygImageUrl = function (guid) {
        return this.siteAddressUrl + "images/commonImage/" + encodeURIComponent(guid);
    };
    ApiServiceBase.prototype.getCampaignImageUrl = function (id, width, height) {
        if (width && height) {
            return this.getUrl('campaigns/image/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getCDNUrl('campaigns/image/' + id);
        }
    };
    ApiServiceBase.prototype.getCampaignThumbnailImageUrl = function (id, width, height) {
        if (width && height) {
            return this.getUrl('campaigns/video/' + id + '/thumbnail?width=' + width + '&height=' + height);
        }
        else {
            return this.getUrl('campaigns/video/' + id + '/thumbnail');
        }
    };
    ApiServiceBase.prototype.getCampaignVideoContentUrl = function (id) {
        return this.getUrl('campaigns/video/' + id + '/contentMp4');
    };
    ApiServiceBase.prototype.getSiteAddressUrl = function () {
        return this.siteAddressUrl;
    };
    return ApiServiceBase;
}());
exports.ApiServiceBase = ApiServiceBase;


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _ = __webpack_require__(1);
var CategoriesServiceBase = /** @class */ (function () {
    function CategoriesServiceBase(http) {
        this.http = http;
        this.list = null;
        this.tree = {};
    }
    CategoriesServiceBase.prototype.getTree = function (languageId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.tree[languageId]) return [3 /*break*/, 2];
                        _a = this.tree;
                        _b = languageId;
                        return [4 /*yield*/, this.http.get(this.getApiUrl())];
                    case 1:
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [2 /*return*/, this.tree[languageId]];
                }
            });
        });
    };
    CategoriesServiceBase.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tree;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.list) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getTree(1)];
                    case 1:
                        tree = _a.sent();
                        this.list = this.flattenCategories(tree);
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.list];
                }
            });
        });
    };
    CategoriesServiceBase.prototype.flattenCategories = function (categories) {
        var _this = this;
        var flatten = [];
        categories.forEach(function (category) {
            flatten = flatten.concat(_this.flattenCategory(category));
        });
        return flatten;
    };
    CategoriesServiceBase.prototype.flattenCategory = function (category) {
        var _this = this;
        var result = [category];
        if (category.Subcategories) {
            _.forEach(category.Subcategories, function (subcategory) {
                result = result.concat(_this.flattenCategory(subcategory));
            });
        }
        return result;
    };
    return CategoriesServiceBase;
}());
exports.CategoriesServiceBase = CategoriesServiceBase;


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

module.exports = "<h3  translate=\"403_access_denied\" translate-default=\"403 - Access denied\">403 - Access denied</h3>\n<h4 translate=\"access_denied_text\" translate-default=\"Sorry, you’re not allowed to access this page.\">Sorry, you’re not allowed to access this page.</h4>";

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "<h3 translate=\"404_not_found\"></h3>\n<h4 translate=\"not_found_text\">\n</h4>";

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _ = __webpack_require__(1);
var JispPayPlacesBase = /** @class */ (function () {
    function JispPayPlacesBase($translate) {
        var _this = this;
        this.$translate = $translate;
        this.waiting = false;
        this.places = null;
        this.jispPayMerchants = [];
        this.defaultMerchants = [];
        this.isPlacesAny = null;
        this.edit = {
            isOpenEdit: false,
            retailerID: null,
            showRefundPassword: false,
            model: {
                RefundPassword: '',
                JispPayMerchantID: null,
                Enabled: true,
                isPasswordExist: false,
                selectedMerchant: null
            },
            error: {
                merchant: null,
                password: null,
                clean: function () {
                    var i = _this.edit.error;
                    i.merchant = null;
                    i.password = null;
                },
                isEmpty: function () {
                    var i = _this.edit.error;
                    return _.isEmpty(i.merchant) && _.isEmpty(i.password);
                }
            },
            setModel: function (place) {
                var i = _this.edit.model;
                i.JispPayMerchantID = place ? place.JispPayMerchantID : null,
                    i.isPasswordExist = place ? place.IsRefundPasswordExist : false;
                i.RefundPassword = place.refundPassword ? place.refundPassword : '';
                i.selectedMerchant = i.JispPayMerchantID ? _.find(_this.jispPayMerchants, function (merchant) {
                    return merchant.ID === i.JispPayMerchantID;
                }) : null;
                _this.edit.error.clean();
            }
        };
        this.placeEdit = function (place, showPassword, retailerID) {
            if (retailerID === void 0) { retailerID = null; }
            place.isOpenEdit = true;
            _this.edit.isOpenEdit = true;
            _this.edit.showRefundPassword = showPassword;
            _this.edit.retailerID = retailerID;
            _this.edit.setModel(place);
            if (_this.edit.showRefundPassword) {
                _this.edit.model.isPasswordExist = false;
            }
        };
        this.cancelEdit = function (place) {
            place.isOpenEdit = false;
            _this.edit.isOpenEdit = false;
            _this.edit.setModel(place);
            if (!place.IsRefundPasswordExist) {
                place.Enabled = false;
            }
        };
    }
    JispPayPlacesBase.prototype.isValidEditModel = function (place) {
        var required = this.$translate.instant('field_is_required');
        var i = this.edit;
        i.error.clean();
        // merchant
        if (!_.isNumber(i.model.JispPayMerchantID)) {
            i.error.merchant = required;
        }
        // password
        i.model.RefundPassword = this.trim(i.model.RefundPassword);
        var size = _.size(i.model.RefundPassword);
        if (!place.IsRefundPasswordExist && size === 0) {
            i.error.password = required;
        }
        else if (size > 0 && size < 8) {
            i.error.password = this.$translate.instant('password_too_short_8');
        }
        else if (size > 20) {
            i.error.password = this.$translate.instant('password_too_long_20');
        }
        return i.error.isEmpty();
    };
    JispPayPlacesBase.prototype.trim = function (str) {
        return str ? str.trim() : '';
    };
    return JispPayPlacesBase;
}());
exports.JispPayPlacesBase = JispPayPlacesBase;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var VoucherTypesEnum;
(function (VoucherTypesEnum) {
    VoucherTypesEnum[VoucherTypesEnum["FixedAmount"] = 1] = "FixedAmount";
    VoucherTypesEnum[VoucherTypesEnum["FreeDelivery"] = 2] = "FreeDelivery";
    VoucherTypesEnum[VoucherTypesEnum["Percent"] = 3] = "Percent";
})(VoucherTypesEnum = exports.VoucherTypesEnum || (exports.VoucherTypesEnum = {}));
var VoucherStatusEnum;
(function (VoucherStatusEnum) {
    VoucherStatusEnum[VoucherStatusEnum["Draft"] = 1] = "Draft";
    VoucherStatusEnum[VoucherStatusEnum["Published"] = 2] = "Published";
})(VoucherStatusEnum = exports.VoucherStatusEnum || (exports.VoucherStatusEnum = {}));


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var api_serviceBase_1 = __webpack_require__(11);
var RetailerServiceBase = /** @class */ (function (_super) {
    __extends(RetailerServiceBase, _super);
    function RetailerServiceBase(retailerServiceUrl, siteAddressUrl, apiCDNUrlRetailer) {
        var _this = _super.call(this, retailerServiceUrl, siteAddressUrl, apiCDNUrlRetailer) || this;
        _this.retailerServiceUrl = retailerServiceUrl;
        _this.siteAddressUrl = siteAddressUrl;
        _this.apiCDNUrlRetailer = apiCDNUrlRetailer;
        return _this;
    }
    RetailerServiceBase.prototype.auth = function () {
        return this.getUrl(this.authToken);
    };
    RetailerServiceBase.prototype.classificationCategories = function () {
        return this.getUrl('classificationcategories');
    };
    RetailerServiceBase.prototype.classificationCategoriesForInventory = function () {
        return this.getUrl('classificationcategories/forInventory');
    };
    RetailerServiceBase.prototype.classificationCategoriesForRules = function () {
        return this.getUrl('classificationcategories/forRules');
    };
    RetailerServiceBase.prototype.classificationCategoriesSearch = function () {
        return this.getUrl('classificationcategories/search');
    };
    RetailerServiceBase.prototype.getTimelineProductImageUrl = function (id, width, height) {
        if (width && height) {
            return this.getUrl('timeline/product/image/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getUrl('timeline/product/image/' + id);
        }
    };
    RetailerServiceBase.prototype.country = function () {
        return this.getUrl('profile/country');
    };
    RetailerServiceBase.$inject = ['retailerServiceUrl', 'siteAddressUrl', 'apiCDNUrlRetailer'];
    return RetailerServiceBase;
}(api_serviceBase_1.ApiServiceBase));
exports.RetailerServiceBase = RetailerServiceBase;
angular
    .module('app.retailes.common')
    .service('commonRetailerService', RetailerServiceBase);


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "<span ng-bind-html=\"vm.activeDate\"></span> ";

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "<span ng-class=\"{'control-label fontNormal': vm.allDaily == true}\" ng-bind=\"vm.activeTime\"></span>";

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "<span ng-bind='vm.message'></span>";

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.campaign.Image\" class=\"imgCampainWrap\">\n    <div class=\"form-group m0 imgCampain paddingTemlate widthSelector campaign-overview-head\">\n        <i class=\"fa fa-picture-o\" aria-hidden=\"true\"></i>\n        <img ng-src=\"{{ vm.campaign.Image }}\" alt=\"\" height=\"140\" />\n    </div>\n</div>\n<div ng-if=\"vm.campaign.Video\" class=\"imgCampainWrap\">\n    <div class=\"form-group m0 imgCampain paddingTemlate widthSelector campaign-overview-head\">\n        <i class=\"fa fa-film\" aria-hidden=\"true\"></i>\n        <img ng-src=\"{{ vm.campaign.Video }}\" alt=\"\" width=\"280\" height=\"140\" />\n    </div>\n</div>\n<div ng-if=\"!vm.campaign.Image && !vm.campaign.Video\" class=\"imgCampainWrap\">\n    <span class=\"fa fa-image fa-custom-placeholder \"></span>\n</div>\n\n<div class=\"camp-type\">\n    <campaign-type ng-if=\"vm.campaign.Type != $root.enums.CampaignType.Advert\" exclusive=\"vm.campaign.JispExclusive\" type=\"vm.campaign.Type\"></campaign-type>\n</div>\n<h3 title=\"{{vm.campaign.Name}}\"><span>{{ ::vm.campaign.Name | limitTo: 48 }} {{::vm.campaign.Name.length > 48 ? '...' : ''}}</span></h3>\n\n<div class=\"createDate\" translate=\"created_on\" translate-value-date=\"{{vm.campaign.CreateDate | date:'dd MMM yyyy'}}\"></div>\n<div class=\"dateCampaign\">\n    <div class=\"inner\">\n        <campaign-status status=\"vm.campaign.Status\" message=\"vm.campaign.StatusMessage\" class=\"width1\"></campaign-status>\n        <span class=\"td30\">\n            <campaign-active-date start-date=\"vm.campaign.StartDate\" end-date=\"vm.campaign.EndDate\" wrapping=\"true\"> </campaign-active-date>\n        </span>\n    </div>\n</div>\n<div ng-if=\"vm.campaign.Type != $root.enums.CampaignType.Advert\" class=\"dateActiveCampaign\">\n    <campaign-active-time  start-time=\"vm.campaign.DailyStartTime\" end-time=\"vm.campaign.DailyEndTime\"> </campaign-active-time>\n</div>\n<div class=\"weeksdaysCampaign\" translate=\"reoccurs_every_weekdays\"  translate-value-weekdays=\"{{vm.campaign.weeksdays}}\"></div>\n\n<div ng-show=\"vm.showCompetition\" class=\"competition\">\n    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\">\n        <label for=\"campaign{{vm.campaign.ID}}\" title=\"Competition\">\n            <input id=\"campaign{{vm.campaign.ID}}\" ng-model=\"vm.campaign.Competition\" type=\"checkbox\">\n            <span class=\"fa fa-check\"></span>\n            <ng-container translate=\"competition\" ></ng-container>\n        </label>\n    </div>\n</div>\n\n<div ng-hide=\"vm.showCompetition\" class=\"viewCampaign\">\n    <span ng-show=\"vm.campaign.Views && vm.campaign.Views > 0\"><span class=\"fa fa-eye\"></span> <ng-pluralize count=\"vm.campaign.Views\" when=\"{'': '0 views', 1: '{} view', 'other': '{} views'}\"></ng-pluralize></span>\n    <span ng-show=\"vm.campaign.Clicks && vm.campaign.Clicks > 0\"><span class=\"fa fa-hand-o-up\"></span> <ng-pluralize count=\"vm.campaign.Clicks\" when=\"{'': '0 clicks', 1: '{} click', 'other': '{} clicks'}\"></ng-pluralize></span>\n</div>\n";

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "<script>\n    $(function () {\n        $(\".touch .app-container\").click(function (e) {\n            $('.tooltip').hide();\n        });\n    });\n</script>\n<span class=\"statusBg {{vm.statusModel.class}}\" >\n    {{vm.statusModel.title}} <a ng-if=\"vm.isShowTooltip()\" ng-click=\"$event.stopPropagation()\" href=\"javascript:void(0)\"\n             tooltip-animation=\"true\"\n             tooltip-trigger=\"focus\"\n             tooltip-popup-delay=\"200\"\n             tooltip-placement=\"top\"\n             tooltip-append-to-body=\"true\"\n             uib-tooltip-html=\"vm.getMessage()\">\n        <em class=\"fa fa-question-circle\"></em>\n    </a>\n</span>";

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "<span ng-bind=\"vm.getMessage()\"></span>";

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"vm.daysOfWeek\" class=\"weeksdaysCampaign\" translate=\"reoccurs_every_weekdays\"  translate-value-weekdays=\"{{vm.daysOfWeek}}\"></div>\n";

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"caretNo tableSelect width196 pull-left\" ng-class=\"{'mr0': vm.all.length === 0, 'noPadBottom': vm.filtered.length <= vm.top.length}\">\n         <ui-select  name=\"availableBrand\" ng-model=\"vm.model\" on-select=\"vm.onSelect($item);\"\n            theme=\"bootstrap\" reset-search-input=\"true\" search-enabled=\"false\"  ng-disabled=\"vm.waiting\" style=\"width:100%\">\n            <ui-select-match autocomplete=\"off\" class=\"ui-select-match\" placeholder=\"{{ vm.getFilteredPlaceholder() }}\">\n                {{ $select.selected.MerchantID }}\n            </ui-select-match>\n            <ui-select-choices repeat=\"merchant in vm.filtered\" refresh=\"vm.refreshFiltered($select.search)\" refresh-delay=\"3\" style=\"overflow: visible;\">\n                <div ng-bind-html=\"merchant.MerchantID | highlight: $select.search\"></div>\n                <div ng-show=\"vm.allowAdd && vm.newMerchantID\" ng-click=\"vm.addNew()\" class=\"addLine\">\n                    <span translate=\"add_merchant\"  translate-value-newMerchantID=\"{{ vm.newMerchantID }}\"></span>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n";

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = "<!-- START panel-->\n<div ng-if=\"!vm.place.isOpenEdit\" class=\"panel\">\n    <div class=\"panel-heading\">\n        <h2>{{vm.place.Name}}</h2>\n        <h3>{{vm.place.Town}}</h3>\n        <button ng-click=\"vm.placeEdit(vm.place)\" ng-show=\"vm.place.Enabled\"\n            ng-disabled=\"vm.waiting || vm.edit.isOpenEdit\" class=\"fa fa-pencil btn btn-link\"></button>\n    </div>\n    <div class=\"panel-body\">\n        <div class=\"form-group mb10\">\n            <label class=\"control-label\" translate=\"jisppay_enabled\"></label>\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <label class=\"switch switch-success posRel\">\n                        <input type=\"checkbox\" ng-click=\"vm.placeEnabled(vm.place)\"\n                            ng-disabled=\"vm.waiting || vm.edit.isOpenEdit\" ng-model=\"vm.place.Enabled\">\n                        <span></span>\n                    </label>\n                </div>\n            </div>\n        </div>\n        <div ng-show=\"vm.place.IsRefundPasswordExist && vm.place.Enabled\">\n            <div class=\"form-group mb10\">\n                <label class=\"control-label\" translate=\"merchant_id\"></label>\n                <div class=\"posRel\">\n                    <div class=\"form-control-static m0 p0\">\n\n                        <span title=\"{{vm.place.merchantID}}\" ng-bind=\"vm.place.merchantID\"></span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"form-group m0\">\n                <label class=\"control-label mr15\" translate=\"refund_password\"></label>\n                <div class=\"posRel\">\n                    <div class=\"form-control-static m0 p0 pl15\">\n                        <span>••••••••••••</span>\n                        <button class=\"btnChange\" ng-disabled=\"vm.waiting || vm.edit.isOpenEdit\"\n                            ng-click=\"vm.edit.isOpenEdit ? null : vm.placeEdit(vm.place, true)\"\n                            translate=\"button_change\"></button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<!-- EN panel-->\n<form name=\"jisppayform\" ng-if=\"vm.place.isOpenEdit\" class=\"panel editCase\" autocomplete=\"off\" novalidate>\n    <div class=\"panel-heading\">\n        <h2>{{vm.place.Name}}</h2>\n        <h3>{{vm.place.Town}}</h3>\n        <span class=\"fa fa-pencil\"></span>\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"vm.save(vm.place)\" ng-disabled=\"vm.waiting || jisppayform.$pristine\"\n                class=\"btn btn-success pull-right\" translate=\"button_save\">\n            </button>\n            <button type=\"button\" ng-click=\"vm.cancelEdit(vm.place)\" ng-disabled=\"vm.waiting\"\n                class=\"btn btn-danger  pull-right\" translate=\"button_cancel\">\n            </button>\n        </div>\n    </div>\n    <div class=\"panel-body\">\n        <div class=\"form-group\">\n            <label class=\"control-label inline-block\">\n                <ng-content translate=\"merchant_id\"></ng-content>\n            </label>\n            <div class=\"posRel inline-block width196 ml15\">\n                <div class=\"form-control-static m0 p0 merchandIDDiv\">\n                    <jisp-pay-merchant-selector ng-show=\"vm.admineMode\" allow-add=\"false\"\n                        default-merchant-ids=\"vm.defaultMerchants\" existing-merchants=\"vm.jispPayMerchants\"\n                        model=\"vm.edit.model.selectedMerchant\"></jisp-pay-merchant-selector>\n\n                    <select ng-model=\"vm.edit.model.selectedMerchant\" ng-show=\"!vm.admineMode\"\n                        ng-options=\"item.MerchantID for item in vm.jispPayMerchants track by item.ID\"\n                        ng-change=\"vm.edit.model.JispPayMerchantID = vm.edit.model.selectedMerchant.ID; vm.isPreviousEditAccount()\"\n                        class=\"form-control\"></select>\n\n                </div>\n                <span class=\"text-danger\" ng-show=\"vm.edit.error.merchant\" ng-bind=\"vm.edit.error.merchant\"></span>\n            </div>\n        </div>\n        <div class=\"form-group m0\">\n            <label class=\"control-label inline-block\">\n                <ng-content translate=\"refund_password\"></ng-content>\n            </label>\n            <div class=\"posRel inline-block width196 ml15\">\n                <div ng-hide=\"vm.edit.model.isPasswordExist\" class=\"form-control-static m0 p0 passwordField\"\n                    ng-class=\"{'showPassword': !vm.edit.showRefundPassword}\">\n                    <input ng-disabled=\"!vm.edit.model.selectedMerchant\" type=\"password\" autocapitalize=\"off\"\n                    autocomplete=\"new-password\" ng-model=\"vm.edit.model.RefundPassword\" placeholder=\"••••••••••••\"\n                    class=\"form-control\">\n                    <input ng-disabled=\"!vm.edit.model.selectedMerchant\" type=\"text\"\n                    ng-model=\"vm.edit.model.RefundPassword\" placeholder=\"••••••••••••\" class=\"form-control\">\n                    <span ng-if=\"vm.edit.model.selectedMerchant\"\n                        ng-click=\"vm.toggleInput()\" class=\"fa fa-eye\"></span>\n                </div>\n                <div ng-show=\"vm.edit.model.isPasswordExist\" class=\"form-control-static m0 p0 editPass pl15\">\n                    <span>••••••••••••</span>\n                    <button class=\"btnChange\" ng-click=\"vm.edit.model.isPasswordExist = false\" ng-disabled=\"vm.waiting\"\n                        translate=\"button_change\"></button>\n                </div>\n                <span class=\"text-danger\" ng-show=\"vm.edit.error.password\" ng-bind=\"vm.edit.error.password\"></span>\n            </div>\n        </div>\n    </div>\n</form>";

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sellCategories\">\n    <h1 ng-if=\"vm.categories.length == 0\" translate=\"load_categories\" ></h1>\n    <div ng-repeat=\"category in vm.categories\">\n        <div ng-if=\"subcategory.Subcategories.length > 0\" class=\"sellCategoriesLine\" ng-repeat=\"subcategory in category.Subcategories \" ng-class=\"{'classification-categories__livecategory' : subcategory.emulateLiveCategory}\">\n            <h3 ng-bind=\"subcategory.Name\" class=\"fs-18\"></h3>\n            <div class=\"clearfix\">\n                <div ng-repeat=\"livecategory in subcategory.Subcategories\">\n                    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\" ng-click=\"vm.onChecked($event, livecategory)\">\n                        <label for=\"checkbox{{livecategory.ID}}\" title=\"{{livecategory.Name}}\">\n                            <input type=\"checkbox\" id=\"checkbox{{livecategory.ID}}\" ng-disabled=\"vm.waiting\" ng-change=\"vm.selectedCategory(livecategory)\"\n                                ng-model=\"livecategory.selected\"  />\n                            <span class=\"fa fa-check\"></span>\n                            <i class=\"inner\">\n                                <img class=\"showCheck\" ng-src=\"{{livecategory.logoPurple}}\" width=\"50\" height=\"50\" />\n                                <img class=\"hideCheck\" ng-src=\"{{livecategory.logoWhite}}\" width=\"50\" height=\"50\" />\n                                <em class=\"text\">{{livecategory.Name}}</em>\n                            </i>\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "<h2 translate=\"category_classification_title\" ng-hide=\"vm.singleSelect || vm.hideTitles\" class=\"classification-categories__heading\"></h2>\n<!-- <div>vm.categories</div> -->\n<div ng-show=\"vm.isShowAll\">\n    <div class=\"flexVerticalAlignParent flex-wrap mb12 classification-categories__root\">\n        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded clearfix wd-sd mb12\" ng-repeat=\"category in vm.categories\">\n            <label for=\"checkbox{{category.ID}}\" title=\"{{category.Name}}\">\n                <input id=\"checkbox{{category.ID}}\" ng-change=\"vm.selectedCategory(category)\" ng-disabled=\"vm.waiting || vm.isDisabled\"\n                    ng-model=\"category.selected\" type=\"checkbox\" />\n                <span class=\"fa fa-check\"></span>\n                {{category.Name}}\n            </label>\n        </div>\n    </div>\n</div>\n\n<div ng-hide=\"vm.isShowAll && !vm.isRootSelected()\">\n\n    <div class=\"flex-align-start flex-wrap classification-categories__subcategories\" ng-repeat=\"category in vm.categories | filter:{ selected: true, hide: false }\">\n        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded wd-sd\" ng-repeat=\"subCategory in category.Subcategories | filter:{ hide: false } \">\n            <label for=\"checkbox{{subCategory.ID}}\" title=\"{{subCategory.Name}}\">\n                <input id=\"checkbox{{subCategory.ID}}\"\n                       ng-change=\"vm.selectedCategory(subCategory)\"\n                       ng-disabled=\"vm.waiting || vm.isDisabled\"\n                       ng-model=\"subCategory.selected\"\n                       type=\"checkbox\" />\n                <span class=\"fa fa-check\"></span>\n                {{subCategory.Name}}\n            </label>\n        </div>\n    </div>\n\n    <div ng-show=\"vm.isLivel3Exist\" class=\"sellCategories\">\n        <h2 translate=\"what_product_categories_do_you_sell\" ng-hide=\"vm.singleSelect || vm.hideTitles\" class=\"classification-categories__heading\"></h2>\n        <div ng-repeat=\"category in vm.categories\">\n            <div ng-if=\"subcategory.Subcategories.length > 0\" class=\"sellCategoriesLine\" ng-repeat=\"subcategory in category.Subcategories | filter:{ selected: true, hide: false }\" ng-class=\"{'classification-categories__livecategory' : subcategory.emulateLiveCategory}\">\n                <h3 ng-bind=\"subcategory.Name\" class=\"classification-categories__subtitle\"></h3>\n                <div class=\"clearfix\">\n                    <div ng-repeat=\"livecategory in subcategory.Subcategories | filter:{ hide: false }\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\">\n                            <label for=\"checkbox{{subcategory.ID}}_{{livecategory.ID}}\" title=\"{{livecategory.Name}}\">\n                                <input type=\"checkbox\" id=\"checkbox{{subcategory.ID}}_{{livecategory.ID}}\"\n                                       ng-disabled=\"vm.waiting || vm.isDisabled\"\n                                       ng-change=\"vm.selectedCategory(livecategory)\"\n                                       ng-model=\"livecategory.selected\" />\n                                <span class=\"fa fa-check\"></span>\n                                <i class=\"inner\">\n                                    <img class=\"showCheck\" ng-src=\"{{livecategory.logoPurple}}\" width=\"50\" height=\"50\" />\n                                    <img class=\"hideCheck\" ng-src=\"{{livecategory.logoWhite}}\" width=\"50\" height=\"50\" />\n                                    <em class=\"text\">{{livecategory.Name}}</em>\n                                </i>\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if=\"!vm.isShowAll && !vm.isCategorySelected()\">\n            <span translate=\"classification_categories_not_selected\">\n                Please choose the main products and services above to select their categories.\n            </span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"ctrl.add()\" ng-disabled=\"ctrl.selectedCategories.length === 0 && !ctrl.selectedCategory || ctrl.waiting || ctrl.countToAdd() > ctrl.maxCategoriesCount\" class=\"btn btn-success btn-with-line\">\n                <em class=\"fa fa-check\"></em>\n                <span ng-hide=\"ctrl.resolve.options.singleSelect\">\n                    <span translate=\"add_count\"  translate-value-countToAdd=\"{{ctrl.countToAdd()}}\"></span>\n                    <ng-pluralize count=\"ctrl.countToAdd()\" when=\"{'1': 'category', other: 'categories'}\"></ng-pluralize>\n                </span>\n                <span ng-show=\"ctrl.resolve.options.singleSelect\" translate=\"select_category\"></span>\n                <span ng-if=\"ctrl.resolve.options.showPrices\" \n                    translate=\"with_total_price\"\n                    translate-value-totalPrice=\"{{ ctrl.totalPrice() | formatCurrency: ctrl.countryID }}\"></span>\n\n            </button>\n            <button type=\"button\" ng-disabled=\"ctrl.waiting\" ng-click=\"ctrl.discard()\" class=\"btn btn-danger btn-with-line\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\" ></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\">\n        <span ng-hide=\"ctrl.resolve.options.singleSelect\" translate=\"select_the_categories_to_add\" ></span>\n        <span ng-show=\"ctrl.resolve.options.singleSelect\" translate=\"select_the_category\" ></span>\n    </div>\n</div>\n<div class=\"modal-body\">\n    <form name=\"categoriesform\" novalidate>\n        <div ng-show=\"ctrl.recentlyUsedCategories.all.length > 0 && ctrl.resolve.options.singleSelect\" class=\"recentlyUsedCategList\">\n            <h5 translate=\"recently_used_categories\" ></h5>\n            <label ng-repeat=\"category in ctrl.recentlyUsedCategories.all\">\n                <input type=\"radio\" name=\"recentlyUsedCategory\" ng-model=\"ctrl.recentlyUsedCategories.selected\" ng-click=\"ctrl.recentlyUsedCategoryClick()\" ng-value=\"category\" />\n                <span class=\"font21Block\"></span>\n                <span class=\"fa-circle\"></span>\n                <span ng-bind=\"category.FullName\"></span>\n            </label>\n        </div>\n        <div class=\"underCategList\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Search for product category\" ng-change=\"ctrl.filterCategories()\" ng-model=\"ctrl.keywords\" ng-model-options='{ debounce: 500 }' />\n            <div ng-show=\"ctrl.countToAdd() > ctrl.maxCategoriesCount\" class=\"text-danger\"\n                translate=\"please_reduce_the_number_of_selected_categories\"\n                \n                translate-value-maxCategoriesCount=\"{{ ctrl.maxCategoriesCount }}\"\n                translate-value-countToAdd=\"{{ ctrl.countToAdd() }}\">\n            </div>\n        </div>\n        <div class=\"popupCategoryHeight changeOnlyInventoryTree\">\n            <treecontrol class=\"tree-classic\"\n                         tree-model=\"ctrl.categories\"\n                         selected-nodes=\"ctrl.selectedCategories\"\n                         options=\"ctrl.treeOptions\"\n                         filter-expression=\"ctrl.categoryMatch\"\n                         on-selection=\"ctrl.selectCategory(node, selected, $parentNode)\"\n                         expanded-nodes=\"ctrl.expandedNodes\"\n                         on-node-toggle=\"ctrl.nodeToggle(node, expanded, $parentNode, $index)\">\n                <span ng-class=\"{ 'caseWithPrise': ctrl.resolve.options.showPrices && node.Subcategories.length === 0 }\">\n                    <span class=\"fa\" ng-class=\"{'fa-check': !(ctrl.resolve.options.singleSelect && ctrl.resolve.options.leafOnly), 'fa-circle': (ctrl.resolve.options.singleSelect && ctrl.resolve.options.leafOnly), 'lastCateg': node.Subcategories.length === 0 }\"></span>\n                    <span class=\"font21Block\"></span>{{ node.Name }}\n                    <span ng-if=\"ctrl.resolve.options.showPrices && node.Subcategories.length === 0\" class=\"pricePerDay\"\n                        translate=\"advert_price_per_day\" \n                        translate-value-advertPrice=\"{{ node.AdvertPrice | formatCurrency: ctrl.countryID }}\"></span>\n                </span>\n            </treecontrol>\n            <div ng-show=\"ctrl.filteredCount === 0\" class=\"anymatch\" \n                translate=\"keywords_didnt_match_any_categories\"\n                \n                translate-value-keywords=\"{{ctrl.keywords}}\">\n            </div>\n        </div>\n    </form>\n</div>\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n<script type=\"text/javascript\">\n    function popupCategoryHeight()\n    {\n        $('.popupCategoryHeight').css('height', ($(window).height() - $('.underCategList').outerHeight() - $('.recentlyUsedCategList').outerHeight() - 160) + 'px');\n    }\n    popupCategoryHeight();\n    $(window).resize(function ()\n    {\n        popupCategoryHeight();\n    });\n</script>";

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"!ctrl.resolve.options.isOnlyStoreCategories\" class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"ctrl.select()\" ng-disabled=\"ctrl.waiting || ctrl.isPristine()\"\n                class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"save_selection\" ></span>\n            </button> <!-- ng-disabled=\"ctrl.isPristine() || ctrl.waiting\" -->\n            <button type=\"button\" ng-disabled=\"ctrl.waiting\" ng-click=\"ctrl.discard()\" class=\"btn btn-danger btn-with-icon\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\" ></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\" translate=\"select_product_category\" ></div>\n</div>\n<div class=\"modal-body classification-categories p0\">\n    <div class=\"pr24 pl24 pt10 pb10\" ng-if=\"!ctrl.resolve.options.isOnlyStoreCategories\">\n    <classification-categories selected-categories=\"ctrl.resolve.options.selectedCategories\" single-select=\"ctrl.resolve.options.singleSelect\"\n        business-type=\"ctrl.resolve.options.businessType\" change-category=\"ctrl.changeClassificationCategory()\" external-confirm=\"true\"\n        subcategory-id=\"ctrl.resolve.options.subcategoryId\"\n        errors=\"classificationCategoriesErrors\"\n        waiting=\"ctrl.waiting\" language-id=\"ctrl.resolve.languageId\"></classification-categories>\n    </div>\n</div>\n\n<div ng-if=\"ctrl.resolve.options.isOnlyStoreCategories\" class=\"modal-content\">\n    <div class=\"modal-header modal-header--categories\">\n        <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close close--categories\" ng-click=\"ctrl.discard()\">×</button>\n        <h3 class=\"modal-title\">Choose category</h3>\n    </div>\n    <div class=\"modal-body modalWithScroll modal-body--categories\">\n        <div class=\"pr30 pl30 pt10 pb10 modal-body-inner--categories\" ng-if=\"ctrl.resolve.options.isOnlyStoreCategories\" >\n            <classification-categories-for-store selected-categories=\"ctrl.resolve.options.selectedCategories\" single-select=\"ctrl.resolve.options.singleSelect\"\n                business-type=\"ctrl.resolve.options.businessType\" change-category=\"ctrl.changeClassificationCategory()\" external-confirm=\"true\"\n                errors=\"classificationCategoriesErrors\"\n                waiting=\"ctrl.waiting\" get-tree=\"ctrl.resolve.options.getCategoriesTree\" on-select=\"ctrl.select\"></classification-categories-for-store>\n        </div>\n    </div>\n</div>\n\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CampaignActiveDate = /** @class */ (function () {
    CampaignActiveDate.$inject = ["$filter"];
    function CampaignActiveDate($filter) {
        this.$filter = $filter;
    }
    CampaignActiveDate.prototype.$onChanges = function (changes) {
        if (!this.startDate && !this.endDate) {
            this.activeDate = 'Runs permanently';
        }
        else if (!this.endDate && this.startDate) {
            this.activeDate = "Runs from " + this.$filter('date')(this.startDate, 'd MMM yyyy');
        }
        else if (!this.startDate && this.endDate) {
            this.activeDate = "Runs till " + this.$filter('date')(this.endDate, 'd MMM yyyy');
        }
        else if (this.endDate && this.startDate) {
            this.activeDate = "Runs from " + this.$filter('date')(this.startDate, 'd MMM yyyy') + "\n            " + (this.wrapping ? '<br />' : ' ') + "till " + this.$filter('date')(this.endDate, 'd MMM yyyy');
        }
        else {
            this.activeDate = null;
        }
    };
    return CampaignActiveDate;
}());
angular
    .module('app.retailes.common')
    .component('campaignActiveDate', {
    template: __webpack_require__(23),
    controller: CampaignActiveDate,
    controllerAs: 'vm',
    bindings: {
        startDate: '<',
        endDate: '<',
        wrapping: '<'
    }
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var CampaignActiveTime = /** @class */ (function () {
    function CampaignActiveTime(campaignsService, $translate) {
        this.campaignsService = campaignsService;
        this.$translate = $translate;
        this.defaultStartTime = '12:00 AM';
        this.defaultEndTime = '12:00 PM';
        this.minTime = '00:00';
    }
    CampaignActiveTime.prototype.$onChanges = function (changes) {
        this.allDaily = !this.endTime && !this.startTime;
        var startTime = this.startTime ? this.getTime(this.startTime === this.minTime ? this.defaultStartTime : this.startTime) : this.defaultStartTime;
        var endTime = this.endTime ? this.getTime(this.endTime === this.minTime ? this.defaultEndTime : this.endTime) : this.defaultEndTime;
        if ((startTime === this.defaultStartTime && endTime === this.minTime) ||
            (startTime === this.minTime && endTime === this.defaultEndTime) ||
            (startTime === endTime)) {
            this.allDaily = true;
        }
        this.activeTime = this.allDaily
            ? this.$translate.instant('active_all_day')
            : this.$translate.instant('active_between', { startTime: startTime, endTime: endTime });
    };
    CampaignActiveTime.prototype.getTime = function (stringTime) {
        return moment(this.campaignsService.getDateTime(null, stringTime)).format('hh:mm A');
    };
    CampaignActiveTime.$inject = ['commonCampaignsService', '$translate'];
    return CampaignActiveTime;
}());
angular
    .module('app.retailes.common')
    .component('campaignActiveTime', {
    template: __webpack_require__(24),
    controller: CampaignActiveTime,
    controllerAs: 'vm',
    bindings: {
        startTime: '<',
        endTime: '<'
    }
});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var CampaignKeywords = /** @class */ (function () {
    function CampaignKeywords() {
    }
    CampaignKeywords.prototype.$onChanges = function (changes) {
        if (changes.keywords && changes.keywords.currentValue) {
            var keywords = _.pluck(changes.keywords.currentValue, 'keyword');
            this.message = keywords.join('; ');
        }
        else {
            this.message = null;
        }
    };
    return CampaignKeywords;
}());
angular
    .module('app.retailes.common')
    .component('campaignKeywords', {
    template: __webpack_require__(25),
    controller: CampaignKeywords,
    controllerAs: 'vm',
    bindings: {
        keywords: '<'
    }
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CampaignOverview = /** @class */ (function () {
    function CampaignOverview() {
    }
    return CampaignOverview;
}());
angular
    .module('app.retailes.common')
    .component('campaignOverview', {
    template: __webpack_require__(26),
    controller: CampaignOverview,
    controllerAs: 'vm',
    bindings: {
        campaign: '<',
        waiting: '<',
        showCompetition: '<',
        showAdventCalendarParams: '<'
    }
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var CampaignStatus = /** @class */ (function () {
    function CampaignStatus(enumService) {
        this.enumService = enumService;
        var running = {
            status: enumService.CampaignStatus.Running,
            "class": 'bg-success',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Running)
        };
        var draft = {
            status: enumService.CampaignStatus.Draft,
            "class": 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Draft)
        };
        var adSubmission = {
            status: enumService.CampaignStatus.AdSubmission,
            "class": 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.AdSubmission)
        };
        var qualityControl = {
            status: enumService.CampaignStatus.QualityControl,
            "class": 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.QualityControl)
        };
        var archived = {
            status: enumService.CampaignStatus.Archived,
            "class": 'bg-black',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Archived)
        };
        var completed = {
            status: enumService.CampaignStatus.Completed,
            "class": 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Completed)
        };
        var error = {
            status: enumService.CampaignStatus.Error,
            "class": 'bg-danger tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Error)
        };
        var disabled = {
            status: enumService.CampaignStatus.Disabled,
            "class": 'bg-amber',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Disabled)
        };
        var warning = {
            status: enumService.CampaignStatus.Warning,
            "class": 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Warning)
        };
        var scheduled = {
            status: enumService.CampaignStatus.Scheduled,
            "class": 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.Scheduled)
        };
        var videoProcessing = {
            status: enumService.CampaignStatus.VideoProcessing,
            "class": 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.VideoProcessing)
        };
        var videoProcessingError = {
            status: enumService.CampaignStatus.VideoProcessingError,
            "class": 'bg-warning tooltip-white tooltip-shops',
            title: enumService.CampaignStatus.getName(enumService.CampaignStatus.VideoProcessingError)
        };
        this.campaignStatuses = [running, draft, adSubmission, qualityControl, archived, completed, error, disabled, warning, scheduled, videoProcessing, videoProcessingError];
    }
    CampaignStatus.prototype.$onChanges = function (changes) {
        var _this = this;
        if (this.status) {
            this.statusModel = _.find(this.campaignStatuses, function (item) {
                return item.status === _this.status;
            });
        }
    };
    CampaignStatus.prototype.isShowTooltip = function () {
        return this.message && !_.isEmpty(this.message);
    };
    CampaignStatus.prototype.getMessage = function () {
        if (this.message) {
            return "<div>" + this.message + "</div>";
        }
        else {
            return null;
        }
    };
    CampaignStatus.$inject = ['enumService'];
    return CampaignStatus;
}());
angular
    .module('app.retailes.common')
    .component('campaignStatus', {
    template: __webpack_require__(27),
    controller: CampaignStatus,
    controllerAs: 'vm',
    bindings: {
        status: '<',
        message: '<'
    }
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var CampaignType = /** @class */ (function () {
    CampaignType.$inject = ["enumService"];
    function CampaignType(enumService) {
        this.enumService = enumService;
        this.campaignsType = ['', 'offer', 'promotion', 'advertisement', 'flash sale', 'event', 'voucher', 'referral offer', 'advent promotion', 'hero offer'];
        this.jispExclusive = 'Jisp exclusive ';
    }
    CampaignType.prototype.getMessage = function () {
        var type = this.campaignsType[this.type];
        var addExclusive = (this.exclusive && (this.type < this.enumService.CampaignType.ExclusiveOffer));
        return (addExclusive ? this.jispExclusive : '') + (addExclusive ? type : this.capitalise(type));
    };
    CampaignType.prototype.capitalise = function (msg) {
        return (msg && _.size(msg) > 1) ? (msg.charAt(0).toUpperCase() + msg.slice(1).toLowerCase()) : '';
    };
    return CampaignType;
}());
angular
    .module('app.retailes.common')
    .component('campaignType', {
    template: __webpack_require__(28),
    controller: CampaignType,
    controllerAs: 'vm',
    bindings: {
        type: '<',
        exclusive: '<'
    }
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var DaysOfWeek = /** @class */ (function () {
    function DaysOfWeek(campaignsService) {
        this.campaignsService = campaignsService;
    }
    DaysOfWeek.prototype.$onChanges = function (changes) {
        this.daysOfWeek = _.isNumber(this.days) ? this.campaignsService.getSelectdaysOfWeek(this.days) : null;
    };
    DaysOfWeek.$inject = ['commonCampaignsService'];
    return DaysOfWeek;
}());
angular
    .module('app.retailes.common')
    .component('daysOfWeek', {
    template: __webpack_require__(29),
    controller: DaysOfWeek,
    controllerAs: 'vm',
    bindings: {
        days: '<'
    }
});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var JispPayMerchantSelector = /** @class */ (function () {
    function JispPayMerchantSelector($q, $uibModal, $translate) {
        var _this = this;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.all = [];
        this.existingMerchants = [];
        this.filtered = [];
        this.newMerchantID = null;
        this.merchantIDsForSearch = [];
        this.$onInit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    Array.prototype.push.apply(this.all, this.existingMerchants);
                    _.forEach(this.defaultMerchantIds, function (merchant) {
                        if (_this.all.length === 0) {
                            _this.all.push(merchant);
                        }
                        var existing = _.filter(_this.all, function (item) {
                            return item.MerchantID === merchant.MerchantID;
                        });
                        if (existing.length === 0) {
                            _this.all.push(merchant);
                        }
                    });
                    this.setMerchantForSearch();
                    this.refreshFiltered();
                }
                catch (error) {
                    console.warn(error);
                }
                return [2 /*return*/];
            });
        }); };
        this.updateData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setMerchantForSearch();
                this.refreshAvailable();
                return [2 /*return*/];
            });
        }); };
    }
    JispPayMerchantSelector.prototype.refreshFiltered = function (search) {
        var keywords = search || null;
        if (keywords && keywords.length > 0) {
            var reg_1 = new RegExp('^.*' + keywords + '.*', 'i');
            this.filtered = _.filter(this.merchantIDsForSearch, function (merchantID) {
                return reg_1.test(merchantID.MerchantID);
            });
        }
        else {
            this.filtered = this.merchantIDsForSearch;
        }
        var alreadyexists = [];
        Array.prototype.push.apply(alreadyexists, this.model);
        Array.prototype.push.apply(alreadyexists, this.merchantIDsForSearch);
        if ((keywords) && _.any(alreadyexists, function (merchant) { return merchant.MerchantID.toLowerCase() === keywords.toLowerCase(); })) {
            this.newMerchantID = '';
        }
        else {
            this.newMerchantID = keywords;
        }
        if (this.allowAdd && this.newMerchantID) {
            this.newMerchantID = this.newMerchantID.trim();
            if (this.newMerchantID.length > 2 && this.filtered.length === 0) {
                this.filtered.push({ MerchantID: '' });
            }
        }
    };
    JispPayMerchantSelector.prototype.getFilteredPlaceholder = function () {
        return this.$translate.instant('add_merchant');
    };
    JispPayMerchantSelector.prototype.onSelect = function (merchantID) {
        if (merchantID === this.newMerchantID) {
            return;
        }
        if (!this.model || this.model.MerchantID !== merchantID.MerchantID) {
            this.model = merchantID;
        }
        this.refreshAvailable();
    };
    JispPayMerchantSelector.prototype.addNew = function () {
        if (this.newMerchantID) {
            this.model = {
                ID: -1,
                MerchantID: this.newMerchantID
            };
            this.merchantIDsForSearch.push({ ID: -1, MerchantID: this.newMerchantID });
            this.onSelect(this.model);
        }
    };
    JispPayMerchantSelector.prototype.setMerchantForSearch = function () {
        this.merchantIDsForSearch = this.all;
    };
    JispPayMerchantSelector.prototype.refreshAvailable = function () {
        this.refreshFiltered();
    };
    JispPayMerchantSelector.$inject = ['$q', '$uibModal', '$translate'];
    return JispPayMerchantSelector;
}());
angular.module('app.retailes.common').component('jispPayMerchantSelector', {
    template: __webpack_require__(30),
    controller: JispPayMerchantSelector,
    controllerAs: 'vm',
    bindings: {
        allowAdd: '<',
        defaultMerchantIds: '<',
        existingMerchants: '<',
        model: '='
    }
});


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var JispPayPlace = /** @class */ (function () {
    function JispPayPlace() {
    }
    JispPayPlace.prototype.$onChanges = function (onChangesObj) {
        this.currentRefundPassword = this.edit.model.RefundPassword;
    };
    JispPayPlace.prototype.isPreviousEditAccount = function () {
        this.edit.model.RefundPassword =
            this.edit.model.JispPayMerchantID ===
                this.place.JispPayMerchantID
                ? this.currentRefundPassword
                : '';
    };
    JispPayPlace.prototype.toggleInput = function () {
        this.edit.showRefundPassword = !this.edit.showRefundPassword;
    };
    return JispPayPlace;
}());
angular.module('app.retailes.common').component('jisppayPlace', {
    template: __webpack_require__(31),
    controller: JispPayPlace,
    controllerAs: 'vm',
    bindings: {
        place: '<',
        jispPayMerchants: '<',
        defaultMerchants: '<',
        waiting: '<',
        placeEdit: '=',
        placeEnabled: '=',
        save: '=',
        cancelEdit: '=',
        edit: '=',
        admineMode: '<'
    }
});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var classification_categories_base_component_1 = __webpack_require__(7);
var ClassificationCategoriesForStore = /** @class */ (function (_super) {
    __extends(ClassificationCategoriesForStore, _super);
    function ClassificationCategoriesForStore(classificationCategoriesService, popupService, $timeout, enumService) {
        return _super.call(this, classificationCategoriesService, popupService, $timeout, enumService) || this;
    }
    ClassificationCategoriesForStore.prototype.getCategoriesTree = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTree()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClassificationCategoriesForStore.prototype.onChecked = function ($event, livecategory) {
        var _this = this;
        if (livecategory.selected) {
            $event.preventDefault();
        }
        this.$timeout(function () {
            _this.onSelect();
        }, 200);
    };
    ClassificationCategoriesForStore.$inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    return ClassificationCategoriesForStore;
}(classification_categories_base_component_1.ClassificationCategoriesBase));
angular
    .module('app.retailes.common')
    .component('classificationCategoriesForStore', {
    template: __webpack_require__(32),
    controller: ClassificationCategoriesForStore,
    controllerAs: 'vm',
    bindings: {
        selectedCategories: '=',
        businessType: '<',
        singleSelect: '<',
        waiting: '<',
        errors: '=',
        externalConfirm: '@',
        changeCategory: '&',
        hideWithoutPair: '@',
        getTree: '<',
        onSelect: '<'
    }
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var categories_service_1 = __webpack_require__(13);
var ClassificationCategoriesService = /** @class */ (function (_super) {
    __extends(ClassificationCategoriesService, _super);
    function ClassificationCategoriesService(http, commonRetailerService) {
        var _this = _super.call(this, http) || this;
        _this.commonRetailerService = commonRetailerService;
        _this.categoryType = 2;
        _this.categoriesWithParents = null;
        _this.getClassificationCategoriesForRules = function () {
            return _this.http.get(_this.commonRetailerService.classificationCategoriesForRules());
        };
        _this.categoriesSearch = function (keywords) {
            return _this.http.get(_this.commonRetailerService.classificationCategoriesSearch(), { params: { keywords: keywords } });
        };
        return _this;
    }
    ClassificationCategoriesService.prototype.getApiUrl = function () {
        return this.commonRetailerService.classificationCategoriesForInventory();
    };
    ClassificationCategoriesService.prototype.getWithParents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.categoriesWithParents) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getList()];
                    case 1:
                        list = _a.sent();
                        this.categoriesWithParents = [];
                        list.forEach(function (category) {
                            _this.categoriesWithParents[category.ID] = _this.toParent(category);
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.categoriesWithParents];
                }
            });
        });
    };
    ClassificationCategoriesService.prototype.getCountry = function () {
        return this.http.get(this.commonRetailerService.country()).then(function (country) {
            return country;
        });
    };
    ClassificationCategoriesService.prototype.toParent = function (category) {
        var list = [category.ID];
        while (category && category.ParentID) {
            category = _.findWhere(this.list, { ID: category.ParentID });
            if (!_.isUndefined(category)) {
                list.push(category.ID);
            }
        }
        return list;
    };
    ClassificationCategoriesService.$inject = ['http', 'commonRetailerService'];
    return ClassificationCategoriesService;
}(categories_service_1.CategoriesServiceBase));
exports.ClassificationCategoriesService = ClassificationCategoriesService;
angular
    .module('app.retailes.common')
    .service('classificationCategoriesService', ClassificationCategoriesService);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var classification_categories_base_component_1 = __webpack_require__(7);
var ClassificationCategories = /** @class */ (function (_super) {
    __extends(ClassificationCategories, _super);
    function ClassificationCategories(classificationCategoriesService, popupService, $timeout, enumService) {
        return _super.call(this, classificationCategoriesService, popupService, $timeout, enumService) || this;
    }
    ClassificationCategories.prototype.getCategoriesTree = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.classificationCategoriesService.getTree(this.languageId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClassificationCategories.$inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    return ClassificationCategories;
}(classification_categories_base_component_1.ClassificationCategoriesBase));
angular
    .module('app.retailes.common')
    .component('classificationCategories', {
    template: __webpack_require__(33),
    controller: ClassificationCategories,
    controllerAs: 'vm',
    bindings: {
        selectedCategories: '=',
        businessType: '<',
        subcategoryId: '<',
        singleSelect: '<',
        waiting: '<',
        errors: '=',
        externalConfirm: '@',
        changeCategory: '&',
        hideTitles: '<',
        isDisabled: '<',
        languageId: '<'
    }
});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SelectClassificationCategoriesTreeController = /** @class */ (function () {
    function SelectClassificationCategoriesTreeController($localStorage, categoriesService, notificationService) {
        var _this = this;
        this.$localStorage = $localStorage;
        this.categoriesService = categoriesService;
        this.notificationService = notificationService;
        this.modalInstance = this;
        this.filteredCount = null;
        this.selectedCategories = [];
        this.expandedNodes = [];
        this.categories = [];
        this.waiting = true;
        this.maxCategoriesCount = 100;
        this.keywords = null;
        this.recentlyUsedCategories = {
            all: [],
            selected: null,
            selectCategory: function (category, select) {
                var i = _this.recentlyUsedCategories;
                if (select) {
                    i.selected = _.findWhere(i.all, { ID: category.ID });
                }
                else {
                    i.selected = null;
                }
            }
        };
        this.treeOptions = {
            nodeChildren: 'Subcategories',
            dirSelectable: true,
            multiSelection: true,
            isSelectable: function (node) {
                var isSelectableStandart = (_this.resolve.options.selectedIDs || []).indexOf(node.ID) === -1;
                if (_this.resolve.options.singleSelect && _this.resolve.options.leafOnly) {
                    return isSelectableStandart && node.Subcategories.length === 0;
                }
                return isSelectableStandart;
            },
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'liSelected',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8'
            },
            equality: function (x, y) { return x === y; }
        };
        this.categoryMatch = function (category) {
            return category.CategoryMatch || category.SubcategoriesMatch;
        };
        this.add = function () {
            var categories = _this.getCategoriesToAdd();
            if (_this.resolve.options.singleSelect) {
                _this.setRecentlyUsedClassificationCategories(categories);
            }
            _this.modalInstance.close({
                $value: _this.resolve.options.singleSelect ? [categories[0]] : categories
            });
        };
        this.discard = function () {
            _this.modalInstance.dismiss({ $value: 'cancel' });
        };
        this.recentlyUsedCategoryClick = function () {
            if (_this.recentlyUsedCategories.selected) {
                _this.expandedNodes.push(_this.recentlyUsedCategories.selected);
                if (_this.resolve.options.singleSelect) {
                    _this.selectedCategories = [_this.recentlyUsedCategories.selected];
                }
            }
        };
        this.nodeToggle = function (node, expanded, parentNode, index) {
            if (!expanded) {
                _this.expandedNodes = _.without(_this.expandedNodes, node);
            }
        };
    }
    SelectClassificationCategoriesTreeController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var categories, flatten_1, promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        if (this.resolve.options.singleSelect && this.$localStorage.recentlyUsedClassificationCategories) {
                            this.resolve.options.recentlyUsedCategories = this.$localStorage.recentlyUsedClassificationCategories;
                        }
                        return [4 /*yield*/, this.categoriesService.getTree(this.resolve.languageId)];
                    case 1:
                        categories = _a.sent();
                        this.categories = this.getCategories(categories, this.resolve.options.excludedIDs || [], this.resolve.options.selectedIDs || []);
                        if (this.resolve.options.leafOnly && _.size(this.resolve.options.recentlyUsedCategories) > 0) {
                            flatten_1 = this.categoriesService.flattenCategories(this.categories);
                            _.forEach(this.resolve.options.recentlyUsedCategories, function (id) {
                                var category = _.findWhere(flatten_1, { ID: id });
                                if (category) {
                                    _this.recentlyUsedCategories.all.push(category);
                                }
                            });
                        }
                        this.waiting = false;
                        this.notificationService.clearAll();
                        promise = this.categoriesService.getCountry();
                        promise.then(function (result) {
                            _this.currencySign = result.CurrencySign;
                        });
                        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                        return [2 /*return*/];
                }
            });
        });
    };
    SelectClassificationCategoriesTreeController.prototype.countToAdd = function () {
        return this.getCategoriesToAdd().length;
    };
    SelectClassificationCategoriesTreeController.prototype.totalPrice = function () {
        return _.reduce(_.pluck(this.getCategoriesToAdd(), 'AdvertPrice'), function (x, y) {
            return x + y;
        }, 0);
    };
    SelectClassificationCategoriesTreeController.prototype.filterCategories = function () {
        var _this = this;
        var keywords = this.keywords;
        this.setCategoriesKeywordsMatch(keywords).then(function () {
            if (_this.resolve.options.leafOnly) {
                var selectedLeafCategories = _this.selectedCategories.filter(function (category) {
                    return category.Subcategories.length === 0;
                });
                _this.selectedCategories.forEach(_this.resetSelected);
                _this.selectedCategories = _this.getSelectedCategories(selectedLeafCategories);
                _this.selectedCategories.forEach(_this.setSelected);
            }
            _this.expandedNodes = [];
            if (!keywords) {
                _this.selectedCategories.forEach(function (category) {
                    var parent = category.Parent;
                    var added = false;
                    while (parent) {
                        if (added || _.difference(parent.Subcategories, _this.selectedCategories).length > 0) {
                            _this.expandedNodes.push(parent);
                            added = true;
                        }
                        parent = parent.Parent;
                    }
                });
                _this.expandedNodes = _.uniq(_this.expandedNodes);
            }
            var filtered = _this.categories.filter(_this.categoryMatch);
            var expandedCount = filtered.length;
            _this.filteredCount = filtered.length;
            filtered.forEach(function (category) {
                expandedCount = _this.setExpandedNodes(category, expandedCount);
            });
        });
    };
    SelectClassificationCategoriesTreeController.prototype.getCategories = function (categories, excludedIDs, selectedIDs) {
        var _this = this;
        var result = [];
        categories.forEach(function (category) {
            if (excludedIDs.indexOf(category.ID) === -1) {
                var subcategories = _this.getCategories(category.Subcategories, excludedIDs, selectedIDs);
                if (subcategories.length > 0 || category.Subcategories.length === 0) {
                    var mapped_1 = {
                        ID: category.ID,
                        ParentID: category.ParentID,
                        Name: category.Name,
                        FullName: category.FullName,
                        AdvertPrice: category.AdvertPrice,
                        Subcategories: subcategories,
                        CategoryMatch: true,
                        SubcategoriesMatch: true
                    };
                    mapped_1.Subcategories.forEach(function (subcategory) {
                        subcategory.Parent = mapped_1;
                    });
                    result.push(mapped_1);
                }
            }
        });
        return result;
    };
    SelectClassificationCategoriesTreeController.prototype.flatten = function (category) {
        return [category].concat(_.flatten(category.Subcategories.map(this.flatten), true));
    };
    SelectClassificationCategoriesTreeController.prototype.setSelected = function (category) {
        category.Selected = true;
    };
    SelectClassificationCategoriesTreeController.prototype.resetSelected = function (category) {
        category.Selected = false;
    };
    SelectClassificationCategoriesTreeController.prototype.setExpandedNodes = function (category, count) {
        var maxExpandedCount = 50;
        if (count < maxExpandedCount && !category.CategoryMatch && category.SubcategoriesMatch) {
            this.expandedNodes.push(category);
            var filtered = category.Subcategories.filter(this.categoryMatch);
            count += filtered.length;
            for (var i = 0; i < filtered.length && count < maxExpandedCount; i++) {
                count = this.setExpandedNodes(filtered[i], count);
            }
        }
        return count;
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoryMatch = function (category, matcher, parentMatch) {
        var _this = this;
        category.CategoryMatch = !matcher || parentMatch || matcher(category);
        category.Subcategories.forEach(function (subcategory) {
            _this.setCategoryMatch(subcategory, matcher, category.CategoryMatch);
        });
        category.SubcategoriesMatch = !matcher || category.CategoryMatch || _.some(category.Subcategories, this.categoryMatch);
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoriesMatch = function (matcher) {
        var _this = this;
        if (_.isArray(this.categories)) {
            this.categories.forEach(function (category) {
                _this.setCategoryMatch(category, matcher, false);
            });
        }
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoriesRegexMatch = function (regex) {
        this.setCategoriesMatch(function (category) {
            return regex.test(category.Name);
        });
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoriesIDsMatch = function (ids) {
        this.setCategoriesMatch(function (category) {
            return ids.indexOf(category.ID) !== -1;
        });
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoriesAllMatch = function () {
        this.setCategoriesMatch(function (category) {
            return true;
        });
    };
    SelectClassificationCategoriesTreeController.prototype.setCategoriesKeywordsMatch = function (keywords) {
        return __awaiter(this, void 0, void 0, function () {
            var ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!keywords || _.isEmpty(keywords)) {
                            this.setCategoriesAllMatch();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.categoriesService.categoriesSearch(keywords)];
                    case 1:
                        ids = _a.sent();
                        if (ids.length > 0) {
                            this.setCategoriesIDsMatch(ids);
                        }
                        else {
                            this.setCategoriesRegexMatch(new RegExp('\\b' + keywords + '.*', 'i'));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SelectClassificationCategoriesTreeController.prototype.getSelectedCategories = function (leafCategories) {
        var _this = this;
        var result = leafCategories;
        leafCategories.forEach(function (category) {
            var parent = category.Parent;
            while (parent && _.difference(parent.Subcategories.filter(_this.categoryMatch), result).length === 0) {
                result.push(parent);
                parent = parent.Parent;
            }
        });
        return _.uniq(result);
    };
    SelectClassificationCategoriesTreeController.prototype.selectNested = function (category) {
        var subcategories = this.flatten(category).filter(this.categoryMatch);
        subcategories.forEach(this.setSelected);
        this.selectedCategories = _.union(this.selectedCategories, subcategories);
    };
    SelectClassificationCategoriesTreeController.prototype.deselectNested = function (category) {
        var subcategories = this.flatten(category).filter(this.categoryMatch);
        subcategories.forEach(this.resetSelected);
        this.selectedCategories = _.difference(this.selectedCategories, subcategories);
    };
    SelectClassificationCategoriesTreeController.prototype.selectParent = function (category) {
        _.all(category.Parent.Subcategories, function (category) { return category.Selected === true; });
        while (category.Parent && _.all(category.Parent.Subcategories, function (category) { return category.Selected === true; })) {
            category = category.Parent;
            this.setSelected(category);
            this.selectedCategories.push(category);
        }
    };
    SelectClassificationCategoriesTreeController.prototype.deselectParent = function (category) {
        while (category.Parent && category.Parent.Selected) {
            category = category.Parent;
            this.resetSelected(category);
            this.selectedCategories = _.without(this.selectedCategories, category);
        }
    };
    SelectClassificationCategoriesTreeController.prototype.getCategoriesToAdd = function () {
        return this.resolve.options.leafOnly
            ? this.selectedCategories.filter(function (category) {
                return category.Subcategories.length === 0;
            })
            : this.selectedCategories;
    };
    SelectClassificationCategoriesTreeController.prototype.setRecentlyUsedClassificationCategories = function (categories) {
        var maxCount = 5;
        var recentlyUsedCategories = this.$localStorage.recentlyUsedClassificationCategories ? this.$localStorage.recentlyUsedClassificationCategories : [];
        _.forEach(categories, function (category) {
            recentlyUsedCategories = _.reject(recentlyUsedCategories, function (id) { return id === category.ID; });
            recentlyUsedCategories.unshift(category.ID);
        });
        this.$localStorage.recentlyUsedClassificationCategories = _.first(recentlyUsedCategories, maxCount);
    };
    SelectClassificationCategoriesTreeController.$inject = ['$localStorage', 'classificationCategoriesService', 'notificationService'];
    return SelectClassificationCategoriesTreeController;
}());
angular.module('app.retailes.common').component('selectClassificationCategoriesTree', {
    template: __webpack_require__(34),
    controller: SelectClassificationCategoriesTreeController,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SelectClassificationCategoriesController = /** @class */ (function () {
    function SelectClassificationCategoriesController(popupService, $translate) {
        var _this = this;
        this.popupService = popupService;
        this.$translate = $translate;
        this.modalInstance = this;
        this.select = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isRemoveBrands()) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('remove_category_and_brands'),
                                content: "<p>" + this.$translate.instant('remove_category_and_brands_confirm') + "</p>"
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        this.modalInstance.close({
                            $value: this.resolve.options.selectedCategories
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.discard = function () {
            _this.modalInstance.dismiss({ $value: 'cancel' });
        };
    }
    SelectClassificationCategoriesController.prototype.$onChanges = function (changes) {
        if (changes.resolve) {
            this.startSelectedCategories = this.resolve.options.selectedCategories;
        }
    };
    SelectClassificationCategoriesController.prototype.changeClassificationCategory = function () {
        return;
    };
    SelectClassificationCategoriesController.prototype.isPristine = function () {
        var _this = this;
        if (_.isEmpty(this.resolve.options.selectedCategories)) {
            return true;
        }
        else if (_.isEmpty(this.startSelectedCategories) && !_.isEmpty(this.resolve.options.selectedCategories)) {
            return false;
        }
        else if (!_.isEmpty(this.resolve.options.selectedCategories) && !_.isEmpty(this.startSelectedCategories)) {
            if (_.size(this.resolve.options.selectedCategories) === _.size(this.startSelectedCategories)) {
                return !_.any(this.resolve.options.selectedCategories, function (item) {
                    return !_.any(_this.startSelectedCategories, function (category) {
                        return category.CategoryID === item.CategoryID;
                    });
                });
            }
            else {
                return false;
            }
        }
        return true;
    };
    SelectClassificationCategoriesController.prototype.isRemoveBrands = function () {
        var ids = _.pluck(this.resolve.options.selectedCategories, 'CategoryID');
        var absence = _.filter(this.startSelectedCategories, function (category) {
            return !_.contains(ids, category.CategoryID);
        });
        return _.any(absence, function (item) {
            return false; // item.Brands && _.any(item.Brands);
        });
    };
    SelectClassificationCategoriesController.$inject = ['popupService', '$translate'];
    return SelectClassificationCategoriesController;
}());
angular.module('app.retailes.common').component('selectClassificationCategories', {
    template: __webpack_require__(35),
    controller: SelectClassificationCategoriesController,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function filterFunction($filter) {
    return function (store) {
        var values = [
            store.Town,
            store.AddressLine1
        ];
        return values.filter(function (value) {
            return !!value;
        }).join(', ');
    };
}
angular.module('app.common')
    .filter('storeAddress', ['$filter', filterFunction]);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var MAX_LENGTH = 15;
function trimStartFilter() {
    return function (input) {
        if (typeof input === 'string') {
            if (!input || input.length <= MAX_LENGTH) {
                return input;
            }
            return "..." + input.substr(input.length - MAX_LENGTH);
        }
        return null;
    };
}
angular
    .module('app.common')
    .filter('trimstart', trimStartFilter);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var RetailerCommonPopupService = /** @class */ (function () {
    function RetailerCommonPopupService($uibModal) {
        this.$uibModal = $uibModal;
    }
    RetailerCommonPopupService.prototype.categoriesSelector = function (excludedIDs, selectedIDs, showPrices, leafOnly, singleSelect, languageId) {
        return this.$uibModal.open({
            component: 'selectClassificationCategoriesTree',
            size: 'md',
            windowClass: 'categories-selector-popup',
            resolve: {
                options: function () {
                    return {
                        showPrices: showPrices,
                        excludedIDs: excludedIDs,
                        selectedIDs: selectedIDs,
                        leafOnly: leafOnly,
                        singleSelect: singleSelect,
                        recentlyUsedCategories: []
                    };
                },
                languageId: function () {
                    return languageId;
                }
            }
        }).result;
    };
    RetailerCommonPopupService.$inject = ['$uibModal'];
    return RetailerCommonPopupService;
}());
exports.RetailerCommonPopupService = RetailerCommonPopupService;
angular.module('app.retailes.common').service('retailerCommonPopupService', RetailerCommonPopupService);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var defaultToolbar = [
    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
    ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'html']
];
function taOptionsFactory(taOptions) {
    taOptions.toolbar = defaultToolbar;
    return taOptions;
}
taOptionsFactory.$inject = ['taOptions'];
angular.module('app.retailes.common')
    .factory('appWysiwygOptions', taOptionsFactory);


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var CommonCampaignsService = /** @class */ (function () {
    function CommonCampaignsService(enumService, commonRetailerService, $translate) {
        var _this = this;
        this.enumService = enumService;
        this.commonRetailerService = commonRetailerService;
        this.$translate = $translate;
        this.previewImgSize = {
            w: 320,
            h: 160
        };
        this.daysOfWeek = [
            { key: 0, name: this.$translate.instant('sunday'), selected: false, order: 7 },
            { key: 1, name: this.$translate.instant('monday'), selected: false, order: 1 },
            { key: 2, name: this.$translate.instant('tuesday'), selected: false, order: 2 },
            { key: 3, name: this.$translate.instant('wednesday'), selected: false, order: 3 },
            { key: 4, name: this.$translate.instant('thursday'), selected: false, order: 4 },
            { key: 5, name: this.$translate.instant('friday'), selected: false, order: 5 },
            { key: 6, name: this.$translate.instant('saturday'), selected: false, order: 6 }
        ];
        this.getDateTime = function (dateStr, stringTime) {
            var date = new Date();
            if (dateStr) {
                date = new Date(dateStr);
            }
            if (_.isString(stringTime)) {
                var time = stringTime.split(':');
                if (time.length >= 2) {
                    var hour = parseInt(time[0], 10);
                    var minute = parseInt(time[1], 10);
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour ? hour : 0, minute ? minute : 0, 0, 0);
                }
            }
            return date;
        };
        this.getTimeString = function (allDay, time) {
            if (allDay) {
                time = _this.getDateTime(null, '00:00');
            }
            if (time instanceof Date) {
                var hours = time.getHours();
                var minutes = time.getMinutes();
                return (hours < 10 ? '0' + hours : hours) + ':' +
                    (minutes < 10 ? '0' + minutes : minutes);
            }
            else {
                return '';
            }
        };
        this.getDaysOfWeek = function () {
            return _this.daysOfWeek;
        };
        this.getBitArrayByNumber = function (number) {
            // needed since toString does not zero fill on left
            var template = '0000000';
            // toString converts a number to a bitstring
            var bit = number.toString(2);
            return template.substring(0, template.length - bit.length) + bit;
        };
        this.getSelectdaysOfWeek = function (number) {
            if (number == null) {
                return 'day';
            }
            var numberBit = _this.getBitArrayByNumber(number).split('').reverse().join('');
            var daysOfWeek = _this.getDaysOfWeek();
            var arrayDaysName = [];
            var selectedDaysOfWeek = [];
            for (var c = 0; c < numberBit.length; c++) {
                if (numberBit[c] === '1') {
                    selectedDaysOfWeek.push(daysOfWeek[c]);
                    arrayDaysName.push(daysOfWeek[c].name);
                }
            }
            selectedDaysOfWeek = _.sortBy(selectedDaysOfWeek, 'order');
            arrayDaysName = _.pluck(selectedDaysOfWeek, 'name');
            var daysOfWeekString;
            if (arrayDaysName.length > 1) {
                daysOfWeekString = arrayDaysName.slice(0, arrayDaysName.length - 1).join(', ');
                daysOfWeekString += ' and ' + arrayDaysName[arrayDaysName.length - 1];
            }
            else {
                daysOfWeekString = arrayDaysName.length === 0 ? 'day' : arrayDaysName[0];
            }
            return daysOfWeekString;
        };
        this.getCampaignStatus = function () {
            return _this.enumService.CampaignStatus;
        };
        this.getVideoStatus = function () {
            return _this.enumService.VideoStatus;
        };
        this.adaptCampaignData = function (campaign) {
            if (!campaign) {
                return;
            }
            campaign.StartDate = campaign.StartDate ? new Date(campaign.StartDate) : null;
            campaign.EndDate = campaign.EndDate ? new Date(campaign.EndDate) : null;
            campaign.Image = campaign.ImageID ? _this.commonRetailerService.getCampaignImageUrl(campaign.ImageID) : null;
            campaign.Video = campaign.VideoID ? _this.commonRetailerService.getCampaignThumbnailImageUrl(campaign.VideoID, _this.previewImgSize.w, _this.previewImgSize.h) : null;
            campaign.weeksdays = _this.getSelectdaysOfWeek(campaign.DaysOfWeek);
            campaign.archived = campaign.Status === _this.enumService.CampaignStatus.Archived || campaign.Status === _this.enumService.CampaignStatus.Completed;
        };
    }
    CommonCampaignsService.$inject = ['enumService', 'commonRetailerService', '$translate'];
    return CommonCampaignsService;
}());
exports.CommonCampaignsService = CommonCampaignsService;
angular
    .module('app.retailes.common')
    .service('commonCampaignsService', CommonCampaignsService);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__(315);
exports.RetailerProfile = models_1.Open360BusinessLogicRetailersAccountBERetailerProfile;
exports.StoreInventoryResponse = models_1.Open360BusinessLogicRetailersStoresBEStoreInventoryResponse;
exports.Campaign = models_1.Open360BusinessLogicRetailersCampaignsBECampaign;
exports.Store = models_1.Open360BusinessLogicRetailersStoresBEStore;
exports.PhysicalProduct = models_1.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct;
exports.PhysicalProductVariation = models_1.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation;
exports.PhysicalProductsBrand = models_1.Open360BusinessLogicRetailersPhysicalProductsBEBrand;
exports.PhysicalProductLink = models_1.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink;
exports.PhysicalProductItemType = models_1.Open360BusinessLogicItemTypesBEItemType;
exports.StoreTapAndGo = models_1.Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo;
exports.InformationCardLink = models_1.Open360BusinessLogicRetailersInformationCardsBEInformationCardLink;
exports.UploadedCampaignImage = models_1.Open360BusinessLogicRetailersCampaignsBECampaignImage;
exports.CreateNfcOperationRequest = models_1.Open360RetailerApiContractNfcStickersCreateNfcOperationRequest;
exports.NfcSticker = models_1.Open360NfcStickersModelsNfcSticker;
exports.NfcOperation = models_1.Open360RetailerApiContractNfcStickersNfcOperationModel;
exports.NfcStickerRequest = models_1.Open360NfcStickersAbstractionsFiltersNfcStickerRequest;
exports.CreateNfcExportRequest = models_1.Open360RetailerApiContractNfcStickersCreateNfcExportRequest;
// List Item
exports.CampaignListItem = models_1.Open360EntitiesRetailerApiCampaignListItem;
exports.StoreListItem = models_1.Open360BusinessLogicPlacesPlacesPlaceWithStateListModel;
exports.ClassificationCategoryListItem = models_1.Open360EntitiesListItemsClassificationCategoryListItem;
exports.MeasurementListItem = models_1.Open360ShopperApiContractV18MeasurementsMeasurementListItem;
exports.PhysicalProductLinkListItem = models_1.Open360EntitiesRetailerApiPhysicalProductLinkListItem;
exports.PhysicalProductVariationListItem = models_1.Open360EntitiesRetailerApiPhysicalProductVariationListItem;
exports.BrandListItem = models_1.Open360EntitiesRetailerApiBrandListItem;
exports.StoreTapAndGoListItem = models_1.Open360EntitiesRetailerApiStoreTapAndGoListItem;
// Filters
exports.AnalyticsFilter = models_1.Open360EntitiesRetailerApiVisitsAnalyticsFilter;
exports.VisitsAnalyticsFilter = models_1.Open360EntitiesRetailerApiVisitsAnalyticsFilter;
exports.PagingSettings = models_1.CommonPagingPagingSettings;
exports.InformationCardFilter = models_1.Open360RetailerApiContractInformationCardInformationCardFilter;
exports.StoreFilter = models_1.Open360BusinessLogicRetailersStoresStoreFilter;
exports.SalesAssistantPagingSettings = models_1.Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings;
exports.SalesAssistantRatingPagingSettings = models_1.Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings;


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./components/campaign-active-date/campaign-active-date.component.ts": 37,
	"./components/campaign-active-time/campaign-active-time.component.ts": 38,
	"./components/campaign-keywords/campaign-keywords.component.ts": 39,
	"./components/campaign-overview/campaign-overview.component.ts": 40,
	"./components/campaign-status/campaign-status.component.ts": 41,
	"./components/campaign-type/campaignType.component.ts": 42,
	"./components/days-of-week/days-of-week.component.ts": 43,
	"./components/jisppay-merchant-selector/jisppay-merchant-selector.component.ts": 44,
	"./components/jisppay-place/jisppay-place.component.ts": 45,
	"./controllers/jispPayPlacesBase.controller.ts": 18,
	"./index.ts": 9,
	"./modules/categories/categories.service.ts": 13,
	"./modules/categories/classification-categories-base.component.ts": 7,
	"./modules/categories/classification-categories-store/classification-categories-store.component.ts": 46,
	"./modules/categories/classification-categories.service.ts": 47,
	"./modules/categories/classification-categories/classification-categories.component.ts": 48,
	"./modules/categories/select-classification-categories-tree/select-classification-categories-tree.component.ts": 49,
	"./modules/categories/select-classification-categories/select-classification-categories.component.ts": 50,
	"./modules/filters/store-address.filter.ts": 51,
	"./modules/filters/trim-start.filter.ts": 52,
	"./modules/popup/retailer-common-popup.service.ts": 53,
	"./modules/services/api.serviceBase.ts": 11,
	"./modules/services/appWysiwygOptions.factory.ts": 54,
	"./modules/services/commonCampaigns.service.ts": 55,
	"./modules/services/retailer.service.ts": 22
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var AnalyticsBase = /** @class */ (function () {
    function AnalyticsBase($scope, $stateParams, $filter, analiticsService, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.analiticsService = analiticsService;
        this.$translate = $translate;
        this.timeFormat = null;
        this.dataset = null;
        this.tabs = [this.$translate.instant('gender'),
            this.$translate.instant('age'),
            this.$translate.instant('interests')];
        this.defaultMonthsPeriod = 6;
        this.startDate = new Date();
        this.endDate = new Date();
        this.dayBreakdown = this.$translate.instant('day');
        this.weekBreakdown = this.$translate.instant('week');
        this.monthBreakdown = this.$translate.instant('month');
        this.dateFilter = this.$filter('date');
        this.numberFilter = this.$filter('number');
        this.intervalInDays = null;
        this.tooltipDateFormat = 'd MMM';
        this.tooltipFormat = function (label, x, y) {
            var xFormatted = '';
            var yFormatted = _this.numberFilter(y);
            switch (_this.filter.breakdown) {
                case _this.weekBreakdown:
                    var dateFrom = new Date(x);
                    var dateTo = new Date(x);
                    var dayOfWeek = (dateTo.getDay() + 6) % 7;
                    dateTo.setDate(dateTo.getDate() + 6 - dayOfWeek);
                    xFormatted = _this.dateFilter(dateFrom, _this.tooltipDateFormat) + ' - ' + _this.dateFilter(dateTo, _this.tooltipDateFormat);
                    break;
                default:
                    xFormatted = '%x';
                    break;
            }
            return xFormatted + " : " + yFormatted;
        };
        this.setBreakdown = function (value) {
            _this.filter.breakdown = value;
            _this.refresh();
        };
        this.getTimeFormat = function () {
            switch (_this.filter.breakdown) {
                case _this.monthBreakdown:
                    return '%b %Y';
                default:
                    return '%e %b';
            }
        };
        this.refresh = function () { return __awaiter(_this, void 0, void 0, function () {
            var dataset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getData(this.id, this.filter)];
                    case 1:
                        dataset = _a.sent();
                        try {
                            this.dataset = dataset;
                            this.timeFormat = this.getTimeFormat();
                        }
                        catch (error) {
                            console.warn(error);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.id = parseInt($stateParams.id, 10);
        this.startDate.setMonth(this.startDate.getMonth() - this.defaultMonthsPeriod);
        this.breakdowns = [this.dayBreakdown, this.weekBreakdown, this.monthBreakdown];
        this.filter = {
            startDate: this.startDate.setHours(0, 0, 0, 0),
            endDate: this.endDate.setHours(0, 0, 0, 0),
            breakdown: ''
        };
        this.intervalInDays = (this.filter.endDate - this.filter.startDate) / 24 / 60 / 60 / 1000;
        if (this.intervalInDays < 7) {
            this.filter.breakdown = this.dayBreakdown;
        }
        else if (this.intervalInDays < 30) {
            this.filter.breakdown = this.weekBreakdown;
        }
        else {
            this.filter.breakdown = this.monthBreakdown;
        }
        this.setFilterExtension();
        $scope.$watch('vm.filter', this.refresh, true);
    }
    return AnalyticsBase;
}());
exports.AnalyticsBase = AnalyticsBase;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var BusinessUnionTypeEnum;
(function (BusinessUnionTypeEnum) {
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["NONE"] = 0] = "NONE";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["NFRN"] = 1] = "NFRN";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["BESTWAY"] = 2] = "BESTWAY";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["WHITE_LABEL"] = 3] = "WHITE_LABEL";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["BOOKER"] = 4] = "BOOKER";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["NISA"] = 5] = "NISA";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["ONE_STOP"] = 6] = "ONE_STOP";
    BusinessUnionTypeEnum[BusinessUnionTypeEnum["WHOLESALER"] = 7] = "WHOLESALER";
})(BusinessUnionTypeEnum = exports.BusinessUnionTypeEnum || (exports.BusinessUnionTypeEnum = {}));


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// greg hedin

var Clipboard = (function () {
    function Clipboard() {
    }
    Clipboard.init = function () {
        window.addEventListener('copy', function (e) {
            if (Clipboard._data) {
                e.clipboardData.setData('text/plain', Clipboard._data);
                e.preventDefault(); // this disables 'ctrl + c'
                Clipboard._data = null;
            }
        });
    };
    Clipboard._data = null;
    // MSIE boolean
    Clipboard.POS = !!window['clipboardData'];
    Clipboard.copy = function (data) {
        Clipboard._data = data;
        if (!Clipboard.POS) {
            document.execCommand('copy');
        }
        else if (!!window['clipboardData']) {
            window['clipboardData'].setData('Text', Clipboard._data);
        }
    };
    return Clipboard;
}());
exports.Clipboard = Clipboard;
Clipboard.init();
//# sourceMappingURL=ts-clipboard.js.map

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TooltipState;
(function (TooltipState) {
    TooltipState[TooltipState["None"] = 1] = "None";
    TooltipState[TooltipState["Loading"] = 2] = "Loading";
    TooltipState[TooltipState["Done"] = 3] = "Done";
})(TooltipState = exports.TooltipState || (exports.TooltipState = {}));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var OperationMessageKind;
(function (OperationMessageKind) {
    OperationMessageKind[OperationMessageKind["FullUpdate"] = 0] = "FullUpdate";
    OperationMessageKind[OperationMessageKind["PriceUpdate"] = 1] = "PriceUpdate";
    OperationMessageKind[OperationMessageKind["VariationArchive"] = 2] = "VariationArchive";
    OperationMessageKind[OperationMessageKind["FullUpdateReplace"] = 3] = "FullUpdateReplace";
    OperationMessageKind[OperationMessageKind["StockQuantityUpdate"] = 4] = "StockQuantityUpdate";
    OperationMessageKind[OperationMessageKind["ProductsImportBySku"] = 5] = "ProductsImportBySku";
})(OperationMessageKind = exports.OperationMessageKind || (exports.OperationMessageKind = {}));
var OperationMessageStatus;
(function (OperationMessageStatus) {
    OperationMessageStatus[OperationMessageStatus["Enqueued"] = 1] = "Enqueued";
    OperationMessageStatus[OperationMessageStatus["Processing"] = 2] = "Processing";
    OperationMessageStatus[OperationMessageStatus["Processed"] = 3] = "Processed";
})(OperationMessageStatus = exports.OperationMessageStatus || (exports.OperationMessageStatus = {}));
var OperationMessageSource;
(function (OperationMessageSource) {
    OperationMessageSource[OperationMessageSource["API"] = 1] = "API";
    OperationMessageSource[OperationMessageSource["CSV"] = 2] = "CSV";
})(OperationMessageSource = exports.OperationMessageSource || (exports.OperationMessageSource = {}));
var OperationMessageResult;
(function (OperationMessageResult) {
    OperationMessageResult[OperationMessageResult["None"] = 1] = "None";
    OperationMessageResult[OperationMessageResult["Success"] = 2] = "Success";
    OperationMessageResult[OperationMessageResult["Warning"] = 3] = "Warning";
    OperationMessageResult[OperationMessageResult["Error"] = 4] = "Error";
})(OperationMessageResult = exports.OperationMessageResult || (exports.OperationMessageResult = {}));


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

module.exports = "<back-to-dashboard fixed=\"true\"></back-to-dashboard>\n\n<toaster-container toaster-options=\"{'position-class': 'toast-top-center', 'close-button':true}\"></toaster-container>\n<toaster-container toaster-options=\"{'position-class': 'toast-top-center', 'close-button':true, 'toaster-id': 'waiting'}\"></toaster-container>\n\n<div autoscroll=\"false\" class=\"ng-fadeOutZoom ng-fluid full-height-page login\">\n    <div class=\"animated fadeInDown login__inner\">\n        <div class=\"login__container absolute-center-flex\">\n            <div class=\"block login__logo\">\n                <img ng-src=\"{{'/assets/images/jisp-logo-purple.svg' | cdn}}\" alt=\"jisp\" class=\"center-block\"/>\n            </div>\n            <div >\n                <div ui-view=\"\" >\n                </div>\n            </div>\n            <div class=\"login__link\" ng-if=\"$state.current.name == 'account.login'\">\n            <a ui-sref=\"account.selectRole\" class=\"text-muted\" translate=\"forgot_password\" ></a>\n        </div>\n        </div>\n        <div class=\"login__footer\">\n            <app-footer></app-footer>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var BundleTypeEnum;
(function (BundleTypeEnum) {
    BundleTypeEnum[BundleTypeEnum["Fixed"] = 0] = "Fixed";
    BundleTypeEnum[BundleTypeEnum["Discount"] = 1] = "Discount";
})(BundleTypeEnum = exports.BundleTypeEnum || (exports.BundleTypeEnum = {}));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var SpecialOfferTypeEnum;
(function (SpecialOfferTypeEnum) {
    SpecialOfferTypeEnum[SpecialOfferTypeEnum["None"] = 0] = "None";
    SpecialOfferTypeEnum[SpecialOfferTypeEnum["BuyXGetY"] = 1] = "BuyXGetY";
    SpecialOfferTypeEnum[SpecialOfferTypeEnum["Discount"] = 2] = "Discount";
    SpecialOfferTypeEnum[SpecialOfferTypeEnum["BuyXForY"] = 3] = "BuyXForY";
})(SpecialOfferTypeEnum = exports.SpecialOfferTypeEnum || (exports.SpecialOfferTypeEnum = {}));
var OfferTemplateTypeEnum;
(function (OfferTemplateTypeEnum) {
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["None"] = 0] = "None";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["SaveXX"] = 1] = "SaveXX";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["SaveXXp"] = 2] = "SaveXXp";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["NowOnlyXX"] = 3] = "NowOnlyXX";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["NowOnlyXXp"] = 4] = "NowOnlyXXp";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["OnlyXX"] = 5] = "OnlyXX";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["BuyXForY"] = 6] = "BuyXForY";
    OfferTemplateTypeEnum[OfferTemplateTypeEnum["BuyXForYp"] = 7] = "BuyXForYp";
})(OfferTemplateTypeEnum = exports.OfferTemplateTypeEnum || (exports.OfferTemplateTypeEnum = {}));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var _ = __webpack_require__(1);
var wysiwygControllerBase_1 = __webpack_require__(61);
var popupServiceCancel_1 = __webpack_require__(5);
var paginated_item_type_list_1 = __webpack_require__(246);
var ProductBaseController = /** @class */ (function (_super) {
    __extends(ProductBaseController, _super);
    function ProductBaseController($rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService, categoriesSelectorService, brandsService, popupService, 
        // tslint:disable-next-line:no-shadowed-variable
        taOptions, htmlService, definitionsService, wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal) {
        var _this = _super.call(this, $scope, taOptions, wysiwygService) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.$stateParams = $stateParams;
        _this.$timeout = $timeout;
        _this.$previousState = $previousState;
        _this.productsService = productsService;
        _this.categoriesSelectorService = categoriesSelectorService;
        _this.brandsService = brandsService;
        _this.popupService = popupService;
        _this.taOptions = taOptions;
        _this.htmlService = htmlService;
        _this.definitionsService = definitionsService;
        _this.wysiwygService = wysiwygService;
        _this.notificationService = notificationService;
        _this.accountService = accountService;
        _this.$translate = $translate;
        _this.nfcRetailerStickersService = nfcRetailerStickersService;
        _this.foodPreferencesService = foodPreferencesService;
        _this.$localStorage = $localStorage;
        _this.offersService = offersService;
        _this.uibModal = uibModal;
        _this.waiting = false;
        _this.state = null;
        _this.variation = null;
        _this.foodCategoryId = 228; // Meals
        _this.groceryId = 11; // Groceries
        _this.IsFoodProduct = false;
        _this.isGroceryProduct = false;
        _this.model = {
            main: null,
            edit: null,
            editSample: null,
            linkTypes: [],
            serverImagesID: [],
            serverVariationImagesID: [],
            draft: {
                fields: {
                    category: {
                        state: false,
                        name: _this.$translate.instant('category')
                    },
                    images: {
                        state: false,
                        name: _this.$translate.instant('product_variation_image')
                    },
                    prices: {
                        state: false,
                        name: _this.$translate.instant('product_variation_price')
                    },
                    document: {
                        state: false,
                        name: _this.$translate.instant('digital_content_file')
                    }
                },
                setAll: function (state) {
                    var i = _this.model.draft;
                    _.forEach(i.fields, function (field) {
                        field.state = state;
                    });
                },
                verify: function (product) {
                    var i = _this.model.draft;
                    i.fields.category.state = product.category == null;
                    i.fields.images.state =
                        _.size(product.variations) === 0 ||
                            _.any(product.variations, function (variation) {
                                return _.size(variation.imagesID) === 0;
                            });
                    if (!_this.isPublisher) {
                        i.fields.prices.state = _.any(product.variations, function (variation) {
                            return _.isNaN(parseFloat(variation.price));
                        });
                    }
                    if (_this.isPublisher) {
                        i.fields.document.state = _.any(product.variations, function (variation) {
                            return !!!variation.attachment;
                        });
                    }
                },
                getDraftFields: function (product) {
                    var i = _this.model.draft;
                    i.verify(product);
                    return _.filter(i.fields, function (field) {
                        return field.state;
                    });
                }
            },
            fillServerImagesID: function () {
                var i = _this.model;
                i.serverVariationImagesID = [];
                i.serverImagesID = [];
                if (_this.state.isEdit && i.main && i.main.variations) {
                    var imagesID_1 = i.serverImagesID;
                    var variationImagesID_1 = i.serverVariationImagesID;
                    _.forEach(i.main.variations, function (variation) {
                        var array = variation.imagesID ? variation.imagesID : [];
                        variationImagesID_1[variation.id] = array;
                        imagesID_1 = Array.prototype.concat(imagesID_1, array);
                    });
                    i.serverImagesID = imagesID_1;
                }
            },
            getServerVariationImagesID: function (id) {
                var i = _this.model;
                if (!id && i.main && i.main.variations) {
                    i.serverImagesID = _.flatten(_.pluck(i.main.variations, 'imagesID'));
                    return i.serverImagesID;
                }
                return [];
            },
            getClientImagesID: function () {
                var i = _this.model;
                if (i.edit && i.edit.variations) {
                    return _.flatten(_.pluck(i.edit.variations, 'imagesID'));
                }
                return [];
            },
            fillEditModel: function () {
                var model = _this.model;
                model.edit = angular.copy(model.main);
                if (model.edit.category) {
                    _this.productTypeCheck(model.edit.category.ParentID);
                }
                model.fillServerImagesID();
                _.forEach(model.edit.links, function (link) {
                    link.type = _.findWhere(model.linkTypes, { ID: link.Type });
                });
                model.edit.genderItem = _.findWhere(model.edit.genderItems, {
                    ID: model.edit.gender
                });
                model.editSample = angular.copy(model.edit);
            },
            isValidModel: function (skipServerSideValidation) { return __awaiter(_this, void 0, void 0, function () {
                var i, model, valid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = this.model;
                            model = i.edit;
                            return [4 /*yield*/, i.isValidProduct(skipServerSideValidation)];
                        case 1:
                            valid = _a.sent();
                            if (valid) {
                                _.forEach(model.variations, function (variation) {
                                    if (!i.isValidVariation(variation)) {
                                        valid = false;
                                    }
                                });
                            }
                            if (valid) {
                                valid = i.isValidArrayVariations();
                            }
                            if (valid) {
                                model.error.summary = null;
                            }
                            else {
                                model.error.summary = this.$translate.instant('form_has_error');
                            }
                            return [2 /*return*/, valid];
                    }
                });
            }); },
            isValidProduct: function (skipServerSideValidation) { return __awaiter(_this, void 0, void 0, function () {
                var model, isStickerAreValid, isExtrasValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            model = this.model.edit;
                            // title
                            model.title = model.title ? model.title.trim() : '';
                            if (model.title.length === 0) {
                                model.error.title = this.requiredfield;
                            }
                            else if (model.title.length > 64) {
                                model.error.title = this.$translate.instant('title_too_long');
                            }
                            else {
                                model.error.title = null;
                            }
                            model.error.category = null;
                            model.error.brand = null;
                            model.error.itemType = null;
                            model.error.preparation = null;
                            model.error.ingredients = null;
                            model.error.originCountry = null;
                            // description
                            model.description = model.description
                                ? model.description.trim()
                                : '';
                            if (model.description.length > 30000) {
                                model.error.description = this.$translate.instant('description_too_long', { maxLength: 30000 });
                            }
                            else {
                                model.error.description = null;
                            }
                            // shortDescription
                            model.shortDescription = model.shortDescription
                                ? model.shortDescription.trim()
                                : '';
                            if (model.shortDescription.length > 48) {
                                model.error.shortDescription = this.$translate.instant('short_description_too_long', { maxLength: 48 });
                            }
                            else {
                                model.error.shortDescription = null;
                            }
                            return [4 /*yield*/, this.model.isValidNfcStickers(skipServerSideValidation)];
                        case 1:
                            isStickerAreValid = _a.sent();
                            isExtrasValid = this.model.isValidExtras();
                            return [2 /*return*/, (model.error.title === null &&
                                    model.error.category == null &&
                                    model.error.shortDescription == null &&
                                    model.error.brand == null &&
                                    model.error.description == null &&
                                    this.model.isValidLinks() &&
                                    isStickerAreValid &&
                                    isExtrasValid &&
                                    this.model.isValidFoodProduct() &&
                                    this.model.isValidGrocery() &&
                                    this.model.isValidDigitalContent())];
                    }
                });
            }); },
            isValidFoodProduct: function () {
                if (!_this.IsFoodProduct) {
                    return true;
                }
                var model = _this.model.edit;
                if (model.itemType === undefined ||
                    model.itemType === null ||
                    model.itemType.ID === undefined) {
                    model.error.itemType = _this.$translate.instant('itemType_required');
                }
                else {
                    model.error.itemType = null;
                }
                // preparation
                model.preparation = model.preparation
                    ? model.preparation.trim()
                    : '';
                if (model.preparation.length > 250) {
                    model.error.preparation = _this.$translate.instant('preparation_too_long', { maxLength: 250 });
                }
                else {
                    model.error.preparation = null;
                }
                // ingredients
                model.ingredients = model.ingredients
                    ? model.ingredients.trim()
                    : '';
                if (model.ingredients.length > 2000) {
                    model.error.ingredients = _this.$translate.instant('ingredients_too_long', { maxLength: 2000 });
                }
                else {
                    model.error.ingredients = null;
                }
                // ingredient list
                if (model.ingredientList.length > 0) {
                    var badIngredient = model.ingredientList.find(function (ingredient) { return ingredient.MinQuantity == null; });
                    if (badIngredient) {
                        model.error.ingredientList = _this.$translate.instant('ingredients_list_required_error');
                    }
                }
                else {
                    model.error.ingredientList = null;
                }
                // country of origin
                if (model.originCountry === null) {
                    model.error.originCountry = _this.$translate.instant('originCountry_required_for_food');
                }
                else {
                    model.error.originCountry = null;
                }
                return (model.error.itemType === null &&
                    model.error.preparation === null &&
                    model.error.ingredients == null &&
                    model.error.ingredientList == null &&
                    model.error.originCountry == null);
            },
            isValidDigitalContent: function () {
                if (!_this.isPublisher) {
                    return true;
                }
                var model = _this.model.edit;
                if (model.itemType === undefined ||
                    model.itemType === null ||
                    model.itemType.ID === undefined) {
                    model.error.itemType = _this.$translate.instant('itemType_required');
                }
                else {
                    model.error.itemType = null;
                }
                return model.error.itemType === null;
            },
            isValidGrocery: function () {
                if (!_this.isGroceryProduct) {
                    return true;
                }
                var model = _this.model.edit;
                model.ingredients = model.ingredients
                    ? model.ingredients.trim()
                    : '';
                if (model.ingredients.length > 2000) {
                    model.error.ingredients = _this.$translate.instant('ingredients_too_long', { maxLength: 2000 });
                }
                else {
                    model.error.ingredients = null;
                }
                return model.error.ingredients === null;
            },
            isValidVariation: function (variation) {
                var model = _this.model.edit;
                variation.error = {};
                variation.error.sizes = {};
                // sku
                variation.sku = variation.sku ? variation.sku.trim() : '';
                if (variation.sku.length > 64) {
                    variation.error.sku = _this.$translate.instant('sku_too_long');
                }
                else {
                    variation.error.sku = null;
                }
                // color
                variation.color = variation.color ? variation.color.trim() : '';
                if (variation.color.length > 40) {
                    variation.error.color = _this.$translate.instant('color_too_long');
                }
                else {
                    variation.error.color = null;
                }
                // sizes
                var sizesError = false;
                if (model.measurementEnable) {
                    _.forEach(model.measurementTypes, function (type) {
                        if (model.measurementTypeEnable[type.ID] &&
                            variation.measurementTypeItem[type.ID] &&
                            variation.measurementTypeItem[type.ID].Value) {
                            var value = (variation.measurementTypeItem[type.ID].Value = variation.measurementTypeItem[type.ID].Value.trim());
                            if (value && value.length > 40) {
                                variation.error.sizes[type.ID] = _this.$translate.instant('size_too_long');
                                sizesError = true;
                            }
                            else {
                                variation.error.sizes[type.ID] = null;
                            }
                        }
                    });
                }
                else {
                    variation.size = variation.size ? variation.size.trim() : '';
                    if (variation.size.length > 40) {
                        variation.error.size = _this.$translate.instant('size_too_long');
                        sizesError = true;
                    }
                    else {
                        variation.error.size = null;
                    }
                }
                // price
                if ((variation.price === '' ||
                    (!_.isNaN(parseFloat(variation.price)) &&
                        variation.price <= 0)) && !_this.isPublisher) {
                    variation.error.price = _this.$translate.instant('must_be_greater_than_0');
                }
                else {
                    variation.error.price = null;
                }
                // old price
                if (!_.isNaN(parseFloat(variation.oldPrice)) &&
                    parseFloat(variation.oldPrice) <=
                        parseFloat(variation.price)) {
                    variation.error.oldPrice = _this.$translate.instant(_this.IsFoodProduct ?
                        'must_be_greater_than_takeaway_price' :
                        'must_be_greater_than_current_price');
                }
                else {
                    variation.error.oldPrice = null;
                }
                // takeaway price greater eatIn
                if (!_.isNaN(parseFloat(variation.price)) &&
                    (parseFloat(variation.insidePrice) !==
                        parseFloat(variation.price)) &&
                    (parseFloat(variation.insidePrice) <
                        parseFloat(variation.price))) {
                    variation.error.takeawayGreatEatIn = true;
                }
                else {
                    variation.error.takeawayGreatEatIn = false;
                }
                // preparation time error
                if (variation.preparationTime > 1440) {
                    variation.error.preparationTime = true;
                }
                else {
                    variation.error.preparationTime = false;
                }
                if (variation.ingredients.length > 0) {
                    var badIngredientWithEmptyFields = variation.ingredients.find(function (ingredient) {
                        var badTakeawayPrice = function () {
                            if (variation.price === '' || variation.price == null) {
                                return false;
                            }
                            return ingredient.Price == null || Number.isNaN(ingredient.Price);
                        };
                        var badEatInPrice = function () {
                            if (variation.insidePrice === '' || variation.insidePrice == null) {
                                return false;
                            }
                            return ingredient.InsidePrice == null || Number.isNaN(ingredient.InsidePrice);
                        };
                        var badQuantity = function () { return ingredient.DefaultQuantity == null || ingredient.MaxQuantity == null; };
                        return badTakeawayPrice() || badEatInPrice() || badQuantity();
                    });
                    if (badIngredientWithEmptyFields) {
                        variation.error.ingredient = true;
                    }
                    else {
                        variation.error.ingredient = model.ingredientList.some(function (ingredientItem) {
                            var ingredient = variation.ingredients.find(function (variationIngredient) {
                                return variationIngredient.ID === ingredientItem.ID;
                            });
                            var badQuantityValidation = ingredientItem.MinQuantity > ingredient.DefaultQuantity || ingredient.DefaultQuantity > ingredient.MaxQuantity;
                            var badPriceValidation = false;
                            if (variation.price && variation.insidePrice) {
                                if (ingredient.InsidePrice < ingredient.Price) {
                                    badPriceValidation = true;
                                }
                            }
                            return badQuantityValidation || badPriceValidation;
                        });
                    }
                }
                else {
                    variation.error.ingredient = false;
                }
                // special offer
                var specialOfferError = variation.specialOffer && !_this.offersService.isValidOffer(variation.specialOffer, variation.price);
                return (!variation.error.storeVariations &&
                    !variation.error.image &&
                    !variation.error.sku &&
                    !variation.error.color &&
                    !sizesError &&
                    !variation.error.price &&
                    !variation.error.oldPrice &&
                    !variation.error.ingredient &&
                    !variation.error.takeawayGreatEatIn &&
                    !variation.error.preparationTime &&
                    !specialOfferError);
            },
            isValidArrayVariations: function () {
                var model = _this.model.edit;
                // variationsCount
                model.error.variations = null;
                var variationsCount = model.variations.length;
                if (variationsCount === 1) {
                    return true;
                }
                else if (variationsCount === 0) {
                    model.error.variations = _this.$translate.instant('at_least_one_variation_required');
                    return false;
                }
                var countOfNullable = { sizes: {}, size: 0, color: 0 };
                _.forEach(model.variations, function (variation) {
                    if (model.measurementEnable) {
                        _.forEach(model.measurementTypes, function (type) {
                            if (!countOfNullable.sizes[type.ID]) {
                                countOfNullable.sizes[type.ID] = 0;
                            }
                            if (model.measurementTypeEnable[type.ID]) {
                                if (!(variation.measurementTypeItem[type.ID] &&
                                    variation.measurementTypeItem[type.ID].Value)) {
                                    countOfNullable.sizes[type.ID]++;
                                }
                            }
                        });
                    }
                    else if (variation.size === '') {
                        countOfNullable.size++;
                    }
                    if (variation.color === '') {
                        countOfNullable.color++;
                    }
                });
                var checkAllNullable = true;
                var checkNotAllNullable = false;
                if (model.measurementEnable) {
                    _.forEach(model.measurementTypes, function (type) {
                        if (model.measurementTypeEnable[type.ID]) {
                            checkAllNullable =
                                checkAllNullable &&
                                    countOfNullable.sizes[type.ID] === variationsCount;
                            checkNotAllNullable =
                                checkNotAllNullable ||
                                    (countOfNullable.sizes[type.ID] !== 0 &&
                                        countOfNullable.sizes[type.ID] !==
                                            variationsCount);
                        }
                    });
                }
                else {
                    checkAllNullable = countOfNullable.size === variationsCount;
                    checkNotAllNullable =
                        countOfNullable.size !== 0 &&
                            countOfNullable.size !== variationsCount;
                }
                // size or colour
                if (checkAllNullable &&
                    countOfNullable.color === variationsCount &&
                    variationsCount > 1) {
                    model.error.variations = _this.$translate.instant('size_or_color_required', {
                        sizeName: model.sizeName.toLowerCase(),
                        colourName: model.colourName.toLowerCase()
                    });
                    return false;
                }
                // all size values (or none)
                if (checkNotAllNullable) {
                    model.error.variations = _this.$translate.instant('all_size_values_or_none_are_required', { sizeName: model.sizeName.toLowerCase() });
                    return false;
                }
                // all colour values (or none)
                if (countOfNullable.color !== 0 &&
                    countOfNullable.color !== variationsCount) {
                    model.error.variations = !_this.IsFoodProduct
                        ? _this.$translate.instant('none_or_all_colour_should_be_blank')
                        : _this.$translate.instant('none_or_all_choose_should_be_blank');
                    return false;
                }
                // size/colour pair
                var uniq = _.uniq(model.variations, function (variation) {
                    var sizes = '';
                    if (model.measurementEnable) {
                        _.forEach(model.measurementTypes, function (type) {
                            if (model.measurementTypeEnable[type.ID] &&
                                variation.measurementTypeItem[type.ID] &&
                                variation.measurementTypeItem[type.ID].Value) {
                                sizes += variation.measurementTypeItem[type.ID].Value.toLowerCase();
                            }
                        });
                    }
                    else {
                        sizes += variation.size ? variation.size.toLowerCase() : '';
                    }
                    return variation.color
                        ? variation.color.toLowerCase() + sizes
                        : sizes;
                });
                if (uniq.length !== variationsCount) {
                    model.error.variations = _this.$translate.instant('size_and_colour_pair_should_be_unique', {
                        sizeName: model.sizeName,
                        colorName: model.colourName.toLowerCase()
                    });
                    return false;
                }
                // clear not use sizes
                _.forEach(model.variations, function (variation) {
                    _.forEach(model.measurementTypes, function (type) {
                        if (!model.measurementTypeEnable[type.ID]) {
                            variation.measurementTypeItem[type.ID] = null;
                        }
                    });
                    if (model.measurementEnable) {
                        variation.size = null;
                    }
                });
                return true;
            },
            isValidLink: function (link) {
                link.error = { sum: null };
                link.Title = link.Title ? link.Title.trim() : '';
                if (link.Title.length === 0) {
                    link.error.title = _this.$translate.instant('title_is_required');
                }
                else if (link.Title.length > 64) {
                    link.error.title = _this.$translate.instant('title_too_long');
                }
                else {
                    link.error.title = null;
                }
                var regexUrl = _this.definitionsService.regexUrl;
                link.Url = link.Url ? link.Url.trim() : '';
                if (link.Url.length === 0) {
                    link.error.url = _this.$translate.instant('web_address_is_required');
                }
                else if (!regexUrl.test(link.Url)) {
                    link.error.url = _this.$translate.instant('web_address_is_invalid');
                }
                else if (link.Url.length > 256) {
                    link.error.url = _this.$translate.instant('web_address_too_long');
                }
                else {
                    link.error.url = null;
                }
                if (!link.type) {
                    link.error.type = _this.$translate.instant('link_type_url_title_are_required');
                }
                else {
                    link.error.type = null;
                }
                if (link.error.type) {
                    link.error.sum = link.error.type;
                }
                else if (link.error.url) {
                    link.error.sum = link.error.url;
                }
                else if (link.error.title) {
                    link.error.sum = link.error.title;
                }
                return !link.error.sum;
            },
            isValidLinks: function () {
                var i = _this.model;
                var isValid = true;
                if (_.all(i.edit.links, i.isValidLink)) {
                    // url uniq
                    _.forEach(i.edit.links, function (current) {
                        if (isValid) {
                            var eqUrl = _.where(i.edit.links, {
                                Url: current.Url
                            });
                            if (_.size(eqUrl) > 1) {
                                isValid = false;
                                _.forEach(eqUrl, function (link) {
                                    link.error.sum = _this.$translate.instant('web_address_must_be_unique');
                                    link.error.url = _this.$translate.instant('web_address_must_be_unique');
                                });
                            }
                        }
                    });
                    return isValid;
                }
                return false;
            },
            isValidNfcStickers: function (skipServerSideValidation) {
                _this.model.edit.error.stickers = [];
                var editModel = _this.model.edit;
                if (!editModel.nfcStickers ||
                    (editModel.nfcStickers && editModel.nfcStickers.length === 0)) {
                    return _this.$q.when(true);
                }
                var STICKER_NUMBER_PATTERN = new RegExp('[A-Z]{1}\\d{12}$');
                var stickersError = false;
                var duplicatesMap = _.groupBy(editModel.nfcStickers, function (item) { return item.StickerNumber; });
                editModel.nfcStickers.forEach(function (sticker, index) {
                    var stickerHasError = false;
                    var stickerError = {
                        id: index,
                        nfcNumber: null,
                        store: null
                    };
                    if (!sticker.StickerNumber) {
                        stickerHasError = true;
                        stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_required_error');
                    }
                    if (sticker.StickerNumber) {
                        if (!STICKER_NUMBER_PATTERN.test(sticker.StickerNumber)) {
                            stickerHasError = true;
                            stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_format_error');
                        }
                        else {
                            var duplicates = duplicatesMap[sticker.StickerNumber];
                            if (duplicates && duplicates.length > 1) {
                                stickerHasError = true;
                                stickerError.nfcNumber = _this.$translate.instant('sticker_is_already_used');
                            }
                        }
                    }
                    if (!sticker.PlaceID) {
                        stickerHasError = true;
                        stickerError.store = _this.$translate.instant('nfc_product_stickers_list_location_required_error');
                    }
                    if (stickerHasError) {
                        _this.model.edit.error.stickers.push(stickerError);
                        stickersError = true;
                    }
                });
                if (stickersError) {
                    return _this.$q.when(false);
                }
                if (skipServerSideValidation) {
                    return _this.$q.when(true);
                }
                _this.waiting = true;
                _this.notificationService.showWaitingMessage();
                return _this.nfcRetailerStickersService
                    .checkStickersAvailable(_.map(editModel.nfcStickers, function (s) { return s.StickerNumber; }), _this.state.isEdit ? _this.productID : null)
                    .then(function () {
                    _this.waiting = false;
                    _this.notificationService.clearAll();
                    return true;
                })["catch"](function (error) {
                    _this.waiting = false;
                    _this.notificationService.showErrorMessage(error);
                    _this.$timeout(function () { return _this.notificationService.clearAll(); }, 1000);
                    return false;
                });
            },
            isValidExtras: function () {
                var editModel = _this.model.edit;
                if (!editModel.extras) {
                    return true;
                }
                var isValid = true;
                editModel.extras.forEach(function (extra) {
                    extra.QuantityError = null;
                    if (!extra.MaxAmount || extra.MaxAmount < 0) {
                        extra.QuantityError = _this.$translate.instant('extra_list_column_max_quantity_error');
                        isValid = false;
                    }
                });
                return isValid;
            },
            isValidIngredients: function () {
                return true;
            },
            loadedModel: function () {
                return;
            }
        };
        _this.attachmentsForRemove = [];
        _this.requiredfield = _this.$translate.instant('required_field');
        _this.productID = null;
        _this.loadFoodPreferenceInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.allergenTitle = this.$translate.instant('allergens_title');
                        this.preferenceTitle = this.$translate.instant('foodPreference_title');
                        _a = this;
                        return [4 /*yield*/, this.foodPreferencesService.getAllergens()];
                    case 1:
                        _a.allAllergens = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.foodPreferencesService.getFoodPreference()];
                    case 2:
                        _b.allPreference = _c.sent();
                        this.commonAllergenDescription = this.bindDescription(this.allAllergens);
                        this.commonPreferenceDescription = this.bindDescription(this.allPreference);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadOriginCountry = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.productsService.GetCountryOrigins()];
                    case 1:
                        _a.originCountryList = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getTooltipText = function (variation) {
            return variation.id
                ? _this.$translate.instant('archive')
                : _this.$translate.instant('delete');
        };
        _this.discard = function () {
            _this.deleteImages();
            _this.back();
        };
        _this.getImageUrl = function (imageIds) {
            if (!imageIds) {
                return null;
            }
            if (_.isArray(imageIds)) {
                return _this.productsService.getImageUrl(_.first(imageIds));
            }
            else {
                return _this.productsService.getImageUrl(imageIds);
            }
        };
        _this.deleteImage = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var imageID, ok, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageID = id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (imageID || _.contains(this.model.serverImagesID, imageID)) {
                            // return;
                        }
                        return [4 /*yield*/, this.productsService.deleteImage(imageID)];
                    case 2:
                        ok = _a.sent();
                        if (ok) {
                            console.log('Deleted imageID - ' + imageID);
                        }
                        else {
                            console.log('Could not remove image with id - ' + imageID);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1 + ' Image with id ' + imageID + ' is not removed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.removeVariation = function (variation, callback) { return __awaiter(_this, void 0, void 0, function () {
            var isDelete, popupTitle, popupContent, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (_.size(this.model.edit.variations) === 1) {
                            return [2 /*return*/];
                        }
                        isDelete = variation.id === null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        popupTitle = this.$translate.instant(isDelete ? 'delete_variation' : 'archive_variation');
                        popupContent = "<p>" + this.$translate.instant(isDelete
                            ? 'delete_variation_confirm'
                            : 'archive_variation_confirm') + "</p>";
                        return [4 /*yield*/, this.popupService.confirm({
                                title: popupTitle,
                                content: popupContent
                            })];
                    case 2:
                        _a.sent();
                        this.$removeVariation(variation);
                        if (_.isFunction(callback)) {
                            callback();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.addVariation = function () {
            var defaultVariation = _this.productsService.getDefaultVariationModel();
            var ingredientList = _this.model.edit.ingredientList;
            if (ingredientList.length > 0) {
                ingredientList.forEach(function (item) {
                    var ingredient = {
                        ID: item.ID,
                        Title: item.Title,
                        Price: null,
                        InsidePrice: null,
                        DefaultQuantity: item.MinQuantity,
                        MaxQuantity: 0
                    };
                    defaultVariation.ingredients.push(ingredient);
                });
            }
            _this.model.edit.variations.push(defaultVariation);
            if (_this.productForm) {
                _this.productForm.$setDirty();
            }
        };
        _this.back = function () {
            var pSt = _this.$previousState.get();
            var stateNameProducts = 'app.products';
            if (_this.state.isEdit &&
                pSt &&
                pSt.state.name === stateNameProducts &&
                pSt.params &&
                pSt.params.page) {
                _this.$rootScope.$state.go(stateNameProducts, {
                    page: pSt.params.page,
                    search: pSt.params.search,
                    column: pSt.params.column,
                    order: pSt.params.order
                });
            }
            else {
                _this.$rootScope.$state.go(stateNameProducts);
            }
        };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var isModelValid, draftFields, result, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        return [4 /*yield*/, this.model.isValidModel(true)];
                    case 1:
                        isModelValid = _a.sent();
                        if (!isModelValid) {
                            window.scroll(0, 0);
                            this.waiting = false;
                            return [2 /*return*/];
                        }
                        draftFields = this.model.draft.getDraftFields(this.model.edit);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        result = void 0;
                        if (!(_.size(draftFields) > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.uibModal.open({
                                component: 'draftConfirmationDialog',
                                resolve: {
                                    items: function () { return draftFields.map(function (element) {
                                        return element.name;
                                    }); }
                                },
                                windowClass: 'dpp-info-dialog'
                            }).result];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(_.size(draftFields) === 0 || result)) return [3 /*break*/, 6];
                        if (this.isPublisher) {
                            this.model.edit.variations[0].price = 0;
                        }
                        return [4 /*yield*/, this.$save()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 8];
                    case 8:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.selectCategory = function () { return __awaiter(_this, void 0, void 0, function () {
            var modelSelectCategories, businessTypeEnum, businessType, subcategoryId, categories, productCategories, selectCategory, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        modelSelectCategories = [];
                        if (this.model.edit.category) {
                            modelSelectCategories.push({
                                CategoryID: this.model.edit.category.ID,
                                CategoryFullName: this.model.edit.category.FullName,
                                ParentID: this.model.edit.category.ParentID
                                // Brands: this.model.edit.brands ? this.model.edit.brands : []
                            });
                        }
                        businessTypeEnum = this.$rootScope.enums.BusinessType;
                        businessType = this.isNfrnRetailer ? businessTypeEnum.Shop : businessTypeEnum.All;
                        businessType = this.isPublisher ? businessTypeEnum.DigitalContentPublisher : businessType;
                        subcategoryId = this.isNfrnRetailer ? this.groceryId : null;
                        return [4 /*yield*/, this.categoriesSelectorService.selectClassificationCategories(modelSelectCategories, businessType, true, null, subcategoryId)];
                    case 1:
                        categories = _a.sent();
                        if (categories) {
                            this.productTypeCheck(categories[0].ParentID);
                            productCategories = _.map(categories, function (item) {
                                return {
                                    ID: item.CategoryID,
                                    Name: _.last(item.CategoryFullName.split('>')).trim(),
                                    FullName: item.CategoryFullName
                                };
                            });
                            selectCategory = _.first(productCategories);
                            if (!this.model.edit.category ||
                                this.model.edit.category.ID !== selectCategory.ID) {
                                this.model.edit.category = selectCategory;
                                this.productForm.$setDirty();
                                this.model.edit.brands = [];
                                this.clearSizeValues();
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_4)) {
                            this.notificationService.showErrorMessage(error_4);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.badgeClick = function (badge, badges) {
            if (badge.key === 0) {
                badge.selected = true;
                _.forEach(_.rest(badges), function (item) {
                    item.selected = false;
                });
            }
            else {
                badges[0].selected = !_.any(_.rest(badges), function (item) {
                    return item.selected;
                });
            }
        };
        _this.isBadgeDisabled = function (badge, badgeList, specialOffer) {
            if (badge.key === 128) {
                if (specialOffer) {
                    var utcToday = moment(new Date()).utc(true).startOf('day').toDate();
                    var isEndDateExpired = moment.utc(utcToday).isAfter(moment.utc(specialOffer.OfferValidTo), 'date');
                    if (isEndDateExpired) {
                        badge.selected = false;
                        return true;
                    }
                }
                else {
                    badge.selected = false;
                    return true;
                }
            }
            var selectedBadges = badgeList.filter(function (i) { return i.selected; });
            return selectedBadges.length > 1 && !badge.selected;
        };
        _this.updateSelectedSizes = function (variation) {
            var measurementTypeIDs = _.pluck(_this.model.edit.measurementTypes, 'ID');
            _.forEach(measurementTypeIDs, function (id) {
                var selectedItem = _.findWhere(_this.model.edit.measurementItems[id], { Value: variation.measurementItemValues[id] });
                if (!selectedItem && variation.measurementItemValues[id]) {
                    selectedItem = {
                        ID: null,
                        Value: variation.measurementItemValues[id]
                    };
                    if (_this.model.edit.measurementItems[id]) {
                        _this.model.edit.measurementItems[id].push(selectedItem);
                    }
                    else {
                        _this.model.edit.measurementItems[id] = [selectedItem];
                    }
                }
                variation.measurementTypeItem[id] = selectedItem;
            });
        };
        _this.addLink = function () {
            if (!_this.model.isValidLinks()) {
                return;
            }
            var link = {
                type: null,
                Title: '',
                Url: '',
                error: null
            };
            _this.model.edit.links.push(link);
            _this.productForm.$setDirty();
        };
        _this.removeLink = function (index) {
            _this.model.edit.links.splice(index, 1);
            _this.productForm.$setDirty();
        };
        _this.pasteHandler = function (html) {
            return _this.htmlService.filterWysiwygContent(html);
        };
        _this.refreshMeasurementTypeItem = function ($select) {
            var search = $select.search;
            var list = angular.copy($select.items);
            // remove last user input
            list = list.filter(function (item) {
                return item.ID;
            });
            if (search &&
                list.findIndex(function (x) { return x.Value.toLowerCase() === search.toLowerCase(); }) === -1) {
                // manually add user input and set selection
                var userInputItem = {
                    ID: null,
                    Value: search,
                    forAdd: true
                };
                $select.items = list.concat([userInputItem]);
            }
            else {
                // se the predefined list
                $select.items = list;
            }
        };
        _this.selectMeasurementItem = function (item, measurementType, variation) {
            if (!variation.measurementTypeItem) {
                variation.measurementTypeItem = {};
            }
            variation.measurementTypeItem[measurementType] = item;
            _this.addNewMeasurementItem(item, measurementType, variation);
        };
        _this.addNewMeasurementItem = function (item, measurementType, variation) {
            if (item && measurementType && variation) {
                variation.measurementItemValues[measurementType] = item.Value;
                _this.updateMeasurementTypesEnable();
            }
        };
        _this.clearMeasurementItem = function ($event, $select, measurementType, variation) {
            $event.stopPropagation();
            // to allow empty field, in order to force a selection remove the following line
            $select.selected = null;
            // reset search query
            $select.search = '';
            variation.measurementTypeItem[measurementType] = null;
            variation.measurementItemValues[measurementType] = null;
            _this.updateMeasurementTypesEnable();
        };
        _this.updateVariationPreview = function () {
            return;
        };
        _this.getOppositeMeasurementType = function (measurementType) {
            switch (measurementType) {
                case _this.$rootScope.enums.MeasurementType.Chest:
                    return _this.$rootScope.enums.MeasurementType.Bust;
                case _this.$rootScope.enums.MeasurementType.Bust:
                    return _this.$rootScope.enums.MeasurementType.Chest;
                case _this.$rootScope.enums.MeasurementType.InsideLeg:
                    return _this.$rootScope.enums.MeasurementType.LegLength;
                case _this.$rootScope.enums.MeasurementType.LegLength:
                    return _this.$rootScope.enums.MeasurementType.InsideLeg;
                default:
                    return null;
            }
        };
        _this.updateMeasurementTypesEnable = function () {
            var gender = _this.model.edit.genderItem
                ? _this.model.edit.genderItem.ID
                : null;
            if (gender === null) {
                _.forEach(_this.model.edit.measurements, function (measurement) {
                    var oppositeType = _this.getOppositeMeasurementType(measurement.Type);
                    if (oppositeType) {
                        var allVariations = angular.copy(_this.model.edit.variations);
                        if (_this.variation) {
                            allVariations.push(_this.variation);
                        }
                        var existValue = _.any(allVariations, function (variation) {
                            return !!variation.measurementItemValues[measurement.Type];
                        });
                        _this.model.edit.measurementTypeEnable[oppositeType] = existValue
                            ? false
                            : _this.model.edit.measurementTypeVisible[oppositeType];
                    }
                });
            }
            _.forEach(_this.model.edit.variations, function (variation) {
                _this.updateSelectedSizes(variation);
            });
        };
        _this.getMeasurements = function (gender) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var response, smlMeasurements_1, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([
                                this.productsService.getMeasurements(gender),
                                this.productsService.getSmlMeasurements(gender)
                            ])];
                    case 2:
                        response = _a.sent();
                        this.model.edit.measurements = response[0];
                        smlMeasurements_1 = response[1];
                        _.forEach(this.model.edit.measurements, function (measurement) {
                            _this.model.edit.measurementItems[measurement.Type] =
                                measurement.Sizes;
                            if (smlMeasurements_1) {
                                var sml = _.findWhere(smlMeasurements_1, {
                                    Type: measurement.Type
                                });
                                if (sml) {
                                    _.forEach(sml.Sizes, function (smlSize) {
                                        _this.model.edit.measurementItems[measurement.Type].push({
                                            ID: smlSize.Value,
                                            Value: smlSize.Value
                                        });
                                    });
                                }
                            }
                        });
                        _.forEach(this.model.edit.measurementTypes, function (measurementType) {
                            if (!_this.model.edit.measurementItems[measurementType.ID]) {
                                _this.model.edit.measurementItems[measurementType.ID] = [];
                            }
                        });
                        _.forEach(this.model.edit.variations, function (variation) {
                            _this.updateSelectedSizes(variation);
                        });
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.deleteImages = function () {
            _.forEach(_this.model.getClientImagesID(), function (id) {
                _this.deleteImage(id);
            });
            _this.productForm.$setDirty();
        };
        _this.$removeVariation = function (variation) {
            _this.model.edit.variations = _.difference(_this.model.edit.variations, [
                variation
            ]);
            _.forEach(variation.imagesID, _this.deleteImage);
            _this.productForm.$setDirty();
        };
        _this.sortImageID = function (variation) {
            variation.ImagesID.sort();
        };
        _this.isNeedSplitProduct = function () {
            return false; // TODO: implement later with access rights feature
        };
        _this.saveInternal = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var model_1, promieses, _i, _a, id, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, , 9]);
                        model_1 = angular.copy(this.model.edit);
                        model_1.variations.forEach(function (variation) {
                            if (!variation.sku) {
                                variation.sku = null;
                            }
                            if (!variation.insidePrice) {
                                variation.insideVAT = null;
                                if (variation.ingredients.length > 0) {
                                    variation.ingredients.forEach(function (ingredient) {
                                        ingredient.InsidePrice = 0;
                                    });
                                }
                            }
                            if (!variation.price) {
                                if (variation.ingredients.length > 0) {
                                    variation.ingredients.forEach(function (ingredient) {
                                        ingredient.Price = 0;
                                    });
                                }
                            }
                            if (!_this.IsFoodProduct) {
                                variation.isHot = null;
                                variation.preparationTime = null;
                                model_1.originCountry = null;
                            }
                            if (_this.IsFoodProduct && !variation.preparationTime) {
                                variation.preparationTime = 0;
                            }
                        });
                        if (!!this.saveDisabled) return [3 /*break*/, 7];
                        if (!this.state.isEdit) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.productsService.updateProduct(this.productID, model_1)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.productsService.createProduct(model_1)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        promieses = [];
                        for (_i = 0, _a = this.attachmentsForRemove; _i < _a.length; _i++) {
                            id = _a[_i];
                            promieses.push(this.productsService.deleteAttachment(id));
                        }
                        return [4 /*yield*/, this.$q.all(promieses)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        this.saveDisabled = true;
                        this.notificationService.showSuccessMessage();
                        this.instanceWysiwygService.deleteRemovedTokens(model_1.description);
                        this.$timeout(this.back, 1000);
                        return [3 /*break*/, 9];
                    case 8:
                        error_6 = _b.sent();
                        this.notificationService.showErrorMessage(error_6);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        _this.$save = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        if (!this.isNeedSplitProduct()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.productsService.showSaveChangesDialog()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.saveInternal()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_7 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_7)) {
                            this.notificationService.showErrorMessage(error_7);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.getItemTypes = function (categoryID, gender) { return __awaiter(_this, void 0, void 0, function () {
            var itemTypes, doOnChange, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.productsService.getItemTypes(categoryID, gender)];
                    case 2:
                        itemTypes = _a.sent();
                        this.model.edit.itemTypes = _.sortBy(itemTypes, 'SingleForm');
                        this.paginatedItemTypes = new paginated_item_type_list_1.PaginatedItemTypeList(this.model.edit.itemTypes);
                        if (_.size(this.model.edit.itemTypes) === 1) {
                            this.model.edit.itemType = _.first(this.model.edit.itemTypes);
                        }
                        else {
                            this.model.edit.itemType = _.findWhere(this.model.edit.itemTypes, {
                                ID: this.model.edit.itemType
                                    ? this.model.edit.itemType.ID
                                    : this.model.edit.itemTypeID
                            });
                        }
                        doOnChange = this.model.edit.itemTypeID ===
                            (this.model.edit.itemType ? this.model.edit.itemType.ID : null);
                        this.model.edit.itemTypeID = this.model.edit.itemType
                            ? this.model.edit.itemType.ID
                            : null;
                        this.model.editSample.itemType = this.model.editSample.itemType
                            ? this.model.editSample.itemType
                            : this.model.edit.itemType;
                        if (doOnChange) {
                            this.onChangeItemType();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_8 = _a.sent();
                        this.notificationService.showErrorMessage(error_8);
                        return [3 /*break*/, 5];
                    case 4:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.onChangeItemType = function () {
            if (!_this.model.edit) {
                return;
            }
            _.forEach(_this.model.edit.measurementTypes, function (mType) {
                _this.model.edit.measurementTypeEnable[mType.ID] = false;
                _this.model.edit.measurementTypeVisible[mType.ID] = false;
            });
            if (_this.model.edit.itemType &&
                _this.model.edit.itemType.MeasurementTypes &&
                _this.model.edit.itemType.MeasurementTypes.length > 0) {
                _.forEach(_this.model.edit.itemType.MeasurementTypes, function (mType) {
                    _this.model.edit.measurementTypeEnable[mType] = true;
                    _this.model.edit.measurementTypeVisible[mType] = true;
                });
                _this.model.edit.measurementEnable = true;
            }
            else {
                _this.model.edit.measurementEnable = false;
            }
            _this.updateMeasurementTypesEnable();
        };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var getProduct, getLocations, checkCanEditStickers, response, canEditStickers, _a, error_9;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.loadFoodPreferenceInfo()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.loadOriginCountry()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 6, , 7]);
                        this.$scope.$watch('vm.model.edit.category.ID', function (n, o) {
                            if (n && n !== o) {
                                _this.getItemTypes(n, _this.model.edit.genderItem
                                    ? _this.model.edit.genderItem.ID
                                    : null);
                                if (o) {
                                    _this.productForm.$setDirty();
                                }
                                _this.productsService
                                    .getCategoryFieldNames(n)
                                    .then(function (fieldNames) {
                                    _this.model.edit.sizeName = fieldNames.SizeName;
                                    _this.model.edit.colourName =
                                        fieldNames.ColourName;
                                    if (!_this.model.edit.colourName) {
                                        _.forEach(_this.model.edit.variations, function (variant) {
                                            variant.color = '';
                                        });
                                    }
                                });
                            }
                        });
                        getProduct = this.state.isEdit || this.state.isCopy
                            ? this.productsService.getProductModel(this.productID, this.state.isEdit)
                            : this.productsService.getDefaultProductModel();
                        getLocations = this.nfcRetailerStickersService.getLocations({});
                        checkCanEditStickers = this.nfcRetailerStickersService.checkCanEditStickers();
                        return [4 /*yield*/, this.$q.all([
                                getProduct,
                                this.productsService.getLinkTypes(),
                                this.productsService.getGenders(),
                                this.productsService.getMeasurementTypes(),
                                this.productsService.getMetadata(),
                                getLocations,
                                checkCanEditStickers
                            ])];
                    case 4:
                        response = _b.sent();
                        this.model.main = response[0];
                        this.model.linkTypes = response[1];
                        this.model.main.genderItems = response[2];
                        this.model.main.measurementTypes = response[3];
                        this.productMetadata = response[4];
                        this.stores = response[5].Items;
                        canEditStickers = response[6];
                        this.canEditStickers = this.stores.length !== 0 && canEditStickers;
                        if (this.state.isCopy) {
                            this.model.main.title = this.model.main.title + this.$translate.instant('copy_space_beginning');
                        }
                        this.model.fillEditModel();
                        this.model.loadedModel();
                        this.$scope.$watch('vm.model.edit.itemType.ID', function () {
                            _this.onChangeItemType();
                        });
                        this.$scope.$watch('vm.model.edit.genderItem.ID', function (n, o) { return __awaiter(_this, void 0, void 0, function () {
                            var categoryID;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!this.model.edit) {
                                            return [2 /*return*/];
                                        }
                                        if (!n) {
                                            n = null;
                                        }
                                        return [4 /*yield*/, this.getMeasurements(n)];
                                    case 1:
                                        _a.sent();
                                        categoryID = this.model.edit.category
                                            ? this.model.edit.category.ID
                                            : null;
                                        if (!categoryID) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.getItemTypes(categoryID, n)];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        this.onChangeItemType();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.$scope.$watch('vm.model.edit.extras', function (newValue, oldValue) {
                            if (newValue && newValue !== oldValue) {
                                if (oldValue) {
                                    _this.productForm.$setDirty();
                                }
                            }
                        }, true);
                        this.$scope.$watch('vm.model.edit.ingredientList', function (newValue, oldValue) {
                            if (newValue && newValue !== oldValue) {
                                if (oldValue) {
                                    _this.productForm.$setDirty();
                                }
                            }
                        }, true);
                        this.$scope.$watch('vm.variation', this.updateVariationPreview, true);
                        _a = this;
                        return [4 /*yield*/, this.accountService.getProfile()];
                    case 5:
                        _a.profile = _b.sent();
                        this.currencySign = this.profile.CurrencySign;
                        this.currencyCssClass = this.getCurrencyCssClass(this.profile.CurrencySign);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 7];
                    case 6:
                        error_9 = _b.sent();
                        this.notificationService.showErrorMessage(error_9);
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.productID = _this.$stateParams.id;
        _this.state = {
            isEdit: _this.productID &&
                $rootScope.$state.current.name.startsWith('app.product.edit'),
            isCopy: _this.productID &&
                $rootScope.$state.current.name.startsWith('app.product.copy'),
            isNew: $rootScope.$state.current.name.startsWith('app.product.new'),
            saveTitle: _this.productID &&
                $rootScope.$state.current.name.startsWith('app.product.edit')
                ? _this.$translate.instant('save')
                : _this.$translate.instant('create')
        };
        var unwatch = $rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userData.permission) {
                    unwatch();
                    this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                    this.isPublisher = userData.permission === this.$rootScope.enums.RetailerPermission.Publisher;
                }
                return [2 /*return*/];
            });
        }); }, true);
        _this.init();
        return _this;
    }
    ProductBaseController.prototype.clearEatInTakeawayError = function (variation) {
        variation.error.takeawayGreatEatIn = false;
    };
    ProductBaseController.prototype.clearSizeValues = function () {
        _.forEach(this.model.edit.variations, function (variation) {
            variation.size = null;
            variation.measurementItemValues = {};
        });
    };
    ProductBaseController.prototype.getCurrencyCssClass = function (sign) {
        switch (sign) {
            case '£':
                return 'withPound';
            case 'kr':
                return 'withKrona';
            case '$':
                return 'withDollar';
            case '€':
                return 'withEuro';
            case 'د.إ':
                return 'withDirham';
            default:
                return '';
        }
    };
    ProductBaseController.prototype.onAddNewIngredient = function (item) {
        var variations = this.model.edit.variations;
        variations.forEach(function (variation) {
            var variationIngredient = {
                ID: item.ID,
                Title: item.Title,
                Price: null,
                InsidePrice: null,
                DefaultQuantity: item.MinQuantity,
                MaxQuantity: 1
            };
            variation.ingredients.push(variationIngredient);
            variation.ingredients.sort(function (a, b) { return a.Title.localeCompare(b.Title); });
        });
    };
    ProductBaseController.prototype.onDeleteIngredient = function (item) {
        var variations = this.model.edit.variations;
        variations.forEach(function (variation) {
            if (variation.ingredients.length > 0) {
                var foundIngredientIndex = variation.ingredients.findIndex(function (ingredient) { return ingredient.ID === item.ID; });
                if (foundIngredientIndex > -1) {
                    variation.ingredients.splice(foundIngredientIndex, 1);
                    variation.ingredients.sort(function (a, b) { return a.Title.localeCompare(b.Title); });
                }
            }
        });
    };
    ProductBaseController.prototype.onDeleteIngredients = function (items) {
        var _this = this;
        if (items.length > 0) {
            items.forEach(function (item) { return _this.onDeleteIngredient(item); });
        }
    };
    ProductBaseController.prototype.showIngredientAttentionDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.alert({
                                classPopup: 'alert--redesign modal360',
                                title: this.$translate.instant('ingredient_attention_dialog_title'),
                                content: this.$translate.instant('ingredient_attention_dialog_content'),
                                okTxt: this.$translate.instant('ingredient_attention_dialog_ok_button'),
                                okClass: 'btn btn-success'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProductBaseController.prototype.openStockLevelInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.info({
                                classPopup: 'alert--redesign modal520',
                                title: this.$translate.instant('stock_level_label'),
                                content: this.$translate.instant('stock_level_info_dialog_content')
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProductBaseController.prototype.onChangeSpecialOffer = function (message) {
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    };
    ProductBaseController.prototype.bindDescription = function (preference) {
        var result = '';
        result += '<table class="preferenceDescription">';
        var counter = 0;
        preference
            .sort(function (a, b) {
            return a.Description.length > b.Description.length
                ? -1
                : b.Description.length > a.Description.length
                    ? 1
                    : 0;
        })
            .forEach(function (c) {
            if (counter % 3 === 0) {
                result += '<tr>';
            }
            result +=
                '<td><h3>' +
                    c.Name +
                    '</h3>' +
                    c.Description +
                    '</br></td>';
            counter++;
            if (counter % 3 === 0) {
                result += '</tr>';
            }
        });
        result += '</table>';
        return result;
    };
    ProductBaseController.prototype.productTypeCheck = function (categoryID) {
        var _this = this;
        if (categoryID === this.foodCategoryId || categoryID === this.groceryId) {
            if (categoryID === this.foodCategoryId) {
                this.IsFoodProduct = true;
                var country = this.model.edit.originCountry
                    ? this.originCountryList.find(function (c) { return c.ID === _this.model.edit.originCountry.ID; })
                    : undefined;
                if (country) {
                    this.model.edit.originCountry = country;
                }
            }
            else {
                this.IsFoodProduct = false;
            }
            this.isGroceryProduct = categoryID === this.groceryId;
            this.model.edit.allergens = _.map(this.allAllergens, function (item) {
                var exist = _this.model.edit.allergens
                    ? _this.model.edit.allergens.find(function (c) { return c.ID === item.ID; })
                    : undefined;
                return {
                    ID: item.ID,
                    Description: item.Description,
                    Name: item.Name,
                    IsSelected: exist ? exist.IsSelected : false
                };
            });
            this.model.edit.foodPreferences = _.map(this.allPreference, function (item) {
                var exist = _this.model.edit.foodPreferences
                    ? _this.model.edit.foodPreferences.find(function (c) { return c.ID === item.ID; })
                    : undefined;
                return {
                    ID: item.ID,
                    Description: item.Description,
                    Name: item.Name,
                    IsSelected: exist ? exist.IsSelected : false
                };
            });
        }
        else {
            this.IsFoodProduct = false;
            this.isGroceryProduct = false;
            this.model.edit.ingredientList = [];
            this.model.edit.variations.forEach(function (variation) { return variation.ingredients = []; });
        }
    };
    return ProductBaseController;
}(wysiwygControllerBase_1.WysiwygControllerBase));
exports.ProductBaseController = ProductBaseController;


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.SortOrderEnum = {
    Ascending: 0,
    Descending: 1
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersStoresBEStore;
(function (Open360BusinessLogicRetailersStoresBEStore) {
    Open360BusinessLogicRetailersStoresBEStore.BusinessTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        FoodAndDrink: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8
    };
})(Open360BusinessLogicRetailersStoresBEStore = exports.Open360BusinessLogicRetailersStoresBEStore || (exports.Open360BusinessLogicRetailersStoresBEStore = {}));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractInformationCardInformationCardFilter;
(function (Open360RetailerApiContractInformationCardInformationCardFilter) {
    Open360RetailerApiContractInformationCardInformationCardFilter.StateEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360RetailerApiContractInformationCardInformationCardFilter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360RetailerApiContractInformationCardInformationCardFilter = exports.Open360RetailerApiContractInformationCardInformationCardFilter || (exports.Open360RetailerApiContractInformationCardInformationCardFilter = {}));


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

module.exports = "<div class=\"imgProducts\">\n    <div class=\"imgProductsInner\">\n        <!-- ngIf: variation.imagesID.length > 0 -->\n        <img ng-if=\"vm.images.length > 0\" ng-src=\"{{vm.images[0].url}}\" class=\"ng-scope\" src=\"xxxHTMLLINKxxx0.47626100527655790.794205504329053xxx\"><!-- end ngIf: variation.imagesID.length > 0 -->\n    </div>\n</div>\n<div class=\"maxImagesCont\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.images\" ng-style=\"{width: vm.images.length*110}\">\n    <div ng-repeat=\"image in vm.images\"\n         dnd-draggable=\"image\"\n         dnd-effect-allowed=\"move\"\n         class=\"imgProducts smaller\">\n        <div class=\"imgProductsInner\">\n            <img ng-src=\"{{image.url}}\" alt=\"\" />\n        </div>\n        <span class=\"fa fa-chevron-left\"></span>\n        <span class=\"fa fa-chevron-right\"></span>\n        <span class=\"fa fa-trash\" ng-click=\"vm.deleteImage(image)\"></span>\n    </div>\n    <div class=\"addElement mt8\">\n        <div>\n            <span translate=\"add_a_photo\" ><em class=\"fa fa-plus\"></em></span>\n            <input type=\"file\" ng-disabled=\"vm.waiting\" img-filereader max-size-mb=\"5\" min-width=\"120\" min-height=\"120\" accept=\"image/*\" multiple ng-model=\"vm.uploadedImages\" callback=\"vm.uploadImages()\" />\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var translation_1 = __webpack_require__(6);
__webpack_require__(9);
__webpack_require__(10);
__webpack_require__(477);
angular.module('app.common')
    .value('localStorageAuthKey', 'retailerAuthorizationData')
    .value('customAuthHeaders', null);
var module = angular.module('naut', ['ngRoute', 'ngAnimate', 'ngStorage', 'ngCookies', 'ngSanitize', 'ngResource', 'ui.bootstrap', 'ui.router',
    'ui.utils', 'cfp.loadingBar', 'toaster', 'ngTable', 'xeditable', 'textAngular', 'angularFileUpload', 'angular.filter', 'mrImage',
    'angularMoment', 'ui.select', 'angular-flot', 'ui.map', 'app.common', 'ui.sortable', 'app.retailes.common', 'pascalprecht.translate', 'ui.tree']);
module.value('siteAddressUrl', "https://dashboard-stage.jisp.com/");
module.value('retailerServiceUrl', "https://stageapi.jisp.com/retailer/");
module.value('jispPayServiceUrl', "https://stageapi.jisp.com/jisppay/");
module.value('googleMapsAPIKey', "AIzaSyA0RY_iaL5p96Bd97dAxtsf7qMz2N0eUkk");
module.value('imageServiceUrl', "https://stageapi.jisp.com/retailer/");
module.value('siteRetailerHomeUrl', "https://retailer-stage.jisp.com");
module.value('apiCDNUrlRetailer', "https://api-stage-jisp-a2bwccgjbng0hzcq.a02.azurefd.net/retailer/");
module.value('apiAdminCDNUrl', "https://api-stage-jisp-a2bwccgjbng0hzcq.a02.azurefd.net/admin/");
var tsContext = __webpack_require__(484);
tsContext.keys().forEach(tsContext);
module.config(configSce);
translation_1.mixinTranslation(module, ['en', 'no'], 'retailer');
configSce.$inject = ['$sceDelegateProvider'];
function configSce($sce) {
    $sce.resourceUrlWhitelist(['self', "https://stageapi.jisp.com/retailer/" + "**"]);
}


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var IRetailerType;
(function (IRetailerType) {
    IRetailerType[IRetailerType["FULL"] = 0] = "FULL";
    IRetailerType[IRetailerType["LIGHT"] = 1] = "LIGHT";
    IRetailerType[IRetailerType["PUBLISHER"] = 2] = "PUBLISHER";
})(IRetailerType = exports.IRetailerType || (exports.IRetailerType = {}));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var wysiwygControllerBase_1 = __webpack_require__(61);
var popupServiceCancel_1 = __webpack_require__(5);
var core_1 = __webpack_require__(56);
var CreateEditCampaignBase = /** @class */ (function (_super) {
    __extends(CreateEditCampaignBase, _super);
    function CreateEditCampaignBase($rootScope, $scope, $timeout, commonCampaignsService, campaignsService, popupService, notificationService, htmlService, taOptions, wysiwygService, $translate, retailerService, fileUploaderFactory, // FileUploaderFactory
        $q, http, blobService) {
        var _this = _super.call(this, $scope, taOptions, wysiwygService) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$timeout = $timeout;
        _this.commonCampaignsService = commonCampaignsService;
        _this.campaignsService = campaignsService;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.htmlService = htmlService;
        _this.taOptions = taOptions;
        _this.wysiwygService = wysiwygService;
        _this.$translate = $translate;
        _this.retailerService = retailerService;
        _this.fileUploaderFactory = fileUploaderFactory;
        _this.$q = $q;
        _this.http = http;
        _this.blobService = blobService;
        // region properties
        _this.ID = null;
        _this.campaign = null;
        _this.campaignType = _this.$rootScope.enums.CampaignType;
        _this.firstImgLoad = false;
        _this.imageCropped = null;
        _this.videoManager = null;
        _this.videos = [];
        _this.video = null;
        _this.waiting = true;
        _this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        _this.accordionOptions = {
            setupGroupError: false,
            setupGroupOpen: true,
            audienceGroupError: false,
            audienceGroupOpen: false,
            designGroupError: false,
            designGroupOpen: false,
            scheduleGroupError: false,
            scheduleGroupOpen: false,
            scheduleGroupShow: true,
            summaryGroupOpen: true,
            keywordsGroupError: false,
            keywordsGroupOpen: false
        };
        _this.campaignPushNotificationShow = false;
        _this.campaignStatus = _this.commonCampaignsService.getCampaignStatus();
        _this.videoStatus = _this.commonCampaignsService.getVideoStatus();
        _this.customScroll = _this.campaignsService.customScrollView;
        _this.uploader = null;
        _this.audienceService = {
            changeModel: false,
            model: null,
            enabledChange: function (group) {
                _.forEach(group.items, function (item) {
                    item.selected = !group.enabled;
                });
                group.selected = !group.enabled;
                _this.audienceService.update();
            },
            selectedChange: function (group) {
                _.forEach(group.items, function (item) {
                    item.selected = group.selected;
                });
                _this.audienceService.update();
            },
            enabledPlaceChange: function () {
                var places = _this.audienceService.model.places;
                _.forEach(places.items, function (item) {
                    item.selected = item.isArchived ? false : !places.enabled;
                });
                places.selected = !places.enabled;
                _this.audienceService.update();
            },
            selectedPlaceChange: function (group) {
                _.forEach(group.items, function (item) {
                    item.selected = item.isArchived ? false : group.selected;
                });
                _this.audienceService.update();
            },
            changeSelectedPlace: function (option, group) {
                group.selected = _.all(group.items, function (item) { return item.selected; });
                var selected = _.where(group.items, { selected: true });
                _this.audienceService.update();
            },
            // need for udate audience view
            update: function () {
                _this.audienceService.changeModel = !_this.audienceService.changeModel;
            },
            getOfferAudience: function () {
                var model = _this.audienceService.model;
                var audience = {
                    ages: model.ages.enabled ? _.pluck(_.where(model.ages.items, { selected: true }), 'id') : [],
                    categoryIDs: model.categories.enabled ? _.pluck(_.where(model.categories.items, { selected: true }), 'id') : [],
                    interests: model.interests.enabled ? _.pluck(_.where(model.interests.items, { selected: true }), 'id') : [],
                    genders: model.genders.enabled ? _.pluck(_.where(model.genders.items, { selected: true }), 'id') : [],
                    placeIDs: model.places.enabled ? _.pluck(_.where(model.places.items, { selected: true }), 'id') : []
                };
                return audience;
            },
            validate: {
                incompleteGroup: function () {
                    var model = _this.audienceService.model;
                    function incompleteGroup(gr) {
                        return gr.enabled ? _.any(gr.items, function (item) { return item.selected; }) : true;
                    }
                    return incompleteGroup(model.ages) && incompleteGroup(model.categories) && incompleteGroup(model.genders) && incompleteGroup(model.interests) && incompleteGroup(model.places);
                },
                audiencePlaceGroup: function () {
                    var places = _this.audienceService.model.places;
                    return places.enabled ? !_.any(places.items, function (item) { return item.selected && item.isArchived; }) : true;
                },
                storeCategory: function () {
                    var model = _this.audienceService.model;
                    if (!model.categories.enabled || !model.places.enabled) {
                        return true;
                    }
                    var selectedCategoryIDs = _.pluck(_.where(model.categories.items, { selected: true }), 'id');
                    if (_.isEmpty(selectedCategoryIDs)) {
                        return true;
                    }
                    var selectedPlaces = _.where(model.places.items, { selected: true });
                    var allowedCategoryIDs = _.uniq(_.reduce(_.pluck(selectedPlaces, 'categoryIDs'), function (a, b) {
                        return a.concat(b);
                    }, []));
                    var badStores = _.filter(selectedPlaces, function (place) {
                        return _.all(place.categoryIDs, function (allowedID) {
                            return !_.contains(selectedCategoryIDs, allowedID);
                        });
                    });
                    if (!_.isEmpty(badStores)) {
                        _this.showBadStores(badStores);
                        return false;
                    }
                    return true;
                }
            }
        };
        // region Events
        _this.createCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.campaignsService.createCampaign(this.campaign, this.imageCropped, this.video)];
            });
        }); };
        _this.updateCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.campaignsService.updateCampaign(this.ID, this.campaign, this.imageCropped, this.video)];
            });
        }); };
        _this.archiveCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('archive_campaign'),
                                content: "<p>" + this.$translate.instant('archive_campaing_confirm') + "</p>",
                                cancelClass: 'btn-success',
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.campaignsService.deleteCampaign(this.ID)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage(this.$translate.instant('campaing_has_been_archived'));
                        this.$timeout(1500);
                        this.$scope.$emit('campaignsChanged');
                        this.$rootScope.$state.go('app.marketing-campaigns.overview');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.pageBack = function () {
            if (_this.ID) {
                if (_this.campaign.type === _this.campaignType.Advert) {
                    _this.$rootScope.$state.go('app.advertising.campaign.view', { id: _this.ID });
                }
                else {
                    _this.$rootScope.$state.go('app.marketing-campaigns.view', { id: _this.ID });
                }
            }
            else {
                if (_this.campaign.type === _this.campaignType.Advert) {
                    _this.$rootScope.$state.go('app.advertising.overview');
                }
                else {
                    _this.$rootScope.$state.go('app.marketing-campaigns.overview');
                }
            }
        };
        _this.needHelp = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.campaignsService.needHelp()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.initWatch = function () {
            _this.$timeout(function () {
                angular.element(document.querySelector('#fileInputCropped')).on('change', _this.handleFileSelect);
                _this.$timeout(function () {
                    angular.element(document.querySelector('#campaignName')).focus();
                }, 500);
            }, 500);
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                _this.$scope.$watch('vm.campaign.additionalInfo', function (value, old) {
                    // disable img autoresize in firefox in angularTextEditor
                    _this.$timeout(function () {
                        var imgs = document.getElementsByTagName('IMG');
                        for (var i = 0; i < imgs.length; ++i) {
                            imgs[i].contentEditable = false;
                        }
                    });
                });
            }
            _this.$scope.$on('$destroy', function () {
                $(window).off('resize', _this.setHeightPanel);
            });
        };
        _this.setHeightPanel = function () {
            $('.panel-quick-camp-twoCol > form > .panel-body').css('min-height', ($(window).height() - $('header').height() - 219) + 'px'); // for narrow column
            $('.panel-quick-camp > form > .panel-body').css('min-height', ($(window).height() - $('header').height() - 202) + 'px'); // for wide column
            $('.panel-campaign-choice .tab-content').height($(window).height() - $('header').height() - 303);
        };
        // endregion
        // region StatusModel
        _this.isCompletedCampaignModel = function () {
            return _this.campaign.schedule.endDate && _this.commonCampaignsService.getDateTime(_this.campaign.schedule.endDate.toString(), '00:00') < _this.commonCampaignsService.getDateTime(null, '00:00');
        };
        _this.isScheduledCampaignModel = function () {
            return _this.campaign.schedule.startDate && _this.commonCampaignsService.getDateTime(_this.campaign.schedule.startDate.toString(), '00:00') > _this.commonCampaignsService.getDateTime(null, '00:00');
        };
        _this.isErrorDesignCampaignModel = function () {
            return !_this.campaign.image && !_this.imageCropped.croppedImage && !_this.video.videoID;
        };
        // endregion
        // region Video
        _this.setVideo = function (videoID) { return __awaiter(_this, void 0, void 0, function () {
            var videoMetadata, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.campaignsService.getCampaignVideoMetadata(videoID)];
                    case 1:
                        videoMetadata = _a.sent();
                        this.video.campaignStatus = this.campaignStatus.VideoProcessing;
                        this.video.ID = videoID.toString();
                        this.video.videoID = videoID;
                        this.video.VideoUrl = videoMetadata.VideoUrl || this.retailerService.getCampaignVideoContentUrl(videoID);
                        this.video.ThumbnailUrl = this.retailerService.getCampaignThumbnailImageUrl(videoID);
                        this.video.Width = videoMetadata.Width;
                        this.video.Height = videoMetadata.Height;
                        this.videos = [];
                        return [4 /*yield*/, this.$timeout(0)];
                    case 2:
                        _a.sent();
                        this.videos.push(this.video);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.clearVideo = function () {
            _this.videos = [];
            _this.videoManager.clear();
        };
        // region CropImage
        _this.fileInputCroppedClick = function (event) {
            angular.element('#fileInputCropped').click();
        };
        _this.getCropImageDivWidth = function () {
            return $('.imgcrop-area').width();
        };
        _this.onCropped = function (cropped) {
            if (_this.campaign.image && !_.isEmpty(cropped)) {
                _this.campaignsService.setInitialCampaignImageData(_this.campaign.image.imageID, cropped);
            }
            _this.imageCropped.croppedImage = cropped ? cropped : null;
            if (_this.imageCropped.selector.imageSize) {
                _this.validateCampaignImageSize();
            }
            if (_this.campaignForm) {
                _this.campaignForm.$setDirty();
            }
        };
        _this.clearCropped = function () {
            _this.imageCropped.croppedImage = null;
            _this.imageCropped.sizeCropped = null;
            _this.imageCropped.selector.clear();
        };
        _this.imageOnload = function () {
            if (_this.firstImgLoad) {
                _this.campaignForm.$setPristine();
                _this.firstImgLoad = false;
            }
        };
        _this.onLoadImgCrop = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        this.imageCropped.loading = false;
                        return [2 /*return*/];
                }
            });
        }); };
        // endregion
        // region  Rule/Content
        _this.updateCampaignModel = function () {
            if (_this.campaignForm) {
                _this.campaignForm.$setDirty();
            }
        };
        _this.copyWysiwygContent = function (obj, key) { return __awaiter(_this, void 0, void 0, function () {
            var copy;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.instanceWysiwygService) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.instanceWysiwygService.copyHtmlContent(obj[key])];
                    case 1:
                        copy = _a.sent();
                        obj[key] = copy;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.pasteHandler = function (html) {
            return _this.htmlService.filterWysiwygContent(html);
        };
        // endregion
        // region Validate
        _this.validateCampaignKeyword = function () {
            _this.campaignForm.keywords.$setValidity('required', true);
            _this.campaignForm.keywords.$setValidity('maxlength', true);
            _this.campaignForm.keywords.$setValidity('unique', true);
            _.forEach(_this.campaign.keywords, function (item) {
                item.keyword = item.keyword ? item.keyword.trim() : '';
                item.error = null;
                if (_.isEmpty(item.keyword)) {
                    item.error = _this.$translate.instant('keyword_required_field');
                    _this.campaignForm.keywords.$setValidity('required', false);
                }
                else if (_.size(item.keyword) < 3 || _.size(item.keyword) > 64) {
                    item.error = _this.$translate.instant('keyword_length_error');
                    _this.campaignForm.keywords.$setValidity('maxlength', false);
                }
                else if (_.size(_.filter(_this.campaign.keywords, function (temp) {
                    return temp.keyword.trim().toLocaleLowerCase() === item.keyword.toLowerCase();
                })) > 1) {
                    item.error = _this.$translate.instant('keyword_unique_error');
                    _this.campaignForm.keywords.$setValidity('unique', false);
                }
            });
        };
        _this.validateDate = function () {
            _this.campaignForm.campaignStartDate.$setValidity('date', true);
            _this.campaignForm.campaignEndDate.$setValidity('date', true);
            _this.campaignForm.campaignAlertDate.$setValidity('date', true);
            var schedule = _this.campaign.schedule;
            var startDateIsValid = !schedule.hasStartDate || (schedule.hasStartDate && (schedule.startDate !== undefined));
            startDateIsValid = startDateIsValid ? true : false;
            var endDateIsValid = !schedule.hasEndDate
                || schedule.hasEndDate
                    && schedule.endDate
                    && _this.getDateIsValid(schedule.endDate);
            endDateIsValid = endDateIsValid ? true : false;
            var alertDateIsValid = !schedule.hasAlertDate
                || schedule.hasAlertDate
                    && schedule.alertDate
                    && _this.getDateIsValid(schedule.alertDate);
            alertDateIsValid = alertDateIsValid ? true : false;
            var keyInvalidDate = 'invalidDate';
            var keyRequired = 'required';
            _this.campaignForm.campaignAlertDate.$setValidity(keyRequired, true);
            _this.campaignForm.campaignStartDate.$setValidity(keyInvalidDate, startDateIsValid);
            _this.campaignForm.campaignEndDate.$setValidity(keyInvalidDate, endDateIsValid);
            _this.campaignForm.campaignAlertDate.$setValidity(keyInvalidDate, alertDateIsValid);
            if (_this.campaign.entityStatus === core_1.Campaign.EntityStatusEnum.NUMBER_4 && !schedule.hasEndDate && !schedule.hasAlertDate && (!_this.campaign.isExclusiveOffer && _this.campaign.type !== _this.campaignType.SpecialEvent)) {
                _this.campaignForm.campaignAlertDate.$setValidity(keyRequired, false);
            }
            if (schedule.hasStartDate && startDateIsValid && schedule.hasEndDate && endDateIsValid) {
                var startDate = _this.commonCampaignsService.getDateTime(schedule.startDate.toString(), '00:00');
                var endDate = _this.commonCampaignsService.getDateTime(schedule.endDate.toString(), '00:00');
                var rangeDateIsValid = startDate <= endDate;
                _this.campaignForm.campaignStartDate.$setValidity(keyInvalidDate, rangeDateIsValid);
                _this.campaignForm.campaignEndDate.$setValidity(keyInvalidDate, rangeDateIsValid);
            }
        };
        _this.validateWeeksday = function () {
            var schedule = _this.campaign.schedule;
            if (!schedule.hasDaily && schedule.daysOfWeekInt === 0) {
                _this.campaignForm.datesHasDaily.$setValidity('invalidDaysOfWeek', false);
            }
            else {
                _this.campaignForm.datesHasDaily.$setValidity('invalidDaysOfWeek', true);
            }
        };
        _this.validateCampaignName = function () {
            _this.campaignForm.campaignName.$setValidity('required', true);
            _this.campaignForm.campaignName.$setValidity('maxlength', true);
            if (!_this.campaign.name || _this.campaign.name.trim().length === 0) {
                _this.campaignForm.campaignName.$setValidity('required', false);
                return;
            }
            else if (!_this.campaign.name || _this.campaign.name.trim().length > 100) {
                _this.campaignForm.campaignName.$setValidity('maxlength', false);
                return;
            }
            _this.campaignForm.campaignPushNotification.$setValidity('required', true);
            _this.campaignForm.campaignPushNotification.$setValidity('maxlength', true);
            if (_this.campaignPushNotificationShow && (!_this.campaign.pushNotification || _this.campaign.pushNotification.trim().length === 0)) {
                _this.campaignForm.campaignPushNotification.$setValidity('required', false);
                return;
            }
            else if (_this.campaignPushNotificationShow && (!_this.campaign.pushNotification || _this.campaign.pushNotification.trim().length > 100)) {
                _this.campaignForm.campaignPushNotification.$setValidity('maxlength', false);
                return;
            }
        };
        _this.validateCampaignImageSize = function () {
            if (!_this.campaignForm || !_this.campaignForm || !_this.campaignForm.useTemplate) {
                return;
            }
            _this.campaignForm.useTemplate.$setValidity('imageRequired', true);
            _this.campaignForm.useTemplate.$setValidity('imageMinAreaSize', true);
            _this.campaignForm.useTemplate.$setValidity('imageMaxRatio', true);
            _this.campaignForm.useTemplate.$setValidity('imageMinRatio', true);
            if (_this.campaign.campaignContentType === _this.$rootScope.enums.CampaignContentType.Image &&
                _this.imageCropped.croppedImage != null &&
                _this.imageCropped.selector.size != null) {
                var w = _this.imageCropped.selector.size.w ? _this.imageCropped.selector.size.w : _this.imageCropped.selector.imageSize.w;
                var h = _this.imageCropped.selector.size.h ? _this.imageCropped.selector.size.h : _this.imageCropped.selector.imageSize.h;
                // var validMinSize = $scope.imageCropped.selector.size.w >= $scope.imageCropped.minSize.w;
                _this.campaignForm.useTemplate.$setValidity('imageMinAreaSize', w >= _this.imageCropped.minSize.w && h >= _this.imageCropped.minSize.h);
                var ratio = w === 0 ? 100 : h / w;
                _this.campaignForm.useTemplate.$setValidity('imageMaxRatio', ratio <= 1.25);
                _this.campaignForm.useTemplate.$setValidity('imageMinRatio', ratio >= 0.5);
            }
            else {
                if (_this.campaign.campaignContentType === _this.$rootScope.enums.CampaignContentType.Image && _this.imageCropped.croppedImage == null && _this.imageCropped.src) {
                    var validSelectorSize = angular.isDefined(_this.imageCropped.selector.x1);
                    _this.campaignForm.useTemplate.$setValidity('imageMinAreaSize', validSelectorSize);
                    if (!validSelectorSize && _this.imageCropped.selector.size) {
                        _this.imageCropped.selector.size.w = null;
                    }
                }
            }
        };
        _this.validateCampaignImage = function () {
            _this.validateCampaignImageSize();
            if (_this.campaign.campaignContentType === _this.$rootScope.enums.CampaignContentType.Image && _this.imageCropped.croppedImage === null) {
                _this.campaignForm.useTemplate.$setValidity('imageRequired', false);
            }
            else {
                _this.campaignForm.useTemplate.$setValidity('imageRequired', true);
            }
        };
        _this.isValidCampaignAudience = function () {
            var isValid = _this.audienceService.validate.incompleteGroup();
            _this.campaignForm.rules.$setValidity('incompleteGroup', isValid);
            isValid = _this.audienceService.validate.audiencePlaceGroup();
            _this.campaignForm.rules.$setValidity('audienceStores', isValid);
            isValid = _this.audienceService.validate.storeCategory();
            _this.campaignForm.rules.$setValidity('audienceStoreCampaigns', isValid);
            return isValid;
        };
        _this.isValidMandatoryFields = function () {
            return true;
        };
        _this.getFileType = function (file) { return __awaiter(_this, void 0, void 0, function () {
            var deferred, blob, fileReader;
            return __generator(this, function (_a) {
                deferred = this.$q.defer();
                blob = file.slice(0, 4 + 1);
                fileReader = new FileReader();
                fileReader.onloadend = function (e) {
                    var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
                    var header = '';
                    for (var i = 0; i < arr.length; i++) {
                        header += arr[i].toString(16);
                    }
                    var type = 'video';
                    switch (header) {
                        case '89504e47':
                            type = 'image/png';
                            break;
                        case '47494638':
                            type = 'image/gif';
                            break;
                        case 'ffd8ffe0':
                        case 'ffd8ffe1':
                        case 'ffd8ffe2':
                        case 'ffd8ffe3':
                        case 'ffd8ffdb':
                        case 'ffd8ffe8':
                            type = 'image/jpeg';
                            break;
                        default:
                            type = 'video';
                            break;
                    }
                    deferred.resolve(type);
                };
                fileReader.onerror = function (e) {
                    deferred.reject(e);
                };
                fileReader.readAsArrayBuffer(blob);
                return [2 /*return*/, deferred.promise];
            });
        }); };
        _this.checkVideoFileType = function (file) {
            var ext = file.name.split('.').pop();
            if (ext === file.name) {
                return false;
            }
            var exts = ['mp4', 'avi', 'wmv', 'mov', 'mpg', 'mkv', 'flv', '3gp', 'webm'];
            return (exts.indexOf(ext.toLowerCase()) > -1);
        };
        // region private
        _this.handleFileSelect = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var file, fileType, success, reader;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        file = event.currentTarget.files[0];
                        if (!file) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getFileType(file)];
                    case 2:
                        fileType = _a.sent();
                        if (fileType === 'video') {
                            this.campaign.campaignContentType = this.$rootScope.enums.CampaignContentType.Video;
                            if (this.campaignForm) {
                                this.campaignForm.$setDirty();
                            }
                            success = this.checkVideoFileType(file);
                            if (success) {
                                this.videoManager.error.fileTypeError = false;
                                this.uploader.clearQueue();
                                this.uploader.addToQueue(file, null, null);
                            }
                            else {
                                this.videoManager.error.fileTypeError = true;
                            }
                        }
                        else {
                            this.getCropImageDivWidth();
                            this.campaignsService.resizeFontWithTimeOut();
                            this.campaign.campaignContentType = (fileType === 'image/gif') ? this.$rootScope.enums.CampaignContentType.Gif : this.$rootScope.enums.CampaignContentType.Image;
                            this.imageCropped.src = null;
                            this.imageCropped.isGif = this.campaign.campaignContentType === this.$rootScope.enums.CampaignContentType.Gif;
                            this.campaignForm.useTemplate.$setValidity('imageMinSize', true);
                            this.campaignForm.useTemplate.$setValidity('fileType', true);
                            if (_.isUndefined(file.size) || file.size > 5 * 1024 * 1024) {
                                this.campaignForm.useTemplate.$setValidity('fileSize', false);
                                return [2 /*return*/];
                            }
                            this.campaignForm.useTemplate.$setValidity('fileSize', true);
                            this.imageCropped.loading = true;
                            reader = new FileReader();
                            reader.onload = function (evtreader) { return __awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                var image, target;
                                return __generator(this, function (_a) {
                                    image = new Image();
                                    target = evtreader.target;
                                    image.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                                        var img;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.$timeout(0)];
                                                case 1:
                                                    _a.sent();
                                                    this.campaignForm.useTemplate.$setValidity('fileType', true);
                                                    if (image.width < this.imageCropped.minSize.w || image.height < this.imageCropped.minSize.h) {
                                                        this.imageCropped.src = null;
                                                        this.campaignForm.useTemplate.$setValidity('imageMinSize', false);
                                                        this.imageCropped.loading = false;
                                                    }
                                                    else {
                                                        this.imageCropped.src = target.result;
                                                        if (this.imageCropped.isGif) {
                                                            img = {
                                                                dataUri: this.imageCropped.src,
                                                                imageSize: {
                                                                    height: image.height,
                                                                    width: image.width
                                                                },
                                                                size: file.size,
                                                                error: null
                                                            };
                                                            this.setImageCropped(img);
                                                            this.imageCropped.loading = false;
                                                        }
                                                        this.campaignForm.useTemplate.$setValidity('imageMinSize', true);
                                                        this.clearVideo();
                                                    }
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    image.onerror = function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.$timeout(0)];
                                                case 1:
                                                    _a.sent();
                                                    this.imageCropped.loading = false;
                                                    this.campaignForm.useTemplate.$setValidity('fileType', false);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    image.src = target.result;
                                    return [2 /*return*/];
                                });
                            }); };
                            if (file) {
                                reader.readAsDataURL(file);
                                this.imageCropped.fileName = file.name;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.ID = parseInt($rootScope.$stateParams.id, 10);
        _this.imageCropped = {
            imageID: null,
            imageUrl: null,
            fileName: null,
            src: '',
            selector: {
                enabled: true,
                size: null,
                clear: function () {
                    var selector = _this.imageCropped.selector;
                    selector.enabled = true;
                    selector.size = null;
                }
            },
            minSize: { w: 640, h: 320 },
            maxSize: { w: 1200, h: 600 },
            croppedImage: null,
            maxWidth: 600,
            scale: 1,
            aspectRatio: 2,
            wasChanged: false,
            isBadBrowser: window.navigator.appName.toLowerCase().indexOf('internet explorer')
                !== -1 && window.navigator.appVersion.toLowerCase().indexOf('MSIE 9') !== -1,
            loading: false,
            isGif: false
        };
        _this.videoManager = {
            uploading: false,
            uploadingError: false,
            uploadingProgress: 0,
            processing: false,
            processingError: false,
            processed: false,
            maxQueueSize: 10,
            maxFileSizeMb: 500,
            queueSizeFilterName: 'queueSizeFilter',
            fileSizeFilterName: 'fileSizeFilter',
            error: {
                fileTypeError: false,
                fileSizeError: false,
                customError: null,
                clear: function () {
                    var v = _this.videoManager;
                    v.error.fileTypeError = false;
                    v.error.fileSizeError = false;
                    v.error.customError = null;
                    v.uploading = false;
                    v.uploadingError = false;
                    v.uploadingProgress = 0;
                    v.processing = false;
                    v.processingError = false;
                    v.processed = false;
                }
            },
            clear: function () {
                var v = _this.video;
                if (!v) {
                    return;
                }
                v.ID = null;
                v.VideoUrl = null;
                v.TeaserUrl = null;
                v.ThumbnailUrl = null;
                v.Width = null;
                v.Height = null;
                v.videoID = null;
                v.campaignStatus = null;
            }
        };
        _this.video = {
            ID: null,
            VideoUrl: null,
            TeaserUrl: null,
            ThumbnailUrl: null,
            Width: null,
            Height: null,
            videoID: null,
            campaignStatus: null
        };
        _this.campaignEntityStates = [
            {
                value: _this.$rootScope.enums.CampaignEntityStatus.Active,
                title: _this.$translate.instant('active'),
                isDisabled: function () {
                    return !_this.isValidMandatoryFields();
                }
            },
            {
                value: _this.$rootScope.enums.CampaignEntityStatus.QualityControl,
                title: _this.$translate.instant('quality_control'),
                isDisabled: function () {
                    return false;
                }
            },
            {
                value: _this.$rootScope.enums.CampaignEntityStatus.AdSubmission,
                title: _this.$translate.instant('ad_submission'),
                isDisabled: function () {
                    return false;
                }
            },
            {
                value: _this.$rootScope.enums.CampaignEntityStatus.Draft,
                title: _this.$translate.instant('draft'),
                isDisabled: function () {
                    return false;
                }
            }
        ];
        _this.campaignTypes = [
            {
                value: _this.$rootScope.enums.CampaignType.Promotion,
                title: _this.$translate.instant('promotion')
            }, {
                value: _this.$rootScope.enums.CampaignType.Offer,
                title: _this.$translate.instant('offer')
            }, {
                value: _this.$rootScope.enums.CampaignType.FlashSale,
                title: _this.$translate.instant('flash_sale')
            }, {
                value: _this.$rootScope.enums.CampaignType.Event,
                title: _this.$translate.instant('event')
            }, {
                value: _this.$rootScope.enums.CampaignType.Voucher,
                title: _this.$translate.instant('voucher')
            }
        ];
        _this.initUploader();
        return _this;
    }
    // endregion
    // region keywords
    CreateEditCampaignBase.prototype.addKeyword = function () {
        this.campaign.keywords.push({
            id: null,
            keyword: '',
            error: null
        });
    };
    CreateEditCampaignBase.prototype.deleteKeyword = function (keyword) {
        this.campaign.keywords = _.reject(this.campaign.keywords, function (item) {
            return item === keyword;
        });
    };
    CreateEditCampaignBase.prototype.updateKeyword = function () {
        var temp = angular.copy(this.campaign.keywords);
        this.campaign.keywords = temp;
    };
    // endregion
    CreateEditCampaignBase.prototype.setImageCropped = function (imgData) {
        this.imageCropped.croppedImage = imgData.dataUri;
        this.imageCropped.src = imgData.dataUri;
        var size = {
            h: imgData.imageSize.height,
            w: imgData.imageSize.width
        };
        this.imageCropped.selector.size = size;
        this.imageCropped.selector.imageSize = size;
        this.onCropped(this.imageCropped.src);
    };
    CreateEditCampaignBase.prototype.getDateIsValid = function (date) {
        return this.commonCampaignsService.getDateTime(date.toString(), '00:00') > this.commonCampaignsService.getDateTime(null, '00:00');
    };
    CreateEditCampaignBase.prototype.showBadStores = function (badStores) {
        return __awaiter(this, void 0, void 0, function () {
            var names, message, initial, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        names = _.pluck(badStores, 'title');
                        message = '';
                        if (_.isEmpty(names)) {
                            return [2 /*return*/];
                        }
                        else if (_.size(names) === 1) {
                            message = this.$translate.instant('campaign_wont_run_in_a_bad_store', { name: "<b>" + names[0] + "</b>" });
                        }
                        else if (_.size(names) > 1) {
                            names = _.sortBy(names);
                            initial = _.initial(names).join(' ,');
                            message = this.$translate.instant('campaign_wont_run_in_bad_stores', { initial: "<b>" + initial, last: _.last(names) + "</b>" });
                        }
                        else {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.popupService.alert({
                                title: this.$translate.instant('cant_save_campaign'),
                                content: message
                            })];
                    case 2:
                        _a.sent();
                        $('html, body').animate({ scrollTop: 0 }, 1);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        $('html, body').animate({ scrollTop: 0 }, 1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // endregion
    CreateEditCampaignBase.prototype.initUploader = function () {
        var _this = this;
        var i = this;
        this.uploader = new this.fileUploaderFactory({
            headers: this.campaignsService.getAuthorizationBearer(),
            url: this.campaignsService.getUploadVideoUrl(),
            autoUpload: true
        });
        // filters
        this.uploader.filters.push({
            name: i.videoManager.queueSizeFilterName,
            fn: function (item /* {File|FileLikeObject} */, options) {
                return this.queue.length < i.videoManager.maxQueueSize;
            }
        });
        this.uploader.filters.push({
            name: i.videoManager.fileSizeFilterName,
            fn: function (item /* {File|FileLikeObject} */, options) {
                return item.size / 1024 / 1024 < i.videoManager.maxFileSizeMb;
            }
        });
        // events
        this.uploader.onBeforeUploadItem = function (fileItem) {
            // clear all queue except selected file
            _this.uploader.queue = _.filter(_this.uploader.queue, function (item) {
                return fileItem.file.name === item.file.name;
            });
            _this.videoManager.error.clear();
            _this.videoManager.uploading = true;
        };
        this.uploader.onCancelItem = function (fileItem, response, status, headers) { return __awaiter(_this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!fileItem.serverSideID) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.campaignsService.deleteCampaignVideo(fileItem.serverSideID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        if (fileItem.serverSideID === this.video.videoID) {
                            this.clearVideo();
                        }
                        this.videoManager.uploading = false;
                        this.uploader.clearQueue();
                        return [2 /*return*/];
                }
            });
        }); };
        this.uploader.onSuccessItem = function (fileItem, response, status, headers) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                fileItem.serverSideID = response;
                fileItem.errorMessage = null;
                this.videoManager.uploading = false;
                this.videoManager.processing = true;
                this.setVideo(response);
                this.clearCropped();
                return [2 /*return*/];
            });
        }); };
        this.uploader.onProgressItem = function (fileItem, progress) {
            _this.videoManager.uploadingProgress = progress;
        };
        this.uploader.onProgressAll = function (progress) {
            _this.waiting = progress !== 100;
            _this.videoManager.uploadingProgress = progress;
        };
        this.uploader.onErrorItem = function (fileItem, response, status, headers) {
            if (_.isNumber(status) && status > 0) {
                var errorResponse = {
                    data: response,
                    status: status,
                    headers: headers,
                    config: null,
                    statusText: null,
                    xhrStatus: 'error'
                };
                var message = _this.http.decodeError(errorResponse) || response.ExceptionMessage;
                _this.videoManager.error.customError = message;
            }
            else {
                _this.videoManager.error.customError = 'Upload failed';
            }
            _this.videoManager.uploadingError = true;
            _this.videoManager.uploading = false;
        };
        this.uploader.onAfterAddingAll = function (addedItems) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.uploader.queue = _.filter(this.uploader.queue, function (item) {
                    return !item.excludeFromQueue;
                });
                if (this.uploader.queue.length === 0) {
                    this.videoManager.uploading = false;
                }
                return [2 /*return*/];
            });
        }); };
        this.uploader.onWhenAddingFileFailed = function (file /* {File|FileLikeObject} */, filter, options) {
            file.excludeFromQueue = true;
            if (filter.name === _this.videoManager.fileSizeFilterName) {
                _this.videoManager.error.fileSizeError = true;
                _this.uploader.queue.push(file);
            }
        };
    };
    return CreateEditCampaignBase;
}(wysiwygControllerBase_1.WysiwygControllerBase));
exports.CreateEditCampaignBase = CreateEditCampaignBase;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var wysiwygControllerBase_1 = __webpack_require__(61);
var popupServiceCancel_1 = __webpack_require__(5);
var InformationCardBaseController = /** @class */ (function (_super) {
    __extends(InformationCardBaseController, _super);
    function InformationCardBaseController($rootScope, $scope, $q, $stateParams, $timeout, $previousState, informationCardsService, categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService, wysiwygService, notificationService, $translate, nfcRetailerStickersService) {
        var _this = _super.call(this, $scope, taOptions, wysiwygService) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.$stateParams = $stateParams;
        _this.$timeout = $timeout;
        _this.$previousState = $previousState;
        _this.informationCardsService = informationCardsService;
        _this.categoriesSelectorService = categoriesSelectorService;
        _this.brandsService = brandsService;
        _this.popupService = popupService;
        _this.taOptions = taOptions;
        _this.htmlService = htmlService;
        _this.definitionsService = definitionsService;
        _this.wysiwygService = wysiwygService;
        _this.notificationService = notificationService;
        _this.$translate = $translate;
        _this.nfcRetailerStickersService = nfcRetailerStickersService;
        _this.waiting = false;
        _this.state = null;
        _this.model = {
            main: null,
            edit: null,
            editSample: null,
            linkTypes: [],
            serverImagesID: [],
            draft: {
                fields: {
                    images: { state: false, name: _this.$translate.instant('information_card_image') }
                },
                setAll: function (state) {
                    var i = _this.model.draft;
                    _.forEach(i.fields, function (field) {
                        field.state = state;
                    });
                },
                verify: function (product) {
                    var i = _this.model.draft;
                    i.fields.images.state = _.size(product.imagesID) === 0;
                },
                getDraftFields: function (product) {
                    var i = _this.model.draft;
                    i.verify(product);
                    return _.filter(i.fields, function (field) {
                        return field.state;
                    });
                }
            },
            fillServerImagesID: function () {
                var i = _this.model;
                i.serverImagesID = [];
                if (_this.state.isEdit && i.main) {
                    i.serverImagesID = angular.copy(i.main.imagesID);
                }
            },
            getServerVariationImagesID: function (id) {
                var i = _this.model;
                var variationID = parseInt(id, 10);
                if (i.main && i.main.imagesID) {
                    i.serverImagesID = angular.copy(i.edit.imagesID);
                    return i.serverImagesID;
                }
                return [];
            },
            getClientImagesID: function () {
                var i = _this.model;
                if (i.edit && i.edit.imagesID) {
                    return angular.copy(i.edit.imagesID);
                }
                return [];
            },
            fillEditModel: function () {
                var i = _this.model;
                i.edit = angular.copy(i.main);
                i.fillServerImagesID();
                _.forEach(i.edit.links, function (link) {
                    link.type = _.findWhere(i.linkTypes, { ID: link.Type });
                });
                i.editSample = angular.copy(i.edit);
            },
            isValidModel: function () { return __awaiter(_this, void 0, void 0, function () {
                var i, model, valid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = this.model;
                            model = i.edit;
                            return [4 /*yield*/, i.isValidProduct()];
                        case 1:
                            valid = _a.sent();
                            if (valid) {
                                model.error.summary = null;
                            }
                            else {
                                model.error.summary = this.$translate.instant('form_has_error');
                            }
                            return [2 /*return*/, valid];
                    }
                });
            }); },
            isValidProduct: function () { return __awaiter(_this, void 0, void 0, function () {
                var model, stickersError;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            model = this.model.edit;
                            // title
                            model.title = model.title ? model.title.trim() : '';
                            if (model.title.length === 0) {
                                model.error.title = this.requiredfield;
                            }
                            else if (model.title.length > 128) {
                                model.error.title = this.$translate.instant('title_too_long');
                            }
                            else {
                                model.error.title = null;
                            }
                            // description
                            model.description = model.description ? model.description.trim() : '';
                            if (model.description.length > 30000) {
                                model.error.description = this.$translate.instant('description_too_long', { maxLength: 30000 });
                            }
                            else {
                                model.error.description = null;
                            }
                            return [4 /*yield*/, this.model.isValidStickers()];
                        case 1:
                            stickersError = _a.sent();
                            return [2 /*return*/, model.error.title === null
                                    && model.error.description == null && this.model.isValidLinks() && stickersError];
                    }
                });
            }); },
            isValidStickers: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var editModel, STICKER_NUMBER_PATTERN, stickersError, duplicatesMap;
                return __generator(this, function (_a) {
                    this.model.edit.error.stickers = [];
                    editModel = this.model.edit;
                    if (!editModel.nfcStickers || (editModel.nfcStickers && editModel.nfcStickers.length === 0)) {
                        return [2 /*return*/, this.$q.when(true)];
                    }
                    STICKER_NUMBER_PATTERN = new RegExp('[A-Z]{1}\\d{12}$');
                    stickersError = false;
                    duplicatesMap = _.groupBy(editModel.nfcStickers, function (item) { return item.StickerNumber; });
                    editModel.nfcStickers.forEach(function (sticker, index) {
                        var stickerHasError = false;
                        var stickerError = {
                            id: index,
                            nfcNumber: null,
                            store: null
                        };
                        if (!sticker.StickerNumber) {
                            stickerHasError = true;
                            stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_required_error');
                        }
                        if (sticker.StickerNumber) {
                            if (!STICKER_NUMBER_PATTERN.test(sticker.StickerNumber)) {
                                stickerHasError = true;
                                stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_format_error');
                            }
                            else {
                                var duplicates = duplicatesMap[sticker.StickerNumber];
                                if (duplicates && duplicates.length > 1) {
                                    stickerHasError = true;
                                    stickerError.nfcNumber = _this.$translate.instant('sticker_is_already_used');
                                }
                            }
                        }
                        if (!sticker.PlaceID) {
                            stickerHasError = true;
                            stickerError.store = _this.$translate.instant('nfc_product_stickers_list_location_required_error');
                        }
                        if (stickerHasError) {
                            _this.model.edit.error.stickers.push(stickerError);
                            stickersError = true;
                        }
                    });
                    if (stickersError) {
                        return [2 /*return*/, this.$q.when(false)];
                    }
                    return [2 /*return*/, this.$q.when(true)];
                });
            }); },
            isValidLink: function (link) {
                link.error = { sum: null };
                link.Title = link.Title ? link.Title.trim() : '';
                if (link.Title.length === 0) {
                    link.error.title = _this.$translate.instant('title_is_required');
                }
                else if (link.Title.length > 64) {
                    link.error.title = _this.$translate.instant('title_too_long');
                }
                else {
                    link.error.title = null;
                }
                var regexUrl = _this.definitionsService.regexUrl;
                link.Url = link.Url ? link.Url.trim() : '';
                if (link.Url.length === 0) {
                    link.error.url = _this.$translate.instant('web_address_is_required');
                }
                else if (!regexUrl.test(link.Url)) {
                    link.error.url = _this.$translate.instant('web_address_is_invalid');
                }
                else if (link.Url.length > 256) {
                    link.error.url = _this.$translate.instant('web_address_too_long');
                }
                else {
                    link.error.url = null;
                }
                if (!link.type) {
                    link.error.type = _this.$translate.instant('link_type_url_title_are_required');
                }
                else {
                    link.error.type = null;
                }
                if (link.error.type) {
                    link.error.sum = link.error.type;
                }
                else if (link.error.url) {
                    link.error.sum = link.error.url;
                }
                else if (link.error.title) {
                    link.error.sum = link.error.title;
                }
                return !link.error.sum;
            },
            isValidLinks: function () {
                var i = _this.model;
                var isValid = true;
                if (_.all(i.edit.links, i.isValidLink)) {
                    // url uniq
                    _.forEach(i.edit.links, function (current) {
                        if (isValid) {
                            var eqUrl = _.where(i.edit.links, { Url: current.Url });
                            if (_.size(eqUrl) > 1) {
                                isValid = false;
                                _.forEach(eqUrl, function (link) {
                                    link.error.sum = _this.$translate.instant('web_address_must_be_unique');
                                    link.error.url = _this.$translate.instant('web_address_must_be_unique');
                                });
                            }
                        }
                    });
                    return isValid;
                }
                return false;
            },
            loadedModel: function () { return; }
        };
        _this.requiredfield = _this.$translate.instant('required_field');
        _this.productID = null;
        _this.discard = function () {
            _this.deleteImages();
            _this.back();
        };
        _this.getImageUrl = function (imageIDs) {
            if (!imageIDs) {
                return null;
            }
            if (_.isArray(imageIDs)) {
                return _this.informationCardsService.getImageUrl(_.first(imageIDs));
            }
            else {
                return _this.informationCardsService.getImageUrl(imageIDs);
            }
        };
        _this.deleteImage = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var imageID, ok, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageID = id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if ((imageID) || _.contains(this.model.serverImagesID, imageID)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.informationCardsService.deleteImage(imageID)];
                    case 2:
                        ok = _a.sent();
                        if (ok) {
                            console.log('Deleted imageID - ' + imageID);
                        }
                        else {
                            console.log('Could not remove image with id - ' + imageID);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1 + ' Image with id ' + imageID + ' is not removed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.back = function () {
            var pSt = _this.$previousState.get();
            var stateNameProducts = 'app.information-cards';
            if (_this.state.isEdit && pSt && pSt.state.name === stateNameProducts && pSt.params && pSt.params.page) {
                _this.$rootScope.$state.go(stateNameProducts, { page: pSt.params.page, search: pSt.params.search, column: pSt.params.column, order: pSt.params.order });
            }
            else {
                _this.$rootScope.$state.go(stateNameProducts);
            }
        };
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var draftFields, msg, li_1, ul, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.model.isValidModel()];
                    case 1:
                        if (!(_a.sent())) {
                            return [2 /*return*/];
                        }
                        draftFields = this.model.draft.getDraftFields(this.model.edit);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!(_.size(draftFields) > 0)) return [3 /*break*/, 4];
                        msg = "<p>" + this.$translate.instant('save_information_card_as_draft_confirm') + "</p>";
                        li_1 = '';
                        _.forEach(draftFields, function (field) {
                            li_1 += '<li>' + field.name + '</li>';
                        });
                        ul = '<ul class="pl15">' + li_1 + '</ul>';
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('warning'),
                                content: msg + ul,
                                okTxt: this.$translate.instant('save_draft'),
                                cancelTxt: this.$translate.instant('complete_the_fields'),
                                okClass: 'btn btn-success plr15',
                                cancelClass: 'btn btn-danger plr15'
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.$save();
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.addLink = function () {
            if (!_this.model.isValidLinks()) {
                return;
            }
            var link = {
                type: null,
                Title: '',
                Url: '',
                error: null
            };
            _this.model.edit.links.push(link);
            _this.productForm.$setDirty();
        };
        _this.removeLink = function (index) {
            _this.model.edit.links.splice(index, 1);
            _this.productForm.$setDirty();
        };
        _this.pasteHandler = function (html) {
            return _this.htmlService.filterWysiwygContent(html);
        };
        _this.updateVariationPreview = function () {
            return;
        };
        _this.deleteImages = function () {
            _.forEach(_this.model.getClientImagesID(), function (id) {
                _this.deleteImage(id);
            });
            _this.productForm.$setDirty();
        };
        _this.sortImageID = function (card) {
            card.imagesID.sort();
        };
        _this.$save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.saveInternal();
                }
                catch (error) {
                    if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error)) {
                        this.notificationService.showErrorMessage(error);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        _this.saveInternal = function () { return __awaiter(_this, void 0, void 0, function () {
            var model, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        model = angular.copy(this.model.edit);
                        if (!this.state.isEdit) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.informationCardsService.updateInformationCard(this.productID, model)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.informationCardsService.createInformationCard(model)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.instanceWysiwygService.deleteRemovedTokens(model.description);
                        this.notificationService.showSuccessMessage();
                        this.$timeout(this.back, 1000);
                        return [3 /*break*/, 7];
                    case 6:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var getProduct, getLocations, checkCanEditStickers, response, canEditStickers, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        getProduct = this.state.isEdit || this.state.isCopy ?
                            this.informationCardsService.getInformationCardModel(this.productID, this.state.isEdit) :
                            this.informationCardsService.getDefaultProductModel();
                        getLocations = this.nfcRetailerStickersService.getLocations({});
                        checkCanEditStickers = this.nfcRetailerStickersService.checkCanEditStickers();
                        return [4 /*yield*/, this.$q.all([
                                getProduct,
                                this.informationCardsService.getLinkTypes(),
                                getLocations,
                                checkCanEditStickers
                            ])];
                    case 2:
                        response = _a.sent();
                        this.model.main = response[0];
                        this.model.linkTypes = response[1];
                        this.stores = response[2].Items;
                        canEditStickers = response[3];
                        this.canEditStickers = this.stores.length !== 0 && canEditStickers;
                        this.model.fillEditModel();
                        this.model.loadedModel();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.productID = _this.$stateParams.id;
        _this.state = {
            isEdit: (_this.productID) && $rootScope.$state.current.name.startsWith('app.information-card.edit'),
            isCopy: (_this.productID) && $rootScope.$state.current.name.startsWith('app.information-card.copy'),
            isNew: $rootScope.$state.current.name.startsWith('app.information-card.new'),
            saveTitle: (_this.productID) && $rootScope.$state.current.name.startsWith('app.information-card.edit')
                ? _this.$translate.instant('save')
                : _this.$translate.instant('create')
        };
        _this.init();
        return _this;
    }
    return InformationCardBaseController;
}(wysiwygControllerBase_1.WysiwygControllerBase));
exports.InformationCardBaseController = InformationCardBaseController;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var IJispPayAccountTypeEnum;
(function (IJispPayAccountTypeEnum) {
    IJispPayAccountTypeEnum[IJispPayAccountTypeEnum["Vendor"] = 0] = "Vendor";
    IJispPayAccountTypeEnum[IJispPayAccountTypeEnum["Staff"] = 1] = "Staff";
})(IJispPayAccountTypeEnum = exports.IJispPayAccountTypeEnum || (exports.IJispPayAccountTypeEnum = {}));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var AccountTypeEnum;
(function (AccountTypeEnum) {
    AccountTypeEnum[AccountTypeEnum["staff"] = 1] = "staff";
    AccountTypeEnum[AccountTypeEnum["vendor"] = 2] = "vendor";
})(AccountTypeEnum = exports.AccountTypeEnum || (exports.AccountTypeEnum = {}));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TableSettingEnum;
(function (TableSettingEnum) {
    TableSettingEnum[TableSettingEnum["TableService"] = 0] = "TableService";
    TableSettingEnum[TableSettingEnum["TableMandatorySelection"] = 1] = "TableMandatorySelection";
})(TableSettingEnum = exports.TableSettingEnum || (exports.TableSettingEnum = {}));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var TestPrintStatusEnum;
(function (TestPrintStatusEnum) {
    TestPrintStatusEnum[TestPrintStatusEnum["PrintingSuccess"] = 0] = "PrintingSuccess";
    TestPrintStatusEnum[TestPrintStatusEnum["PrintingError"] = 1] = "PrintingError";
    TestPrintStatusEnum[TestPrintStatusEnum["PrinterNotFound"] = 2] = "PrinterNotFound";
})(TestPrintStatusEnum = exports.TestPrintStatusEnum || (exports.TestPrintStatusEnum = {}));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var PaginatedItemTypeList = /** @class */ (function () {
    function PaginatedItemTypeList(list) {
        this.list = [];
        this.offset = 20;
        this.visibleList = [];
        this.filteredList = [];
        this.list = list;
        this.setFilter('');
    }
    PaginatedItemTypeList.prototype.getVisibleList = function () {
        return this.visibleList;
    };
    PaginatedItemTypeList.prototype.setFilter = function (filter) {
        if (filter === void 0) { filter = ''; }
        if (filter !== this.filter) {
            this.filter = filter;
            this.filteredList = this.filter ?
                this.list.filter(function (item) { return item.PluralForm.toLowerCase().includes(filter.toLowerCase()); }) : this.list.slice();
            this.resetVisibleList();
        }
    };
    PaginatedItemTypeList.prototype.showMore = function () {
        this.visibleList = this.visibleList.concat(this.filteredList.slice(this.visibleList.length, this.visibleList.length + this.offset));
    };
    PaginatedItemTypeList.prototype.resetVisibleList = function () {
        this.visibleList = [];
        this.showMore();
    };
    return PaginatedItemTypeList;
}());
exports.PaginatedItemTypeList = PaginatedItemTypeList;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var EShoppingScanMethod;
(function (EShoppingScanMethod) {
    EShoppingScanMethod[EShoppingScanMethod["NFC"] = 1] = "NFC";
    EShoppingScanMethod[EShoppingScanMethod["BARCODE"] = 2] = "BARCODE";
})(EShoppingScanMethod = exports.EShoppingScanMethod || (exports.EShoppingScanMethod = {}));


/***/ }),
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var IShopperStaffDiscountTransactionStatus;
(function (IShopperStaffDiscountTransactionStatus) {
    IShopperStaffDiscountTransactionStatus[IShopperStaffDiscountTransactionStatus["None"] = 0] = "None";
    IShopperStaffDiscountTransactionStatus[IShopperStaffDiscountTransactionStatus["Active"] = 1] = "Active";
    IShopperStaffDiscountTransactionStatus[IShopperStaffDiscountTransactionStatus["Expired"] = 3] = "Expired";
    IShopperStaffDiscountTransactionStatus[IShopperStaffDiscountTransactionStatus["Archived"] = 4] = "Archived";
})(IShopperStaffDiscountTransactionStatus = exports.IShopperStaffDiscountTransactionStatus || (exports.IShopperStaffDiscountTransactionStatus = {}));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var CommonPagingDateFilteredPagingSettings;
(function (CommonPagingDateFilteredPagingSettings) {
    CommonPagingDateFilteredPagingSettings.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(CommonPagingDateFilteredPagingSettings = exports.CommonPagingDateFilteredPagingSettings || (exports.CommonPagingDateFilteredPagingSettings = {}));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var CommonPagingPagingSettings;
(function (CommonPagingPagingSettings) {
    CommonPagingPagingSettings.SortOrderEnum = {
        Ascending: 0,
        Descending: 1
    };
})(CommonPagingPagingSettings = exports.CommonPagingPagingSettings || (exports.CommonPagingPagingSettings = {}));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter;
(function (CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter) {
    CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter.GlobalFilterEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
    CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter = exports.CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter || (exports.CommonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter = {}));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var VariationsReportFilterEnum;
(function (VariationsReportFilterEnum) {
    VariationsReportFilterEnum[VariationsReportFilterEnum["ALL"] = 0] = "ALL";
    VariationsReportFilterEnum[VariationsReportFilterEnum["LIMITED"] = 1] = "LIMITED";
    VariationsReportFilterEnum[VariationsReportFilterEnum["UNLIMITED"] = 2] = "UNLIMITED";
})(VariationsReportFilterEnum = exports.VariationsReportFilterEnum || (exports.VariationsReportFilterEnum = {}));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
exports.__esModule = true;
__export(__webpack_require__(311));
__export(__webpack_require__(359));
__export(__webpack_require__(361));
__export(__webpack_require__(356));
__export(__webpack_require__(357));
__export(__webpack_require__(358));
__export(__webpack_require__(360));
__export(__webpack_require__(312));
__export(__webpack_require__(313));
__export(__webpack_require__(316));
__export(__webpack_require__(317));
__export(__webpack_require__(318));
__export(__webpack_require__(319));
__export(__webpack_require__(320));
__export(__webpack_require__(321));
__export(__webpack_require__(322));
__export(__webpack_require__(323));
__export(__webpack_require__(324));
__export(__webpack_require__(325));
__export(__webpack_require__(326));
__export(__webpack_require__(327));
__export(__webpack_require__(328));
__export(__webpack_require__(329));
__export(__webpack_require__(330));
__export(__webpack_require__(331));
__export(__webpack_require__(332));
__export(__webpack_require__(333));
__export(__webpack_require__(334));
__export(__webpack_require__(335));
__export(__webpack_require__(336));
__export(__webpack_require__(337));
__export(__webpack_require__(338));
__export(__webpack_require__(339));
__export(__webpack_require__(340));
__export(__webpack_require__(341));
__export(__webpack_require__(342));
__export(__webpack_require__(92));
__export(__webpack_require__(343));
__export(__webpack_require__(344));
__export(__webpack_require__(345));
__export(__webpack_require__(346));
__export(__webpack_require__(347));
__export(__webpack_require__(348));
__export(__webpack_require__(349));
__export(__webpack_require__(350));
__export(__webpack_require__(351));
__export(__webpack_require__(352));
__export(__webpack_require__(353));
__export(__webpack_require__(354));
__export(__webpack_require__(93));
__export(__webpack_require__(366));
__export(__webpack_require__(367));
__export(__webpack_require__(93));
__export(__webpack_require__(362));
__export(__webpack_require__(364));
__export(__webpack_require__(365));
__export(__webpack_require__(355));
var open360RetailerApiContractPhysicalProductSpecialOfferResourceModel_1 = __webpack_require__(363);
exports.SpecialOffer = open360RetailerApiContractPhysicalProductSpecialOfferResourceModel_1.Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicInventoryFiltersOperationFilter;
(function (Open360BusinessLogicInventoryFiltersOperationFilter) {
    Open360BusinessLogicInventoryFiltersOperationFilter.StatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
})(Open360BusinessLogicInventoryFiltersOperationFilter = exports.Open360BusinessLogicInventoryFiltersOperationFilter || (exports.Open360BusinessLogicInventoryFiltersOperationFilter = {}));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicInventoryModelsOperationStatistics;
(function (Open360BusinessLogicInventoryModelsOperationStatistics) {
    Open360BusinessLogicInventoryModelsOperationStatistics.SourceEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
    Open360BusinessLogicInventoryModelsOperationStatistics.KindEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360BusinessLogicInventoryModelsOperationStatistics.StatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360BusinessLogicInventoryModelsOperationStatistics.ResultEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
})(Open360BusinessLogicInventoryModelsOperationStatistics = exports.Open360BusinessLogicInventoryModelsOperationStatistics || (exports.Open360BusinessLogicInventoryModelsOperationStatistics = {}));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicInventoryModelsOperationStatisticsDetailed;
(function (Open360BusinessLogicInventoryModelsOperationStatisticsDetailed) {
    Open360BusinessLogicInventoryModelsOperationStatisticsDetailed.SourceEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
    Open360BusinessLogicInventoryModelsOperationStatisticsDetailed.KindEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360BusinessLogicInventoryModelsOperationStatisticsDetailed.StatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360BusinessLogicInventoryModelsOperationStatisticsDetailed.ResultEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
})(Open360BusinessLogicInventoryModelsOperationStatisticsDetailed = exports.Open360BusinessLogicInventoryModelsOperationStatisticsDetailed || (exports.Open360BusinessLogicInventoryModelsOperationStatisticsDetailed = {}));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicInventoryModelsProduct;
(function (Open360BusinessLogicInventoryModelsProduct) {
    Open360BusinessLogicInventoryModelsProduct.GenderEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicInventoryModelsProduct = exports.Open360BusinessLogicInventoryModelsProduct || (exports.Open360BusinessLogicInventoryModelsProduct = {}));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicInventoryModelsProductLink;
(function (Open360BusinessLogicInventoryModelsProductLink) {
    Open360BusinessLogicInventoryModelsProductLink.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_100: 100,
        NUMBER_101: 101,
        NUMBER_102: 102,
        NUMBER_103: 103
    };
})(Open360BusinessLogicInventoryModelsProductLink = exports.Open360BusinessLogicInventoryModelsProductLink || (exports.Open360BusinessLogicInventoryModelsProductLink = {}));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicInventoryModelsProductUpdateRequest;
(function (Open360BusinessLogicInventoryModelsProductUpdateRequest) {
    Open360BusinessLogicInventoryModelsProductUpdateRequest.GenderEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicInventoryModelsProductUpdateRequest = exports.Open360BusinessLogicInventoryModelsProductUpdateRequest || (exports.Open360BusinessLogicInventoryModelsProductUpdateRequest = {}));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicInventoryModelsProductVariant;
(function (Open360BusinessLogicInventoryModelsProductVariant) {
    Open360BusinessLogicInventoryModelsProductVariant.BadgesEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
})(Open360BusinessLogicInventoryModelsProductVariant = exports.Open360BusinessLogicInventoryModelsProductVariant || (exports.Open360BusinessLogicInventoryModelsProductVariant = {}));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicInventoryModelsProductVariantUpdateRequest;
(function (Open360BusinessLogicInventoryModelsProductVariantUpdateRequest) {
    Open360BusinessLogicInventoryModelsProductVariantUpdateRequest.BadgesEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
})(Open360BusinessLogicInventoryModelsProductVariantUpdateRequest = exports.Open360BusinessLogicInventoryModelsProductVariantUpdateRequest || (exports.Open360BusinessLogicInventoryModelsProductVariantUpdateRequest = {}));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicItemTypesBEGenderFilter;
(function (Open360BusinessLogicItemTypesBEGenderFilter) {
    Open360BusinessLogicItemTypesBEGenderFilter.GenderEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicItemTypesBEGenderFilter = exports.Open360BusinessLogicItemTypesBEGenderFilter || (exports.Open360BusinessLogicItemTypesBEGenderFilter = {}));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicItemTypesBEItemType;
(function (Open360BusinessLogicItemTypesBEItemType) {
    Open360BusinessLogicItemTypesBEItemType.MeasurementTypesEnum = {
        _1: '1',
        _2: '2',
        _3: '3',
        _4: '4',
        _5: '5',
        _6: '6',
        _7: '7',
        _8: '8',
        _9: '9'
    };
})(Open360BusinessLogicItemTypesBEItemType = exports.Open360BusinessLogicItemTypesBEItemType || (exports.Open360BusinessLogicItemTypesBEItemType = {}));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicPlacesPlacesPlaceListModel;
(function (Open360BusinessLogicPlacesPlacesPlaceListModel) {
    Open360BusinessLogicPlacesPlacesPlaceListModel.BusinessTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8
    };
})(Open360BusinessLogicPlacesPlacesPlaceListModel = exports.Open360BusinessLogicPlacesPlacesPlaceListModel || (exports.Open360BusinessLogicPlacesPlacesPlaceListModel = {}));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
// tslint:disable-next-line: no-namespace
var Open360BusinessLogicPlacesPlacesPlaceWithStateListModel;
(function (Open360BusinessLogicPlacesPlacesPlaceWithStateListModel) {
    Open360BusinessLogicPlacesPlacesPlaceWithStateListModel.BusinessTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8
    };
})(Open360BusinessLogicPlacesPlacesPlaceWithStateListModel = exports.Open360BusinessLogicPlacesPlacesPlaceWithStateListModel || (exports.Open360BusinessLogicPlacesPlacesPlaceWithStateListModel = {}));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo;
(function (Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo) {
    Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo.DefaultProductScanActionEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo.PaymentMethodEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
})(Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo = exports.Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo || (exports.Open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo = {}));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
//  0 = Standard, 1 = Pro, 2 = Enterprise
var Open360BusinessLogicRetailersAccountBERetailerProfile;
(function (Open360BusinessLogicRetailersAccountBERetailerProfile) {
    Open360BusinessLogicRetailersAccountBERetailerProfile.RetailerStatusEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360BusinessLogicRetailersAccountBERetailerProfile.PermissionEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicRetailersAccountBERetailerProfile = exports.Open360BusinessLogicRetailersAccountBERetailerProfile || (exports.Open360BusinessLogicRetailersAccountBERetailerProfile = {}));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersAccountStoreManagerPagingSettings;
(function (Open360BusinessLogicRetailersAccountStoreManagerPagingSettings) {
    Open360BusinessLogicRetailersAccountStoreManagerPagingSettings.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicRetailersAccountStoreManagerPagingSettings = exports.Open360BusinessLogicRetailersAccountStoreManagerPagingSettings || (exports.Open360BusinessLogicRetailersAccountStoreManagerPagingSettings = {}));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicRetailersCampaignsBECampaign;
(function (Open360BusinessLogicRetailersCampaignsBECampaign) {
    Open360BusinessLogicRetailersCampaignsBECampaign.DaysOfWeekEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
    Open360BusinessLogicRetailersCampaignsBECampaign.EntityStatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360BusinessLogicRetailersCampaignsBECampaign.ContentTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360BusinessLogicRetailersCampaignsBECampaign.VideoStatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360BusinessLogicRetailersCampaignsBECampaign.StatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8,
        NUMBER_9: 9,
        NUMBER_10: 10,
        NUMBER_13: 13,
        NUMBER_14: 14,
        NUMBER_15: 15
    };
    Open360BusinessLogicRetailersCampaignsBECampaign.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_8: 8
    };
})(Open360BusinessLogicRetailersCampaignsBECampaign = exports.Open360BusinessLogicRetailersCampaignsBECampaign || (exports.Open360BusinessLogicRetailersCampaignsBECampaign = {}));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersCampaignsBECampaignImage;
(function (Open360BusinessLogicRetailersCampaignsBECampaignImage) {
    Open360BusinessLogicRetailersCampaignsBECampaignImage.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
})(Open360BusinessLogicRetailersCampaignsBECampaignImage = exports.Open360BusinessLogicRetailersCampaignsBECampaignImage || (exports.Open360BusinessLogicRetailersCampaignsBECampaignImage = {}));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersInformationCardsBEInformationCardLink;
(function (Open360BusinessLogicRetailersInformationCardsBEInformationCardLink) {
    Open360BusinessLogicRetailersInformationCardsBEInformationCardLink.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_100: 100,
        NUMBER_101: 101,
        NUMBER_102: 102,
        NUMBER_103: 103
    };
})(Open360BusinessLogicRetailersInformationCardsBEInformationCardLink = exports.Open360BusinessLogicRetailersInformationCardsBEInformationCardLink || (exports.Open360BusinessLogicRetailersInformationCardsBEInformationCardLink = {}));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter;
(function (Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter) {
    Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter.GenderEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter = exports.Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter || (exports.Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter = {}));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours;
(function (Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours) {
    Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours.DayOfWeekEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6
    };
})(Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours = exports.Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours || (exports.Open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours = {}));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsBEBrand;
(function (Open360BusinessLogicRetailersPhysicalProductsBEBrand) {
    Open360BusinessLogicRetailersPhysicalProductsBEBrand.StatusEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicRetailersPhysicalProductsBEBrand = exports.Open360BusinessLogicRetailersPhysicalProductsBEBrand || (exports.Open360BusinessLogicRetailersPhysicalProductsBEBrand = {}));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct;
(function (Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct) {
    Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct.GenderEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct = exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct || (exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct = {}));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink;
(function (Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink) {
    Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_100: 100,
        NUMBER_101: 101,
        NUMBER_102: 102,
        NUMBER_103: 103
    };
})(Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink = exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink || (exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink = {}));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation;
(function (Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation) {
    Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation.BadgesEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
})(Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation = exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation || (exports.Open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation = {}));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter;
(function (Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter) {
    Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.ProductStateEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
    Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter = exports.Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter || (exports.Open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter = {}));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter;
(function (Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter) {
    Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter = exports.Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter || (exports.Open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter = {}));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter;
(function (Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter) {
    Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter = exports.Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter || (exports.Open360BusinessLogicRetailersReferralAccountsReferralAccountFilter = {}));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360BusinessLogicRetailersStoresBEStoreInventoryResponse;
(function (Open360BusinessLogicRetailersStoresBEStoreInventoryResponse) {
    Open360BusinessLogicRetailersStoresBEStoreInventoryResponse.BusinessTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8
    };
})(Open360BusinessLogicRetailersStoresBEStoreInventoryResponse = exports.Open360BusinessLogicRetailersStoresBEStoreInventoryResponse || (exports.Open360BusinessLogicRetailersStoresBEStoreInventoryResponse = {}));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicRetailersStoresStoreFilter;
(function (Open360BusinessLogicRetailersStoresStoreFilter) {
    Open360BusinessLogicRetailersStoresStoreFilter.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicRetailersStoresStoreFilter = exports.Open360BusinessLogicRetailersStoresStoreFilter || (exports.Open360BusinessLogicRetailersStoresStoreFilter = {}));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings;
(function (Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings) {
    Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings = exports.Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings || (exports.Open360BusinessLogicSalesAssistantSalesAssistantPagingSettings = {}));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesListItemsClassificationCategoryListItem;
(function (Open360EntitiesListItemsClassificationCategoryListItem) {
    Open360EntitiesListItemsClassificationCategoryListItem.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8
    };
})(Open360EntitiesListItemsClassificationCategoryListItem = exports.Open360EntitiesListItemsClassificationCategoryListItem || (exports.Open360EntitiesListItemsClassificationCategoryListItem = {}));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiAnalyticsFilter;
(function (Open360EntitiesRetailerApiAnalyticsFilter) {
    Open360EntitiesRetailerApiAnalyticsFilter.BreakdownEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360EntitiesRetailerApiAnalyticsFilter = exports.Open360EntitiesRetailerApiAnalyticsFilter || (exports.Open360EntitiesRetailerApiAnalyticsFilter = {}));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiBillingStatementListItem;
(function (Open360EntitiesRetailerApiBillingStatementListItem) {
    Open360EntitiesRetailerApiBillingStatementListItem.CardTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
    Open360EntitiesRetailerApiBillingStatementListItem.ReasonEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
})(Open360EntitiesRetailerApiBillingStatementListItem = exports.Open360EntitiesRetailerApiBillingStatementListItem || (exports.Open360EntitiesRetailerApiBillingStatementListItem = {}));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiBrandListItem;
(function (Open360EntitiesRetailerApiBrandListItem) {
    Open360EntitiesRetailerApiBrandListItem.StatusEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360EntitiesRetailerApiBrandListItem = exports.Open360EntitiesRetailerApiBrandListItem || (exports.Open360EntitiesRetailerApiBrandListItem = {}));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360EntitiesRetailerApiCampaignListItem;
(function (Open360EntitiesRetailerApiCampaignListItem) {
    Open360EntitiesRetailerApiCampaignListItem.DaysOfWeekEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
    Open360EntitiesRetailerApiCampaignListItem.EntityStatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360EntitiesRetailerApiCampaignListItem.StatusEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8,
        NUMBER_9: 9,
        NUMBER_10: 10,
        NUMBER_13: 13,
        NUMBER_14: 14,
        NUMBER_15: 15
    };
    Open360EntitiesRetailerApiCampaignListItem.Line1FontSizeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360EntitiesRetailerApiCampaignListItem.Line2FontSizeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360EntitiesRetailerApiCampaignListItem.Line3FontSizeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
    Open360EntitiesRetailerApiCampaignListItem.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_8: 8
    };
})(Open360EntitiesRetailerApiCampaignListItem = exports.Open360EntitiesRetailerApiCampaignListItem || (exports.Open360EntitiesRetailerApiCampaignListItem = {}));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiPhysicalProductLinkListItem;
(function (Open360EntitiesRetailerApiPhysicalProductLinkListItem) {
    Open360EntitiesRetailerApiPhysicalProductLinkListItem.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_100: 100,
        NUMBER_101: 101,
        NUMBER_102: 102,
        NUMBER_103: 103
    };
})(Open360EntitiesRetailerApiPhysicalProductLinkListItem = exports.Open360EntitiesRetailerApiPhysicalProductLinkListItem || (exports.Open360EntitiesRetailerApiPhysicalProductLinkListItem = {}));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiPhysicalProductVariationListItem;
(function (Open360EntitiesRetailerApiPhysicalProductVariationListItem) {
    Open360EntitiesRetailerApiPhysicalProductVariationListItem.BadgesEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_4: 4,
        NUMBER_8: 8,
        NUMBER_16: 16,
        NUMBER_32: 32,
        NUMBER_64: 64
    };
})(Open360EntitiesRetailerApiPhysicalProductVariationListItem = exports.Open360EntitiesRetailerApiPhysicalProductVariationListItem || (exports.Open360EntitiesRetailerApiPhysicalProductVariationListItem = {}));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiStoreTapAndGoListItem;
(function (Open360EntitiesRetailerApiStoreTapAndGoListItem) {
    Open360EntitiesRetailerApiStoreTapAndGoListItem.DefaultProductScanActionEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360EntitiesRetailerApiStoreTapAndGoListItem.PaymentMethodEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360EntitiesRetailerApiStoreTapAndGoListItem = exports.Open360EntitiesRetailerApiStoreTapAndGoListItem || (exports.Open360EntitiesRetailerApiStoreTapAndGoListItem = {}));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360EntitiesRetailerApiVisitsAnalyticsFilter;
(function (Open360EntitiesRetailerApiVisitsAnalyticsFilter) {
    Open360EntitiesRetailerApiVisitsAnalyticsFilter.GroupEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
    Open360EntitiesRetailerApiVisitsAnalyticsFilter.BreakdownEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360EntitiesRetailerApiVisitsAnalyticsFilter = exports.Open360EntitiesRetailerApiVisitsAnalyticsFilter || (exports.Open360EntitiesRetailerApiVisitsAnalyticsFilter = {}));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360NfcStickersAbstractionsFiltersNfcStickerRequest;
(function (Open360NfcStickersAbstractionsFiltersNfcStickerRequest) {
    Open360NfcStickersAbstractionsFiltersNfcStickerRequest.NfcStickerTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
})(Open360NfcStickersAbstractionsFiltersNfcStickerRequest = exports.Open360NfcStickersAbstractionsFiltersNfcStickerRequest || (exports.Open360NfcStickersAbstractionsFiltersNfcStickerRequest = {}));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360NfcStickersModelsFiltersNfcStickerRequest;
(function (Open360NfcStickersModelsFiltersNfcStickerRequest) {
    Open360NfcStickersModelsFiltersNfcStickerRequest.NfcStickerTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
})(Open360NfcStickersModelsFiltersNfcStickerRequest = exports.Open360NfcStickersModelsFiltersNfcStickerRequest || (exports.Open360NfcStickersModelsFiltersNfcStickerRequest = {}));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360NfcStickersModelsNfcOperation;
(function (Open360NfcStickersModelsNfcOperation) {
    Open360NfcStickersModelsNfcOperation.StateEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360NfcStickersModelsNfcOperation.KindEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
})(Open360NfcStickersModelsNfcOperation = exports.Open360NfcStickersModelsNfcOperation || (exports.Open360NfcStickersModelsNfcOperation = {}));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360NfcStickersModelsNfcSticker;
(function (Open360NfcStickersModelsNfcSticker) {
    Open360NfcStickersModelsNfcSticker.NfcStickerTypeEnum = {
        Product: 1,
        InformationCard: 2,
        Offer: 3,
        CheckOut: 4,
        CheckIn: 5
    };
})(Open360NfcStickersModelsNfcSticker = exports.Open360NfcStickersModelsNfcSticker || (exports.Open360NfcStickersModelsNfcSticker = {}));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractNfcStickersCreateNfcExportRequest;
(function (Open360RetailerApiContractNfcStickersCreateNfcExportRequest) {
    Open360RetailerApiContractNfcStickersCreateNfcExportRequest.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
})(Open360RetailerApiContractNfcStickersCreateNfcExportRequest = exports.Open360RetailerApiContractNfcStickersCreateNfcExportRequest || (exports.Open360RetailerApiContractNfcStickersCreateNfcExportRequest = {}));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractNfcStickersCreateNfcOperationRequest;
(function (Open360RetailerApiContractNfcStickersCreateNfcOperationRequest) {
    Open360RetailerApiContractNfcStickersCreateNfcOperationRequest.AssignTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360RetailerApiContractNfcStickersCreateNfcOperationRequest = exports.Open360RetailerApiContractNfcStickersCreateNfcOperationRequest || (exports.Open360RetailerApiContractNfcStickersCreateNfcOperationRequest = {}));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360RetailerApiContractNfcStickersNfcOperationModel;
(function (Open360RetailerApiContractNfcStickersNfcOperationModel) {
    Open360RetailerApiContractNfcStickersNfcOperationModel.StateEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4
    };
    Open360RetailerApiContractNfcStickersNfcOperationModel.KindEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3
    };
})(Open360RetailerApiContractNfcStickersNfcOperationModel = exports.Open360RetailerApiContractNfcStickersNfcOperationModel || (exports.Open360RetailerApiContractNfcStickersNfcOperationModel = {}));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractNfcStickersNfcStickerModel;
(function (Open360RetailerApiContractNfcStickersNfcStickerModel) {
    Open360RetailerApiContractNfcStickersNfcStickerModel.NfcStickerTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5
    };
})(Open360RetailerApiContractNfcStickersNfcStickerModel = exports.Open360RetailerApiContractNfcStickersNfcStickerModel || (exports.Open360RetailerApiContractNfcStickersNfcStickerModel = {}));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel;
(function (Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel) {
    Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel.TypeEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel = exports.Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel || (exports.Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel = {}));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings;
(function (Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings) {
    Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings = exports.Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings || (exports.Open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings = {}));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings;
(function (Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings) {
    Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings.SortOrderEnum = {
        NUMBER_0: 0,
        NUMBER_1: 1
    };
})(Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings = exports.Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings || (exports.Open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings = {}));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var Open360ShopperApiContractV18MeasurementsMeasurementListItem;
(function (Open360ShopperApiContractV18MeasurementsMeasurementListItem) {
    Open360ShopperApiContractV18MeasurementsMeasurementListItem.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2,
        NUMBER_3: 3,
        NUMBER_4: 4,
        NUMBER_5: 5,
        NUMBER_6: 6,
        NUMBER_7: 7,
        NUMBER_8: 8,
        NUMBER_9: 9
    };
})(Open360ShopperApiContractV18MeasurementsMeasurementListItem = exports.Open360ShopperApiContractV18MeasurementsMeasurementListItem || (exports.Open360ShopperApiContractV18MeasurementsMeasurementListItem = {}));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360ShopperApiContractV18PaymentCardPaymentCardListItem;
(function (Open360ShopperApiContractV18PaymentCardPaymentCardListItem) {
    Open360ShopperApiContractV18PaymentCardPaymentCardListItem.TypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360ShopperApiContractV18PaymentCardPaymentCardListItem = exports.Open360ShopperApiContractV18PaymentCardPaymentCardListItem || (exports.Open360ShopperApiContractV18PaymentCardPaymentCardListItem = {}));


/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.ts": 238,
	"./modules/account/account.service.ts": 1223,
	"./modules/account/components/forgotPassword/forgotPassword.component.ts": 1224,
	"./modules/account/components/login/login.component.ts": 1225,
	"./modules/account/components/profile/change-retailer-email/change-retailer-email.component.ts": 1226,
	"./modules/account/components/profile/change-retailer-password/change-retailer-password.component.ts": 1227,
	"./modules/account/components/profile/profile.component.ts": 1228,
	"./modules/account/components/reportSupervisor/reportSupervisor.component.ts": 1229,
	"./modules/account/components/resetPassword/resetPassword.component.ts": 1230,
	"./modules/account/components/resetSuccess/resetSuccess.component.ts": 1231,
	"./modules/account/components/selectRole/selectRole.component.ts": 1232,
	"./modules/account/jispPayAccount.service.ts": 1233,
	"./modules/account/model/iLogin.ts": 1234,
	"./modules/account/model/iUser.ts": 239,
	"./modules/account/model/index.ts": 1235,
	"./modules/account/model/reset-response.model.ts": 1236,
	"./modules/account/uniqueEmail.directive.ts": 1237,
	"./modules/analytics/analytics.service.ts": 1238,
	"./modules/analytics/analyticsBase.ts": 63,
	"./modules/analytics/components/analytics/analytics.component.ts": 1239,
	"./modules/analytics/components/analyticsChart/analyticsChart.component.ts": 1240,
	"./modules/analytics/components/analyticsFilter/analyticsFilter.component.ts": 1241,
	"./modules/analytics/components/campaignAnalytics/campaignAnalytics.component.ts": 1242,
	"./modules/analytics/components/shopCampaignAnalytics/shopCampaignAnalytics.component.ts": 1243,
	"./modules/analytics/components/shopImpressionAnalytics/shopImpressionAnalytics.component.ts": 1244,
	"./modules/analytics/components/shopVisitsAnalytics/shopVisitsAnalytics.component.ts": 1245,
	"./modules/analytics/components/staffRating/staffRatingAnalytics.component.ts": 1246,
	"./modules/api/index.ts": 1247,
	"./modules/api/retailer.service.ts": 1248,
	"./modules/brands/brands.service.ts": 1249,
	"./modules/brands/components/brandStatus/brandStatus.component.ts": 1250,
	"./modules/brands/components/brandsSelector/brandsSelector.component.ts": 1251,
	"./modules/brands/components/choiceBrands/choiceBrands.component.ts": 1252,
	"./modules/bundles/components/add-items-popup/add-items-popup.component.ts": 1253,
	"./modules/bundles/components/bundle-details/bundle-details.component.ts": 1254,
	"./modules/bundles/components/bundle-list/bundle-list.component.ts": 1255,
	"./modules/bundles/components/create-template-dialog/create-template-dialog.component.ts": 1256,
	"./modules/bundles/components/edit-bundle-details-form/edit-bundle-details-form.component.ts": 1257,
	"./modules/bundles/components/edit-bundle-items/edit-bundle-items.component.ts": 1258,
	"./modules/bundles/components/new-edit-bundle/new-edit-bundle.component.ts": 1259,
	"./modules/bundles/models/models.ts": 82,
	"./modules/bundles/services/bundles.service.ts": 1260,
	"./modules/campaigns/components/audience-view/audience-view.ts": 1261,
	"./modules/campaigns/components/campaignDescription/camapign-description.ts": 1262,
	"./modules/campaigns/components/campaignsOverview/campaignsOverview.component.ts": 1263,
	"./modules/campaigns/components/designRequest/designRequest.component.ts": 1264,
	"./modules/campaigns/components/marketingCampaign/marketingCampaign.component.ts": 1265,
	"./modules/campaigns/components/viewCampaign/viewCampaign.component.ts": 1266,
	"./modules/campaigns/controllers/createEditCampaignBase.controller.ts": 240,
	"./modules/campaigns/directives/image-onload.directive.ts": 1267,
	"./modules/campaigns/models/index.ts": 1268,
	"./modules/campaigns/services/campaigns.service.ts": 1269,
	"./modules/campaigns/services/designRequest.service.ts": 1270,
	"./modules/categories/categoriesSelector.service.ts": 1271,
	"./modules/clickAndDeliver/components/clickAndDeliver.component.ts": 1272,
	"./modules/common/components/sidebar/sidebar.component.ts": 1273,
	"./modules/common/components/topNavbar/topNavbar.component.ts": 1274,
	"./modules/common/filters/campaignTime.filter.ts": 1275,
	"./modules/common/filters/endDate.filter.ts": 1276,
	"./modules/common/filters/serverDate.filter.ts": 1277,
	"./modules/common/filters/titleCase.filter.ts": 1278,
	"./modules/common/services/auth.service.ts": 1279,
	"./modules/common/services/ingredients.service.ts": 1280,
	"./modules/common/services/navigation.service.ts": 1281,
	"./modules/common/services/services.service.ts": 1282,
	"./modules/core/core.controller.ts": 1283,
	"./modules/core/core.run.ts": 1284,
	"./modules/core/index.ts": 56,
	"./modules/core/models.ts": 1285,
	"./modules/discountForStaff/discount-for-staff.service.ts": 1286,
	"./modules/discountForStaff/history-tab/discount-for-staff-history-tab.component.ts": 1287,
	"./modules/discountForStaff/special-tab/active-tab/add-or-edit-staff/add-or-edit-staff.component.ts": 1288,
	"./modules/discountForStaff/special-tab/active-tab/confirm-password/discount-for-staff-confirm-password.component.ts": 1289,
	"./modules/discountForStaff/special-tab/active-tab/discount-for-staff-special-active-tab.component.ts": 1290,
	"./modules/discountForStaff/special-tab/discount-for-staff-special-tab.component.ts": 1291,
	"./modules/discountForStaff/tabs-list/discount-for-staff-tab-list.component.ts": 1292,
	"./modules/discountForStaff/transaction-tab/single-transaction/discount-for-staff-single-transaction.component.ts": 1293,
	"./modules/discountForStaff/transaction-tab/transaction-export-history/transaction-export-history.component.ts": 1294,
	"./modules/discountForStaff/transaction-tab/transaction-with-discount-tab/transaction-discount-filter/transaction-discount-filter.component.ts": 1295,
	"./modules/discountForStaff/transaction-tab/transaction-with-discount-tab/transaction-discount-information-box/transaction-discount-information-box.component.ts": 1296,
	"./modules/discountForStaff/transaction-tab/transaction-with-discount-tab/transaction-with-discount-tab.component.ts": 1297,
	"./modules/dpp-analytics/downloads/downloads.component.ts": 1298,
	"./modules/dpp-analytics/dpp-analytics.service.ts": 1299,
	"./modules/extras/active-extras/active-extras.component.ts": 1300,
	"./modules/extras/add-or-edit-extra-item/add-or-edit-extra-item.component.ts": 1301,
	"./modules/extras/archived-extras/archived-extras.component.ts": 1302,
	"./modules/extras/extra-item-card/extra-item-card.component.ts": 1303,
	"./modules/extras/extras.service.ts": 1304,
	"./modules/extras/models/models.ts": 1305,
	"./modules/extras/shared/checkboxes-group-list/checkboxes-group-list.component.ts": 1306,
	"./modules/extras/shared/search/search.component.ts": 1307,
	"./modules/foodPreferences/components/preference-selector.component.ts": 1308,
	"./modules/foodPreferences/foodPreference.service.ts": 1309,
	"./modules/home/homeScreen.component.ts": 1310,
	"./modules/informationCards/components/choiceProductImages/choiceInformationCardImages.component.ts": 1311,
	"./modules/informationCards/components/informationCard/informationCard.component.ts": 1312,
	"./modules/informationCards/components/informationCardSearch/informationCard.search.components.ts": 1313,
	"./modules/informationCards/components/informationCards/informationCards.component.ts": 1314,
	"./modules/informationCards/informationCardBase.controller.ts": 241,
	"./modules/informationCards/informationCards.service.ts": 1315,
	"./modules/informationCards/models/index.ts": 1316,
	"./modules/ingredients/tabs-list/ingredient-dialog/ingredient-dialog.component.ts": 1317,
	"./modules/ingredients/tabs-list/ingredients-tabs.component.ts": 1318,
	"./modules/inventory/components/chooseCategory/chooseCategory.component.ts": 1319,
	"./modules/inventory/components/help-countries/help-countries.component.ts": 1320,
	"./modules/inventory/components/help-dictionary/help-dictionary.component.ts": 1321,
	"./modules/inventory/components/help-page/help-page.component.ts": 1322,
	"./modules/inventory/components/help-preferences/help-preferences.component.ts": 1323,
	"./modules/inventory/components/import-errors-list/import-errors-list.component.ts": 1324,
	"./modules/inventory/components/import-tab/import-tab.component.ts": 1325,
	"./modules/inventory/components/import-tab/tooltip-state.ts": 74,
	"./modules/inventory/components/import-tab/tooltip.component.ts": 1326,
	"./modules/inventory/components/inventory/inventory.component.ts": 1327,
	"./modules/inventory/components/operation-list/operation-list.component.ts": 1328,
	"./modules/inventory/components/operation-list/operation-status.component.ts": 1329,
	"./modules/inventory/components/operation/operationComponent.ts": 1330,
	"./modules/inventory/inventory.service.ts": 1331,
	"./modules/inventory/models/index.ts": 75,
	"./modules/inventory/operation.service.ts": 1332,
	"./modules/jispPay/components/jispPayAccount/jispPayAccount.component.ts": 1333,
	"./modules/jispPay/components/jispPayStaff/archive-confirmation-dialog/archive-confirmation-dialog.component.ts": 1334,
	"./modules/jispPay/components/jispPayStaff/jispPayStaff.component.ts": 1335,
	"./modules/jispPay/components/jisppayPlaces/jisppayPlaces.component.ts": 1336,
	"./modules/jispPay/components/jisppayPlaces/payment-settings-popup/payment-settings-popup.component.ts": 1337,
	"./modules/jispPay/components/passwordConfirmation/passwordConfirmation.component.ts": 1338,
	"./modules/jispPay/components/vendors/add-or-edit-vendor-item/add-or-edit-vendor-item.component.ts": 1339,
	"./modules/jispPay/components/vendors/models/IVendor.ts": 1340,
	"./modules/jispPay/components/vendors/models/IVendorImageSize.ts": 1341,
	"./modules/jispPay/components/vendors/models/IVendorListItem.ts": 1342,
	"./modules/jispPay/components/vendors/models/IVendorSearchFilter.ts": 1343,
	"./modules/jispPay/components/vendors/vendors-mock.service.ts": 1344,
	"./modules/jispPay/components/vendors/vendors.service.ts": 1345,
	"./modules/jispPay/jispPay.service.ts": 1346,
	"./modules/jispPay/models/ICompanyInformation.ts": 1347,
	"./modules/jispPay/models/IJispPayAccount.ts": 242,
	"./modules/jispPay/models/index.ts": 243,
	"./modules/loyaltyProgram/loyaltyProgram.service.ts": 1348,
	"./modules/marketplace/ad-for-marketplace/ad-for-marketplace.component.ts": 1349,
	"./modules/marketplace/ad-image-selector/ad-image-selector.component.ts": 1350,
	"./modules/marketplace/marketplace.service.ts": 1351,
	"./modules/marketplace/models/ICroppedImage.ts": 1352,
	"./modules/marketplace/models/IImageCroppedState.ts": 1353,
	"./modules/marketplace/models/IImageError.ts": 1354,
	"./modules/marketplace/models/IMarketPlaceRetailerAdvert.ts": 1355,
	"./modules/marketplace/models/IRetailerAdvert.ts": 1356,
	"./modules/menus/components/menu-card/menu.card.component.ts": 1357,
	"./modules/menus/components/menu-editor/menu.editor.component.ts": 1358,
	"./modules/menus/components/menu-schedule-render/menu.schedule.render.component.ts": 1359,
	"./modules/menus/components/menus/menus.component.ts": 1360,
	"./modules/menus/menu.service.ts": 1361,
	"./modules/menus/models.ts": 1362,
	"./modules/menus/schedule.service.ts": 1363,
	"./modules/model/IActiveStaffsFilter.ts": 91,
	"./modules/model/IAnaliticsData.ts": 1652,
	"./modules/model/IFindShopperByEmailRequest.ts": 1653,
	"./modules/model/IInformationCardsSearch.ts": 1654,
	"./modules/model/ILanguageSettings.ts": 1655,
	"./modules/model/IPagingResult.model.ts": 1656,
	"./modules/model/IPagingResultShopperStaffDiscountItem.ts": 1657,
	"./modules/model/IPagingResultShopperStaffDiscountTransactionListItem.ts": 1658,
	"./modules/model/IPlaceInfo.ts": 1659,
	"./modules/model/IShopperInfo.ts": 1660,
	"./modules/model/IShopperStaffDiscountCreate.ts": 1661,
	"./modules/model/IShopperStaffDiscountEdit.ts": 1662,
	"./modules/model/IShopperStaffDiscountTransaction.ts": 1663,
	"./modules/model/IShopperStaffDiscountTransactionExtraItem.ts": 1664,
	"./modules/model/IShopperStaffDiscountTransactionFilter.ts": 1665,
	"./modules/model/IShopperStaffDiscountTransactionItem.ts": 1666,
	"./modules/model/IShopperStaffDiscountTransactionListItem.ts": 310,
	"./modules/model/IShopperStaffDiscountTransactionsSummary.ts": 1667,
	"./modules/model/commonDataUtilsDataUploadFileData.ts": 1668,
	"./modules/model/commonPagingDateFilteredPagingSettings.ts": 311,
	"./modules/model/commonPagingPagingResultOpen360BusinessLogicInventoryModelsOperationStatistics.ts": 1669,
	"./modules/model/commonPagingPagingResultOpen360BusinessLogicPlacesPlacesPlaceForRulesListModel.ts": 1670,
	"./modules/model/commonPagingPagingResultOpen360BusinessLogicPlacesPlacesPlaceListShortModel.ts": 1671,
	"./modules/model/commonPagingPagingResultOpen360BusinessLogicPlacesPlacesPlaceWithStateListModel.ts": 1672,
	"./modules/model/commonPagingPagingResultOpen360EntitiesListItemsSalesAssistantListItem.ts": 1673,
	"./modules/model/commonPagingPagingResultOpen360EntitiesListItemsStoreManagerAccountListItem.ts": 1674,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiBillingStatementListItem.ts": 1675,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiCampaignListItem.ts": 1676,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiInformationCardListItem.ts": 1677,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiInvoiceListItem.ts": 1678,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiPhysicalProductListItem.ts": 1679,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiPhysicalProductSearchItem.ts": 1680,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiPlaceJispPayListItem.ts": 1681,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiReferralAccountListItem.ts": 1682,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiStoreLoyaltyProgramListItem.ts": 1683,
	"./modules/model/commonPagingPagingResultOpen360EntitiesRetailerApiStoreTapAndGoListItem.ts": 1684,
	"./modules/model/commonPagingPagingResultOpen360NfcStickersModelsNfcOperation.ts": 1685,
	"./modules/model/commonPagingPagingResultOpen360NfcStickersModelsNfcSticker.ts": 1686,
	"./modules/model/commonPagingPagingResultOpen360NfcStickersModelsNfcStickerShort.ts": 1687,
	"./modules/model/commonPagingPagingResultOpen360RetailerApiContractExtrasExtraItemResourceBaseModel.ts": 1688,
	"./modules/model/commonPagingPagingResultOpen360RetailerApiContractExtrasExtraItemResourceModel.ts": 1689,
	"./modules/model/commonPagingPagingResultOpen360RetailerApiContractNfcStickersNfcStickerModel.ts": 1690,
	"./modules/model/commonPagingPagingResultOpen360RetailerApiContractSalesAssistantSalesAssistantItem.ts": 1691,
	"./modules/model/commonPagingPagingResultOpen360RetailerApiContractSalesAssistantSalesAssistantRatingItem.ts": 1692,
	"./modules/model/commonPagingPagingResultOpen360SalesAssistantAbstractsModelsSalesAssistantListItem.ts": 1693,
	"./modules/model/commonPagingPagingSettings.ts": 312,
	"./modules/model/commonPagingPagingSettingsOpen360EntitiesFiltersSlotFliter.ts": 313,
	"./modules/model/dpp-analytics/reading-location-variations-statistics.interface.ts": 1694,
	"./modules/model/dpp-analytics/variations-report-filter.enum.ts": 314,
	"./modules/model/dpp-analytics/variations-report-request.interface.ts": 1695,
	"./modules/model/dpp-analytics/variations-statistic.interface.ts": 1696,
	"./modules/model/ingredients/IIngredient.ts": 1697,
	"./modules/model/ingredients/IIngredientSearchFilter.ts": 1698,
	"./modules/model/models.ts": 315,
	"./modules/model/open360APICoreActionResultsFileDataResult.ts": 1699,
	"./modules/model/open360BusinessLogicBEBeacon.ts": 1700,
	"./modules/model/open360BusinessLogicBEBeacons.ts": 1701,
	"./modules/model/open360BusinessLogicBagCheckSettings.ts": 1702,
	"./modules/model/open360BusinessLogicCategoriesInventoryListItem.ts": 1703,
	"./modules/model/open360BusinessLogicInventoryFiltersOperationFilter.ts": 316,
	"./modules/model/open360BusinessLogicInventoryModelsOperationResponse.ts": 1704,
	"./modules/model/open360BusinessLogicInventoryModelsOperationStatistics.ts": 317,
	"./modules/model/open360BusinessLogicInventoryModelsOperationStatisticsDetailed.ts": 318,
	"./modules/model/open360BusinessLogicInventoryModelsPriceUpdate.ts": 1705,
	"./modules/model/open360BusinessLogicInventoryModelsPriceUpdateRequest.ts": 1706,
	"./modules/model/open360BusinessLogicInventoryModelsPriceUpdatesRequest.ts": 1707,
	"./modules/model/open360BusinessLogicInventoryModelsProduct.ts": 319,
	"./modules/model/open360BusinessLogicInventoryModelsProductLink.ts": 320,
	"./modules/model/open360BusinessLogicInventoryModelsProductRequest.ts": 1708,
	"./modules/model/open360BusinessLogicInventoryModelsProductUpdateRequest.ts": 321,
	"./modules/model/open360BusinessLogicInventoryModelsProductVariant.ts": 322,
	"./modules/model/open360BusinessLogicInventoryModelsProductVariantImage.ts": 1709,
	"./modules/model/open360BusinessLogicInventoryModelsProductVariantUpdateRequest.ts": 323,
	"./modules/model/open360BusinessLogicInventoryModelsProductVariantsArchiveRequest.ts": 1710,
	"./modules/model/open360BusinessLogicInventoryModelsProductsImportResult.ts": 1711,
	"./modules/model/open360BusinessLogicInventoryModelsProductsImportResultEntryShort.ts": 1712,
	"./modules/model/open360BusinessLogicInventoryModelsProductsImportResultGroupedEntries.ts": 1713,
	"./modules/model/open360BusinessLogicInventoryModelsProductsUpdateRequest.ts": 1714,
	"./modules/model/open360BusinessLogicInventoryModelsValidationError.ts": 1715,
	"./modules/model/open360BusinessLogicInventoryValidationBatchValidationResult.ts": 1716,
	"./modules/model/open360BusinessLogicInventoryValidationValidationResult.ts": 1717,
	"./modules/model/open360BusinessLogicItemTypesBEGenderFilter.ts": 324,
	"./modules/model/open360BusinessLogicItemTypesBEItemType.ts": 325,
	"./modules/model/open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements.ts": 1718,
	"./modules/model/open360BusinessLogicItemTypesItemTypeWithMeasurements.ts": 1719,
	"./modules/model/open360BusinessLogicPhysicalProductsPhysicalProductVariantFieldsName.ts": 1720,
	"./modules/model/open360BusinessLogicPlacesOffersAudienceOfferAudienceModel.ts": 1721,
	"./modules/model/open360BusinessLogicPlacesOffersAudienceOfferAudienceResourceModel.ts": 1722,
	"./modules/model/open360BusinessLogicPlacesOffersAudienceOfferCategoryListItem.ts": 1723,
	"./modules/model/open360BusinessLogicPlacesOffersAudienceOfferPlaceListItem.ts": 1724,
	"./modules/model/open360BusinessLogicPlacesPlacesPlaceForRulesListModel.ts": 1725,
	"./modules/model/open360BusinessLogicPlacesPlacesPlaceListModel.ts": 326,
	"./modules/model/open360BusinessLogicPlacesPlacesPlaceListShortModel.ts": 1726,
	"./modules/model/open360BusinessLogicPlacesPlacesPlaceWithStateListModel.ts": 327,
	"./modules/model/open360BusinessLogicPlacesTapAndGoBEStoreTapAndGo.ts": 328,
	"./modules/model/open360BusinessLogicRetailersAccountBERetailerChangeEmail.ts": 1727,
	"./modules/model/open360BusinessLogicRetailersAccountBERetailerChangePassword.ts": 1728,
	"./modules/model/open360BusinessLogicRetailersAccountBERetailerForgotPassword.ts": 1729,
	"./modules/model/open360BusinessLogicRetailersAccountBERetailerProfile.ts": 329,
	"./modules/model/open360BusinessLogicRetailersAccountBERetailerResetPassword.ts": 1730,
	"./modules/model/open360BusinessLogicRetailersAccountBEStoreManagerAccount.ts": 1731,
	"./modules/model/open360BusinessLogicRetailersAccountStoreManagerPagingSettings.ts": 330,
	"./modules/model/open360BusinessLogicRetailersBillingBEWithdrawalPayPayAccount.ts": 1732,
	"./modules/model/open360BusinessLogicRetailersCampaignsBECampaign.ts": 331,
	"./modules/model/open360BusinessLogicRetailersCampaignsBECampaignImage.ts": 332,
	"./modules/model/open360BusinessLogicRetailersCampaignsBECampaignKeyword.ts": 1733,
	"./modules/model/open360BusinessLogicRetailersCampaignsBECampaignProductLink.ts": 1734,
	"./modules/model/open360BusinessLogicRetailersCampaignsBEVideoMetadata.ts": 1735,
	"./modules/model/open360BusinessLogicRetailersGoogleCalendarGoogleCalendarEvent.ts": 1736,
	"./modules/model/open360BusinessLogicRetailersInformationCardsBEInformationCard.ts": 1737,
	"./modules/model/open360BusinessLogicRetailersInformationCardsBEInformationCardLink.ts": 333,
	"./modules/model/open360BusinessLogicRetailersInformationCardsNfcStickerItemModel.ts": 1738,
	"./modules/model/open360BusinessLogicRetailersLoyaltyProgramBEStoreLoyaltyProgram.ts": 1739,
	"./modules/model/open360BusinessLogicRetailersLoyaltyProgramBEStoreRedemptionAmount.ts": 1740,
	"./modules/model/open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter.ts": 334,
	"./modules/model/open360BusinessLogicRetailersNeedHelpBENeedHelp.ts": 1741,
	"./modules/model/open360BusinessLogicRetailersOpeningHoursBEInterval.ts": 1742,
	"./modules/model/open360BusinessLogicRetailersOpeningHoursBENormalOpeningHours.ts": 335,
	"./modules/model/open360BusinessLogicRetailersOpeningHoursBEOpeningHours.ts": 1743,
	"./modules/model/open360BusinessLogicRetailersOpeningHoursBESpecialOpeningHours.ts": 1744,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEBrand.ts": 336,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEClassificationCategory.ts": 1745,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProduct.ts": 337,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductLink.ts": 338,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation.ts": 339,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariationPrice.ts": 1746,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsNfcStickerProductItemModel.ts": 1747,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductExtraItemModel.ts": 1748,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductFetchFilter.ts": 1749,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductFilter.ts": 340,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductMetadata.ts": 1750,
	"./modules/model/open360BusinessLogicRetailersPhysicalProductsPhysicalProductSearchFilter.ts": 341,
	"./modules/model/open360BusinessLogicRetailersReferralAccountsBEReferralAccount.ts": 1751,
	"./modules/model/open360BusinessLogicRetailersReferralAccountsReferralAccountFilter.ts": 342,
	"./modules/model/open360BusinessLogicRetailersStoresBEInventoryListItem.ts": 1752,
	"./modules/model/open360BusinessLogicRetailersStoresBEJispPayMerchantListItem.ts": 1753,
	"./modules/model/open360BusinessLogicRetailersStoresBEStore.ts": 92,
	"./modules/model/open360BusinessLogicRetailersStoresBEStoreInventoryRequest.ts": 1754,
	"./modules/model/open360BusinessLogicRetailersStoresBEStoreInventoryResponse.ts": 343,
	"./modules/model/open360BusinessLogicRetailersStoresBEStoreJispPayEnable.ts": 1755,
	"./modules/model/open360BusinessLogicRetailersStoresBEStoreJispPayPasswordConfirmation.ts": 1756,
	"./modules/model/open360BusinessLogicRetailersStoresBEStoreListItem.ts": 1757,
	"./modules/model/open360BusinessLogicRetailersStoresPlaceNameListModel.ts": 1758,
	"./modules/model/open360BusinessLogicRetailersStoresStoreCampaigns.ts": 1759,
	"./modules/model/open360BusinessLogicRetailersStoresStoreFilter.ts": 344,
	"./modules/model/open360BusinessLogicRetailersStoresStoreFindFilter.ts": 1760,
	"./modules/model/open360BusinessLogicRetailersStoresStoreInventoryListItem.ts": 1761,
	"./modules/model/open360BusinessLogicSalesAssistantBESalesAssistant.ts": 1762,
	"./modules/model/open360BusinessLogicSalesAssistantSalesAssistantPagingSettings.ts": 345,
	"./modules/model/open360EntitiesApiCommonBeaconListItem.ts": 1763,
	"./modules/model/open360EntitiesBrand.ts": 1764,
	"./modules/model/open360EntitiesCountriesCountryModel.ts": 1765,
	"./modules/model/open360EntitiesListItemsClassificationCategoryListItem.ts": 346,
	"./modules/model/open360EntitiesListItemsEnumListItem.ts": 1766,
	"./modules/model/open360EntitiesListItemsSalesAssistantListItem.ts": 1767,
	"./modules/model/open360EntitiesListItemsStoreManagerAccountListItem.ts": 1768,
	"./modules/model/open360EntitiesListItemsStoreRedemptionAmountListItem.ts": 1769,
	"./modules/model/open360EntitiesRetailerApiAnalyticsFilter.ts": 347,
	"./modules/model/open360EntitiesRetailerApiBeaconIdentifierListItem.ts": 1770,
	"./modules/model/open360EntitiesRetailerApiBillingStatementListItem.ts": 348,
	"./modules/model/open360EntitiesRetailerApiBrandListItem.ts": 349,
	"./modules/model/open360EntitiesRetailerApiCampaignListItem.ts": 350,
	"./modules/model/open360EntitiesRetailerApiChargingScheduleListItem.ts": 1771,
	"./modules/model/open360EntitiesRetailerApiInformationCardListItem.ts": 1772,
	"./modules/model/open360EntitiesRetailerApiInvoiceListItem.ts": 1773,
	"./modules/model/open360EntitiesRetailerApiPhysicalProductLinkListItem.ts": 351,
	"./modules/model/open360EntitiesRetailerApiPhysicalProductListItem.ts": 1774,
	"./modules/model/open360EntitiesRetailerApiPhysicalProductSearchItem.ts": 1775,
	"./modules/model/open360EntitiesRetailerApiPhysicalProductVariationListItem.ts": 352,
	"./modules/model/open360EntitiesRetailerApiPlaceJispPayListItem.ts": 1776,
	"./modules/model/open360EntitiesRetailerApiReferralAccountListItem.ts": 1777,
	"./modules/model/open360EntitiesRetailerApiStoreLoyaltyProgramListItem.ts": 1778,
	"./modules/model/open360EntitiesRetailerApiStoreTapAndGoListItem.ts": 353,
	"./modules/model/open360EntitiesRetailerApiStoreWithAddressListItem.ts": 1779,
	"./modules/model/open360EntitiesRetailerApiVisitsAnalyticsFilter.ts": 354,
	"./modules/model/open360NfcStickersAbstractionsFiltersNfcStickerRequest.ts": 355,
	"./modules/model/open360NfcStickersModelsDeleteStickerRequest.ts": 1780,
	"./modules/model/open360NfcStickersModelsFiltersDeletedStickersRequest.ts": 1781,
	"./modules/model/open360NfcStickersModelsFiltersNfcOperationsRequest.ts": 1782,
	"./modules/model/open360NfcStickersModelsFiltersNfcStickerRequest.ts": 356,
	"./modules/model/open360NfcStickersModelsNfcOperation.ts": 357,
	"./modules/model/open360NfcStickersModelsNfcSticker.ts": 358,
	"./modules/model/open360NfcStickersModelsNfcStickerShort.ts": 1783,
	"./modules/model/open360RetailerApiContractExtrasCreateExtraItemRequest.ts": 1784,
	"./modules/model/open360RetailerApiContractExtrasExtraItemResourceBaseModel.ts": 1785,
	"./modules/model/open360RetailerApiContractExtrasExtraItemResourceModel.ts": 1786,
	"./modules/model/open360RetailerApiContractExtrasGetActiveExtrasFilter.ts": 1787,
	"./modules/model/open360RetailerApiContractExtrasGetExtrasFilter.ts": 1788,
	"./modules/model/open360RetailerApiContractExtrasUpdateExtraItemRequest.ts": 1789,
	"./modules/model/open360RetailerApiContractFoodMenuFoodPreferenceItem.ts": 1790,
	"./modules/model/open360RetailerApiContractFoodMenuMenuPreference.ts": 1791,
	"./modules/model/open360RetailerApiContractInformationCardInformationCardFilter.ts": 93,
	"./modules/model/open360RetailerApiContractNfcStickersCreateNfcExportRequest.ts": 359,
	"./modules/model/open360RetailerApiContractNfcStickersCreateNfcOperationRequest.ts": 360,
	"./modules/model/open360RetailerApiContractNfcStickersEntityItem.ts": 1792,
	"./modules/model/open360RetailerApiContractNfcStickersExportResultItem.ts": 1793,
	"./modules/model/open360RetailerApiContractNfcStickersNfcOperationModel.ts": 361,
	"./modules/model/open360RetailerApiContractNfcStickersNfcOperationResponse.ts": 1794,
	"./modules/model/open360RetailerApiContractNfcStickersNfcStickerModel.ts": 362,
	"./modules/model/open360RetailerApiContractPhysicalProductBuyXGetYOfferValuesResourceModel.ts": 1795,
	"./modules/model/open360RetailerApiContractPhysicalProductSpecialOfferResourceModel.ts": 363,
	"./modules/model/open360RetailerApiContractRetailerAuthorizationInfoModel.ts": 1796,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantFeedbackStats.ts": 1797,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantItem.ts": 1798,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantPagingSettings.ts": 364,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantRatingItem.ts": 1799,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantRatingPagingSettings.ts": 365,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantRatingSettings.ts": 1800,
	"./modules/model/open360RetailerApiContractSalesAssistantSalesAssistantSummaryResourceModel.ts": 1801,
	"./modules/model/open360RetailerApiModelsCreateNfcOperationRequest.ts": 1802,
	"./modules/model/open360RetailerApiModelsEntityItem.ts": 1803,
	"./modules/model/open360RetailerApiModelsNfcOperationResponse.ts": 1804,
	"./modules/model/open360SalesAssistantAbstractionsModelsSalesAssistantEditModel.ts": 1805,
	"./modules/model/open360SalesAssistantAbstractionsModelsSalesAssistantListItem.ts": 1806,
	"./modules/model/open360ShopperApiContractV18MeasurementsMeasurementListItem.ts": 366,
	"./modules/model/open360ShopperApiContractV18MeasurementsSizeListItem.ts": 1807,
	"./modules/model/open360ShopperApiContractV18PaymentCardPaymentCardListItem.ts": 367,
	"./modules/model/open360ShopperApiContractV18ThumbnailRequest.ts": 1808,
	"./modules/model/open360ShopperApiContractV18VideosVideoItemResourceModel.ts": 1809,
	"./modules/model/products/IProductIngredient.ts": 1810,
	"./modules/model/products/IProductVariationIngredient.ts": 1811,
	"./modules/model/services/IServicesModel.ts": 1812,
	"./modules/model/systemIOStream.ts": 1813,
	"./modules/nfc-stickers/active-tab/active-stickers-filter/active-stickers-filter.component.ts": 1364,
	"./modules/nfc-stickers/active-tab/nfc-retailer-active-tab.component.ts": 1365,
	"./modules/nfc-stickers/deleted-tab/add-sticker/add-deleted-sticker.component.ts": 1366,
	"./modules/nfc-stickers/deleted-tab/nfc-retailer-deleted-tab.component.ts": 1367,
	"./modules/nfc-stickers/export/nfc-export.component.ts": 1368,
	"./modules/nfc-stickers/history/history-export-item/history-export-item.component.ts": 1369,
	"./modules/nfc-stickers/history/history-item/history-item.component.ts": 1370,
	"./modules/nfc-stickers/history/nfc-retailer-history-tab.component.ts": 1371,
	"./modules/nfc-stickers/nfc-retailer-stickers.service.ts": 1372,
	"./modules/nfc-stickers/shared/chips/chips.component.ts": 1373,
	"./modules/nfc-stickers/shared/select-locations/select-locations.component.ts": 1374,
	"./modules/nfc-stickers/shared/select-product-category/select-product-category.component.ts": 1375,
	"./modules/nfc-stickers/shared/select-product-category/select-product-classification-categories/select-product-classification-categories.component.ts": 1376,
	"./modules/nfc-stickers/shared/select-products/select-products.component.ts": 1377,
	"./modules/nfc-stickers/shared/selected-list/selected-list.component.ts": 1378,
	"./modules/nfc-stickers/shared/sticky/sticky.directive.ts": 1379,
	"./modules/nfc-stickers/tabs-list/nfc-retailer-tab-list.component.ts": 1380,
	"./modules/nfc-stickers/wizard/discard-popup/wizard-discard-popup.component.ts": 1381,
	"./modules/nfc-stickers/wizard/nfc-wizard.component.ts": 1382,
	"./modules/nfc-stickers/wizard/wizard-assign-step/wizard-assign-step.component.ts": 1383,
	"./modules/nfc-stickers/wizard/wizard-locations-step/wizard-locations-step.component.ts": 1384,
	"./modules/nfc-stickers/wizard/wizard-products-step/wizard-product-and-category-list/wizard-product-and-category-list.component.ts": 1385,
	"./modules/nfc-stickers/wizard/wizard-products-step/wizard-products-step.component.ts": 1386,
	"./modules/nfc-stickers/wizard/wizard-steps/wizard-steps.component.ts": 1387,
	"./modules/places/components/shop-tables/add-or-edit-table/add-or-edit-table.component.ts": 1388,
	"./modules/places/components/shop-tables/shop-tables.component.ts": 1389,
	"./modules/places/components/shop-tables/tables-list/tables-list.component.ts": 1390,
	"./modules/places/components/shop/shop.component.ts": 1391,
	"./modules/places/components/shopCampaigns/shopCampaigns.component.ts": 1392,
	"./modules/places/components/shopInventory/shopInventory.component.ts": 1393,
	"./modules/places/components/shopOpeningHours/shopOpeningHours.component.ts": 1394,
	"./modules/places/components/shopStore/shopStore.component.ts": 1395,
	"./modules/places/components/shops/shops.component.ts": 1396,
	"./modules/places/models/index.ts": 244,
	"./modules/places/shop.service.ts": 1397,
	"./modules/printers/components/add-edit-printer/add-edit-printer.component.ts": 1398,
	"./modules/printers/components/printer-list/printer-list.component.ts": 1399,
	"./modules/printers/models/models.ts": 245,
	"./modules/printers/services/printers.service.ts": 1400,
	"./modules/products/components/advancedProduct/advancedProduct.component.ts": 1401,
	"./modules/products/components/choiceProductImages/choiceProductImages.component.ts": 1402,
	"./modules/products/components/dpp-info-dialog/dpp-info-dialog.component.ts": 1403,
	"./modules/products/components/draft-confirmation-dialog/draft-confirmation-dialog.component.ts": 1404,
	"./modules/products/components/modals/edit-discount-for-staff/edit-discount-for-staff-modal.component.ts": 1405,
	"./modules/products/components/modals/edit-price-modal/edit-price-modal.component.ts": 1406,
	"./modules/products/components/modals/edit-stock-level/edit-stock-level.component.ts": 1407,
	"./modules/products/components/product-search/product.search.component.ts": 1408,
	"./modules/products/components/products/products.component.ts": 1409,
	"./modules/products/components/productsImport/productsImport.component.ts": 1410,
	"./modules/products/components/shared/product-discount/product-discount.component.ts": 1411,
	"./modules/products/components/shared/product-extras-list/product-extras-list.component.ts": 1412,
	"./modules/products/components/shared/product-extras-list/select-extras/select-extras.component.ts": 1413,
	"./modules/products/components/shared/product-ingredients-list/product-ingredients-list.component.ts": 1414,
	"./modules/products/components/shared/product-ingredients-list/product-select-ingredients/product-select-ingredients.component.ts": 1415,
	"./modules/products/components/shared/product-preparation/product-preparation.component.ts": 1416,
	"./modules/products/components/shared/product-special-offer/product-special-offer.component.ts": 1417,
	"./modules/products/components/shared/product-stickers-list/product-stickers-list-item/product-stickers-list-item.component.ts": 1418,
	"./modules/products/components/shared/product-stickers-list/product-stickers-list.component.ts": 1419,
	"./modules/products/components/shared/product-variation-ingredients-list/product-variation-ingredient/product-variation-ingredient.component.ts": 1420,
	"./modules/products/components/shared/product-variation-ingredients-list/product-variation-ingredients-list.component.ts": 1421,
	"./modules/products/components/wizardProduct/wizardProduct.component.ts": 1422,
	"./modules/products/models/IIngredientSelectItem.ts": 1423,
	"./modules/products/models/index.ts": 83,
	"./modules/products/paginated-item-type-list.ts": 246,
	"./modules/products/productBase.controller.ts": 84,
	"./modules/products/products.service.ts": 1424,
	"./modules/products/services/offers.service.ts": 1425,
	"./modules/publisher-settings/models/store.interface.ts": 1426,
	"./modules/publisher-settings/publisher-settings.component.ts": 1427,
	"./modules/publisher-settings/publisher-settings.service.ts": 1428,
	"./modules/referral-accounts/components/referralAccount/referralAccount.component.ts": 1429,
	"./modules/referral-accounts/components/referralAccounts/referralAccounts.component.ts": 1430,
	"./modules/referral-accounts/models/index.ts": 1431,
	"./modules/referral-accounts/referralAccounts.service.ts": 1432,
	"./modules/routes/routes.config.ts": 1433,
	"./modules/services/add-or-edit-service/add-or-edit-service.component.ts": 1434,
	"./modules/services/services-tab.component.ts": 1435,
	"./modules/shared/select-single-location/select-single-location.component.ts": 1436,
	"./modules/staffRating/components/details/staffRatingDetails.component.ts": 1437,
	"./modules/staffRating/components/list/staffRatingList.component.ts": 1438,
	"./modules/staffRating/components/rating-stars/rating-stars.component.ts": 1439,
	"./modules/staffRating/staffRating.service.ts": 1440,
	"./modules/store-managers/components/storeManagerAccount/storeManagerAccount.component.ts": 1441,
	"./modules/store-managers/components/storeManagerAccounts/storeManagerAccounts.component.ts": 1442,
	"./modules/store-managers/models/index.ts": 1443,
	"./modules/store-managers/storeManager.service.ts": 1444,
	"./modules/tapAndGo/components/check-stickers/check-stickers.component.ts": 1445,
	"./modules/tapAndGo/components/food-monitor-url-generator/food-monitor-url-generator.component.ts": 1446,
	"./modules/tapAndGo/components/order-settings-locations.component.ts": 1447,
	"./modules/tapAndGo/models/index.ts": 247,
	"./modules/tapAndGo/order-settings.service.ts": 1448,
	"./modules/vouchers/components/add-or-edit-voucher/add-or-edit-voucher.component.ts": 1449,
	"./modules/vouchers/components/select-category-dialog/select-category-dialog.component.ts": 1450,
	"./modules/vouchers/components/vouchers-list/vouchers-list.component.ts": 1451,
	"./modules/vouchers/models/models.ts": 19,
	"./modules/vouchers/vouchers.service.ts": 1452,
	"./modules/warnings/components/warnings/warnings.component.ts": 1453
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;

/***/ }),
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* build: `node build.js modules=ALL exclude=gestures,accessors requirejs minifier=uglifyjs` */
/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */

var fabric = fabric || { version: '4.2.0' };
if (true) {
  exports.fabric = fabric;
}
/* _AMD_START_ */
else if (typeof define === 'function' && define.amd) {
  define([], function() { return fabric; });
}
/* _AMD_END_ */
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) {
    fabric.document = document;
  }
  else {
    fabric.document = document.implementation.createHTMLDocument('');
  }
  fabric.window = window;
}
else {
  // assume we're running under node.js when document/window are not present
  var jsdom = __webpack_require__(2057);
  var virtualWindow = new jsdom.JSDOM(
    decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'),
    {
      features: {
        FetchExternalResources: ['img']
      },
      resources: 'usable'
    }).window;
  fabric.document = virtualWindow.document;
  fabric.jsdomImplForWrapper = __webpack_require__(2058).implForWrapper;
  fabric.nodeCanvas = __webpack_require__(2059).Canvas;
  fabric.window = virtualWindow;
  DOMParser = fabric.window.DOMParser;
}

/**
 * True when in environment that supports touch events
 * @type boolean
 */
fabric.isTouchSupported = 'ontouchstart' in fabric.window || 'ontouchstart' in fabric.document ||
  (fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0);

/**
 * True when in environment that's probably Node.js
 * @type boolean
 */
fabric.isLikelyNode = typeof Buffer !== 'undefined' &&
                      typeof window === 'undefined';

/* _FROM_SVG_START_ */
/**
 * Attributes parsed from all SVG elements
 * @type array
 */
fabric.SHARED_ATTRIBUTES = [
  'display',
  'transform',
  'fill', 'fill-opacity', 'fill-rule',
  'opacity',
  'stroke', 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset',
  'stroke-linejoin', 'stroke-miterlimit',
  'stroke-opacity', 'stroke-width',
  'id', 'paint-order', 'vector-effect',
  'instantiated_by_use', 'clip-path',
];
/* _FROM_SVG_END_ */

/**
 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
 */
fabric.DPI = 96;
fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
fabric.commaWsp = '(?:\\s+,?\\s*|,\\s*)'
fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
fabric.reNonWord = /[ \n\.,;!\?\-]/;
fabric.fontPaths = { };
fabric.iMatrix = [1, 0, 0, 1, 0, 0];
fabric.svgNS = 'http://www.w3.org/2000/svg';

/**
 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.perfLimitSizeTotal = 2097152;

/**
 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.maxCacheSideLimit = 4096;

/**
 * Lowest pixel limit for cache canvases, set at 256PX
 * @since 1.7.14
 * @type Number
 * @default
 */
fabric.minCacheSideLimit = 256;

/**
 * Cache Object for widths of chars in text rendering.
 */
fabric.charWidthsCache = { };

/**
 * if webgl is enabled and available, textureSize will determine the size
 * of the canvas backend
 * @since 2.0.0
 * @type Number
 * @default
 */
fabric.textureSize = 2048;

/**
 * When 'true', style information is not retained when copy/pasting text, making
 * pasted text use destination style.
 * Defaults to 'false'.
 * @type Boolean
 * @default
 */
fabric.disableStyleCopyPaste = false;

/**
 * Enable webgl for filtering picture is available
 * A filtering backend will be initialized, this will both take memory and
 * time since a default 2048x2048 canvas will be created for the gl context
 * @since 2.0.0
 * @type Boolean
 * @default
 */
fabric.enableGLFiltering = true;

/**
 * Device Pixel Ratio
 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
 */
fabric.devicePixelRatio = fabric.window.devicePixelRatio ||
                          fabric.window.webkitDevicePixelRatio ||
                          fabric.window.mozDevicePixelRatio ||
                          1;
/**
 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
 * which is unitless and not rendered equally across browsers.
 *
 * Values that work quite well (as of October 2017) are:
 * - Chrome: 1.5
 * - Edge: 1.75
 * - Firefox: 0.9
 * - Safari: 0.95
 *
 * @since 2.0.0
 * @type Number
 * @default 1
 */
fabric.browserShadowBlurConstant = 1;

/**
 * This object contains the result of arc to beizer conversion for faster retrieving if the same arc needs to be converted again.
 * It was an internal variable, is accessible since version 2.3.4
 */
fabric.arcToSegmentsCache = { };

/**
 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
 * you do not get any speed benefit and you get a big object in memory.
 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
 * can eventually clear it.
 * It was an internal variable, is accessible since version 2.3.4
 */
fabric.boundsOfCurveCache = { };

/**
 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
 * @default true
 */
fabric.cachesBoundsOfCurve = true;

/**
 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
 * this has to be set before instantiating the filtering backend ( before filtering the first image )
 * @type Boolean
 * @default false
 */
fabric.forceGLPutImageData = false;

fabric.initFilterBackend = function() {
  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
    console.log('max texture size: ' + fabric.maxTextureSize);
    return (new fabric.WebglFilterBackend({ tileSize: fabric.textureSize }));
  }
  else if (fabric.Canvas2dFilterBackend) {
    return (new fabric.Canvas2dFilterBackend());
  }
};


if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
  window.fabric = fabric;
}


(function() {

  /**
   * @private
   * @param {String} eventName
   * @param {Function} handler
   */
  function _removeEventListener(eventName, handler) {
    if (!this.__eventListeners[eventName]) {
      return;
    }
    var eventListener = this.__eventListeners[eventName];
    if (handler) {
      eventListener[eventListener.indexOf(handler)] = false;
    }
    else {
      fabric.util.array.fill(eventListener, false);
    }
  }

  /**
   * Observes specified event
   * @memberOf fabric.Observable
   * @alias on
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Self} thisArg
   * @chainable
   */
  function on(eventName, handler) {
    if (!this.__eventListeners) {
      this.__eventListeners = { };
    }
    // one object with key/value pairs was passed
    if (arguments.length === 1) {
      for (var prop in eventName) {
        this.on(prop, eventName[prop]);
      }
    }
    else {
      if (!this.__eventListeners[eventName]) {
        this.__eventListeners[eventName] = [];
      }
      this.__eventListeners[eventName].push(handler);
    }
    return this;
  }

  /**
   * Stops event observing for a particular event handler. Calling this method
   * without arguments removes all handlers for all events
   * @memberOf fabric.Observable
   * @alias off
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function to be deleted from EventListeners
   * @return {Self} thisArg
   * @chainable
   */
  function off(eventName, handler) {
    if (!this.__eventListeners) {
      return this;
    }

    // remove all key/value pairs (event name -> event handler)
    if (arguments.length === 0) {
      for (eventName in this.__eventListeners) {
        _removeEventListener.call(this, eventName);
      }
    }
    // one object with key/value pairs was passed
    else if (arguments.length === 1 && typeof arguments[0] === 'object') {
      for (var prop in eventName) {
        _removeEventListener.call(this, prop, eventName[prop]);
      }
    }
    else {
      _removeEventListener.call(this, eventName, handler);
    }
    return this;
  }

  /**
   * Fires event with an optional options object
   * @memberOf fabric.Observable
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   * @return {Self} thisArg
   * @chainable
   */
  function fire(eventName, options) {
    if (!this.__eventListeners) {
      return this;
    }

    var listenersForEvent = this.__eventListeners[eventName];
    if (!listenersForEvent) {
      return this;
    }

    for (var i = 0, len = listenersForEvent.length; i < len; i++) {
      listenersForEvent[i] && listenersForEvent[i].call(this, options || { });
    }
    this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
      return value !== false;
    });
    return this;
  }

  /**
   * @namespace fabric.Observable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */
  fabric.Observable = {
    fire: fire,
    on: on,
    off: off,
  };
})();


/**
 * @namespace fabric.Collection
 */
fabric.Collection = {

  _objects: [],

  /**
   * Adds objects to collection, Canvas or Group, then renders canvas
   * (if `renderOnAddRemove` is not `false`).
   * in case of Group no changes to bounding box are made.
   * Objects should be instances of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the add method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  add: function () {
    this._objects.push.apply(this._objects, arguments);
    if (this._onObjectAdded) {
      for (var i = 0, length = arguments.length; i < length; i++) {
        this._onObjectAdded(arguments[i]);
      }
    }
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
   * An object should be an instance of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the insertAt method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {Object} object Object to insert
   * @param {Number} index Index to insert object at
   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
   * @return {Self} thisArg
   * @chainable
   */
  insertAt: function (object, index, nonSplicing) {
    var objects = this._objects;
    if (nonSplicing) {
      objects[index] = object;
    }
    else {
      objects.splice(index, 0, object);
    }
    this._onObjectAdded && this._onObjectAdded(object);
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },

  /**
   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */
  remove: function() {
    var objects = this._objects,
        index, somethingRemoved = false;

    for (var i = 0, length = arguments.length; i < length; i++) {
      index = objects.indexOf(arguments[i]);

      // only call onObjectRemoved if an object was actually removed
      if (index !== -1) {
        somethingRemoved = true;
        objects.splice(index, 1);
        this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
      }
    }

    this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
    return this;
  },

  /**
   * Executes given function for each object in this group
   * @param {Function} callback
   *                   Callback invoked with current object as first argument,
   *                   index - as second and an array of all objects - as third.
   *                   Callback is invoked in a context of Global Object (e.g. `window`)
   *                   when no `context` argument is given
   *
   * @param {Object} context Context (aka thisObject)
   * @return {Self} thisArg
   * @chainable
   */
  forEachObject: function(callback, context) {
    var objects = this.getObjects();
    for (var i = 0, len = objects.length; i < len; i++) {
      callback.call(context, objects[i], i, objects);
    }
    return this;
  },

  /**
   * Returns an array of children objects of this instance
   * Type parameter introduced in 1.3.10
   * since 2.3.5 this method return always a COPY of the array;
   * @param {String} [type] When specified, only objects of this type are returned
   * @return {Array}
   */
  getObjects: function(type) {
    if (typeof type === 'undefined') {
      return this._objects.concat();
    }
    return this._objects.filter(function(o) {
      return o.type === type;
    });
  },

  /**
   * Returns object at specified index
   * @param {Number} index
   * @return {Self} thisArg
   */
  item: function (index) {
    return this._objects[index];
  },

  /**
   * Returns true if collection contains no objects
   * @return {Boolean} true if collection is empty
   */
  isEmpty: function () {
    return this._objects.length === 0;
  },

  /**
   * Returns a size of a collection (i.e: length of an array containing its objects)
   * @return {Number} Collection size
   */
  size: function() {
    return this._objects.length;
  },

  /**
   * Returns true if collection contains an object
   * @param {Object} object Object to check against
   * @return {Boolean} `true` if collection contains an object
   */
  contains: function(object) {
    return this._objects.indexOf(object) > -1;
  },

  /**
   * Returns number representation of a collection complexity
   * @return {Number} complexity
   */
  complexity: function () {
    return this._objects.reduce(function (memo, current) {
      memo += current.complexity ? current.complexity() : 0;
      return memo;
    }, 0);
  }
};


/**
 * @namespace fabric.CommonMethods
 */
fabric.CommonMethods = {

  /**
   * Sets object's properties from options
   * @param {Object} [options] Options object
   */
  _setOptions: function(options) {
    for (var prop in options) {
      this.set(prop, options[prop]);
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Gradient to
   */
  _initGradient: function(filler, property) {
    if (filler && filler.colorStops && !(filler instanceof fabric.Gradient)) {
      this.set(property, new fabric.Gradient(filler));
    }
  },

  /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Pattern to
   * @param {Function} [callback] callback to invoke after pattern load
   */
  _initPattern: function(filler, property, callback) {
    if (filler && filler.source && !(filler instanceof fabric.Pattern)) {
      this.set(property, new fabric.Pattern(filler, callback));
    }
    else {
      callback && callback();
    }
  },

  /**
   * @private
   */
  _setObject: function(obj) {
    for (var prop in obj) {
      this._set(prop, obj[prop]);
    }
  },

  /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  set: function(key, value) {
    if (typeof key === 'object') {
      this._setObject(key);
    }
    else {
      this._set(key, value);
    }
    return this;
  },

  _set: function(key, value) {
    this[key] = value;
  },

  /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   * @return {fabric.Object} thisArg
   * @chainable
   */
  toggle: function(property) {
    var value = this.get(property);
    if (typeof value === 'boolean') {
      this.set(property, !value);
    }
    return this;
  },

  /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */
  get: function(property) {
    return this[property];
  }
};


(function(global) {

  var sqrt = Math.sqrt,
      atan2 = Math.atan2,
      pow = Math.pow,
      PiBy180 = Math.PI / 180,
      PiBy2 = Math.PI / 2;

  /**
   * @namespace fabric.util
   */
  fabric.util = {

    /**
     * Calculate the cos of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    cos: function(angle) {
      if (angle === 0) { return 1; }
      if (angle < 0) {
        // cos(a) = cos(-a)
        angle = -angle;
      }
      var angleSlice = angle / PiBy2;
      switch (angleSlice) {
        case 1: case 3: return 0;
        case 2: return -1;
      }
      return Math.cos(angle);
    },

    /**
     * Calculate the sin of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */
    sin: function(angle) {
      if (angle === 0) { return 0; }
      var angleSlice = angle / PiBy2, sign = 1;
      if (angle < 0) {
        // sin(-a) = -sin(a)
        sign = -1;
      }
      switch (angleSlice) {
        case 1: return sign;
        case 2: return 0;
        case 3: return -sign;
      }
      return Math.sin(angle);
    },

    /**
     * Removes value from an array.
     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
     * @static
     * @memberOf fabric.util
     * @param {Array} array
     * @param {*} value
     * @return {Array} original array
     */
    removeFromArray: function(array, value) {
      var idx = array.indexOf(value);
      if (idx !== -1) {
        array.splice(idx, 1);
      }
      return array;
    },

    /**
     * Returns random number between 2 specified ones.
     * @static
     * @memberOf fabric.util
     * @param {Number} min lower limit
     * @param {Number} max upper limit
     * @return {Number} random value (between min and max)
     */
    getRandomInt: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    /**
     * Transforms degrees to radians.
     * @static
     * @memberOf fabric.util
     * @param {Number} degrees value in degrees
     * @return {Number} value in radians
     */
    degreesToRadians: function(degrees) {
      return degrees * PiBy180;
    },

    /**
     * Transforms radians to degrees.
     * @static
     * @memberOf fabric.util
     * @param {Number} radians value in radians
     * @return {Number} value in degrees
     */
    radiansToDegrees: function(radians) {
      return radians / PiBy180;
    },

    /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {fabric.Point} point The point to rotate
     * @param {fabric.Point} origin The origin of the rotation
     * @param {Number} radians The radians of the angle for the rotation
     * @return {fabric.Point} The new rotated point
     */
    rotatePoint: function(point, origin, radians) {
      point.subtractEquals(origin);
      var v = fabric.util.rotateVector(point, radians);
      return new fabric.Point(v.x, v.y).addEquals(origin);
    },

    /**
     * Rotates `vector` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {Object} vector The vector to rotate (x and y)
     * @param {Number} radians The radians of the angle for the rotation
     * @return {Object} The new rotated point
     */
    rotateVector: function(vector, radians) {
      var sin = fabric.util.sin(radians),
          cos = fabric.util.cos(radians),
          rx = vector.x * cos - vector.y * sin,
          ry = vector.x * sin + vector.y * cos;
      return {
        x: rx,
        y: ry
      };
    },

    /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Point} p The point to transform
     * @param  {Array} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {fabric.Point} The transformed point
     */
    transformPoint: function(p, t, ignoreOffset) {
      if (ignoreOffset) {
        return new fabric.Point(
          t[0] * p.x + t[2] * p.y,
          t[1] * p.x + t[3] * p.y
        );
      }
      return new fabric.Point(
        t[0] * p.x + t[2] * p.y + t[4],
        t[1] * p.x + t[3] * p.y + t[5]
      );
    },

    /**
     * Returns coordinates of points's bounding rectangle (left, top, width, height)
     * @param {Array} points 4 points array
     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
     * @return {Object} Object with left, top, width, height properties
     */
    makeBoundingBoxFromPoints: function(points, transform) {
      if (transform) {
        for (var i = 0; i < points.length; i++) {
          points[i] = fabric.util.transformPoint(points[i], transform);
        }
      }
      var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x],
          minX = fabric.util.array.min(xPoints),
          maxX = fabric.util.array.max(xPoints),
          width = maxX - minX,
          yPoints = [points[0].y, points[1].y, points[2].y, points[3].y],
          minY = fabric.util.array.min(yPoints),
          maxY = fabric.util.array.max(yPoints),
          height = maxY - minY;

      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Invert transformation t
     * @static
     * @memberOf fabric.util
     * @param {Array} t The transform
     * @return {Array} The inverted transform
     */
    invertTransform: function(t) {
      var a = 1 / (t[0] * t[3] - t[1] * t[2]),
          r = [a * t[3], -a * t[1], -a * t[2], a * t[0]],
          o = fabric.util.transformPoint({ x: t[4], y: t[5] }, r, true);
      r[4] = -o.x;
      r[5] = -o.y;
      return r;
    },

    /**
     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
     * @static
     * @memberOf fabric.util
     * @param {Number|String} number number to operate on
     * @param {Number} fractionDigits number of fraction digits to "leave"
     * @return {Number}
     */
    toFixed: function(number, fractionDigits) {
      return parseFloat(Number(number).toFixed(fractionDigits));
    },

    /**
     * Converts from attribute value to pixel value if applicable.
     * Returns converted pixels or original value not converted.
     * @param {Number|String} value number to operate on
     * @param {Number} fontSize
     * @return {Number|String}
     */
    parseUnit: function(value, fontSize) {
      var unit = /\D{0,2}$/.exec(value),
          number = parseFloat(value);
      if (!fontSize) {
        fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
      }
      switch (unit[0]) {
        case 'mm':
          return number * fabric.DPI / 25.4;

        case 'cm':
          return number * fabric.DPI / 2.54;

        case 'in':
          return number * fabric.DPI;

        case 'pt':
          return number * fabric.DPI / 72; // or * 4 / 3

        case 'pc':
          return number * fabric.DPI / 72 * 12; // or * 16

        case 'em':
          return number * fontSize;

        default:
          return number;
      }
    },

    /**
     * Function which always returns `false`.
     * @static
     * @memberOf fabric.util
     * @return {Boolean}
     */
    falseFunction: function() {
      return false;
    },

    /**
     * Returns klass "Class" object of given namespace
     * @memberOf fabric.util
     * @param {String} type Type of object (eg. 'circle')
     * @param {String} namespace Namespace to get klass "Class" object from
     * @return {Object} klass "Class"
     */
    getKlass: function(type, namespace) {
      // capitalize first letter only
      type = fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
      return fabric.util.resolveNamespace(namespace)[type];
    },

    /**
     * Returns array of attributes for given svg that fabric parses
     * @memberOf fabric.util
     * @param {String} type Type of svg element (eg. 'circle')
     * @return {Array} string names of supported attributes
     */
    getSvgAttributes: function(type) {
      var attributes = [
        'instantiated_by_use',
        'style',
        'id',
        'class'
      ];
      switch (type) {
        case 'linearGradient':
          attributes = attributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
          break;
        case 'radialGradient':
          attributes = attributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
          break;
        case 'stop':
          attributes = attributes.concat(['offset', 'stop-color', 'stop-opacity']);
          break;
      }
      return attributes;
    },

    /**
     * Returns object of given namespace
     * @memberOf fabric.util
     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
     * @return {Object} Object for given namespace (default fabric)
     */
    resolveNamespace: function(namespace) {
      if (!namespace) {
        return fabric;
      }

      var parts = namespace.split('.'),
          len = parts.length, i,
          obj = global || fabric.window;

      for (i = 0; i < len; ++i) {
        obj = obj[parts[i]];
      }

      return obj;
    },

    /**
     * Loads image element from given url and passes it to a callback
     * @memberOf fabric.util
     * @param {String} url URL representing an image
     * @param {Function} callback Callback; invoked with loaded image
     * @param {*} [context] Context to invoke callback in
     * @param {Object} [crossOrigin] crossOrigin value to set image element to
     */
    loadImage: function(url, callback, context, crossOrigin) {
      if (!url) {
        callback && callback.call(context, url);
        return;
      }

      var img = fabric.util.createImage();

      /** @ignore */
      var onLoadCallback = function () {
        callback && callback.call(context, img, false);
        img = img.onload = img.onerror = null;
      };

      img.onload = onLoadCallback;
      /** @ignore */
      img.onerror = function() {
        fabric.log('Error loading ' + img.src);
        callback && callback.call(context, null, true);
        img = img.onload = img.onerror = null;
      };

      // data-urls appear to be buggy with crossOrigin
      // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
      // see https://code.google.com/p/chromium/issues/detail?id=315152
      //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
      // crossOrigin null is the same as not set.
      if (url.indexOf('data') !== 0 &&
        crossOrigin !== undefined &&
        crossOrigin !== null) {
        img.crossOrigin = crossOrigin;
      }

      // IE10 / IE11-Fix: SVG contents from data: URI
      // will only be available if the IMG is present
      // in the DOM (and visible)
      if (url.substring(0,14) === 'data:image/svg') {
        img.onload = null;
        fabric.util.loadImageInDom(img, onLoadCallback);
      }

      img.src = url;
    },

    /**
     * Attaches SVG image with data: URL to the dom
     * @memberOf fabric.util
     * @param {Object} img Image object with data:image/svg src
     * @param {Function} callback Callback; invoked with loaded image
     * @return {Object} DOM element (div containing the SVG image)
     */
    loadImageInDom: function(img, onLoadCallback) {
      var div = fabric.document.createElement('div');
      div.style.width = div.style.height = '1px';
      div.style.left = div.style.top = '-100%';
      div.style.position = 'absolute';
      div.appendChild(img);
      fabric.document.querySelector('body').appendChild(div);
      /**
       * Wrap in function to:
       *   1. Call existing callback
       *   2. Cleanup DOM
       */
      img.onload = function () {
        onLoadCallback();
        div.parentNode.removeChild(div);
        div = null;
      };
    },

    /**
     * Creates corresponding fabric instances from their object representations
     * @static
     * @memberOf fabric.util
     * @param {Array} objects Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * @param {String} namespace Namespace to get klass "Class" object from
     * @param {Function} reviver Method for further parsing of object elements,
     * called after each fabric object created.
     */
    enlivenObjects: function(objects, callback, namespace, reviver) {
      objects = objects || [];

      var enlivenedObjects = [],
          numLoadedObjects = 0,
          numTotalObjects = objects.length;

      function onLoaded() {
        if (++numLoadedObjects === numTotalObjects) {
          callback && callback(enlivenedObjects.filter(function(obj) {
            // filter out undefined objects (objects that gave error)
            return obj;
          }));
        }
      }

      if (!numTotalObjects) {
        callback && callback(enlivenedObjects);
        return;
      }

      objects.forEach(function (o, index) {
        // if sparse array
        if (!o || !o.type) {
          onLoaded();
          return;
        }
        var klass = fabric.util.getKlass(o.type, namespace);
        klass.fromObject(o, function (obj, error) {
          error || (enlivenedObjects[index] = obj);
          reviver && reviver(o, obj, error);
          onLoaded();
        });
      });
    },

    /**
     * Create and wait for loading of patterns
     * @static
     * @memberOf fabric.util
     * @param {Array} patterns Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * called after each fabric object created.
     */
    enlivenPatterns: function(patterns, callback) {
      patterns = patterns || [];

      function onLoaded() {
        if (++numLoadedPatterns === numPatterns) {
          callback && callback(enlivenedPatterns);
        }
      }

      var enlivenedPatterns = [],
          numLoadedPatterns = 0,
          numPatterns = patterns.length;

      if (!numPatterns) {
        callback && callback(enlivenedPatterns);
        return;
      }

      patterns.forEach(function (p, index) {
        if (p && p.source) {
          new fabric.Pattern(p, function(pattern) {
            enlivenedPatterns[index] = pattern;
            onLoaded();
          });
        }
        else {
          enlivenedPatterns[index] = p;
          onLoaded();
        }
      });
    },

    /**
     * Groups SVG elements (usually those retrieved from SVG document)
     * @static
     * @memberOf fabric.util
     * @param {Array} elements SVG elements to group
     * @param {Object} [options] Options object
     * @param {String} path Value to set sourcePath to
     * @return {fabric.Object|fabric.Group}
     */
    groupSVGElements: function(elements, options, path) {
      var object;
      if (elements && elements.length === 1) {
        return elements[0];
      }
      if (options) {
        if (options.width && options.height) {
          options.centerPoint = {
            x: options.width / 2,
            y: options.height / 2
          };
        }
        else {
          delete options.width;
          delete options.height;
        }
      }
      object = new fabric.Group(elements, options);
      if (typeof path !== 'undefined') {
        object.sourcePath = path;
      }
      return object;
    },

    /**
     * Populates an object with properties of another object
     * @static
     * @memberOf fabric.util
     * @param {Object} source Source object
     * @param {Object} destination Destination object
     * @return {Array} properties Properties names to include
     */
    populateWithProperties: function(source, destination, properties) {
      if (properties && Object.prototype.toString.call(properties) === '[object Array]') {
        for (var i = 0, len = properties.length; i < len; i++) {
          if (properties[i] in source) {
            destination[properties[i]] = source[properties[i]];
          }
        }
      }
    },

    /**
     * Draws a dashed line between two points
     *
     * This method is used to draw dashed line around selection area.
     * See <a href="http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas">dotted stroke in canvas</a>
     *
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x  start x coordinate
     * @param {Number} y start y coordinate
     * @param {Number} x2 end x coordinate
     * @param {Number} y2 end y coordinate
     * @param {Array} da dash array pattern
     */
    drawDashedLine: function(ctx, x, y, x2, y2, da) {
      var dx = x2 - x,
          dy = y2 - y,
          len = sqrt(dx * dx + dy * dy),
          rot = atan2(dy, dx),
          dc = da.length,
          di = 0,
          draw = true;

      ctx.save();
      ctx.translate(x, y);
      ctx.moveTo(0, 0);
      ctx.rotate(rot);

      x = 0;
      while (len > x) {
        x += da[di++ % dc];
        if (x > len) {
          x = len;
        }
        ctx[draw ? 'lineTo' : 'moveTo'](x, 0);
        draw = !draw;
      }

      ctx.restore();
    },

    /**
     * Creates canvas element
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    createCanvasElement: function() {
      return fabric.document.createElement('canvas');
    },

    /**
     * Creates a canvas element that is a copy of another and is also painted
     * @param {CanvasElement} canvas to copy size and content of
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */
    copyCanvasElement: function(canvas) {
      var newCanvas = fabric.util.createCanvasElement();
      newCanvas.width = canvas.width;
      newCanvas.height = canvas.height;
      newCanvas.getContext('2d').drawImage(canvas, 0, 0);
      return newCanvas;
    },

    /**
     * since 2.6.0 moved from canvas instance to utility.
     * @param {CanvasElement} canvasEl to copy size and content of
     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
     * @param {Number} quality <= 1 and > 0
     * @static
     * @memberOf fabric.util
     * @return {String} data url
     */
    toDataURL: function(canvasEl, format, quality) {
      return canvasEl.toDataURL('image/' + format, quality);
    },

    /**
     * Creates image element (works on client and node)
     * @static
     * @memberOf fabric.util
     * @return {HTMLImageElement} HTML image element
     */
    createImage: function() {
      return fabric.document.createElement('img');
    },

    /**
     * Multiply matrix A by matrix B to nest transformations
     * @static
     * @memberOf fabric.util
     * @param  {Array} a First transformMatrix
     * @param  {Array} b Second transformMatrix
     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
     * @return {Array} The product of the two transform matrices
     */
    multiplyTransformMatrices: function(a, b, is2x2) {
      // Matrix multiply a * b
      return [
        a[0] * b[0] + a[2] * b[1],
        a[1] * b[0] + a[3] * b[1],
        a[0] * b[2] + a[2] * b[3],
        a[1] * b[2] + a[3] * b[3],
        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
      ];
    },

    /**
     * Decomposes standard 2x3 matrix into transform components
     * @static
     * @memberOf fabric.util
     * @param  {Array} a transformMatrix
     * @return {Object} Components of transform
     */
    qrDecompose: function(a) {
      var angle = atan2(a[1], a[0]),
          denom = pow(a[0], 2) + pow(a[1], 2),
          scaleX = sqrt(denom),
          scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX,
          skewX = atan2(a[0] * a[2] + a[1] * a [3], denom);
      return {
        angle: angle / PiBy180,
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: skewX / PiBy180,
        skewY: 0,
        translateX: a[4],
        translateY: a[5]
      };
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle] angle in degrees
     * @return {Number[]} transform matrix
     */
    calcRotateMatrix: function(options) {
      if (!options.angle) {
        return fabric.iMatrix.concat();
      }
      var theta = fabric.util.degreesToRadians(options.angle),
          cos = fabric.util.cos(theta),
          sin = fabric.util.sin(theta);
      return [cos, sin, -sin, cos, 0, 0];
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet.
     * is called DimensionsTransformMatrix because those properties are the one that influence
     * the size of the resulting box of the object.
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @return {Number[]} transform matrix
     */
    calcDimensionsMatrix: function(options) {
      var scaleX = typeof options.scaleX === 'undefined' ? 1 : options.scaleX,
          scaleY = typeof options.scaleY === 'undefined' ? 1 : options.scaleY,
          scaleMatrix = [
            options.flipX ? -scaleX : scaleX,
            0,
            0,
            options.flipY ? -scaleY : scaleY,
            0,
            0],
          multiply = fabric.util.multiplyTransformMatrices,
          degreesToRadians = fabric.util.degreesToRadians;
      if (options.skewX) {
        scaleMatrix = multiply(
          scaleMatrix,
          [1, 0, Math.tan(degreesToRadians(options.skewX)), 1],
          true);
      }
      if (options.skewY) {
        scaleMatrix = multiply(
          scaleMatrix,
          [1, Math.tan(degreesToRadians(options.skewY)), 0, 1],
          true);
      }
      return scaleMatrix;
    },

    /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle]
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.translateX]
     * @param  {Number} [options.translateY]
     * @return {Number[]} transform matrix
     */
    composeMatrix: function(options) {
      var matrix = [1, 0, 0, 1, options.translateX || 0, options.translateY || 0],
          multiply = fabric.util.multiplyTransformMatrices;
      if (options.angle) {
        matrix = multiply(matrix, fabric.util.calcRotateMatrix(options));
      }
      if (options.scaleX !== 1 || options.scaleY !== 1 ||
          options.skewX || options.skewY || options.flipX || options.flipY) {
        matrix = multiply(matrix, fabric.util.calcDimensionsMatrix(options));
      }
      return matrix;
    },

    /**
     * reset an object transform state to neutral. Top and left are not accounted for
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to transform
     */
    resetObjectTransform: function (target) {
      target.scaleX = 1;
      target.scaleY = 1;
      target.skewX = 0;
      target.skewY = 0;
      target.flipX = false;
      target.flipY = false;
      target.rotate(0);
    },

    /**
     * Extract Object transform values
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to read from
     * @return {Object} Components of transform
     */
    saveObjectTransform: function (target) {
      return {
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
      };
    },

    /**
     * Returns true if context has transparent pixel
     * at specified location (taking tolerance into account)
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x x coordinate
     * @param {Number} y y coordinate
     * @param {Number} tolerance Tolerance
     */
    isTransparent: function(ctx, x, y, tolerance) {

      // If tolerance is > 0 adjust start coords to take into account.
      // If moves off Canvas fix to 0
      if (tolerance > 0) {
        if (x > tolerance) {
          x -= tolerance;
        }
        else {
          x = 0;
        }
        if (y > tolerance) {
          y -= tolerance;
        }
        else {
          y = 0;
        }
      }

      var _isTransparent = true, i, temp,
          imageData = ctx.getImageData(x, y, (tolerance * 2) || 1, (tolerance * 2) || 1),
          l = imageData.data.length;

      // Split image data - for tolerance > 1, pixelDataSize = 4;
      for (i = 3; i < l; i += 4) {
        temp = imageData.data[i];
        _isTransparent = temp <= 0;
        if (_isTransparent === false) {
          break; // Stop if colour found
        }
      }

      imageData = null;

      return _isTransparent;
    },

    /**
     * Parse preserveAspectRatio attribute from element
     * @param {string} attribute to be parsed
     * @return {Object} an object containing align and meetOrSlice attribute
     */
    parsePreserveAspectRatioAttribute: function(attribute) {
      var meetOrSlice = 'meet', alignX = 'Mid', alignY = 'Mid',
          aspectRatioAttrs = attribute.split(' '), align;

      if (aspectRatioAttrs && aspectRatioAttrs.length) {
        meetOrSlice = aspectRatioAttrs.pop();
        if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
          align = meetOrSlice;
          meetOrSlice = 'meet';
        }
        else if (aspectRatioAttrs.length) {
          align = aspectRatioAttrs.pop();
        }
      }
      //divide align in alignX and alignY
      alignX = align !== 'none' ? align.slice(1, 4) : 'none';
      alignY = align !== 'none' ? align.slice(5, 8) : 'none';
      return {
        meetOrSlice: meetOrSlice,
        alignX: alignX,
        alignY: alignY
      };
    },

    /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @memberOf fabric.util
     * @param {String} [fontFamily] font family to clear
     */
    clearFabricFontCache: function(fontFamily) {
      fontFamily = (fontFamily || '').toLowerCase();
      if (!fontFamily) {
        fabric.charWidthsCache = { };
      }
      else if (fabric.charWidthsCache[fontFamily]) {
        delete fabric.charWidthsCache[fontFamily];
      }
    },

    /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Number} ar aspect ratio
     * @param {Number} maximumArea Maximum area you want to achieve
     * @return {Object.x} Limited dimensions by X
     * @return {Object.y} Limited dimensions by Y
     */
    limitDimsByArea: function(ar, maximumArea) {
      var roughWidth = Math.sqrt(maximumArea * ar),
          perfLimitSizeY = Math.floor(maximumArea / roughWidth);
      return { x: Math.floor(roughWidth), y: perfLimitSizeY };
    },

    capValue: function(min, value, max) {
      return Math.max(min, Math.min(value, max));
    },

    /**
     * Finds the scale for the object source to fit inside the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to fit into destination
     */
    findScaleToFit: function(source, destination) {
      return Math.min(destination.width / source.width, destination.height / source.height);
    },

    /**
     * Finds the scale for the object source to cover entirely the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to cover destination
     */
    findScaleToCover: function(source, destination) {
      return Math.max(destination.width / source.width, destination.height / source.height);
    },

    /**
     * given an array of 6 number returns something like `"matrix(...numbers)"`
     * @memberOf fabric.util
     * @param {Array} trasnform an array with 6 numbers
     * @return {String} transform matrix for svg
     * @return {Object.y} Limited dimensions by Y
     */
    matrixToSVG: function(transform) {
      return 'matrix(' + transform.map(function(value) {
        return fabric.util.toFixed(value, fabric.Object.NUM_FRACTION_DIGITS);
      }).join(' ') + ')';
    },

    /**
     * given a width and height, return the size of the bounding box
     * that can contains the box with width/height with applied transform
     * described in options.
     * Use to calculate the boxes around objects for controls.
     * @memberOf fabric.util
     * @param {Number} width
     * @param {Number} height
     * @param {Object} options
     * @param {Number} options.scaleX
     * @param {Number} options.scaleY
     * @param {Number} options.skewX
     * @param {Number} options.skewY
     * @return {Object.x} width of containing
     * @return {Object.y} height of containing
     */
    sizeAfterTransform: function(width, height, options) {
      var dimX = width / 2, dimY = height / 2,
          points = [
            {
              x: -dimX,
              y: -dimY
            },
            {
              x: dimX,
              y: -dimY
            },
            {
              x: -dimX,
              y: dimY
            },
            {
              x: dimX,
              y: dimY
            }],
          transformMatrix = fabric.util.calcDimensionsMatrix(options),
          bbox = fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
      return {
        x: bbox.width,
        y: bbox.height,
      };
    }
  };
})( true ? exports : this);


(function() {
  var _join = Array.prototype.join,
      commandLengths = {
        m: 2,
        l: 2,
        h: 1,
        v: 1,
        c: 6,
        s: 4,
        q: 4,
        t: 2,
        a: 7
      },
      repeatedCommands = {
        m: 'l',
        M: 'L'
      };
  function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
    var costh2 = fabric.util.cos(th2),
        sinth2 = fabric.util.sin(th2),
        costh3 = fabric.util.cos(th3),
        sinth3 = fabric.util.sin(th3),
        toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1,
        toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1,
        cp1X = fromX + mT * ( -cosTh * rx * sinth2 - sinTh * ry * costh2),
        cp1Y = fromY + mT * ( -sinTh * rx * sinth2 + cosTh * ry * costh2),
        cp2X = toX + mT * ( cosTh * rx * sinth3 + sinTh * ry * costh3),
        cp2Y = toY + mT * ( sinTh * rx * sinth3 - cosTh * ry * costh3);

    return ['C',
      cp1X, cp1Y,
      cp2X, cp2Y,
      toX, toY
    ];
  }

  /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   */
  function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
    var PI = Math.PI, th = rotateX * PI / 180,
        sinTh = fabric.util.sin(th),
        cosTh = fabric.util.cos(th),
        fromX = 0, fromY = 0;

    rx = Math.abs(rx);
    ry = Math.abs(ry);

    var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5,
        py = -cosTh * toY * 0.5 + sinTh * toX * 0.5,
        rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px,
        pl = rx2 * ry2 - rx2 * py2 - ry2 * px2,
        root = 0;

    if (pl < 0) {
      var s = Math.sqrt(1 - pl / (rx2 * ry2));
      rx *= s;
      ry *= s;
    }
    else {
      root = (large === sweep ? -1.0 : 1.0) *
              Math.sqrt( pl / (rx2 * py2 + ry2 * px2));
    }

    var cx = root * rx * py / ry,
        cy = -root * ry * px / rx,
        cx1 = cosTh * cx - sinTh * cy + toX * 0.5,
        cy1 = sinTh * cx + cosTh * cy + toY * 0.5,
        mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry),
        dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);

    if (sweep === 0 && dtheta > 0) {
      dtheta -= 2 * PI;
    }
    else if (sweep === 1 && dtheta < 0) {
      dtheta += 2 * PI;
    }

    // Convert into cubic bezier segments <= 90deg
    var segments = Math.ceil(Math.abs(dtheta / PI * 2)),
        result = [], mDelta = dtheta / segments,
        mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2),
        th3 = mTheta + mDelta;

    for (var i = 0; i < segments; i++) {
      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
      fromX = result[i][5];
      fromY = result[i][6];
      mTheta = th3;
      th3 += mDelta;
    }
    return result;
  }

  /*
   * Private
   */
  function calcVectorAngle(ux, uy, vx, vy) {
    var ta = Math.atan2(uy, ux),
        tb = Math.atan2(vy, vx);
    if (tb >= ta) {
      return tb - ta;
    }
    else {
      return 2 * Math.PI - (ta - tb);
    }
  }

  /**
   * Calculate bounding box of a beziercurve
   * @param {Number} x0 starting point
   * @param {Number} y0
   * @param {Number} x1 first control point
   * @param {Number} y1
   * @param {Number} x2 secondo control point
   * @param {Number} y2
   * @param {Number} x3 end of beizer
   * @param {Number} y3
   */
  // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
  // TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
  function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
    var argsString;
    if (fabric.cachesBoundsOfCurve) {
      argsString = _join.call(arguments);
      if (fabric.boundsOfCurveCache[argsString]) {
        return fabric.boundsOfCurveCache[argsString];
      }
    }

    var sqrt = Math.sqrt,
        min = Math.min, max = Math.max,
        abs = Math.abs, tvalues = [],
        bounds = [[], []],
        a, b, c, t, t1, t2, b2ac, sqrtb2ac;

    b = 6 * x0 - 12 * x1 + 6 * x2;
    a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
    c = 3 * x1 - 3 * x0;

    for (var i = 0; i < 2; ++i) {
      if (i > 0) {
        b = 6 * y0 - 12 * y1 + 6 * y2;
        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
        c = 3 * y1 - 3 * y0;
      }

      if (abs(a) < 1e-12) {
        if (abs(b) < 1e-12) {
          continue;
        }
        t = -c / b;
        if (0 < t && t < 1) {
          tvalues.push(t);
        }
        continue;
      }
      b2ac = b * b - 4 * c * a;
      if (b2ac < 0) {
        continue;
      }
      sqrtb2ac = sqrt(b2ac);
      t1 = (-b + sqrtb2ac) / (2 * a);
      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }
      t2 = (-b - sqrtb2ac) / (2 * a);
      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }

    var x, y, j = tvalues.length, jlen = j, mt;
    while (j--) {
      t = tvalues[j];
      mt = 1 - t;
      x = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
      bounds[0][j] = x;

      y = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
      bounds[1][j] = y;
    }

    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    var result = [
      {
        x: min.apply(null, bounds[0]),
        y: min.apply(null, bounds[1])
      },
      {
        x: max.apply(null, bounds[0]),
        y: max.apply(null, bounds[1])
      }
    ];
    if (fabric.cachesBoundsOfCurve) {
      fabric.boundsOfCurveCache[argsString] = result;
    }
    return result;
  }

  /**
   * Converts arc to a bunch of beizer curves
   * @param {Number} fx starting point x
   * @param {Number} fy starting point y
   * @param {Array} coords Arc command
   */
  function fromArcToBeizers(fx, fy, coords) {
    var rx = coords[1],
        ry = coords[2],
        rot = coords[3],
        large = coords[4],
        sweep = coords[5],
        tx = coords[6],
        ty = coords[7],
        segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segsNorm.length; i < len; i++) {
      segsNorm[i][1] += fx;
      segsNorm[i][2] += fy;
      segsNorm[i][3] += fx;
      segsNorm[i][4] += fy;
      segsNorm[i][5] += fx;
      segsNorm[i][6] += fy;
    }
    return segsNorm;
  };


  function makePathSimpler(path) {
    // x and y represent the last point of the path. the previous command point.
    // we add them to each relative command to make it an absolute comment.
    // we also swap the v V h H with L, because are easier to transform.
    var x = 0, y = 0, len = path.length,
        // x1 and y1 represent the last point of the subpath. the subpath is started with
        // m or M command. When a z or Z command is drawn, x and y need to be resetted to
        // the last x1 and y1.
        x1 = 0, y1 = 0, current, i, converted,
        // previous will host the letter of the previous command, to handle S and T.
        // controlX and controlY will host the previous reflected control point
        destinationPath = [], previous, controlX, controlY;
    for (i = 0; i < len; ++i) {
      converted = false;
      current = path[i].slice(0);
      switch (current[0]) { // first letter
        case 'l': // lineto, relative
          current[0] = 'L';
          current[1] += x;
          current[2] += y;
          // falls through
        case 'L':
          x = current[1];
          y = current[2];
          break;
        case 'h': // horizontal lineto, relative
          current[1] += x;
          // falls through
        case 'H':
          current[0] = 'L';
          current[2] = y;
          x = current[1];
          break;
        case 'v': // vertical lineto, relative
          current[1] += y;
          // falls through
        case 'V':
          current[0] = 'L';
          y = current[1];
          current[1] = x;
          current[2] = y;
          break;
        case 'm': // moveTo, relative
          current[0] = 'M';
          current[1] += x;
          current[2] += y;
          // falls through
        case 'M':
          x = current[1];
          y = current[2];
          x1 = current[1];
          y1 = current[2];
          break;
        case 'c': // bezierCurveTo, relative
          current[0] = 'C';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
          current[5] += x;
          current[6] += y;
          // falls through
        case 'C':
          controlX = current[3];
          controlY = current[4];
          x = current[5];
          y = current[6];
          break;
        case 's': // shorthand cubic bezierCurveTo, relative
          current[0] = 'S';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
          // falls through
        case 'S':
          // would be sScC but since we are swapping sSc for C, we check just that.
          if (previous === 'C') {
            // calculate reflection of previous control points
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          }
          else {
            // If there is no previous command or if the previous command was not a C, c, S, or s,
            // the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }
          x = current[3];
          y = current[4];
          current[0] = 'C';
          current[5] = current[3];
          current[6] = current[4];
          current[3] = current[1];
          current[4] = current[2];
          current[1] = controlX;
          current[2] = controlY;
          // current[3] and current[4] are NOW the second control point.
          // we keep it for the next reflection.
          controlX = current[3];
          controlY = current[4];
          break;
        case 'q': // quadraticCurveTo, relative
          current[0] = 'Q';
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
          // falls through
        case 'Q':
          controlX = current[1];
          controlY = current[2];
          x = current[3];
          y = current[4];
          break;
        case 't': // shorthand quadraticCurveTo, relative
          current[0] = 'T';
          current[1] += x;
          current[2] += y;
          // falls through
        case 'T':
          if (previous === 'Q') {
            // calculate reflection of previous control point
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          }
          else {
            // If there is no previous command or if the previous command was not a Q, q, T or t,
            // assume the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }
          current[0] = 'Q';
          x = current[1];
          y = current[2];
          current[1] = controlX;
          current[2] = controlY;
          current[3] = x;
          current[4] = y;
          break;
        case 'a':
          current[0] = 'A';
          current[6] += x;
          current[7] += y;
          // falls through
        case 'A':
          converted = true;
          destinationPath = destinationPath.concat(fromArcToBeizers(x, y, current));
          x = current[6];
          y = current[7];
          break;
        case 'z':
        case 'Z':
          x = x1;
          y = y1;
          break;
        default:
      }
      if (!converted) {
        destinationPath.push(current);
      }
      previous = current[0];
    }
    return destinationPath;
  };

  /**
   * Calc length from point x1,y1 to x2,y2
   * @param {Number} x1 starting point x
   * @param {Number} y1 starting point y
   * @param {Number} x2 starting point x
   * @param {Number} y2 starting point y
   * @return {Number} length of segment
   */
  function calcLineLength(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  }

  // functions for the Cubic beizer
  // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
  function CB1(t) {
    return t * t * t;
  }
  function CB2(t) {
    return 3 * t * t * (1 - t);
  }
  function CB3(t) {
    return 3 * t * (1 - t) * (1 - t);
  }
  function CB4(t) {
    return (1 - t) * (1 - t) * (1 - t);
  }

  function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
    return function(pct) {
      var c1 = CB1(pct), c2 = CB2(pct), c3 = CB3(pct), c4 = CB4(pct);
      return {
        x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
        y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
      };
    };
  }

  function QB1(t) {
    return t * t;
  }

  function QB2(t) {
    return 2 * t * (1 - t);
  }

  function QB3(t) {
    return (1 - t) * (1 - t);
  }

  function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
    return function(pct) {
      var c1 = QB1(pct), c2 = QB2(pct), c3 = QB3(pct);
      return {
        x: p3x * c1 + p2x * c2 + p1x * c3,
        y: p3y * c1 + p2y * c2 + p1y * c3
      };
    };
  }

  function pathIterator(iterator, x1, y1) {
    var tempP = { x: x1, y: y1 }, p, tmpLen = 0, perc;
    for (perc = 0.01; perc <= 1; perc += 0.01) {
      p = iterator(perc);
      tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
      tempP = p;
    }
    return tmpLen;
  }

  //measures the length of a pre-simplified path
  function getPathSegmentsInfo(path) {
    var totalLength = 0, len = path.length, current,
        //x2 and y2 are the coords of segment start
        //x1 and y1 are the coords of the current point
        x1 = 0, y1 = 0, x2 = 0, y2 = 0, info = [], iterator, tempInfo;
    for (var i = 0; i < len; i++) {
      current = path[i];
      tempInfo = {
        x: x1,
        y: y1,
        command: current[0],
      };
      switch (current[0]) { //first letter
        case 'M':
          tempInfo.length = 0;
          x2 = x1 = current[1];
          y2 = y1 = current[2];
          break;
        case 'L':
          tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
          x1 = current[1];
          y1 = current[2];
          break;
        case 'C':
          iterator = getPointOnCubicBezierIterator(
            x1,
            y1,
            current[1],
            current[2],
            current[3],
            current[4],
            current[5],
            current[6]
          );
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[5];
          y1 = current[6];
          break;
        case 'Q':
          iterator = getPointOnQuadraticBezierIterator(
            x1,
            y1,
            current[1],
            current[2],
            current[3],
            current[4]
          );
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[3];
          y1 = current[4];
          break;
        case 'Z':
        case 'z':
          // we add those in order to ease calculations later
          tempInfo.destX = x2;
          tempInfo.destY = y2;
          tempInfo.length = calcLineLength(x1, y1, x2, y2);
          x1 = x2;
          y1 = y2;
          break;
      }
      totalLength += tempInfo.length;
      info.push(tempInfo);
    }
    info.push({ length: totalLength, x: x1, y: y1 });
    return info;
  }

  function getPointOnPath(path, perc, infos) {
    if (!infos) {
      infos = getPathSegmentsInfo(path);
    }
    var distance = infos[infos.length - 1] * perc, i = 0;
    while ((distance - infos[i] > 0) && i < infos.length) {
      distance -= infos[i];
      i++;
    }
    var segInfo = infos[i], segPercent = distance / segInfo.length,
        command = segInfo.length, segment = path[i];
    switch (command) {
      case 'Z':
      case 'z':
        return new fabric.Point(segInfo.x, segInfo.y).lerp(
          new fabric.Point(segInfo.destX, segInfo.destY),
          segPercent
        );
        break;
      case 'L':
        return new fabric.Point(segInfo.x, segInfo.y).lerp(
          new fabric.Point(segment[1], segment[2]),
          segPercent
        );
        break;
      case 'C':
        return getPointOnCubicBezierIterator(
          segInfo.x,
          segInfo.y,
          segment[1],
          segment[2],
          segment[3],
          segment[4],
          segment[5],
          segment[6]
        )(segPercent);
        break;
      case 'Q':
        return getPointOnQuadraticBezierIterator(
          segInfo.x,
          segInfo.y,
          segment[1],
          segment[2],
          segment[3],
          segment[4]
        )(segPercent);
        break;
    }
  }

  function parsePath(pathString) {
    var result = [],
        coords = [],
        currentPath,
        parsed,
        re = fabric.rePathCommand,
        rNumber = '[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*',
        rNumberCommaWsp = '(' + rNumber + ')' + fabric.commaWsp,
        rFlagCommaWsp = '([01])' + fabric.commaWsp + '?',
        rArcSeq = rNumberCommaWsp + '?' + rNumberCommaWsp + '?' + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp +
          rNumberCommaWsp + '?(' + rNumber + ')',
        regArcArgumentSequence = new RegExp(rArcSeq, 'g'),
        match,
        coordsStr,
        // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
        path;
    if (!pathString || !pathString.match) {
      return result;
    }
    path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);

    for (var i = 0, coordsParsed, len = path.length; i < len; i++) {
      currentPath = path[i];

      coordsStr = currentPath.slice(1).trim();
      coords.length = 0;

      var command = currentPath.charAt(0);
      coordsParsed = [command];

      if (command.toLowerCase() === 'a') {
        // arcs have special flags that apparently don't require spaces so handle special
        for (var args; (args = regArcArgumentSequence.exec(coordsStr));) {
          for (var j = 1; j < args.length; j++) {
            coords.push(args[j]);
          }
        }
      }
      else {
        while ((match = re.exec(coordsStr))) {
          coords.push(match[0]);
        }
      }

      for (var j = 0, jlen = coords.length; j < jlen; j++) {
        parsed = parseFloat(coords[j]);
        if (!isNaN(parsed)) {
          coordsParsed.push(parsed);
        }
      }

      var commandLength = commandLengths[command.toLowerCase()],
          repeatedCommand = repeatedCommands[command] || command;

      if (coordsParsed.length - 1 > commandLength) {
        for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
          result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
          command = repeatedCommand;
        }
      }
      else {
        result.push(coordsParsed);
      }
    }

    return result;
  };

  /**
   * Calculate bounding box of a elliptic-arc
   * @deprecated
   * @param {Number} fx start point of arc
   * @param {Number} fy
   * @param {Number} rx horizontal radius
   * @param {Number} ry vertical radius
   * @param {Number} rot angle of horizontal axis
   * @param {Number} large 1 or 0, whatever the arc is the big or the small on the 2 points
   * @param {Number} sweep 1 or 0, 1 clockwise or counterclockwise direction
   * @param {Number} tx end point of arc
   * @param {Number} ty
   */
  function getBoundsOfArc(fx, fy, rx, ry, rot, large, sweep, tx, ty) {

    var fromX = 0, fromY = 0, bound, bounds = [],
        segs = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);

    for (var i = 0, len = segs.length; i < len; i++) {
      bound = getBoundsOfCurve(fromX, fromY, segs[i][1], segs[i][2], segs[i][3], segs[i][4], segs[i][5], segs[i][6]);
      bounds.push({ x: bound[0].x + fx, y: bound[0].y + fy });
      bounds.push({ x: bound[1].x + fx, y: bound[1].y + fy });
      fromX = segs[i][5];
      fromY = segs[i][6];
    }
    return bounds;
  };

  /**
   * Draws arc
   * @param {CanvasRenderingContext2D} ctx
   * @param {Number} fx
   * @param {Number} fy
   * @param {Array} coords coords of the arc, without the front 'A/a'
   */
  function drawArc(ctx, fx, fy, coords) {
    coords = coords.slice(0).unshift('X'); // command A or a does not matter
    var beizers = fromArcToBeizers(fx, fy, coords);
    beizers.forEach(function(beizer) {
      ctx.bezierCurveTo.apply(ctx, beizer.slice(1));
    });
  };

  fabric.util.parsePath = parsePath;
  fabric.util.makePathSimpler = makePathSimpler;
  fabric.util.getPathSegmentsInfo = getPathSegmentsInfo;
  fabric.util.fromArcToBeizers = fromArcToBeizers;
  fabric.util.getBoundsOfCurve = getBoundsOfCurve;
  fabric.util.getPointOnPath = getPointOnPath;
  // kept because we do not want to make breaking changes.
  // but useless and deprecated.
  fabric.util.getBoundsOfArc = getBoundsOfArc;
  fabric.util.drawArc = drawArc;
})();


(function() {

  var slice = Array.prototype.slice;

  /**
   * Invokes method on all items in a given array
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} method Name of a method to invoke
   * @return {Array}
   */
  function invoke(array, method) {
    var args = slice.call(arguments, 2), result = [];
    for (var i = 0, len = array.length; i < len; i++) {
      result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
    }
    return result;
  }

  /**
   * Finds maximum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */
  function max(array, byProperty) {
    return find(array, byProperty, function(value1, value2) {
      return value1 >= value2;
    });
  }

  /**
   * Finds minimum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */
  function min(array, byProperty) {
    return find(array, byProperty, function(value1, value2) {
      return value1 < value2;
    });
  }

  /**
   * @private
   */
  function fill(array, value) {
    var k = array.length;
    while (k--) {
      array[k] = value;
    }
    return array;
  }

  /**
   * @private
   */
  function find(array, byProperty, condition) {
    if (!array || array.length === 0) {
      return;
    }

    var i = array.length - 1,
        result = byProperty ? array[i][byProperty] : array[i];
    if (byProperty) {
      while (i--) {
        if (condition(array[i][byProperty], result)) {
          result = array[i][byProperty];
        }
      }
    }
    else {
      while (i--) {
        if (condition(array[i], result)) {
          result = array[i];
        }
      }
    }
    return result;
  }

  /**
   * @namespace fabric.util.array
   */
  fabric.util.array = {
    fill: fill,
    invoke: invoke,
    min: min,
    max: max
  };

})();


(function() {
  /**
   * Copies all enumerable properties of one js object to another
   * this does not and cannot compete with generic utils.
   * Does not clone or extend fabric.Object subclasses.
   * This is mostly for internal use and has extra handling for fabricJS objects
   * it skips the canvas and group properties in deep cloning.
   * @memberOf fabric.util.object
   * @param {Object} destination Where to copy to
   * @param {Object} source Where to copy from
   * @return {Object}
   */

  function extend(destination, source, deep) {
    // JScript DontEnum bug is not taken care of
    // the deep clone is for internal use, is not meant to avoid
    // javascript traps or cloning html element or self referenced objects.
    if (deep) {
      if (!fabric.isLikelyNode && source instanceof Element) {
        // avoid cloning deep images, canvases,
        destination = source;
      }
      else if (source instanceof Array) {
        destination = [];
        for (var i = 0, len = source.length; i < len; i++) {
          destination[i] = extend({ }, source[i], deep);
        }
      }
      else if (source && typeof source === 'object') {
        for (var property in source) {
          if (property === 'canvas' || property === 'group') {
            // we do not want to clone this props at all.
            // we want to keep the keys in the copy
            destination[property] = null;
          }
          else if (source.hasOwnProperty(property)) {
            destination[property] = extend({ }, source[property], deep);
          }
        }
      }
      else {
        // this sounds odd for an extend but is ok for recursive use
        destination = source;
      }
    }
    else {
      for (var property in source) {
        destination[property] = source[property];
      }
    }
    return destination;
  }

  /**
   * Creates an empty object and copies all enumerable properties of another object to it
   * @memberOf fabric.util.object
   * TODO: this function return an empty object if you try to clone null
   * @param {Object} object Object to clone
   * @return {Object}
   */
  function clone(object, deep) {
    return extend({ }, object, deep);
  }

  /** @namespace fabric.util.object */
  fabric.util.object = {
    extend: extend,
    clone: clone
  };
  fabric.util.object.extend(fabric.util, fabric.Observable);
})();


(function() {

  /**
   * Camelizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to camelize
   * @return {String} Camelized version of a string
   */
  function camelize(string) {
    return string.replace(/-+(.)?/g, function(match, character) {
      return character ? character.toUpperCase() : '';
    });
  }

  /**
   * Capitalizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */
  function capitalize(string, firstLetterOnly) {
    return string.charAt(0).toUpperCase() +
      (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
  }

  /**
   * Escapes XML in a string
   * @memberOf fabric.util.string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */
  function escapeXml(string) {
    return string.replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /**
   * Divide a string in the user perceived single units
   * @memberOf fabric.util.string
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */
  function graphemeSplit(textstring) {
    var i = 0, chr, graphemes = [];
    for (i = 0, chr; i < textstring.length; i++) {
      if ((chr = getWholeChar(textstring, i)) === false) {
        continue;
      }
      graphemes.push(chr);
    }
    return graphemes;
  }

  // taken from mdn in the charAt doc page.
  function getWholeChar(str, i) {
    var code = str.charCodeAt(i);

    if (isNaN(code)) {
      return ''; // Position not found
    }
    if (code < 0xD800 || code > 0xDFFF) {
      return str.charAt(i);
    }

    // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xD800 <= code && code <= 0xDBFF) {
      if (str.length <= (i + 1)) {
        throw 'High surrogate without following low surrogate';
      }
      var next = str.charCodeAt(i + 1);
      if (0xDC00 > next || next > 0xDFFF) {
        throw 'High surrogate without following low surrogate';
      }
      return str.charAt(i) + str.charAt(i + 1);
    }
    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
    if (i === 0) {
      throw 'Low surrogate without preceding high surrogate';
    }
    var prev = str.charCodeAt(i - 1);

    // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xD800 > prev || prev > 0xDBFF) {
      throw 'Low surrogate without preceding high surrogate';
    }
    // We can pass over low surrogates now as the second component
    // in a pair which we have already processed
    return false;
  }


  /**
   * String utilities
   * @namespace fabric.util.string
   */
  fabric.util.string = {
    camelize: camelize,
    capitalize: capitalize,
    escapeXml: escapeXml,
    graphemeSplit: graphemeSplit
  };
})();


(function() {

  var slice = Array.prototype.slice, emptyFunction = function() { },

      IS_DONTENUM_BUGGY = (function() {
        for (var p in { toString: 1 }) {
          if (p === 'toString') {
            return false;
          }
        }
        return true;
      })(),

      /** @ignore */
      addMethods = function(klass, source, parent) {
        for (var property in source) {

          if (property in klass.prototype &&
              typeof klass.prototype[property] === 'function' &&
              (source[property] + '').indexOf('callSuper') > -1) {

            klass.prototype[property] = (function(property) {
              return function() {

                var superclass = this.constructor.superclass;
                this.constructor.superclass = parent;
                var returnValue = source[property].apply(this, arguments);
                this.constructor.superclass = superclass;

                if (property !== 'initialize') {
                  return returnValue;
                }
              };
            })(property);
          }
          else {
            klass.prototype[property] = source[property];
          }

          if (IS_DONTENUM_BUGGY) {
            if (source.toString !== Object.prototype.toString) {
              klass.prototype.toString = source.toString;
            }
            if (source.valueOf !== Object.prototype.valueOf) {
              klass.prototype.valueOf = source.valueOf;
            }
          }
        }
      };

  function Subclass() { }

  function callSuper(methodName) {
    var parentMethod = null,
        _this = this;

    // climb prototype chain to find method not equal to callee's method
    while (_this.constructor.superclass) {
      var superClassMethod = _this.constructor.superclass.prototype[methodName];
      if (_this[methodName] !== superClassMethod) {
        parentMethod = superClassMethod;
        break;
      }
      // eslint-disable-next-line
      _this = _this.constructor.superclass.prototype;
    }

    if (!parentMethod) {
      return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
    }

    return (arguments.length > 1)
      ? parentMethod.apply(this, slice.call(arguments, 1))
      : parentMethod.call(this);
  }

  /**
   * Helper for creation of "classes".
   * @memberOf fabric.util
   * @param {Function} [parent] optional "Class" to inherit from
   * @param {Object} [properties] Properties shared by all instances of this class
   *                  (be careful modifying objects defined here as this would affect all instances)
   */
  function createClass() {
    var parent = null,
        properties = slice.call(arguments, 0);

    if (typeof properties[0] === 'function') {
      parent = properties.shift();
    }
    function klass() {
      this.initialize.apply(this, arguments);
    }

    klass.superclass = parent;
    klass.subclasses = [];

    if (parent) {
      Subclass.prototype = parent.prototype;
      klass.prototype = new Subclass();
      parent.subclasses.push(klass);
    }
    for (var i = 0, length = properties.length; i < length; i++) {
      addMethods(klass, properties[i], parent);
    }
    if (!klass.prototype.initialize) {
      klass.prototype.initialize = emptyFunction;
    }
    klass.prototype.constructor = klass;
    klass.prototype.callSuper = callSuper;
    return klass;
  }

  fabric.util.createClass = createClass;
})();


(function () {
  // since ie11 can use addEventListener but they do not support options, i need to check
  var couldUseAttachEvent = !!fabric.document.createElement('div').attachEvent,
      touchEvents = ['touchstart', 'touchmove', 'touchend'];
  /**
   * Adds an event listener to an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */
  fabric.util.addListener = function(element, eventName, handler, options) {
    element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };

  /**
   * Removes an event listener from an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */
  fabric.util.removeListener = function(element, eventName, handler, options) {
    element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
  };

  function getTouchInfo(event) {
    var touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) {
      return touchProp[0];
    }
    return event;
  }

  fabric.util.getPointer = function(event) {
    var element = event.target,
        scroll = fabric.util.getScrollLeftTop(element),
        _evt = getTouchInfo(event);
    return {
      x: _evt.clientX + scroll.left,
      y: _evt.clientY + scroll.top
    };
  };

  fabric.util.isTouchEvent = function(event) {
    return touchEvents.indexOf(event.type) > -1 || event.pointerType === 'touch';
  };
})();


(function () {

  /**
   * Cross-browser wrapper for setting element's style
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {Object} styles
   * @return {HTMLElement} Element that was passed as a first argument
   */
  function setStyle(element, styles) {
    var elementStyle = element.style;
    if (!elementStyle) {
      return element;
    }
    if (typeof styles === 'string') {
      element.style.cssText += ';' + styles;
      return styles.indexOf('opacity') > -1
        ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1])
        : element;
    }
    for (var property in styles) {
      if (property === 'opacity') {
        setOpacity(element, styles[property]);
      }
      else {
        var normalizedProperty = (property === 'float' || property === 'cssFloat')
          ? (typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat')
          : property;
        elementStyle[normalizedProperty] = styles[property];
      }
    }
    return element;
  }

  var parseEl = fabric.document.createElement('div'),
      supportsOpacity = typeof parseEl.style.opacity === 'string',
      supportsFilters = typeof parseEl.style.filter === 'string',
      reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,

      /** @ignore */
      setOpacity = function (element) { return element; };

  if (supportsOpacity) {
    /** @ignore */
    setOpacity = function(element, value) {
      element.style.opacity = value;
      return element;
    };
  }
  else if (supportsFilters) {
    /** @ignore */
    setOpacity = function(element, value) {
      var es = element.style;
      if (element.currentStyle && !element.currentStyle.hasLayout) {
        es.zoom = 1;
      }
      if (reOpacity.test(es.filter)) {
        value = value >= 0.9999 ? '' : ('alpha(opacity=' + (value * 100) + ')');
        es.filter = es.filter.replace(reOpacity, value);
      }
      else {
        es.filter += ' alpha(opacity=' + (value * 100) + ')';
      }
      return element;
    };
  }

  fabric.util.setStyle = setStyle;

})();


(function() {

  var _slice = Array.prototype.slice;

  /**
   * Takes id and returns an element with that id (if one exists in a document)
   * @memberOf fabric.util
   * @param {String|HTMLElement} id
   * @return {HTMLElement|null}
   */
  function getById(id) {
    return typeof id === 'string' ? fabric.document.getElementById(id) : id;
  }

  var sliceCanConvertNodelists,
      /**
       * Converts an array-like object (e.g. arguments or NodeList) to an array
       * @memberOf fabric.util
       * @param {Object} arrayLike
       * @return {Array}
       */
      toArray = function(arrayLike) {
        return _slice.call(arrayLike, 0);
      };

  try {
    sliceCanConvertNodelists = toArray(fabric.document.childNodes) instanceof Array;
  }
  catch (err) { }

  if (!sliceCanConvertNodelists) {
    toArray = function(arrayLike) {
      var arr = new Array(arrayLike.length), i = arrayLike.length;
      while (i--) {
        arr[i] = arrayLike[i];
      }
      return arr;
    };
  }

  /**
   * Creates specified element with specified attributes
   * @memberOf fabric.util
   * @param {String} tagName Type of an element to create
   * @param {Object} [attributes] Attributes to set on an element
   * @return {HTMLElement} Newly created element
   */
  function makeElement(tagName, attributes) {
    var el = fabric.document.createElement(tagName);
    for (var prop in attributes) {
      if (prop === 'class') {
        el.className = attributes[prop];
      }
      else if (prop === 'for') {
        el.htmlFor = attributes[prop];
      }
      else {
        el.setAttribute(prop, attributes[prop]);
      }
    }
    return el;
  }

  /**
   * Adds class to an element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to add class to
   * @param {String} className Class to add to an element
   */
  function addClass(element, className) {
    if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) {
      element.className += (element.className ? ' ' : '') + className;
    }
  }

  /**
   * Wraps element with another element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to wrap
   * @param {HTMLElement|String} wrapper Element to wrap with
   * @param {Object} [attributes] Attributes to set on a wrapper
   * @return {HTMLElement} wrapper
   */
  function wrapElement(element, wrapper, attributes) {
    if (typeof wrapper === 'string') {
      wrapper = makeElement(wrapper, attributes);
    }
    if (element.parentNode) {
      element.parentNode.replaceChild(wrapper, element);
    }
    wrapper.appendChild(element);
    return wrapper;
  }

  /**
   * Returns element scroll offsets
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */
  function getScrollLeftTop(element) {

    var left = 0,
        top = 0,
        docElement = fabric.document.documentElement,
        body = fabric.document.body || {
          scrollLeft: 0, scrollTop: 0
        };

    // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
    while (element && (element.parentNode || element.host)) {

      // Set element to element parent, or 'host' in case of ShadowDOM
      element = element.parentNode || element.host;

      if (element === fabric.document) {
        left = body.scrollLeft || docElement.scrollLeft || 0;
        top = body.scrollTop ||  docElement.scrollTop || 0;
      }
      else {
        left += element.scrollLeft || 0;
        top += element.scrollTop || 0;
      }

      if (element.nodeType === 1 && element.style.position === 'fixed') {
        break;
      }
    }

    return { left: left, top: top };
  }

  /**
   * Returns offset for a given element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */
  function getElementOffset(element) {
    var docElem,
        doc = element && element.ownerDocument,
        box = { left: 0, top: 0 },
        offset = { left: 0, top: 0 },
        scrollLeftTop,
        offsetAttributes = {
          borderLeftWidth: 'left',
          borderTopWidth:  'top',
          paddingLeft:     'left',
          paddingTop:      'top'
        };

    if (!doc) {
      return offset;
    }

    for (var attr in offsetAttributes) {
      offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
    }

    docElem = doc.documentElement;
    if ( typeof element.getBoundingClientRect !== 'undefined' ) {
      box = element.getBoundingClientRect();
    }

    scrollLeftTop = getScrollLeftTop(element);

    return {
      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0)  + offset.top
    };
  }

  /**
   * Returns style attribute value of a given element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get style attribute for
   * @param {String} attr Style attribute to get for element
   * @return {String} Style attribute value of the given element.
   */
  var getElementStyle;
  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
    getElementStyle = function(element, attr) {
      var style = fabric.document.defaultView.getComputedStyle(element, null);
      return style ? style[attr] : undefined;
    };
  }
  else {
    getElementStyle = function(element, attr) {
      var value = element.style[attr];
      if (!value && element.currentStyle) {
        value = element.currentStyle[attr];
      }
      return value;
    };
  }

  (function () {
    var style = fabric.document.documentElement.style,
        selectProp = 'userSelect' in style
          ? 'userSelect'
          : 'MozUserSelect' in style
            ? 'MozUserSelect'
            : 'WebkitUserSelect' in style
              ? 'WebkitUserSelect'
              : 'KhtmlUserSelect' in style
                ? 'KhtmlUserSelect'
                : '';

    /**
     * Makes element unselectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make unselectable
     * @return {HTMLElement} Element that was passed in
     */
    function makeElementUnselectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = fabric.util.falseFunction;
      }
      if (selectProp) {
        element.style[selectProp] = 'none';
      }
      else if (typeof element.unselectable === 'string') {
        element.unselectable = 'on';
      }
      return element;
    }

    /**
     * Makes element selectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make selectable
     * @return {HTMLElement} Element that was passed in
     */
    function makeElementSelectable(element) {
      if (typeof element.onselectstart !== 'undefined') {
        element.onselectstart = null;
      }
      if (selectProp) {
        element.style[selectProp] = '';
      }
      else if (typeof element.unselectable === 'string') {
        element.unselectable = '';
      }
      return element;
    }

    fabric.util.makeElementUnselectable = makeElementUnselectable;
    fabric.util.makeElementSelectable = makeElementSelectable;
  })();

  function getNodeCanvas(element) {
    var impl = fabric.jsdomImplForWrapper(element);
    return impl._canvas || impl._image;
  };

  function cleanUpJsdomNode(element) {
    if (!fabric.isLikelyNode) {
      return;
    }
    var impl = fabric.jsdomImplForWrapper(element);
    if (impl) {
      impl._image = null;
      impl._canvas = null;
      // unsure if necessary
      impl._currentSrc = null;
      impl._attributes = null;
      impl._classList = null;
    }
  }

  function setImageSmoothing(ctx, value) {
    ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled
      || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
    ctx.imageSmoothingEnabled = value;
  }

  /**
   * setImageSmoothing sets the context imageSmoothingEnabled property.
   * Used by canvas and by ImageObject.
   * @memberOf fabric.util
   * @since 4.0.0
   * @param {HTMLRenderingContext2D} ctx to set on
   * @param {Boolean} value true or false
   */
  fabric.util.setImageSmoothing = setImageSmoothing;
  fabric.util.getById = getById;
  fabric.util.toArray = toArray;
  fabric.util.addClass = addClass;
  fabric.util.makeElement = makeElement;
  fabric.util.wrapElement = wrapElement;
  fabric.util.getScrollLeftTop = getScrollLeftTop;
  fabric.util.getElementOffset = getElementOffset;
  fabric.util.getNodeCanvas = getNodeCanvas;
  fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;

})();


(function() {

  function addParamToUrl(url, param) {
    return url + (/\?/.test(url) ? '&' : '?') + param;
  }

  function emptyFn() { }

  /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @memberOf fabric.util
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {String} [options.method="GET"]
   * @param {String} [options.parameters] parameters to append to url in GET or in body
   * @param {String} [options.body] body to send with POST or PUT request
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */
  function request(url, options) {
    options || (options = { });

    var method = options.method ? options.method.toUpperCase() : 'GET',
        onComplete = options.onComplete || function() { },
        xhr = new fabric.window.XMLHttpRequest(),
        body = options.body || options.parameters;

    /** @ignore */
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        onComplete(xhr);
        xhr.onreadystatechange = emptyFn;
      }
    };

    if (method === 'GET') {
      body = null;
      if (typeof options.parameters === 'string') {
        url = addParamToUrl(url, options.parameters);
      }
    }

    xhr.open(method, url, true);

    if (method === 'POST' || method === 'PUT') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    xhr.send(body);
    return xhr;
  }

  fabric.util.request = request;
})();


/**
 * Wrapper around `console.log` (when available)
 * @param {*} [values] Values to log
 */
fabric.log = console.log;

/**
 * Wrapper around `console.warn` (when available)
 * @param {*} [values] Values to log as a warning
 */
fabric.warn = console.warn;


(function() {

  function noop() {
    return false;
  }

  function defaultEasing(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }

  /**
   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Number} [options.startValue=0] Starting value
   * @param {Number} [options.endValue=100] Ending value
   * @param {Number} [options.byValue=100] Value to modify the property by
   * @param {Function} [options.easing] Easing function
   * @param {Number} [options.duration=500] Duration of change (in ms)
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */
  function animate(options) {

    requestAnimFrame(function(timestamp) {
      options || (options = { });

      var start = timestamp || +new Date(),
          duration = options.duration || 500,
          finish = start + duration, time,
          onChange = options.onChange || noop,
          abort = options.abort || noop,
          onComplete = options.onComplete || noop,
          easing = options.easing || defaultEasing,
          startValue = 'startValue' in options ? options.startValue : 0,
          endValue = 'endValue' in options ? options.endValue : 100,
          byValue = options.byValue || endValue - startValue;

      options.onStart && options.onStart();

      (function tick(ticktime) {
        // TODO: move abort call after calculation
        // and pass (current,valuePerc, timePerc) as arguments
        time = ticktime || +new Date();
        var currentTime = time > finish ? duration : (time - start),
            timePerc = currentTime / duration,
            current = easing(currentTime, startValue, byValue, duration),
            valuePerc = Math.abs((current - startValue) / byValue);
        if (abort()) {
          onComplete(endValue, 1, 1);
          return;
        }
        if (time > finish) {
          onChange(endValue, 1, 1);
          onComplete(endValue, 1, 1);
          return;
        }
        else {
          onChange(current, valuePerc, timePerc);
          requestAnimFrame(tick);
        }
      })(start);
    });
  }

  var _requestAnimFrame = fabric.window.requestAnimationFrame       ||
                          fabric.window.webkitRequestAnimationFrame ||
                          fabric.window.mozRequestAnimationFrame    ||
                          fabric.window.oRequestAnimationFrame      ||
                          fabric.window.msRequestAnimationFrame     ||
                          function(callback) {
                            return fabric.window.setTimeout(callback, 1000 / 60);
                          };

  var _cancelAnimFrame = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;

  /**
   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
   * @memberOf fabric.util
   * @param {Function} callback Callback to invoke
   * @param {DOMElement} element optional Element to associate with animation
   */
  function requestAnimFrame() {
    return _requestAnimFrame.apply(fabric.window, arguments);
  }

  function cancelAnimFrame() {
    return _cancelAnimFrame.apply(fabric.window, arguments);
  }

  fabric.util.animate = animate;
  fabric.util.requestAnimFrame = requestAnimFrame;
  fabric.util.cancelAnimFrame = cancelAnimFrame;
})();


(function() {
  // Calculate an in-between color. Returns a "rgba()" string.
  // Credit: Edwin Martin <edwin@bitstorm.org>
  //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
  function calculateColor(begin, end, pos) {
    var color = 'rgba('
        + parseInt((begin[0] + pos * (end[0] - begin[0])), 10) + ','
        + parseInt((begin[1] + pos * (end[1] - begin[1])), 10) + ','
        + parseInt((begin[2] + pos * (end[2] - begin[2])), 10);

    color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
    color += ')';
    return color;
  }

  /**
   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {String} fromColor The starting color in hex or rgb(a) format.
   * @param {String} toColor The starting color in hex or rgb(a) format.
   * @param {Number} [duration] Duration of change (in ms).
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   */
  function animateColor(fromColor, toColor, duration, options) {
    var startColor = new fabric.Color(fromColor).getSource(),
        endColor = new fabric.Color(toColor).getSource(),
        originalOnComplete = options.onComplete,
        originalOnChange = options.onChange;
    options = options || {};

    fabric.util.animate(fabric.util.object.extend(options, {
      duration: duration || 500,
      startValue: startColor,
      endValue: endColor,
      byValue: endColor,
      easing: function (currentTime, startValue, byValue, duration) {
        var posValue = options.colorEasing
          ? options.colorEasing(currentTime, duration)
          : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
        return calculateColor(startValue, byValue, posValue);
      },
      // has to take in account for color restoring;
      onComplete: function(current, valuePerc, timePerc) {
        if (originalOnComplete) {
          return originalOnComplete(
            calculateColor(endColor, endColor, 0),
            valuePerc,
            timePerc
          );
        }
      },
      onChange: function(current, valuePerc, timePerc) {
        if (originalOnChange) {
          if (Array.isArray(current)) {
            return originalOnChange(
              calculateColor(current, current, 0),
              valuePerc,
              timePerc
            );
          }
          originalOnChange(current, valuePerc, timePerc);
        }
      }
    }));
  }

  fabric.util.animateColor = animateColor;

})();


(function() {

  function normalize(a, c, p, s) {
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    }
    else {
      //handle the 0/0 case:
      if (c === 0 && a === 0) {
        s = p / (2 * Math.PI) * Math.asin(1);
      }
      else {
        s = p / (2 * Math.PI) * Math.asin(c / a);
      }
    }
    return { a: a, c: c, p: p, s: s };
  }

  function elastic(opts, t, d) {
    return opts.a *
      Math.pow(2, 10 * (t -= 1)) *
      Math.sin( (t * d - opts.s) * (2 * Math.PI) / opts.p );
  }

  /**
   * Cubic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  /**
   * Cubic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutCubic(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t + b;
    }
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  }

  /**
   * Quartic easing in
   * @memberOf fabric.util.ease
   */
  function easeInQuart(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  }

  /**
   * Quartic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutQuart(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  }

  /**
   * Quartic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutQuart(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t * t + b;
    }
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  }

  /**
   * Quintic easing in
   * @memberOf fabric.util.ease
   */
  function easeInQuint(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  }

  /**
   * Quintic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutQuint(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  }

  /**
   * Quintic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutQuint(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t * t * t * t + b;
    }
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  }

  /**
   * Sinusoidal easing in
   * @memberOf fabric.util.ease
   */
  function easeInSine(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  }

  /**
   * Sinusoidal easing out
   * @memberOf fabric.util.ease
   */
  function easeOutSine(t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  }

  /**
   * Sinusoidal easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutSine(t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  }

  /**
   * Exponential easing in
   * @memberOf fabric.util.ease
   */
  function easeInExpo(t, b, c, d) {
    return (t === 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  }

  /**
   * Exponential easing out
   * @memberOf fabric.util.ease
   */
  function easeOutExpo(t, b, c, d) {
    return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  }

  /**
   * Exponential easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutExpo(t, b, c, d) {
    if (t === 0) {
      return b;
    }
    if (t === d) {
      return b + c;
    }
    t /= d / 2;
    if (t < 1) {
      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    }
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  }

  /**
   * Circular easing in
   * @memberOf fabric.util.ease
   */
  function easeInCirc(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  }

  /**
   * Circular easing out
   * @memberOf fabric.util.ease
   */
  function easeOutCirc(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  }

  /**
   * Circular easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutCirc(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    }
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  }

  /**
   * Elastic easing in
   * @memberOf fabric.util.ease
   */
  function easeInElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    var opts = normalize(a, c, p, s);
    return -elastic(opts, t, d) + b;
  }

  /**
   * Elastic easing out
   * @memberOf fabric.util.ease
   */
  function easeOutElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    var opts = normalize(a, c, p, s);
    return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) + opts.c + b;
  }

  /**
   * Elastic easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutElastic(t, b, c, d) {
    var s = 1.70158, p = 0, a = c;
    if (t === 0) {
      return b;
    }
    t /= d / 2;
    if (t === 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    var opts = normalize(a, c, p, s);
    if (t < 1) {
      return -0.5 * elastic(opts, t, d) + b;
    }
    return opts.a * Math.pow(2, -10 * (t -= 1)) *
      Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) * 0.5 + opts.c + b;
  }

  /**
   * Backwards easing in
   * @memberOf fabric.util.ease
   */
  function easeInBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  }

  /**
   * Backwards easing out
   * @memberOf fabric.util.ease
   */
  function easeOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  }

  /**
   * Backwards easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutBack(t, b, c, d, s) {
    if (s === undefined) {
      s = 1.70158;
    }
    t /= d / 2;
    if (t < 1) {
      return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    }
    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
  }

  /**
   * Bouncing easing in
   * @memberOf fabric.util.ease
   */
  function easeInBounce(t, b, c, d) {
    return c - easeOutBounce (d - t, 0, c, d) + b;
  }

  /**
   * Bouncing easing out
   * @memberOf fabric.util.ease
   */
  function easeOutBounce(t, b, c, d) {
    if ((t /= d) < (1 / 2.75)) {
      return c * (7.5625 * t * t) + b;
    }
    else if (t < (2 / 2.75)) {
      return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b;
    }
    else if (t < (2.5 / 2.75)) {
      return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b;
    }
    else {
      return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b;
    }
  }

  /**
   * Bouncing easing in and out
   * @memberOf fabric.util.ease
   */
  function easeInOutBounce(t, b, c, d) {
    if (t < d / 2) {
      return easeInBounce (t * 2, 0, c, d) * 0.5 + b;
    }
    return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
  }

  /**
   * Easing functions
   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
   * @namespace fabric.util.ease
   */
  fabric.util.ease = {

    /**
     * Quadratic easing in
     * @memberOf fabric.util.ease
     */
    easeInQuad: function(t, b, c, d) {
      return c * (t /= d) * t + b;
    },

    /**
     * Quadratic easing out
     * @memberOf fabric.util.ease
     */
    easeOutQuad: function(t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },

    /**
     * Quadratic easing in and out
     * @memberOf fabric.util.ease
     */
    easeInOutQuad: function(t, b, c, d) {
      t /= (d / 2);
      if (t < 1) {
        return c / 2 * t * t + b;
      }
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    },

    /**
     * Cubic easing in
     * @memberOf fabric.util.ease
     */
    easeInCubic: function(t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },

    easeOutCubic: easeOutCubic,
    easeInOutCubic: easeInOutCubic,
    easeInQuart: easeInQuart,
    easeOutQuart: easeOutQuart,
    easeInOutQuart: easeInOutQuart,
    easeInQuint: easeInQuint,
    easeOutQuint: easeOutQuint,
    easeInOutQuint: easeInOutQuint,
    easeInSine: easeInSine,
    easeOutSine: easeOutSine,
    easeInOutSine: easeInOutSine,
    easeInExpo: easeInExpo,
    easeOutExpo: easeOutExpo,
    easeInOutExpo: easeInOutExpo,
    easeInCirc: easeInCirc,
    easeOutCirc: easeOutCirc,
    easeInOutCirc: easeInOutCirc,
    easeInElastic: easeInElastic,
    easeOutElastic: easeOutElastic,
    easeInOutElastic: easeInOutElastic,
    easeInBack: easeInBack,
    easeOutBack: easeOutBack,
    easeInOutBack: easeInOutBack,
    easeInBounce: easeInBounce,
    easeOutBounce: easeOutBounce,
    easeInOutBounce: easeInOutBounce
  };

})();


(function(global) {

  'use strict';

  /**
   * @name fabric
   * @namespace
   */

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      parseUnit = fabric.util.parseUnit,
      multiplyTransformMatrices = fabric.util.multiplyTransformMatrices,

      svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line',
        'image', 'text'],
      svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
      svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
      svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],

      attributesMap = {
        cx:                   'left',
        x:                    'left',
        r:                    'radius',
        cy:                   'top',
        y:                    'top',
        display:              'visible',
        visibility:           'visible',
        transform:            'transformMatrix',
        'fill-opacity':       'fillOpacity',
        'fill-rule':          'fillRule',
        'font-family':        'fontFamily',
        'font-size':          'fontSize',
        'font-style':         'fontStyle',
        'font-weight':        'fontWeight',
        'letter-spacing':     'charSpacing',
        'paint-order':        'paintFirst',
        'stroke-dasharray':   'strokeDashArray',
        'stroke-dashoffset':  'strokeDashOffset',
        'stroke-linecap':     'strokeLineCap',
        'stroke-linejoin':    'strokeLineJoin',
        'stroke-miterlimit':  'strokeMiterLimit',
        'stroke-opacity':     'strokeOpacity',
        'stroke-width':       'strokeWidth',
        'text-decoration':    'textDecoration',
        'text-anchor':        'textAnchor',
        opacity:              'opacity',
        'clip-path':          'clipPath',
        'clip-rule':          'clipRule',
        'vector-effect':      'strokeUniform',
        'image-rendering':    'imageSmoothing',
      },

      colorAttributes = {
        stroke: 'strokeOpacity',
        fill:   'fillOpacity'
      },

      fSize = 'font-size', cPath = 'clip-path';

  fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
  fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
  fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
  fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);

  fabric.cssRules = { };
  fabric.gradientDefs = { };
  fabric.clipPaths = { };

  function normalizeAttr(attr) {
    // transform attribute names
    if (attr in attributesMap) {
      return attributesMap[attr];
    }
    return attr;
  }

  function normalizeValue(attr, value, parentAttributes, fontSize) {
    var isArray = Object.prototype.toString.call(value) === '[object Array]',
        parsed;

    if ((attr === 'fill' || attr === 'stroke') && value === 'none') {
      value = '';
    }
    else if (attr === 'strokeUniform') {
      return (value === 'non-scaling-stroke');
    }
    else if (attr === 'strokeDashArray') {
      if (value === 'none') {
        value = null;
      }
      else {
        value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
      }
    }
    else if (attr === 'transformMatrix') {
      if (parentAttributes && parentAttributes.transformMatrix) {
        value = multiplyTransformMatrices(
          parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
      }
      else {
        value = fabric.parseTransformAttribute(value);
      }
    }
    else if (attr === 'visible') {
      value = value !== 'none' && value !== 'hidden';
      // display=none on parent element always takes precedence over child element
      if (parentAttributes && parentAttributes.visible === false) {
        value = false;
      }
    }
    else if (attr === 'opacity') {
      value = parseFloat(value);
      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
        value *= parentAttributes.opacity;
      }
    }
    else if (attr === 'textAnchor' /* text-anchor */) {
      value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
    }
    else if (attr === 'charSpacing') {
      // parseUnit returns px and we convert it to em
      parsed = parseUnit(value, fontSize) / fontSize * 1000;
    }
    else if (attr === 'paintFirst') {
      var fillIndex = value.indexOf('fill');
      var strokeIndex = value.indexOf('stroke');
      var value = 'fill';
      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
        value = 'stroke';
      }
      else if (fillIndex === -1 && strokeIndex > -1) {
        value = 'stroke';
      }
    }
    else if (attr === 'href' || attr === 'xlink:href' || attr === 'font') {
      return value;
    }
    else if (attr === 'imageSmoothing') {
      return (value === 'optimizeQuality' ? true : false);
    }
    else {
      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
    }

    return (!isArray && isNaN(parsed) ? value : parsed);
  }

  /**
    * @private
    */
  function getSvgRegex(arr) {
    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
  }

  /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */
  function _setStrokeFillOpacity(attributes) {
    for (var attr in colorAttributes) {

      if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') {
        continue;
      }

      if (typeof attributes[attr] === 'undefined') {
        if (!fabric.Object.prototype[attr]) {
          continue;
        }
        attributes[attr] = fabric.Object.prototype[attr];
      }

      if (attributes[attr].indexOf('url(') === 0) {
        continue;
      }

      var color = new fabric.Color(attributes[attr]);
      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
    }
    return attributes;
  }

  /**
   * @private
   */
  function _getMultipleNodes(doc, nodeNames) {
    var nodeName, nodeArray = [], nodeList, i, len;
    for (i = 0, len = nodeNames.length; i < len; i++) {
      nodeName = nodeNames[i];
      nodeList = doc.getElementsByTagName(nodeName);
      nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
    }
    return nodeArray;
  }

  /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {Array} Array of 6 elements representing transformation matrix
   */
  fabric.parseTransformAttribute = (function() {
    function rotateMatrix(matrix, args) {
      var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]),
          x = 0, y = 0;
      if (args.length === 3) {
        x = args[1];
        y = args[2];
      }

      matrix[0] = cos;
      matrix[1] = sin;
      matrix[2] = -sin;
      matrix[3] = cos;
      matrix[4] = x - (cos * x - sin * y);
      matrix[5] = y - (sin * x + cos * y);
    }

    function scaleMatrix(matrix, args) {
      var multiplierX = args[0],
          multiplierY = (args.length === 2) ? args[1] : args[0];

      matrix[0] = multiplierX;
      matrix[3] = multiplierY;
    }

    function skewMatrix(matrix, args, pos) {
      matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
    }

    function translateMatrix(matrix, args) {
      matrix[4] = args[0];
      if (args.length === 2) {
        matrix[5] = args[1];
      }
    }

    // identity matrix
    var iMatrix = fabric.iMatrix,

        // == begin transform regexp
        number = fabric.reNum,

        commaWsp = fabric.commaWsp,

        skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))',

        skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))',

        rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + ')' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' +
                    commaWsp + '(' + number + '))?\\s*\\))',

        matrix = '(?:(matrix)\\s*\\(\\s*' +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' + commaWsp +
                  '(' + number + ')' +
                  '\\s*\\))',

        transform = '(?:' +
                    matrix + '|' +
                    translate + '|' +
                    scale + '|' +
                    rotate + '|' +
                    skewX + '|' +
                    skewY +
                    ')',

        transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')',

        transformList = '^\\s*(?:' + transforms + '?)\\s*$',

        // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
        reTransformList = new RegExp(transformList),
        // == end transform regexp

        reTransform = new RegExp(transform, 'g');

    return function(attributeValue) {

      // start with identity matrix
      var matrix = iMatrix.concat(),
          matrices = [];

      // return if no argument was given or
      // an argument does not match transform attribute regexp
      if (!attributeValue || (attributeValue && !reTransformList.test(attributeValue))) {
        return matrix;
      }

      attributeValue.replace(reTransform, function(match) {

        var m = new RegExp(transform).exec(match).filter(function (match) {
              // match !== '' && match != null
              return (!!match);
            }),
            operation = m[1],
            args = m.slice(2).map(parseFloat);

        switch (operation) {
          case 'translate':
            translateMatrix(matrix, args);
            break;
          case 'rotate':
            args[0] = fabric.util.degreesToRadians(args[0]);
            rotateMatrix(matrix, args);
            break;
          case 'scale':
            scaleMatrix(matrix, args);
            break;
          case 'skewX':
            skewMatrix(matrix, args, 2);
            break;
          case 'skewY':
            skewMatrix(matrix, args, 1);
            break;
          case 'matrix':
            matrix = args;
            break;
        }

        // snapshot current matrix into matrices array
        matrices.push(matrix.concat());
        // reset
        matrix = iMatrix.concat();
      });

      var combinedMatrix = matrices[0];
      while (matrices.length > 1) {
        matrices.shift();
        combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
      }
      return combinedMatrix;
    };
  })();

  /**
   * @private
   */
  function parseStyleString(style, oStyle) {
    var attr, value;
    style.replace(/;\s*$/, '').split(';').forEach(function (chunk) {
      var pair = chunk.split(':');

      attr = pair[0].trim().toLowerCase();
      value =  pair[1].trim();

      oStyle[attr] = value;
    });
  }

  /**
   * @private
   */
  function parseStyleObject(style, oStyle) {
    var attr, value;
    for (var prop in style) {
      if (typeof style[prop] === 'undefined') {
        continue;
      }

      attr = prop.toLowerCase();
      value = style[prop];

      oStyle[attr] = value;
    }
  }

  /**
   * @private
   */
  function getGlobalStylesForElement(element, svgUid) {
    var styles = { };
    for (var rule in fabric.cssRules[svgUid]) {
      if (elementMatchesRule(element, rule.split(' '))) {
        for (var property in fabric.cssRules[svgUid][rule]) {
          styles[property] = fabric.cssRules[svgUid][rule][property];
        }
      }
    }
    return styles;
  }

  /**
   * @private
   */
  function elementMatchesRule(element, selectors) {
    var firstMatching, parentMatching = true;
    //start from rightmost selector.
    firstMatching = selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) {
      parentMatching = doesSomeParentMatch(element, selectors);
    }
    return firstMatching && parentMatching && (selectors.length === 0);
  }

  function doesSomeParentMatch(element, selectors) {
    var selector, parentMatching = true;
    while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
      if (parentMatching) {
        selector = selectors.pop();
      }
      element = element.parentNode;
      parentMatching = selectorMatches(element, selector);
    }
    return selectors.length === 0;
  }

  /**
   * @private
   */
  function selectorMatches(element, selector) {
    var nodeName = element.nodeName,
        classNames = element.getAttribute('class'),
        id = element.getAttribute('id'), matcher, i;
    // i check if a selector matches slicing away part from it.
    // if i get empty string i should match
    matcher = new RegExp('^' + nodeName, 'i');
    selector = selector.replace(matcher, '');
    if (id && selector.length) {
      matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
      selector = selector.replace(matcher, '');
    }
    if (classNames && selector.length) {
      classNames = classNames.split(' ');
      for (i = classNames.length; i--;) {
        matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
        selector = selector.replace(matcher, '');
      }
    }
    return selector.length === 0;
  }

  /**
   * @private
   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
   */
  function elementById(doc, id) {
    var el;
    doc.getElementById && (el = doc.getElementById(id));
    if (el) {
      return el;
    }
    var node, i, len, nodelist = doc.getElementsByTagName('*');
    for (i = 0, len = nodelist.length; i < len; i++) {
      node = nodelist[i];
      if (id === node.getAttribute('id')) {
        return node;
      }
    }
  }

  /**
   * @private
   */
  function parseUseDirectives(doc) {
    var nodelist = _getMultipleNodes(doc, ['use', 'svg:use']), i = 0;
    while (nodelist.length && i < nodelist.length) {
      var el = nodelist[i],
          xlink = (el.getAttribute('xlink:href') || el.getAttribute('href')).substr(1),
          x = el.getAttribute('x') || 0,
          y = el.getAttribute('y') || 0,
          el2 = elementById(doc, xlink).cloneNode(true),
          currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')',
          parentNode, oldLength = nodelist.length, attr, j, attrs, len, namespace = fabric.svgNS;

      applyViewboxTransform(el2);
      if (/^svg$/i.test(el2.nodeName)) {
        var el3 = el2.ownerDocument.createElementNS(namespace, 'g');
        for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
          attr = attrs.item(j);
          el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
        }
        // el2.firstChild != null
        while (el2.firstChild) {
          el3.appendChild(el2.firstChild);
        }
        el2 = el3;
      }

      for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
        attr = attrs.item(j);
        if (attr.nodeName === 'x' || attr.nodeName === 'y' ||
          attr.nodeName === 'xlink:href' || attr.nodeName === 'href') {
          continue;
        }

        if (attr.nodeName === 'transform') {
          currentTrans = attr.nodeValue + ' ' + currentTrans;
        }
        else {
          el2.setAttribute(attr.nodeName, attr.nodeValue);
        }
      }

      el2.setAttribute('transform', currentTrans);
      el2.setAttribute('instantiated_by_use', '1');
      el2.removeAttribute('id');
      parentNode = el.parentNode;
      parentNode.replaceChild(el2, el);
      // some browsers do not shorten nodelist after replaceChild (IE8)
      if (nodelist.length === oldLength) {
        i++;
      }
    }
  }

  // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
  // matches, e.g.: +14.56e-12, etc.
  var reViewBoxAttrValue = new RegExp(
    '^' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*,?' +
    '\\s*(' + fabric.reNum + '+)\\s*' +
    '$'
  );

  /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */
  function applyViewboxTransform(element) {
    if (!fabric.svgViewBoxElementsRegEx.test(element.nodeName)) {
      return;
    }
    var viewBoxAttr = element.getAttribute('viewBox'),
        scaleX = 1,
        scaleY = 1,
        minX = 0,
        minY = 0,
        viewBoxWidth, viewBoxHeight, matrix, el,
        widthAttr = element.getAttribute('width'),
        heightAttr = element.getAttribute('height'),
        x = element.getAttribute('x') || 0,
        y = element.getAttribute('y') || 0,
        preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '',
        missingViewBox = (!viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue))),
        missingDimAttr = (!widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%'),
        toBeParsed = missingViewBox && missingDimAttr,
        parsedDim = { }, translateMatrix = '', widthDiff = 0, heightDiff = 0;

    parsedDim.width = 0;
    parsedDim.height = 0;
    parsedDim.toBeParsed = toBeParsed;

    if (missingViewBox) {
      if (((x || y) && element.parentNode.nodeName !== '#document')) {
        translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
        matrix = (element.getAttribute('transform') || '') + translateMatrix;
        element.setAttribute('transform', matrix);
        element.removeAttribute('x');
        element.removeAttribute('y');
      }
    }

    if (toBeParsed) {
      return parsedDim;
    }

    if (missingViewBox) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      // set a transform for elements that have x y and are inner(only) SVGs
      return parsedDim;
    }
    minX = -parseFloat(viewBoxAttr[1]);
    minY = -parseFloat(viewBoxAttr[2]);
    viewBoxWidth = parseFloat(viewBoxAttr[3]);
    viewBoxHeight = parseFloat(viewBoxAttr[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      scaleX = parsedDim.width / viewBoxWidth;
      scaleY = parsedDim.height / viewBoxHeight;
    }
    else {
      parsedDim.width = viewBoxWidth;
      parsedDim.height = viewBoxHeight;
    }

    // default is to preserve aspect ratio
    preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
    if (preserveAspectRatio.alignX !== 'none') {
      //translate all container for the effect of Mid, Min, Max
      if (preserveAspectRatio.meetOrSlice === 'meet') {
        scaleY = scaleX = (scaleX > scaleY ? scaleY : scaleX);
        // calculate additional translation to move the viewbox
      }
      if (preserveAspectRatio.meetOrSlice === 'slice') {
        scaleY = scaleX = (scaleX > scaleY ? scaleX : scaleY);
        // calculate additional translation to move the viewbox
      }
      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
      heightDiff = parsedDim.height - viewBoxHeight * scaleX;
      if (preserveAspectRatio.alignX === 'Mid') {
        widthDiff /= 2;
      }
      if (preserveAspectRatio.alignY === 'Mid') {
        heightDiff /= 2;
      }
      if (preserveAspectRatio.alignX === 'Min') {
        widthDiff = 0;
      }
      if (preserveAspectRatio.alignY === 'Min') {
        heightDiff = 0;
      }
    }

    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
      return parsedDim;
    }
    if ((x || y) && element.parentNode.nodeName !== '#document') {
      translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
    }

    matrix = translateMatrix + ' matrix(' + scaleX +
                  ' 0' +
                  ' 0 ' +
                  scaleY + ' ' +
                  (minX * scaleX + widthDiff) + ' ' +
                  (minY * scaleY + heightDiff) + ') ';
    // seems unused.
    // parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
    if (element.nodeName === 'svg') {
      el = element.ownerDocument.createElementNS(fabric.svgNS, 'g');
      // element.firstChild != null
      while (element.firstChild) {
        el.appendChild(element.firstChild);
      }
      element.appendChild(el);
    }
    else {
      el = element;
      el.removeAttribute('x');
      el.removeAttribute('y');
      matrix = el.getAttribute('transform') + matrix;
    }
    el.setAttribute('transform', matrix);
    return parsedDim;
  }

  function hasAncestorWithNodeName(element, nodeName) {
    while (element && (element = element.parentNode)) {
      if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', ''))
        && !element.getAttribute('instantiated_by_use')) {
        return true;
      }
    }
    return false;
  }

  /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {SVGDocument} doc SVG document to parse
   * @param {Function} callback Callback to call when parsing is finished;
   * It's being passed an array of elements (parsed from a document).
   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
   * @param {Object} [parsingOptions] options for parsing document
   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
   */
  fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
    if (!doc) {
      return;
    }

    parseUseDirectives(doc);

    var svgUid =  fabric.Object.__uid++, i, len,
        options = applyViewboxTransform(doc),
        descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
    options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
    options.svgUid = svgUid;

    if (descendants.length === 0 && fabric.isLikelyNode) {
      // we're likely in node, where "o3-xml" library fails to gEBTN("*")
      // https://github.com/ajaxorg/node-o3-xml/issues/21
      descendants = doc.selectNodes('//*[name(.)!="svg"]');
      var arr = [];
      for (i = 0, len = descendants.length; i < len; i++) {
        arr[i] = descendants[i];
      }
      descendants = arr;
    }

    var elements = descendants.filter(function(el) {
      applyViewboxTransform(el);
      return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) &&
            !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });
    if (!elements || (elements && !elements.length)) {
      callback && callback([], {});
      return;
    }
    var clipPaths = { };
    descendants.filter(function(el) {
      return el.nodeName.replace('svg:', '') === 'clipPath';
    }).forEach(function(el) {
      var id = el.getAttribute('id');
      clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function(el) {
        return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
      });
    });
    fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
    fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
    fabric.clipPaths[svgUid] = clipPaths;
    // Precedence of rules:   style > class > attribute
    fabric.parseElements(elements, function(instances, elements) {
      if (callback) {
        callback(instances, options, elements, descendants);
        delete fabric.gradientDefs[svgUid];
        delete fabric.cssRules[svgUid];
        delete fabric.clipPaths[svgUid];
      }
    }, clone(options), reviver, parsingOptions);
  };

  function recursivelyParseGradientsXlink(doc, gradient) {
    var gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'],
        xlinkAttr = 'xlink:href',
        xLink = gradient.getAttribute(xlinkAttr).substr(1),
        referencedGradient = elementById(doc, xLink);
    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
      recursivelyParseGradientsXlink(doc, referencedGradient);
    }
    gradientsAttrs.forEach(function(attr) {
      if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) {
        gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
      }
    });
    if (!gradient.children.length) {
      var referenceClone = referencedGradient.cloneNode(true);
      while (referenceClone.firstChild) {
        gradient.appendChild(referenceClone.firstChild);
      }
    }
    gradient.removeAttribute(xlinkAttr);
  }

  var reFontDeclaration = new RegExp(
    '(normal|italic)?\\s*(normal|small-caps)?\\s*' +
    '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' +
      fabric.reNum +
    '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');

  extend(fabric, {
    /**
     * Parses a short font declaration, building adding its properties to a style object
     * @static
     * @function
     * @memberOf fabric
     * @param {String} value font declaration
     * @param {Object} oStyle definition
     */
    parseFontDeclaration: function(value, oStyle) {
      var match = value.match(reFontDeclaration);

      if (!match) {
        return;
      }
      var fontStyle = match[1],
          // font variant is not used
          // fontVariant = match[2],
          fontWeight = match[3],
          fontSize = match[4],
          lineHeight = match[5],
          fontFamily = match[6];

      if (fontStyle) {
        oStyle.fontStyle = fontStyle;
      }
      if (fontWeight) {
        oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
      }
      if (fontSize) {
        oStyle.fontSize = parseUnit(fontSize);
      }
      if (fontFamily) {
        oStyle.fontFamily = fontFamily;
      }
      if (lineHeight) {
        oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
      }
    },

    /**
     * Parses an SVG document, returning all of the gradient declarations found in it
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
     */
    getGradientDefs: function(doc) {
      var tagArray = [
            'linearGradient',
            'radialGradient',
            'svg:linearGradient',
            'svg:radialGradient'],
          elList = _getMultipleNodes(doc, tagArray),
          el, j = 0, gradientDefs = { };
      j = elList.length;
      while (j--) {
        el = elList[j];
        if (el.getAttribute('xlink:href')) {
          recursivelyParseGradientsXlink(doc, el);
        }
        gradientDefs[el.getAttribute('id')] = el;
      }
      return gradientDefs;
    },

    /**
     * Returns an object of attributes' name/value, given element and an array of attribute names;
     * Parses parent "g" nodes recursively upwards.
     * @static
     * @memberOf fabric
     * @param {DOMElement} element Element to parse
     * @param {Array} attributes Array of attributes to parse
     * @return {Object} object containing parsed attributes' names/values
     */
    parseAttributes: function(element, attributes, svgUid) {

      if (!element) {
        return;
      }

      var value,
          parentAttributes = { },
          fontSize, parentFontSize;

      if (typeof svgUid === 'undefined') {
        svgUid = element.getAttribute('svgUid');
      }
      // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
      if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
      }

      var ownAttributes = attributes.reduce(function(memo, attr) {
        value = element.getAttribute(attr);
        if (value) { // eslint-disable-line
          memo[attr] = value;
        }
        return memo;
      }, { });
      // add values parsed from style, which take precedence over attributes
      // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
      var cssAttrs = extend(
        getGlobalStylesForElement(element, svgUid),
        fabric.parseStyleAttribute(element)
      );
      ownAttributes = extend(
        ownAttributes,
        cssAttrs
      );
      if (cssAttrs[cPath]) {
        element.setAttribute(cPath, cssAttrs[cPath]);
      }
      fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
      if (ownAttributes[fSize]) {
        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
        ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
      }

      var normalizedAttr, normalizedValue, normalizedStyle = {};
      for (var attr in ownAttributes) {
        normalizedAttr = normalizeAttr(attr);
        normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
        normalizedStyle[normalizedAttr] = normalizedValue;
      }
      if (normalizedStyle && normalizedStyle.font) {
        fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
      }
      var mergedAttrs = extend(parentAttributes, normalizedStyle);
      return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
    },

    /**
     * Transforms an array of svg elements to corresponding fabric.* instances
     * @static
     * @memberOf fabric
     * @param {Array} elements Array of elements to parse
     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
     * @param {Object} [options] Options object
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     */
    parseElements: function(elements, callback, options, reviver, parsingOptions) {
      new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
    },

    /**
     * Parses "style" attribute, retuning an object with values
     * @static
     * @memberOf fabric
     * @param {SVGElement} element Element to parse
     * @return {Object} Objects with values parsed from style attribute of an element
     */
    parseStyleAttribute: function(element) {
      var oStyle = { },
          style = element.getAttribute('style');

      if (!style) {
        return oStyle;
      }

      if (typeof style === 'string') {
        parseStyleString(style, oStyle);
      }
      else {
        parseStyleObject(style, oStyle);
      }

      return oStyle;
    },

    /**
     * Parses "points" attribute, returning an array of values
     * @static
     * @memberOf fabric
     * @param {String} points points attribute string
     * @return {Array} array of points
     */
    parsePointsAttribute: function(points) {

      // points attribute is required and must not be empty
      if (!points) {
        return null;
      }

      // replace commas with whitespace and remove bookending whitespace
      points = points.replace(/,/g, ' ').trim();

      points = points.split(/\s+/);
      var parsedPoints = [], i, len;

      for (i = 0, len = points.length; i < len; i += 2) {
        parsedPoints.push({
          x: parseFloat(points[i]),
          y: parseFloat(points[i + 1])
        });
      }

      // odd number of points is an error
      // if (parsedPoints.length % 2 !== 0) {
      //   return null;
      // }

      return parsedPoints;
    },

    /**
     * Returns CSS rules for a given SVG document
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} CSS rules of this document
     */
    getCSSRules: function(doc) {
      var styles = doc.getElementsByTagName('style'), i, len,
          allRules = { }, rules;

      // very crude parsing of style contents
      for (i = 0, len = styles.length; i < len; i++) {
        // <style/> could produce `undefined`, covering this case with ''
        var styleContents = styles[i].textContent || '';

        // remove comments
        styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');
        if (styleContents.trim() === '') {
          continue;
        }
        rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
        rules = rules.map(function(rule) { return rule.trim(); });
        // eslint-disable-next-line no-loop-func
        rules.forEach(function(rule) {

          var match = rule.match(/([\s\S]*?)\s*\{([^}]*)\}/),
              ruleObj = { }, declaration = match[2].trim(),
              propertyValuePairs = declaration.replace(/;$/, '').split(/\s*;\s*/);

          for (i = 0, len = propertyValuePairs.length; i < len; i++) {
            var pair = propertyValuePairs[i].split(/\s*:\s*/),
                property = pair[0],
                value = pair[1];
            ruleObj[property] = value;
          }
          rule = match[1];
          rule.split(',').forEach(function(_rule) {
            _rule = _rule.replace(/^svg/i, '').trim();
            if (_rule === '') {
              return;
            }
            if (allRules[_rule]) {
              fabric.util.object.extend(allRules[_rule], ruleObj);
            }
            else {
              allRules[_rule] = fabric.util.object.clone(ruleObj);
            }
          });
        });
      }
      return allRules;
    },

    /**
     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
     * @memberOf fabric
     * @param {String} url
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromURL: function(url, callback, reviver, options) {

      url = url.replace(/^\n\s*/, '').trim();
      new fabric.util.request(url, {
        method: 'get',
        onComplete: onComplete
      });

      function onComplete(r) {

        var xml = r.responseXML;
        if (!xml || !xml.documentElement) {
          callback && callback(null);
          return false;
        }

        fabric.parseSVGDocument(xml.documentElement, function (results, _options, elements, allElements) {
          callback && callback(results, _options, elements, allElements);
        }, reviver, options);
      }
    },

    /**
     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
     * @memberOf fabric
     * @param {String} string
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */
    loadSVGFromString: function(string, callback, reviver, options) {
      var parser = new fabric.window.DOMParser(),
          doc = parser.parseFromString(string.trim(), 'text/xml');
      fabric.parseSVGDocument(doc.documentElement, function (results, _options, elements, allElements) {
        callback(results, _options, elements, allElements);
      }, reviver, options);
    }
  });

})( true ? exports : this);


fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
  this.elements = elements;
  this.callback = callback;
  this.options = options;
  this.reviver = reviver;
  this.svgUid = (options && options.svgUid) || 0;
  this.parsingOptions = parsingOptions;
  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
  this.doc = doc;
};

(function(proto) {
  proto.parse = function() {
    this.instances = new Array(this.elements.length);
    this.numElements = this.elements.length;
    this.createObjects();
  };

  proto.createObjects = function() {
    var _this = this;
    this.elements.forEach(function(element, i) {
      element.setAttribute('svgUid', _this.svgUid);
      _this.createObject(element, i);
    });
  };

  proto.findTag = function(el) {
    return fabric[fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
  };

  proto.createObject = function(el, index) {
    var klass = this.findTag(el);
    if (klass && klass.fromElement) {
      try {
        klass.fromElement(el, this.createCallback(index, el), this.options);
      }
      catch (err) {
        fabric.log(err);
      }
    }
    else {
      this.checkIfDone();
    }
  };

  proto.createCallback = function(index, el) {
    var _this = this;
    return function(obj) {
      var _options;
      _this.resolveGradient(obj, el, 'fill');
      _this.resolveGradient(obj, el, 'stroke');
      if (obj instanceof fabric.Image && obj._originalElement) {
        _options = obj.parsePreserveAspectRatioAttribute(el);
      }
      obj._removeTransformMatrix(_options);
      _this.resolveClipPath(obj, el);
      _this.reviver && _this.reviver(el, obj);
      _this.instances[index] = obj;
      _this.checkIfDone();
    };
  };

  proto.extractPropertyDefinition = function(obj, property, storage) {
    var value = obj[property], regex = this.regexUrl;
    if (!regex.test(value)) {
      return;
    }
    regex.lastIndex = 0;
    var id = regex.exec(value)[1];
    regex.lastIndex = 0;
    return fabric[storage][this.svgUid][id];
  };

  proto.resolveGradient = function(obj, el, property) {
    var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');
    if (gradientDef) {
      var opacityAttr = el.getAttribute(property + '-opacity');
      var gradient = fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
      obj.set(property, gradient);
    }
  };

  proto.createClipPathCallback = function(obj, container) {
    return function(_newObj) {
      _newObj._removeTransformMatrix();
      _newObj.fillRule = _newObj.clipRule;
      container.push(_newObj);
    };
  };

  proto.resolveClipPath = function(obj, usingElement) {
    var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'),
        element, klass, objTransformInv, container, gTransform, options;
    if (clipPath) {
      container = [];
      objTransformInv = fabric.util.invertTransform(obj.calcTransformMatrix());
      // move the clipPath tag as sibling to the real element that is using it
      var clipPathTag = clipPath[0].parentNode;
      var clipPathOwner = usingElement;
      while (clipPathOwner.parentNode && clipPathOwner.getAttribute('clip-path') !== obj.clipPath) {
        clipPathOwner = clipPathOwner.parentNode;
      }
      clipPathOwner.parentNode.appendChild(clipPathTag);
      for (var i = 0; i < clipPath.length; i++) {
        element = clipPath[i];
        klass = this.findTag(element);
        klass.fromElement(
          element,
          this.createClipPathCallback(obj, container),
          this.options
        );
      }
      if (container.length === 1) {
        clipPath = container[0];
      }
      else {
        clipPath = new fabric.Group(container);
      }
      gTransform = fabric.util.multiplyTransformMatrices(
        objTransformInv,
        clipPath.calcTransformMatrix()
      );
      if (clipPath.clipPath) {
        this.resolveClipPath(clipPath, clipPathOwner);
      }
      var options = fabric.util.qrDecompose(gTransform);
      clipPath.flipX = false;
      clipPath.flipY = false;
      clipPath.set('scaleX', options.scaleX);
      clipPath.set('scaleY', options.scaleY);
      clipPath.angle = options.angle;
      clipPath.skewX = options.skewX;
      clipPath.skewY = 0;
      clipPath.setPositionByOrigin({ x: options.translateX, y: options.translateY }, 'center', 'center');
      obj.clipPath = clipPath;
    }
    else {
      // if clip-path does not resolve to any element, delete the property.
      delete obj.clipPath;
    }
  };

  proto.checkIfDone = function() {
    if (--this.numElements === 0) {
      this.instances = this.instances.filter(function(el) {
        // eslint-disable-next-line no-eq-null, eqeqeq
        return el != null;
      });
      this.callback(this.instances, this.elements);
    }
  };
})(fabric.ElementsParser.prototype);


(function(global) {

  'use strict';

  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Point) {
    fabric.warn('fabric.Point is already defined');
    return;
  }

  fabric.Point = Point;

  /**
   * Point class
   * @class fabric.Point
   * @memberOf fabric
   * @constructor
   * @param {Number} x
   * @param {Number} y
   * @return {fabric.Point} thisArg
   */
  function Point(x, y) {
    this.x = x;
    this.y = y;
  }

  Point.prototype = /** @lends fabric.Point.prototype */ {

    type: 'point',

    constructor: Point,

    /**
     * Adds another point to this one and returns another one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point instance with added values
     */
    add: function (that) {
      return new Point(this.x + that.x, this.y + that.y);
    },

    /**
     * Adds another point to this one
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    addEquals: function (that) {
      this.x += that.x;
      this.y += that.y;
      return this;
    },

    /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point} new Point with added value
     */
    scalarAdd: function (scalar) {
      return new Point(this.x + scalar, this.y + scalar);
    },

    /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarAddEquals: function (scalar) {
      this.x += scalar;
      this.y += scalar;
      return this;
    },

    /**
     * Subtracts another point from this point and returns a new one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point object with subtracted values
     */
    subtract: function (that) {
      return new Point(this.x - that.x, this.y - that.y);
    },

    /**
     * Subtracts another point from this point
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */
    subtractEquals: function (that) {
      this.x -= that.x;
      this.y -= that.y;
      return this;
    },

    /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    scalarSubtract: function (scalar) {
      return new Point(this.x - scalar, this.y - scalar);
    },

    /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    scalarSubtractEquals: function (scalar) {
      this.x -= scalar;
      this.y -= scalar;
      return this;
    },

    /**
     * Multiplies this point by a value and returns a new one
     * TODO: rename in scalarMultiply in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    multiply: function (scalar) {
      return new Point(this.x * scalar, this.y * scalar);
    },

    /**
     * Multiplies this point by a value
     * TODO: rename in scalarMultiplyEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    multiplyEquals: function (scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    },

    /**
     * Divides this point by a value and returns a new one
     * TODO: rename in scalarDivide in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */
    divide: function (scalar) {
      return new Point(this.x / scalar, this.y / scalar);
    },

    /**
     * Divides this point by a value
     * TODO: rename in scalarDivideEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */
    divideEquals: function (scalar) {
      this.x /= scalar;
      this.y /= scalar;
      return this;
    },

    /**
     * Returns true if this point is equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    eq: function (that) {
      return (this.x === that.x && this.y === that.y);
    },

    /**
     * Returns true if this point is less than another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lt: function (that) {
      return (this.x < that.x && this.y < that.y);
    },

    /**
     * Returns true if this point is less than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    lte: function (that) {
      return (this.x <= that.x && this.y <= that.y);
    },

    /**

     * Returns true if this point is greater another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gt: function (that) {
      return (this.x > that.x && this.y > that.y);
    },

    /**
     * Returns true if this point is greater than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */
    gte: function (that) {
      return (this.x >= that.x && this.y >= that.y);
    },

    /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {fabric.Point} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {fabric.Point}
     */
    lerp: function (that, t) {
      if (typeof t === 'undefined') {
        t = 0.5;
      }
      t = Math.max(Math.min(1, t), 0);
      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    },

    /**
     * Returns distance from this point and another one
     * @param {fabric.Point} that
     * @return {Number}
     */
    distanceFrom: function (that) {
      var dx = this.x - that.x,
          dy = this.y - that.y;
      return Math.sqrt(dx * dx + dy * dy);
    },

    /**
     * Returns the point between this point and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    midPointFrom: function (that) {
      return this.lerp(that);
    },

    /**
     * Returns a new point which is the min of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    min: function (that) {
      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
    },

    /**
     * Returns a new point which is the max of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */
    max: function (that) {
      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
    },

    /**
     * Returns string representation of this point
     * @return {String}
     */
    toString: function () {
      return this.x + ',' + this.y;
    },

    /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */
    setXY: function (x, y) {
      this.x = x;
      this.y = y;
      return this;
    },

    /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */
    setX: function (x) {
      this.x = x;
      return this;
    },

    /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */
    setY: function (y) {
      this.y = y;
      return this;
    },

    /**
     * Sets x/y of this point from another point
     * @param {fabric.Point} that
     * @chainable
     */
    setFromPoint: function (that) {
      this.x = that.x;
      this.y = that.y;
      return this;
    },

    /**
     * Swaps x/y of this point and another point
     * @param {fabric.Point} that
     */
    swap: function (that) {
      var x = this.x,
          y = this.y;
      this.x = that.x;
      this.y = that.y;
      that.x = x;
      that.y = y;
    },

    /**
     * return a cloned instance of the point
     * @return {fabric.Point}
     */
    clone: function () {
      return new Point(this.x, this.y);
    }
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */
  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Intersection) {
    fabric.warn('fabric.Intersection is already defined');
    return;
  }

  /**
   * Intersection class
   * @class fabric.Intersection
   * @memberOf fabric
   * @constructor
   */
  function Intersection(status) {
    this.status = status;
    this.points = [];
  }

  fabric.Intersection = Intersection;

  fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {

    constructor: Intersection,

    /**
     * Appends a point to intersection
     * @param {fabric.Point} point
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoint: function (point) {
      this.points.push(point);
      return this;
    },

    /**
     * Appends points to intersection
     * @param {Array} points
     * @return {fabric.Intersection} thisArg
     * @chainable
     */
    appendPoints: function (points) {
      this.points = this.points.concat(points);
      return this;
    }
  };

  /**
   * Checks if one line intersects another
   * TODO: rename in intersectSegmentSegment
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {fabric.Point} b1
   * @param {fabric.Point} b2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectLineLine = function (a1, a2, b1, b2) {
    var result,
        uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
        ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
        uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
    if (uB !== 0) {
      var ua = uaT / uB,
          ub = ubT / uB;
      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
        result = new Intersection('Intersection');
        result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
      }
      else {
        result = new Intersection();
      }
    }
    else {
      if (uaT === 0 || ubT === 0) {
        result = new Intersection('Coincident');
      }
      else {
        result = new Intersection('Parallel');
      }
    }
    return result;
  };

  /**
   * Checks if line intersects polygon
   * TODO: rename in intersectSegmentPolygon
   * fix detection of coincident
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {Array} points
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
    var result = new Intersection(),
        length = points.length,
        b1, b2, inter, i;

    for (i = 0; i < length; i++) {
      b1 = points[i];
      b2 = points[(i + 1) % length];
      inter = Intersection.intersectLineLine(a1, a2, b1, b2);

      result.appendPoints(inter.points);
    }
    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

  /**
   * Checks if polygon intersects another polygon
   * @static
   * @param {Array} points1
   * @param {Array} points2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectPolygonPolygon = function (points1, points2) {
    var result = new Intersection(),
        length = points1.length, i;

    for (i = 0; i < length; i++) {
      var a1 = points1[i],
          a2 = points1[(i + 1) % length],
          inter = Intersection.intersectLinePolygon(a1, a2, points2);

      result.appendPoints(inter.points);
    }
    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

  /**
   * Checks if polygon intersects rectangle
   * @static
   * @param {Array} points
   * @param {fabric.Point} r1
   * @param {fabric.Point} r2
   * @return {fabric.Intersection}
   */
  fabric.Intersection.intersectPolygonRectangle = function (points, r1, r2) {
    var min = r1.min(r2),
        max = r1.max(r2),
        topRight = new fabric.Point(max.x, min.y),
        bottomLeft = new fabric.Point(min.x, max.y),
        inter1 = Intersection.intersectLinePolygon(min, topRight, points),
        inter2 = Intersection.intersectLinePolygon(topRight, max, points),
        inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points),
        inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points),
        result = new Intersection();

    result.appendPoints(inter1.points);
    result.appendPoints(inter2.points);
    result.appendPoints(inter3.points);
    result.appendPoints(inter4.points);

    if (result.points.length > 0) {
      result.status = 'Intersection';
    }
    return result;
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Color) {
    fabric.warn('fabric.Color is already defined.');
    return;
  }

  /**
   * Color class
   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
   *
   * @class fabric.Color
   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
   * @return {fabric.Color} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
   */
  function Color(color) {
    if (!color) {
      this.setSource([0, 0, 0, 1]);
    }
    else {
      this._tryParsingColor(color);
    }
  }

  fabric.Color = Color;

  fabric.Color.prototype = /** @lends fabric.Color.prototype */ {

    /**
     * @private
     * @param {String|Array} color Color value to parse
     */
    _tryParsingColor: function(color) {
      var source;

      if (color in Color.colorNameMap) {
        color = Color.colorNameMap[color];
      }

      if (color === 'transparent') {
        source = [255, 255, 255, 0];
      }

      if (!source) {
        source = Color.sourceFromHex(color);
      }
      if (!source) {
        source = Color.sourceFromRgb(color);
      }
      if (!source) {
        source = Color.sourceFromHsl(color);
      }
      if (!source) {
        //if color is not recognize let's make black as canvas does
        source = [0, 0, 0, 1];
      }
      if (source) {
        this.setSource(source);
      }
    },

    /**
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @private
     * @param {Number} r Red color value
     * @param {Number} g Green color value
     * @param {Number} b Blue color value
     * @return {Array} Hsl color
     */
    _rgbToHsl: function(r, g, b) {
      r /= 255; g /= 255; b /= 255;

      var h, s, l,
          max = fabric.util.array.max([r, g, b]),
          min = fabric.util.array.min([r, g, b]);

      l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      }
      else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }

      return [
        Math.round(h * 360),
        Math.round(s * 100),
        Math.round(l * 100)
      ];
    },

    /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {Array}
     */
    getSource: function() {
      return this._source;
    },

    /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {Array} source
     */
    setSource: function(source) {
      this._source = source;
    },

    /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */
    toRgb: function() {
      var source = this.getSource();
      return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
    },

    /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */
    toRgba: function() {
      var source = this.getSource();
      return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
    },

    /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */
    toHsl: function() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
    },

    /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */
    toHsla: function() {
      var source = this.getSource(),
          hsl = this._rgbToHsl(source[0], source[1], source[2]);

      return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
    },

    /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */
    toHex: function() {
      var source = this.getSource(), r, g, b;

      r = source[0].toString(16);
      r = (r.length === 1) ? ('0' + r) : r;

      g = source[1].toString(16);
      g = (g.length === 1) ? ('0' + g) : g;

      b = source[2].toString(16);
      b = (b.length === 1) ? ('0' + b) : b;

      return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
    },

    /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */
    toHexa: function() {
      var source = this.getSource(), a;

      a = Math.round(source[3] * 255);
      a = a.toString(16);
      a = (a.length === 1) ? ('0' + a) : a;

      return this.toHex() + a.toUpperCase();
    },

    /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */
    getAlpha: function() {
      return this.getSource()[3];
    },

    /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {fabric.Color} thisArg
     */
    setAlpha: function(alpha) {
      var source = this.getSource();
      source[3] = alpha;
      this.setSource(source);
      return this;
    },

    /**
     * Transforms color to its grayscale representation
     * @return {fabric.Color} thisArg
     */
    toGrayscale: function() {
      var source = this.getSource(),
          average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10),
          currentAlpha = source[3];
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {fabric.Color} thisArg
     */
    toBlackWhite: function(threshold) {
      var source = this.getSource(),
          average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0),
          currentAlpha = source[3];

      threshold = threshold || 127;

      average = (Number(average) < Number(threshold)) ? 0 : 255;
      this.setSource([average, average, average, currentAlpha]);
      return this;
    },

    /**
     * Overlays color with another color
     * @param {String|fabric.Color} otherColor
     * @return {fabric.Color} thisArg
     */
    overlayWith: function(otherColor) {
      if (!(otherColor instanceof Color)) {
        otherColor = new Color(otherColor);
      }

      var result = [],
          alpha = this.getAlpha(),
          otherAlpha = 0.5,
          source = this.getSource(),
          otherSource = otherColor.getSource(), i;

      for (i = 0; i < 3; i++) {
        result.push(Math.round((source[i] * (1 - otherAlpha)) + (otherSource[i] * otherAlpha)));
      }

      result[3] = alpha;
      this.setSource(result);
      return this;
    }
  };

  /**
   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * @static
   * @field
   * @memberOf fabric.Color
   */
  // eslint-disable-next-line max-len
  fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;

  /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
   * @static
   * @field
   * @memberOf fabric.Color
   */
  fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;

  /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   * @static
   * @field
   * @memberOf fabric.Color
   */
  fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;

  /**
   * Map of the 148 color names with HEX code
   * @static
   * @field
   * @memberOf fabric.Color
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */
  fabric.Color.colorNameMap = {
    aliceblue:            '#F0F8FF',
    antiquewhite:         '#FAEBD7',
    aqua:                 '#00FFFF',
    aquamarine:           '#7FFFD4',
    azure:                '#F0FFFF',
    beige:                '#F5F5DC',
    bisque:               '#FFE4C4',
    black:                '#000000',
    blanchedalmond:       '#FFEBCD',
    blue:                 '#0000FF',
    blueviolet:           '#8A2BE2',
    brown:                '#A52A2A',
    burlywood:            '#DEB887',
    cadetblue:            '#5F9EA0',
    chartreuse:           '#7FFF00',
    chocolate:            '#D2691E',
    coral:                '#FF7F50',
    cornflowerblue:       '#6495ED',
    cornsilk:             '#FFF8DC',
    crimson:              '#DC143C',
    cyan:                 '#00FFFF',
    darkblue:             '#00008B',
    darkcyan:             '#008B8B',
    darkgoldenrod:        '#B8860B',
    darkgray:             '#A9A9A9',
    darkgrey:             '#A9A9A9',
    darkgreen:            '#006400',
    darkkhaki:            '#BDB76B',
    darkmagenta:          '#8B008B',
    darkolivegreen:       '#556B2F',
    darkorange:           '#FF8C00',
    darkorchid:           '#9932CC',
    darkred:              '#8B0000',
    darksalmon:           '#E9967A',
    darkseagreen:         '#8FBC8F',
    darkslateblue:        '#483D8B',
    darkslategray:        '#2F4F4F',
    darkslategrey:        '#2F4F4F',
    darkturquoise:        '#00CED1',
    darkviolet:           '#9400D3',
    deeppink:             '#FF1493',
    deepskyblue:          '#00BFFF',
    dimgray:              '#696969',
    dimgrey:              '#696969',
    dodgerblue:           '#1E90FF',
    firebrick:            '#B22222',
    floralwhite:          '#FFFAF0',
    forestgreen:          '#228B22',
    fuchsia:              '#FF00FF',
    gainsboro:            '#DCDCDC',
    ghostwhite:           '#F8F8FF',
    gold:                 '#FFD700',
    goldenrod:            '#DAA520',
    gray:                 '#808080',
    grey:                 '#808080',
    green:                '#008000',
    greenyellow:          '#ADFF2F',
    honeydew:             '#F0FFF0',
    hotpink:              '#FF69B4',
    indianred:            '#CD5C5C',
    indigo:               '#4B0082',
    ivory:                '#FFFFF0',
    khaki:                '#F0E68C',
    lavender:             '#E6E6FA',
    lavenderblush:        '#FFF0F5',
    lawngreen:            '#7CFC00',
    lemonchiffon:         '#FFFACD',
    lightblue:            '#ADD8E6',
    lightcoral:           '#F08080',
    lightcyan:            '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray:            '#D3D3D3',
    lightgrey:            '#D3D3D3',
    lightgreen:           '#90EE90',
    lightpink:            '#FFB6C1',
    lightsalmon:          '#FFA07A',
    lightseagreen:        '#20B2AA',
    lightskyblue:         '#87CEFA',
    lightslategray:       '#778899',
    lightslategrey:       '#778899',
    lightsteelblue:       '#B0C4DE',
    lightyellow:          '#FFFFE0',
    lime:                 '#00FF00',
    limegreen:            '#32CD32',
    linen:                '#FAF0E6',
    magenta:              '#FF00FF',
    maroon:               '#800000',
    mediumaquamarine:     '#66CDAA',
    mediumblue:           '#0000CD',
    mediumorchid:         '#BA55D3',
    mediumpurple:         '#9370DB',
    mediumseagreen:       '#3CB371',
    mediumslateblue:      '#7B68EE',
    mediumspringgreen:    '#00FA9A',
    mediumturquoise:      '#48D1CC',
    mediumvioletred:      '#C71585',
    midnightblue:         '#191970',
    mintcream:            '#F5FFFA',
    mistyrose:            '#FFE4E1',
    moccasin:             '#FFE4B5',
    navajowhite:          '#FFDEAD',
    navy:                 '#000080',
    oldlace:              '#FDF5E6',
    olive:                '#808000',
    olivedrab:            '#6B8E23',
    orange:               '#FFA500',
    orangered:            '#FF4500',
    orchid:               '#DA70D6',
    palegoldenrod:        '#EEE8AA',
    palegreen:            '#98FB98',
    paleturquoise:        '#AFEEEE',
    palevioletred:        '#DB7093',
    papayawhip:           '#FFEFD5',
    peachpuff:            '#FFDAB9',
    peru:                 '#CD853F',
    pink:                 '#FFC0CB',
    plum:                 '#DDA0DD',
    powderblue:           '#B0E0E6',
    purple:               '#800080',
    rebeccapurple:        '#663399',
    red:                  '#FF0000',
    rosybrown:            '#BC8F8F',
    royalblue:            '#4169E1',
    saddlebrown:          '#8B4513',
    salmon:               '#FA8072',
    sandybrown:           '#F4A460',
    seagreen:             '#2E8B57',
    seashell:             '#FFF5EE',
    sienna:               '#A0522D',
    silver:               '#C0C0C0',
    skyblue:              '#87CEEB',
    slateblue:            '#6A5ACD',
    slategray:            '#708090',
    slategrey:            '#708090',
    snow:                 '#FFFAFA',
    springgreen:          '#00FF7F',
    steelblue:            '#4682B4',
    tan:                  '#D2B48C',
    teal:                 '#008080',
    thistle:              '#D8BFD8',
    tomato:               '#FF6347',
    turquoise:            '#40E0D0',
    violet:               '#EE82EE',
    wheat:                '#F5DEB3',
    white:                '#FFFFFF',
    whitesmoke:           '#F5F5F5',
    yellow:               '#FFFF00',
    yellowgreen:          '#9ACD32'
  };

  /**
   * @private
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */
  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }

  /**
   * Returns new color object, when given a color in RGB format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {fabric.Color}
   */
  fabric.Color.fromRgb = function(color) {
    return Color.fromSource(Color.sourceFromRgb(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {Array} source
   */
  fabric.Color.sourceFromRgb = function(color) {
    var match = color.match(Color.reRGBa);
    if (match) {
      var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1),
          g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1),
          b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);

      return [
        parseInt(r, 10),
        parseInt(g, 10),
        parseInt(b, 10),
        match[4] ? parseFloat(match[4]) : 1
      ];
    }
  };

  /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */
  fabric.Color.fromRgba = Color.fromRgb;

  /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf fabric.Color
   * @return {fabric.Color}
   */
  fabric.Color.fromHsl = function(color) {
    return Color.fromSource(Color.sourceFromHsl(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf fabric.Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {Array} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */
  fabric.Color.sourceFromHsl = function(color) {
    var match = color.match(Color.reHSLa);
    if (!match) {
      return;
    }

    var h = (((parseFloat(match[1]) % 360) + 360) % 360) / 360,
        s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1),
        l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1),
        r, g, b;

    if (s === 0) {
      r = g = b = l;
    }
    else {
      var q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
          p = l * 2 - q;

      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return [
      Math.round(r * 255),
      Math.round(g * 255),
      Math.round(b * 255),
      match[4] ? parseFloat(match[4]) : 1
    ];
  };

  /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */
  fabric.Color.fromHsla = Color.fromHsl;

  /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color Color value ex: FF5555
   * @return {fabric.Color}
   */
  fabric.Color.fromHex = function(color) {
    return Color.fromSource(Color.sourceFromHex(color));
  };

  /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {Array} source
   */
  fabric.Color.sourceFromHex = function(color) {
    if (color.match(Color.reHex)) {
      var value = color.slice(color.indexOf('#') + 1),
          isShortNotation = (value.length === 3 || value.length === 4),
          isRGBa = (value.length === 8 || value.length === 4),
          r = isShortNotation ? (value.charAt(0) + value.charAt(0)) : value.substring(0, 2),
          g = isShortNotation ? (value.charAt(1) + value.charAt(1)) : value.substring(2, 4),
          b = isShortNotation ? (value.charAt(2) + value.charAt(2)) : value.substring(4, 6),
          a = isRGBa ? (isShortNotation ? (value.charAt(3) + value.charAt(3)) : value.substring(6, 8)) : 'FF';

      return [
        parseInt(r, 16),
        parseInt(g, 16),
        parseInt(b, 16),
        parseFloat((parseInt(a, 16) / 255).toFixed(2))
      ];
    }
  };

  /**
   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
   * @static
   * @memberOf fabric.Color
   * @param {Array} source
   * @return {fabric.Color}
   */
  fabric.Color.fromSource = function(source) {
    var oColor = new Color();
    oColor.setSource(source);
    return oColor;
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      scaleMap = ['e', 'se', 's', 'sw', 'w', 'nw', 'n', 'ne', 'e'],
      skewMap = ['ns', 'nesw', 'ew', 'nwse'],
      controls = {},
      LEFT = 'left', TOP = 'top', RIGHT = 'right', BOTTOM = 'bottom', CENTER = 'center',
      opposite = {
        top: BOTTOM,
        bottom: TOP,
        left: RIGHT,
        right: LEFT,
        center: CENTER,
      }, radiansToDegrees = fabric.util.radiansToDegrees,
      sign = (Math.sign || function(x) { return ((x > 0) - (x < 0)) || +x; });

  /**
   * Combine control position and object angle to find the control direction compared
   * to the object center.
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   * @param {fabric.Control} control the control class
   * @return {Number} 0 - 7 a quadrant number
   */
  function findCornerQuadrant(fabricObject, control) {
    var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
    return Math.round((cornerAngle % 360) / 45);
  }

  function fireEvent(eventName, options) {
    var target = options.transform.target,
        canvas = target.canvas,
        canvasOptions = fabric.util.object.clone(options);
    canvasOptions.target = target;
    canvas && canvas.fire('object:' + eventName, canvasOptions);
    target.fire(eventName, options);
  }

  /**
   * Inspect event and fabricObject properties to understand if the scaling action
   * @param {Event} eventData from the user action
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @return {Boolean} true if scale is proportional
   */
  function scaleIsProportional(eventData, fabricObject) {
    var canvas = fabricObject.canvas, uniScaleKey = canvas.uniScaleKey,
        uniformIsToggled = eventData[uniScaleKey];
    return (canvas.uniformScaling && !uniformIsToggled) ||
    (!canvas.uniformScaling && uniformIsToggled);
  }

  /**
   * Checks if transform is centered
   * @param {Object} transform transform data
   * @return {Boolean} true if transform is centered
   */
  function isTransformCentered(transform) {
    return transform.originX === CENTER && transform.originY === CENTER;
  }

  /**
   * Inspect fabricObject to understand if the current scaling action is allowed
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @param {String} by 'x' or 'y' or ''
   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
   * @return {Boolean} true if scaling is not allowed at current conditions
   */
  function scalingIsForbidden(fabricObject, by, scaleProportionally) {
    var lockX = fabricObject.lockScalingX, lockY = fabricObject.lockScalingY;
    if (lockX && lockY) {
      return true;
    }
    if (!by && (lockX || lockY) && scaleProportionally) {
      return true;
    }
    if (lockX && by === 'x') {
      return true;
    }
    if (lockY && by === 'y') {
      return true;
    }
    return false;
  }

  /**
   * return the correct cursor style for the scale action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  function scaleCursorStyleHandler(eventData, control, fabricObject) {
    var notAllowed = 'not-allowed',
        scaleProportionally = scaleIsProportional(eventData, fabricObject),
        by = '';
    if (control.x !== 0 && control.y === 0) {
      by = 'x';
    }
    else if (control.x === 0 && control.y !== 0) {
      by = 'y';
    }
    if (scalingIsForbidden(fabricObject, by, scaleProportionally)) {
      return notAllowed;
    }
    var n = findCornerQuadrant(fabricObject, control);
    return scaleMap[n] + '-resize';
  }

  /**
   * return the correct cursor style for the skew action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  function skewCursorStyleHandler(eventData, control, fabricObject) {
    var notAllowed = 'not-allowed';
    if (control.x !== 0 && fabricObject.lockSkewingY) {
      return notAllowed;
    }
    if (control.y !== 0 && fabricObject.lockSkewingX) {
      return notAllowed;
    }
    var n = findCornerQuadrant(fabricObject, control) % 4;
    return skewMap[n] + '-resize';
  }

  /**
   * Combine skew and scale style handlers to cover fabric standard use case
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
    if (eventData[fabricObject.canvas.altActionKey]) {
      return controls.skewCursorStyleHandler(eventData, control, fabricObject);
    }
    return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
  }

  /**
   * Inspect event, control and fabricObject to return the correct action name
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} an action name
   */
  function scaleOrSkewActionName(eventData, control, fabricObject) {
    var isAlternative = eventData[fabricObject.canvas.altActionKey];
    if (control.x === 0) {
      // then is scaleY or skewX
      return isAlternative ? 'skewX' : 'scaleY';
    }
    if (control.y === 0) {
      // then is scaleY or skewX
      return isAlternative ? 'skewY' : 'scaleX';
    }
  }

  /**
   * Find the correct style for the control that is used for rotation.
   * this function is very simple and it just take care of not-allowed or standard cursor
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  function rotationStyleHandler(eventData, control, fabricObject) {
    if (fabricObject.lockRotation) {
      return 'not-allowed';
    }
    return control.cursorStyle;
  }

  function commonEventInfo(eventData, transform, x, y) {
    return {
      e: eventData,
      transform: transform,
      pointer: {
        x: x,
        y: y,
      }
    };
  }

  /**
   * Wrap an action handler with saving/restoring object position on the transform.
   * this is the code that permits to objects to keep their position while transforming.
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */
  function wrapWithFixedAnchor(actionHandler) {
    return function(eventData, transform, x, y) {
      var target = transform.target, centerPoint = target.getCenterPoint(),
          constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY),
          actionPerformed = actionHandler(eventData, transform, x, y);
      target.setPositionByOrigin(constraint, transform.originX, transform.originY);
      return actionPerformed;
    };
  }

  /**
   * Transforms a point described by x and y in a distance from the top left corner of the object
   * bounding box.
   * @param {Object} transform
   * @param {String} originX
   * @param {String} originY
   * @param {number} x
   * @param {number} y
   * @return {Fabric.Point} the normalized point
   */
  function getLocalPoint(transform, originX, originY, x, y) {
    var target = transform.target,
        control = target.controls[transform.corner],
        zoom = target.canvas.getZoom(),
        padding = target.padding / zoom,
        localPoint = target.toLocalPoint(new fabric.Point(x, y), originX, originY);
    if (localPoint.x >= padding) {
      localPoint.x -= padding;
    }
    if (localPoint.x <= -padding) {
      localPoint.x += padding;
    }
    if (localPoint.y >= padding) {
      localPoint.y -= padding;
    }
    if (localPoint.y <= padding) {
      localPoint.y += padding;
    }
    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
  }

  /**
   * Detect if the fabric object is flipped on one side.
   * @param {fabric.Object} target
   * @return {Boolean} true if one flip, but not two.
   */
  function targetHasOneFlip(target) {
    return (target.flipX && !target.flipY) || (!target.flipX && target.flipY);
  }

  /**
   * Utility function to compensate the scale factor when skew is applied on both axes
   * @private
   */
  function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
    if (target[oppositeSkew] !== 0) {
      var newDim = target._getTransformedDimensions()[axis];
      var newValue = reference / newDim * target[scaleToCompensate];
      target.set(scaleToCompensate, newValue);
    }
  }

  /**
   * Action handler for skewing on the X axis
   * @private
   */
  function skewObjectX(eventData, transform, x, y) {
    var target = transform.target,
        // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(0, target.skewY),
        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x,
        currentSkew = target.skewX, newSkew;
    if (totalSkewSize < 2) {
      // let's make it easy to go back to position 0.
      newSkew = 0;
    }
    else {
      newSkew = radiansToDegrees(
        Math.atan2((totalSkewSize / target.scaleX), (dimNoSkew.y / target.scaleY))
      );
      // now we have to find the sign of the skew.
      // it mostly depend on the origin of transformation.
      if (transform.originX === LEFT && transform.originY === BOTTOM) {
        newSkew = -newSkew;
      }
      if (transform.originX === RIGHT && transform.originY === TOP) {
        newSkew = -newSkew;
      }
      if (targetHasOneFlip(target)) {
        newSkew = -newSkew;
      }
    }
    var hasSkewed = currentSkew !== newSkew;
    if (hasSkewed) {
      var dimBeforeSkewing = target._getTransformedDimensions().y;
      target.set('skewX', newSkew);
      compensateScaleForSkew(target, 'skewY', 'scaleY', 'y', dimBeforeSkewing);
      fireEvent('skewing', commonEventInfo(eventData, transform, x, y));
    }
    return hasSkewed;
  }

  /**
   * Action handler for skewing on the Y axis
   * @private
   */
  function skewObjectY(eventData, transform, x, y) {
    var target = transform.target,
        // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(target.skewX, 0),
        localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y,
        currentSkew = target.skewY, newSkew;
    if (totalSkewSize < 2) {
      // let's make it easy to go back to position 0.
      newSkew = 0;
    }
    else {
      newSkew = radiansToDegrees(
        Math.atan2((totalSkewSize / target.scaleY), (dimNoSkew.x / target.scaleX))
      );
      // now we have to find the sign of the skew.
      // it mostly depend on the origin of transformation.
      if (transform.originX === LEFT && transform.originY === BOTTOM) {
        newSkew = -newSkew;
      }
      if (transform.originX === RIGHT && transform.originY === TOP) {
        newSkew = -newSkew;
      }
      if (targetHasOneFlip(target)) {
        newSkew = -newSkew;
      }
    }
    var hasSkewed = currentSkew !== newSkew;
    if (hasSkewed) {
      var dimBeforeSkewing = target._getTransformedDimensions().x;
      target.set('skewY', newSkew);
      compensateScaleForSkew(target, 'skewX', 'scaleX', 'x', dimBeforeSkewing);
      fireEvent('skewing', commonEventInfo(eventData, transform, x, y));
    }
    return hasSkewed;
  }

  /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function skewHandlerX(eventData, transform, x, y) {
    // step1 figure out and change transform origin.
    // if skewX > 0 and originY bottom we anchor on right
    // if skewX > 0 and originY top we anchor on left
    // if skewX < 0 and originY bottom we anchor on left
    // if skewX < 0 and originY top we anchor on right
    // if skewX is 0, we look for mouse position to understand where are we going.
    var target = transform.target, currentSkew = target.skewX, originX, originY = transform.originY;
    if (target.lockSkewingX) {
      return false;
    }
    if (currentSkew === 0) {
      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
      if (localPointFromCenter.x > 0) {
        // we are pulling right, anchor left;
        originX = LEFT;
      }
      else {
        // we are pulling right, anchor right
        originX = RIGHT;
      }
    }
    else {
      if (currentSkew > 0) {
        originX = originY === TOP ? LEFT : RIGHT;
      }
      if (currentSkew < 0) {
        originX = originY === TOP ? RIGHT : LEFT;
      }
      // is the object flipped on one side only? swap the origin.
      if (targetHasOneFlip(target)) {
        originX = originX === LEFT ? RIGHT : LEFT;
      }
    }

    // once we have the origin, we find the anchor point
    transform.originX = originX;
    var finalHandler = wrapWithFixedAnchor(skewObjectX);
    return finalHandler(eventData, transform, x, y);
  }

  /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function skewHandlerY(eventData, transform, x, y) {
    // step1 figure out and change transform origin.
    // if skewY > 0 and originX left we anchor on top
    // if skewY > 0 and originX right we anchor on bottom
    // if skewY < 0 and originX left we anchor on bottom
    // if skewY < 0 and originX right we anchor on top
    // if skewY is 0, we look for mouse position to understand where are we going.
    var target = transform.target, currentSkew = target.skewY, originY, originX = transform.originX;
    if (target.lockSkewingY) {
      return false;
    }
    if (currentSkew === 0) {
      var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
      if (localPointFromCenter.y > 0) {
        // we are pulling down, anchor up;
        originY = TOP;
      }
      else {
        // we are pulling up, anchor down
        originY = BOTTOM;
      }
    }
    else {
      if (currentSkew > 0) {
        originY = originX === LEFT ? TOP : BOTTOM;
      }
      if (currentSkew < 0) {
        originY = originX === LEFT ? BOTTOM : TOP;
      }
      // is the object flipped on one side only? swap the origin.
      if (targetHasOneFlip(target)) {
        originY = originY === TOP ? BOTTOM : TOP;
      }
    }

    // once we have the origin, we find the anchor point
    transform.originY = originY;
    var finalHandler = wrapWithFixedAnchor(skewObjectY);
    return finalHandler(eventData, transform, x, y);
  }

  /**
   * Action handler for rotation and snapping, without anchor point.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   * @private
   */
  function rotationWithSnapping(eventData, transform, x, y) {
    var t = transform,
        target = t.target,
        pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);

    if (target.lockRotation) {
      return false;
    }

    var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x),
        curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x),
        angle = radiansToDegrees(curAngle - lastAngle + t.theta),
        hasRotated = true;

    if (target.snapAngle > 0) {
      var snapAngle  = target.snapAngle,
          snapThreshold  = target.snapThreshold || snapAngle,
          rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
          leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;

      if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
        angle = leftAngleLocked;
      }
      else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
        angle = rightAngleLocked;
      }
    }

    // normalize angle to positive value
    if (angle < 0) {
      angle = 360 + angle;
    }
    angle %= 360;

    hasRotated = target.angle !== angle;
    target.angle = angle;
    if (hasRotated) {
      fireEvent('rotating', commonEventInfo(eventData, transform, x, y));
    }
    return hasRotated;
  }

  /**
   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @param {Object} options additional information for scaling
   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
   * @return {Boolean} true if some change happened
   * @private
   */
  function scaleObject(eventData, transform, x, y, options) {
    options = options || {};
    var target = transform.target,
        lockScalingX = target.lockScalingX, lockScalingY = target.lockScalingY,
        by = options.by, newPoint, scaleX, scaleY, dim,
        scaleProportionally = scaleIsProportional(eventData, target),
        forbidScaling = scalingIsForbidden(target, by, scaleProportionally),
        signX, signY, gestureScale = transform.gestureScale;

    if (forbidScaling) {
      return false;
    }
    if (gestureScale) {
      scaleX = transform.scaleX * gestureScale;
      scaleY = transform.scaleY * gestureScale;
    }
    else {
      newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
      // use of sign: We use sign to detect change of direction of an action. sign usually change when
      // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
      // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
      // cross many time the origin point and flip the object. so we need a way to filter out the noise.
      // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
      signX = by !== 'y' ? sign(newPoint.x) : 1;
      signY = by !== 'x' ? sign(newPoint.y) : 1;
      if (!transform.signX) {
        transform.signX = signX;
      }
      if (!transform.signY) {
        transform.signY = signY;
      }

      if (target.lockScalingFlip &&
        (transform.signX !== signX || transform.signY !== signY)
      ) {
        return false;
      }

      dim = target._getTransformedDimensions();
      // missing detection of flip and logic to switch the origin
      if (scaleProportionally && !by) {
        // uniform scaling
        var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y),
            original = transform.original,
            originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) +
              Math.abs(dim.y * original.scaleY / target.scaleY),
            scale = distance / originalDistance, hasScaled;
        scaleX = original.scaleX * scale;
        scaleY = original.scaleY * scale;
      }
      else {
        scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
        scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
      }
      // if we are scaling by center, we need to double the scale
      if (isTransformCentered(transform)) {
        scaleX *= 2;
        scaleY *= 2;
      }
      if (transform.signX !== signX && by !== 'y') {
        transform.originX = opposite[transform.originX];
        scaleX *= -1;
        transform.signX = signX;
      }
      if (transform.signY !== signY && by !== 'x') {
        transform.originY = opposite[transform.originY];
        scaleY *= -1;
        transform.signY = signY;
      }
    }
    // minScale is taken are in the setter.
    var oldScaleX = target.scaleX, oldScaleY = target.scaleY;
    if (!by) {
      !lockScalingX && target.set('scaleX', scaleX);
      !lockScalingY && target.set('scaleY', scaleY);
    }
    else {
      // forbidden cases already handled on top here.
      by === 'x' && target.set('scaleX', scaleX);
      by === 'y' && target.set('scaleY', scaleY);
    }
    hasScaled = oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    if (hasScaled) {
      fireEvent('scaling', commonEventInfo(eventData, transform, x, y));
    }
    return hasScaled;
  }

  /**
   * Generic scaling logic, to scale from corners either equally or freely.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function scaleObjectFromCorner(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y);
  }

  /**
   * Scaling logic for the X axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function scaleObjectX(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y , { by: 'x' });
  }

  /**
   * Scaling logic for the Y axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function scaleObjectY(eventData, transform, x, y) {
    return scaleObject(eventData, transform, x, y , { by: 'y' });
  }

  /**
   * Composed action handler to either scale Y or skew X
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function scalingYOrSkewingX(eventData, transform, x, y) {
    // ok some safety needed here.
    if (eventData[transform.target.canvas.altActionKey]) {
      return controls.skewHandlerX(eventData, transform, x, y);
    }
    return controls.scalingY(eventData, transform, x, y);
  }

  /**
   * Composed action handler to either scale X or skew Y
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function scalingXOrSkewingY(eventData, transform, x, y) {
    // ok some safety needed here.
    if (eventData[transform.target.canvas.altActionKey]) {
      return controls.skewHandlerY(eventData, transform, x, y);
    }
    return controls.scalingX(eventData, transform, x, y);
  }

  /**
   * Action handler to change textbox width
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function changeWidth(eventData, transform, x, y) {
    var target = transform.target, localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y),
        strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1),
        multiplier = isTransformCentered(transform) ? 2 : 1,
        oldWidth = target.width, hasResized,
        newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
    target.set('width', Math.max(newWidth, 0));
    hasResized = oldWidth !== newWidth;
    if (hasResized) {
      fireEvent('resizing', commonEventInfo(eventData, transform, x, y));
    }
    return hasResized;
  }

  /**
   * Action handler
   * @private
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if the translation occurred
   */
  function dragHandler(eventData, transform, x, y) {
    var target = transform.target,
        newLeft = x - transform.offsetX,
        newTop = y - transform.offsetY,
        moveX = !target.get('lockMovementX') && target.left !== newLeft,
        moveY = !target.get('lockMovementY') && target.top !== newTop;
    moveX && target.set('left', newLeft);
    moveY && target.set('top', newTop);
    if (moveX || moveY) {
      fireEvent('moving', commonEventInfo(eventData, transform, x, y));
    }
    return moveX || moveY;
  }

  controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
  controls.skewCursorStyleHandler = skewCursorStyleHandler;
  controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
  controls.rotationWithSnapping = wrapWithFixedAnchor(rotationWithSnapping);
  controls.scalingEqually = wrapWithFixedAnchor(scaleObjectFromCorner);
  controls.scalingX = wrapWithFixedAnchor(scaleObjectX);
  controls.scalingY = wrapWithFixedAnchor(scaleObjectY);
  controls.scalingYOrSkewingX = scalingYOrSkewingX;
  controls.scalingXOrSkewingY = scalingXOrSkewingY;
  controls.changeWidth = wrapWithFixedAnchor(changeWidth);
  controls.skewHandlerX = skewHandlerX;
  controls.skewHandlerY = skewHandlerY;
  controls.dragHandler = dragHandler;
  controls.scaleOrSkewActionName = scaleOrSkewActionName;
  controls.rotationStyleHandler = rotationStyleHandler;
  controls.fireEvent = fireEvent;
  controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
  controls.getLocalPoint = getLocalPoint;
  fabric.controlsUtils = controls;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      degreesToRadians = fabric.util.degreesToRadians,
      controls = fabric.controlsUtils;

  /**
   * Render a round control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */
  function renderCircleControl (ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    var size = styleOverride.cornerSize || fabricObject.cornerSize,
        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
          styleOverride.transparentCorners : this.transparentCorners,
        methodName = transparentCorners ? 'stroke' : 'fill',
        stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor);
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
    // this is still wrong
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(left, top, size / 2, 0, 2 * Math.PI, false);
    ctx[methodName]();
    if (stroke) {
      ctx.stroke();
    }
    ctx.restore();
  }

  /**
   * Render a square control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */
  function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    var size = styleOverride.cornerSize || fabricObject.cornerSize,
        transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
          styleOverride.transparentCorners : fabricObject.transparentCorners,
        methodName = transparentCorners ? 'stroke' : 'fill',
        stroke = !transparentCorners && (
          styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor
        ), sizeBy2 = size / 2;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
    ctx.strokeStyle = styleOverride.strokeCornerColor || fabricObject.strokeCornerColor;
    // this is still wrong
    ctx.lineWidth = 1;
    ctx.translate(left, top);
    ctx.rotate(degreesToRadians(fabricObject.angle));
    // this does not work, and fixed with ( && ) does not make sense.
    // to have real transparent corners we need the controls on upperCanvas
    // transparentCorners || ctx.clearRect(-sizeBy2, -sizeBy2, size, size);
    ctx[methodName + 'Rect'](-sizeBy2, -sizeBy2, size, size);
    if (stroke) {
      ctx.strokeRect(-sizeBy2, -sizeBy2, size, size);
    }
    ctx.restore();
  }

  controls.renderCircleControl = renderCircleControl;
  controls.renderSquareControl = renderSquareControl;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  function Control(options) {
    for (var i in options) {
      this[i] = options[i];
    }
  }

  fabric.Control = Control;

  fabric.Control.prototype = /** @lends fabric.Control.prototype */ {

    /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the controlset.
     * @type {Boolean}
     * @default true
     */
    visible: true,

    /**
     * Name of the action that the controll will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */
    actionName: 'scale',

    /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */
    angle: 0,

    /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    x: 0,

    /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    y: 0,

    /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundindbox, with an offset of 30 pixels vertivally. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */
    offsetX: 0,

    /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */
    offsetY: 0,

    /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */
    cursorStyle: 'crosshair',

    /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */
    withConnection: false,

    /**
     * The control actionHandler, provide one to handle action ( control being moved )
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    actionHandler: function(/* eventData, transformData, fabricObject */) { },

    /**
     * The control handler for mouse down, provide one to handle mouse down on control
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    mouseDownHandler: function(/* eventData, transformData, fabricObject */) { },

    /**
     * The control mouseUpHandler, provide one to handle an effect on mouse up.
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    mouseUpHandler: function(/* eventData, transformData, fabricObject */) { },

    /**
     * Returns control actionHandler
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    getActionHandler: function(/* eventData, transformData, fabricObject */) {
      return this.actionHandler;
    },

    /**
     * Returns control mouseDown handler
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    getMouseDownHandler: function(/* eventData, fabricObject, control */) {
      return this.mouseDownHandler;
    },

    /**
     * Returns control mouseUp handler
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {fabric.Object} object on which the control is displayed
     * @return {Function}
     */
    getMouseUpHandler: function(/* eventData, fabricObject, control */) {
      return this.mouseUpHandler;
    },

    /**
     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
     * function you can pass one in the constructor
     * the cursorStyle property
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */
    cursorStyleHandler: function(eventData, control /* fabricObject */) {
      return control.cursorStyle;
    },

    /**
     * Returns the action name. The basic implementation just return the actionName property.
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */
    getActionName: function(eventData, control /* fabricObject */) {
      return control.actionName;
    },

    /**
     * Returns controls visibility
     * @param {fabric.Object} object on which the control is displayed
     * @param {String} controlKey key where the control is memorized on the
     * @return {Boolean}
     */
    getVisibility: function(fabricObject, controlKey) {
      var objectVisibility = fabricObject._controlsVisibility;
      if (objectVisibility && typeof objectVisibility[controlKey] !== 'undefined') {
        return objectVisibility[controlKey];
      }
      return this.visible;
    },

    /**
     * Sets controls visibility
     * @param {Boolean} visibility for the object
     * @return {Void}
     */
    setVisibility: function(visibility /* name, fabricObject */) {
      this.visible = visibility;
    },


    positionHandler: function(dim, finalMatrix /*, fabricObject, currentControl */) {
      var point = fabric.util.transformPoint({
        x: this.x * dim.x + this.offsetX,
        y: this.y * dim.y + this.offsetY }, finalMatrix);
      return point;
    },

    /**
    * Render function for the control.
    * When this function runs the context is unscaled. unrotate. Just retina scaled.
    * all the functions will have to translate to the point left,top before starting Drawing
    * if they want to draw a control where the position is detected.
    * left and top are the result of the positionHandler function
    * @param {RenderingContext2D} ctx the context where the control will be drawn
    * @param {Number} left position of the canvas where we are about to render the control.
    * @param {Number} top position of the canvas where we are about to render the control.
    * @param {Object} styleOverride
    * @param {fabric.Object} fabricObject the object where the control is about to be rendered
    */
    render: function(ctx, left, top, styleOverride, fabricObject) {
      styleOverride = styleOverride || {};
      switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
        case 'circle':
          fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
          break;
        default:
          fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
      }
    },
  };

})( true ? exports : this);


(function() {

  /* _FROM_SVG_START_ */
  function getColorStop(el, multiplier) {
    var style = el.getAttribute('style'),
        offset = el.getAttribute('offset') || 0,
        color, colorAlpha, opacity, i;

    // convert percents to absolute values
    offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
    offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
    if (style) {
      var keyValuePairs = style.split(/\s*;\s*/);

      if (keyValuePairs[keyValuePairs.length - 1] === '') {
        keyValuePairs.pop();
      }

      for (i = keyValuePairs.length; i--; ) {

        var split = keyValuePairs[i].split(/\s*:\s*/),
            key = split[0].trim(),
            value = split[1].trim();

        if (key === 'stop-color') {
          color = value;
        }
        else if (key === 'stop-opacity') {
          opacity = value;
        }
      }
    }

    if (!color) {
      color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
    }
    if (!opacity) {
      opacity = el.getAttribute('stop-opacity');
    }

    color = new fabric.Color(color);
    colorAlpha = color.getAlpha();
    opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
    opacity *= colorAlpha * multiplier;

    return {
      offset: offset,
      color: color.toRgb(),
      opacity: opacity
    };
  }

  function getLinearCoords(el) {
    return {
      x1: el.getAttribute('x1') || 0,
      y1: el.getAttribute('y1') || 0,
      x2: el.getAttribute('x2') || '100%',
      y2: el.getAttribute('y2') || 0
    };
  }

  function getRadialCoords(el) {
    return {
      x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
      y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
      r1: 0,
      x2: el.getAttribute('cx') || '50%',
      y2: el.getAttribute('cy') || '50%',
      r2: el.getAttribute('r') || '50%'
    };
  }
  /* _FROM_SVG_END_ */

  var clone = fabric.util.object.clone;

  /**
   * Gradient class
   * @class fabric.Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   * @see {@link fabric.Gradient#initialize} for constructor definition
   */
  fabric.Gradient = fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {

    /**
     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetX: 0,

    /**
     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */
    offsetY: 0,

    /**
     * A transform matrix to apply to the gradient before painting.
     * Imported from svg gradients, is not applied with the current transform in the center.
     * Before this transform is applied, the origin point is at the top left corner of the object
     * plus the addition of offsetY and offsetX.
     * @type Number[]
     * @default null
     */
    gradientTransform: null,

    /**
     * coordinates units for coords.
     * If `pixels`, the number of coords are in the same unit of width / height.
     * If set as `percentage` the coords are still a number, but 1 means 100% of width
     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
     * allowed values pixels or percentage.
     * @type String
     * @default 'pixels'
     */
    gradientUnits: 'pixels',

    /**
     * Gradient type linear or radial
     * @type String
     * @default 'pixels'
     */
    type: 'linear',

    /**
     * Constructor
     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
     * @param {Object} [options.type] gradient type linear or radial
     * @param {Object} [options.gradientUnits] gradient units
     * @param {Object} [options.offsetX] SVG import compatibility
     * @param {Object} [options.offsetY] SVG import compatibility
     * @param {Object[]} options.colorStops contains the colorstops.
     * @param {Object} options.coords contains the coords of the gradient
     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
     * @return {fabric.Gradient} thisArg
     */
    initialize: function(options) {
      options || (options = { });
      options.coords || (options.coords = { });

      var coords, _this = this;

      // sets everything, then coords and colorstops get sets again
      Object.keys(options).forEach(function(option) {
        _this[option] = options[option];
      });

      if (this.id) {
        this.id += '_' + fabric.Object.__uid++;
      }
      else {
        this.id = fabric.Object.__uid++;
      }

      coords = {
        x1: options.coords.x1 || 0,
        y1: options.coords.y1 || 0,
        x2: options.coords.x2 || 0,
        y2: options.coords.y2 || 0
      };

      if (this.type === 'radial') {
        coords.r1 = options.coords.r1 || 0;
        coords.r2 = options.coords.r2 || 0;
      }

      this.coords = coords;
      this.colorStops = options.colorStops.slice();
    },

    /**
     * Adds another colorStop
     * @param {Object} colorStop Object with offset and color
     * @return {fabric.Gradient} thisArg
     */
    addColorStop: function(colorStops) {
      for (var position in colorStops) {
        var color = new fabric.Color(colorStops[position]);
        this.colorStops.push({
          offset: parseFloat(position),
          color: color.toRgb(),
          opacity: color.getAlpha()
        });
      }
      return this;
    },

    /**
     * Returns object representation of a gradient
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object}
     */
    toObject: function(propertiesToInclude) {
      var object = {
        type: this.type,
        coords: this.coords,
        colorStops: this.colorStops,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        gradientUnits: this.gradientUnits,
        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);

      return object;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of an gradient
     * @param {Object} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */
    toSVG: function(object, options) {
      var coords = clone(this.coords, true), i, len, options = options || {},
          markup, commonAttributes, colorStops = clone(this.colorStops, true),
          needsSwap = coords.r1 > coords.r2,
          transform = this.gradientTransform ? this.gradientTransform.concat() : fabric.iMatrix.concat(),
          offsetX = -this.offsetX, offsetY = -this.offsetY,
          withViewport = !!options.additionalTransform,
          gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
      // colorStops must be sorted ascending
      colorStops.sort(function(a, b) {
        return a.offset - b.offset;
      });

      if (gradientUnits === 'objectBoundingBox') {
        offsetX /= object.width;
        offsetY /= object.height;
      }
      else {
        offsetX += object.width / 2;
        offsetY += object.height / 2;
      }
      if (object.type === 'path') {
        offsetX -= object.pathOffset.x;
        offsetY -= object.pathOffset.y;
      }


      transform[4] -= offsetX;
      transform[5] -= offsetY;

      commonAttributes = 'id="SVGID_' + this.id +
                     '" gradientUnits="' + gradientUnits + '"';
      commonAttributes += ' gradientTransform="' + (withViewport ?
        options.additionalTransform + ' ' : '') + fabric.util.matrixToSVG(transform) + '" ';

      if (this.type === 'linear') {
        markup = [
          '<linearGradient ',
          commonAttributes,
          ' x1="', coords.x1,
          '" y1="', coords.y1,
          '" x2="', coords.x2,
          '" y2="', coords.y2,
          '">\n'
        ];
      }
      else if (this.type === 'radial') {
        // svg radial gradient has just 1 radius. the biggest.
        markup = [
          '<radialGradient ',
          commonAttributes,
          ' cx="', needsSwap ? coords.x1 : coords.x2,
          '" cy="', needsSwap ? coords.y1 : coords.y2,
          '" r="', needsSwap ? coords.r1 : coords.r2,
          '" fx="', needsSwap ? coords.x2 : coords.x1,
          '" fy="', needsSwap ? coords.y2 : coords.y1,
          '">\n'
        ];
      }

      if (this.type === 'radial') {
        if (needsSwap) {
          // svg goes from internal to external radius. if radius are inverted, swap color stops.
          colorStops = colorStops.concat();
          colorStops.reverse();
          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset = 1 - colorStops[i].offset;
          }
        }
        var minRadius = Math.min(coords.r1, coords.r2);
        if (minRadius > 0) {
          // i have to shift all colorStops and add new one in 0.
          var maxRadius = Math.max(coords.r1, coords.r2),
              percentageShift = minRadius / maxRadius;
          for (i = 0, len = colorStops.length; i < len; i++) {
            colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
          }
        }
      }

      for (i = 0, len = colorStops.length; i < len; i++) {
        var colorStop = colorStops[i];
        markup.push(
          '<stop ',
          'offset="', (colorStop.offset * 100) + '%',
          '" style="stop-color:', colorStop.color,
          (typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';'),
          '"/>\n'
        );
      }

      markup.push((this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n'));

      return markup.join('');
    },
    /* _TO_SVG_END_ */

    /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {CanvasGradient}
     */
    toLive: function(ctx) {
      var gradient, coords = fabric.util.object.clone(this.coords), i, len;

      if (!this.type) {
        return;
      }

      if (this.type === 'linear') {
        gradient = ctx.createLinearGradient(
          coords.x1, coords.y1, coords.x2, coords.y2);
      }
      else if (this.type === 'radial') {
        gradient = ctx.createRadialGradient(
          coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
      }

      for (i = 0, len = this.colorStops.length; i < len; i++) {
        var color = this.colorStops[i].color,
            opacity = this.colorStops[i].opacity,
            offset = this.colorStops[i].offset;

        if (typeof opacity !== 'undefined') {
          color = new fabric.Color(color).setAlpha(opacity).toRgba();
        }
        gradient.addColorStop(offset, color);
      }

      return gradient;
    }
  });

  fabric.util.object.extend(fabric.Gradient, {

    /* _FROM_SVG_START_ */
    /**
     * Returns {@link fabric.Gradient} instance from an SVG element
     * @static
     * @memberOf fabric.Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {fabric.Object} instance
     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly graidents
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
     * @param {Object.number} width width part of the svg tag if viewBox is not specified
     * @param {Object.number} height height part of the svg tag if viewBox is not specified
     * @return {fabric.Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     */
    fromElement: function(el, instance, opacityAttr, svgOptions) {
      /**
       *  @example:
       *
       *  <linearGradient id="linearGrad1">
       *    <stop offset="0%" stop-color="white"/>
       *    <stop offset="100%" stop-color="black"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <linearGradient id="linearGrad2">
       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad1">
       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
       *  </radialGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad2">
       *    <stop offset="0" stop-color="rgb(255,255,255)" />
       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
       *    <stop offset="1" stop-color="rgb(255,255,255)" />
       *  </radialGradient>
       *
       */

      var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
      multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
      if (isNaN(multiplier)) {
        multiplier = 1;
      }

      var colorStopEls = el.getElementsByTagName('stop'),
          type,
          gradientUnits = el.getAttribute('gradientUnits') === 'userSpaceOnUse' ?
            'pixels' : 'percentage',
          gradientTransform = el.getAttribute('gradientTransform') || '',
          colorStops = [],
          coords, i, offsetX = 0, offsetY = 0,
          transformMatrix;
      if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
        type = 'linear';
        coords = getLinearCoords(el);
      }
      else {
        type = 'radial';
        coords = getRadialCoords(el);
      }

      for (i = colorStopEls.length; i--; ) {
        colorStops.push(getColorStop(colorStopEls[i], multiplier));
      }

      transformMatrix = fabric.parseTransformAttribute(gradientTransform);

      __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);

      if (gradientUnits === 'pixels') {
        offsetX = -instance.left;
        offsetY = -instance.top;
      }

      var gradient = new fabric.Gradient({
        id: el.getAttribute('id'),
        type: type,
        coords: coords,
        colorStops: colorStops,
        gradientUnits: gradientUnits,
        gradientTransform: transformMatrix,
        offsetX: offsetX,
        offsetY: offsetY,
      });

      return gradient;
    }
    /* _FROM_SVG_END_ */
  });

  /**
   * @private
   */
  function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
    var propValue, finalValue;
    Object.keys(options).forEach(function(prop) {
      propValue = options[prop];
      if (propValue === 'Infinity') {
        finalValue = 1;
      }
      else if (propValue === '-Infinity') {
        finalValue = 0;
      }
      else {
        finalValue = parseFloat(options[prop], 10);
        if (typeof propValue === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
          finalValue *= 0.01;
          if (gradientUnits === 'pixels') {
            // then we need to fix those percentages here in svg parsing
            if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
              finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
            }
            if (prop === 'y1' || prop === 'y2') {
              finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
            }
          }
        }
      }
      options[prop] = finalValue;
    });
  }
})();


(function() {

  'use strict';

  var toFixed = fabric.util.toFixed;

  /**
   * Pattern class
   * @class fabric.Pattern
   * @see {@link http://fabricjs.com/patterns|Pattern demo}
   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
   * @see {@link fabric.Pattern#initialize} for constructor definition
   */


  fabric.Pattern = fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {

    /**
     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @type String
     * @default
     */
    repeat: 'repeat',

    /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */
    crossOrigin: '',

    /**
     * transform matrix to change the pattern, imported from svgs.
     * @type Array
     * @default
     */
    patternTransform: null,

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {Function} [callback] function to invoke after callback init.
     * @return {fabric.Pattern} thisArg
     */
    initialize: function(options, callback) {
      options || (options = { });

      this.id = fabric.Object.__uid++;
      this.setOptions(options);
      if (!options.source || (options.source && typeof options.source !== 'string')) {
        callback && callback(this);
        return;
      }
      else {
        // img src string
        var _this = this;
        this.source = fabric.util.createImage();
        fabric.util.loadImage(options.source, function(img, isError) {
          _this.source = img;
          callback && callback(_this, isError);
        }, null, this.crossOrigin);
      }
    },

    /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of a pattern instance
     */
    toObject: function(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          source, object;

      // <img> element
      if (typeof this.source.src === 'string') {
        source = this.source.src;
      }
      // <canvas> element
      else if (typeof this.source === 'object' && this.source.toDataURL) {
        source = this.source.toDataURL();
      }

      object = {
        type: 'pattern',
        source: source,
        repeat: this.repeat,
        crossOrigin: this.crossOrigin,
        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
      };
      fabric.util.populateWithProperties(this, object, propertiesToInclude);

      return object;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of a pattern
     * @param {fabric.Object} object
     * @return {String} SVG representation of a pattern
     */
    toSVG: function(object) {
      var patternSource = typeof this.source === 'function' ? this.source() : this.source,
          patternWidth = patternSource.width / object.width,
          patternHeight = patternSource.height / object.height,
          patternOffsetX = this.offsetX / object.width,
          patternOffsetY = this.offsetY / object.height,
          patternImgSrc = '';
      if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
        patternHeight = 1;
        if (patternOffsetY) {
          patternHeight += Math.abs(patternOffsetY);
        }
      }
      if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
        patternWidth = 1;
        if (patternOffsetX) {
          patternWidth += Math.abs(patternOffsetX);
        }

      }
      if (patternSource.src) {
        patternImgSrc = patternSource.src;
      }
      else if (patternSource.toDataURL) {
        patternImgSrc = patternSource.toDataURL();
      }

      return '<pattern id="SVGID_' + this.id +
                    '" x="' + patternOffsetX +
                    '" y="' + patternOffsetY +
                    '" width="' + patternWidth +
                    '" height="' + patternHeight + '">\n' +
               '<image x="0" y="0"' +
                      ' width="' + patternSource.width +
                      '" height="' + patternSource.height +
                      '" xlink:href="' + patternImgSrc +
               '"></image>\n' +
             '</pattern>\n';
    },
    /* _TO_SVG_END_ */

    setOptions: function(options) {
      for (var prop in options) {
        this[prop] = options[prop];
      }
    },

    /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */
    toLive: function(ctx) {
      var source = this.source;
      // if the image failed to load, return, and allow rest to continue loading
      if (!source) {
        return '';
      }

      // if an image
      if (typeof source.src !== 'undefined') {
        if (!source.complete) {
          return '';
        }
        if (source.naturalWidth === 0 || source.naturalHeight === 0) {
          return '';
        }
      }
      return ctx.createPattern(source, this.repeat);
    }
  });
})();


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      toFixed = fabric.util.toFixed;

  if (fabric.Shadow) {
    fabric.warn('fabric.Shadow is already defined.');
    return;
  }

  /**
   * Shadow class
   * @class fabric.Shadow
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @see {@link fabric.Shadow#initialize} for constructor definition
   */
  fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {

    /**
     * Shadow color
     * @type String
     * @default
     */
    color: 'rgb(0,0,0)',

    /**
     * Shadow blur
     * @type Number
     */
    blur: 0,

    /**
     * Shadow horizontal offset
     * @type Number
     * @default
     */
    offsetX: 0,

    /**
     * Shadow vertical offset
     * @type Number
     * @default
     */
    offsetY: 0,

    /**
     * Whether the shadow should affect stroke operations
     * @type Boolean
     * @default
     */
    affectStroke: false,

    /**
     * Indicates whether toObject should include default values
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * When `false`, the shadow will scale with the object.
     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
     * default to false
     * @type Boolean
     * @default
     */
    nonScaling: false,

    /**
     * Constructor
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     * @return {fabric.Shadow} thisArg
     */
    initialize: function(options) {

      if (typeof options === 'string') {
        options = this._parseShadow(options);
      }

      for (var prop in options) {
        this[prop] = options[prop];
      }

      this.id = fabric.Object.__uid++;
    },

    /**
     * @private
     * @param {String} shadow Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */
    _parseShadow: function(shadow) {
      var shadowStr = shadow.trim(),
          offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [],
          color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';

      return {
        color: color.trim(),
        offsetX: parseInt(offsetsAndBlur[1], 10) || 0,
        offsetY: parseInt(offsetsAndBlur[2], 10) || 0,
        blur: parseInt(offsetsAndBlur[3], 10) || 0
      };
    },

    /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */
    toString: function() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
    },

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of a shadow
     * @param {fabric.Object} object
     * @return {String} SVG representation of a shadow
     */
    toSVG: function(object) {
      var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
          offset = fabric.util.rotateVector(
            { x: this.offsetX, y: this.offsetY },
            fabric.util.degreesToRadians(-object.angle)),
          BLUR_BOX = 20, color = new fabric.Color(this.color);

      if (object.width && object.height) {
        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
        // we add some extra space to filter box to contain the blur ( 20 )
        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
      }
      if (object.flipX) {
        offset.x *= -1;
      }
      if (object.flipY) {
        offset.y *= -1;
      }

      return (
        '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' +
          'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' +
          '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' +
            toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' +
          '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) +
          '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' +
          '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' +
          '\t<feComposite in2="oBlur" operator="in" />\n' +
          '\t<feMerge>\n' +
            '\t\t<feMergeNode></feMergeNode>\n' +
            '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' +
          '\t</feMerge>\n' +
        '</filter>\n');
    },
    /* _TO_SVG_END_ */

    /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */
    toObject: function() {
      if (this.includeDefaultValues) {
        return {
          color: this.color,
          blur: this.blur,
          offsetX: this.offsetX,
          offsetY: this.offsetY,
          affectStroke: this.affectStroke,
          nonScaling: this.nonScaling
        };
      }
      var obj = { }, proto = fabric.Shadow.prototype;

      ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke', 'nonScaling'].forEach(function(prop) {
        if (this[prop] !== proto[prop]) {
          obj[prop] = this[prop];
        }
      }, this);

      return obj;
    }
  });

  /**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * @static
   * @field
   * @memberOf fabric.Shadow
   */
  // eslint-disable-next-line max-len
  fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/;

})( true ? exports : this);


(function () {

  'use strict';

  if (fabric.StaticCanvas) {
    fabric.warn('fabric.StaticCanvas is already defined.');
    return;
  }

  // aliases for faster resolution
  var extend = fabric.util.object.extend,
      getElementOffset = fabric.util.getElementOffset,
      removeFromArray = fabric.util.removeFromArray,
      toFixed = fabric.util.toFixed,
      transformPoint = fabric.util.transformPoint,
      invertTransform = fabric.util.invertTransform,
      getNodeCanvas = fabric.util.getNodeCanvas,
      createCanvasElement = fabric.util.createCanvasElement,

      CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');

  /**
   * Static canvas class
   * @class fabric.StaticCanvas
   * @mixes fabric.Collection
   * @mixes fabric.Observable
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */
  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {

    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(el, options) {
      options || (options = { });
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);
      this._initStatic(el, options);
    },

    /**
     * Background color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
     * @type {(String|fabric.Pattern)}
     * @default
     */
    backgroundColor: '',

    /**
     * Background image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as background, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    backgroundImage: null,

    /**
     * Overlay color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
     * @since 1.3.9
     * @type {(String|fabric.Pattern)}
     * @default
     */
    overlayColor: '',

    /**
     * Overlay image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */
    overlayImage: null,

    /**
     * Indicates whether toObject/toDatalessObject should include default values
     * if set to false, takes precedence over the object value.
     * @type Boolean
     * @default
     */
    includeDefaultValues: true,

    /**
     * Indicates whether objects' state should be saved
     * @type Boolean
     * @default
     */
    stateful: false,

    /**
     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
     * since the renders are quequed and executed one per frame.
     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
     * Left default to true to do not break documentation and old app, fiddles.
     * @type Boolean
     * @default
     */
    renderOnAddRemove: true,

    /**
     * Indicates whether object controls (borders/controls) are rendered above overlay image
     * @type Boolean
     * @default
     */
    controlsAboveOverlay: false,

    /**
     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
     * @type Boolean
     * @default
     */
    allowTouchScrolling: false,

    /**
     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
     * @type Boolean
     * @default
     */
    imageSmoothingEnabled: true,

    /**
     * The transformation (in the format of Canvas transform) which focuses the viewport
     * @type Array
     * @default
     */
    viewportTransform: fabric.iMatrix.concat(),

    /**
     * if set to false background image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    backgroundVpt: true,

    /**
     * if set to false overlya image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    overlayVpt: true,

    /**
     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
     * @type Boolean
     * @default
     */
    enableRetinaScaling: true,

    /**
     * Describe canvas element extension over design
     * properties are tl,tr,bl,br.
     * if canvas is not zoomed/panned those points are the four corner of canvas
     * if canvas is viewportTransformed you those points indicate the extension
     * of canvas element in plain untrasformed coordinates
     * The coordinates get updated with @method calcViewportBoundaries.
     * @memberOf fabric.StaticCanvas.prototype
     */
    vptCoords: { },

    /**
     * Based on vptCoords and object.aCoords, skip rendering of objects that
     * are not included in current viewport.
     * May greatly help in applications with crowded canvas and use of zoom/pan
     * If One of the corner of the bounding box of the object is on the canvas
     * the objects get rendered.
     * @memberOf fabric.StaticCanvas.prototype
     * @type Boolean
     * @default
     */
    skipOffscreen: true,

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
     * top left corner of the canvas.
     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * @private
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     */
    _initStatic: function(el, options) {
      var cb = this.requestRenderAllBound;
      this._objects = [];
      this._createLowerCanvas(el);
      this._initOptions(options);
      // only initialize retina scaling once
      if (!this.interactive) {
        this._initRetinaScaling();
      }

      if (options.overlayImage) {
        this.setOverlayImage(options.overlayImage, cb);
      }
      if (options.backgroundImage) {
        this.setBackgroundImage(options.backgroundImage, cb);
      }
      if (options.backgroundColor) {
        this.setBackgroundColor(options.backgroundColor, cb);
      }
      if (options.overlayColor) {
        this.setOverlayColor(options.overlayColor, cb);
      }
      this.calcOffset();
    },

    /**
     * @private
     */
    _isRetinaScaling: function() {
      return (fabric.devicePixelRatio !== 1 && this.enableRetinaScaling);
    },

    /**
     * @private
     * @return {Number} retinaScaling if applied, otherwise 1;
     */
    getRetinaScaling: function() {
      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
    },

    /**
     * @private
     */
    _initRetinaScaling: function() {
      if (!this._isRetinaScaling()) {
        return;
      }
      var scaleRatio = fabric.devicePixelRatio;
      this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
      if (this.upperCanvasEl) {
        this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
      }
    },

    __initRetinaScaling: function(scaleRatio, canvas, context) {
      canvas.setAttribute('width', this.width * scaleRatio);
      canvas.setAttribute('height', this.height * scaleRatio);
      context.scale(scaleRatio, scaleRatio);
    },


    /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     * @return {fabric.Canvas} instance
     * @chainable
     */
    calcOffset: function () {
      this._offset = getElementOffset(this.lowerCanvasEl);
      return this;
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
     * @example <caption>Normal overlayImage with left/top = 0</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage with different properties</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage loaded from cross-origin</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    setOverlayImage: function (image, callback, options) {
      return this.__setBgOverlayImage('overlayImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
     * @param {Function} callback Callback to invoke when image is loaded and set as background
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
     * @example <caption>Normal backgroundImage with left/top = 0</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage with different properties</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage loaded from cross-origin</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */
    // TODO: fix stretched examples
    setBackgroundImage: function (image, callback, options) {
      return this.__setBgOverlayImage('backgroundImage', image, callback, options);
    },

    /**
     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
     * @param {Function} callback Callback to invoke when foreground color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
     * @example <caption>Normal overlayColor - color value</caption>
     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setOverlayColor: function(overlayColor, callback) {
      return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
    },

    /**
     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
     * @param {Function} callback Callback to invoke when background color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
     * @example <caption>Normal backgroundColor - color value</caption>
     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */
    setBackgroundColor: function(backgroundColor, callback) {
      return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occured or not.
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
     */
    __setBgOverlayImage: function(property, image, callback, options) {
      if (typeof image === 'string') {
        fabric.util.loadImage(image, function(img, isError) {
          if (img) {
            var instance = new fabric.Image(img, options);
            this[property] = instance;
            instance.canvas = this;
          }
          callback && callback(img, isError);
        }, this, options && options.crossOrigin);
      }
      else {
        options && image.setOptions(options);
        this[property] = image;
        image && (image.canvas = this);
        callback && callback(image, false);
      }

      return this;
    },

    /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
     * @param {(Object|String|null)} color Object with pattern information, color value or null
     * @param {Function} [callback] Callback is invoked when color is set
     */
    __setBgOverlayColor: function(property, color, callback) {
      this[property] = color;
      this._initGradient(color, property);
      this._initPattern(color, property, callback);
      return this;
    },

    /**
     * @private
     */
    _createCanvasElement: function() {
      var element = createCanvasElement();
      if (!element) {
        throw CANVAS_INIT_ERROR;
      }
      if (!element.style) {
        element.style = { };
      }
      if (typeof element.getContext === 'undefined') {
        throw CANVAS_INIT_ERROR;
      }
      return element;
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initOptions: function (options) {
      var lowerCanvasEl = this.lowerCanvasEl;
      this._setOptions(options);

      this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
      this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;

      if (!this.lowerCanvasEl.style) {
        return;
      }

      lowerCanvasEl.width = this.width;
      lowerCanvasEl.height = this.height;

      lowerCanvasEl.style.width = this.width + 'px';
      lowerCanvasEl.style.height = this.height + 'px';

      this.viewportTransform = this.viewportTransform.slice();
    },

    /**
     * Creates a bottom canvas
     * @private
     * @param {HTMLElement} [canvasEl]
     */
    _createLowerCanvas: function (canvasEl) {
      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
      if (canvasEl && canvasEl.getContext) {
        this.lowerCanvasEl = canvasEl;
      }
      else {
        this.lowerCanvasEl = fabric.util.getById(canvasEl) || this._createCanvasElement();
      }

      fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');

      if (this.interactive) {
        this._applyCanvasStyle(this.lowerCanvasEl);
      }

      this.contextContainer = this.lowerCanvasEl.getContext('2d');
    },

    /**
     * Returns canvas width (in px)
     * @return {Number}
     */
    getWidth: function () {
      return this.width;
    },

    /**
     * Returns canvas height (in px)
     * @return {Number}
     */
    getHeight: function () {
      return this.height;
    },

    /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setWidth: function (value, options) {
      return this.setDimensions({ width: value }, options);
    },

    /**
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setHeight: function (value, options) {
      return this.setDimensions({ height: value }, options);
    },

    /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setDimensions: function (dimensions, options) {
      var cssValue;

      options = options || {};

      for (var prop in dimensions) {
        cssValue = dimensions[prop];

        if (!options.cssOnly) {
          this._setBackstoreDimension(prop, dimensions[prop]);
          cssValue += 'px';
          this.hasLostContext = true;
        }

        if (!options.backstoreOnly) {
          this._setCssDimension(prop, cssValue);
        }
      }
      if (this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
      }
      this._initRetinaScaling();
      this.calcOffset();

      if (!options.cssOnly) {
        this.requestRenderAll();
      }

      return this;
    },

    /**
     * Helper for setting width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {Number} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setBackstoreDimension: function (prop, value) {
      this.lowerCanvasEl[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl[prop] = value;
      }

      if (this.cacheCanvasEl) {
        this.cacheCanvasEl[prop] = value;
      }

      this[prop] = value;

      return this;
    },

    /**
     * Helper for setting css width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {String} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    _setCssDimension: function (prop, value) {
      this.lowerCanvasEl.style[prop] = value;

      if (this.upperCanvasEl) {
        this.upperCanvasEl.style[prop] = value;
      }

      if (this.wrapperEl) {
        this.wrapperEl.style[prop] = value;
      }

      return this;
    },

    /**
     * Returns canvas zoom level
     * @return {Number}
     */
    getZoom: function () {
      return this.viewportTransform[0];
    },

    /**
     * Sets viewport transform of this canvas instance
     * @param {Array} vpt the transform in the form of context.transform
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setViewportTransform: function (vpt) {
      var activeObject = this._activeObject, object, i, len;
      this.viewportTransform = vpt;
      for (i = 0, len = this._objects.length; i < len; i++) {
        object = this._objects[i];
        object.group || object.setCoords(true);
      }
      if (activeObject) {
        activeObject.setCoords();
      }
      this.calcViewportBoundaries();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Sets zoom level of this canvas instance, zoom centered around point
     * @param {fabric.Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    zoomToPoint: function (point, value) {
      // TODO: just change the scale, preserve other transformations
      var before = point, vpt = this.viewportTransform.slice(0);
      point = transformPoint(point, invertTransform(this.viewportTransform));
      vpt[0] = value;
      vpt[3] = value;
      var after = transformPoint(point, vpt);
      vpt[4] += before.x - after.x;
      vpt[5] += before.y - after.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    setZoom: function (value) {
      this.zoomToPoint(new fabric.Point(0, 0), value);
      return this;
    },

    /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {fabric.Point} point to move to
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    absolutePan: function (point) {
      var vpt = this.viewportTransform.slice(0);
      vpt[4] = -point.x;
      vpt[5] = -point.y;
      return this.setViewportTransform(vpt);
    },

    /**
     * Pans viewpoint relatively
     * @param {fabric.Point} point (position vector) to move by
     * @return {fabric.Canvas} instance
     * @chainable true
     */
    relativePan: function (point) {
      return this.absolutePan(new fabric.Point(
        -point.x - this.viewportTransform[4],
        -point.y - this.viewportTransform[5]
      ));
    },

    /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */
    getElement: function () {
      return this.lowerCanvasEl;
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was added
     */
    _onObjectAdded: function(obj) {
      this.stateful && obj.setupState();
      obj._set('canvas', this);
      obj.setCoords();
      this.fire('object:added', { target: obj });
      obj.fire('added');
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function(obj) {
      this.fire('object:removed', { target: obj });
      obj.fire('removed');
      delete obj.canvas;
    },

    /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clearContext: function(ctx) {
      ctx.clearRect(0, 0, this.width, this.height);
      return this;
    },

    /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */
    getContext: function () {
      return this.contextContainer;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function () {
      this._objects.length = 0;
      this.backgroundImage = null;
      this.overlayImage = null;
      this.backgroundColor = '';
      this.overlayColor = '';
      if (this._hasITextHandlers) {
        this.off('mouse:up', this._mouseUpITextHandler);
        this._iTextInstances = null;
        this._hasITextHandlers = false;
      }
      this.clearContext(this.contextContainer);
      this.fire('canvas:cleared');
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Renders the canvas
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function () {
      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._objects);
      return this;
    },

    /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAndReset: function() {
      this.isRendering = 0;
      this.renderAll();
    },

    /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    requestRenderAll: function () {
      if (!this.isRendering) {
        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
      }
      return this;
    },

    /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport using
     * object absolute coordinates ( aCoords )
     * @return {Object} points.tl
     * @chainable
     */
    calcViewportBoundaries: function() {
      var points = { }, width = this.width, height = this.height,
          iVpt = invertTransform(this.viewportTransform);
      points.tl = transformPoint({ x: 0, y: 0 }, iVpt);
      points.br = transformPoint({ x: width, y: height }, iVpt);
      points.tr = new fabric.Point(points.br.x, points.tl.y);
      points.bl = new fabric.Point(points.tl.x, points.br.y);
      this.vptCoords = points;
      return points;
    },

    cancelRequestedRender: function() {
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
    },

    /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderCanvas: function(ctx, objects) {
      var v = this.viewportTransform, path = this.clipPath;
      this.cancelRequestedRender();
      this.calcViewportBoundaries();
      this.clearContext(ctx);
      fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
      this.fire('before:render', { ctx: ctx, });
      this._renderBackground(ctx);

      ctx.save();
      //apply viewport transform once for all rendering process
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this._renderObjects(ctx, objects);
      ctx.restore();
      if (!this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }
      if (path) {
        path.canvas = this;
        // needed to setup a couple of variables
        path.shouldCache();
        path._transformDone = true;
        path.renderCache({ forClipping: true });
        this.drawClipPathOnCanvas(ctx);
      }
      this._renderOverlay(ctx);
      if (this.controlsAboveOverlay && this.interactive) {
        this.drawControls(ctx);
      }
      this.fire('after:render', { ctx: ctx, });
    },

    /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCanvas: function(ctx) {
      var v = this.viewportTransform, path = this.clipPath;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4;
      ctx.globalCompositeOperation = 'destination-in';
      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */
    _renderObjects: function(ctx, objects) {
      var i, len;
      for (i = 0, len = objects.length; i < len; ++i) {
        objects[i] && objects[i].render(ctx);
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */
    _renderBackgroundOrOverlay: function(ctx, property) {
      var fill = this[property + 'Color'], object = this[property + 'Image'],
          v = this.viewportTransform, needsVpt = this[property + 'Vpt'];
      if (!fill && !object) {
        return;
      }
      if (fill) {
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.width, 0);
        ctx.lineTo(this.width, this.height);
        ctx.lineTo(0, this.height);
        ctx.closePath();
        ctx.fillStyle = fill.toLive
          ? fill.toLive(ctx, this)
          : fill;
        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }
        ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
        var m = fill.gradientTransform || fill.patternTransform;
        m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        ctx.fill();
        ctx.restore();
      }
      if (object) {
        ctx.save();
        if (needsVpt) {
          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        }
        object.render(ctx);
        ctx.restore();
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'background');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderOverlay: function(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'overlay');
    },

    /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     */
    getCenter: function () {
      return {
        top: this.height / 2,
        left: this.width / 2
      };
    },

    /**
     * Centers object horizontally in the canvas
     * @param {fabric.Object} object Object to center horizontally
     * @return {fabric.Canvas} thisArg
     */
    centerObjectH: function (object) {
      return this._centerObject(object, new fabric.Point(this.getCenter().left, object.getCenterPoint().y));
    },

    /**
     * Centers object vertically in the canvas
     * @param {fabric.Object} object Object to center vertically
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObjectV: function (object) {
      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, this.getCenter().top));
    },

    /**
     * Centers object vertically and horizontally in the canvas
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    centerObject: function(object) {
      var center = this.getCenter();

      return this._centerObject(object, new fabric.Point(center.left, center.top));
    },

    /**
     * Centers object vertically and horizontally in the viewport
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObject: function(object) {
      var vpCenter = this.getVpCenter();

      return this._centerObject(object, vpCenter);
    },

    /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectH: function(object) {
      var vpCenter = this.getVpCenter();
      this._centerObject(object, new fabric.Point(vpCenter.x, object.getCenterPoint().y));
      return this;
    },

    /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    viewportCenterObjectV: function(object) {
      var vpCenter = this.getVpCenter();

      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, vpCenter.y));
    },

    /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {fabric.Point} vpCenter, viewport center
     * @chainable
     */
    getVpCenter: function() {
      var center = this.getCenter(),
          iVpt = invertTransform(this.viewportTransform);
      return transformPoint({ x: center.left, y: center.top }, iVpt);
    },

    /**
     * @private
     * @param {fabric.Object} object Object to center
     * @param {fabric.Point} center Center point
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    _centerObject: function(object, center) {
      object.setPositionByOrigin(center, 'center', 'center');
      object.setCoords();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Returs dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */
    toDatalessJSON: function (propertiesToInclude) {
      return this.toDatalessObject(propertiesToInclude);
    },

    /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function (propertiesToInclude) {
      return this._toObjectMethod('toObject', propertiesToInclude);
    },

    /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function (propertiesToInclude) {
      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
    },

    /**
     * @private
     */
    _toObjectMethod: function (methodName, propertiesToInclude) {

      var clipPath = this.clipPath, data = {
        version: fabric.version,
        objects: this._toObjects(methodName, propertiesToInclude),
      };
      if (clipPath) {
        data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
      }
      extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));

      fabric.util.populateWithProperties(this, data, propertiesToInclude);

      return data;
    },

    /**
     * @private
     */
    _toObjects: function(methodName, propertiesToInclude) {
      return this._objects.filter(function(object) {
        return !object.excludeFromExport;
      }).map(function(instance) {
        return this._toObject(instance, methodName, propertiesToInclude);
      }, this);
    },

    /**
     * @private
     */
    _toObject: function(instance, methodName, propertiesToInclude) {
      var originalValue;

      if (!this.includeDefaultValues) {
        originalValue = instance.includeDefaultValues;
        instance.includeDefaultValues = false;
      }

      var object = instance[methodName](propertiesToInclude);
      if (!this.includeDefaultValues) {
        instance.includeDefaultValues = originalValue;
      }
      return object;
    },

    /**
     * @private
     */
    __serializeBgOverlay: function(methodName, propertiesToInclude) {
      var data = { }, bgImage = this.backgroundImage, overlay = this.overlayImage;

      if (this.backgroundColor) {
        data.background = this.backgroundColor.toObject
          ? this.backgroundColor.toObject(propertiesToInclude)
          : this.backgroundColor;
      }

      if (this.overlayColor) {
        data.overlay = this.overlayColor.toObject
          ? this.overlayColor.toObject(propertiesToInclude)
          : this.overlayColor;
      }
      if (bgImage && !bgImage.excludeFromExport) {
        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
      }
      if (overlay && !overlay.excludeFromExport) {
        data.overlayImage = this._toObject(overlay, methodName, propertiesToInclude);
      }

      return data;
    },

    /* _TO_SVG_START_ */
    /**
     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
     * a zoomed canvas will then produce zoomed SVG output.
     * @type Boolean
     * @default
     */
    svgViewportTransformation: true,

    /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-cooridnate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */
    toSVG: function(options, reviver) {
      options || (options = { });
      options.reviver = reviver;
      var markup = [];

      this._setSVGPreamble(markup, options);
      this._setSVGHeader(markup, options);
      if (this.clipPath) {
        markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
      }
      this._setSVGBgOverlayColor(markup, 'background');
      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
      this._setSVGObjects(markup, reviver);
      if (this.clipPath) {
        markup.push('</g>\n');
      }
      this._setSVGBgOverlayColor(markup, 'overlay');
      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);

      markup.push('</svg>');

      return markup.join('');
    },

    /**
     * @private
     */
    _setSVGPreamble: function(markup, options) {
      if (options.suppressPreamble) {
        return;
      }
      markup.push(
        '<?xml version="1.0" encoding="', (options.encoding || 'UTF-8'), '" standalone="no" ?>\n',
        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
        '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
      );
    },

    /**
     * @private
     */
    _setSVGHeader: function(markup, options) {
      var width = options.width || this.width,
          height = options.height || this.height,
          vpt, viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      if (options.viewBox) {
        viewBox = 'viewBox="' +
                options.viewBox.x + ' ' +
                options.viewBox.y + ' ' +
                options.viewBox.width + ' ' +
                options.viewBox.height + '" ';
      }
      else {
        if (this.svgViewportTransformation) {
          vpt = this.viewportTransform;
          viewBox = 'viewBox="' +
                  toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
                  toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
        }
      }

      markup.push(
        '<svg ',
        'xmlns="http://www.w3.org/2000/svg" ',
        'xmlns:xlink="http://www.w3.org/1999/xlink" ',
        'version="1.1" ',
        'width="', width, '" ',
        'height="', height, '" ',
        viewBox,
        'xml:space="preserve">\n',
        '<desc>Created with Fabric.js ', fabric.version, '</desc>\n',
        '<defs>\n',
        this.createSVGFontFacesMarkup(),
        this.createSVGRefElementsMarkup(),
        this.createSVGClipPathMarkup(options),
        '</defs>\n'
      );
    },

    createSVGClipPathMarkup: function(options) {
      var clipPath = this.clipPath;
      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        return  '<clipPath id="' + clipPath.clipPathId + '" >\n' +
          this.clipPath.toClipPathSVG(options.reviver) +
          '</clipPath>\n';
      }
      return '';
    },

    /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */
    createSVGRefElementsMarkup: function() {
      var _this = this,
          markup = ['background', 'overlay'].map(function(prop) {
            var fill = _this[prop + 'Color'];
            if (fill && fill.toLive) {
              var shouldTransform = _this[prop + 'Vpt'], vpt = _this.viewportTransform,
                  object = {
                    width: _this.width / (shouldTransform ? vpt[0] : 1),
                    height: _this.height / (shouldTransform ? vpt[3] : 1)
                  };
              return fill.toSVG(
                object,
                { additionalTransform: shouldTransform ? fabric.util.matrixToSVG(vpt) : '' }
              );
            }
          });
      return markup.join('');
    },

    /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */
    createSVGFontFacesMarkup: function() {
      var markup = '', fontList = { }, obj, fontFamily,
          style, row, rowIndex, _char, charIndex, i, len,
          fontPaths = fabric.fontPaths, objects = [];

      this._objects.forEach(function add(object) {
        objects.push(object);
        if (object._objects) {
          object._objects.forEach(add);
        }
      });

      for (i = 0, len = objects.length; i < len; i++) {
        obj = objects[i];
        fontFamily = obj.fontFamily;
        if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
          continue;
        }
        fontList[fontFamily] = true;
        if (!obj.styles) {
          continue;
        }
        style = obj.styles;
        for (rowIndex in style) {
          row = style[rowIndex];
          for (charIndex in row) {
            _char = row[charIndex];
            fontFamily = _char.fontFamily;
            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
              fontList[fontFamily] = true;
            }
          }
        }
      }

      for (var j in fontList) {
        markup += [
          '\t\t@font-face {\n',
          '\t\t\tfont-family: \'', j, '\';\n',
          '\t\t\tsrc: url(\'', fontPaths[j], '\');\n',
          '\t\t}\n'
        ].join('');
      }

      if (markup) {
        markup = [
          '\t<style type="text/css">',
          '<![CDATA[\n',
          markup,
          ']]>',
          '</style>\n'
        ].join('');
      }

      return markup;
    },

    /**
     * @private
     */
    _setSVGObjects: function(markup, reviver) {
      var instance, i, len, objects = this._objects;
      for (i = 0, len = objects.length; i < len; i++) {
        instance = objects[i];
        if (instance.excludeFromExport) {
          continue;
        }
        this._setSVGObject(markup, instance, reviver);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function(markup, instance, reviver) {
      markup.push(instance.toSVG(reviver));
    },

    /**
     * @private
     */
    _setSVGBgOverlayImage: function(markup, property, reviver) {
      if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
        markup.push(this[property].toSVG(reviver));
      }
    },

    /**
     * @private
     */
    _setSVGBgOverlayColor: function(markup, property) {
      var filler = this[property + 'Color'], vpt = this.viewportTransform, finalWidth = this.width,
          finalHeight = this.height;
      if (!filler) {
        return;
      }
      if (filler.toLive) {
        var repeat = filler.repeat, iVpt = fabric.util.invertTransform(vpt), shouldInvert = this[property + 'Vpt'],
            additionalTransform = shouldInvert ? fabric.util.matrixToSVG(iVpt) : '';
        markup.push(
          '<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"',
          ' x="', filler.offsetX - finalWidth / 2,
          '" y="', filler.offsetY - finalHeight / 2, '" ',
          'width="',
          (repeat === 'repeat-y' || repeat === 'no-repeat'
            ? filler.source.width
            : finalWidth ),
          '" height="',
          (repeat === 'repeat-x' || repeat === 'no-repeat'
            ? filler.source.height
            : finalHeight),
          '" fill="url(#SVGID_' + filler.id + ')"',
          '></rect>\n'
        );
      }
      else {
        markup.push(
          '<rect x="0" y="0" width="100%" height="100%" ',
          'fill="', filler, '"',
          '></rect>\n'
        );
      }
    },
    /* _TO_SVG_END_ */

    /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendToBack: function (object) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, objs;
      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = objs.length; i--;) {
          obj = objs[i];
          removeFromArray(this._objects, obj);
          this._objects.unshift(obj);
        }
      }
      else {
        removeFromArray(this._objects, object);
        this._objects.unshift(object);
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringToFront: function (object) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, objs;
      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          removeFromArray(this._objects, obj);
          this._objects.push(obj);
        }
      }
      else {
        removeFromArray(this._objects, object);
        this._objects.push(object);
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional paramter, intersecting allowes to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    sendBackwards: function (object, intersecting) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, idx, newIdx, objs, objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = 0; i < objs.length; i++) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);
          if (idx > 0 + objsMoved) {
            newIdx = idx - 1;
            removeFromArray(this._objects, obj);
            this._objects.splice(newIdx, 0, obj);
          }
          objsMoved++;
        }
      }
      else {
        idx = this._objects.indexOf(object);
        if (idx !== 0) {
          // if object is not on the bottom of stack
          newIdx = this._findNewLowerIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
        }
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewLowerIndex: function(object, idx, intersecting) {
      var newIdx, i;

      if (intersecting) {
        newIdx = idx;

        // traverse down the stack looking for the nearest intersecting object
        for (i = idx - 1; i >= 0; --i) {

          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
                               object.isContainedWithinObject(this._objects[i]) ||
                               this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      }
      else {
        newIdx = idx - 1;
      }

      return newIdx;
    },

    /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional paramter, intersecting allowes to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    bringForward: function (object, intersecting) {
      if (!object) {
        return this;
      }
      var activeSelection = this._activeObject,
          i, obj, idx, newIdx, objs, objsMoved = 0;

      if (object === activeSelection && object.type === 'activeSelection') {
        objs = activeSelection._objects;
        for (i = objs.length; i--;) {
          obj = objs[i];
          idx = this._objects.indexOf(obj);
          if (idx < this._objects.length - 1 - objsMoved) {
            newIdx = idx + 1;
            removeFromArray(this._objects, obj);
            this._objects.splice(newIdx, 0, obj);
          }
          objsMoved++;
        }
      }
      else {
        idx = this._objects.indexOf(object);
        if (idx !== this._objects.length - 1) {
          // if object is not on top of stack (last item in an array)
          newIdx = this._findNewUpperIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
        }
      }
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },

    /**
     * @private
     */
    _findNewUpperIndex: function(object, idx, intersecting) {
      var newIdx, i, len;

      if (intersecting) {
        newIdx = idx;

        // traverse up the stack looking for the nearest intersecting object
        for (i = idx + 1, len = this._objects.length; i < len; ++i) {

          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
                               object.isContainedWithinObject(this._objects[i]) ||
                               this._objects[i].isContainedWithinObject(object);

          if (isIntersecting) {
            newIdx = i;
            break;
          }
        }
      }
      else {
        newIdx = idx + 1;
      }

      return newIdx;
    },

    /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {Number} index Position to move to
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    moveTo: function (object, index) {
      removeFromArray(this._objects, object);
      this._objects.splice(index, 0, object);
      return this.renderOnAddRemove && this.requestRenderAll();
    },

    /**
     * Clears a canvas element and dispose objects
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function () {
      // cancel eventually ongoing renders
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
      this.forEachObject(function(object) {
        object.dispose && object.dispose();
      });
      this._objects = [];
      if (this.backgroundImage && this.backgroundImage.dispose) {
        this.backgroundImage.dispose();
      }
      this.backgroundImage = null;
      if (this.overlayImage && this.overlayImage.dispose) {
        this.overlayImage.dispose();
      }
      this.overlayImage = null;
      this._iTextInstances = null;
      this.contextContainer = null;
      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
      this.lowerCanvasEl = undefined;
      return this;
    },

    /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function () {
      return '#<fabric.Canvas (' + this.complexity() + '): ' +
               '{ objects: ' + this._objects.length + ' }>';
    }
  });

  extend(fabric.StaticCanvas.prototype, fabric.Observable);
  extend(fabric.StaticCanvas.prototype, fabric.Collection);
  extend(fabric.StaticCanvas.prototype, fabric.DataURLExporter);

  extend(fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {

    /**
     * @static
     * @type String
     * @default
     */
    EMPTY_JSON: '{"objects": [], "background": "white"}',

    /**
     * Provides a way to check support of some of the canvas methods
     * (either those of HTMLCanvasElement itself, or rendering context)
     *
     * @param {String} methodName Method to check support for;
     *                            Could be one of "setLineDash"
     * @return {Boolean | null} `true` if method is supported (or at least exists),
     *                          `null` if canvas element or context can not be initialized
     */
    supports: function (methodName) {
      var el = createCanvasElement();

      if (!el || !el.getContext) {
        return null;
      }

      var ctx = el.getContext('2d');
      if (!ctx) {
        return null;
      }

      switch (methodName) {

        case 'setLineDash':
          return typeof ctx.setLineDash !== 'undefined';

        default:
          return null;
      }
    }
  });

  /**
   * Returns JSON representation of canvas
   * @function
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {String} JSON string
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * canvas.includeDefaultValues = false;
   * var json = canvas.toJSON();
   */
  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;

  if (fabric.isLikelyNode) {
    fabric.StaticCanvas.prototype.createPNGStream = function() {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createPNGStream();
    };
    fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
      var impl = getNodeCanvas(this.lowerCanvasEl);
      return impl && impl.createJPEGStream(opts);
    };
  }
})();


/**
 * BaseBrush class
 * @class fabric.BaseBrush
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */
fabric.BaseBrush = fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {

  /**
   * Color of a brush
   * @type String
   * @default
   */
  color: 'rgb(0, 0, 0)',

  /**
   * Width of a brush, has to be a Number, no string literals
   * @type Number
   * @default
   */
  width: 1,

  /**
   * Shadow object representing shadow of this shape.
   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
   * @type fabric.Shadow
   * @default
   */
  shadow: null,

  /**
   * Line endings style of a brush (one of "butt", "round", "square")
   * @type String
   * @default
   */
  strokeLineCap: 'round',

  /**
   * Corner style of a brush (one of "bevel", "round", "miter")
   * @type String
   * @default
   */
  strokeLineJoin: 'round',

  /**
   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
   * @type Number
   * @default
   */
  strokeMiterLimit:         10,

  /**
   * Stroke Dash Array.
   * @type Array
   * @default
   */
  strokeDashArray: null,

  /**
   * Sets brush styles
   * @private
   */
  _setBrushStyles: function() {
    var ctx = this.canvas.contextTop;
    ctx.strokeStyle = this.color;
    ctx.lineWidth = this.width;
    ctx.lineCap = this.strokeLineCap;
    ctx.miterLimit = this.strokeMiterLimit;
    ctx.lineJoin = this.strokeLineJoin;
    if (fabric.StaticCanvas.supports('setLineDash')) {
      ctx.setLineDash(this.strokeDashArray || []);
    }
  },

  /**
   * Sets the transformation on given context
   * @param {RenderingContext2d} ctx context to render on
   * @private
   */
  _saveAndTransform: function(ctx) {
    var v = this.canvas.viewportTransform;
    ctx.save();
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
  },

  /**
   * Sets brush shadow styles
   * @private
   */
  _setShadow: function() {
    if (!this.shadow) {
      return;
    }

    var canvas = this.canvas,
        shadow = this.shadow,
        ctx = canvas.contextTop,
        zoom = canvas.getZoom();
    if (canvas && canvas._isRetinaScaling()) {
      zoom *= fabric.devicePixelRatio;
    }

    ctx.shadowColor = shadow.color;
    ctx.shadowBlur = shadow.blur * zoom;
    ctx.shadowOffsetX = shadow.offsetX * zoom;
    ctx.shadowOffsetY = shadow.offsetY * zoom;
  },

  needsFullRender: function() {
    var color = new fabric.Color(this.color);
    return color.getAlpha() < 1 || !!this.shadow;
  },

  /**
   * Removes brush shadow styles
   * @private
   */
  _resetShadow: function() {
    var ctx = this.canvas.contextTop;

    ctx.shadowColor = '';
    ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
  }
});


(function() {
  /**
   * PencilBrush class
   * @class fabric.PencilBrush
   * @extends fabric.BaseBrush
   */
  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {

    /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */
    decimate: 0.4,

    /**
     * Constructor
     * @param {fabric.Canvas} canvas
     * @return {fabric.PencilBrush} Instance of a pencil brush
     */
    initialize: function(canvas) {
      this.canvas = canvas;
      this._points = [];
    },

    /**
     * Invoked inside on mouse down and mouse move
     * @param {Object} pointer
     */
    _drawSegment: function (ctx, p1, p2) {
      var midPoint = p1.midPointFrom(p2);
      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
      return midPoint;
    },

    /**
     * Inovoked on mouse down
     * @param {Object} pointer
     */
    onMouseDown: function(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }
      this._prepareForDrawing(pointer);
      // capture coordinates immediately
      // this allows to draw dots (when movement never occurs)
      this._captureDrawingPath(pointer);
      this._render();
    },

    /**
     * Inovoked on mouse move
     * @param {Object} pointer
     */
    onMouseMove: function(pointer, options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return;
      }
      if (this._captureDrawingPath(pointer) && this._points.length > 1) {
        if (this.needsFullRender()) {
          // redraw curve
          // clear top canvas
          this.canvas.clearContext(this.canvas.contextTop);
          this._render();
        }
        else {
          var points = this._points, length = points.length, ctx = this.canvas.contextTop;
          // draw the curve update
          this._saveAndTransform(ctx);
          if (this.oldEnd) {
            ctx.beginPath();
            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
          }
          this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
          ctx.stroke();
          ctx.restore();
        }
      }
    },

    /**
     * Invoked on mouse up
     */
    onMouseUp: function(options) {
      if (!this.canvas._isMainEvent(options.e)) {
        return true;
      }
      this.oldEnd = undefined;
      this._finalizeAndAddPath();
      return false;
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _prepareForDrawing: function(pointer) {

      var p = new fabric.Point(pointer.x, pointer.y);

      this._reset();
      this._addPoint(p);
      this.canvas.contextTop.moveTo(p.x, p.y);
    },

    /**
     * @private
     * @param {fabric.Point} point Point to be added to points array
     */
    _addPoint: function(point) {
      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
        return false;
      }
      this._points.push(point);
      return true;
    },

    /**
     * Clear points array and set contextTop canvas style.
     * @private
     */
    _reset: function() {
      this._points = [];
      this._setBrushStyles();
      this._setShadow();
    },

    /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */
    _captureDrawingPath: function(pointer) {
      var pointerPoint = new fabric.Point(pointer.x, pointer.y);
      return this._addPoint(pointerPoint);
    },

    /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     */
    _render: function() {
      var ctx  = this.canvas.contextTop, i, len,
          p1 = this._points[0],
          p2 = this._points[1];

      this._saveAndTransform(ctx);
      ctx.beginPath();
      //if we only have 2 points in the path and they are the same
      //it means that the user only clicked the canvas without moving the mouse
      //then we should be drawing a dot. A path isn't drawn between two identical dots
      //that's why we set them apart a bit
      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
        var width = this.width / 1000;
        p1 = new fabric.Point(p1.x, p1.y);
        p2 = new fabric.Point(p2.x, p2.y);
        p1.x -= width;
        p2.x += width;
      }
      ctx.moveTo(p1.x, p1.y);

      for (i = 1, len = this._points.length; i < len; i++) {
        // we pick the point between pi + 1 & pi + 2 as the
        // end point and p1 as our control point.
        this._drawSegment(ctx, p1, p2);
        p1 = this._points[i];
        p2 = this._points[i + 1];
      }
      // Draw last line as a straight line while
      // we wait for the next point to be able to calculate
      // the bezier control point
      ctx.lineTo(p1.x, p1.y);
      ctx.stroke();
      ctx.restore();
    },

    /**
     * Converts points to SVG path
     * @param {Array} points Array of points
     * @return {String} SVG path
     */
    convertPointsToSVGPath: function(points) {
      var path = [], i, width = this.width / 1000,
          p1 = new fabric.Point(points[0].x, points[0].y),
          p2 = new fabric.Point(points[1].x, points[1].y),
          len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;

      if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
      }
      path.push('M ', p1.x - multSignX * width, ' ', p1.y - multSignY * width, ' ');
      for (i = 1; i < len; i++) {
        if (!p1.eq(p2)) {
          var midPoint = p1.midPointFrom(p2);
          // p1 is our bezier control point
          // midpoint is our endpoint
          // start point is p(i-1) value.
          path.push('Q ', p1.x, ' ', p1.y, ' ', midPoint.x, ' ', midPoint.y, ' ');
        }
        p1 = points[i];
        if ((i + 1) < points.length) {
          p2 = points[i + 1];
        }
      }
      if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
      }
      path.push('L ', p1.x + multSignX * width, ' ', p1.y + multSignY * width);
      return path;
    },

    /**
     * Creates fabric.Path object to add on canvas
     * @param {String} pathData Path data
     * @return {fabric.Path} Path to add on canvas
     */
    createPath: function(pathData) {
      var path = new fabric.Path(pathData, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray,
      });
      if (this.shadow) {
        this.shadow.affectStroke = true;
        path.shadow = new fabric.Shadow(this.shadow);
      }

      return path;
    },

    /**
     * Decimate poins array with the decimate value
     */
    decimatePoints: function(points, distance) {
      if (points.length <= 2) {
        return points;
      }
      var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2),
          i, l = points.length - 1, lastPoint = points[0], newPoints = [lastPoint],
          cDistance;
      for (i = 1; i < l; i++) {
        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
        if (cDistance >= adjustedDistance) {
          lastPoint = points[i];
          newPoints.push(lastPoint);
        }
      }
      if (newPoints.length === 1) {
        newPoints.push(new fabric.Point(newPoints[0].x, newPoints[0].y));
      }
      return newPoints;
    },

    /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new fabric path object
     * and add it to the fabric canvas.
     */
    _finalizeAndAddPath: function() {
      var ctx = this.canvas.contextTop;
      ctx.closePath();
      if (this.decimate) {
        this._points = this.decimatePoints(this._points, this.decimate);
      }
      var pathData = this.convertPointsToSVGPath(this._points).join('');
      if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
        // do not create 0 width/height paths, as they are
        // rendered inconsistently across browsers
        // Firefox 4, for example, renders a dot,
        // whereas Chrome 10 renders nothing
        this.canvas.requestRenderAll();
        return;
      }

      var path = this.createPath(pathData);
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.fire('before:path:created', { path: path });
      this.canvas.add(path);
      this.canvas.requestRenderAll();
      path.setCoords();
      this._resetShadow();


      // fire event 'path' created
      this.canvas.fire('path:created', { path: path });
    }
  });
})();


/**
 * CircleBrush class
 * @class fabric.CircleBrush
 */
fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {

  /**
   * Width of a brush
   * @type Number
   * @default
   */
  width: 10,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.CircleBrush} Instance of a circle brush
   */
  initialize: function(canvas) {
    this.canvas = canvas;
    this.points = [];
  },

  /**
   * Invoked inside on mouse down and mouse move
   * @param {Object} pointer
   */
  drawDot: function(pointer) {
    var point = this.addPoint(pointer),
        ctx = this.canvas.contextTop;
    this._saveAndTransform(ctx);
    this.dot(ctx, point);
    ctx.restore();
  },

  dot: function(ctx, point) {
    ctx.fillStyle = point.fill;
    ctx.beginPath();
    ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
    ctx.closePath();
    ctx.fill();
  },

  /**
   * Invoked on mouse down
   */
  onMouseDown: function(pointer) {
    this.points.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);
    this._setShadow();
    this.drawDot(pointer);
  },

  /**
   * Render the full state of the brush
   * @private
   */
  _render: function() {
    var ctx  = this.canvas.contextTop, i, len,
        points = this.points;
    this._saveAndTransform(ctx);
    for (i = 0, len = points.length; i < len; i++) {
      this.dot(ctx, points[i]);
    }
    ctx.restore();
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function(pointer) {
    if (this.needsFullRender()) {
      this.canvas.clearContext(this.canvas.contextTop);
      this.addPoint(pointer);
      this._render();
    }
    else {
      this.drawDot(pointer);
    }
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
    this.canvas.renderOnAddRemove = false;

    var circles = [];

    for (i = 0, len = this.points.length; i < len; i++) {
      var point = this.points[i],
          circle = new fabric.Circle({
            radius: point.radius,
            left: point.x,
            top: point.y,
            originX: 'center',
            originY: 'center',
            fill: point.fill
          });

      this.shadow && (circle.shadow = new fabric.Shadow(this.shadow));

      circles.push(circle);
    }
    var group = new fabric.Group(circles);
    group.canvas = this.canvas;

    this.canvas.fire('before:path:created', { path: group });
    this.canvas.add(group);
    this.canvas.fire('path:created', { path: group });

    this.canvas.clearContext(this.canvas.contextTop);
    this._resetShadow();
    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @param {Object} pointer
   * @return {fabric.Point} Just added pointer point
   */
  addPoint: function(pointer) {
    var pointerPoint = new fabric.Point(pointer.x, pointer.y),

        circleRadius = fabric.util.getRandomInt(
          Math.max(0, this.width - 20), this.width + 20) / 2,

        circleColor = new fabric.Color(this.color)
          .setAlpha(fabric.util.getRandomInt(0, 100) / 100)
          .toRgba();

    pointerPoint.radius = circleRadius;
    pointerPoint.fill = circleColor;

    this.points.push(pointerPoint);

    return pointerPoint;
  }
});


/**
 * SprayBrush class
 * @class fabric.SprayBrush
 */
fabric.SprayBrush = fabric.util.createClass( fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {

  /**
   * Width of a spray
   * @type Number
   * @default
   */
  width:              10,

  /**
   * Density of a spray (number of dots per chunk)
   * @type Number
   * @default
   */
  density:            20,

  /**
   * Width of spray dots
   * @type Number
   * @default
   */
  dotWidth:           1,

  /**
   * Width variance of spray dots
   * @type Number
   * @default
   */
  dotWidthVariance:   1,

  /**
   * Whether opacity of a dot should be random
   * @type Boolean
   * @default
   */
  randomOpacity:        false,

  /**
   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
   * @type Boolean
   * @default
   */
  optimizeOverlapping:  true,

  /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.SprayBrush} Instance of a spray brush
   */
  initialize: function(canvas) {
    this.canvas = canvas;
    this.sprayChunks = [];
  },

  /**
   * Invoked on mouse down
   * @param {Object} pointer
   */
  onMouseDown: function(pointer) {
    this.sprayChunks.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);
    this._setShadow();

    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse move
   * @param {Object} pointer
   */
  onMouseMove: function(pointer) {
    this.addSprayChunk(pointer);
    this.render(this.sprayChunkPoints);
  },

  /**
   * Invoked on mouse up
   */
  onMouseUp: function() {
    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
    this.canvas.renderOnAddRemove = false;

    var rects = [];

    for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      var sprayChunk = this.sprayChunks[i];

      for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {

        var rect = new fabric.Rect({
          width: sprayChunk[j].width,
          height: sprayChunk[j].width,
          left: sprayChunk[j].x + 1,
          top: sprayChunk[j].y + 1,
          originX: 'center',
          originY: 'center',
          fill: this.color
        });
        rects.push(rect);
      }
    }

    if (this.optimizeOverlapping) {
      rects = this._getOptimizedRects(rects);
    }

    var group = new fabric.Group(rects);
    this.shadow && group.set('shadow', new fabric.Shadow(this.shadow));
    this.canvas.fire('before:path:created', { path: group });
    this.canvas.add(group);
    this.canvas.fire('path:created', { path: group });

    this.canvas.clearContext(this.canvas.contextTop);
    this._resetShadow();
    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
    this.canvas.requestRenderAll();
  },

  /**
   * @private
   * @param {Array} rects
   */
  _getOptimizedRects: function(rects) {

    // avoid creating duplicate rects at the same coordinates
    var uniqueRects = { }, key, i, len;

    for (i = 0, len = rects.length; i < len; i++) {
      key = rects[i].left + '' + rects[i].top;
      if (!uniqueRects[key]) {
        uniqueRects[key] = rects[i];
      }
    }
    var uniqueRectsArray = [];
    for (key in uniqueRects) {
      uniqueRectsArray.push(uniqueRects[key]);
    }

    return uniqueRectsArray;
  },

  /**
   * Render new chunk of spray brush
   */
  render: function(sprayChunk) {
    var ctx = this.canvas.contextTop, i, len;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, len = sprayChunk.length; i < len; i++) {
      var point = sprayChunk[i];
      if (typeof point.opacity !== 'undefined') {
        ctx.globalAlpha = point.opacity;
      }
      ctx.fillRect(point.x, point.y, point.width, point.width);
    }
    ctx.restore();
  },

  /**
   * Render all spray chunks
   */
  _render: function() {
    var ctx = this.canvas.contextTop, i, ilen;
    ctx.fillStyle = this.color;

    this._saveAndTransform(ctx);

    for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
      this.render(this.sprayChunks[i]);
    }
    ctx.restore();
  },

  /**
   * @param {Object} pointer
   */
  addSprayChunk: function(pointer) {
    this.sprayChunkPoints = [];

    var x, y, width, radius = this.width / 2, i;

    for (i = 0; i < this.density; i++) {

      x = fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
      y = fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);

      if (this.dotWidthVariance) {
        width = fabric.util.getRandomInt(
          // bottom clamp width to 1
          Math.max(1, this.dotWidth - this.dotWidthVariance),
          this.dotWidth + this.dotWidthVariance);
      }
      else {
        width = this.dotWidth;
      }

      var point = new fabric.Point(x, y);
      point.width = width;

      if (this.randomOpacity) {
        point.opacity = fabric.util.getRandomInt(0, 100) / 100;
      }

      this.sprayChunkPoints.push(point);
    }

    this.sprayChunks.push(this.sprayChunkPoints);
  }
});


/**
 * PatternBrush class
 * @class fabric.PatternBrush
 * @extends fabric.BaseBrush
 */
fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {

  getPatternSrc: function() {

    var dotWidth = 20,
        dotDistance = 5,
        patternCanvas = fabric.util.createCanvasElement(),
        patternCtx = patternCanvas.getContext('2d');

    patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;

    patternCtx.fillStyle = this.color;
    patternCtx.beginPath();
    patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
    patternCtx.closePath();
    patternCtx.fill();

    return patternCanvas;
  },

  getPatternSrcFunction: function() {
    return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
  },

  /**
   * Creates "pattern" instance property
   */
  getPattern: function() {
    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), 'repeat');
  },

  /**
   * Sets brush styles
   */
  _setBrushStyles: function() {
    this.callSuper('_setBrushStyles');
    this.canvas.contextTop.strokeStyle = this.getPattern();
  },

  /**
   * Creates path
   */
  createPath: function(pathData) {
    var path = this.callSuper('createPath', pathData),
        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);

    path.stroke = new fabric.Pattern({
      source: this.source || this.getPatternSrcFunction(),
      offsetX: -topLeft.x,
      offsetY: -topLeft.y
    });
    return path;
  }
});


(function() {

  var getPointer = fabric.util.getPointer,
      degreesToRadians = fabric.util.degreesToRadians,
      abs = Math.abs,
      supportLineDash = fabric.StaticCanvas.supports('setLineDash'),
      isTouchEvent = fabric.util.isTouchEvent,
      STROKE_OFFSET = 0.5;

  /**
   * Canvas class
   * @class fabric.Canvas
   * @extends fabric.StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   * @see {@link fabric.Canvas#initialize} for constructor definition
   *
   * @fires object:modified at the end of a transform or any change when statefull is true
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   * the following events are deprecated:
   * @fires object:rotated at the end of a rotation transform
   * @fires object:scaled at the end of a scale transform
   * @fires object:moved at the end of translation transform
   * @fires object:skewed at the end of a skew transform
   */
  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {

    /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(el, options) {
      options || (options = { });
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);
      this._initStatic(el, options);
      this._initInteractive();
      this._createCacheCanvas();
    },

    /**
     * When true, objects can be transformed by one side (unproportionally)
     * when dragged on the corners that normally would not do that.
     * @type Boolean
     * @default
     * @since fabric 4.0 // changed name and default value
     */
    uniformScaling:      true,

    /**
     * Indicates which key switches uniform scaling.
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * totally wrong named. this sounds like `uniform scaling`
     * if Canvas.uniformScaling is true, pressing this will set it to false
     * and viceversa.
     * @since 1.6.2
     * @type String
     * @default
     */
    uniScaleKey:           'shiftKey',

    /**
     * When true, objects use center point as the origin of scale transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling:        false,

    /**
     * When true, objects use center point as the origin of rotate transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation:       false,

    /**
     * Indicates which key enable centered Transform
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    centeredKey:           'altKey',

    /**
     * Indicates which key enable alternate action on corner
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */
    altActionKey:           'shiftKey',

    /**
     * Indicates that canvas is interactive. This property should not be changed.
     * @type Boolean
     * @default
     */
    interactive:            true,

    /**
     * Indicates whether group selection should be enabled
     * @type Boolean
     * @default
     */
    selection:              true,

    /**
     * Indicates which key or keys enable multiple click selection
     * Pass value as a string or array of strings
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or empty or containing any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.2
     * @type String|Array
     * @default
     */
    selectionKey:           'shiftKey',

    /**
     * Indicates which key enable alternative selection
     * in case of target overlapping with active object
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * For a series of reason that come from the general expectations on how
     * things should work, this feature works only for preserveObjectStacking true.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.5
     * @type null|String
     * @default
     */
    altSelectionKey:           null,

    /**
     * Color of selection
     * @type String
     * @default
     */
    selectionColor:         'rgba(100, 100, 255, 0.3)', // blue

    /**
     * Default dash array pattern
     * If not empty the selection border is dashed
     * @type Array
     */
    selectionDashArray:     [],

    /**
     * Color of the border of selection (usually slightly darker than color of selection itself)
     * @type String
     * @default
     */
    selectionBorderColor:   'rgba(255, 255, 255, 0.3)',

    /**
     * Width of a line used in object/group selection
     * @type Number
     * @default
     */
    selectionLineWidth:     1,

    /**
     * Select only shapes that are fully contained in the dragged selection rectangle.
     * @type Boolean
     * @default
     */
    selectionFullyContained: false,

    /**
     * Default cursor value used when hovering over an object on canvas
     * @type String
     * @default
     */
    hoverCursor:            'move',

    /**
     * Default cursor value used when moving an object on canvas
     * @type String
     * @default
     */
    moveCursor:             'move',

    /**
     * Default cursor value used for the entire canvas
     * @type String
     * @default
     */
    defaultCursor:          'default',

    /**
     * Cursor value used during free drawing
     * @type String
     * @default
     */
    freeDrawingCursor:      'crosshair',

    /**
     * Cursor value used for rotation point
     * @type String
     * @default
     */
    rotationCursor:         'crosshair',

    /**
     * Cursor value used for disabled elements ( corners with disabled action )
     * @type String
     * @since 2.0.0
     * @default
     */
    notAllowedCursor:         'not-allowed',

    /**
     * Default element class that's given to wrapper (div) element of canvas
     * @type String
     * @default
     */
    containerClass:         'canvas-container',

    /**
     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
     * @type Boolean
     * @default
     */
    perPixelTargetFind:     false,

    /**
     * Number of pixels around target pixel to tolerate (consider active) during object detection
     * @type Number
     * @default
     */
    targetFindTolerance:    0,

    /**
     * When true, target detection is skipped. Target detection will return always undefined.
     * click selection won't work anymore, events will fire with no targets.
     * if something is selected before setting it to true, it will be deselected at the first click.
     * area selection will still work. check the `selection` property too.
     * if you deactivate both, you should look into staticCanvas.
     * @type Boolean
     * @default
     */
    skipTargetFind:         false,

    /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */
    isDrawingMode:          false,

    /**
     * Indicates whether objects should remain in current stack position when selected.
     * When false objects are brought to top and rendered as part of the selection group
     * @type Boolean
     * @default
     */
    preserveObjectStacking: false,

    /**
     * Indicates the angle that an object will lock to while rotating.
     * @type Number
     * @since 1.6.7
     * @default
     */
    snapAngle: 0,

    /**
     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
     * When `null`, the snapThreshold will default to the snapAngle.
     * @type null|Number
     * @since 1.6.7
     * @default
     */
    snapThreshold: null,

    /**
     * Indicates if the right click on canvas can output the context menu or not
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    stopContextMenu: false,

    /**
     * Indicates if the canvas can fire right click events
     * @type Boolean
     * @since 1.6.5
     * @default
     */
    fireRightClick: false,

    /**
     * Indicates if the canvas can fire middle click events
     * @type Boolean
     * @since 1.7.8
     * @default
     */
    fireMiddleClick: false,

    /**
     * Keep track of the subTargets for Mouse Events
     * @type fabric.Object[]
     */
    targets: [],

    /**
     * Keep track of the hovered target
     * @type fabric.Object
     * @private
     */
    _hoveredTarget: null,

    /**
     * hold the list of nested targets hovered
     * @type fabric.Object[]
     * @private
     */
    _hoveredTargets: [],

    /**
     * @private
     */
    _initInteractive: function() {
      this._currentTransform = null;
      this._groupSelector = null;
      this._initWrapperElement();
      this._createUpperCanvas();
      this._initEventListeners();

      this._initRetinaScaling();

      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);

      this.calcOffset();
    },

    /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */
    _chooseObjectsToRender: function() {
      var activeObjects = this.getActiveObjects(),
          object, objsToRender, activeGroupObjects;

      if (activeObjects.length > 0 && !this.preserveObjectStacking) {
        objsToRender = [];
        activeGroupObjects = [];
        for (var i = 0, length = this._objects.length; i < length; i++) {
          object = this._objects[i];
          if (activeObjects.indexOf(object) === -1 ) {
            objsToRender.push(object);
          }
          else {
            activeGroupObjects.push(object);
          }
        }
        if (activeObjects.length > 1) {
          this._activeObject._objects = activeGroupObjects;
        }
        objsToRender.push.apply(objsToRender, activeGroupObjects);
      }
      else {
        objsToRender = this._objects;
      }
      return objsToRender;
    },

    /**
     * Renders both the top canvas and the secondary container canvas.
     * @return {fabric.Canvas} instance
     * @chainable
     */
    renderAll: function () {
      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
        this.clearContext(this.contextTop);
        this.contextTopDirty = false;
      }
      if (this.hasLostContext) {
        this.renderTopLayer(this.contextTop);
      }
      var canvasToDrawOn = this.contextContainer;
      this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
      return this;
    },

    renderTopLayer: function(ctx) {
      ctx.save();
      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._render();
        this.contextTopDirty = true;
      }
      // we render the top context - last object
      if (this.selection && this._groupSelector) {
        this._drawSelection(ctx);
        this.contextTopDirty = true;
      }
      ctx.restore();
    },

    /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    renderTop: function () {
      var ctx = this.contextTop;
      this.clearContext(ctx);
      this.renderTopLayer(ctx);
      this.fire('after:render');
      return this;
    },

    /**
     * @private
     */
    _normalizePointer: function (object, pointer) {
      var m = object.calcTransformMatrix(),
          invertedM = fabric.util.invertTransform(m),
          vptPointer = this.restorePointerVpt(pointer);
      return fabric.util.transformPoint(vptPointer, invertedM);
    },

    /**
     * Returns true if object is transparent at a certain location
     * @param {fabric.Object} target Object to check
     * @param {Number} x Left coordinate
     * @param {Number} y Top coordinate
     * @return {Boolean}
     */
    isTargetTransparent: function (target, x, y) {
      // in case the target is the activeObject, we cannot execute this optimization
      // because we need to draw controls too.
      if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
        var normalizedPointer = this._normalizePointer(target, {x: x, y: y}),
            targetRelativeX = Math.max(target.cacheTranslationX + (normalizedPointer.x * target.zoomX), 0),
            targetRelativeY = Math.max(target.cacheTranslationY + (normalizedPointer.y * target.zoomY), 0);

        var isTransparent = fabric.util.isTransparent(
          target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);

        return isTransparent;
      }

      var ctx = this.contextCache,
          originalColor = target.selectionBackgroundColor, v = this.viewportTransform;

      target.selectionBackgroundColor = '';

      this.clearContext(ctx);

      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      target.render(ctx);
      ctx.restore();

      target === this._activeObject && target._renderControls(ctx, {
        hasBorders: false,
        transparentCorners: false
      }, {
        hasBorders: false,
      });

      target.selectionBackgroundColor = originalColor;

      var isTransparent = fabric.util.isTransparent(
        ctx, x, y, this.targetFindTolerance);

      return isTransparent;
    },

    /**
     * takes an event and determins if selection key has been pressed
     * @private
     * @param {Event} e Event object
     */
    _isSelectionKeyPressed: function(e) {
      var selectionKeyPressed = false;

      if (Object.prototype.toString.call(this.selectionKey) === '[object Array]') {
        selectionKeyPressed = !!this.selectionKey.find(function(key) { return e[key] === true; });
      }
      else {
        selectionKeyPressed = e[this.selectionKey];
      }

      return selectionKeyPressed;
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _shouldClearSelection: function (e, target) {
      var activeObjects = this.getActiveObjects(),
          activeObject = this._activeObject;

      return (
        !target
        ||
        (target &&
          activeObject &&
          activeObjects.length > 1 &&
          activeObjects.indexOf(target) === -1 &&
          activeObject !== target &&
          !this._isSelectionKeyPressed(e))
        ||
        (target && !target.evented)
        ||
        (target &&
          !target.selectable &&
          activeObject &&
          activeObject !== target)
      );
    },

    /**
     * centeredScaling from object can't override centeredScaling from canvas.
     * this should be fixed, since object setting should take precedence over canvas.
     * also this should be something that will be migrated in the control properties.
     * as ability to define the origin of the transformation that the control provide.
     * @private
     * @param {fabric.Object} target
     * @param {String} action
     * @param {Boolean} altKey
     */
    _shouldCenterTransform: function (target, action, altKey) {
      if (!target) {
        return;
      }

      var centerTransform;

      if (action === 'scale' || action === 'scaleX' || action === 'scaleY' || action === 'resizing') {
        centerTransform = this.centeredScaling || target.centeredScaling;
      }
      else if (action === 'rotate') {
        centerTransform = this.centeredRotation || target.centeredRotation;
      }

      return centerTransform ? !altKey : altKey;
    },

    /**
     * should disappear before release 4.0
     * @private
     */
    _getOriginFromCorner: function(target, corner) {
      var origin = {
        x: target.originX,
        y: target.originY
      };

      if (corner === 'ml' || corner === 'tl' || corner === 'bl') {
        origin.x = 'right';
      }
      else if (corner === 'mr' || corner === 'tr' || corner === 'br') {
        origin.x = 'left';
      }

      if (corner === 'tl' || corner === 'mt' || corner === 'tr') {
        origin.y = 'bottom';
      }
      else if (corner === 'bl' || corner === 'mb' || corner === 'br') {
        origin.y = 'top';
      }
      else if (corner === 'mtr') {
        origin.x = 'center';
        origin.y = 'center';
      }
      return origin;
    },

    /**
     * @private
     * @param {Boolean} alreadySelected true if target is already selected
     * @param {String} corner a string representing the corner ml, mr, tl ...
     * @param {Event} e Event object
     * @param {fabric.Object} [target] inserted back to help overriding. Unused
     */
    _getActionFromCorner: function(alreadySelected, corner, e, target) {
      if (!corner || !alreadySelected) {
        return 'drag';
      }
      var control = target.controls[corner];
      return control.getActionName(e, control, target);
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _setupCurrentTransform: function (e, target, alreadySelected) {
      if (!target) {
        return;
      }

      var pointer = this.getPointer(e), corner = target.__corner,
          actionHandler = (alreadySelected && corner) ?
            target.controls[corner].getActionHandler() : fabric.controlsUtils.dragHandler,
          action = this._getActionFromCorner(alreadySelected, corner, e, target),
          origin = this._getOriginFromCorner(target, corner),
          altKey = e[this.centeredKey],
          transform = {
            target: target,
            action: action,
            actionHandler: actionHandler,
            corner: corner,
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            skewX: target.skewX,
            skewY: target.skewY,
            // used by transation
            offsetX: pointer.x - target.left,
            offsetY: pointer.y - target.top,
            originX: origin.x,
            originY: origin.y,
            ex: pointer.x,
            ey: pointer.y,
            lastX: pointer.x,
            lastY: pointer.y,
            // unsure they are useful anymore.
            // left: target.left,
            // top: target.top,
            theta: degreesToRadians(target.angle),
            // end of unsure
            width: target.width * target.scaleX,
            shiftKey: e.shiftKey,
            altKey: altKey,
            original: fabric.util.saveObjectTransform(target),
          };

      if (this._shouldCenterTransform(target, action, altKey)) {
        transform.originX = 'center';
        transform.originY = 'center';
      }
      transform.original.originX = origin.x;
      transform.original.originY = origin.y;
      this._currentTransform = transform;
      this._beforeTransform(e);
    },

    /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */
    setCursor: function (value) {
      this.upperCanvasEl.style.cursor = value;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */
    _drawSelection: function (ctx) {
      var groupSelector = this._groupSelector,
          left = groupSelector.left,
          top = groupSelector.top,
          aleft = abs(left),
          atop = abs(top);

      if (this.selectionColor) {
        ctx.fillStyle = this.selectionColor;

        ctx.fillRect(
          groupSelector.ex - ((left > 0) ? 0 : -left),
          groupSelector.ey - ((top > 0) ? 0 : -top),
          aleft,
          atop
        );
      }

      if (!this.selectionLineWidth || !this.selectionBorderColor) {
        return;
      }
      ctx.lineWidth = this.selectionLineWidth;
      ctx.strokeStyle = this.selectionBorderColor;

      // selection border
      if (this.selectionDashArray.length > 1 && !supportLineDash) {

        var px = groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
            py = groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop);

        ctx.beginPath();

        fabric.util.drawDashedLine(ctx, px, py, px + aleft, py, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py + atop - 1, px + aleft, py + atop - 1, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px, py, px, py + atop, this.selectionDashArray);
        fabric.util.drawDashedLine(ctx, px + aleft - 1, py, px + aleft - 1, py + atop, this.selectionDashArray);

        ctx.closePath();
        ctx.stroke();
      }
      else {
        fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
        ctx.strokeRect(
          groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
          groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop),
          aleft,
          atop
        );
      }
    },

    /**
     * Method that determines what object we are clicking on
     * the skipGroup parameter is for internal use, is needed for shift+click action
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
     * @return {fabric.Object} the target found
     */
    findTarget: function (e, skipGroup) {
      if (this.skipTargetFind) {
        return;
      }

      var ignoreZoom = true,
          pointer = this.getPointer(e, ignoreZoom),
          activeObject = this._activeObject,
          aObjects = this.getActiveObjects(),
          activeTarget, activeTargetSubs,
          isTouch = isTouchEvent(e);

      // first check current group (if one exists)
      // active group does not check sub targets like normal groups.
      // if active group just exits.
      this.targets = [];

      if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        return activeObject;
      }
      // if we hit the corner of an activeObject, let's return that.
      if (aObjects.length === 1 && activeObject._findTargetCorner(pointer, isTouch)) {
        return activeObject;
      }
      if (aObjects.length === 1 &&
        activeObject === this._searchPossibleTargets([activeObject], pointer)) {
        if (!this.preserveObjectStacking) {
          return activeObject;
        }
        else {
          activeTarget = activeObject;
          activeTargetSubs = this.targets;
          this.targets = [];
        }
      }
      var target = this._searchPossibleTargets(this._objects, pointer);
      if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
        target = activeTarget;
        this.targets = activeTargetSubs;
      }
      return target;
    },

    /**
     * Checks point is inside the object.
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @param {fabric.Object} obj Object to test against
     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */
    _checkTarget: function(pointer, obj, globalPointer) {
      if (obj &&
          obj.visible &&
          obj.evented &&
          // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
          // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
          (obj.containsPoint(pointer) || !!obj._findTargetCorner(pointer))
      ) {
        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
          var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
          if (!isTransparent) {
            return true;
          }
        }
        else {
          return true;
        }
      }
    },

    /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {fabric.Object} object that contains pointer
     * @private
     */
    _searchPossibleTargets: function(objects, pointer) {
      // Cache all targets where their bounding box contains point.
      var target, i = objects.length, subTarget;
      // Do not check for currently grouped objects, since we check the parent group itself.
      // until we call this function specifically to search inside the activeGroup
      while (i--) {
        var objToCheck = objects[i];
        var pointerToUse = objToCheck.group ?
          this._normalizePointer(objToCheck.group, pointer) : pointer;
        if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
          target = objects[i];
          if (target.subTargetCheck && target instanceof fabric.Group) {
            subTarget = this._searchPossibleTargets(target._objects, pointer);
            subTarget && this.targets.push(subTarget);
          }
          break;
        }
      }
      return target;
    },

    /**
     * Returns pointer coordinates without the effect of the viewport
     * @param {Object} pointer with "x" and "y" number values
     * @return {Object} object with "x" and "y" number values
     */
    restorePointerVpt: function(pointer) {
      return fabric.util.transformPoint(
        pointer,
        fabric.util.invertTransform(this.viewportTransform)
      );
    },

    /**
     * Returns pointer coordinates relative to canvas.
     * Can return coordinates with or without viewportTransform.
     * ignoreZoom false gives back coordinates that represent
     * the point clicked on canvas element.
     * ignoreZoom true gives back coordinates after being processed
     * by the viewportTransform ( sort of coordinates of what is displayed
     * on the canvas where you are clicking.
     * ignoreZoom true = HTMLElement coordinates relative to top,left
     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
     * To interact with your shapes top and left you want to use ignoreZoom true
     * most of the time, while ignoreZoom false will give you coordinates
     * compatible with the object.oCoords system.
     * of the time.
     * @param {Event} e
     * @param {Boolean} ignoreZoom
     * @return {Object} object with "x" and "y" number values
     */
    getPointer: function (e, ignoreZoom) {
      // return cached values if we are in the event processing chain
      if (this._absolutePointer && !ignoreZoom) {
        return this._absolutePointer;
      }
      if (this._pointer && ignoreZoom) {
        return this._pointer;
      }

      var pointer = getPointer(e),
          upperCanvasEl = this.upperCanvasEl,
          bounds = upperCanvasEl.getBoundingClientRect(),
          boundsWidth = bounds.width || 0,
          boundsHeight = bounds.height || 0,
          cssScale;

      if (!boundsWidth || !boundsHeight ) {
        if ('top' in bounds && 'bottom' in bounds) {
          boundsHeight = Math.abs( bounds.top - bounds.bottom );
        }
        if ('right' in bounds && 'left' in bounds) {
          boundsWidth = Math.abs( bounds.right - bounds.left );
        }
      }

      this.calcOffset();
      pointer.x = pointer.x - this._offset.left;
      pointer.y = pointer.y - this._offset.top;
      if (!ignoreZoom) {
        pointer = this.restorePointerVpt(pointer);
      }

      var retinaScaling = this.getRetinaScaling();
      if (retinaScaling !== 1) {
        pointer.x /= retinaScaling;
        pointer.y /= retinaScaling;
      }

      if (boundsWidth === 0 || boundsHeight === 0) {
        // If bounds are not available (i.e. not visible), do not apply scale.
        cssScale = { width: 1, height: 1 };
      }
      else {
        cssScale = {
          width: upperCanvasEl.width / boundsWidth,
          height: upperCanvasEl.height / boundsHeight
        };
      }

      return {
        x: pointer.x * cssScale.width,
        y: pointer.y * cssScale.height
      };
    },

    /**
     * @private
     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
     */
    _createUpperCanvas: function () {
      var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ''),
          lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;

      // there is no need to create a new upperCanvas element if we have already one.
      if (upperCanvasEl) {
        upperCanvasEl.className = '';
      }
      else {
        upperCanvasEl = this._createCanvasElement();
        this.upperCanvasEl = upperCanvasEl;
      }
      fabric.util.addClass(upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);

      this.wrapperEl.appendChild(upperCanvasEl);

      this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
      this._applyCanvasStyle(upperCanvasEl);
      this.contextTop = upperCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _createCacheCanvas: function () {
      this.cacheCanvasEl = this._createCanvasElement();
      this.cacheCanvasEl.setAttribute('width', this.width);
      this.cacheCanvasEl.setAttribute('height', this.height);
      this.contextCache = this.cacheCanvasEl.getContext('2d');
    },

    /**
     * @private
     */
    _initWrapperElement: function () {
      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
        'class': this.containerClass
      });
      fabric.util.setStyle(this.wrapperEl, {
        width: this.width + 'px',
        height: this.height + 'px',
        position: 'relative'
      });
      fabric.util.makeElementUnselectable(this.wrapperEl);
    },

    /**
     * @private
     * @param {HTMLElement} element canvas element to apply styles on
     */
    _applyCanvasStyle: function (element) {
      var width = this.width || element.width,
          height = this.height || element.height;

      fabric.util.setStyle(element, {
        position: 'absolute',
        width: width + 'px',
        height: height + 'px',
        left: 0,
        top: 0,
        'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
        '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
      });
      element.width = width;
      element.height = height;
      fabric.util.makeElementUnselectable(element);
    },

    /**
     * Copy the entire inline style from one element (fromEl) to another (toEl)
     * @private
     * @param {Element} fromEl Element style is copied from
     * @param {Element} toEl Element copied style is applied to
     */
    _copyCanvasStyle: function (fromEl, toEl) {
      toEl.style.cssText = fromEl.style.cssText;
    },

    /**
     * Returns context of canvas where object selection is drawn
     * @return {CanvasRenderingContext2D}
     */
    getSelectionContext: function() {
      return this.contextTop;
    },

    /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */
    getSelectionElement: function () {
      return this.upperCanvasEl;
    },

    /**
     * Returns currently active object
     * @return {fabric.Object} active object
     */
    getActiveObject: function () {
      return this._activeObject;
    },

    /**
     * Returns an array with the current selected objects
     * @return {fabric.Object} active object
     */
    getActiveObjects: function () {
      var active = this._activeObject;
      if (active) {
        if (active.type === 'activeSelection' && active._objects) {
          return active._objects.slice(0);
        }
        else {
          return [active];
        }
      }
      return [];
    },

    /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */
    _onObjectRemoved: function(obj) {
      // removing active object should fire "selection:cleared" events
      if (obj === this._activeObject) {
        this.fire('before:selection:cleared', { target: obj });
        this._discardActiveObject();
        this.fire('selection:cleared', { target: obj });
        obj.fire('deselected');
      }
      if (obj === this._hoveredTarget){
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
      this.callSuper('_onObjectRemoved', obj);
    },

    /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {fabric.Object} obj old activeObject
     */
    _fireSelectionEvents: function(oldObjects, e) {
      var somethingChanged = false, objects = this.getActiveObjects(),
          added = [], removed = [], opt = { e: e };
      oldObjects.forEach(function(oldObject) {
        if (objects.indexOf(oldObject) === -1) {
          somethingChanged = true;
          oldObject.fire('deselected', opt);
          removed.push(oldObject);
        }
      });
      objects.forEach(function(object) {
        if (oldObjects.indexOf(object) === -1) {
          somethingChanged = true;
          object.fire('selected', opt);
          added.push(object);
        }
      });
      if (oldObjects.length > 0 && objects.length > 0) {
        opt.selected = added;
        opt.deselected = removed;
        // added for backward compatibility
        opt.updated = added[0] || removed[0];
        opt.target = this._activeObject;
        somethingChanged && this.fire('selection:updated', opt);
      }
      else if (objects.length > 0) {
        opt.selected = added;
        // added for backward compatibility
        opt.target = this._activeObject;
        this.fire('selection:created', opt);
      }
      else if (oldObjects.length > 0) {
        opt.deselected = removed;
        this.fire('selection:cleared', opt);
      }
    },

    /**
     * Sets given object as the only active object on canvas
     * @param {fabric.Object} object Object to set as an active one
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    setActiveObject: function (object, e) {
      var currentActives = this.getActiveObjects();
      this._setActiveObject(object, e);
      this._fireSelectionEvents(currentActives, e);
      return this;
    },

    /**
     * @private
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the selection happened
     */
    _setActiveObject: function(object, e) {
      if (this._activeObject === object) {
        return false;
      }
      if (!this._discardActiveObject(e, object)) {
        return false;
      }
      if (object.onSelect({ e: e })) {
        return false;
      }
      this._activeObject = object;
      return true;
    },

    /**
     * @private
     */
    _discardActiveObject: function(e, object) {
      var obj = this._activeObject;
      if (obj) {
        // onDeselect return TRUE to cancel selection;
        if (obj.onDeselect({ e: e, object: object })) {
          return false;
        }
        this._activeObject = null;
      }
      return true;
    },

    /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    discardActiveObject: function (e) {
      var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
      if (currentActives.length) {
        this.fire('before:selection:cleared', { target: activeObject, e: e });
      }
      this._discardActiveObject(e);
      this._fireSelectionEvents(currentActives, e);
      return this;
    },

    /**
     * Clears a canvas element and removes all event listeners
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    dispose: function () {
      var wrapper = this.wrapperEl;
      this.removeListeners();
      wrapper.removeChild(this.upperCanvasEl);
      wrapper.removeChild(this.lowerCanvasEl);
      this.contextCache = null;
      this.contextTop = null;
      ['upperCanvasEl', 'cacheCanvasEl'].forEach((function(element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }).bind(this));
      if (wrapper.parentNode) {
        wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
      }
      delete this.wrapperEl;
      fabric.StaticCanvas.prototype.dispose.call(this);
      return this;
    },

    /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */
    clear: function () {
      // this.discardActiveGroup();
      this.discardActiveObject();
      this.clearContext(this.contextTop);
      return this.callSuper('clear');
    },

    /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */
    drawControls: function(ctx) {
      var activeObject = this._activeObject;

      if (activeObject) {
        activeObject._renderControls(ctx);
      }
    },

    /**
     * @private
     */
    _toObject: function(instance, methodName, propertiesToInclude) {
      //If the object is part of the current selection group, it should
      //be transformed appropriately
      //i.e. it should be serialised as it would appear if the selection group
      //were to be destroyed.
      var originalProperties = this._realizeGroupTransformOnObject(instance),
          object = this.callSuper('_toObject', instance, methodName, propertiesToInclude);
      //Undo the damage we did by changing all of its properties
      this._unwindGroupTransformOnObject(instance, originalProperties);
      return object;
    },

    /**
     * Realises an object's group transformation on it
     * @private
     * @param {fabric.Object} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */
    _realizeGroupTransformOnObject: function(instance) {
      if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
        var layoutProps = ['angle', 'flipX', 'flipY', 'left', 'scaleX', 'scaleY', 'skewX', 'skewY', 'top'];
        //Copy all the positionally relevant properties across now
        var originalValues = {};
        layoutProps.forEach(function(prop) {
          originalValues[prop] = instance[prop];
        });
        this._activeObject.realizeTransform(instance);
        return originalValues;
      }
      else {
        return null;
      }
    },

    /**
     * Restores the changed properties of instance
     * @private
     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
     */
    _unwindGroupTransformOnObject: function(instance, originalValues) {
      if (originalValues) {
        instance.set(originalValues);
      }
    },

    /**
     * @private
     */
    _setSVGObject: function(markup, instance, reviver) {
      //If the object is in a selection group, simulate what would happen to that
      //object when the group is deselected
      var originalProperties = this._realizeGroupTransformOnObject(instance);
      this.callSuper('_setSVGObject', markup, instance, reviver);
      this._unwindGroupTransformOnObject(instance, originalProperties);
    },

    setViewportTransform: function (vpt) {
      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
        this._activeObject.clearContextTop();
      }
      fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
    }
  });

  // copying static properties manually to work around Opera's bug,
  // where "prototype" property is enumerable and overrides existing prototype
  for (var prop in fabric.StaticCanvas) {
    if (prop !== 'prototype') {
      fabric.Canvas[prop] = fabric.StaticCanvas[prop];
    }
  }
})();


(function() {

  var addListener = fabric.util.addListener,
      removeListener = fabric.util.removeListener,
      RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1,
      addEventOptions = { passive: false };

  function checkClick(e, value) {
    return e.button && (e.button === value - 1);
  }

  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

    /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */
    mainTouchId: null,

    /**
     * Adds mouse listeners to canvas
     * @private
     */
    _initEventListeners: function () {
      // in case we initialized the class twice. This should not happen normally
      // but in some kind of applications where the canvas element may be changed
      // this is a workaround to having double listeners.
      this.removeListeners();
      this._bindEvents();
      this.addOrRemove(addListener, 'add');
    },

    /**
     * return an event prefix pointer or mouse.
     * @private
     */
    _getEventPrefix: function () {
      return this.enablePointerEvents ? 'pointer' : 'mouse';
    },

    addOrRemove: function(functor, eventjsFunctor) {
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      functor(fabric.window, 'resize', this._onResize);
      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
      functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
      functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
      functor(canvasElement, 'wheel', this._onMouseWheel);
      functor(canvasElement, 'contextmenu', this._onContextMenu);
      functor(canvasElement, 'dblclick', this._onDoubleClick);
      functor(canvasElement, 'dragover', this._onDragOver);
      functor(canvasElement, 'dragenter', this._onDragEnter);
      functor(canvasElement, 'dragleave', this._onDragLeave);
      functor(canvasElement, 'drop', this._onDrop);
      if (!this.enablePointerEvents) {
        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
      }
      if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
        eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
        eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
        eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
        eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
        eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
      }
    },

    /**
     * Removes all event listeners
     */
    removeListeners: function() {
      this.addOrRemove(removeListener, 'remove');
      // if you dispose on a mouseDown, before mouse up, you need to clean document to...
      var eventTypePrefix = this._getEventPrefix();
      removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     */
    _bindEvents: function() {
      if (this.eventsBound) {
        // for any reason we pass here twice we do not want to bind events twice.
        return;
      }
      this._onMouseDown = this._onMouseDown.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onGesture = this._onGesture.bind(this);
      this._onDrag = this._onDrag.bind(this);
      this._onShake = this._onShake.bind(this);
      this._onLongPress = this._onLongPress.bind(this);
      this._onOrientationChange = this._onOrientationChange.bind(this);
      this._onMouseWheel = this._onMouseWheel.bind(this);
      this._onMouseOut = this._onMouseOut.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onContextMenu = this._onContextMenu.bind(this);
      this._onDoubleClick = this._onDoubleClick.bind(this);
      this._onDragOver = this._onDragOver.bind(this);
      this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
      this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
      this._onDrop = this._simpleEventHandler.bind(this, 'drop');
      this.eventsBound = true;
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js gesture
     * @param {Event} [self] Inner Event object
     */
    _onGesture: function(e, self) {
      this.__onTransformGesture && this.__onTransformGesture(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js drag
     * @param {Event} [self] Inner Event object
     */
    _onDrag: function(e, self) {
      this.__onDrag && this.__onDrag(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */
    _onMouseWheel: function(e) {
      this.__onMouseWheel(e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseOut: function(e) {
      var target = this._hoveredTarget;
      this.fire('mouse:out', { target: target, e: e });
      this._hoveredTarget = null;
      target && target.fire('mouseout', { e: e });

      var _this = this;
      this._hoveredTargets.forEach(function(_target){
        _this.fire('mouse:out', { target: target, e: e });
        _target && target.fire('mouseout', { e: e });
      });
      this._hoveredTargets = [];

      if (this._iTextInstances) {
        this._iTextInstances.forEach(function(obj) {
          if (obj.isEditing) {
            obj.hiddenTextarea.focus();
          }
        });
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */
    _onMouseEnter: function(e) {
      // This find target and consequent 'mouse:over' is used to
      // clear old instances on hovered target.
      // calling findTarget has the side effect of killing target.__corner.
      // as a short term fix we are not firing this if we are currently transforming.
      // as a long term fix we need to separate the action of finding a target with the
      // side effects we added to it.
      if (!this._currentTransform && !this.findTarget(e)) {
        this.fire('mouse:over', { target: null, e: e });
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js orientation change
     * @param {Event} [self] Inner Event object
     */
    _onOrientationChange: function(e, self) {
      this.__onOrientationChange && this.__onOrientationChange(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onShake: function(e, self) {
      this.__onShake && this.__onShake(e, self);
    },

    /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */
    _onLongPress: function(e, self) {
      this.__onLongPress && this.__onLongPress(e, self);
    },

    /**
     * prevent default to allow drop event to be fired
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */
    _onDragOver: function(e) {
      e.preventDefault();
      var target = this._simpleEventHandler('dragover', e);
      this._fireEnterLeaveEvents(target, e);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onContextMenu: function (e) {
      if (this.stopContextMenu) {
        e.stopPropagation();
        e.preventDefault();
      }
      return false;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onDoubleClick: function (e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'dblclick');
      this._resetTransformEventData(e);
    },

    /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */
    getPointerId: function(evt) {
      var changedTouches = evt.changedTouches;

      if (changedTouches) {
        return changedTouches[0] && changedTouches[0].identifier;
      }

      if (this.enablePointerEvents) {
        return evt.pointerId;
      }

      return -1;
    },

    /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */
    _isMainEvent: function(evt) {
      if (evt.isPrimary === true) {
        return true;
      }
      if (evt.isPrimary === false) {
        return false;
      }
      if (evt.type === 'touchend' && evt.touches.length === 0) {
        return true;
      }
      if (evt.changedTouches) {
        return evt.changedTouches[0].identifier === this.mainTouchId;
      }
      return true;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchStart: function(e) {
      e.preventDefault();
      if (this.mainTouchId === null) {
        this.mainTouchId = this.getPointerId(e);
      }
      this.__onMouseDown(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
      // Unbind mousedown to prevent double triggers from touch devices
      removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDown: function (e) {
      this.__onMouseDown(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      addListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
      addListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchEnd: function(e) {
      if (e.touches.length > 0) {
        // if there are still touches stop here
        return;
      }
      this.__onMouseUp(e);
      this._resetTransformEventData();
      this.mainTouchId = null;
      var eventTypePrefix = this._getEventPrefix();
      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
      var _this = this;
      if (this._willAddMouseDown) {
        clearTimeout(this._willAddMouseDown);
      }
      this._willAddMouseDown = setTimeout(function() {
        // Wait 400ms before rebinding mousedown to prevent double triggers
        // from touch devices
        addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
        _this._willAddMouseDown = 0;
      }, 400);
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUp: function (e) {
      this.__onMouseUp(e);
      this._resetTransformEventData();
      var canvasElement = this.upperCanvasEl,
          eventTypePrefix = this._getEventPrefix();
      if (this._isMainEvent(e)) {
        removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
        removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
        addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
      }
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMove: function (e) {
      !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
      this.__onMouseMove(e);
    },

    /**
     * @private
     */
    _onResize: function () {
      this.calcOffset();
    },

    /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */
    _shouldRender: function(target) {
      var activeObject = this._activeObject;

      if (
        !!activeObject !== !!target ||
        (activeObject && target && (activeObject !== target))
      ) {
        // this covers: switch of target, from target to no target, selection of target
        // multiSelection with key and mouse
        return true;
      }
      else if (activeObject && activeObject.isEditing) {
        // if we mouse up/down over a editing textbox a cursor change,
        // there is no need to re render
        return false;
      }
      return false;
    },

    /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseUp: function (e) {
      var target, transform = this._currentTransform,
          groupSelector = this._groupSelector, shouldRender = false,
          isClick = (!groupSelector || (groupSelector.left === 0 && groupSelector.top === 0));
      this._cacheTransformEventData(e);
      target = this._target;
      this._handleEvent(e, 'up:before');
      // if right/middle click just fire events and return
      // target undefined will make the _handleEvent search the target
      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
        }
        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
        }
        this._resetTransformEventData();
        return;
      }

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this._onMouseUpInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }
      if (transform) {
        this._finalizeCurrentTransform(e);
        shouldRender = transform.actionPerformed;
      }
      if (!isClick) {
        var targetWasActive = target === this._activeObject;
        this._maybeGroupObjects(e);
        if (!shouldRender) {
          shouldRender = (
            this._shouldRender(target) ||
            (!targetWasActive && target === this._activeObject)
          );
        }
      }
      if (target) {
        var corner = target._findTargetCorner(
          this.getPointer(e, true),
          fabric.util.isTouchEvent(e)
        );
        var control = target.controls[corner],
            mouseUpHandler = control && control.getMouseUpHandler(e, target, control);
        if (mouseUpHandler) {
          mouseUpHandler(e, target, control);
        }
        target.isMoving = false;
      }
      this._setCursorFromEvent(e, target);
      this._handleEvent(e, 'up', LEFT_CLICK, isClick);
      this._groupSelector = null;
      this._currentTransform = null;
      // reset the target information about which corner is selected
      target && (target.__corner = 0);
      if (shouldRender) {
        this.requestRenderAll();
      }
      else if (!isClick) {
        this.renderTop();
      }
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @return {Fabric.Object} target return the the target found, for internal reasons.
     */
    _simpleEventHandler: function(eventType, e) {
      var target = this.findTarget(e),
          targets = this.targets,
          options = {
            e: e,
            target: target,
            subTargets: targets,
          };
      this.fire(eventType, options);
      target && target.fire(eventType, options);
      if (!targets) {
        return target;
      }
      for (var i = 0; i < targets.length; i++) {
        targets[i].fire(eventType, options);
      }
      return target;
    },

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @param {fabric.Object} targetObj receiving event
     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
     */
    _handleEvent: function(e, eventType, button, isClick) {
      var target = this._target,
          targets = this.targets || [],
          options = {
            e: e,
            target: target,
            subTargets: targets,
            button: button || LEFT_CLICK,
            isClick: isClick || false,
            pointer: this._pointer,
            absolutePointer: this._absolutePointer,
            transform: this._currentTransform
          };
      if (eventType === 'up') {
        options.currentTarget = this.findTarget(e);
        options.currentSubTargets = this.targets;
      }
      this.fire('mouse:' + eventType, options);
      target && target.fire('mouse' + eventType, options);
      for (var i = 0; i < targets.length; i++) {
        targets[i].fire('mouse' + eventType, options);
      }
    },

    /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */
    _finalizeCurrentTransform: function(e) {

      var transform = this._currentTransform,
          target = transform.target,
          eventName,
          options = {
            e: e,
            target: target,
            transform: transform,
            action: transform.action,
          };

      if (target._scaling) {
        target._scaling = false;
      }

      target.setCoords();

      if (transform.actionPerformed || (this.stateful && target.hasStateChanged())) {
        if (transform.actionPerformed) {
          // this is not friendly to the new control api.
          // is deprecated.
          eventName = this._addEventOptions(options, transform);
          this._fire(eventName, options);
        }
        this._fire('modified', options);
      }
    },

    /**
     * Mutate option object in order to add by property and give back the event name.
     * @private
     * @deprecated since 4.2.0
     * @param {Object} options to mutate
     * @param {Object} transform to inspect action from
     */
    _addEventOptions: function(options, transform) {
      // we can probably add more details at low cost
      // scale change, rotation changes, translation changes
      var eventName, by;
      switch (transform.action) {
        case 'scaleX':
          eventName = 'scaled';
          by = 'x';
          break;
        case 'scaleY':
          eventName = 'scaled';
          by = 'y';
          break;
        case 'skewX':
          eventName = 'skewed';
          by = 'x';
          break;
        case 'skewY':
          eventName = 'skewed';
          by = 'y';
          break;
        case 'scale':
          eventName = 'scaled';
          by = 'equally';
          break;
        case 'rotate':
          eventName = 'rotated';
          break;
        case 'drag':
          eventName = 'moved';
          break;
      }
      options.by = by;
      return eventName;
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDownInDrawingMode: function(e) {
      this._isCurrentlyDrawing = true;
      if (this.getActiveObject()) {
        this.discardActiveObject(e).requestRenderAll();
      }
      var pointer = this.getPointer(e);
      this.freeDrawingBrush.onMouseDown(pointer, { e: e, pointer: pointer });
      this._handleEvent(e, 'down');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMoveInDrawingMode: function(e) {
      if (this._isCurrentlyDrawing) {
        var pointer = this.getPointer(e);
        this.freeDrawingBrush.onMouseMove(pointer, { e: e, pointer: pointer });
      }
      this.setCursor(this.freeDrawingCursor);
      this._handleEvent(e, 'move');
    },

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUpInDrawingMode: function(e) {
      var pointer = this.getPointer(e);
      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({ e: e, pointer: pointer });
      this._handleEvent(e, 'up');
    },

    /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    __onMouseDown: function (e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'down:before');
      var target = this._target;
      // if right click just fire events
      if (checkClick(e, RIGHT_CLICK)) {
        if (this.fireRightClick) {
          this._handleEvent(e, 'down', RIGHT_CLICK);
        }
        return;
      }

      if (checkClick(e, MIDDLE_CLICK)) {
        if (this.fireMiddleClick) {
          this._handleEvent(e, 'down', MIDDLE_CLICK);
        }
        return;
      }

      if (this.isDrawingMode) {
        this._onMouseDownInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      // ignore if some object is being transformed at this moment
      if (this._currentTransform) {
        return;
      }

      var pointer = this._pointer;
      // save pointer for check in __onMouseUp event
      this._previousPointer = pointer;
      var shouldRender = this._shouldRender(target),
          shouldGroup = this._shouldGroup(e, target);
      if (this._shouldClearSelection(e, target)) {
        this.discardActiveObject(e);
      }
      else if (shouldGroup) {
        this._handleGrouping(e, target);
        target = this._activeObject;
      }

      if (this.selection && (!target ||
        (!target.selectable && !target.isEditing && target !== this._activeObject))) {
        this._groupSelector = {
          ex: pointer.x,
          ey: pointer.y,
          top: 0,
          left: 0
        };
      }

      if (target) {
        var alreadySelected = target === this._activeObject;
        if (target.selectable) {
          this.setActiveObject(target, e);
        }
        var corner = target._findTargetCorner(
          this.getPointer(e, true),
          fabric.util.isTouchEvent(e)
        );
        target.__corner = corner;
        if (target === this._activeObject && (corner || !shouldGroup)) {
          var control = target.controls[corner],
              mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
          if (mouseDownHandler) {
            mouseDownHandler(e, target, control);
          }
          this._setupCurrentTransform(e, target, alreadySelected);
        }
      }
      this._handleEvent(e, 'down');
      // we must renderAll so that we update the visuals
      (shouldRender || shouldGroup) && this.requestRenderAll();
    },

    /**
     * reset cache form common information needed during event processing
     * @private
     */
    _resetTransformEventData: function() {
      this._target = null;
      this._pointer = null;
      this._absolutePointer = null;
    },

    /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */
    _cacheTransformEventData: function(e) {
      // reset in order to avoid stale caching
      this._resetTransformEventData();
      this._pointer = this.getPointer(e, true);
      this._absolutePointer = this.restorePointerVpt(this._pointer);
      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
    },

    /**
     * @private
     */
    _beforeTransform: function(e) {
      var t = this._currentTransform;
      this.stateful && t.target.saveState();
      this.fire('before:transform', {
        e: e,
        transform: t,
      });
    },

    /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    __onMouseMove: function (e) {
      this._handleEvent(e, 'move:before');
      this._cacheTransformEventData(e);
      var target, pointer;

      if (this.isDrawingMode) {
        this._onMouseMoveInDrawingMode(e);
        return;
      }

      if (!this._isMainEvent(e)) {
        return;
      }

      var groupSelector = this._groupSelector;

      // We initially clicked in an empty area, so we draw a box for multiple selection
      if (groupSelector) {
        pointer = this._pointer;

        groupSelector.left = pointer.x - groupSelector.ex;
        groupSelector.top = pointer.y - groupSelector.ey;

        this.renderTop();
      }
      else if (!this._currentTransform) {
        target = this.findTarget(e) || null;
        this._setCursorFromEvent(e, target);
        this._fireOverOutEvents(target, e);
      }
      else {
        this._transformObject(e);
      }
      this._handleEvent(e, 'move');
      this._resetTransformEventData();
    },

    /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */
    _fireOverOutEvents: function(target, e) {
      var _hoveredTarget = this._hoveredTarget,
          _hoveredTargets = this._hoveredTargets, targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);

      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _hoveredTarget,
        evtOut: 'mouseout',
        canvasEvtOut: 'mouse:out',
        evtIn: 'mouseover',
        canvasEvtIn: 'mouse:over',
      });
      for (var i = 0; i < length; i++){
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'mouseout',
          evtIn: 'mouseover',
        });
      }
      this._hoveredTarget = target;
      this._hoveredTargets = this.targets.concat();
    },

    /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Event} e Event object fired on ondrag
     * @private
     */
    _fireEnterLeaveEvents: function(target, e) {
      var _draggedoverTarget = this._draggedoverTarget,
          _hoveredTargets = this._hoveredTargets, targets = this.targets,
          length = Math.max(_hoveredTargets.length, targets.length);

      this.fireSyntheticInOutEvents(target, e, {
        oldTarget: _draggedoverTarget,
        evtOut: 'dragleave',
        evtIn: 'dragenter',
      });
      for (var i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents(targets[i], e, {
          oldTarget: _hoveredTargets[i],
          evtOut: 'dragleave',
          evtIn: 'dragenter',
        });
      }
      this._draggedoverTarget = target;
    },

    /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Event} e Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */
    fireSyntheticInOutEvents: function(target, e, config) {
      var inOpt, outOpt, oldTarget = config.oldTarget, outFires, inFires,
          targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
      if (targetChanged) {
        inOpt = { e: e, target: target, previousTarget: oldTarget };
        outOpt = { e: e, target: oldTarget, nextTarget: target };
      }
      inFires = target && targetChanged;
      outFires = oldTarget && targetChanged;
      if (outFires) {
        canvasEvtOut && this.fire(canvasEvtOut, outOpt);
        oldTarget.fire(config.evtOut, outOpt);
      }
      if (inFires) {
        canvasEvtIn && this.fire(canvasEvtIn, inOpt);
        target.fire(config.evtIn, inOpt);
      }
    },

    /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseWheel: function(e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'wheel');
      this._resetTransformEventData();
    },

    /**
     * @private
     * @param {Event} e Event fired on mousemove
     */
    _transformObject: function(e) {
      var pointer = this.getPointer(e),
          transform = this._currentTransform;

      transform.reset = false;
      transform.target.isMoving = true;
      transform.shiftKey = e.shiftKey;
      transform.altKey = e[this.centeredKey];

      this._performTransformAction(e, transform, pointer);
      transform.actionPerformed && this.requestRenderAll();
    },

    /**
     * @private
     */
    _performTransformAction: function(e, transform, pointer) {
      var x = pointer.x,
          y = pointer.y,
          action = transform.action,
          actionPerformed = false,
          actionHandler = transform.actionHandler;
          // this object could be created from the function in the control handlers


      if (actionHandler) {
        actionPerformed = actionHandler(e, transform, x, y);
      }
      if (action === 'drag' && actionPerformed) {
        this.setCursor(transform.target.moveCursor || this.moveCursor);
      }
      transform.actionPerformed = transform.actionPerformed || actionPerformed;
    },

    /**
     * @private
     */
    _fire: fabric.controlsUtils.fireEvent,

    /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */
    _setCursorFromEvent: function (e, target) {
      if (!target) {
        this.setCursor(this.defaultCursor);
        return false;
      }
      var hoverCursor = target.hoverCursor || this.hoverCursor,
          activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ?
            this._activeObject : null,
          // only show proper corner when group selection is not active
          corner = (!activeSelection || !activeSelection.contains(target))
          // here we call findTargetCorner always with undefined for the touch parameter.
          // we assume that if you are using a cursor you do not need to interact with
          // the bigger touch area.
                    && target._findTargetCorner(this.getPointer(e, true));

      if (!corner) {
        if (target.subTargetCheck){
          // hoverCursor should come from top-most subTarget,
          // so we walk the array backwards
          this.targets.concat().reverse().map(function(_target){
            hoverCursor = _target.hoverCursor || hoverCursor;
          });
        }
        this.setCursor(hoverCursor);
      }
      else {
        this.setCursor(this.getCornerCursor(corner, target, e));
      }
    },

    /**
     * @private
     */
    getCornerCursor: function(corner, target, e) {
      var control = target.controls[corner];
      return control.cursorStyleHandler(e, control, target);
    }
  });
})();


(function() {

  var min = Math.min,
      max = Math.max;

  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     * @return {Boolean}
     */
    _shouldGroup: function(e, target) {
      var activeObject = this._activeObject;
      return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection &&
            (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({ e: e });
    },

    /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */
    _handleGrouping: function (e, target) {
      var activeObject = this._activeObject;
      // avoid multi select when shift click on a corner
      if (activeObject.__corner) {
        return;
      }
      if (target === activeObject) {
        // if it's a group, find target again, using activeGroup objects
        target = this.findTarget(e, true);
        // if even object is not found or we are on activeObjectCorner, bail out
        if (!target || !target.selectable) {
          return;
        }
      }
      if (activeObject && activeObject.type === 'activeSelection') {
        this._updateActiveSelection(target, e);
      }
      else {
        this._createActiveSelection(target, e);
      }
    },

    /**
     * @private
     */
    _updateActiveSelection: function(target, e) {
      var activeSelection = this._activeObject,
          currentActiveObjects = activeSelection._objects.slice(0);
      if (activeSelection.contains(target)) {
        activeSelection.removeWithUpdate(target);
        this._hoveredTarget = target;
        this._hoveredTargets = this.targets.concat();
        if (activeSelection.size() === 1) {
          // activate last remaining object
          this._setActiveObject(activeSelection.item(0), e);
        }
      }
      else {
        activeSelection.addWithUpdate(target);
        this._hoveredTarget = activeSelection;
        this._hoveredTargets = this.targets.concat();
      }
      this._fireSelectionEvents(currentActiveObjects, e);
    },

    /**
     * @private
     */
    _createActiveSelection: function(target, e) {
      var currentActives = this.getActiveObjects(), group = this._createGroup(target);
      this._hoveredTarget = group;
      // ISSUE 4115: should we consider subTargets here?
      // this._hoveredTargets = [];
      // this._hoveredTargets = this.targets.concat();
      this._setActiveObject(group, e);
      this._fireSelectionEvents(currentActives, e);
    },

    /**
     * @private
     * @param {Object} target
     */
    _createGroup: function(target) {
      var objects = this._objects,
          isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target),
          groupObjects = isActiveLower
            ? [this._activeObject, target]
            : [target, this._activeObject];
      this._activeObject.isEditing && this._activeObject.exitEditing();
      return new fabric.ActiveSelection(groupObjects, {
        canvas: this
      });
    },

    /**
     * @private
     * @param {Event} e mouse event
     */
    _groupSelectedObjects: function (e) {

      var group = this._collectObjects(e),
          aGroup;

      // do not create group for 1 element only
      if (group.length === 1) {
        this.setActiveObject(group[0], e);
      }
      else if (group.length > 1) {
        aGroup = new fabric.ActiveSelection(group.reverse(), {
          canvas: this
        });
        this.setActiveObject(aGroup, e);
      }
    },

    /**
     * @private
     */
    _collectObjects: function(e) {
      var group = [],
          currentObject,
          x1 = this._groupSelector.ex,
          y1 = this._groupSelector.ey,
          x2 = x1 + this._groupSelector.left,
          y2 = y1 + this._groupSelector.top,
          selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)),
          selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)),
          allowIntersect = !this.selectionFullyContained,
          isClick = x1 === x2 && y1 === y2;
      // we iterate reverse order to collect top first in case of click.
      for (var i = this._objects.length; i--; ) {
        currentObject = this._objects[i];

        if (!currentObject || !currentObject.selectable || !currentObject.visible) {
          continue;
        }

        if ((allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2)) ||
            currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2) ||
            (allowIntersect && currentObject.containsPoint(selectionX1Y1)) ||
            (allowIntersect && currentObject.containsPoint(selectionX2Y2))
        ) {
          group.push(currentObject);
          // only add one object if it's a click
          if (isClick) {
            break;
          }
        }
      }

      if (group.length > 1) {
        group = group.filter(function(object) {
          return !object.onSelect({ e: e });
        });
      }

      return group;
    },

    /**
     * @private
     */
    _maybeGroupObjects: function(e) {
      if (this.selection && this._groupSelector) {
        this._groupSelectedObjects(e);
      }
      this.setCursor(this.defaultCursor);
      // clear selection and current transformation
      this._groupSelector = null;
    }
  });

})();


(function () {
  fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

    /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     */
    toDataURL: function (options) {
      options || (options = { });

      var format = options.format || 'png',
          quality = options.quality || 1,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1),
          canvasEl = this.toCanvasElement(multiplier, options);
      return fabric.util.toDataURL(canvasEl, format, quality);
    },

    /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [cropping] Cropping informations
     * @param {Number} [cropping.left] Cropping left offset.
     * @param {Number} [cropping.top] Cropping top offset.
     * @param {Number} [cropping.width] Cropping width.
     * @param {Number} [cropping.height] Cropping height.
     */
    toCanvasElement: function(multiplier, cropping) {
      multiplier = multiplier || 1;
      cropping = cropping || { };
      var scaledWidth = (cropping.width || this.width) * multiplier,
          scaledHeight = (cropping.height || this.height) * multiplier,
          zoom = this.getZoom(),
          originalWidth = this.width,
          originalHeight = this.height,
          newZoom = zoom * multiplier,
          vp = this.viewportTransform,
          translateX = (vp[4] - (cropping.left || 0)) * multiplier,
          translateY = (vp[5] - (cropping.top || 0)) * multiplier,
          originalInteractive = this.interactive,
          newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
          originalRetina = this.enableRetinaScaling,
          canvasEl = fabric.util.createCanvasElement(),
          originalContextTop = this.contextTop;
      canvasEl.width = scaledWidth;
      canvasEl.height = scaledHeight;
      this.contextTop = null;
      this.enableRetinaScaling = false;
      this.interactive = false;
      this.viewportTransform = newVp;
      this.width = scaledWidth;
      this.height = scaledHeight;
      this.calcViewportBoundaries();
      this.renderCanvas(canvasEl.getContext('2d'), this._objects);
      this.viewportTransform = vp;
      this.width = originalWidth;
      this.height = originalHeight;
      this.calcViewportBoundaries();
      this.interactive = originalInteractive;
      this.enableRetinaScaling = originalRetina;
      this.contextTop = originalContextTop;
      return canvasEl;
    },
  });

})();


fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
  /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * });
   */
  loadFromJSON: function (json, callback, reviver) {
    if (!json) {
      return;
    }

    // serialize if it wasn't already
    var serialized = (typeof json === 'string')
      ? JSON.parse(json)
      : fabric.util.object.clone(json);

    var _this = this,
        clipPath = serialized.clipPath,
        renderOnAddRemove = this.renderOnAddRemove;

    this.renderOnAddRemove = false;

    delete serialized.clipPath;

    this._enlivenObjects(serialized.objects, function (enlivenedObjects) {
      _this.clear();
      _this._setBgOverlay(serialized, function () {
        if (clipPath) {
          _this._enlivenObjects([clipPath], function (enlivenedCanvasClip) {
            _this.clipPath = enlivenedCanvasClip[0];
            _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
          });
        }
        else {
          _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
        }
      });
    }, reviver);
    return this;
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Array} restored canvas objects
   * @param {Function} cached renderOnAddRemove callback
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
    var _this = this;
    enlivenedObjects.forEach(function(obj, index) {
      // we splice the array just in case some custom classes restored from JSON
      // will add more object to canvas at canvas init.
      _this.insertAt(obj, index);
    });
    this.renderOnAddRemove = renderOnAddRemove;
    // remove parts i cannot set as options
    delete serialized.objects;
    delete serialized.backgroundImage;
    delete serialized.overlayImage;
    delete serialized.background;
    delete serialized.overlay;
    // this._initOptions does too many things to just
    // call it. Normally loading an Object from JSON
    // create the Object instance. Here the Canvas is
    // already an instance and we are just loading things over it
    this._setOptions(serialized);
    this.renderAll();
    callback && callback();
  },

  /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */
  _setBgOverlay: function(serialized, callback) {
    var loaded = {
      backgroundColor: false,
      overlayColor: false,
      backgroundImage: false,
      overlayImage: false
    };

    if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
      callback && callback();
      return;
    }

    var cbIfLoaded = function () {
      if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
        callback && callback();
      }
    };

    this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);
    this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);
    this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);
    this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
  },

  /**
   * @private
   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
   * @param {(Object|String)} value Value to set
   * @param {Object} loaded Set loaded property to true if property is set
   * @param {Object} callback Callback function to invoke after property is set
   */
  __setBgOverlay: function(property, value, loaded, callback) {
    var _this = this;

    if (!value) {
      loaded[property] = true;
      callback && callback();
      return;
    }

    if (property === 'backgroundImage' || property === 'overlayImage') {
      fabric.util.enlivenObjects([value], function(enlivedObject){
        _this[property] = enlivedObject[0];
        loaded[property] = true;
        callback && callback();
      });
    }
    else {
      this['set' + fabric.util.string.capitalize(property, true)](value, function() {
        loaded[property] = true;
        callback && callback();
      });
    }
  },

  /**
   * @private
   * @param {Array} objects
   * @param {Function} callback
   * @param {Function} [reviver]
   */
  _enlivenObjects: function (objects, callback, reviver) {
    if (!objects || objects.length === 0) {
      callback && callback([]);
      return;
    }

    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      callback && callback(enlivenedObjects);
    }, null, reviver);
  },

  /**
   * @private
   * @param {String} format
   * @param {Function} callback
   */
  _toDataURL: function (format, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURL(format));
    });
  },

  /**
   * @private
   * @param {String} format
   * @param {Number} multiplier
   * @param {Function} callback
   */
  _toDataURLWithMultiplier: function (format, multiplier, callback) {
    this.clone(function (clone) {
      callback(clone.toDataURLWithMultiplier(format, multiplier));
    });
  },

  /**
   * Clones canvas instance
   * @param {Object} [callback] Receives cloned instance as a first argument
   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
   */
  clone: function (callback, properties) {
    var data = JSON.stringify(this.toJSON(properties));
    this.cloneWithoutData(function(clone) {
      clone.loadFromJSON(data, function() {
        callback && callback(clone);
      });
    });
  },

  /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions, clipping properties, etc.
   * but leaves data empty (so that you can populate it with your own)
   * @param {Object} [callback] Receives cloned instance as a first argument
   */
  cloneWithoutData: function(callback) {
    var el = fabric.util.createCanvasElement();

    el.width = this.width;
    el.height = this.height;

    var clone = new fabric.Canvas(el);
    if (this.backgroundImage) {
      clone.setBackgroundImage(this.backgroundImage.src, function() {
        clone.renderAll();
        callback && callback(clone);
      });
      clone.backgroundImageOpacity = this.backgroundImageOpacity;
      clone.backgroundImageStretch = this.backgroundImageStretch;
    }
    else {
      callback && callback(clone);
    }
  }
});


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      toFixed = fabric.util.toFixed,
      capitalize = fabric.util.string.capitalize,
      degreesToRadians = fabric.util.degreesToRadians,
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash'),
      objectCaching = !fabric.isLikelyNode,
      ALIASING_LIMIT = 2;

  if (fabric.Object) {
    return;
  }

  /**
   * Root object class from which all 2d shape classes inherit from
   * @class fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   * @see {@link fabric.Object#initialize} for constructor definition
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   * @fires modified
   * @fires modified
   * @fires moved
   * @fires scaled
   * @fires rotated
   * @fires skewed
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */
  fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {

    /**
     * Type of an object (rect, circle, path, etc.).
     * Note that this property is meant to be read-only and not meant to be modified.
     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
     * @type String
     * @default
     */
    type:                     'object',

    /**
     * Horizontal origin of transformation of an object (one of "left", "right", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originX:                  'left',

    /**
     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */
    originY:                  'top',

    /**
     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
     * @type Number
     * @default
     */
    top:                      0,

    /**
     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
     * @type Number
     * @default
     */
    left:                     0,

    /**
     * Object width
     * @type Number
     * @default
     */
    width:                    0,

    /**
     * Object height
     * @type Number
     * @default
     */
    height:                   0,

    /**
     * Object scale factor (horizontal)
     * @type Number
     * @default
     */
    scaleX:                   1,

    /**
     * Object scale factor (vertical)
     * @type Number
     * @default
     */
    scaleY:                   1,

    /**
     * When true, an object is rendered as flipped horizontally
     * @type Boolean
     * @default
     */
    flipX:                    false,

    /**
     * When true, an object is rendered as flipped vertically
     * @type Boolean
     * @default
     */
    flipY:                    false,

    /**
     * Opacity of an object
     * @type Number
     * @default
     */
    opacity:                  1,

    /**
     * Angle of rotation of an object (in degrees)
     * @type Number
     * @default
     */
    angle:                    0,

    /**
     * Angle of skew on x axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewX:                    0,

    /**
     * Angle of skew on y axes of an object (in degrees)
     * @type Number
     * @default
     */
    skewY:                    0,

    /**
     * Size of object's controlling corners (in pixels)
     * @type Number
     * @default
     */
    cornerSize:               13,

    /**
     * Size of object's controlling corners when touch interaction is detected
     * @type Number
     * @default
     */
    touchCornerSize:               24,

    /**
     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
     * @type Boolean
     * @default
     */
    transparentCorners:       true,

    /**
     * Default cursor value used when hovering over this object on canvas
     * @type String
     * @default
     */
    hoverCursor:              null,

    /**
     * Default cursor value used when moving this object on canvas
     * @type String
     * @default
     */
    moveCursor:               null,

    /**
     * Padding between object and its controlling borders (in pixels)
     * @type Number
     * @default
     */
    padding:                  0,

    /**
     * Color of controlling borders of an object (when it's active)
     * @type String
     * @default
     */
    borderColor:              'rgb(178,204,255)',

    /**
     * Array specifying dash pattern of an object's borders (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    borderDashArray:          null,

    /**
     * Color of controlling corners of an object (when it's active)
     * @type String
     * @default
     */
    cornerColor:              'rgb(178,204,255)',

    /**
     * Color of controlling corners of an object (when it's active and transparentCorners false)
     * @since 1.6.2
     * @type String
     * @default
     */
    cornerStrokeColor:        null,

    /**
     * Specify style of control, 'rect' or 'circle'
     * @since 1.6.2
     * @type String
     */
    cornerStyle:          'rect',

    /**
     * Array specifying dash pattern of an object's control (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */
    cornerDashArray:          null,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being scaled via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredScaling:          false,

    /**
     * When true, this object will use center point as the origin of transformation
     * when being rotated via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */
    centeredRotation:         true,

    /**
     * Color of object's fill
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    fill:                     'rgb(0,0,0)',

    /**
     * Fill rule used to fill an object
     * accepted values are nonzero, evenodd
     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
     * @type String
     * @default
     */
    fillRule:                 'nonzero',

    /**
     * Composite rule used for canvas globalCompositeOperation
     * @type String
     * @default
     */
    globalCompositeOperation: 'source-over',

    /**
     * Background color of an object.
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    backgroundColor:          '',

    /**
     * Selection Background color of an object. colored layer behind the object when it is active.
     * does not mix good with globalCompositeOperation methods.
     * @type String
     * @default
     */
    selectionBackgroundColor:          '',

    /**
     * When defined, an object is rendered via stroke and this property specifies its color
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */
    stroke:                   null,

    /**
     * Width of a stroke used to render this object
     * @type Number
     * @default
     */
    strokeWidth:              1,

    /**
     * Array specifying dash pattern of an object's stroke (stroke must be defined)
     * @type Array
     */
    strokeDashArray:          null,

    /**
     * Line offset of an object's stroke
     * @type Number
     * @default
     */
    strokeDashOffset: 0,

    /**
     * Line endings style of an object's stroke (one of "butt", "round", "square")
     * @type String
     * @default
     */
    strokeLineCap:            'butt',

    /**
     * Corner style of an object's stroke (one of "bevil", "round", "miter")
     * @type String
     * @default
     */
    strokeLineJoin:           'miter',

    /**
     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
     * @type Number
     * @default
     */
    strokeMiterLimit:         4,

    /**
     * Shadow object representing shadow of this shape
     * @type fabric.Shadow
     * @default
     */
    shadow:                   null,

    /**
     * Opacity of object's controlling borders when object is active and moving
     * @type Number
     * @default
     */
    borderOpacityWhenMoving:  0.4,

    /**
     * Scale factor of object's controlling borders
     * bigger number will make a thicker border
     * border is 1, so this is basically a border tickness
     * since there is no way to change the border itself.
     * @type Number
     * @default
     */
    borderScaleFactor:        1,

    /**
     * Minimum allowed scale value of an object
     * @type Number
     * @default
     */
    minScaleLimit:            0,

    /**
     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
     * But events still fire on it.
     * @type Boolean
     * @default
     */
    selectable:               true,

    /**
     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
     * @type Boolean
     * @default
     */
    evented:                  true,

    /**
     * When set to `false`, an object is not rendered on canvas
     * @type Boolean
     * @default
     */
    visible:                  true,

    /**
     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
     * @type Boolean
     * @default
     */
    hasControls:              true,

    /**
     * When set to `false`, object's controlling borders are not rendered
     * @type Boolean
     * @default
     */
    hasBorders:               true,

    /**
     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
     * @type Boolean
     * @default
     */
    perPixelTargetFind:       false,

    /**
     * When `false`, default object's values are not included in its serialization
     * @type Boolean
     * @default
     */
    includeDefaultValues:     true,

    /**
     * When `true`, object horizontal movement is locked
     * @type Boolean
     * @default
     */
    lockMovementX:            false,

    /**
     * When `true`, object vertical movement is locked
     * @type Boolean
     * @default
     */
    lockMovementY:            false,

    /**
     * When `true`, object rotation is locked
     * @type Boolean
     * @default
     */
    lockRotation:             false,

    /**
     * When `true`, object horizontal scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingX:             false,

    /**
     * When `true`, object vertical scaling is locked
     * @type Boolean
     * @default
     */
    lockScalingY:             false,

    /**
     * When `true`, object horizontal skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingX:             false,

    /**
     * When `true`, object vertical skewing is locked
     * @type Boolean
     * @default
     */
    lockSkewingY:             false,

    /**
     * When `true`, object cannot be flipped by scaling into negative values
     * @type Boolean
     * @default
     */
    lockScalingFlip:          false,

    /**
     * When `true`, object is not exported in OBJECT/JSON
     * @since 1.6.3
     * @type Boolean
     * @default
     */
    excludeFromExport:        false,

    /**
     * When `true`, object is cached on an additional canvas.
     * When `false`, object is not cached unless necessary ( clipPath )
     * default to true
     * @since 1.7.0
     * @type Boolean
     * @default true
     */
    objectCaching:            objectCaching,

    /**
     * When `true`, object properties are checked for cache invalidation. In some particular
     * situation you may want this to be disabled ( spray brush, very big, groups)
     * or if your application does not allow you to modify properties for groups child you want
     * to disable it for groups.
     * default to false
     * since 1.7.0
     * @type Boolean
     * @default false
     */
    statefullCache:            false,

    /**
     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
     * too much and will be redrawn with correct details at the end of scaling.
     * this setting is performance and application dependant.
     * default to true
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    noScaleCache:              true,

    /**
     * When `false`, the stoke width will scale with the object.
     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
     * default to false
     * @since 2.6.0
     * @type Boolean
     * @default false
     * @type Boolean
     * @default false
     */
    strokeUniform:              false,

    /**
     * When set to `true`, object's cache will be rerendered next render call.
     * since 1.7.0
     * @type Boolean
     * @default true
     */
    dirty:                true,

    /**
     * keeps the value of the last hovered corner during mouse move.
     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
     * It should be private, but there is no harm in using it as
     * a read-only property.
     * @type number|string|any
     * @default 0
     */
    __corner: 0,

    /**
     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
     * @type String
     * @default
     */
    paintFirst:           'fill',

    /**
     * List of properties to consider when checking if state
     * of an object is changed (fabric.Object#hasStateChanged)
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: (
      'top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' +
      'stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit ' +
      'angle opacity fill globalCompositeOperation shadow visible backgroundColor ' +
      'skewX skewY fillRule paintFirst clipPath strokeUniform'
    ).split(' '),

    /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */
    cacheProperties: (
      'fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform' +
      ' strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath'
    ).split(' '),

    /**
     * List of properties to consider for animating colors.
     * @type Array
     */
    colorProperties: (
      'fill stroke backgroundColor'
    ).split(' '),

    /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the object has rendered, and the context is placed in the center
     * of the object cacheCanvas.
     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
     * @type fabric.Object
     */
    clipPath: undefined,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will make the object clip to the outside of the clipPath
     * since 2.4.0
     * @type boolean
     * @default false
     */
    inverted: false,

    /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will have its top and left relative to canvas, and will
     * not be influenced by the object transform. This will make the clipPath relative
     * to the canvas, but clipping just a particular object.
     * WARNING this is beta, this feature may change or be renamed.
     * since 2.4.0
     * @type boolean
     * @default false
     */
    absolutePositioned: false,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      if (options) {
        this.setOptions(options);
      }
    },

    /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */
    _createCacheCanvas: function() {
      this._cacheProperties = {};
      this._cacheCanvas = fabric.util.createCanvasElement();
      this._cacheContext = this._cacheCanvas.getContext('2d');
      this._updateCacheCanvas();
      // if canvas gets created, is empty, so dirty.
      this.dirty = true;
    },

    /**
     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _limitCacheSize: function(dims) {
      var perfLimitSizeTotal = fabric.perfLimitSizeTotal,
          width = dims.width, height = dims.height,
          max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
      if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
        if (width < min) {
          dims.width = min;
        }
        if (height < min) {
          dims.height = min;
        }
        return dims;
      }
      var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal),
          capValue = fabric.util.capValue,
          x = capValue(min, limitedDims.x, max),
          y = capValue(min, limitedDims.y, max);
      if (width > x) {
        dims.zoomX /= width / x;
        dims.width = x;
        dims.capped = true;
      }
      if (height > y) {
        dims.zoomY /= height / y;
        dims.height = y;
        dims.capped = true;
      }
      return dims;
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function() {
      var objectScale = this.getTotalObjectScaling(),
          // caculate dimensions without skewing
          dim = this._getTransformedDimensions(0, 0),
          neededX = dim.x * objectScale.scaleX / this.scaleX,
          neededY = dim.y * objectScale.scaleY / this.scaleY;
      return {
        // for sure this ALIASING_LIMIT is slightly creating problem
        // in situation in which the cache canvas gets an upper limit
        // also objectScale contains already scaleX and scaleY
        width: neededX + ALIASING_LIMIT,
        height: neededY + ALIASING_LIMIT,
        zoomX: objectScale.scaleX,
        zoomY: objectScale.scaleY,
        x: neededX,
        y: neededY
      };
    },

    /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */
    _updateCacheCanvas: function() {
      var targetCanvas = this.canvas;
      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
        var target = targetCanvas._currentTransform.target,
            action = targetCanvas._currentTransform.action;
        if (this === target && action.slice && action.slice(0, 5) === 'scale') {
          return false;
        }
      }
      var canvas = this._cacheCanvas,
          dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          minCacheSize = fabric.minCacheSideLimit,
          width = dims.width, height = dims.height, drawingWidth, drawingHeight,
          zoomX = dims.zoomX, zoomY = dims.zoomY,
          dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight,
          zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY,
          shouldRedraw = dimensionsChanged || zoomChanged,
          additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
      if (dimensionsChanged) {
        var canvasWidth = this._cacheCanvas.width,
            canvasHeight = this._cacheCanvas.height,
            sizeGrowing = width > canvasWidth || height > canvasHeight,
            sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) &&
              canvasWidth > minCacheSize && canvasHeight > minCacheSize;
        shouldResizeCanvas = sizeGrowing || sizeShrinking;
        if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
          additionalWidth = width * 0.1;
          additionalHeight = height * 0.1;
        }
      }
      if (shouldRedraw) {
        if (shouldResizeCanvas) {
          canvas.width = Math.ceil(width + additionalWidth);
          canvas.height = Math.ceil(height + additionalHeight);
        }
        else {
          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
          this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
        }
        drawingWidth = dims.x / 2;
        drawingHeight = dims.y / 2;
        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
        this.cacheWidth = width;
        this.cacheHeight = height;
        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
        this._cacheContext.scale(zoomX, zoomY);
        this.zoomX = zoomX;
        this.zoomY = zoomY;
        return true;
      }
      return false;
    },

    /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */
    setOptions: function(options) {
      this._setOptions(options);
      this._initGradient(options.fill, 'fill');
      this._initGradient(options.stroke, 'stroke');
      this._initPattern(options.fill, 'fill');
      this._initPattern(options.stroke, 'stroke');
    },

    /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */
    transform: function(ctx) {
      var needFullTransform = (this.group && !this.group._transformDone) ||
         (this.group && this.canvas && ctx === this.canvas.contextTop);
      var m = this.calcTransformMatrix(!needFullTransform);
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    },

    /**
     * Returns an object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,

          object = {
            type:                     this.type,
            version:                  fabric.version,
            originX:                  this.originX,
            originY:                  this.originY,
            left:                     toFixed(this.left, NUM_FRACTION_DIGITS),
            top:                      toFixed(this.top, NUM_FRACTION_DIGITS),
            width:                    toFixed(this.width, NUM_FRACTION_DIGITS),
            height:                   toFixed(this.height, NUM_FRACTION_DIGITS),
            fill:                     (this.fill && this.fill.toObject) ? this.fill.toObject() : this.fill,
            stroke:                   (this.stroke && this.stroke.toObject) ? this.stroke.toObject() : this.stroke,
            strokeWidth:              toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
            strokeDashArray:          this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
            strokeLineCap:            this.strokeLineCap,
            strokeDashOffset:         this.strokeDashOffset,
            strokeLineJoin:           this.strokeLineJoin,
            // strokeUniform:            this.strokeUniform,
            strokeMiterLimit:         toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
            scaleX:                   toFixed(this.scaleX, NUM_FRACTION_DIGITS),
            scaleY:                   toFixed(this.scaleY, NUM_FRACTION_DIGITS),
            angle:                    toFixed(this.angle, NUM_FRACTION_DIGITS),
            flipX:                    this.flipX,
            flipY:                    this.flipY,
            opacity:                  toFixed(this.opacity, NUM_FRACTION_DIGITS),
            shadow:                   (this.shadow && this.shadow.toObject) ? this.shadow.toObject() : this.shadow,
            visible:                  this.visible,
            backgroundColor:          this.backgroundColor,
            fillRule:                 this.fillRule,
            paintFirst:               this.paintFirst,
            globalCompositeOperation: this.globalCompositeOperation,
            skewX:                    toFixed(this.skewX, NUM_FRACTION_DIGITS),
            skewY:                    toFixed(this.skewY, NUM_FRACTION_DIGITS),
          };

      if (this.clipPath) {
        object.clipPath = this.clipPath.toObject(propertiesToInclude);
        object.clipPath.inverted = this.clipPath.inverted;
        object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
      }

      fabric.util.populateWithProperties(this, object, propertiesToInclude);
      if (!this.includeDefaultValues) {
        object = this._removeDefaultValues(object);
      }

      return object;
    },

    /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      // will be overwritten by subclasses
      return this.toObject(propertiesToInclude);
    },

    /**
     * @private
     * @param {Object} object
     */
    _removeDefaultValues: function(object) {
      var prototype = fabric.util.getKlass(object.type).prototype,
          stateProperties = prototype.stateProperties;
      stateProperties.forEach(function(prop) {
        if (prop === 'left' || prop === 'top') {
          return;
        }
        if (object[prop] === prototype[prop]) {
          delete object[prop];
        }
        var isArray = Object.prototype.toString.call(object[prop]) === '[object Array]' &&
                      Object.prototype.toString.call(prototype[prop]) === '[object Array]';

        // basically a check for [] === []
        if (isArray && object[prop].length === 0 && prototype[prop].length === 0) {
          delete object[prop];
        }
      });

      return object;
    },

    /**
     * Returns a string representation of an instance
     * @return {String}
     */
    toString: function() {
      return '#<fabric.' + capitalize(this.type) + '>';
    },

    /**
     * Return the object scale factor counting also the group scaling
     * @return {Object} object with scaleX and scaleY properties
     */
    getObjectScaling: function() {
      var options = fabric.util.qrDecompose(this.calcTransformMatrix());
      return { scaleX: Math.abs(options.scaleX), scaleY: Math.abs(options.scaleY) };
    },

    /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */
    getTotalObjectScaling: function() {
      var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
      if (this.canvas) {
        var zoom = this.canvas.getZoom();
        var retina = this.canvas.getRetinaScaling();
        scaleX *= zoom * retina;
        scaleY *= zoom * retina;
      }
      return { scaleX: scaleX, scaleY: scaleY };
    },

    /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */
    getObjectOpacity: function() {
      var opacity = this.opacity;
      if (this.group) {
        opacity *= this.group.getObjectOpacity();
      }
      return opacity;
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Object} thisArg
     */
    _set: function(key, value) {
      var shouldConstrainValue = (key === 'scaleX' || key === 'scaleY'),
          isChanged = this[key] !== value, groupNeedsUpdate = false;

      if (shouldConstrainValue) {
        value = this._constrainScale(value);
      }
      if (key === 'scaleX' && value < 0) {
        this.flipX = !this.flipX;
        value *= -1;
      }
      else if (key === 'scaleY' && value < 0) {
        this.flipY = !this.flipY;
        value *= -1;
      }
      else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) {
        value = new fabric.Shadow(value);
      }
      else if (key === 'dirty' && this.group) {
        this.group.set('dirty', value);
      }

      this[key] = value;

      if (isChanged) {
        groupNeedsUpdate = this.group && this.group.isOnACache();
        if (this.cacheProperties.indexOf(key) > -1) {
          this.dirty = true;
          groupNeedsUpdate && this.group.set('dirty', true);
        }
        else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
          this.group.set('dirty', true);
        }
      }

      return this;
    },

    /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */
    setOnGroup: function() {
      // implemented by sub-classes, as needed.
    },

    /**
     * Retrieves viewportTransform from Object's canvas if possible
     * @method getViewportTransform
     * @memberOf fabric.Object.prototype
     * @return {Array}
     */
    getViewportTransform: function() {
      if (this.canvas && this.canvas.viewportTransform) {
        return this.canvas.viewportTransform;
      }
      return fabric.iMatrix.concat();
    },

    /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf fabric.Object.prototype
     * @return {Boolean}
     */
    isNotVisible: function() {
      return this.opacity === 0 ||
        (!this.width && !this.height && this.strokeWidth === 0) ||
        !this.visible;
    },

    /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      // do not render if width/height are zeros or object is not visible
      if (this.isNotVisible()) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      ctx.save();
      this._setupCompositeOperation(ctx);
      this.drawSelectionBackground(ctx);
      this.transform(ctx);
      this._setOpacity(ctx);
      this._setShadow(ctx, this);
      if (this.shouldCache()) {
        this.renderCache();
        this.drawCacheOnCanvas(ctx);
      }
      else {
        this._removeCacheCanvas();
        this.dirty = false;
        this.drawObject(ctx);
        if (this.objectCaching && this.statefullCache) {
          this.saveState({ propertySet: 'cacheProperties' });
        }
      }
      ctx.restore();
    },

    renderCache: function(options) {
      options = options || {};
      if (!this._cacheCanvas) {
        this._createCacheCanvas();
      }
      if (this.isCacheDirty()) {
        this.statefullCache && this.saveState({ propertySet: 'cacheProperties' });
        this.drawObject(this._cacheContext, options.forClipping);
        this.dirty = false;
      }
    },

    /**
     * Remove cacheCanvas and its dimensions from the objects
     */
    _removeCacheCanvas: function() {
      this._cacheCanvas = null;
      this.cacheWidth = 0;
      this.cacheHeight = 0;
    },

    /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an aproximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasStroke: function() {
      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
    },

    /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an aproximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasFill: function() {
      return this.fill && this.fill !== 'transparent';
    },

    /**
     * When set to `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */
    needsItsOwnCache: function() {
      if (this.paintFirst === 'stroke' &&
        this.hasFill() && this.hasStroke() && typeof this.shadow === 'object') {
        return true;
      }
      if (this.clipPath) {
        return true;
      }
      return false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */
    shouldCache: function() {
      this.ownCaching = this.needsItsOwnCache() || (
        this.objectCaching &&
        (!this.group || !this.group.isOnACache())
      );
      return this.ownCaching;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     */
    willDrawShadow: function() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    },

    /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCache: function(ctx) {
      var path = this.clipPath;
      ctx.save();
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4
      if (path.inverted) {
        ctx.globalCompositeOperation = 'destination-out';
      }
      else {
        ctx.globalCompositeOperation = 'destination-in';
      }
      //ctx.scale(1 / 2, 1 / 2);
      if (path.absolutePositioned) {
        var m = fabric.util.invertTransform(this.calcTransformMatrix());
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }
      path.transform(ctx);
      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
      ctx.restore();
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function(ctx, forClipping) {
      var originalFill = this.fill, originalStroke = this.stroke;
      if (forClipping) {
        this.fill = 'black';
        this.stroke = '';
        this._setClippingProperties(ctx);
      }
      else {
        this._renderBackground(ctx);
        this._setStrokeStyles(ctx, this);
        this._setFillStyles(ctx, this);
      }
      this._render(ctx);
      this._drawClipPath(ctx);
      this.fill = originalFill;
      this.stroke = originalStroke;
    },

    _drawClipPath: function(ctx) {
      var path = this.clipPath;
      if (!path) { return; }
      // needed to setup a couple of variables
      // path canvas gets overridden with this one.
      // TODO find a better solution?
      path.canvas = this.canvas;
      path.shouldCache();
      path._transformDone = true;
      path.renderCache({ forClipping: true });
      this.drawClipPathOnCache(ctx);
    },

    /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas: function(ctx) {
      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    },

    /**
     * Check if cache is dirty
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */
    isCacheDirty: function(skipCanvas) {
      if (this.isNotVisible()) {
        return false;
      }
      if (this._cacheCanvas && !skipCanvas && this._updateCacheCanvas()) {
        // in this case the context is already cleared.
        return true;
      }
      else {
        if (this.dirty ||
          (this.clipPath && this.clipPath.absolutePositioned) ||
          (this.statefullCache && this.hasStateChanged('cacheProperties'))
        ) {
          if (this._cacheCanvas && !skipCanvas) {
            var width = this.cacheWidth / this.zoomX;
            var height = this.cacheHeight / this.zoomY;
            this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
          }
          return true;
        }
      }
      return false;
    },

    /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground: function(ctx) {
      if (!this.backgroundColor) {
        return;
      }
      var dim = this._getNonTransformedDimensions();
      ctx.fillStyle = this.backgroundColor;

      ctx.fillRect(
        -dim.x / 2,
        -dim.y / 2,
        dim.x,
        dim.y
      );
      // if there is background color no other shadows
      // should be casted
      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setOpacity: function(ctx) {
      if (this.group && !this.group._transformDone) {
        ctx.globalAlpha = this.getObjectOpacity();
      }
      else {
        ctx.globalAlpha *= this.opacity;
      }
    },

    _setStrokeStyles: function(ctx, decl) {
      if (decl.stroke) {
        ctx.lineWidth = decl.strokeWidth;
        ctx.lineCap = decl.strokeLineCap;
        ctx.lineDashOffset = decl.strokeDashOffset;
        ctx.lineJoin = decl.strokeLineJoin;
        ctx.miterLimit = decl.strokeMiterLimit;
        ctx.strokeStyle = decl.stroke.toLive
          ? decl.stroke.toLive(ctx, this)
          : decl.stroke;
      }
    },

    _setFillStyles: function(ctx, decl) {
      if (decl.fill) {
        ctx.fillStyle = decl.fill.toLive
          ? decl.fill.toLive(ctx, this)
          : decl.fill;
      }
    },

    _setClippingProperties: function(ctx) {
      ctx.globalAlpha = 1;
      ctx.strokeStyle = 'transparent';
      ctx.fillStyle = '#000000';
    },

    /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     * @param {Function} alternative function to call if browser does not support lineDash
     */
    _setLineDash: function(ctx, dashArray, alternative) {
      if (!dashArray || dashArray.length === 0) {
        return;
      }
      // Spec requires the concatenation of two copies the dash list when the number of elements is odd
      if (1 & dashArray.length) {
        dashArray.push.apply(dashArray, dashArray);
      }
      if (supportsLineDash) {
        ctx.setLineDash(dashArray);
      }
      else {
        alternative && alternative(ctx);
      }
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     */
    _renderControls: function(ctx, styleOverride) {
      var vpt = this.getViewportTransform(),
          matrix = this.calcTransformMatrix(),
          options, drawBorders, drawControls;
      styleOverride = styleOverride || { };
      drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
      drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
      matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
      options = fabric.util.qrDecompose(matrix);
      ctx.save();
      ctx.translate(options.translateX, options.translateY);
      ctx.lineWidth = 1 * this.borderScaleFactor;
      if (!this.group) {
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      }
      if (styleOverride.forActiveSelection) {
        ctx.rotate(degreesToRadians(options.angle));
        drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
      }
      else {
        ctx.rotate(degreesToRadians(this.angle));
        drawBorders && this.drawBorders(ctx, styleOverride);
      }
      drawControls && this.drawControls(ctx, styleOverride);
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setShadow: function(ctx) {
      if (!this.shadow) {
        return;
      }

      var shadow = this.shadow, canvas = this.canvas, scaling,
          multX = (canvas && canvas.viewportTransform[0]) || 1,
          multY = (canvas && canvas.viewportTransform[3]) || 1;
      if (shadow.nonScaling) {
        scaling = { scaleX: 1, scaleY: 1 };
      }
      else {
        scaling = this.getObjectScaling();
      }
      if (canvas && canvas._isRetinaScaling()) {
        multX *= fabric.devicePixelRatio;
        multY *= fabric.devicePixelRatio;
      }
      ctx.shadowColor = shadow.color;
      ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant *
        (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _removeShadow: function(ctx) {
      if (!this.shadow) {
        return;
      }

      ctx.shadowColor = '';
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */
    _applyPatternGradientTransform: function(ctx, filler) {
      if (!filler || !filler.toLive) {
        return { offsetX: 0, offsetY: 0 };
      }
      var t = filler.gradientTransform || filler.patternTransform;
      var offsetX = -this.width / 2 + filler.offsetX || 0,
          offsetY = -this.height / 2 + filler.offsetY || 0;

      if (filler.gradientUnits === 'percentage') {
        ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
      }
      else {
        ctx.transform(1, 0, 0, 1, offsetX, offsetY);
      }
      if (t) {
        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
      }
      return { offsetX: offsetX, offsetY: offsetY };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderPaintInOrder: function(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderStroke(ctx);
        this._renderFill(ctx);
      }
      else {
        this._renderFill(ctx);
        this._renderStroke(ctx);
      }
    },

    /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(/* ctx */) {

    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderFill: function(ctx) {
      if (!this.fill) {
        return;
      }

      ctx.save();
      this._applyPatternGradientTransform(ctx, this.fill);
      if (this.fillRule === 'evenodd') {
        ctx.fill('evenodd');
      }
      else {
        ctx.fill();
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderStroke: function(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();
      if (this.strokeUniform && this.group) {
        var scaling = this.getObjectScaling();
        ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
      }
      else if (this.strokeUniform) {
        ctx.scale(1 / this.scaleX, 1 / this.scaleY);
      }
      this._setLineDash(ctx, this.strokeDashArray, this._renderDashedStroke);
      if (this.stroke.toLive && this.stroke.gradientUnits === 'percentage') {
        // need to transform gradient in a pattern.
        // this is a slow process. If you are hitting this codepath, and the object
        // is not using caching, you should consider switching it on.
        // we need a canvas as big as the current object caching canvas.
        this._applyPatternForTransformedGradient(ctx, this.stroke);
      }
      else {
        this._applyPatternGradientTransform(ctx, this.stroke);
      }
      ctx.stroke();
      ctx.restore();
    },

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Gradient} filler a fabric gradient instance
     */
    _applyPatternForTransformedGradient: function(ctx, filler) {
      var dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
          pCanvas = fabric.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(),
          width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
      pCanvas.width = width;
      pCanvas.height = height;
      pCtx = pCanvas.getContext('2d');
      pCtx.beginPath(); pCtx.moveTo(0, 0); pCtx.lineTo(width, 0); pCtx.lineTo(width, height);
      pCtx.lineTo(0, height); pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.scale(
        dims.zoomX / this.scaleX / retinaScaling,
        dims.zoomY / this.scaleY / retinaScaling
      );
      this._applyPatternGradientTransform(pCtx, filler);
      pCtx.fillStyle = filler.toLive(ctx);
      pCtx.fill();
      ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
      ctx.scale(
        retinaScaling * this.scaleX / dims.zoomX,
        retinaScaling * this.scaleY / dims.zoomY
      );
      ctx.strokeStyle = pCtx.createPattern(pCanvas, 'no-repeat');
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function() {
      return { x: this.left + this.width / 2, y: this.top + this.height / 2 };
    },

    /**
     * This function is an helper for svg import. it decompose the transformMatrix
     * and assign properties to object.
     * untransformed coordinates
     * @private
     * @chainable
     */
    _assignTransformMatrixProps: function() {
      if (this.transformMatrix) {
        var options = fabric.util.qrDecompose(this.transformMatrix);
        this.flipX = false;
        this.flipY = false;
        this.set('scaleX', options.scaleX);
        this.set('scaleY', options.scaleY);
        this.angle = options.angle;
        this.skewX = options.skewX;
        this.skewY = 0;
      }
    },

    /**
     * This function is an helper for svg import. it removes the transform matrix
     * and set to object properties that fabricjs can handle
     * @private
     * @param {Object} preserveAspectRatioOptions
     * @return {thisArg}
     */
    _removeTransformMatrix: function(preserveAspectRatioOptions) {
      var center = this._findCenterFromElement();
      if (this.transformMatrix) {
        this._assignTransformMatrixProps();
        center = fabric.util.transformPoint(center, this.transformMatrix);
      }
      this.transformMatrix = null;
      if (preserveAspectRatioOptions) {
        this.scaleX *= preserveAspectRatioOptions.scaleX;
        this.scaleY *= preserveAspectRatioOptions.scaleY;
        this.cropX = preserveAspectRatioOptions.cropX;
        this.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        this.width = preserveAspectRatioOptions.width;
        this.height = preserveAspectRatioOptions.height;
      }
      this.setPositionByOrigin(center, 'center', 'center');
    },

    /**
     * Clones an instance, using a callback method will work for every object.
     * @param {Function} callback Callback is invoked with a clone as a first argument
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     */
    clone: function(callback, propertiesToInclude) {
      var objectForm = this.toObject(propertiesToInclude);
      if (this.constructor.fromObject) {
        this.constructor.fromObject(objectForm, callback);
      }
      else {
        fabric.Object._fromObject('Object', objectForm, callback);
      }
    },

    /**
     * Creates an instance of fabric.Image out of an object
     * could make use of both toDataUrl or toCanvasElement.
     * @param {Function} callback callback, invoked with an instance as a first argument
     * @param {Object} [options] for clone as image, passed to toDataURL
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {fabric.Object} thisArg
     */
    cloneAsImage: function(callback, options) {
      var canvasEl = this.toCanvasElement(options);
      if (callback) {
        callback(new fabric.Image(canvasEl));
      }
      return this;
    },

    /**
     * Converts an object into a HTMLCanvas element
     * @param {Object} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
     */
    toCanvasElement: function(options) {
      options || (options = { });

      var utils = fabric.util, origParams = utils.saveObjectTransform(this),
          originalGroup = this.group,
          originalShadow = this.shadow, abs = Math.abs,
          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
      delete this.group;
      if (options.withoutTransform) {
        utils.resetObjectTransform(this);
      }
      if (options.withoutShadow) {
        this.shadow = null;
      }

      var el = fabric.util.createCanvasElement(),
          // skip canvas zoom and calculate with setCoords now.
          boundingRect = this.getBoundingRect(true, true),
          shadow = this.shadow, scaling,
          shadowOffset = { x: 0, y: 0 }, shadowBlur,
          width, height;

      if (shadow) {
        shadowBlur = shadow.blur;
        if (shadow.nonScaling) {
          scaling = { scaleX: 1, scaleY: 1 };
        }
        else {
          scaling = this.getObjectScaling();
        }
        // consider non scaling shadow.
        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * (abs(scaling.scaleX));
        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * (abs(scaling.scaleY));
      }
      width = boundingRect.width + shadowOffset.x;
      height = boundingRect.height + shadowOffset.y;
      // if the current width/height is not an integer
      // we need to make it so.
      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      var canvas = new fabric.StaticCanvas(el, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false,
      });
      if (options.format === 'jpeg') {
        canvas.backgroundColor = '#fff';
      }
      this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');

      var originalCanvas = this.canvas;
      canvas.add(this);
      var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.shadow = originalShadow;
      this.set('canvas', originalCanvas);
      if (originalGroup) {
        this.group = originalGroup;
      }
      this.set(origParams).setCoords();
      // canvas.dispose will call image.dispose that will nullify the elements
      // since this canvas is a simple element for the process, we remove references
      // to objects in this way in order to avoid object trashing.
      canvas._objects = [];
      canvas.dispose();
      canvas = null;

      return canvasEl;
    },

    /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */
    toDataURL: function(options) {
      options || (options = { });
      return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    },

    /**
     * Returns true if specified type is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */
    isType: function(type) {
      return this.type === type;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */
    complexity: function() {
      return 1;
    },

    /**
     * Returns a JSON representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} JSON
     */
    toJSON: function(propertiesToInclude) {
      // delegate, not alias
      return this.toObject(propertiesToInclude);
    },

    /**
     * Sets "angle" of an instance with centered rotation
     * @param {Number} angle Angle value (in degrees)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    rotate: function(angle) {
      var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;

      if (shouldCenterOrigin) {
        this._setOriginToCenter();
      }

      this.set('angle', angle);

      if (shouldCenterOrigin) {
        this._resetOrigin();
      }

      return this;
    },

    /**
     * Centers object horizontally on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerH: function () {
      this.canvas && this.canvas.centerObjectH(this);
      return this;
    },

    /**
     * Centers object horizontally on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterH: function () {
      this.canvas && this.canvas.viewportCenterObjectH(this);
      return this;
    },

    /**
     * Centers object vertically on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    centerV: function () {
      this.canvas && this.canvas.centerObjectV(this);
      return this;
    },

    /**
     * Centers object vertically on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenterV: function () {
      this.canvas && this.canvas.viewportCenterObjectV(this);
      return this;
    },

    /**
     * Centers object vertically and horizontally on canvas to which is was added last
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    center: function () {
      this.canvas && this.canvas.centerObject(this);
      return this;
    },

    /**
     * Centers object on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    viewportCenter: function () {
      this.canvas && this.canvas.viewportCenterObject(this);
      return this;
    },

    /**
     * Returns coordinates of a pointer relative to an object
     * @param {Event} e Event to operate upon
     * @param {Object} [pointer] Pointer to operate upon (instead of event)
     * @return {Object} Coordinates of a pointer (x, y)
     */
    getLocalPointer: function(e, pointer) {
      pointer = pointer || this.canvas.getPointer(e);
      var pClicked = new fabric.Point(pointer.x, pointer.y),
          objectLeftTop = this._getLeftTopCoords();
      if (this.angle) {
        pClicked = fabric.util.rotatePoint(
          pClicked, objectLeftTop, degreesToRadians(-this.angle));
      }
      return {
        x: pClicked.x - objectLeftTop.x,
        y: pClicked.y - objectLeftTop.y
      };
    },

    /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */
    _setupCompositeOperation: function (ctx) {
      if (this.globalCompositeOperation) {
        ctx.globalCompositeOperation = this.globalCompositeOperation;
      }
    }
  });

  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);

  extend(fabric.Object.prototype, fabric.Observable);

  /**
   * Defines the number of fraction digits to use when serializing object values.
   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type Number
   */
  fabric.Object.NUM_FRACTION_DIGITS = 2;

  fabric.Object._fromObject = function(className, object, callback, extraParam) {
    var klass = fabric[className];
    object = clone(object, true);
    fabric.util.enlivenPatterns([object.fill, object.stroke], function(patterns) {
      if (typeof patterns[0] !== 'undefined') {
        object.fill = patterns[0];
      }
      if (typeof patterns[1] !== 'undefined') {
        object.stroke = patterns[1];
      }
      fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
        object.clipPath = enlivedProps[0];
        var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
        callback && callback(instance);
      });
    });
  };

  /**
   * Unique id used internally when creating SVG elements
   * @static
   * @memberOf fabric.Object
   * @type Number
   */
  fabric.Object.__uid = 0;
})( true ? exports : this);


(function() {

  var degreesToRadians = fabric.util.degreesToRadians,
      originXOffset = {
        left: -0.5,
        center: 0,
        right: 0.5
      },
      originYOffset = {
        top: -0.5,
        center: 0,
        bottom: 0.5
      };

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
      var x = point.x,
          y = point.y,
          offsetX, offsetY, dim;

      if (typeof fromOriginX === 'string') {
        fromOriginX = originXOffset[fromOriginX];
      }
      else {
        fromOriginX -= 0.5;
      }

      if (typeof toOriginX === 'string') {
        toOriginX = originXOffset[toOriginX];
      }
      else {
        toOriginX -= 0.5;
      }

      offsetX = toOriginX - fromOriginX;

      if (typeof fromOriginY === 'string') {
        fromOriginY = originYOffset[fromOriginY];
      }
      else {
        fromOriginY -= 0.5;
      }

      if (typeof toOriginY === 'string') {
        toOriginY = originYOffset[toOriginY];
      }
      else {
        toOriginY -= 0.5;
      }

      offsetY = toOriginY - fromOriginY;

      if (offsetX || offsetY) {
        dim = this._getTransformedDimensions();
        x = point.x + offsetX * dim.x;
        y = point.y + offsetY * dim.y;
      }

      return new fabric.Point(x, y);
    },

    /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToCenterPoint: function(point, originX, originY) {
      var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');
      if (this.angle) {
        return fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
      }
      return p;
    },

    /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {fabric.Point} center The point which corresponds to center of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    translateToOriginPoint: function(center, originX, originY) {
      var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
      if (this.angle) {
        return fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
      }
      return p;
    },

    /**
     * Returns the real center coordinates of the object
     * @return {fabric.Point}
     */
    getCenterPoint: function() {
      var leftTop = new fabric.Point(this.left, this.top);
      return this.translateToCenterPoint(leftTop, this.originX, this.originY);
    },

    /**
     * Returns the coordinates of the object based on center coordinates
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @return {fabric.Point}
     */
    // getOriginPoint: function(center) {
    //   return this.translateToOriginPoint(center, this.originX, this.originY);
    // },

    /**
     * Returns the coordinates of the object as if it has a different origin
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    getPointByOrigin: function(originX, originY) {
      var center = this.getCenterPoint();
      return this.translateToOriginPoint(center, originX, originY);
    },

    /**
     * Returns the point in local coordinates
     * @param {fabric.Point} point The point relative to the global coordinate system
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */
    toLocalPoint: function(point, originX, originY) {
      var center = this.getCenterPoint(),
          p, p2;

      if (typeof originX !== 'undefined' && typeof originY !== 'undefined' ) {
        p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
      }
      else {
        p = new fabric.Point(this.left, this.top);
      }

      p2 = new fabric.Point(point.x, point.y);
      if (this.angle) {
        p2 = fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
      }
      return p2.subtractEquals(p);
    },

    /**
     * Returns the point in global coordinates
     * @param {fabric.Point} The point relative to the local coordinate system
     * @return {fabric.Point}
     */
    // toGlobalPoint: function(point) {
    //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
    // },

    /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {fabric.Point} pos The new position of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */
    setPositionByOrigin: function(pos, originX, originY) {
      var center = this.translateToCenterPoint(pos, originX, originY),
          position = this.translateToOriginPoint(center, this.originX, this.originY);
      this.set('left', position.x);
      this.set('top', position.y);
    },

    /**
     * @param {String} to One of 'left', 'center', 'right'
     */
    adjustPosition: function(to) {
      var angle = degreesToRadians(this.angle),
          hypotFull = this.getScaledWidth(),
          xFull = fabric.util.cos(angle) * hypotFull,
          yFull = fabric.util.sin(angle) * hypotFull,
          offsetFrom, offsetTo;

      //TODO: this function does not consider mixed situation like top, center.
      if (typeof this.originX === 'string') {
        offsetFrom = originXOffset[this.originX];
      }
      else {
        offsetFrom = this.originX - 0.5;
      }
      if (typeof to === 'string') {
        offsetTo = originXOffset[to];
      }
      else {
        offsetTo = to - 0.5;
      }
      this.left += xFull * (offsetTo - offsetFrom);
      this.top += yFull * (offsetTo - offsetFrom);
      this.setCoords();
      this.originX = to;
    },

    /**
     * Sets the origin/position of the object to it's center point
     * @private
     * @return {void}
     */
    _setOriginToCenter: function() {
      this._originalOriginX = this.originX;
      this._originalOriginY = this.originY;

      var center = this.getCenterPoint();

      this.originX = 'center';
      this.originY = 'center';

      this.left = center.x;
      this.top = center.y;
    },

    /**
     * Resets the origin/position of the object to it's original origin
     * @private
     * @return {void}
     */
    _resetOrigin: function() {
      var originPoint = this.translateToOriginPoint(
        this.getCenterPoint(),
        this._originalOriginX,
        this._originalOriginY);

      this.originX = this._originalOriginX;
      this.originY = this._originalOriginY;

      this.left = originPoint.x;
      this.top = originPoint.y;

      this._originalOriginX = null;
      this._originalOriginY = null;
    },

    /**
     * @private
     */
    _getLeftTopCoords: function() {
      return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
    },
  });

})();


(function() {

  function arrayFromCoords(coords) {
    return [
      new fabric.Point(coords.tl.x, coords.tl.y),
      new fabric.Point(coords.tr.x, coords.tr.y),
      new fabric.Point(coords.br.x, coords.br.y),
      new fabric.Point(coords.bl.x, coords.bl.y)
    ];
  }

  var util = fabric.util,
      degreesToRadians = util.degreesToRadians,
      multiplyMatrices = util.multiplyTransformMatrices,
      transformPoint = util.transformPoint;

  util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Describe object's corner position in canvas element coordinates.
     * properties are depending on control keys and padding the main controls.
     * each property is an object with x, y and corner.
     * The `corner` property contains in a similar manner the 4 points of the
     * interactive area of the corner.
     * The coordinates depends from the controls positionHandler and are used
     * to draw and locate controls
     * @memberOf fabric.Object.prototype
     */
    oCoords: null,

    /**
     * Describe object's corner position in canvas object absolute coordinates
     * properties are tl,tr,bl,br and describe the four main corner.
     * each property is an object with x, y, instance of Fabric.Point.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, top, left.
     * Those coordinates are useful to understand where an object is. They get updated
     * with oCoords but they do not need to be updated when zoom or panning change.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcACoords();
     * @memberOf fabric.Object.prototype
     */
    aCoords: null,

    /**
     * Describe object's corner position in canvas element coordinates.
     * includes padding. Used of object detection.
     * set and refreshed with setCoords and calcCoords.
     * @memberOf fabric.Object.prototype
     */
    lineCoords: null,

    /**
     * storage for object transform matrix
     */
    ownMatrixCache: null,

    /**
     * storage for object full transform matrix
     */
    matrixCache: null,

    /**
     * custom controls interface
     * controls are added by default_controls.js
     */
    controls: { },

    /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * @param {Boolean} absolute will return aCoords if true or lineCoords
     * @return {Object} {tl, tr, br, bl} points
     */
    _getCoords: function(absolute, calculate) {
      if (calculate) {
        return (absolute ? this.calcACoords() : this.calcLineCoords());
      }
      if (!this.aCoords || !this.lineCoords) {
        this.setCoords(true);
      }
      return (absolute ? this.aCoords : this.lineCoords);
    },

    /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * The coords are returned in an array.
     * @return {Array} [tl, tr, br, bl] of points
     */
    getCoords: function(absolute, calculate) {
      return arrayFromCoords(this._getCoords(absolute, calculate));
    },

    /**
     * Checks if object intersects with an area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with an area formed by 2 points
     */
    intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
      var coords = this.getCoords(absolute, calculate),
          intersection = fabric.Intersection.intersectPolygonRectangle(
            coords,
            pointTL,
            pointBR
          );
      return intersection.status === 'Intersection';
    },

    /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with another object
     */
    intersectsWithObject: function(other, absolute, calculate) {
      var intersection = fabric.Intersection.intersectPolygonPolygon(
        this.getCoords(absolute, calculate),
        other.getCoords(absolute, calculate)
      );

      return intersection.status === 'Intersection'
        || other.isContainedWithinObject(this, absolute, calculate)
        || this.isContainedWithinObject(other, absolute, calculate);
    },

    /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area of another object
     */
    isContainedWithinObject: function(other, absolute, calculate) {
      var points = this.getCoords(absolute, calculate),
          otherCoords = absolute ? other.aCoords : other.lineCoords,
          i = 0, lines = other._getImageLines(otherCoords);
      for (; i < 4; i++) {
        if (!other.containsPoint(points[i], lines)) {
          return false;
        }
      }
      return true;
    },

    /**
     * Checks if object is fully contained within area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area formed by 2 points
     */
    isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
      var boundingRect = this.getBoundingRect(absolute, calculate);

      return (
        boundingRect.left >= pointTL.x &&
        boundingRect.left + boundingRect.width <= pointBR.x &&
        boundingRect.top >= pointTL.y &&
        boundingRect.top + boundingRect.height <= pointBR.y
      );
    },

    /**
     * Checks if point is inside the object
     * @param {fabric.Point} point Point to check against
     * @param {Object} [lines] object returned from @method _getImageLines
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if point is inside the object
     */
    containsPoint: function(point, lines, absolute, calculate) {
      var coords = this._getCoords(absolute, calculate),
          lines = lines || this._getImageLines(coords),
          xPoints = this._findCrossPoints(point, lines);
      // if xPoints is odd then point is inside the object
      return (xPoints !== 0 && xPoints % 2 === 1);
    },

    /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
     * @return {Boolean} true if object is fully or partially contained within canvas
     */
    isOnScreen: function(calculate) {
      if (!this.canvas) {
        return false;
      }
      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
      var points = this.getCoords(true, calculate);
      // if some point is on screen, the object is on screen.
      if (points.some(function(point) {
        return point.x <= pointBR.x && point.x >= pointTL.x &&
        point.y <= pointBR.y && point.y >= pointTL.y;
      })) {
        return true;
      }
      // no points on screen, check intersection with absolute coordinates
      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }
      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Checks if the object contains the midpoint between canvas extremities
     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
     * @private
     * @param {Fabric.Point} pointTL Top Left point
     * @param {Fabric.Point} pointBR Top Right point
     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
     * @return {Boolean} true if the object contains the point
     */
    _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
      // worst case scenario the object is so big that contains the screen
      var centerPoint = { x: (pointTL.x + pointBR.x) / 2, y: (pointTL.y + pointBR.y) / 2 };
      if (this.containsPoint(centerPoint, null, true, calculate)) {
        return true;
      }
      return false;
    },

    /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is partially contained within canvas
     */
    isPartiallyOnScreen: function(calculate) {
      if (!this.canvas) {
        return false;
      }
      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
        return true;
      }
      var allPointsAreOutside = this.getCoords(true, calculate).every(function(point) {
        return (point.x >= pointBR.x || point.x <= pointTL.x) &&
        (point.y >= pointBR.y || point.y <= pointTL.y);
      });
      return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
    },

    /**
     * Method that returns an object with the object edges in it, given the coordinates of the corners
     * @private
     * @param {Object} oCoords Coordinates of the object corners
     */
    _getImageLines: function(oCoords) {

      var lines = {
        topline: {
          o: oCoords.tl,
          d: oCoords.tr
        },
        rightline: {
          o: oCoords.tr,
          d: oCoords.br
        },
        bottomline: {
          o: oCoords.br,
          d: oCoords.bl
        },
        leftline: {
          o: oCoords.bl,
          d: oCoords.tl
        }
      };

      // // debugging
      // if (this.canvas.contextTop) {
      //   this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
      //
      //   this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
      //   this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
      // }

      return lines;
    },

    /**
     * Helper method to determine how many cross points are between the 4 object edges
     * and the horizontal line determined by a point on canvas
     * @private
     * @param {fabric.Point} point Point to check
     * @param {Object} lines Coordinates of the object being evaluated
     */
    // remove yi, not used but left code here just in case.
    _findCrossPoints: function(point, lines) {
      var b1, b2, a1, a2, xi, // yi,
          xcount = 0,
          iLine;

      for (var lineKey in lines) {
        iLine = lines[lineKey];
        // optimisation 1: line below point. no cross
        if ((iLine.o.y < point.y) && (iLine.d.y < point.y)) {
          continue;
        }
        // optimisation 2: line above point. no cross
        if ((iLine.o.y >= point.y) && (iLine.d.y >= point.y)) {
          continue;
        }
        // optimisation 3: vertical line case
        if ((iLine.o.x === iLine.d.x) && (iLine.o.x >= point.x)) {
          xi = iLine.o.x;
          // yi = point.y;
        }
        // calculate the intersection point
        else {
          b1 = 0;
          b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
          a1 = point.y - b1 * point.x;
          a2 = iLine.o.y - b2 * iLine.o.x;

          xi = -(a1 - a2) / (b1 - b2);
          // yi = a1 + b1 * xi;
        }
        // dont count xi < point.x cases
        if (xi >= point.x) {
          xcount += 1;
        }
        // optimisation 4: specific for square images
        if (xcount === 2) {
          break;
        }
      }
      return xcount;
    },

    /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
     * @return {Object} Object with left, top, width, height properties
     */
    getBoundingRect: function(absolute, calculate) {
      var coords = this.getCoords(absolute, calculate);
      return util.makeBoundingBoxFromPoints(coords);
    },

    /**
     * Returns width of an object's bounding box counting transformations
     * before 2.0 it was named getWidth();
     * @return {Number} width value
     */
    getScaledWidth: function() {
      return this._getTransformedDimensions().x;
    },

    /**
     * Returns height of an object bounding box counting transformations
     * before 2.0 it was named getHeight();
     * @return {Number} height value
     */
    getScaledHeight: function() {
      return this._getTransformedDimensions().y;
    },

    /**
     * Makes sure the scale is valid and modifies it if necessary
     * @private
     * @param {Number} value
     * @return {Number}
     */
    _constrainScale: function(value) {
      if (Math.abs(value) < this.minScaleLimit) {
        if (value < 0) {
          return -this.minScaleLimit;
        }
        else {
          return this.minScaleLimit;
        }
      }
      else if (value === 0) {
        return 0.0001;
      }
      return value;
    },

    /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scale: function(value) {
      this._set('scaleX', value);
      this._set('scaleY', value);
      return this.setCoords();
    },

    /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToWidth: function(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
      return this.scale(value / this.width / boundingRectFactor);
    },

    /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */
    scaleToHeight: function(value, absolute) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
      return this.scale(value / this.height / boundingRectFactor);
    },

    /**
     * Calculates and returns the .coords of an object.
     * unused by the library, only for the end dev.
     * @return {Object} Object with tl, tr, br, bl ....
     * @chainable
     * @deprecated
     */
    calcCoords: function(absolute) {
      // this is a compatibility function to avoid removing calcCoords now.
      if (absolute) {
        return this.calcACoords();
      }
      return this.calcOCoords();
    },

    calcLineCoords: function() {
      var vpt = this.getViewportTransform(),
          padding = this.padding, angle = degreesToRadians(this.angle),
          cos = util.cos(angle), sin = util.sin(angle),
          cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP,
          cosPMinusSinP = cosP - sinP, aCoords = this.calcACoords();

      var lineCoords = {
        tl: transformPoint(aCoords.tl, vpt),
        tr: transformPoint(aCoords.tr, vpt),
        bl: transformPoint(aCoords.bl, vpt),
        br: transformPoint(aCoords.br, vpt),
      };

      if (padding) {
        lineCoords.tl.x -= cosPMinusSinP;
        lineCoords.tl.y -= cosPSinP;
        lineCoords.tr.x += cosPSinP;
        lineCoords.tr.y -= cosPMinusSinP;
        lineCoords.bl.x -= cosPSinP;
        lineCoords.bl.y += cosPMinusSinP;
        lineCoords.br.x += cosPMinusSinP;
        lineCoords.br.y += cosPSinP;
      }

      return lineCoords;
    },

    calcOCoords: function() {
      var rotateMatrix = this._calcRotateMatrix(),
          translateMatrix = this._calcTranslateMatrix(),
          vpt = this.getViewportTransform(),
          startMatrix = multiplyMatrices(vpt, translateMatrix),
          finalMatrix = multiplyMatrices(startMatrix, rotateMatrix),
          finalMatrix = multiplyMatrices(finalMatrix, [1 / vpt[0], 0, 0, 1 / vpt[3], 0, 0]),
          dim = this._calculateCurrentDimensions(),
          coords = {};
      this.forEachControl(function(control, key, fabricObject) {
        coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
      });

      // debug code
      // var canvas = this.canvas;
      // setTimeout(function() {
      //   canvas.contextTop.clearRect(0, 0, 700, 700);
      //   canvas.contextTop.fillStyle = 'green';
      //   Object.keys(coords).forEach(function(key) {
      //     var control = coords[key];
      //     canvas.contextTop.fillRect(control.x, control.y, 3, 3);
      //   });
      // }, 50);
      return coords;
    },

    calcACoords: function() {
      var rotateMatrix = this._calcRotateMatrix(),
          translateMatrix = this._calcTranslateMatrix(),
          finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix),
          dim = this._getTransformedDimensions(),
          w = dim.x / 2, h = dim.y / 2;
      return {
        // corners
        tl: transformPoint({ x: -w, y: -h }, finalMatrix),
        tr: transformPoint({ x: w, y: -h }, finalMatrix),
        bl: transformPoint({ x: -w, y: h }, finalMatrix),
        br: transformPoint({ x: w, y: h }, finalMatrix)
      };
    },

    /**
     * Sets corner position coordinates based on current angle, width and height.
     * oCoords are used to find the corners
     * aCoords are used to quickly find an object on the canvas
     * lineCoords are used to quickly find object during pointer events.
     * See {@link https://github.com/kangax/fabric.js/wiki/When-to-call-setCoords|When-to-call-setCoords}
     * @param {Boolean} [skipCorners] skip calculation of oCoords.
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setCoords: function(skipCorners) {
      this.aCoords = this.calcACoords();
      // in case we are in a group, for how the inner group target check works,
      // lineCoords are exactly aCoords. Since the vpt gets absorbed by the normalized pointer.
      this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();
      if (skipCorners) {
        return this;
      }
      // set coordinates of the draggable boxes in the corners used to scale/rotate the image
      this.oCoords = this.calcOCoords();
      this._setCornerCoords && this._setCornerCoords();
      return this;
    },

    /**
     * calculate rotation matrix of an object
     * @return {Array} rotation matrix for the object
     */
    _calcRotateMatrix: function() {
      return util.calcRotateMatrix(this);
    },

    /**
     * calculate the translation matrix for an object transform
     * @return {Array} rotation matrix for the object
     */
    _calcTranslateMatrix: function() {
      var center = this.getCenterPoint();
      return [1, 0, 0, 1, center.x, center.y];
    },

    transformMatrixKey: function(skipGroup) {
      var sep = '_', prefix = '';
      if (!skipGroup && this.group) {
        prefix = this.group.transformMatrixKey(skipGroup) + sep;
      };
      return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY +
        sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY +
        sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * There are some situation in which this is useful to avoid the fake rotation.
     * @return {Array} transform matrix for the object
     */
    calcTransformMatrix: function(skipGroup) {
      var matrix = this.calcOwnMatrix();
      if (skipGroup || !this.group) {
        return matrix;
      }
      var key = this.transformMatrixKey(skipGroup), cache = this.matrixCache || (this.matrixCache = {});
      if (cache.key === key) {
        return cache.value;
      }
      if (this.group) {
        matrix = multiplyMatrices(this.group.calcTransformMatrix(false), matrix);
      }
      cache.key = key;
      cache.value = matrix;
      return matrix;
    },

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {Array} transform matrix for the object
     */
    calcOwnMatrix: function() {
      var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
      if (cache.key === key) {
        return cache.value;
      }
      var tMatrix = this._calcTranslateMatrix(),
          options = {
            angle: this.angle,
            translateX: tMatrix[4],
            translateY: tMatrix[5],
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            flipX: this.flipX,
            flipY: this.flipY,
          };
      cache.key = key;
      cache.value = util.composeMatrix(options);
      return cache.value;
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @deprecated since 3.4.0, please use fabric.util._calcDimensionsTransformMatrix
     * not including or including flipX, flipY to emulate the flipping boolean
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _calcDimensionsTransformMatrix: function(skewX, skewY, flipping) {
      return util.calcDimensionsMatrix({
        skewX: skewX,
        skewY: skewY,
        scaleX: this.scaleX * (flipping && this.flipX ? -1 : 1),
        scaleY: this.scaleY * (flipping && this.flipY ? -1 : 1)
      });
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getNonTransformedDimensions: function() {
      var strokeWidth = this.strokeWidth,
          w = this.width + strokeWidth,
          h = this.height + strokeWidth;
      return { x: w, y: h };
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param {Number} skewX, a value to override current skewX
     * @param {Number} skewY, a value to override current skewY
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */
    _getTransformedDimensions: function(skewX, skewY) {
      if (typeof skewX === 'undefined') {
        skewX = this.skewX;
      }
      if (typeof skewY === 'undefined') {
        skewY = this.skewY;
      }
      var dimensions = this._getNonTransformedDimensions(), dimX, dimY,
          noSkew = skewX === 0 && skewY === 0;

      if (this.strokeUniform) {
        dimX = this.width;
        dimY = this.height;
      }
      else {
        dimX = dimensions.x;
        dimY = dimensions.y;
      }
      if (noSkew) {
        return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
      }
      var bbox = util.sizeAfterTransform(dimX, dimY, {
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: skewX,
        skewY: skewY,
      });
      return this._finalizeDimensions(bbox.x, bbox.y);
    },

    /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */
    _finalizeDimensions: function(width, height) {
      return this.strokeUniform ?
        { x: width + this.strokeWidth, y: height + this.strokeWidth }
        :
        { x: width, y: height };
    },

    /*
     * Calculate object dimensions for controls box, including padding and canvas zoom.
     * and active selection
     * private
     */
    _calculateCurrentDimensions: function()  {
      var vpt = this.getViewportTransform(),
          dim = this._getTransformedDimensions(),
          p = transformPoint(dim, vpt, true);
      return p.scalarAdd(2 * this.padding);
    },
  });
})();


fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

  /**
   * Moves an object to the bottom of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendToBack: function() {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
    }
    else if (this.canvas) {
      this.canvas.sendToBack(this);
    }
    return this;
  },

  /**
   * Moves an object to the top of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringToFront: function() {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
    }
    else if (this.canvas) {
      this.canvas.bringToFront(this);
    }
    return this;
  },

  /**
   * Moves an object down in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  sendBackwards: function(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
    }
    else if (this.canvas) {
      this.canvas.sendBackwards(this, intersecting);
    }
    return this;
  },

  /**
   * Moves an object up in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  bringForward: function(intersecting) {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
    }
    else if (this.canvas) {
      this.canvas.bringForward(this, intersecting);
    }
    return this;
  },

  /**
   * Moves an object to specified level in stack of drawn objects
   * @param {Number} index New position of object
   * @return {fabric.Object} thisArg
   * @chainable
   */
  moveTo: function(index) {
    if (this.group && this.group.type !== 'activeSelection') {
      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
    }
    else if (this.canvas) {
      this.canvas.moveTo(this, index);
    }
    return this;
  }
});


/* _TO_SVG_START_ */
(function() {
  function getSvgColorString(prop, value) {
    if (!value) {
      return prop + ': none; ';
    }
    else if (value.toLive) {
      return prop + ': url(#SVGID_' + value.id + '); ';
    }
    else {
      var color = new fabric.Color(value),
          str = prop + ': ' + color.toRgb() + '; ',
          opacity = color.getAlpha();
      if (opacity !== 1) {
        //change the color in rgb + opacity
        str += prop + '-opacity: ' + opacity.toString() + '; ';
      }
      return str;
    }
  }

  var toFixed = fabric.util.toFixed;

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function(skipShadow) {

      var fillRule = this.fillRule ? this.fillRule : 'nonzero',
          strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
          strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
          strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
          strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
          strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
          strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
          opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
          visibility = this.visible ? '' : ' visibility: hidden;',
          filter = skipShadow ? '' : this.getSvgFilter(),
          fill = getSvgColorString('fill', this.fill),
          stroke = getSvgColorString('stroke', this.stroke);

      return [
        stroke,
        'stroke-width: ', strokeWidth, '; ',
        'stroke-dasharray: ', strokeDashArray, '; ',
        'stroke-linecap: ', strokeLineCap, '; ',
        'stroke-dashoffset: ', strokeDashOffset, '; ',
        'stroke-linejoin: ', strokeLineJoin, '; ',
        'stroke-miterlimit: ', strokeMiterLimit, '; ',
        fill,
        'fill-rule: ', fillRule, '; ',
        'opacity: ', opacity, ';',
        filter,
        visibility
      ].join('');
    },

    /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */
    getSvgSpanStyles: function(style, useWhiteSpace) {
      var term = '; ';
      var fontFamily = style.fontFamily ?
        'font-family: ' + (((style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1) ?
          '\'' + style.fontFamily  + '\'' : style.fontFamily)) + term : '';
      var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '',
          fontFamily = fontFamily,
          fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '',
          fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '',
          fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '',
          fill = style.fill ? getSvgColorString('fill', style.fill) : '',
          stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '',
          textDecoration = this.getSvgTextDecoration(style),
          deltaY = style.deltaY ? 'baseline-shift: ' + (-style.deltaY) + '; ' : '';
      if (textDecoration) {
        textDecoration = 'text-decoration: ' + textDecoration + term;
      }

      return [
        stroke,
        strokeWidth,
        fontFamily,
        fontSize,
        fontStyle,
        fontWeight,
        textDecoration,
        fill,
        deltaY,
        useWhiteSpace ? 'white-space: pre; ' : ''
      ].join('');
    },

    /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */
    getSvgTextDecoration: function(style) {
      return ['overline', 'underline', 'line-through'].filter(function(decoration) {
        return style[decoration.replace('-', '')];
      }).join(' ');
    },

    /**
     * Returns filter for svg shadow
     * @return {String}
     */
    getSvgFilter: function() {
      return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
    },

    /**
     * Returns id attribute for svg output
     * @return {String}
     */
    getSvgCommons: function() {
      return [
        this.id ? 'id="' + this.id + '" ' : '',
        this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : '',
      ].join('');
    },

    /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */
    getSvgTransform: function(full, additionalTransform) {
      var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
          svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
      return svgTransform +
        (additionalTransform || '') + '" ';
    },

    _setSVGBg: function(textBgRects) {
      if (this.backgroundColor) {
        var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
        textBgRects.push(
          '\t\t<rect ',
          this._getFillAttributes(this.backgroundColor),
          ' x="',
          toFixed(-this.width / 2, NUM_FRACTION_DIGITS),
          '" y="',
          toFixed(-this.height / 2, NUM_FRACTION_DIGITS),
          '" width="',
          toFixed(this.width, NUM_FRACTION_DIGITS),
          '" height="',
          toFixed(this.height, NUM_FRACTION_DIGITS),
          '"></rect>\n');
      }
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver: reviver });
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), { reviver: reviver });
    },

    /**
     * @private
     */
    _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
      options = options || {};
      var reviver = options.reviver,
          additionalTransform = options.additionalTransform || '',
          commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons(),
          ].join(''),
          // insert commons in the markup, style and svgCommons
          index = objectMarkup.indexOf('COMMON_PARTS');
      objectMarkup[index] = commonPieces;
      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
    },

    /**
     * @private
     */
    _createBaseSVGMarkup: function(objectMarkup, options) {
      options = options || {};
      var noStyle = options.noStyle,
          reviver = options.reviver,
          styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ',
          shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '',
          clipPath = this.clipPath,
          vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
          absoluteClipPath = clipPath && clipPath.absolutePositioned,
          stroke = this.stroke, fill = this.fill, shadow = this.shadow,
          commonPieces, markup = [], clipPathMarkup,
          // insert commons in the markup, style and svgCommons
          index = objectMarkup.indexOf('COMMON_PARTS'),
          additionalTransform = options.additionalTransform;
      if (clipPath) {
        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
        clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' +
          clipPath.toClipPathSVG(reviver) +
          '</clipPath>\n';
      }
      if (absoluteClipPath) {
        markup.push(
          '<g ', shadowInfo, this.getSvgCommons(), ' >\n'
        );
      }
      markup.push(
        '<g ',
        this.getSvgTransform(false),
        !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '',
        ' >\n'
      );
      commonPieces = [
        styleInfo,
        vectorEffect,
        noStyle ? '' : this.addPaintOrder(), ' ',
        additionalTransform ? 'transform="' + additionalTransform + '" ' : '',
      ].join('');
      objectMarkup[index] = commonPieces;
      if (fill && fill.toLive) {
        markup.push(fill.toSVG(this));
      }
      if (stroke && stroke.toLive) {
        markup.push(stroke.toSVG(this));
      }
      if (shadow) {
        markup.push(shadow.toSVG(this));
      }
      if (clipPath) {
        markup.push(clipPathMarkup);
      }
      markup.push(objectMarkup.join(''));
      markup.push('</g>\n');
      absoluteClipPath && markup.push('</g>\n');
      return reviver ? reviver(markup.join('')) : markup.join('');
    },

    addPaintOrder: function() {
      return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
    }
  });
})();
/* _TO_SVG_END_ */


(function() {

  var extend = fabric.util.object.extend,
      originalSet = 'stateProperties';

  /*
    Depends on `stateProperties`
  */
  function saveProps(origin, destination, props) {
    var tmpObj = { }, deep = true;
    props.forEach(function(prop) {
      tmpObj[prop] = origin[prop];
    });

    extend(origin[destination], tmpObj, deep);
  }

  function _isEqual(origValue, currentValue, firstPass) {
    if (origValue === currentValue) {
      // if the objects are identical, return
      return true;
    }
    else if (Array.isArray(origValue)) {
      if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
        return false;
      }
      for (var i = 0, len = origValue.length; i < len; i++) {
        if (!_isEqual(origValue[i], currentValue[i])) {
          return false;
        }
      }
      return true;
    }
    else if (origValue && typeof origValue === 'object') {
      var keys = Object.keys(origValue), key;
      if (!currentValue ||
          typeof currentValue !== 'object' ||
          (!firstPass && keys.length !== Object.keys(currentValue).length)
      ) {
        return false;
      }
      for (var i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        // since clipPath is in the statefull cache list and the clipPath objects
        // would be iterated as an object, this would lead to possible infinite recursion
        // we do not want to compare those.
        if (key === 'canvas' || key === 'group') {
          continue;
        }
        if (!_isEqual(origValue[key], currentValue[key])) {
          return false;
        }
      }
      return true;
    }
  }


  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

    /**
     * Returns true if object state (one of its state properties) was changed
     * @param {String} [propertySet] optional name for the set of property we want to save
     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
     */
    hasStateChanged: function(propertySet) {
      propertySet = propertySet || originalSet;
      var dashedPropertySet = '_' + propertySet;
      if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
        return true;
      }
      return !_isEqual(this[dashedPropertySet], this, true);
    },

    /**
     * Saves state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    saveState: function(options) {
      var propertySet = options && options.propertySet || originalSet,
          destination = '_' + propertySet;
      if (!this[destination]) {
        return this.setupState(options);
      }
      saveProps(this, destination, this[propertySet]);
      if (options && options.stateProperties) {
        saveProps(this, destination, options.stateProperties);
      }
      return this;
    },

    /**
     * Setups state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */
    setupState: function(options) {
      options = options || { };
      var propertySet = options.propertySet || originalSet;
      options.propertySet = propertySet;
      this['_' + propertySet] = { };
      this.saveState(options);
      return this;
    }
  });
})();


(function() {

  var degreesToRadians = fabric.util.degreesToRadians;

  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
     * Determines which corner has been clicked
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
     */
    _findTargetCorner: function(pointer, forTouch) {
      // objects in group, anykind, are not self modificable,
      // must not return an hovered corner.
      if (!this.hasControls || this.group || (!this.canvas || this.canvas._activeObject !== this)) {
        return false;
      }

      var ex = pointer.x,
          ey = pointer.y,
          xPoints,
          lines, keys = Object.keys(this.oCoords),
          j = keys.length - 1, i;
      this.__corner = 0;

      // cycle in reverse order so we pick first the one on top
      for (; j >= 0; j--) {
        i = keys[j];
        if (!this.isControlVisible(i)) {
          continue;
        }

        lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner);
        // debugging

        // this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
        //
        // this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
        // this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);

        xPoints = this._findCrossPoints({ x: ex, y: ey }, lines);
        if (xPoints !== 0 && xPoints % 2 === 1) {
          this.__corner = i;
          return i;
        }
      }
      return false;
    },

    /**
     * Calls a function for each control. The function gets called,
     * with the control, the object that is calling the iterator and the control's key
     * @param {Function} fn function to iterate over the controls over
     */
    forEachControl: function(fn) {
      for (var i in this.controls) {
        fn(this.controls[i], i, this);
      };
    },

    /**
     * Sets the coordinates of the draggable boxes in the corners of
     * the image used to scale/rotate it.
     * note: if we would switch to ROUND corner area, all of this would disappear.
     * everything would resolve to a single point and a pythagorean theorem for the distance
     * @private
     */
    _setCornerCoords: function() {
      var coords = this.oCoords,
          newTheta = degreesToRadians(45 - this.angle),
          cosTheta = fabric.util.cos(newTheta),
          sinTheta = fabric.util.sin(newTheta),
          /* Math.sqrt(2 * Math.pow(this.cornerSize, 2)) / 2, */
          /* 0.707106 stands for sqrt(2)/2 */
          cornerHypotenuse = this.cornerSize * 0.707106,
          touchHypotenuse = this.touchCornerSize * 0.707106,
          cosHalfOffset = cornerHypotenuse * cosTheta,
          sinHalfOffset = cornerHypotenuse * sinTheta,
          touchCosHalfOffset = touchHypotenuse * cosTheta,
          touchSinHalfOffset = touchHypotenuse * sinTheta,
          x, y;

      for (var control in coords) {
        x = coords[control].x;
        y = coords[control].y;
        coords[control].corner = {
          tl: {
            x: x - sinHalfOffset,
            y: y - cosHalfOffset
          },
          tr: {
            x: x + cosHalfOffset,
            y: y - sinHalfOffset
          },
          bl: {
            x: x - cosHalfOffset,
            y: y + sinHalfOffset
          },
          br: {
            x: x + sinHalfOffset,
            y: y + cosHalfOffset
          }
        };
        coords[control].touchCorner = {
          tl: {
            x: x - touchSinHalfOffset,
            y: y - touchCosHalfOffset
          },
          tr: {
            x: x + touchCosHalfOffset,
            y: y - touchSinHalfOffset
          },
          bl: {
            x: x - touchCosHalfOffset,
            y: y + touchSinHalfOffset
          },
          br: {
            x: x + touchSinHalfOffset,
            y: y + touchCosHalfOffset
          }
        };
      }
    },

    /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawSelectionBackground: function(ctx) {
      if (!this.selectionBackgroundColor ||
        (this.canvas && !this.canvas.interactive) ||
        (this.canvas && this.canvas._activeObject !== this)
      ) {
        return this;
      }
      ctx.save();
      var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(),
          vpt = this.canvas.viewportTransform;
      ctx.translate(center.x, center.y);
      ctx.scale(1 / vpt[0], 1 / vpt[3]);
      ctx.rotate(degreesToRadians(this.angle));
      ctx.fillStyle = this.selectionBackgroundColor;
      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBorders: function(ctx, styleOverride) {
      styleOverride = styleOverride || {};
      var wh = this._calculateCurrentDimensions(),
          strokeWidth = this.borderScaleFactor,
          width = wh.x + strokeWidth,
          height = wh.y + strokeWidth,
          hasControls = typeof styleOverride.hasControls !== 'undefined' ?
            styleOverride.hasControls : this.hasControls,
          shouldStroke = false;

      ctx.save();
      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);

      ctx.strokeRect(
        -width / 2,
        -height / 2,
        width,
        height
      );

      if (hasControls) {
        ctx.beginPath();
        this.forEachControl(function(control, key, fabricObject) {
          // in this moment, the ctx is centered on the object.
          // width and height of the above function are the size of the bbox.
          if (control.withConnection && control.getVisibility(fabricObject, key)) {
            // reset movement for each control
            shouldStroke = true;
            ctx.moveTo(control.x * width, control.y * height);
            ctx.lineTo(
              control.x * width + control.offsetX,
              control.y * height + control.offsetY
            );
          }
        });
        if (shouldStroke) {
          ctx.stroke();
        }
      }
      ctx.restore();
      return this;
    },

    /**
     * Draws borders of an object's bounding box when it is inside a group.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawBordersInGroup: function(ctx, options, styleOverride) {
      styleOverride = styleOverride || {};
      var bbox = fabric.util.sizeAfterTransform(this.width, this.height, options),
          strokeWidth = this.strokeWidth,
          strokeUniform = this.strokeUniform,
          borderScaleFactor = this.borderScaleFactor,
          width =
            bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor,
          height =
            bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
      ctx.save();
      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);
      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
      ctx.strokeRect(
        -width / 2,
        -height / 2,
        width,
        height
      );

      ctx.restore();
      return this;
    },

    /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */
    drawControls: function(ctx, styleOverride) {
      styleOverride = styleOverride || {};
      ctx.save();
      ctx.setTransform(this.canvas.getRetinaScaling(), 0, 0, this.canvas.getRetinaScaling(), 0, 0);
      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
      if (!this.transparentCorners) {
        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
      }
      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);
      this.setCoords();
      this.forEachControl(function(control, key, fabricObject) {
        if (control.getVisibility(fabricObject, key)) {
          control.render(ctx,
            fabricObject.oCoords[key].x,
            fabricObject.oCoords[key].y, styleOverride, fabricObject);
        }
      });
      ctx.restore();

      return this;
    },

    /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @returns {Boolean} true if the specified control is visible, false otherwise
     */
    isControlVisible: function(controlKey) {
      return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    },

    /**
     * Sets the visibility of the specified control.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlVisible: function(controlKey, visible) {
      if (!this._controlsVisibility) {
        this._controlsVisibility = {};
      }
      this._controlsVisibility[controlKey] = visible;
      return this;
    },

    /**
     * Sets the visibility state of object controls.
     * @param {Object} [options] Options object
     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
     * @return {fabric.Object} thisArg
     * @chainable
     */
    setControlsVisibility: function(options) {
      options || (options = { });

      for (var p in options) {
        this.setControlVisible(p, options[p]);
      }
      return this;
    },


    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onDeselect: function() {
      // implemented by sub-classes, as needed.
    },


    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */
    onSelect: function() {
      // implemented by sub-classes, as needed.
    }
  });
})();


fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

  /**
   * Animation duration (in ms) for fx* methods
   * @type Number
   * @default
   */
  FX_DURATION: 500,

  /**
   * Centers object horizontally with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectH: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.left,
      endValue: this.getCenter().left,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('left', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function() {
        object.setCoords();
        onComplete();
      }
    });

    return this;
  },

  /**
   * Centers object vertically with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxCenterObjectV: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.top,
      endValue: this.getCenter().top,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('top', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function() {
        object.setCoords();
        onComplete();
      }
    });

    return this;
  },

  /**
   * Same as `fabric.Canvas#remove` but animated
   * @param {fabric.Object} object Object to remove
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxRemove: function (object, callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: object.opacity,
      endValue: 0,
      duration: this.FX_DURATION,
      onChange: function(value) {
        object.set('opacity', value);
        _this.requestRenderAll();
        onChange();
      },
      onComplete: function () {
        _this.remove(object);
        onComplete();
      }
    });

    return this;
  }
});

fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
  /**
   * Animates object's properties
   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
   * @return {fabric.Object} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @chainable
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   *
   * As string — one property
   *
   * object.animate('left', ...);
   * object.animate('left', { duration: ... });
   *
   */
  animate: function() {
    if (arguments[0] && typeof arguments[0] === 'object') {
      var propsToAnimate = [], prop, skipCallbacks;
      for (prop in arguments[0]) {
        propsToAnimate.push(prop);
      }
      for (var i = 0, len = propsToAnimate.length; i < len; i++) {
        prop = propsToAnimate[i];
        skipCallbacks = i !== len - 1;
        this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks);
      }
    }
    else {
      this._animate.apply(this, arguments);
    }
    return this;
  },

  /**
   * @private
   * @param {String} property Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
   */
  _animate: function(property, to, options, skipCallbacks) {
    var _this = this, propPair;

    to = to.toString();

    if (!options) {
      options = { };
    }
    else {
      options = fabric.util.object.clone(options);
    }

    if (~property.indexOf('.')) {
      propPair = property.split('.');
    }

    var propIsColor =
      _this.colorProperties.indexOf(property) > -1 ||
      (propPair && _this.colorProperties.indexOf(propPair[1]) > -1);

    var currentValue = propPair
      ? this.get(propPair[0])[propPair[1]]
      : this.get(property);

    if (!('from' in options)) {
      options.from = currentValue;
    }

    if (!propIsColor) {
      if (~to.indexOf('=')) {
        to = currentValue + parseFloat(to.replace('=', ''));
      }
      else {
        to = parseFloat(to);
      }
    }

    var _options = {
      startValue: options.from,
      endValue: to,
      byValue: options.by,
      easing: options.easing,
      duration: options.duration,
      abort: options.abort && function () {
        return options.abort.call(_this);
      },
      onChange: function (value, valueProgress, timeProgress) {
        if (propPair) {
          _this[propPair[0]][propPair[1]] = value;
        }
        else {
          _this.set(property, value);
        }
        if (skipCallbacks) {
          return;
        }
        options.onChange && options.onChange(value, valueProgress, timeProgress);
      },
      onComplete: function (value, valueProgress, timeProgress) {
        if (skipCallbacks) {
          return;
        }

        _this.setCoords();
        options.onComplete && options.onComplete(value, valueProgress, timeProgress);
      }
    };

    if (propIsColor) {
      fabric.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
    }
    else {
      fabric.util.animate(_options);
    }
  }
});


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      clone = fabric.util.object.clone,
      coordProps = { x1: 1, x2: 1, y1: 1, y2: 1 },
      supportsLineDash = fabric.StaticCanvas.supports('setLineDash');

  if (fabric.Line) {
    fabric.warn('fabric.Line is already defined');
    return;
  }

  /**
   * Line class
   * @class fabric.Line
   * @extends fabric.Object
   * @see {@link fabric.Line#initialize} for constructor definition
   */
  fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'line',

    /**
     * x value or first line edge
     * @type Number
     * @default
     */
    x1: 0,

    /**
     * y value or first line edge
     * @type Number
     * @default
     */
    y1: 0,

    /**
     * x value or second line edge
     * @type Number
     * @default
     */
    x2: 0,

    /**
     * y value or second line edge
     * @type Number
     * @default
     */
    y2: 0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),

    /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {fabric.Line} thisArg
     */
    initialize: function(points, options) {
      if (!points) {
        points = [0, 0, 0, 0];
      }

      this.callSuper('initialize', options);

      this.set('x1', points[0]);
      this.set('y1', points[1]);
      this.set('x2', points[2]);
      this.set('y2', points[3]);

      this._setWidthHeight(options);
    },

    /**
     * @private
     * @param {Object} [options] Options
     */
    _setWidthHeight: function(options) {
      options || (options = { });

      this.width = Math.abs(this.x2 - this.x1);
      this.height = Math.abs(this.y2 - this.y1);

      this.left = 'left' in options
        ? options.left
        : this._getLeftToOriginX();

      this.top = 'top' in options
        ? options.top
        : this._getTopToOriginY();
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);
      if (typeof coordProps[key] !== 'undefined') {
        this._setWidthHeight();
      }
      return this;
    },

    /**
     * @private
     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
     */
    _getLeftToOriginX: makeEdgeToOriginGetter(
      { // property names
        origin: 'originX',
        axis1: 'x1',
        axis2: 'x2',
        dimension: 'width'
      },
      { // possible values of origin
        nearest: 'left',
        center: 'center',
        farthest: 'right'
      }
    ),

    /**
     * @private
     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
     */
    _getTopToOriginY: makeEdgeToOriginGetter(
      { // property names
        origin: 'originY',
        axis1: 'y1',
        axis2: 'y2',
        dimension: 'height'
      },
      { // possible values of origin
        nearest: 'top',
        center: 'center',
        farthest: 'bottom'
      }
    ),

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();

      if (!this.strokeDashArray || this.strokeDashArray && supportsLineDash) {
        // move from center (of virtual box) to its left/top corner
        // we can't assume x1, y1 is top left and x2, y2 is bottom right
        var p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
      }

      ctx.lineWidth = this.strokeWidth;

      // TODO: test this
      // make sure setting "fill" changes color of a line
      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
      var origStrokeStyle = ctx.strokeStyle;
      ctx.strokeStyle = this.stroke || ctx.fillStyle;
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var p = this.calcLinePoints();

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, p.x1, p.y1, p.x2, p.y2, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */
    _findCenterFromElement: function() {
      return {
        x: (this.x1 + this.x2) / 2,
        y: (this.y1 + this.y2) / 2,
      };
    },

    /**
     * Returns object representation of an instance
     * @methd toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
    },

    /*
     * Calculate object dimensions from its properties
     * @private
     */
    _getNonTransformedDimensions: function() {
      var dim = this.callSuper('_getNonTransformedDimensions');
      if (this.strokeLineCap === 'butt') {
        if (this.width === 0) {
          dim.y -= this.strokeWidth;
        }
        if (this.height === 0) {
          dim.x -= this.strokeWidth;
        }
      }
      return dim;
    },

    /**
     * Recalculates line points given width and height
     * @private
     */
    calcLinePoints: function() {
      var xMult = this.x1 <= this.x2 ? -1 : 1,
          yMult = this.y1 <= this.y2 ? -1 : 1,
          x1 = (xMult * this.width * 0.5),
          y1 = (yMult * this.height * 0.5),
          x2 = (xMult * this.width * -0.5),
          y2 = (yMult * this.height * -0.5);

      return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      };
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var p = this.calcLinePoints();
      return [
        '<line ', 'COMMON_PARTS',
        'x1="', p.x1,
        '" y1="', p.y1,
        '" x2="', p.x2,
        '" y2="', p.y2,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
   * @static
   * @memberOf fabric.Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */
  fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));

  /**
   * Returns fabric.Line instance from an SVG element
   * @static
   * @memberOf fabric.Line
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */
  fabric.Line.fromElement = function(element, callback, options) {
    options = options || { };
    var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES),
        points = [
          parsedAttributes.x1 || 0,
          parsedAttributes.y1 || 0,
          parsedAttributes.x2 || 0,
          parsedAttributes.y2 || 0
        ];
    callback(new fabric.Line(points, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Line instance from an object representation
   * @static
   * @memberOf fabric.Line
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */
  fabric.Line.fromObject = function(object, callback) {
    function _callback(instance) {
      delete instance.points;
      callback && callback(instance);
    };
    var options = clone(object, true);
    options.points = [object.x1, object.y1, object.x2, object.y2];
    fabric.Object._fromObject('Line', options, _callback, 'points');
  };

  /**
   * Produces a function that calculates distance from canvas edge to Line origin.
   */
  function makeEdgeToOriginGetter(propertyNames, originValues) {
    var origin = propertyNames.origin,
        axis1 = propertyNames.axis1,
        axis2 = propertyNames.axis2,
        dimension = propertyNames.dimension,
        nearest = originValues.nearest,
        center = originValues.center,
        farthest = originValues.farthest;

    return function() {
      switch (this.get(origin)) {
        case nearest:
          return Math.min(this.get(axis1), this.get(axis2));
        case center:
          return Math.min(this.get(axis1), this.get(axis2)) + (0.5 * this.get(dimension));
        case farthest:
          return Math.max(this.get(axis1), this.get(axis2));
      }
    };

  }

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      pi = Math.PI;

  if (fabric.Circle) {
    fabric.warn('fabric.Circle is already defined.');
    return;
  }

  /**
   * Circle class
   * @class fabric.Circle
   * @extends fabric.Object
   * @see {@link fabric.Circle#initialize} for constructor definition
   */
  fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'circle',

    /**
     * Radius of this circle
     * @type Number
     * @default
     */
    radius: 0,

    /**
     * Start angle of the circle, moving clockwise
     * deprectated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 0
     */
    startAngle: 0,

    /**
     * End angle of the circle
     * deprectated type, this should be in degree, this was an oversight.
     * probably will change to degrees in next major version
     * @type Number
     * @default 2Pi
     */
    endAngle: pi * 2,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Circle} thisArg
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);

      if (key === 'radius') {
        this.setRadius(value);
      }

      return this;
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['radius', 'startAngle', 'endAngle'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var svgString, x = 0, y = 0,
          angle = (this.endAngle - this.startAngle) % ( 2 * pi);

      if (angle === 0) {
        svgString = [
          '<circle ', 'COMMON_PARTS',
          'cx="' + x + '" cy="' + y + '" ',
          'r="', this.radius,
          '" />\n'
        ];
      }
      else {
        var startX = fabric.util.cos(this.startAngle) * this.radius,
            startY = fabric.util.sin(this.startAngle) * this.radius,
            endX = fabric.util.cos(this.endAngle) * this.radius,
            endY = fabric.util.sin(this.endAngle) * this.radius,
            largeFlag = angle > pi ? '1' : '0';
        svgString = [
          '<path d="M ' + startX + ' ' + startY,
          ' A ' + this.radius + ' ' + this.radius,
          ' 0 ', +largeFlag + ' 1', ' ' + endX + ' ' + endY,
          '" ', 'COMMON_PARTS', ' />\n'
        ];
      }
      return svgString;
    },
    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();
      ctx.arc(
        0,
        0,
        this.radius,
        this.startAngle,
        this.endAngle, false);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusX: function() {
      return this.get('radius') * this.get('scaleX');
    },

    /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusY: function() {
      return this.get('radius') * this.get('scaleY');
    },

    /**
     * Sets radius of an object (and updates width accordingly)
     * @return {fabric.Circle} thisArg
     */
    setRadius: function(value) {
      this.radius = value;
      return this.set('width', value * 2).set('height', value * 2);
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
   * @static
   * @memberOf fabric.Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */
  fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));

  /**
   * Returns {@link fabric.Circle} instance from an SVG element
   * @static
   * @memberOf fabric.Circle
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @param {Object} [options] Options object
   * @throws {Error} If value of `r` attribute is missing or invalid
   */
  fabric.Circle.fromElement = function(element, callback) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);

    if (!isValidRadius(parsedAttributes)) {
      throw new Error('value of `r` attribute is required and can not be negative');
    }

    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
    callback(new fabric.Circle(parsedAttributes));
  };

  /**
   * @private
   */
  function isValidRadius(attributes) {
    return (('radius' in attributes) && (attributes.radius >= 0));
  }
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Circle} instance from an object representation
   * @static
   * @memberOf fabric.Circle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {Object} Instance of fabric.Circle
   */
  fabric.Circle.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Circle', object, callback);
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Triangle) {
    fabric.warn('fabric.Triangle is already defined');
    return;
  }

  /**
   * Triangle class
   * @class fabric.Triangle
   * @extends fabric.Object
   * @return {fabric.Triangle} thisArg
   * @see {@link fabric.Triangle#initialize} for constructor definition
   */
  fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'triangle',

    /**
     * Width is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    width: 100,

    /**
     * Height is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */
    height: 100,

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;

      ctx.beginPath();
      ctx.moveTo(-widthBy2, heightBy2);
      ctx.lineTo(0, -heightBy2);
      ctx.lineTo(widthBy2, heightBy2);
      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2;

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, -widthBy2, heightBy2, 0, -heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, 0, -heightBy2, widthBy2, heightBy2, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, widthBy2, heightBy2, -widthBy2, heightBy2, this.strokeDashArray);
      ctx.closePath();
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var widthBy2 = this.width / 2,
          heightBy2 = this.height / 2,
          points = [
            -widthBy2 + ' ' + heightBy2,
            '0 ' + -heightBy2,
            widthBy2 + ' ' + heightBy2
          ].join(',');
      return [
        '<polygon ', 'COMMON_PARTS',
        'points="', points,
        '" />'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /**
   * Returns {@link fabric.Triangle} instance from an object representation
   * @static
   * @memberOf fabric.Triangle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */
  fabric.Triangle.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Triangle', object, callback);
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      piBy2   = Math.PI * 2;

  if (fabric.Ellipse) {
    fabric.warn('fabric.Ellipse is already defined.');
    return;
  }

  /**
   * Ellipse class
   * @class fabric.Ellipse
   * @extends fabric.Object
   * @return {fabric.Ellipse} thisArg
   * @see {@link fabric.Ellipse#initialize} for constructor definition
   */
  fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'ellipse',

    /**
     * Horizontal radius
     * @type Number
     * @default
     */
    rx:   0,

    /**
     * Vertical radius
     * @type Number
     * @default
     */
    ry:   0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {fabric.Ellipse} thisArg
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      this.set('rx', options && options.rx || 0);
      this.set('ry', options && options.ry || 0);
    },

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Ellipse} thisArg
     */
    _set: function(key, value) {
      this.callSuper('_set', key, value);
      switch (key) {

        case 'rx':
          this.rx = value;
          this.set('width', value * 2);
          break;

        case 'ry':
          this.ry = value;
          this.set('height', value * 2);
          break;

      }
      return this;
    },

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRx: function() {
      return this.get('rx') * this.get('scaleX');
    },

    /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRy: function() {
      return this.get('ry') * this.get('scaleY');
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      return [
        '<ellipse ', 'COMMON_PARTS',
        'cx="0" cy="0" ',
        'rx="', this.rx,
        '" ry="', this.ry,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render: function(ctx) {
      ctx.beginPath();
      ctx.save();
      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
      ctx.arc(
        0,
        0,
        this.rx,
        0,
        piBy2,
        false);
      ctx.restore();
      this._renderPaintInOrder(ctx);
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
   * @static
   * @memberOf fabric.Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */
  fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));

  /**
   * Returns {@link fabric.Ellipse} instance from an SVG element
   * @static
   * @memberOf fabric.Ellipse
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @return {fabric.Ellipse}
   */
  fabric.Ellipse.fromElement = function(element, callback) {

    var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);

    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
    callback(new fabric.Ellipse(parsedAttributes));
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Ellipse} instance from an object representation
   * @static
   * @memberOf fabric.Ellipse
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {fabric.Ellipse}
   */
  fabric.Ellipse.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Ellipse', object, callback);
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend;

  if (fabric.Rect) {
    fabric.warn('fabric.Rect is already defined');
    return;
  }

  /**
   * Rectangle class
   * @class fabric.Rect
   * @extends fabric.Object
   * @return {fabric.Rect} thisArg
   * @see {@link fabric.Rect#initialize} for constructor definition
   */
  fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {

    /**
     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'rect',

    /**
     * Horizontal border radius
     * @type Number
     * @default
     */
    rx:   0,

    /**
     * Vertical border radius
     * @type Number
     * @default
     */
    ry:   0,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      this._initRxRy();
    },

    /**
     * Initializes rx/ry attributes
     * @private
     */
    _initRxRy: function() {
      if (this.rx && !this.ry) {
        this.ry = this.rx;
      }
      else if (this.ry && !this.rx) {
        this.rx = this.ry;
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {

      // 1x1 case (used in spray brush) optimization was removed because
      // with caching and higher zoom level this makes more damage than help

      var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0,
          ry = this.ry ? Math.min(this.ry, this.height / 2) : 0,
          w = this.width,
          h = this.height,
          x = -this.width / 2,
          y = -this.height / 2,
          isRounded = rx !== 0 || ry !== 0,
          /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
          k = 1 - 0.5522847498;
      ctx.beginPath();

      ctx.moveTo(x + rx, y);

      ctx.lineTo(x + w - rx, y);
      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);

      ctx.lineTo(x + w, y + h - ry);
      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);

      ctx.lineTo(x + rx, y + h);
      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);

      ctx.lineTo(x, y + ry);
      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);

      ctx.closePath();

      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var x = -this.width / 2, y = -this.height / 2;
      return [
        '<rect ', 'COMMON_PARTS',
        'x="', x, '" y="', y,
        '" rx="', this.rx, '" ry="', this.ry,
        '" width="', this.width, '" height="', this.height,
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
   * @static
   * @memberOf fabric.Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */
  fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));

  /**
   * Returns {@link fabric.Rect} instance from an SVG element
   * @static
   * @memberOf fabric.Rect
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Rect.fromElement = function(element, callback, options) {
    if (!element) {
      return callback(null);
    }
    options = options || { };

    var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
    parsedAttributes.left = parsedAttributes.left || 0;
    parsedAttributes.top  = parsedAttributes.top  || 0;
    parsedAttributes.height  = parsedAttributes.height || 0;
    parsedAttributes.width  = parsedAttributes.width || 0;
    var rect = new fabric.Rect(extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
    rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
    callback(rect);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns {@link fabric.Rect} instance from an object representation
   * @static
   * @memberOf fabric.Rect
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
   */
  fabric.Rect.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Rect', object, callback);
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      toFixed = fabric.util.toFixed;

  if (fabric.Polyline) {
    fabric.warn('fabric.Polyline is already defined');
    return;
  }

  /**
   * Polyline class
   * @class fabric.Polyline
   * @extends fabric.Object
   * @see {@link fabric.Polyline#initialize} for constructor definition
   */
  fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polyline',

    /**
     * Points array
     * @type Array
     * @default
     */
    points: null,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),

    /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {fabric.Polyline} thisArg
     * @example
     * var poly = new fabric.Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */
    initialize: function(points, options) {
      options = options || {};
      this.points = points || [];
      this.callSuper('initialize', options);
      this._setPositionDimensions(options);
    },

    _setPositionDimensions: function(options) {
      var calcDim = this._calcDimensions(options), correctLeftTop;
      this.width = calcDim.width;
      this.height = calcDim.height;
      if (!options.fromSVG) {
        correctLeftTop = this.translateToGivenOrigin(
          { x: calcDim.left - this.strokeWidth / 2, y: calcDim.top - this.strokeWidth / 2 },
          'left',
          'top',
          this.originX,
          this.originY
        );
      }
      if (typeof options.left === 'undefined') {
        this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
      }
      if (typeof options.top === 'undefined') {
        this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
      }
      this.pathOffset = {
        x: calcDim.left + this.width / 2,
        y: calcDim.top + this.height / 2
      };
    },

    /**
     * Calculate the polygon min and max point from points array,
     * returning an object with left, top, widht, height to measure the
     * polygon size
     * @return {Object} object.left X coordinate of the polygon leftmost point
     * @return {Object} object.top Y coordinate of the polygon topmost point
     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
     * @private
     */
    _calcDimensions: function() {

      var points = this.points,
          minX = min(points, 'x') || 0,
          minY = min(points, 'y') || 0,
          maxX = max(points, 'x') || 0,
          maxY = max(points, 'y') || 0,
          width = (maxX - minX),
          height = (maxY - minY);

      return {
        left: minX,
        top: minY,
        width: width,
        height: height
      };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        points: this.points.concat()
      });
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y,
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;

      for (var i = 0, len = this.points.length; i < len; i++) {
        points.push(
          toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',',
          toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' '
        );
      }
      return [
        '<' + this.type + ' ', 'COMMON_PARTS',
        'points="', points.join(''),
        '" />\n'
      ];
    },
    /* _TO_SVG_END_ */


    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    commonRender: function(ctx) {
      var point, len = this.points.length,
          x = this.pathOffset.x,
          y = this.pathOffset.y;

      if (!len || isNaN(this.points[len - 1].y)) {
        // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return false;
      }
      ctx.beginPath();
      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
      for (var i = 0; i < len; i++) {
        point = this.points[i];
        ctx.lineTo(point.x - x, point.y - y);
      }
      return true;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }
      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var p1, p2;

      ctx.beginPath();
      for (var i = 0, len = this.points.length; i < len; i++) {
        p1 = this.points[i];
        p2 = this.points[i + 1] || p1;
        fabric.util.drawDashedLine(ctx, p1.x, p1.y, p2.x, p2.y, this.strokeDashArray);
      }
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */
    complexity: function() {
      return this.get('points').length;
    }
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
   * @static
   * @memberOf fabric.Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */
  fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

  /**
   * Returns fabric.Polyline instance from an SVG element
   * @static
   * @memberOf fabric.Polyline
   * @param {SVGElement} element Element to parser
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Polyline.fromElementGenerator = function(_class) {
    return function(element, callback, options) {
      if (!element) {
        return callback(null);
      }
      options || (options = { });

      var points = fabric.parsePointsAttribute(element.getAttribute('points')),
          parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
      parsedAttributes.fromSVG = true;
      callback(new fabric[_class](points, extend(parsedAttributes, options)));
    };
  };

  fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');

  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polyline instance from an object representation
   * @static
   * @memberOf fabric.Polyline
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Polyline.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Polyline', object, callback, 'points');
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.Polygon) {
    fabric.warn('fabric.Polygon is already defined');
    return;
  }

  /**
   * Polygon class
   * @class fabric.Polygon
   * @extends fabric.Polyline
   * @see {@link fabric.Polygon#initialize} for constructor definition
   */
  fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'polygon',

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      if (!this.commonRender(ctx)) {
        return;
      }
      ctx.closePath();
      this._renderPaintInOrder(ctx);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      this.callSuper('_renderDashedStroke', ctx);
      ctx.closePath();
    },
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
   * @static
   * @memberOf fabric.Polygon
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
   */
  fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();

  /**
   * Returns {@link fabric.Polygon} instance from an SVG element
   * @static
   * @memberOf fabric.Polygon
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Polygon instance from an object representation
   * @static
   * @memberOf fabric.Polygon
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Polygon.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Polygon', object, callback, 'points');
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      min = fabric.util.array.min,
      max = fabric.util.array.max,
      extend = fabric.util.object.extend,
      _toString = Object.prototype.toString,
      toFixed = fabric.util.toFixed;

  if (fabric.Path) {
    fabric.warn('fabric.Path is already defined');
    return;
  }

  /**
   * Path class
   * @class fabric.Path
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
   * @see {@link fabric.Path#initialize} for constructor definition
   */
  fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'path',

    /**
     * Array of path points
     * @type Array
     * @default
     */
    path: null,

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),

    stateProperties: fabric.Object.prototype.stateProperties.concat('path'),

    /**
     * Constructor
     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Object} [options] Options object
     * @return {fabric.Path} thisArg
     */
    initialize: function(path, options) {
      options = options || { };
      this.callSuper('initialize', options);
      if (!path) {
        path = [];
      }

      var fromArray = _toString.call(path) === '[object Array]';

      this.path = fromArray
        ? fabric.util.makePathSimpler(path)

        : fabric.util.makePathSimpler(
          fabric.util.parsePath(path)
        );

      if (!this.path) {
        return;
      }
      fabric.Polyline.prototype._setPositionDimensions.call(this, options);
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _renderPathCommands: function(ctx) {
      var current, // current instruction
          subpathStartX = 0,
          subpathStartY = 0,
          x = 0, // current x
          y = 0, // current y
          controlX = 0, // current control point x
          controlY = 0, // current control point y
          l = -this.pathOffset.x,
          t = -this.pathOffset.y;

      ctx.beginPath();

      for (var i = 0, len = this.path.length; i < len; ++i) {

        current = this.path[i];

        switch (current[0]) { // first letter

          case 'L': // lineto, absolute
            x = current[1];
            y = current[2];
            ctx.lineTo(x + l, y + t);
            break;

          case 'M': // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            ctx.moveTo(x + l, y + t);
            break;

          case 'C': // bezierCurveTo, absolute
            x = current[5];
            y = current[6];
            controlX = current[3];
            controlY = current[4];
            ctx.bezierCurveTo(
              current[1] + l,
              current[2] + t,
              controlX + l,
              controlY + t,
              x + l,
              y + t
            );
            break;

          case 'Q': // quadraticCurveTo, absolute
            ctx.quadraticCurveTo(
              current[1] + l,
              current[2] + t,
              current[3] + l,
              current[4] + t
            );
            x = current[3];
            y = current[4];
            controlX = current[1];
            controlY = current[2];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            ctx.closePath();
            break;
        }
      }
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _render: function(ctx) {
      this._renderPathCommands(ctx);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Returns string representation of an instance
     * @return {String} string representation of an instance
     */
    toString: function() {
      return '#<fabric.Path (' + this.complexity() +
        '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return extend(this.callSuper('toObject', propertiesToInclude), {
        path: this.path.map(function(item) { return item.slice(); }),
      });
    },

    /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      var o = this.toObject(['sourcePath'].concat(propertiesToInclude));
      if (o.sourcePath) {
        delete o.path;
      }
      return o;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var path = this.path.map(function(path) {
        return path.join(' ');
      }).join(' ');
      return [
        '<path ', 'COMMON_PARTS',
        'd="', path,
        '" stroke-linecap="round" ',
        '/>\n'
      ];
    },

    _getOffsetTransform: function() {
      var digits = fabric.Object.NUM_FRACTION_DIGITS;
      return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' +
          toFixed(-this.pathOffset.y, digits) + ')';
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      var additionalTransform = this._getOffsetTransform();
      return '\t' + this._createBaseClipPathSVGMarkup(
        this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform }
      );
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      var additionalTransform = this._getOffsetTransform();
      return this._createBaseSVGMarkup(this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform  });
    },
    /* _TO_SVG_END_ */

    /**
     * Returns number representation of an instance complexity
     * @return {Number} complexity of this instance
     */
    complexity: function() {
      return this.path.length;
    },

    /**
     * @private
     */
    _calcDimensions: function() {

      var aX = [],
          aY = [],
          current, // current instruction
          subpathStartX = 0,
          subpathStartY = 0,
          x = 0, // current x
          y = 0, // current y
          bounds;

      for (var i = 0, len = this.path.length; i < len; ++i) {

        current = this.path[i];

        switch (current[0]) { // first letter

          case 'L': // lineto, absolute
            x = current[1];
            y = current[2];
            bounds = [];
            break;

          case 'M': // moveTo, absolute
            x = current[1];
            y = current[2];
            subpathStartX = x;
            subpathStartY = y;
            bounds = [];
            break;

          case 'C': // bezierCurveTo, absolute
            bounds = fabric.util.getBoundsOfCurve(x, y,
              current[1],
              current[2],
              current[3],
              current[4],
              current[5],
              current[6]
            );
            x = current[5];
            y = current[6];
            break;

          case 'Q': // quadraticCurveTo, absolute
            bounds = fabric.util.getBoundsOfCurve(x, y,
              current[1],
              current[2],
              current[1],
              current[2],
              current[3],
              current[4]
            );
            x = current[3];
            y = current[4];
            break;

          case 'z':
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            break;
        }
        bounds.forEach(function (point) {
          aX.push(point.x);
          aY.push(point.y);
        });
        aX.push(x);
        aY.push(y);
      }

      var minX = min(aX) || 0,
          minY = min(aY) || 0,
          maxX = max(aX) || 0,
          maxY = max(aY) || 0,
          deltaX = maxX - minX,
          deltaY = maxY - minY;

      return {
        left: minX,
        top: minY,
        width: deltaX,
        height: deltaY
      };
    }
  });

  /**
   * Creates an instance of fabric.Path from an object
   * @static
   * @memberOf fabric.Path
   * @param {Object} object
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */
  fabric.Path.fromObject = function(object, callback) {
    if (typeof object.sourcePath === 'string') {
      var pathUrl = object.sourcePath;
      fabric.loadSVGFromURL(pathUrl, function (elements) {
        var path = elements[0];
        path.setOptions(object);
        callback && callback(path);
      });
    }
    else {
      fabric.Object._fromObject('Path', object, callback, 'path');
    }
  };

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
   * @static
   * @memberOf fabric.Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */
  fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(['d']);

  /**
   * Creates an instance of fabric.Path from an SVG <path> element
   * @static
   * @memberOf fabric.Path
   * @param {SVGElement} element to parse
   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
   * @param {Object} [options] Options object
   * @param {Function} [callback] Options callback invoked after parsing is finished
   */
  fabric.Path.fromElement = function(element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
    parsedAttributes.fromSVG = true;
    callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
  };
  /* _FROM_SVG_END_ */

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      min = fabric.util.array.min,
      max = fabric.util.array.max;

  if (fabric.Group) {
    return;
  }

  /**
   * Group class
   * @class fabric.Group
   * @extends fabric.Object
   * @mixes fabric.Collection
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.Group#initialize} for constructor definition
   */
  fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'group',

    /**
     * Width of stroke
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
     * @type Boolean
     * @default
     */
    subTargetCheck: false,

    /**
     * Groups are container, do not render anything on theyr own, ence no cache properties
     * @type Array
     * @default
     */
    cacheProperties: [],

    /**
     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
     * available setting this boolean to true.
     * @type Boolean
     * @since 2.0.0
     * @default
     */
    useSetOnGroup: false,

    /**
     * Constructor
     * @param {Object} objects Group objects
     * @param {Object} [options] Options object
     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
     * @return {Object} thisArg
     */
    initialize: function(objects, options, isAlreadyGrouped) {
      options = options || {};
      this._objects = [];
      // if objects enclosed in a group have been grouped already,
      // we cannot change properties of objects.
      // Thus we need to set options to group without objects,
      isAlreadyGrouped && this.callSuper('initialize', options);
      this._objects = objects || [];
      for (var i = this._objects.length; i--; ) {
        this._objects[i].group = this;
      }

      if (!isAlreadyGrouped) {
        var center = options && options.centerPoint;
        // we want to set origins before calculating the bounding box.
        // so that the topleft can be set with that in mind.
        // if specific top and left are passed, are overwritten later
        // with the callSuper('initialize', options)
        if (options.originX !== undefined) {
          this.originX = options.originX;
        }
        if (options.originY !== undefined) {
          this.originY = options.originY;
        }
        // if coming from svg i do not want to calc bounds.
        // i assume width and height are passed along options
        center || this._calcBounds();
        this._updateObjectsCoords(center);
        delete options.centerPoint;
        this.callSuper('initialize', options);
      }
      else {
        this._updateObjectsACoords();
      }

      this.setCoords();
    },

    /**
     * @private
     */
    _updateObjectsACoords: function() {
      var skipControls = true;
      for (var i = this._objects.length; i--; ){
        this._objects[i].setCoords(skipControls);
      }
    },

    /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */
    _updateObjectsCoords: function(center) {
      var center = center || this.getCenterPoint();
      for (var i = this._objects.length; i--; ){
        this._updateObjectCoords(this._objects[i], center);
      }
    },

    /**
     * @private
     * @param {Object} object
     * @param {fabric.Point} center, current center of group.
     */
    _updateObjectCoords: function(object, center) {
      var objectLeft = object.left,
          objectTop = object.top,
          skipControls = true;

      object.set({
        left: objectLeft - center.x,
        top: objectTop - center.y
      });
      object.group = this;
      object.setCoords(skipControls);
    },

    /**
     * Returns string represenation of a group
     * @return {String}
     */
    toString: function() {
      return '#<fabric.Group: (' + this.complexity() + ')>';
    },

    /**
     * Adds an object to a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    addWithUpdate: function(object) {
      this._restoreObjectsState();
      fabric.util.resetObjectTransform(this);
      if (object) {
        this._objects.push(object);
        object.group = this;
        object._set('canvas', this.canvas);
      }
      this._calcBounds();
      this._updateObjectsCoords();
      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * Removes an object from a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */
    removeWithUpdate: function(object) {
      this._restoreObjectsState();
      fabric.util.resetObjectTransform(this);

      this.remove(object);
      this._calcBounds();
      this._updateObjectsCoords();
      this.setCoords();
      this.dirty = true;
      return this;
    },

    /**
     * @private
     */
    _onObjectAdded: function(object) {
      this.dirty = true;
      object.group = this;
      object._set('canvas', this.canvas);
    },

    /**
     * @private
     */
    _onObjectRemoved: function(object) {
      this.dirty = true;
      delete object.group;
    },

    /**
     * @private
     */
    _set: function(key, value) {
      var i = this._objects.length;
      if (this.useSetOnGroup) {
        while (i--) {
          this._objects[i].setOnGroup(key, value);
        }
      }
      if (key === 'canvas') {
        while (i--) {
          this._objects[i]._set(key, value);
        }
      }
      fabric.Object.prototype._set.call(this, key, value);
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var _includeDefaultValues = this.includeDefaultValues;
      var objsToObject = this._objects.map(function(obj) {
        var originalDefaults = obj.includeDefaultValues;
        obj.includeDefaultValues = _includeDefaultValues;
        var _obj = obj.toObject(propertiesToInclude);
        obj.includeDefaultValues = originalDefaults;
        return _obj;
      });
      var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Returns object representation of an instance, in dataless mode.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject: function(propertiesToInclude) {
      var objsToObject, sourcePath = this.sourcePath;
      if (sourcePath) {
        objsToObject = sourcePath;
      }
      else {
        var _includeDefaultValues = this.includeDefaultValues;
        objsToObject = this._objects.map(function(obj) {
          var originalDefaults = obj.includeDefaultValues;
          obj.includeDefaultValues = _includeDefaultValues;
          var _obj = obj.toDatalessObject(propertiesToInclude);
          obj.includeDefaultValues = originalDefaults;
          return _obj;
        });
      }
      var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
      obj.objects = objsToObject;
      return obj;
    },

    /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */
    render: function(ctx) {
      this._transformDone = true;
      this.callSuper('render', ctx);
      this._transformDone = false;
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */
    shouldCache: function() {
      var ownCache = fabric.Object.prototype.shouldCache.call(this);
      if (ownCache) {
        for (var i = 0, len = this._objects.length; i < len; i++) {
          if (this._objects[i].willDrawShadow()) {
            this.ownCaching = false;
            return false;
          }
        }
      }
      return ownCache;
    },

    /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */
    willDrawShadow: function() {
      if (fabric.Object.prototype.willDrawShadow.call(this)) {
        return true;
      }
      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].willDrawShadow()) {
          return true;
        }
      }
      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function() {
      return this.ownCaching || (this.group && this.group.isOnACache());
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function(ctx) {
      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i].render(ctx);
      }
      this._drawClipPath(ctx);
    },

    /**
     * Check if cache is dirty
     */
    isCacheDirty: function(skipCanvas) {
      if (this.callSuper('isCacheDirty', skipCanvas)) {
        return true;
      }
      if (!this.statefullCache) {
        return false;
      }
      for (var i = 0, len = this._objects.length; i < len; i++) {
        if (this._objects[i].isCacheDirty(true)) {
          if (this._cacheCanvas) {
            // if this group has not a cache canvas there is nothing to clean
            var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
            this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
          }
          return true;
        }
      }
      return false;
    },

    /**
     * Retores original state of each of group objects (original state is that which was before group was created).
     * @private
     * @return {fabric.Group} thisArg
     * @chainable
     */
    _restoreObjectsState: function() {
      this._objects.forEach(this._restoreObjectState, this);
      return this;
    },

    /**
     * Realises the transform from this group onto the supplied object
     * i.e. it tells you what would happen if the supplied object was in
     * the group, and then the group was destroyed. It mutates the supplied
     * object.
     * @param {fabric.Object} object
     * @return {fabric.Object} transformedObject
     */
    realizeTransform: function(object) {
      var matrix = object.calcTransformMatrix(),
          options = fabric.util.qrDecompose(matrix),
          center = new fabric.Point(options.translateX, options.translateY);
      object.flipX = false;
      object.flipY = false;
      object.set('scaleX', options.scaleX);
      object.set('scaleY', options.scaleY);
      object.skewX = options.skewX;
      object.skewY = options.skewY;
      object.angle = options.angle;
      object.setPositionByOrigin(center, 'center', 'center');
      return object;
    },

    /**
     * Restores original state of a specified object in group
     * @private
     * @param {fabric.Object} object
     * @return {fabric.Group} thisArg
     */
    _restoreObjectState: function(object) {
      this.realizeTransform(object);
      delete object.group;
      object.setCoords();
      return this;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    destroy: function() {
      // when group is destroyed objects needs to get a repaint to be eventually
      // displayed on canvas.
      this._objects.forEach(function(object) {
        object.set('dirty', true);
      });
      return this._restoreObjectsState();
    },

    /**
     * make a group an active selection, remove the group from canvas
     * the group has to be on canvas for this to work.
     * @return {fabric.ActiveSelection} thisArg
     * @chainable
     */
    toActiveSelection: function() {
      if (!this.canvas) {
        return;
      }
      var objects = this._objects, canvas = this.canvas;
      this._objects = [];
      var options = this.toObject();
      delete options.objects;
      var activeSelection = new fabric.ActiveSelection([]);
      activeSelection.set(options);
      activeSelection.type = 'activeSelection';
      canvas.remove(this);
      objects.forEach(function(object) {
        object.group = activeSelection;
        object.dirty = true;
        canvas.add(object);
      });
      activeSelection.canvas = canvas;
      activeSelection._objects = objects;
      canvas._activeObject = activeSelection;
      activeSelection.setCoords();
      return activeSelection;
    },

    /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */
    ungroupOnCanvas: function() {
      return this._restoreObjectsState();
    },

    /**
     * Sets coordinates of all objects inside group
     * @return {fabric.Group} thisArg
     * @chainable
     */
    setObjectsCoords: function() {
      var skipControls = true;
      this.forEachObject(function(object) {
        object.setCoords(skipControls);
      });
      return this;
    },

    /**
     * @private
     */
    _calcBounds: function(onlyWidthHeight) {
      var aX = [],
          aY = [],
          o, prop,
          props = ['tr', 'br', 'bl', 'tl'],
          i = 0, iLen = this._objects.length,
          j, jLen = props.length;

      for ( ; i < iLen; ++i) {
        o = this._objects[i];
        o.aCoords = o.calcACoords();
        for (j = 0; j < jLen; j++) {
          prop = props[j];
          aX.push(o.aCoords[prop].x);
          aY.push(o.aCoords[prop].y);
        }
      }

      this._getBounds(aX, aY, onlyWidthHeight);
    },

    /**
     * @private
     */
    _getBounds: function(aX, aY, onlyWidthHeight) {
      var minXY = new fabric.Point(min(aX), min(aY)),
          maxXY = new fabric.Point(max(aX), max(aY)),
          top = minXY.y || 0, left = minXY.x || 0,
          width = (maxXY.x - minXY.x) || 0,
          height = (maxXY.y - minXY.y) || 0;
      this.width = width;
      this.height = height;
      if (!onlyWidthHeight) {
        // the bounding box always finds the topleft most corner.
        // whatever is the group origin, we set up here the left/top position.
        this.setPositionByOrigin({ x: left, y: top }, 'left', 'top');
      }
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function(reviver) {
      var svgString = ['<g ', 'COMMON_PARTS', ' >\n'];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t\t', this._objects[i].toSVG(reviver));
      }
      svgString.push('</g>\n');
      return svgString;
    },

    /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */
    getSvgStyles: function() {
      var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ?
            'opacity: ' + this.opacity + ';' : '',
          visibility = this.visible ? '' : ' visibility: hidden;';
      return [
        opacity,
        this.getSvgFilter(),
        visibility
      ].join('');
    },

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG: function(reviver) {
      var svgString = [];

      for (var i = 0, len = this._objects.length; i < len; i++) {
        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
      }

      return this._createBaseClipPathSVGMarkup(svgString, { reviver: reviver });
    },
    /* _TO_SVG_END_ */
  });

  /**
   * Returns {@link fabric.Group} instance from an object representation
   * @static
   * @memberOf fabric.Group
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an group instance is created
   */
  fabric.Group.fromObject = function(object, callback) {
    var objects = object.objects,
        options = fabric.util.object.clone(object, true);
    delete options.objects;
    if (typeof objects === 'string') {
      // it has to be an url or something went wrong.
      fabric.loadSVGFromURL(objects, function (elements) {
        var group = fabric.util.groupSVGElements(elements, object, objects);
        group.set(options);
        callback && callback(group);
      });
      return;
    }
    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
      fabric.util.enlivenObjects([object.clipPath], function(enlivedClipPath) {
        var options = fabric.util.object.clone(object, true);
        options.clipPath = enlivedClipPath[0];
        delete options.objects;
        callback && callback(new fabric.Group(enlivenedObjects, options, true));
      });
    });
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { });

  if (fabric.ActiveSelection) {
    return;
  }

  /**
   * Group class
   * @class fabric.ActiveSelection
   * @extends fabric.Group
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
   */
  fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'activeSelection',

    /**
     * Constructor
     * @param {Object} objects ActiveSelection objects
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */
    initialize: function(objects, options) {
      options = options || {};
      this._objects = objects || [];
      for (var i = this._objects.length; i--; ) {
        this._objects[i].group = this;
      }

      if (options.originX) {
        this.originX = options.originX;
      }
      if (options.originY) {
        this.originY = options.originY;
      }
      this._calcBounds();
      this._updateObjectsCoords();
      fabric.Object.prototype.initialize.call(this, options);
      this.setCoords();
    },

    /**
     * Change te activeSelection to a normal group,
     * High level function that automatically adds it to canvas as
     * active object. no events fired.
     * @since 2.0.0
     * @return {fabric.Group}
     */
    toGroup: function() {
      var objects = this._objects.concat();
      this._objects = [];
      var options = fabric.Object.prototype.toObject.call(this);
      var newGroup = new fabric.Group([]);
      delete options.type;
      newGroup.set(options);
      objects.forEach(function(object) {
        object.canvas.remove(object);
        object.group = newGroup;
      });
      newGroup._objects = objects;
      if (!this.canvas) {
        return newGroup;
      }
      var canvas = this.canvas;
      canvas.add(newGroup);
      canvas._activeObject = newGroup;
      newGroup.setCoords();
      return newGroup;
    },

    /**
     * If returns true, deselection is cancelled.
     * @since 2.0.0
     * @return {Boolean} [cancel]
     */
    onDeselect: function() {
      this.destroy();
      return false;
    },

    /**
     * Returns string representation of a group
     * @return {String}
     */
    toString: function() {
      return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * @return {Boolean}
     */
    shouldCache: function() {
      return false;
    },

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache: function() {
      return false;
    },

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */
    _renderControls: function(ctx, styleOverride, childrenOverride) {
      ctx.save();
      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      this.callSuper('_renderControls', ctx, styleOverride);
      childrenOverride = childrenOverride || { };
      if (typeof childrenOverride.hasControls === 'undefined') {
        childrenOverride.hasControls = false;
      }
      childrenOverride.forActiveSelection = true;
      for (var i = 0, len = this._objects.length; i < len; i++) {
        this._objects[i]._renderControls(ctx, childrenOverride);
      }
      ctx.restore();
    },
  });

  /**
   * Returns {@link fabric.ActiveSelection} instance from an object representation
   * @static
   * @memberOf fabric.ActiveSelection
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
   */
  fabric.ActiveSelection.fromObject = function(object, callback) {
    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
      delete object.objects;
      callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
    });
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var extend = fabric.util.object.extend;

  if (!global.fabric) {
    global.fabric = { };
  }

  if (global.fabric.Image) {
    fabric.warn('fabric.Image is already defined.');
    return;
  }

  /**
   * Image class
   * @class fabric.Image
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   * @see {@link fabric.Image#initialize} for constructor definition
   */
  fabric.Image = fabric.util.createClass(fabric.Object, /** @lends fabric.Image.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'image',

    /**
     * Width of a stroke.
     * For image quality a stroke multiple of 2 gives better results.
     * @type Number
     * @default
     */
    strokeWidth: 0,

    /**
     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default
     */
    srcFromAttribute: false,

    /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleX: 1,

    /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */
    _lastScaleY: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingX: 1,

    /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */
    _filterScalingY: 1,

    /**
     * minimum scale factor under which any resizeFilter is triggered to resize the image
     * 0 will disable the automatic resize. 1 will trigger automatically always.
     * number bigger than 1 are not implemented yet.
     * @type Number
     */
    minimumScaleTrigger: 0.5,

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),

    /**
     * key used to retrieve the texture representing this image
     * @since 2.0.0
     * @type String
     * @default
     */
    cacheKey: '',

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropX: 0,

    /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */
    cropY: 0,

    /**
     * Indicates whether this canvas will use image smoothing when painting this image.
     * Also influence if the cacheCanvas for this image uses imageSmoothing
     * @since 4.0.0-beta.11
     * @type Boolean
     * @default
     */
    imageSmoothing: true,

    /**
     * Constructor
     * @param {HTMLImageElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */
    initialize: function(element, options) {
      options || (options = { });
      this.filters = [];
      this.cacheKey = 'texture' + fabric.Object.__uid++;
      this.callSuper('initialize', options);
      this._initElement(element, options);
    },

    /**
     * Returns image element which this instance if based on
     * @return {HTMLImageElement} Image element
     */
    getElement: function() {
      return this._element || {};
    },

    /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setElement: function(element, options) {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._element = element;
      this._originalElement = element;
      this._initConfig(options);
      if (this.filters.length !== 0) {
        this.applyFilters();
      }
      // resizeFilters work on the already filtered copy.
      // we need to apply resizeFilters AFTER normal filters.
      // applyResizeFilters is run more often than normal fiters
      // and is triggered by user interactions rather than dev code
      if (this.resizeFilter) {
        this.applyResizeFilters();
      }
      return this;
    },

    /**
     * Delete a single texture if in webgl mode
     */
    removeTexture: function(key) {
      var backend = fabric.filterBackend;
      if (backend && backend.evictCachesForKey) {
        backend.evictCachesForKey(key);
      }
    },

    /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */
    dispose: function() {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + '_filtered');
      this._cacheContext = undefined;
      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach((function(element) {
        fabric.util.cleanUpJsdomNode(this[element]);
        this[element] = undefined;
      }).bind(this));
    },

    /**
     * Get the crossOrigin value (of the corresponding image element)
     */
    getCrossOrigin: function() {
      return this._originalElement && (this._originalElement.crossOrigin || null);
    },

    /**
     * Returns original size of an image
     * @return {Object} Object with "width" and "height" properties
     */
    getOriginalSize: function() {
      var element = this.getElement();
      return {
        width: element.naturalWidth || element.width,
        height: element.naturalHeight || element.height
      };
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _stroke: function(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }
      var w = this.width / 2, h = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-w, -h);
      ctx.lineTo(w, -h);
      ctx.lineTo(w, h);
      ctx.lineTo(-w, h);
      ctx.lineTo(-w, -h);
      ctx.closePath();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderDashedStroke: function(ctx) {
      var x = -this.width / 2,
          y = -this.height / 2,
          w = this.width,
          h = this.height;

      ctx.save();
      this._setStrokeStyles(ctx, this);

      ctx.beginPath();
      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
      ctx.closePath();
      ctx.restore();
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var filters = [];

      this.filters.forEach(function(filterObj) {
        if (filterObj) {
          filters.push(filterObj.toObject());
        }
      });
      var object = extend(
        this.callSuper(
          'toObject',
          ['cropX', 'cropY'].concat(propertiesToInclude)
        ), {
          src: this.getSrc(),
          crossOrigin: this.getCrossOrigin(),
          filters: filters,
        });
      if (this.resizeFilter) {
        object.resizeFilter = this.resizeFilter.toObject();
      }
      return object;
    },

    /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,hight.
     * @return {Boolean}
     */
    hasCrop: function() {
      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
    },

    /* _TO_SVG_START_ */
    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG: function() {
      var svgString = [], imageMarkup = [], strokeSvg, element = this._element,
          x = -this.width / 2, y = -this.height / 2, clipPath = '', imageRendering = '';
      if (!element) {
        return [];
      }
      if (this.hasCrop()) {
        var clipPathId = fabric.Object.__uid++;
        svgString.push(
          '<clipPath id="imageCrop_' + clipPathId + '">\n',
          '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n',
          '</clipPath>\n'
        );
        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
      }
      if (!this.imageSmoothing) {
        imageRendering = '" image-rendering="optimizeSpeed';
      }
      imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true),
        '" x="', x - this.cropX, '" y="', y - this.cropY,
        // we're essentially moving origin of transformation from top/left corner to the center of the shape
        // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
        // so that object's center aligns with container's left/top
        '" width="', element.width || element.naturalWidth,
        '" height="', element.height || element.height,
        imageRendering,
        '"', clipPath,
        '></image>\n');

      if (this.stroke || this.strokeDashArray) {
        var origFill = this.fill;
        this.fill = null;
        strokeSvg = [
          '\t<rect ',
          'x="', x, '" y="', y,
          '" width="', this.width, '" height="', this.height,
          '" style="', this.getSvgStyles(),
          '"/>\n'
        ];
        this.fill = origFill;
      }
      if (this.paintFirst !== 'fill') {
        svgString = svgString.concat(strokeSvg, imageMarkup);
      }
      else {
        svgString = svgString.concat(imageMarkup, strokeSvg);
      }
      return svgString;
    },
    /* _TO_SVG_END_ */

    /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */
    getSrc: function(filtered) {
      var element = filtered ? this._element : this._originalElement;
      if (element) {
        if (element.toDataURL) {
          return element.toDataURL();
        }

        if (this.srcFromAttribute) {
          return element.getAttribute('src');
        }
        else {
          return element.src;
        }
      }
      else {
        return this.src || '';
      }
    },

    /**
     * Sets source of an image
     * @param {String} src Source string (URL)
     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
     * @param {Object} [options] Options object
     * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @return {fabric.Image} thisArg
     * @chainable
     */
    setSrc: function(src, callback, options) {
      fabric.util.loadImage(src, function(img, isError) {
        this.setElement(img, options);
        this._setWidthHeight();
        callback && callback(this, isError);
      }, this, options && options.crossOrigin);
      return this;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */
    toString: function() {
      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
    },

    applyResizeFilters: function() {
      var filter = this.resizeFilter,
          minimumScale = this.minimumScaleTrigger,
          objectScale = this.getTotalObjectScaling(),
          scaleX = objectScale.scaleX,
          scaleY = objectScale.scaleY,
          elementToFilter = this._filteredEl || this._originalElement;
      if (this.group) {
        this.set('dirty', true);
      }
      if (!filter || (scaleX > minimumScale && scaleY > minimumScale)) {
        this._element = elementToFilter;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        this._lastScaleX = scaleX;
        this._lastScaleY = scaleY;
        return;
      }
      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }
      var canvasEl = fabric.util.createCanvasElement(),
          cacheKey = this._filteredEl ? (this.cacheKey + '_filtered') : this.cacheKey,
          sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
      canvasEl.width = sourceWidth;
      canvasEl.height = sourceHeight;
      this._element = canvasEl;
      this._lastScaleX = filter.scaleX = scaleX;
      this._lastScaleY = filter.scaleY = scaleY;
      fabric.filterBackend.applyFilters(
        [filter], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
      this._filterScalingX = canvasEl.width / this._originalElement.width;
      this._filterScalingY = canvasEl.height / this._originalElement.height;
    },

    /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     * @return {thisArg} return the fabric.Image object
     * @chainable
     */
    applyFilters: function(filters) {

      filters = filters || this.filters || [];
      filters = filters.filter(function(filter) { return filter && !filter.isNeutralState(); });
      this.set('dirty', true);

      // needs to clear out or WEBGL will not resize correctly
      this.removeTexture(this.cacheKey + '_filtered');

      if (filters.length === 0) {
        this._element = this._originalElement;
        this._filteredEl = null;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        return this;
      }

      var imgElement = this._originalElement,
          sourceWidth = imgElement.naturalWidth || imgElement.width,
          sourceHeight = imgElement.naturalHeight || imgElement.height;

      if (this._element === this._originalElement) {
        // if the element is the same we need to create a new element
        var canvasEl = fabric.util.createCanvasElement();
        canvasEl.width = sourceWidth;
        canvasEl.height = sourceHeight;
        this._element = canvasEl;
        this._filteredEl = canvasEl;
      }
      else {
        // clear the existing element to get new filter data
        // also dereference the eventual resized _element
        this._element = this._filteredEl;
        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
        // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
        this._lastScaleX = 1;
        this._lastScaleY = 1;
      }
      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }
      fabric.filterBackend.applyFilters(
        filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
      if (this._originalElement.width !== this._element.width ||
        this._originalElement.height !== this._element.height) {
        this._filterScalingX = this._element.width / this._originalElement.width;
        this._filterScalingY = this._element.height / this._originalElement.height;
      }
      return this;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
        this.applyResizeFilters();
      }
      this._stroke(ctx);
      this._renderPaintInOrder(ctx);
    },

    /**
     * Paint the cached copy of the object on the target context.
     * it will set the imageSmoothing for the draw operation
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas: function(ctx) {
      fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
      fabric.Object.prototype.drawCacheOnCanvas.call(this, ctx);
    },

    /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */
    shouldCache: function() {
      return this.needsItsOwnCache();
    },

    _renderFill: function(ctx) {
      var elementToDraw = this._element;
      if (!elementToDraw) {
        return;
      }
      var scaleX = this._filterScalingX, scaleY = this._filterScalingY,
          w = this.width, h = this.height, min = Math.min, max = Math.max,
          // crop values cannot be lesser than 0.
          cropX = max(this.cropX, 0), cropY = max(this.cropY, 0),
          elWidth = elementToDraw.naturalWidth || elementToDraw.width,
          elHeight = elementToDraw.naturalHeight || elementToDraw.height,
          sX = cropX * scaleX,
          sY = cropY * scaleY,
          // the width height cannot exceed element width/height, starting from the crop offset.
          sW = min(w * scaleX, elWidth - sX),
          sH = min(h * scaleY, elHeight - sY),
          x = -w / 2, y = -h / 2,
          maxDestW = min(w, elWidth / scaleX - cropX),
          maxDestH = min(h, elHeight / scaleX - cropY);

      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    },

    /**
     * needed to check if image needs resize
     * @private
     */
    _needsResize: function() {
      var scale = this.getTotalObjectScaling();
      return (scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY);
    },

    /**
     * @private
     */
    _resetWidthHeight: function() {
      this.set(this.getOriginalSize());
    },

    /**
     * The Image class's initialization method. This method is automatically
     * called by the constructor.
     * @private
     * @param {HTMLImageElement|String} element The element representing the image
     * @param {Object} [options] Options object
     */
    _initElement: function(element, options) {
      this.setElement(fabric.util.getById(element), options);
      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
    },

    /**
     * @private
     * @param {Object} [options] Options object
     */
    _initConfig: function(options) {
      options || (options = { });
      this.setOptions(options);
      this._setWidthHeight(options);
    },

    /**
     * @private
     * @param {Array} filters to be initialized
     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
     */
    _initFilters: function(filters, callback) {
      if (filters && filters.length) {
        fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
          callback && callback(enlivenedObjects);
        }, 'fabric.Image.filters');
      }
      else {
        callback && callback();
      }
    },

    /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     * @param {Object} [options] Object with width/height properties
     */
    _setWidthHeight: function(options) {
      options || (options = { });
      var el = this.getElement();
      this.width = options.width || el.naturalWidth || el.width || 0;
      this.height = options.height || el.naturalHeight || el.height || 0;
    },

    /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     * @return {Object}
     */
    parsePreserveAspectRatioAttribute: function() {
      var pAR = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
          rWidth = this._element.width, rHeight = this._element.height,
          scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0,
          offset, pWidth = this.width, pHeight = this.height, parsedAttributes = { width: pWidth, height: pHeight };
      if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
        if (pAR.meetOrSlice === 'meet') {
          scaleX = scaleY = fabric.util.findScaleToFit(this._element, parsedAttributes);
          offset = (pWidth - rWidth * scaleX) / 2;
          if (pAR.alignX === 'Min') {
            offsetLeft = -offset;
          }
          if (pAR.alignX === 'Max') {
            offsetLeft = offset;
          }
          offset = (pHeight - rHeight * scaleY) / 2;
          if (pAR.alignY === 'Min') {
            offsetTop = -offset;
          }
          if (pAR.alignY === 'Max') {
            offsetTop = offset;
          }
        }
        if (pAR.meetOrSlice === 'slice') {
          scaleX = scaleY = fabric.util.findScaleToCover(this._element, parsedAttributes);
          offset = rWidth - pWidth / scaleX;
          if (pAR.alignX === 'Mid') {
            cropX = offset / 2;
          }
          if (pAR.alignX === 'Max') {
            cropX = offset;
          }
          offset = rHeight - pHeight / scaleY;
          if (pAR.alignY === 'Mid') {
            cropY = offset / 2;
          }
          if (pAR.alignY === 'Max') {
            cropY = offset;
          }
          rWidth = pWidth / scaleX;
          rHeight = pHeight / scaleY;
        }
      }
      else {
        scaleX = pWidth / rWidth;
        scaleY = pHeight / rHeight;
      }
      return {
        width: rWidth,
        height: rHeight,
        scaleX: scaleX,
        scaleY: scaleY,
        offsetLeft: offsetLeft,
        offsetTop: offsetTop,
        cropX: cropX,
        cropY: cropY
      };
    }
  });

  /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */
  fabric.Image.CSS_CANVAS = 'canvas-img';

  /**
   * Alias for getSrc
   * @static
   */
  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;

  /**
   * Creates an instance of fabric.Image from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} callback Callback to invoke when an image instance is created
   */
  fabric.Image.fromObject = function(_object, callback) {
    var object = fabric.util.object.clone(_object);
    fabric.util.loadImage(object.src, function(img, isError) {
      if (isError) {
        callback && callback(null, true);
        return;
      }
      fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
        object.filters = filters || [];
        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
          object.resizeFilter = resizeFilters[0];
          fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
            object.clipPath = enlivedProps[0];
            var image = new fabric.Image(img, object);
            callback(image, false);
          });
        });
      });
    }, null, object.crossOrigin);
  };

  /**
   * Creates an instance of fabric.Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument). Second argument is a boolean indicating if an error occured or not.
   * @param {Object} [imgOptions] Options object
   */
  fabric.Image.fromURL = function(url, callback, imgOptions) {
    fabric.util.loadImage(url, function(img, isError) {
      callback && callback(new fabric.Image(img, imgOptions), isError);
    }, null, imgOptions && imgOptions.crossOrigin);
  };

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */
  fabric.Image.ATTRIBUTE_NAMES =
    fabric.SHARED_ATTRIBUTES.concat(
      'x y width height preserveAspectRatio xlink:href crossOrigin image-rendering'.split(' ')
    );

  /**
   * Returns {@link fabric.Image} instance from an SVG element
   * @static
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} callback Callback to execute when fabric.Image object is created
   * @return {fabric.Image} Instance of fabric.Image
   */
  fabric.Image.fromElement = function(element, callback, options) {
    var parsedAttributes = fabric.parseAttributes(element, fabric.Image.ATTRIBUTE_NAMES);
    fabric.Image.fromURL(parsedAttributes['xlink:href'], callback,
      extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
  };
  /* _FROM_SVG_END_ */

})( true ? exports : this);


fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {

  /**
   * @private
   * @return {Number} angle value
   */
  _getAngleValueForStraighten: function() {
    var angle = this.angle % 360;
    if (angle > 0) {
      return Math.round((angle - 1) / 90) * 90;
    }
    return Math.round(angle / 90) * 90;
  },

  /**
   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
   * @return {fabric.Object} thisArg
   * @chainable
   */
  straighten: function() {
    this.rotate(this._getAngleValueForStraighten());
    return this;
  },

  /**
   * Same as {@link fabric.Object.prototype.straighten} but with animation
   * @param {Object} callbacks Object with callback functions
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Object} thisArg
   * @chainable
   */
  fxStraighten: function(callbacks) {
    callbacks = callbacks || { };

    var empty = function() { },
        onComplete = callbacks.onComplete || empty,
        onChange = callbacks.onChange || empty,
        _this = this;

    fabric.util.animate({
      startValue: this.get('angle'),
      endValue: this._getAngleValueForStraighten(),
      duration: this.FX_DURATION,
      onChange: function(value) {
        _this.rotate(value);
        onChange();
      },
      onComplete: function() {
        _this.setCoords();
        onComplete();
      },
    });

    return this;
  }
});

fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {

  /**
   * Straightens object, then rerenders canvas
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  straightenObject: function (object) {
    object.straighten();
    this.requestRenderAll();
    return this;
  },

  /**
   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */
  fxStraightenObject: function (object) {
    object.fxStraighten({
      onChange: this.requestRenderAllBound
    });
    return this;
  }
});


(function() {

  'use strict';

  /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */
  function testPrecision(gl, precision){
    var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      return false;
    }
    return true;
  }

  /**
   * Indicate whether this filtering backend is supported by the user's browser.
   * @param {Number} tileSize check if the tileSize is supported
   * @returns {Boolean} Whether the user's browser supports WebGL.
   */
  fabric.isWebglSupported = function(tileSize) {
    if (fabric.isLikelyNode) {
      return false;
    }
    tileSize = tileSize || fabric.WebglFilterBackend.prototype.tileSize;
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    var isSupported = false;
    // eslint-disable-next-line
    if (gl) {
      fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
      isSupported = fabric.maxTextureSize >= tileSize;
      var precisions = ['highp', 'mediump', 'lowp'];
      for (var i = 0; i < 3; i++){
        if (testPrecision(gl, precisions[i])){
          fabric.webGlPrecision = precisions[i];
          break;
        };
      }
    }
    this.isSupported = isSupported;
    return isSupported;
  };

  fabric.WebglFilterBackend = WebglFilterBackend;

  /**
   * WebGL filter backend.
   */
  function WebglFilterBackend(options) {
    if (options && options.tileSize) {
      this.tileSize = options.tileSize;
    }
    this.setupGLContext(this.tileSize, this.tileSize);
    this.captureGPUInfo();
  };

  WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {

    tileSize: 2048,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you problably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {

    },

    /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */
    setupGLContext: function(width, height) {
      this.dispose();
      this.createWebGLCanvas(width, height);
      // eslint-disable-next-line
      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
      this.chooseFastestCopyGLTo2DMethod(width, height);
    },

    /**
     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
     * putImageData is faster than drawImage for that specific operation.
     */
    chooseFastestCopyGLTo2DMethod: function(width, height) {
      var canMeasurePerf = typeof window.performance !== 'undefined', canUseImageData;
      try {
        new ImageData(1, 1);
        canUseImageData = true;
      }
      catch (e) {
        canUseImageData = false;
      }
      // eslint-disable-next-line no-undef
      var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined';
      // eslint-disable-next-line no-undef
      var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';

      if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
        return;
      }

      var targetCanvas = fabric.util.createCanvasElement();
      // eslint-disable-next-line no-undef
      var imageBuffer = new ArrayBuffer(width * height * 4);
      if (fabric.forceGLPutImageData) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
        return;
      }
      var testContext = {
        imageBuffer: imageBuffer,
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
      };
      var startTime, drawImageTime, putImageDataTime;
      targetCanvas.width = width;
      targetCanvas.height = height;

      startTime = window.performance.now();
      copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
      drawImageTime = window.performance.now() - startTime;

      startTime = window.performance.now();
      copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
      putImageDataTime = window.performance.now() - startTime;

      if (drawImageTime > putImageDataTime) {
        this.imageBuffer = imageBuffer;
        this.copyGLTo2D = copyGLTo2DPutImageData;
      }
      else {
        this.copyGLTo2D = copyGLTo2DDrawImage;
      }
    },

    /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */
    createWebGLCanvas: function(width, height) {
      var canvas = fabric.util.createCanvasElement();
      canvas.width = width;
      canvas.height = height;
      var glOptions = {
            alpha: true,
            premultipliedAlpha: false,
            depth: false,
            stencil: false,
            antialias: false
          },
          gl = canvas.getContext('webgl', glOptions);
      if (!gl) {
        gl = canvas.getContext('experimental-webgl', glOptions);
      }
      if (!gl) {
        return;
      }
      gl.clearColor(0, 0, 0, 0);
      // this canvas can fire webglcontextlost and webglcontextrestored
      this.canvas = canvas;
      this.gl = gl;
    },

    /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */
    applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
      var gl = this.gl;
      var cachedTexture;
      if (cacheKey) {
        cachedTexture = this.getCachedTexture(cacheKey, source);
      }
      var pipelineState = {
        originalWidth: source.width || source.originalWidth,
        originalHeight: source.height || source.originalHeight,
        sourceWidth: width,
        sourceHeight: height,
        destinationWidth: width,
        destinationHeight: height,
        context: gl,
        sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
        targetTexture: this.createTexture(gl, width, height),
        originalTexture: cachedTexture ||
          this.createTexture(gl, width, height, !cachedTexture && source),
        passes: filters.length,
        webgl: true,
        aPosition: this.aPosition,
        programCache: this.programCache,
        pass: 0,
        filterBackend: this,
        targetCanvas: targetCanvas
      };
      var tempFbo = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
      filters.forEach(function(filter) { filter && filter.applyTo(pipelineState); });
      resizeCanvasIfNeeded(pipelineState);
      this.copyGLTo2D(gl, pipelineState);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.deleteTexture(pipelineState.sourceTexture);
      gl.deleteTexture(pipelineState.targetTexture);
      gl.deleteFramebuffer(tempFbo);
      targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
      return pipelineState;
    },

    /**
     * Detach event listeners, remove references, and clean up caches.
     */
    dispose: function() {
      if (this.canvas) {
        this.canvas = null;
        this.gl = null;
      }
      this.clearWebGLCaches();
    },

    /**
     * Wipe out WebGL-related caches.
     */
    clearWebGLCaches: function() {
      this.programCache = {};
      this.textureCache = {};
    },

    /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the textuer to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {Number} width The width to initialize the texture at.
     * @param {Number} height The height to initialize the texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
     * @returns {WebGLTexture}
     */
    createTexture: function(gl, width, height, textureImageSource) {
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      if (textureImageSource) {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
      }
      else {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      }
      return texture;
    },

    /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */
    getCachedTexture: function(uniqueId, textureImageSource) {
      if (this.textureCache[uniqueId]) {
        return this.textureCache[uniqueId];
      }
      else {
        var texture = this.createTexture(
          this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
        this.textureCache[uniqueId] = texture;
        return texture;
      }
    },

    /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */
    evictCachesForKey: function(cacheKey) {
      if (this.textureCache[cacheKey]) {
        this.gl.deleteTexture(this.textureCache[cacheKey]);
        delete this.textureCache[cacheKey];
      }
    },

    copyGLTo2D: copyGLTo2DDrawImage,

    /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */
    captureGPUInfo: function() {
      if (this.gpuInfo) {
        return this.gpuInfo;
      }
      var gl = this.gl, gpuInfo = { renderer: '', vendor: '' };
      if (!gl) {
        return gpuInfo;
      }
      var ext = gl.getExtension('WEBGL_debug_renderer_info');
      if (ext) {
        var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
        var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
        if (renderer) {
          gpuInfo.renderer = renderer.toLowerCase();
        }
        if (vendor) {
          gpuInfo.vendor = vendor.toLowerCase();
        }
      }
      this.gpuInfo = gpuInfo;
      return gpuInfo;
    },
  };
})();

function resizeCanvasIfNeeded(pipelineState) {
  var targetCanvas = pipelineState.targetCanvas,
      width = targetCanvas.width, height = targetCanvas.height,
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight;

  if (width !== dWidth || height !== dHeight) {
    targetCanvas.width = dWidth;
    targetCanvas.height = dHeight;
  }
}

/**
 * Copy an input WebGL canvas on to an output 2D canvas.
 *
 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
 * desired output image appearing in the bottom-left corner of the WebGL canvas.
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */
function copyGLTo2DDrawImage(gl, pipelineState) {
  var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas,
      ctx = targetCanvas.getContext('2d');
  ctx.translate(0, targetCanvas.height); // move it down again
  ctx.scale(1, -1); // vertical flip
  // where is my image on the big glcanvas?
  var sourceY = glCanvas.height - targetCanvas.height;
  ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0,
    targetCanvas.width, targetCanvas.height);
}

/**
 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */
function copyGLTo2DPutImageData(gl, pipelineState) {
  var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'),
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight,
      numBytes = dWidth * dHeight * 4;

  // eslint-disable-next-line no-undef
  var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
  // eslint-disable-next-line no-undef
  var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);

  gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
  var imgData = new ImageData(u8Clamped, dWidth, dHeight);
  ctx.putImageData(imgData, 0, 0);
}


(function() {

  'use strict';

  var noop = function() {};

  fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;

  /**
   * Canvas 2D filter backend.
   */
  function Canvas2dFilterBackend() {};

  Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
    evictCachesForKey: noop,
    dispose: noop,
    clearWebGLCaches: noop,

    /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/
    resources: {

    },

    /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */
    applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
      var ctx = targetCanvas.getContext('2d');
      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
      var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      var pipelineState = {
        sourceWidth: sourceWidth,
        sourceHeight: sourceHeight,
        imageData: imageData,
        originalEl: sourceElement,
        originalImageData: originalImageData,
        canvasEl: targetCanvas,
        ctx: ctx,
        filterBackend: this,
      };
      filters.forEach(function(filter) { filter.applyTo(pipelineState); });
      if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
        targetCanvas.width = pipelineState.imageData.width;
        targetCanvas.height = pipelineState.imageData.height;
      }
      ctx.putImageData(pipelineState.imageData, 0, 0);
      return pipelineState;
    },

  };
})();


/**
 * @namespace fabric.Image.filters
 * @memberOf fabric.Image
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 */
fabric.Image = fabric.Image || { };
fabric.Image.filters = fabric.Image.filters || { };

/**
 * Root filter class from which all filter classes inherit from
 * @class fabric.Image.filters.BaseFilter
 * @memberOf fabric.Image.filters
 */
fabric.Image.filters.BaseFilter = fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {

  /**
   * Filter type
   * @param {String} type
   * @default
   */
  type: 'BaseFilter',

  /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */

  vertexSource: 'attribute vec2 aPosition;\n' +
    'varying vec2 vTexCoord;\n' +
    'void main() {\n' +
      'vTexCoord = aPosition;\n' +
      'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
    '}',

  fragmentSource: 'precision highp float;\n' +
    'varying vec2 vTexCoord;\n' +
    'uniform sampler2D uTexture;\n' +
    'void main() {\n' +
      'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
    '}',

  /**
   * Constructor
   * @param {Object} [options] Options object
   */
  initialize: function(options) {
    if (options) {
      this.setOptions(options);
    }
  },

  /**
   * Sets filter's properties from options
   * @param {Object} [options] Options object
   */
  setOptions: function(options) {
    for (var prop in options) {
      this[prop] = options[prop];
    }
  },

  /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */
  createProgram: function(gl, fragmentSource, vertexSource) {
    fragmentSource = fragmentSource || this.fragmentSource;
    vertexSource = vertexSource || this.vertexSource;
    if (fabric.webGlPrecision !== 'highp'){
      fragmentSource = fragmentSource.replace(
        /precision highp float/g,
        'precision ' + fabric.webGlPrecision + ' float'
      );
    }
    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(vertexShader, vertexSource);
    gl.compileShader(vertexShader);
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Vertex shader compile error for ' + this.type + ': ' +
        gl.getShaderInfoLog(vertexShader)
      );
    }

    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(fragmentShader, fragmentSource);
    gl.compileShader(fragmentShader);
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Fragment shader compile error for ' + this.type + ': ' +
        gl.getShaderInfoLog(fragmentShader)
      );
    }

    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      throw new Error(
        // eslint-disable-next-line prefer-template
        'Shader link error for "${this.type}" ' +
        gl.getProgramInfoLog(program)
      );
    }

    var attributeLocations = this.getAttributeLocations(gl, program);
    var uniformLocations = this.getUniformLocations(gl, program) || { };
    uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
    uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
    return {
      program: program,
      attributeLocations: attributeLocations,
      uniformLocations: uniformLocations
    };
  },

  /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */
  getAttributeLocations: function(gl, program) {
    return {
      aPosition: gl.getAttribLocation(program, 'aPosition'),
    };
  },

  /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */
  getUniformLocations: function (/* gl, program */) {
    // in case i do not need any special uniform i need to return an empty object
    return { };
  },

  /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */
  sendAttributeData: function(gl, attributeLocations, aPositionData) {
    var attributeLocation = attributeLocations.aPosition;
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.enableVertexAttribArray(attributeLocation);
    gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
    gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
  },

  _setupFrameBuffer: function(options) {
    var gl = options.context, width, height;
    if (options.passes > 1) {
      width = options.destinationWidth;
      height = options.destinationHeight;
      if (options.sourceWidth !== width || options.sourceHeight !== height) {
        gl.deleteTexture(options.targetTexture);
        options.targetTexture = options.filterBackend.createTexture(gl, width, height);
      }
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D,
        options.targetTexture, 0);
    }
    else {
      // draw last filter on canvas and not to framebuffer.
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.finish();
    }
  },

  _swapTextures: function(options) {
    options.passes--;
    options.pass++;
    var temp = options.targetTexture;
    options.targetTexture = options.sourceTexture;
    options.sourceTexture = temp;
  },

  /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own verison ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/
  isNeutralState: function(/* options */) {
    var main = this.mainParameter,
        _class = fabric.Image.filters[this.type].prototype;
    if (main) {
      if (Array.isArray(_class[main])) {
        for (var i = _class[main].length; i--;) {
          if (this[main][i] !== _class[main][i]) {
            return false;
          }
        }
        return true;
      }
      else {
        return _class[main] === this[main];
      }
    }
    else {
      return false;
    }
  },

  /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyTo: function(options) {
    if (options.webgl) {
      this._setupFrameBuffer(options);
      this.applyToWebGL(options);
      this._swapTextures(options);
    }
    else {
      this.applyTo2d(options);
    }
  },

  /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  retrieveShader: function(options) {
    if (!options.programCache.hasOwnProperty(this.type)) {
      options.programCache[this.type] = this.createProgram(options.context);
    }
    return options.programCache[this.type];
  },

  /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */
  applyToWebGL: function(options) {
    var gl = options.context;
    var shader = this.retrieveShader(options);
    if (options.pass === 0 && options.originalTexture) {
      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
    }
    else {
      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
    }
    gl.useProgram(shader.program);
    this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);

    gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
    gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);

    this.sendUniformData(gl, shader.uniformLocations);
    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  },

  bindAdditionalTexture: function(gl, texture, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // reset active texture to 0 as usual
    gl.activeTexture(gl.TEXTURE0);
  },

  unbindAdditionalTexture: function(gl, textureUnit) {
    gl.activeTexture(textureUnit);
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.activeTexture(gl.TEXTURE0);
  },

  getMainParameter: function() {
    return this[this.mainParameter];
  },

  setMainParameter: function(value) {
    this[this.mainParameter] = value;
  },

  /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */
  sendUniformData: function(/* gl, uniformLocations */) {
    // Intentionally left blank.  Override me in subclasses.
  },

  /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */
  createHelpLayer: function(options) {
    if (!options.helpLayer) {
      var helpLayer = document.createElement('canvas');
      helpLayer.width = options.sourceWidth;
      helpLayer.height = options.sourceHeight;
      options.helpLayer = helpLayer;
    }
  },

  /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */
  toObject: function() {
    var object = { type: this.type }, mainP = this.mainParameter;
    if (mainP) {
      object[mainP] = this[mainP];
    }
    return object;
  },

  /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */
  toJSON: function() {
    // delegate, not alias
    return this.toObject();
  }
});

fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
  var filter = new fabric.Image.filters[object.type](object);
  callback && callback(filter);
  return filter;
};


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Color Matrix filter class
   * @class fabric.Image.filters.ColorMatrix
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
   * @example <caption>Kodachrome filter</caption>
   * var filter = new fabric.Image.filters.ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'ColorMatrix',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'varying vec2 vTexCoord;\n' +
      'uniform mat4 uColorMatrix;\n' +
      'uniform vec4 uConstants;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color *= uColorMatrix;\n' +
        'color += uConstants;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Colormatrix for pixels.
     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
     * outside the -1, 1 range.
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Array} matrix array of 20 numbers.
     * @default
     */
    matrix: [
      1, 0, 0, 0, 0,
      0, 1, 0, 0, 0,
      0, 0, 1, 0, 0,
      0, 0, 0, 1, 0
    ],

    mainParameter: 'matrix',

    /**
     * Lock the colormatrix on the color part, skipping alpha, manly for non webgl scenario
     * to save some calculation
     */
    colorsOnly: true,

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      // create a new array instead mutating the prototype with push
      this.matrix = this.matrix.slice(0);
    },

    /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = data.length,
          m = this.matrix,
          r, g, b, a, i, colorsOnly = this.colorsOnly;

      for (i = 0; i < iLen; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        if (colorsOnly) {
          data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
        }
        else {
          a = data[i + 3];
          data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
        uConstants: gl.getUniformLocation(program, 'uConstants'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var m = this.matrix,
          matrix = [
            m[0], m[1], m[2], m[3],
            m[5], m[6], m[7], m[8],
            m[10], m[11], m[12], m[13],
            m[15], m[16], m[17], m[18]
          ],
          constants = [m[4], m[9], m[14], m[19]];
      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
      gl.uniform4fv(uniformLocations.uConstants, constants);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] function to invoke after filter creation
   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
   */
  fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Brightness filter class
   * @class fabric.Image.filters.Brightness
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Brightness',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uBrightness;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color.rgb += uBrightness;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Brightness value, from -1 to 1.
     * translated to -255 to 255 for 2d
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Number} brightness
     * @default
     */
    brightness: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'brightness',

    /**
    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
    *
    * @param {Object} options
    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
    */
    applyTo2d: function(options) {
      if (this.brightness === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, i, len = data.length,
          brightness = Math.round(this.brightness * 255);
      for (i = 0; i < len; i += 4) {
        data[i] = data[i] + brightness;
        data[i + 1] = data[i + 1] + brightness;
        data[i + 2] = data[i + 2] + brightness;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uBrightness: gl.getUniformLocation(program, 'uBrightness'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
   */
  fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @class fabric.Image.filters.Convolute
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example <caption>Sharpen filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Convolute',

    /*
     * Opaque value (true/false)
     */
    opaque: false,

    /*
     * matrix for the filter, max 9x9
     */
    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: {
      Convolute_3_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[9];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_3_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[9];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_5_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[25];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_5_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[25];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_7_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[49];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_7_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[49];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
      Convolute_9_1: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[81];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 0);\n' +
          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'gl_FragColor = color;\n' +
        '}',
      Convolute_9_0: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform float uMatrix[81];\n' +
        'uniform float uStepW;\n' +
        'uniform float uStepH;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = vec4(0, 0, 0, 1);\n' +
          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n' +
            '}\n' +
          '}\n' +
          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
          'gl_FragColor = color;\n' +
          'gl_FragColor.a = alpha;\n' +
        '}',
    },

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Convolute.prototype
     * @param {Object} [options] Options object
     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
     * @param {Array} [options.matrix] Filter matrix
     */


    /**
    * Retrieves the cached shader.
    * @param {Object} options
    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
    */
    retrieveShader: function(options) {
      var size = Math.sqrt(this.matrix.length);
      var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
      var shaderSource = this.fragmentSource[cacheKey];
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          weights = this.matrix,
          side = Math.round(Math.sqrt(weights.length)),
          halfSide = Math.floor(side / 2),
          sw = imageData.width,
          sh = imageData.height,
          output = options.ctx.createImageData(sw, sh),
          dst = output.data,
          // go through the destination image pixels
          alphaFac = this.opaque ? 1 : 0,
          r, g, b, a, dstOff,
          scx, scy, srcOff, wt,
          x, y, cx, cy;

      for (y = 0; y < sh; y++) {
        for (x = 0; x < sw; x++) {
          dstOff = (y * sw + x) * 4;
          // calculate the weighed sum of the source image pixels that
          // fall under the convolution matrix
          r = 0; g = 0; b = 0; a = 0;

          for (cy = 0; cy < side; cy++) {
            for (cx = 0; cx < side; cx++) {
              scy = y + cy - halfSide;
              scx = x + cx - halfSide;

              // eslint-disable-next-line max-depth
              if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
                continue;
              }

              srcOff = (scy * sw + scx) * 4;
              wt = weights[cy * side + cx];

              r += data[srcOff] * wt;
              g += data[srcOff + 1] * wt;
              b += data[srcOff + 2] * wt;
              // eslint-disable-next-line max-depth
              if (!alphaFac) {
                a += data[srcOff + 3] * wt;
              }
            }
          }
          dst[dstOff] = r;
          dst[dstOff + 1] = g;
          dst[dstOff + 2] = b;
          if (!alphaFac) {
            dst[dstOff + 3] = a;
          }
          else {
            dst[dstOff + 3] = data[dstOff + 3];
          }
        }
      }
      options.imageData = output;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uMatrix: gl.getUniformLocation(program, 'uMatrix'),
        uOpaque: gl.getUniformLocation(program, 'uOpaque'),
        uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
        uSize: gl.getUniformLocation(program, 'uSize'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        opaque: this.opaque,
        matrix: this.matrix
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
   */
  fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Grayscale image filter class
   * @class fabric.Image.filters.Grayscale
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Grayscale',

    fragmentSource: {
      average: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'float average = (color.r + color.b + color.g) / 3.0;\n' +
          'gl_FragColor = vec4(average, average, average, color.a);\n' +
        '}',
      lightness: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform int uMode;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
          'float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n' +
          'gl_FragColor = vec4(average, average, average, col.a);\n' +
        '}',
      luminosity: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform int uMode;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
          'float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n' +
          'gl_FragColor = vec4(average, average, average, col.a);\n' +
        '}',
    },


    /**
     * Grayscale mode, between 'average', 'lightness', 'luminosity'
     * @param {String} type
     * @default
     */
    mode: 'average',

    mainParameter: 'mode',

    /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          len = data.length, value,
          mode = this.mode;
      for (i = 0; i < len; i += 4) {
        if (mode === 'average') {
          value = (data[i] + data[i + 1] + data[i + 2]) / 3;
        }
        else if (mode === 'lightness') {
          value = (Math.min(data[i], data[i + 1], data[i + 2]) +
            Math.max(data[i], data[i + 1], data[i + 2])) / 2;
        }
        else if (mode === 'luminosity') {
          value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
        }
        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
      }
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var shaderSource = this.fragmentSource[this.mode];
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uMode: gl.getUniformLocation(program, 'uMode'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      // default average mode.
      var mode = 1;
      gl.uniform1i(uniformLocations.uMode, mode);
    },

    /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/
    isNeutralState: function() {
      return false;
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
   */
  fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Invert filter class
   * @class fabric.Image.filters.Invert
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Invert',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform int uInvert;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'if (uInvert == 1) {\n' +
          'gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n' +
        '} else {\n' +
          'gl_FragColor = color;\n' +
        '}\n' +
      '}',

    /**
     * Filter invert. if false, does nothing
     * @param {Boolean} invert
     * @default
     */
    invert: true,

    mainParameter: 'invert',

    /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          len = data.length;
      for (i = 0; i < len; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
      }
    },

    /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function() {
      return !this.invert;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uInvert: gl.getUniformLocation(program, 'uInvert'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1i(uniformLocations.uInvert, this.invert);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
   */
  fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;


})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Noise filter class
   * @class fabric.Image.filters.Noise
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Noise',

    /**
     * Fragment source for the noise program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uStepH;\n' +
      'uniform float uNoise;\n' +
      'uniform float uSeed;\n' +
      'varying vec2 vTexCoord;\n' +
      'float rand(vec2 co, float seed, float vScale) {\n' +
        'return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n' +
      '}\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'noise',

    /**
     * Noise value, from
     * @param {Number} noise
     * @default
     */
    noise: 0,

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      if (this.noise === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, i, len = data.length,
          noise = this.noise, rand;

      for (i = 0, len = data.length; i < len; i += 4) {

        rand = (0.5 - Math.random()) * noise;

        data[i] += rand;
        data[i + 1] += rand;
        data[i + 2] += rand;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uNoise: gl.getUniformLocation(program, 'uNoise'),
        uSeed: gl.getUniformLocation(program, 'uSeed'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
      gl.uniform1f(uniformLocations.uSeed, Math.random());
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        noise: this.noise
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
   */
  fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Pixelate filter class
   * @class fabric.Image.filters.Pixelate
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Pixelate',

    blocksize: 4,

    mainParameter: 'blocksize',

    /**
     * Fragment source for the Pixelate program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uBlocksize;\n' +
      'uniform float uStepW;\n' +
      'uniform float uStepH;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'float blockW = uBlocksize * uStepW;\n' +
        'float blockH = uBlocksize * uStepW;\n' +
        'int posX = int(vTexCoord.x / blockW);\n' +
        'int posY = int(vTexCoord.y / blockH);\n' +
        'float fposX = float(posX);\n' +
        'float fposY = float(posY);\n' +
        'vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n' +
        'vec4 color = texture2D(uTexture, squareCoords);\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data,
          iLen = imageData.height,
          jLen = imageData.width,
          index, i, j, r, g, b, a,
          _i, _j, _iLen, _jLen;

      for (i = 0; i < iLen; i += this.blocksize) {
        for (j = 0; j < jLen; j += this.blocksize) {

          index = (i * 4) * jLen + (j * 4);

          r = data[index];
          g = data[index + 1];
          b = data[index + 2];
          a = data[index + 3];

          _iLen = Math.min(i + this.blocksize, iLen);
          _jLen = Math.min(j + this.blocksize, jLen);
          for (_i = i; _i < _iLen; _i++) {
            for (_j = j; _j < _jLen; _j++) {
              index = (_i * 4) * jLen + (_j * 4);
              data[index] = r;
              data[index + 1] = g;
              data[index + 2] = b;
              data[index + 3] = a;
            }
          }
        }
      }
    },

    /**
     * Indicate when the filter is not gonna apply changes to the image
     **/
    isNeutralState: function() {
      return this.blocksize === 1;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
        uStepW: gl.getUniformLocation(program, 'uStepW'),
        uStepH: gl.getUniformLocation(program, 'uStepH'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
   */
  fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      extend = fabric.util.object.extend,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Remove white filter class
   * @class fabric.Image.filters.RemoveColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'RemoveColor',

    /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */
    color: '#FFFFFF',

    /**
     * Fragment source for the brightness program
     */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec4 uLow;\n' +
      'uniform vec4 uHigh;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
        'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' +
          'gl_FragColor.a = 0.0;\n' +
        '}\n' +
      '}',

    /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/
    distance: 0.02,

    /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/
    useAlpha: false,

    /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */

    /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, i,
          distance = this.distance * 255,
          r, g, b,
          source = new fabric.Color(this.color).getSource(),
          lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance,
          ],
          highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance,
          ];


      for (i = 0; i < data.length; i += 4) {
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        if (r > lowC[0] &&
            g > lowC[1] &&
            b > lowC[2] &&
            r < highC[0] &&
            g < highC[1] &&
            b < highC[2]) {
          data[i + 3] = 0;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uLow: gl.getUniformLocation(program, 'uLow'),
        uHigh: gl.getUniformLocation(program, 'uHigh'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource(),
          distance = parseFloat(this.distance),
          lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
          ],
          highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
          ];
      gl.uniform4fv(uniformLocations.uLow, lowC);
      gl.uniform4fv(uniformLocations.uHigh, highC);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return extend(this.callSuper('toObject'), {
        color: this.color,
        distance: this.distance
      });
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
   */
  fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  var matrices = {
    Brownie: [
      0.59970,0.34553,-0.27082,0,0.186,
      -0.03770,0.86095,0.15059,0,-0.1449,
      0.24113,-0.07441,0.44972,0,-0.02965,
      0,0,0,1,0
    ],
    Vintage: [
      0.62793,0.32021,-0.03965,0,0.03784,
      0.02578,0.64411,0.03259,0,0.02926,
      0.04660,-0.08512,0.52416,0,0.02023,
      0,0,0,1,0
    ],
    Kodachrome: [
      1.12855,-0.39673,-0.03992,0,0.24991,
      -0.16404,1.08352,-0.05498,0,0.09698,
      -0.16786,-0.56034,1.60148,0,0.13972,
      0,0,0,1,0
    ],
    Technicolor: [
      1.91252,-0.85453,-0.09155,0,0.04624,
      -0.30878,1.76589,-0.10601,0,-0.27589,
      -0.23110,-0.75018,1.84759,0,0.12137,
      0,0,0,1,0
    ],
    Polaroid: [
      1.438,-0.062,-0.062,0,0,
      -0.122,1.378,-0.122,0,0,
      -0.016,-0.016,1.483,0,0,
      0,0,0,1,0
    ],
    Sepia: [
      0.393, 0.769, 0.189, 0, 0,
      0.349, 0.686, 0.168, 0, 0,
      0.272, 0.534, 0.131, 0, 0,
      0, 0, 0, 1, 0
    ],
    BlackWhite: [
      1.5, 1.5, 1.5, 0, -1,
      1.5, 1.5, 1.5, 0, -1,
      1.5, 1.5, 1.5, 0, -1,
      0, 0, 0, 1, 0,
    ]
  };

  for (var key in matrices) {
    filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {

      /**
       * Filter type
       * @param {String} type
       * @default
       */
      type: key,

      /**
       * Colormatrix for the effect
       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
       * outside the -1, 1 range.
       * @param {Array} matrix array of 20 numbers.
       * @default
       */
      matrix: matrices[key],

      /**
       * Lock the matrix export for this kind of static, parameter less filters.
       */
      mainParameter: false,
      /**
       * Lock the colormatrix on the color part, skipping alpha
       */
      colorsOnly: true,

    });
    fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
  }
})( true ? exports : this);


(function(global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Color Blend filter class
   * @class fabric.Image.filter.BlendColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
    type: 'BlendColor',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    color: '#F95C63',

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend color operation.
     **/
    alpha: 1,

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
      screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
      add: 'gl_FragColor.rgb += uColor.rgb;\n',
      diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
      subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
      lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
      darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
      exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
      overlay: 'if (uColor.r < 0.5) {\n' +
          'gl_FragColor.r *= 2.0 * uColor.r;\n' +
        '} else {\n' +
          'gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n' +
        '}\n' +
        'if (uColor.g < 0.5) {\n' +
          'gl_FragColor.g *= 2.0 * uColor.g;\n' +
        '} else {\n' +
          'gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n' +
        '}\n' +
        'if (uColor.b < 0.5) {\n' +
          'gl_FragColor.b *= 2.0 * uColor.b;\n' +
        '} else {\n' +
          'gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n' +
        '}\n',
      tint: 'gl_FragColor.rgb *= (1.0 - uColor.a);\n' +
        'gl_FragColor.rgb += uColor.rgb;\n',
    },

    /**
     * build the fragment source for the filters, joining the common part with
     * the specific one.
     * @param {String} mode the mode of the filter, a key of this.fragmentSource
     * @return {String} the source to be compiled
     * @private
     */
    buildSource: function(mode) {
      return 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'gl_FragColor = color;\n' +
          'if (color.a > 0.0) {\n' +
            this.fragmentSource[mode] +
          '}\n' +
        '}';
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode, shaderSource;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        shaderSource = this.buildSource(this.mode);
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          data = imageData.data, iLen = data.length,
          tr, tg, tb,
          r, g, b,
          source, alpha1 = 1 - this.alpha;

      source = new fabric.Color(this.color).getSource();
      tr = source[0] * this.alpha;
      tg = source[1] * this.alpha;
      tb = source[2] * this.alpha;

      for (var i = 0; i < iLen; i += 4) {

        r = data[i];
        g = data[i + 1];
        b = data[i + 2];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            break;
          case 'screen':
            data[i] = 255 - (255 - r) * (255 - tr) / 255;
            data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
            data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
            break;
          case 'add':
            data[i] = r + tr;
            data[i + 1] = g + tg;
            data[i + 2] = b + tb;
            break;
          case 'diff':
          case 'difference':
            data[i] = Math.abs(r - tr);
            data[i + 1] = Math.abs(g - tg);
            data[i + 2] = Math.abs(b - tb);
            break;
          case 'subtract':
            data[i] = r - tr;
            data[i + 1] = g - tg;
            data[i + 2] = b - tb;
            break;
          case 'darken':
            data[i] = Math.min(r, tr);
            data[i + 1] = Math.min(g, tg);
            data[i + 2] = Math.min(b, tb);
            break;
          case 'lighten':
            data[i] = Math.max(r, tr);
            data[i + 1] = Math.max(g, tg);
            data[i + 2] = Math.max(b, tb);
            break;
          case 'overlay':
            data[i] = tr < 128 ? (2 * r * tr / 255) : (255 - 2 * (255 - r) * (255 - tr) / 255);
            data[i + 1] = tg < 128 ? (2 * g * tg / 255) : (255 - 2 * (255 - g) * (255 - tg) / 255);
            data[i + 2] = tb < 128 ? (2 * b * tb / 255) : (255 - 2 * (255 - b) * (255 - tb) / 255);
            break;
          case 'exclusion':
            data[i] = tr + r - ((2 * tr * r) / 255);
            data[i + 1] = tg + g - ((2 * tg * g) / 255);
            data[i + 2] = tb + b - ((2 * tb * b) / 255);
            break;
          case 'tint':
            data[i] = tr + r * alpha1;
            data[i + 1] = tg + g * alpha1;
            data[i + 2] = tb + b * alpha1;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uColor: gl.getUniformLocation(program, 'uColor'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var source = new fabric.Color(this.color).getSource();
      source[0] = this.alpha * source[0] / 255;
      source[1] = this.alpha * source[1] / 255;
      source[2] = this.alpha * source[2] / 255;
      source[3] = this.alpha;
      gl.uniform4fv(uniformLocations.uColor, source);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        color: this.color,
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
   */
  fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {
  'use strict';

  var fabric = global.fabric,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Image Blend filter class
   * @class fabric.Image.filter.BlendImage
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */

  filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
    type: 'BlendImage',

    /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/
    image: null,

    /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     **/
    mode: 'multiply',

    /**
     * alpha value. represent the strength of the blend image operation.
     * not implemented.
     **/
    alpha: 1,

    vertexSource: 'attribute vec2 aPosition;\n' +
      'varying vec2 vTexCoord;\n' +
      'varying vec2 vTexCoord2;\n' +
      'uniform mat3 uTransformMatrix;\n' +
      'void main() {\n' +
        'vTexCoord = aPosition;\n' +
        'vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n' +
        'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
      '}',

    /**
     * Fragment source for the Multiply program
     */
    fragmentSource: {
      multiply: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform sampler2D uImage;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'varying vec2 vTexCoord2;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
          'color.rgba *= color2.rgba;\n' +
          'gl_FragColor = color;\n' +
        '}',
      mask: 'precision highp float;\n' +
        'uniform sampler2D uTexture;\n' +
        'uniform sampler2D uImage;\n' +
        'uniform vec4 uColor;\n' +
        'varying vec2 vTexCoord;\n' +
        'varying vec2 vTexCoord2;\n' +
        'void main() {\n' +
          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
          'color.a = color2.a;\n' +
          'gl_FragColor = color;\n' +
        '}',
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var cacheKey = this.type + '_' + this.mode;
      var shaderSource = this.fragmentSource[this.mode];
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
      }
      return options.programCache[cacheKey];
    },

    applyToWebGL: function(options) {
      // load texture to blend.
      var gl = options.context,
          texture = this.createTexture(options.filterBackend, this.image);
      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
      this.callSuper('applyToWebGL', options);
      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    },

    createTexture: function(backend, image) {
      return backend.getCachedTexture(image.cacheKey, image._element);
    },

    /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    calculateMatrix: function() {
      var image = this.image,
          width = image._element.width,
          height = image._element.height;
      return [
        1 / image.scaleX, 0, 0,
        0, 1 / image.scaleY, 0,
        -image.left / width, -image.top / height, 1
      ];
    },

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          resources = options.filterBackend.resources,
          data = imageData.data, iLen = data.length,
          width = imageData.width,
          height = imageData.height,
          tr, tg, tb, ta,
          r, g, b, a,
          canvas1, context, image = this.image, blendData;

      if (!resources.blendImage) {
        resources.blendImage = fabric.util.createCanvasElement();
      }
      canvas1 = resources.blendImage;
      context = canvas1.getContext('2d');
      if (canvas1.width !== width || canvas1.height !== height) {
        canvas1.width = width;
        canvas1.height = height;
      }
      else {
        context.clearRect(0, 0, width, height);
      }
      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
      context.drawImage(image._element, 0, 0, width, height);
      blendData = context.getImageData(0, 0, width, height).data;
      for (var i = 0; i < iLen; i += 4) {

        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];

        tr = blendData[i];
        tg = blendData[i + 1];
        tb = blendData[i + 2];
        ta = blendData[i + 3];

        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            data[i + 3] = a * ta / 255;
            break;
          case 'mask':
            data[i + 3] = ta;
            break;
        }
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
        uImage: gl.getUniformLocation(program, 'uImage'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var matrix = this.calculateMatrix();
      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        image: this.image && this.image.toObject(),
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} callback to be invoked after filter creation
   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
   */
  fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
    fabric.Image.fromObject(object.image, function(image) {
      var options = fabric.util.object.clone(object);
      options.image = image;
      callback(new fabric.Image.filters.BlendImage(options));
    });
  };

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }), pow = Math.pow, floor = Math.floor,
      sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin,
      ceil = Math.ceil,
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Resize image filter class
   * @class fabric.Image.filters.Resize
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Resize',

    /**
     * Resize type
     * for webgl resizeType is just lanczos, for canvas2d can be:
     * bilinear, hermite, sliceHack, lanczos.
     * @param {String} resizeType
     * @default
     */
    resizeType: 'hermite',

    /**
     * Scale factor for resizing, x axis
     * @param {Number} scaleX
     * @default
     */
    scaleX: 1,

    /**
     * Scale factor for resizing, y axis
     * @param {Number} scaleY
     * @default
     */
    scaleY: 1,

    /**
     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
     * @param {Number} lanczosLobes
     * @default
     */
    lanczosLobes: 3,


    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uDelta: gl.getUniformLocation(program, 'uDelta'),
        uTaps: gl.getUniformLocation(program, 'uTaps'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
      gl.uniform1fv(uniformLocations.uTaps, this.taps);
    },

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    retrieveShader: function(options) {
      var filterWindow = this.getFilterWindow(), cacheKey = this.type + '_' + filterWindow;
      if (!options.programCache.hasOwnProperty(cacheKey)) {
        var fragmentShader = this.generateShader(filterWindow);
        options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
      }
      return options.programCache[cacheKey];
    },

    getFilterWindow: function() {
      var scale = this.tempScale;
      return Math.ceil(this.lanczosLobes / scale);
    },

    getTaps: function() {
      var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale,
          filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
      for (var i = 1; i <= filterWindow; i++) {
        taps[i - 1] = lobeFunction(i * scale);
      }
      return taps;
    },

    /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */
    generateShader: function(filterWindow) {
      var offsets = new Array(filterWindow),
          fragmentShader = this.fragmentSourceTOP, filterWindow;

      for (var i = 1; i <= filterWindow; i++) {
        offsets[i - 1] = i + '.0 * uDelta';
      }

      fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
      fragmentShader += 'void main() {\n';
      fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
      fragmentShader += '  float sum = 1.0;\n';

      offsets.forEach(function(offset, i) {
        fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
        fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
      });
      fragmentShader += '  gl_FragColor = color / sum;\n';
      fragmentShader += '}';
      return fragmentShader;
    },

    fragmentSourceTOP: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec2 uDelta;\n' +
      'varying vec2 vTexCoord;\n',

    /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function(options) {
      if (options.webgl) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;
        this._setupFrameBuffer(options);
        this.applyToWebGL(options);
        this._swapTextures(options);
        options.sourceWidth = options.destinationWidth;

        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;
        this._setupFrameBuffer(options);
        this.applyToWebGL(options);
        this._swapTextures(options);
        options.sourceHeight = options.destinationHeight;
      }
      else {
        this.applyTo2d(options);
      }
    },

    isNeutralState: function() {
      return this.scaleX === 1 && this.scaleY === 1;
    },

    lanczosCreate: function(lobes) {
      return function(x) {
        if (x >= lobes || x <= -lobes) {
          return 0.0;
        }
        if (x < 1.19209290E-07 && x > -1.19209290E-07) {
          return 1.0;
        }
        x *= Math.PI;
        var xx = x / lobes;
        return (sin(x) / x) * sin(xx) / xx;
      };
    },

    /**
     * Applies filter to canvas element
     * @memberOf fabric.Image.filters.Resize.prototype
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} scaleX
     * @param {Number} scaleY
     */
    applyTo2d: function(options) {
      var imageData = options.imageData,
          scaleX = this.scaleX,
          scaleY = this.scaleY;

      this.rcpScaleX = 1 / scaleX;
      this.rcpScaleY = 1 / scaleY;

      var oW = imageData.width, oH = imageData.height,
          dW = round(oW * scaleX), dH = round(oH * scaleY),
          newData;

      if (this.resizeType === 'sliceHack') {
        newData = this.sliceByTwo(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'hermite') {
        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'bilinear') {
        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
      }
      else if (this.resizeType === 'lanczos') {
        newData = this.lanczosResize(options, oW, oH, dW, dH);
      }
      options.imageData = newData;
    },

    /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    sliceByTwo: function(options, oW, oH, dW, dH) {
      var imageData = options.imageData,
          mult = 0.5, doneW = false, doneH = false, stepW = oW * mult,
          stepH = oH * mult, resources = fabric.filterBackend.resources,
          tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
      if (!resources.sliceByTwo) {
        resources.sliceByTwo = document.createElement('canvas');
      }
      tmpCanvas = resources.sliceByTwo;
      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
        tmpCanvas.width = oW * 1.5;
        tmpCanvas.height = oH;
      }
      ctx = tmpCanvas.getContext('2d');
      ctx.clearRect(0, 0, oW * 1.5, oH);
      ctx.putImageData(imageData, 0, 0);

      dW = floor(dW);
      dH = floor(dH);

      while (!doneW || !doneH) {
        oW = stepW;
        oH = stepH;
        if (dW < floor(stepW * mult)) {
          stepW = floor(stepW * mult);
        }
        else {
          stepW = dW;
          doneW = true;
        }
        if (dH < floor(stepH * mult)) {
          stepH = floor(stepH * mult);
        }
        else {
          stepH = dH;
          doneH = true;
        }
        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
        sX = dX;
        sY = dY;
        dY += stepH;
      }
      return ctx.getImageData(sX, sY, dW, dH);
    },

    /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    lanczosResize: function(options, oW, oH, dW, dH) {

      function process(u) {
        var v, i, weight, idx, a, red, green,
            blue, alpha, fX, fY;
        center.x = (u + 0.5) * ratioX;
        icenter.x = floor(center.x);
        for (v = 0; v < dH; v++) {
          center.y = (v + 0.5) * ratioY;
          icenter.y = floor(center.y);
          a = 0; red = 0; green = 0; blue = 0; alpha = 0;
          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
            if (i < 0 || i >= oW) {
              continue;
            }
            fX = floor(1000 * abs(i - center.x));
            if (!cacheLanc[fX]) {
              cacheLanc[fX] = { };
            }
            for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
              if (j < 0 || j >= oH) {
                continue;
              }
              fY = floor(1000 * abs(j - center.y));
              if (!cacheLanc[fX][fY]) {
                cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
              }
              weight = cacheLanc[fX][fY];
              if (weight > 0) {
                idx = (j * oW + i) * 4;
                a += weight;
                red += weight * srcData[idx];
                green += weight * srcData[idx + 1];
                blue += weight * srcData[idx + 2];
                alpha += weight * srcData[idx + 3];
              }
            }
          }
          idx = (v * dW + u) * 4;
          destData[idx] = red / a;
          destData[idx + 1] = green / a;
          destData[idx + 2] = blue / a;
          destData[idx + 3] = alpha / a;
        }

        if (++u < dW) {
          return process(u);
        }
        else {
          return destImg;
        }
      }

      var srcData = options.imageData.data,
          destImg = options.ctx.createImageData(dW, dH),
          destData = destImg.data,
          lanczos = this.lanczosCreate(this.lanczosLobes),
          ratioX = this.rcpScaleX, ratioY = this.rcpScaleY,
          rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY,
          range2X = ceil(ratioX * this.lanczosLobes / 2),
          range2Y = ceil(ratioY * this.lanczosLobes / 2),
          cacheLanc = { }, center = { }, icenter = { };

      return process(0);
    },

    /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    bilinearFiltering: function(options, oW, oH, dW, dH) {
      var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl,
          color, offset = 0, origPix, ratioX = this.rcpScaleX,
          ratioY = this.rcpScaleY,
          w4 = 4 * (oW - 1), img = options.imageData,
          pixels = img.data, destImage = options.ctx.createImageData(dW, dH),
          destPixels = destImage.data;
      for (i = 0; i < dH; i++) {
        for (j = 0; j < dW; j++) {
          x = floor(ratioX * j);
          y = floor(ratioY * i);
          xDiff = ratioX * j - x;
          yDiff = ratioY * i - y;
          origPix = 4 * (y * oW + x);

          for (chnl = 0; chnl < 4; chnl++) {
            a = pixels[origPix + chnl];
            b = pixels[origPix + 4 + chnl];
            c = pixels[origPix + w4 + chnl];
            d = pixels[origPix + w4 + 4 + chnl];
            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) +
                    c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
            destPixels[offset++] = color;
          }
        }
      }
      return destImage;
    },

    /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    hermiteFastResize: function(options, oW, oH, dW, dH) {
      var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY,
          ratioWHalf = ceil(ratioW / 2),
          ratioHHalf = ceil(ratioH / 2),
          img = options.imageData, data = img.data,
          img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
      for (var j = 0; j < dH; j++) {
        for (var i = 0; i < dW; i++) {
          var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0,
              gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
          for (var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
            var dy = abs(centerY - (yy + 0.5)) / ratioHHalf,
                centerX = (i + 0.5) * ratioW, w0 = dy * dy;
            for (var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
              var dx = abs(centerX - (xx + 0.5)) / ratioWHalf,
                  w = sqrt(w0 + dx * dx);
              /* eslint-disable max-depth */
              if (w > 1 && w < -1) {
                continue;
              }
              //hermite filter
              weight = 2 * w * w * w - 3 * w * w + 1;
              if (weight > 0) {
                dx = 4 * (xx + yy * oW);
                //alpha
                gxA += weight * data[dx + 3];
                weightsAlpha += weight;
                //colors
                if (data[dx + 3] < 255) {
                  weight = weight * data[dx + 3] / 250;
                }
                gxR += weight * data[dx];
                gxG += weight * data[dx + 1];
                gxB += weight * data[dx + 2];
                weights += weight;
              }
              /* eslint-enable max-depth */
            }
          }
          data2[x2] = gxR / weights;
          data2[x2 + 1] = gxG / weights;
          data2[x2 + 2] = gxB / weights;
          data2[x2 + 3] = gxA / weightsAlpha;
        }
      }
      return img2;
    },

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject: function() {
      return {
        type: this.type,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        resizeType: this.resizeType,
        lanczosLobes: this.lanczosLobes
      };
    }
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
   */
  fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Contrast filter class
   * @class fabric.Image.filters.Contrast
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Contrast',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uContrast;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n' +
        'color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n' +
        'gl_FragColor = color;\n' +
      '}',

    /**
     * contrast value, range from -1 to 1.
     * @param {Number} contrast
     * @default 0
     */
    contrast: 0,

    mainParameter: 'contrast',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Contrast.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
     */

    /**
      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
      *
      * @param {Object} options
      * @param {ImageData} options.imageData The Uint8Array to be filtered.
      */
    applyTo2d: function(options) {
      if (this.contrast === 0) {
        return;
      }
      var imageData = options.imageData, i, len,
          data = imageData.data, len = data.length,
          contrast = Math.floor(this.contrast * 255),
          contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));

      for (i = 0; i < len; i += 4) {
        data[i] = contrastF * (data[i] - 128) + 128;
        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uContrast: gl.getUniformLocation(program, 'uContrast'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uContrast, this.contrast);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
   */
  fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Saturate filter class
   * @class fabric.Image.filters.Saturation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Saturation({
   *   saturation: 100
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Saturation',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uSaturation;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'float rgMax = max(color.r, color.g);\n' +
        'float rgbMax = max(rgMax, color.b);\n' +
        'color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n' +
        'color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n' +
        'color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n' +
        'gl_FragColor = color;\n' +
      '}',

    saturation: 0,

    mainParameter: 'saturation',

    /**
     * Constructor
     * @memberOf fabric.Image.filters.Saturate.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
     */

    /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d: function(options) {
      if (this.saturation === 0) {
        return;
      }
      var imageData = options.imageData,
          data = imageData.data, len = data.length,
          adjust = -this.saturation, i, max;

      for (i = 0; i < len; i += 4) {
        max = Math.max(data[i], data[i + 1], data[i + 2]);
        data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uSaturation: gl.getUniformLocation(program, 'uSaturation'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
   */
  fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Blur filter class
   * @class fabric.Image.filters.Blur
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {

    type: 'Blur',

    /*
'gl_FragColor = vec4(0.0);',
'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
*/

    /* eslint-disable max-len */
    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec2 uDelta;\n' +
      'varying vec2 vTexCoord;\n' +
      'const float nSamples = 15.0;\n' +
      'vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n' +
      'float random(vec3 scale) {\n' +
        /* use the fragment position for a different seed per-pixel */
        'return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n' +
      '}\n' +
      'void main() {\n' +
        'vec4 color = vec4(0.0);\n' +
        'float total = 0.0;\n' +
        'float offset = random(v3offset);\n' +
        'for (float t = -nSamples; t <= nSamples; t++) {\n' +
          'float percent = (t + offset - 0.5) / nSamples;\n' +
          'float weight = 1.0 - abs(percent);\n' +
          'color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n' +
          'total += weight;\n' +
        '}\n' +
        'gl_FragColor = color / total;\n' +
      '}',
    /* eslint-enable max-len */

    /**
     * blur value, in percentage of image dimensions.
     * specific to keep the image blur constant at different resolutions
     * range bewteen 0 and 1.
     */
    blur: 0,

    mainParameter: 'blur',

    applyTo: function(options) {
      if (options.webgl) {
        // this aspectRatio is used to give the same blur to vertical and horizontal
        this.aspectRatio = options.sourceWidth / options.sourceHeight;
        options.passes++;
        this._setupFrameBuffer(options);
        this.horizontal = true;
        this.applyToWebGL(options);
        this._swapTextures(options);
        this._setupFrameBuffer(options);
        this.horizontal = false;
        this.applyToWebGL(options);
        this._swapTextures(options);
      }
      else {
        this.applyTo2d(options);
      }
    },

    applyTo2d: function(options) {
      // paint canvasEl with current image data.
      //options.ctx.putImageData(options.imageData, 0, 0);
      options.imageData = this.simpleBlur(options);
    },

    simpleBlur: function(options) {
      var resources = options.filterBackend.resources, canvas1, canvas2,
          width = options.imageData.width,
          height = options.imageData.height;

      if (!resources.blurLayer1) {
        resources.blurLayer1 = fabric.util.createCanvasElement();
        resources.blurLayer2 = fabric.util.createCanvasElement();
      }
      canvas1 = resources.blurLayer1;
      canvas2 = resources.blurLayer2;
      if (canvas1.width !== width || canvas1.height !== height) {
        canvas2.width = canvas1.width = width;
        canvas2.height = canvas1.height = height;
      }
      var ctx1 = canvas1.getContext('2d'),
          ctx2 = canvas2.getContext('2d'),
          nSamples = 15,
          random, percent, j, i,
          blur = this.blur * 0.06 * 0.5;

      // load first canvas
      ctx1.putImageData(options.imageData, 0, 0);
      ctx2.clearRect(0, 0, width, height);

      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * width + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, j, random);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }
      for (i = -nSamples; i <= nSamples; i++) {
        random = (Math.random() - 0.5) / 4;
        percent = i / nSamples;
        j = blur * percent * height + random;
        ctx2.globalAlpha = 1 - Math.abs(percent);
        ctx2.drawImage(canvas1, random, j);
        ctx1.drawImage(canvas2, 0, 0);
        ctx2.globalAlpha = 1;
        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
      }
      options.ctx.drawImage(canvas1, 0, 0);
      var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
      ctx1.globalAlpha = 1;
      ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
      return newImageData;
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        delta: gl.getUniformLocation(program, 'uDelta'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      var delta = this.chooseRightDelta();
      gl.uniform2fv(uniformLocations.delta, delta);
    },

    /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */
    chooseRightDelta: function() {
      var blurScale = 1, delta = [0, 0], blur;
      if (this.horizontal) {
        if (this.aspectRatio > 1) {
          // image is wide, i want to shrink radius horizontal
          blurScale = 1 / this.aspectRatio;
        }
      }
      else {
        if (this.aspectRatio < 1) {
          // image is tall, i want to shrink radius vertical
          blurScale = this.aspectRatio;
        }
      }
      blur = blurScale * this.blur * 0.12;
      if (this.horizontal) {
        delta[0] = blur;
      }
      else {
        delta[1] = blur;
      }
      return delta;
    },
  });

  /**
   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
   */
  filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * Gamma filter class
   * @class fabric.Image.filters.Gamma
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Gamma({
   *   gamma: [1, 0.5, 2.1]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'Gamma',

    fragmentSource: 'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform vec3 uGamma;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
        'vec3 correction = (1.0 / uGamma);\n' +
        'color.r = pow(color.r, correction.r);\n' +
        'color.g = pow(color.g, correction.g);\n' +
        'color.b = pow(color.b, correction.b);\n' +
        'gl_FragColor = color;\n' +
        'gl_FragColor.rgb *= color.a;\n' +
      '}',

    /**
     * Gamma array value, from 0.01 to 2.2.
     * @param {Array} gamma
     * @default
     */
    gamma: [1, 1, 1],

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'gamma',

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.gamma = [1, 1, 1];
      filters.BaseFilter.prototype.initialize.call(this, options);
    },

    /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d: function(options) {
      var imageData = options.imageData, data = imageData.data,
          gamma = this.gamma, len = data.length,
          rInv = 1 / gamma[0], gInv = 1 / gamma[1],
          bInv = 1 / gamma[2], i;

      if (!this.rVals) {
        // eslint-disable-next-line
        this.rVals = new Uint8Array(256);
        // eslint-disable-next-line
        this.gVals = new Uint8Array(256);
        // eslint-disable-next-line
        this.bVals = new Uint8Array(256);
      }

      // This is an optimization - pre-compute a look-up table for each color channel
      // instead of performing these pow calls for each pixel in the image.
      for (i = 0, len = 256; i < len; i++) {
        this.rVals[i] = Math.pow(i / 255, rInv) * 255;
        this.gVals[i] = Math.pow(i / 255, gInv) * 255;
        this.bVals[i] = Math.pow(i / 255, bInv) * 255;
      }
      for (i = 0, len = data.length; i < len; i += 4) {
        data[i] = this.rVals[data[i]];
        data[i + 1] = this.gVals[data[i + 1]];
        data[i + 2] = this.bVals[data[i + 2]];
      }
    },

    /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */
    getUniformLocations: function(gl, program) {
      return {
        uGamma: gl.getUniformLocation(program, 'uGamma'),
      };
    },

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData: function(gl, uniformLocations) {
      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    },
  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
   */
  fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */
  filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {

    type: 'Composed',

    /**
     * A non sparse array of filters to apply
     */
    subFilters: [],

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    initialize: function(options) {
      this.callSuper('initialize', options);
      // create a new array instead mutating the prototype with push
      this.subFilters = this.subFilters.slice(0);
    },

    /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */
    applyTo: function(options) {
      options.passes += this.subFilters.length - 1;
      this.subFilters.forEach(function(filter) {
        filter.applyTo(options);
      });
    },

    /**
     * Serialize this filter into JSON.
     *
     * @returns {Object} A JSON representation of this filter.
     */
    toObject: function() {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        subFilters: this.subFilters.map(function(filter) { return filter.toObject(); }),
      });
    },

    isNeutralState: function() {
      return !this.subFilters.some(function(filter) { return !filter.isNeutralState(); });
    }
  });

  /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   */
  fabric.Image.filters.Composed.fromObject = function(object, callback) {
    var filters = object.subFilters || [],
        subFilters = filters.map(function(filter) {
          return new fabric.Image.filters[filter.type](filter);
        }),
        instance = new fabric.Image.filters.Composed({ subFilters: subFilters });
    callback && callback(instance);
    return instance;
  };
})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric  = global.fabric || (global.fabric = { }),
      filters = fabric.Image.filters,
      createClass = fabric.util.createClass;

  /**
   * HueRotation filter class
   * @class fabric.Image.filters.HueRotation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {

    /**
     * Filter type
     * @param {String} type
     * @default
     */
    type: 'HueRotation',

    /**
     * HueRotation value, from -1 to 1.
     * the unit is radians
     * @param {Number} myParameter
     * @default
     */
    rotation: 0,

    /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */
    mainParameter: 'rotation',

    calculateMatrix: function() {
      var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad),
          aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
      this.matrix = [
        1, 0, 0, 0, 0,
        0, 1, 0, 0, 0,
        0, 0, 1, 0, 0,
        0, 0, 0, 1, 0
      ];
      this.matrix[0] = cos + OneMinusCos / 3;
      this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[6] = cos + aThird * OneMinusCos;
      this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
      this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
      this.matrix[12] = cos + aThird * OneMinusCos;
    },

    /**
     * HueRotation isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState: function(options) {
      this.calculateMatrix();
      return filters.BaseFilter.prototype.isNeutralState.call(this, options);
    },

    /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo: function(options) {
      this.calculateMatrix();
      filters.BaseFilter.prototype.applyTo.call(this, options);
    },

  });

  /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
   */
  fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;

})( true ? exports : this);


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = { }),
      clone = fabric.util.object.clone;

  if (fabric.Text) {
    fabric.warn('fabric.Text is already defined');
    return;
  }

  /**
   * Text class
   * @class fabric.Text
   * @extends fabric.Object
   * @return {fabric.Text} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   * @see {@link fabric.Text#initialize} for constructor definition
   */
  fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {

    /**
     * Properties which when set cause object to change dimensions
     * @type Array
     * @private
     */
    _dimensionAffectingProps: [
      'fontSize',
      'fontWeight',
      'fontFamily',
      'fontStyle',
      'lineHeight',
      'text',
      'charSpacing',
      'textAlign',
      'styles',
    ],

    /**
     * @private
     */
    _reNewline: /\r?\n/,

    /**
     * Use this regular expression to filter for whitespaces that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpacesAndTabs: /[ \t\r]/g,

    /**
     * Use this regular expression to filter for whitespace that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reSpaceAndTab: /[ \t\r]/,

    /**
     * Use this regular expression to filter consecutive groups of non spaces.
     * Mostly used when text is 'justify' aligned.
     * @private
     */
    _reWords: /\S+/g,

    /**
     * Type of an object
     * @type String
     * @default
     */
    type:                 'text',

    /**
     * Font size (in pixels)
     * @type Number
     * @default
     */
    fontSize:             40,

    /**
     * Font weight (e.g. bold, normal, 400, 600, 800)
     * @type {(Number|String)}
     * @default
     */
    fontWeight:           'normal',

    /**
     * Font family
     * @type String
     * @default
     */
    fontFamily:           'Times New Roman',

    /**
     * Text decoration underline.
     * @type Boolean
     * @default
     */
    underline:       false,

    /**
     * Text decoration overline.
     * @type Boolean
     * @default
     */
    overline:       false,

    /**
     * Text decoration linethrough.
     * @type Boolean
     * @default
     */
    linethrough:       false,

    /**
     * Text alignment. Possible values: "left", "center", "right", "justify",
     * "justify-left", "justify-center" or "justify-right".
     * @type String
     * @default
     */
    textAlign:            'left',

    /**
     * Font style . Possible values: "", "normal", "italic" or "oblique".
     * @type String
     * @default
     */
    fontStyle:            'normal',

    /**
     * Line height
     * @type Number
     * @default
     */
    lineHeight:           1.16,

    /**
     * Superscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    superscript: {
      size:      0.60, // fontSize factor
      baseline: -0.35  // baseline-shift factor (upwards)
    },

    /**
     * Subscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */
    subscript: {
      size:      0.60, // fontSize factor
      baseline:  0.11  // baseline-shift factor (downwards)
    },

    /**
     * Background color of text lines
     * @type String
     * @default
     */
    textBackgroundColor:  '',

    /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */
    stateProperties: fabric.Object.prototype.stateProperties.concat('fontFamily',
      'fontWeight',
      'fontSize',
      'text',
      'underline',
      'overline',
      'linethrough',
      'textAlign',
      'fontStyle',
      'lineHeight',
      'textBackgroundColor',
      'charSpacing',
      'styles'),

    /**
     * List of properties to consider when checking if cache needs refresh
     * @type Array
     */
    cacheProperties: fabric.Object.prototype.cacheProperties.concat('fontFamily',
      'fontWeight',
      'fontSize',
      'text',
      'underline',
      'overline',
      'linethrough',
      'textAlign',
      'fontStyle',
      'lineHeight',
      'textBackgroundColor',
      'charSpacing',
      'styles'),

    /**
     * When defined, an object is rendered via stroke and this property specifies its color.
     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
     * @type String
     * @default
     */
    stroke:               null,

    /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
     * @type fabric.Shadow
     * @default
     */
    shadow:               null,

    /**
     * @private
     */
    _fontSizeFraction: 0.222,

    /**
     * @private
     */
    offsets: {
      underline: 0.10,
      linethrough: -0.315,
      overline: -0.88
    },

    /**
     * Text Line proportion to font Size (in pixels)
     * @type Number
     * @default
     */
    _fontSizeMult:             1.13,

    /**
     * additional space between characters
     * expressed in thousands of em unit
     * @type Number
     * @default
     */
    charSpacing:             0,

    /**
     * Object containing character styles - top-level properties -> line numbers,
     * 2nd-level properties - charater numbers
     * @type Object
     * @default
     */
    styles: null,

    /**
     * Reference to a context to measure text char or couple of chars
     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
     * once created it will be referenced on fabric._measuringContext to avoide creating a canvas for every
     * text object created.
     * @type {CanvasRenderingContext2D}
     * @default
     */
    _measuringContext: null,

    /**
     * Baseline shift, stlyes only, keep at 0 for the main text object
     * @type {Number}
     * @default
     */
    deltaY: 0,

    /**
     * Array of properties that define a style unit (of 'styles').
     * @type {Array}
     * @default
     */
    _styleProperties: [
      'stroke',
      'strokeWidth',
      'fill',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'fontStyle',
      'underline',
      'overline',
      'linethrough',
      'deltaY',
      'textBackgroundColor',
    ],

    /**
     * contains characters bounding boxes
     */
    __charBounds: [],

    /**
     * use this size when measuring text. To avoid IE11 rounding errors
     * @type {Number}
     * @default
     * @readonly
     * @private
     */
    CACHE_FONT_SIZE: 400,

    /**
     * contains the min text width to avoid getting 0
     * @type {Number}
     * @default
     */
    MIN_TEXT_WIDTH: 2,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    initialize: function(text, options) {
      this.styles = options ? (options.styles || { }) : { };
      this.text = text;
      this.__skipDimension = true;
      this.callSuper('initialize', options);
      this.__skipDimension = false;
      this.initDimensions();
      this.setCoords();
      this.setupState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Return a contex for measurement of text string.
     * if created it gets stored for reuse
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */
    getMeasuringContext: function() {
      // if we did not return we have to measure something.
      if (!fabric._measuringContext) {
        fabric._measuringContext = this.canvas && this.canvas.contextCache ||
          fabric.util.createCanvasElement().getContext('2d');
      }
      return fabric._measuringContext;
    },

    /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */
    _splitText: function() {
      var newLines = this._splitTextIntoLines(this.text);
      this.textLines = newLines.lines;
      this._textLines = newLines.graphemeLines;
      this._unwrappedTextLines = newLines._unwrappedLines;
      this._text = newLines.graphemeText;
      return newLines;
    },

    /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */
    initDimensions: function() {
      if (this.__skipDimension) {
        return;
      }
      this._splitText();
      this._clearCache();
      this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
      this.height = this.calcTextHeight();
      this.saveState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Enlarge space boxes and shift the others
     */
    enlargeSpaces: function() {
      var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) {
          continue;
        }
        accumulatedSpace = 0;
        line = this._textLines[i];
        currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
          numberOfSpaces = spaces.length;
          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
          for (var j = 0, jlen = line.length; j <= jlen; j++) {
            charBound = this.__charBounds[i][j];
            if (this._reSpaceAndTab.test(line[j])) {
              charBound.width += diffSpace;
              charBound.kernedWidth += diffSpace;
              charBound.left += accumulatedSpace;
              accumulatedSpace += diffSpace;
            }
            else {
              charBound.left += accumulatedSpace;
            }
          }
        }
      }
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */
    isEndOfWrapping: function(lineIndex) {
      return lineIndex === this._textLines.length - 1;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always for text and Itext.
     * @return Number
     */
    missingNewlineOffset: function() {
      return 1;
    },

    /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */
    toString: function() {
      return '#<fabric.Text (' + this.complexity() +
        '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function() {
      var dims = this.callSuper('_getCacheCanvasDimensions');
      var fontSize = this.fontSize;
      dims.width += fontSize * dims.zoomX;
      dims.height += fontSize * dims.zoomY;
      return dims;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      this._setTextStyles(ctx);
      this._renderTextLinesBackground(ctx);
      this._renderTextDecoration(ctx, 'underline');
      this._renderText(ctx);
      this._renderTextDecoration(ctx, 'overline');
      this._renderTextDecoration(ctx, 'linethrough');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderText: function(ctx) {
      if (this.paintFirst === 'stroke') {
        this._renderTextStroke(ctx);
        this._renderTextFill(ctx);
      }
      else {
        this._renderTextFill(ctx);
        this._renderTextStroke(ctx);
      }
    },

    /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */
    _setTextStyles: function(ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';
      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    },

    /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of fabric.Text object
     */
    calcTextWidth: function() {
      var maxWidth = this.getLineWidth(0);

      for (var i = 1, len = this._textLines.length; i < len; i++) {
        var currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth > maxWidth) {
          maxWidth = currentLineWidth;
        }
      }
      return maxWidth;
    },

    /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */
    _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
      this._renderChars(method, ctx, line, left, top, lineIndex);
    },

    /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextLinesBackground: function(ctx) {
      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
        return;
      }
      var lineTopOffset = 0, heightOfLine,
          lineLeftOffset, originalFill = ctx.fillStyle,
          line, lastColor,
          leftOffset = this._getLeftOffset(),
          topOffset = this._getTopOffset(),
          boxStart = 0, boxWidth = 0, charBox, currentColor;

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);
        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
          lineTopOffset += heightOfLine;
          continue;
        }
        line = this._textLines[i];
        lineLeftOffset = this._getLineLeftOffset(i);
        boxWidth = 0;
        boxStart = 0;
        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
          if (currentColor !== lastColor) {
            ctx.fillStyle = lastColor;
            lastColor && ctx.fillRect(
              leftOffset + lineLeftOffset + boxStart,
              topOffset + lineTopOffset,
              boxWidth,
              heightOfLine / this.lineHeight
            );
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastColor = currentColor;
          }
          else {
            boxWidth += charBox.kernedWidth;
          }
        }
        if (currentColor) {
          ctx.fillStyle = currentColor;
          ctx.fillRect(
            leftOffset + lineLeftOffset + boxStart,
            topOffset + lineTopOffset,
            boxWidth,
            heightOfLine / this.lineHeight
          );
        }
        lineTopOffset += heightOfLine;
      }
      ctx.fillStyle = originalFill;
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    },

    /**
     * @private
     * @param {Object} decl style declaration for cache
     * @param {String} decl.fontFamily fontFamily
     * @param {String} decl.fontStyle fontStyle
     * @param {String} decl.fontWeight fontWeight
     * @return {Object} reference to cache
     */
    getFontCache: function(decl) {
      var fontFamily = decl.fontFamily.toLowerCase();
      if (!fabric.charWidthsCache[fontFamily]) {
        fabric.charWidthsCache[fontFamily] = { };
      }
      var cache = fabric.charWidthsCache[fontFamily],
          cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();
      if (!cache[cacheProp]) {
        cache[cacheProp] = { };
      }
      return cache[cacheProp];
    },

    /**
     * apply all the character style to canvas for rendering
     * @private
     * @param {String} _char
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} [decl]
     */
    _applyCharStyles: function(method, ctx, lineIndex, charIndex, styleDeclaration) {

      this._setFillStyles(ctx, styleDeclaration);
      this._setStrokeStyles(ctx, styleDeclaration);

      ctx.font = this._getFontDeclaration(styleDeclaration);
    },

    /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */
    _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
      // first i try to return from cache
      var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle),
          previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char,
          stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth,
          fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;

      if (previousChar && fontCache[previousChar] !== undefined) {
        previousWidth = fontCache[previousChar];
      }
      if (fontCache[_char] !== undefined) {
        kernedWidth = width = fontCache[_char];
      }
      if (stylesAreEqual && fontCache[couple] !== undefined) {
        coupleWidth = fontCache[couple];
        kernedWidth = coupleWidth - previousWidth;
      }
      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
        var ctx = this.getMeasuringContext();
        // send a TRUE to specify measuring font size CACHE_FONT_SIZE
        this._setTextStyles(ctx, charStyle, true);
      }
      if (width === undefined) {
        kernedWidth = width = ctx.measureText(_char).width;
        fontCache[_char] = width;
      }
      if (previousWidth === undefined && stylesAreEqual && previousChar) {
        previousWidth = ctx.measureText(previousChar).width;
        fontCache[previousChar] = previousWidth;
      }
      if (stylesAreEqual && coupleWidth === undefined) {
        // we can measure the kerning couple and subtract the width of the previous character
        coupleWidth = ctx.measureText(couple).width;
        fontCache[couple] = coupleWidth;
        kernedWidth = coupleWidth - previousWidth;
      }
      return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier };
    },

    /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */
    getHeightOfChar: function(line, _char) {
      return this.getValueOfPropertyAt(line, _char, 'fontSize');
    },

    /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    measureLine: function(lineIndex) {
      var lineInfo = this._measureLine(lineIndex);
      if (this.charSpacing !== 0) {
        lineInfo.width -= this._getWidthOfCharSpacing();
      }
      if (lineInfo.width < 0) {
        lineInfo.width = 0;
      }
      return lineInfo;
    },

    /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
     */
    _measureLine: function(lineIndex) {
      var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme,
          graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length);

      this.__charBounds[lineIndex] = lineBounds;
      for (i = 0; i < line.length; i++) {
        grapheme = line[i];
        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
        lineBounds[i] = graphemeInfo;
        width += graphemeInfo.kernedWidth;
        prevGrapheme = grapheme;
      }
      // this latest bound box represent the last character of the line
      // to simplify cursor handling in interactive mode.
      lineBounds[i] = {
        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
        width: 0,
        kernedWidth: 0,
        height: this.fontSize
      };
      return { width: width, numOfSpaces: numOfSpaces };
    },

    /**
     * Measure and return the info of a single grapheme.
     * needs the the info of previous graphemes already filled
     * @private
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     */
    _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
      var style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : { },
          info = this._measureChar(grapheme, style, prevGrapheme, prevStyle),
          kernedWidth = info.kernedWidth,
          width = info.width, charSpacing;

      if (this.charSpacing !== 0) {
        charSpacing = this._getWidthOfCharSpacing();
        width += charSpacing;
        kernedWidth += charSpacing;
      }

      var box = {
        width: width,
        left: 0,
        height: style.fontSize,
        kernedWidth: kernedWidth,
        deltaY: style.deltaY,
      };
      if (charIndex > 0 && !skipLeft) {
        var previousBox = this.__charBounds[lineIndex][charIndex - 1];
        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
      }
      return box;
    },

    /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */
    getHeightOfLine: function(lineIndex) {
      if (this.__lineHeights[lineIndex]) {
        return this.__lineHeights[lineIndex];
      }

      var line = this._textLines[lineIndex],
          // char 0 is measured before the line cycle because it nneds to char
          // emptylines
          maxHeight = this.getHeightOfChar(lineIndex, 0);
      for (var i = 1, len = line.length; i < len; i++) {
        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
      }

      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
    },

    /**
     * Calculate text box height
     */
    calcTextHeight: function() {
      var lineHeight, height = 0;
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineHeight = this.getHeightOfLine(i);
        height += (i === len - 1 ? lineHeight / this.lineHeight : lineHeight);
      }
      return height;
    },

    /**
     * @private
     * @return {Number} Left offset
     */
    _getLeftOffset: function() {
      return -this.width / 2;
    },

    /**
     * @private
     * @return {Number} Top offset
     */
    _getTopOffset: function() {
      return -this.height / 2;
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */
    _renderTextCommon: function(ctx, method) {
      ctx.save();
      var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset(),
          offsets = this._applyPatternGradientTransform(ctx, method === 'fillText' ? this.fill : this.stroke);
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        var heightOfLine = this.getHeightOfLine(i),
            maxHeight = heightOfLine / this.lineHeight,
            leftOffset = this._getLineLeftOffset(i);
        this._renderTextLine(
          method,
          ctx,
          this._textLines[i],
          left + leftOffset - offsets.offsetX,
          top + lineHeights + maxHeight - offsets.offsetY,
          i
        );
        lineHeights += heightOfLine;
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextFill: function(ctx) {
      if (!this.fill && !this.styleHas('fill')) {
        return;
      }

      this._renderTextCommon(ctx, 'fillText');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextStroke: function(ctx) {
      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }

      ctx.save();
      this._setLineDash(ctx, this.strokeDashArray);
      ctx.beginPath();
      this._renderTextCommon(ctx, 'strokeText');
      ctx.closePath();
      ctx.restore();
    },

    /**
     * @private
     * @param {String} method fillText or strokeText.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} line Content of the line, splitted in an array by grapheme
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */
    _renderChars: function(method, ctx, line, left, top, lineIndex) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox,
          boxWidth = 0,
          timeToRender,
          shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex);

      ctx.save();
      top -= lineHeight * this._fontSizeFraction / this.lineHeight;
      if (shortCut) {
        // render all the line in one pass without checking
        this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top, lineHeight);
        ctx.restore();
        return;
      }
      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          left += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
        }
        if (timeToRender) {
          this._renderChar(method, ctx, lineIndex, i, charsToRender, left, top, lineHeight);
          charsToRender = '';
          actualStyle = nextStyle;
          left += boxWidth;
          boxWidth = 0;
        }
      }
      ctx.restore();
    },

    /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */
    _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
      var decl = this._getStyleDeclaration(lineIndex, charIndex),
          fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
          shouldFill = method === 'fillText' && fullDecl.fill,
          shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;

      if (!shouldStroke && !shouldFill) {
        return;
      }
      decl && ctx.save();

      this._applyCharStyles(method, ctx, lineIndex, charIndex, fullDecl);

      if (decl && decl.textBackgroundColor) {
        this._removeShadow(ctx);
      }
      if (decl && decl.deltaY) {
        top += decl.deltaY;
      }

      shouldFill && ctx.fillText(_char, left, top);
      shouldStroke && ctx.strokeText(_char, left, top);
      decl && ctx.restore();
    },

    /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSuperscript: function(start, end) {
      return this._setScript(start, end, this.superscript);
    },

    /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    setSubscript: function(start, end) {
      return this._setScript(start, end, this.subscript);
    },

    /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     * @returns {fabric.Text} thisArg
     * @chainable
     */
    _setScript: function(start, end, schema) {
      var loc = this.get2DCursorLocation(start, true),
          fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
          dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
          style = { fontSize: fontSize * schema.size, deltaY: dy + fontSize * schema.baseline };
      this.setSelectionStyles(style, start, end);
      return this;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChanged: function(prevStyle, thisStyle) {
      return prevStyle.fill !== thisStyle.fill ||
              prevStyle.stroke !== thisStyle.stroke ||
              prevStyle.strokeWidth !== thisStyle.strokeWidth ||
              prevStyle.fontSize !== thisStyle.fontSize ||
              prevStyle.fontFamily !== thisStyle.fontFamily ||
              prevStyle.fontWeight !== thisStyle.fontWeight ||
              prevStyle.fontStyle !== thisStyle.fontStyle ||
              prevStyle.deltaY !== thisStyle.deltaY;
    },

    /**
     * @private
     * @param {Object} prevStyle
     * @param {Object} thisStyle
     */
    _hasStyleChangedForSvg: function(prevStyle, thisStyle) {
      return this._hasStyleChanged(prevStyle, thisStyle) ||
        prevStyle.overline !== thisStyle.overline ||
        prevStyle.underline !== thisStyle.underline ||
        prevStyle.linethrough !== thisStyle.linethrough;
    },

    /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */
    _getLineLeftOffset: function(lineIndex) {
      var lineWidth = this.getLineWidth(lineIndex);
      if (this.textAlign === 'center') {
        return (this.width - lineWidth) / 2;
      }
      if (this.textAlign === 'right') {
        return this.width - lineWidth;
      }
      if (this.textAlign === 'justify-center' && this.isEndOfWrapping(lineIndex)) {
        return (this.width - lineWidth) / 2;
      }
      if (this.textAlign === 'justify-right' && this.isEndOfWrapping(lineIndex)) {
        return this.width - lineWidth;
      }
      return 0;
    },

    /**
     * @private
     */
    _clearCache: function() {
      this.__lineWidths = [];
      this.__lineHeights = [];
      this.__charBounds = [];
    },

    /**
     * @private
     */
    _shouldClearDimensionCache: function() {
      var shouldClear = this._forceClearCache;
      shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));
      if (shouldClear) {
        this.dirty = true;
        this._forceClearCache = false;
      }
      return shouldClear;
    },

    /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    getLineWidth: function(lineIndex) {
      if (this.__lineWidths[lineIndex]) {
        return this.__lineWidths[lineIndex];
      }

      var width, line = this._textLines[lineIndex], lineInfo;

      if (line === '') {
        width = 0;
      }
      else {
        lineInfo = this.measureLine(lineIndex);
        width = lineInfo.width;
      }
      this.__lineWidths[lineIndex] = width;
      return width;
    },

    _getWidthOfCharSpacing: function() {
      if (this.charSpacing !== 0) {
        return this.fontSize * this.charSpacing / 1000;
      }
      return 0;
    },

    /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the charater number
     * @param {String} property the property name
     * @returns the value of 'property'
     */
    getValueOfPropertyAt: function(lineIndex, charIndex, property) {
      var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
      if (charStyle && typeof charStyle[property] !== 'undefined') {
        return charStyle[property];
      }
      return this[property];
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextDecoration: function(ctx, type) {
      if (!this[type] && !this.styleHas(type)) {
        return;
      }
      var heightOfLine, size, _size,
          lineLeftOffset, dy, _dy,
          line, lastDecoration,
          leftOffset = this._getLeftOffset(),
          topOffset = this._getTopOffset(), top,
          boxStart, boxWidth, charBox, currentDecoration,
          maxHeight, currentFill, lastFill,
          charSpacing = this._getWidthOfCharSpacing();

      for (var i = 0, len = this._textLines.length; i < len; i++) {
        heightOfLine = this.getHeightOfLine(i);
        if (!this[type] && !this.styleHas(type, i)) {
          topOffset += heightOfLine;
          continue;
        }
        line = this._textLines[i];
        maxHeight = heightOfLine / this.lineHeight;
        lineLeftOffset = this._getLineLeftOffset(i);
        boxStart = 0;
        boxWidth = 0;
        lastDecoration = this.getValueOfPropertyAt(i, 0, type);
        lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
        top = topOffset + maxHeight * (1 - this._fontSizeFraction);
        size = this.getHeightOfChar(i, 0);
        dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
        for (var j = 0, jlen = line.length; j < jlen; j++) {
          charBox = this.__charBounds[i][j];
          currentDecoration = this.getValueOfPropertyAt(i, j, type);
          currentFill = this.getValueOfPropertyAt(i, j, 'fill');
          _size = this.getHeightOfChar(i, j);
          _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
          if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) &&
              boxWidth > 0) {
            ctx.fillStyle = lastFill;
            lastDecoration && lastFill && ctx.fillRect(
              leftOffset + lineLeftOffset + boxStart,
              top + this.offsets[type] * size + dy,
              boxWidth,
              this.fontSize / 15
            );
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastDecoration = currentDecoration;
            lastFill = currentFill;
            size = _size;
            dy = _dy;
          }
          else {
            boxWidth += charBox.kernedWidth;
          }
        }
        ctx.fillStyle = currentFill;
        currentDecoration && currentFill && ctx.fillRect(
          leftOffset + lineLeftOffset + boxStart,
          top + this.offsets[type] * size + dy,
          boxWidth - charSpacing,
          this.fontSize / 15
        );
        topOffset += heightOfLine;
      }
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    },

    /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */
    _getFontDeclaration: function(styleObject, forMeasuring) {
      var style = styleObject || this, family = this.fontFamily,
          fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
      var fontFamily = family === undefined ||
      family.indexOf('\'') > -1 || family.indexOf(',') > -1 ||
      family.indexOf('"') > -1 || fontIsGeneric
        ? style.fontFamily : '"' + style.fontFamily + '"';
      return [
        // node-canvas needs "weight style", while browsers need "style weight"
        // verify if this can be fixed in JSDOM
        (fabric.isLikelyNode ? style.fontWeight : style.fontStyle),
        (fabric.isLikelyNode ? style.fontStyle : style.fontWeight),
        forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px',
        fontFamily
      ].join(' ');
    },

    /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      // do not render if object is not visible
      if (!this.visible) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
      }
      this.callSuper('render', ctx);
    },

    /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns {Array} Lines in the text
     */
    _splitTextIntoLines: function(text) {
      var lines = text.split(this._reNewline),
          newLines = new Array(lines.length),
          newLine = ['\n'],
          newText = [];
      for (var i = 0; i < lines.length; i++) {
        newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
        newText = newText.concat(newLines[i], newLine);
      }
      newText.pop();
      return { _unwrappedLines: newLines, lines: lines, graphemeText: newText, graphemeLines: newLines };
    },

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      var additionalProperties = [
        'text',
        'fontSize',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'lineHeight',
        'underline',
        'overline',
        'linethrough',
        'textAlign',
        'textBackgroundColor',
        'charSpacing',
      ].concat(propertiesToInclude);
      var obj = this.callSuper('toObject', additionalProperties);
      obj.styles = clone(this.styles, true);
      return obj;
    },

    /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */
    set: function(key, value) {
      this.callSuper('set', key, value);
      var needsDims = false;
      if (typeof key === 'object') {
        for (var _key in key) {
          needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
        }
      }
      else {
        needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
      }
      if (needsDims) {
        this.initDimensions();
        this.setCoords();
      }
      return this;
    },

    /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */
    complexity: function() {
      return 1;
    }
  });

  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
   * @static
   * @memberOf fabric.Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */
  fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(
    'x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));

  /**
   * Default SVG font size
   * @static
   * @memberOf fabric.Text
   */
  fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;

  /**
   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf fabric.Text
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */
  fabric.Text.fromElement = function(element, callback, options) {
    if (!element) {
      return callback(null);
    }

    var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES),
        parsedAnchor = parsedAttributes.textAnchor || 'left';
    options = fabric.util.object.extend((options ? clone(options) : { }), parsedAttributes);

    options.top = options.top || 0;
    options.left = options.left || 0;
    if (parsedAttributes.textDecoration) {
      var textDecoration = parsedAttributes.textDecoration;
      if (textDecoration.indexOf('underline') !== -1) {
        options.underline = true;
      }
      if (textDecoration.indexOf('overline') !== -1) {
        options.overline = true;
      }
      if (textDecoration.indexOf('line-through') !== -1) {
        options.linethrough = true;
      }
      delete options.textDecoration;
    }
    if ('dx' in parsedAttributes) {
      options.left += parsedAttributes.dx;
    }
    if ('dy' in parsedAttributes) {
      options.top += parsedAttributes.dy;
    }
    if (!('fontSize' in options)) {
      options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
    }

    var textContent = '';

    // The XML is not properly parsed in IE9 so a workaround to get
    // textContent is through firstChild.data. Another workaround would be
    // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
    if (!('textContent' in element)) {
      if ('firstChild' in element && element.firstChild !== null) {
        if ('data' in element.firstChild && element.firstChild.data !== null) {
          textContent = element.firstChild.data;
        }
      }
    }
    else {
      textContent = element.textContent;
    }

    textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
    var originalStrokeWidth = options.strokeWidth;
    options.strokeWidth = 0;

    var text = new fabric.Text(textContent, options),
        textHeightScaleFactor = text.getScaledHeight() / text.height,
        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
        scaledDiff = lineHeightDiff * textHeightScaleFactor,
        textHeight = text.getScaledHeight() + scaledDiff,
        offX = 0;
    /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */
    if (parsedAnchor === 'center') {
      offX = text.getScaledWidth() / 2;
    }
    if (parsedAnchor === 'right') {
      offX = text.getScaledWidth();
    }
    text.set({
      left: text.left - offX,
      top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
      strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1,
    });
    callback(text);
  };
  /* _FROM_SVG_END_ */

  /**
   * Returns fabric.Text instance from an object representation
   * @static
   * @memberOf fabric.Text
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
   */
  fabric.Text.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Text', object, callback, 'text');
  };

  fabric.Text.genericFonts = ['sans-serif', 'serif', 'cursive', 'fantasy', 'monospace'];

  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);

})( true ? exports : this);


(function() {
  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function(lineIndex) {
      if (!this.styles) {
        return true;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return true;
      }
      var obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          // eslint-disable-next-line no-unused-vars
          for (var p3 in obj[p1][p2]) {
            return false;
          }
        }
      }
      return true;
    },

    /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */
    styleHas: function(property, lineIndex) {
      if (!this.styles || !property || property === '') {
        return false;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return false;
      }
      var obj = typeof lineIndex === 'undefined' ? this.styles : { 0: this.styles[lineIndex] };
      // eslint-disable-next-line
      for (var p1 in obj) {
        // eslint-disable-next-line
        for (var p2 in obj[p1]) {
          if (typeof obj[p1][p2][property] !== 'undefined') {
            return true;
          }
        }
      }
      return false;
    },

    /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     *
     * @param {string} property The property to compare between characters and text.
     */
    cleanStyle: function(property) {
      if (!this.styles || !property || property === '') {
        return false;
      }
      var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue,
          allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
      // eslint-disable-next-line
      for (var p1 in obj) {
        letterCount = 0;
        // eslint-disable-next-line
        for (var p2 in obj[p1]) {
          var styleObject = obj[p1][p2],
              stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);

          stylesCount++;

          if (stylePropertyHasBeenSet) {
            if (!stylePropertyValue) {
              stylePropertyValue = styleObject[property];
            }
            else if (styleObject[property] !== stylePropertyValue) {
              allStyleObjectPropertiesMatch = false;
            }

            if (styleObject[property] === this[property]) {
              delete styleObject[property];
            }
          }
          else {
            allStyleObjectPropertiesMatch = false;
          }

          if (Object.keys(styleObject).length !== 0) {
            letterCount++;
          }
          else {
            delete obj[p1][p2];
          }
        }

        if (letterCount === 0) {
          delete obj[p1];
        }
      }
      // if every grapheme has the same style set then
      // delete those styles and set it on the parent
      for (var i = 0; i < this._textLines.length; i++) {
        graphemeCount += this._textLines[i].length;
      }
      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
        this[property] = stylePropertyValue;
        this.removeStyle(property);
      }
    },

    /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */
    removeStyle: function(property) {
      if (!this.styles || !property || property === '') {
        return;
      }
      var obj = this.styles, line, lineNum, charNum;
      for (lineNum in obj) {
        line = obj[lineNum];
        for (charNum in line) {
          delete line[charNum][property];
          if (Object.keys(line[charNum]).length === 0) {
            delete line[charNum];
          }
        }
        if (Object.keys(line).length === 0) {
          delete obj[lineNum];
        }
      }
    },

    /**
     * @private
     */
    _extendStyles: function(index, styles) {
      var loc = this.get2DCursorLocation(index);

      if (!this._getLineStyle(loc.lineIndex)) {
        this._setLineStyle(loc.lineIndex);
      }

      if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
        this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
      }

      fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
    },

    /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */
    get2DCursorLocation: function(selectionStart, skipWrapping) {
      if (typeof selectionStart === 'undefined') {
        selectionStart = this.selectionStart;
      }
      var lines = skipWrapping ? this._unwrappedTextLines : this._textLines,
          len = lines.length;
      for (var i = 0; i < len; i++) {
        if (selectionStart <= lines[i].length) {
          return {
            lineIndex: i,
            charIndex: selectionStart
          };
        }
        selectionStart -= lines[i].length + this.missingNewlineOffset(i);
      }
      return {
        lineIndex: i - 1,
        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
      };
    },

    /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, slectionStart or selectionEnd will be used.
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */
    getSelectionStyles: function(startIndex, endIndex, complete) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }
      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }
      var styles = [];
      for (var i = startIndex; i < endIndex; i++) {
        styles.push(this.getStyleAtPosition(i, complete));
      }
      return styles;
    },

    /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */
    getStyleAtPosition: function(position, complete) {
      var loc = this.get2DCursorLocation(position),
          style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) :
            this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
      return style || {};
    },

    /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @return {fabric.IText} thisArg
     * @chainable
     */
    setSelectionStyles: function(styles, startIndex, endIndex) {
      if (typeof startIndex === 'undefined') {
        startIndex = this.selectionStart || 0;
      }
      if (typeof endIndex === 'undefined') {
        endIndex = this.selectionEnd || startIndex;
      }
      for (var i = startIndex; i < endIndex; i++) {
        this._extendStyles(i, styles);
      }
      /* not included in _extendStyles to avoid clearing cache more than once */
      this._forceClearCache = true;
      return this;
    },

    /**
     * get the reference, not a clone, of the style object for a given character
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Object} style object
     */
    _getStyleDeclaration: function(lineIndex, charIndex) {
      var lineStyle = this.styles && this.styles[lineIndex];
      if (!lineStyle) {
        return null;
      }
      return lineStyle[charIndex];
    },

    /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */
    getCompleteStyleDeclaration: function(lineIndex, charIndex) {
      var style = this._getStyleDeclaration(lineIndex, charIndex) || { },
          styleObject = { }, prop;
      for (var i = 0; i < this._styleProperties.length; i++) {
        prop = this._styleProperties[i];
        styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
      }
      return styleObject;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function(lineIndex, charIndex, style) {
      this.styles[lineIndex][charIndex] = style;
    },

    /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function(lineIndex, charIndex) {
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function(lineIndex) {
      return !!this.styles[lineIndex];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */
    _setLineStyle: function(lineIndex) {
      this.styles[lineIndex] = {};
    },

    /**
     * @param {Number} lineIndex
     * @private
     */
    _deleteLineStyle: function(lineIndex) {
      delete this.styles[lineIndex];
    }
  });
})();


(function() {

  function parseDecoration(object) {
    if (object.textDecoration) {
      object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
      object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
      object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
      delete object.textDecoration;
    }
  }

  /**
   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
   * prefix when observing canvas.
   * @class fabric.IText
   * @extends fabric.Text
   * @mixes fabric.Observable
   *
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   *
   * @return {fabric.IText} thisArg
   * @see {@link fabric.IText#initialize} for constructor definition
   *
   * <p>Supported key combinations:</p>
   * <pre>
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * </pre>
   *
   * <p>Supported mouse/touch combination</p>
   * <pre>
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * </pre>
   */
  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, /** @lends fabric.IText.prototype */ {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'i-text',

    /**
     * Index where text selection starts (or where cursor is when there is no selection)
     * @type Number
     * @default
     */
    selectionStart: 0,

    /**
     * Index where text selection ends
     * @type Number
     * @default
     */
    selectionEnd: 0,

    /**
     * Color of text selection
     * @type String
     * @default
     */
    selectionColor: 'rgba(17,119,255,0.3)',

    /**
     * Indicates whether text is in editing mode
     * @type Boolean
     * @default
     */
    isEditing: false,

    /**
     * Indicates whether a text can be edited
     * @type Boolean
     * @default
     */
    editable: true,

    /**
     * Border color of text object while it's in editing mode
     * @type String
     * @default
     */
    editingBorderColor: 'rgba(102,153,255,0.25)',

    /**
     * Width of cursor (in px)
     * @type Number
     * @default
     */
    cursorWidth: 2,

    /**
     * Color of text cursor color in editing mode.
     * if not set (default) will take color from the text.
     * if set to a color value that fabric can understand, it will
     * be used instead of the color of the text at the current position.
     * @type String
     * @default
     */
    cursorColor: '',

    /**
     * Delay between cursor blink (in ms)
     * @type Number
     * @default
     */
    cursorDelay: 1000,

    /**
     * Duration of cursor fadein (in ms)
     * @type Number
     * @default
     */
    cursorDuration: 600,

    /**
     * Indicates whether internal text char widths can be cached
     * @type Boolean
     * @default
     */
    caching: true,

    /**
     * @private
     */
    _reSpace: /\s|\n/,

    /**
     * @private
     */
    _currentCursorOpacity: 0,

    /**
     * @private
     */
    _selectionDirection: null,

    /**
     * @private
     */
    _abortCursorAnimation: false,

    /**
     * @private
     */
    __widthOfSpace: [],

    /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */
    inCompositionMode: false,

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.IText} thisArg
     */
    initialize: function(text, options) {
      this.callSuper('initialize', text, options);
      this.initBehavior();
    },

    /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */
    setSelectionStart: function(index) {
      index = Math.max(index, 0);
      this._updateAndFire('selectionStart', index);
    },

    /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */
    setSelectionEnd: function(index) {
      index = Math.min(index, this.text.length);
      this._updateAndFire('selectionEnd', index);
    },

    /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */
    _updateAndFire: function(property, index) {
      if (this[property] !== index) {
        this._fireSelectionChanged();
        this[property] = index;
      }
      this._updateTextarea();
    },

    /**
     * Fires the even of selection changed
     * @private
     */
    _fireSelectionChanged: function() {
      this.fire('selection:changed');
      this.canvas && this.canvas.fire('text:selection:changed', { target: this });
    },

    /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */
    initDimensions: function() {
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this.callSuper('initDimensions');
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render: function(ctx) {
      this.clearContextTop();
      this.callSuper('render', ctx);
      // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
      // the correct position but not at every cursor animation.
      this.cursorOffsetCache = { };
      this.renderCursorOrSelection();
    },

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render: function(ctx) {
      this.callSuper('_render', ctx);
    },

    /**
     * Prepare and clean the contextTop
     */
    clearContextTop: function(skipRestore) {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }
      var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this.transform(ctx);
      this._clearTextArea(ctx);
      skipRestore || ctx.restore();
    },
    /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */
    renderCursorOrSelection: function() {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }
      var boundaries = this._getCursorBoundaries(),
          ctx = this.canvas.contextTop;
      this.clearContextTop(true);
      if (this.selectionStart === this.selectionEnd) {
        this.renderCursor(boundaries, ctx);
      }
      else {
        this.renderSelection(boundaries, ctx);
      }
      ctx.restore();
    },

    _clearTextArea: function(ctx) {
      // we add 4 pixel, to be sure to do not leave any pixel out
      var width = this.width + 4, height = this.height + 4;
      ctx.clearRect(-width / 2, -height / 2, width, height);
    },

    /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * @private
     * @param {Array} chars Array of characters
     * @param {String} typeOfBoundaries
     */
    _getCursorBoundaries: function(position) {

      // left/top are left/top of entire text box
      // leftOffset/topOffset are offset from that left/top point of a text box

      if (typeof position === 'undefined') {
        position = this.selectionStart;
      }

      var left = this._getLeftOffset(),
          top = this._getTopOffset(),
          offsets = this._getCursorBoundariesOffsets(position);

      return {
        left: left,
        top: top,
        leftOffset: offsets.left,
        topOffset: offsets.top
      };
    },

    /**
     * @private
     */
    _getCursorBoundariesOffsets: function(position) {
      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
        return this.cursorOffsetCache;
      }
      var lineLeftOffset,
          lineIndex,
          charIndex,
          topOffset = 0,
          leftOffset = 0,
          boundaries,
          cursorPosition = this.get2DCursorLocation(position);
      charIndex = cursorPosition.charIndex;
      lineIndex = cursorPosition.lineIndex;
      for (var i = 0; i < lineIndex; i++) {
        topOffset += this.getHeightOfLine(i);
      }
      lineLeftOffset = this._getLineLeftOffset(lineIndex);
      var bound = this.__charBounds[lineIndex][charIndex];
      bound && (leftOffset = bound.left);
      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
        leftOffset -= this._getWidthOfCharSpacing();
      }
      boundaries = {
        top: topOffset,
        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0),
      };
      this.cursorOffsetCache = boundaries;
      return this.cursorOffsetCache;
    },

    /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderCursor: function(boundaries, ctx) {
      var cursorLocation = this.get2DCursorLocation(),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
          multiplier = this.scaleX * this.canvas.getZoom(),
          cursorWidth = this.cursorWidth / multiplier,
          topOffset = boundaries.topOffset,
          dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');

      topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight
        - charHeight * (1 - this._fontSizeFraction);

      if (this.inCompositionMode) {
        this.renderSelection(boundaries, ctx);
      }

      ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
      ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
      ctx.fillRect(
        boundaries.left + boundaries.leftOffset - cursorWidth / 2,
        topOffset + boundaries.top + dy,
        cursorWidth,
        charHeight);
    },

    /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderSelection: function(boundaries, ctx) {

      var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
          selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
          isJustify = this.textAlign.indexOf('justify') !== -1,
          start = this.get2DCursorLocation(selectionStart),
          end = this.get2DCursorLocation(selectionEnd),
          startLine = start.lineIndex,
          endLine = end.lineIndex,
          startChar = start.charIndex < 0 ? 0 : start.charIndex,
          endChar = end.charIndex < 0 ? 0 : end.charIndex;

      for (var i = startLine; i <= endLine; i++) {
        var lineOffset = this._getLineLeftOffset(i) || 0,
            lineHeight = this.getHeightOfLine(i),
            realLineHeight = 0, boxStart = 0, boxEnd = 0;

        if (i === startLine) {
          boxStart = this.__charBounds[startLine][startChar].left;
        }
        if (i >= startLine && i < endLine) {
          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
        }
        else if (i === endLine) {
          if (endChar === 0) {
            boxEnd = this.__charBounds[endLine][endChar].left;
          }
          else {
            var charSpacing = this._getWidthOfCharSpacing();
            boxEnd = this.__charBounds[endLine][endChar - 1].left
              + this.__charBounds[endLine][endChar - 1].width - charSpacing;
          }
        }
        realLineHeight = lineHeight;
        if (this.lineHeight < 1 || (i === endLine && this.lineHeight > 1)) {
          lineHeight /= this.lineHeight;
        }
        if (this.inCompositionMode) {
          ctx.fillStyle = this.compositionColor || 'black';
          ctx.fillRect(
            boundaries.left + lineOffset + boxStart,
            boundaries.top + boundaries.topOffset + lineHeight,
            boxEnd - boxStart,
            1);
        }
        else {
          ctx.fillStyle = this.selectionColor;
          ctx.fillRect(
            boundaries.left + lineOffset + boxStart,
            boundaries.top + boundaries.topOffset,
            boxEnd - boxStart,
            lineHeight);
        }


        boundaries.topOffset += realLineHeight;
      }
    },

    /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */
    getCurrentCharFontSize: function() {
      var cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
    },

    /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * Unused from the library, is for the end user
     * @return {String} Character color (fill)
     */
    getCurrentCharColor: function() {
      var cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
    },

    /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */
    _getCurrentCharIndex: function() {
      var cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
          charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
      return { l: cursorPosition.lineIndex, c: charIndex };
    }
  });

  /**
   * Returns fabric.IText instance from an object representation
   * @static
   * @memberOf fabric.IText
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as argument
   */
  fabric.IText.fromObject = function(object, callback) {
    parseDecoration(object);
    if (object.styles) {
      for (var i in object.styles) {
        for (var j in object.styles[i]) {
          parseDecoration(object.styles[i][j]);
        }
      }
    }
    fabric.Object._fromObject('IText', object, callback, 'text');
  };
})();


(function() {

  var clone = fabric.util.object.clone;

  fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

    /**
     * Initializes all the interactive behavior of IText
     */
    initBehavior: function() {
      this.initAddedHandler();
      this.initRemovedHandler();
      this.initCursorSelectionHandlers();
      this.initDoubleClickSimulation();
      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    },

    onDeselect: function() {
      this.isEditing && this.exitEditing();
      this.selected = false;
    },

    /**
     * Initializes "added" event handler
     */
    initAddedHandler: function() {
      var _this = this;
      this.on('added', function() {
        var canvas = _this.canvas;
        if (canvas) {
          if (!canvas._hasITextHandlers) {
            canvas._hasITextHandlers = true;
            _this._initCanvasHandlers(canvas);
          }
          canvas._iTextInstances = canvas._iTextInstances || [];
          canvas._iTextInstances.push(_this);
        }
      });
    },

    initRemovedHandler: function() {
      var _this = this;
      this.on('removed', function() {
        var canvas = _this.canvas;
        if (canvas) {
          canvas._iTextInstances = canvas._iTextInstances || [];
          fabric.util.removeFromArray(canvas._iTextInstances, _this);
          if (canvas._iTextInstances.length === 0) {
            canvas._hasITextHandlers = false;
            _this._removeCanvasHandlers(canvas);
          }
        }
      });
    },

    /**
     * register canvas event to manage exiting on other instances
     * @private
     */
    _initCanvasHandlers: function(canvas) {
      canvas._mouseUpITextHandler = function() {
        if (canvas._iTextInstances) {
          canvas._iTextInstances.forEach(function(obj) {
            obj.__isMousedown = false;
          });
        }
      };
      canvas.on('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * remove canvas event to manage exiting on other instances
     * @private
     */
    _removeCanvasHandlers: function(canvas) {
      canvas.off('mouse:up', canvas._mouseUpITextHandler);
    },

    /**
     * @private
     */
    _tick: function() {
      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
    },

    /**
     * @private
     */
    _animateCursor: function(obj, targetOpacity, duration, completeMethod) {

      var tickState;

      tickState = {
        isAborted: false,
        abort: function() {
          this.isAborted = true;
        },
      };

      obj.animate('_currentCursorOpacity', targetOpacity, {
        duration: duration,
        onComplete: function() {
          if (!tickState.isAborted) {
            obj[completeMethod]();
          }
        },
        onChange: function() {
          // we do not want to animate a selection, only cursor
          if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
            obj.renderCursorOrSelection();
          }
        },
        abort: function() {
          return tickState.isAborted;
        }
      });
      return tickState;
    },

    /**
     * @private
     */
    _onTickComplete: function() {

      var _this = this;

      if (this._cursorTimeout1) {
        clearTimeout(this._cursorTimeout1);
      }
      this._cursorTimeout1 = setTimeout(function() {
        _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
      }, 100);
    },

    /**
     * Initializes delayed cursor
     */
    initDelayedCursor: function(restart) {
      var _this = this,
          delay = restart ? 0 : this.cursorDelay;

      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this._cursorTimeout2 = setTimeout(function() {
        _this._tick();
      }, delay);
    },

    /**
     * Aborts cursor animation and clears all timeouts
     */
    abortCursorAnimation: function() {
      var shouldClear = this._currentTickState || this._currentTickCompleteState,
          canvas = this.canvas;
      this._currentTickState && this._currentTickState.abort();
      this._currentTickCompleteState && this._currentTickCompleteState.abort();

      clearTimeout(this._cursorTimeout1);
      clearTimeout(this._cursorTimeout2);

      this._currentCursorOpacity = 0;
      // to clear just itext area we need to transform the context
      // it may not be worth it
      if (shouldClear && canvas) {
        canvas.clearContext(canvas.contextTop || canvas.contextContainer);
      }

    },

    /**
     * Selects entire text
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectAll: function() {
      this.selectionStart = 0;
      this.selectionEnd = this._text.length;
      this._fireSelectionChanged();
      this._updateTextarea();
      return this;
    },

    /**
     * Returns selected text
     * @return {String}
     */
    getSelectedText: function() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
    },

    /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryLeft: function(startFrom) {
      var offset = 0, index = startFrom - 1;

      // remove space before cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index--;
        }
      }
      while (/\S/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryRight: function(startFrom) {
      var offset = 0, index = startFrom;

      // remove space after cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index++;
        }
      }
      while (/\S/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryLeft: function(startFrom) {
      var offset = 0, index = startFrom - 1;

      while (!/\n/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }

      return startFrom - offset;
    },

    /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryRight: function(startFrom) {
      var offset = 0, index = startFrom;

      while (!/\n/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }

      return startFrom + offset;
    },

    /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */
    searchWordBoundary: function(selectionStart, direction) {
      var text = this._text,
          index     = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart,
          _char     = text[index],
          // wrong
          reNonWord = fabric.reNonWord;

      while (!reNonWord.test(_char) && index > 0 && index < text.length) {
        index += direction;
        _char = text[index];
      }
      if (reNonWord.test(_char)) {
        index += direction === 1 ? 0 : 1;
      }
      return index;
    },

    /**
     * Selects a word based on the index
     * @param {Number} selectionStart Index of a character
     */
    selectWord: function(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */
          newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */

      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
      this.renderCursorOrSelection();
    },

    /**
     * Selects a line based on the index
     * @param {Number} selectionStart Index of a character
     * @return {fabric.IText} thisArg
     * @chainable
     */
    selectLine: function(selectionStart) {
      selectionStart = selectionStart || this.selectionStart;
      var newSelectionStart = this.findLineBoundaryLeft(selectionStart),
          newSelectionEnd = this.findLineBoundaryRight(selectionStart);

      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
      return this;
    },

    /**
     * Enters editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    enterEditing: function(e) {
      if (this.isEditing || !this.editable) {
        return;
      }

      if (this.canvas) {
        this.canvas.calcOffset();
        this.exitEditingOnOthers(this.canvas);
      }

      this.isEditing = true;

      this.initHiddenTextarea(e);
      this.hiddenTextarea.focus();
      this.hiddenTextarea.value = this.text;
      this._updateTextarea();
      this._saveEditingProps();
      this._setEditingProps();
      this._textBeforeEdit = this.text;

      this._tick();
      this.fire('editing:entered');
      this._fireSelectionChanged();
      if (!this.canvas) {
        return this;
      }
      this.canvas.fire('text:editing:entered', { target: this });
      this.initMouseMoveHandler();
      this.canvas.requestRenderAll();
      return this;
    },

    exitEditingOnOthers: function(canvas) {
      if (canvas._iTextInstances) {
        canvas._iTextInstances.forEach(function(obj) {
          obj.selected = false;
          if (obj.isEditing) {
            obj.exitEditing();
          }
        });
      }
    },

    /**
     * Initializes "mousemove" event handler
     */
    initMouseMoveHandler: function() {
      this.canvas.on('mouse:move', this.mouseMoveHandler);
    },

    /**
     * @private
     */
    mouseMoveHandler: function(options) {
      if (!this.__isMousedown || !this.isEditing) {
        return;
      }

      var newSelectionStart = this.getSelectionStartFromPointer(options.e),
          currentStart = this.selectionStart,
          currentEnd = this.selectionEnd;
      if (
        (newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd)
        &&
        (currentStart === newSelectionStart || currentEnd === newSelectionStart)
      ) {
        return;
      }
      if (newSelectionStart > this.__selectionStartOnMouseDown) {
        this.selectionStart = this.__selectionStartOnMouseDown;
        this.selectionEnd = newSelectionStart;
      }
      else {
        this.selectionStart = newSelectionStart;
        this.selectionEnd = this.__selectionStartOnMouseDown;
      }
      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
        this.restartCursorIfNeeded();
        this._fireSelectionChanged();
        this._updateTextarea();
        this.renderCursorOrSelection();
      }
    },

    /**
     * @private
     */
    _setEditingProps: function() {
      this.hoverCursor = 'text';

      if (this.canvas) {
        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
      }

      this.borderColor = this.editingBorderColor;
      this.hasControls = this.selectable = false;
      this.lockMovementX = this.lockMovementY = true;
    },

    /**
     * convert from textarea to grapheme indexes
     */
    fromStringToGraphemeSelection: function(start, end, text) {
      var smallerTextStart = text.slice(0, start),
          graphemeStart = fabric.util.string.graphemeSplit(smallerTextStart).length;
      if (start === end) {
        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
      }
      var smallerTextEnd = text.slice(start, end),
          graphemeEnd = fabric.util.string.graphemeSplit(smallerTextEnd).length;
      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
    },

    /**
     * convert from fabric to textarea values
     */
    fromGraphemeToStringSelection: function(start, end, _text) {
      var smallerTextStart = _text.slice(0, start),
          graphemeStart = smallerTextStart.join('').length;
      if (start === end) {
        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
      }
      var smallerTextEnd = _text.slice(start, end),
          graphemeEnd = smallerTextEnd.join('').length;
      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
    },

    /**
     * @private
     */
    _updateTextarea: function() {
      this.cursorOffsetCache = { };
      if (!this.hiddenTextarea) {
        return;
      }
      if (!this.inCompositionMode) {
        var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
      }
      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateFromTextArea: function() {
      if (!this.hiddenTextarea) {
        return;
      }
      this.cursorOffsetCache = { };
      this.text = this.hiddenTextarea.value;
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }
      var newSelection = this.fromStringToGraphemeSelection(
        this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
      if (!this.inCompositionMode) {
        this.selectionStart = newSelection.selectionStart;
      }
      this.updateTextareaPosition();
    },

    /**
     * @private
     */
    updateTextareaPosition: function() {
      if (this.selectionStart === this.selectionEnd) {
        var style = this._calcTextareaPosition();
        this.hiddenTextarea.style.left = style.left;
        this.hiddenTextarea.style.top = style.top;
      }
    },

    /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */
    _calcTextareaPosition: function() {
      if (!this.canvas) {
        return { x: 1, y: 1 };
      }
      var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
          boundaries = this._getCursorBoundaries(desiredPosition),
          cursorLocation = this.get2DCursorLocation(desiredPosition),
          lineIndex = cursorLocation.lineIndex,
          charIndex = cursorLocation.charIndex,
          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
          leftOffset = boundaries.leftOffset,
          m = this.calcTransformMatrix(),
          p = {
            x: boundaries.left + leftOffset,
            y: boundaries.top + boundaries.topOffset + charHeight
          },
          retinaScaling = this.canvas.getRetinaScaling(),
          upperCanvas = this.canvas.upperCanvasEl,
          upperCanvasWidth = upperCanvas.width / retinaScaling,
          upperCanvasHeight = upperCanvas.height / retinaScaling,
          maxWidth = upperCanvasWidth - charHeight,
          maxHeight = upperCanvasHeight - charHeight,
          scaleX = upperCanvas.clientWidth / upperCanvasWidth,
          scaleY = upperCanvas.clientHeight / upperCanvasHeight;

      p = fabric.util.transformPoint(p, m);
      p = fabric.util.transformPoint(p, this.canvas.viewportTransform);
      p.x *= scaleX;
      p.y *= scaleY;
      if (p.x < 0) {
        p.x = 0;
      }
      if (p.x > maxWidth) {
        p.x = maxWidth;
      }
      if (p.y < 0) {
        p.y = 0;
      }
      if (p.y > maxHeight) {
        p.y = maxHeight;
      }

      // add canvas offset on document
      p.x += this.canvas._offset.left;
      p.y += this.canvas._offset.top;

      return { left: p.x + 'px', top: p.y + 'px', fontSize: charHeight + 'px', charHeight: charHeight };
    },

    /**
     * @private
     */
    _saveEditingProps: function() {
      this._savedProps = {
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        lockMovementX: this.lockMovementX,
        lockMovementY: this.lockMovementY,
        hoverCursor: this.hoverCursor,
        selectable: this.selectable,
        defaultCursor: this.canvas && this.canvas.defaultCursor,
        moveCursor: this.canvas && this.canvas.moveCursor
      };
    },

    /**
     * @private
     */
    _restoreEditingProps: function() {
      if (!this._savedProps) {
        return;
      }

      this.hoverCursor = this._savedProps.hoverCursor;
      this.hasControls = this._savedProps.hasControls;
      this.borderColor = this._savedProps.borderColor;
      this.selectable = this._savedProps.selectable;
      this.lockMovementX = this._savedProps.lockMovementX;
      this.lockMovementY = this._savedProps.lockMovementY;

      if (this.canvas) {
        this.canvas.defaultCursor = this._savedProps.defaultCursor;
        this.canvas.moveCursor = this._savedProps.moveCursor;
      }
    },

    /**
     * Exits from editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */
    exitEditing: function() {
      var isTextChanged = (this._textBeforeEdit !== this.text);
      var hiddenTextarea = this.hiddenTextarea;
      this.selected = false;
      this.isEditing = false;

      this.selectionEnd = this.selectionStart;

      if (hiddenTextarea) {
        hiddenTextarea.blur && hiddenTextarea.blur();
        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      }
      this.hiddenTextarea = null;
      this.abortCursorAnimation();
      this._restoreEditingProps();
      this._currentCursorOpacity = 0;
      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }
      this.fire('editing:exited');
      isTextChanged && this.fire('modified');
      if (this.canvas) {
        this.canvas.off('mouse:move', this.mouseMoveHandler);
        this.canvas.fire('text:editing:exited', { target: this });
        isTextChanged && this.canvas.fire('object:modified', { target: this });
      }
      return this;
    },

    /**
     * @private
     */
    _removeExtraneousStyles: function() {
      for (var prop in this.styles) {
        if (!this._textLines[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */
    removeStyleFromTo: function(start, end) {
      var cursorStart = this.get2DCursorLocation(start, true),
          cursorEnd = this.get2DCursorLocation(end, true),
          lineStart = cursorStart.lineIndex,
          charStart = cursorStart.charIndex,
          lineEnd = cursorEnd.lineIndex,
          charEnd = cursorEnd.charIndex,
          i, styleObj;
      if (lineStart !== lineEnd) {
        // step1 remove the trailing of lineStart
        if (this.styles[lineStart]) {
          for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
            delete this.styles[lineStart][i];
          }
        }
        // step2 move the trailing of lineEnd to lineStart if needed
        if (this.styles[lineEnd]) {
          for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
            styleObj = this.styles[lineEnd][i];
            if (styleObj) {
              this.styles[lineStart] || (this.styles[lineStart] = { });
              this.styles[lineStart][charStart + i - charEnd] = styleObj;
            }
          }
        }
        // step3 detects lines will be completely removed.
        for (i = lineStart + 1; i <= lineEnd; i++) {
          delete this.styles[i];
        }
        // step4 shift remaining lines.
        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
      }
      else {
        // remove and shift left on the same line
        if (this.styles[lineStart]) {
          styleObj = this.styles[lineStart];
          var diff = charEnd - charStart, numericChar, _char;
          for (i = charStart; i < charEnd; i++) {
            delete styleObj[i];
          }
          for (_char in this.styles[lineStart]) {
            numericChar = parseInt(_char, 10);
            if (numericChar >= charEnd) {
              styleObj[numericChar - diff] = styleObj[_char];
              delete styleObj[_char];
            }
          }
        }
      }
    },

    /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */
    shiftLineStyles: function(lineIndex, offset) {
      // shift all line styles by offset upward or downward
      // do not clone deep. we need new array, not new style objects
      var clonedStyles = clone(this.styles);
      for (var line in this.styles) {
        var numericLine = parseInt(line, 10);
        if (numericLine > lineIndex) {
          this.styles[numericLine + offset] = clonedStyles[numericLine];
          if (!clonedStyles[numericLine - offset]) {
            delete this.styles[numericLine];
          }
        }
      }
    },

    restartCursorIfNeeded: function() {
      if (!this._currentTickState || this._currentTickState.isAborted
        || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted
      ) {
        this.initDelayedCursor();
      }
    },

    /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */
    insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
      var currentCharStyle,
          newLineStyles = {},
          somethingAdded = false,
          isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;

      qty || (qty = 1);
      this.shiftLineStyles(lineIndex, qty);
      if (this.styles[lineIndex]) {
        currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
      }
      // we clone styles of all chars
      // after cursor onto the current line
      for (var index in this.styles[lineIndex]) {
        var numIndex = parseInt(index, 10);
        if (numIndex >= charIndex) {
          somethingAdded = true;
          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
          // remove lines from the previous line since they're on a new line now
          if (!(isEndOfLine && charIndex === 0)) {
            delete this.styles[lineIndex][index];
          }
        }
      }
      var styleCarriedOver = false;
      if (somethingAdded && !isEndOfLine) {
        // if is end of line, the extra style we copied
        // is probably not something we want
        this.styles[lineIndex + qty] = newLineStyles;
        styleCarriedOver = true;
      }
      if (styleCarriedOver) {
        // skip the last line of since we already prepared it.
        qty--;
      }
      // for the all the lines or all the other lines
      // we clone current char style onto the next (otherwise empty) line
      while (qty > 0) {
        if (copiedStyle && copiedStyle[qty - 1]) {
          this.styles[lineIndex + qty] = { 0: clone(copiedStyle[qty - 1]) };
        }
        else if (currentCharStyle) {
          this.styles[lineIndex + qty] = { 0: clone(currentCharStyle) };
        }
        else {
          delete this.styles[lineIndex + qty];
        }
        qty--;
      }
      this._forceClearCache = true;
    },

    /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */
    insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
      if (!this.styles) {
        this.styles = {};
      }
      var currentLineStyles       = this.styles[lineIndex],
          currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};

      quantity || (quantity = 1);
      // shift all char styles by quantity forward
      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
      for (var index in currentLineStylesCloned) {
        var numericIndex = parseInt(index, 10);
        if (numericIndex >= charIndex) {
          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
          // only delete the style if there was nothing moved there
          if (!currentLineStylesCloned[numericIndex - quantity]) {
            delete currentLineStyles[numericIndex];
          }
        }
      }
      this._forceClearCache = true;
      if (copiedStyle) {
        while (quantity--) {
          if (!Object.keys(copiedStyle[quantity]).length) {
            continue;
          }
          if (!this.styles[lineIndex]) {
            this.styles[lineIndex] = {};
          }
          this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
        }
        return;
      }
      if (!currentLineStyles) {
        return;
      }
      var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
      while (newStyle && quantity--) {
        this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
      }
    },

    /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */
    insertNewStyleBlock: function(insertedText, start, copiedStyle) {
      var cursorLoc = this.get2DCursorLocation(start, true),
          addedLines = [0], linesLength = 0;
      // get an array of how many char per lines are being added.
      for (var i = 0; i < insertedText.length; i++) {
        if (insertedText[i] === '\n') {
          linesLength++;
          addedLines[linesLength] = 0;
        }
        else {
          addedLines[linesLength]++;
        }
      }
      // for the first line copy the style from the current char position.
      if (addedLines[0] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
      }
      linesLength && this.insertNewlineStyleObject(
        cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
      for (var i = 1; i < linesLength; i++) {
        if (addedLines[i] > 0) {
          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        }
        else if (copiedStyle) {
          this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
        }
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
      }
      // we use i outside the loop to get it like linesLength
      if (addedLines[i] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
      }
    },

    /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */
    setSelectionStartEndWithShift: function(start, end, newSelection) {
      if (newSelection <= start) {
        if (end === start) {
          this._selectionDirection = 'left';
        }
        else if (this._selectionDirection === 'right') {
          this._selectionDirection = 'left';
          this.selectionEnd = start;
        }
        this.selectionStart = newSelection;
      }
      else if (newSelection > start && newSelection < end) {
        if (this._selectionDirection === 'right') {
          this.selectionEnd = newSelection;
        }
        else {
          this.selectionStart = newSelection;
        }
      }
      else {
        // newSelection is > selection start and end
        if (end === start) {
          this._selectionDirection = 'right';
        }
        else if (this._selectionDirection === 'left') {
          this._selectionDirection = 'right';
          this.selectionStart = end;
        }
        this.selectionEnd = newSelection;
      }
    },

    setSelectionInBoundaries: function() {
      var length = this.text.length;
      if (this.selectionStart > length) {
        this.selectionStart = length;
      }
      else if (this.selectionStart < 0) {
        this.selectionStart = 0;
      }
      if (this.selectionEnd > length) {
        this.selectionEnd = length;
      }
      else if (this.selectionEnd < 0) {
        this.selectionEnd = 0;
      }
    }
  });
})();


fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
  /**
   * Initializes "dbclick" event handler
   */
  initDoubleClickSimulation: function() {

    // for double click
    this.__lastClickTime = +new Date();

    // for triple click
    this.__lastLastClickTime = +new Date();

    this.__lastPointer = { };

    this.on('mousedown', this.onMouseDown);
  },

  /**
   * Default event handler to simulate triple click
   * @private
   */
  onMouseDown: function(options) {
    if (!this.canvas) {
      return;
    }
    this.__newClickTime = +new Date();
    var newPointer = options.pointer;
    if (this.isTripleClick(newPointer)) {
      this.fire('tripleclick', options);
      this._stopEvent(options.e);
    }
    this.__lastLastClickTime = this.__lastClickTime;
    this.__lastClickTime = this.__newClickTime;
    this.__lastPointer = newPointer;
    this.__lastIsEditing = this.isEditing;
    this.__lastSelected = this.selected;
  },

  isTripleClick: function(newPointer) {
    return this.__newClickTime - this.__lastClickTime < 500 &&
        this.__lastClickTime - this.__lastLastClickTime < 500 &&
        this.__lastPointer.x === newPointer.x &&
        this.__lastPointer.y === newPointer.y;
  },

  /**
   * @private
   */
  _stopEvent: function(e) {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
  },

  /**
   * Initializes event handlers related to cursor or selection
   */
  initCursorSelectionHandlers: function() {
    this.initMousedownHandler();
    this.initMouseupHandler();
    this.initClicks();
  },

  /**
   * Default handler for double click, select a word
   */
  doubleClickHandler: function(options) {
    if (!this.isEditing) {
      return;
    }
    this.selectWord(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Default handler for triple click, select a line
   */
  tripleClickHandler: function(options) {
    if (!this.isEditing) {
      return;
    }
    this.selectLine(this.getSelectionStartFromPointer(options.e));
  },

  /**
   * Initializes double and triple click event handlers
   */
  initClicks: function() {
    this.on('mousedblclick', this.doubleClickHandler);
    this.on('tripleclick', this.tripleClickHandler);
  },

  /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */
  _mouseDownHandler: function(options) {
    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
      return;
    }

    this.__isMousedown = true;

    if (this.selected) {
      this.inCompositionMode = false;
      this.setCursorByClick(options.e);
    }

    if (this.isEditing) {
      this.__selectionStartOnMouseDown = this.selectionStart;
      if (this.selectionStart === this.selectionEnd) {
        this.abortCursorAnimation();
      }
      this.renderCursorOrSelection();
    }
  },

  /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */
  _mouseDownHandlerBefore: function(options) {
    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
      return;
    }
    // we want to avoid that an object that was selected and then becomes unselectable,
    // may trigger editing mode in some way.
    this.selected = this === this.canvas._activeObject;
  },

  /**
   * Initializes "mousedown" event handler
   */
  initMousedownHandler: function() {
    this.on('mousedown', this._mouseDownHandler);
    this.on('mousedown:before', this._mouseDownHandlerBefore);
  },

  /**
   * Initializes "mouseup" event handler
   */
  initMouseupHandler: function() {
    this.on('mouseup', this.mouseUpHandler);
  },

  /**
   * standard hander for mouse up, overridable
   * @private
   */
  mouseUpHandler: function(options) {
    this.__isMousedown = false;
    if (!this.editable || this.group ||
      (options.transform && options.transform.actionPerformed) ||
      (options.e.button && options.e.button !== 1)) {
      return;
    }

    if (this.canvas) {
      var currentActive = this.canvas._activeObject;
      if (currentActive && currentActive !== this) {
        // avoid running this logic when there is an active object
        // this because is possible with shift click and fast clicks,
        // to rapidly deselect and reselect this object and trigger an enterEdit
        return;
      }
    }

    if (this.__lastSelected && !this.__corner) {
      this.selected = false;
      this.__lastSelected = false;
      this.enterEditing(options.e);
      if (this.selectionStart === this.selectionEnd) {
        this.initDelayedCursor(true);
      }
      else {
        this.renderCursorOrSelection();
      }
    }
    else {
      this.selected = true;
    }
  },

  /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {Event} e Event object
   */
  setCursorByClick: function(e) {
    var newSelection = this.getSelectionStartFromPointer(e),
        start = this.selectionStart, end = this.selectionEnd;
    if (e.shiftKey) {
      this.setSelectionStartEndWithShift(start, end, newSelection);
    }
    else {
      this.selectionStart = newSelection;
      this.selectionEnd = newSelection;
    }
    if (this.isEditing) {
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {Event} e Event object
   * @return {Number} Index of a character
   */
  getSelectionStartFromPointer: function(e) {
    var mouseOffset = this.getLocalPointer(e),
        prevWidth = 0,
        width = 0,
        height = 0,
        charIndex = 0,
        lineIndex = 0,
        lineLeftOffset,
        line;

    for (var i = 0, len = this._textLines.length; i < len; i++) {
      if (height <= mouseOffset.y) {
        height += this.getHeightOfLine(i) * this.scaleY;
        lineIndex = i;
        if (i > 0) {
          charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
        }
      }
      else {
        break;
      }
    }
    lineLeftOffset = this._getLineLeftOffset(lineIndex);
    width = lineLeftOffset * this.scaleX;
    line = this._textLines[lineIndex];
    for (var j = 0, jlen = line.length; j < jlen; j++) {
      prevWidth = width;
      // i removed something about flipX here, check.
      width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
      if (width <= mouseOffset.x) {
        charIndex++;
      }
      else {
        break;
      }
    }
    return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
  },

  /**
   * @private
   */
  _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
    // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
    var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth,
        distanceBtwNextCharAndCursor = width - mouseOffset.x,
        offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor ||
          distanceBtwNextCharAndCursor < 0 ? 0 : 1,
        newSelectionStart = index + offset;
    // if object is horizontally flipped, mirror cursor location from the end
    if (this.flipX) {
      newSelectionStart = jlen - newSelectionStart;
    }

    if (newSelectionStart > this._text.length) {
      newSelectionStart = this._text.length;
    }

    return newSelectionStart;
  }
});


fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {

  /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */
  initHiddenTextarea: function() {
    this.hiddenTextarea = fabric.document.createElement('textarea');
    this.hiddenTextarea.setAttribute('autocapitalize', 'off');
    this.hiddenTextarea.setAttribute('autocorrect', 'off');
    this.hiddenTextarea.setAttribute('autocomplete', 'off');
    this.hiddenTextarea.setAttribute('spellcheck', 'false');
    this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
    this.hiddenTextarea.setAttribute('wrap', 'off');
    var style = this._calcTextareaPosition();
    // line-height: 1px; was removed from the style to fix this:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
    this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top +
    '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' +
    ' paddingｰtop: ' + style.fontSize + ';';
    fabric.document.body.appendChild(this.hiddenTextarea);

    fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
    fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));

    if (!this._clickHandlerInitialized && this.canvas) {
      fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
      this._clickHandlerInitialized = true;
    }
  },

  /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behaviour for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the fabric.Itext or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = fabric.util.object.clone(this.keysMap);
   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
   */
  keysMap: {
    9:  'exitEditing',
    27: 'exitEditing',
    33: 'moveCursorUp',
    34: 'moveCursorDown',
    35: 'moveCursorRight',
    36: 'moveCursorLeft',
    37: 'moveCursorLeft',
    38: 'moveCursorUp',
    39: 'moveCursorRight',
    40: 'moveCursorDown',
  },

  /**
   * For functionalities on keyUp + ctrl || cmd
   */
  ctrlKeysMapUp: {
    67: 'copy',
    88: 'cut'
  },

  /**
   * For functionalities on keyDown + ctrl || cmd
   */
  ctrlKeysMapDown: {
    65: 'selectAll'
  },

  onClick: function() {
    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
    this.hiddenTextarea && this.hiddenTextarea.focus();
  },

  /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {Event} e Event object
   */
  onKeyDown: function(e) {
    if (!this.isEditing) {
      return;
    }
    if (e.keyCode in this.keysMap) {
      this[this.keysMap[e.keyCode]](e);
    }
    else if ((e.keyCode in this.ctrlKeysMapDown) && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapDown[e.keyCode]](e);
    }
    else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    if (e.keyCode >= 33 && e.keyCode <= 40) {
      // if i press an arrow key just update selection
      this.inCompositionMode = false;
      this.clearContextTop();
      this.renderCursorOrSelection();
    }
    else {
      this.canvas && this.canvas.requestRenderAll();
    }
  },

  /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {Event} e Event object
   */
  onKeyUp: function(e) {
    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
      this._copyDone = false;
      return;
    }
    if ((e.keyCode in this.ctrlKeysMapUp) && (e.ctrlKey || e.metaKey)) {
      this[this.ctrlKeysMapUp[e.keyCode]](e);
    }
    else {
      return;
    }
    e.stopImmediatePropagation();
    e.preventDefault();
    this.canvas && this.canvas.requestRenderAll();
  },

  /**
   * Handles onInput event
   * @param {Event} e Event object
   */
  onInput: function(e) {
    var fromPaste = this.fromPaste;
    this.fromPaste = false;
    e && e.stopPropagation();
    if (!this.isEditing) {
      return;
    }
    // decisions about style changes.
    var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
        charCount = this._text.length,
        nextCharCount = nextText.length,
        removedText, insertedText,
        charDiff = nextCharCount - charCount,
        selectionStart = this.selectionStart, selectionEnd = this.selectionEnd,
        selection = selectionStart !== selectionEnd,
        copiedStyle, removeFrom, removeTo;
    if (this.hiddenTextarea.value === '') {
      this.styles = { };
      this.updateFromTextArea();
      this.fire('changed');
      if (this.canvas) {
        this.canvas.fire('text:changed', { target: this });
        this.canvas.requestRenderAll();
      }
      return;
    }

    var textareaSelection = this.fromStringToGraphemeSelection(
      this.hiddenTextarea.selectionStart,
      this.hiddenTextarea.selectionEnd,
      this.hiddenTextarea.value
    );
    var backDelete = selectionStart > textareaSelection.selectionStart;

    if (selection) {
      removedText = this._text.slice(selectionStart, selectionEnd);
      charDiff += selectionEnd - selectionStart;
    }
    else if (nextCharCount < charCount) {
      if (backDelete) {
        removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
      }
      else {
        removedText = this._text.slice(selectionStart, selectionStart - charDiff);
      }
    }
    insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
    if (removedText && removedText.length) {
      if (insertedText.length) {
        // let's copy some style before deleting.
        // we want to copy the style before the cursor OR the style at the cursor if selection
        // is bigger than 0.
        copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
        // now duplicate the style one for each inserted text.
        copiedStyle = insertedText.map(function() {
          // this return an array of references, but that is fine since we are
          // copying the style later.
          return copiedStyle[0];
        });
      }
      if (selection) {
        removeFrom = selectionStart;
        removeTo = selectionEnd;
      }
      else if (backDelete) {
        // detect differencies between forwardDelete and backDelete
        removeFrom = selectionEnd - removedText.length;
        removeTo = selectionEnd;
      }
      else {
        removeFrom = selectionEnd;
        removeTo = selectionEnd + removedText.length;
      }
      this.removeStyleFromTo(removeFrom, removeTo);
    }
    if (insertedText.length) {
      if (fromPaste && insertedText.join('') === fabric.copiedText && !fabric.disableStyleCopyPaste) {
        copiedStyle = fabric.copiedTextStyle;
      }
      this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
    }
    this.updateFromTextArea();
    this.fire('changed');
    if (this.canvas) {
      this.canvas.fire('text:changed', { target: this });
      this.canvas.requestRenderAll();
    }
  },
  /**
   * Composition start
   */
  onCompositionStart: function() {
    this.inCompositionMode = true;
  },

  /**
   * Composition end
   */
  onCompositionEnd: function() {
    this.inCompositionMode = false;
  },

  // /**
  //  * Composition update
  //  */
  onCompositionUpdate: function(e) {
    this.compositionStart = e.target.selectionStart;
    this.compositionEnd = e.target.selectionEnd;
    this.updateTextareaPosition();
  },

  /**
   * Copies selected text
   * @param {Event} e Event object
   */
  copy: function() {
    if (this.selectionStart === this.selectionEnd) {
      //do not cut-copy if no selection
      return;
    }

    fabric.copiedText = this.getSelectedText();
    if (!fabric.disableStyleCopyPaste) {
      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
    }
    else {
      fabric.copiedTextStyle = null;
    }
    this._copyDone = true;
  },

  /**
   * Pastes text
   * @param {Event} e Event object
   */
  paste: function() {
    this.fromPaste = true;
  },

  /**
   * @private
   * @param {Event} e Event object
   * @return {Object} Clipboard data object
   */
  _getClipboardData: function(e) {
    return (e && e.clipboardData) || fabric.window.clipboardData;
  },

  /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */
  _getWidthBeforeCursor: function(lineIndex, charIndex) {
    var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;

    if (charIndex > 0) {
      bound = this.__charBounds[lineIndex][charIndex - 1];
      widthBeforeCursor += bound.left + bound.width;
    }
    return widthBeforeCursor;
  },

  /**
   * Gets start offset of a selection
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getDownCursorOffset: function(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
    // if on last line, down cursor goes to end of line
    if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
      // move to the end of a text
      return this._text.length - selectionProp;
    }
    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
        textAfterCursor = this._textLines[lineIndex].slice(charIndex);
    return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
  },

  /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  _getSelectionForOffset: function(e, isRight) {
    if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
      return this.selectionEnd;
    }
    else {
      return this.selectionStart;
    }
  },

  /**
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */
  getUpCursorOffset: function(e, isRight) {
    var selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
    if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
      // if on first line, up cursor goes to start of line
      return -selectionProp;
    }
    var charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
    // return a negative offset
    return -this._textLines[lineIndex - 1].length
     + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
  },

  /**
   * for a given width it founds the matching character.
   * @private
   */
  _getIndexOnLine: function(lineIndex, width) {

    var line = this._textLines[lineIndex],
        lineLeftOffset = this._getLineLeftOffset(lineIndex),
        widthOfCharsOnLine = lineLeftOffset,
        indexOnLine = 0, charWidth, foundMatch;

    for (var j = 0, jlen = line.length; j < jlen; j++) {
      charWidth = this.__charBounds[lineIndex][j].width;
      widthOfCharsOnLine += charWidth;
      if (widthOfCharsOnLine > width) {
        foundMatch = true;
        var leftEdge = widthOfCharsOnLine - charWidth,
            rightEdge = widthOfCharsOnLine,
            offsetFromLeftEdge = Math.abs(leftEdge - width),
            offsetFromRightEdge = Math.abs(rightEdge - width);

        indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : (j - 1);
        break;
      }
    }

    // reached end
    if (!foundMatch) {
      indexOnLine = line.length - 1;
    }

    return indexOnLine;
  },


  /**
   * Moves cursor down
   * @param {Event} e Event object
   */
  moveCursorDown: function(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }
    this._moveCursorUpOrDown('Down', e);
  },

  /**
   * Moves cursor up
   * @param {Event} e Event object
   */
  moveCursorUp: function(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }
    this._moveCursorUpOrDown('Up', e);
  },

  /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {Event} e Event object
   */
  _moveCursorUpOrDown: function(direction, e) {
    // getUpCursorOffset
    // getDownCursorOffset
    var action = 'get' + direction + 'CursorOffset',
        offset = this[action](e, this._selectionDirection === 'right');
    if (e.shiftKey) {
      this.moveCursorWithShift(offset);
    }
    else {
      this.moveCursorWithoutShift(offset);
    }
    if (offset !== 0) {
      this.setSelectionInBoundaries();
      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this.initDelayedCursor();
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Moves cursor with shift
   * @param {Number} offset
   */
  moveCursorWithShift: function(offset) {
    var newSelection = this._selectionDirection === 'left'
      ? this.selectionStart + offset
      : this.selectionEnd + offset;
    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
    return offset !== 0;
  },

  /**
   * Moves cursor up without shift
   * @param {Number} offset
   */
  moveCursorWithoutShift: function(offset) {
    if (offset < 0) {
      this.selectionStart += offset;
      this.selectionEnd = this.selectionStart;
    }
    else {
      this.selectionEnd += offset;
      this.selectionStart = this.selectionEnd;
    }
    return offset !== 0;
  },

  /**
   * Moves cursor left
   * @param {Event} e Event object
   */
  moveCursorLeft: function(e) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }
    this._moveCursorLeftOrRight('Left', e);
  },

  /**
   * @private
   * @return {Boolean} true if a change happened
   */
  _move: function(e, prop, direction) {
    var newValue;
    if (e.altKey) {
      newValue = this['findWordBoundary' + direction](this[prop]);
    }
    else if (e.metaKey || e.keyCode === 35 ||  e.keyCode === 36 ) {
      newValue = this['findLineBoundary' + direction](this[prop]);
    }
    else {
      this[prop] += direction === 'Left' ? -1 : 1;
      return true;
    }
    if (typeof newValue !== undefined && this[prop] !== newValue) {
      this[prop] = newValue;
      return true;
    }
  },

  /**
   * @private
   */
  _moveLeft: function(e, prop) {
    return this._move(e, prop, 'Left');
  },

  /**
   * @private
   */
  _moveRight: function(e, prop) {
    return this._move(e, prop, 'Right');
  },

  /**
   * Moves cursor left without keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithoutShift: function(e) {
    var change = true;
    this._selectionDirection = 'left';

    // only move cursor when there is no selection,
    // otherwise we discard it, and leave cursor on same place
    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
      change = this._moveLeft(e, 'selectionStart');

    }
    this.selectionEnd = this.selectionStart;
    return change;
  },

  /**
   * Moves cursor left while keeping selection
   * @param {Event} e
   */
  moveCursorLeftWithShift: function(e) {
    if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) {
      return this._moveLeft(e, 'selectionEnd');
    }
    else if (this.selectionStart !== 0){
      this._selectionDirection = 'left';
      return this._moveLeft(e, 'selectionStart');
    }
  },

  /**
   * Moves cursor right
   * @param {Event} e Event object
   */
  moveCursorRight: function(e) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }
    this._moveCursorLeftOrRight('Right', e);
  },

  /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {Event} e Event object
   */
  _moveCursorLeftOrRight: function(direction, e) {
    var actionName = 'moveCursor' + direction + 'With';
    this._currentCursorOpacity = 1;

    if (e.shiftKey) {
      actionName += 'Shift';
    }
    else {
      actionName += 'outShift';
    }
    if (this[actionName](e)) {
      this.abortCursorAnimation();
      this.initDelayedCursor();
      this._fireSelectionChanged();
      this._updateTextarea();
    }
  },

  /**
   * Moves cursor right while keeping selection
   * @param {Event} e
   */
  moveCursorRightWithShift: function(e) {
    if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) {
      return this._moveRight(e, 'selectionStart');
    }
    else if (this.selectionEnd !== this._text.length) {
      this._selectionDirection = 'right';
      return this._moveRight(e, 'selectionEnd');
    }
  },

  /**
   * Moves cursor right without keeping selection
   * @param {Event} e Event object
   */
  moveCursorRightWithoutShift: function(e) {
    var changed = true;
    this._selectionDirection = 'right';

    if (this.selectionStart === this.selectionEnd) {
      changed = this._moveRight(e, 'selectionStart');
      this.selectionEnd = this.selectionStart;
    }
    else {
      this.selectionStart = this.selectionEnd;
    }
    return changed;
  },

  /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  removeChars: function(start, end) {
    if (typeof end === 'undefined') {
      end = start + 1;
    }
    this.removeStyleFromTo(start, end);
    this._text.splice(start, end - start);
    this.text = this._text.join('');
    this.set('dirty', true);
    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }
    this._removeExtraneousStyles();
  },

  /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */
  insertChars: function(text, style, start, end) {
    if (typeof end === 'undefined') {
      end = start;
    }
    if (end > start) {
      this.removeStyleFromTo(start, end);
    }
    var graphemes = fabric.util.string.graphemeSplit(text);
    this.insertNewStyleBlock(graphemes, start, style);
    this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
    this.text = this._text.join('');
    this.set('dirty', true);
    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }
    this._removeExtraneousStyles();
  },

});


/* _TO_SVG_START_ */
(function() {
  var toFixed = fabric.util.toFixed,
      multipleSpacesRegex = /  +/g;

  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {

    /**
     * Returns SVG representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG: function() {
      var offsets = this._getSVGLeftTopOffsets(),
          textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
      return this._wrapSVGTextAndBg(textAndBg);
    },

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG: function(reviver) {
      return this._createBaseSVGMarkup(
        this._toSVG(),
        { reviver: reviver, noStyle: true, withShadow: true }
      );
    },

    /**
     * @private
     */
    _getSVGLeftTopOffsets: function() {
      return {
        textLeft: -this.width / 2,
        textTop: -this.height / 2,
        lineTop: this.getHeightOfLine(0)
      };
    },

    /**
     * @private
     */
    _wrapSVGTextAndBg: function(textAndBg) {
      var noShadow = true,
          textDecoration = this.getSvgTextDecoration(this);
      return [
        textAndBg.textBgRects.join(''),
        '\t\t<text xml:space="preserve" ',
        (this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : ''),
        (this.fontSize ? 'font-size="' + this.fontSize + '" ' : ''),
        (this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : ''),
        (this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : ''),
        (textDecoration ? 'text-decoration="' + textDecoration + '" ' : ''),
        'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >',
        textAndBg.textSpans.join(''),
        '</text>\n'
      ];
    },

    /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */
    _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
      var textSpans = [],
          textBgRects = [],
          height = textTopOffset, lineOffset;
      // bounding-box background
      this._setSVGBg(textBgRects);

      // text and text-background
      for (var i = 0, len = this._textLines.length; i < len; i++) {
        lineOffset = this._getLineLeftOffset(i);
        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
        }
        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
        height += this.getHeightOfLine(i);
      }

      return {
        textSpans: textSpans,
        textBgRects: textBgRects
      };
    },

    /**
     * @private
     */
    _createTextCharSpan: function(_char, styleDecl, left, top) {
      var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex),
          styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace),
          fillStyles = styleProps ? 'style="' + styleProps + '"' : '',
          dy = styleDecl.deltaY, dySpan = '',
          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
      if (dy) {
        dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
      }
      return [
        '<tspan x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="',
        toFixed(top, NUM_FRACTION_DIGITS), '" ', dySpan,
        fillStyles, '>',
        fabric.util.string.escapeXml(_char),
        '</tspan>'
      ].join('');
    },

    _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
      // set proper line offset
      var lineHeight = this.getHeightOfLine(lineIndex),
          isJustify = this.textAlign.indexOf('justify') !== -1,
          actualStyle,
          nextStyle,
          charsToRender = '',
          charBox, style,
          boxWidth = 0,
          line = this._textLines[lineIndex],
          timeToRender;

      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
      for (var i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          textLeftOffset += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
        }
        if (timeToRender) {
          style = this._getStyleDeclaration(lineIndex, i) || { };
          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
          charsToRender = '';
          actualStyle = nextStyle;
          textLeftOffset += boxWidth;
          boxWidth = 0;
        }
      }
    },

    _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
      textBgRects.push(
        '\t\t<rect ',
        this._getFillAttributes(color),
        ' x="',
        toFixed(left, NUM_FRACTION_DIGITS),
        '" y="',
        toFixed(top, NUM_FRACTION_DIGITS),
        '" width="',
        toFixed(width, NUM_FRACTION_DIGITS),
        '" height="',
        toFixed(height, NUM_FRACTION_DIGITS),
        '"></rect>\n');
    },

    _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
      var line = this._textLines[i],
          heightOfLine = this.getHeightOfLine(i) / this.lineHeight,
          boxWidth = 0,
          boxStart = 0,
          charBox, currentColor,
          lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
      for (var j = 0, jlen = line.length; j < jlen; j++) {
        charBox = this.__charBounds[i][j];
        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
        if (currentColor !== lastColor) {
          lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart,
            textTopOffset, boxWidth, heightOfLine);
          boxStart = charBox.left;
          boxWidth = charBox.width;
          lastColor = currentColor;
        }
        else {
          boxWidth += charBox.kernedWidth;
        }
      }
      currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart,
        textTopOffset, boxWidth, heightOfLine);
    },

    /**
     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
     *
     * @private
     * @param {*} value
     * @return {String}
     */
    _getFillAttributes: function(value) {
      var fillColor = (value && typeof value === 'string') ? new fabric.Color(value) : '';
      if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
        return 'fill="' + value + '"';
      }
      return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
    },

    /**
     * @private
     */
    _getSVGLineTopOffset: function(lineIndex) {
      var lineTopOffset = 0, lastHeight = 0;
      for (var j = 0; j < lineIndex; j++) {
        lineTopOffset += this.getHeightOfLine(j);
      }
      lastHeight = this.getHeightOfLine(j);
      return {
        lineTop: lineTopOffset,
        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
      };
    },

    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles: function(skipShadow) {
      var svgStyle = fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
      return svgStyle + ' white-space: pre;';
    },
  });
})();
/* _TO_SVG_END_ */


(function(global) {

  'use strict';

  var fabric = global.fabric || (global.fabric = {});

  /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   * @class fabric.Textbox
   * @extends fabric.IText
   * @mixes fabric.Observable
   * @return {fabric.Textbox} thisArg
   * @see {@link fabric.Textbox#initialize} for constructor definition
   */
  fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {

    /**
     * Type of an object
     * @type String
     * @default
     */
    type: 'textbox',

    /**
     * Minimum width of textbox, in pixels.
     * @type Number
     * @default
     */
    minWidth: 20,

    /**
     * Minimum calculated width of a textbox, in pixels.
     * fixed to 2 so that an empty textbox cannot go to 0
     * and is still selectable without text.
     * @type Number
     * @default
     */
    dynamicMinWidth: 2,

    /**
     * Cached array of text wrapping.
     * @type Array
     */
    __cachedLines: null,

    /**
     * Override standard Object class values
     */
    lockScalingFlip: true,

    /**
     * Override standard Object class values
     * Textbox needs this on false
     */
    noScaleCache: false,

    /**
     * Properties which when set cause object to change dimensions
     * @type Object
     * @private
     */
    _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),

    /**
     * Use this regular expression to split strings in breakable lines
     * @private
     */
    _wordJoiners: /[ \t\r]/,

    /**
     * Use this boolean property in order to split strings that have no white space concept.
     * this is a cheap way to help with chinese/japaense
     * @type Boolean
     * @since 2.6.0
     */
    splitByGrapheme: false,

    /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */
    initDimensions: function() {
      if (this.__skipDimension) {
        return;
      }
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this._clearCache();
      // clear dynamicMinWidth as it will be different after we re-wrap line
      this.dynamicMinWidth = 0;
      // wrap lines
      this._styleMap = this._generateStyleMap(this._splitText());
      // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
      if (this.dynamicMinWidth > this.width) {
        this._set('width', this.dynamicMinWidth);
      }
      if (this.textAlign.indexOf('justify') !== -1) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
      // clear cache and re-calculate height
      this.height = this.calcTextHeight();
      this.saveState({ propertySet: '_dimensionAffectingProps' });
    },

    /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */
    _generateStyleMap: function(textInfo) {
      var realLineCount     = 0,
          realLineCharCount = 0,
          charCount         = 0,
          map               = {};

      for (var i = 0; i < textInfo.graphemeLines.length; i++) {
        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
          realLineCharCount = 0;
          charCount++;
          realLineCount++;
        }
        else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
          // this case deals with space's that are removed from end of lines when wrapping
          realLineCharCount++;
          charCount++;
        }

        map[i] = { line: realLineCount, offset: realLineCharCount };

        charCount += textInfo.graphemeLines[i].length;
        realLineCharCount += textInfo.graphemeLines[i].length;
      }

      return map;
    },

    /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */
    styleHas: function(property, lineIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];
        if (map) {
          lineIndex = map.line;
        }
      }
      return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
    },

    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles: function(lineIndex) {
      if (!this.styles) {
        return true;
      }
      var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false,
          map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
      if (map) {
        lineIndex = map.line;
        offset = map.offset;
      }
      if (mapNextLine) {
        nextLineIndex = mapNextLine.line;
        shouldLimit = nextLineIndex === lineIndex;
        nextOffset = mapNextLine.offset;
      }
      obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
      for (var p1 in obj) {
        for (var p2 in obj[p1]) {
          if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
            // eslint-disable-next-line no-unused-vars
            for (var p3 in obj[p1][p2]) {
              return false;
            }
          }
        }
      }
      return true;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _getStyleDeclaration: function(lineIndex, charIndex) {
      if (this._styleMap && !this.isWrapping) {
        var map = this._styleMap[lineIndex];
        if (!map) {
          return null;
        }
        lineIndex = map.line;
        charIndex = map.offset + charIndex;
      }
      return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration: function(lineIndex, charIndex, style) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;

      this.styles[lineIndex][charIndex] = style;
    },

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration: function(lineIndex, charIndex) {
      var map = this._styleMap[lineIndex];
      lineIndex = map.line;
      charIndex = map.offset + charIndex;
      delete this.styles[lineIndex][charIndex];
    },

    /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle: function(lineIndex) {
      var map = this._styleMap[lineIndex];
      return !!this.styles[map.line];
    },

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */
    _setLineStyle: function(lineIndex) {
      var map = this._styleMap[lineIndex];
      this.styles[map.line] = {};
    },

    /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */
    _wrapText: function(lines, desiredWidth) {
      var wrapped = [], i;
      this.isWrapping = true;
      for (i = 0; i < lines.length; i++) {
        wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
      }
      this.isWrapping = false;
      return wrapped;
    },

    /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * it gets called when charBounds are not available yet.
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     * @private
     */
    _measureWord: function(word, lineIndex, charOffset) {
      var width = 0, prevGrapheme, skipLeft = true;
      charOffset = charOffset || 0;
      for (var i = 0, len = word.length; i < len; i++) {
        var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
        width += box.kernedWidth;
        prevGrapheme = word[i];
      }
      return width;
    },

    /**
     * Wraps a line of text using the width of the Textbox and a context.
     * @param {Array} line The grapheme array that represent the line
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */
    _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
      var lineWidth = 0,
          splitByGrapheme = this.splitByGrapheme,
          graphemeLines = [],
          line = [],
          // spaces in different languges?
          words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners),
          word = '',
          offset = 0,
          infix = splitByGrapheme ? '' : ' ',
          wordWidth = 0,
          infixWidth = 0,
          largestWordWidth = 0,
          lineJustStarted = true,
          additionalSpace = this._getWidthOfCharSpacing(),
          reservedSpace = reservedSpace || 0;
      // fix a difference between split and graphemeSplit
      if (words.length === 0) {
        words.push([]);
      }
      desiredWidth -= reservedSpace;
      for (var i = 0; i < words.length; i++) {
        // if using splitByGrapheme words are already in graphemes.
        word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
        wordWidth = this._measureWord(word, lineIndex, offset);
        offset += word.length;

        lineWidth += infixWidth + wordWidth - additionalSpace;
        if (lineWidth >= desiredWidth && !lineJustStarted) {
          graphemeLines.push(line);
          line = [];
          lineWidth = wordWidth;
          lineJustStarted = true;
        }
        else {
          lineWidth += additionalSpace;
        }

        if (!lineJustStarted && !splitByGrapheme) {
          line.push(infix);
        }
        line = line.concat(word);

        infixWidth = splitByGrapheme ? 0 : this._measureWord([infix], lineIndex, offset);
        offset++;
        lineJustStarted = false;
        // keep track of largest word
        if (wordWidth > largestWordWidth) {
          largestWordWidth = wordWidth;
        }
      }

      i && graphemeLines.push(line);

      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
      }
      return graphemeLines;
    },

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */
    isEndOfWrapping: function(lineIndex) {
      if (!this._styleMap[lineIndex + 1]) {
        // is last line, return true;
        return true;
      }
      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
        // this is last line before a line break, return true;
        return true;
      }
      return false;
    },

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * @return Number
     */
    missingNewlineOffset: function(lineIndex) {
      if (this.splitByGrapheme) {
        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
      }
      return 1;
    },

    /**
    * Gets lines of text to render in the Textbox. This function calculates
    * text wrapping on the fly every time it is called.
    * @param {String} text text to split
    * @returns {Array} Array of lines in the Textbox.
    * @override
    */
    _splitTextIntoLines: function(text) {
      var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
          graphemeLines = this._wrapText(newText.lines, this.width),
          lines = new Array(graphemeLines.length);
      for (var i = 0; i < graphemeLines.length; i++) {
        lines[i] = graphemeLines[i].join('');
      }
      newText.lines = lines;
      newText.graphemeLines = graphemeLines;
      return newText;
    },

    getMinWidth: function() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    },

    _removeExtraneousStyles: function() {
      var linesToKeep = {};
      for (var prop in this._styleMap) {
        if (this._textLines[prop]) {
          linesToKeep[this._styleMap[prop].line] = 1;
        }
      }
      for (var prop in this.styles) {
        if (!linesToKeep[prop]) {
          delete this.styles[prop];
        }
      }
    },

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject: function(propertiesToInclude) {
      return this.callSuper('toObject', ['minWidth', 'splitByGrapheme'].concat(propertiesToInclude));
    }
  });

  /**
   * Returns fabric.Textbox instance from an object representation
   * @static
   * @memberOf fabric.Textbox
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
   */
  fabric.Textbox.fromObject = function(object, callback) {
    return fabric.Object._fromObject('Textbox', object, callback, 'text');
  };
})( true ? exports : this);


(function() {

  var controlsUtils = fabric.controlsUtils,
      scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler,
      scaleStyleHandler = controlsUtils.scaleCursorStyleHandler,
      scalingEqually = controlsUtils.scalingEqually,
      scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX,
      scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY,
      scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName,
      objectControls = fabric.Object.prototype.controls;

  objectControls.ml = new fabric.Control({
    x: -0.5,
    y: 0,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingXOrSkewingY,
    getActionName: scaleOrSkewActionName,
  });

  objectControls.mr = new fabric.Control({
    x: 0.5,
    y: 0,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingXOrSkewingY,
    getActionName: scaleOrSkewActionName,
  });

  objectControls.mb = new fabric.Control({
    x: 0,
    y: 0.5,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingYOrSkewingX,
    getActionName: scaleOrSkewActionName,
  });

  objectControls.mt = new fabric.Control({
    x: 0,
    y: -0.5,
    cursorStyleHandler: scaleSkewStyleHandler,
    actionHandler: scalingYOrSkewingX,
    getActionName: scaleOrSkewActionName,
  });

  objectControls.tl = new fabric.Control({
    x: -0.5,
    y: -0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });

  objectControls.tr = new fabric.Control({
    x: 0.5,
    y: -0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });

  objectControls.bl = new fabric.Control({
    x: -0.5,
    y: 0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });

  objectControls.br = new fabric.Control({
    x: 0.5,
    y: 0.5,
    cursorStyleHandler: scaleStyleHandler,
    actionHandler: scalingEqually
  });

  objectControls.mtr = new fabric.Control({
    x: 0,
    y: -0.5,
    actionHandler: controlsUtils.rotationWithSnapping,
    cursorStyleHandler: controlsUtils.rotationStyleHandler,
    offsetY: -40,
    withConnection: true,
    actionName: 'rotate',
  });

  if (fabric.Textbox) {
    // this is breaking the prototype inheritance, no time / ideas to fix it.
    // is important to document that if you want to have all objects to have a
    // specific custom control, you have to add it to Object prototype and to Textbox
    // prototype. The controls are shared as references. So changes to control `tr`
    // can still apply to all objects if needed.
    var textBoxControls = fabric.Textbox.prototype.controls = { };

    textBoxControls.mtr = objectControls.mtr;
    textBoxControls.tr = objectControls.tr;
    textBoxControls.br = objectControls.br;
    textBoxControls.tl = objectControls.tl;
    textBoxControls.bl = objectControls.bl;
    textBoxControls.mt = objectControls.mt;
    textBoxControls.mb = objectControls.mb;

    textBoxControls.mr = new fabric.Control({
      x: 0.5,
      y: 0,
      actionHandler: controlsUtils.changeWidth,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionName: 'resizing',
    });

    textBoxControls.ml = new fabric.Control({
      x: -0.5,
      y: 0,
      actionHandler: controlsUtils.changeWidth,
      cursorStyleHandler: scaleSkewStyleHandler,
      actionName: 'resizing',
    });
  }
})();


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(111).Buffer))

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */
/***/ (function(module, exports) {

module.exports = "<p class=\"text-center login__text\">\n    <strong translate=\"reset_your_password\"></strong>\n    <br /><span translate=\"reset_your_password_istructions\"></span>\n</p>\n<form name=\"ctrl.forgotPasswordForm\" method=\"post\" ng-submit=\"ctrl.submit()\" class=\"form-validate-on-submit\" novalidate role=\"form\">\n    <div class=\"form-group has-feedback\">\n        <label class=\"login__label \" translate=\"email_label\"></label>\n        <input type=\"email\"\n        translate translate-attr-placeholder=\"your_email\"\n        name=\"email\" ng-model=\"ctrl.email\"\n        ng-pattern=\"ctrl.emailPattern\"\n        required\n        autocomplete=\"off\"\n        class=\"form-control login__input mb16\" />\n        <span ng-show=\"ctrl.submitted && ctrl.forgotPasswordForm.email.$invalid\">\n            <span ng-show=\"ctrl.forgotPasswordForm.email.$error.required\" class=\"text-danger\"\n            translate=\"email_is_required\" ></span>\n            <span ng-show=\"ctrl.forgotPasswordForm.email.$error.email\" class=\"text-danger\"\n            translate=\"email_is_invalid\" ></span>\n        </span>\n    </div>\n    <button type=\"submit\" ng-disabled=\"ctrl.waiting\" class=\"btn btn-block login__btn mb32\" translate=\"reset_password_str\"></button>\n    <!-- <div class=\"login__link text-center\">\n        <a ui-sref=\"account.selectRole\" translate=\"forgot_password\"></a>\n    </div> -->\n</form>\n<div class=\"text-center login__link\">\n    <a ui-sref=\"account.login\" class=\"text-muted\" translate=\"return_to_login\"></a>\n</div>";

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = " <form name=\"ctrl.loginForm\" method=\"post\" ng-submit=\"ctrl.submit()\" class=\"form-validate-on-submit\" novalidate role=\"form\">\n    <div class=\"mb24\">\n        <label for=\"email\" class=\"login__label\" translate=\"username_or_email\"></label>\n        <input type=\"text\"\n               translate translate-attr-placeholder=\"your_username_or_email\"\n               name=\"email\"\n               ng-model=\"ctrl.email\"\n               required\n               autocomplete=\"off\"\n               class=\"form-control login__input mb0\"\n               id=\"email\"/>\n        <span ng-show=\"ctrl.submitted && ctrl.loginForm.email.$invalid && ctrl.loginForm.email.$error.required\"\n              class=\"text-danger login__error\"\n              translate=\"email_is_required\" >\n        </span>\n        <span ng-show=\"ctrl.submitted && ctrl.loginForm.email.$invalid && ctrl.loginForm.email.$error.email\"\n              class=\"text-danger login__error\"\n              translate=\"email_is_invalid\" >\n        </span>\n    </div>\n    <div class=\"mb32 posRel passwordField\">\n        <label for=\"password\" class=\"login__label\" translate=\"password\"></label>\n        <input translate translate-attr-placeholder=\"your_password\"\n               type=\"password\"\n               show-password=\"ctrl.showPassword\"\n               autocapitalize=\"off\"\n               name=\"password\"\n               ng-model=\"ctrl.password\"\n               required\n               class=\"form-control login__input mb0\" id=\"password\" />\n        <span class=\"login__show-pass\"\n              ng-click=\"ctrl.showPassword = !ctrl.showPassword\">\n        </span>\n        <span ng-show=\"ctrl.submitted && ctrl.loginForm.password.$invalid && ctrl.loginForm.password.$error.required\"\n              class=\"text-danger login__error\"\n              translate=\"password_is_required\">\n        </span>\n    </div>\n    <button type=\"submit\"\n            ng-disabled=\"waiting\"\n            class=\"btn btn-block login__btn mb32\"\n            translate=\"login\" >\n    </button>\n</form>\n";

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "<!--Header-->\n<div class=\"modal-header--redesign bb\">\n    <button type=\"button\"\n            data-dismiss=\"modal\"\n            aria-hidden=\"true\"\n            class=\"close\"\n            ng-click=\"ctrl.closeDialog()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"retailer_profile_change_email_dialog_title\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.changeEmailForm\"\n          class=\"form-validate-on-submit pb5\"\n          novalidate\n          autocomplete=\"off\">\n        <div>\n            <div>\n                <div class=\"form-group\">\n                    <label class=\"fw-400\" translate=\"retailer_profile_change_email_dialog_new_email\"></label>\n                    <input type=\"email\"\n                           name=\"newEmail\"\n                           ng-model=\"ctrl.changeEmail.Email\"\n                           ng-change=\"ctrl.changeEmailModel()\"\n                           ng-disabled=\"ctrl.waiting\"\n                           ng-pattern=\"ctrl.emailPattern\"\n                           unique-email\n                           required\n                           autocomplete=\"off\" class=\"form-control\"/>\n                    <span ng-show=\"ctrl.changeEmailForm.newEmail.$error.required && ctrl.changeEmailForm.newEmail.$dirty\"\n                          class=\"text-danger\" translate=\"email_is_required\"></span>\n                    <span ng-show=\"ctrl.changeEmailForm.newEmail.$error.email && ctrl.changeEmailForm.newEmail.$dirty\"\n                          class=\"text-danger\" translate=\"email_is_invalid\"></span>\n                    <span ng-show=\"ctrl.changeEmailForm.newEmail.$error.isunique && ctrl.changeEmailForm.newEmail.$dirty\"\n                          class=\"text-danger\" translate=\"email_is_in_use\"></span>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"fw-400\" translate=\"retailer_profile_change_email_dialog_confirm_email\"></label>\n                    <input type=\"email\"\n                           name=\"confirmEmail\"\n                           ng-model=\"ctrl.confirmEmail\"\n                           ng-change=\"ctrl.changeEmailModel()\"\n                           ng-disabled=\"ctrl.waiting\"\n                           autocomplete=\"off\"\n                           required class=\"form-control\"/>\n                    <span ng-show=\"ctrl.changeEmailForm.confirmEmail.$error.match && ctrl.changeEmailForm.confirmEmail.$dirty\"\n                          class=\"text-danger\"\n                          translate=\"emails_do_not_match\">\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"fw-400\" translate=\"retailer_profile_change_email_dialog_confirm_password\"></label>\n                <input type=\"password\"\n                       name=\"changeEmailPassword\"\n                       ng-model=\"ctrl.changeEmail.Password\"\n                       ng-disabled=\"ctrl.waiting\"\n                       ng-minlength=\"8\"\n                       ng-maxlength=\"128\"\n                       autocapitalize=\"off\"\n                       required\n                       class=\"form-control\"/>\n                <span ng-show=\"ctrl.changeEmailForm.changeEmailPassword.$error.required && ctrl.changeEmailForm.changeEmailPassword.$dirty\"\n                      class=\"text-danger\" translate=\"new_password_is_required\"></span>\n                <span ng-show=\"ctrl.changeEmailForm.changeEmailPassword.$error.maxlength && ctrl.changeEmailForm.changeEmailPassword.$dirty\"\n                      class=\"text-danger\" translate=\"password_too_long\"></span>\n                <span ng-show=\"ctrl.changeEmailForm.changeEmailPassword.$error.minlength && ctrl.changeEmailForm.changeEmailPassword.$dirty\"\n                      class=\"text-danger\" translate=\"password_too_short\"></span>\n            </div>\n        </div>\n    </form>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\"\n                ng-click=\"ctrl.closeDialog()\"\n                class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"retailer_profile_change_email_dialog_cancel\"></span>\n        </button>\n        <button type=\"button\"\n                ng-click=\"ctrl.updateEmail()\"\n                ng-disabled=\"ctrl.changeEmailForm.$invalid || ctrl.waiting\"\n                class=\"btn btn-success btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"retailer_profile_change_email_dialog_ok\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<!--Header-->\n<div class=\"modal-header--redesign bb\">\n    <button type=\"button\"\n            data-dismiss=\"modal\"\n            aria-hidden=\"true\"\n            class=\"close\"\n            ng-click=\"ctrl.closeDialog()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"retailer_profile_change_password_dialog_title\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.changePasswordForm\"\n          method=\"post\"\n          class=\"form-validate-on-submit pb5\"\n          novalidate\n          autocomplete=\"off\">\n        <div>\n            <div>\n                <div class=\"form-group\">\n                    <label class=\"fw-400\" translate=\"retailer_profile_change_password_dialog_current_password\"></label>\n                    <input type=\"password\"\n                           name=\"currentPassword\"\n                           ng-model=\"ctrl.changePassword.Password\"\n                           ng-disabled=\"ctrl.waiting\"\n                           ng-minlength=\"8\"\n                           ng-maxlength=\"128\"\n                           autocapitalize=\"off\"\n                           autocomplete=\"off\"\n                           required class=\"form-control\"/>\n                    <span ng-show=\"ctrl.changePasswordForm.currentPassword.$error.required && ctrl.changePasswordForm.currentPassword.$dirty\"\n                          class=\"text-danger\" translate=\"new_password_is_required\"></span>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"fw-400\" translate=\"retailer_profile_change_password_dialog_new_password\"></label>\n                    <input type=\"password\"\n                           name=\"newPassword\"\n                           ng-model=\"ctrl.changePassword.NewPassword\"\n                           ng-disabled=\"ctrl.waiting\"\n                           ng-change=\"ctrl.changePasswordModel()\"\n                           ng-minlength=\"8\"\n                           ng-maxlength=\"128\"\n                           autocomplete=\"off\"\n                           autocapitalize=\"off\"\n                           required class=\"form-control\"/>\n                    <span ng-show=\"ctrl.changePasswordForm.newPassword.$error.required && ctrl.changePasswordForm.newPassword.$dirty\"\n                          class=\"text-danger\" translate=\"new_password_is_required\"></span>\n                    <span ng-show=\"ctrl.changePasswordForm.newPassword.$error.minlength && ctrl.changePasswordForm.newPassword.$dirty\"\n                          class=\"text-danger\" translate=\"password_too_short\"></span>\n                    <span ng-show=\"ctrl.changePasswordForm.newPassword.$error.maxlength && ctrl.changePasswordForm.newPassword.$dirty\"\n                          class=\"text-danger\" translate=\"password_too_long\"></span>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"fw-400\" translate=\"retailer_profile_change_password_dialog_confirm_password\"></label>\n                    <input type=\"password\"\n                           name=\"confirmPassword\"\n                           ng-model=\"ctrl.confirmPassword\"\n                           ng-change=\"ctrl.changePasswordModel()\"\n                           ng-disabled=\"ctrl.waiting\"\n                           autocapitalize=\"off\"\n                           autocomplete=\"off\"\n                           required class=\"form-control\"/>\n                    <span ng-show=\"ctrl.changePasswordForm.confirmPassword.$error.match && ctrl.changePasswordForm.confirmPassword.$dirty\"\n                          class=\"text-danger\" translate=\"passwords_do_not_match\"></span>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\"\n                ng-click=\"ctrl.closeDialog()\"\n                class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"retailer_profile_change_password_dialog_cancel\"></span>\n        </button>\n        <button type=\"button\"\n                ng-click=\"ctrl.submitChangePassword()\"\n                ng-disabled=\"ctrl.changePasswordForm.$invalid || ctrl.waiting\"\n                class=\"btn btn-success  btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"retailer_profile_change_password_dialog_ok\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2 class=\"profile-id\"><span translate=\"profile_id\"></span> &ndash; <span ng-bind=\"ctrl.profile.ID\"></span> </h2>\n    <div class=\"row row-store\">\n\n        <div ng-show=\"ctrl.profileLoaded\" class=\"col-lg-12 fw\">\n            <div class=\"panel\">\n                <div class=\"panel-body overflowVisible\" style=\"height: auto\">\n                    <form name=\"ctrl.profileForm\" autocomplete=\"off\" novalidate>\n                        <div class=\"row menu-editor pb24 row flex-input-container\">\n                            <div>\n                                <div ng-if=\"!ctrl.profileImage\"\n                                    class=\"menu-editor-placeholder icon-placeholder-plus clickable profile-image \"\n                                    ng-click=\"ctrl.addImage()\"></div>\n                                <div ng-if=\"ctrl.profileImage\" class=\"d-block\">\n                                    <div>\n                                        <img ng-src=\"{{ctrl.profileImage}}\" ng-click=\"ctrl.addImage()\"\n                                            class=\"menu-editor-placeholder profile-image clickable\" />\n                                    </div>\n                                    <a class=\"clickable\" ng-click=\"ctrl.deleteProfileImage(ctrl.profile.LogoID)\">\n                                        <span class=\"fa fa-trash mr5\"></span>\n                                        <span translate=\"remove_photo\"></span>\n                                    </a>\n                                </div>\n                            </div>\n                            <div class=\"flex-stretch pr0 pl52\">\n                                <label class=\"control-label\" for=\"profileStory\" translate=\"profile_story\"></label>\n                                <div class=\"form-group m0\">\n                                    <textarea ng-model=\"ctrl.profile.Story\" ng-minlength=\"1\" ng-maxlength=\"1000\" class=\"w-100 max-h120 min-h120 rounded-4 form-control no-resize\"\n                                        name=\"profileStory\"></textarea>\n                                    <span ng-hide=\"ctrl.profileForm.profileStory.$error.maxlength\" class=\"grayNote\" translate=\"max_1000_characters\"></span>\n                                    <span ng-show=\"ctrl.profileForm.profileStory.$error.maxlength\" class=\"text-danger\"\n                                    translate=\"profile_story_too_long\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"mr-19 ml-19 pl19 pr19 bb pb24 mb24\">\n                            <label class=\"control-label\" for=\"companyName\" translate=\"company_name_required\"></label>\n                            <div class=\"form-group mb24\">\n                                <input type=\"text\" name=\"companyName\" ng-model=\"ctrl.profile.CompanyName\"\n                                    autocomplete=\"off\" ng-minlength=\"3\" ng-maxlength=\"100\" required class=\"form-control\"\n                                    ng-disabled=\"ctrl.profile.Permission == ctrl.permissionType.StoreManager || ctrl.waiting\" />\n                                <span ng-show=\"ctrl.profileForm.companyName.$error.required  && ctrl.profileForm.$dirty\"\n                                    class=\"text-danger\" translate=\"company_name_is_required\"></span>\n                                <span ng-show=\"ctrl.profileForm.companyName.$error.maxlength\" class=\"text-danger\"\n                                    translate=\"company_name_too_long\"></span>\n                                <span ng-show=\"ctrl.profileForm.companyName.$error.minlength\" class=\"text-danger\"\n                                    translate=\"company_name_too_short\"></span>\n                            </div>\n\n                            <div class=\"d-flex\">\n                                <div class=\"mr24 width320\">\n                                    <label class=\"control-label\" for=\"countryName\" translate=\"country\"></label>\n                                    <div class=\"form-group mb24\">\n                                        <input type=\"text\" name=\"countryName\" ng-model=\"ctrl.profile.CountryName\"\n                                            readonly class=\"form-control\" />\n                                    </div>\n                                </div>\n                                <div class=\"width320 mr24 mb24\">\n                                    <label class=\"control-label\" for=\"language\" translate=\"language\"></label>\n                                    <div uib-dropdown class=\"input-group-btn dropdown--in-modal\">\n                                        <button type=\"button\" uib-dropdown-toggle\n                                            class=\"btn btn-default dropdown-toggle text-left fw flexVerticalAlignParent rounded-4 pl12 pr12\"\n                                            aria-haspopup=\"true\" aria-expanded=\"false\">\n                                            <span ng-hide=\"ctrl.selectedLanguage\">\n                                            </span>\n                                            <span class=\"text-gray-dark\" ng-show=\"ctrl.selectedLanguage\">\n                                                {{ctrl.selectedLanguage.Name}}\n                                            </span>\n                                            <span class=\"caret ml-auto\"></span>\n                                        </button>\n                                        <ul class=\"dropdown-menu fw\">\n                                            <li ng-repeat=\"option in ctrl.languages\"\n                                                ng-click=\"ctrl.selectedLanguage = option; ctrl.profileForm.$setDirty()\">\n                                                <a href=\"#\">{{option.Name}}</a>\n                                            </li>\n                                        </ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"bb pb24\">\n                            <div class=\"d-flex\">\n                                <div class=\"mr24 width320\">\n                                    <label class=\"control-label\" for=\"firstName\" translate=\"first_name_required\"></label>\n                                    <div class=\"form-group mb24\">\n                                        <input type=\"text\" name=\"firstName\" ng-model=\"ctrl.profile.FirstName\"\n                                               autocomplete=\"off\" ng-minlength=\"1\" ng-maxlength=\"20\" ng-disabled=\"ctrl.waiting\"\n                                               required class=\"form-control\" />\n                                        <span\n                                            ng-show=\"ctrl.profileForm.firstName.$error.required && ctrl.profileForm.$dirty\"\n                                            class=\"text-danger\" translate=\"first_name_is_required\"></span>\n                                        <span ng-show=\"ctrl.profileForm.firstName.$error.maxlength\" class=\"text-danger\"\n                                              translate=\"first_name_too_long\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"width320\">\n                                    <label class=\"control-label\" for=\"lastName\" translate=\"last_name_required_is\"></label>\n                                    <div class=\"form-group mb24\">\n                                        <input type=\"text\" name=\"lastName\" ng-model=\"ctrl.profile.LastName\"\n                                               autocomplete=\"off\" ng-minlength=\"1\" ng-maxlength=\"20\" ng-disabled=\"ctrl.waiting\"\n                                               required class=\"form-control\" />\n                                        <span\n                                            ng-show=\"ctrl.profileForm.lastName.$error.required  && ctrl.profileForm.$dirty\"\n                                            class=\"text-danger\" translate=\"last_name_is_requied\"></span>\n                                        <span ng-show=\"ctrl.profileForm.lastName.$error.maxlength\" class=\"text-danger\"\n                                              translate=\"last_name_too_long\"></span>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"d-flex\">\n                                <div class=\"mr24 width320\">\n                                    <label class=\"control-label\" for=\"phone\">\n                                    <span ng-show=\"ctrl.profile.Permission == ctrl.permissionType.Retailer\"\n                                          translate=\"telephone_required\"></span>\n                                        <span ng-show=\"ctrl.profile.Permission == ctrl.permissionType.StoreManager\"\n                                              translate=\"company_telephone\"></span>\n                                    </label>\n                                    <div class=\"form-group\">\n                                        <phone-number-control id=\"signupInputPhone\"\n                                                              class=\"form-control\"\n                                                              name=\"phone\"\n                                                              ng-model=\"ctrl.phoneNumberControl\"\n                                                              ng-model-options=\"{ allowInvalid: true, updateOn: 'default', debounce: 0 }\"\n                                                              min-number-length=\"2\"\n                                                              max-number-length=\"17\"\n                                                              append-to-body=\"false\"\n                                                              model=\"ctrl.profile.PhoneNumber.PhoneNumberWithoutCode\"\n                                                              country-phone-code-i-d=\"ctrl.profile.PhoneNumber.CountryPhoneCodeID\"\n                                                              required\n                                        ></phone-number-control>\n\n\n                                        <span ng-show=\"!ctrl.profile.PhoneNumber.PhoneNumberWithoutCode.length\"\n                                              class=\"text-danger\" translate=\"phone_number_is_required\"></span>\n                                        <span ng-show=\"ctrl.profile.PhoneNumber.PhoneNumberWithoutCode.length > 17\" class=\"text-danger\"\n                                              translate=\"phone_number_too_long_17\"></span>\n                                        <span ng-show=\"ctrl.profile.PhoneNumber.PhoneNumberWithoutCode && ctrl.profile.PhoneNumber.PhoneNumberWithoutCode.length < 2\" class=\"text-danger\"\n                                              translate=\"phone_number_too_short_2\"></span>\n\n                                    </div>\n                                </div>\n\n                                <div class=\"width320\">\n                                    <label class=\"control-label\" translate=\"register_new_retailer_whats_app\"></label>\n                                    <phone-number-control\n                                        class=\"form-control\"\n                                        name=\"whatsApp\"\n                                        ng-model=\"ctrl.whatsAppNumberControl\"\n                                        ng-model-options=\"{ allowInvalid: true, updateOn: 'default', debounce: 0 }\"\n                                        min-number-length=\"2\"\n                                        max-number-length=\"17\"\n                                        append-to-body=\"false\"\n                                        model=\"ctrl.profile.WhatsAppNumber.PhoneNumberWithoutCode\"\n                                        country-phone-code-i-d=\"ctrl.profile.WhatsAppNumber.CountryPhoneCodeID\"\n\n                                    ></phone-number-control>\n\n                                    <span ng-show=\"ctrl.profile.WhatsAppNumber.PhoneNumberWithoutCode.length > 17\" class=\"text-danger\"\n                                          translate=\"phone_number_too_long_17\"></span>\n                                    <span ng-show=\"ctrl.profile.WhatsAppNumber.PhoneNumberWithoutCode && ctrl.profile.WhatsAppNumber.PhoneNumberWithoutCode.length < 2\" class=\"text-danger\"\n                                          translate=\"phone_number_too_short_2\"></span>\n                                </div>\n                            </div>\n\n                            <div class=\"d-flex\">\n                                <div class=\"mr24 width320\">\n                                    <label class=\"control-label\" for=\"email\" translate=\"email\"></label>\n                                    <div class=\"form-group mb24\">\n                                        <input name=\"email\" type=\"email\" ng-model=\"ctrl.profile.Email\" readonly unique-email\n                                               required class=\"form-control\" />\n                                    </div>\n                                </div>\n                                <div class=\"mt24\">\n                                    <button ng-click=\"ctrl.openChangeEmailDialog()\" ng-disabled=\"ctrl.waiting\"\n                                            class=\"btn btnWhitePurple\">\n                                        <span translate=\"retailer_profile_change_email_button\"></span>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <div class=\"row\">\n                            <div class=\"col-md-6 mr10 mb24 pt32\">\n                                <button ng-click=\"ctrl.openChangePasswordDialog()\" ng-disabled=\"ctrl.waiting\"\n                                    class=\"btn btnWhitePurple\">\n                                    <span translate=\"retailer_profile_change_password\"></span>\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n                <div class=\"panel-footer clearfix\">\n                    <div class=\"pull-right\">\n                        <button ng-click=\"ctrl.updateProfile()\"\n                            ng-disabled=\"ctrl.waiting || ctrl.profileForm.$pristine || ctrl.profileForm.$invalid \"\n                            class=\"btn btn-success add-btn pull-right\">\n                            <span class=\"icon-tick--small icon24 mr8\"></span>\n                            <span translate=\"retailer_profile_apply_button\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 705 */
/***/ (function(module, exports) {

module.exports = "<p class=\"text-center login__text mb37\">\n    <strong translate=\"assistant_password_recovery\"></strong><br />\n    <span translate=\"report_your_need_for_password\"></span>\n</p>\n<button ui-sref=\"account.login\" class=\"btn btn-block login__btn mb32\" translate=\"return_to_login\"></button>\n<div class=\"text-center mt10\">\n\n</div>\n";

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "<p class=\"text-center login__text mb37\">\n    <strong translate=\"set_your_new_password\"></strong>\n    <br/><span translate=\"password_instructions\"></span>\n</p>\n<form name=\"ctrl.resetPasswordForm\" method=\"post\" ng-submit=\"ctrl.submit()\" class=\"form-validate-on-submit login__new-pass\" novalidate role=\"form\">\n    <div class=\"posRel\">\n        <label for=\"new_password\" class=\"login__label\" translate=\"password\"></label>\n        <input type=\"password\"\n        translate translate-attr-placeholder=\"your_password\"\n        name=\"password\"\n        autocapitalize=\"off\"\n        ng-model=\"ctrl.password\"\n        autocomplete=\"off\"\n        ng-minlength=\"8\"\n        ng-maxlength=\"20\"\n        required\n        class=\"form-control login__input\"\n        show-password=\"ctrl.showPassword\"\n        id=\"new_password\" />\n        <span class=\"login__show-pass\" ng-click=\"ctrl.showPassword = !ctrl.showPassword\"></span>\n        <span ng-show=\"ctrl.errorPassword && ctrl.resetPasswordForm.password.$invalid\" class=\"text-danger\" ng-bind=\"errorPassword\"></span>\n    </div>\n    <div class=\"mb32 posRel\">\n        <label for=\"confirm_password\" class=\"login__label\" translate=\"confirm_password_v2\"></label>\n        <input type=\"password\"\n        translate translate-attr-placeholder=\"confirm_password\"\n        autocapitalize=\"off\"\n        name=\"confirmPassword\"\n        ng-model=\"ctrl.confirmPassword\"\n        required\n        ng-match=\"ctrl.password\"\n        autocomplete=\"off\"\n        class=\"form-control login__input\"\n        show-password=\"ctrl.showConfirmPassword\"\n        id=\"confirm_password\" />\n        <span class=\"login__show-pass\" ng-click=\"ctrl.showConfirmPassword = !ctrl.showConfirmPassword\"></span>\n        <span ng-show=\"ctrl.errorConfirmPassword && ctrl.resetPasswordForm.confirmPassword.$invalid\" class=\"text-danger\" ng-bind=\"errorConfirmPassword\"></span>\n    </div>\n    <button type=\"submit\" ng-disabled=\"ctrl.waiting\" class=\"btn btn-block login__btn mb32\" translate=\"button_set_password\"></button>\n</form>\n";

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center login__text mb20 login__success-title\">\n    <strong class=\"block\" translate=\"reset_success_title\"></strong>\n    <span class=\"block\" translate=\"reset_success_description\"></span>\n</div>\n<a ui-sref=\"account.login\" class=\"btn-block login__btn mb32\" translate=\"return_to_login\"></a>";

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "<div class=\"login__select-role\">\n    <p class=\"text-center login__text mb37\">\n        <span translate=\"password_recovery\"></span>\n        <br /><strong translate=\"select_your_position\"></strong>\n    </p>\n\n    <div class=\"select-role__wrap mb32\">\n        <a ui-sref=\"account.forgot\" class=\"select-role__position\">\n            <span class=\"select-role__position--big\" translate=\"role_manager_retailer\"></span><br />\n            <span class=\"select-role__position--small\" translate=\"using_email_to_log_in\"></span>\n            <span class=\"select-role__arrow\"></span>\n        </a>\n        <a ui-sref=\"account.reportSupervisor\" class=\"select-role__position\">\n            <span class=\"select-role__position--big\" translate=\"role_assistant\"></span><br />\n            <span class=\"select-role__position--small\" translate=\"using_username_to_log_in\"></span>\n            <span class=\"select-role__arrow\"></span>\n        </a>\n    </div>\n    <div class=\"login__link text-center\">\n        <a ui-sref=\"account.login\" translate=\"return_to_login\"></a>\n    </div>\n</div>";

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span class=\"fs-20 \">Analytics</span>\n</div>\n\n<div class=\"analytics\">\n    <staff-rating-analytics></staff-rating-analytics>\n</div>\n\n<!-- <div class=\"analytics\">\n    <div class=\"analytics__cards\">\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">Beacons</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--pie\">\n                <div class=\"pie-chart posRel\">\n                    <svg width=\"96\" height=\"96\" viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <mask id=\"mask0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"96\" height=\"96\">\n                        <circle cx=\"48\" cy=\"48\" r=\"40\" stroke=\"black\" stroke-width=\"16\"/>\n                        </mask>\n                        <g mask=\"url(#mask0)\">\n                        <rect x=\"48\" width=\"48\" height=\"48\" fill=\"#B39DDB\"/>\n                        <path d=\"M0 0H48V48H96V96H0V0Z\" fill=\"#E0E0E4\"/>\n                        </g>\n                        </svg>\n                    <span class=\"pie-chart__num\"><span class=\"pie-chart__num-centerer\">1480</span></span>\n                </div>\n                <ul class=\"chart-legend\">\n                    <li class=\"chart-legend__item chart-legend__item--purple\">Internal pickups</li>\n                    <li class=\"chart-legend__item chart-legend__item--gray\">Door traffic</li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">AdPoint</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--columns\">\n                <svg width=\"259\" height=\"76\" viewBox=\"0 0 259 76\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" d=\"M0 0h259v76H0z\"/><path stroke=\"#E0E0E4\" d=\"M.5.5h258v75H.5z\"/><path fill=\"#B39DDB\" d=\"M37 33h40v42H37z\"/><path fill=\"#FFCC80\" d=\"M109 8h40v67h-40z\"/><path fill=\"#A5D6A7\" d=\"M181 51h40v24h-40z\"/></svg>\n                <ul class=\"chart-legend\">\n                    <li class=\"chart-legend__item  chart-legend__item--purple\">Notified</li>\n                    <li class=\"chart-legend__item  chart-legend__item--yellow\">Selected</li>\n                    <li class=\"chart-legend__item  chart-legend__item--green\">Accessed</li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">jispSTICKERS</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--pie\">\n                <div class=\"pie-chart posRel\">\n                    <svg width=\"96\" height=\"96\" viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <mask id=\"mask0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"96\" height=\"96\">\n                        <circle cx=\"48\" cy=\"48\" r=\"40\" stroke=\"black\" stroke-width=\"16\"/>\n                        </mask>\n                        <g mask=\"url(#mask0)\">\n                        <path d=\"M48 -1L96 0L92 12L48 48V-1Z\" fill=\"#EF9A9A\"/>\n                        <path d=\"M0 0H48V48L-3.5 61.5L0 0Z\" fill=\"#B39DDB\"/>\n                        <path d=\"M48 48L97 7.5L96 96L90.5 83.5L48 48Z\" fill=\"#FFCC80\"/>\n                        <path d=\"M-2 61L48 48L30 98L0 96L-2 61Z\" fill=\"#A5D6A7\"/>\n                        <path d=\"M48 48L89.5 82.5L96 96L28.5 101L48 48Z\" fill=\"#90CAF9\"/>\n                        </g>\n                        </svg>\n                    <span class=\"pie-chart__num\"><span class=\"pie-chart__num-centerer\">2865</span></span>\n                </div>\n                <ul class=\"chart-legend\">\n                    <li class=\"chart-legend__item chart-legend__item--red\">Discarded</li>\n                    <li class=\"chart-legend__item chart-legend__item--yellow\">Saved</li>\n                    <li class=\"chart-legend__item chart-legend__item--blue\">Liked</li>\n                    <li class=\"chart-legend__item chart-legend__item--green\">Shared</li>\n                    <li class=\"chart-legend__item chart-legend__item--purple\">Bought</li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">jispPAY</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--pie\">\n                <div class=\"pie-chart posRel\">\n                    <svg width=\"96\" height=\"96\" viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <mask id=\"mask0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"96\" height=\"96\">\n                        <circle cx=\"48\" cy=\"48\" r=\"40\" stroke=\"black\" stroke-width=\"16\"/>\n                        </mask>\n                        <g mask=\"url(#mask0)\">\n                        <path d=\"M47.9996 -6.5L95.1948 -0.517671L99.9999 99.5003L47.9995 48.0003L47.9996 -6.5Z\" fill=\"#B39DDB\"/>\n                        <path d=\"M-0.62605 5.34251L48.0003 -2.49947L48.0003 48.0008L-5.49984 39L-0.62605 5.34251Z\" fill=\"#EF9A9A\"/>\n                        <path d=\"M-17.4993 36.9998L48 48L88 87.5L27.0005 114L-17.4993 36.9998Z\" fill=\"#FFCC80\"/>\n                        </g>\n                        </svg>\n                    <span class=\"pie-chart__num\"><span class=\"pie-chart__num-centerer\">1148</span></span>\n                </div>\n                <ul class=\"chart-legend\">\n                    <li class=\"chart-legend__item chart-legend__item--purple\">Click&Collect</li>\n                    <li class=\"chart-legend__item chart-legend__item--yellow\">In-store</li>\n                    <li class=\"chart-legend__item chart-legend__item--red\">Click&Deliver</li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">jispGO</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--story\">\n                <ul class=\"story__list chart-legend\">\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--purple\">1264</span>\n                        <span class=\"story__item-text\">Customers served today</span>\n                    </li>\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--yellow\">246</span>\n                        <span class=\"story__item-text\">Required staff help</span>\n                    </li>\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--red\">32</span>\n                        <span class=\"story__item-text\">Anomalies</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">Loyalty</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--story\">\n                <ul class=\"story__list chart-legend\">\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--purple\">1148</span>\n                        <span class=\"story__item-text\">Users gained points</span>\n                    </li>\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--red\">116</span>\n                        <span class=\"story__item-text\">Users didn’t gained points</span>\n                    </li>\n                    <li class=\"story__item\">\n                        <span class=\"story__item-num story__item-num--yellow\">523</span>\n                        <span class=\"story__item-text\">Vouchers used</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"cards__item\">\n            <div class=\"cards__item-name\">\n                <span class=\"item-name__inner\">Overall jisp usage</span>\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\"/></svg>\n            </div>\n            <div class=\"cards__item-inner cards__item-inner--overall\">\n                <div class=\"overall-list\">\n                    <div class=\"overall-list__row\">\n                        <div class=\"overall__item pb8\">\n                            <span class=\"overall__item-num\">24835</span>\n                            <span class=\"overall__item-text\">Users in total</span>\n                        </div>\n                        <div class=\"overall__item\">\n                            <span class=\"overall__item-num\">685</span>\n                            <span class=\"overall__item-text\">Beacons in use</span>\n                        </div>\n                        <div class=\"overall__item\">\n                            <span class=\"overall__item-num\">16942</span>\n                            <span class=\"overall__item-text\">People picked</span>\n                        </div>\n                    </div>\n                    <div class=\"overall-list__row\">\n                        <div class=\"overall__item\">\n                            <span class=\"overall__item-num\">24835</span>\n                            <span class=\"overall__item-text\">Using loyalty</span>\n                        </div>\n                        <div class=\"overall__item\">\n                            <span class=\"overall__item-num\">685</span>\n                            <span class=\"overall__item-text\">Campaigns running</span>\n                        </div>\n                        <div class=\"overall__item\">\n                            <span class=\"overall__item-num\">2</span>\n                            <span class=\"overall__item-text\">Locations</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div> -->\n\n    </div>\n</div>\n\n<!-- <div class=\"warnings\">\n    <div class=\"soon-overlay\">\n        <div class=\"soon-overlay__inner text-center\">\n            <div class=\"soon-overlay__icon\">\n                <div class=\"soon-overlay__icon-inner\"><svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" d=\"M0 0h48v48H0z\"/><path d=\"M24 34c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm12-18h-2v-4c0-5.52-4.48-10-10-10S14 6.48 14 12h3.8c0-3.42 2.78-6.2 6.2-6.2 3.42 0 6.2 2.78 6.2 6.2v4H12c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V20c0-2.2-1.8-4-4-4zm0 24H12V20h24v20z\" fill=\"#795B9A\"/></svg>\n                </div>\n            </div>\n            <div class=\"soon-overlay__text\">\n                Coming soon\n            </div>\n        </div>\n    </div>\n</div> -->\n";

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<flot dataset=\"vm.filteredDataset\" options=\"vm.options\" height=\"200px\"></flot>\n<div>\n    <label ng-repeat=\"item in vm.dataset\" ng-class=\"{'disabledLabel' : item.selected && vm.filteredDataset.length === 1}\">\n        <input type=\"checkbox\" ng-model=\"item.selected\" ng-change=\"vm.changeLegend()\" ng-disabled=\"item.selected && vm.filteredDataset.length === 1\"\n        />\n        <span class=\"colorMark\" ng-style=\"{ 'background-color': item.color,'border-color': item.color  }\"></span>\n        <span class=\"text\">{{ item.total | number }} {{ item.label }}</span>\n    </label>\n</div>";

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tableFilter clearfix\">\n    <div class=\"text-nowrap pr5 pull-left lh37\" translate=\"date_range\" ></div>\n    <div class=\"pull-left\">\n        <div class=\"input-group hasHiddenBtn\">\n            <input type=\"text\"\n                   uib-datepicker-popup=\"dd MMM yyyy\"\n                   ng-model=\"vm.filter.startDate\"\n                   datepicker-options=\"vm.dateOptions\"\n                   name=\"startDate\"\n                   is-open=\"openStartDate\"\n                   close-text=\"Close\"\n                   readonly\n                   class=\"form-control\" />\n            <span class=\"input-group-btn\">\n                <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); openStartDate = true;\" class=\"btn btn-default\">\n                    <em class=\"fa fa-calendar\"></em>\n                </button>\n            </span>\n        </div>\n    </div>\n    <div class=\"pl5 pr5 pull-left lh37\">-</div>\n    <div class=\"pull-left\">\n        <div class=\"input-group pull-left hasHiddenBtn\">\n            <input type=\"text\"\n                   uib-datepicker-popup=\"dd MMM yyyy\"\n                   ng-model=\"vm.filter.endDate\"\n                   datepicker-options=\"vm.dateOptions\"\n                   name=\"endDate\"\n                   is-open=\"openEndDate\"\n                   close-text=\"{{::'close' | translate}}\"\n                   clear-text=\"{{::'clear' | translate}}\"\n                   current-text=\"{{::'today' | translate}}\"\n                   readonly\n                   class=\"form-control\" />\n            <span class=\"input-group-btn\">\n                <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); openEndDate = true;\" class=\"btn btn-default\">\n                    <em class=\"fa fa-calendar\"></em>\n                </button>\n            </span>\n        </div>\n    </div>\n    <div class=\"selectPeriod pull-right\">\n        <div class=\"btn-group\">\n            <label ng-repeat=\"item in vm.breakdowns\" ng-model=\"vm.filter.breakdown\" uib-btn-radio=\"item\" ng-bind=\"item\" class=\"btn btn-default\"></label>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info mb0\">\n    <div class=\"panel-heading\">\n        <div class=\"panel-title\" translate=\"analytics\" >\n        </div>\n    </div>\n    <div class=\"panel-body  pt0  customAnaliticsFilter heightForCalendar\">\n        <analytics-filter filter=\"vm.filter\" breakdowns=\"vm.breakdowns\"></analytics-filter>\n        <div class=\"tableImit\" ng-if=\"vm.dataset && vm.dataset.length !== 0\">\n            <analytics-chart dataset=\"vm.dataset\" time-format=\"vm.timeFormat\" tooltip-format=\"vm.tooltipFormat\" />\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info  \">\n    <div class=\"panel-heading\">\n        <div class=\"panel-title\" translate=\"place_campaign_analytics\" ></div>\n    </div>\n    <div class=\"panel-body pt0 pb0 customAnaliticsFilter\">\n        <analytics-filter filter=\"vm.filter\" breakdowns=\"vm.breakdowns\"></analytics-filter>\n        <div></div>\n        <div class=\"withoutTab\" ng-if=\"vm.dataset\">\n            <analytics-chart dataset=\"vm.dataset\" time-format=\"vm.timeFormat\" tooltip-format=\"vm.tooltipFormat\" />\n        </div>\n    </div>\n</div>";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info  \">\n    <div class=\"panel-heading\">\n        <div class=\"panel-title\" translate=\"impressions\" ></div>\n    </div>\n    <div class=\"panel-body pt0 pb0 customAnaliticsFilter\">\n        <analytics-filter filter=\"vm.filter\" breakdowns=\"vm.breakdowns\"></analytics-filter>\n        <div class=\"withoutTab\" ng-if=\"vm.dataset\">\n            <analytics-chart dataset=\"vm.dataset\" time-format=\"vm.timeFormat\" tooltip-format=\"vm.tooltipFormat\" />\n        </div>\n    </div>\n</div>";

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info \">\n    <div class=\"panel-heading\">\n        <div class=\"panel-title\" translate=\"place_visit_analytics\" ></div>\n    </div>\n    <div class=\"panel-body pt0 pb0 customAnaliticsFilter\">\n        <analytics-filter filter=\"vm.filter\" breakdowns=\"vm.breakdowns\"></analytics-filter>\n        <div class=\"ng-isolate-scope\">\n            <ul class=\"nav nav-tabs\">\n                <li ng-repeat=\"tab in vm.tabs\" ng-class=\"{ active: tab === vm.filter.group }\">\n                    <a ng-click=\"vm.switchTab(tab)\" ng-bind=\"tab\"></a>\n                </li>\n            </ul>\n            <div class=\"tab-content\">\n                <div class=\"tab-pane active\" ng-if=\"vm.dataset\">\n                    <analytics-chart dataset=\"vm.dataset\" time-format=\"vm.timeFormat\" tooltip-format=\"vm.tooltipFormat\" />\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "<!-- <div class=\"cards__item\">\n    <div class=\"cards__item-name\">\n        <span class=\"item-name__inner\">Staff rating</span>\n        <a ui-sref=\"app.staff-ratings\" style=\"margin-left: auto;\">\n            <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\" /></svg>\n        </a>\n    </div>\n    <p style=\"margin-bottom: 0;\">AverageRating: {{vm.viewModel.AverageRating}}</p>\n    <p style=\"margin-bottom: 0;\">FeedbackCount: {{vm.viewModel.FeedbackCount}}</p>\n    <div class=\"cards__item-inner\">\n        <span style=\"flex-basis: 100%;\">Display for buyers</span>\n        <label class=\"switch switch-success posRel\">\n            <input type=\"checkbox\" ng-click=\"vm.switchStaffRatingDisplay()\" ng-disabled=\"vm.waiting\"\n                ng-model=\"vm.viewModel.AllowViewRating\"\n                class=\"ng-pristine ng-untouched ng-valid ng-not-empty\">\n            <span></span>\n        </label>\n    </div>\n</div> -->\n\n<div class=\"analytics__cards\">\n    <div class=\"cards__item panel mt24\">\n        <div class=\"cards__item-name mb17\">\n            <span class=\"item-name__inner fw-500\" translate=\"staff_rating\"></span>\n            <a ui-sref=\"app.staff-ratings\" style=\"margin-left: auto;\">\n                <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                    <path d=\"M8 0L6.59 1.41 12.17 7H0v2h12.17l-5.58 5.59L8 16l8-8-8-8z\" fill=\"#000\" fill-opacity=\".6\">\n                    </path>\n                </svg>\n            </a>\n        </div>\n        <div class=\"cards__item-inner--rating\">\n            <div class=\"rating\">\n                <span class=\"rating__caption mb3 fs-14\" translate=\"average_staff_rating\"></span>\n                <rating-stars rating=\"vm.viewModel.AverageRating\" stars-count=\"vm.viewModel.StarsCount\" show-label=\"true\"></rating-stars>\n            </div>\n            <div class=\"flex-align-start\">\n                <div class=\"feedback flex-column\">\n                    <span class=\"feedback__caption mb10 fs-14\" translate=\"feedback\"></span>\n                    <span class=\"feedback__number fs-14 fw-500\">{{vm.viewModel.FeedbackCount}}</span>\n                </div>\n                <div class=\"form-group flex-column ml-auto\" ng-show=\"vm.isRetailer\">\n                    <label class=\"control-label mb10 text-normal fs-14\" translate=\"display_for_buyers\"></label>\n                    <div class=\"posRel\">\n                        <div class=\"form-control-static m0 p0\">\n                            <label class=\"switch switch-primary posRel\">\n                                <input type=\"checkbox\" ng-click=\"vm.switchStaffRatingDisplay()\" ng-disabled=\"vm.waiting\" ng-model=\"vm.viewModel.AllowViewRating\">\n                                <span></span>\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"$ctrl.brand\" class=\"brandSingle\" ng-class=\"{ brandSingleNotApr: $ctrl.isPending(), brandSingleRejected: $ctrl.isRejected() }\">\n    <span ng-if=\"$ctrl.isPending()\" class=\"fa fa-warning\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"\n        tooltip-class=\"mlTooltip\" uib-tooltip-html=\"$ctrl.htmlTooltip.awaitingApproval\"></span>\n    <span ng-if=\"$ctrl.isRejected()\" class=\"fa fa-warning\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"\n        tooltip-class=\"mlTooltip\" uib-tooltip-html=\"$ctrl.htmlTooltip.rejected\"></span>\n    <span ng-bind=\"$ctrl.brand.Name\"></span>\n</span>";

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "<span ng-repeat=\"brand in $ctrl.model | orderBy : 'Name'\">\n    <span class=\"pull-left brandSingle\" ng-class=\"{ brandSingleNoStatus: brand.Status == null, brandSingleNotApr: brand.Status === $ctrl.brandStatus.pending, brandSingleRejected: brand.Status === $ctrl.brandStatus.rejected }\">\n        <span class=\"overflowEllips\" title=\"{{ brand.Name }}\">\n            <span ng-if=\"brand.Status === $ctrl.brandStatus.pending\" class=\"fa fa-warning colorOrange\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                tooltip-append-to-body=\"true\" tooltip-class=\"mlTooltip\" uib-tooltip-html=\"htmlTooltip.awaitingApproval\"></span>\n            <span ng-if=\"brand.Status === $ctrl.brandStatus.rejected\" class=\"fa fa-warning colorRed\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                tooltip-append-to-body=\"true\" tooltip-class=\"mlTooltip\" uib-tooltip-html=\"$ctrl.htmlTooltip.rejected\"></span>\n            <span ng-if=\"brand.Status == null\" class=\"fa fa-warning\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"\n                tooltip-class=\"mlTooltip\" uib-tooltip-html=\"$ctrl.htmlTooltip.unknown\"></span>\n            <span ng-bind='brand.Name'></span>\n        </span>\n        <em ng-click=\"$ctrl.delete(brand)\" class=\"fa fa-close\"></em>\n    </span>\n</span>\n<div class=\"selectSearchWrap caretNo tableSelect width444 pull-left dropdownWithNote dropdownHeight292\" ng-class=\"{'mr0': $ctrl.all.length === 0, 'noPadBottom': $ctrl.filtered.length <= $ctrl.top.length}\">\n    <button ng-if=\"$ctrl.allowAdd && $ctrl.newBrand\" type=\"button\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.addNew()\" class=\"btn btn-default btnApproval text-ellipsis\"\n        translate=\"button_add_new_bran_for_approval\"  translate-value-newBrandName=\"{{ $ctrl.newBrand }}\">\n        <em class=\"fa fa-check\"></em>\n    </button>\n    <button type=\"button\" ng-show=\"$ctrl.all.length > 0\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.showModalBrands($event)\"\n        class=\"btn btn-default btnSelectList\">\n        <span ng-show=\"$ctrl.singleSelect\" translate=\"select_a_brand_from_list\" ></span>\n        <span ng-hide=\"$ctrl.singleSelect\" translate=\"select_brands_from_list\" ></span>\n    </button>\n    <ui-select name=\"availableBrand\" ng-model=\"$ctrl.selectedBrand\" on-select=\"$ctrl.onSelect($item); $select.selected = null;\"\n        theme=\"bootstrap\" reset-search-input=\"true\" ng-disabled=\"$ctrl.waiting\" class=\"brands__select\">\n        <ui-select-match class=\"ui-select-match\" placeholder=\"{{ $ctrl.getFilteredPlaceholder() }}\">\n            {{ $select.selected.Name }}\n        </ui-select-match>\n        <ui-select-choices repeat=\"brand in $ctrl.top\" refresh=\"$ctrl.refreshFiltered($select.search)\" refresh-delay=\"0\">\n            <div ng-hide=\"brand.forApproval\">\n                <div ng-bind-html=\"brand.Name | highlight: $select.search\"></div>\n                <div class=\"bottomNoteSelect\" ng-if=\"brand.last && $ctrl.filtered.length > $ctrl.top.length\">\n                    <span ng-click=\"$ctrl.showModalBrands($event)\">Select from all {{ $ctrl.filtered.length + $ctrl.pending.length }} matching brands&nbsp;&rarr;</span>\n                </div>\n            </div>\n            <div ng-show=\"$ctrl.allowAdd && $ctrl.brand.forApproval\" ng-click=\"$ctrl.addNew()\" class=\"addLine\">\n                <span translate=\"button_add_new_bran_for_approval\"  translate-value-newBrandName=\"{{ $ctrl.newBrand }}\"></span>\n            </div>\n        </ui-select-choices>\n    </ui-select>\n</div>\n<button type=\"button\" ng-hide=\"$ctrl.singleSelect\" ng-class=\"{'block': $ctrl.available.length > 0}\" ng-disabled=\"$ctrl.waiting\"\n    ng-click=\"$ctrl.onSelectAll($event)\" class=\"btn btn-default  btnSelectAll\" translate=\"button_select_all\" >\n</button>\n<button type=\"button\" ng-hide=\"$ctrl.singleSelect\" ng-class=\"{'block': $ctrl.model.length > 0}\" ng-disabled=\"$ctrl.waiting\"\n    ng-click=\"$ctrl.onClearSelected($event)\" class=\"btn btn-default  btnClearAll\" translate=\"button_remove_all\" >\n</button>\n";

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header gray-header pos-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"$ctrl.add()\" ng-disabled=\"$ctrl.isPristineData || $ctrl.brandsform.$pristine || $ctrl.waiting\"\n                class=\"btn btn-success btn-with-line wd-auto\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"select\" ></span>                \n                <ng-pluralize ng-if=\"!$ctrl.resolve.singleSelect\" count=\"$ctrl.countSelected.pending + $ctrl.countSelected.approved\" when=\"{\n                                   1: '{} brand',\n                                   'other': '{} brands'}\"></ng-pluralize>\n                <span ng-show=\"$ctrl.countSelected.pending + $ctrl.countSelected.approved > 0\" ng-if=\"$ctrl.resolve.singleSelect\">brand</span>\n            </button>\n            <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.discard()\" class=\"btn btn-danger btn-with-line\">\n                <em class=\"fa fa-close\"></em> <span translate=\"discard\" ></span>\n            </button>\n        </div>\n    </div>\n\n    <div ng-hide=\"!$ctrl.countSelected.pending || $ctrl.countSelected.pending === 0\" class=\"countBrand\">\n        <span class=\"fa fa-warning text-warning\"></span>\n        <ng-pluralize count=\"$ctrl.countSelected.pending\" when=\"{\n                                   1: '{} of the selected brand will need to be approved',\n                                   'other': '{} of the selected brands will need to be approved'}\"></ng-pluralize>\n        <br /> <span translate=\"for_the_categories_you_have_chosen\"></span>\n    </div>\n    <div class=\"btn-form modal-title\">\n        Add brands\n    </div>\n</div>\n<div class=\"modal-body\">\n    <form name=\"$ctrl.brandsform\" novalidate>\n        <div class=\"containerAlphabet clearfix\">\n            <div class=\"letterAlphabet\" ng-disabled=\"anchor.disabled\" ng-class=\"{'selected': anchor.selected, 'disabled':anchor.disabled}\"\n                ng-click=\"$ctrl.goToAnchorBrand(anchor)\" ng-repeat=\"anchor in $ctrl.resolve.anchors\">\n                <span ng-bind=\"anchor.name\"></span>\n            </div>\n        </div>\n        <div class=\"containerBrandList\">\n            <div class=\"positFooterFixed\" ng-if=\"$ctrl.settings.total > $ctrl.settings.pageSize\">\n                <div class=\"panel-footer\">\n                    <ul uib-pagination total-items=\"$ctrl.settings.total\" items-per-page=\"$ctrl.settings.pageSize\" ng-model=\"$ctrl.settings.page\"\n                        previous-text=\"«\" next-text=\"»\" max-size=\"10\" />\n                </div>\n            </div>\n            <div class=\"absoluteInner\">\n                <div ng-repeat=\"(key, value) in $ctrl.brandsFiltered\" id=\"{{key}}\" class=\"colorAnimate\">\n                    <div class=\"letter\">{{key == $ctrl.resolve.anchorNoChar ? $ctrl.resolve.anchors[$ctrl.resolve.anchors.length - 1].name : key}}</div>\n                    <div class=\"columnsBrandCss\">\n                        <div  ng-repeat=\"brand in value |  after:  ($ctrl.settings.page - 1) * $ctrl.settings.pageSize  | limitTo: $ctrl.settings.pageSize\">\n                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded mb0\" ng-class=\"{'padr20':brand.Status === $ctrl.resolve.brandStatus.pending}\">\n                                <label class=\"text-ellipsis\" title=\"{{brand.Name}}\">\n                                    <input ng-disabled=\"brand.disabled\" type=\"checkbox\" ng-click=\"$ctrl.changeState(brand)\" ng-model=\"brand.selected\">\n                                    <span class=\"fa fa-check\" ng-init=\"$ctrl.popupBrandsHeight()\"></span>{{brand.Name}}\n                                    <i ng-if=\"brand.Status === $ctrl.resolve.brandStatus.pending\" ng-show=\"brand.selected\" class=\"fa fa-warning text-warning\" tooltip-popup-delay=\"200\"\n                                        tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-class=\"mlTooltip\" uib-tooltip-html=\"$ctrl.htmlTooltip.awaitingApproval\"></i>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "<div class=\"bundle\">\n    <div class=\"modal-header flexVerticalAlignParent justify-content-between\">\n        <div class=\"modal-title fw-500 fs-20 color-black87\">\n            <span translate=\"add_items\"></span>\n            <span ng-if=\"ctrl.resolve.componentName\">{{'to_name' | translate : {name: ctrl.resolve.componentName} }}</span>\n        </div>\n        <div class=\"flexVerticalAlignParent\">\n            <button type=\"button\" ng-click=\"ctrl.add()\" class=\"btn btn-success height40 w103 btn-with-icon mr8\">\n                <span translate=\"button_add\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn btn-danger height40 w103 btn-with-icon\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_cancel\"></span>\n            </button>\n        </div>\n    </div>\n\n    <div class=\"modal-body p0\">\n        <!-- search -->\n        <div class=\"mb32 pt16 pl16 pr16\">\n            <search placeholder-text=\"'button_search' | translate\"\n                    text=\"ctrl.searchTerm\"\n                    classes=\"'white-theme'\"\n                    disabled=\"ctrl.waiting\"\n                    on-search-click=\"ctrl.search(searchText)\"\n                    on-clear-click=\"ctrl.resetSearch()\">\n            </search>\n        </div>\n\n        <!-- categories & products title -->\n        <div class=\"d-flex pr24 pb15 fs-12 lh16 ls-4 color-black6 bordered--bottom\">\n            <div class=\"w280\">\n                <span class=\"pl16\" translate=\"category\"></span>\n            </div>\n            <div class=\"flex-stretch checkbox c-checkbox m0 pl20\">\n                <label class=\"lh20\">\n                    <input type=\"checkbox\"\n                           ui-indeterminate=\"ctrl.checkboxIndeterminate\"\n                           ng-click=\"ctrl.allCheckboxClicked()\"\n                           ng-disabled=\"!ctrl.selectedItemType || !ctrl.itemList || !ctrl.itemList.length || ctrl.checkAllDisabled\"\n                           ng-checked=\"ctrl.checkboxChecked\"/>\n                    <span class=\"fa mr16\"\n                          ng-class=\"ctrl.checkboxIndeterminate ? 'fa-minus' : 'fa-check'\"></span>{{'product' | translate}}\n                </label>\n            </div>\n            <div class=\"w103 text-right mr16\" translate=\"special_offer_price\"></div>\n            <div class=\"w103 text-right\" translate=\"stock_level_label\"></div>\n        </div>\n\n        <!-- categories & products lists -->\n        <div class=\"d-flex\">\n\n            <!-- categories -->\n            <div class=\"custom-scroll w280 bordered--right\">\n                <div ng-repeat=\"category in ctrl.categoryList\">\n                    <div class=\"flexVerticalAlignParent pt12 pb12 clickable\"\n                         ng-click=\"category.IsOpen = !category.IsOpen;\">\n                        <div class=\"icon24 pl8 text-center mr4 color-black38\">\n                            <div class=\"fa fs-20\"\n                                 ng-class=\"{'fa-angle-right': !category.IsOpen, 'fa-angle-down padding-top: 2px;': category.IsOpen}\"></div>\n                        </div>\n                        <span class=\"fs-14 lh16 ls-0146 color-black87 mr8\" ng-bind=\"category.Name\"></span>\n                        <div ng-if=\"category.Counter\" class=\"fs-12 lh16 ls-04 text-center bundle__counter mr8\"\n                             ng-bind=\"category.Counter\"></div>\n                    </div>\n                    <div ng-if=\"category.IsOpen\"\n                         ng-repeat=\"itemType in category.ItemTypes\"\n                         class=\"flexVerticalAlignParent pt12 pb12 pl44 clickable\"\n                         ng-class=\"{'active-category': ctrl.selectedItemType === itemType}\"\n                         ng-click=\"ctrl.selectItemTypeAndCategory(itemType, category)\">\n                        <span class=\"fs-14 lh16 ls-0146 color-black87 mr8\" ng-bind=\"itemType.Name\"></span>\n                        <div ng-if=\"itemType.Counter\" class=\"fs-12 lh16 ls-04 text-center bundle__counter mr8\"\n                             ng-bind=\"itemType.Counter\"></div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- products -->\n            <div class=\"flex-stretch custom-scroll\">\n                <div ng-repeat=\"item in ctrl.itemList\"\n                     ng-click=\"ctrl.onItemClick(item)\"\n                     class=\"flexVerticalAlignParent pl20 pt6 pb6 pr24 bundle__border-bottom fs-14 lh16 ls-0146 color-black87 clickable\">\n                    <div class=\"checkbox c-checkbox m0\">\n                        <label class=\"lh20\"\n                               ng-click=\"$event.preventDefault();\">\n                            <input type=\"checkbox\"\n                                   ng-click=\"$event.preventDefault();\"\n                                   ng-checked=\"item.Selected\"\n                                   ng-disabled=\"item.Disabled\"\n                            />\n                            <span class=\"fa fa-check mr16\"></span>\n                        </label>\n                    </div>\n                    <div class=\"bundle__image--product mr16\">\n                        <img ng-src=\"{{ctrl.getVariationImage(item.ImageID)}}\" alt=\"\">\n                    </div>\n                    <div class=\"d-flex flex-column flex-stretch mr8\">\n                        <span ng-bind=\"item.Title\"></span>\n                        <div class=\"bundle-size_and_colour\"\n                             ng-if=\"item.Size && item.SizeName\"\n                             translate=\"name_value_by_colon\"\n                             translate-value-name=\"{{item.SizeName}}\"\n                             translate-value-value=\"{{item.Size}}\"\n                        ></div>\n                        <div class=\"bundle-size_and_colour\"\n                             ng-if=\"item.Colour && item.ColourName\"\n                             translate=\"name_value_by_colon\"\n                             translate-value-name=\"{{item.ColourName}}\"\n                             translate-value-value=\"{{item.Colour}}\"\n                        ></div>\n                    </div>\n                    <div class=\"w103 text-right mr16\"\n                         ng-bind=\"item.Price | formatCurrency : ctrl.resolve.countryID\"></div>\n                    <div class=\"w103 text-right\" ng-bind=\"item.StockLevel\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pr12 pl12 pb24 animated rotateInDownLeft bundle\" ng-if=\"ctrl.bundle\">\n    <!-- Breadcrumbs-->\n    <div class=\"mb24 flexVerticalAlignParent justify-content-between\">\n        <ol class=\"breadcrumb ns m0\">\n            <li><span ui-sref=\"app.bundles\" translate=\"bundles\" class=\"fs-20 fw-500 color-amethyst-smoke\"></span></li>\n            <li class=\"active\"><span translate=\"bundle_details\" class=\"fs-20 fw-500 color-black87\"></span></li>\n        </ol>\n        <button class=\"btn btn-with-icon flexVerticalAlignParent p12 bg-black12\" ng-click=\"ctrl.confirmDeleteBundle()\">\n            <span class=\"icon-delete-grey mr12\"></span>\n            <span translate=\"delete\" class=\"color-black6 fw-500 lh16 ls-031\"></span>\n        </button>\n    </div>\n\n    <!-- Bundle info-->\n    <div class=\"panel panel-info d-flex p24 pb40 mb16\">\n        <div class=\"bundle__image mr48\">\n            <img ng-src=\"{{ctrl.getLogoImage(ctrl.bundle.LogoImageID)}}\" alt=\"\" />\n        </div>\n        <div class=\"mr25 flex-stretch\">\n            <div class=\"fs-24 lh28 ls-0146 mb8\" ng-bind=\"ctrl.bundle.Name\"></div>\n            <div ng-if=\"ctrl.bundle.BundleValue.Price\" class=\"fs-18 fw-500 lh21 mb24\"\n                ng-bind=\"ctrl.bundle.BundleValue.Price.toFixed(2) | formatCurrency : ctrl.countryID\"></div>\n            <div ng-if=\"ctrl.bundle.BundleValue.DiscountPercent\" class=\"fs-18 fw-500 lh21 mb24\"\n                translate=\"percentage_discount_value\"\n                translate-value-discount=\"{{ctrl.bundle.BundleValue.DiscountPercent}}\"></div>\n            <div class=\"fs-14 lh16 ls-0146 mb24\" ng-bind=\"ctrl.bundle.Description\"></div>\n            <div class=\"fs-14 lh16 ls-0146 color-black6\" ng-if=\"ctrl.bundle.ValidFrom || ctrl.bundle.ValidTo\">\n                <span translate=\"bundles_valid\"></span>\n                <span ng-if=\"ctrl.bundle.ValidFrom\">{{'bundles_from' | translate}} {{ctrl.bundle.ValidFrom |\n                    date:ctrl.dateFormat:'utc'}}</span>\n                <span ng-if=\"ctrl.bundle.ValidTo\">{{'bundles_until' | translate}} {{ctrl.bundle.ValidTo |\n                    date:ctrl.dateFormat:'utc'}}</span>\n            </div>\n        </div>\n        <div>\n            <div ui-sref=\"app.bundle.edit({id:ctrl.bundle.ID})\" class=\"flexVerticalAlignParent bundle__link\">\n                <div class=\"icon-edit-blue mr12\"></div>\n                <div translate=\"bundle_edit\"></div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Components-->\n    <div class=\"panel panel-edit mb16\" ng-repeat=\"component in ctrl.bundle.Components\">\n        <div class=\"panel-heading flexVerticalAlignParent justify-content-between border-bottom-gray\">\n            <div class=\"fs-18 lh24 fw-500 color-black87\" ng-bind=\"component.Name\"></div>\n            <div class=\"fs-14 lh16 color-black6 ls-0146\"\n                uib-tooltip=\"{{'bundle_required_quantity_tooltip' | translate}}\" tooltip-placement=\"top\">\n                <span translate=\"bundle_required_quantity\"></span>:\n                <span ng-bind=\"component.Quantity\"></span>\n            </div>\n        </div>\n        <div class=\"panel-body pt8 pb8 custom-scroll fs-14 lh16 ls-0146 color-black87\">\n            <div class=\"flexVerticalAlignParent bundle__list-item\" ng-repeat=\"variation in component.Variations\">\n                <div class=\"bundle__image--product mr16\">\n                    <img ng-src=\"{{ctrl.getVariationImage(variation.ImageID)}}\" alt=\"\" />\n                </div>\n                <div class=\"d-flex flex-column flex-stretch mr16\">\n                    <span ng-bind=\"variation.Title\"></span>\n                    <div class=\"bundle-size_and_colour\" ng-if=\"variation.Size && variation.SizeName\"\n                        translate=\"name_value_by_colon\" translate-value-name=\"{{variation.SizeName}}\"\n                        translate-value-value=\"{{variation.Size}}\"></div>\n                    <div class=\"bundle-size_and_colour\" ng-if=\"variation.Colour && variation.ColourName\"\n                        translate=\"name_value_by_colon\" translate-value-name=\"{{variation.ColourName}}\"\n                        translate-value-value=\"{{variation.Colour}}\"></div>\n                </div>\n                <div class=\"w80 text-right\">{{variation.Price.toFixed(2) | formatCurrency : ctrl.countryID}}</div>\n            </div>\n        </div>\n    </div>\n\n</div>";

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pr12 pl12 pb24 bundle\">\n    <div class=\"mb24 flexVerticalAlignParent justify-content-between\">\n        <span class=\"fs-20 fw-500\" translate=\"bundles\"></span>\n        <button ui-sref=\"app.bundle.new\" class=\"btn btn-success add-btn height40\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span class=\"fw-500 fs-14 lh16 ls-031\" translate=\"bundles_add\"></span>\n        </button>\n    </div>\n    <div ng-if=\"ctrl.total !== 0\" ng-infinite-scroll load-more=\"ctrl.loadData()\">\n        <div ng-repeat=\"bundle in ctrl.bundleList\"\n             ui-sref=\"app.bundle.details({id:bundle.ID})\"\n             class=\"d-flex panel panel-info mb16 p16 clickable\">\n            <div class=\"bundle__image mr32\">\n                <img ng-src=\"{{ctrl.getLogoImage(bundle.LogoImageID)}}\" alt=\"\" />\n            </div>\n            <div class=\"flex-stretch d-flex flex-column\">\n                <span class=\"fs-24 lh28 ls-0146 mb8\" ng-bind=\"bundle.Name\"></span>\n                <span ng-if=\"bundle.BundleValue.Price\"\n                      class=\"fs-18 fw-500 lh21 mb24\"\n                      ng-bind=\"bundle.BundleValue.Price.toFixed(2) | formatCurrency : ctrl.countryID\"\n                ></span>\n                <span ng-if=\"bundle.BundleValue.DiscountPercent\"\n                      class=\"fs-18 fw-500 lh21 mb24\"\n                      translate=\"percentage_discount_value\"\n                      translate-value-discount=\"{{bundle.BundleValue.DiscountPercent}}\"\n                ></span>\n                <span class=\"fs-14 lh16 ls-0146 mb24\" ng-bind=\"bundle.Description\"></span>\n                <div class=\"fs-14 lh16 ls-0146 color-black6 mb4\" ng-if=\"bundle.ValidFrom || bundle.ValidTo\">\n                    <span translate=\"bundles_valid\"></span>\n                    <span ng-if=\"bundle.ValidFrom\">{{'bundles_from' | translate}} {{bundle.ValidFrom | date:ctrl.dateFormat:'utc'}}</span>\n                    <span ng-if=\"bundle.ValidTo\">{{'bundles_until' | translate}} {{bundle.ValidTo | date:ctrl.dateFormat:'utc'}}</span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <empty-list-state ng-if=\"ctrl.total === 0 && !ctrl.waiting\"\n                      title-message=\"'bundles_empty_screen_title' | translate\" message=\"'bundles_empty_screen_content' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\" fill-element>\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb pr8\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"bundle_template_title\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign bundle pt24 pb0 pl0 pr0 d-flex flex-column align-items-center\">\n    <div class=\"mb46 text-center text-pre fs-14 lh16\" translate=\"bundle_template_description\"></div>\n    <div class=\"mb46\">\n        <canvas id=\"templateCanvas\" class=\"rounded-8\"></canvas>\n    </div>\n    <div class=\"offer--preview-image\"></div>\n    <div class=\"bordered--bottom mb24 w-100\"></div>\n    <div uib-dropdown class=\"wideSelect mb35\">\n        <button type=\"button\"\n                uib-dropdown-toggle\n                class=\"btn btn-default dropdown-toggle h40 w240\"\n                aria-haspopup=\"true\"\n                aria-expanded=\"false\">\n            <span class=\"caret\"></span>\n            <span>{{ctrl.selectedText}}</span>\n        </button>\n        <ul class=\"dropdown-menu noBorder\">\n            <li ng-repeat=\"text in ctrl.textList\"\n                ng-click=\"ctrl.selectText(text)\"\n                class=\"pl16 pt12 pb12 clickable fs-14 lh16\">\n                {{::text}}\n            </li>\n        </ul>\n    </div>\n    <div class=\"d-flex align-items-center mb28\">\n        <div ng-repeat=\"icon in ctrl.iconList\"\n             class=\"bundle__icon-example clickable\"\n             ng-class=\"{'selected': icon === ctrl.selectedIcon}\"\n             ng-click=\"ctrl.selectIcon(icon)\">\n            <img src=\"{{::ctrl.getIconSrcByName(icon)}}\" alt=\"\">\n        </div>\n    </div>\n    <div class=\"d-flex align-items-center mb35\">\n        <div ng-repeat=\"color in ctrl.colorList\"\n             class=\"bundle__colour-example circle clickable\"\n             style=\"background-color: {{color}}\"\n             ng-click=\"ctrl.selectColor(color)\">\n            <div class=\"icon-selected\" ng-if=\"ctrl.selectedColor === color\"></div>\n        </div>\n    </div>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <!--        ng-click=\"ctrl.validateBeforeSave()\"\n                        ng-disabled=\"ctrl.waiting || voucherForm.$pristine ||!ctrl.isFormFilled()\"-->\n        <button type=\"button\"\n                class=\"btn btn-with-icon btn-in-popup-footer mr8 ml0 h40\"\n                ng-click=\"ctrl.close()\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"button_cancel\" class=\"fw-500\"></span>\n        </button>\n        <button type=\"button\"\n                class=\"btn btn-success mr8 height40 btn-with-icon\"\n                ng-click=\"ctrl.save()\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"button_save\"></span>\n        </button>\n\n    </div>\n</div>\n";

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = "<!--  Image, Name & Price  -->\n<div class=\"d-flex mb32\">\n    <div class=\"bundle__image bundle__image--editable mr48 wrapRelative\">\n        <div ng-if=\"ctrl.imageSrc\">\n            <img ng-src=\"{{ctrl.imageSrc}}\" alt=\"\">\n            <button type=\"button\" class=\"bundle__btn-delete-image flexVerticalAlignParent\" ng-click=\"ctrl.deleteImage()\">\n                <div class=\"icon-trashcan-outline-white icon24 mr8\"></div>\n                <div translate=\"delete_image\"></div>\n            </button>\n            <div class=\"bundle__image-gradient\" ng-if=\"ctrl.needGradient\"></div>\n        </div>\n        <div ng-if=\"!ctrl.imageSrc\"\n             class=\"bundle__image bundle__image--editable bundle__br-dashed d-flex p8\">\n            <div class=\"d-flex flex-column align-items-center flex-stretch bg-dark08 br4 pt24\">\n                <button type=\"button\" class=\"btn bundle__btn-set-image flexVerticalAlignParent\"\n                        ng-click=\"ctrl.useTemplate()\" translate=\"bundle_btn_use_template\">\n                </button>\n                <div class=\"fs-14 lh16 fw-500 color-black6 pt8 pb8\" translate=\"or_text\"></div>\n                <button type=\"button\" class=\"btn bundle__btn-set-image flexVerticalAlignParent mb16\"\n                        ng-click=\"ctrl.uploadLogo()\" translate=\"bundle_btn_upload_image\">\n                </button>\n                <div class=\"fs-12 lh16 ls-031 color-black38 text-center w356\"\n                     translate=\"bundle_image_restrictions\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"d-flex flex-column flex-stretch\">\n        <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"Name\"\n               translate=\"name_with_asterisk\"></label>\n        <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 bundle__name-field\"\n               id=\"Name\" name=\"Name\"\n               ng-model=\"ctrl.bundle.Name\"\n               ng-model-options=\"{allowInvalid: true}\"\n               ng-change=\"ctrl.validateRequired(ctrl.form.Name, ctrl.bundle.Name)\"\n               ng-disabled=\"ctrl.waiting\"\n               ng-minlength=\"3\"\n               ng-maxlength=\"128\">\n        <div class=\"fs-12 lh16 ls-031 color-black38 mb24\">\n            <div ng-if=\"ctrl.form.Name.$pristine || ctrl.form.Name.$valid\">{{::'maximum_characters' | translate: {num: 128} }}</div>\n            <div ng-if=\"ctrl.form.Name.$error.required\" class=\"text-danger\" translate=\"field_is_required\"></div>\n            <div ng-if=\"ctrl.form.Name.$error.minlength\" class=\"text-danger\">{{::'min_text_length_error' | translate: {count: 3} }}</div>\n            <div ng-if=\"ctrl.form.Name.$error.maxlength\" class=\"text-danger\">{{:: 'max_text_length_error' | translate: {count: 128} }}</div>\n        </div>\n        <div class=\"d-flex\">\n            <div class=\"d-flex flex-column mr24\">\n                <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" translate=\"bundle_type\"></label>\n                <div uib-dropdown class=\"dropdown-select\" on-toggle=\"ctrl.bundleTypeExpanded = !ctrl.bundleTypeExpanded\">\n                    <button type=\"button\" uib-dropdown-toggle class=\"btn\"\n                            aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"ctrl.waiting\">\n                        <div class=\"button-content d-flex align-items-center justify-content-between\">\n                            <div class=\"d-flex align-items-center\">\n                                <span ng-bind=\"ctrl.getCurrentTypeName()\"></span>\n                            </div>\n                            <span class=\"arrow\" ng-class=\"{'arrow-rotated': ctrl.bundleTypeExpanded}\"></span>\n                        </div>\n                    </button>\n                    <ul class=\"dropdown-menu dropdown-menu-items\">\n                        <li ng-repeat=\"bundleType in ctrl.bundleTypes\" ng-click=\"ctrl.changeBundleType(bundleType)\">\n                            <div class=\"dropdown-item d-flex align-items-center\">\n                                <span class=\"dropdown-item-text\" ng-bind=\"ctrl.getBundleTypeName(bundleType)\"></span>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <div class=\"d-flex flex-column\" ng-if=\"ctrl.currentBundleType === ctrl.bundleTypesEnum.Fixed\">\n                <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"Price\" translate=\"field_price\"></label>\n                <div class=\"{{::ctrl.currencyCssClass}} t10\">\n                    <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 h40 w140\"\n                           id=\"Price\" name=\"Price\"\n                           ng-model=\"ctrl.bundle.BundleValue.Price\"\n                           ng-model-options=\"{allowInvalid: true}\"\n                           ng-change=\"ctrl.validatePrice()\"\n                           only-decimal\n                           is-number=\"true\"\n                           ng-disabled=\"ctrl.waiting\">\n                </div>\n                <div class=\"fs-12 lh16 ls-031 text-danger\">\n                    <span ng-if=\"ctrl.form.Price.$error.required\" translate=\"field_is_required\"></span>\n                    <span ng-if=\"ctrl.form.Price.$error.min\" translate=\"price_must_be_not_less\"\n                          translate-value-num=\"{{0.01 | formatCurrency: countryID}}\">\n\n                    </span>\n                    <span ng-if=\"ctrl.form.Price.$error.max\" translate=\"price_must_be_less\"\n                          translate-value-num=\"{{9999.99 | formatCurrency: countryID}}\">\n                    </span>\n                </div>\n            </div>\n            <div class=\"d-flex flex-column\" ng-if=\"ctrl.currentBundleType === ctrl.bundleTypesEnum.Discount\">\n                <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"DiscountPercent\" translate=\"discount_required\"></label>\n                <div class=\"percentage-input w140\">\n                    <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 w140 h40\"\n                           id=\"DiscountPercent\"\n                           name=\"DiscountPercent\"\n                           ng-model=\"ctrl.bundle.BundleValue.DiscountPercent\"\n                           ng-model-options=\"{allowInvalid: true}\"\n                           ng-change=\"ctrl.validateDiscount()\"\n                           only-decimal\n                           is-number=\"true\"\n                           ng-disabled=\"ctrl.waiting\">\n                </div>\n                <div class=\"fs-12 lh16 ls-031 text-danger\">\n                    <span ng-if=\"ctrl.form.DiscountPercent.$error.required\" translate=\"field_is_required\"></span>\n                    <span ng-if=\"ctrl.form.DiscountPercent.$error.min\" translate=\"must_be_greater_than_0\"></span>\n                    <span ng-if=\"ctrl.form.DiscountPercent.$error.max\">{{:: 'must_be_not_more_than' | translate: {num: 100} }}</span>\n                    <span ng-if=\"ctrl.form.DiscountPercent.$error.integer\"  translate=\"must_be_integer\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--  Description  -->\n<div class=\"flex-column mb24\">\n    <label class=\"fs-14 fw-500 lh16 ls-031 color-black6 mb8\" for=\"Description\"\n           translate=\"services_description\"></label>\n    <textarea class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 w-100 no-resize br4\"\n              id=\"Description\" name=\"Description\" rows=\"3\"\n              ng-model=\"ctrl.bundle.Description\"\n              ng-model-options=\"{allowInvalid: true}\"\n              ng-readonly=\"ctrl.waiting\"\n              ng-change=\"ctrl.validateRequired(ctrl.form.Description, ctrl.bundle.Description)\"\n              ng-minlength=\"3\"\n              ng-maxlength=\"1000\">\n           </textarea>\n    <div class=\"fs-12 lh16 ls-031 color-black87\">\n        <div ng-if=\"ctrl.form.Description.$pristine || ctrl.form.Description.$valid\">\n            <span class=\"color-red\">* </span><span translate=\"bundle_description_hint\"></span>\n        </div>\n        <div ng-if=\"ctrl.form.Description.$error.required\" class=\"text-danger\" translate=\"field_is_required\"></div>\n        <div ng-if=\"ctrl.form.Description.$error.minlength\" class=\"text-danger\">{{:: 'min_text_length_error' | translate: {count: 3} }}</div>\n        <div ng-if=\"ctrl.form.Description.$error.maxlength\" class=\"text-danger\">{{:: 'max_text_length_error' | translate: {count: 1000} }}</div>\n    </div>\n</div>\n\n<!--  Date range  -->\n<div class=\"d-flex\">\n    <div class=\"flex-column w190 mr48\">\n        <label class=\"fs-14 fw-500 lh16 ls-031 color-black6 mb8\"\n               translate=\"valid_from\"></label>\n        <div class=\"input-group input-invalid-field wrapRelative datepicker--transparent\"\n             ng-class=\"ctrl.form.ValidFrom.$invalid ? 'input-invalid-field--invalid':''\">\n            <input type=\"text\"\n                   name=\"ValidFrom\"\n                   uib-datepicker-popup=\"dd MMMM yyyy\"\n                   datepicker-options=\"ctrl.startDateOptions\"\n                   ng-model=\"ctrl.bundle.ValidFrom\"\n                   ng-model-options=\"{timezone: 'utc'}\"\n                   ng-change=\"ctrl.validateValidFrom()\"\n                   is-open=\"ctrl.openedValidFrom\"\n                   ng-focus=\"ctrl.openValidFromDatepicker()\"\n                   close-text=\"{{::'close' | translate}}\"\n                   clear-text=\"{{::'clear' | translate}}\"\n                   current-text=\"{{::'today' | translate}}\"\n                   class=\"form-control\"\n                   ng-disabled=\"ctrl.waiting\"\n                   readonly/>\n            <div class=\"input-group-btn\">\n                <button type=\"button\"\n                        ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openValidFromDatepicker()\"\n                        ng-disabled=\"ctrl.waiting\"\n                        class=\"btn btn-default pt0 pb0 pr8\">\n                    <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <div class=\"flex-column w190 mr24 mb24 input-validation\">\n        <label class=\"fs-14 fw-500 lh16 ls-031 color-black6 mb8\" translate=\"valid_until\"></label>\n        <div class=\"input-group input-invalid-field wrapRelative datepicker--transparent\"\n             ng-class=\"ctrl.form.ValidTo.$invalid ? 'input-invalid-field--invalid':''\">\n            <input type=\"text\"\n                   name=\"ValidTo\"\n                   uib-datepicker-popup=\"dd MMMM yyyy\"\n                   ng-model=\"ctrl.bundle.ValidTo\"\n                   ng-model-options=\"{timezone: 'utc'}\"\n                   ng-change=\"ctrl.validateValidTo()\"\n                   datepicker-options=\"ctrl.endDateOptions\"\n                   is-open=\"ctrl.openedValidTo\"\n                   ng-focus=\"ctrl.openValidToDatepicker()\"\n                   close-text=\"{{::'close' | translate}}\"\n                   clear-text=\"{{::'clear' | translate}}\"\n                   current-text=\"{{::'today' | translate}}\"\n                   class=\"form-control\"\n                   ng-disabled=\"ctrl.waiting\"\n                   readonly/>\n            <div class=\"input-group-btn\">\n                <button type=\"button\"\n                        ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openValidToDatepicker()\"\n                        ng-disabled=\"ctrl.waiting\"\n                        class=\"btn btn-default pt0 pb0 pr8\">\n                    <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"fs-12 lh16 ls-031 text-danger\"\n             ng-if=\"ctrl.form.ValidTo.$invalid\"\n             translate=\"end_date_error\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<div ui-tree=\"ctrl.treeOptions\" ng-if=\"ctrl.componentList.length\">\n    <div ui-tree-nodes ng-model=\"ctrl.componentList\">\n        <div ng-repeat=\"component in ctrl.componentList\"\n             ui-tree-node\n             class=\"d-flex align-items-start pt24\"\n             ng-form=\"group{{::$id}}\"\n             ng-class=\"{'bundle__border-bottom': $index !== 6}\"\n        >\n            <div class=\"pt8 pl8 pb8 pr24 mt30\" ui-tree-handle>\n                <div class=\"icon-drag-drop--light icon24 cursor-move\"></div>\n            </div>\n            <div class=\"flex-stretch flex-column\">\n                <div class=\"d-flex align-items-start\"\n                     ng-class=\"component.Variations.length ? 'bundle__border-bottom pb24' : ''\">\n                    <div class=\"flex-stretch flex-column mr16\">\n                        <label class=\"fw-500 fs-14 lh16 ls-031 color-black6 pt8 mb8\" for=\"name{{::$id}}\">\n                            <span translate=\"bundle_component_name\"></span> *\n                        </label>\n\n                        <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 w-100\"\n                               id=\"name{{::$id}}\"\n                               name=\"name\"\n                               ng-model=\"component.Name\"\n                               ng-model-options=\"{allowInvalid: true}\"\n                               ng-minlength=\"3\"\n                               ng-maxlength=\"30\"\n                               ng-change=\"ctrl.nameChanged(ctrl.form['group' + $id].name, component)\"\n                               ng-disabled=\"ctrl.waiting\">\n                        <div class=\"fs-12 lh16 ls-031 text-danger\"\n                             ng-if=\"ctrl.form['group' + $id].name.$error.required ||\n                                    component.errors && component.errors.name\" translate=\"field_is_required\">\n                        </div>\n                        <div class=\"fs-12 lh16 ls-031 text-danger\"\n                             ng-if=\"ctrl.form['group' + $id].name.$error.minlength\">{{:: 'min_text_length_error' | translate: {count: 3} }}</div>\n                        <div class=\"fs-12 lh16 ls-031 text-danger\"\n                             ng-if=\"ctrl.form['group' + $id].name.$error.maxlength\">{{:: 'max_text_length_error' | translate: {count: 30} }}\n                        </div>\n                    </div>\n                    <div class=\"flex-column mr16\">\n                        <label class=\"fw-500 fs-14 lh16 ls-031 color-black6 pt8 mb8\" for=\"quantity{{::$id}}\">\n                            <span translate=\"bundle_required_quantity\"></span> *\n                        </label>\n                        <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4 w140\"\n                               id=\"quantity{{::$id}}\"\n                               name=\"quantity\"\n                               ng-model=\"component.Quantity\"\n                               ng-model-options=\"{allowInvalid: true}\"\n                               ng-change=\"ctrl.quantityChanged(ctrl.form['group' + $id].quantity, component.Quantity)\"\n                               only-num\n                               is-number=\"true\"\n                               ng-disabled=\"ctrl.waiting\">\n                        <div class=\"fs-12 lh16 ls-031 text-danger\" ng-if=\"ctrl.form['group' + $id].quantity.$error.required\" translate=\"field_is_required\"></div>\n                        <div class=\"fs-12 lh16 ls-031 text-danger\" ng-if=\"ctrl.form['group' + $id].quantity.$error.min\" translate=\"must_be_greater_than_0\"></div>\n                        <div class=\"fs-12 lh16 ls-031 text-danger\" ng-if=\"ctrl.form['group' + $id].quantity.$error.max\">\n                            {{:: 'must_be_not_more_than' | translate: {num: 30} }}</div>\n                        </div>\n                    <div class=\"p8 mt30\" ng-click=\"ctrl.removeComponent(component)\">\n                        <div class=\"icon-trashcan-outline opacity38 icon24 clickable\"></div>\n                    </div>\n                </div>\n                <div class=\"flexVerticalAlignParent pt6 pb6 bundle__border-bottom\"\n                     ng-repeat=\"variation in component.Variations\">\n                    <div class=\"bundle__image--product mr16\">\n                        <img ng-src=\"{{ctrl.getVariationImage(variation.ImageID)}}\" alt=\"\"/>\n                    </div>\n                    <div class=\"flex-stretch flexVerticalAlignParent justify-content-between mr16\">\n                        <div class=\"d-flex flex-column flex-stretch mr16\">\n                            <span ng-bind=\"variation.Title\"></span>\n                            <div class=\"bundle-size_and_colour\"\n                                 ng-if=\"variation.Size && variation.SizeName\"\n                                 translate=\"name_value_by_colon\"\n                                 translate-value-name=\"{{variation.SizeName}}\"\n                                 translate-value-value=\"{{variation.Size}}\"\n                            ></div>\n                            <div class=\"bundle-size_and_colour\"\n                                 ng-if=\"variation.Colour && variation.ColourName\"\n                                 translate=\"name_value_by_colon\"\n                                 translate-value-name=\"{{variation.ColourName}}\"\n                                 translate-value-value=\"{{variation.Colour}}\"\n                            ></div>\n                        </div>\n                        <div class=\"w80 text-right\">\n                            {{variation.Price.toFixed(2) | formatCurrency: ctrl.countryID}}\n                        </div>\n                    </div>\n                    <div class=\"w140 mr16\"></div>\n                    <div class=\"p8\" ng-click=\"ctrl.removeItem(variation, component)\">\n                        <div class=\"icon-trashcan-outline opacity38 icon24 clickable\"></div>\n                    </div>\n                </div>\n                <div class=\"pt20 pb30 flexVerticalAlignParent\">\n                    <div class=\"flexVerticalAlignParent w112 bundle__link clickable mr24\"\n                         ng-click=\"ctrl.addItems(component, $index)\">\n                        <div class=\"plus-icon--blue icon24 mr8\"></div>\n                        <div translate=\"add_items\"></div>\n                    </div>\n                    <div class=\"fs-12 lh16 ls-031 text-danger\">\n                        <span ng-if=\"component.errors && component.errors.noVariations\"\n                              translate=\"bundle_component_is_empty\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"pl56 pr50 pt24\" ng-if=\"ctrl.componentList.length < 7\">\n    <button type=\"button\"\n            ng-disabled=\"ctrl.waiting\"\n            ng-click=\"ctrl.addComponent()\"\n            class=\"flexVerticalAlignParent justify-content-center btn btnWhitePurple w-100 br4\">\n        <div class=\"plus-icon--purple icon24 mr8\"></div>\n        <div class=\"fs-14 lh16 fw-500 ls-031\" translate=\"add_component\"></div>\n    </button>\n</div>\n";

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "<form name=\"ctrl.form\"\n      class=\"pr12 pl12 pb24 animated rotateInDownLeft bundle\"\n      ng-if=\"ctrl.bundle\">\n    <!-- Breadcrumbs-->\n    <div class=\"mb8\">\n        <ol class=\"breadcrumb ns m0\">\n            <li><span ui-sref=\"app.bundles\" translate=\"bundles\" class=\"fs-20 fw-500 color-amethyst-smoke\"></span></li>\n            <li class=\"active\">\n                <span ng-if=\"ctrl.isNew\" translate=\"new\" class=\"fs-20 fw-500 color-black87\"></span>\n                <span ng-if=\"!ctrl.isNew\" translate=\"edit\" class=\"fs-20 fw-500 color-black87\"></span>\n            </li>\n        </ol>\n    </div>\n\n    <div class=\"fs-12 lh16 ls-031 color-black6 mb24\" translate=\"bundle_please_complete\"></div>\n\n    <!-- Bundle Details-->\n    <div class=\"panel panel-edit mb8\">\n        <div class=\"panel-heading border-bottom-gray\">\n            <span class=\"fs-18 lh24 fw-500 color-black87\" translate=\"bundle_details\"></span>\n        </div>\n        <div class=\"panel-body form-validate-only-errors\">\n            <edit-bundle-details-form-component\n                bundle=\"ctrl.bundle\"\n                waiting=\"ctrl.waiting\">\n            </edit-bundle-details-form-component>\n        </div>\n    </div>\n\n    <!-- Bundle Component & Items-->\n    <div class=\"panel panel-edit mb24\">\n        <div class=\"panel-heading border-bottom-gray\">\n            <span class=\"fs-18 lh24 fw-500 color-black87\" translate=\"bundle_components_and_items\"></span>\n        </div>\n        <div class=\"panel-body\">\n            <div class=\"fs-12 lh16 ls-031 color-black6 mb24\"\n                 translate=\"bundle_create_components\">\n            </div>\n            <edit-bundle-items-component class=\"form-validate-only-errors\"\n                component-list=\"ctrl.bundle.Components\"\n                waiting=\"ctrl.waiting\">\n            </edit-bundle-items-component>\n        </div>\n    </div>\n\n    <!-- Buttons -->\n    <div class=\"d-flex justify-content-end\">\n        <button type=\"submit\"\n                ng-disabled=\"ctrl.waiting || ctrl.form.$pristine || !ctrl.isBundleValid()\"\n                ng-click=\"ctrl.save()\"\n                class=\"btn btn-success height40 btn-with-icon mr8\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\"></span>\n        </button>\n        <button type=\"submit\"\n                ui-sref=\"app.bundles\"\n                class=\"btn btn-danger height40 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n</form>\n";

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <span translate=\"promote_for_shoppers\" translate-value-html-b=\"<b>\" translate-value-html-b-close=\"</b>\"></span>\n<div ng-repeat=\"rule in $vm.rules\">\n    <div ng-if=\"!$first\" ng-bind=\"rule.operator\"></div>\n    <div ng-include=\"rule.template\"></div>\n</div>\n<!-- templates -->\n<script type=\"text/ng-template\" id=\"simpleAudienceView\">\n    <div class=\"margLeftOption\" ng-repeat=\"item in rule.items\">\n        <p class=\"mb0\">\n            <span ng-if=\"!$first\" ng-bind=\"rule.comparator\"></span> <span ng-bind=\"rule.title\"></span>\n            <b><span ng-bind=\"item\"></span></b>\n        </p>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"ageAudienceView\">\n    <div class=\"margLeftOption\" ng-repeat=\"items in rule.items\">\n        <p class=\"mb0\">\n        <span ng-if=\"!$first\" ng-bind=\"rule.comparator\"></span>\n        <div class=\"margLeftOption\" ng-repeat=\"age in items\">\n            <span ng-if=\"!$first\" ng-bind=\"rule.operator\"></span> <span ng-bind=\"age.title\"></span>\n            <b><span ng-bind=\"age.item\"></span></b>\n        </div>\n    </p>\n    </div>\n</script>";

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<div class=\"descrCondit\">\n    <div ng-show=\"$ctrl.campaign.additionalInfo && $ctrl.campaign.additionalInfo.length\" ng-bind-html=\"$ctrl.campaign.additionalInfo\"></div>\n    <div ng-show=\"$ctrl.campaign.campaignProductLinks.length\">\n        <table class=\"full-width\">\n            <tbody>\n                <tr ng-repeat=\"link in $ctrl.campaign.campaignProductLinks | filter:$ctrl.isNotDraft\">\n                    <td class=\"width60 pr10 pb10 pt10\">\n                        <img class=\"campaign-product__img\" ng-src=\"{{::link.imageUrl}}\"/>\n                    </td>\n                    <td width=\"100%\">\n                        <div class=\"mt0 inline-block\">\n                            <b class=\"color-black54\">{{::link.title}}</b>\n                        </div>\n                        <div ng-show=\"link.oldPrice\">\n                            <span class=\"text-nowrap inactiveProduct\">{{::link.oldPrice | formatCurrency:$ctrl.countryID}}</span>&nbsp;<span>{{::link.maxPrice | formatCurrency:$ctrl.countryID}}</span>\n                        </div>\n                        <div ng-show=\"!link.oldPrice && link.minPrice != link.maxPrice\">\n                            {{::link.minPrice | formatCurrency:$ctrl.countryID }} - {{::link.maxPrice | formatCurrency:$ctrl.countryID }}\n                        </div>\n                        <div ng-show=\"!link.oldPrice && link.minPrice == link.maxPrice\">\n                            {{::link.minPrice | formatCurrency:$ctrl.countryID }}\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n";

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9\">\n    <span ng-class=\"{'activefilter': !vm.campaigns.isShowRunning}\" ng-click=\"vm.toggleShow(true)\">\n        <span ng-if=\"vm.isAdvertising\" translate=\"ad_campaigns\"></span>\n        <span ng-if=\"vm.isRetailing\" translate=\"marketing_campaigns\"></span></span>\n    <span ng-hide=\"vm.campaigns.archived.length === 0\" ng-class=\"{'activefilter': vm.campaigns.isShowRunning}\" ng-click=\"vm.toggleShow(false)\"\n        translate=\"archived_campaigns\">\n    </span>\n\n    <span class=\"pull-right\" ng-class=\"{'hidden': !vm.loading}\">\n        <button type=\"button\" ng-show=\"vm.isRetailing\" ui-sref=\"app.marketing-campaigns.new-branded\" class=\"btn btn-success ml-auto add-btn\">\n            <span class=\"plus-icon icon24\"></span>\n            <span class=\"ml8 fs-14\" translate=\"button_create_a_marketing_campaign\"></span>\n        </button>\n        <button type=\"button\" ng-show=\"vm.isAdvertising\" ui-sref=\"app.advertising.campaign.new\" class=\"btn btn-success ml-auto add-btn\">\n            <span class=\"plus-icon icon24\"></span>\n            <span class=\"ml8 fs-14\" translate=\"button_create_an_ad_campaign\"></span>\n        </button>\n    </span>\n</div>\n<div class=\"flexVerticalAlignParent mb37 mt15\">\n    <div ng-class=\"{'hidden': !vm.loading, 'opened': vm.isSelectOpen}\" class=\"width155 filter-with-icon filter-with-icon--transparent\">\n        <span class=\"icon-sidebar-location icon\"></span>\n        <ui-select ng-model=\"vm.storeFilter.store\" reset-search-input=\"true\" uis-open-close=\"vm.isSelectOpen = $select.open\"\n            theme=\"bootstrap\" on-select=\"vm.applyStoreFilter()\" ng-disabled=\"vm.waiting || !vm.campaigns.runningFiltered || vm.campaigns.runningFiltered.length === 0\">\n            <ui-select-match placeholder=\"{{:: 'all_locations' | translate }}\">{{$select.selected.StoreName }}</ui-select-match>\n            <ui-select-choices repeat=\"store in vm.storeFilter.stores | filter:{StoreName:$select.search}\" refresh=\"\"\n                refresh-delay=\"0\">\n                <span ng-bind-html=\"store.StoreName | highlight: $select.search\" class=\"choice-top\"></span>\n                <br>\n                <span ng-bind=\"store.StoreTown + ', ' + store.StoreAddress \" class=\"choice-bottom\"></span>\n            </ui-select-choices>\n        </ui-select>\n        <span ng-class=\"{'visible': vm.storeFilter.store != null}\" ng-click=\"vm.storeFilter.store = null;vm.applyStoreFilter()\"\n            class=\"filter-with-icon__reset fs-14\" translate=\"reset_filter\"></span>\n    </div>\n    <div class=\"ml-auto\">\n        <div ng-show=\"vm.campaigns.isShowRunning\" class=\"campaigns-filter flexVerticalAlignParent\">\n            <span ng-repeat=\"filter in vm.runningFilters  | where:{show: true}\">\n                <span ng-class=\"{'activefilter': filter.active}\" ng-click=\"vm.applyRunningFilter(filter)\" ng-bind=\"filter.key\"\n                    class=\"campaigns-filter__key fs-13\"></span>\n            </span>\n        </div>\n        <div ng-hide=\"vm.campaigns.isShowRunning\" class=\"campaigns-filter flexVerticalAlignParent\">\n            <span ng-repeat=\"filter in vm.archivedFilters | where:{show: true}\">\n                <span ng-class=\"{'activefilter': filter.active}\" ng-click=\"vm.applyArchivedFilter(filter)\" class=\"campaigns-filter__key fs-13\"\n                    ng-bind=\"filter.key\"></span>\n            </span>\n        </div>\n\n    </div>\n\n    \n</div>\n\n\n\n<div ng-show=\"vm.campaigns.isShowRunning\" class=\"clearfix blocks-campaings pl0\" ng-class=\"{'disable': vm.waiting}\">\n    <div class=\"pull-left block-campaing\" ng-class=\"{'block-advertising': vm.isAdvertising}\" ng-click=\"vm.gotoView(campaign.ID, $event)\"\n        ng-repeat=\"campaign in vm.campaigns.runningFiltered  | orderBy:'-ID'\">\n        <campaign-overview campaign=\"campaign\" show-competition=\"false\" waiting=\"vm.waiting\"></campaign-overview>\n    </div>\n    <div class=\"helpBlock\"></div>\n</div>\n\n\n\n<div ng-hide=\"vm.campaigns.isShowRunning\" class=\"clearfix blocks-campaings pl0\" ng-class=\"{'disable': vm.waiting}\">\n    <div class=\"pull-left block-campaing\" ng-click=\"vm.gotoView(campaign.ID, $event)\" ng-repeat=\"campaign in vm.campaigns.archivedFiltered  | orderBy:'ID'\">\n        <campaign-overview campaign=\"campaign\" show-competition=\"false\" waiting=\"vm.waiting\"></campaign-overview>\n    </div>\n    <div class=\"helpBlock\"></div>\n</div>\n\n\n<div ng-class=\"{'hidden': !vm.loading}\"\n         ng-show=\"!vm.campaigns.runningFiltered || vm.campaigns.runningFiltered.length === 0\"\n         >\n\n        <empty-list-state fill-element class=\" absolute-center-flex\"\n                  title-message=\"'no_marketing_campaigns_to_show' | translate\"\n                 \n                  class=\"container-fh absolute-center-flex\">\n        </empty-list-state>\n    </div>\n\n";

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"vm.cancel()\">×</button>\n    <h4 class=\"modal-title\" translate=\"design_request_title\" ></h4>\n</div>\n<div class=\"modal-body\">\n    <h5 class=\"modal-title\"\n        translate=\"design_request_subtitle\" \n        ></h5>\n    <form name=\"vm.needHelpForm\" novalidate role=\"form\">\n        <div class=\"form-group\">\n            <label translate=\"name_label\" ></label>\n            <input name=\"name\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.waiting\" ng-model=\"vm.model.Name\" />\n            <div>\n                <span ng-class=\"{'open': vm.needHelpForm.name.$error.required}\" class=\"text-danger\"\n                    translate=\"name_is_required\" ></span>\n                <span ng-class=\"{'open' : vm.needHelpForm.name.$error.length}\" class=\"text-danger\"\n                    translate=\"name_length_error\" ></span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"contact_number\" ></label>\n            <input name=\"phone\" type=\"text\" class=\"form-control\" ng-disabled=\"vm.waiting\" ng-model=\"vm.model.Phone\" />\n            <div>\n                <span  ng-class=\"{'open': vm.needHelpForm.phone.$error.required}\" class=\"text-danger\"\n                    translate=\"contact_number_is_required\" ></span>\n                <span  ng-class=\"{'open': vm.needHelpForm.phone.$error.length}\" class=\"text-danger\"\n                    translate=\"contact_number_length_error\" ></span>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label>Email:</label>\n            <input name=\"email\" type=\"email\" class=\"form-control\" ng-disabled=\"vm.waiting\" ng-model=\"vm.model.Email\" />\n            <div>\n                <span  ng-class=\"{'open': vm.needHelpForm.email.$error.required}\" class=\"text-danger\"\n                    translate=\"email_is_required\" ></span>\n                <span  ng-class=\"{'open': vm.needHelpForm.email.$error.email}\" class=\"text-danger\"\n                    translate=\"email_is_invalid\" ></span>\n            </div>\n        </div>\n        <div class=\"form-group wide posrel\">\n            <label translate=\"bried_description\" ></label>\n\n            <textarea name=\"description\" class=\"form-control\" ng-disabled=\"vm.waiting\" rows=\"10\" ng-model=\"vm.model.Description\"></textarea>\n            <div>\n                <span ng-class=\"{'open': vm.needHelpForm.description.$error.required}\" class=\"text-danger\"\n                    translate=\"brief_description_is_required\" ></span>\n                <span ng-class=\"{'open': vm.needHelpForm.description.$error.length}\" class=\"text-danger\"\n                    translate=\"brief_description_length_error\" ></span>\n            </div>\n        </div>\n        <div class=\"form-group wide\">\n            <label \n                translate=\"please_upload_images\" \n                >\n            </label>\n            <div nv-file-drop=\"\" uploader=\"vm.uploader\" class=\"uploader\">\n                <div nv-file-over=\"\" uploader=\"vm.uploader\" ng-click=\"vm.openMultipleInputup()\" over-class=\"bg-info\" class=\"box-placeholder my-drop-zone\"\n                    translate=\"upload_area_hint\" ></div>\n            </div>\n            <div class=\"hidden\">\n                <input filestyle=\"\" type=\"file\" id=\"multipleInputup\" ng-disabled=\"vm.waiting\" nv-file-select=\"\" uploader=\"vm.uploader\" multiple=\"\" class=\"hidden\" />\n            </div>\n        </div>\n        <div class=\"row pointLineWrap\">\n            <div class=\"col-lg-12 col-md-12 col-sm-12 \"> \n                <div ng-repeat=\"item in vm.uploader.queue\" class=\"pointLine\">\n                    <div>\n                        <!--progressbar ng-hide=\"item.progress === 100\"--> \n                        <div ng-hide=\"item.progress === 100 || item.isError\" class=\"progress progress-xs\">\n                            <div role=\"progressbar\" ng-style=\"{ 'width': item.progress + '%' }\" class=\"progress-bar\"></div>\n                        </div>\n                        <span class=\"text-danger width100InlBlock\" ng-show=\"item.isError\"><span class=\"fa fa-warning\"></span> {{item.errorMessage}} </span>\n                        <!--thumb-->\n                        <span ng-class=\"vm.getFileThumb(item)\"></span>\n                        <span ng-bind=\"item.file.name\" title=\"{{item.file.name}}\"></span>\n                        <!--cancel  or remove-->\n                        <a href=\"javascript:void(0)\" onclick=\"return false;\" ng-click=\"item.cancel();item.remove()\"><span class=\"fa fa-close\"></span></a>\n                        <a href=\"javascript:void(0)\" class=\"refresh\" ng-show=\"item.isError\" onclick=\"return false;\" ng-click=\"item.upload()\"><span class=\"fa fa-refresh\"></span></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger\" translate=\"button_cancel\" ></button>\n    <button type=\"button\" ng-click=\"vm.ok()\" ng-disabled=\"vm.waiting\" class=\"btn btn-success\" translate=\"button_submit\" ></button>\n</div>";

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<script>\n    $(function () {\n        $(\".touch .app-container\").click(function (e) {\n            $('.tooltip').hide();\n        });\n    });\n\n</script>\n\n<div class=\"app-view-header mt-9 mb9\">\n    <span>\n        <span ng-show=\"vm.isEdit\" translate=\"edit\"></span>\n        <span ng-hide=\"vm.isEdit\" translate=\"create\"></span>\n        <span translate=\"a_marketingcampaign\"></span>\n    </span>\n</div>\n<div ng-show=\"vm.campaign\"\n    class=\"panel panel-campaign panel-quick-camp panel-quick-camp-twoCol panel-edit mb-60 edit-campaign\">\n    <form name=\"vm.campaignForm\" class=\"form-validate positRelative\" autocomplete=\"off\" role=\"form\" novalidate>\n        <div class=\"panel-body newPad\">\n            <div class=\"overflow-quick-camp posRelForDeleteScroll\">\n                <div>\n                    <div class=\"form-group m0\"\n                        ng-show=\"vm.accordionOptions.setupGroupError || vm.accordionOptions.designGroupError || vm.accordionOptions.scheduleGroupError || vm.accordionOptions.audienceGroupError  ||  vm.accordionOptions.keywordsGroupError\">\n                        <div class=\"campainInput\">\n                            <span class=\"text-danger\" translate=\"your_form_has_some_errors\">\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <uib-accordion close-others=\"false\" class=\"accordion-customize\">\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.setupGroupOpen\">\n                        <uib-accordion-heading>\n                            <span translate=\"setup\"></span>\n                            <span ng-show=\"vm.accordionOptions.setupGroupError\"\n                                class=\"text-danger error-datepicker\">*</span>\n                        </uib-accordion-heading>\n                        <div class=\"form-group mb0\">\n                            <div>\n                                <label class=\"control-label\">\n                                    <ng-container translate=\"campaign_name\"></ng-container>\n                                </label>\n                                <div class=\"campainInput\">\n                                    <input type=\"text\" id=\"campaignName\" name=\"campaignName\" ng-model=\"vm.campaign.name\"\n                                        autocomplete=\"off\" class=\"form-control\" />\n                                    <div class=\"grayNote\" translate=\"max_100_characters\"></div>\n                                    <span\n                                        ng-show=\"vm.campaignForm.campaignName.$error.required && !vm.campaignForm.$pristine\"\n                                        class=\"text-danger\" translate=\"campaign_name_is_required\"></span>\n                                    <span ng-show=\"vm.campaignForm.campaignName.$error.maxlength\" class=\"text-danger\"\n                                        translate=\"campaign_name_too_long\"></span>\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class=\"form-group mb0 inline-block__wrap\">\n\n                            <div class=\"mb24\">\n                                <label class=\"control-label flexVerticalAlignParent\">\n                                    <ng-container translate=\"campaign_type\"></ng-container>\n                                    <em class=\"icon-question-circle inline-block icon24 opacity16 ml10\"\n                                        tooltip-popup-delay=\"200\" tooltip-placement=\"right\"\n                                        uib-tooltip-html=\"vm.htmlTooltip.campaignType\"></em>\n                                </label>\n                                <div class=\"flexVerticalAlignParent\">\n                                    <div ng-repeat=\"type in vm.campaignTypes\">\n                                        <label class=\"radio mr24\">\n                                            <input type=\"radio\" ng-model=\"vm.campaign.type\" name=\"campaignType\"\n                                                ng-value=\"type.value\" class=\"radio__input\" />\n                                            <span class=\"radio__check\"></span>\n                                            <span class=\"radio__label\" ng-bind=\"type.title\"></span>\n                                        </label>\n                                    </div>\n                                    <div\n                                        class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0 flexVerticalAlignParent referral-offer\">\n                                        <label class=\"pl28\">\n                                            <input type=\"checkbox\" ng-model=\"vm.campaign.isExclusiveOffer\">\n                                            <span class=\"fa fa-check mr15\"></span>\n                                            <ng-container translate=\"referral_offer\"></ng-container>\n                                        </label>\n                                        <em class=\"icon-question-circle inline-block icon24 opacity16 ml10\"\n                                            tooltip-popup-delay=\"200\" tooltip-placement=\"right\"\n                                            uib-tooltip-html=\"vm.htmlTooltip.referralOffer\"></em>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"mb24\">\n                                <label class=\"control-label flexVerticalAlignParent\">\n                                    <ng-container translate=\"jisp_exclusivity\"></ng-container>\n                                    <em class=\"icon-question-circle inline-block icon24 opacity16 ml10\"\n                                        tooltip-popup-delay=\"200\" tooltip-placement=\"right\"\n                                        uib-tooltip-html=\"vm.htmlTooltip.jispExclusivity\"></em>\n                                </label>\n                                <div class=\"flexVerticalAlignParent mBCont\">\n                                    <label class=\"radio mr24\" for=\"jispAvailable\">\n                                        <input type=\"radio\" ng-model=\"vm.campaign.jispExclusive\" id=\"jispAvailable\"\n                                            name=\"campaignJispExclusive\" ng-value=\"false\" class=\"radio__input\" />\n                                        <span class=\"radio__check\"></span>\n                                        <span class=\"radio__label\" translate=\"avialable_to_all_customers\"></span>\n                                    </label>\n                                    <label class=\"radio mr24\" for=\"jispExclusive\">\n                                        <input type=\"radio\" ng-model=\"vm.campaign.jispExclusive\" id=\"jispExclusive\"\n                                            name=\"campaignJispExclusive\" ng-value=\"true\" class=\"radio__input\" />\n                                        <span class=\"radio__check\"></span>\n                                        <span class=\"radio__label\" translate=\"exclusive_to_jisp_customers\"></span>\n                                    </label>\n                                </div>\n                            </div>\n\n                            <div class=\"row\">\n                                <div class=\"col-xs-12\" ng-show=\"vm.campaignPushNotificationShow\">\n                                    <div class=\"campainInput\">\n                                        <input type=\"text\" id=\"campaignPushNotification\" name=\"campaignPushNotification\"\n                                            ng-model=\"vm.campaign.pushNotification\" autocomplete=\"off\"\n                                            class=\"form-control\" translate\n                                            translate-attr-placeholder=\"notification_text\" />\n                                        <div class=\"grayNote\" translate=\"maximum_100_characters_full\"></div>\n                                        <span\n                                            ng-show=\"vm.campaignForm.campaignPushNotification.$error.required && !vm.campaignForm.$pristine\"\n                                            translate=\"push_notification_text_is_required\"\n                                            class=\"text-danger fs-13\"></span>\n                                        <span ng-show=\"vm.campaignForm.campaignPushNotification.$error.maxlength\"\n                                            translate=\"push_notification_text_too_long\"\n                                            class=\"text-danger fs-13\"></span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"mb-20\"></div>\n                        <product-stickers-list items=\"vm.campaign.nfcStickers\" stores=\"vm.stores\"\n                            is-list-disabled=\"!vm.canEditStickers\" hide-position=\"true\" errors=\"vm.stickersErrors\">\n                        </product-stickers-list>\n                    </div>\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.designGroupOpen\">\n                        <uib-accordion-heading>\n                            <span translate=\"design\"></span>\n                            <span ng-show=\"vm.accordionOptions.designGroupError\"\n                                class=\"text-danger error-datepicker\">*</span>\n                        </uib-accordion-heading>\n                        <div class=\"row designFields\">\n                            <div class=\"form-group m0 hidden\">\n                                <div class=\"clearfix radioGroup\">\n                                    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded m0\">\n                                        <label for=\"designImage\">\n                                            <input type=\"radio\" ng-model=\"vm.campaign.useTemplate\"\n                                                ng-click=\"vm.getCropImageDivWidth(); vm.resizeFontWithTimeOut()\"\n                                                id=\"designImage\" name=\"useTemplate\" ng-value=\"false\" />\n                                            <span class=\"fa fa-check\"></span>\n                                            <ng-container translate=\"upload_my_own_image\"></ng-container>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"m0\">\n                                <!-- image-->\n                                <div ng-class=\"{'hidden':vm.campaign.campaignContentType == 1 || vm.campaign.campaignContentType == 3, 'show':vm.campaign.campaignContentType == 2 || vm.campaign.campaignContentType == 4}\"\n                                    class=\"container-fluid \">\n                                    <div class=\"pl15 pr15\">\n                                        <div class=\"clearfix\">\n                                            <div class=\"width345\">\n                                                <div class=\"wrapPhone\">\n                                                    <div class=\"wrapPhoneInner\">\n                                                        <div class=\"widthSelector\">\n                                                            <div class=\"imgcrop-area-container \">\n                                                                <div class=\"imgcrop-preview-wrap \">\n                                                                    <div data-text=\"Cropped Image\"\n                                                                        class=\"imgcrop-preview \">\n                                                                        <img ng-show=\"vm.campaignForm.useTemplate.$valid && vm.imageCropped.croppedImage != null\"\n                                                                            imageonload=\"vm.imageOnload($event)\"\n                                                                            ng-src=\"{{vm.imageCropped.croppedImage}}\" />\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"image-error\">\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMinAreaSize\"\n                                                                        class=\"text-danger\">\n                                                                        <ng-container translate=\"cropped_image_error\">\n                                                                        </ng-container>\n                                                                        {{vm.imageCropped.minSize.w}}x{{vm.imageCropped.minSize.h}}\n                                                                        px\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMaxRatio\"\n                                                                        class=\"text-danger\"\n                                                                        translate=\"campaign_image_aspect_max_ratio_error\">\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMinRatio\"\n                                                                        class=\"text-danger\"\n                                                                        translate=\"campaign_image_aspect_min_ratio_error\">\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length == 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageRequired && vm.campaign.campaignContentType == 2\"\n                                                                        class=\"text-danger\"\n                                                                        translate=\"image_is_required\"></span>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                        <campaign-description campaign=\"vm.campaign\">\n                                                        </campaign-description>\n                                                    </div>\n                                                    <div class=\"typeInPhone\">\n                                                        <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                            type=\"vm.campaign.type\"></campaign-type>\n                                                        <span class=\"typeInPhoneJisp\" translate=\"jisp_store\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"cropImageDiv\">\n                                                <div class=\"no-scroll specMarg\">\n\n                                                    <div class=\"form-group  customInputFile inline-block\">\n                                                        <input id=\"fileInputCropped\" name=\"fileInputCropped\"\n                                                            filestyle=\"\" type=\"file\" data-class-button=\"btn btn-default\"\n                                                            data-class-input=\"form-control\"\n                                                            data-button-text=\"Upload your own image or video\"\n                                                            data-icon-name=\"fa fa-upload\"\n                                                            class=\"form-control btn btn-primary btn-144x37\"\n                                                            accept=\"image/png, image/jpeg, image/gif, image/bmp,\n                                                            video/mp4, video/avi, video/msvideo, video/x-msvideo, video/x-ms-wmv, video/quicktime,\n                                                            video/mpeg, video/x-matroska, video/x-flv, video/3gpp2, video/3gpp, video/webm, .3gp, .flv\" />\n                                                    </div>\n                                                    <a href=\"#\" class=\"block mb16\" ng-click=\"vm.needHelp()\">\n                                                        <ng-container translate=\"button_need_help_with_design\">\n                                                        </ng-container>\n                                                    </a>\n                                                </div>\n                                                <div class=\"imageNote imageNoteStandart pl0 mb16\"\n                                                    translate=\"image_or_video_note\">\n                                                </div>\n                                                <div class=\"labelCrop\">\n                                                    <div class=\"flexVerticalAlignParent mb4\">\n                                                        <!-- <span ng-show=\"vm.imageCropped.loading\" translate=\"processing_image\" ></span> -->\n                                                        <span class=\"text-danger flex-order-2\"\n                                                            ng-if=\"vm.campaignForm.useTemplate.$error.imageMinSize\">\n                                                            <ng-container translate=\"image_too_small_than\">\n                                                            </ng-container>\n                                                            {{vm.imageCropped.minSize.w}} x\n                                                            {{vm.imageCropped.minSize.h}} px\n                                                        </span>\n                                                        <span class=\"text-danger flex-order-2\"\n                                                            ng-if=\"vm.campaignForm.useTemplate.$error.fileType\"\n                                                            translate=\"image_file_type_error\"></span>\n                                                        <span class=\"text-danger flex-order-2\"\n                                                            ng-if=\"vm.campaignForm.useTemplate.$error.fileSize\"\n                                                            translate=\"image_file_size_error\"></span>\n                                                        <label class=\"text-normal fs-14 mb0 flex-order-1\">\n                                                            <ng-container translate=\"preview\"></ng-container>\n                                                            <span\n                                                                ng-show=\"vm.imageCropped.src &&  !vm.imageCropped.loading\">\n                                                                <span ng-show=\"vm.imageCropped.selector.size.w\">:\n                                                                    {{vm.imageCropped.selector.size.w}} &times;\n                                                                    {{vm.imageCropped.selector.size.h}}</span>\n                                                                <span\n                                                                    ng-show=\"!vm.imageCropped.selector.size && vm.imageCropped.selector.imageSize.w\">:\n                                                                    {{vm.imageCropped.selector.imageSize.w}} &times;\n                                                                    {{vm.imageCropped.selector.imageSize.h}}</span>\n                                                            </span>\n                                                        </label>\n                                                    </div>\n                                                </div>\n                                                <div class=\"imgcrop-area\"\n                                                    ng-if=\"!vm.imageCropped.src || (vm.imageCropped.src && vm.imageCropped.loading) \">\n                                                    <div class=\"imgcrop-area-inner\">\n                                                        <div class=\"imgcrop-area-table\">\n                                                            <div class=\"imgcrop-area-td\">\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div class=\"imgcrop-area noFixedArea\"\n                                                    ng-class=\"{'imgOpasity0': vm.imageCropped.loading, 'imgOpasity1': !vm.imageCropped.loading }\"\n                                                    ng-if=\"vm.imageCropped.src\">\n                                                    <div class=\"imgcrop-area-inner\">\n                                                        <div class=\"imgcrop-area-table\">\n                                                            <div class=\"imgcrop-area-td\">\n                                                                <div ng-if=\"!vm.imageCropped.isGif\" mr-image\n                                                                    mr-src=\"vm.imageCropped.src\"\n                                                                    mr-max-area-width=\"vm.imageCropped.maxWidth\"\n                                                                    mr-max-image-width=\"vm.imageCropped.maxSize.w\"\n                                                                    mr-scale=\"vm.imageCropped.scale\"\n                                                                    mr-selector=\"vm.imageCropped.selector\"\n                                                                    mr-drawer=\"vm.imageCropped.drawer\"\n                                                                    mr-on-load=\"vm.onLoadImgCrop\"\n                                                                    on-cropped=\"vm.onCropped(cropped)\"\n                                                                    ng-mousedown=\"vm.clearCropped()\"></div>\n                                                                <div>\n                                                                    <img ng-if=\"vm.imageCropped.isGif\"\n                                                                        ng-src=\"{{vm.imageCropped.src}}\" />\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- video-->\n                                <div ng-class=\"{'hidden':vm.campaign.campaignContentType != 3, 'show':vm.campaign.campaignContentType == 3}\"\n                                    class=\"container-fluid video-campaign\">\n                                    <div class=\"pl15 pr15\">\n                                        <div class=\"clearfix\">\n                                            <div class=\"width345\">\n                                                <div class=\"wrapPhone\">\n                                                    <div class=\"wrapPhoneInner\">\n                                                        <div class=\"widthSelector video-wrap\">\n                                                            <div class=\"imgcrop-area-container \">\n                                                                <i class=\"fa fa-film\" aria-hidden=\"true\"></i>\n                                                                <div class=\"imgcrop-preview-wrap \">\n                                                                    <div data-text=\"Cropped Image\">\n                                                                        <div ng-repeat=\"videoItem in vm.videos\">\n                                                                            <div videojs ng-model=\"videoItem\"\n                                                                                fixed-width=\"261\"\n                                                                                identifier=\"'design_accordion_video'\"\n                                                                                class=\"paddingTemlate\"></div>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                        <campaign-description campaign=\"vm.campaign\">\n                                                        </campaign-description>\n                                                    </div>\n                                                    <div class=\"typeInPhone\">\n                                                        <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                            type=\"vm.campaign.type\"></campaign-type>\n                                                        <span class=\"typeInPhoneJisp\" translate=\"jisp_store\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"cropImageDiv\" id=\"videoContainer\">\n                                                <div class=\"no-scroll specMarg\">\n                                                    <button type=\"button\" ng-click=\"vm.fileInputCroppedClick($event)\"\n                                                        class=\"btn btn-144x37 width246 mb8 btn-primary\">\n                                                        <ng-container translate=\"button_upload_your_own_image\">\n                                                        </ng-container>\n                                                    </button>\n                                                    <ng-container ng-show=\"vm.useTemplateEnable\">\n                                                        <span class=\"orSpan\">\n                                                            <ng-container translate=\"or\"></ng-container>\n                                                        </span>\n                                                        <button type=\"button\" ripple=\"\" ng-click=\"vm.changeTemplate()\"\n                                                            class=\"btn btn-144x37 mb8 btn-primary\">\n                                                            <ng-container translate=\"button_choose_a_template\">\n                                                            </ng-container>\n                                                        </button>\n\n                                                    </ng-container>\n\n                                                    <a href=\"#\" class=\"block mb16\" ng-click=\"vm.needHelp()\">\n                                                        <ng-container translate=\"button_need_help_with_design\">\n                                                        </ng-container>\n                                                    </a>\n                                                </div>\n\n                                                <div class=\"imageNote pl0 mb16\" translate=\"image_or_video_note\">\n                                                </div>\n\n                                                <div class=\"row pointLineWrap\">\n                                                    <div class=\"col-lg-12 col-md-12 col-sm-12 \">\n                                                        <div>\n                                                            <div class=\"flexVerticalAlignParent mb4\">\n                                                                <span ng-show=\"vm.videoManager.uploading\"\n                                                                    class=\"label label--upload mr10 \"\n                                                                    translate=\"uploading\"></span>\n                                                                <span ng-show=\"vm.videoManager.processing\">\n                                                                    <span class=\"label label--process mr10 \"\n                                                                        translate=\"processing\"></span>\n                                                                    <em class=\"fa fa-question-circle\"\n                                                                        tooltip-popup-delay=\"200\"\n                                                                        tooltip-class=\"width330\"\n                                                                        tooltip-placement=\"right\"\n                                                                        uib-tooltip-html=\"vm.htmlTooltip.videoProcessingTooltip\"></em>\n                                                                </span>\n                                                                <span ng-show=\"vm.videoManager.processed\"\n                                                                    class=\"label label--processed mr10 \"\n                                                                    translate=\"processed\"></span>\n                                                                <span ng-show=\"vm.videoManager.processingError\"\n                                                                    class=\"label label-danger mr10 \"\n                                                                    translate=\"processing_error\"></span>\n                                                                <span class=\"text-danger video-campaign__error\"\n                                                                    ng-show=\"vm.videoManager.error.fileSizeError\"\n                                                                    translate=\"video_file_size_error\"></span>\n                                                                <span class=\"text-danger video-campaign__error\"\n                                                                    ng-show=\"vm.videoManager.error.fileTypeError\"\n                                                                    translate=\"video_file_type_error\"></span>\n                                                                <span class=\"text-danger video-campaign__error--custom\"\n                                                                    ng-show=\"vm.videoManager.error.customError\">{{vm.videoManager.error.customError}}</span>\n\n\n                                                                <div ng-repeat=\"item in vm.uploader.queue\"\n                                                                    class=\"pointLine\">\n                                                                    <div>\n\n                                                                        <span\n                                                                            ng-show=\"vm.videoManager.uploading || item.isError\"\n                                                                            ng-bind=\"item.file.name\"\n                                                                            title=\"{{item.file.name}}\"\n                                                                            class=\"video-campaign__file-name mr10\"></span>\n                                                                        <!--cancel  or remove-->\n                                                                        <a href=\"javascript:void(0)\"\n                                                                            ng-show=\"vm.videoManager.uploading\"\n                                                                            onclick=\"return false;\"\n                                                                            ng-click=\"item.cancel();item.remove()\"\n                                                                            class=\"fs-14 text-danger\"\n                                                                            translate=\"cancel\"></a>\n                                                                        <a href=\"javascript:void(0)\" class=\"refresh\"\n                                                                            ng-show=\"item.isError\"\n                                                                            onclick=\"return false;\"\n                                                                            ng-click=\"item.upload()\"\n                                                                            class=\"fs-14 text-danger\"\n                                                                            translate=\"reload\"></a>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                            <div ng-hide=\"!vm.videoManager.uploading && (vm.videoManager.uploadingProgress === 100 || vm.videoManager.uploadingError)\"\n                                                                class=\"progress progress-gradient\">\n                                                                <div role=\"progressbar\"\n                                                                    ng-style=\"{ 'width': vm.videoManager.uploadingProgress + '%' }\"\n                                                                    class=\"progress-bar\"></div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n\n                                                <div class=\"imgcrop-area video-crop noFixedArea\">\n                                                    <div class=\"imgcrop-area-inner\">\n                                                        <div class=\"imgcrop-area-table\">\n                                                            <div class=\"imgcrop-area-td\">\n                                                                <div ng-repeat=\"videoItem in vm.videos\">\n                                                                    <div videojs fixed-width=\"\" max-height=\"500\"\n                                                                        max-width=\"870\"\n                                                                        video-container=\"'#videoContainer'\"\n                                                                        ng-model=\"videoItem\"\n                                                                        identifier=\"'design_accordion_video_preview'\"\n                                                                        class=\"paddingTemlate\"></div>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.scheduleGroupOpen\"\n                        ng-show=\"vm.accordionOptions.scheduleGroupShow\">\n                        <uib-accordion-heading>\n                            <span translate=\"schedule\"></span>\n                            <span ng-show=\"vm.accordionOptions.scheduleGroupError\"\n                                class=\"text-danger error-datepicker\">*</span>\n                        </uib-accordion-heading>\n                        <div class=\"row scheduleDate\">\n                            <div class=\"form-group pull-left calendar-fields\">\n                                <label class=\"control-label\"></label>\n                                <div class=\"datepickerWrap\">\n                                    <div class=\"datepickerWrapLine\">\n                                        <div\n                                            class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded ml0 mr0 mt0  \">\n                                            <label for=\"hasStartDate\">\n                                                <input type=\"checkbox\" ng-model=\"vm.campaign.schedule.hasStartDate\"\n                                                    ng-click=\"vm.updateCampaignModel()\" id=\"hasStartDate\" />\n                                                <span class=\"fa fa-check\"></span>\n                                                <ng-content translate=\"specify_start_date\"></ng-content>\n                                            </label>\n                                        </div>\n                                        <div class=\"input-group wrapRelative\">\n                                            <div class=\"layoutAbsShadow animate-show\"\n                                                ng-if=\"!vm.campaign.schedule.hasStartDate\"></div>\n                                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\"\n                                                ng-model=\"vm.campaign.schedule.startDate\" is-open=\"openedSD\"\n                                                datepicker-options=\"vm.dateOptions\" name=\"campaignStartDate\"\n                                                close-text=\"{{::'close' | translate}}\"\n                                                clear-text=\"{{::'clear' | translate}}\"\n                                                current-text=\"{{::'today' | translate}}\" readonly\n                                                class=\"form-control\" />\n                                            <span class=\"input-group-btn\">\n                                                <button type=\"button\"\n                                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedSD = true;\"\n                                                    class=\"btn btn-default\">\n                                                    <em class=\"fa fa-calendar\"></em>\n                                                </button>\n                                            </span>\n                                        </div>\n                                        <div ng-show=\"vm.campaignForm.campaignStartDate.$error.invalidDate\"\n                                            class=\"text-danger error-datepicker positAbs\" translate=\"invalid_date\">\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <label class=\"control-label\">\n                                            <ng-container translate=\"daily_start_time\"></ng-container>\n                                        </label>\n                                        <div class=\"timepickerLine flexVerticalAlignParent\">\n\n                                            <div>\n                                                <label class=\"radio mr24\">\n                                                    <input type=\"radio\" ng-model=\"vm.campaign.schedule.allDayStart\"\n                                                        ng-click=\"vm.campaign.schedule.updateState()\" ng-value=\"true\"\n                                                        class=\"radio__input\" />\n                                                    <span class=\"radio__check\"></span>\n                                                    <span class=\"radio__label\" translate=\"all_day\"></ng-container>\n                                                </label>\n\n                                                <label class=\"radio mr24\">\n                                                    <input type=\"radio\" ng-model=\"vm.campaign.schedule.allDayStart\"\n                                                        ng-click=\"vm.updateCampaignModel()\" ng-value=\"false\"\n                                                        class=\"radio__input\" />\n                                                    <span class=\"radio__check\"></span>\n                                                    <span class=\"radio__label\" translate=\"specific_time\"></span>\n                                                </label>\n                                            </div>\n\n                                            <div>\n                                                <span ng-show=\"vm.campaignForm.campaignStartTime.$error.invalidTime\"\n                                                    class=\"text-danger error-datepicker\"\n                                                    translate=\"invalid_time\"></span>\n                                            </div>\n\n                                            <div class=\"positRelative ml0\">\n                                                <div class=\"layoutAbsShadow animate-show\"\n                                                    ng-if=\"vm.campaign.schedule.allDayStart\"></div>\n                                                <div uib-timepicker ng-model=\"vm.campaign.schedule.startTime\"\n                                                    name=\"campaignStartTime\" show-meridian=\"true\"></div>\n                                            </div>\n\n\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\" form-group pull-left calendar-fields\">\n                                <label class=\"control-label\"></label>\n                                <div class=\"datepickerWrap\">\n                                    <div class=\"datepickerWrapLine \">\n                                        <div\n                                            class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded ml0 mt0 mr0 \">\n                                            <label for=\"hasEndDate\">\n                                                <input type=\"checkbox\" ng-model=\"vm.campaign.schedule.hasEndDate\"\n                                                    ng-click=\"vm.updateCampaignModel()\" id=\"hasEndDate\" />\n                                                <span class=\"fa fa-check\"></span>\n                                                <ng-container translate=\"specify_end_date\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"input-group endDatepicker wrapRelative\">\n                                            <div class=\"layoutAbsShadow animate-show\"\n                                                ng-if=\"!vm.campaign.schedule.hasEndDate\"></div>\n                                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\"\n                                                ng-model=\"vm.campaign.schedule.endDate\" is-open=\"openedED\"\n                                                datepicker-options=\"vm.dateOptions\" name=\"campaignEndDate\"\n                                                close-text=\"{{::'close' | translate}}\"\n                                                clear-text=\"{{::'clear' | translate}}\"\n                                                current-text=\"{{::'today' | translate}}\" readonly\n                                                class=\"form-control\" />\n                                            <span class=\"input-group-btn\">\n                                                <button type=\"button\"\n                                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedED = true;\"\n                                                    class=\"btn btn-default\">\n                                                    <em class=\"fa fa-calendar\"></em>\n                                                </button>\n                                            </span>\n                                        </div>\n                                        <div ng-show=\"vm.campaignForm.campaignEndDate.$error.invalidDate\"\n                                            class=\"text-danger error-datepicker positAbs\" translate=\"invalid_date\">\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <label class=\"control-label\">\n                                            <ng-container translate=\"daily_end_time\"></ng-container>\n                                        </label>\n                                        <div class=\"timepickerLine flexVerticalAlignParent\">\n                                            <div>\n                                                <label class=\"radio mr24\">\n                                                    <input type=\"radio\" ng-model=\"vm.campaign.schedule.allDayEnd\"\n                                                        ng-click=\"vm.campaign.schedule.updateState()\" ng-value=\"true\"\n                                                        class=\"radio__input\" />\n                                                    <span class=\"radio__check\"></span>\n                                                    <span class=\"radio__label\" translate=\"all_day\"></ng-container>\n                                                </label>\n                                                <label class=\"radio mr24\">\n                                                    <input type=\"radio\" ng-model=\"vm.campaign.schedule.allDayEnd\"\n                                                        ng-click=\"vm.updateCampaignModel()\" ng-value=\"false\"\n                                                        class=\"radio__input\" />\n                                                    <span class=\"radio__check\"></span>\n                                                    <span class=\"radio__label\" translate=\"specific_time\"></s>\n                                                </label>\n                                            </div>\n                                            <div class=\"positRelative ml0\">\n                                                <div class=\"layoutAbsShadow animate-show\"\n                                                    ng-if=\"vm.campaign.schedule.allDayEnd\"></div>\n                                                <div uib-timepicker ng-model=\"vm.campaign.schedule.endTime\"\n                                                    name=\"campaignEndTime\" show-meridian=\"true\"></div>\n                                            </div>\n                                            <div>\n                                                <span ng-show=\"vm.campaignForm.campaignEndTime.$error.invalidTime\"\n                                                    class=\"text-danger error-datepicker\"\n                                                    translate=\"invalid_time\"></span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- alert date -->\n                            <div class=\" form-group pull-left calendar-fields\">\n                                <label class=\"control-label\"></label>\n                                <div class=\"datepickerWrap\">\n                                    <div class=\"datepickerWrapLine\">\n                                        <div\n                                            class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded ml0 mt0 mr0 \">\n                                            <label for=\"hasAlertDate\">\n                                                <input type=\"checkbox\" ng-model=\"vm.campaign.schedule.hasAlertDate\"\n                                                    ng-click=\"vm.updateCampaignModel()\" id=\"hasAlertDate\" />\n                                                <span class=\"fa fa-check\"></span>\n                                                <ng-container translate=\"specify_alert_date\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"input-group endDatepicker wrapRelative\">\n                                            <div class=\"layoutAbsShadow animate-show\"\n                                                ng-if=\"!vm.campaign.schedule.hasAlertDate\"></div>\n                                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\"\n                                                ng-model=\"vm.campaign.schedule.alertDate\" is-open=\"openedAD\"\n                                                datepicker-options=\"vm.dateOptions\" name=\"campaignAlertDate\"\n                                                close-text=\"{{::'close' | translate}}\"\n                                                clear-text=\"{{::'clear' | translate}}\"\n                                                current-text=\"{{::'today' | translate}}\" readonly\n                                                class=\"form-control\" />\n                                            <span class=\"input-group-btn\">\n                                                <button type=\"button\"\n                                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedAD = true;\"\n                                                    class=\"btn btn-default\">\n                                                    <em class=\"fa fa-calendar\"></em>\n                                                </button>\n                                            </span>\n                                        </div>\n                                        <div ng-show=\"vm.campaignForm.campaignAlertDate.$error.required\"\n                                            class=\"text-danger error-datepicker positAbs\"\n                                            translate=\"to_launch_campaign_end_date_or_alert_date_are_required\"></div>\n                                        <div ng-show=\"vm.campaignForm.campaignAlertDate.$error.invalidDate\"\n                                            class=\"text-danger error-datepicker positAbs\" translate=\"invalid_date\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row recurringWrap\">\n                            <div class=\" form-group calendar-fields wd-wide\">\n                                <label class=\"control-label\">\n                                    <ng-container translate=\"recurring\"></ng-container>\n                                </label>\n                                <div>\n                                    <div class=\"clearfix\">\n                                        <div class=\"wd-md left\">\n                                            <label class=\"radio mr24\" for=\"datesDaily\">\n                                                <input type=\"radio\" ng-model=\"vm.campaign.schedule.hasDaily\"\n                                                    id=\"datesDaily\" ng-click=\"vm.campaign.schedule.setDaysOfWeek(true);\"\n                                                    name=\"datesHasDaily\" ng-value=\"true\" class=\"radio__input\" />\n                                                <span class=\"radio__check\"></span>\n                                                <span class=\"radio__label\" translate=\"daily\"></ng-cont>\n                                            </label>\n                                        </div>\n                                        <div class=\"ml246 clearfix\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded \"\n                                                ng-repeat=\"weeksday in  vm.campaign.schedule.daysOfWeek |  omit:'key == 0 || key == 6'\">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"weeksday.selected\"\n                                                        ng-change=\"vm.campaign.schedule.changeWeeksday()\"\n                                                        ng-disabled=\"vm.campaign.schedule.hasDaily\"\n                                                        ng-value=\"weeksday.key\" />\n                                                    <span class=\"fa fa-check\"></span>{{weeksday.name}}\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"clearfix\">\n                                        <div class=\"wd-md left\">\n                                            <label class=\"radio mr24\" for=\"datesSpecificWeeksdays\">\n                                                <input type=\"radio\" ng-model=\"vm.campaign.schedule.hasDaily\"\n                                                    id=\"datesSpecificWeeksdays\"\n                                                    ng-click=\"vm.campaign.schedule.setDaysOfWeek(false)\"\n                                                    name=\"datesHasDaily\" ng-value=\"false\" class=\"radio__input\" />\n                                                <span class=\"radio__check\"></span>\n                                                <span class=\"radio__label\" translate=\"specific_weekdays\"></span>\n                                            </label>\n                                        </div>\n                                        <div class=\"ml246  clearfix\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded \"\n                                                ng-repeat=\"weeksday in  vm.campaign.schedule.daysOfWeek | pick:'key == 0 || key == 6' | orderBy:'-key' \">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"weeksday.selected\"\n                                                        ng-change=\"vm.campaign.schedule.changeWeeksday()\"\n                                                        ng-disabled=\"vm.campaign.schedule.hasDaily\"\n                                                        ng-value=\"weeksday.key\" />\n                                                    <span class=\"fa fa-check\"></span>{{weeksday.name}}\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div>\n                                    <span ng-show=\"vm.campaignForm.datesHasDaily.$error.invalidDaysOfWeek\"\n                                        class=\"text-danger error-datepicker\" translate=\"invalid_working_days\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group is-open=\"false\">\n                        <uib-accordion-heading>\n                            <span translate=\"products\"></span>\n                        </uib-accordion-heading>\n                        <button type=\"button\" ng-click=\"vm.addProductLinks()\"\n                            class=\"btn btn-success btn-with-line mb15\">\n                            <em class=\"fa fa-plus\"></em>\n                            <span translate=\"button_add_products\"></span>\n                        </button>\n                        <div class=\"row\">\n                            <div class=\"variationsWrap pl15 pr15 pt15 pb15 linked-products\"\n                                ng-show=\"vm.campaign.campaignProductLinks.length\">\n                                <table class=\"full-width mb15\">\n                                    <tbody>\n                                        <tr ng-repeat=\"link in vm.campaign.campaignProductLinks\"\n                                            ng-class=\"{ 'linked-products__row--draft': link.isDraft }\">\n                                            <!-- linked-products__row--draft -->\n                                            <td class=\"wd-xxs pr10 pb10 pt10 pl15 text-center\" height=\"80px\">\n                                                <img ng-src=\"{{::link.imageUrl}}\" />\n                                            </td>\n                                            <td width=\"100%\" class=\"pr15 pb10 pt10 pl15\">\n                                                <span class=\"draftProduct\" translate=\"draft\"></span>&nbsp;<span\n                                                    class=\"mt0 inline-block\">{{::link.title}}</span>\n                                            </td>\n                                            <td\n                                                class=\"wd-xxs pb10 pt10 pl15 text-right linked-products__price text-nowrap\">\n                                                <span ng-show=\"link.oldPrice\">\n                                                    <span\n                                                        class=\"inactiveProduct\">{{::link.oldPrice | formatCurrency:vm.countryID}}</span>&nbsp;<span>{{::link.minPrice | formatCurrency:vm.countryID}}</span>\n                                                </span>\n                                                <span ng-show=\"!link.oldPrice && link.minPrice !== link.maxPrice\">\n                                                    {{::link.minPrice | formatCurrency:vm.countryID}} -\n                                                    {{::link.maxPrice | formatCurrency:vm.countryID}}\n                                                </span>\n                                                <span ng-show=\"!link.oldPrice && link.minPrice === link.maxPrice\">\n                                                    {{::link.minPrice | formatCurrency:vm.countryID}}\n                                                </span>\n                                            </td>\n                                            <td class=\"pr20 pl30 pb10 text-right wd-xxs\">\n                                                <button type=\"button\" title=\"Remove\"\n                                                    class=\"btn btn-danger btn-delete btn-no-bg mt7\"\n                                                    ng-click=\"vm.removeProductLink(link)\">\n                                                    <span class=\"fa fa-close\"></span>\n                                                </button>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                    <!-- Infotags -->\n                    <div uib-accordion-group is-open=\"false\">\n                        <uib-accordion-heading>\n                            <span translate=\"menu_infoTags\"></span>\n                        </uib-accordion-heading>\n                        <button type=\"button\" ng-click=\"vm.addInfotagLinks()\"\n                            class=\"btn btn-success btn-with-line mb15\">\n                            <em class=\"fa fa-plus\"></em>\n                            <span translate=\"button_add_infotags\"></span>\n                        </button>\n                        <div class=\"row\">\n                            <div class=\"variationsWrap pl15 pr15 pt15 pb15 linked-products\"\n                                ng-show=\"vm.campaign.campaignInformationCardLinks.length\">\n                                <table class=\"full-width mb15\">\n                                    <tbody>\n                                        <tr ng-repeat=\"link in vm.campaign.campaignInformationCardLinks\">\n                                            <!-- linked-products__row--draft -->\n                                            <td class=\"wd-xxs pr10 pb10 pt10 pl15 text-center\" height=\"80px\">\n                                                <img ng-src=\"{{vm.getImageUrl(link.ImageID)}}\" />\n                                            </td>\n                                            <td width=\"100%\" class=\"pr15 pb10 pt10 pl15\">\n                                                <span class=\"draftProduct\" translate=\"draft\"></span>&nbsp;<span\n                                                    class=\"mt0 inline-block\">{{::link.Title}}</span>\n                                            </td>\n                                            <td\n                                                class=\"wd-xxs pb10 pt10 pl15 text-right linked-products__price text-nowrap\">\n                                            </td>\n                                            <td class=\"pr20 pl30 pb10 text-right wd-xxs\">\n                                                <span class=\"btn btn-danger btn-delete btn-no-bg mt7\"\n                                                    ng-click=\"vm.removeInfotagLink(link)\">\n                                                    <span class=\"fa fa-close\"></span>\n                                                </span>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.audienceGroupOpen\">\n                        <uib-accordion-heading>\n                            <span translate=\"audience\"></span>\n                            <span ng-show=\"vm.accordionOptions.audienceGroupError\"\n                                class=\"text-danger error-datepicker\">*</span>\n                        </uib-accordion-heading>\n                        <input type=\"hidden\" name=\"rules\" ng-model=\"vm.campaignModel.offerAudience\" />\n                        <!-- Audience -->\n                        <div>\n                            <div>\n                                <span ng-show=\"vm.campaignForm.rules.$error.incompleteGroup\" class=\"text-danger\"\n                                    translate=\"empty_groups_are_now_allowed\">\n                                </span>\n                            </div>\n                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0 mb46\">\n                                <label class=\"pl28\">\n                                    <input type=\"checkbox\">\n                                    <span class=\"fa fa-check mr15\"></span>\n                                    <ng-container translate=\"display_within_10_km_from_the_store\"></ng-container>\n                                </label>\n                            </div>\n                            <div class=\"row\">\n                                <div class=\"col-xs-6\">\n                                    <!-- interests -->\n                                    <div class=\"form-group inner-group mb43\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0 mb18\">\n                                            <label class=\"pl28\">\n                                                <input type=\"checkbox\"\n                                                    ng-model=\"vm.audienceService.model.interests.enabled\"\n                                                    ng-change=\"vm.audienceService.enabledChange(vm.audienceService.model.interests)\" />\n                                                <span class=\"fa fa-check mr15\"></span>\n                                                <ng-container translate=\"promote_to_these_interests\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"inner-group__container\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb10\"\n                                                ng-repeat=\"option in vm.audienceService.model.interests.items\">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"option.selected\"\n                                                        ng-click=\"vm.audienceService.update()\"\n                                                        ng-disabled=\"!vm.audienceService.model.interests.enabled\" />\n                                                    <span class=\"fa fa-check mr15\"></span>{{ option.title }}\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- categories -->\n                                    <div class=\"form-group inner-group\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb18 \"\n                                            ng-show=\"vm.audienceService.model.categories.items.length > 0\">\n                                            <label class=\"pl28\">\n                                                <input type=\"checkbox\"\n                                                    ng-model=\"vm.audienceService.model.categories.enabled\"\n                                                    ng-change=\"vm.audienceService.enabledChange(vm.audienceService.model.categories)\" />\n                                                <span class=\"fa fa-check mr15\"></span>\n                                                <ng-container translate=\"only_in_these_categories\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"inner-group__container\"\n                                            ng-if=\"vm.audienceService.model.categories.items.length > 0\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb10\"\n                                                ng-repeat=\"option in vm.audienceService.model.categories.items\">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"option.selected\"\n                                                        ng-change=\"vm.audienceService.update()\"\n                                                        ng-disabled=\"!vm.audienceService.model.categories.enabled\" />\n                                                    <span class=\"fa fa-check mr15\"></span>\n                                                    {{::option.title}}\n                                                </label>\n                                            </div>\n                                        </div>\n                                        <div ng-show=\"vm.audienceService.model.categories.items.length === 0\">\n                                            <span class=\"text-danger\"\n                                                  translate=\"marketing_campaign_audience_no_categories\">\n                                            </span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-xs-6\">\n                                    <!--  genders -->\n                                    <div class=\"form-group  inner-group mb43\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0 mb18\">\n                                            <label class=\"pl28\">\n                                                <input type=\"checkbox\"\n                                                    ng-model=\"vm.audienceService.model.genders.enabled\"\n                                                    ng-change=\"vm.audienceService.enabledChange(vm.audienceService.model.genders)\" />\n                                                <span class=\"fa fa-check mr15\"></span>\n                                                <ng-container translate=\"promote_to_these_genders\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"inner-group__container\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb10\"\n                                                ng-repeat=\"option in vm.audienceService.model.genders.items\">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"option.selected\"\n                                                        ng-click=\"vm.audienceService.update()\"\n                                                        ng-disabled=\"!vm.audienceService.model.genders.enabled\" />\n                                                    <span class=\"fa fa-check mr15\"></span>{{ option.title }}\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- ages -->\n                                    <div class=\"form-group inner-group mb43\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb18\">\n                                            <label class=\"pl28\">\n                                                <input type=\"checkbox\" ng-model=\"vm.audienceService.model.ages.enabled\"\n                                                    ng-change=\"vm.audienceService.enabledChange(vm.audienceService.model.ages)\" />\n                                                <span class=\"fa fa-check mr15\"></span>\n                                                <ng-container translate=\"promote_to_the_age_group\"></ng-container>\n                                            </label>\n                                        </div>\n                                        <div class=\"inner-group__container\">\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb10\"\n                                                ng-repeat=\"option in vm.audienceService.model.ages.items\">\n                                                <label>\n                                                    <input type=\"checkbox\" ng-model=\"option.selected\"\n                                                        ng-click=\"vm.audienceService.update()\"\n                                                        ng-disabled=\"!vm.audienceService.model.ages.enabled\" />\n                                                    <span class=\"fa fa-check mr15\"></span>{{ option.title }}\n                                                </label>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- places -->\n                                    <div class=\"form-group inner-group mb43\"\n                                        ng-if=\"vm.audienceService.model.places.items.length > 0\">\n                                        <!-- group -->\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0 mb18\">\n                                            <label class=\"pl28\">\n                                                <input type=\"checkbox\"\n                                                    ng-model=\"vm.audienceService.model.places.enabled\"\n                                                    ng-change=\"vm.audienceService.enabledPlaceChange();\" />\n                                                <span class=\"fa fa-check mr15\"></span>\n                                                <ng-container translate=\"only_in_these_places\"></ng-container>\n\n                                            </label>\n                                        </div>\n                                        <div class=\"inner-group__container\">\n                                            <div class=\"flexVerticalAlignParent inner-group__hero-line\">\n                                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0\">\n                                                    <label class=\"flexVerticalAlignParent\">\n                                                        <input type=\"checkbox\"\n                                                            ng-model=\"vm.audienceService.model.places.selected\"\n                                                            ng-change=\"vm.audienceService.selectedPlaceChange(vm.audienceService.model.places)\"\n                                                            ng-disabled=\"!vm.audienceService.model.places.enabled\">\n                                                        <span class=\"fa fa-check mr15\"></span>\n                                                        <ng-container translate=\"places\"></ng-container>\n                                                    </label>\n                                                </div>\n                                            </div>\n                                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt0  mb10 clearfix\"\n                                                ng-repeat=\"option in vm.audienceService.model.places.items\">\n                                                <label ng-class=\"{'archived':option.archived}\">\n                                                    <input type=\"checkbox\" ng-model=\"option.selected\"\n                                                        ng-change=\"vm.audienceService.changeSelectedPlace(option, vm.audienceService.model.places)\"\n                                                        ng-disabled=\"!vm.audienceService.model.places.enabled || (option.archived && !option.selected)\" />\n                                                    <span class=\"fa fa-check mr15\"></span>\n                                                    {{option.title}} ({{option.town}})\n                                                </label>\n                                                <em ng-if=\"option.archived\" class=\"fa fa-exclamation-triangle\"\n                                                    tooltip-animation=\"true\" tooltip-popup-delay=\"200\"\n                                                    tooltip-placement=\"right\"\n                                                    translate-attr-uib-tooltip-html=\"this_place_has_been_archived_it_causes_the_error\"></em>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group\">\n                                <span ng-show=\"vm.campaignForm.rules.$error.audienceStores\" class=\"text-danger\"\n                                    translate=\"you_must_select_any_or_all_active_places\"></span>\n                                <span ng-show=\"vm.campaignForm.rules.$error.audienceStoreCampaigns\" class=\"text-danger\"\n                                    translate=\"none_or_allowed_category_is_required\"></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group>\n                        <uib-accordion-heading>\n                            <ng-container translate=\"additional_information\"></ng-container>\n                        </uib-accordion-heading>\n                        <div class=\"mb15\" translate=\"additional_information_hint\">\n                        </div>\n                        <div class=\"campaignAdditInfo\">\n                            <div text-angular ta-resize-force-aspect-ratio=\"true\" ng-model=\"vm.campaign.additionalInfo\"\n                                ta-paste=\"vm.pasteHandler($html)\" name=\"description\" class=\"btn-group-small\"></div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.keywordsGroupOpen\">\n                        <uib-accordion-heading>\n                            <span translate=\"keywords_optional\"></span>\n                            <span ng-show=\"vm.accordionOptions.keywordsGroupError\"\n                                class=\"text-danger error-datepicker\">*</span>\n                        </uib-accordion-heading>\n                        <div class=\"mb15g\">\n                            <span translate=\"specify_keywords_for_your_campaign_to_improve_its_discoverability\"></span>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12 keywordsWrap\"\n                                ng-repeat=\"item in vm.campaign.keywords\">\n                                <div class=\"keywordsField\">\n                                    <input class=\"form-control\" type=\"text\" ng-model=\"item.keyword\"\n                                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1500, blur: 0 }}\"\n                                        ng-change=\"vm.updateKeyword()\" />\n                                    <span class=\"fa fa-remove pull-left\" ng-click=\"vm.deleteKeyword(item)\"></span>\n                                </div>\n                                <span class=\"text-danger\" ng-bind=\"item.error\"></span>\n                            </div>\n                            <div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\">\n                                <input type=\"hidden\" name=\"keywords\" ng-model=\"vm.campaign.keywords\" />\n                                <button type=\"button\" class=\"btn btn-success btn-with-line pull-left wd-auto mb20\"\n                                    ng-click=\"vm.addKeyword(item)\">\n                                    <em class=\"fa fa-plus\"></em>\n                                    <span translate=\"add_keyword\"></span>\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div uib-accordion-group is-open=\"vm.accordionOptions.summaryGroupOpen\">\n                        <uib-accordion-heading>\n                            <ng-container translate=\"campaign_summary\"></ng-container>\n                        </uib-accordion-heading>\n                        <div class=\"row designFields\">\n                            <div class=\"m0\">\n                                <!-- image -->\n                                <div ng-class=\"{'hidden':vm.campaign.campaignContentType == 1 || vm.campaign.campaignContentType == 3, 'show':vm.campaign.campaignContentType == 2 || vm.campaign.campaignContentType == 4}\"\n                                    class=\"container-fluid \">\n                                    <div class=\"pl15 pr15\">\n                                        <div class=\"clearfix\">\n                                            <div class=\"width345\">\n                                                <div class=\"wrapPhone\">\n                                                    <div class=\"wrapPhoneInner\">\n                                                        <div class=\"widthSelector\">\n                                                            <div class=\"imgcrop-area-container \">\n                                                                <div class=\"imgcrop-preview-wrap \">\n                                                                    <div data-text=\"Cropped Image\"\n                                                                        class=\"imgcrop-preview \">\n                                                                        <img ng-show=\"vm.campaignForm.useTemplate.$valid && vm.imageCropped.croppedImage != null\"\n                                                                            imageonload=\"vm.imageOnload($event)\"\n                                                                            ng-src=\"{{vm.imageCropped.croppedImage}}\" />\n                                                                    </div>\n                                                                </div>\n                                                                <div class=\"image-error\">\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMinAreaSize\"\n                                                                        class=\"text-danger mb8\">\n                                                                        <ng-container translate=\"cropped_image_error\">\n                                                                        </ng-container>\n                                                                        {{vm.imageCropped.minSize.w}}x{{vm.imageCropped.minSize.h}}\n                                                                        px.\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMaxRatio\"\n                                                                        class=\"text-danger mb8\"\n                                                                        translate=\"campaign_image_aspect_max_ratio_error\">\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length > 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageMinRatio\"\n                                                                        class=\"text-danger mb8\"\n                                                                        translate=\"campaign_image_aspect_min_ratio_error\">\n                                                                    </span>\n                                                                    <span\n                                                                        ng-show=\"vm.imageCropped.src.length == 0 && !vm.imageCropped.loading && vm.campaignForm.useTemplate.$error.imageRequired && vm.campaign.campaignContentType == 2\"\n                                                                        class=\"text-danger mb8\"\n                                                                        translate=\"image_is_required\"></span>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                        <campaign-description campaign=\"vm.campaign\">\n                                                        </campaign-description>\n                                                    </div>\n                                                    <div class=\"typeInPhone\">\n                                                        <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                            type=\"vm.campaign.type\"></campaign-type>\n                                                        <span class=\"typeInPhoneJisp\" translate=\"jisp_store\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"summaryDescr\">\n                                                <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                    type=\"vm.campaign.type\"></campaign-type>\n                                                <h3 class=\"posCampStatus\" ng-bind=\"vm.campaign.name\"></h3>\n                                                <campaign-status status=\"vm.campaign.statusModel.status\"\n                                                    message=\"vm.campaign.statusModel.message\"></campaign-status>\n                                                <div class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\">\n                                                        <ng-container translate=\"schedule\"></ng-container>\n                                                    </label>\n                                                    <div>\n                                                        <campaign-active-date\n                                                            start-date=\"vm.campaign.schedule.getStartDate()\"\n                                                            end-date=\"vm.campaign.schedule.getEndDate()\">\n                                                        </campaign-active-date>\n                                                    </div>\n                                                    <div>\n                                                        <campaign-active-time\n                                                            start-time=\"vm.campaign.schedule.getDailyStartTime()\"\n                                                            end-time=\"vm.campaign.schedule.getDailyEndTime()\">\n                                                        </campaign-active-time>\n                                                    </div>\n                                                    <days-of-week days=\"vm.campaign.schedule.daysOfWeekInt\">\n                                                    </days-of-week>\n                                                </div>\n                                                <div ng-if=\"vm.campaign.campaignContentType == 2 || vm.campaign.campaignContentType == 4\"\n                                                    class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\">\n                                                        <ng-container translate=\"audience\"></ng-container>\n                                                    </label>\n                                                    <div>\n                                                        <audience-view class=\"newAudienceWrap fs-14\"\n                                                            audience=\"vm.audienceService.model\"\n                                                            change=\"vm.audienceService.changeModel\">\n                                                        </audience-view>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\" translate=\"keywords\"></label>\n                                                    <div>\n                                                        <campaign-keywords keywords=\"vm.campaign.keywords\">\n                                                        </campaign-keywords>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group mb0 \">\n                                                    <div ng-if=\"vm.campaign.campaignContentType == 2 || vm.campaign.campaignContentType == 4\"\n                                                        ng-include=\"'campaignState'\"></div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- video -->\n                                <div ng-class=\"{'hidden':vm.campaign.campaignContentType != 3, 'show':vm.campaign.campaignContentType == 3}\"\n                                    class=\"container-fluid \">\n                                    <div class=\"pl15 pr15\">\n                                        <div class=\"clearfix\">\n                                            <div class=\"width345\">\n                                                <div class=\"wrapPhone\">\n                                                    <div class=\"wrapPhoneInner\">\n                                                        <div class=\"widthSelector video-edit\">\n                                                            <div class=\"imgcrop-area-container \">\n                                                                <div class=\"imgcrop-preview-wrap \">\n                                                                    <div data-text=\"Cropped Image\">\n                                                                        <div ng-repeat=\"videoItem in vm.videos\">\n                                                                            <div videojs ng-model=\"videoItem\"\n                                                                                fixed-width=\"261\"\n                                                                                identifier=\"'summary_accordion_video'\"\n                                                                                class=\"paddingTemlate\"></div>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                        <campaign-description campaign=\"vm.campaign\">\n                                                        </campaign-description>\n                                                    </div>\n                                                    <div class=\"typeInPhone\">\n                                                        <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                            type=\"vm.campaign.type\"></campaign-type>\n                                                        <span class=\"typeInPhoneJisp\" translate=\"jisp_store\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"summaryDescr\">\n                                                <campaign-type exclusive=\"vm.campaign.jispExclusive\"\n                                                    type=\"vm.campaign.type\"></campaign-type>\n                                                <h3 class=\"posCampStatus\" ng-bind=\"vm.campaign.name\"></h3>\n                                                <campaign-status status=\"vm.campaign.statusModel.status\"\n                                                    message=\"vm.campaign.statusModel.message\"></campaign-status>\n                                                <div class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\">\n                                                        <ng-container translate=\"schedule\"></ng-container>\n                                                    </label>\n                                                    <div>\n                                                        <campaign-active-date\n                                                            start-date=\"vm.campaign.schedule.getStartDate()\"\n                                                            end-date=\"vm.campaign.schedule.getEndDate()\">\n                                                        </campaign-active-date>\n                                                    </div>\n                                                    <div>\n                                                        <campaign-active-time\n                                                            start-time=\"vm.campaign.schedule.getDailyStartTime()\"\n                                                            end-time=\"vm.campaign.schedule.getDailyEndTime()\">\n                                                        </campaign-active-time>\n                                                    </div>\n                                                    <days-of-week days=\"vm.campaign.schedule.daysOfWeekInt\">\n                                                    </days-of-week>\n                                                </div>\n                                                <div ng-if=\"vm.campaign.campaignContentType == 3\"\n                                                    class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\">\n                                                        <ng-container translate=\"audience\"></ng-container>\n                                                    </label>\n                                                    <div>\n                                                        <audience-view class=\"newAudienceWrap s-t14\"\n                                                            audience=\"vm.audienceService.model\"\n                                                            change=\"vm.audienceService.changeModel\">\n                                                        </audience-view>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group m0 fs-14\">\n                                                    <label class=\"control-label\" translate=\"keywords\"></label>\n                                                    <div>\n                                                        <campaign-keywords keywords=\"vm.campaign.keywords\">\n                                                        </campaign-keywords>\n                                                    </div>\n                                                </div>\n                                                <div class=\"form-group mb0 \">\n                                                    <div ng-if=\"vm.campaign.campaignContentType == 3\"\n                                                        ng-include=\"'campaignState'\"></div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </uib-accordion>\n            </div>\n        </div>\n        <div ng-show=\"vm.waiting\" class=\"shadowCampaignform\"></div>\n    </form>\n    <span ng-init=\"vm.customScroll()\"></span>\n    <div class=\"panel-heading bg-transparent\">\n        <div class=\"pull-right\">\n            <div class=\"btn-form btn-form-header clearfix pr15\">\n                <button ng-show=\"vm.isEdit\" type=\"button\" ng-click=\"vm.archiveCampaign()\" ng-disabled=\"vm.waiting\"\n                    translate translate-attr-title=\"to_archive\" class=\"btn btn-sm btn-black\">\n                    <em class=\"fa fa-trash\"></em>\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.campaignForm.$setPristine(); vm.pageBack();\"\n                    class=\"btn btn-danger h37\" translate=\"button_cancel\"></button>\n                <button type=\"button\" ng-click=\"vm.save()\"\n                    ng-disabled=\"vm.waiting || !vm.campaign || vm.campaignForm.$pristine && vm.isEdit\"\n                    class=\"btn btn-success wd-auto h37\">\n                    <span ng-show=\"!vm.campaign.draft && !vm.isEdit\" translate=\"button_launch_campaign\"></span>\n                    <span ng-show=\"!vm.campaign.draft && vm.isEdit\" translate=\"button_save_campaign\"></span>\n                    <span ng-show=\"vm.campaign.draft\" translate=\"button_save_as_draft\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"panel-title text-ellipsis\">&nbsp;</div>\n    </div>\n</div>\n<script type=\"text/ng-template\" id=\"campaignState\">\n    <div >\n        <label class=\"control-label\">Campaign state</label>\n        <div class=\"clearfix radioGroup\">\n            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded m0\" ng-repeat=\"state in vm.campaignEntityStates\">\n                <label>\n                    <input type=\"radio\" ng-model=\"vm.campaign.entityStatus\" ng-click=\"vm.updateCampaignModel()\" name=\"campaignState\" ng-value=\"state.value\" ng-disabled=\"state.isDisabled()\" />\n                    <span class=\"fa fa-check\"></span><ng-container ng-bind=\"state.title\"></ng-container>\n                </label>\n            </div>\n        </div>\n    </div>\n</script>\n";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "<!--<div class=\"app-view-header mt-9\"><span ng-bind=\"campaign.Name\"></span></div>-->\n<div class=\"panel panel-campaign animated rotateInDownLeft  panel\" ng-if=\"vm.campaign\">\n    <div class=\"panel-heading whiteHideTitle\">\n        <div class=\"pull-right\">\n            <div class=\"buttons\">\n                <button type=\"button\" translate translate-attr-title=\"button_copy_campaign\" ng-click=\"vm.copyCampaign()\"\n                    class=\"btn btn-sm btn-info\">\n                    <em class=\"fa fa-copy\"></em>\n                </button>\n                <button type=\"button\" ng-hide=\"vm.isArchived\" ng-click=\"vm.editCampaign()\" translate\n                    translate-attr-title=\"button_edit_campaign\" class=\"btn btn-sm btn-info\">\n                    <em class=\"fa fa-pencil\"></em>\n                </button>\n            </div>\n        </div>\n        <div class=\"panel-title\">\n            <span ng-bind=\"vm.campaign.name\"></span>&nbsp;</div>\n    </div>\n    <div class=\"panel-body \">\n        <div class=\"width345\">\n            <!--image -->\n            <div class=\"wrapPhone\">\n                <div class=\"wrapPhoneInner\">\n                    <div ng-if=\"vm.campaign.image && (!vm.campaign.video)\" class=\"imgCampainWrap\">\n                        <div class=\"form-group m0 imgCampain paddingTemlate widthSelector padmar0 mb0 \">\n                            <!--<div ng-if=\"isRetailing\" ng-show=\"campaign.JispExclusive\" class=\"jispExlusiveImage\">Jisp Exclusive</div>-->\n                            <img ng-src=\"{{ vm.campaign.image.imageUrl }}\" alt=\"\" />\n                        </div>\n                    </div>\n                    <div ng-if=\"vm.campaign.video\" class=\"imgCampainWrap\">\n                        <div\n                            class=\"form-group m0 imgCampain paddingTemlate widthSelector padmar0 video-campaign-overview\">\n                            <div ng-repeat=\"videoItem in vm.videos\">\n                                <div videojs ng-model=\"videoItem\" fixed-width=\"261\" identifier=\"'view_campaign'\"\n                                    class=\"paddingTemlate\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"paddingTemlate\">\n\n                    </div>\n                    <div ng-if=\"!vm.campaign.image && !vm.campaign.video\"\n                        class=\"imgCampainWrap\">\n                        <div class=\"form-group m0 imgCampain paddingTemlate widthSelector padmar0 simpleView\">\n                            <span class=\"fa fa-image fa-custom-placeholder\"></span>\n                        </div>\n                    </div>\n                    <campaign-description campaign=\"vm.campaign\"></campaign-description>\n                </div>\n                <!--Type-->\n                <div class=\"typeInPhone\">\n                    <campaign-type ng-if=\"vm.isRetailing\" exclusive=\"vm.campaign.jispExclusive\" type=\"vm.campaign.type\">\n                    </campaign-type>\n                    <!--<span ng-if=\"campaign.Type == campaignType.Offer\">Offer</span>\n                            <span ng-if=\"campaign.Type == campaignType.Promotion\">Promotion</span>-->\n                    <span ng-if=\"vm.campaign.type == vm.campaignType.Advert\" translate=\"advertisement\"></span>\n                    <span class=\"typeInPhoneJisp\" translate=\"jisp_store\"></span>\n                </div>\n            </div>\n        </div>\n        <div>\n            <!--name-->\n            <div class=\"form-group m0\">\n                <h2 class=\"campTitle\">\n                    <span ng-bind=\"vm.campaign.name\"></span>\n                </h2>\n                <div class=\"fs-14\">\n                    <span translate=\"created_on\"\n                        translate-value-date=\"{{vm.campaign.createDate | date:'dd MMM yyyy'}}\"></span>\n                </div>\n            </div>\n            <!--status-->\n            <div class=\"form-group\">\n                <div class=\"mb7\">\n                    <campaign-status status=\"vm.campaign.statusModel.status\" message=\"vm.campaign.statusModel.message\">\n                    </campaign-status>\n                </div>\n                <div class=\"fs-14 mb3\">\n                    <campaign-active-date start-date=\"vm.campaign.schedule.getStartDate()\"\n                        end-date=\"vm.campaign.schedule.getEndDate()\"></campaign-active-date>\n                </div>\n                <div ng-if=\"isRetailing\" class=\"fs-14 mb3\">\n                    <campaign-active-time start-time=\"vm.campaign.schedule.getDailyStartTime()\"\n                        end-time=\"vm.campaign.schedule.getDailyEndTime()\">\n                    </campaign-active-time>\n                </div>\n                <div class=\"fs-14 mb3\">\n                    <days-of-week days=\"vm.campaign.schedule.daysOfWeekInt\"></days-of-week>\n                </div>\n            </div>\n            <!--rule-->\n            <div class=\"form-group m0 fs-14\">\n                <label class=\"control-label\" translate=\"audience\"></label>\n                <div>\n                    <audience-view class=\"newAudienceWrap fs-14\" audience=\"vm.audienceOffer\">\n                    </audience-view>\n                </div>\n            </div>\n            <!--keywords-->\n            <div class=\"form-group m0 fs-14\" ng-if=\"vm.campaign.keywords && vm.campaign.keywords.length > 0\">\n                <label class=\"control-label\" translate=\"keywords\"></label>\n                <div>\n                    <campaign-keywords keywords=\"vm.campaign.keywords\"></campaign-keywords>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div ng-if=\"vm.campaign != null\">\n    <campaign-analytics schedule=\"vm.campaign.schedule\"></campaign-analytics>\n</div>";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "<div class=\"click-and-deliver\">\n    <div class=\"panel\">\n        <div class=\"panel-body\">\n            <div class=\"click-and-deliver__filters flexVerticalAlignParent\">\n                <div class=\"posRel searchInput mr30 flex-stretch\">\n                    <input type=\"text\" name=\"\" class=\"form-control \" placeholder=\"Order # or customer name\">\n                    <span class=\"fa fa-search\"></span>\n                </div>\n                <label class=\"mr9\" for=\"status\">Status</label>\n                <select class=\"form-control mr30 max-w110\" id=\"status\">\n                    <option>All</option>\n                </select>\n                <div class=\"date-range flexVerticalAlignParent mr30\">\n                    <div class=\"date-range__inner flexVerticalAlignParent mr5 \">\n                        <label class=\"mr9 text-nowrap \" translate=\"date_range\"></label>\n                        <input type=\"text\" class=\"form-control date-input\" value=\"1 Feb 2015\" />\n                        <span class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-default\">\n                            <em class=\"fa fa-calendar\"></em>\n                            </button>\n                        </span>\n                    </div>\n                    <span class=\"mr5\">–</span>\n                    <div class=\"date-range__inner flexVerticalAlignParent\">\n                        <input type=\"text\" class=\"form-control date-input\" value=\"1 May 2018\" />\n                        <span class=\"input-group-btn\">\n                            <button type=\"button\" class=\"btn btn-default\">\n                            <em class=\"fa fa-calendar\"></em>\n                            </button>\n                        </span>\n                    </div>\n                </div>\n                <button class=\"btn btn-primary\">Show</button>\n            </div>\n            <div class=\"click-and-deliver__table-orders\">\n                <table class=\"table fullWidth\">\n                    <thead>\n                        <tr>\n                            <th>\n                                <span class=\"fs-23 fw-400 mr10 \">Order #39000070242</span>\n                                <span class=\"fs-13 fw-400\"><i class=\"fa fa-clock-o\" aria-hidden=\"true\"></i> 02:59:38 pm</span>\n                            </th>\n                            <th></th>\n                            <th><b>Client</b></th>\n                            <th class=\"text-right text-nowrap\">\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" role=\"img\" height=\"14\" viewBox=\"0 0 384 512\"><path fill=\"#585f69\" d=\"M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z\"/></svg>\n                            Paid, waiting for confirmation</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr>\n                            <td width=\"45%\" class=\"pb18\">\n                                <div class=\"table-orders__item flexVerticalAlignParent\">\n                                    <ul class=\"orders__list m0\">\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,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\" width=\"29\" height=\"29\" alt=\"Layer-1863.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEZElEQVRIx72WW2hdRRSGvzX72qRNcpq0hdiSNC0qtbRpTIMohXoptMUH9UFUkPrgk4IXRBQRBEtfFOmjIII+axWUipeiSIWCtFBsYiVJVVrTWy4952Sf2z57z4wPJzlWbPfRBJzH2cN861//2muWGGPOATn+v5V3gbXAqqxTInLDfWvtP85cv3eT5blA0go4MTFBEATkcjmUUhhj0FrjeR6+7yMixHFMrVajp6enFThx/00+SqUSaZriui6O42CtJUkSRISOjg7a2tqI4xitdTPQLLBqpfLKlcuUSiWCICAMQ8IwhLYVJJ5LHMdU63UQwfd9kiRZCFBnilBZwFK5ypkzP9pb-xls+n+fjI0eoxDW6P/mSns+Psaa3F3VpGlcpgjCgu7ubqalLTE5euGkdtFRaqdSIFlT29/czWyhw8cdTOCdOoo59T3j5KrlihB7/FXEb/rpK4buSdS2Znvqei6McjDHMzMxQr8eQpJgH9zC/rpvcxDlkdBK5ZydWBKwFx0G5wdKhjiNYaxAR8vk8Ub5AuPV21Kdfs+bQUSQ12O7VcOBRsAYAYzRWp0uHiihEoFwuUywWGR4ZQU3Pofc9QLR5I+H0LOr0GPwxhV3Xg0VjjMHJNK2Fp0oJYNFas7K9namrVyjOzCKffYVJEmTsF5x8CdW3AZumWAtaGxwvm5qpVEmjEYRhSGoM928f4o6BTaSDO2g7+DbufBl542Uk1wU6RRwF1qJsdiFlhmSxGGNIkoS7d+9m26lRvP1P4Dz5DO6Fi0i+AC+8jvn9POJ7C0o1vu8tx9NGL9VaI2mKvW8XZmQIE8fUj36Dbw3Ovj3Ihl5sPQGl0Ebj+e7SoUoprG2otVrjDG3DArz6JuG3P6AcFzNbRHbdhYQ+2EaQvrccpTQKyRjzV8p/O4/ecAtzHxxmZW41K06fRZ+dhJFBJE3Rafq38//ZU1GCXYh+sYHbMMD6PlYprBLEdUAa4YkISZKQ1Jf1n0ozvYhgi/Pg+Tj5PGsPPI8kKWbnEM777yw0BAEE5TrL87T5THke+t0Psf198NKzTG/eyCoLfrmKk6RI00eLyv5jaNE7rkttpYLcupngob2ITikObqH+yH68LbehT48hjsPiwyKyjOYgIk2lFoFShLUW8QMSbRppv3ARHMWiOAuZz1pL6PVK7co2VKVK+vSL2L330lW4RvDRF5jvTqDeewsFaPuvZqTW0MV5iFqM99jDJD+NoV47SJ8V0jDEvvIczqb+ZoBaa6w1y4M2lWqNam/HP3yI+KnHmTh5is4dg6y7c7CZ2sVm0mpcyYQaY6hWq5TL5aZPAvjbtxJ5gt/R2QQaYygUCtSqFdrbwkyoGGPmgNU3/CjC+Pg4x48fx1rL+vXr6ezsBGBubg7P8wiCgCiKiKII3/cZHh5mYGAgy9trmdBFcBRFjI6OEsdxs1k4joPrunieh4gQhiF9fX10dXW1KqZrYoyZZ4kT/s1qoMWKXGCaFlP+jS5qNVBnrPyfMjczFj/IyboAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-1865.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAGbElEQVRIx32WSY9cZxWGnzvWcGvoru6uHmy38dA2kYcQueMODigBJBJYsEAgIhD8ANZI7PgBICEhRdmAIoFAQhFhQxJwiJ0IYycQhN3x2O65q4fqmqvuUHf4vvuxiCAytvMuz9H76D3nbI6mlPoD8CUeo/buHpffeIulG4vMHDzI17/3ElOHZ/kUvYtS6pJ6hFKl1Bu/+Z368pET6sJIVX3/xFn1zdk59eKxJ9Sl115Xn6JLKKUuPqrzx1++qo5gq886ZTU/MaPmJ2bUU2PT6vzYlDpfnlAfvP3O46AX9cfNcO3NP1MulTg0XiVr20yOjDJRKnJooopA8drLr6DS9JFe81FFBRQ0nZcWLmDbNsMkpt7v8VFti4Jt8435BRbv3We7VuPQ4cMP+R9KmgpB8/YSvX6f67VNFrc26HseYZLQ8AaUMjliIfD8gFvvvIfbbD8E1ZRSF4GvAtRXVrn+q9+iuj1CIbh8c5HNVoOKUyCfybDZ63B6coadTptj1SmqeQctn+OFn/yY40+e+S/z7QeSvv6zX7C7dJ8gjpFS8sLZp/j2wrOcnD5AmssyWSzTC3xKuRwVx2FsdIT1tTV+//Irj97p3X98SO3mLTTL5ETGJmta+EIihWCsUMQXMXPHDxIlMVnLxjRNup5HTyYs/+0Ku1s1ZmYPPQi9+qe38FyP0NCoFIqcOjiLBmgqpdNpUzRtyoUCtmVh6DpCSj6qbbLZaSOjmK079/4H1T8+jsTf3qUTR6y1m9zd26HruvQ9Dzcc4oUhgUhYazbo+j5+GLLdbnFjawMJjOTzLF65+uD1m7Uay7duMzczw5GJSTZbLVbqe3hRhNI0lK7T8T1s28IwDPZ7Xf69vsq+55KxLKQGd/75IVLIT8Yf1HYwhODG1gaxlLhRyE6vi5QCDY1AxGRNkyAIWOp06fke660mAC3P5eyBQyStDndu3ODM/LmPky5e+4BqocR4qUwr8PGiiMagx263w3a3Tb3fJ0wEO90OTc+lHfjEUiJTSSmXwzZNtnZ3ufLmXz5J2m+1uLu/Ry8VRElCHMdIpSgXCuSzWZI0pdHvUS2VMTWdXhgAkMQJ3jBkf9BntFymcfMOaZpiRmFIY2OTp+dO8v7GClY2y8L8Oep3l6gP+lieSyQEQimEECilcIdDwijiwvPP0djYYirv4JgWd2/epL5VQ++12qysrbParBNHMYcPzPCVr72ITBLSVBHLFIVG1rLI2hkimaJrOiKJWfjiFxiZGOfOdo26O4Aopru9ixn1+0znHAqOw/LeHsdnZ6lMjCOFpFoqMZJ3GMYxTc/FNgzKuSyupmFoOqVKhbHJSdJ6g9mxcayyxOt2MZtb25AkWKbJhOPwzPPPEQ6HyFTS830a/R4iTdF0nSiJEUIwFIJYCPJOnifOnGbl6vv0ij5ef8BefR89aLSYGa1wcLTC0ckpzi2cZ2tllWIuB5qGrhvYpkksBClgWzZOJkMxl2N3fYPPXXiGEcdh/shxjlYnsUwD3fc8GoMBXd8jlBJnZJTNpWUs0yRjGozkcliGgYZG1jApZjKYmo5tWdz+8F+cPH2KarVKs9el3u0QBENMTcFYucxYsUSs6yRJzMbqKolKqXU6GLqOZRgYmo4XhfSDAJFKlKaxtryKVKA7DnGckMgUQ9Mwe70uDbePYVlEOZtGvU67vs/R6iSmoQMaaZrixzF52yabtwjiBMMw6PV7NHd2qVRG6a6uMxgG5EpF9OkTc9iGiW0YVKtVXNcljCLCJCGME+IkQdc0dF0jTgRRHJNKiRApw2FIp9mknHeYHZ9garRCJpfFtJw8SZpiGSapUqzfX8bQNGIpiKWGZRgoDZRSBCIhECClRMgUKQX17W0028ILQ7w4olgZxcyXirQGfQp5hyCN0ZQgZ1l8ZmyMjGmTSEnbdwmimJF8jopTpOUOCOKEdqpYu7fEmJ1hP4oYDAMM3UA3bJvNoc+r7/2VuFzA7feJ05SeH9By+/R8FylTMoaBjk6730ckCUoKDENn0OnQGfq8e2uRbhxhWhbm6YWnzV9fuUxjd5e506f40Xd/gD8Y0MhmKebzlPMO1fIoIpfBbbVRto1l6KS+jyZSQtflhz//Kc9+51tMHzrI7LGjpvb/v9T1v19jfek+pcoo1ekpMpksTj6PNAziwKc4MkKuUCAMAtaX7pPLZXnywucf+KX+AyKRypyMs84YAAAAAElFTkSuQmCC\" width=\"21\" height=\"29\" alt=\"Layer-1867.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,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\" width=\"23\" height=\"29\" alt=\"Layer-1869.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEdklEQVRIx8WW3W4kSRGFv4jIrOpu2+O1Z+1hFqFlpb1YgbhDXPMIvDJPgLhCiwCJXQGjYWbsdXva3ZUZEVxUu+eX1dxgUmpVZiurzomIEz+SmX8Bzni4dVWAS+DkAUGrAu0BAQGaPjAgAGV+JCDzLiEz9r88nO/v5P6SyMxXVRARRBQVAZFPBRUiGpvNHUnu34sDiYg4nO/JkTMBkZmAAImgIpRSMbP5fxFUC/IWmYOl7k7i9N72FxWziooi4rO1qWQmZvMzmcnMe4FMPB2fOpGJ7D2lUlgsV1gxitUZNDPp3cmE3p1SKu4J2VE1kti7c3Zl74EIqCqRiaqiMu/d9yQiCI/ZgAK1Dmy3G7ImChCRiAjFKioFUhCUiCTS55i9FRPV+RSRCIaI4OG49304kogEEXp3usfs9mpkOgrJNN1RStl/KPbCEFQN8l4biZCYCqqCqWAKppA5u19FUEBEMDNAAaXUioeTkZhVSu+d3LvoPvjTtKOUgg8DYgMpAc2pYnsX7sXmQTEjA0SFLkkKKEl2B4xSK+O4OGSCiCAR/jIzzyMcmNV2ff0CFJ5Hsr66pm8bw2pFqbMKyzgwjCPuQUhSCAYTPKB5J3rnchgYtHJycrbXzMQwjIC8KrOseRMjVZaLJbXAt/98xp//+C30RM2oY2U8PmJ1/ojzn36O945753io4EZmsG2N290dj+0UtQERobV2EOJbKQOqhnsjI9htt+SQ0Cb+/eIF1oX1+jVlLPzw3XPOvnrKb373W6I3DLjpE1sREGi9URJam7gL5Xhvaa3D+3k6LzObXZFBCeVoOXDy6Jirvz0jtlvEB04fP+LJFxcQwTTdMeH0cD5fHCMJKompkalEzJaN4/hORXqn9qoqqsqcIMKiVMpiSS3G2dMLcueYKm3XCd/xy/MLvlgtudm9JBPW0x1/X/+Lv15/T/MJFfuxMvhmzXIvpATTrrFYVH7262+wcSB+EagVdps7Xl+v2SyXnNUjvlw+4eruhn+sv+MnJ6f8sF3jdMgkM98pgR8FBbCi9LajSXLy5DNUCmqKiNF6sNm85vX1ht/f/AmV5HJ5imfnS3vM6c0zLpcXGJXujcxA3rP4o6Aqcugst89eUqziHkgxXCGzc/b0KU8WBc2AdExHVtvv+Xr6Azf2c0y/AcmPNp2PgrbWD5dtMSJaKAJSjNVqYPHoCI9g1zomoARkZ6LS/A6XCTNF8k3L/FHQiKD3zjAYxZSz81O6O56BmDKuFqR3ikKQFCmoGFWCHC543n6FL77iso4Myb4KvaebzHwJnL8NenPzinE0pj4RkXTveJ+LuY11Lw4lIxAURDFi7qlSEIJBC2KF5erkfRW/+sDS+7TZ7RpDHbGiIEL4HON7QNW5u0QE7k5rje4NlUDNQAqtNdjccnR0+t/dm5nc3q7p7izGBaXU+eMIWeC+n6rKnMsih/ciYi8+ORCP8A/S5QPQeSwRPjt9jOqnz2xvWtm7qaH6CcXBzDg5+d+PwP+XEVSB+sCYtQDPedgp/+o/UIdrNKq7UtgAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-1871.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,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\" width=\"29\" height=\"29\" alt=\"Layer-1988.png\">\n                                        </li>\n                                        <li class=\"orders__item\">\n                                            •••\n                                        </li>\n                                    </ul>\n                                    <div class=\"orders__quantity\">\n                                        <span class=\"quantity\">242</span>\n                                        &nbsp;\n                                        <span class=\"quantity__num\">items</span>\n                                        &nbsp;&nbsp;\n                                        <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                                    </div>\n                                </div>\n                            </td>\n                            <td class=\"text-right pr46 pb18\" width=\"16%\">\n                                <span class=\"table-orders__sum\">£854.00</span>\n                            </td>\n                            <td class=\"pb18\" width=\"17%\">\n                                <span class=\"table-orders__client block\">Christopher Hammerschmidt</span>\n                                <span class=\"table-orders__card-img cardPaymentSystemImg masterImg align-middle\"></span>\n                                <span class=\"table-orders__card\">•••• <span class=\"card__number\">0242</span></span>\n                            </td>\n                            <td class=\"pb18\">\n                                <div class=\"table-orders__btns text-right text-nowrap\">\n                                    <button type=\"button\" class=\"btn btn-success btn-with-line\">\n                                    <em class=\"fa fa-check\"></em>\n                                    <span>Confirm</span>\n                                    </button>\n                                    <button class=\"btn btn-primary dropdown-toggle\">Refund <span class=\"caret\"></span></button>\n                                </div>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"pb20\">\n                                <div class=\"table-orders__delivery-type\">UK Next Day Evening Delivery</div>\n                                <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                            </td>\n                            <td class=\"text-right pr46 pb18 pb20\">\n                                <div class=\"table-orders__delivery-price\">£169.95</div>\n                                <div class=\"table-orders__total-sum\">£1,023.95</div>\n                            </td>\n                            <td class=\"pb20\" colspan=\"2\">\n                                <div class=\"table-orders__delivery-address\">10 Crabwood Rd, Southampton, Hampshire, SO16 9EZ</div>\n                                <div class=\"table-orders__delivery-phone\"><a href=\"tel:+44 7768 614248\">+44 7768 614248</a></div>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n                <table class=\"table fullWidth\">\n                    <thead>\n                        <tr>\n                            <th>\n                                <span class=\"fs-23 fw-400 mr10 \">Order #39000070241</span>\n                                <span class=\"fs-13 fw-400\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> 30 Apr, 03:00:57 pm</span>\n                            </th>\n                            <th></th>\n                            <th><b>Client</b></th>\n                            <th class=\"text-right text-nowrap\">\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" role=\"img\" height=\"14\" viewBox=\"0 0 512 512\"><path fill=\"#585f69\" d=\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\"/></svg>\n                            Confirmed, passed to packing</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr>\n                            <td width=\"45%\" class=\"pb18\">\n                                <div class=\"table-orders__item flexVerticalAlignParent\">\n                                    <ul class=\"orders__list m0\">\n                                        <li class=\"orders__item\">\n                                            <img src=\"data:image/png;base64,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\" width=\"24\" height=\"29\" alt=\"Layer-1740.png\">\n                                        </li>\n                                    </ul>\n                                    <div class=\"orders__quantity\">\n                                        <span class=\"quantity\">1</span>\n                                        &nbsp;\n                                        <span class=\"quantity__num\">item</span>\n                                        &nbsp;&nbsp;\n                                        <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                                    </div>\n                                </div>\n                            </td>\n                            <td class=\"text-right pr46 pb18\" width=\"16%\">\n                                <span class=\"table-orders__sum\">£150.00</span>\n                            </td>\n                            <td class=\"pb18\" width=\"17%\">\n                                <span class=\"table-orders__client block\">Karen Smith</span>\n                                <span class=\"table-orders__card-img cardPaymentSystemImg visaImg align-middle\"></span>\n                                <span class=\"table-orders__card\">•••• <span class=\"card__number\">2393</span></span>\n                            </td>\n                            <td class=\"pb18\">\n                                <div class=\"table-orders__btns text-right text-nowrap\">\n                                    <button class=\"btn btn-primary dropdown-toggle\">Refund <span class=\"caret\"></span></button>\n                                </div>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"pb20\">\n                                <div class=\"table-orders__delivery-type\">Standard Delivery</div>\n                                <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                            </td>\n                            <td class=\"text-right pr46 pb18 pb20\">\n                                <div class=\"table-orders__delivery-price\">£0.00</div>\n                                <div class=\"table-orders__total-sum\">£150.00</div>\n                            </td>\n                            <td class=\"pb20\" colspan=\"2\">\n                                <div class=\"table-orders__delivery-address\">Mulcair House, Ffordd Penmynydd, Llanfairpwllgwyngyll, Wales, LL61 5QE, United Kingdom</div>\n                                <div class=\"table-orders__delivery-phone\"><a href=\"tel:+44 7768 614248\">+44 7768 614248</a></div>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n                <table class=\"table fullWidth\">\n                    <thead>\n                        <tr>\n                            <th>\n                                <span class=\"fs-23 fw-400 mr10 \">Order #39000070200</span>\n                                <span class=\"fs-13 fw-400\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> 29 Apr, 11:29:16 pm</span>\n                            </th>\n                            <th></th>\n                            <th><b>Client</b></th>\n                            <th class=\"text-right text-nowrap\">\n                            <svg aria-hidden=\"true\" height=\"14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><path fill=\"#585f69\" d=\"M53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9zm585.1 102.8L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9z\"></path></svg>\n                        Packing</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr>\n                        <td width=\"45%\" class=\"pb18\">\n                            <div class=\"table-orders__item flexVerticalAlignParent\">\n                                <ul class=\"orders__list m0\">\n                                    <li class=\"orders__item\">\n                                        <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAdCAYAAACwuqxLAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAIFklEQVRIx22WaYyV5RXHf8/zPu9717l35l6BWUBGZUcHhiKKQkGlVYhpP5RWGrtoTdo0xNjapk2TBtNGjYlRU5N+sGmjqdWqTZBIbKi1RUUWQQWRKXdQxgUdYBju3Jm7vcuz9MO4pMv5ds6H8zvJ+Z9FJEnCf5tA4ikJQL3eWHTkyNCaY0OVKyaqNVsqd8XlUtfE7L7uoUWL5w91dXUeA3DOYoxDSvEfuRT/xzwlSZJk9gt/f/mHTzy549bjlZM9cRRjjMbisEaTzWa4qH/u+I2brtu15aav3tdRyA8JYf+3WK31Z45zDqUUx/51Yss9d//mgTeOHOsFge9JwOGcw0qJjtok7QZekAXpc9nShbUf3XHb/desv+ohcG1r3ecAY8xnjpQSk8SLv/udOw+9+vpbuWI+i41aTNUnsJk8Uiq+PSPHvqbmyNhZ/LjFjO5+DBIdR9z6vS0v/fTH3/+6r9S4c9MQ+RlJCOr1+uJfb7v3d7z5Wq6nVKLtYAGWX6UdW1KwXjcZrAyzslVnUyHHpc0JkvFTpNJppO+z+7E/rz/9/odXCyFwzuKc/bwHQggqlXc2PbPzxTWZRDOnPcm4n6MgJeujFhtJyKQVLT/DBr+N0Ia/KMndYRsRx3Q6S76jA+159lOhIMDbtu2uTwDQ29v97it7Dt5yqhbmZFRHOkniS2Zc3M9wrouRcjfvZYu8k85TndXLO0he0x5ZP6CoJB83GwgvM2/t2lV/RAgDoJyznwCU3L59510H9u3pmj17LiZdpmOiyoJFlyKvXY2ZnMJISVgu01ApbG2csccfh1SeLk/Q9Hy0NDz3/CuXb9x4zQ8GB5c87JxFSilRSlGpnNj8wIOPbi129ampqQY6yNNEMKe/h6VfuJQVq1ewYPkSVg4s5IpFcymOVDg5GZLP5BBJhPYCnJA0W21++8jT29pRdJGQAjXdbVf4/e+fundyqkU+X2Ci2iRsjJMtldn36kHO2Tahc5w+cxZnLKV8juWVE7zrAspRnVSuwFjURuuEQjHgxFtD5QMv7b/9muvX3yk9z+Pwm8e++fKeg5f4vqLZnMJTaSZH36U2OcYHUxETew/T91aFZWcmWHF2glXnxhhJJF6uyJJino/adYR1xElE1oMvmQmO73h+S2JMSYFL/+nJZ7dGkSabzRMnEalMjrBjJmdOv0+sssxPZrA1PI/wFam0z+Q5y8/OhSzIl2j3ziEcPolvEqyOSBwcyJRoVT7uWVcZ2SxPnRq9ct/+Ny7zfUUUt2m1mlij6Zkzn5m9CylmOthfq3LISZCCRAgmwwQrFbVMnjNWUe4s45xDx220tUyqHLWW5uChYxvl0aPD158/P0WSJBit6Z5ZIpXySRJNLleku7uf9Kx+HoxTTBqHaYW81rIMl/qYSuVp1yNUEJDLFQBJFLVRQqA8yd79h1fJt49VrvJUgB9ksE7yrZs3UywUiOMIbSzWWvLpNOO5EmEQEFvH30qzSXJFhLVoY8F5GOO47tp19HSXabZaKKX48NTZrHxv5MP5YEiSCKUcPT0zCcMInEV6ina7zVSzRRA26XKW3ZHHcZUhg8VaPT2hOLSFy5YvZ8G8Cxk78wE4jTHOynPjE+nAD4jjmL7eXrq6Omk220zLVyCkpJ1obsh6FHRMJVUgNI4kiZBCoDwP6yTOQi5bYMHCebSbUzTqVaK4iRJSaOl5BH5AOp1CSkGiE7SxCDQqk2VOJscmN4ZxMOansVZjnCAxhjhJQHyyd5Si0JEijCLCsIU3VUP29swYbTSbGGuZnKpTrdaI4gTlBzilyCdtBkWIVB4VP4vuLCDs9IpPpzNIKRE4AiVpNhqcGD5JV7mHQrFMKp1DdXeXPzI6WibTaSbrbSrDI0hfkRGWhUmNonNslAFKgPF9QnwyqQxCa3zlEccGIQTtKKRarfL20cOUS2X8IIXvpz25ZMnCo1IIpHBg4bm//pPZUrOhfZoLpcDmSgzoJrNNyAVJSC2cvuGBH+Dw0MYSxxGpIMWevYcYPnESpSTGSFYOLqnKZQOLXyx2FgGwQiLrTdYmNaJ0JztSsxjQTWb4EDqBRpLEIeBoRQlJEpPL5gCBMQmjo6cJw+kTnGjN2jUrdsn+/gtfX7r4klGjNQKL9nz2uAI7yDMPzY2iSS2xpDyJEYCUhGGCEI6UL/A8j2wmizUR2UyKYucFaG0odXayYnDpLimlnFr3xdUvG2MQzmCl4j0vTQHD1niMTmGxQqCtRQDGQRD4BEpgrCDRFiklcdgglUqTyRaIE8OKwcUfzJ3bt1sCXH75wPZcLotzFi+Voj+Q/DIaY0C3qCWObEqRJAZPCHK5LH6gCCNNOwwROFqtKeJYI4WH7ysy2Q42Xr/maSGoS4D58y86MGf2rKbRBgv4KmDAM2Skw0QxOjHk0wriBGUsYZSgggAhBXEcUZ+qku8okhhLKzRccvHcaPWVyx5z1iGddWQy2dFVqwZfrTfq6CjmrPD5g38Bz8QBQ04wMtmiEcWMO0u91cAnxsQxVlsmJs7TbDQpFssEqQxRGPPlDVc8lc2mjztAWGMRUjA0NHzTN7bc/pQfBCA8CsUO7vjJbY90KG80E7YyBbQdHRm5WXX37a1F7ZUefi2T79g9cnase+fOF7720Wg1r4IMhY4CTz9x/4aenpn/sM6CNQZrLcaYjrvvefjQwIob3MYbb2ltf3bXQ8456dz0R+ecY6xa3eyc62s1G19xznV+Gh8fr67++S/ue/PqdTe5Rx/b/pxzTjnrsNbxbyl0Hq+nedgxAAAAAElFTkSuQmCC\" width=\"24\" height=\"29\" alt=\"Layer-1740.png\">\n                                    </li>\n                                    <li class=\"orders__item\">\n                                        <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACfFBMVEX////29fXe3t7m5uf+/v7j4eDAwL+enp7BwsTs7e/4+fno6OfOzszV1dXS0tLZ2tvV19nm5+fv8PH8/Pz5+PbFvbC7ure+vr7Ly8vW1tfV1dTV1tfU1tbW2Nnr7O34+Pn29vfBvbXY0cL59/T9/PvMxbeyrKK7u7zAv7+5uLfJycjU1NTa29vS09Xf4OHt7e7Z2dnAwcHDwLm1q5a1q5i3rp6to5SyraTAwMG/v7/W1tbGxsXAwL69vLq+vrzCwsHa2tnT09TT1NXFxcbMzMzW19jQ0NC6tq64s6zFxMPFxcW7u7vMzMvQ0M/Hx8bLy8rNzczPz8/JyMfKysnCwb/W1tXe3t3a2trY2Njp6+rJycnR0dHV1tbU1dbPz9DKysrDw8POzs3Ozs7S0tHGxcPb29rR09LT1dPV1tPDtK/HtbH7+/u+wMDHycnOz9DR0tLU1dXQ0dHIycnP0NDY2dnNzs7b3d3c3t7c3d7d39/g4uLf4eLb2tvW0M/NvrnJs6vHtazEwbfz8/Gml5a5q6rAtLLDuLfGvbzJv76/t7bRzczNxcTEurnMw8LOxMPPxMPRxsXVycjWysnWycjWycfUxMLQvbrNubTJs63Mu7POxLrOzcLO0Mbc29X7+/qMh4iaj46jlZSnmJaomZinl5agkI+WiIi+t7awo6Kfj46llpWnmJepm5qtn56uoZ+wo6GxpqOtpKK6s67Tz8fR0cnKzMTExb7W1tHx8fDKy8y9v8C3u7uxtbausrOvs7SssLGprK26vLzDxcavsrOusrKzt7evtLausbOtsLKytra2ubi2uLe5uri+vru3t7S0tLLAwMDb29vx8fL9/f1GLvF4AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAASNJREFUKM9jYBgFWAAjEzMLbllWNnYOTi5cstw8vHz8AoJCwqjCIhBKVExcQlJKWkZWTh5JUkFRSZmBQUVVTV1CQ1NLm1eHV1dPHy5rYGhkbGJqZm5haWVtY2tnz8Pr4OikBzPf2cXVzd3D08vbx9fPPyAwKDgkQCKULyw8wiESqEQ8KjomNi7eK0E7wD8xyY1PO1Q7MTklNS09IzMrmyEnNy9fpqCwqLik1KmkrLyioryyqqq6prauvqGxiaG5pbWtvaO9s6u7p7evf8LESZOnTJ02fcbMWbPnzJ3HMH/BwkWLlyxdtnzFylXNq9esXbd+w8ZNm7ds3bZ9B9BVO3ft3rN33/4DBw8dPnL02PETR06eOn3m7LnzFy5eujzQsUt3AADa2V9IS4u9ZgAAAABJRU5ErkJggg==\" width=\"29\" height=\"29\" alt=\"Layer-1.png\">\n                                    </li>\n                                    <li class=\"orders__item\">\n                                        <img src=\"data:image/png;base64,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\" width=\"29\" height=\"26\" alt=\"Layer-1998.png\">\n                                    </li>\n                                </ul>\n                                <div class=\"orders__quantity\">\n                                    <span class=\"quantity\">3</span>\n                                    &nbsp;\n                                    <span class=\"quantity__num\">items</span>\n                                    &nbsp;&nbsp;\n                                    <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                                </div>\n                            </div>\n                        </td>\n                        <td class=\"text-right pr46 pb18\" width=\"16%\">\n                            <span class=\"table-orders__sum\">£76.97</span>\n                        </td>\n                        <td class=\"pb18\" width=\"17%\">\n                            <span class=\"table-orders__client block\">Joanna Cifarelli</span>\n                            <span class=\"table-orders__card-img cardPaymentSystemImg masterImg align-middle\"></span>\n                            <span class=\"table-orders__card\">•••• <span class=\"card__number\">2960</span></span>\n                        </td>\n                        <td class=\"pb18\">\n                            <div class=\"table-orders__btns text-right text-nowrap\">\n                                <button class=\"btn btn-primary dropdown-toggle\">Refund <span class=\"caret\"></span></button>\n                            </div>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td class=\"pb20\">\n                            <div class=\"table-orders__delivery-type\">Next Day</div>\n                            <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                        </td>\n                        <td class=\"text-right pr46 pb18 pb20\">\n                            <div class=\"table-orders__delivery-price\">£4.99</div>\n                            <div class=\"table-orders__total-sum\">£81.96</div>\n                        </td>\n                        <td class=\"pb20\" colspan=\"2\">\n                            <div class=\"table-orders__delivery-address\">Leisure World, W Quay Rd, Southampton, SO15 1RE, UK</div>\n                            <div class=\"table-orders__delivery-phone\"><a href=\"#\">+44 23 8033 8622</a></div>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n            <table class=\"table fullWidth\">\n                <thead>\n                    <tr>\n                        <th>\n                            <span class=\"fs-23 fw-400 mr10 \">Order #39000070199</span>\n                            <span class=\"fs-13 fw-400\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> 29 Apr, 11:26:01 pm</span>\n                        </th>\n                        <th></th>\n                        <th><b>Client</b></th>\n                        <th class=\"text-right text-nowrap\">\n                        <svg aria-hidden=\"true\" height=\"14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"#585f69\" d=\"M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z\"></path></svg>\n                    Packed, passed to delivery</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td width=\"45%\" class=\"pb18\">\n                        <div class=\"table-orders__item flexVerticalAlignParent\">\n                            <ul class=\"orders__list m0\">\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEZElEQVRIx72WW2hdRRSGvzX72qRNcpq0hdiSNC0qtbRpTIMohXoptMUH9UFUkPrgk4IXRBQRBEtfFOmjIII+axWUipeiSIWCtFBsYiVJVVrTWy4952Sf2z57z4wPJzlWbPfRBJzH2cN861//2muWGGPOATn+v5V3gbXAqqxTInLDfWvtP85cv3eT5blA0go4MTFBEATkcjmUUhhj0FrjeR6+7yMixHFMrVajp6enFThx/00+SqUSaZriui6O42CtJUkSRISOjg7a2tqI4xitdTPQLLBqpfLKlcuUSiWCICAMQ8IwhLYVJJ5LHMdU63UQwfd9kiRZCFBnilBZwFK5ypkzP9pb-xls+n+fjI0eoxDW6P/mSns+Psaa3F3VpGlcpgjCgu7ubqalLTE5euGkdtFRaqdSIFlT29/czWyhw8cdTOCdOoo59T3j5KrlihB7/FXEb/rpK4buSdS2Znvqei6McjDHMzMxQr8eQpJgH9zC/rpvcxDlkdBK5ZydWBKwFx0G5wdKhjiNYaxAR8vk8Ub5AuPV21Kdfs+bQUSQ12O7VcOBRsAYAYzRWp0uHiihEoFwuUywWGR4ZQU3Pofc9QLR5I+H0LOr0GPwxhV3Xg0VjjMHJNK2Fp0oJYNFas7K9namrVyjOzCKffYVJEmTsF5x8CdW3AZumWAtaGxwvm5qpVEmjEYRhSGoM928f4o6BTaSDO2g7+DbufBl542Uk1wU6RRwF1qJsdiFlhmSxGGNIkoS7d+9m26lRvP1P4Dz5DO6Fi0i+AC+8jvn9POJ7C0o1vu8tx9NGL9VaI2mKvW8XZmQIE8fUj36Dbw3Ovj3Ihl5sPQGl0Ebj+e7SoUoprG2otVrjDG3DArz6JuG3P6AcFzNbRHbdhYQ+2EaQvrccpTQKyRjzV8p/O4/ecAtzHxxmZW41K06fRZ+dhJFBJE3Rafq38//ZU1GCXYh+sYHbMMD6PlYprBLEdUAa4YkISZKQ1Jf1n0ozvYhgi/Pg+Tj5PGsPPI8kKWbnEM777yw0BAEE5TrL87T5THke+t0Psf198NKzTG/eyCoLfrmKk6RI00eLyv5jaNE7rkttpYLcupngob2ITikObqH+yH68LbehT48hjsPiwyKyjOYgIk2lFoFShLUW8QMSbRppv3ARHMWiOAuZz1pL6PVK7co2VKVK+vSL2L330lW4RvDRF5jvTqDeewsFaPuvZqTW0MV5iFqM99jDJD+NoV47SJ8V0jDEvvIczqb+ZoBaa6w1y4M2lWqNam/HP3yI+KnHmTh5is4dg6y7c7CZ2sVm0mpcyYQaY6hWq5TL5aZPAvjbtxJ5gt/R2QQaYygUCtSqFdrbwkyoGGPmgNU3/CjC+Pg4x48fx1rL+vXr6ezsBGBubg7P8wiCgCiKiKII3/cZHh5mYGAgy9trmdBFcBRFjI6OEsdxs1k4joPrunieh4gQhiF9fX10dXW1KqZrYoyZZ4kT/s1qoMWKXGCaFlP+jS5qNVBnrPyfMjczFj/IyboAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-1865.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACQFBMVEX////9/Pz+///8/f37+fm5qKe1QT64fX/Uqp7gpJ7erqSlmZiQk5SQkpONkJGKjpCEjI6BjI2AjIuCiYuSkZCOjY6Mjo7Dnpm/raKXmZqbm5utr665urqpnZ3JjYzPycmdi4maAACyLhfaOxnWQipkJhkFCAkGCwoUDgwnFhEwHRRZKRx6KR2OIBl7MCDRUDFORiU5EQ/tKCHOckANFA0kIiRbU1YfIyNhFhS/YF/Hw8OTgYKlGAjlX0DgNx9rIxEAAAB1HBK5GxTNPCXbRSnlczrrQijwRyrxQSfxTS72ZzhDRyKbFxPxLR3kXzQYGwY1MDXBr7ZfREWsTEmbDwyJcG2Whn7GMATgV0VxKRgAAAF+Khj2OCTNbDfdPSbyez7lQSrlNSPkTSjfTSnrQiq0UDDlMiLfLxzzUi5JOhwXGRmSLiy8SEi4Ig6DbmaNdnLEIQ+AQDIrBgXxSy6haTbfJx3xQyftUS32ZTVUQBp3IRPPNRm+USi4ZS9uUSeETiR+YTAjIhAmAADFMC7GW1DBNBiPd3WZgn9NDAEgIyQDBAVIGBLhXzBMPiBrHhajORpdLRVSLBcMDgoKCggRDgkmIxSCcTtxYjRRSSlKQSQYEwuDCQjRKiO+STK5GQaOdm90c3EQExRiY2NaWVlcXFxbXF1uamOEeGVybWNna2NkZ2FnaWNoamNtaWFxbWRxbWV0b2VwbGNqZ2FpZl9aXFtwXV7Ea2rcgHXCU0S4JgeQfnju7u7p6en79/bv3t3t6+xV6RIgAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAPJJREFUKM9jYBgFxANGJhwSzCxAgpWNnYOTi5uHl49fQFBIWERUTFxCUkpaRlZOHiiroKikrKKqpq6hqaWto6unb2BoZGxiamZuYWkFlLW2sbWzd3B0cnZxdXP38PTy9vH18w8IDAoOCQXKhoVHRDpERcfExsUnJCYlp6SmpWdkOmRl5+TmAWXzCwodHByKiktKy8orKquqa2rr6hsam5pbWtuAsu0dnQ4OXd09vX39EyZOmjxl6rTpM2bOmj1n7rz5QNkFCxctXrJ02fIVK1etXrN23foNGzdt3rJ12/YdO3cBZXfvwe7dvfv2D3RUDCkAABqLSWERwwB/AAAAAElFTkSuQmCC\" width=\"29\" height=\"29\" alt=\"Layer-1.png\">\n                                </li>\n                            </ul>\n                            <div class=\"orders__quantity\">\n                                <span class=\"quantity\">2</span>\n                                &nbsp;\n                                <span class=\"quantity__num\">items</span>\n                                &nbsp;&nbsp;\n                                <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                            </div>\n                        </div>\n                    </td>\n                    <td class=\"text-right pr46 pb18\" width=\"16%\">\n                        <span class=\"table-orders__sum\">£3.57</span>\n                    </td>\n                    <td class=\"pb18\" width=\"17%\">\n                        <span class=\"table-orders__client block\">Sarah Smith</span>\n                        <span class=\"table-orders__card-img cardPaymentSystemImg visaImg align-middle\"></span>\n                        <span class=\"table-orders__card\">•••• <span class=\"card__number\">8492</span></span>\n                    </td>\n                    <td class=\"pb18\">\n                        <div class=\"table-orders__btns text-right text-nowrap\">\n                            <button class=\"btn btn-primary dropdown-toggle\">Refund <span class=\"caret\"></span></button>\n                        </div>\n                    </td>\n                </tr>\n                <tr>\n                    <td class=\"pb20\">\n                        <div class=\"table-orders__delivery-type\">Premium Next Day (via DPD)</div>\n                        <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                    </td>\n                    <td class=\"text-right pr46 pb18 pb20\">\n                        <div class=\"table-orders__delivery-price\">£5.99</div>\n                        <div class=\"table-orders__total-sum\">£9.56</div>\n                    </td>\n                    <td class=\"pb20\" colspan=\"2\">\n                        <div class=\"table-orders__delivery-address\">76 St Mary St, Southampton, SO14 1NY, UK</div>\n                        <div class=\"table-orders__delivery-phone\"><a href=\"#\">+44 23 8022 8231</a></div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n        <table class=\"table fullWidth\">\n            <thead>\n                <tr>\n                    <th>\n                        <span class=\"fs-23 fw-400 mr10 \">Order #39000070197</span>\n                        <span class=\"fs-13 fw-400\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> 28 Apr, 02:00:32 pm</span>\n                    </th>\n                    <th></th>\n                    <th><b>Client</b></th>\n                    <th class=\"text-right text-nowrap\">\n                        <svg aria-hidden=\"true\" height=\"14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\" class=\"fa-flip-horizontal\"><path fill=\"#585f69\" d=\"M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z\"></path></svg>\n                    In delivery</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td width=\"45%\" class=\"pb18\">\n                        <div class=\"table-orders__item flexVerticalAlignParent\">\n                            <ul class=\"orders__list m0\">\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACQFBMVEX////9/Pz+///8/f37+fm5qKe1QT64fX/Uqp7gpJ7erqSlmZiQk5SQkpONkJGKjpCEjI6BjI2AjIuCiYuSkZCOjY6Mjo7Dnpm/raKXmZqbm5utr665urqpnZ3JjYzPycmdi4maAACyLhfaOxnWQipkJhkFCAkGCwoUDgwnFhEwHRRZKRx6KR2OIBl7MCDRUDFORiU5EQ/tKCHOckANFA0kIiRbU1YfIyNhFhS/YF/Hw8OTgYKlGAjlX0DgNx9rIxEAAAB1HBK5GxTNPCXbRSnlczrrQijwRyrxQSfxTS72ZzhDRyKbFxPxLR3kXzQYGwY1MDXBr7ZfREWsTEmbDwyJcG2Whn7GMATgV0VxKRgAAAF+Khj2OCTNbDfdPSbyez7lQSrlNSPkTSjfTSnrQiq0UDDlMiLfLxzzUi5JOhwXGRmSLiy8SEi4Ig6DbmaNdnLEIQ+AQDIrBgXxSy6haTbfJx3xQyftUS32ZTVUQBp3IRPPNRm+USi4ZS9uUSeETiR+YTAjIhAmAADFMC7GW1DBNBiPd3WZgn9NDAEgIyQDBAVIGBLhXzBMPiBrHhajORpdLRVSLBcMDgoKCggRDgkmIxSCcTtxYjRRSSlKQSQYEwuDCQjRKiO+STK5GQaOdm90c3EQExRiY2NaWVlcXFxbXF1uamOEeGVybWNna2NkZ2FnaWNoamNtaWFxbWRxbWV0b2VwbGNqZ2FpZl9aXFtwXV7Ea2rcgHXCU0S4JgeQfnju7u7p6en79/bv3t3t6+xV6RIgAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAPJJREFUKM9jYBgFxANGJhwSzCxAgpWNnYOTi5uHl49fQFBIWERUTFxCUkpaRlZOHiiroKikrKKqpq6hqaWto6unb2BoZGxiamZuYWkFlLW2sbWzd3B0cnZxdXP38PTy9vH18w8IDAoOCQXKhoVHRDpERcfExsUnJCYlp6SmpWdkOmRl5+TmAWXzCwodHByKiktKy8orKquqa2rr6hsam5pbWtuAsu0dnQ4OXd09vX39EyZOmjxl6rTpM2bOmj1n7rz5QNkFCxctXrJ02fIVK1etXrN23foNGzdt3rJ12/YdO3cBZXfvwe7dvfv2D3RUDCkAABqLSWERwwB/AAAAAElFTkSuQmCC\" width=\"29\" height=\"29\" alt=\"Layer-1.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEN0lEQVRIx63WS2hcVRzH8e+573ndTDOP0CRO2iS0NdhaRaRF7IPioijYhQoiIi4EBXGr7rQI7lxVUZciaBdFijsXIggq1mIoTau1kSZtMmkmM5N5ZObOvfec46K4zR1IzvrP/dz7///OOVdorS8AL7PdUgodR0ilGIQR/X4PGUss28FzbCzTxM1mQQgS1jcW4AOj21WtBzHVRgcZhnjddVS/S6wkjuMSZMrgZTiczmCbiaBvAXL7Gs3nv9/my4aPrTVfz1pURnx6gxDPcXhrYcDtWHEpk+VYKZMESiupYjAIOVT7i+9OHWGxeZ/J1DRpW+HbNlIbfHjMYyyXYl/GSHoUAImgaZhMT1nku+/zwuTbCHeMrW4HIUw8x+bUaAcMDToNmDsHEZJRv0K5/BHKKmIbBjl/hF5wi43mt6w2LrLSDTiy/wLT5bM7Bw1hs95ZpLP6E49UXkKoPaysfcraxgLV1h0iN+LQ1HtMFU/vTksRgpRlsF77lc+uF+iJg8h4hpW1Q3R7ISmjzfLiQcpnJYU9yWDipIUQBFT5+cYcn3w1y9JiCdl+mvbaLDn1GEZ4kos/VLn82/ckBn44ELRIcXczYK8PY2mLfNbm5Jn9FGeybHQaxHHEgb3H2ZXQaKUR/TzPn3iRy22LLy5dJlXJc/7NOkdSN6k2cjz1+GvMVZZQagzD8HYIagVhnnMnTnPuSc1q/TD/1uZxnC2miq/yzNF95LxRev2/kwc4NChCojhkYblOxikwU3yOaqPHRl1QbbZ4dDpNKT83FDjU8dBrbYDWlEbS3FlvYFuSgg8bnRa2JVhptB+82G58oWnZhJZLHEcIBKURj/nbVUy1hZdKc7Ayjm1bKKUxkzMzTEs1Wmq01owXfUKtsFyXWnUNy/IItCbvCJSKGUZMBIUQVCYqCGEgZcxYPsOYHGDXa0yOT2FYPQZbDUw3D7a7cxA0GA7CMNAyxAg26XfXMaIOMmgTa0UcBfjlwu7MUGuIlSAKWoRhE9tJMeg1MYlZvfUjAoOxmTNIQ2NphRDb53ColMaxIg7amKaFjEMECqI+KtJkRw8QiRZ/LL77oBu7MUPbNOj3u0T9PkKY1JauEwZtcqV9GHaaze7HmKqKELtxHwKeZ5PxR4i6awRbdfzyDG7GxzBTeDmXf9bmuDd4hWNA0l/NUGAka5hOiZGpJyDWSB2iVUgQC9qxScP9gFxaJGJDg6bhU+tc48+VefYXJilmH0aZs9wPBMutHnebffIjWSC/O6CKInriKNdqV7i6dJ65YopC4Q1WeJ17nZiFrmTCTQ7M0GBr0GO1FTNIv8ON1rP824woqQk6UZulUHOla3I8k3z5/g8mRstNp7mxGbJsRNT9CW6ud+hUN2kHA/quQxDGePmhNr5pAW2gsV3VePkhfpkPuLpZR0YRoh9CLDGUwjUNpJS4Q+xBoP0fYGLZztWsZdQAAAAASUVORK5CYII=\" width=\"28\" height=\"28\" alt=\"Layer-3595.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAERElEQVRIx62WSW8cRRSAv+rqZdrTM/Z4i4OdwbZCIIkDComsANmAA0HKgRtIQcmBXxDBhb+AkBD/AC4cEBJIICGIoiQoyqIQcKQYsprY8TIZ2zPM2jO9VHGIuE63FPe5+vvqvVdV7wmt9QOgQNpPK7phBGgEAtu2AJH276rQWteBXK9V7TDm4nKHFT/gjUHFdN4mUiCF4n4j5veqYsKVHJ/IY5uyF6phAGHStjrdGtnur0zLBcwowPd94ihE4+CKLC/YDmMiJooSUaGZJg+e7TI9sEQu4+FmZoiUQMdd/O5lbH2BUdvBdV7HlscSWamENf8hiClsez+xqtHuXKbc+Ilq+zwb7WXW230cLH7JxFAyLpWwG21wb/00u40zIPawWPmKepCj3CyCKvDmrk/ZOfI+YRxiSOvZhba1xsPFV/j860MMFIaZHP6C+/80iYIQWwb8qGJOnbzByaMzwBYIm+Emcw/HiZuTvPNaFtc06FcmpmkSxxELpQ5X5+c4caSIxO3JMtII25FHpGBzs8IPF0vcXIh4cbeJObjK+fm7/HHrMXueO4ojtyWyhNZ6ExjstWilOk+rFfHbNcU3P5+jabf45PQNCrm73Hw0w3bjQ946EONlxyh4x3uhKqmEcawIww6moYl1k/XaHRpBiwFvmmFvHCksytX7ZDIw4O3rKUxVQ6UjNisNfD/GEAaW+TKuElRX2wReG2FA0B1lpDCayEpVQ6010jDIZEyUUkgzxskolI6o1Xy0hnzeBKJEVqoIhQDLNolaIQaacqlKpAT5vEsm4+C6Nq5roXUyK1WEaPCyDv2j/bQtm5ph0udZSB2RcSQjg1kylkyFShVhI4SlesiCH9AJTYZz/Rh9ittNwWAgufckYLJPMJbdIuF6R3G9qpjMmRzoj/GVSTlUXOgojA6cHIp51BIooSnmtyClSmuez7sMPbhCt7xErCKKrmA9MlBoDg8KLKFoxiqRlUqYtUymmvepz/3C6PgOduVNciLiXb3Gx0WDdhjzqGsjRXIdUwkH+my89ios36S6ukQkJI40+OCl7YznXEorK8iVc7hiY2uENjFKC/JZif/gGobjIi2LSFo01v4hqpTRq5dw9WYiK9WhQceEwkb1jZEdnqD015/Erodu16kv3iEoPyHkOpXGcUYGZp5dqKKIwtQ+2v1ZFr77jMZ6iyAzROlfWFeC/YeKjO7N4WSS70WqlAo0Qtpse/sjZCzoNOq0Fm9h6xtMH/6bne/tYPerZxnLzyaz0nSLIOhQqdaIlET6VdqtearBdWThMcsbx5i7tY9TJ6aYHB/GMHqe1HTdAkBKQRgEiNwQrncYRx3EFCHfXqrz/dXHeLbB2TNDiRyTpCGEp93i/8e5VKrQbAZopcn3ORzZX+DK/BNm9w6htUb0HsItkWbU73Z9uoFPq/VUZEiB1mBKQdCNuT2/xuxskayXx7acXqjqf5HT5/pWdGkXAAAAAElFTkSuQmCC\" width=\"28\" height=\"28\" alt=\"Layer-3594.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,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\" width=\"29\" height=\"29\" alt=\"Layer-2.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,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\" width=\"29\" height=\"29\" alt=\"Layer-3.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAEZElEQVRIx72WW2hdRRSGvzX72qRNcpq0hdiSNC0qtbRpTIMohXoptMUH9UFUkPrgk4IXRBQRBEtfFOmjIII+axWUipeiSIWCtFBsYiVJVVrTWy4952Sf2z57z4wPJzlWbPfRBJzH2cN861//2muWGGPOATn+v5V3gbXAqqxTInLDfWvtP85cv3eT5blA0go4MTFBEATkcjmUUhhj0FrjeR6+7yMixHFMrVajp6enFThx/00+SqUSaZriui6O42CtJUkSRISOjg7a2tqI4xitdTPQLLBqpfLKlcuUSiWCICAMQ8IwhLYVJJ5LHMdU63UQwfd9kiRZCFBnilBZwFK5ypkzP9pb-xls+n+fjI0eoxDW6P/mSns+Psaa3F3VpGlcpgjCgu7ubqalLTE5euGkdtFRaqdSIFlT29/czWyhw8cdTOCdOoo59T3j5KrlihB7/FXEb/rpK4buSdS2Znvqei6McjDHMzMxQr8eQpJgH9zC/rpvcxDlkdBK5ZydWBKwFx0G5wdKhjiNYaxAR8vk8Ub5AuPV21Kdfs+bQUSQ12O7VcOBRsAYAYzRWp0uHiihEoFwuUywWGR4ZQU3Pofc9QLR5I+H0LOr0GPwxhV3Xg0VjjMHJNK2Fp0oJYNFas7K9namrVyjOzCKffYVJEmTsF5x8CdW3AZumWAtaGxwvm5qpVEmjEYRhSGoM928f4o6BTaSDO2g7+DbufBl542Uk1wU6RRwF1qJsdiFlhmSxGGNIkoS7d+9m26lRvP1P4Dz5DO6Fi0i+AC+8jvn9POJ7C0o1vu8tx9NGL9VaI2mKvW8XZmQIE8fUj36Dbw3Ovj3Ihl5sPQGl0Ebj+e7SoUoprG2otVrjDG3DArz6JuG3P6AcFzNbRHbdhYQ+2EaQvrccpTQKyRjzV8p/O4/ecAtzHxxmZW41K06fRZ+dhJFBJE3Rafq38//ZU1GCXYh+sYHbMMD6PlYprBLEdUAa4YkISZKQ1Jf1n0ozvYhgi/Pg+Tj5PGsPPI8kKWbnEM777yw0BAEE5TrL87T5THke+t0Psf198NKzTG/eyCoLfrmKk6RI00eLyv5jaNE7rkttpYLcupngob2ITikObqH+yH68LbehT48hjsPiwyKyjOYgIk2lFoFShLUW8QMSbRppv3ARHMWiOAuZz1pL6PVK7co2VKVK+vSL2L330lW4RvDRF5jvTqDeewsFaPuvZqTW0MV5iFqM99jDJD+NoV47SJ8V0jDEvvIczqb+ZoBaa6w1y4M2lWqNam/HP3yI+KnHmTh5is4dg6y7c7CZ2sVm0mpcyYQaY6hWq5TL5aZPAvjbtxJ5gt/R2QQaYygUCtSqFdrbwkyoGGPmgNU3/CjC+Pg4x48fx1rL+vXr6ezsBGBubg7P8wiCgCiKiKII3/cZHh5mYGAgy9trmdBFcBRFjI6OEsdxs1k4joPrunieh4gQhiF9fX10dXW1KqZrYoyZZ4kT/s1qoMWKXGCaFlP+jS5qNVBnrPyfMjczFj/IyboAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-1865.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAADy0lEQVRIx72WzY4bRRSFv3Or2t1uz2SYkJ8Fu0hRYIcQG5a8AS/B0/AYLHgI1khsYBcWwAoEGhJmPL+x291Vl0W1nYxmJthSoCXL7fLte+rce+6plrs7//MVd31gtTije3VBjBMsRuKkJVTNTjm0C9Puak538TcWJiCRhp7l+TH3P3hKNTv8b5h28yMcp9p/QNXsA1A1e8x/e87DZ58hC1vlsV1AX82PwCrq2SEWIhYi7XuP8TTQnb3YOs9OoMvzOfXs4MZ6qFu6q9N3A5o98WbDQ7OPxcmNOFVTPG+/+bcK6buvv+Lij185ePAQCxWLy1MO3n/EKkGsJtR1jQMX8xfM9vaZzO6ThxXnpydo0vLJF18yme7dyHtNSO6OJAD++vkHjp5/z9mfv7N49JCmneKKpMtjLs/PqGJFiAELAZfR1w1D17HqOi5PT4lNy/zTz3n89OO3g64Bs2d++vYb2iYyffKEECPTWYu7SGmgPTikaVtS3wNQ1TWpH4hTw+qa6b0D+uUVx7/8+O+g18BlDGkgxAkpJ1Z9D2bknHCc5XJBkEgOvlrhODlnlDN4yWFVtb2QhDAzHHCEcFLf4ylt2pCGgX4YcE94zgghILmX57Ij3T63d5qDKY5pHMnAIb+pOal8UGGZEniJ9ewldmzXVkwBFCPCMQlHYAIVsJLKkcomkuc1PhJYMBQMC7dzupNp2fEIEqx8OziOzMoeBFLAx/icS/nNKDF3gN5tDhZJKZGzo5xL4MhSXpJKAnc8O+5eNrL+nTOKOwgJIFbVyKQoGTNkQgIXeM5FcmbYuC4zgtkoNnYvb4gRk5BKYgBzQIG8McfSSKmgyAw3gecyMruCWlVDKOxsXVKNYhrvBWW03jBeA1xGFrf69FtBY6xKYhXxhBCKinGihFvY/C8FPI/8NfbMAmFXprFusFhh1WRkOI6KFRtYA64rbSHgozEII9iAwq7mUFWvM3rxY637KDEWfRO/Oax83WrbvbyhalBYl1BItnEoC2HTz2uAgHsZJTPbvbwhRIJeJ4gWRt6+WVtXV9LmWMwOhshAHvrtQbNnhmEAz2X43Uk5oex4cYYyhziZYghCuBXXyvIiqGpLpn234OXLF8yPT4rreHGkQkubUcEzm0GRFTfwsaHuxDghuZGGVSmz7G7QlBJnJyecz+f0ywU5DMXEKY5DCEhOUBHS2nfdM0jYeLKkGOmWS7rlgqadYXeBujtNu8eTZx9yb1ZzdfRRMfE8QBrKSKSEewLPpbw5kYYBcianvghNghiZHT5g0jQ33od3esN/V9c/0ty7k9mMPzUAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-1.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    •••\n                                </li>\n                            </ul>\n                            <div class=\"orders__quantity\">\n                                <span class=\"quantity\">7</span>\n                                &nbsp;\n                                <span class=\"quantity__num\">items</span>\n                                &nbsp;&nbsp;\n                                <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                            </div>\n                        </div>\n                    </td>\n                    <td class=\"text-right pr46 pb18\" width=\"16%\">\n                        <span class=\"table-orders__sum\">£33.24</span>\n                    </td>\n                    <td class=\"pb18\" width=\"17%\">\n                        <span class=\"table-orders__client block\">Raymond Watts</span>\n                        <span class=\"table-orders__card-img cardPaymentSystemImg masterImg align-middle\"></span>\n                        <span class=\"table-orders__card\">•••• <span class=\"card__number\">0666</span></span>\n                    </td>\n                    <td class=\"pb18\">\n                        <div class=\"table-orders__btns text-right text-nowrap\">\n                            <button class=\"btn btn-primary dropdown-toggle\">\n                                Refund\n                                <span class=\"caret\"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n                <tr>\n                    <td class=\"pb20\">\n                        <div class=\"table-orders__delivery-type\">Pre-Book 1 Hour Delivery Slot</div>\n                        <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                    </td>\n                    <td class=\"text-right pr46 pb18 pb20\">\n                        <div class=\"table-orders__delivery-price\">£5.99</div>\n                        <div class=\"table-orders__total-sum\">£39.23</div>\n                    </td>\n                    <td class=\"pb20\" colspan=\"2\">\n                        <div class=\"table-orders__delivery-address\">11 Mare St, London, E8 4RP, UK</div>\n                        <div class=\"table-orders__delivery-phone\"><a href=\"#\">+44 20 7998 3617</a></div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n\n        <table class=\"table fullWidth\">\n            <thead>\n                <tr>\n                    <th>\n                        <span class=\"fs-23 fw-400 mr10 \">Order #39000070196</span>\n                        <span class=\"fs-13 fw-400\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i> 28 Apr, 12:42:00 pm</span>\n                    </th>\n                    <th></th>\n                    <th><b>Client</b></th>\n                    <th class=\"text-right text-nowrap\">\n                        <svg aria-hidden=\"true\" height=\"14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><path fill=\"#585f69\" d=\"M488 312.7V456c0 13.3-10.7 24-24 24H348c-6.6 0-12-5.4-12-12V356c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v112c0 6.6-5.4 12-12 12H112c-13.3 0-24-10.7-24-24V312.7c0-3.6 1.6-7 4.4-9.3l188-154.8c4.4-3.6 10.8-3.6 15.3 0l188 154.8c2.7 2.3 4.3 5.7 4.3 9.3zm83.6-60.9L488 182.9V44.4c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12V117l-89.5-73.7c-17.7-14.6-43.3-14.6-61 0L4.4 251.8c-5.1 4.2-5.8 11.8-1.6 16.9l25.5 31c4.2 5.1 11.8 5.8 16.9 1.6l235.2-193.7c4.4-3.6 10.8-3.6 15.3 0l235.2 193.7c5.1 4.2 12.7 3.5 16.9-1.6l25.5-31c4.2-5.2 3.4-12.7-1.7-16.9z\"></path></svg>\n                    Delivered</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td width=\"45%\" class=\"pb18\">\n                        <div class=\"table-orders__item flexVerticalAlignParent\">\n                            <ul class=\"orders__list m0\">\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAG9UlEQVRIx5WWe4wfVRXHP+feefzmt+9tty0tW1eBRsUiBFQEhQq0mBCDFYOKgSpRhPCHYogaDRACIiL4CDGxBNSI1ABWwAfEgg8ES4qIEB9NS0tp2bJtl+52d3/7+/1m5t57/GOWwtJuUk4yk8nM3PM958znnjOiqsoc5oPHFW0gkKYdIIY5TaE59SoBpd7Zhy89cRIfds1hvezatZM/fWENO+++k5ICXIkvmviihfqS4H2lgse5Fr5oUrTHKdsNrLEULueF71zHby75DFu2bztMgG82F/SLn/qsnjm/Vx/6wIm6+w+/1jzkWjQPaN7Yr0VzTF0+qTu3/U+Hd2zRsr1f8+l92pwc0XZzXNutKd1y27f1nhPeqcsH5ulVn75I1btZEodkWh54kfPSzZiufn60e4xN197A3vX34YC4o4soq2OTOlu372B49whR2kNU7ybtmk8olRe/dzNP3fVTbp1oMdTbz+oFO3DTr8zSkDd/0/b4y4xvuJFdG//BNY80MK7g8oFujjnlZOLBpXSfeBIdS5aQZJ2ggfbkARpbNlPu3ceB5//Dpmee4SdTOUvThGs/1sXbP7KKnrO/SZx1zy0KMDk2gvvn7Wzf8BjXPDDBuAZOEMdkq6RlLVlHRleSANBotzB5i6OsYSJK2DjtOaU35avndTF47oV0nno5ab1r7kyH/7uZf9/3AMd/YhWdg4vINt/NC797kHsfbzA8XZBEUDOC9548BIIKiCH3QssLQeG0xQkXnNVH/4oL6Xj/pZSNJs898DAnf3I1WU+VbfTGCPb/5THG7rqD++9fz6o7f8h7Tv8aQ/FCvvLep3DtHIxg4hRQ1AvqclQ9vshxeYkET9rbTe2kC0jftZLxnS/x+6tvZGrT33nHsYNkZ541O1NX5Dx56UV07t7FS69O8coxy/n82tvpXLgIV0zjXY4giLEEQBRUHRo8BIeWBeodGmXEvQO8uGkTj111Hf1jw/TWhcHzP84J1988O9Ox556luXULWU83Hd0d7H3iSX578eW8+7I11BcMkKYpAXBFQZm3QBUbxdgkJcpS0izDpAlIi52PPsifv/sDluVj9PZ30iwLRjc9TTlxgLin93XRXY/+kZp6MiPUY8O8/oxFk8M8+/VvkdsYYyN88ARVCB5EMSr4KAJrkThGogjvPeX4BIvrjr6eTvIQSJME3beP8X89w4IV51Sie/fu4ep19zGQN/lwnLE8S5AAWT3i+KEuvA+ogiKIgpcEEIwqahQN4H2BI8cFgUUJbWcxConAqAY2NqbZsO5X3LLinKoNWgMXX3kFXaefwb3ecv3wKDt8iXeOECAAKhWpocIICDNBGIwIcWSJbIS1ljIoAowj/GL/ODeNjPJ0bx+Llx37OkiqARFD2ZpgZGQfP167lqfW3cNNQ4vpTBKKEN7QN1/LWjHWwsx1UMUDzgtTRUESAuunGjzfP58r1lzCynM/ypKlg2DS2fu0EhcgcO/Pf8Yvb7yBvjjGiiEWJbEGgxBUCQACiVhiEVILCYaIQJE7uozl6AtXc/oln+PopcfNag6z9qkcHEOWD529ig1/fZwiL2mWBUVR4L0n+DDzLoSg5HlOXrbREMAHnC9p5E0MhkfWXMaSwbcdMmRkrnnqyjaRKKpKkVeCPgSCBgSpvqwqznm8L1ENuLygnbfZv38fo6+Ocda555Nl2SG+I+YwHxRsgkSCJcaoEh+siPBapFXDEKyxBwNZ3J7AmIi0lh3W95yixeg27PATJEmNsixmyioggFhEBYwgUQwmxkQxxCmYlMKDTbtJh04BEx+56NZtu1h/263ESY127gkhgLF4DaCCRTAG0lhIY0scCVFk6EwstUjpm7+QVd9YR9rZf+SiedTL3/YMkGV1sloNBYw1r2GOiFC2HW6qxHmHc448zylcSaMxQV+P59QvewY6D/U9J0h5q0FjcowoSrHWVlUVqbCdWVLB5SuqQ6DIc5qtNmOjewgK7zttBVEcH7mo9znGWoQIJVSHKoKgVS9CpEKpOtuDa5Vy5m58ONdzl7c1sofxhx/CiOBbLULeBh9QH1ANIIKxFo0sNkqwaYKtZUhHBz6JsT29LDhjJWLtkYvufnk3d9zyfcRaSiMUQSjVE9Qc3C7WKImJiDSQGiERQ2aFUJT0Dw3xpQ+eSWzfwj6dLHK2qKeexKQmIo4glpjUKrGpupFTwQcosEwEaDtPEaBZOoZmBsRbKu9xR2XcfuVyko4aSEqUxtWvSmSxNkbVoN4TXI74CibnSlzuaLenqS1cRhQf3v2cIBWtKbQ9ATZCxGJshFKNNmsjRAzBlRVcpsJHg0PUE4JDxVLrWvTWMsXESH1eBadqNU8BNICNAAORIFRQHXyOYAREX6f8zfZ/VVK1v8Nwfj8AAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-2.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAFCElEQVRIx62WS28bVRSAv5nxayaJ7Uni5uG0oWmTNpBCRSiUEGhRgQohJIQEGyQ2SLBB/ASEkPgBLFiwQIBALCpFvCoE4tHgkrZpmpYUmqSx2+bhOPHbsWOPZ8aeywKxIzaiOdt79H333HOvzpWEEDFAp0GsLa9y4eJlpqdnePyJMfbt60MP+ilXDJZX1vj1l/OMjz/K/aNHGbinvxEq7wL2AG07ZXz++Rnefec9HOHQ09mB1qoSDncTjydQWzQmJ8/z8SdfMPnDTzx49AivvPEaJ06M74Rzy4C906rjCL6e+JpyxeD0+HFG7z1M5JdfWbwZY093N/G1daYiUwSDAfB66Wjx8/vFGWr1+k5I29Wo/uL2NscPH6acK3B+dg7brqE4Dp99+gXh3m4mzkyQyRfwKArPPDRKbHWNsqhTs2xcqvKvzIZCCYnZWAzTtvAobva2d3B7M8lS9A5vv/0emWSGuu1giTp/xhP43C7OXbxMxTDwqb5/ZcqNhPVajVvxBFvlIs+eGufhR0ZRXC5kWSaXK2DXHQTgb9FIZzLoQT96MEjVNHdkNqzQcepYhsmtaJSecB+5rRKGUaVdD/LUo8eYm79JbDWOkGVy+QLfTZ5jeHAYf0vr/xNqmsZzzz1N5th9pLMlkku3EQg6vD6M7QqWZXPv4H50PUB+u8KTJ8fpCHWhar4dmZIQIgu00yQiP0f45swEP/42jc+l8PpLLzAxdYFsOsuBrm7GTp/izbfeaIbJyc0y/onOrhCpTB7V5SJTLPHpt99jGSZbpTJX5xc4MHDPf+L8Z6FfD6BqPo4dGUb1+Yin06SSGfRAgFDPHg4ND+2uMJfNYxpVVK+Hql0l3NOFx+cml8vixuHK5RmEELsn/PLLs8wv3SSZSiM7dVLpJMViAVGrspFK8eH7H3Dl8uzuCKuGwbVLM9QkiaX1dfpCnfT39aE4Es889hgjQ4Mki2UCemB3hNeuXmdtPcG+nm6qlTJ1CY4ePEhPKITm8bBVqdLf20M2k9sd4ZXZOdRWjZGhAwz09wOCyKVpZJ8Hl9fLamIDBCwsLDVluZrrYHl5jaGebkJBnUihwGAoRMmBa9Eo5XIJSZZxe7yocvP9N80QQpBJZZi6foOPvjrLZjLF+fl59oW70dwe1tY36AoEGdwbZnMzdfdC0zQJtqkgSbjqAsuyqFs15hZvYZhVhCSRLZWY/mMeXdOaPo2mwmw2h1ExePHkOGOjD6CpKttGhVh8nc6gH5ciY1o2qWyeyNVZHMe5O2EmkyOZTIOmUajVqFgmrZqKLMlsm1VkSaaj9e/pUN4qYdl2Q17zSyMcoiur3IjdBuHQ6vXR1e5nPVeBmoMtHA4eGiCXL5AulLBMC9W387RoWqHq8RDuaOfQwF60FhW7XieVL6C4ZAzLwisrZPNFAv42TMvEtq27O9LFxSjxjU3GjhyhS9cJ+tvY29uLHmon4G9BOILorTtcmL2OJP39LbkroW1bCEXm3MxVNpJJEuk08fUEz48dZ+TgAbZti1q9Tq8e5OXTp2jia97DkB7k6PAgo0OHmFlcZHL6EplikbORKUqlAiceGEF2+2jTVGYXorwqKQ15MuBulDB3Y4GbyytEFhYJd3Wier3UhCBf2CKbzYHbjaS40Nt1YiurGFbDHrpdQIoGn+FMLo9ZrnJnZY348ioj+/dTrJRxKx4so8ylG/OEgh2sJhLUZAVFadil/F8ZG0biuhv5WAAAAABJRU5ErkJggg==\" width=\"28\" height=\"28\" alt=\"Layer-3143.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAC9FBMVEX///+3uL1vdYJzeYRzeIJ3fIWKjpaJjpeEi5SMkZl5fYUiKzozPEs5PUktNURVVl42O0RHT186RFQ8RlSGiZEwOEg4PEg4PkowOUc5P08uNEM8Q1E0Pk9KUl+Ii5MkLDwpMkI0PUs+R1YlLj8nMEAtNkdMUF5/gogXIC8vN0k1PVI0PU48Q1MwOEsrNEcyOk8+RliHi5EfKDk9SFpFUGUtNUgmKzo5Qlc7RFk+SV5GTmGanKIkLkBRYHNOXnE+SFZCRUpOXXBRYXROWmypq7ElMUBEVGM4R1hPWGXBxMcuNkhRXm9ndolYZneusLYnNURNXW88SlxGT1zHycwyOkpIVmdreo1gbX+ztronNENXZ3pNV2TMzs8yPEtOXXFkcoO3ub4nNERMW2xRYHRaY3Hd3t8pMj9BT19re41lcoO/wsUrN0dPYG9KWWtnb3z19vUyOUUwPUtldYRhb4HMz9EuOUdTY3BLW2tweIdFTFYpNkVZaXdebH7R09Y0Pk1JWGVBT153foleY2spNkZWZnNebH3T1NY2QE5SYm9ATl1/hI91e4AoNENZaXVca3rd3uA8RVRJWGZEUmF/hY+Eh40hKzpda3ri4+VETFpBS1o8R1Z9g42PkpcZIzI+TVpOW2rj5OU6Q1BIUGIyO0t6gIqTl5sYIi87RVRNWGfp6eowN0U2P04sNUV8goqgo6caJDJGTV7s7O0wOEYkLT2IjpawsrYTHCkjLDlCS1rx8fE2PUclLTwjLT2Rlp66vL4THCUbISxHT1319fU8QEkmLTwiLDyNlJu+wMIVHSgcIi5IUF73+PhARU0iKTchKzuGjJTIyssUHScdJTJBSlj6+vpESFEeJDEgKjqSlp7U1tccJC4cJDI9RVNUVmAcIC4cIzKcn6fh4uMmLTgZIi41PkxjZm8eIzEZHy2eoKfo6OkrMzwYIS5maHAoLDsjKzufoafs7e0wOEIhKjo4QE56fYMwM0AxN0asr7Xz8/NHTVYyOkhPV2SyKQ/jAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAWlJREFUKM9jYCASMDIxs7CysbFzcGKT5eLm4eXjFxAUEsYmKyIqJi4hKSUtI4tNVk5eVEFRSVlFVQ2brLqGppa2jq6evgE2WUMjYxNTM3MLSytsstY2tnb2DuaOTs7YZF1c3dw9PL28fXyxyfr5BwQGBYeEhoVjk42ItI2KjomN84nHJpuQmJSckpqWnpGJTTYrOyc3L7+gsKgYm2xJaVl5BUNlVXUNNtnauvqGRoam5pZWbLJt7R2dXQzdPb192GT7J0ycNJlhytSWadhkp8+YOWs2w5y58+Zjk12wcNHiJQxLly1fgU125arVa9YyrFvPswGb7MZNKpu3MGzdtn0HNtmdu3bv2cuwb/+Bg9hkDx0+cvQYw/ETJ09hkz195uy58wwXLl66jE32ytVr128w3Lx1+w42WYa79+4/YHj46PETrLJPnz1/wfDy1euFWGXfvH33nuHDx0+fscp++frtO8OPn79+w0UALzl9u1EQfWAAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-3.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACglBMVEX////////////7+fn7+vr+/f3//v7////a2Na1sawgGBSop6b5+Pj5+fhBOjUaFRLGxcfJyMjp6ei7t7UXEQwPCwczLio7NzQ9OTbf3t3+/v5oYl8YEw4UEAsMBwIAAAAEAAAvKyji4eDu7ew5My8cGBQqJyWNi4tfXFsSDwsCAABAOzfw8O/t7Os6My4VEAwGAwAeGxlMSUgbGBMNCQRgW1b9/f2hnJktJyQjHx0VEA4FAQAJBgELCAMQDAYPCgSIhILp6OZUTUs8NzUuKCYmIR8qJiYdGRYMCAQQDAcWEAumo6FuaGUzLCmWjoiQioVcVEw0LSomIiAQDQgMCAIcFhDHxcOHgX82Lirv7ev9+fW3r6dFPjkrJiQXFBAHAQAxKiXk4uKgmpg4MC3a19RTS0YvKigfGRYGAABEOTXQzs39///7/Pqvqqg7Mi/39/fh29NOQjcyKyklHRoMAAAnFRBRR0RoY2F0Y2KDUVGFNzWvcW7Qp6Xev73o0dDz6ei7trM8MCz8/PzQx7tFOjIyKiglGRYZAgAoBQA3BgRMBQVfAwVpAgRvAAF6BQiEEhSOGh2SIyasaGfGv71PPzz+///PyMA7MCowIiAiCgcpAAA9AQBRAwNlDhFwExd5FRh/GBp7Fhd6HBuFPjyyko/OxMNhSkjDvbY+Mi02Hhw9FBNGCwpXDQ1iEhRnFxlsIiJ9RUKbe3bLwb7y9vTMxMNiUE3FvbNVQDNLNS5VNi9bOTNgQjtxWE2bi3/X1c/5+/n///7q6ujEwr/7+vnp5N7b1M3W0cva19Ld29fl49/t6+jw7ers6Obr5uPt6OXv6uj08e/9/Pz8/Pv8+/v8+vv8+vprGzzEAAAAB3RSTlPc7fLt7e3tEW1BegAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAFASURBVCjPY2BgxAkYGJjYcQImBkbckoyEJTnwSHJycfPgkuTl4xcQFMIhKSwiKiYuIYlVUkpaRlZOXkFRCZuksoqqmrqGppa2DhZJXT19A0MjYxMFUzMsdppbWFpZ29ja2TtgkXR0cnZxdXP38PTyxuJPH18//4DAoOCQ0DBMyfCISPao6JjYuPiERAzJpGSQQ1NS09IzMrOygcwcJMncvHwQu6CwqLiktKy8orKquqa2rh4i2dDYBFbZ3NLa1t7R2dXd09vXP2HiJGaQ5OQpUyHmTJs+Y+as2XPmzpu/YOGixUtYQJJLl8GcsHzFylWr16xdt37Dxk2bIcZu2Qp34LbtO3bu2r1n77797AcgkgcPweQOHzl67PiJk6dOnzl77vwFVtRkclEKREqZXWy6dPnKVTYKExhOSbyJGl92AABe92gY0wi+VQAAAABJRU5ErkJggg==\" width=\"28\" height=\"28\" alt=\"Layer-3145.png\">\n                                </li>\n                                <li class=\"orders__item\">\n                                    <img src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFDElEQVRIx+2WX48bVxnGf+ffjL322us03dCGcIG0bRLxIWi5WgHi03CF+CRFlbgAcYuQUJSiCm4qcUGLEFBKuptsliT2eu1d22PPzPnLxdiTRr2FXuVII41mdOZ53+d53meOSCklvuElv2nA16D/96V3Nx8//AMPHjxAJkgpkeU5iUQMASElZVlinSUzGTcORoQYUFqR6QxSIsZISAESKCmRSqO1QkvF8U9+zNHdd78O+tHDh/zyww8ZHYwwWqONASlIKZF8wMWAFIIYE8F7gvckIdjLOigpQElyZRAC4nYgYghUZUVta3768599HdTWlr1eH6EkSEEIgRSbdyYzRAedTofh/hDrHd86fJPJZEKMEGKgrsqGGSkJIUJKZHnGfp7x5b8eEVNCCvGqps47BImqqvAhUDuL954YIykltNaklNiUa+rNhh/98Jh3j464nE0py5IogExT2ZqyqrDBs7F102ldwVfiQAN47zk/O+PmcIQlopTCOoeta4QQOOeaZ9Zi6xqpFL/+1W+YXV8jlcJkBiEE1jaFhhjQaPIsx5YV4/GYoigYDAYvO40xMplesCo3KKW4eeOAYX+fLMuIMeK9J5GQsqH+anHN4/OnbMoNQghijDjn2uJ63T2Ovvsd9vt9dG64urri+fl/Xh2ZsixZLlbUzrLf7/O9e3cbna2l2+2ilCKGBlwg6JgcIRRG53TzLs55QvAI0RivrGvevHXI7TtvEVPCWstf//Lpq/ROXoxZXF/R7fWQUnL65IzpfNbqmVIihACAUpos79Dt9DFKkxnNfDWHJBAClFJ47/nsb39nOOgjpcQLOHv85FXQ6XRKVdVoYxBKMJ7OEFvad5SlbcXr9QqlDHVdkrKMJBKkhFKqcXxKGGO4mExRJHp7Ha5ry5OTU1JKCCEaescvXqC0otMxDHpdimJN2n7IOUcIASHE1kyOslxTrBcslnNqWyEArXVLLwBC4ELg7cMRSMnp6Smr5eqlpv/+4guEkAx7ORcXl9S23u4TrZGUUiilGrp805GUCoEixEhVlY1zdzJIycV0jkQxGvSYXV9zMZm8BD07e4oUEW8tz8cXpBi3+qm2gxgjUkryPG/nutPZAxLee5xzrWZNQZKUEp+fPGHY7+CD5/mzZw1oSonHX57QzTNmy5LS2tY4Ow12s7oLie5eD+8Dm/WS9WZBSg0bUsqWEaUUeZZxvVjhfKKbGx6fnDagzjnm8xlFZVlXNUrQunYHuCuiKApWqxV1VWG9Y7ZcsFgssNaSUrNvx46UcnsJJvMFVe348yefkABdVxWXl5cgBEZp+r0eQgi89y21eZ5TFAW79HLOsSwKlFaI7h7Z1uXGGPI8xxiDUopi3eyxzuKd5/zpOd455Hg8ZlOWiAQCyPO81XDXsbW2sfq2eqUUP3j/Pe7fv09pa5JodFwul00Ox4gQAhLb/G5Ym81mVGWFfrYVN89zQghcXV1hjCHGyGq1QkrZgu9AYwh88MEv+Mfn/+T4+Ji4P0BrvZ3jNd57jDHtmHWzjAhE5zl59Aj9p4//iLWWwWDQpg9AlmUtnbsutdY45+h29xi9cYM7d+60calVo+POB7vZtnXNIkSyLCNE+P1vf4e+e/8e33//PebTS1ZF0XSjFFopEokQIuErvzgfPIeHt+j1evT7fW7feovRcIiUEmNMm9W9Xo+DgwNujEa8cfMmR++8w9vfvs3de/cQr8+9r0H/F+u/e5IoJdB9WUwAAAAASUVORK5CYII=\" width=\"29\" height=\"29\" alt=\"Layer-4.png\">\n                                </li>\n                            </ul>\n                            <div class=\"orders__quantity\">\n                                <span class=\"quantity\">5</span>\n                                &nbsp;\n                                <span class=\"quantity__num\">items</span>\n                                &nbsp;&nbsp;\n                                <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i>\n                            </div>\n                        </div>\n                    </td>\n                    <td class=\"text-right pr46 pb18\" width=\"16%\">\n                        <span class=\"table-orders__sum\">£199.00</span>\n                    </td>\n                    <td class=\"pb18\" width=\"17%\">\n                        <span class=\"table-orders__client block\">Alexander Knights</span>\n                        <span class=\"table-orders__card-img cardPaymentSystemImg visaImg align-middle\"></span>\n                        <span class=\"table-orders__card\">•••• <span class=\"card__number\">1148</span></span>\n                    </td>\n                    <td class=\"pb18\">\n                        <div class=\"table-orders__btns text-right text-nowrap\">\n                            <button class=\"btn btn-primary dropdown-toggle\">Refund <span class=\"caret\"></span></button>\n                        </div>\n                    </td>\n                </tr>\n                <tr>\n                    <td class=\"pb20\">\n                        <div class=\"table-orders__delivery-type\">Same Day</div>\n                        <div class=\"table-orders__total-text\"><b>Order total</b></div>\n                    </td>\n                    <td class=\"text-right pr46 pb18 pb20\">\n                        <div class=\"table-orders__delivery-price\">£9.99</div>\n                        <div class=\"table-orders__total-sum\">£208.99</div>\n                    </td>\n                    <td class=\"pb20\" colspan=\"2\">\n                        <div class=\"table-orders__delivery-address\">11 Mare St, London, E8 4RP, UK</div>\n                        <div class=\"table-orders__delivery-phone\"><a href=\"#\">+44 20 7998 3617</a></div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n</div>\n<div class=\"soon-overlay\">\n    <div class=\"soon-overlay__inner text-center\">\n        <div class=\"soon-overlay__icon\">\n            <div class=\"soon-overlay__icon-inner\"><svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" d=\"M0 0h48v48H0z\"/><path d=\"M24 34c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm12-18h-2v-4c0-5.52-4.48-10-10-10S14 6.48 14 12h3.8c0-3.42 2.78-6.2 6.2-6.2 3.42 0 6.2 2.78 6.2 6.2v4H12c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V20c0-2.2-1.8-4-4-4zm0 24H12V20h24v20z\" fill=\"#795B9A\"/></svg>\n        </div>\n    </div>\n    <div class=\"soon-overlay__text\" translate=\"coming_soon\"></div>\n</div>\n</div>\n</div>\n";

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<!-- START Sidebar-->\n<div class=\"sidebar-wrapper\" ng-class=\"{showAll: !mode.isSimple, 'mt40': vm.canNavigateBack()}\">\n\n    <div ui-sidebar=\"\" class=\"sidebar\" >\n        <div class=\"absolute-center-flex pt30 pb30\">\n            <a href=\"#\" ui-sref=\"home.screen\" target=\"_self\"><img ng-src=\"{{'/assets/images/jisp-logo-white.svg' | cdn}}\" alt=\"jisp\" class=\"brand-logo\" /></a>\n        </div>\n        <div class=\"sidebar-nav\" >\n            <ul class=\"nav\">\n                <li ng-repeat=\"menuItem in vm.menu\" ng-class=\"{ openClassMenu: vm.isActive(menuItem) || menuItem.isOpen, activeClassMenu: vm.isActive(menuItem) }\">\n                    <a ng-click=\"vm.clickRoot(menuItem)\" ng-class=\"{openLink: isOpenLink(menuItem)}\" ui-sref=\"{{ menuItem.url }}\" title=\"{{ menuItem.title }}\" ripple=\"\" >\n                        <span class=\"align-middle\" ng-class=\"menuItem.icon ? menuItem.icon : ''\"></span>\n                        <em ng-if=\"menuItem.submenu\" class=\"sidebar-item-caret fa pull-right\"></em>\n                        <span class=\"inline-block\">\n                           <span ng-class = \"menuItem.additionalClass ? menuItem.additionalClass : ''\" >{{ menuItem.title }}</span>\n                        </span>\n                        <!-- START sidebar__warning ONLY for warnings link-->\n                        <!-- <span class=\"sidebar__warning align-middle\">8</span> -->\n                    </a>\n                    <ul class=\"nav sidebar-subnav\" ng-if=\"menuItem.submenu\">\n                        <li ng-repeat=\"submenuItem in menuItem.submenu\"  ng-class=\"{ openClassMenu: vm.isActive(submenuItem), activeClassMenu: vm.isActive(submenuItem), active:  vm.isActive(submenuItem)}\">\n                            <a ui-sref=\"{{ submenuItem.url }}\" title=\"{{ submenuItem.title }}\" ripple=\"\" ng-class = \"submenuItem.additionalClass ? submenuItem.additionalClass : ''\" >\n                                <em class=\"sidebar-item-icon\"></em>\n                                <em ng-if=\"submenuItem.submenu\" class=\"sidebar-item-caret fa pull-right\"></em>\n                                <span class=\"tdLeftMenu\">\n                                    <span>{{ submenuItem.title }} </span>\n                                    <span ng-if=\"submenuItem.description\" ng-bind=\"submenuItem.description\" class=\"submenuItemDescription\"></span>\n                                </span>\n                            </a>\n                            <ul class=\"nav sidebar-subnav\" ng-if=\"submenuItem.submenu\">\n                                <li ng-repeat=\"submenuItem in submenuItem.submenu\" ng-class=\"{ openClassMenu: vm.isActive(submenuItem), activeClassMenu: vm.isActive(submenuItem) }\">\n                                    <a ui-sref=\"{{ submenuItem.url }}\" title=\"{{ submenuItem.title }}\" ripple=\"\">\n                                        <span class=\"tdLeftMenu\">\n                                            <em class=\"sidebar-item-icon\"></em>\n                                            <span>{{ submenuItem.title }}</span>\n                                        </span>\n                                    </a>\n                                </li>\n                            </ul>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n        <div class=\"profile\" ng-if=\"$root.userData\">\n            <div class=\"profile__header flexVerticalAlignParent\" ng-click=\"clicked = !clicked\" ng-class=\"{'opened': clicked}\">\n                <div class=\"profile__inner\">\n                    <span class=\"profile__pic\"><img src=\"{{'/assets/images/avatar.svg' | cdn}}\"></span>\n                    <span class=\"profile__name\">{{$root.userData.firstName}}&nbsp;{{$root.userData.lastName}}</span>\n                </div>\n                <em class=\"sidebar-item-caret fa\"  ></em>\n            </div>\n            <ul class=\"profile__list\" ng-class=\"{'opened': clicked}\">\n                <li class=\"profile__item\"><a href=\"#\" ui-sref=\"app.profile\" translate=\"profile\"></a></li>\n                <li class=\"profile__item\"><a href=\"#\" ng-click=\"vm.logOff()\" translate=\"logout\"></a></li>\n            </ul>\n        </div>\n\n    </div>\n</div>\n<!-- END Sidebar\n";

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "<!-- START Top Navbar-->\n<nav role=\"navigation\" class=\"navbar topnavbar hidden\" ng-class=\"{ hasMessage: $root.hasWarnings() }\">\n    <div ng-show=\"$root.userData.retailerStatus == $root.enums.RetailerStatus.Unverified\" class=\"userDataStatusMes text-center\"\n        translate=\"retailerStatus_message_unverified\" ></div>\n    <!-- START button offset-->\n    <div class=\"btn-offset\">\n    </div>\n    <!-- START button offset-->\n    <!-- START navbar header-->\n    <div class=\"navbar-header\">\n        <a href=\"/business\" target=\"_self\" class=\"navbar-brand\">\n            <img ng-src=\"{{'/assets/images/jisp-logo-white.svg' | cdn}}\" alt=\"jisp\" class=\"brand-logo\" />\n        </a>\n        <!-- Mobile buttons-->\n        <div class=\"mobile-toggles\">\n            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->\n            <a href=\"\" class=\"sidebar-toggle\">\n                <em class=\"fa fa-navicon\"></em>\n            </a>\n            <!-- Button to show/hide the header menu on mobile. Visible on mobile only.-->\n            <a href=\"\" ng-click=\"vm.toggleHeaderMenu()\" class=\"menu-toggle hidden-material\">\n                <em class=\"fa fa-ellipsis-v fa-fw\"></em>\n            </a>\n        </div>\n    </div>\n    <!-- END navbar header-->\n    <!-- START Nav wrapper-->\n    <div collapse=\"vm.headerMenuCollapsed\" class=\"nav-wrapper collapse navbar-collapse\">\n        <!-- START Left navbar-->\n        <ul class=\"nav navbar-nav hidden-material\">\n            <li>\n                <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->\n                <a href=\"\" class=\"hidden-xs\">\n                    <em class=\"fa\"></em>\n                </a>\n            </li>\n        </ul>\n        <ul ng-show=\"$root.userData.isAuth\" class=\"nav navbar-nav navbar-user\">\n            <!-- START Apps menu-->\n            <li uib-dropdown class=\"dropdown\">\n                <a href=\"\" uib-dropdown-toggle title=\"{{$root.enums.RetailerStatus.getName($root.userData.retailerStatus)}}\" ripple=\"\" class=\"dropdown-toggle\">\n                    <em class=\"fa fa-user fa-fw\"></em>\n                    <span>{{$root.userData.firstName}}&nbsp;{{$root.userData.lastName}}</span>\n                    <em class=\"fa fa-angle-down fa-fw \"></em>\n                </a>\n                <!-- START Dropdown menu-->\n                <ul id=\"bg-white\" class=\"dropdown-menu dropdown-menu-profile\">\n                    <div class=\"row ml0 mr0 mt15 mb10 text-center\">\n                        <div class=\"col-xs-6\">\n                            <div class=\"pt10 pb10\">\n                                <a ui-sref=\"app.profile\" title=\"Profile\">\n                                    <span class=\"block mb5 mt5\">\n                                        <em class=\"fa fa-user fa-2x text-info\"></em>\n                                    </span>\n                                    <small class=\"text-muted\" translate=\"profile\" ></small>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <div ng-click=\"mv.logOff()\" class=\"pt10 pb10\">\n                                <a href=\"javascript:void(0);\" ng-click=\"vm.logOff()\" title=\"Log out\">\n                                    <span class=\"block mb5 mt5\">\n                                        <em class=\"fa fa-sign-out fa-2x text-danger\"></em>\n                                    </span>\n                                    <small class=\"text-muted\" translate=\"logout\" ></small>\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </ul>\n            </li>\n            <!-- END Apps menu-->\n        </ul>\n        <!-- END Left navbar-->\n    </div>\n    <!-- END Nav wrapper-->\n</nav>\n<!-- END Top Navbar-->\n";

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tabs mb24\">\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.transaction.with-discount\" class=\"tabs__item mr8\">\n        <span translate=\"tab_transaction_with_discount\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.transaction.export\" class=\"tabs__item mr8\">\n        <span translate=\"tab_transaction_export_history\"></span>\n    </a>\n</div>\n\n<div ui-view></div>";

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "<!--Header-->\n<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" ng-if=\"ctrl.model.isEditMode\" translate=\"edit_staff_dialog_title\"></h4>\n    <h4 class=\"modal-title\" ng-if=\"!ctrl.model.isEditMode\" translate=\"add_staff_dialog_title\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.form\">\n        <div class=\"form-group mb5 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"add_staff_dialog_email_field\"></label>\n            <div class=\"posRel search-with-right-search-button flex-stretch\">\n                <input type=\"text\"\n                       class=\"form-control mb15\"\n                       ng-model=\"::ctrl.model.email\"\n                       ng-if=\"ctrl.model.isEditMode\"\n                       disabled>\n                <input type=\"text\"\n                       ng-if=\"!ctrl.model.isEditMode\"\n                       name=\"email\"\n                       ng-model=\"ctrl.model.email\"\n                       ng-pattern=\"ctrl.emailPattern\"\n                       ng-class=\"ctrl.model.clickSearch && !ctrl.model.isSuccessSearch || ctrl.model.isAlreadyExist ? 'form-control--invalid': ''\"\n                       translate translate-attr-placeholder=\"add_staff_dialog_email_placeholder\"\n                       required\n                       class=\"form-control\"\n                       ng-change=\"(!ctrl.model.isSuccessSearch || ctrl.model.isAlreadyExist) && ctrl.resetErrors()\" />\n                <span class=\"fa fa-search\"\n                      ng-class=\"ctrl.getSearchClass()\"\n                      ng-if=\"!ctrl.model.isEditMode\"\n                      ng-hide=\"ctrl.model.clickSearch\"\n                      ng-click=\"ctrl.form.email.$valid && ctrl.findStaff(false)\"></span>\n                <span class=\"close-icon--small clickable ng-scope\"\n                      ng-if=\"ctrl.model.email && !ctrl.model.isEditMode\"\n                      ng-click=\"ctrl.clearEmailAndReset()\"></span>\n                <span class=\"block icon24 icon-check-rounded--green result-icon\" ng-if=\"ctrl.model.clickSearch && ctrl.model.isSuccessSearch && !ctrl.model.isAlreadyExist\"></span>\n                <span class=\"block icon24 icon-error-rounded--red result-icon\" ng-if=\"ctrl.model.clickSearch && !ctrl.model.isSuccessSearch || ctrl.model.isAlreadyExist\"></span>\n            </div>\n            <div ng-show=\"ctrl.model.clickSearch && !ctrl.model.isSuccessSearch\"\n                 class=\"text-danger\"\n                 translate=\"add_staff_dialog_email_error\"></div>\n            <div ng-show=\"ctrl.model.isAlreadyExist\"\n                 class=\"text-danger\"\n                 translate=\"add_staff_dialog_user_already_exists\"></div>\n        </div>\n        <div class=\"form-group mb20 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"add_staff_dialog_first_name\"></label>\n            <input type=\"text\"\n                   name=\"firstName\"\n                   ng-model=\"ctrl.model.firstName\"\n                   ng-disabled=\"!ctrl.model.canEdit || ctrl.waiting\"\n                   required class=\"form-control\" />\n        </div>\n        <div class=\"form-group mb20 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"add_staff_dialog_last_name\"></label>\n            <input type=\"text\"\n                   name=\"lastName\"\n                   ng-model=\"ctrl.model.lastName\"\n                   ng-disabled=\"!ctrl.model.canEdit || ctrl.waiting\"\n                   required class=\"form-control\" />\n        </div>\n        <div class=\"form-group mb20 pb5 posRel\">\n            <label class=\"fw-400\" translate=\"add_staff_dialog_discount_date\"></label>\n            <div class=\"input-group wrapRelative datepicker--transparent width175\"\n                 ng-class=\"ctrl.model.canEdit?'':'form-control--disabled'\">\n                <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\"\n                       ng-model=\"ctrl.model.date\"\n                       ng-disabled=\"!ctrl.model.canEdit\"\n                       datepicker-options=\"ctrl.dateOptions\"\n                       is-open=\"ctrl.openedDate\"\n                       close-text=\"{{::'close' | translate}}\"\n                       clear-text=\"{{::'clear' | translate}}\"\n                       current-text=\"{{::'today' | translate}}\"\n                       class=\"form-control\" />\n                <span class=\"input-group-btn pr5\">\n                    <button type=\"button\"\n                            ng-disabled=\"!ctrl.model.canEdit || ctrl.waiting\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedDate = true;\"\n                            class=\"btn btn-default p0 pt7 lh1\">\n                        <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                    </button>\n                </span>\n            </div>\n            <div ng-show=\"!ctrl.model.date && ctrl.requiredDateError\"\n                 class=\"text-danger\"\n                 translate=\"field_is_required\"></div>\n        </div>\n    </form>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\"\n                ng-click=\"ctrl.close()\"\n                class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"add_staff_dialog_cancel\"></span>\n        </button>\n        <button type=\"button\"\n                ng-click=\"ctrl.addOrEditStaff()\"\n                ng-disabled=\"ctrl.waiting || ctrl.form.$invalid || ctrl.form.$pristine\"\n                class=\"btn btn-success  btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span ng-if=\"!ctrl.model.isEditMode\" translate=\"add_staff_dialog_ok\"></span>\n            <span ng-if=\"ctrl.model.isEditMode\" translate=\"edit_staff_dialog_ok\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"password_required\"></h4>\n</div>\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.form\">\n        <div class=\"form-group mb5 pb5 posRel form-password-with-show\">\n            <div style=\"opacity: 0; height:0\">\n                <input type=\"password\" autocapitalize=\"off\" name=\"fakepasswordremembered\" />\n                <input type=\"password\" name=\"fakeusernameremembered\" />\n            </div>\n            <span class=\"fw-400\" translate=\"discount_for_staff_confirm_password_input_label\"></span> <br>\n            <label class=\"fw-500 fs-14 mt10\" translate=\"password\"></label>\n            <div class=\"posRel\">\n                <input type=\"password\"\n                   class=\"form-control form-control-password\"\n                   ng-class=\"{'form-control--invalid' : ctrl.hasError}\"\n                   ng-model=\"ctrl.confirmPassword\"\n                   autocomplete=\"off\"\n                   show-password=\"ctrl.showPassword\" />\n            <span ng-if=\"ctrl.confirmPassword\" class=\"form-password-with-show__show-pass-icon icon-open-eye\"\n                ng-click=\"ctrl.showPassword = !ctrl.showPassword\"></span>\n            <span ng-if=\"ctrl.confirmPassword\" class=\"close-icon-small icon24\" ng-click=\"ctrl.clearPassword()\"></span>\n            <div ng-show=\"ctrl.hasError\" class=\"text-danger\" translate=\"discount_for_staff_password_error\"></div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto flexVerticalAlignParent\">\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <span class=\"close-icon--tiny24 icon24\"></span>\n            <span translate=\"button_cancel\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.ok()\" ng-disabled=\"ctrl.waiting || ctrl.form.$invalid\"\n            class=\"btn btn-success  btn-with-icon\">\n            <span class=\"icon-check--white icon24\"></span>\n            <span translate=\"button_confirm\"></span>\n        </button>\n    </div>\n</div>\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex mb16\">\n    <div class=\"search-with-right-search-button\">\n        <input type=\"text\"\n               class=\"form-control top-panel-input width360\"\n               translate\n               translate-attr-placeholder=\"search_by_staff_placeholder\"\n               ng-model=\"ctrl.search.text\"\n               ng-keydown=\"$event.keyCode === 13 && ctrl.applySearch()\">\n        <span ng-click=\"ctrl.applySearch()\" class=\"fa fa-search clickable\"></span>\n    </div>\n    <button class=\"btn btn-success add-btn ml-auto\"\n            ng-click=\"ctrl.openStaffDialog()\"\n            ng-if=\"!ctrl.isArchived\">\n        <span class=\"plus-icon icon24 mr8\"></span>\n        <span translate=\"staff_add_button\"></span>\n    </button>\n</div>\n\n<div class=\"panel\">\n    <div class=\"panel-body p0\">\n        <div class=\"tags-panel\">\n            <div class=\"tableTags ml0 mr0 mt0\" ng-infinite-scroll load-more=\"ctrl.loadData()\">\n                <table class=\"tableTags ml0 mr0 mt0 table-white basic-table basic-table--no-hover\">\n                    <thead>\n                        <tr class=\"tableTagsHeader\">\n                            <th class=\"pl16 pt14 pb14\">\n                                <div class=\"inner\">\n                                    <span translate=\"column_full_name\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16\">\n                                <div class=\"inner\">\n                                    <span translate=\"column_email\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16\">\n                                <div class=\"inner\">\n                                    <span translate=\"column_added_date\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16\">\n                                <div class=\"inner\">\n                                    <span translate=\"column_discount_expiration_date\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16\">\n\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <!-- ngRepeat: staffAccount in ctrl.staffAccounts -->\n                        <tr ng-repeat=\"item in ctrl.items track by item.ID\" ng-class=\"{'danger': item.Status === 3 || item.Status === 2}\">\n                            <td class=\"pl16 pt14 pb14\">\n                                <div class=\"inner\">\n                                    <span>{{::item.FullName}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner\">\n                                    <span>{{::item.Email}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner\">\n                                    <span>{{::item.CreateDateUTC | date:'dd.MM.yyyy'}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner flexVerticalAlignParent\">\n                                    <span>{{::item.DiscountExpirationDate | date:'dd.MM.yyyy'}}</span>\n                                    <span ng-if=\"item.Status === 3 && (ctrl.currentDate | date:'dd.MM.yyyy') !== (item.DiscountExpirationDate | date:'dd.MM.yyyy')\"\n                                    class=\"label label-danger ml10\" translate=\"Expired\"></span>\n                                </div>\n                            </td>\n                            <td>\n                                <div class=\"d-flex\">\n                                    <span class=\"icon-hover-wrap mr32\" ng-click=\"ctrl.openStaffDialog(item)\">\n                                        <span class=\"edit-icon icon24 opacity6 inline-block\"></span>\n                                    </span>\n                                    <span class=\"icon-hover-wrap\"\n                                          ng-click=\"ctrl.isArchived || ctrl.archiveDiscount(item)\"\n                                          ng-class=\"{'not-allowed opacity38': ctrl.isArchived}\">\n                                        <span class=\"delete-icon icon24 opacity6 inline-block\"></span>\n                                    </span>\n                                    <span disabled\n                                          class=\"icon-hover-wrap ml32 not-allowed opacity38\"\n                                          ng-if=\"ctrl.isArchived\"\n                                          ng-click=\"ctrl.discountRestore(item)\">\n                                        <span class=\"icon-time-restore icon24 inline-block\"></span>\n                                    </span>\n                                </div>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n<empty-list-state class=\"absolute-center-flex\"\n                  title-message=\"'discount_for_staff_special_active_tab_empty_message_title' | translate\"\n                  message=\"'discount_for_staff_special_active_tab_empty_message' | translate\"\n                  ng-if=\"ctrl.items.length === 0\">\n</empty-list-state>\n";

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "<div class=\"tabs mb24\">\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.special.active\" class=\"tabs__item mr8\">\n        <span translate=\"tab_active\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\"app.discountForStaffs.special.archived\" class=\"tabs__item mr8\">\n        <span translate=\"tab_archived\"></span>\n    </a>\n</div>\n\n<div ui-view></div>\n\n\n\n";

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb16 header-tablist\">\n    <span ui-sref-active=\"{'header-tablist__item--active': 'app.discountForStaffs.special.**'}\"\n          ui-sref=\"app.discountForStaffs.special.active\"\n          class=\"header-tablist__item\">\n        <span class=\"mr25 fs-20\" translate=\"special_amount_heading\"></span>\n    </span>\n    <span ui-sref-active=\"{'header-tablist__item--active': 'app.discountForStaffs.transaction.**'}\"\n          ui-sref=\"app.discountForStaffs.transaction.with-discount\"\n          class=\"header-tablist__item\">\n        <span class=\"fs-20\" translate=\"transaction_history\"></span>\n    </span>\n</div>\n<div ui-view></div>\n\n\n";

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel p24 d-flex mb24\">\n    <div class=\"flex-column flex-stretch\">\n        <div class=\"flex-column mb24\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"order_number\"></span>\n            <span class=\"text-normal text-style-normal fs-24\">{{ctrl.model.OrderNumber}}</span>\n        </div>\n        <div class=\"flex-column\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"name\">\n            </span>\n            <span class=\"text-style-normal fs-14 text-normal\">{{ctrl.model.FullName}}\n            </span>\n        </div>\n    </div>\n    <div class=\"flex-column flex-stretch\">\n        <div class=\"flex-column mb24\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"order_total\"></span>\n            <span class=\"text-normal text-style-normal fs-24\" ng-if=\"ctrl.dataReady\">\n                {{ctrl.model.Total  | formatCurrency:ctrl.countryID}}\n            </span>\n            <span ng-if=\"!ctrl.dataReady\"></span>\n        </div>\n        <div class=\"flex-column\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"email_label\"></span>\n            <span class=\"text-style-normal fs-14 text-normal \">{{ctrl.model.Email}}</span>\n        </div>\n    </div>\n    <div class=\"flex-column col-4\">\n        <div class=\"flex-column mb24\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"date\">\n            </span>\n            <span class=\"text-normal text-style-normal fs-24\">\n                {{ctrl.model.DateTime | date:'dd.MM.yyyy, h:mm a'}}\n            </span>\n        </div>\n        <div class=\"flex-column\">\n            <span class=\"text-style-normal fs-14 fw-500 panel-group-title\" translate=\"place\">\n            </span>\n            <span class=\"text-style-normal fs-14 text-normal\" ng-if=\"ctrl.dataReady\">\n                {{ctrl.model.Place.Town}}, {{ctrl.model.Place.Name}}, {{ctrl.model.Place.Address}}\n            </span>\n            <span ng-if=\"!ctrl.dataReady\"></span>\n        </div>\n    </div>\n</div>\n<div class=\"panel no-scroll\">\n    <div class=\"panel-body p0\">\n        <div class=\"tags-panel\">\n            <div class=\"tableTags ml0 mr0 mt0\">\n                <table class=\"nesting-table tableTags ml0 mr0 mt0 table-white basic-table basic-table--no-hover\">\n                    <thead>\n                        <tr class=\"tableTagsHeader\">\n                            <th class=\"pl16 pt14 pb14\" colspan=\"2\">\n                                <div class=\"inner\">\n                                    <span translate=\"product\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16 col-2\">\n                                <div class=\"inner\">\n                                    <span translate=\"extra_list_column_price\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16 col-2\">\n                                <div class=\"inner\">\n                                    <span translate=\"quantity\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16 col-2\">\n                                <div class=\"inner\">\n                                    <span translate=\"sum\"></span>\n                                </div>\n                            </th>\n                            <th class=\"pl16 width1\">\n                                <div class=\"inner\">\n                                    <span class=\"text-nowrap\" translate=\"sum_with_discount\"></span>\n                                </div>\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody ng-repeat=\"product in ctrl.model.Items\">\n                        <tr>\n                            <td class=\"pl24 pt12 pb12\" colspan=\"2\">\n                                <div class=\"inner flex-column\">\n                                    <span>\n                                        {{product.ProductName}}</span>\n                                    <span ng-if=\"product.Size\">{{product.Size}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner\">\n                                    <span\">{{product.Price | formatCurrency:ctrl.countryID}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner\">\n                                    <span>{{product.Quantity}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner\">\n                                    <span>{{product.Sum | formatCurrency:ctrl.countryID}}</span>\n                                </div>\n                            </td>\n                            <td class=\"pl16  pr30\">\n                                <div class=\"inner inner-colored\">\n                                    <span>{{product.SumWithDiscount | formatCurrency:ctrl.countryID}}</span>\n                                </div>\n                            </td>\n                        </tr>\n                            <tr ng-if=\"product.Ingredients\" ng-repeat=\"ingredient in product.Ingredients\">\n                                <td width=\"50\" class=\"noBorder\"></td>\n                                <td class=\"pl16 pt12 pb12\">\n                                    <span>\n                                        <span class=\"text-through\" ng-if=\"ingredient.Quantity === 0\">\n                                            <span class=\"text-capitalize\" ng-bind=\"ingredient.ProductName\"></span>\n                                        </span>\n                                        <span ng-if=\"ingredient.Quantity > ingredient.DefaultQuantity\">\n                                            +\n                                            <span ng-bind=\"ingredient.Quantity - ingredient.DefaultQuantity\"></span>\n                                            <span class=\"text-capitalize\" ng-bind=\"ingredient.ProductName\"></span>\n                                        </span>\n                                        <span ng-if=\"ingredient.Quantity < ingredient.DefaultQuantity && ingredient.Quantity !== 0\">\n                                            −\n                                            <span ng-bind=\"ctrl.getIngerdientQuantityDifference(ingredient.DefaultQuantity, ingredient.Quantity )\"></span>\n                                            <span class=\"text-capitalize\" ng-bind=\"ingredient.ProductName\"></span>\n                                        </span>\n                                    </span>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span ng-if=\"ingredient.Quantity > ingredient.DefaultQuantity\">\n                                            <span ng-if=\"ingredient.Price > 0\" ng-bind=\"ingredient.Price | formatCurrency:ctrl.countryID\"></span>\n                                            <span ng-if=\"ingredient.Price === 0 && ingredient.Quantity !== 0\" translate=\"extra_free_price\"></span>\n                                        </span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span ng-if=\"ingredient.Quantity > ingredient.DefaultQuantity\">\n                                            <span>{{ ingredient.Quantity - ingredient.DefaultQuantity}}</span>\n                                        </span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span ng-if=\"ingredient.Quantity > ingredient.DefaultQuantity\">\n                                            <span ng-if=\"ingredient.Price > 0\" ng-bind=\"ingredient.Sum | formatCurrency:ctrl.countryID\"></span>\n                                            <span ng-if=\"ingredient.Price === 0 && ingredient.Quantity !== 0\" translate=\"extra_free_price\"></span>\n                                        </span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner inner-colored\">\n                                        <span>{{ingredient.SumWithDiscount | formatCurrency:ctrl.countryID}}</span>\n                                    </div>\n                                </td>\n                            </tr>\n                            <tr ng-if=\"product.Extras\" ng-repeat=\"extra in product.Extras\">\n                                <td width=\"50\" class=\"noBorder\"></td>\n                                <td class=\"pl16 pt12 pb12\">\n                                    <span>{{extra.ProductName}}</span>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span\">{{extra.Price | formatCurrency:ctrl.countryID}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span>{{extra.Quantity}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner\">\n                                        <span>{{extra.Sum | formatCurrency:ctrl.countryID}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16  pr30\">\n                                    <div class=\"inner inner-colored\">\n                                        <span>{{extra.SumWithDiscount | formatCurrency:ctrl.countryID}}</span>\n                                    </div>\n                                </td>\n                            </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "\n\n\n    <empty-list-state class=\"absolute-center-flex\"\n        title-message=\"'discount_for_staff_transaction_export_history_tab_empty_message_title' | translate\"\n        message=\"'discount_for_staff_transaction_export_history_tab_empty_message' | translate\">\n    </empty-list-state>\n";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "<div class=\"p16 flexVerticalAlignParent bottom-line\">\n    <!--location-->\n    <button ng-click=\"ctrl.selectLocations()\"\n            class=\"btn apply-btn--purple apply-btn--transparent mr8 height40 fs-14\"\n            translate=\"{{ctrl.model.selectedLocationsCount > 0 ? 'location_with_count' : 'location_without_count'}}  \"\n            translate-value-count=\"{{ctrl.model.selectedLocationsCount}}\">\n    </button>\n    <!--date from-->\n    <div class=\"input-group wrapRelative datepicker--transparent width175\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.model.dateFrom\"\n               ng-change=\"ctrl.dateFromChange()\"\n               datepicker-options=\"ctrl.dateOptions\"\n               placeholder=\"dd mm yyyy\"\n               is-open=\"ctrl.openedStartDate\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               class=\"form-control\"\n               readonly />\n        <span class=\"input-group-btn\">\n            <button type=\"button\"\n                    ng-disabled=\"ctrl.waiting\"\n                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedStartDate = true;\"\n                    class=\"btn btn-default p0 \">\n                <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n            </button>\n        </span>\n    </div>\n    <div class=\"dash\"></div>\n    <!--    date to-->\n    <div class=\"input-group wrapRelative datepicker--transparent width175\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.model.dateTo\"\n               ng-change=\"ctrl.dateToChange()\"\n               datepicker-options=\"{ minDate: ctrl.model.dateFrom }\"\n               is-open=\"ctrl.openedEndDate\"\n               placeholder=\"dd mm yyyy\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               class=\"form-control\"\n               readonly />\n        <span class=\"input-group-btn\">\n            <button type=\"button\"\n                    ng-disabled=\"ctrl.waiting\"\n                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedEndDate = true;\"\n                    class=\"btn btn-default p0\">\n                <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n            </button>\n        </span>\n    </div>\n    <div class=\"ml-auto flexVerticalAlignParent\">\n        <!--    Clear all filter-->\n        <button ng-click=\"ctrl.onAllClear()\" class=\"btn mr8 color-black54 bg-dark12 btn-with-icon height40 fs-14\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"transaction_history_filter_clear_all\"></span>\n        </button>\n        <!--    Apply button-->\n        <button ng-click=\"ctrl.onFilterApply()\"\n                class=\"btn btn-success height40 fs-14\">\n            <span translate=\"transaction_history_filter_apply\"></span>\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "<div class=\"p16 flexVerticalAlignParent d-flex form-transaction-infobox\">\n    <div class=\"mr40\">\n        <div class=\"title\" translate=\"transaction_history_info_box_total_sum\"></div>\n        <div class=\"content\">\n            <span ng-bind=\"ctrl.summary.Total | formatCurrency:ctrl.countryID\"></span>\n        </div>\n    </div>\n    <div class=\"mr40\">\n        <div class=\"title\" translate=\"transaction_history_info_box_sum_with_discount\"></div>\n        <div class=\"content\">\n            <span ng-bind=\"ctrl.summary.TotalWithDiscount | formatCurrency:ctrl.countryID\"></span>\n        </div>\n    </div>\n    <div class=\"mr40\">\n        <div class=\"title\" translate=\"transaction_history_info_box_total_discount\"></div>\n        <div class=\"content\">\n            <span ng-bind=\"ctrl.summary.TotalDiscount | formatCurrency:ctrl.countryID\"></span>\n        </div>\n    </div>\n    <div class=\"mr40\">\n        <div class=\"title\" translate=\"transaction_history_info_box_free_products_total\"></div>\n        <div class=\"content\">\n            <span ng-bind=\"ctrl.summary.TotalFreeDiscount | formatCurrency:ctrl.countryID\"></span>\n        </div>\n    </div>\n    <div class=\"ml-auto\">\n        <span class=\"export-title\" translate=\"transaction_history_info_box_export_progress\" ng-show=\"ctrl.exportInProcess\"></span>\n        <button class=\"btn btn-with-icon btn-primary ml-auto flexVerticalAlignParent\" ng-disabled=\"true\" ng-click=\"ctrl.exportCSV()\">\n            <span class=\"icon-export--white icon24 mr8\"></span>\n            <span translate=\"transaction_history_info_box_export_btn\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex mb5\">\n    <search class=\"form-transaction-search\" placeholder-text=\"'search_by_staff_name_or_email' | translate \" text=\"ctrl.search.text\" on-search-click=\"ctrl.applySearch(searchText)\" on-clear-click=\"ctrl.resetSearch()\">\n    </search>\n    <div>\n        <button ng-click=\"ctrl.toggleFilter()\" class=\"btn btn-primary height37 w40 p8 ml8\" ng-class=\"ctrl.filter.isApplied ? 'btn-danger' : 'btn-primary' \">\n            <span ng-if=\"!ctrl.filter.isApplied\" class=\"icon-filter--white icon24 inline-block\"></span>\n            <span ng-if=\"ctrl.filter.isApplied\" class=\"icon-remove-filter--white icon24 inline-block\"></span>\n        </button>\n    </div>\n</div>\n\n<!--Info-box-->\n<div>\n    <div class=\"panel\" sticky sticky-class=\"panel--sticky\">\n        <div class=\"panel-body p0\">\n            <div ng-if=\"ctrl.filter.isActive\">\n                <transaction-discount-filter class=\"form-transaction-filter\" filter-model=\"ctrl.filter.data\" on-apply=\"ctrl.applyFilter(filter)\" on-all-clear=\"ctrl.clearFilter()\">\n                </transaction-discount-filter>\n            </div>\n            <transaction-discount-information-box summary=\"ctrl.transactionsSummary\">\n            </transaction-discount-information-box>\n        </div>\n    </div>\n</div>\n\n<div class=\"mb10 form-transaction-label d-flex\">\n    <span translate=\"transaction_history_items_count\" translate-value-count=\"<b>{{ctrl.total}}</b>\"></span>\n    <div class=\"ml-auto\" ng-show=\"!ctrl.filter.isApplied\">\n        <span translate=\"transaction_history_items_search_period\"></span>\n        <b translate=\"30_days\" translate-values=\"{ datePeriod: ctrl.getFilterPeriod() }\"></b>\n    </div>\n</div>\n\n<!-- table -->\n<div>\n    <div class=\"panel mb-50\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <div class=\"tableTags ml0 mr0 mt0\" ng-infinite-scroll load-more=\"ctrl.loadData()\">\n                    <table class=\"tableTags form-transaction-history-table fs-14 ml0 mr0 mt0 table-white basic-table\">\n                        <thead>\n                            <tr class=\"tableTagsHeader\">\n                                <th class=\"pl16 pt14 pb14\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_full_name_column\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_email_column\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_order_number_column\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_sum_column\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_with_discount_column\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"transaction_history_order_date_column\"></span>\n                                    </div>\n                                </th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"transaction in ctrl.items track by transaction.ID\" ng-click=\"ctrl.openTransactionDetails(transaction.ID)\">\n                                <td class=\"pl16 pt14 pb14\">\n                                    <div ng-if=\"transaction.Status === ctrl.enumStatus.Expired\">\n                                        <span class=\"label label-danger\" translate=\"Expired\"></span>\n                                    </div>\n                                    <div ng-if=\"transaction.Status === ctrl.enumStatus.Archived\">\n                                        <span class=\"label label-default\" translate=\"Archived\"></span>\n                                    </div>\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.FullName\"></span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.Email\"></span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.OrderNumber\"></span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.Total | formatCurrency:ctrl.countryID\"></span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.TotalWithDiscount | formatCurrency:ctrl.countryID\"></span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"::transaction.DateTime | date:'dd.MM.yyyy, h:mm:ss a'\"></span>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div ng-show=\"ctrl.items.length===0\" class=\"empty-list-center-position absolute-center-flex\"\n     ng-style=\"{ 'height': (ctrl.viewport.height) - 320 + 'px'}\">\n    <empty-list-state ng-if=\"!ctrl.forSearch && !ctrl.waiting && !ctrl.filter.isApplied\"\n                      title-message=\"'transaction_history_empty_title' | translate\"\n                      message=\"'transaction_history_empty_content' | translate\">\n    </empty-list-state>\n    <empty-list-state ng-if=\"ctrl.forSearch && !ctrl.waiting && !ctrl.filter.isApplied\"\n                      image-class=\"'icon-empty-list-search'\"\n                      title-message=\"'transaction_history_search_empty_title' | translate\"\n                      message=\"ctrl.messages.searchMessageContent\">\n    </empty-list-state>\n    <empty-list-state ng-if=\"ctrl.filter.isApplied && ctrl.total === 0 && !ctrl.waiting\"\n                      image-class=\"'icon-empty-list-search'\"\n                      title-message=\"'extras_message_empty_search_title' | translate\"\n                      message=\"'nothing_matched_your_search' | translate\">\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "<div class=\"analytics d-flex flex-column\">\n    <div class=\"analytics-title mt4\" translate=\"downloads\"></div>\n    <div class=\"h90\" ng-if=\"!ctrl.nothingToShowYet && ctrl.loadedOnce\">\n        <div class=\"filters d-flex align-items-center justify-content-between pt24 pb24\"\n             sticky sticky-class=\"panel--sticky\">\n            <div class=\"d-flex align-items-center\">\n                <div class=\"input-group dateInput mr4\">\n                    <input type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"ctrl.from\"\n                           ng-change=\"ctrl.onChangeDate()\"\n                           is-open=\"ctrl.openedStartDate\"\n                           datepicker-options=\"ctrl.fromDateOptions\" close-text=\"{{::'close' | translate}}\"\n                           clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                           class=\"height40 form-control bg-transparent fs-14 pr8\" onfocus=\"this.blur()\" readonly/>\n                    <span class=\"input-group-btn\">\n                <button type=\"button\"\n                        ng-click=\"ctrl.openedStartDate = true; ctrl.openedEndDate = false\"\n                        class=\"btn btn-default btn-no-bg date-input--btn\" ng-disabled=\"ctrl.waiting\">\n                  <span class=\"icon-calendar icon24\"></span>\n                </button>\n              </span>\n                </div>\n                <div class=\"filters-dash mr4\">-</div>\n                <div class=\"input-group dateInput mr16\">\n                    <input type=\"text\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"ctrl.to\"\n                           ng-change=\"ctrl.onChangeDate()\"\n                           is-open=\"ctrl.openedEndDate\"\n                           datepicker-options=\"ctrl.toDateOptions\" close-text=\"{{::'close' | translate}}\"\n                           clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                           class=\"height40 form-control bg-transparent fs-14 pr8\" onfocus=\"this.blur()\" readonly/>\n                    <span class=\"input-group-btn\">\n                <button type=\"button\"\n                        ng-click=\"ctrl.openedEndDate = true; ctrl.openedStartDate = false\"\n                        class=\"btn btn-default btn-no-bg date-input--btn\" ng-disabled=\"ctrl.waiting\">\n                  <span class=\"icon-calendar icon24\"></span>\n                </button>\n              </span>\n                </div>\n                <div uib-dropdown class=\"dropdown-select\" on-toggle=\"ctrl.filterExpanded = !ctrl.filterExpanded\">\n                    <button type=\"button\" uib-dropdown-toggle class=\"btn\"\n                            aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"ctrl.waiting\">\n                        <div class=\"button-content d-flex align-items-center justify-content-between\">\n                            <div class=\"d-flex align-items-center\">\n                                <span ng-bind=\"ctrl.getFilterName(ctrl.selectedFilter)\"></span>\n                            </div>\n                            <span class=\"arrow\" ng-class=\"{'arrow-rotated': ctrl.filterExpanded}\"></span>\n                        </div>\n                    </button>\n                    <ul class=\"dropdown-menu dropdown-menu-items\">\n                        <li ng-repeat=\"filter in ctrl.filters\" ng-click=\"ctrl.onChangeFilter(filter)\">\n                            <div class=\"dropdown-item d-flex align-items-center\">\n                                <span class=\"dropdown-item-text\" ng-bind=\"ctrl.getFilterName(filter)\"></span>\n                            </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <button ng-if=\"!ctrl.noResults\" class=\"btn export\" translate=\"nfc_tab_export_button\" ng-click=\"ctrl.exportCSV()\"\n                    ng-disabled=\"ctrl.waiting\"></button>\n        </div>\n    </div>\n    <div ng-if=\"!ctrl.noResults && !ctrl.nothingToShowYet && !ctrl.waiting\" class=\"analytics-items d-flex flex-column\">\n        <table>\n            <thead>\n            <tr class=\"head-row\">\n                <th translate=\"product_title\"></th>\n                <th translate=\"downloads\"></th>\n                <th translate=\"unique_users\"></th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"report in ctrl.variationsStatistics.VariationStatistics\">\n                <td>\n                    <div class=\"d-flex align-items-center\">\n                        <div class=\"image-container mr16\">\n                            <img ng-if=\"ctrl.getImageUrl(report)\" src=\"{{ctrl.getImageUrl(report)}}\">\n                        </div>\n                        <div class=\"d-flex flex-column\">\n                            <div class=\"mb4\" ng-bind=\"report.Title\"></div>\n                            <div ng-if=\"report.Free\" class=\"item-limitation\" translate=\"unlimited_reading_time\"></div>\n                        </div>\n                    </div>\n                </td>\n                <td ng-bind=\"report.ViewsCount\"></td>\n                <td ng-bind=\"report.ShoppersCount\"></td>\n                <td></td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <empty-list-state ng-if=\"ctrl.noResults && !ctrl.waiting\"\n                      title-message=\"'no_results' | translate\"\n                      message=\"'nothing_found_for_parameters' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\"\n                      fill-element\n                      image-class=\"'empty-list-search-icon'\"\n    >\n    </empty-list-state>\n\n    <empty-list-state ng-if=\"ctrl.nothingToShowYet && !ctrl.waiting\"\n                      title-message=\"'nothing_to_show_yet' | translate\"\n                      message=\"'there_is_no_data' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\"\n                      fill-element\n    >\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb16 ng-scope\">\n    <a ui-sref=\"app.extras.active\" style=\"color:black\">\n        <span translate=\"extras_active\" class=\"mr25 fs-20\" ></span>\n    </a>\n    <a ui-sref=\"app.extras.archived\" style=\"color: black\">\n        <span translate=\"extras_archived\" class=\"activefilter fs-20\"></span>\n    </a>\n\n     <div class=\"pull-right mr20\">\n            <a ui-sref=\"app.extras.new\">\n                <button class=\"btn btn-success add-btn ml20\">\n                    <span class=\"plus-icon icon24 mr8\"></span>\n                    <span translate=\"extras_add_button\"></span>\n                </button>\n            </a>\n     </div>\n</div>\n\n<div class=\"row marginRowMinus\">\n    <div class=\"col-lg-12\">\n        <search placeholder-text=\"'extras_search' | translate\"\n                text=\"ctrl.model.searchTerm\"\n                disabled=\"ctrl.model.waiting\"\n                on-search-click=\"ctrl.search(searchText)\"\n                on-clear-click=\"ctrl.resetSearch()\">\n        </search>\n\n        <div class=\"d-flex flex-wrap\" ng-infinite-scroll threshold=\"150\" load-more=\"ctrl.loadActiveExtras()\"\n             ng-if=\"ctrl.model.extras.length > 0\">\n                <extra-item-card ng-repeat=\"extra in ctrl.model.extras track by extra.ID\"\n                                 style=\"margin-right: 20px; margin-bottom: 20px;\"\n                                 item-title=\"extra.Title\"\n                                 item-id=\"extra.ID\"\n                                 price=\"extra.Price\"\n                                 image-id=\"extra.ImageID\"\n                                 is-archived=\"extra.Archived\"\n                                 sku=\"extra.SKU\"\n                                 on-delete=\"ctrl.archiveExtra(extra)\"\n                                 on-edit=\"ctrl.editExtra(extra)\">\n                </extra-item-card>\n        </div>\n\n        <div class=\"d-flex flex-wrap\">\n            <empty-list-state class=\"empty-location\"\n                              ng-if=\"!ctrl.model.waiting && ctrl.model.extras.length === 0 && !ctrl.isSearch\"\n                              title-message=\"'extras_message_empty_list_title' | translate\"\n                              message=\"'extras_message_empty_list_content' | translate\">\n            </empty-list-state>\n            <empty-list-state  class=\"empty-location\"\n                               ng-if=\"!ctrl.model.waiting && ctrl.model.extras.length === 0 && ctrl.isSearch\"\n                               image-class=\"'icon-empty-list-search'\"\n                               title-message=\"'extras_message_empty_search_title' | translate\"\n                               message=\"'extras_message_empty_search_content' | translate: { search: ctrl.model.searchTermForEmptyScreen }\">\n            </empty-list-state>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb9 extra-new__header\">\n    <a ui-sref=\"app.extras.active\" translate=\"extras_active\">\n    </a>\n    <span class=\"fa fa-angle-right\"></span>\n    <span ng-show=\"ctrl.isNew\" translate=\"new\">\n    </span>\n    <span ng-show=\"!ctrl.isNew\" translate=\"edit\">\n    </span>\n</div>\n<div class=\"extra-new__notification mb24\">\n    <span translate=\"extras_editor_notification\"></span>\n</div>\n\n\n<div ng-form name=\"ctrl.extraEditorForm\" novalidate role=\"form\" class=\"panel extra-new__editor\">\n    <div class=\"flex-input-container extra-new__editor--overflow\">\n        <div class=\"menu-editor mr38 ml24 mt24\">\n            <label class=\"control-label\" translate=\"extra_editor_image\"></label>\n            <div class=\"pt9\">\n                <div ng-if=\"!ctrl.item.ImageID\" class=\"menu-editor-placeholder icon-placeholder-plus clickable\"\n                    ng-click=\"ctrl.addImage()\">\n                </div>\n                <div ng-if=\"ctrl.item.ImageID\" class=\"d-block\">\n                    <div>\n                        <img ng-src=\"{{ ctrl.getImage(ctrl.item) }}\" ng-click=\"ctrl.addImage()\"\n                            class=\"menu-editor-placeholder clickable\" />\n                    </div>\n                    <a class=\"clickable mr15\" ng-click=\"ctrl.item.ImageID = null\">\n                        <span class=\"fa fa-trash mr5\"></span>\n                        <span translate=\"remove_photo\"></span>\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class=\"mt24 mr24 w-100\">\n            <div class=\"form-group m0 mb27\">\n                <label class=\"control-label mb0\" translate=\"extra_editor_name\"></label>\n                <div class=\"posRel input-validation\">\n                    <div class=\"form-control-static pt5\">\n                        <input type=\"text\" ng-disabled=\"ctrl.waiting\" ng-model=\"ctrl.item.Title\"\n                            ng-class=\"ctrl.showTitleError? 'input-validation__field--invalid':''\"\n                            class=\"form-control input-validation__field\" name=\"title\">\n                    </div>\n                    <span ng-show=\"ctrl.showTitleError\" ng-bind=\"ctrl.titleErrorText\"\n                        class=\"text-danger mt-5 input-validation__error\">\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group m0 mb24\">\n                <div class=\"d-flex mb24\">\n                    <div class=\"width150 mr24\">\n                        <label class=\"control-label mb0\" translate=\"Takeaway_price_not_required\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static pt5 pb0\" ng-class=\"::ctrl.currencyCssClass\">\n                                <input type=\"text\" only-decimal ng-disabled=\"ctrl.waiting\" ng-model=\"ctrl.item.Price\"\n                                    class=\"form-control\" name=\"price\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"width150\">\n                        <label class=\"control-label mb0\" translate=\"takeaway_VAT\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static pt5 pb0 withPercent\">\n                                <input type=\"text\" only-decimal min-value=\"0\" max-value=\"100\" \n                                    ng-disabled=\"ctrl.waiting || !ctrl.item.Price || ctrl.item.Price == 0\"\n                                    ng-model=\"ctrl.item.VAT\" class=\"form-control\" name=\"takeawayVAT\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"d-flex mb24\">\n                    <div class=\"width150 mr24\">\n                        <label class=\"control-label mb0\" translate=\"eat_in_price\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static pt5 pb0\" ng-class=\"::ctrl.currencyCssClass\">\n                                <input type=\"text\" only-decimal \n                                    ng-change=\"ctrl.isEatInGreaterTakeaway && ctrl.clearEatInTakeawayError()\"\n                                    ng-disabled=\"ctrl.waiting || !ctrl.item.Price || ctrl.item.Price == 0\"\n                                    ng-class=\"ctrl.isEatInGreaterTakeaway? 'input-validation__field--invalid': ''\"\n                                    ng-model=\"ctrl.item.InsidePrice\" class=\"form-control\" name=\"insidePrice\">\n                                <div class=\"text-danger text-nowrap mt4\" ng-if=\"ctrl.isEatInGreaterTakeaway\"\n                                    translate=\"eatIn_must_be_greater_takeAway\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"width150\">\n                        <label class=\"control-label mb0\" translate=\"eat_in_VAT\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static pt5 pb0 withPercent\">\n                                <input type=\"text\" only-decimal min-value=\"0\" max-value=\"100\" \n                                    ng-disabled=\"ctrl.waiting || !ctrl.item.InsidePrice || ctrl.item.InsidePrice == 0 \n                                    || !ctrl.item.Price || ctrl.item.Price == 0 || ctrl.isEatInGreaterTakeaway\"\n                                    ng-model=\"ctrl.item.InsideVAT\" class=\"form-control\" name=\"insideVAT\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <label class=\"control-label mb0\" translate=\"extra_editor_sku\"></label>\n                    <div class=\"posRel\" style=\"width:324px \">\n                        <div class=\"form-control-static pt5 pb0\">\n                            <input type=\"text\" ng-disabled=\"ctrl.waiting\" ng-model=\"ctrl.item.SKU\" class=\"form-control\"\n                                name=\"title\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div>\n                <div class=\"col-lg-8 p0\">\n                    <preference-selector preferences=\"ctrl.foodPreferences\" component-title=\"ctrl.preferenceTitle\"\n                        description='ctrl.commonPreferenceDescription' on-change=\"ctrl.extraEditorForm.$setDirty()\">\n                    </preference-selector>\n                    <preference-selector preferences=\"ctrl.foodAllergens\" component-title=\"ctrl.allergenTitle\"\n                        description='ctrl.commonAllergenDescription' on-change=\"ctrl.extraEditorForm.$setDirty()\">\n                    </preference-selector>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"wizardBottomButton\">\n        <div class=\"d-flex flex-align-right\">\n            <button type=\"submit\" ng-disabled=\"!ctrl.item.Title || ctrl.extraEditorForm.$pristine\"\n                ng-click=\"ctrl.saveData()\" class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"button_save\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"ctrl.cancel()\" class=\"btn btn-danger btn-with-icon\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\"></span>\n            </button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb16 ng-scope\">\n    <a ui-sref=\"app.extras.active\" style=\"color:black\">\n        <span translate=\"extras_active\" class=\"activefilter mr25 fs-20\" ></span>\n    </a>\n    <a ui-sref=\"app.extras.archived\" style=\"color: black\">\n        <span translate=\"extras_archived\" class=\"fs-20\"></span>\n    </a>\n</div>\n\n<div class=\"row marginRowMinus\">\n    <div class=\"col-lg-12\">\n        <search placeholder-text=\"'extras_search' | translate\"\n                text=\"ctrl.model.searchTerm\"\n                disabled=\"ctrl.model.waiting\"\n                on-search-click=\"ctrl.search(searchText)\"\n                on-clear-click=\"ctrl.resetSearch()\">\n        </search>\n\n        <div class=\"d-flex flex-wrap\" ng-infinite-scroll threshold=\"150\" load-more=\"ctrl.loadArchivedExtras()\"\n             ng-if=\"ctrl.model.extras.length > 0\">\n            <extra-item-card ng-repeat=\"extra in ctrl.model.extras track by extra.ID\"\n                             style=\"margin-right: 20px; margin-bottom: 20px;\"\n                             item-id=\"extra.ID\"\n                             item-title=\"extra.Title\"\n                             price=\"extra.Price\"\n                             image-id=\"extra.ImageID\"\n                             is-archived=\"extra.Archived\"\n                             sku=\"extra.SKU\"\n                             on-restore=\"ctrl.restoreExtra(extra)\">\n            </extra-item-card>\n        </div>\n\n        <div class=\"d-flex flex-wrap\">\n            <empty-list-state class=\"empty-location\"\n                              ng-if=\"!ctrl.model.waiting && ctrl.model.extras.length === 0 && !ctrl.isSearch\"\n                              title-message=\"'extras_message_empty_archived_title' | translate\"\n                              message=\"'extras_message_empty_archived_content' | translate\">\n            </empty-list-state>\n            <empty-list-state  class=\"empty-location\"\n                               ng-if=\"!ctrl.model.waiting && ctrl.model.extras.length === 0 && ctrl.isSearch\"\n                               image-class=\"'icon-empty-list-search'\"\n                               title-message=\"'extras_message_empty_search_title' | translate\"\n                               message=\"'extras_message_empty_search_content' | translate: { search: ctrl.model.searchTermForEmptyScreen }\">\n            </empty-list-state>\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "<div class=\"extra-item width280\">\n    <div class=\"panel height248\">\n        <div class=\"panel-image d-flex\" ng-if=\"ctrl.imageId\">\n            <img class=\"image\"\n                 ng-show=\"ctrl.imageId\"\n                 ng-src=\"{{ctrl.getImage(ctrl.imageId)}}\" />\n        </div>\n        <div ng-show=\"!ctrl.imageId\" class=\"extra-item__placeholder icon-placeholder-gray\"></div>\n        <div class=\"panel-body pb0\">\n            <div>\n                <div class=\"text-ellipsis\">\n                    <span class=\"extra-item__header\"\n                          ng-bind=\"::ctrl.itemTitle\">\n                    </span>\n                </div>\n                <div>\n                    <span class=\"extra-item__element price\"\n                          ng-if=\"ctrl.price\"\n                          ng-bind=\"::ctrl.price | formatCurrency:ctrl.countryID\">\n                    </span>\n                    <span class=\"extra-item__element price\"\n                          ng-if=\"!ctrl.price\"\n                          translate=\"extra_free_price\">\n                    </span>\n                </div>\n                <div class=\"flexVerticalAlignParent\">\n                    <span class=\"extra-item__element text-muted mr8\" ng-if=\"ctrl.sku\" >SKU </span>\n                    <span class=\"extra-item__element text-ellipsis inline-block pr10 text-muted\" ng-if=\"ctrl.sku\" ng-bind=\"::ctrl.sku\"></span>\n                    <div uib-dropdown class=\"extra-item__bottom-btn ml-auto\" ng-if=\"!ctrl.isArchived\">\n                        <span uib-dropdown-toggle class=\"fa fa-ellipsis-v\"></span>\n                        <ul class=\"dropdown-menu\">\n                            <li>\n                                <a ng-click=\"ctrl.onEdit({id: ctrl.itemID})\">\n                                    <span class=\"fa fa-pencil icon\"></span>\n                                    <span translate=\"edit\"></span>\n                                </a>\n                            </li>\n                            <li>\n                                <a ng-click=\"ctrl.onDelete({id: ctrl.itemID})\">\n                                    <span class=\"fa fa-trash icon\"></span>\n                                    <span translate=\"delete\"></span>\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"extra-item__restore-btn ml-auto\" ng-if=\"ctrl.isArchived\">\n                        <span ng-click=\"ctrl.onRestore({id: ctrl.itemID})\"\n                              class=\"icon-restore-clock clickable icon24 inline-block\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-align-start flex-wrap extra-preference-column max-h145\">\n    <div class='styleRadioCheckboxWrap checkbox c-checkbox ml0 mt0 mb18'\n         ng-repeat=\"item in ctrl.items | orderBy: 'Name'\">\n    <label class=\"width240\" title=\"{{::item.Name}}\">\n        <input type=\"checkbox\" ng-model=\"item.IsChecked\"/>\n        <span class='fa fa-check mr15'></span>\n        <ng-container ng-bind=\"::item.Name\"></ng-container>\n    </label>\n    </div>\n</div>\n";

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "<div class=\"posRel search-with-right-search-button flex-stretch mb16\" style=\"margin-bottom: 20px\">\n    <input type=\"text\"\n           maxlength=\"25\"\n           placeholder=\"{{ctrl.placeholderText}}\"\n           class=\"form-control top-panel-input {{ ctrl.classes }}\"\n           ng-disabled=\"ctrl.disabled\"\n           ng-model=\"ctrl.text\"\n           ng-keydown=\"$event.keyCode === 13 && ctrl.onSearchClick({searchText: ctrl.text})\"/>\n    <span class=\"fa fa-search clickable\" ng-click=\"ctrl.onSearchClick({searchText: ctrl.text})\"></span>\n    <span class=\"close-icon--small clickable\"\n          ng-if=\"ctrl.text\"\n          ng-click=\"ctrl.clear()\"></span>\n</div>\n";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group m0 d-flex align-items-center mb8\">\n    <label class=\"control-label mb0\">{{vm.componentTitle}}</label>\n    <span class=\"icon-question-circle fa  mt-extra icon24 opacity16 ml5 clickable \"\n        ng-click=\"vm.ShowTooltip(vm.description)\"></span>\n</div>\n<div class=\"clearfix radioGroup badgeCheck\">\n    <div class='styleRadioCheckboxWrap checkbox c-checkbox ml0 mt0 mb18'\n        ng-repeat=\"preference in vm.preferences | orderBy: 'Name'\">\n        <label class=\"width220\" title=\"{{preference.Name}}\">\n            <input type=\"checkbox\" ng-value=\"preference.ID\" ng-model=\"preference.IsSelected\">\n            <span class='fa fa-check mr15'></span>\n            <ng-container ng-bind=\"preference.Name\"></ng-container>\n        </label>\n    </div>\n</div>\n";

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "<div class=\"home\">\n    <div class=\"profile\" ng-class=\"{'t45': ctrl.canNavigateBack()}\">\n        <div class=\"profile__header flexVerticalAlignParent\" ng-class=\"{'opened': clicked}\" ng-click=\"clicked = !clicked\">\n            <div class=\"profile__inner\">\n                <span class=\"profile__pic\"><img src=\"{{'/assets/images/avatar-home.svg' | cdn}}\"></span>\n                <span class=\"profile__name\">{{$root.userData.firstName}}&nbsp;{{$root.userData.lastName}}</span>\n            </div>\n            <em class=\"sidebar-item-caret fa\"></em>\n        </div>\n        <ul class=\"profile__list\" ng-class=\"{'opened': clicked}\">\n            <li class=\"profile__item m0\"><a href=\"#\" ui-sref=\"app.profile\" translate=\"profile\"></a></li>\n            <li class=\"profile__item m0\"><a href=\"#\" ng-click=\"ctrl.logOff()\" translate=\"logout\"></a></li>\n        </ul>\n    </div>\n\n    <div class=\"home__pickers\" ng-if=\"ctrl.isNfrnRetailer !== undefined\">\n        <ul class=\"pickers__list\">\n            <li class=\"pickers__item\">\n                <div class=\"pickers__top\" ui-sref=\"app.shops\" ng-class=\"ctrl.isNfrnRetailer ?'pickers__top--warnings':''\">\n                    <span class=\"icon-sidebar-location\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_locations\"></span>\n                </div>\n                <div ng-if=\"!ctrl.isNfrnRetailer\" class=\"pickers__bottom\" ui-sref=\"app.create-shop\" translate=\"homescreen_add_location\"></div>\n                <div ng-if=\"ctrl.isNfrnRetailer\" class=\"pickers__bottom pickers__bottom--warnings\" ui-sref=\"app.shops\">\n                    <span class=\"bottom__warning visibility-hidden\"></span>\n                </div>\n            </li>\n            <li class=\"pickers__item\" ng-if=\"!ctrl.isNfrnRetailer\">\n                <div class=\"pickers__top\" ui-sref=\"app.marketing-campaigns.overview\">\n                    <span class=\"icon-sidebar-campaigns\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_campaigns\"></span>\n                </div>\n                <div class=\"pickers__bottom\" ui-sref=\"app.marketing-campaigns.new-branded\" translate=\"homescreen_create_campaign\"></div>\n            </li>\n            <li class=\"pickers__item\">\n                <div class=\"pickers__top\" ui-sref=\"app.products\" ng-class=\"ctrl.isNfrnRetailer ?'pickers__top--warnings':''\">\n                    <span class=\"icon-sidebar-products\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_products\"></span>\n                </div>\n                <div ng-if=\"!ctrl.isNfrnRetailer\" class=\"pickers__bottom\" ui-sref=\"app.product.new\" translate=\"homescreen_add_product\"></div>\n                <div ng-if=\"ctrl.isNfrnRetailer\" class=\"pickers__bottom pickers__bottom--warnings\" ui-sref=\"app.products\">\n                    <span class=\"bottom__warning visibility-hidden\"></span>\n                </div>\n            </li>\n            <li ng-if=\"ctrl.isNfrnRetailer\" class=\"pickers__item\">\n                <div class=\"pickers__top\" ui-sref=\"app.jisppay.staff\" ng-class=\"ctrl.isNfrnRetailer ?'pickers__top--warnings':''\">\n                    <span class=\"icon-sidebar-admin\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_staff_accounts\"></span>\n                </div>\n                <div class=\"pickers__bottom pickers__bottom--warnings\" ui-sref=\"app.jisppay.staff\">\n                    <span class=\"bottom__warning visibility-hidden\"></span>\n                </div>\n            </li>\n            <li class=\"pickers__item\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top\" ui-sref=\"app.information-cards\">\n                    <span class=\"icon-sidebar-infotags\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_infoTags\"></span>\n                </div>\n                <div class=\"pickers__bottom\" ui-sref=\"app.information-card.new\" translate=\"homescreen_add_infoTag\"></div>\n            </li>\n            <li class=\"pickers__item\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top\" ui-sref=\"app.nfcs.active\">\n                    <span class=\"icon-sidebar-nfc\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_nfc\"></span>\n                </div>\n                <div class=\"pickers__bottom\" ui-sref=\"app.information-card.new\" translate=\"homescreen_add_nfc\"></div>\n            </li>\n            <li class=\"pickers__item\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top\" ui-sref=\"app.vouchers.list\">\n                     <span class=\"icon-sidebar-vouchers--home-screen\"></span>\n                     <span class=\"pickers__name\" translate=\"vouchers\"></span>\n                 </div>\n                 <div class=\"pickers__bottom\" ui-sref=\"app.vouchers.new\" translate=\"create_voucher\"></div>\n             </li>\n            <li class=\"pickers__item\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top\" ui-sref=\"app.bundles\">\n                    <span class=\"icon-sidebar-bundles--home-screen\"></span>\n                    <span class=\"pickers__name\" translate=\"bundles\"></span>\n                </div>\n                <div class=\"pickers__bottom\" ui-sref=\"app.bundle.new\" translate=\"bundles_create\"></div>\n            </li>\n            <li class=\"pickers__item\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top\" ui-sref=\"app.analytics\">\n                    <span class=\"icon-sidebar-analytics\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_analytics\"></span>\n                </div>\n                <div class=\"pickers__bottom\" ui-sref=\"app.analytics\" translate=\"homescreen_generate_report\"></div>\n            </li>\n            <li class=\"pickers__item\" ui-sref=\"app.warnings\" ng-if=\"ctrl.isNfrnRetailer === false\">\n                <div class=\"pickers__top pickers__top--warnings\">\n                    <span class=\"icon-sidebar-warnings\"></span>\n                    <span class=\"pickers__name\" translate=\"homescreen_warnings\"></span>\n                </div>\n                <div class=\"pickers__bottom pickers__bottom--warnings\">\n                    <span ng-class=\"ctrl.warningsCount && ctrl.warningsCount !== '0' ? '' : 'visibility-hidden'\" class=\"bottom__warning\"><!-- Если пусто, то класс .visibility-hidden -->\n                        {{ctrl.warningsCount}}\n                    </span>\n                </div>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"home__bottom-nav\"  ng-if=\"ctrl.isNfrnRetailer === false\">\n        <div class=\"posRel\">\n            <div class=\"icon-sidebar-admin\"></div>\n            <ul class=\"bottom-nav__list\">\n                <li class=\"bottom-nav__item\" ng-repeat=\"menuItem in ctrl.adminMenu.submenu\"><a href=\"#\" ui-sref=\"{{menuItem.url}}\">{{menuItem.title}}</a></li>\n            </ul>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb9 \">\n    <a ui-sref=\"app.information-cards\" translate=\"information_cards\"></a>\n    <span class=\"fa fa-angle-right\"></span>\n    <span ng-show=\"vm.state.isNew\" translate=\"new\" ></span>\n    <span ng-show=\"vm.state.isEdit\" translate=\"edit\" ></span>\n</div>\n<div class=\"row row-store\">\n    <div ng-show=\"vm.model.edit\" class=\"col-lg-12 fw\">\n        <div class=\"panel panel-products panel-edit panel-address-shop info-card\">\n            <div class=\"panel-heading flex-align-start h-auto pr20\">\n                <div class=\"ml-auto\">\n                    <div>\n                        <button type=\"button\" ng-disabled=\"vm.productForm.$pristine || vm.waiting\" ng-click=\"vm.save()\" class=\"btn btn-success btn-with-icon\">\n                            <em class=\"fa fa-check\"></em>\n                            <span ng-bind=\"vm.state.saveTitle\"></span>\n                        </button>\n                        <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.discard()\" class=\"btn btn-danger btn-with-icon\">\n                            <em class=\"fa fa-close\"></em>\n                            <span translate=\"button_discard\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"panel-body overflowVisible\">\n                <form name=\"vm.productForm\" novalidate role=\"form\">\n                    <div class=\"row form-horizontal mb10 extraPadForButton\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12 pt6 mb16\" translate=\"required_fields_description\" translate-value-html-b=\"<b>\"\n                            translate-value-html-b-close=\"</b>\"></div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12 pt6 mb16 text-danger\" ng-show=\"vm.model.edit.error.summary\" ng-bind=\"vm.model.edit.error.summary\"></div>\n\n                        <div class=\"col-lg-7 col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"field_title\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static\">\n                                        <input type=\"text\" ng-model=\"vm.model.edit.title\" ng-readonly=\"vm.waiting\" class=\"form-control\" />\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.title\" ng-bind=\"vm.model.edit.error.title\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"field_description\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static textEditor200\">\n                                        <div text-angular ta-paste=\"vm.pasteHandler($html)\" class=\"btn-group-small\" ng-model=\"vm.model.edit.description\" ng-readonly=\"vm.waiting\"></div>\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.description\" ng-bind=\"vm.model.edit.error.description\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <product-stickers-list items=\"vm.model.edit.nfcStickers\"\n                                                       stores=\"vm.stores\"\n                                                       is-list-disabled=\"!vm.canEditStickers\"\n                                                       hide-position=\"true\"\n                                                       errors=\"vm.model.edit.error.stickers\">\n                                </product-stickers-list>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"row socialLinkControl\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                                    <div class=\"form-group m0\">\n                                        <label class=\"control-label\" translate=\"links_and_social_networks\">\n                                        </label>\n                                        <div class=\"posRel padRight\" ng-repeat=\"link in vm.model.edit.links\">\n                                            <div class=\"form-control-static\">\n                                                <div class=\"campainInputProd  input-group\">\n                                                    <div uib-dropdown ng-class=\"{'error': link.error.type}\" class=\"input-group-btn\">\n                                                        <button type=\"button\" uib-dropdown-toggle class=\"btn btn-default dropdown-toggle\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                                                            <span ng-hide=\"link.type\" translate=\"link_type\"></span>\n                                                            <span class=\"text-gray-dark\" ng-show=\"link.type\">{{link.type.Name}}</span>\n                                                            <span class=\"caret\"></span>\n                                                        </button>\n                                                        <ul class=\"dropdown-menu\">\n                                                            <li ng-repeat=\"type in vm.model.linkTypes\" ng-click=\"link.type = type; vm.productForm.$setDirty()\">\n                                                                <a href=\"#\">{{type.Name}}</a>\n                                                            </li>\n                                                        </ul>\n                                                    </div>\n                                                    <input type=\"text\" ng-model=\"link.Url\" ng-class=\"{'error': link.error.url}\" class=\"form-control error\" ng- placeholder=\"URL\"\n                                                    />\n                                                    <input type=\"text\" ng-model=\"link.Title\" ng-class=\"{'error': link.error.title}\" class=\"form-control\" placeholder=\"Title\"\n                                                    />\n                                                </div>\n                                            </div>\n                                            <span class=\"fa fa-close\" ng-click=\"vm.removeLink($index)\"></span>\n                                            <div class=\"text-danger mt-1\" ng-show=\"link.error.sum\" ng-bind=\"link.error.sum\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"addElement\">\n                                        <span ng-click=\"vm.addLink()\" class=\"link\">\n                                            <em class=\"fa fa-plus\"></em>\n                                            <span translate=\"add_a_link\"></span>\n                                        </span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"singleProducts\">\n                        <div class=\"row form-horizontal\">\n                            <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                                <div class=\"clearfix\">\n                                    <div class=\"imgChoice wd-auto\">\n                                        <div class=\"imgProducts images-list\">\n                                            <div class=\"imgProductsInner\" ng-repeat=\"image in vm.model.edit.imagesID\">\n                                                <img ng-if=\"(image)\" ng-src=\"{{vm.getImageUrl(image)}}\" />\n                                            </div>\n                                        </div>\n                                        <div off-click=\"vm.model.edit.showImagesPanel = false\" class=\"callTooltipImages\">\n                                            <span class=\"addElement afterImage\" ng-click=\"vm.model.edit.showImagesPanel = !vm.model.edit.showImagesPanel\">\n                                                <span class=\"fileLabel\">\n                                                    <span class=\"fa fa-camera\"></span>\n                                                    <ng-pluralize count=\"vm.model.edit.imagesID.length\" when=\"{ NaN: 'No images', 0: 'No images', 1: '{} image', 'other': '{} images'}\"></ng-pluralize>\n                                                </span>\n                                            </span>\n                                            <div>\n                                                <choice-information-card-images ng-show=\"vm.model.edit.showImagesPanel\" server-images-id=\"vm.model.edit.serverImagesID\"\n                                                    current-images-id=\"vm.model.edit.imagesID\" callback-update=\"vm.productForm.$setDirty()\"\n                                                    class=\"tooltipImages clearfix\">\n                                                </choice-information-card-images>\n                                            </div>\n                                        </div>\n                                        <div class=\"text-danger\" ng-show=\"vm.model.edit.error.image\" ng-bind=\"vm.model.edit.error.image\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"text-danger\" ng-show=\"vm.model.edit.error.image\" ng-bind=\"vm.model.edit.error.image\"></span>\n                    <div class=\"bottomButton\">\n                        <div class=\"pull-right\">\n                            <button type=\"button\" ng-disabled=\"vm.productForm.$pristine || vm.waiting\" ng-click=\"vm.save()\" class=\"btn btn-success btn-with-line\">\n                                <em class=\"fa fa-check\"></em>\n                                <span ng-bind=\"vm.state.saveTitle\"></span>\n                            </button>\n                            <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.discard()\" class=\"btn btn-danger btn-with-line ml8\">\n                                <em class=\"fa fa-close\"></em>\n                                <span translate=\"button_discard\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"$ctrl.confirm()\" class=\"btn btn-success btn-with-line\">\n                <em class=\"fa fa-check\"></em>\n                <span ng-show=\"$ctrl.getSelectedCount() < 1\" translate=\"button_add\"></span>\n                <span ng-show=\"$ctrl.getSelectedCount() > 0\"\n                    translate=\"button_add_count\"\n                    translate-value-count=\"{{ $ctrl.getSelectedCount() }}\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"$ctrl.dismiss()\" class=\"btn btn-danger btn-with-line\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\" translate=\"add_infotag_title\">\n    </div>\n</div>\n\n<div class=\"modal-body panel-campaign-choice product-search\">\n\n\n    <!-- search -->\n    <div  class=\"mb10 mt10\">\n        <search placeholder-text=\"$ctrl.$translate.instant('search_for_infotag')\"\n                text=\"$ctrl.searchTerm\"\n                classes=\"'white-theme'\"\n                disabled=\"$ctrl.waiting\"\n                on-search-click=\"$ctrl.search(searchText)\"\n                on-clear-click=\"$ctrl.resetSearch()\">\n        </search>\n    </div>\n\n    <div class=\"pl5 pr5 product-search__wrap\">\n        <table class=\"full-width product-search__table\">\n            <tbody>\n                <tr ng-repeat=\"product in $ctrl.pagination.data\" class=\"clickable\" ng-click=\"$ctrl.selectProduct(product)\" ng-class=\"{ 'active': $ctrl.selectedProducts[product.ID] }\">\n                    <td class=\"wd-xxs pr10 pb10 pt10 pl15\" height=\"80px\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded m0\">\n                            <label for=\"checkbox_{{::product.ID}}\">\n                                <input id=\"checkbox_{{::product.ID}}\" ng-checked=\"$ctrl.selectedProducts[product.ID]\" type=\"checkbox\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.selectProduct(product)\"/>\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                    </td>\n                    <td class=\"pr15 pb10 wd-xxs pt10 pl15 text-center\">\n                        <img ng-src=\"{{$ctrl.getImageUrl(product.ImageID)}}\"/>\n                    </td>\n                    <td width=\"100%\" class=\"pr15 pb10 pt10 pl15\">\n                        <div>{{::product.Title}}</div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"panel-footer footer-padinationSmaller bt0 pt15 pb5\" ng-if=\"$ctrl.pagination.total > $ctrl.pagination.pageSize\">\n        <ul uib-pagination ng-disabled=\"$ctrl.waiting\" ng-change=\"$ctrl.loadData()\" total-items=\"$ctrl.pagination.total\" items-per-page=\"$ctrl.pagination.pageSize\" ng-model=\"$ctrl.pagination.page\" previous-text=\"«\" next-text=\"»\" max-size=\"5\" boundary-link-numbers=\"true\" />\n    </div>\n</div>\n";

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 ng-scope productHeader\">\n    <span ng-class=\"{'activefilter': vm.settings.productState !== vm.enums.PhysicalProductState.NotArchived}\"\n        ng-click=\"vm.settings.settingsClear(vm.enums.PhysicalProductState.NotArchived)\">\n        <span translate=\"information_cards\"></span>\n    </span>\n    <span ng-class=\"{'activefilter': vm.settings.productState !== vm.enums.PhysicalProductState.Archived}\"\n        ng-show=\"vm.settings.isExistArchiveProducts\"\n        ng-click=\"vm.settings.settingsClear(vm.enums.PhysicalProductState.Archived)\"\n        translate=\"archived_information_cards\">\n    </span>\n    <div class=\"headerButton\">\n        <button type=\"button\" ui-sref=\"app.information-card.new()\"\n            class=\"btn btn-success ml-auto add-btn\"\n            ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\" ng-disabled=\"vm.waiting\">\n            <span class=\"plus-icon icon24\"></span>\n            <span class=\"ml8 fs-14\" translate=\"button_add_an_information_card\"></span>\n        </button>\n    </div>\n</div>\n<div class=\"row  marginRowMinus\">\n    <div class=\"col-lg-12\">\n        <div class=\"productsSearch\" ng-show=\"vm.settings.isShowFilter()\">\n            <table>\n                <tr>\n                    <td>\n                        <div class=\"posRel searchInput\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"vm.settings.productFilter\"\n                                ng-keypress=\"vm.onSearchFilterKeyPress($event)\" translate\n                                translate-attr-placeholder=\"search_for_information_card\" />\n                            <span class=\"fa fa-search\"></span>\n                        </div>\n                    </td>\n                    <td>\n                        <button type=\"button\" ng-click=\"vm.applyFilter()\" class=\"buttonMarg btn btn-primary\"\n                            translate=\"button_search\"></button>\n                    </td>\n                    <td>\n                        <span translate=\"sort_by\"></span>\n                    </td>\n                    <td class=\"selectSortProd\">\n                        <div uib-dropdown class=\"input-group-btn\">\n                            <button type=\"button\" uib-dropdown-toggle class=\"btn btn-default dropdown-toggle\"\n                                aria-haspopup=\"true\" aria-expanded=\"false\">\n                                <span class=\"caret\"></span>\n                                <span ng-hide=\"vm.settings.sort\"></span>\n                                <span ng-show=\"vm.settings.sort\">{{vm.settings.sort.title}}\n                                    <span class=\"fa fa-sort-{{vm.settings.sort.classSort}}\"></span>\n                                </span>\n\n                            </button>\n                            <ul class=\"dropdown-menu\">\n                                <li ng-repeat=\"sort in vm.settings.sortSet\"\n                                    ng-click=\"vm.settings.sort = sort;vm.applyFilter() \">\n                                    <a href=\"#\">{{sort.title}}\n                                        <span class=\"fa fa-sort-{{sort.classSort}}\"></span>\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div class=\"panel panel-info mb20\" ng-repeat=\"product in vm.data.Items\">\n            <div class=\"panel-body \">\n                <div class=\"productsWrap\">\n                    <h2 ng-bind=\"product.Title\"></h2>\n                    <div class=\"text-right controlProducts\">\n                        <em ui-sref=\"app.information-card.edit({id:product.ID})\" tooltip-popup-delay=\"200\"\n                            tooltip-placement=\"top\" uib-tooltip-html=\"'Edit'\"\n                            translate-attr-uib-tooltip-html=\"tooltip_edit\"\n                            ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\"\n                            class=\"fa fa-pencil changePadToMarg\"></em>\n                        <em ng-click=\"vm.archive(product)\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                            uib-tooltip-html=\"'Archive'\" translate-attr-uib-tooltip-html=\"tooltip_archive\"\n                            ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\"\n                            class=\"fa fa-close changePadToMarg\"></em>\n                        <em ng-click=\"vm.restore(product)\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                            uib-tooltip-html=\"'Restore'\" translate-attr-uib-tooltip-html=\"restore\"\n                            ng-hide=\"vm.settings.productState !== vm.enums.PhysicalProductState.Archived\"\n                            class=\"fa fa-rotate-left changePadToMarg\"></em>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"variationsWrap\" ng-show=\"product.ImagesID.length > 0\">\n                                <table class=\"tableProduct\">\n                                    <tr>\n                                        <td class=\"tableProdImg info-card__images-list\">\n                                            <div class=\"tableProdImgInner\" ng-repeat=\"image in product.ImagesID\">\n                                                <img ng-if=\"(image)\" ng-src=\"{{vm.getImageUrl(image)}}\" alt=\"\" />\n                                            </div>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row posRel showLess\">\n                        <div ng-class=\"showLess ? 'visible' : 'invisible'\">\n                            <div class=\"showMoreProduct\">\n                                <h2 ng-show=\"product.Draft\" class=\"colorOrange\">\n                                    <span class=\"draftProduct\" translate=\"draft\"></span>&nbsp;\n                                    <span ng-bind=\"product.Title\"></span>\n                                </h2>\n                                <div ng-show=\"product.Description\" class=\"brandTittle clearfix hideLess\">\n                                    <b translate=\"description\"></b>\n                                    <div class=\"posRel\">\n                                        <div class=\"showmore_one wysiwyg__main\" ng-bind-html=\"product.Description\">\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-show=\"product.Links && product.Links.length > 0\"\n                                    class=\"brandTittle  clearfix hideLess\">\n                                    <b translate=\"product_links_and_social_networks\"></b>\n                                    <div class=\"socialLinkWrap\">\n                                        <div class=\"socialLinkSingle\" ng-repeat=\"link in product.Links\">\n                                            <span class=\"fa {{link.viewClass}}\"></span>\n                                            <div>{{link.Title}}</div>\n                                            <div>\n                                                <a target=\"_blank\" ng-href=\"{{link.Url}}\">{{link.Url}}</a>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-click=\"showLess = !showLess\"\n                             class=\"inline-block p10\">\n                            <span class=\"showLess__btn\" ng-class=\"showLess ? 'invisible' : 'visible'\" >\n                                <span translate=\"show_more\"></span>\n                                <i class=\"fa fa-caret-down\"></i>\n                            </span>\n                            <span class=\"showLess__btn\" ng-class=\"showLess ? 'visible' : 'invisible'\">\n                                <span translate=\"show_less\"></span>\n                                <i class=\"fa fa-caret-up\"></i>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"table emptyMessage\" ng-style=\"{ 'height': (vm.viewport.height) -260 + 'px'}\"\n            ng-show=\"!vm.settings.isExistActiveProducts && !vm.settings.isExistArchiveProducts\">\n            <div class=\"td\">\n                <h4 translate=\"have_no_infotags\"></h4>\n            </div>\n        </div>\n        <div class=\"table emptyMessage\" ng-style=\"{ 'height': (vm.viewport.height) -260 + 'px'}\"\n            ng-show=\"!vm.settings.isExistActiveProducts && vm.settings.isExistArchiveProducts && vm.settings.productState === vm.enums.PhysicalProductState.Active\">\n            <div class=\"td\">\n                <h4 translate=\"have_no_active_infotags\"></h4>\n            </div>\n        </div>\n        <div class=\"panel-footer footer-padinationSmaller\" ng-if=\"vm.data.Total > vm.settings.pageSize\">\n            <ul uib-pagination total-items=\"vm.data.Total\" template-url=\"custompagination.html\"\n                items-per-page=\"vm.settings.pageSize\" ng-model=\"vm.settings.page\" previous-text=\"«\" next-text=\"»\"\n                max-size=\"10\" boundary-link-numbers=\"true\" />\n        </div>\n    </div>\n</div>\n<script id=\"custompagination.html\" type=\"text/ng-template\">\n    <ul class=\"pagination\">\n        <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious() || ngDisabled}\" class=\"pagination-first\"><a ui-sref=\"app.information-cards({page:1})\">{{::getText('first')}}</a></li>\n        <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious() || ngDisabled}\" class=\"pagination-prev\"><a ui-sref=\"app.information-cards({page:page - 1})\">{{::getText('previous')}}</a></li>\n        <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active, disabled: ngDisabled && !page.active}\" class=\"pagination-page\"><a ui-sref=\"app.information-cards({page:page.number})\">{{page.text}}</a></li>\n        <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext() || ngDisabled}\" class=\"pagination-next\"><a ui-sref=\"app.information-cards({page:page + 1})\">{{::getText('next')}}</a></li>\n        <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext() || ngDisabled}\" class=\"pagination-last\"><a ui-sref=\"app.information-cards({page:totalPages})\">{{::getText('last')}}</a></li>\n    </ul>\n</script>";

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <!-- <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button> -->\n    <h4 class=\"modal-title\"\n        ng-if=\"ctrl.isNew\"\n        translate=\"new_ingredient\"></h4>\n    <h4 class=\"modal-title\"\n        ng-if=\"!ctrl.isNew\"\n        translate=\"edit_ingredient\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign\" ng-form=\"ctrl.ingredientForm\">\n    <label class=\"font-normal\" translate=\"name_with_asterisk\"></label>\n        <div class=\"posRel\">\n            <input type=\"text\"\n               class=\"form-control mb10\"\n               ng-model=\"ctrl.item.Title\"\n               ng-change=\"ctrl.titleChange()\"\n               ng-class=\"{'input-validation__field--invalid': ctrl.showUniqueNameError || ctrl.showLongNameError}\"\n               name=\"title\">\n        <div class=\"text-danger input-validation__error mt-5\"\n             ng-if=\"ctrl.showUniqueNameError\"\n             translate=\"ingredient_editor_title_error\"></div>\n        <div class=\"text-danger input-validation__error mt-5\"\n             ng-if=\"ctrl.showLongNameError\"\n             translate=\"ingredient_editor_length_error\"></div>\n        </div>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\"\n                ng-click=\"ctrl.updateIngredient()\"\n                ng-disabled=\"ctrl.ingredientForm.$pristine || ctrl.waiting || ctrl.showUniqueNameError || !ctrl.item.Title \"\n                class=\"btn btn-success mr8 height40 btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\"></span>\n        </button>\n        <button type=\"button\"\n                ng-click=\"ctrl.close()\"\n                class=\"btn btn-danger height40 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex\">\n    <div class=\"app-view-header tab-campaings mt-9 mb16 header-tablist\">\n        <span ng-class=\"{'header-tablist__item--active': ctrl.isActive}\"\n              ng-click=\"ctrl.setTab('active')\"\n              class=\"header-tablist__item clickable\">\n            <span class=\"mr25 fs-20\" translate=\"ingredients\"></span>\n        </span>\n        <span ng-class=\"{'header-tablist__item--active': !ctrl.isActive}\"\n              ng-click=\"ctrl.setTab('archived')\"\n              class=\"header-tablist__item clickable\">\n            <span class=\"fs-20\" translate=\"archived_ingredients\"></span>\n        </span>\n    </div>\n    <button type=\"button\"\n            class=\"btn btn-success ml-auto add-btn ml-auto height40\"\n            ng-click=\"ctrl.openIngredientDialog()\"\n            ng-if=\"ctrl.isActive\">\n        <span class=\"plus-icon icon24\"></span>\n        <span class=\"ml8 fs-14 ng-scope\" translate=\"add_ingredient\"></span>\n    </button>\n</div>\n\n<!--Search-->\n<search placeholder-text=\"'search_ingredients' | translate\"\n        text=\"ctrl.search.text\"\n        on-search-click=\"ctrl.applySearch(searchText)\"\n        on-clear-click=\"ctrl.resetSearch()\">\n</search>\n\n<div ng-infinite-scroll load-more=\"ctrl.loadData(true)\">\n    <div class=\"panel ingredients\" ng-show=\"ctrl.ingredients.length > 0\">\n        <div class=\"ingredients__item d-flex pt12 pb12 pr24 pl24\" ng-repeat=\"ingredient in ctrl.ingredients\">\n            <span class=\"ingredients__name fs-14\" ng-bind=\"ingredient.Title\"></span>\n            <div class=\"ingredients__control ml-auto\">\n\n                <span class=\"d-flex\" ng-if=\"ctrl.isActive\">\n                    <span class=\"edit-icon icon24 mr25 clickable\"\n                          ng-click=\"ctrl.openIngredientDialog(ingredient)\"></span>\n                    <span class=\"delete-icon icon24 clickable\"\n                          ng-click=\"ctrl.deleteIngredient(ingredient)\"></span>\n                </span>\n\n                <span class=\"flexVerticalAlignParent clickable\"\n                      ng-click=\"ctrl.restoreIngredient(ingredient)\"\n                      ng-if=\"!ctrl.isActive\">\n                    <span class=\"icon-time-restore icon24\"></span>\n                </span>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n<empty-list-state ng-show=\"ctrl.ingredients.length === 0\"\n                  ng-if=\"!ctrl.forSearch && ctrl.isActive\"\n                  title-message=\"'ingredients_list_empty_screen_title' | translate\"\n                  message=\"'ingredients_list_empty_screen_content' | translate\"\n                  fill-element>\n</empty-list-state>\n<empty-list-state ng-show=\"ctrl.ingredients.length === 0\"\n                  ng-if=\"!ctrl.forSearch && !ctrl.isActive\"\n                  title-message=\"'ingredient_message_empty_archived_title' | translate\"\n                  message=\"'ingredient_message_empty_archived_content' | translate\"\n                  fill-element>\n</empty-list-state>\n<empty-list-state ng-show=\"ctrl.ingredients.length === 0\"\n                  ng-if=\"ctrl.forSearch\"\n                  image-class=\"'icon-empty-list-search'\"\n                  title-message=\"'ingredients_list_not_found_screen_title' | translate\"\n                  message=\"ctrl.searchMessageContent\"\n                  class=\"ingredients-not-found\"\n                  fill-element>\n</empty-list-state>\n";

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"vm.cancel()\">×</button>\n    <h4 class=\"modal-title\" translate=\"choose_category\" ></h4>\n</div>\n<div class=\"modal-body panel-campaign-choice\">\n    <div class=\"selectCategoriesNote\" translate=\"choose_category_note\" ></div>\n    <div class=\"posRel searchInput mb20\">\n        <input type=\"text\" class=\"form-control\" ng-change=\"vm.pagination.setData()\" ng-model=\"vm.pagination.filter\"\n            translate translate-attr-placeholder=\"search_your_categories\"  />\n        <span class=\"fa fa-search\"></span>\n    </div>\n    <div class=\"selectCategoriesWrap\">\n        <div ng-repeat=\"category in vm.pagination.data\" ng-click=\"vm.ok(category)\">\n            <span ng-bind=\"category.CategoryFullName\"></span>\n        </div>\n        <div ng-show=\"vm.pagination.data == 0\" class=\"anymatch\">\n            &#39;{{vm.pagination.filter}}&#39;<br /><span translate=\"filter_didnt_match_any_categories\" ></span>\n        </div>\n    </div>\n    <div class=\"panel-footer footer-padinationSmaller bt0 pt20 pb20\" ng-if=\"vm.pagination.total > vm.pagination.pageSize\">\n        <ul uib-pagination ng-disabled=\"vm.waiting\" ng-change=\"vm.pagination.setData()\" total-items=\"vm.pagination.total\" items-per-page=\"vm.pagination.pageSize\" ng-model=\"vm.pagination.page\" previous-text=\"«\" next-text=\"»\" max-size=\"5\" boundary-link-numbers=\"true\" />\n    </div>\n</div>\n";

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb24 productHeader flexVerticalAlignParent\" ng-show=\"$ctrl.isNotPublicRoute\">\n    <span translate=\"list_of_countries\" class=\"fs-20\"></span>\n</div>\n<div class=\"row marginRowMinus\">\n    <!-- table countries -->\n    <div class=\"panel help-panel\" ng-hide=\"$ctrl.waiting\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <table class=\"help-panel__table table-white wd-wide\">\n                    <thead>\n                        <tr>\n                            <th class=\"pt14 pb14 pl24 text-nowrap\"><span translate=\"column_country_id\"></span></th>\n                            <th class=\"pl20\"><span translate=\"column_country_name\"></span></th>\n                        </tr>\n                    </thead>\n                    <tbody ng-repeat=\"item in ::$ctrl.items track by item.ID\">\n                        <tr>\n                            <td class=\"pt14 pb14 pl24 width1\">\n                                <span>{{::item.ID}}</span>\n                            </td>\n                            <td class=\"pl20\">\n                                <span>{{::item.Name}}</span>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n                <table class=\"help-panel__table table-white wd-wide\">\n\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.waiting\" class=\"absolute-center-flex empty-wrap\">\n        <h4 class=\"opacity54 flexVerticalAlignParent\">\n            <i class=\"icon24 icon-processing fa-spin\"></i>&nbsp;<span translate=\"request_is_being_processed\"></span>\n        </h4>\n    </div>\n</div>\n";

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb24 productHeader flexVerticalAlignParent\"\n    ng-show=\"$ctrl.isNotPublicRoute\">\n    <span translate=\"list_of_categories\" class=\"fs-20\"></span>\n</div>\n<div class=\"row marginRowMinus\">\n    <!-- table -->\n    <div class=\"panel help-panel\" ng-hide=\"$ctrl.waiting\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <table class=\"help-panel__table table-white wd-wide\">\n                    <thead>\n                        <tr>\n                            <th class=\"pt14 pb14 pl24 text-nowrap\"><span translate=\"column_category_id\"></span></th>\n                            <th class=\"pl8\"><span translate=\"column_category_name\"></span></th>\n                            <th class=\"text-right pr24 \" colspan=\"3\">&nbsp;</th>\n                        </tr>\n                    </thead>\n                    <tbody ng-repeat=\"item in ::$ctrl.items track by item.CategoryID\">\n                        <tr ng-click=\"item.expanded = !item.expanded\" class=\"clickable\">\n                            <td class=\"pt14 pb14 pl24\" width=\"1\">\n                                <span>{{::item.CategoryID}}</span>\n                            </td>\n                            <td class=\"pl8\" width=\"30%\">\n                                <span>{{::item.CategoryName}}</span>\n                            </td>\n                            <td class=\"text-right\" width=\"10%\">\n                                <span class=\"color-black54\" translate=\"item_types_count\"\n                                    ng-show=\"item.ItemTypesWithMeasurements.length\"\n                                    translate-value-count=\"{{::item.ItemTypesWithMeasurements.length}}\"\n                                    translate-interpolation=\"messageformat\">\n                                </span>\n                            </td>\n                            <td class=\"pr24 text-right\">\n                                <span class=\"ml-auto fs-14 fa fa-caret-down animated opacity0\"\n                                    ng-class=\"{ 'fa-rotate-180': item.expanded, 'opacity38': item.ItemTypesWithMeasurements.length  }\"></span>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"item.expanded\">\n                            <td class=\"pl24\"></td>\n                            <td colspan=\"3\">\n                                <table class=\"fw\">\n                                    <tr>\n                                        <td class=\"pl16 pt14 pb14\" colspan=\"2\">\n                                            <table class=\"wd-wide\">\n                                                <tr>\n                                                    <td class=\"pl16 pt8 pb14 color-black54 table__inner-item\">ID</td>\n                                                    <td class=\"pl16 pt8 pb14 color-black54 table__inner-item\"\n                                                        colspan=\"2\">Item Type</td>\n                                                </tr>\n                                                <tr ng-repeat=\"itemType in ::item.ItemTypesWithMeasurements\">\n                                                    <td ng-if=\"itemType.ID\"\n                                                        class=\"pl16 pt8 pb14 width1 text-nowrap pr16 table__inner-item align-top\">\n                                                        {{::itemType.ID}}</td>\n                                                    <td\n                                                        class=\"pl16 pt8 pb14 width1 text-nowrap pr16 table__inner-item align-top\">\n                                                        {{::itemType.Name}}</td>\n                                                    <td class=\"table__inner-item\">\n                                                        <table class=\"wd-wide\">\n                                                            <tbody class=\"bb0\">\n                                                                <tr>\n                                                                    <td class=\"width1 pt8 pr24 text-nowrap\"><span\n                                                                            ng-show=\"itemType.MaleMeasurements.length\"\n                                                                            class=\"color-black54\"\n                                                                            translate=\"male_measurements\"></span> </td>\n                                                                    <td class=\"pt8\">\n                                                                        {{::itemType.MaleMeasurements.join(', ')}}</td>\n                                                                </tr>\n                                                                <tr>\n                                                                    <td class=\"width1 pr24 text-nowrap pb8\"><span\n                                                                            class=\"color-black54\"\n                                                                            ng-show=\"itemType.FemaleMeasurements.length\"\n                                                                            translate=\"female_measurements\"></span></td>\n                                                                    <td class=\"pb8\">\n                                                                        {{::itemType.FemaleMeasurements.join(', ')}}\n                                                                    </td>\n                                                                </tr>\n                                                            </tbody>\n                                                        </table>\n                                                    </td>\n                                                </tr>\n                                            </table>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div ng-show=\"$ctrl.waiting\" class=\"absolute-center-flex empty-wrap\">\n        <h4 class=\"opacity54 flexVerticalAlignParent\">\n            <i class=\"icon24 icon-processing fa-spin\"></i>&nbsp;<span translate=\"request_is_being_processed\"></span>\n        </h4>\n    </div>\n</div>\n";

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span translate=\"file_format_and_properties\" class=\"fs-20\"></span>\n</div>\n\n<div class=\"help-wrap mt32\">\n    <div class=\"row mb32\">\n        <div class=\"col-md-7\">\n            <h2 class=\"fs-24 text-normal mb8 mt0\">About CSV</h2>\n            <p>A CSV is a comma-separated values file, which allows data to be saved in a tabular format. CSVs look like\n                a\n                spreadsheet but with a .csv extension. They differ from other spreadsheet file types because you can\n                only\n                have a single sheet in a file and you cannot save formulas in this format.</p>\n            <p class=\"mb0\">CSV files can be easily created and used with most any spreadsheet program, such as Microsoft\n                Excel or\n                Google Spreadsheets.</p>\n        </div>\n    </div>\n    <div class=\"row mb32\">\n        <div class=\"col-md-7\">\n            <h2 class=\"fs-24 text-normal mt0 mb8\">Before you begin</h2>\n            <p>We strongly recommend to download our <a ng-href=\"{{::$ctrl.templateCsvUrl}}\">template file</a> and complete it with your products.\n            </p>\n            <p>You can also rely on the example files filled with test products:\n                <ul>\n                    <li>\n                        <a ng-href=\"{{::$ctrl.exampleCsvUrl}}\">clothing example;</a>\n                    </li>\n                    <li>\n                        <a ng-href=\"{{::$ctrl.exampleCsvUrl_food_bev}}\">food example.</a>\n                    </li>\n                </ul>\n            </p>\n            <p class=\"mb0\">Add your products one row at a time. If you’re importing variants, see <a href=\"#formatting_variants\">Formatting\n                    variants.</a></p>\n        </div>\n        <div class=\"col-md-offset-1 col-md-4\">\n            <a ng-href=\"{{::$ctrl.templateCsvUrl}}\"\n                class=\"btn btn-with-icon flexVerticalAlignParent apply-btn apply-btn--transparent apply-btn--purple-no-border mt24\">\n                <span class=\"icon24 icon-csv--purple mr8\"></span>\n                <span>Template</span>\n            </a>\n            <a ng-href=\"{{::$ctrl.exampleCsvUrl}}\"\n                class=\"btn btn-with-icon flexVerticalAlignParent apply-btn apply-btn--transparent apply-btn--purple-no-border\">\n                <span class=\"icon24 icon-csv--purple mr8\"></span>\n                <span>Clothing example</span>\n            </a>\n                <a ng-href=\"{{::$ctrl.exampleCsvUrl_food_bev}}\"\n                class=\"btn btn-with-icon flexVerticalAlignParent apply-btn apply-btn--transparent apply-btn--purple-no-border\">\n                <span class=\"icon24 icon-csv--purple mr8\"></span>\n                <span>Food example</span>\n            </a>\n        </div>\n    </div>\n    <div class=\"row mb16\">\n        <div class=\"col-md-7\">\n            <h2 class=\"fs-24 text-normal mb16 mt0\">File format and limitations</h2>\n            <h3 class=\"fs-20 text-normal mb8 mt0\">Header row</h3>\n            <p>CSV file must start with a header row, containing the name of all required fields (columns). The possible\n                columns\n                are listed below in this document.</p>\n        </div>\n        <div class=\"col-md-7\">\n            <h3 class=\"fs-20 text-normal mb8 mt0\">Separator</h3>\n            <p>CSV file might use one of the following separators: comma, semicolon, or tab. Text must be encoded with UTF-8 to avoid generating unwanted characters in your products.</p>\n        </div>\n        <div class=\"col-md-offset-1 col-md-4\">\n            <span class=\"opacity54 block mt27\"><span class=\"text-bold\">sep=;</span> – service row means that<br>\n                semicolon is used as separator;</span>\n        </div>\n        <div class=\"col-md-7\">\n            <h3 class=\"fs-20 text-normal mb8 mt0\">Size</h3>\n            <p>Maximum allowed file size is 5 MB.</p>\n            <h3 class=\"fs-20 text-normal mb8 mt0\">Fields</h3>\n            <p>When completing your CSV file, your column headers and entries must match the following formatting.</p>\n            <p>\n                Required fields are marked with an asterisk <span class=\"red-asterisk\">*</span><br>\n                If some of the optional fields are not used, such fields can be even excluded from the resulting CSV file for ease of use.\n            </p>\n        </div>\n    </div>\n    <table class=\"table-white wd-wide operation-error__table mb32\">\n        <thead class=\"tableTagsHeader\">\n            <tr>\n                <th class=\"text-normal pl24 pr24 pt16 pb15 rounded-top\"><span>Field</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Restrictions</span></th>\n                <th class=\"text-normal pl24 pt16 pb15 rounded-top\"><span>Description</span></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    ID <span class=\"red-asterisk\">*</span>\n                    <br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Unique per account.</span> <br>\n                    <span>Up to 100 characters.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\"><span>Unique Product ID</span></td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Title</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">Up to 128 characters</td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Product title.</span><br>\n                    <span>If the product has variants, only enter the product title in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Description</span> <br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    Up to 30000 characters <br>\n\n                    Can contain HTML markup. The following HTML tags are allowed: <br>\n\n                    <span class=\"tags\">\n                        &lt;a&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;p&gt;, &lt;h1&gt;, &lt;h2&gt;, &lt;h3&gt;, &lt;h4&gt;,\n                        &lt;h5&gt;, &lt;h6&gt;, &lt;b&gt;, &lt;i&gt;, &lt;em&gt;, &lt;u&gt;, &lt;strike&gt;,\n                        &lt;strong&gt;, &lt;ol&gt;, &lt;br&gt;, &lt;span&gt;, &lt;div&gt;.\n                    </span>\n                    <br>\n                    Please note: all class and style attributes will be cleared out.\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    Some text which describes a product. <br>\n                    If the product has variants, only enter the description in the first variant's row.\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>ShortDescription</span> <br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    Up to 48 characters\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    Some text which describes a product shortly. <br>\n                    If the product has variants, only enter the short description in the first variant's row.\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Brand</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 100 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Product brand</span><br>\n                    <span>If the product has variants, only enter brand in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>ClassificationCategoryID</span><span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>The list of categories is available on <a target=\"_blank\" ui-sref=\"app.help.dictionary\">this page.</a></span>\n                    <span>Make sure you use ID, not category name.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>ID of category which identifies a product.</span>\n                    <span>If the product has variants, only enter category in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>ItemTypeID</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>The list of item types is available on <a target=\"_blank\" ui-sref=\"app.help.dictionary\">the same page</a> where the categories are listed.\n                    </span><br>\n                    <span>Make sure you use ID, not name.</span><br>\n                    <span>Use only one of those item types. If no item types listed for a particular category, keep this field empty, otherwise an\n                        error message will be shown.</span><br>\n                        <span>ItemType is required for products in categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Item type identities a product more precisely than category. It might be\n                        considered as an optional low level category.</span><br>\n                    <span>If the product has variants, only enter item type in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Gender</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Possible values (case insensitive):</span><br>\n                    <ul class=\"list-block\">\n                        <li>female</li>\n                        <li>f</li>\n                        <li>male</li>\n                        <li>m</li>\n                    </ul>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Mostly used for clothing. </span><br>\n                    <span>If the product has variants, only enter gender in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>VerificationRequired</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Possible values (case insensitive):</span>\n                    <ul class=\"list-block\">\n                        <li>true</li>\n                        <li>false</li>\n                    </ul>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Indicates whether a staff member should verify a customer's identity when selling this\n                        product.</span>\n                    <br>\n                    <span>False is default value.</span><br>\n                    <span>If the product has variants, only enter VerificationRequired in the first variant's\n                        row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Website</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's website</span>\n                    <br>\n                    <span>If the product has variants, only enter Website in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>VideoUrl</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's video</span>\n                    <br>\n                    <span>If the product has variants, only enter VideoUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>DocumentUrl</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's document(s) (*.pdf for example)</span>\n                    <br>\n                    <span>If the product has variants, only enter DocumentUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>FacebookUrl</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's Facebook page</span>\n                    <br>\n                    <span>If the product has variants, only enter FacebookUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>TwitterUrl</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's Twitter page</span>\n                    <br>\n                    <span>If the product has variants, only enter TwitterUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>InstagramUrl </span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>URL to a product's Instagram page</span>\n                    <br>\n                    <span>If the product has variants, only enter InstagramUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>PinterestUrl</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 256 characters</span>\n                    <br>\n                    <span>Properly formatted HTTP/HTTPS URL</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>URL to a product's Pinterest page</span>\n                    <br>\n                    <span>If the product has variants, only enter PinterestUrl in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>PreOrder</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Possible values (case insensitive):</span>\n                    <ul class=\"list-block\">\n                        <li>true</li>\n                        <li>false</li>\n                    </ul>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>If set to false, a customer will not be able to pre-order this product. Whereas another types of order will be available.</span><br>\n                    <span>If set to true, a customer will be able to pre-order this product as well as buy it using another types of order (In Store, Click&Collect, etc.).</span><br>\n                    <span>False is default value.</span>\n                    <br>\n                    <span>If the product has variants, only enter PreOrder in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td colspan =\"3\" class=\"pl24 pt16 pb15\">\n                    <span><b>Fields for food and beverage</b></span><br>\n                    <span>Fields Ingredients, FoodPreferences, Allergens are allowed only when a product is in categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231), or any Groceries subcategory.</span><br>\n                    <span>Fields Preparation, CountryOfOriginID are allowed only when a product is in categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</span><br>\n                    <span>If a product belongs to another category and some of these fields are specified, you will receive a validation error.</span><br>\n                    <span>The full list of categories is available on <a target=\"_blank\" ui-sref=\"app.help.dictionary\">this page</a>.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>CountryOfOriginID</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>The list of countries is available on <a target=\"_blank\" ui-sref=\"app.help.countries\">this page.</a></span>\n                    <span>Make sure you use ID, not country name.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>Country of origin, is the country of manufacture, production, or growth where a product comes from.</span><br>\n                    <span>If it is burrito cooked in Norway, please specify Norway, not Mexico.</span><br>\n                    <span>If the product has variants, only enter country in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Preparation</span> <br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    Up to 250 characters <br>\n                    Can contain only text.\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    Some text which describes product preparation. <br>\n                    If the product has variants, only enter the preparation in the first variant's row.\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Ingredients</span> <br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    Up to 2000 characters <br>\n                    Can contain only text.\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    Some text which describes  product ingredients. <br>\n                    If the product has variants, only enter the ingredients in the first variant's row.\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>FoodPreferences</span><br>\n                    <span class=\"fs-12 opacity54\">list of numbers</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>The list of food preferences is available on <a target=\"_blank\" ui-sref=\"app.help.preferences\">this page.</a></span>\n                    <span>Make sure you use ID, not name.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>Separate multiple preferences with comma.</span> <br>\n                    <span>This information is highlighted in the mobile app for those customers who specified such preferences in their profile.</span><br>\n                    <span>If the product has variants, only enter food preferences in the first variant's row.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>Allergens</span><br>\n                    <span class=\"fs-12 opacity54\">list of numbers</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>The list of allergens is available on <a target=\"_blank\" ui-sref=\"app.help.preferences\">this page.</a></span>\n                    <span>Make sure you use ID, not name.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>Separate multiple allergens with comma.</span> <br>\n                    <span>This information is highlighted in the mobile app for those customers who specified such allergens in their profile.</span><br>\n                    <span>If the product has variants, only enter allergens in the first variant's row.</span>\n                </td>\n                </tr>\n        </tbody>\n    </table>\n\n    <h3 class=\"fs-20 text-normal mt0 mb16\">Variant fields</h3>\n\n    <table class=\"table-white wd-wide operation-error__table mb32\">\n        <thead class=\"tableTagsHeader\">\n            <tr>\n                <th class=\"text-normal pl24 pr24 pt16 pb15 rounded-top\"><span>Field</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Restrictions</span></th>\n                <th class=\"text-normal pl24 pt16 pb15 rounded-top\"><span>Description</span></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>VariantID</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Unique among all product's variants of this account</span>\n                    <br>\n                    <span>Up to 100 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Product variant's ID</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Price</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">decimal</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Must be greater than zero. </span>\n                    <br>\n                    <span>Enter numbers and decimal points (.) only. No spaces are allowed. After the import, prices\n                        will display in your store’s currency.</span>\n                    <br>\n                    <span>The field only supports two decimal places, so round values to the nearest hundredth. Example:\n                        enter 10.513 as 10.51.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>The price of the product or variant (if there are multiple variants in the product).</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>InsidePrice</span><br>\n                    <span class=\"fs-12 opacity54\">decimal</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Only for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</span>\n                    <br>\n                    <span>Enter numbers and decimal points (.) only. No spaces are allowed. After the import, prices\n                        will display in your store’s currency.</span>\n                    <br>\n                    <span>The field only supports two decimal places, so round values to the nearest hundredth. Example:\n                        enter 10.513 as 10.51.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>When a customer has made a decision to eat inside, this price is applied instead of general price.\n                            If this price is not specified, general price is used in all cases.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>OldPrice</span><br>\n                    <span class=\"fs-12 opacity54\">decimal</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Must be greater than Price. </span>\n                    <br>\n                    <span>Enter numbers and decimal points (.) only. No spaces are allowed. After the import, prices\n                        will display in your store’s currency.</span>\n                    <br>\n                    <span>The field only supports two decimal places, so round values to the nearest hundredth. Example:\n                        enter 10.513 as 10.51.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>If the product is on sale, this is its original price, whereas sale price should be filled in\n                        Price column.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>VAT</span><br>\n                    <span class=\"fs-12 opacity54\">decimal</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Acceptable value in range [0-100]. </span>\n                    <br>\n                    <span>Can be empty.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Amount of product variation VAT in percents</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>InsideVAT</span><br>\n                    <span class=\"fs-12 opacity54\">decimal</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Only for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</span>\n                    <br>\n                    <span>Acceptable value in range [0-100]. </span>\n                    <br>\n                    <span>Can be empty.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Amount of product variation VAT in percents if user decides to eat inside.\n                        If it's not specified, VAT will be used.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Discount</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Acceptable value in range [1-100]. </span>\n                    <br>\n                    <span>Can be empty.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Discount of the variant. This percentage is applied and shown to a customer at the final stage in the basket and Order History page.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>MealTemperature</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Only for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</span>\n                    <br>\n                    <span>Possible values (case insensitive):</span>\n                    <ul class=\"list-block\">\n                        <li>h</li>\n                        <li>hot</li>\n                        <li>c</li>\n                        <li>cold</li>\n                    </ul>\n                    <span>Can be empty.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Indicates temperature of product's variant.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>PreparationTime</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Required for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231). Not available for another categories.</span>\n                    <br>\n                    <span>Acceptable value in range [0-1440] (24 hours).</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Time (in minutes) needed to cook this product's variant.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Images</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>At least one image is required.</span>\n                    <br>\n                    <span>Web-hosted product image link(s). Paste the image’s full URL. Ensure the URL leads directly to\n                        the image, not a page that includes the image. Check if the URL ends in an image file\n                        extension—like .jpg or .png—instead of .com or .html.</span>\n                    <br>\n                    <span>It’s not possible to upload images from your hard drive into this file.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Separate multiple images with space.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Size</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Colour</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's colour</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>SKU</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's SKU</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>NeckSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's neck size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>ChestSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's chest size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>BustSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's bust size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>WaistSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's waist size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>HipsSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's hips size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>InsideLegSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's inside leg size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>ShoeSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's shoe size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>LegLengthSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's leg length size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>DressSize</span><br>\n                    <span class=\"fs-12 opacity54\">text</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Up to 40 characters</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Variant's dress size</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>Badges</span><br>\n                    <span class=\"fs-12 opacity54\">list of numbers</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Possible values:</span><br>\n                    <ul class=\"list-block\">\n                        <li>0 - no badge (default value)</li>\n                        <li>1 - new</li>\n                        <li>2 - limited offer</li>\n                        <li>4 - hot deal</li>\n                        <li>8 - sale ending soon</li>\n                        <li>16 - clearance sale</li>\n                        <li>32 - new collection</li>\n                        <li>64 - sale</li>\n                        <li>128 - offer</li>\n                    </ul>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>Separate multiple badges with comma.</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>StockQuantity</span> <span class=\"red-asterisk\">*</span><br>\n                    <span class=\"fs-12 opacity54\">number</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Must be greater than or equal to zero. </span>\n                    <br>\n                    <span>Can be null.</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Stock level for the variant. Null value means unlimited quantity. Variant’s stock quantity won't be changed if CSV file doesn't have this field.</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <h3 class=\"fs-20 text-normal mt0 mb8\"><a name=\"formatting_variants\"></a>Formatting variants</h3>\n            <p>Each unique combination of size/colour creates a variant. Add a new row for every possible variant.</p>\n            <p>All combinations of variant's sizes and colour must be unique for each product.</p>\n            <p class=\"mb16\">If a product has multiple variants, each row must contain product's ID and variant data,\n                whereas product\n                specific fields should be filled only in the first variant's row, for example:</p>\n        </div>\n    </div>\n    <table class=\"table-white wd-wide operation-error__table mb32\">\n        <thead class=\"tableTagsHeader\">\n            <tr>\n                <th class=\"text-normal pl24 pt16 pb15 rounded-top\"><span>ID</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Title</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>...</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>VariantID</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Price</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>OldPrice</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Size</span></th>\n                <th class=\"text-normal pl24 pt16 pb15\"><span>Colour</span></th>\n                <th class=\"text-normal pl24 pt16 pb15 rounded-top\"><span>...</span></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>P-ID-1</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Clarks Men's Tilden Cap Oxford Shoe</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>...</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>ID1-V1</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>58</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>90</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>UK 9</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Dark Tan Leather</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>...</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>P-ID-1</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span></span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>...</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>ID1-V2</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>58</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>90</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>UK 9</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Black Leather</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>...</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>P-ID-3</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span>Lark & Ro Women's Sleeveless Crewneck Fit and Flare Dress</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span></span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>ID3-V1</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>34</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>39</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>8</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Blue</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>...</span>\n                </td>\n            </tr>\n            <tr>\n                <td class=\"pl24 pt16 pb15 rounded-bottom\">\n                    <span>P-ID-3</span>\n                </td>\n                <td class=\"pl24 pt16 pb15\">\n                    <span></span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span></span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>ID3-V2</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>22</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span></span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>8</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24\">\n                    <span>Salmon</span>\n                </td>\n                <td class=\"pl24 pt16 pb15 pr24 rounded-bottom\">\n                    <span>...</span>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <h3 class=\"fs-20 text-normal mt0 mb8\">Sizes</h3>\n            <p>There are different type of measurements available to fill in the file: NeckSize, ChestSize, BustSize,\n                WaistSize, HipsSize, InsideLegSize, ShoeSize, LegLengthSize, and DressSize.</p>\n            <p>It's not possible to combine any of them with column Size.</p>\n            <p>Availability of measurement type depends on selected ItemType and Gender. Please take a look at the <a\n                ui-sref=\"app.help.dictionary\" target=\"_blank\">web page</a>\n                to see which size columns are allowed for your particular product. Entering the data into size column\n                which\n                is not allowed for selected item type and gender will lead to appearing of error message.</p>\n            <p>For example, for ItemType \"Coat\" only ChestSize, BustSize. and WaistSize are allowed.</p>\n        </div>\n    </div>\n\n    <div class=\"row mb32\">\n        <div class=\"col-md-7\">\n            <h2 class=\"fs-24 text-normal mb16 mt0\">File upload</h2>\n            <p>There are 2 options available to select when uploading CSV file with products:</p>\n            <ul>\n                <li>Add to existing products - new products will be added into the system, existing in the system products will be\n                    updated with data coming from the CSV file;</li>\n                <li>Replace existing products - new products will be added into the system, existing in the system products will\n                    be updated with data coming from the CSV file. However, products which are not included into the CSV\n                    file (but existing in the system) will be archived.</li>\n            </ul>\n            <p>When 1st options is chosen, it's allowed to upload another one CSV file until the previous file is\n                processed. However, when 2nd options is selected, you should wait until all previous files are\n                processed.</p>\n            <p>After uploading a file the system validates it.</p>\n            <p>If any validation errors are found, they will be listed on the screen. You should fix them and upload the\n                fixed version of the file again.</p>\n            <p>When the validation step succeeds, the system will register a new upload request, which will be shown to\n                you as a new row in the operations table, as follows:</p>\n        </div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\"><img class=\"wd-wide mb32\" src=\"{{'/assets/images/help-example.png' | cdn}}\" alt=\"Example grid\"></div>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <p>The upload operation will be processed by the system as soon as possible, you may look at the status of\n                this operation by refreshing the operation table.</p>\n            <p>An upload operation might be in one of the following statuses:</p>\n            <ul>\n                <li>Enqueued - file is uploaded into system, validated, and waiting to be processed</li>\n                <li>Processing - the systems starts to process the file</li>\n                <li>Processed - the file is processed</li>\n            </ul>\n\n            <p>After processing is finished, the import operation status could have one of the icons:</p>\n            <ul class=\"mb24\">\n                <li><span class=\"color-success\">Green (success)</span> - all products from the file are either added or\n                    updated.</li>\n                <li><span class=\"color-error\">Red (error)</span> - some errors occurred during processing, which means\n                    only some (or even none) products are updated / added. In this case the list of errors is available\n                    by clicking on a row of a particular operation in the operations table.</li>\n            </ul>\n\n            <h3 class=\"fs-20 text-normal mt0 mb16\">List of possible errors</h3>\n            <p class=\"text-bold\">General errors</p>\n            <p>CSV file is empty.</p>\n            <p>CSV file is too large, the maximum size is 32 KB.</p>\n            <p>Unable to parse CSV file.</p>\n            <p>Failed to upload file of such size, please decrease size of your file and try again.</p>\n\n            <p class=\"text-bold\">Processing errors</p>\n            <p>Product already has been updated by another import operation.</p>\n            <p>Product's description contains forbidden html tags.</p>\n            <p>Unable to update product.</p>\n            <p>Variant already has been archived by another import operation.</p>\n            <p>Variant's price already has been updated by another import operation.</p>\n            <p class=\"mb16\">Unable to fetch images.</p>\n\n            <p class=\"text-bold\">Validation errors</p>\n            <p>ID is a required field.</p>\n\n            <p class=\"text-bold\">Product validation errors</p>\n            <p>Title is a required field.</p>\n            <p>Title length must be from 1 to 128 characters.</p>\n            <p>Description length must be from 1 to 2000 characters.</p>\n            <p>ClassificationCategoryID is a required field.</p>\n            <p>Classification category doesn't exist.</p>\n            <p>Incorrect classification category.</p>\n            <p>Item type doesn't exist.</p>\n            <p>Product must have at least one variation.</p>\n            <p>Website length must be from 1 to 256 characters.</p>\n            <p>VideoUrl length must be from 1 to 256 characters.</p>\n            <p>DocumentUrl length must be from 1 to 256 characters.</p>\n            <p>FacebookUrl length must be from 1 to 256 characters.</p>\n            <p>TwitterUrl length must be from 1 to 256 characters.</p>\n            <p>InstagramUrl length must be from 1 to 256 characters.</p>\n            <p>Preparation length must be less than 250 characters.</p>\n            <p>Ingredients length must be less than 1000 characters.</p>\n            <p>FoodPreference with ID ... not found.</p>\n            <p>Allergen with ID ... not found.</p>\n            <p>CountryOfOriginID field is required for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</p>\n            <p>ItemTypeID field is required for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</p>\n            <p>CountryOfOriginID field is allowed only for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</p>\n            <p>Preparation field is allowed only for categories Food (ID=229), Dishes (ID=230), or Drinks (ID=231).</p>\n            <p>Ingredients field is allowed only for categories Food (ID=229), Dishes (ID=230), Drinks (ID=231), or any Groceries subcategory</p>\n            <p>Allergens is allowed only for categories Food (ID=229), Dishes (ID=230), Drinks (ID=231), or any Groceries subcategory.</p>\n            <p>FoodPreferences field is allowed only for categories Food (ID=229), Dishes (ID=230), Drinks (ID=231), or any Groceries subcategory.</p>\n            <p class=\"mb16\">PinterestUrl length must be from 1 to 256 characters.</p>\n\n            <p class=\"text-bold\">Product variants validation errors</p>\n            <p>VariantID duplicate values.</p>\n            <p>Either size or colour values should be filled to support variations.</p>\n            <p>Either none or all colour values should be blank.</p>\n            <p>Size and colour pair should be unique for each variation.</p>\n            <p>You have to complete all size values (or none).</p>\n            <p>Price must be greater than 0.</p>\n            <p>OldPrice must be greater than Price.</p>\n            <p>Images is a required field.</p>\n            <p>SKU length must be from 1 to 64 characters.</p>\n            <p>Size length must be from 1 to 40 characters.</p>\n            <p>Colour length must be from 1 to 40 characters.</p>\n            <p>NeckSize length must be from 1 to 40 characters.</p>\n            <p>ChestSize length must be from 1 to 40 characters.</p>\n            <p>BustSize length must be from 1 to 40 characters.</p>\n            <p>WaistSize length must be from 1 to 40 characters.</p>\n            <p>HipsSize length must be from 1 to 40 characters.</p>\n            <p>InsideLegSize length must be from 1 to 40 characters.</p>\n            <p>ShoeSize length must be from 1 to 40 characters.</p>\n            <p>LegLengthSize length must be from 1 to 40 characters.</p>\n            <p>DressSize length must be from 1 to 40 characters.</p>\n            <p>Bust size is not acceptable for provided gender and item type.</p>\n            <p>Chest size is not acceptable for provided gender and item type.</p>\n            <p>Dress size is not acceptable for provided gender and item type.</p>\n            <p>Hips size is not acceptable for provided gender and item type.</p>\n            <p>InsideLeg size is not acceptable for provided gender and item type.</p>\n            <p>LegLength size is not acceptable for provided gender and item type.</p>\n            <p>Neck size is not acceptable for provided gender and item type.</p>\n            <p>Shoe size is not acceptable for provided gender and item type.</p>\n            <p>Waist size is not acceptable for provided gender and item type.</p>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb24 productHeader flexVerticalAlignParent\" ng-show=\"$ctrl.isNotPublicRoute\">\n     <span translate=\"list_of_preferences\" class=\"fs-20\"></span>\n</div>\n<div class=\"row marginRowMinus d-flex\">\n    <!-- table allergens -->\n    <div class=\"preference-help-panel\">\n        <span translate=\"allergens_title\" class=\"fs-20 pref-title\"></span>\n        <span class=\"icon-question-circle fa  mt-extra icon24 opacity16 ml5 clickable\"  ng-click=\"$ctrl.ShowTooltip($ctrl.$translate.instant('allergens_title'), $ctrl.allergensDescription)\"></span>\n        <div class=\"panel help-panel\" ng-hide=\"$ctrl.waiting\">\n            <div class=\"panel-body p0\">\n                <div class=\"tags-panel\">\n\n                    <table class=\"help-panel__table table-white wd-wide\">\n                        <thead>\n                            <tr>\n                                <th class=\"pt14 pb14 pl24 text-nowrap\"><span translate=\"column_allergen_id\"></span></th>\n                                <th class=\"pl20\"><span translate=\"column_allergen_name\"></span></th>\n                            </tr>\n                        </thead>\n                        <tbody ng-repeat=\"item in ::$ctrl.allergens | orderBy : 'ID'\">\n                            <tr>\n                                <td class=\"pt14 pb14 pl24 width1\">\n                                    <span>{{::item.ID}}</span>\n                                </td>\n                                <td class=\"pl20\">\n                                    <span>{{::item.Name}}</span>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <table class=\"help-panel__table table-white wd-wide\">\n\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"preference-help-panel\">\n        <!-- table preference -->\n        <span translate=\"foodPreference_title\" class=\"fs-20 pref-title\"></span>\n        <span class=\"icon-question-circle fa  mt-extra icon24 opacity16 ml5 clickable\"  ng-click=\"$ctrl.ShowTooltip($ctrl.$translate.instant('foodPreference_title'),$ctrl.foodPreferenceDescription)\"></span>\n        <div class=\"panel help-panel\" ng-hide=\"$ctrl.waiting\">\n                <div class=\"panel-body p0\">\n                    <div class=\"tags-panel\">\n\n                        <table class=\"help-panel__table table-white wd-wide\">\n                            <thead>\n                                <tr>\n                                    <th class=\"pt14 pb14 pl24 text-nowrap\"><span translate=\"column_preference_id\"></span></th>\n                                    <th class=\"pl8\"><span translate=\"column_preference_name\"></span></th>\n                                </tr>\n                            </thead>\n                            <tbody ng-repeat=\"item in ::$ctrl.foodPreferences | orderBy : 'ID'\">\n                                <tr>\n                                    <td class=\"pt14 pb14 pl24 width1\">\n                                        <span>{{::item.ID}}</span>\n                                    </td>\n                                    <td class=\"pl20\">\n                                        <span>{{::item.Name}}</span>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                        <table class=\"help-panel__table table-white wd-wide\">\n\n                        </table>\n                    </div>\n                </div>\n            </div>\n    </div>\n\n    <div ng-show=\"$ctrl.waiting\" class=\"absolute-center-flex empty-wrap\">\n       <h4 class=\"opacity54 flexVerticalAlignParent\">\n            <i class=\"icon24 icon-processing fa-spin\"></i>&nbsp;<span translate=\"request_is_being_processed\"></span>\n        </h4>\n    </div>\n</div>\n";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel show-hide mt24 basic-table__error-panel\" ng-show=\"$ctrl.errors && !$ctrl.errors.Success\">\n    <div class=\"panel-body p0\">\n        <div class=\"tags-panel\">\n            <div class=\"tableTags ml0 mr0 mt0 bg-white pl24 pr24 pt16 pb16 error-panel__caption\">\n                <div class=\"flexVerticalAlignParent\">\n                    <h4 translate=\"errors_header\"\n                        translate-interpolation=\"messageformat\"\n                        translate-value-count=\"{{$ctrl.errors.ErrorsCount}}\"\n                        translate-value-file=\"{{$ctrl.errors.FileName}}\">\n                    </h4>\n                    <span class=\"close-icon--small icon24 opacity38 ml-auto clickable\" ng-click=\"$ctrl.errors = null\"></span>\n                </div>\n            </div>\n            <table class=\"wd-wide error-panel__table\" ng-repeat=\"item in $ctrl.errors.ErrorItems\">\n                <tr ng-click=\"item.expanded = !item.expanded\" class=\"clickable\">\n                    <td class=\"pl24\"width=\"1\"><span class=\"icon-error-rounded--red icon24 inline-block\"></span></td>\n                    <td class=\"pl8\" width=\"35%\"><span class=\"fs-14\">{{item.Message}}</span></td>\n                    <td class=\"text-center\">\n                        <span ng-show=\"item.Items.length\" class=\"fs-14\"\n                            translate=\"entries_count\" translate-value-count=\"{{item.Items.length}}\"\n                            translate-interpolation=\"messageformat\"></span>\n                    </td>\n                    <td class=\"text-right pr24\"><span ng-show=\"item.Items.length\" class=\"fs-14 fa fa-caret-down animated ml-auto\" ng-class=\"{ 'fa-rotate-180': item.expanded }\"></span></td>\n                </tr>\n                <tr class=\"show-hide\" ng-if=\"item.expanded\" ng-repeat=\"subItem in item.Items\">\n                    <td class=\"pl24\"></td>\n                    <td class=\"pl16 pt14 pb14 table__inner-item\" colspan=\"3\">\n                        <p class=\"text-ellipsis mb0 posRel\">\n                            <span class=\"color-black54\">#</span> {{::subItem.ID}}&nbsp;&nbsp;\n                            {{::subItem.Title}} &nbsp;&nbsp;\n                            <span class=\"color-black54\" ng-if=\"subItem.Size\">Size:</span> {{::subItem.Size}}&nbsp;&nbsp;\n                            <span class=\"color-black54\" ng-if=\"subItem.Colour\">Colour:</span> {{::subItem.Colour}}&nbsp;&nbsp;\n                        </p>\n\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span class=\"activefilter\" translate=\"products\" ng-click=\"$ctrl.goToProducts(1)\"></span>\n    <span class=\"activefilter\" translate=\"archived_products\" ng-click=\"$ctrl.goToProducts(2)\" ng-show=\"$ctrl.hasArchivedProducts\"></span>\n    <span translate=\"product_import\"></span>\n    <a ui-sref=\"app.help.manual\" target=\"_blank\" class=\"ml24 color-blue fs-14 flexVerticalAlignParent clickable\">\n        <span class=\"icon-question-circle--blue icon24 mr6\"></span>\n        <span>{{::'help' | translate }}</span>\n    </a>\n    <div class=\"headerButton\">\n        <div uib-dropdown class=\"pull-right dropdown--redesign\">\n            <button type=\"button\" uib-dropdown-toggle\n                class=\"btn btn-success pull-right wd-auto dropdown-toggle flexVerticalAlignParent pl8 pr15\"\n                ng-disabled=\"$ctrl.waiting\"\n                aria-haspopup=\"true\"\n                aria-expanded=\"false\">\n                    <span class=\"plus-icon icon24 mr8\"></span>\n                    <span translate=\"button_import_products\"></span>\n                    <span class=\"caret ml15\"></span>\n            </button>\n            <ul class=\"dropdown-menu dropdown-with-icons width300\">\n                <li>\n                    <a href=\"#\" ng-click=\"$ctrl.selectFile(false)\" class=\"pl40\">\n                        <span class=\"flexVerticalAlignParent ml-32\">\n                            <span class=\"icon-add-and-update icon24 opacity54 mr8\"></span>\n                            <span>{{::'button_add_to_existing_products' | translate}}</span>\n                        </span>\n                        <span class=\"opacity6\">Add new products and update the existing ones</span>\n                    </a>\n                </li>\n                <li>\n                    <a href=\"#\" ng-click=\"$ctrl.selectFile(true)\" class=\"pl40\">\n                        <span class=\"flexVerticalAlignParent ml-32\">\n                            <span class=\"icon-purge-and-replace icon24 opacity54 mr8\"></span>\n                            <span>{{::'button_replace_existing_products' | translate}}</span>\n                        </span>\n                        <span class=\"opacity6\">Add new, update existing and remove products that aren’t in the file</span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n<input id=\"input\" type=\"file\" class=\"hidden\" accept=\".csv\"/>\n<div class=\"row  marginRowMinus\">\n    <!-- loading placeholder -->\n    <tooltip state=\"$ctrl.tooltipState\" message=\"$ctrl.tooltipMessage\"></tooltip>\n    <!-- errors paceholder-->\n    <import-errors-list errors=\"$ctrl.errors\"></import-errors-list>\n    <!-- operations list -->\n    <operation-list on-file-upload-promise=\"$ctrl.uploadPromise\"></operation-list>\n</div>\n";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel show-hide mt24 mb32 pl24 pr24 pt16 pb16\" ng-show=\"$ctrl.state > 1\">\n    <div class=\"panel-body p0\">\n        <div class=\"inner flexVerticalAlignParent\">\n            <span class=\"icon24\" ng-class=\"{ 'icon-check-rounded--green': $ctrl.state == 3 || $ctrl.state == 1, 'icon-spinner--purple fa-spin fa-2x': $ctrl.state == 2 }\"></span>&nbsp;\n            {{ $ctrl.message }}\n            <span class=\"close-icon--small opacity38 icon24 ml-auto clickable\" ng-show=\"$ctrl.state == 3\" ng-click=\"$ctrl.state = 1\"></span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<ol class=\"breadcrumb ns\">\n    <li>\n        <span>\n            <span ui-sref=\"app.shops\" translate=\"places\"></span>\n        </span>\n    </li>\n    <li>\n        <span>\n            <i ng-bind=\"vm.data.shop.Town\"></i>\n            <span ui-sref=\"app.shop({id:vm.data.shopID})\" ng-bind=\"vm.data.shop.Name\"></span>\n        </span>\n    </li>\n    <li class=\"active\">\n        <span translate=\"inventory_type\"></span>\n    </li>\n</ol>\n<div >\n    <div class=\"panel animated rotateInDownLeft panel-edit mb0\" ng-show=\"vm.contentLoaded\">\n        <div class=\"panel-heading\">\n            <div class=\"pull-right\">\n                <div class=\"btn-form btn-form-header clearfix\">\n                    <button type=\"button\" ng-click=\"vm.saveInventory()\" ng-disabled=\"vm.waiting || vm.data.inventoryTemp.ClassificationCategories.length == 0\" class=\"btn btn-success btn-with-line wd-auto\">\n                        <em class=\"fa fa-check\"></em>\n                        <span translate=\"button_save\">Save</span>\n                    </button>\n                    <button type=\"button\" ng-disabled=\"vm.waiting\" ui-sref=\"app.shop({id:vm.data.shopID})\" class=\"btn btn-danger btn-with-line\">\n                        <em class=\"fa fa-close\"></em>\n                        <span translate=\"button_discard\"></span>\n                    </button>\n                </div>\n            </div>\n            <div class=\"panel-title\">\n                <span translate=\"inventory_type\"></span>\n            </div>\n        </div>\n        <div class=\"panel-body pb0 overflowYHidden panel-body-inventory\">\n            <div  translate=\"products_in_a_store_hint\" translate-value-shop=\"{{vm.data.shop.Name}}\"></div>\n            <form name=\"vm.inventoryform\" class=\"form-validate positRelative\" autocomplete=\"off\" novalidate>\n                <classification-categories selected-categories=\"vm.data.inventoryTemp.ClassificationCategories\" single-select=\"false\" business-type=\"vm.data.inventoryTemp.BusinessType\"\n                    change-category=\"vm.data.changeClassificationCategory()\" errors=\"vm.data.classificationCategoriesErrors\"\n                    waiting=\"vm.waiting\" language-id=\"vm.languageId\"></classification-categories>\n            </form>\n        </div>\n    </div>\n</div>\n<div ng-show=\"vm.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts m10\">\n    <div>\n        <div class=\"flexVerticalAlignParent pb16\">\n            <div class=\"posRel\">\n                <div class=\"input-group wrapRelative datepicker--transparent width135\">\n                    <input type=\"text\" name=\"dateFrom\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"$ctrl.from\"\n                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                        ng-change=\"$ctrl.refresh()\" close-text=\"{{::'close' | translate}}\"\n                        clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                        is-open=\"dateFromOpened\" class=\"form-control pr0\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); dateFromOpened = true; dateToOpened = false;\"\n                            class=\"btn btn-default p0 pt7\">\n                            <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n            <div class=\"dash\"></div>\n            <div class=\"posRel\">\n                <div class=\"input-group wrapRelative datepicker--transparent width135\">\n                    <input type=\"text\" name=\"dateTo\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"$ctrl.to\"\n                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                        ng-change=\"$ctrl.refresh()\" close-text=\"{{::'close' | translate}}\"\n                        clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                        is-open=\"dateToOpened\" class=\"form-control\" />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); dateToOpened = true; dateFromOpened = false;\"\n                            class=\"btn btn-default p0 pt7\">\n                            <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-control-static placeSelect ml15 width135\">\n                <ui-select ng-model=\"$ctrl.filter\" reset-search-input=\"true\" theme=\"bootstrap\"\n                    on-select=\"$ctrl.refresh()\" ng-disabled=\"$ctrl.waiting\"\n                    class=\"top-panel-select--no-bg select--bordered height40\">\n                    <ui-select-match placeholder=\"All\">{{$select.selected.name }}</ui-select-match>\n                    <ui-select-choices repeat=\"option in $ctrl.filterOptions | filter:$select.search\">{{option.name}}\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <button class=\"btn btn-with-icon ml-auto purpleBtn bg-transparent flexVerticalAlignParent\"\n                ng-click=\"$ctrl.refresh()\" ng-enabled=\"$ctrl.waiting\">\n                <span class=\"icon24 icon-restore--purple mr8\"></span>\n                {{::'button_refresh' | translate }}\n            </button>\n        </div>\n        <div class=\"panel mb-50\">\n            <div class=\"panel-body p0\">\n                <div class=\"tags-panel\">\n                    <div class=\"tableTags ml0 mr0 mt0\" ng-infinite-scroll load-more=\"$ctrl.loadData()\">\n                        <table ng-show=\"$ctrl.total\" class=\"tableTags ml0 mr0 mt0 table-white basic-table\">\n                            <thead>\n                                <tr class=\"tableTagsHeader\">\n                                    <th class=\"width1 pl16 pt14 pb14 rounded-top\"></th>\n                                    <th class=\"pl16 pt14 pb14\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_start\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_end\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_update_type\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_client_id\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_source\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span>ID</span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_updated\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_added\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span translate=\"column_errors\"></span>\n                                        </div>\n                                    </th>\n                                    <th class=\"pl16 text-right pr24 rounded-top\" >\n                                        <div class=\"inner\">\n                                            <span translate=\"column_total\"></span>\n                                        </div>\n                                    </th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"item in $ctrl.items track by item.ID\"\n                                    ng-click=\"$ctrl.openOperation(item.ID)\">\n                                    <td class=\"pl16 pt14 pb14\">\n                                        <div class=\"inner text-center height24\">\n                                            <operation-status operation=\"item\"></operation-status>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.RequestTimeStamp | date:'medium' }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.FinishedAt | date:'medium' }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.Kind}}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ClientID}}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.Source}}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ID | trimstart }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ItemsUpdatedCount | number }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ItemsAddedCount | number }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16 text-right\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ErrorsCount | number }}</span>\n                                        </div>\n                                    </td>\n                                    <td class=\"pl16 text-right pr24\">\n                                        <div class=\"inner\">\n                                            <span class=\"fs-14\">{{::item.ItemsCount | number }}</span>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-hide=\"$ctrl.total\" class=\"absolute-center-flex empty-wrap mt24\">\n        <h4 class=\"opacity54\" translate=\"no_import_operations_found\"></h4>\n    </div>\n</div>\n";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span class=\"activefilter mr0 fs-20\" translate=\"product_import\" ng-click=\"$ctrl.goToProductImport()\"></span>\n    <span class=\"icon24 icon-chevron-right opacity38 mr8 mb-2\"></span>\n    <span class=\"fs-20\">{{::$ctrl.operation.ID}}</span>\n</div>\n<div class=\"accounts\" ng-if=\"!$ctrl.error\">\n    <div class=\"panel\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <div class=\"tableTags ml0 mr0 mt0 no-hover\">\n                    <!-- header begin-->\n                    <div class=\"tr tableTagsHeader\">\n                        <div class=\"td width1 pt14 pb14 pl24\">\n                            <div class=\"inner\" translate=\"column_start\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16\">\n                            <div class=\"inner\" translate=\"column_end\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16\">\n                            <div class=\"inner\" translate=\"column_update_type\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16\">\n                            <div class=\"inner\" translate=\"column_client_id\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16\">\n                            <div class=\"inner\" translate=\"column_source\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16 text-right\">\n                            <div class=\"inner\" translate=\"column_updated\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16 text-right\">\n                            <div class=\"inner\" translate=\"column_added\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pl16 text-right\">\n                            <div class=\"inner\" translate=\"column_errors\"></div>\n                        </div>\n                        <div class=\"td width1 pt14 pb14 pr24 text-right\">\n                            <div class=\"inner\" translate=\"column_total\"></div>\n                        </div>\n                    </div>\n                    <!-- header end -->\n                    <!-- data begin -->\n                    <div class=\"tr\">\n                        <div class=\"td pl24\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.RequestTimeStamp | date:'medium' }}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.FinishedAt | date:'medium' }}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.Kind}}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.ClientID}}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.Source}}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner text-right\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.ItemsUpdatedCount | number }}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner text-right\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.ItemsAddedCount | number }}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pl16\">\n                            <div class=\"inner text-right\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.ErrorsCount | number }}</span>\n                            </div>\n                        </div>\n                        <div class=\"td pr24\">\n                            <div class=\"inner text-right\">\n                                <span class=\"fs-14\">{{::$ctrl.operation.ItemsCount | number }}</span>\n                            </div>\n                        </div>\n                    </div>\n                    <!-- data end -->\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"accounts\" ng-if=\"!$ctrl.error && $ctrl.operation.Errors.length\">\n    <div class=\"panel\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <table class=\"tableTags ml0 mr0 mt0 table-white operation-error__table\">\n                    <!-- header begin-->\n                    <tr>\n                        <td class=\"pt14 pb14 pl24 rounded-top\" colspan=\"3\">\n                            <div class=\"inner\">\n                                <h4 class=\"fs-20 text-nowrap m0\" translate-interpolation=\"messageformat\" translate=\"errors_during_import\" translate-value-count=\"{{::$ctrl.operation.Errors.length}}\"></h4>\n                            </div>\n                        </td>\n                    </tr>\n                    <!-- header end -->\n                    <!-- subheader begin -->\n                    <tr class=\"tableTagsHeader\">\n                        <td class=\"width1 pt14 pb14 pl24 text-nowrap align-middle\">\n                            <div class=\"inner\" translate=\"column_product_id\"></div>\n                        </td>\n                        <td class=\"width1 pl16 text-nowrap align-middle\">\n                            <div class=\"inner\" translate=\"column_variant_id\"></div>\n                        </td>\n                        <td class=\"pl16 align-middle\">\n                            <div class=\"inner\" translate=\"column_error\"></div>\n                        </td>\n                    </tr>\n                    <!-- subheader end-->\n                    <!-- data begin -->\n                    <tr ng-repeat=\"error in ::$ctrl.operation.Errors\">\n                        <td class=\"pl24 pt14 pb14 align-top rounded-bottom\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::error.ProductID }}</span>\n                            </div>\n                        </td>\n                        <td class=\"pl16 pt14 pb14 align-top\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::error.VariantID }}</span>\n                            </div>\n                        </td>\n                        <td class=\"pl16 pr24 pt14 pb14 align-top rounded-bottom\">\n                            <div class=\"inner\">\n                                <span class=\"fs-14\">{{::error.Error }}</span>\n                            </div>\n                        </td>\n                    </tr>\n                    <!-- data end -->\n                </table>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header bb0\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"$ctrl.waiting\" class=\"close full-opacity\" ng-click=\"$ctrl.close()\" >\n        <span class=\"close-icon--small icon24 inline-block opacity54\"></span>\n    </button>\n</div>\n<!-- <div class=\"modal-body\"> -->\n<div class=\"add-account__modal\">\n    <form name=\"$ctrl.form\">\n        <div class=\"mb32 text-center\">\n            <svg width=\"142\" height=\"142\" viewBox=\"0 0 142 142\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" ng-click=\"$ctrl.imageClick()\" class=\"clickable\">\n                <defs>\n                    <clipPath id=\"circle_path\">\n                        <circle cx=\"71\" cy=\"71\" r=\"62\" fill=\"add_color\"/>\n                    </clipPath>\n                </defs>\n                <circle cx=\"71\" cy=\"71\" r=\"70\" stroke=\"#CAC8CB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-dasharray=\"6 8\"/>\n                <circle cx=\"71\" cy=\"71\" r=\"62\" fill=\"#EEEEEE\"/>\n                <path ng-hide=\"$ctrl.data.avatarUrl\" d=\"M51 51.002V45.002H55V51.002H61V55.002H55V61.002H51V55.002H45V51.002H51ZM57 63.002V57.002H63V51.002H77L80.66 55.002H87C89.2 55.002 91 56.802 91 59.002V83.002C91 85.202 89.2 87.002 87 87.002H55C52.8 87.002 51 85.202 51 83.002V63.002H57ZM71 81.002C76.52 81.002 81 76.522 81 71.002C81 65.482 76.52 61.002 71 61.002C65.48 61.002 61 65.482 61 71.002C61 76.522 65.48 81.002 71 81.002ZM64.6 71.002C64.6 74.542 67.46 77.402 71 77.402C74.54 77.402 77.4 74.542 77.4 71.002C77.4 67.462 74.54 64.602 71 64.602C67.46 64.602 64.6 67.462 64.6 71.002Z\" fill=\"black\" fill-opacity=\"0.36\"/>\n                <image ng-show=\"$ctrl.data.avatarUrl\" clip-path=url(#circle_path) xlink:href=\"{{$ctrl.data.avatarUrl}}\" width=\"124\" height=\"124\" x=\"8\" y=\"8\"/>\n            </svg>\n        </div>\n\n        <div class=\"form-group m0 clearfix\">\n            <div class=\"posRel clearfix\">\n                <div class=\"form-control-static width208 m0 p0 pull-left\">\n                    <input type=\"text\" ng-model=\"$ctrl.data.model.FirstName\" ng-disabled=\"$ctrl.waiting\" name=\"firstName\" required maxlength=\"20\"\n                    translate translate-attr-placeholder=\"first_name_required\" class=\"form-control fs-14\">\n                    <div class=\"text-danger\" ng-show=\"$ctrl.form.firstName.$dirty\">\n                        <div ng-show=\"$ctrl.form.firstName.$error.required\" translate=\"field_is_required\"></div>\n                        <div ng-show=\"$ctrl.form.firstName.$error.maxlength\" translate=\"first_name_too_long_20\"></div>\n                    </div>\n                </div>\n                <div class=\"form-control-static width208 m0 p0 pull-right\">\n                    <input type=\"text\" ng-model=\"$ctrl.data.model.LastName\" ng-disabled=\"$ctrl.waiting\" name=\"lastName\" required maxlength=\"20\"\n                    translate translate-attr-placeholder=\"last_name_required_is\"\n                    class=\"form-control fs-14\">\n                    <div class=\"text-danger\" ng-show=\"$ctrl.form.lastName.$dirty\">\n                        <div ng-show=\"$ctrl.form.lastName.$error.required\" translate=\"field_is_required\"></div>\n                        <div ng-show=\"$ctrl.form.lastName.$error.maxlength\" translate=\"last_name_too_long_20\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group m0 clearfix\">\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <input type=\"text\" name=\"login\" maxlength=\"100\" ng-model=\"$ctrl.data.model.Login\" ng-disabled=\"$ctrl.form.login.$pending\" ng-model-options=\"{ updateOn: 'blur'}\" translate translate-attr-placeholder=\"username\" class=\"form-control fs-14\" required>\n                </div>\n                <div class=\"text-danger\" ng-show=\"$ctrl.form.login.$dirty\">\n                    <div ng-show=\"$ctrl.form.login.$error.required\" translate=\"field_is_required\"></div>\n                    <div ng-show=\"$ctrl.form.login.$error.isInUse\" translate=\"login_is_in_use\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group m0 mb24 clearfix\">\n            <div class=\"posRel\">\n                 <div class=\"form-control-static m0 p0\"><!-- ng-hide=\"$ctrl.data.isPasswordExist\"  -->\n                    <input type=\"{{ $ctrl.data.showPassword ? 'text' : 'password' }}\" autocapitalize=\"off\" ng-model=\"$ctrl.data.model.Password\" ng-disabled=\"$ctrl.waiting\" placeholder=\"{{$ctrl.data.password}}\" class=\"form-control fs-14\" name=\"password\" minlength=\"8\" maxlength=\"20\">\n                    <span ng-click=\"$ctrl.data.showPassword = !$ctrl.data.showPassword\" class=\"show-pass\">\n                        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                            <path d=\"M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z\" fill=\"#805297\"/>\n                        </svg>\n                    </span>\n                </div>\n                <!-- <div ng-show=\"$ctrl.data.isPasswordExist\" class=\"form-control-static m0 p0 editPass\">\n                    <span ng-bind=\"$ctrl.data.password\"></span>\n                    <button ng-click=\"$ctrl.data.isPasswordExist = false\" ng-disabled=\"$ctrl.waiting\" class=\"btnChange\" translate=\"button_change\"></button>\n                </div> -->\n                <div class=\"text-danger\" ng-show=\"$ctrl.form.password.$dirty\">\n                    <div ng-show=\"$ctrl.form.password.$error.minlength\" translate=\"password_too_short_8\"></div>\n                    <div ng-show=\"$ctrl.form.password.$error.password\" translate=\"field_is_required\"></div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"posRel\"ng-if=\"$ctrl.businessUnionType === $ctrl.businessUnionTypeEnum.WHOLESALER\">\n            <div\n                class=\"checkbox c-checkbox m0\">\n                <label class=\"flexVerticalAlignParent mb20\">\n                    <input type=\"checkbox\"\n                           ng-model=\"$ctrl.data.model.WholesaleDeliveryDriver\"\n                           ng-click=\"\"\n                           ng-disabled=\"\"\n                           ng-checked=\"$ctrl.data.model.WholesaleDeliveryDriver\">\n                    <span class=\"fa mr15 fa-check\"></span>\n                    <div translate=\"wholesale_delivery_driver\" class=\"fs-14 lh16 ls-0146\"></div>\n                </label>\n            </div>\n        </div>\n\n\n        <div class=\"form-group m0 clearfix\">\n            <label class=\"control-label fullWidth fw-500\" translate=\"staff_interests_label\"></label>\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <input type=\"text\" name=\"interests\" maxlength=\"100\" ng-model=\"$ctrl.data.model.Interests\" ng-disabled=\"$ctrl.form.interests.$pending\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" translate translate-attr-placeholder=\"staff_interests_placeholder\" class=\"form-control fs-14\" />\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group m0 clearfix\">\n            <label class=\"control-label fullWidth fw-500\" translate=\"staff_favourite_products_label\"></label>\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <textarea name=\"lovedProducts\" maxlength=\"100\" ng-model=\"$ctrl.data.model.LovedProducts\" ng-disabled=\"$ctrl.form.lovedProducts.$pending\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" translate translate-attr-placeholder=\"staff_favourite_products_placeholder\" class=\"form-control fs-14\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group m0 clearfix\">\n            <label class=\"control-label fullWidth fw-500\" translate=\"staff_working_at_label\"></label>\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <textarea name=\"workingInfo\" maxlength=\"100\" ng-model=\"$ctrl.data.model.WorkingInfo\" ng-disabled=\"$ctrl.form.workingInfo.$pending\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" translate translate-attr-placeholder=\"staff_working_at_placeholder\" class=\"form-control fs-14\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group m0 clearfix\">\n            <span translate=\"access_to_stores\" class=\"fs-14\"></span>\n            <div class=\"posRel\">\n                <div class=\"form-control-static m0 p0\">\n                    <div class=\"borderChoiceFieldInner staff-stores__wrap pl0\">\n                        <div class=\"fieldCheckSelect\" ng-repeat=\"place in $ctrl.data.places\">\n                            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                <label for=\"placeCheckbox{{$index}}\" class=\"m0\">\n                                    <input type=\"checkbox\" ng-model=\"place.selected\" ng-change=\"$ctrl.changePlaces()\" ng-disabled=\"$ctrl.waiting || place.IsBanned || (!place.IsActive && !place.selected)\" name=\"placeCheckbox{{$index}}\" class=\"\" id=\"placeCheckbox{{$index}}\">\n                                    <span class=\"fa fa-check\"></span>\n                                </label>\n                            </div>\n                            <div class=\"adress lh18 fs-14\" title=\"{{place.info}}\" ng-class=\"{'inactiveStore': !place.IsActive &&  !place.IsBanned, 'bannedStore' : place.IsBanned}\" ng-bind=\"place.info\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer bt0\">\n    <button type=\"button\" ng-disabled=\"$ctrl.waiting || $ctrl.form.$pending || $ctrl.form.$invalid || $ctrl.form.$pristine\" ng-click=\"$ctrl.save()\" class=\"btn btn-success btn-with-icon\">\n    <em class=\"fa fa-check\"></em>\n    <span ng-bind=\"$ctrl.data.textBtn\"></span>\n    </button>\n    <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.close()\" class=\"btn btn-danger btn-with-icon\"  >\n    <em class=\"fa fa-times\"></em>\n    <span translate=\"button_cancel\"></span>\n    </button>\n</div>\n<style>\n.commonShadow {\nposition: fixed;\nwidth: 10000px;\nheight: 10000px;\ntop: -5000px;\nleft: -1000px;\nz-index: 10;\n}\n</style>\n<div ng-show=\"$ctrl.waiting\" class=\"commonShadow\"></div>\n\n<script type=\"text/javascript\">\n    $(document).ready(function () {\n        $('.add-account__modal').slimScroll({\n            height: 'calc(100vh - 200px)',\n            width: \"100%\",\n            alwaysVisible: true,\n            allowPageScroll: true\n        });\n    });\n\n</script>\n";

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"ctrl.waiting\" class=\"close full-opacity\"\n        ng-click=\"ctrl.closeDialog()\">\n        <span class=\"close-icon--small icon24 inline-block opacity54\"></span>\n    </button>\n    <h4 class=\"m0\" translate=\"{{ctrl.title}}\"></h4>\n</div>\n<div class=\"modal-body--redesign\">\n    <div class=\"modal-body-content\">\n        <p class=\"archive-text\" translate=\"{{ctrl.message}}\"></p>\n        <ul type=\"disc\" class=\"archive-list flex-column mb0\">\n            <li class=\"archive-list-item\" ng-repeat=\"item in ctrl.accounts\">\n                {{item}}\n            </li>\n        </ul>\n    </div>\n</div>\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent width100per\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.closeDialog()\"\n            class=\"btn mr8 color-black54 bg-dark12 btn-with-icon height40 width108\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"cancel\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.confirm()\"\n            class=\"btn btn-danger btn-with-icon height40 width108\">\n            <em class=\"fa fa-trash-o\"></em>\n            <span translate=\"button_archive\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts\">\n    <div class=\"accounts__filter\">\n        <span ng-class=\"{'activefilter': !vm.settings.filter.isActive}\" ng-click=\"vm.settings.filter.isActive = true\"\n            translate=\"staff_accounts\" class=\"fw-500 fs-24\">\n        </span>\n        <span ng-hide=\"!vm.settings.isStaffAny.archived\" ng-class=\"{'activefilter': vm.settings.filter.isActive}\"\n            ng-click=\"vm.settings.filter.isActive = false\" translate=\"archived_accounts\" class=\"fw-500 fs-24\">\n        </span>\n    </div>\n    <p ng-show=\"vm.settings.filter.isActive\" translate=\"staff_accounts_add_accounts_hint\" class=\"accounts__hint\"></p>\n    <p ng-hide=\"vm.settings.filter.isActive\" translate=\"staff_accounts_archived_accounts_hint\" class=\"accounts__hint\">\n    </p>\n    <div class=\"flexVerticalAlignParent\">\n        <div class=\"posRel searchInput flex-stretch max-w466\">\n            <input class=\"form-control top-panel-input\" ng-model=\"vm.settings.filter.keyword\"\n                ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" translate\n                translate-attr-placeholder=\"name_or_username\">\n            <span class=\"fa fa-search\"></span>\n        </div>\n        <div class=\"form-control-static placeSelect ml15 width160\">\n            <ui-select ng-model=\"vm.settings.filter.place\" reset-search-input=\"true\" theme=\"bootstrap\"\n                on-select=\"vm.settings.isAllAccountsSelected = false; vm.settings.setCheckboxes()\"\n                ng-disabled=\"vm.waiting || vm.settings.places.length === 1\"\n                class=\"top-panel-select--no-bg place-select\">\n                <ui-select-match placeholder=\"{{:: 'all_locations' | translate }}\">{{$select.selected.Name }}\n                </ui-select-match>\n                <ui-select-choices repeat=\"place in vm.settings.places | filter:$select.search\">\n                    {{place.Name}}\n                </ui-select-choices>\n            </ui-select>\n        </div>\n        <div ng-show=\"vm.settings.filter.isActive && !vm.waiting && vm.settings.isAccountSelected()\" class=\"ml-auto\">\n            <button ng-click=\"vm.archiveAccount()\" class=\"btn btn-danger btn-with-icon\">\n                <em class=\"fa fa-trash\"></em>\n                <span translate=\"button_archive\"></span>\n            </button>\n        </div>\n        <div ng-show=\"vm.settings.filter.isActive && !vm.settings.isAccountSelected()\" class=\"ml-auto\">\n            <button ng-click=\"vm.setAccount(vm.accountTypes.staff)\" ng-disabled=\"vm.waiting\" class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-plus\"></em>\n                <span translate=\"button_add_an_account\"></span>\n            </button>\n        </div>\n        <div ng-if=\"!vm.settings.filter.isActive\" class=\"ml-auto\">\n            <button ng-click=\"vm.restoreAccount()\" ng-disabled=\"vm.waiting || !vm.settings.isAccountSelected()\"\n                class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-rotate-left\"></em>\n                <span translate=\"button_restore\"></span>\n            </button>\n        </div>\n    </div>\n    <div ng-class=\"{'show': vm.settings.showPanel(), 'hidden': !vm.settings.showPanel()}\">\n\n        <div class=\"panel\">\n            <div class=\"panel-body p0\">\n                <div class=\"tags-panel\">\n                    <div class=\"tableTags ml0 mr0 mt0\">\n                        <div ng-hide=\"vm.tableTotal === 0\" class=\"tableTags ml0 mr0 mt0\">\n                            <div class=\"tr tableTagsHeader\">\n                                <!-- Checkbox header -->\n                                <div class=\"td width1 pt14 pb14 pl24\">\n                                    <div class=\"inner\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                            <label for=\"allCheckbox\" class=\"m0\">\n                                                <input type=\"checkbox\" name=\"allCheckbox\" ng-disabled=\"vm.waiting\"\n                                                    ng-model=\"vm.settings.isAllAccountsSelected\"\n                                                    ng-change=\"vm.settings.setCheckboxes()\"\n                                                    class=\"ng-pristine ng-untouched ng-valid\" id=\"allCheckbox\">\n                                                <span class=\"fa fa-check\"></span>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- Avatar header -->\n                                <div class=\"td width1 staff-avatar pl16 pt14 pb14\"></div>\n                                <!-- FIO header -->\n                                <div class=\"td width1 pl16 pt14 pb14\" ng-click=\"vm.settings.sort.set('FirstName')\">\n                                    <div class=\"inner \">\n                                        <span ng-if=\"!vm.settings.isVendorTypeTable\" translate=\"name\"></span>\n                                        <span ng-if=\"vm.settings.isVendorTypeTable\" translate=\"vendor_table_name\"></span>\n                                    </div>\n                                </div>\n                                <!-- UserName header -->\n                                <div class=\"td width1 pl16 pt14 pb14\" ng-click=\"vm.settings.sort.set('Login')\">\n                                    <div class=\"inner text-nowrap\">\n                                        <span ng-if=\"!vm.settings.isVendorTypeTable\" translate=\"username\"></span>\n                                        <span ng-if=\"vm.settings.isVendorTypeTable\" translate=\"vendor_table_user_name\"></span>\n                                    </div>\n                                </div>\n                                <!-- Addres header -->\n                                <div class=\"td width2000 pl16 pt14 pb14\">\n                                    <div class=\"inner\" translate=\"location_th\">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"tr ng-scope\" ng-repeat=\"item in vm.tableData\">\n                                <!-- CheckBox -->\n                                <div class=\"td text-nowrap width1 pl24\">\n                                    <div class=\"inner\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                            <label for=\"checkbox{{$index}}\" class=\"m0\">\n                                                <input type=\"checkbox\" name=\"checkbox{{$index}}\"\n                                                    ng-model=\"item.selected\"\n                                                    ng-change=\"vm.settings.changeSelected()\"\n                                                    id=\"checkbox{{$index}}\">\n                                                <span class=\"fa fa-check\"></span>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- Avatar -->\n                                <div class=\"td pl16 staff-avatar\">\n                                    <svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\"\n                                        xmlns=\"http://www.w3.org/2000/svg\" ng-hide=\"item.avatarUrl\">\n                                        <circle cx=\"24\" cy=\"24\" r=\"24\" fill=\"#EEEEEE\" />\n                                        <path\n                                            d=\"M23.9996 10.8379C27.2125 10.8379 29.8061 13.468 29.8061 16.7261C29.8061 19.9843 27.2125 22.6144 23.9996 22.6144C20.7867 22.6144 18.1932 19.9843 18.1932 16.7261C18.1932 13.468 20.7867 10.8379 23.9996 10.8379ZM23.9996 38.7089C19.1609 38.7089 14.8835 36.1965 12.3867 32.3888C12.4448 28.483 20.1287 26.3436 23.9996 26.3436C27.8512 26.3436 35.5545 28.483 35.6125 32.3888C33.1158 36.1965 28.8383 38.7089 23.9996 38.7089Z\"\n                                            fill=\"black\" fill-opacity=\"0.16\" />\n                                    </svg>\n                                    <img ng-src=\"{{::item.avatarUrl}}\" style=\"width:48px; height:48px;border-radius:50%\"\n                                        ng-show=\"item.avatarUrl\" />\n                                </div>\n                                <!-- FirstName, LastName -->\n                                <div class=\"td text-nowrap pl16\">\n                                    <div class=\"inner\">\n                                        <span class=\"fs-14\" ng-bind=\"item.FirstName\"></span>&#32;\n                                        <span class=\"fs-14\" ng-bind=\"item.LastName\"></span>\n                                    </div>\n                                </div>\n                                <!-- UserName -->\n                                <div class=\"td text-nowrap pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-if=\"!vm.settings.isVendorTypeTable\" ng-bind=\"item.Login\"></span>\n                                        <span ng-if=\"vm.settings.isVendorTypeTable\" class=\"fs-14\" ng-bind=\"item.UserName\"></span>\n                                    </div>\n                                </div>\n                                <!-- Address -->\n                                <div class=\"td posRel pl16\">\n                                    <div class=\"inner \">\n\n                                        <div class=\"d-flex flex-row align-items-center justify-content-between\">\n                                            <div class=\"d-flex flex-column align-items-center location-text\">\n                                                <div class=\"d-flex flex-row align-items-center w-100\" ng-repeat=\"place in item.places\">\n                                                    <span class=\"marker-icon icon24 inline-block\"></span>\n                                                    <span ng-if=\"!vm.settings.isVendorTypeTable\"\n                                                        ng-class=\"{'inactiveStore': (!place.isActive && !place.isBanned), 'bannedStore' : place.isBanned}\"\n                                                        ng-bind=\"place.info\" class=\"fs-14 text addres-text\"></span>\n                                                    <span ng-if=\"vm.settings.isVendorTypeTable\"\n                                                        ng-class=\"{'inactiveStore': (!place.isActive && !place.isBanned), 'bannedStore' : place.isBanned}\"\n                                                        ng-bind=\"place.info\" class=\"fs-14 text addres-text\"></span>\n                                                </div>\n                                            </div>\n                                            <div ng-if=\"vm.settings.filter.isActive\"\n                                                class=\"d-flex flex-row align-items-center justify-content-end edit-delete\">\n                                                <span tooltip-popup-delay=\"200\" tooltip-placement=\"top\" translate\n                                                    translate-attr-uib-tooltip-html=\"Edit\" ng-click=\"vm.setAccount(vm.accountTypes.staff, item)\"\n                                                    class=\"absolute-center-flex icon40 shadowed\">\n                                                    <span class=\"fa fa-pencil\"></span>\n                                                </span>\n                                                <span tooltip-popup-delay=\"200\" tooltip-placement=\"top\" translate\n                                                    translate-attr-uib-tooltip-html=\"archive\"\n                                                    ng-click=\"vm.archiveAccount(item)\"\n                                                    class=\"absolute-center-flex icon40 shadowed\">\n                                                    <span class=\"fa fa-trash\"></span>\n                                                </span>\n                                            </div>\n                                            <div ng-if=\"!vm.settings.filter.isActive\" class=\"controlRowTags\">\n                                                <span ng-click=\"vm.restoreAccount(item)\" class=\"fs-13\">\n                                                    <em class=\"fa fa-rotate-left\"></em>\n                                                    <span translate=\"restore\"></span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-show=\"vm.tableTotal > vm.settings.pageSize\"\n            class=\"panel-footer footer-padinationSmaller bt0 pt5 pb20 pl20 pr20\">\n            <ul uib-pagination boundary-links=\"true\" total-items=\"vm.tableTotal\" items-per-page=\"vm.settings.pageSize\"\n                ng-model=\"vm.settings.page\" first-text=\"first\" last-text=\"last\" previous-text=\"&laquo;\"\n                next-text=\"&raquo;\" max-size=\"10\" />\n        </div>\n    </div>\n\n\n    <div fill-element ng-show=\"!vm.settings.isStaffAny.active && vm.settings.filter.isActive\"\n        class=\"absolute-center-flex\">\n        <empty-list-state ng-if=\"!vm.settings.isStaffAny.active || vm.settings.filter.isActive\"\n            title-message=\"'have_no_active_staff_accounts' | translate\"\n            message=\"'have_no_active_staff_accounts_hint' | translate\">\n        </empty-list-state>\n        <empty-list-state ng-if=\"!vm.settings.filter.isActive\" title-message=\"'have_no_shopping_places' | translate\"\n            message=\"'have_no_shopping_places_hint' | translate\">\n        </empty-list-state>\n    </div>\n</div>\n";

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-align-start\">\n    <div class=\"width70per\">\n        <div class=\"mb20\">\n            <div class=\"app-view-header tab-campaings mt-9 mb-3\">\n                <span translate=\"payment_settings\"></span>\n            </div>\n            <p class=\"lh16 pt2 mb0 pr20\" translate=\"enable_jisppay_hint\"></p>\n        </div>\n        <div>\n            <div ng-show=\"vm.isPlacesAny === true\" class=\"clearfix smallPanelWrap\">\n                <div class=\"smallPanel\" ng-repeat=\"place in vm.places\">\n                    <jisppay-place place=\"place\" edit=\"vm.edit\" place-edit=\"vm.placeEdit\"\n                        place-enabled=\"vm.placeEnabled\" save=\"vm.save\" cancel-edit=\"vm.cancelEdit\"\n                        jisp-pay-merchants=\"vm.jispPayMerchants\" default-merchants=\"vm.defaultMerchants\"\n                        waiting=\"vm.waiting\"></jisppay-place>\n                </div>\n            </div>\n        </div>\n    </div>\n    <button ng-click=\"(!vm.model || vm.model && !vm.model.TaxNumber && !vm.model.Orgnr) && vm.openSetInfoDialog()\"\n        class=\"panel pl16 pr10 pt15 pb10 clickable text-left width242 ml-auto\">\n        <div class=\"d-flex posRel\">\n            <div>\n                <h4 class=\"cart_fonts m0 mb8\" translate=\"company_information\"></h4>\n                <p ng-if=\"!vm.model || vm.model && !vm.model.TaxNumber && !vm.model.Orgnr\"\n                    class=\"cart_fonts m0 fs-12 panel-group-title text-normal\" translate=\"company_registration_details\">\n                </p>\n                <div class=\"d-flex flex-column\" ng-if=\"vm.model\">\n                    <span ng-if=\"vm.model.Orgnr\" class=\"text-ellipsis pl0 width200\">\n                        <span translate=\"company_registration_number\"></span>\n                        : {{vm.model.Orgnr}}\n                    </span>\n                    <span ng-if=\"vm.model.TaxNumber\" class=\"text-ellipsis pl0 width200\">\n                        <span translate=\"VAT\"></span>\n                        : {{vm.model.TaxNumber}}\n                    </span>\n                </div>\n            </div>\n            <span ng-if=\"vm.model && vm.model.Orgnr || vm.model && vm.model.TaxNumber\" ng-click=\"vm.openSetInfoDialog()\"\n                class=\"fa fa-pencil fs-18 company-info-edit-pen\"></span>\n        </div>\n    </button>\n\n    <empty-list-state class=\"empty-list-center-position absolute-center-flex mt-30\"\n                  title-message=\"'have_no_shopping_places' | translate\"\n                  message=\"'have_no_shopping_places_hint' | translate\"\n                  ng-show=\"vm.isPlacesAny === false\"\n                  ng-style=\"{ 'height': (vm.viewport.height)}\">\n</empty-list-state>\n</div>\n";

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"company_information\"></h4>\n</div>\n<div class=\"modal-body--redesign\">\n    <p class=\"m0 fs-12 text-normal ls-031 color-black6\"\n        translate=\"company_registration_number_modal\"></p>\n    <form name=\"ctrl.form\">\n        <div class=\"d-flex mt16\">\n            <div class=\"form-group pb5 flex-stretch\">\n                <label class=\"cart_fonts text-label-gray\" translate=\"company_registration_number\"></label>\n                <input type=\"text\" class=\"form-control mb15\" only-num maxlength=\"30\" ng-model=\"ctrl.model.Orgnr\">\n            </div>\n            <div class=\"form-group pb5 flex-stretch ml24\">\n                <label class=\"cart_fonts text-label-gray\" translate=\"company_vat_number\"></label>\n                <input name=\"TaxNumber\" type=\"text\" class=\"form-control mb15\" maxlength=\"30\" ng-model=\"ctrl.model.TaxNumber\"\n                    ng-pattern=\"ctrl.pattern\">\n            </div>\n        </div>\n        <div class=\"d-flex\">\n            <div class=\"d-flex flex-stretch mr24\">\n                <div class=\"form-group pb5 flex-stretch mr24\">\n                    <label class=\"cart_fonts text-label-gray\" translate=\"sort_code\"></label>\n                    <input name=\"SortCode\" type=\"text\" class=\"form-control mb15\" only-num maxlength=\"10\" ng-model=\"ctrl.model.SortCode\">\n                    <div ng-if=\"ctrl.sortNumberError\" class=\"text-danger text-nowrap mt-10\"\n                         translate=\"sort_code_error\"></div>\n                </div>\n                <div class=\"form-group pb5 flex-stretch\">\n                    <label class=\"cart_fonts text-label-gray\" translate=\"bank_account\"></label>\n                    <input type=\"text\" class=\"form-control mb15\" only-num maxlength=\"10\" ng-model=\"ctrl.model.BankAccount\">\n                    <div ng-if=\"ctrl.bankAccountError\" class=\"text-danger text-nowrap mt-10\"\n                         translate=\"bank_account_error\"></div>\n                </div>\n            </div>\n            <div class=\"form-group pb5 flex-stretch\">\n                <label class=\"cart_fonts text-label-gray\" translate=\"bank_account_name\"></label>\n                <input name=\"BusinessAccountName\" type=\"text\" class=\"form-control mb15\" maxlength=\"100\" ng-model=\"ctrl.model.BusinessAccountName\">\n            </div>\n        </div>\n        <div>\n            <h4 class=\"cart_fonts m0 mb24\" translate=\"company_legal_address\"></h4>\n            <div class=\"form-group mb5 pb5 flex-stretch\">\n                <label class=\"cart_fonts text-label-gray\" translate=\"company_address_first\"></label>\n                <input type=\"text\" class=\"form-control mb15\" ng-model=\"::ctrl.model.AddressLine1\">\n            </div>\n            <div class=\"form-group mb5 pb5 flex-stretch\">\n                <label class=\"cart_fonts text-label-gray\" translate=\"company_address_second\"></label>\n                <input type=\"text\" class=\"form-control mb15\" ng-model=\"::ctrl.model.AddressLine2\">\n            </div>\n            <div class=\"d-flex\">\n                <div class=\"form-group mb5 pb5 flex-stretch\">\n                    <label class=\"cart_fonts text-label-gray\" translate=\"company_town\"></label>\n                    <input type=\"text\" class=\"form-control mb15\" ng-model=\"::ctrl.model.Town\">\n                </div>\n                <div class=\"form-group mb5 pb5 flex-stretch ml24\">\n                    <label class=\"cart_fonts text-label-gray\" translate=\"company_postal_code\"></label>\n                    <input type=\"text\" class=\"form-control mb15\" ng-model=\"::ctrl.model.Postcode\">\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.saveForm()\"\n            class=\"btn btn-success  btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn mr8 btn-danger btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"$ctrl.cancel()\">×</button>\n    <h4 class=\"modal-title\" translate=\"please_type_your_password_to_apply_this_settings\" >\n    </h4>\n</div>\n<div class=\"modal-body\">\n    <input type=\"password\" class=\"form-control inputPassword\" ng-disabled=\"$ctrl.waiting\" ng-model=\"$ctrl.password\" />\n    <span class=\"text-danger\" ng-show=\"$ctrl.data.error\" ng-bind=\"$ctrl.data.error\"></span>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-danger\" translate=\"button_close\" ></button>\n    <button type=\"button\" ng-disabled=\"$ctrl.waiting || !$ctrl.password\" ng-click=\"$ctrl.confirm()\" class=\"btn btn-success\" translate=\"button_confirm\" ></button>\n</div>\n<div ng-show=\"$ctrl.waiting\" class=\"commonShadow\"></div>";

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header bb0\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"ctrl.waiting\" class=\"close full-opacity\"\n        ng-click=\"ctrl.closeDialog()\">\n        <span class=\"close-icon--small icon24 inline-block opacity54\"></span>\n    </button>\n</div>\n<div class=\"add-account__modal pl40 pr40 pb16 pt25\">\n    <form name=\"ctrl.vendorEditorForm\">\n        <div class=\"mb76 text-center\">\n            <svg width=\"140\" height=\"140\" viewBox=\"0 0 142 142\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"\n                ng-click=\"ctrl.addImage()\" class=\"clickable\">\n                <defs>\n                    <clipPath id=\"circle_path\">\n                        <circle cx=\"71\" cy=\"71\" r=\"62\" fill=\"add_color\" />\n                    </clipPath>\n                </defs>\n                <circle cx=\"71\" cy=\"71\" r=\"70\" stroke=\"#CAC8CB\" stroke-width=\"2\" stroke-linecap=\"round\"\n                    stroke-dasharray=\"6 8\" />\n                <circle cx=\"71\" cy=\"71\" r=\"62\" fill=\"#EEEEEE\" />\n                <path ng-hide=\"ctrl.avatarUrl\"\n                    d=\"M51 51.002V45.002H55V51.002H61V55.002H55V61.002H51V55.002H45V51.002H51ZM57 63.002V57.002H63V51.002H77L80.66 55.002H87C89.2 55.002 91 56.802 91 59.002V83.002C91 85.202 89.2 87.002 87 87.002H55C52.8 87.002 51 85.202 51 83.002V63.002H57ZM71 81.002C76.52 81.002 81 76.522 81 71.002C81 65.482 76.52 61.002 71 61.002C65.48 61.002 61 65.482 61 71.002C61 76.522 65.48 81.002 71 81.002ZM64.6 71.002C64.6 74.542 67.46 77.402 71 77.402C74.54 77.402 77.4 74.542 77.4 71.002C77.4 67.462 74.54 64.602 71 64.602C67.46 64.602 64.6 67.462 64.6 71.002Z\"\n                    fill=\"black\" fill-opacity=\"0.36\" />\n                <image ng-show=\"ctrl.avatarUrl\" clip-path=url(#circle_path) xlink:href=\"{{ctrl.avatarUrl}}\" width=\"124\"\n                    height=\"124\" x=\"8\" y=\"8\" />\n            </svg>\n        </div>\n\n        <div class=\"d-flex justify-content-between mb16\">\n            <div class=\"width208\">\n                <input type=\"text\" ng-model=\"ctrl.vendor.FirstName\" ng-disabled=\"ctrl.waiting\" name=\"firstName\"\n                    only-letters required maxlength=\"15\" translate translate-attr-placeholder=\"first_name\"\n                    class=\"form-control fs-14 height40\" ng-change=\"ctrl.setDefaultUsername()\">\n                <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.firstName.$dirty\">\n                    <div ng-show=\"ctrl.vendorEditorForm.firstName.$error.required\" translate=\"field_is_required\"></div>\n                </div>\n            </div>\n            <div class=\"width208\">\n                <input type=\"text\" ng-model=\"ctrl.vendor.LastName\" ng-disabled=\"ctrl.waiting\" name=\"lastName\"\n                    only-letters required maxlength=\"15\" translate translate-attr-placeholder=\"last_name\"\n                    class=\"form-control fs-14 height40\" ng-change=\"ctrl.setDefaultUsername()\">\n                <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.lastName.$dirty\">\n                    <div ng-show=\"ctrl.vendorEditorForm.lastName.$error.required\" translate=\"field_is_required\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"mb24\">\n            <input type=\"text\" ng-model=\"ctrl.vendor.Age\" ng-disabled=\"ctrl.waiting\" name=\"age\" only-decimal\n                min-value=\"1\" max-value=\"999\" translate translate-attr-placeholder=\"age\"\n                class=\"form-control height40 fs-14 width208\">\n        </div>\n        <div class=\"mb16\">\n            <input type=\"text\" autocomplete=\"off\" ng-model=\"ctrl.vendor.UserName\" ng-disabled=\"ctrl.waiting\"\n                name=\"username\" required maxlength=\"30\" only-letters translate translate-attr-placeholder=\"username\"\n                class=\"form-control fs-14 height40\">\n            <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.username.$dirty\">\n                <div ng-show=\"ctrl.vendorEditorForm.username.$error.required\" translate=\"field_is_required\"></div>\n            </div>\n        </div>\n        <div class=\"mb40\">\n            <div class=\"posRel form-password-with-show\">\n                <input type=\"text\" class=\"form-control inputPassword mb0 height40\" translate\n                    translate-attr-placeholder=\"password\" ng-disabled=\"ctrl.waiting\" ng-model=\"ctrl.vendor.Password\"\n                    ng-minlength=\"8\" ng-maxlength=\"128\" name=\"password\" autocomplete=\"off\" required\n                    show-password=\"ctrl.showPassword\" />\n                <span class=\"form-password-with-show__show-pass-icon\n                        form-password-with-show__show-pass-icon__sm\"\n                    ng-class=\"{'icon-open-eye': !ctrl.showPassword, 'icon-close-eye': ctrl.showPassword}\"\n                    ng-click=\"ctrl.showPassword = !ctrl.showPassword\"></span>\n            </div>\n            <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.password.$dirty\">\n                <div ng-show=\"ctrl.vendorEditorForm.password.$error.required\" translate=\"password_is_required\"></div>\n                <div ng-show=\"ctrl.vendorEditorForm.password.$error.minlength\" translate=\"password_too_short_8\"></div>\n                <div ng-show=\"ctrl.vendorEditorForm.password.$error.maxlength\" translate=\"password_too_long_128\"></div>\n            </div>\n        </div>\n        <div class=\"mb24\">\n            <label class=\"mb10 common-label fs-14 fw-500\" translate=\"field_short_description\"></label>\n            <textarea name=\"shortDescription\" maxlength=\"120\" ng-model=\"ctrl.vendor.ShortDescription\"\n                ng-disabled=\"ctrl.waiting\"\n                ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" translate\n                translate-attr-placeholder=\"vendor_description_placeholder\"\n                class=\"form-control fs-14 height72 no-resize rounded-4\"></textarea>\n        </div>\n        <div class=\"mb16\">\n            <label class=\"mb10 common-label fs-14 fw-500\" translate=\"full_description\"></label>\n            <textarea name=\"fullDescription\" maxlength=\"2000\" ng-model=\"ctrl.vendor.Description\"\n                ng-disabled=\"ctrl.waiting\" required\n                ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" translate\n                translate-attr-placeholder=\"vendor_description_placeholder\"\n                class=\"form-control fs-14 height72 no-resize rounded-4\"></textarea>\n            <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.fullDescription.$dirty\">\n                <div ng-show=\"ctrl.vendorEditorForm.fullDescription.$error.required\" translate=\"field_is_required\">\n                </div>\n            </div>\n        </div>\n        <div class=\"mb16\">\n            <input type=\"text\" ng-model=\"ctrl.vendor.Interviewer.InterviewerImg\" ng-disabled=\"ctrl.waiting\"\n                name=\"authorPhoto\" maxlength=\"20\" translate translate-attr-placeholder=\"vendor_editor_photo_author\"\n                class=\"form-control fs-14 height40\">\n        </div>\n        <div class=\"mb40\">\n            <input type=\"text\" ng-model=\"ctrl.vendor.Interviewer.InterviewerName\" ng-disabled=\"ctrl.waiting\"\n                name=\"interviewer\" maxlength=\"20\" translate translate-attr-placeholder=\"vendor_story_interviewer\"\n                class=\"form-control fs-14 height40\">\n        </div>\n        <div class=\"mb24\">\n            <label class=\"mb10 common-label fs-14 fw-500\" translate=\"place\"></label>\n            <div class=\"d-flex mb35 product-discount__row\">\n                <label class=\"radio align-items-baseline mr24\">\n                    <input type=\"radio\" ng-model=\"ctrl.isMapShown\" ng-value=\"true\" class=\"radio__input\" />\n                    <span class=\"radio__check\"></span>\n                    <span class=\"radio__label\" translate=\"input_address\"></span>\n                </label>\n                <label class=\"radio align-items-baseline mr24\">\n                    <input type=\"radio\" ng-model=\"ctrl.isMapShown\" ng-value=\"false\" class=\"radio__input\" />\n                    <span class=\"radio__check\"></span>\n                    <span class=\"radio__label\" translate=\"select_existing_location\"></span>\n                </label>\n            </div>\n        </div>\n        <div class=\"mb24\">\n            <label class=\"mb10 common-label fs-14 fw-500\" translate=\"vendor_street\"></label>\n            <input type=\"text\" ng-model=\"ctrl.vendor.Street\" ng-disabled=\"ctrl.waiting\" name=\"street\" required\n                maxlength=\"20\" translate translate-attr-placeholder=\"street_hint\" class=\"form-control fs-14 height40\">\n            <div class=\"text-danger\" ng-show=\"ctrl.vendorEditorForm.street.$dirty\">\n                <div ng-show=\"ctrl.vendorEditorForm.street.$error.required\" translate=\"field_is_required\"></div>\n            </div>\n        </div>\n        <div class=\"mb16\">\n            <label class=\"mb10 common-label fs-14 fw-500\" translate=\"full_address\"></label>\n            <div ng-if=\"!ctrl.isMapShown\" class=\"form-input--bg\">\n                <ui-select ng-model=\"ctrl.selectedAddress\" reset-search-input=\"true\" theme=\"bootstrap\"\n                    on-select=\"ctrl.setSelectedVendorLocation()\" name=\"fullAddress\"\n                    ng-disabled=\"ctrl.waiting || ctrl.locations.length === 1\" ng-required=\"!ctrl.isMapShown\"\n                    class=\"top-panel-select--no-bg place-select height40\">\n                    <ui-select-match placeholder=\"{{:: 'select_location' | translate }}\">{{$select.selected.Name}}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"place in ctrl.locations | filter:$select.search\">\n                        {{place.Name}}\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div ng-if=\"ctrl.isMapShown\">\n                <input type=\"text\" ng-model=\"ctrl.fullAddress\" ng-disabled=\"ctrl.waiting\" name=\"address\" maxlength=\"100\"\n                    translate translate-attr-placeholder=\"vendor_address_subtext\" class=\"form-control fs-14 height40\"\n                    ng-required=\"ctrl.isMapShown\">\n            </div>\n            <div class=\"text-danger\"\n                ng-show=\"ctrl.vendorEditorForm.address.$dirty || ctrl.vendorEditorForm.fullAddress.$dirty\">\n                <div ng-show=\"ctrl.vendorEditorForm.fullAddress.$error.required || ctrl.vendorEditorForm.address.$error.required\"\n                    translate=\"field_is_required\"></div>\n            </div>\n        </div>\n        <div class=\"containerGmap containerGmap-small mb16\" ng-if=\"ctrl.isMapShown && ctrl.isMapReady\">\n            <div class=\"messageButton\">\n                <button type=\"button\" class=\"btn btn-success height40\" ng-click=\"ctrl.getLocationFromAddress($event);\"\n                    translate=\"button_get_location_from_address\"></button>\n            </div>\n            <div ui-map-marker=\"ctrl.maps.markerEdit\"\n                ui-event=\"{'map-click': 'ctrl.openMarkerInfo(ctrl.maps.edit, ctrl.maps.markerEdit)'}\"></div>\n            <div ui-map-info-window=\"ctrl.maps.infoWindow\"></div>\n            <div id=\"map_canvas_edit\" ui-map=\"ctrl.maps.edit\"\n                ui-event=\"{'map-click': 'ctrl.setMarker($event, $params)', 'map-tilesloaded': 'ctrl.maploaded()', 'map-dragstart': 'ctrl.mapdragstart()', 'map-dragend': 'ctrl.mapdragend()'}\"\n                ui-options=\"ctrl.maps.optionsEdit\" class=\"gmap gmap300\"></div>\n        </div>\n    </form>\n</div>\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.closeDialog()\"\n            class=\"btn mr8 color-black54 bg-dark12 btn-with-icon height40\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"cancel\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.saveVendorForm()\"\n            ng-disabled=\"ctrl.vendorEditorForm.$invalid || ctrl.waiting || !ctrl.isFullAddressFiledValid() || ctrl.vendorEditorForm.$pristine\"\n            class=\"btn btn-success  btn-with-icon height40\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"add_vendor\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "<div class=\"marketplace\" ng-form=\"ctrl.advertForm\">\n    <div class=\"app-view-header mt-9 mb9\">\n        <span translate=\"ad_for_marketplace\">\n        </span>\n    </div>\n    <div class=\"marketplace__notofication mb24\" translate=\"marketplace__hint\">\n\n    </div>\n\n    <div class=\"panel marketplace__impressions mb7\">\n        <div class=\"panel-heading\">\n            <h4 class=\"panel-title\" translate=\"number_of_ad_impressions\"></h4>\n        </div>\n        <div class=\"panel-body\">\n            <table class=\"impressions__items\">\n                <tr>\n                    <td width=\"218\" class=\"pb16\"><span translate=\"current_views\"></span>\n                        <span ng-bind=\"ctrl.model.retailerAdvert.CurrentViews\"></span>\n                    </td>\n                    <td class=\"pb16\"><span translate=\"total_views\"></span>\n                        <span ng-bind=\"ctrl.model.retailerAdvert.TotalViews\"></span>\n                    </td>\n                </tr>\n                <tr>\n                    <td width=\"218\"><span translate=\"current_opennings\"></span>\n                        <span ng-bind=\"ctrl.model.retailerAdvert.CurrentOpennings\"></span>\n                    </td>\n                    <td><span translate=\"total_opennings\"></span>\n                        <span ng-bind=\"ctrl.model.retailerAdvert.TotalOpennings\"></span>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n\n    <div class=\"panel marketplace__setup mb7\">\n        <div class=\"panel-heading\">\n            <h4 class=\"panel-title\" translate=\"setup\"></h4>\n        </div>\n        <div class=\"panel-body\">\n            <span class=\"fw-500\" translate=\"on_click_link_to\"></span>\n            <label class=\"radio mr24 mb26 mt10\" for=\"retailer-page\">\n                <input type=\"radio\"\n                       name=\"location\"\n                       ng-model=\"ctrl.model.linkOption\"\n                       ng-model-options=\"{ allowInvalid: true }\"\n                       ng-change=\"ctrl.changeLinkOption(ctrl.model.linkOption)\"\n                       ng-value=\"0\"\n                       id=\"retailer-page\"\n                       class=\"radio__input\">\n                <span class=\"radio__check\"></span>\n                <span class=\"radio__label\" translate=\"retailer_page\"></span>\n            </label>\n            <label class=\"radio mr24 mb24\" for=\"avialable-to-all-customers\">\n                <input type=\"radio\"\n                       ng-model=\"ctrl.model.linkOption\"\n                       ng-change=\"ctrl.changeLinkOption(ctrl.model.linkOption)\"\n                       ng-value=\"1\"\n                       id=\"avialable-to-all-customers\"\n                       class=\"radio__input\">\n                <span class=\"radio__check\"></span>\n                <span class=\"radio__label\" translate=\"location_th\"></span>\n            </label>\n            <div>\n            </div>\n            <div class=\"flexVerticalAlignParent\">\n                <button class=\"btn btn-success mr24\"\n                        ng-disabled=\"ctrl.model.linkOption === 0\"\n                        ng-click=\"ctrl.openSelectLocationDialog()\"\n                        translate=\"select_location\">\n                </button>\n                <span class=\"marketplace__location\">\n                    <span ng-if=\"ctrl.model.selectedLocation &&\n                                 ctrl.model.selectedLocation.Name &&\n                                 ctrl.model.selectedLocation.Address\"\n                          ng-bind=\"ctrl.model.selectedLocation.Name+', '+ctrl.model.selectedLocation.Address\">\n                    </span>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"panel marketplace__design mb24\">\n        <div class=\"panel-heading\">\n            <h4 class=\"panel-title\" translate=\"design\"></h4>\n        </div>\n        <div class=\"panel-body d-flex\">\n            <div class=\"width345\">\n                <div class=\"wrapPhone\">\n                    <div class=\"wrapPhoneInner\">\n                        <div class=\"widthSelector\">\n                            <div class=\"imgcrop-area-container \">\n                                <div class=\"imgcrop-preview-wrap \">\n                                    <div data-text=\"Cropped Image\"\n                                         class=\"imgcrop-preview \">\n                                        <img ng-show=\"ctrl.image.data != null &&\n                                                 ctrl.error.imageMinAreaSize === false &&\n                                                 ctrl.error.imageRequired === false &&\n                                                 ctrl.error.imageMinSize === false \"\n                                             name=\"image\"\n                                             ng-model=\"ctrl.image.data\"\n                                             imageonload=\"ctrl.imageOnload($event)\"\n                                             ng-src=\"{{ctrl.image.data}}\" />\n                                    </div>\n                                </div>\n                                <div class=\"image-error\">\n                                    <span\n                                        ng-show=\"ctrl.image.src.length > 0 && ctrl.error.imageMinAreaSize\"\n                                        class=\"text-danger mb8\">\n                                        <ng-container translate=\"cropped_image_error\">\n                                        </ng-container>\n                                        {{ctrl.imageMinSize.w}}x{{ctrl.imageMinSize.h}}\n                                        px.\n                                    </span>\n                                    <span\n                                        ng-show=\"ctrl.image.src.length > 0 && ctrl.error.imageMinSize\"\n                                        class=\"text-danger mb8\">\n                                        <span translate=\"cropped_image_must_be_larger\"\n                                              translate-value-min-width=\"{{ctrl.imageMinSize.w}}\"\n                                              translate-value-min-height=\"{{ctrl.imageMinSize.h}}\">\n                                        </span>\n                                    </span>\n                                    <span\n                                        ng-show=\"ctrl.image.src.length == 0 && !ctrl.image.loading && ctrl.error.imageRequired\"\n                                        class=\"text-danger mb8\"\n                                        translate=\"image_is_required\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"marketplace__upload d-flex flex-column ml0 flex-stretch\">\n                <ad-image-selector state=\"ctrl.image\"\n                                waiting=\"ctrl.waiting\"\n                                options=\"ctrl.imageOptions\"\n                                error=\"ctrl.error\"\n                                id=\"imageScroll\"\n                                class=\"customInputFile\">\n                </ad-image-selector>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"d-flex\">\n    <div class=\"ml-auto d-flex\">\n        <button ng-if=\"ctrl.model.retailerAdvert.Advert.ID\"\n                class=\"btn btn-black width40 mr8 height40 text-center p0\"\n                ng-click=\"ctrl.openDeleteDialog()\">\n        <span class=\"icon24 inline-block icon-trashcan-outline-white\"></span>\n        <!-- delete -->\n    </button>\n\n        <button class=\"btn btn-success btn-with-icon ml-auto height40 add-btn\"\n                ng-disabled=\"ctrl.advertForm.$invalid || ctrl.advertForm.$pristine\"\n                ng-if=\"!ctrl.model.retailerAdvert.Advert.ID\"\n                ng-click=\"ctrl.createOrUpdateRetailerAdverts()\">\n        <span class=\"icon-check--white icon24\"></span>\n        <span translate=\"create\"></span>\n    </button>\n\n    <button class=\"btn btn-success btn-with-icon ml-auto height40 add-btn\"\n            ng-if=\"ctrl.model.retailerAdvert.Advert.ID\"\n            ng-disabled=\"ctrl.advertForm.$invalid || ctrl.advertForm.$pristine\"\n            ng-click=\"ctrl.createOrUpdateRetailerAdverts()\">\n        <span class=\"icon-check--white icon24\"></span>\n        <span translate=\"ad_retailer_button_update\"></span>\n    </button>\n    </div>\n\n</div>\n\n<div class=\"fake-divider height90\"></div>\n\n";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex flex-column\">\n\n    <div class=\"form-group input-btn-with-icon mb8\">\n        <input id=\"fileInputCropped\" filestyle=\"\" type=\"file\" ng-disabled=\"ctrl.waiting\" data-class-button=\"btn btn-default \"\n            data-class-input=\"form-control\" data-button-text=\"Upload your own image\" data-icon-name=\"fa fa-upload\" class=\"form-control btn heightAuto text-left\"\n            accept=\".png, .jpeg, .jpg\" />\n    </div>\n    <div class=\"mb18\">\n        <a ng-click=\"ctrl.needHelp()\" class=\"clickable\">\n            <ng-container translate=\"button_need_help_with_design\">\n            </ng-container>\n        </a>\n    </div>\n    <div class=\"imageNote\" translate=\"marketplace_upload_hint\" translate-value-min-width=\"{{ctrl.imageCropped.minSize.w}}\"\n         translate-value-min-height=\"{{ctrl.imageCropped.minSize.h}}\" translate-value-ratio=\"{{ctrl.options.ratio}}\">\n    </div>\n</div>\n<div>\n    <div class=\"cropImageDiv\">\n        <div>\n            <div class=\"labelCrop\">\n                <label class=\"text-normal\">\n                    <span ng-show=\"ctrl.state.src && !ctrl.state.loading\">\n                        <span translate=\"ad_retailer_preview_image\"></span>\n                        <span ng-show=\"ctrl.imageCropped.selector.size.w\">: {{ctrl.imageCropped.selector.size.w}}\n                            &times; {{ctrl.imageCropped.selector.size.h}}</span>\n                        <span ng-show=\"!ctrl.imageCropped.selector.size && ctrl.imageCropped.selector.imageSize.w\">:\n                            {{ctrl.imageCropped.selector.imageSize.w}} &times;\n                            {{ctrl.imageCropped.selector.imageSize.h}}</span>\n                    </span>\n                    <span class=\"text-danger h-auto\" ng-if=\"ctrl.error.imageMinSize\" translate=\"image_too_small\"\n                          translate-value-min-width=\"{{ctrl.imageCropped.minSize.w}}\"\n                          translate-value-min-height=\"{{ctrl.imageCropped.minSize.h}}\"></span>\n                    <span class=\"text-danger\" ng-if=\"ctrl.error.fileType\" translate=\"error_unsopported_image_format\"></span>\n                    <span class=\"text-danger\" ng-if=\"ctrl.error.fileSize\" translate=\"error_file_size_too_big\"></span>\n                </label>\n            </div>\n            <div class=\"imgcrop-area\" ng-if=\"!ctrl.state.src || ctrl.state.loading\">\n                <div class=\"imgcrop-area-inner\">\n                    <div class=\"imgcrop-area-table\">\n                        <div class=\"imgcrop-area-td\">\n                            <div class=\"image-error mt0\">\n                                <span ng-show=\"ctrl.state.loading\" translate=\"processing_your_image\"></span>\n\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"imgcrop-area noFixedArea\" ng-if=\"ctrl.state.src\">\n                <div class=\"imgcrop-area-inner\">\n                    <div class=\"imgcrop-area-table\">\n                        <div class=\"imgcrop-area-td\">\n\n                            <div mr-image=\"\" mr-src=\"ctrl.state.src\" mr-max-area-width=\"ctrl.imageCropped.maxWidth\"\n                                mr-max-image-width=\"ctrl.imageCropped.maxSize.w\" mr-scale=\"ctrl.imageCropped.scale\"\n                                mr-aspect-ratio=\"ctrl.imageCropped.aspectRatio\" mr-selector=\"ctrl.imageCropped.selector\"\n                                mr-drawer=\"ctrl.imageCropped.drawer\" mr-on-load=\"ctrl.onLoadImgCrop\" on-cropped=\"ctrl.onCropped(cropped)\"\n                                ng-mousedown=\"ctrl.clearCropped()\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "<div class=\" panel menu-item 505\">\n    <div\n        ng-if=\"vm.item.ImageID == 0\"\n        class=\"menu-item-placeholder col-12 fa fa-picture-o\"\n    ></div>\n    <div class=\"menu-item-image\" ng-if=\"vm.item.ImageID > 0\">\n        <img\n            ng-src=\"{{ vm.getImage() }}\"\n            alt=\"\"\n        />\n    </div>\n    <div class=\"menu-item-image\" ng-if=\"vm.image\">\n        <img ng-src=\"{{vm.image}}\" class=\"col-12\" alt=\"\" height=\"350\" />\n    </div>\n    <div class=\"panel-body\">\n        <div class=\"menu-item-body\">\n            <div class=\"menu-item-header\">{{ vm.item.Name }}</div>\n            <div class=\"fs-14 menu-item-element color-black54 mt0\">\n                    <span\n                        translate=\"created_on\"\n                        translate-value-date=\"{{ vm.item.CreateDateUTC | date }}\"\n                    ></span>\n            </div>\n            <div class=\"fs-14 menu-item-element menu-item-status\">\n                <div\n                    ng-if=\"vm.item.DisplayInApp\"\n                    class=\"menu-item-badge btn-success\"\n                    translate=\"active\"\n                ></div>\n                <div\n                    ng-if=\"!vm.item.DisplayInApp\"\n                    class=\"menu-item-badge btn-yellow\"\n                    translate=\"draft\"\n                ></div>\n                <span class=\"badge-title\" ng-bind-html=\"vm.scheduleService.renderActiveDates(vm.item.StartDate, vm.item.EndDate)\"></span>\n            </div>\n            <div class=\"fs-14 menu-item-element\">\n                <span class=\"caption\" translate=\"days\"></span>\n                <span\n                    class=\"color-black54\"\n                >{{ vm.scheduleService.renderDaysOfWeek(vm.item.DaysOfWeek, false); }}</span\n                >\n            </div>\n            <div class=\"fs-14 menu-item-element\">\n                <span class=\"caption\" translate=\"active_time\"></span>\n                <span class=\"color-black54\"\n                >{{ vm.toShortTime(vm.item.StartTime) }}\n                        <span ng-if=\"vm.item.StartTime != null && vm.item.EndTime != null\"> - </span>\n                        {{ vm.toShortTime(vm.item.EndTime) }}</span\n                >\n            </div>\n            <div class=\"fs-14 menu-item-element locations mb0\">\n                <div ng-show=\"vm.item.Places.length > 0\">\n                    <div class=\"location\">\n                        {{ vm.item.Places[0].Name + ', ' +\n                            vm.item.Places[0].AddressLine1 +\n                            (vm.item.Places[0].AddressLine2 ? ' ' + vm.item.Places[0].AddressLine2 : '') + ', ' +\n                            vm.item.Places[0].Town + ' ' +\n                            vm.item.Places[0].PostCode\n                        }}\n                    </div>\n                    <div\n                        class=\"text-muted\"\n                        ng-if=\"vm.item.Places.length > 1\"\n                    >\n                        +{{ vm.item.Places.length - 1 }}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div uib-dropdown class=\"menu-item-bottom-btn\">\n            <div uib-dropdown-toggle class=\"icon-ellipsis-v icon24\"></div>\n            <ul class=\"dropdown-menu\">\n                <li>\n                    <a ui-sref=\"app.edit-menu({id:vm.item.ID})\">\n                        <span class=\"fa fa-pencil icon\"></span>\n                        <span translate=\"edit\"></span>\n                    </a>\n                </li>\n                <li>\n                    <a\n                        ng-click=\"vm.duplicateMenu()\"\n                    >\n                        <span class=\"fa fa-files-o icon\"></span>\n                        <span translate=\"duplicate\"></span>\n                    </a>\n                </li>\n                <li>\n                    <a\n                        ng-click=\"vm.setArchivedMenu()\"\n                        class=\"flexVerticalAlignParent\"\n                    >\n                        <span ng-if=\"!vm.isArchived\" class=\"fa fa-trash icon\"></span>\n                        <span ng-if=\"vm.isArchived\" class=\"icon-time-restore icon24 icon\"></span>\n                        <span\n                            ng-if=\"!vm.isArchived\"\n                            translate=\"delete\"\n                        ></span>\n                        <span\n                            ng-if=\"vm.isArchived\"\n                            translate=\"restore\"\n                        ></span>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 ng-scope menu-header\">\n    <span class=\"activefilter mr0 fs-23\" ui-sref=\"app.menus\">\n        <span translate=\"menus\"></span>\n    </span>\n    <span class=\"icon-chevron-right icon24 opacity38 mr0\"></span>\n    <span class=\"fs-23\" ng-if=\"!vm.idParam || vm.isDuplicating\" translate=\"new\"></span>\n    <span class=\"fs-23\" ng-if=\"vm.idParam && !vm.isDuplicating\" translate=\"edit\"></span>\n</div>\n<div>\n    <uib-accordion close-others=\"false\" class=\"accordion-customize menu-editor-wrapper\">\n        <!-- DESCRIPTION -->\n        <div uib-accordion-group is-open=\"true\">\n            <uib-accordion-heading>\n                <span translate=\"description\"></span>\n                <span ng-show=\"vm.errors.title != ''\" class=\"text-danger error-datepicker\">*</span>\n            </uib-accordion-heading>\n            <div class=\"menu-editor\">\n                <div class=\"row flex-input-container\">\n                    <div class=\"mr25\">\n                        <div ng-if=\"!vm.item.ImageID\" class=\"menu-editor-placeholder icon-placeholder-plus clickable\"\n                            ng-click=\"vm.addImage()\"></div>\n                        <div ng-if=\"vm.item.ImageID > 0\" class=\"d-block\">\n                            <div>\n                                <img ng-src=\"{{ vm.getImage(vm.item) }}\" ng-click=\"vm.addImage()\"\n                                    class=\"menu-editor-placeholder clickable\" />\n                            </div>\n                            <a class=\"clickable mr15\" ng-click=\"vm.item.ImageID = null\">\n                                <span class=\"fa fa-trash mr5\"></span>\n                                <span translate=\"remove_photo\"></span>\n                            </a>\n                        </div>\n                    </div>\n                    <div class=\"col-10\">\n                        <label class=\"control-label\">\n                            <ng-container translate=\"menu_name\"></ng-container> *\n                        </label>\n                        <div class=\"menu-input\">\n                            <input type=\"text\" ng-model=\"vm.item.Name\" ng-change=\"vm.errors.title = ''\"\n                                autocomplete=\"off\" class=\"form-control\" />\n                            <div class=\"grayNote\" translate=\"max_64_characters_menus\"></div>\n                            <span ng-bind=\"vm.errors.title\" class=\"text-danger\"></span>\n                            <span ng-if=\"vm.item.Name.length > vm.NameMaxLength\"\n                                translate=\"max_64_characters_menus_error\" class=\"text-danger\"></span>\n                        </div>\n                        <div>\n                            <div class=\"checkbox c-checkbox\">\n                                <label class=\"pl18\">\n                                    <input type=\"checkbox\" ng-checked=\"!vm.item.DisplayInApp\"\n                                        ng-click=\"vm.item.DisplayInApp = !vm.item.DisplayInApp\" />\n                                    <span class=\"fa fa-check mr15\"></span>\n                                    <ng-container translate=\"dont_display_in_app\"></ng-container>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- LOCATIONS -->\n        <div uib-accordion-group is-open=\"false\">\n            <uib-accordion-heading>\n                <span translate=\"locations\"></span>\n            </uib-accordion-heading>\n            <button class=\"btn btn-success add-btn mt22\" ng-click=\"vm.addLocations()\">\n                <span class=\"plus-icon icon24 mr8\"></span>\n                <span translate=\"nfc_wizard_locations_step_add_location_button\">\n                </span>\n            </button>\n            <div class=\"menu-editor-locations\">\n                <div class=\"editor-location\" ng-repeat=\"loc in vm.item.Places\">\n                    <div class=\"pull-left\">\n                        {{ loc.Name + ', ' + loc.AddressLine1 + (location.AddressLine2 ? ' ' + location.AddressLine2 : '') + ', ' + loc.Town + ' ' + loc.PostCode }}\n                    </div>\n                    <div class=\"pull-right icon-trashcan-outline--tiny clickable\" ng-click=\"vm.removeLocation(loc.ID)\">\n                    </div>\n                </div>\n            </div>\n            <span class=\"text-muted\" ng-if=\"vm.item.Places.length < 1\">\n                <span class=\"text-danger\">*</span>\n                <span translate=\"required_places_field\"></span>\n            </span>\n        </div>\n\n        <!-- PRODUCTS -->\n        <div uib-accordion-group is-open=\"false\">\n            <uib-accordion-heading>\n                <span translate=\"products\"></span>\n            </uib-accordion-heading>\n            <div class=\"form-group mb0\">\n                <div class=\"d-flex align-items-center justify-content-between\">\n                    <button class=\"btn btn-success btn-with-icon height40 flexVerticalAlignParent mt22\"\n                        ng-click=\"vm.addProducts()\">\n                        <span class=\"plus-icon icon24 mr8\"></span>\n                        <span translate=\"button_add_products\">\n                        </span>\n                    </button>\n                    <div class=\"form-group mb0 d-flex align-items-center\">\n                        <em class=\"icon-question-circle inline-block icon24 opacity16 mr10\" tooltip-popup-delay=\"200\"\n                            tooltip-placement=\"left\" uib-tooltip-html=\"vm.htmlTooltip\"></em>\n                        <label class=\"control-label m0 mr10\" translate=\"predefined_order\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static m0 p0 min-h1\">\n                                <label class=\"switch switch-success posRel mb0\"\n                                    ng-click=\"vm.setUsersOrder(vm.item.PredeterminedSorting)\">\n                                    <input type=\"checkbox\" ng-model=\"vm.item.PredeterminedSorting\">\n                                    <span></span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-repeat=\"(key, products) in vm.item.ProductsGroups\">\n                    <div ui-tree=\"vm.treeOptions\">\n                        <div class=\"fs-20 mt30\">{{key}}</div>\n                        <div class=\"menu-editor-products\" ui-tree-nodes=\"\" ng-model=\"products\">\n                            <div ng-repeat=\"prod in products\" ui-tree-node>\n                                <div class=\"product\" ng-class=\"{ 'archived' : prod.IsArchived }\">\n                                    <div class=\"pull-left d-flex align-items-center\">\n                                        <div class=\"d-flex flex-row\" ng-if=\"vm.item.PredeterminedSorting\">\n                                            <span class=\"mr8 fs-14\">{{$index + 1}}</span>\n                                            <span ui-tree-handle class=\"drag-trigger icon-drag-drop--light icon24 mr8 clickable\"\n                                                ng-class=\"{ 'icon-drag-drop--dark' : prod.isOnDrag }\">\n                                            </span>\n                                        </div>\n                                        <div class=\"product-image-wrapper mr24 icon64\">\n                                            <img class=\"icon64\" ng-src=\"{{ prod.ImageID }}\" />\n                                        </div>\n                                        <span> {{ prod.Title }}</span>\n                                    </div>\n                                    <div class=\"pull-right mt24 flex-input-container\">\n                                        <span ng-if=\"prod.MinPrice == prod.MaxPrice\" class=\"mr70\">\n                                            {{ prod.MaxPrice | formatCurrency:vm.countryID}}</span>\n                                        <span ng-if=\"prod.MinPrice != prod.MaxPrice\" class=\"mr70\">\n                                            {{ prod.MinPrice | formatCurrency:vm.countryID }} -\n                                            {{ prod.MaxPrice | formatCurrency:vm.countryID}}</span>\n                                        <div class=\"icon-trashcan-outline--tiny clickable\"\n                                            ng-click=\"vm.removeProduct(prod.ID)\"></div>\n                                    </div>\n                                </div>\n                                <div class=\"product variant\" ng-repeat=\"variant in (prod.Variants)\"\n                                    ng-class=\"{ 'archived' : variant.IsArchived }\"\n                                    ng-if=\"variant.Size && !variant.IsArchived\">\n                                    <div class=\"pull-left\">\n                                        {{ prod.Title }}, <span translate=\"choose_menu_caption\"\n                                            ng-show=\"variant.Colour\"></span> {{ variant.Colour }}<span\n                                            ng-show=\"variant.Colour\">,</span> <span translate=\"size\"></span>:\n                                        {{ variant.Size }}\n                                    </div>\n                                    <div class=\"pull-right flex-input-container\">\n                                        <span class=\"mr10\">{{ variant.Price | formatCurrency:vm.countryID }}</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"text-muted mt15\" ng-if=\"vm.item.Products.length < 1\">\n                    <span class=\"text-danger\">*</span>\n                    <span translate=\"required_products_field\"></span>\n                </div>\n            </div>\n        </div>\n\n        <!-- SCHEDULE -->\n        <div uib-accordion-group is-open=\"false\">\n            <uib-accordion-heading>\n                <span translate=\"schedule\"></span>\n                <span ng-show=\"vm.errors.startDate != '' || vm.errors.endDate != '' || vm.errors.days != ''\"\n                    class=\"text-danger error-datepicker\">*</span>\n            </uib-accordion-heading>\n\n            <div class=\"container-fluid\">\n                <div class=\"d-flex mb15\">\n                    <div class=\"w238\">\n                        <label class=\"control-label checkbox\">\n                            <ng-container translate=\"start_date_require\"></ng-container>\n                        </label>\n                        <div class=\"menu-schedule-date height40 width190\">\n                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"vm.schedule.startDate\"\n                                ng-change=\"vm.errors.startDate = ''\" is-open=\"openedSD\"\n                                datepicker-options=\"vm.dateOptions\" close-text=\"{{::'close' | translate}}\"\n                                clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\" readonly\n                                class=\"form-control\" />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\"\n                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedSD = true;\"\n                                    class=\"btn btn-default btn-icon24 flexVerticalAlignParent\">\n                                    <span class=\"icon-calendar icon24\"></span>\n                                </button>\n                            </span>\n                        </div>\n                        <span ng-bind=\"vm.errors.startDate\" class=\"text-danger\"></span>\n                    </div>\n                    <div class=\"w238\">\n                        <div class=\"checkbox c-checkbox\">\n                            <label>\n                                <input type=\"checkbox\" ng-model=\"vm.checkboxes.endDate\"\n                                    ng-click=\"vm.errors.endDate = ''\" />\n                                <span class=\"fa fa-check\"></span>\n                                <ng-content translate=\"specify_end_date\"></ng-content>\n                            </label>\n                        </div>\n                        <div class=\"menu-schedule-date height40 width190\">\n                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"vm.schedule.endDate\"\n                                is-open=\"openedED\" ng-change=\"vm.errors.endDate = ''\"\n                                datepicker-options=\"vm.dateOptions\" close-text=\"{{::'close' | translate}}\"\n                                clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                                ng-readonly=\"!vm.checkboxes.endDate\" class=\"form-control\" />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\"\n                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedED = true;\"\n                                    ng-disabled=\"!vm.checkboxes.endDate\"\n                                    class=\"btn btn-default btn-icon24 flexVerticalAlignParent\">\n                                    <span class=\"icon-calendar icon24\"></span>\n                                </button>\n                            </span>\n                        </div>\n                        <span ng-bind=\"vm.errors.endDate\" class=\"text-danger\"></span>\n                    </div>\n                </div>\n                <div class=\"text-muted mb15\" ng-if=\"vm.schedule.startDate == null\">\n                    <span class=\"text-danger\">*</span>\n                    <span translate=\"required_dates_field\"></span>\n                </div>\n                <div class=\"d-flex\">\n                    <div class=\"w238\">\n                        <div class=\"checkbox c-checkbox\">\n                            <label>\n                                <input type=\"checkbox\" ng-model=\"vm.checkboxes.startTime\"\n                                    ng-click=\"vm.errors.startTime = ''\" />\n                                <span class=\"fa fa-check\"></span>\n                                <ng-content translate=\"daily_start_time\"></ng-content>\n                            </label>\n                        </div>\n                        <div class=\"menu-schedule-time\" uib-timepicker ng-change=\"vm.errors.startTime = ''\"\n                            ng-model=\"vm.schedule.startTime\" ng-disabled=\"!vm.checkboxes.startTime\"\n                            show-meridian=\"true\"></div>\n                        <span ng-bind=\"vm.errors.startTime\" class=\"text-danger\"></span>\n                    </div>\n                    <div class=\"w238\">\n                        <div class=\"checkbox c-checkbox\">\n                            <label>\n                                <input type=\"checkbox\" ng-model=\"vm.checkboxes.endTime\"\n                                    ng-disabled=\"!vm.checkboxes.startTime\" ng-click=\"vm.errors.endTime = ''\" />\n                                <span class=\"fa fa-check\"></span>\n                                <ng-content translate=\"daily_end_time\"></ng-content>\n                            </label>\n                        </div>\n                        <div class=\"menu-schedule-time\" uib-timepicker ng-change=\"vm.errors.endTime = ''\"\n                            ng-disabled=\"!vm.checkboxes.endTime\" ng-model=\"vm.schedule.endTime\" show-meridian=\"true\">\n                        </div>\n                        <span ng-bind=\"vm.errors.endTime\" class=\"text-danger\"></span>\n                    </div>\n                </div>\n                <div>\n                    <div class=\"mb15\">\n                        <label class=\"control-label checkbox\">\n                            <ng-container translate=\"active_days\"></ng-container> *\n                        </label>\n                    </div>\n                    <div class=\"days-checkbox-wrapper\">\n                        <div class=\"checkbox c-checkbox days-checkbox mt0\" ng-repeat=\"d in vm.daysToTranslate\">\n                            <label>\n                                <input type=\"checkbox\" ng-model=\"vm.schedule.days[d]\" ng-change=\"vm.errors.days = ''\" />\n                                <span class=\"fa fa-check\"></span>\n                                <ng-content translate=\"{{ d }}\"></ng-content>\n                            </label>\n                        </div>\n                    </div>\n                    <span class=\"text-muted\" ng-if=\"!vm.schedule.anyDays()\">\n                        <span class=\"text-danger\">*</span>\n                        <span translate=\"required_days_field\"></span>\n                    </span>\n                    <span ng-bind=\"vm.errors.days\" class=\"text-danger\"></span>\n                </div>\n            </div>\n        </div>\n\n        <!-- MENU SUMMARY -->\n        <div uib-accordion-group is-open=\"true\">\n            <uib-accordion-heading>\n                <span translate=\"menu_summary\"></span>\n            </uib-accordion-heading>\n            <div class=\"menu-editor\">\n                <div class=\"row flex-input-container\">\n                    <div class=\"mr15\">\n                        <div ng-if=\"!vm.item.ImageID\" class=\"menu-editor-placeholder summary-placeholder\">\n                            <div class=\"bg-grey-placeholder icon-placeholder\"></div>\n                        </div>\n                        <img ng-if=\"vm.item.ImageID > 0\" ng-src=\"{{ vm.getImage(vm.item) }}\"\n                            class=\"menu-editor-placeholder\" />\n                    </div>\n                    <div class=\"col-10 menu-item\">\n                        <div class=\"menu-item-header\">\n                            <span ng-if=\"!vm.item.Name\" translate=\"untitled_menu\"></span>\n                            <span ng-if=\"vm.item.Name\">{{ vm.item.Name }}</span>\n                        </div>\n                        <div class=\"menu-item-status menu-item-element\">\n                            <div ng-if=\"vm.item.DisplayInApp\" class=\"menu-item-badge btn-success\" translate=\"active\">\n                            </div>\n                            <div ng-if=\"!vm.item.DisplayInApp\" class=\"menu-item-badge btn-yellow\" translate=\"draft\">\n                            </div>\n                        </div>\n                        <div>\n                            <div class=\"text-muted\" translate=\"schedule\"></div>\n                            <menu-schedule-render item=\"vm.schedule\"></menu-schedule-render>\n                        </div>\n                        <div class=\"menu-item-element\">\n                            <div ng-show=\"vm.item.Places.length > 0\">\n                                <span class=\"text-muted\" translate=\"locations\"></span>\n                                <div class=\"mb3\" ng-repeat=\"loc in vm.item.Places\">\n                                    {{ loc.Name + ', ' + loc.AddressLine1 + (location.AddressLine2 ? ' ' + location.AddressLine2 : '') + ', ' + loc.Town + ' ' + loc.PostCode }}\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </uib-accordion>\n    <div class=\"pull-right flex-input-container pt10\">\n        <button class=\"btn mr24 btn-sm btn-black height40 btn-icon24 flexVerticalAlignParent mt22\"\n            ng-if=\"!vm.item.IsArchived && vm.idParam && !vm.isDuplicating\" translate-attr-title=\"to_archive\"\n            ng-disabled=\"vm.waiting\" ng-click=\"vm.setArchivedMenu(true)\">\n            <span class=\"icon-trashcan-outline-white icon24\"></span>\n        </button>\n        <button class=\"btn mr8 btn-success height40 btn-with-icon flexVerticalAlignParent mt22\"\n            ng-disabled=\"vm.waiting || vm.errors.any() || !vm.isAllFilled()\" ng-click=\"vm.saveData()\">\n            <span class=\"plus-icon--tiny icon24 mr8\"></span>\n            <span translate=\"save\"></span>\n        </button>\n        <button class=\"btn btn-danger height40 btn-with-icon flexVerticalAlignParent mt22\" ng-disabled=\"vm.waiting\"\n            ng-click=\"vm.cancel()\">\n            <span class=\"close-icon-white--tiny icon24 mr8\"></span>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "<span ng-bind-html=\"vm.rendered\"></span>\n";

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"app-view-header tab-campaings mt-9 ng-scope menu-header\">\n        <div class=\"pull-left\">\n            <span class=\"mr25 fs-20\" ng-class=\"{ 'activefilter' : vm.isArchived }\" ng-click=\"vm.isArchived = false\">\n                <span translate=\"menus\"></span>\n            </span>\n            <span class=\"fs-20\" ng-class=\"{ 'activefilter' : !vm.isArchived }\" ng-click=\"vm.isArchived = true\">\n                <span translate=\"archived_menu\"></span>\n            </span>\n        </div>\n        <div class=\"pull-right\">\n            <button ng-show=\"!vm.isArchived\" ui-sref=\"app.create-menu\" class=\"btn btn-success add-btn mt22\">\n                <span class=\"plus-icon icon24 mr8\"></span> <span translate=\"add_menu\"></span>\n            </button>\n        </div>\n    </div>\n\n    <div ng-include=\"'enabledMenu'\">\n    </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"enabledMenu\">\n    <div class=\"menu-items-wrapper\" ng-if=\"vm.data.length > 0\">\n        <div class=\"col-md-4 menu-item-wrapper\" ng-repeat=\"item in vm.data\">\n            <menu-card item=\"item\" is-archived=\"vm.isArchived\"></menu-card>\n        </div>\n    </div>\n\n    <div class=\"absolute-center-flex flex-column selected-locations__empty-mes\" ng-if=\"vm.data.length === 0\">\n        <span class=\"icon-empty-list mb25\"></span>\n\n        <span class=\"text-center text-pre fs-20 mb5 color-black54\" ng-if=\"!vm.isArchived\" translate=\"no_menus_title\"></span>\n        <span class=\"text-center text-pre fs-20 mb5 color-black54\" ng-if=\"vm.isArchived\" translate=\"no_menus_archived_title\"></span>\n\n        <span class=\"text-center text-pre color-black54\" ng-if=\"!vm.isArchived\" translate=\"no_menus_subtitle\"></span>\n        <span class=\"text-center text-pre color-black54\" ng-if=\"vm.isArchived\" translate=\"no_menus_archived_subtitle\"></span>\n    </div>\n</script>\n";

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel mb24 p16 flexVerticalAlignParent\">\n<!--location-->\n    <button ng-click=\"ctrl.selectLocations()\"\n        class=\"btn apply-btn--purple apply-btn--transparent mr8 height40\"\n        translate=\"{{ctrl.model.selectedLocationsCount > 0 ? 'location_with_count' : 'location_without_count'}}  \"\n        translate-value-count=\"{{ctrl.model.selectedLocationsCount}}\">\n    </button>\n<!--type-->\n    <div uib-dropdown class=\"input-group-btn width175 mr8\">\n        <button type=\"button\" uib-dropdown-toggle\n                class=\"btn btn-default dropdown-toggle text-left fw flexVerticalAlignParent apply-btn--transparent height40\"\n                aria-haspopup=\"true\"\n                aria-expanded=\"false\"\n                ng-class=\"{'apply-btn--D8D6DA': !ctrl.model.stickerType ,'apply-btn--purple': ctrl.model.stickerType }\">\n            <span ng-hide=\"ctrl.model.stickerType\" class=\"text-black38\" translate=\"tab_active_filter_type\"></span>\n            <span class=\"text-primary\" ng-show=\"ctrl.model.stickerType\">{{(ctrl.stickerTypes[ctrl.model.stickerType])}}</span>\n            <span class=\"caret ml-auto\" ng-class=\"{'color-black38': !ctrl.model.stickerType ,'text-primary': ctrl.model.stickerType }\"></span>\n        </button>\n        <ul class=\"dropdown-menu\">\n            <li ng-repeat=\"(id, typeName) in ctrl.stickerTypes\" ng-click=\"ctrl.model.stickerType = id\">\n                <a href=\"#\">{{typeName}}</a>\n            </li>\n        </ul>\n    </div>\n<!--date from-->\n    <div class=\"input-group wrapRelative datepicker--transparent width175\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.model.dateFrom\"\n               ng-change=\"ctrl.dateFromChange()\"\n               datepicker-options=\"ctrl.dateOptions\"\n               placeholder=\"dd mm yyyy\"\n               is-open=\"ctrl.openedStartDate\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               class=\"form-control\"\n               readonly />\n        <span class=\"input-group-btn\">\n            <button type=\"button\"\n                    ng-disabled=\"ctrl.waiting\"\n                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedStartDate = true;\"\n                    class=\"btn btn-default p0 \">\n                <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n            </button>\n        </span>\n    </div>\n    <div class=\"dash\"></div>\n<!--    date to-->\n    <div class=\"input-group wrapRelative datepicker--transparent width175\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.model.dateTo\"\n               ng-change=\"ctrl.dateToChange()\"\n               datepicker-options=\"{ minDate: ctrl.model.dateFrom }\"\n               is-open=\"ctrl.openedEndDate\"\n               placeholder=\"dd mm yyyy\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               class=\"form-control\"\n               readonly />\n        <span class=\"input-group-btn\">\n            <button type=\"button\"\n                    ng-disabled=\"ctrl.waiting\"\n                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedEndDate = true;\"\n                    class=\"btn btn-default p0\">\n                <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n            </button>\n        </span>\n    </div>\n    <div class=\"ml-auto flexVerticalAlignParent\">\n    <!--    Clear all filter-->\n    <button ng-click=\"ctrl.onAllClear()\" class=\"btn btn-with-icon apply-btn--purple apply-btn--transparent height40 mr8\"> <em class=\"fa fa-close\"></em>Clear all</button>\n<!--    Apply button-->\n    <button ng-click=\"ctrl.onFilterApply()\" class=\"btn btn-primary height40\">Apply</button>\n</div>\n</div>\n";

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flexVerticalAlignParent mb16\">\n    <div class=\"posRel searchInput flex-stretch max-w270 mr8\">\n        <input type=\"text\"\n               maxlength=\"25\"\n               translate translate-attr-placeholder=\"search_by_product_name_or_sticker_id\"\n               class=\"form-control top-panel-input\"\n               ng-model=\"ctrl.search.text\"\n               ng-keydown=\"$event.keyCode === 13 && ctrl.applySearch()\"/>\n        <span class=\"fa fa-search\"></span>\n    </div>\n    <button class=\"btn btn-primary\" ng-click=\"ctrl.applySearch()\">Search</button>\n    <div>\n        <button ng-click=\"ctrl.toggleFilter()\" class=\"btn btn-primary height37 w40 p8 ml8\" ng-class=\"ctrl.filter.isApplied ? 'btn-danger' : 'btn-primary' \">\n            <span ng-if=\"!ctrl.filter.isApplied\" class=\"icon-filter--white icon24 inline-block\"></span>\n            <span ng-if=\"ctrl.filter.isApplied\" class=\"icon-remove-filter--white icon24 inline-block\"></span>\n        </button>\n    </div>\n\n    <div class=\"ml-auto flexVerticalAlignParent\">\n        <span><span class=\"fw-500\" translate=\"free_stickers_label\"></span> {{ctrl.freeStickersCount}}</span>\n        <a ui-sref=\"app.nfc.wizard\" ng-if =\"ctrl.freeStickersCount > 0\">\n            <button class=\"btn btn-success btn-with-icon flexVerticalAlignParent ml20\"  >\n                <span class=\"plus-icon icon24 mr8\"></span>\n                <span translate=\"assign_new_stickers_button\"></span>\n            </button>\n        </a>\n        <a ng-if =\"ctrl.freeStickersCount === 0\">\n                <button class=\"btn btn-success btn-with-icon flexVerticalAlignParent ml20\" ng-disabled=\"true\" >\n                    <span class=\"plus-icon icon24 mr8\"></span>\n                    <span translate=\"assign_new_stickers_button\"></span>\n                </button>\n         </a>\n    </div>\n</div>\n\n<div ng-if=\"ctrl.filter.isActive\" class=\"h96\">\n    <active-stickers-filter\n        sticky sticky-class=\"panel--sticky\"\n        filter-model=\"ctrl.filter.data\"\n        on-apply=\"ctrl.applyFilter(filter)\"\n        on-all-clear=\"ctrl.clearFilter()\">\n    </active-stickers-filter>\n</div>\n\n<!-- table -->\n<div>\n    <div class=\"panel mb-50\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <div class=\"tableTags ml0 mr0 mt0\" ng-infinite-scroll load-more=\"ctrl.loadData()\">\n                    <table class=\"tableTags ml0 mr0 mt0 table-white basic-table basic-table--no-hover\">\n                        <thead>\n                            <tr class=\"tableTagsHeader\">\n                                <th class=\"pl16 pt14 pb14\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_location\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_product_name\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_type\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_sticker_number\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_date\"></span>\n                                    </div>\n                                </th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"sticker in ctrl.items\">\n                                <td class=\"pl16 pt14 pb14\">\n                                    <div class=\"inner\" ng-class=\"{'inactiveStore' : sticker.PlaceArchived}\">\n                                        <span>{{::sticker.PlaceName}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span>{{::sticker.EntityName}}</span>\n                                    </div>\n\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span>\n                                            {{::ctrl.stickerTypes[sticker.NfcStickerType]}}\n                                        </span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span>{{::sticker.ID}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16\">\n                                    <div class=\"inner\">\n                                        <span>{{::sticker.AssignedDate | date:'dd.MM.yyyy'}}</span>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<empty-list-state class=\"empty-list-center-position absolute-center-flex\"\n                  ng-if=\"ctrl.items.length === 0\"\n                  title-message = \"ctrl.emptyStickerMessageTitle\"\n                  message=\"ctrl.emptyStickerMessage\"\n                  ng-style=\"{ 'height': (ctrl.viewport.height) - 225 + 'px'}\">\n</empty-list-state>\n";

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" translate=\"add_deleted_sticker_dialog_title\"></h4>\n</div>\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.form\">\n        <div class=\"form-group mb5 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"add_deleted_sticker_dialog_sticker_label\"></label>\n            <input type=\"text\" name=\"stickerID\" ng-model=\"ctrl.stickerNumber\"\n                ng-model-options=\"{ updateOn: 'submit blur default', debounce: { submit: 0, blur: 0,  default: 0 } }\"\n                translate translate-attr-placeholder=\"add_deleted_sticker_dialog_sticker_label\" required class=\"form-control\" />\n            <div ng-show=\"ctrl.form.stickerID.$dirty && ctrl.form.stickerID.$error.required\"\n                 class=\"text-danger\"\n                 translate=\"the_field_is_required\"></div>\n            <div ng-show=\"ctrl.form.stickerID.$dirty && ctrl.form.stickerID.$error.stickerID\"\n                 class=\"text-danger\"\n                 translate=\"invalid_field_format\"></div>\n        </div>\n    </form>\n</div>\n<!--  || ctrl.form.$pristine -->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"button_cancel\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.delete()\"\n            ng-disabled=\"ctrl.waiting || ctrl.form.$invalid\"\n            class=\"btn btn-success  btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"add_deleted_sticker_dialog_ok\"></span>\n        </button>\n    </div>\n</div>\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flexVerticalAlignParent mb16\">\n    <div class=\"posRel searchInput flex-stretch max-w270 mr8\">\n        <input type=\"text\"\n               maxlength=\"25\"\n               translate\n               translate-attr-placeholder=\"search_by_sticker_id\"\n               class=\"form-control top-panel-input\"\n               ng-model=\"ctrl.filter\"\n               ng-keydown=\"$event.keyCode === 13 && ctrl.applyFilter()\" />\n        <span class=\"fa fa-search\"></span>\n    </div>\n    <button class=\"btn btn-primary\" ng-click=\"ctrl.applyFilter()\">Search</button>\n\n    <button class=\"btn btn-success btn-with-icon flexVerticalAlignParent ml-auto\" ng-click=\"ctrl.addDeletedSticker()\">\n        <span class=\"plus-icon icon24 mr8\"></span>\n        <span translate=\"add_deleted_sticker_label\"></span>\n    </button>\n</div>\n\n\n<!-- table -->\n<div>\n    <div class=\"panel mb-50\">\n        <div class=\"panel-body p0\">\n            <div class=\"tags-panel\">\n                <div class=\"tableTags ml0 mr0 mt0\" ng-infinite-scroll load-more=\"ctrl.loadData()\">\n                    <table class=\"tableTags ml0 mr0 mt0 table-white basic-table basic-table--no-hover\">\n                        <thead>\n                            <tr class=\"tableTagsHeader\">\n                                <th class=\"pl16 pt14 pb14\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_sticker_number\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16 pr30\">\n                                    <div class=\"inner\">\n                                        <span translate=\"column_date\"></span>\n                                    </div>\n                                </th>\n                                <th class=\"pl16 pr30\">\n                                    <div class=\"inner\">\n                                        <span translate=\"\"></span>\n                                    </div>\n                                </th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr ng-repeat=\"sticker in ctrl.items\">\n                                <td class=\"pl16 pt14 pb14\">\n                                    <div class=\"inner\">\n                                        <span>{{::sticker.ID}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16 width1 pr30\">\n                                    <div class=\"inner\">\n                                        <span>{{:: sticker.DeleteDate | date:'dd.MM.yyyy'}}</span>\n                                    </div>\n                                </td>\n                                <td class=\"pl16 width1 pr30\">\n                                    <div class=\"inner\">\n                                        <button ng-click=\"ctrl.restoreSticker(sticker)\" class=\"btn-white--transparent\">\n                                            <span class=\"icon-restore-clock inline-block icon24\"></span>\n                                        </button>\n                                    </div>\n                                </td>\n                            </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<empty-list-state class=\"empty-list-center-position absolute-center-flex\"\n                  ng-if=\"ctrl.items.length === 0\"\n                  message=\"ctrl.noDeletedStickersMessage\"\n                  ng-style=\"{ 'height': (ctrl.viewport.height) - 225 + 'px'}\">\n</empty-list-state>\n";

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header rounded-top-8 gray-header\">\n    <h4 class=\"modal-title\" translate=\"nfc_export_title\">\n    </h4>\n</div>\n<div class=\"modal-body--redesign export-csv\">\n    <form name=\"ctrl.form\">\n        <div class=\"flexVerticalAlignParent pb16\">\n            <!-- assigned from -->\n            <div class=\"posRel mr25\">\n                <label class=\"fw-500\">\n                    <span translate=\"nfc_export_date_from\"></span>\n                </label>\n                <div class=\"input-group wrapRelative datepicker--transparent width175\">\n                    <input type=\"text\"\n                           uib-datepicker-popup=\"dd MMMM yyyy\"\n                           ng-model=\"ctrl.model.dateFrom\"\n                           ng-change=\"ctrl.dateFromChange()\"\n                           datepicker-options=\"ctrl.dateFromOptions\"\n                           is-open=\"ctrl.openedStartDate\"\n                           close-text=\"{{::'close' | translate}}\"\n                           clear-text=\"{{::'clear' | translate}}\"\n                           current-text=\"{{::'today' | translate}}\"\n                           class=\"form-control\" readonly />\n                    <span class=\"input-group-btn pr5\">\n                        <button type=\"button\" ng-disabled=\"ctrl.waiting\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedStartDate = true;\"\n                            class=\"btn btn-default p0 pt7 lh1\">\n                            <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n            <!-- assigned to -->\n            <div class=\"posRel\">\n                <label class=\"fw-500\">\n                    <span translate=\"nfc_export_date_to\"></span>\n                </label>\n                <div class=\"input-group wrapRelative datepicker--transparent width175\">\n                    <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\"\n                           ng-model=\"ctrl.model.dateTo\"\n                           ng-change=\"ctrl.dateToChange()\"\n                           datepicker-options=\"ctrl.dateToOptions\"\n                           is-open=\"ctrl.openedEndDate\"\n                           close-text=\"{{::'close' | translate}}\"\n                           clear-text=\"{{::'clear' | translate}}\"\n                           current-text=\"{{::'today' | translate}}\"\n                           class=\"form-control\" readonly />\n                    <span class=\"input-group-btn pr5\">\n                        <button type=\"button\" ng-disabled=\"ctrl.waiting\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedEndDate = true;\"\n                            class=\"btn btn-default p0 pt7 lh1\">\n                            <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n        </div>\n        <!-- stores -->\n        <div class=\"form-group mb5\">\n            <label class=\"fw-500\">\n                <span translate=\"nfc_export_type_title\"></span>\n            </label>\n            <div uib-dropdown class=\"input-group-btn width175 dropdown--in-modal\">\n                <button type=\"button\" uib-dropdown-toggle\n                        class=\"btn btn-default dropdown-toggle text-left fw flexVerticalAlignParent\" aria-haspopup=\"true\"\n                        aria-expanded=\"false\">\n                    <span ng-hide=\"ctrl.model.stickerType\" translate=\"nfc_export_empty_type_title\"></span>\n                    <span class=\"text-gray-dark\" ng-show=\"ctrl.model.stickerType\">{{ctrl.model.stickerType.Title}}</span>\n                    <span class=\"caret ml-auto\"></span>\n                </button>\n                <ul class=\"dropdown-menu\">\n                    <li ng-repeat=\"option in ctrl.nfcStickerOptions\"\n                        ng-click=\"ctrl.model.stickerType = option\">\n                        <a href=\"#\">{{option.Title}}</a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <!-- category -->\n        <div class=\"form-group mb20\">\n            <label class=\"fw-500\">\n                <span translate=\"nfc_export_select_category_title\"></span>\n            </label><br>\n            <div class=\"export-csv__categories mb8\">\n                <span ng-repeat=\"category in ctrl.model.selectedCategories\">\n                    {{::category.CategoryFullName}}\n                </span>\n            </div>\n            <button class=\"btn apply-btn--transparent apply-btn--purple\"\n                    ng-click=\"ctrl.selectCategory()\" ng-disabled=\"ctrl.isCategoryButtonDisabled\">\n                <span translate=\"nfc_export_select_category_button\"></span>\n            </button>\n        </div>\n        <!-- group -->\n        <div class=\"form-group mb5\">\n            <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox--black ml0 mr0 mt0 mb24 flexVerticalAlignParent\">\n                <label class=\"pl18 control-label\">\n                    <input type=\"checkbox\"\n                           ng-checked=\"ctrl.model.groupByLocations\"\n                           ng-model=\"ctrl.model.groupByLocations\">\n                    <span class=\"fa fa-check mr15\"></span>\n                    <b>{{:: 'nfc_export_group_by' | translate }}</b>\n                </label>\n            </div>\n        </div>\n    </form>\n</div>\n\n<div class=\"modal-footer--redesign dark-gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.confirm()\"\n            ng-disabled=\"ctrl.waiting\"\n            class=\"btn btn-success  btn-with-icon mr8\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"nfc_export_add_button\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn btn-danger btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"nfc_export_discard_button\"></span>\n        </button>\n    </div>\n</div>\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel mb8\">\n    <div class=\"panel-body\">\n        <div class=\"flexVerticalAlignParent mb20\">\n            <div class=\"wrap\">\n                <span class=\"label label-default\" ng-if=\"ctrl.status===1\"\n                    translate=\"nfc_history_item_status_enqueued\"></span>\n                <span class=\"label label-info\" ng-if=\"ctrl.status===2\"\n                    translate=\"nfc_history_item_status_processing\"></span>\n                <span class=\"label label-success\" ng-if=\"ctrl.status===3\"\n                    translate=\"nfc_history_item_status_export\"></span>\n            </div>\n            <div class=\"ml-auto\">\n                <span class=\"color-black54\" ng-bind=\"::ctrl.date | date:'dd.MM.yyyy' \"></span>\n            </div>\n        </div>\n        <table>\n            <tr>\n                <td>\n                    <span class=\"fw-500 pr90\" ng-if=\"ctrl.status == 1\" translate=\"nfc_export_enqueued_description\"></span>\n                    <span class=\"fw-500 pr90\" ng-if=\"ctrl.status == 2\" translate=\"nfc_export_processing_description\"></span>\n                    <span class=\"fw-500 pr90\" ng-if=\"ctrl.status == 3\" translate=\"items_exported\"></span>\n                </td>\n                <td></td>\n            </tr>\n            <tr>\n                <td><span ng-if=\"ctrl.status == 3\" ng-bind=\"::ctrl.items\"></span></td>\n            </tr>\n        </table>\n        <div class=\"ml-15 mr-15\" ng-if=\"ctrl.exportResult.length>1\" >\n            <div ng-repeat=\"file in ctrl.exportResult\">\n                <a ng-if=\"!file.NoData\" class=\"flexVerticalAlignParent text-primary p16 bt clickable\" ng-href=\"{{::file.Url}}\" >\n                    <span class=\"icon-csv--purple icon24 mr-10\"></span>\n                    <span ng-bind=\"file.Name\"></span>\n                </a>\n                <div class=\"export-error flexVerticalAlignParent pl16 pr16 pt8 pb8 bt\" ng-if=\"file.NoData\">\n                    <span class=\"icon-error-rounded--fill-red icon24 mr8\"></span>\n                    <span>\n                        <span class=\"export-error__file-name\" ng-bind=\"file.Name\" ></span><br>\n                        <span class=\"export-error__message\" translate=\"nfcStickers_export_report_no_data\"></span>\n                    </span>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"ml-15 mr-15\" ng-if=\"ctrl.exportResult.length === 1\">\n            <div ng-if=\"!ctrl.exportResult[0].NoData\">\n                <a class=\"flexVerticalAlignParent text-primary p16 bt clickable\" ng-href=\"{{::ctrl.exportResult[0].Url}}\">\n                    <span class=\"icon-csv--purple icon24 mr-10\"></span>\n                    <span translate=\"nfcStickers_export_report_ready\"></span>\n                </a>\n            </div>\n            <div ng-if=\"ctrl.exportResult[0].NoData\" class=\"flexVerticalAlignParent pl16 pt16 pr16 pb0 bt export-error\">\n                <span class=\"icon-error-rounded--fill-red icon24 mr8\"></span>\n                <span class=\"export-error__message\" translate=\"nfcStickers_export_report_no_data\"></span>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel mb8\">\n    <div class=\"panel-body\">\n        <div class=\"flexVerticalAlignParent mb20\">\n            <div class=\"wrap\">\n                <span class=\"label label-default\" ng-if=\"ctrl.status===1\"\n                    translate=\"nfc_history_item_status_enqueued\"></span>\n                <span class=\"label label-info\" ng-if=\"ctrl.status===2\"\n                      translate=\"nfc_history_item_status_processing\"></span>\n                <span class=\"label label-success\" ng-if=\"ctrl.status===3\"\n                      translate=\"nfc_history_item_status_assigned\"></span>\n                <span class=\"label label-warning\" ng-if=\"ctrl.status===4\"\n                      translate=\"nfc_history_item_status_not_enough_stickers\"></span>\n            </div>\n            <div class=\"ml-auto\">\n                <span class=\"color-black54\" ng-bind=\"::ctrl.date | date:'dd.MM.yyyy' \"></span>\n            </div>\n        </div>\n        <table class=\"fw\">\n            <tr>\n                <td class=\"width1 text-nowrap\"><span class=\"fw-500 pr90\" translate=\"nfc_history_item_stores_label\"></span></td>\n                <td class=\"width1 text-nowrap\"><span class=\"fw-500 pr90\" translate=\"nfc_history_item_items_label\"></span></td>\n                <td class=\"width1 text-nowrap\"><span class=\"fw-500\" ng-hide=\"ctrl.status === 1\" translate=\"nfc_history_item_assigned_label\"></span></td>\n                <td class=\"text-right\" rowspan=\"2\">\n                        <span ng-if=\"ctrl.status === 4\" class=\"color-red\"\n                              translate=\"nfc_history_item_not_enough_error\"\n                              translate-value-count=\"{{ctrl.items-ctrl.assigned}}\" >\n                    </span>\n                    </td>\n            </tr>\n            <tr>\n                <td class=\"width1 text-nowrap\"><span ng-bind=\"::ctrl.stores\"></span></td>\n                <td class=\"width1 text-nowrap\"><span ng-bind=\"::ctrl.items\"></span></td>\n                <td class=\"width1 text-nowrap\">\n                    <span ng-hide=\"ctrl.status === 1\" translate=\"nfc_history_item_assigned_value_label\"\n                          translate-value-count=\"{{ctrl.assigned}}\"\n                          translate-interpolation=\"messageformat\">\n                    </span>\n                </td>\n\n            </tr>\n        </table>\n    </div>\n</div>\n";

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flexVerticalAlignParent mb16\">\n    <div class=\"input-group wrapRelative datepicker--transparent width163\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.filter.from\"\n               datepicker-options=\"ctrl.dateFromOptions\"\n               is-open=\"ctrl.openedStartDate\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               ng-change=\"ctrl.dateFromChange()\"\n               class=\"form-control\"\n               readonly />\n        <span class=\"input-group-btn pr5\">\n            <button type=\"button\" ng-disabled=\"ctrl.waiting\"\n                ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedStartDate = true;\"\n                class=\"btn btn-default p0 pt7 lh1\">\n                <span class=\"icon-date icon24 inline-block opacity38\"></span>\n            </button>\n        </span>\n    </div>\n    <div class=\"dash\"></div>\n    <div class=\"input-group wrapRelative datepicker--transparent width163\">\n        <input type=\"text\"\n               uib-datepicker-popup=\"dd MMMM yyyy\"\n               ng-model=\"ctrl.filter.to\"\n               datepicker-options=\"ctrl.dateToOptions\"\n               is-open=\"ctrl.openedEndDate\"\n               close-text=\"{{::'close' | translate}}\"\n               clear-text=\"{{::'clear' | translate}}\"\n               current-text=\"{{::'today' | translate}}\"\n               ng-change=\"ctrl.dateToChange()\"\n               class=\"form-control\"\n            readonly />\n        <span class=\"input-group-btn pr5\">\n            <button type=\"button\" ng-disabled=\"ctrl.waiting\"\n                ng-click=\"$event.preventDefault(); $event.stopPropagation(); ctrl.openedEndDate = true;\"\n                class=\"btn btn-default p0 pt7 lh1\">\n                <span class=\"icon-date icon24 inline-block opacity38\"></span>\n            </button>\n        </span>\n    </div>\n\n</div>\n\n\n<div ng-repeat=\"item in ctrl.items\">\n    <nfc-history-item ng-if=\"item.Kind !== 3\"\n        status=\"item.State\"\n        stores=\"item.PlacesCount\"\n        items=\"item.ItemsCount\"\n        assigned=\"item.AssignedCount\"\n        date=\"item.Date\">\n    </nfc-history-item>\n\n    <nfc-history-export-item ng-if=\"item.Kind === 3\"\n        operation-id=\"item.ID\"\n        status=\"item.State\"\n        items=\"item.ItemsCount\"\n        date=\"item.Date\"\n        export-result=\"item.ExportResult\">\n    </nfc-history-export-item>\n</div>\n\n<empty-list-state class=\"empty-list-center-position absolute-center-flex\"\n                  ng-if=\"ctrl.items.length === 0\"\n                  message=\"ctrl.noHistoryItemsMessage\"\n                  ng-style=\"{ 'height': (ctrl.viewport.height) - 225 + 'px'}\">\n</empty-list-state>\n";

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "<div class=\"chips flexVerticalAlignParent flex-wrap mb8\">\n    <div class=\"chips__item\" ng-repeat=\"item in ctrl.items\">\n        <span>{{::item[ctrl.displayField]}}</span>\n        <span class=\"close-icon--tiny icon18\" ng-click=\"!ctrl.isDisabled && ctrl.onClick({item: item })\"></span>\n    </div>\n</div>\n";

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<!-- header -->\n<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"ctrl.confirm()\" ng-disabled=\"!ctrl.total\" class=\"btn btn-success btn-with-icon pl40 pr40\">\n                <span ng-bind=\"ctrl.model.addButtonText\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"ctrl.dismiss()\" class=\"btn btn-danger btn-with-icon\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\" translate=\"add_store_title\"></div>\n</div>\n\n<!-- body -->\n<div class=\"modal-body panel-campaign-choice store-search pl15 pr15 wizard__selected-modal\">\n    <!-- search -->\n    <div  class=\"mb10 mt10\">\n        <search placeholder-text=\"ctrl.$translate.instant('search_for_store')\"\n                text=\"ctrl.model.searchTerm\"\n                classes=\"'white-theme'\"\n                disabled=\"ctrl.model.waiting || ctrl.model.isAllSelected\"\n                on-search-click=\"ctrl.search(searchText)\"\n                on-clear-click=\"ctrl.resetSearch()\">\n        </search>\n    </div>\n\n    <div ng-show=\"ctrl.total\" class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt20 ml-10 mr-20 mb5 pl10 pb20 flexVerticalAlignParent bordered--bottom\">\n        <label class=\"pl20\">\n            <input type=\"checkbox\" ng-model=\"ctrl.model.isAllSelected\" ng-change=\"ctrl.setAddButtonText()\" ng-disabled=\"ctrl.waiting || !ctrl.canSelectAll\">\n            <span class=\"fa fa-check mr15\"></span>\n            {{::'button_select_all' | translate}}\n        </label>\n    </div>\n    <div when-scrolled=\"ctrl.loadLocations()\" class=\"product-search__wrap\">\n        <table class=\"fw store-search__table\">\n            <tbody>\n                <tr ng-repeat=\"location in ctrl.model.locations\" class=\"clickable\"\n                    ng-click=\"ctrl.setAddButtonText()\"\n                    ng-class=\"{ 'active': location.IsSelected }\">\n                    <td class=\"pb10 pt10\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox m0\">\n                            <label for=\"checkbox_{{::location.ID}}\" class=\"pl20 d-flex fs-14 wordBreakAll\">\n                                <input id=\"checkbox_{{::location.ID}}\"\n                                    ng-checked=\"location.IsSelected\" type=\"checkbox\"\n                                    ng-disabled=\"ctrl.model.waiting || ctrl.model.isAllSelected\"\n                                    ng-model=\"location.IsSelected\" />\n                                <span class=\"fa fa-check mr10 p7\"></span>\n                                <div class=\"w538 text-oneline\">\n                                    {{ (!ctrl.resolve.options.fullName ? (location.Name+', '+location.Address) :\n                                            (location.Name + ', ' +\n                                            location.AddressLine1 +\n                                            (location.AddressLine2 ? ' ' + location.AddressLine2 : '') + ', ' +\n                                            location.Town + ' ' +\n                                            location.PostCode)\n                                    ) }}\n                                </div>\n                            </label>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n        <empty-list-state class=\"empty-location\"\n                          ng-if=\"ctrl.model.locations.length === 0 && !ctrl.model.waiting\"\n                          title-message=\"'location_not_found_title' | translate\"\n                          message=\"ctrl.model.noLocationMessage\"\n                          image-class=\"'icon-empty-list-search'\">\n        </empty-list-state>\n    </div>\n</div>\n";

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <div ng-if=\"ctrl.needAllSelect\" class=\"pull-left styleRadioCheckboxWrap checkbox c-checkbox width87 mt8\">\n                <label>\n                    <input type=\"checkbox\" ng-model=\"ctrl.isAllSelected\" ng-checked=\"ctrl.isAllSelected\" />\n                    <span class=\"fa fa-check\"></span>\n                    <ng-container translate=\"nfc_export_select_all\"></ng-container>\n                </label>\n            </div>\n            <button type=\"button\" ng-click=\"ctrl.select()\" ng-disabled=\"ctrl.waiting || ctrl.isPristine()\"\n                class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"save_selection\"></span>\n            </button>\n            <button type=\"button\" ng-disabled=\"ctrl.waiting\" ng-click=\"ctrl.discard()\"\n                class=\"btn btn-danger btn-with-icon\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"cancel\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"flexVerticalAlignParent\">\n        <span class=\"icon-arrow-left icon24 opacity54 mr10\"></span>\n        <div class=\"btn-form modal-title\" translate=\"select_product_category\"></div>\n    </div>\n\n</div>\n<div class=\"modal-body classification-categories p0\">\n    <div class=\"pr24 pl24 pt10 pb10\">\n        <h2 ng-if=\"!ctrl.isAllSelected\" class=\"mb14 color-black38\">\n            <span translate=\"selected_categories_count\"\n                translate-value-count=\"{{ctrl.resolve.options.selectedCategories.length}}\"\n                translate-interpolation=\"messageformat\">\n            </span>\n        </h2>\n        <h2 ng-if=\"ctrl.isAllSelected\" class=\"mb14 color-black38\">\n            <span translate=\"selected_all_categories\"></span>\n        </h2>\n        <chips items=\"ctrl.resolve.options.selectedCategories\" is-disabled=\"ctrl.needAllSelect && ctrl.isAllSelected\"\n            display-field=\"'CategoryFullName'\" on-click=\"ctrl.deleteChips(item)\" class=\"bb\">\n        </chips>\n        <select-product-classification-categories is-disabled=\"ctrl.needAllSelect && ctrl.isAllSelected\"\n            selected-categories=\"ctrl.resolve.options.selectedCategories\" single-select=\"false\"\n            business-type=\"ctrl.resolve.options.businessType\" change-category=\"ctrl.changeClassificationCategory(item)\"\n            external-confirm=\"true\" errors=\"classificationCategoriesErrors\" waiting=\"ctrl.waiting\" hide-titles=\"true\" language-id=\"ctrl.resolve.languageId\">\n        </select-product-classification-categories>\n    </div>\n</div>\n\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "<h2 translate=\"category_classification_title\" ng-hide=\"vm.singleSelect || vm.hideTitles\" class=\"classification-categories__heading\"></h2>\n<!-- <div>vm.categories</div> -->\n<div ng-show=\"vm.isShowAll\">\n    <div class=\"flexVerticalAlignParent flex-wrap mb24 pt25 bt classification-categories__root\">\n        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded clearfix wd-sd\" ng-repeat=\"category in vm.categories\">\n            <label for=\"checkbox{{category.ID}}\" title=\"{{category.Name}}\">\n                <input id=\"checkbox{{category.ID}}\" ng-change=\"vm.selectedCategory(category)\" ng-disabled=\"vm.waiting || vm.isDisabled\"\n                       ng-model=\"category.selected\" type=\"checkbox\" />\n                <span class=\"fa fa-check\"></span>\n                {{category.Name}}\n            </label>\n        </div>\n    </div>\n</div>\n\n<div ng-hide=\"vm.isShowAll && !vm.isRootSelected()\">\n\n    <div class=\"flex-align-start flex-wrap classification-categories__subcategories\" ng-repeat=\"category in vm.categories | filter:{ selected: true, hide: false }\">\n        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded wd-sd\" ng-repeat=\"subCategory in category.Subcategories | filter:{ hide: false } \">\n            <label for=\"checkbox{{subCategory.ID}}\" title=\"{{subCategory.Name}}\">\n                <input id=\"checkbox{{subCategory.ID}}\"\n                       ng-change=\"vm.selectedCategory(subCategory)\"\n                       ng-disabled=\"vm.waiting || vm.isDisabled\"\n                       ng-model=\"subCategory.selected\"\n                       type=\"checkbox\" />\n                <span class=\"fa fa-check\"></span>\n                {{subCategory.Name}}\n            </label>\n        </div>\n    </div>\n\n    <div ng-show=\"vm.isLivel3Exist\" class=\"sellCategories\">\n        <h2 translate=\"what_product_categories_do_you_sell\" ng-hide=\"vm.singleSelect || vm.hideTitles\" class=\"classification-categories__heading\"></h2>\n        <div ng-repeat=\"category in vm.categories\">\n            <div ng-if=\"subcategory.Subcategories.length > 0\" class=\"sellCategoriesLine\" ng-repeat=\"subcategory in category.Subcategories | filter:{ selected: true, hide: false }\" ng-class=\"{'classification-categories__livecategory' : subcategory.emulateLiveCategory}\">\n                <h3 ng-bind=\"subcategory.Name\" class=\"classification-categories__subtitle\"></h3>\n                <div class=\"clearfix\">\n                    <div ng-repeat=\"livecategory in subcategory.Subcategories | filter:{ hide: false }\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\">\n                            <label for=\"checkbox{{subcategory.ID}}_{{livecategory.ID}}\" title=\"{{livecategory.Name}}\">\n                                <input type=\"checkbox\" id=\"checkbox{{subcategory.ID}}_{{livecategory.ID}}\"\n                                       ng-disabled=\"vm.waiting || vm.isDisabled\"\n                                       ng-change=\"vm.selectedCategory(livecategory)\"\n                                       ng-model=\"livecategory.selected\" />\n                                <span class=\"fa fa-check\"></span>\n                                <i class=\"inner\">\n                                    <img class=\"showCheck\" ng-src=\"{{livecategory.logoPurple}}\" width=\"50\" height=\"50\" />\n                                    <img class=\"hideCheck\" ng-src=\"{{livecategory.logoWhite}}\" width=\"50\" height=\"50\" />\n                                    <em class=\"text\">{{livecategory.Name}}</em>\n                                </i>\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div ng-if=\"!vm.isShowAll && !vm.isCategorySelected()\">\n            <span translate=\"classification_categories_not_selected\">\n                Please choose the main products and services above to select their categories.\n            </span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<!-- header -->\n<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"ctrl.confirm()\" ng-disabled=\"!ctrl.total\" class=\"btn btn-success btn-with-line\">\n                <em class=\"fa fa-check\"></em>\n                <span ng-bind=\"ctrl.model.addButtonText\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"ctrl.dismiss()\" class=\"btn btn-danger btn-with-line\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\" translate=\"add_product_title\"></div>\n</div>\n\n<!-- body -->\n<div class=\"modal-body panel-campaign-choice product-search pl15 pr15 wizard__selected-modal\">\n    <!-- search -->\n    <div class=\"posRel searchInput flex-input-container mb10 mt10\">\n        <input type=\"text\" class=\"form-control\"\n               ng-model=\"ctrl.model.searchTerm\"\n               ng-disabled=\"ctrl.model.isAllSelected\"\n               ng-keypress=\"ctrl.searchKeyPressed($event)\"\n               translate translate-attr-placeholder=\"search_for_product_name\">\n        <span class=\"fa fa-search\"></span>\n        <button type=\"button\"\n                ng-click=\"ctrl.search()\"\n                ng-disabled=\"ctrl.model.waiting || ctrl.model.isAllSelected\"\n                class=\"buttonMarg btn btn-primary ml5\"\n                translate=\"button_search\"></button>\n    </div>\n    <div ng-show=\"ctrl.total\" class=\"styleRadioCheckboxWrap checkbox c-checkbox ml0 mr0 mt20 ml-10 mr-20 mb5 pl10 pb20 flexVerticalAlignParent bordered--bottom\">\n        <label class=\"pl20\">\n            <input type=\"checkbox\" ng-model=\"ctrl.model.isAllSelected\" ng-change=\"ctrl.setAddButtonText()\">\n            <span class=\"fa fa-check mr15\"></span>\n            Select all\n        </label>\n    </div>\n    <div class=\"pl5 pr5 product-search__wrap\" when-scrolled=\"ctrl.loadProducts()\">\n        <table class=\"full-width product-search__table\">\n            <tbody>\n                <tr ng-repeat=\"product in ctrl.model.products\" class=\"clickable\"\n                    ng-click=\"ctrl.selectProduct(product)\"\n                    ng-class=\"{ 'active': product.IsSelected }\">\n                    <td class=\"wd-xxs pr10 pb10 pt10 pl15\" height=\"80px\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded m0\">\n                            <label for=\"checkbox_{{::product.ID}}\" class=\"pl20\">\n                                <input id=\"checkbox_{{::product.ID}}\"\n                                        ng-checked=\"product.IsSelected\"\n                                        type=\"checkbox\"\n                                        ng-disabled=\"ctrl.model.waiting || ctrl.model.isAllSelected\"/>\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                    </td>\n                    <td class=\"pr15 pb10 wd-xxs pt10 pl15 text-center\">\n                        <img ng-src=\"{{::product.ImageUrl}}\"/>\n                    </td>\n                    <td width=\"100%\" class=\"pr15 pb10 pt10 pl15\">\n                        <div>{{::product.Title}}</div>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n        <empty-list-state class=\"empty-list-center-position\"\n                          ng-if=\"ctrl.model.products.length === 0\"\n                          message=\"ctrl.model.noProductMessage\">\n        </empty-list-state>\n    </div>\n</div>\n";

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel mt8\" ng-show=\"ctrl.items.length\">\n    <h3 class=\"fw-500  fs-13 p16\">{{::ctrl.header}}</h3>\n    <div class=\"panel-body bordered--top p0\">\n        <div ng-repeat=\"item in ctrl.items\" class=\"flexVerticalAlignParent bordered--bottom p16\">\n            <span class=\"fs-14\">{{::item[ctrl.displayField]}}</span>\n            <button class=\"delete-btn ml-auto\" ng-click=\"ctrl.onDelete({item: item})\">\n                <span class=\"icon24 inline-block icon-trashcan-outline opacity16\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "<div class=\"flexVerticalAlignParent mb30\">\n    <h2 class=\"fs-23\" translate=\"nfc_tab_title\"></h2>\n<button class=\"btn btn-with-icon btn-primary ml-auto flexVerticalAlignParent\" ng-click=\"ctrl.export()\">\n    <span class=\"icon-export--white icon24 mr8\"></span>\n    <span translate=\"nfc_tab_export_button\"></span>\n</button>\n</div>\n\n\n<div class=\"tabs mb24\">\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\".active\" class=\"tabs__item mr8\">\n        <span translate=\"tab_active\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\".deleted\" class=\"tabs__item mr8\">\n        <span translate=\"nfc_tab_deleted\"></span>\n    </a>\n    <a ui-sref-active-eq=\"tabs__item--active\" ui-sref=\".history\" class=\"tabs__item\">\n        <span translate=\"nfc_tab_history\"></span>\n    </a>\n</div>\n\n<div ui-view></div>\n\n\n";

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\">\n        <span translate=\"nfc_wizard_discard_popup_title\"></span>\n    </h4>\n</div>\n<div class=\"modal-body--redesign\">\n        <span translate=\"all_selected_data_will_be_deleted\"></span><br>\n        <span translate=\"are_you_sure_want_to_continue\"></span>\n</div>\n\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\" ng-click=\"ctrl.delete()\" class=\"btn btn-success  btn-with-icon mr8\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"nfc_wizard_discard_popup_delete_button\"></span>\n        </button>\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn btn-danger btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"button_cancel\"></span>\n        </button>\n    </div>\n</div>\n<div ng-show=\"ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb9 \">\n    <a ui-sref=\"app.nfcs.active\" translate=\"nfc_assignment\"></a>\n    <span class=\"fa fa-angle-right\"></span>\n    <span ng-show=\"ctrl.model.assignNewStickers\" translate=\"assign_new_stickers\"></span>\n</div>\n\n\n<wizard-steps step=\"ctrl.model.step\"\n              next-button-disabled=\"ctrl.model.wizardNextStepButtonDisabled\"\n              on-assign=\"ctrl.createOperation()\"\n              on-discard=\"ctrl.resetAssign()\">\n</wizard-steps>\n<wizard-locations-step ng-if=\"ctrl.model.step === 1\"\n                       is-all-locations-selected=\"ctrl.model.isAllLocationsSelected\"\n                       selected-locations=\"ctrl.model.selectedLocations\">\n</wizard-locations-step>\n<wizard-products-step ng-if=\"ctrl.model.step === 2\"\n                      is-all-categories-selected=\"ctrl.model.isAllCategoriesSelected\"\n                      is-all-products-selected=\"ctrl.model.isAllProductsSelected\"\n                      selected-products-and-categories=\"ctrl.model.selectedProductsAndCategories\">\n</wizard-products-step>\n<wizard-assign-step ng-if=\"ctrl.model.step === 3\"\n                    assign-type = \"ctrl.model.assignType\"\n                    first-sticker-number=\"ctrl.model.firstStickerNumber\">\n</wizard-assign-step>\n";

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wizard__bottom mb8\">\n    <div class=\"fs-18 mb24\">\n        <span translate=\"nfc_wizard_assign_step_title\"></span>\n    </div>\n    <div class=\"mb16\">\n        <span translate=\"nfc_wizard_assign_step_message\"></span>\n    </div>\n\n\n        <label class=\"radio mr24\" for=\"assign-only-product\">\n            <input type=\"radio\"\n                   id=\"assign-only-product\"\n                   ng-model=\"ctrl.assignType\"\n                   name='group1'\n                   ng-value=\"1\"\n                   class=\"radio__input\">\n            <span class=\"radio__check\"></span>\n            <span class=\"radio__label\">{{::'nfc_wizard_assign_step_only_option' | translate}}</span>\n        </label>\n\n        <label class=\"radio mr24\">\n            <input type=\"radio\"\n                   id=\"assign-all-product\"\n                   ng-model=\"ctrl.assignType\"\n                   name='group1'\n                   ng-value=\"2\"\n                   class=\"radio__input\">\n            <span class=\"radio__check\"></span>\n            <span class=\"radio__label\">{{::'nfc_wizard_assign_step_all_option' | translate}}</span>\n        </label>\n</div>\n\n<div class=\"panel p16\">\n    <form name=\"form\">\n        <label>\n            <span translate=\"nfc_wizard_assign_step_sticker_title\"></span>\n        </label>\n        <div class=\"flexVerticalAlignParent\">\n            <input class=\"form-control width450\" type=\"text\"\n                   name=\"stickerCode\"\n                   translate translate-attr-placeholder=\"nfc_wizard_assign_step_sticker_placeholder\"\n                   ng-model=\"ctrl.firstStickerNumber\"\n                   ng-required />\n\n            <div ng-show=\"ctrl.assignType === 2\" class=\"ml10 flexVerticalAlignParent\">\n                <span class=\"icon24 icon-error-rounded--red mr8\"></span>\n                <span class=\"color-red\">\n                     <span translate=\"nfc_wizard_assign_step_sticker_warning\"></span>\n                </span>\n            </div>\n        </div>\n        <div class=\"text-danger\" ng-show=\"form.stickerCode.$error.required\">\n            <div ng-show=\"form.stickerCode.$invalid\" translate=\"the_field_is_required\"></div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wizard__bottom\">\n    <div class=\"fs-18 mb24\">\n        <span translate=\"nfc_wizard_locations_step_full_title\"\n              translate-value-count=\"{{ctrl.selectedLocations.length}}\"\n              translate-interpolation=\"messageformat\">\n        </span>\n    </div>\n    <button class=\"btn btn-primary btn-with-icon flexVerticalAlignParent mt22\" ng-click=\"ctrl.addLocations()\">\n        <span class=\"plus-icon icon24 mr8\"></span>\n        <span translate=\"nfc_wizard_locations_step_add_location_button\">\n        </span>\n    </button>\n</div>\n\n<selected-list\n        on-delete=\"ctrl.deleteLocation(item)\"\n        items=\"ctrl.selectedLocations\"\n        display-field =\"'Address'\"\n        header=\"ctrl.listHeader\"\n        class=\"wizard__selected-locations\">\n</selected-list>\n\n<empty-list-state class=\"empty-list-center-position\"\n                  ng-if=\"ctrl.selectedLocations.length === 0\"\n                  message=\"ctrl.listEmptyMessage\">\n</empty-list-state>\n";

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel mt8\" ng-show=\"ctrl.items.length>0\">\n    <h3 class=\"fw-500  fs-13 p16\">{{ctrl.header}}</h3>\n    <div class=\"panel-body bordered--top p0\">\n        <div ng-repeat=\"item in ctrl.items\" class=\"flexVerticalAlignParent bordered--bottom p16\">\n            <span class=\"fs-14\" ng-if=\"item.hasOwnProperty('Title')\" >{{::item.Title}}</span>\n            <div>\n                <span translate=\"nfc_wizard_products_step_list_category_label\" class=\"fs-10 color-black38 block lh8\" ng-if=\"item.hasOwnProperty('CategoryFullName')\">\n                </span>\n                <span class=\"fs-14 block\" ng-if=\"item.hasOwnProperty('CategoryFullName')\" >{{::item.CategoryFullName}}</span>\n            </div>\n\n            <button class=\"delete-btn ml-auto\" ng-click=\"ctrl.onDelete({item: item})\">\n                <span class=\"icon24 inline-block icon-trashcan-outline opacity16\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wizard__bottom\">\n    <div class=\"fs-18 mb24\">\n        <span translate=\"nfc_wizard_products_step_select_title\"></span>\n    </div>\n    <div class=\"flexVerticalAlignParent mt22\">\n        <button ng-click=\"ctrl.addProduct()\" class=\"btn btn-primary btn-with-icon flexVerticalAlignParent mr10\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span translate=\"nfc_wizard_products_step_add_product_button\"></span>\n        </button>\n        <button ng-click=\"ctrl.addCategory()\" class=\"btn btn-primary btn-with-icon flexVerticalAlignParent\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span translate=\"nfc_wizard_products_step_add_category_button\"></span>\n        </button>\n    </div>\n</div>\n\n<wizard-product-and-category-list ng-if=\"ctrl.selectedProductsAndCategories.length !== 0\"\n        on-delete=\"ctrl.deleteItem(item)\"\n        items=\"ctrl.selectedProductsAndCategories\"\n        header=\"ctrl.listHeader\">\n</wizard-product-and-category-list>\n\n<empty-list-state class=\"empty-list-center-position\"\n                  ng-if=\"ctrl.selectedProductsAndCategories.length === 0\"\n                  message=\"ctrl.itemsNotSelected\">\n</empty-list-state>\n\n";

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "<div class=\"wizard flexVerticalAlignParent\">\n    <button class=\"btn btn-white--transparent\"\n            ng-hide=\"ctrl.step === 1\"\n            ng-click=\"ctrl.backStep()\">\n        <span translate=\"nfc_wizard_steps_back\"></span>\n    </button>\n    <div class=\"wizard__step\">\n            <div ng-class=\"ctrl.step === 1 ? 'step__item--active': 'step__item--not-active'\" class=\"step__item\">1</div>\n            <div ng-class=\"ctrl.step === 2 ? 'step__item--active': 'step__item--not-active'\" class=\"step__item step__item--lined\">2</div>\n            <div ng-class=\"ctrl.step === 3 ? 'step__item--active': 'step__item--not-active'\" class=\"step__item\">3</div>\n    </div>\n    <div class=\"ml-auto inline-block__wrap\">\n            <button class=\"btn btn-success mr8 btn-100px\"\n                    ng-disabled=\"ctrl.nextButtonDisabled\"\n                    ng-click=\"ctrl.nextStep()\">\n                <span ng-if=\"ctrl.step !== 3\" translate=\"nfc_wizard_steps_next\"></span>\n                <span ng-if=\"ctrl.step === 3\" translate=\"nfc_wizard_steps_finish\"></span>\n            </button>\n            <button class=\"btn btn-danger btn-with-icon\" ng-click=\"ctrl.discard()\">\n                    <em class=\"fa fa-close\"></em>\n                <span translate=\"nfc_wizard_steps_discard\"></span>\n            </button>\n    </div>\n</div>\n";

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<!--Header-->\n<div class=\"modal-header--redesign bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"modal-title\" ng-if=\"ctrl.model.isEditMode\" translate=\"table_editor_edit_title\"></h4>\n    <h4 class=\"modal-title\" ng-if=\"!ctrl.model.isEditMode\" translate=\"table_editor_add_title\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign\">\n    <form name=\"ctrl.form\">\n        <div class=\"form-group mb20 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"table_editor_table_number\"></label>\n            <input type=\"text\"\n                   ng-model=\"ctrl.model.tableName\"\n                   maxlength=\"15\"\n                   ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                   ng-change=\"ctrl.validateTableOnExist()\"\n                   required class=\"form-control\" />\n            <div ng-show=\"ctrl.model.tableNameIsAlreadyExist\"\n                 class=\"text-danger\"\n                 translate=\"table_editor_table_number_error\"></div>\n        </div>\n        <div class=\"form-group mb20 pb5 posRel \">\n            <label class=\"fw-400\" translate=\"table_editor_additional_info\"></label>\n            <textarea type=\"text\"\n                   ng-model=\"ctrl.model.tableDescription\"\n                   ng-disabled=\"ctrl.waiting\"\n                   maxlength=\"250\"\n                   style=\"resize: none;\"\n                   class=\"form-control\" >\n            </textarea>\n        </div>\n    </form>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n        <button type=\"button\"\n                ng-click=\"ctrl.close()\"\n                class=\"btn mr8 color-black54 bg-dark12 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"table_editor_cancel\"></span>\n        </button>\n        <button type=\"button\"\n                ng-click=\"ctrl.save()\"\n                ng-disabled=\"ctrl.waiting || ctrl.form.$invalid || ctrl.form.$pristine || ctrl.model.tableNameIsAlreadyExist\"\n                class=\"btn btn-success  btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span ng-if=\"!ctrl.model.isEditMode\" translate=\"table_editor_add_button\"></span>\n            <span ng-if=\"ctrl.model.isEditMode\" translate=\"table_editor_update_button\"></span>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info panel-campaigns\">\n    <div class=\"panel-heading\">\n        <div class=\"pull-right\">\n            <button ng-click=\"ctrl.openTablesList()\" class=\"btn btn-sm btn-info\">\n                <em class=\"fa fa-pencil\"></em>\n            </button>\n        </div>\n        <div class=\"panel-title\" translate=\"location_tables_title\">\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding-bottom: 24px; padding-top: 24px; height: auto;\">\n        <div class=\"d-flex\">\n            <div class=\"mr24\">\n                <div class=\"mb10\">\n                    <b translate=\"location_tables_table_enable_title\"></b>\n                </div>\n                <div class=\"d-flex mb14\">\n                    <label class=\"switch switch-success posRel mr16\"\n                        ng-click=\"ctrl.tables.length !== 0 && ctrl.changeTableSettings(ctrl.tableSettingsOptions.TableService, ctrl.tableSettings.TableOrderEnabled);\">\n                        <input type=\"checkbox\" ng-disabled=\"ctrl.waiting || ctrl.tables.length === 0\"\n                            ng-model=\"ctrl.tableSettings.TableOrderEnabled\"\n                            class=\"ng-pristine ng-untouched ng-valid ng-empty\">\n                        <span></span>\n                    </label>\n                </div>\n            </div>\n            <div class=\"mr16\">\n                <div class=\"mb10\">\n                    <b translate=\"table_selection_mandatory\"></b>\n                </div>\n                <div class=\"d-flex mb14\">\n                    <label class=\"switch switch-success posRel mr16\"\n                        ng-click=\"ctrl.tableSettings.TableOrderEnabled && ctrl.changeTableSettings(ctrl.tableSettingsOptions.TableMandatorySelection, ctrl.tableSettings.TableSelectionMandatory);\">\n                        <input type=\"checkbox\" ng-disabled=\"!ctrl.tableSettings.TableOrderEnabled || ctrl.tables.length === 0 || ctrl.waiting\"\n                            ng-model=\"ctrl.tableSettings.TableSelectionMandatory\"\n                            class=\"ng-pristine ng-untouched ng-valid ng-empty\">\n                        <span></span>\n                    </label>\n                </div>\n            </div>\n            <span class=\"color-grey ng-scope\" ng-if=\"ctrl.tables.length === 0\"\n            translate=\"location_tables_table_enable_content\"></span>\n        </div>\n        <button class=\"btn btn-success btn-with-icon height40 flexVerticalAlignParent mt22\" ng-if=\"ctrl.tables.length === 0\"\n            ng-click=\"ctrl.addTable()\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span class=\"fs-14\" translate=\"location_tables_add_button\" class=\"ng-scope\"></span>\n        </button>\n\n        <div class=\"wrapRelTable\" ng-if=\"ctrl.tables.length > 0\">\n            <div class=\"table-responsive contScrollTable lessHeight\" style=\"height: auto !important;\">\n                <table class=\"table\">\n                    <thead>\n                        <tr style=\"border-bottom: 1px solid #D7D7D7;\">\n                            <th class=\"width1\">\n                                <span class=\"textNo\" translate=\"location_table_number\"></span>\n                                <div class=\"fs-14\" translate=\"location_table_number\"></div>\n                            </th>\n                            <th>\n                                <span class=\"bgTh\"></span>\n                                <span class=\"textNo\" translate=\"location_table_additional_info\"></span>\n                                <div class=\"fs-14\" translate=\"location_table_additional_info\"></div>\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"table in ctrl.pagination.data\">\n                            <td class=\"width1 pl10\">\n                                <span class=\"fs-14\" ng-bind=\"table.Name\"></span>\n                            </td>\n                            <td class=\"width1 pl10\">\n                                <span class=\"fs-14\" ng-bind=\"table.Description\"></span>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"panel-footer footer-padinationSmaller pt20 pb5 bt0\"\n            ng-if=\"ctrl.pagination.total > ctrl.pagination.pageSize\">\n            <ul uib-pagination ng-disabled=\"ctrl.waiting\" total-items=\"ctrl.pagination.total\"\n                items-per-page=\"ctrl.pagination.pageSize\" ng-model=\"ctrl.pagination.page\" previous-text=\"«\"\n                next-text=\"»\" max-size=\"5\" boundary-link-numbers=\"true\" />\n        </div>\n    </div>\n</div>";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"clearfix\">\n        <ol class=\"breadcrumb ns mt-9\">\n            <li><span><span ui-sref=\"app.shops\" translate=\"places\"></span></span></li>\n            <li class=\"active\" ng-if=\"ctrl.shopName\">\n                <span>\n                    <i ng-bind=\"::ctrl.shopTown\"></i>\n                    <span ng-bind=\"::ctrl.shopName\"></span>\n                </span>\n            </li>\n        </ol>\n    </div>\n    <div>\n        <div class=\"panel-beacons panel panel-edit panel-tables\">\n            <div class=\"panel-heading\">\n                <div class=\"pull-right\">\n                    <div class=\"btn-form btn-form-header\">\n                        <button type=\"submit\"\n                                ng-disabled=\"ctrl.waiting\"\n                                ng-click=\"ctrl.save()\"\n                                class=\"btn btn-success btn-with-line\">\n                            <em class=\"fa fa-check\"></em>\n                            <span translate=\"button_save\"></span>\n                        </button>\n                        <button type=\"button\"\n                                ng-disabled=\"ctrl.waiting\"\n                                ng-click=\"ctrl.discard()\"\n                                class=\"btn btn-danger btn-with-line\">\n                            <em class=\"fa fa-close\"></em>\n                            <span translate=\"button_discard\"></span>\n                        </button>\n                    </div>\n                </div>\n                <div class=\"panel-title fs-14\" translate=\"location_tables_title\"></div>\n            </div>\n            <div class=\"panel-body\">\n                <button class=\"btn btn-success btn-with-icon height40 flexVerticalAlignParent mt22\"\n                        ng-click=\"ctrl.openAddTableDialog()\">\n                    <span class=\"plus-icon icon24 mr8\"></span>\n                    <span translate=\"location_tables_add_button\" class=\"ng-scope\"></span>\n                </button>\n            </div>\n            <div class=\"panel-body\" ng-if=\"ctrl.tables.length > 0\">\n                <div class=\"table-responsive contScrollTable lessHeight\">\n                    <table class=\"table\">\n                        <thead>\n                            <tr class=\"border-style\">\n                                <th style=\"width: 20%\">\n                                    <span class=\"textNo fs-14\" translate=\"location_table_number\"></span>\n                                </th>\n                                <th>\n                                    <span class=\"textNo fs-14\" translate=\"location_table_additional_info\"></span>\n                                </th>\n                                <th>\n                                </th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"table in ctrl.tables\" class=\"border-style\">\n                            <td class=\"width1 pl10\">\n                                <span class=\"fs-14\" ng-bind=\"table.Name\"></span>\n                            </td>\n                            <td>\n                                <span class=\"fs-14\" ng-bind=\"table.Description\"></span>\n                            </td>\n                            <td>\n                                <div class=\"flex-align-right\">\n                                    <span class=\"clickable mr32\" ng-click=\"ctrl.openEditTableDialog(table)\">\n                                        <span class=\"edit-icon icon24 opacity6 inline-block\"></span>\n                                    </span>\n                                    <span class=\"clickable\"\n                                          ng-click=\"ctrl.deleteTable(table)\">\n                                        <span class=\"delete-icon icon24 opacity6 inline-block\"></span>\n                                    </span>\n                                </div>\n                            </td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n            <div ng-show=\"ctrl.tables.length===0\" class=\"empty-list-center-position\">\n                <empty-list-state title-message=\"'location_tables_empty_title' | translate\"\n                                  message=\"'location_tables_empty_content' | translate\">\n                </empty-list-state>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<style>\n    .hasHiddenBtn button[ng-click^=\"select(null, $event)\"] {\n        display: none;\n    }\n</style>\n<div class=\"clearfix\">\n    <div uib-dropdown class=\"btn-group mb5  open pull-right dropdownCorner mt-5\" ng-if=\"!vm.manager.isNew\">\n        <button type=\"button\" ng-disabled=\"vm.waiting\" uib-dropdown-toggle ripple class=\"btn pl10 pr10 dropdown-toggle btn-primary width43\"\n            aria-haspopup=\"true\" aria-expanded=\"true\">\n            <span class=\"fa fa-cog\"></span>\n        </button>\n        <ul role=\"menu\" class=\"dropdown-menu\">\n            <li>\n                <a href=\"\" ng-disabled=\"vm.waiting\" ng-click=\"vm.archiveStore()\"><span class=\"fa fa-trash-o\"></span><span\n                        translate=\"archive_this_place\"></span></a>\n            </li>\n        </ul>\n    </div>\n    <ol class=\"breadcrumb ns mt-9\">\n        <li><span><span ui-sref=\"app.shops\" translate=\"places\"></span></span></li>\n        <li class=\"active\">\n            <span ng-show=\"vm.manager.isNew\" translate=\"new_location\"></span>\n            <span ng-hide=\"vm.manager.isNew\"><i>{{vm.manager.store.Town}}</i><span>{{vm.manager.store.Name}}</span></span>\n        </li>\n    </ol>\n</div>\n<div ng-show=\"vm.manager.store != null\">\n    <div class=\"row row-store\" ng-class=\"{'disable': vm.waiting}\">\n        <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.openingHours\" ng-class=\"{'fullWidth': vm.manager.openForm.store}\">\n            <shop-store shop-id=\"vm.shopID\"></shop-store>\n        </div>\n        <div ng-if=\"!vm.manager.isNew\">\n            <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.store || vm.isNfrnRetailer\" ng-class=\"{'fullWidth': vm.manager.openForm.openingHours}\">\n                <shop-opening-hours shop-id=\"vm.shopID\"></shop-opening-hours>\n            </div>\n            <div class=\"col-lg-12\" ng-if=\"vm.manager.isShowInventory()\" ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store || vm.isNfrnRetailer\">\n                <shop-inventory shop-id=\"vm.shopID\"></shop-inventory>\n            </div>\n            <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store || vm.isNfrnRetailer\">\n                <shop-campaigns shop-id=\"vm.shopID\"></shop-campaigns>\n            </div>\n            <div class=\"col-lg-12\"\n                 ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store\"\n                 ng-if=\"vm.manager.store.BusinessType === vm.businessTypeEnum.FoodAndDrink\">\n                <shop-tables shop-id=\"vm.shopID\"\n                             shop-name=\"vm.manager.store.Name\"\n                             shop-town=\"vm.manager.store.Town\">\n                </shop-tables>\n            </div>\n            <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store || vm.isNfrnRetailer\">\n                <shop-campaign-analytics></shop-campaign-analytics>\n            </div>\n            <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store || vm.isNfrnRetailer\">\n                <shop-visits-analytics></shop-visits-analytics>\n            </div>\n            <div class=\"col-lg-12\" ng-hide=\"vm.manager.openForm.openingHours || vm.manager.openForm.store || vm.isNfrnRetailer\">\n                <shop-impression-analytics></shop-impression-analytics>\n            </div>\n        </div>\n        <div class=\"helpBlock\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info panel-campaigns\">\n    <div class=\"panel-heading\">\n        <div class=\"pull-right\">\n            <button ui-sref=\"app.marketing-campaigns.overview\" title=\"Edit store campaigns\" class=\"btn btn-sm btn-info\">\n                <em class=\"fa fa-pencil\"></em>\n            </button>\n        </div>\n        <div class=\"panel-title\" translate=\"place_campaigns\" >\n        </div>\n    </div>\n    <div class=\"panel-body\" ng-if=\"$ctrl.allCampaigns && $ctrl.allCampaigns.length > 0\">\n        <table class=\"tableFilters \">\n            <tbody>\n                <tr>\n                    <td class=\"pr20\">\n                        <label translate=\"status_caption\" ></label>\n                        <select ng-options=\"item.key for item in $ctrl.filter.statuses\" ng-model=\"$ctrl.filter.selectedStatus\" class=\"form-control\"></select>\n                    </td>\n                    <td class=\"pr20\">\n                        <label translate=\"starts_soonest_on_caption\" ></label>\n                        <div class=\"input-group\">\n                            <input type=\"text\"\n                                   uib-datepicker-popup=\"dd MMMM yyyy\"\n                                   ng-model=\"$ctrl.filter.from\"\n                                   is-open=\"$ctrl.openedStartDate\"\n                                   datepicker-options=\"$ctrl.filter.dateOptions\"\n                                   popup-placement=\"bottom\"\n                                   class=\"form-control\"\n                                   close-text=\"{{::'close' | translate}}\"\n                                   clear-text=\"{{::'clear' | translate}}\"\n                                   current-text=\"{{::'today' | translate}}\"\n                                   readonly />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.openedStartDate = true;\" class=\"btn btn-default\">\n                                    <em class=\"fa fa-calendar\"></em>\n                                </button>\n                            </span>\n                        </div>\n                    </td>\n                    <td class=\"pr20\">\n                        <label translate=\"ends_latest_on_caption\" ></label>\n                        <div class=\"input-group\">\n                            <input type=\"text\"\n                                   uib-datepicker-popup=\"dd MMMM yyyy\"\n                                   ng-model=\"$ctrl.filter.to\"\n                                   is-open=\"$ctrl.openedEndDate\"\n                                   datepicker-options=\"$ctrl.dateOptions\"\n                                   popup-placement=\"bottom\"\n                                   close-text=\"{{::'close' | translate}}\"\n                                   clear-text=\"{{::'clear' | translate}}\"\n                                   current-text=\"{{::'today' | translate}}\"\n                                   class=\"form-control\"\n                                   readonly />\n                            <span class=\"input-group-btn\">\n                                <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); $ctrl.openedEndDate = true;\" class=\"btn btn-default\">\n                                    <em class=\"fa fa-calendar\"></em>\n                                </button>\n                            </span>\n                        </div>\n                    </td>\n                    <td class=\"pr20 width30\">\n                        <label>&nbsp;</label>\n                        <button type=\"button\" ng-click=\"$ctrl.applyFilter()\" class=\"btn btn-success btn-with-line\">\n                            <em class=\"fa fa-check\"></em>\n                            <span translate=\"button_apply\" ></span>\n                        </button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n\n        <!-- START table-responsive-->\n        <div class=\"wrapRelTable\">\n            <div class=\"table-responsive contScrollTable lessHeight\">\n                <table class=\"table\">\n                    <thead>\n                        <tr>\n                            <th class=\"width1\">\n                                <span class=\"textNo\" translate=\"logo\" ></span>\n                                <div translate=\"logo\" ></div>\n                            </th>\n                            <th>\n                                <span class=\"bgTh\"></span>\n                                <span class=\"textNo\" translate=\"name\" ></span>\n                                <div translate=\"name\" ></div>\n\n                            </th>\n                            <th>\n                                <span class=\"textNo\" translate=\"start\" ></span>\n                                <div translate=\"start\" ></div>\n                            </th>\n                            <th>\n                                <span class=\"textNo\" translate=\"end\" ></span>\n                                <div translate=\"end\" >End</div>\n                            </th>\n                            <th>\n                                <span class=\"textNo\" translate=\"status\" ></span>\n                                <div translate=\"status\" ></div>\n                            </th>\n                            <th>\n                                <span class=\"textNo\" translate=\"enabled\" ></span>\n                                <div translate=\"enabled\" ></div>\n                            </th>\n                            <th>\n                                <div></div>\n                            </th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat=\"campaign in $ctrl.campaigns\">\n                            <td class=\"width1 pl10\">\n                                <img ng-if=\"campaign.image\" ng-src=\"{{ campaign.image }}\" alt=\"\" />\n                                <div ng-if=\"campaign.template\" ng-style=\"{width: $ctrl.previewImgSize.w}\" ng-include=\"campaign.template.url\" ng-init=\"template = campaign.template\"></div>\n                            </td>\n                            <td><span ng-bind=\"campaign.Name\"></span></td>\n                            <td>\n                                <span ng-if=\"campaign.StartDate\">{{ campaign.StartDate | date:'EEEE, d' }}{{ campaign.StartDate | dayPrefix }} {{ campaign.StartDate | date:'MMMM yyyy' }}</span>\n                                <span ng-if=\"!campaign.StartDate\" translate=\"no_start\" ></span>\n                            </td>\n                            <td>\n                                <span ng-if=\"campaign.EndDate\">{{ campaign.EndDate | date:'EEEE, d' }}{{ campaign.EndDate | dayPrefix }} {{ campaign.EndDate | date:'MMMM yyyy' }}</span>\n                                <span ng-if=\"!campaign.EndDate\" translate=\"no_end\" ></span>\n                            </td>\n                            <td>\n                                <campaign-status status=\"campaign.Status\" message=\"campaign.StatusMessage\" />\n                            </td>\n                            <td>\n                                <label ng-hide=\"campaign.hideState\" class=\"switch switch-success posRel t4\">\n                                    <input type=\"checkbox\" ng-click=\"$ctrl.setState(campaign)\" ng-model=\"campaign.enabled\" ng-disabled=\"$ctrl.waiting\" />\n                                    <span></span>\n                                </label>\n                                <span ng-show=\"campaign.hideState\"></span>\n                            </td>\n                            <td class=\"pr10\"><a ui-sref=\"app.marketing-campaigns.view({id:campaign.ID})\" class=\"btn btn-primary pull-right pl10 pr10\"><span class=\"fa fa-search\"></span></a></td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <!-- END table-responsive-->\n    </div>\n    <div class=\"panel-body panel-table pt0 pb0\" ng-if=\"!$ctrl.allCampaigns || $ctrl.allCampaigns.length === 0\">\n        <div class=\"panel-body panel-table-cell \">\n            <p translate=\"have_no_place_specific_campaigns\" ></p>\n            <p translate=\"create_campaing_hint\" translate-value-html-icon-pencil=\"<em class='fa fa-pencil'></em>\" ></p>\n        </div>\n    </div>\n</div>\n\n";

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel panel-info panel-inventory\">\n    <div class=\"panel-heading\">\n        <div class=\"pull-right\">\n            <div class=\"buttons\">\n                <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ui-sref=\"app.inventory({shopId:$ctrl.shopID})\" title=\"Edit\" class=\"btn btn-sm btn-info\">\n                    <em class=\"fa fa-pencil\"></em>\n                </button>\n            </div>\n        </div>\n        <div class=\"panel-title\" translate=\"inventory_type\"></div>\n    </div>\n    <div class=\"panel-body\">\n        <div class=\"form-horizontal\" ng-if=\"$ctrl.data.inventory\">\n            <div class=\"posRel searchInput \">\n                <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.pagination.filter\" translate translate-attr-placeholder=\"search_your_categories\"\n                />\n                <span class=\"fa fa-search\"></span>\n            </div>\n            <div ng-repeat=\"item in $ctrl.pagination.data\" class=\"groupCategoryBrands\">\n\n                <div class=\"pb5 pt3\">\n                    <b ng-bind=\"item.CategoryFullName\"></b>\n                </div>\n            </div>\n            <div class=\"panel-footer footer-padinationSmaller pt20 pb5 bt0\" ng-if=\"$ctrl.pagination.total > $ctrl.pagination.pageSize\">\n                <ul uib-pagination ng-disabled=\"$ctrl.waiting\" total-items=\"$ctrl.pagination.total\" items-per-page=\"$ctrl.pagination.pageSize\"\n                    ng-model=\"$ctrl.pagination.page\" previous-text=\"«\" next-text=\"»\" max-size=\"5\" boundary-link-numbers=\"true\"\n                />\n            </div>\n            <div ng-show=\"$ctrl.pagination.data == 0\" class=\"anymatch inventory\" translate=\"no_categories_found_by_filter\" translate-value-filter=\"{{ $ctrl.pagination.filter }}\">\n            </div>\n        </div>\n        <div ng-if=\"$ctrl.data.inventory == false\">\n            <div class=\"confCategBtn\">\n                <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ui-sref=\"app.inventory({shopId:$ctrl.shopID})\" class=\"btn btn-success btn-lg\"\n                    translate=\"button_configure_inventory_type\">\n                </button>\n            </div>\n            <div class=\"bottomNoteAttention\">\n                <div>\n                    <div class=\"fa fa-warning\"></div>\n                    <span ng-if=\"$ctrl.data.BusinessType === 1\" translate=\"inventory_bottom_warning\"></span>\n                    <span ng-if=\"$ctrl.data.BusinessType !== 1\" translate=\"inventory_bottom_warning_not_shop\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <form editable-form=\"\" name=\"$ctrl.openingform\" ng-style=\"$ctrl.openingform.opacity ? {'opacity' : '0'} : {'opacity' : '1'}\"\n          onbeforesave=\"$ctrl.beforeSaveOpeningHours()\"\n          onhide=\"$ctrl.hideOpeningHours()\"\n          novalidate>\n        <div class=\"panel-opening-ours\" ng-class=\"{'panel' : true , 'panel-info': !$ctrl.openingform.$visible ,'panel-edit': $ctrl.openingform.$visible }\">\n            <div class=\"panel-heading\">\n                <div class=\"pull-right\">\n                    <div ng-show=\"!$ctrl.openingform.$visible\" class=\"buttons\">\n                        <button type=\"button\" ng-disabled=\"$ctrl.openingform.$waiting\" ng-click=\"$ctrl.edit()\"\n                            translate\n                            translate-attr-title=\"button_edit_opening_hours\"\n                            class=\"btn btn-sm btn-info\">\n                            <em class=\"fa fa-pencil\"></em>\n                        </button>\n                    </div>\n                    <div ng-show=\"$ctrl.openingform.$visible\" class=\"btn-form btn-form-header clearfix buttonEditForm\">\n                        <button type=\"submit\" ng-disabled=\"$ctrl.openingform.$waiting || $ctrl.openingform.$pristine\" class=\"btn btn-success btn-with-line\">\n                            <em class=\"fa fa-check\"></em>\n                            <span translate=\"button_save\" ></span>\n                        </button>\n                        <button type=\"button\" ng-disabled=\"$ctrl.openingform.$waiting\" ng-click=\"$ctrl.discard()\" class=\"btn btn-danger btn-with-line\">\n                            <em class=\"fa fa-close\"></em>\n                            <span translate=\"button_discard\" ></span>\n                        </button>\n                    </div>\n                </div>\n                <div class=\"panel-title\" translate=\"opening_hours\" ></div>\n            </div>\n            <div class=\"panel-body\">\n                <div class=\"clearfix\">\n                    <div class=\"pull-left pd2Col\">\n                        <table class=\"table bg-white wd-auto\">\n                            <tr>\n                                <th><h3 translate=\"normal_opening_hours\" ></h3></th>\n                            </tr>\n                            <tr>\n                                <td class=\"pl0 align-top\">\n                                    <!-- table Normal opening hours-->\n                                    <table class=\"table table-hover bg-white\">\n                                        <thead ng-show=\"$ctrl.openingform.$visible\">\n                                            <tr class=\"subTitle\">\n                                                <th></th>\n                                                <th translate=\"open_at\" ></th>\n                                                <th></th>\n                                                <th translate=\"closed_at\" ></th>\n                                                <th></th>\n                                                <th translate=\"closed\" ></th>\n                                            </tr>\n                                        </thead>\n                                        <tbody class=\"repeat\" ng-init=\"key='normal'\" ng-repeat=\"item in $ctrl.normalOpeningHours\">\n                                            <tr ng-hide=\"$ctrl.openingform.$visible\">\n                                                <td class=\"align-top\">\n                                                    <b ng-bind=\"item.dayOfWeek\"></b>\n                                                </td>\n                                                <td >\n                                                    <ng-include src=\"'showOpeningHours'\"> </ng-include>\n                                                </td>\n                                            </tr>\n                                            <tr ng-show=\"$ctrl.openingform.$visible\" class=\"borderInTd\">\n                                                <td class=\"nameDay\">\n                                                    <b ng-bind=\"item.dayOfWeek\"></b>\n                                                    <span ng-show=\"item.errors.date\" class=\"text-danger\" ng-bind=\"item.errors.date\"></span>\n                                                </td>\n                                                <td colspan=\"4\">\n                                                    <ng-include src=\"'editOpeningHours'\"> </ng-include>\n                                                </td>\n                                                <td class=\"closedCheck\">\n                                                    <ng-include src=\"'checkboxClosed'\"> </ng-include>\n                                                </td>\n                                            </tr>\n\n                                        </tbody>\n                                    </table>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                    <div class=\"pull-left \">\n                        <table class=\"table bg-white\">\n                            <tr>\n                                <th>\n                                    <h3>\n                                        <span ng-show=\"$ctrl.specialOpeningHours.length > 0 || $ctrl.openingform.$visible\" translate=\"special_opening_hours\" ></span>\n                                        <span ng-hide=\"$ctrl.specialOpeningHours.length > 0\">&#32;</span>\n                                    </h3>\n                                </th>\n                            </tr>\n                            <tr>\n                                <td class=\"pl0 pr0 align-top\">\n                                    <!-- table Special opening hours-->\n                                    <table class=\"table table-hover bg-white wd-auto\">\n                                        <thead>\n                                            <tr class=\"subTitle\" ng-show=\"$ctrl.openingform.$visible\">\n                                                <th translate=\"date\" ></th>\n                                                <th translate=\"opens_at\" ></th>\n                                                <th translate=\"closes_at\" ></th>\n                                                <th translate=\"closed\" >Closed</th>\n                                                <th class=\"pl19\" translate=\"action\" ></th>\n                                            </tr>\n                                        </thead>\n                                        <tbody class=\"repeat\" ng-init=\"key='special'\" ng-repeat=\"item in $ctrl.specialOpeningHours\">\n                                            <tr ng-hide=\"$ctrl.openingform.$visible\">\n                                                <td>\n                                                    <b ng-bind=\"item.date | date:'longDate'\"></b>\n                                                    <b ng-bind=\"item.date | date:'EEEE'\"></b>\n                                                </td>\n                                                <td>\n                                                    <ng-include src=\"'showOpeningHours'\"> </ng-include>\n                                                </td>\n                                            </tr>\n                                            <tr ng-show=\"$ctrl.openingform.$visible\" class=\"borderInTd\">\n                                                <td class=\"input-groupTD\">\n                                                    <div class=\"input-group hasHiddenBtn\">\n                                                        <input type=\"text\"\n                                                               uib-datepicker-popup=\"dd MMM EEE\"\n                                                               ng-model=\"item.date\"\n                                                               is-open=\"openedDate\"\n                                                               datepicker-options=\"$ctrl.dateOptions\"\n                                                               close-text=\"{{::'close' | translate}}\"\n                                                               clear-text=\"{{::'clear' | translate}}\"\n                                                               current-text=\"{{::'today' | translate}}\"\n                                                               class=\"form-control\"\n                                                               readonly />\n                                                        <span class=\"input-group-btn\">\n                                                            <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedDate = true;\" class=\"btn btn-default\">\n                                                                <em class=\"fa fa-calendar\"></em>\n                                                            </button>\n                                                        </span>\n                                                    </div>\n                                                    <span ng-show=\"item.errors.date\" class=\"text-danger error-timepeacker\" ng-bind=\"item.errors.date\"></span>\n                                                </td>\n                                                <td colspan=\"2\">\n                                                    <ng-include src=\"'editOpeningHours'\"> </ng-include>\n                                                </td>\n                                                <td class=\"closedCheck\">\n                                                    <ng-include src=\"'checkboxClosed'\"> </ng-include>\n                                                </td>\n                                                <td class=\"tdTrash\">\n                                                    <button type=\"button\" ng-click=\"$ctrl.removeSpecialOpening(item)\" ng-disabled=\"$ctrl.openingform.$waiting || $ctrl.waiting\"\n                                                        translate translate-attr-title=\"button_delete\"\n                                                        class=\"btn  btn-delete\">\n                                                        <em class=\"fa fa-trash\"></em>\n                                                    </button>\n                                                </td>\n                                            </tr>\n                                        </tbody>\n                                    </table>\n                                    <div class=\"pl5 pt15\">\n                                        <button type=\"button\" ng-show=\"$ctrl.openingform.$visible\" ng-disabled=\"$ctrl.openingform.$waiting\" ng-click=\"$ctrl.addSpecialOpening()\" class=\"btn btn-success btn-with-line\">\n                                            <em class=\"fa fa-plus\"></em>\n                                            <span translate=\"button_add_date\" ></span>\n                                        </button>\n                                    </div>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>\n<script type=\"text/ng-template\" id=\"showOpeningHours\">\n    <span ng-show=\"item.closed && !item.open24Hours\" translate=\"closed\" ></span>\n    <span ng-show=\"item.open24Hours\" translate=\"open_24_hours\" ></span>\n    <div ng-hide=\"item.closed || item.open24Hours\" ng-repeat=\"opening in item.openingHours\">\n        <span ng-bind=\"opening.openAt | date:'hh:mm a'\"></span> <span> — </span> <span ng-bind=\"opening.closedAt | date:'hh:mm a'\"></span>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"editOpeningHours\">\n    <div class=\"disableState\" ng-if=\"item.closed || item.open24Hours\" ng-class=\"{'open24':  item.open24Hours}\"></div>\n    <table>\n        <tr ng-repeat=\"opening in item.openingHours\">\n            <td class=\"tdPad\">\n                <div class=\"timepickerLine timePickerNoArrow\">\n                    <div uib-timepicker name=\"openAt\" ng-model=\"opening.openAt\" show-meridian=\"true\"></div>\n                </div>\n            </td>\n            <td class=\"width15\"><span>—</span></td>\n            <td class=\"tdPad\">\n                <div class=\"timepickerLine timePickerNoArrow\">\n                    <div uib-timepicker name=\"closedAt\" ng-model=\"opening.closedAt\" show-meridian=\"true\"></div>\n                </div>\n            </td>\n            <td class=\"tdClose\">\n                <span ng-class=\"{'hidden':item.openingHours.length == 1}\" class=\"fa fa-close\" ng-click=\"$ctrl.deleteInterval(item, opening)\"></span>\n                <span ng-class=\"{'hidden': item.openingHours.length > 1}\" class=\"fa fa-close opacity0\"></span>\n            </td>\n        </tr>\n        <tr>\n            <td><span ng-show=\"item.errors.openAt\" class=\"text-danger\" ng-bind=\"item.errors.openAt\"></span></td>\n            <td></td>\n            <td><span ng-show=\"item.errors.closedAt\" class=\"text-danger\" ng-bind=\"item.errors.closedAt\"></span></td>\n            <td></td>\n        </tr>\n        <tr>\n            <td colspan=\"4\"><span ng-show=\"item.errors.ranges\" class=\"text-danger width246 text-nowrap\" ng-bind=\"item.errors.ranges\"></span></td>\n        </tr>\n        <tr>\n            <td class=\"tdPad\" colspan=\"4\">\n                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox pull-left text-nowrap\">\n                    <label for=\"{{key}}{{$index}}\">\n                        <input type=\"checkbox\" id=\"{{key}}{{$index}}\" ng-model=\"item.open24Hours\" name=\"{{key}}{{$index}}\" />\n                        <span class=\"fa fa-check\"></span><ng-container translate=\"open_24_hours\" ></ng-container>\n                    </label>\n                </div>\n                <div class=\"pull-right\">\n                    <span class=\"link\" ng-click=\"$ctrl.addInterval(item)\" ng-disabled=\"$ctrl.openingform.$waiting || waiting\">\n                        <em class=\"fa fa-plus\"></em> <span translate=\"add_interval\" ></span>\n                    </span>\n                </div>\n            </td>\n        </tr>\n    </table>\n</script>\n<script type=\"text/ng-template\" id=\"checkboxClosed\">\n    <div class=\"disableState\" ng-if=\"item.open24Hours\"></div>\n    <label class=\"switch switch-danger\">\n        <input type=\"checkbox\" ng-model=\"item.closed\" />\n        <span></span>\n    </label>\n</script>\n";

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <form class=\"posRel\" editable-form=\"\" name=\"$ctrl.storeform\" onbeforesave=\"$ctrl.validateStoreForm($data)\"\n        onaftersave=\"$ctrl.saveStore()\" oncancel=\"$ctrl.storeFormCancel()\" novalidate>\n        <div class=\"panel-address-shop\" ng-class=\"{'panel' : true , 'panel-success panel-address-shop-view': !$ctrl.storeform.$visible ,'panel-edit': $ctrl.storeform.$visible, 'panel-hospitality': !$ctrl.storeform.$visible && ($ctrl.store.type.value === $ctrl.enumBusinessType.Restaurant && $ctrl.store.Menu.length > 0)}\">\n            <div class=\"panel-heading flex-align-start\">\n                <div class=\"ml-auto\">\n                    <div ng-if=\"!$ctrl.storeform.$visible\" class=\"buttons\">\n                        <button type=\"button\" ng-disabled=\"$ctrl.storeform.$waiting\" ng-click=\"$ctrl.storeFormShow()\"\n                            title=\"Edit the store\" class=\"btn btn-sm btn-success\">\n                            <em class=\"fa fa-pencil\"></em>\n                        </button>\n                    </div>\n                    <div ng-if=\"$ctrl.storeform.$visible\" class=\"btn-form btn-form-header\">\n                        <button type=\"submit\" ng-disabled=\"$ctrl.storeform.$waiting || $ctrl.storeform.$pristine\" class=\"btn btn-success btn-with-icon\">\n                            <em class=\"fa fa-check\"></em>\n                            <span translate=\"button_save\"></span>\n                        </button>\n                        <button type=\"button\" ng-disabled=\"$ctrl.storeform.$waiting\" ng-click=\"$ctrl.discardStore()\"\n                            class=\"btn btn-danger btn-with-icon\">\n                            <em class=\"fa fa-close\"></em>\n                            <span translate=\"button_discard\"></span>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"panel-body\" ng-class=\"{'bg-success': !$ctrl.storeform.$visible}\">\n                <div class=\"form-horizontal\" ng-if=\"$ctrl.storeform.$visible\">\n                    <div class=\"form-group m0\">\n                        <div >\n                            <span class=\"text-danger errorTop\" ng-show=\"$ctrl.storeform.$invalid\" translate=\"your_form_has_some_errors\"></span>\n                        </div>\n                    </div>\n                    <div class=\"form-horizontal clearfix\">\n                        <div class=\"edit-left\">\n                            <div class=\"row\">\n                                <div class=\"col-lg-8 col-md-8 col-sm-12 col-sm-12\">\n                                    <div class=\"form-group m0\">\n                                        <label class=\"control-label\" translate=\"field_place_name\"></label>\n                                        <div class=\"posRel\">\n                                            <p class=\"form-control-static pb14\">\n                                                <span editable-text=\"$ctrl.store.Name\" e-form=\"$ctrl.storeform\" e-name=\"storeName\"\n                                                    e-class=\"form-control\">{{ $ctrl.store.Name}}</span>\n                                            </p>\n                                            <span ng-show=\"$ctrl.errorStoreName\" class=\"text-danger errorBottom\"\n                                                ng-bind=\"$ctrl.errorStoreName\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-4 col-md-4 col-sm-12 col-sm-12\">\n                                    <div class=\"form-group m0\">\n                                        <label class=\"control-label\" translate=\"field_business_type\"></label>\n                                        <div class=\"posRel\">\n                                            <div class=\"form-control-static colorGray pb14\">\n                                                <ui-select ng-model=\"$ctrl.store.type\" reset-search-input=\"true\" theme=\"bootstrap\"\n                                                    on-select=\"$ctrl.selectBusinessType($item, $model)\" ng-disabled=\"$ctrl.shopID || $ctrl.waiting\">\n                                                    <ui-select-match placeholder=\"Select\">{{$select.selected.name }}</ui-select-match>\n                                                    <ui-select-choices repeat=\"type in $ctrl.businessTypes\">\n                                                        {{type.name}}\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                            <span ng-show=\"$ctrl.errorStoreBusinessType\" class=\"text-danger errorBottom\"\n                                                ng-bind=\"$ctrl.errorStoreBusinessType\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"place_description\"></label>\n                                <div >\n                                    <p class=\"form-control-static pb4\">\n                                        <span editable-textarea=\"$ctrl.store.Description\" e-rows=\"3\" e-cols=\"50\" e-name=\"storeDescription\"\n                                            e-class=\"form-control\">{{ $ctrl.store.Description }}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreDescription\" class=\"text-danger\" ng-bind=\"$ctrl.errorStoreDescription\"></span>\n                                </div>\n                            </div>\n                            <div ng-if=\"$ctrl.store.type.value == $ctrl.enumBusinessType.Exhibition\" class=\"row\">\n                                <div class=\"row\">\n                                    <div class=\"col-lg-12\">\n                                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-sm-12\">\n                                            <div class=\"clearfix\">\n                                                <div class=\"pull-left\">\n                                                    <div class=\"form-group m0\">\n                                                        <label class=\"control-label mb5\" translate=\"start_date_require\"></label>\n                                                        <div class=\"input-group hasHiddenBtn ui-datepicker\">\n                                                            <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"$ctrl.store.ExhibitionStartDate\"\n                                                                is-open=\"startDate\" datepicker-options=\"$ctrl.dateOptions\" ng-change=\"$ctrl.changeEndDateMinDate()\"\n                                                                close-text=\"{{::'close' | translate}}\" clear-text=\"{{::'clear' | translate}}\"\n                                                                current-text=\"{{::'today' | translate}}\" class=\"form-control\" readonly />\n                                                            <span class=\"input-group-btn\">\n                                                                <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); startDate = true; endDate = false\"\n                                                                    class=\"btn btn-default\">\n                                                                    <em class=\"fa fa-calendar\"></em>\n                                                                </button>\n                                                            </span>\n                                                        </div>\n                                                        <span ng-show=\"$ctrl.errorStoreExhibitionStartDate\" class=\"text-danger error-timepeacker\"\n                                                            ng-bind=\"$ctrl.errorStoreExhibitionStartDate\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-sm-12\">\n                                            <div class=\"clearfix\">\n                                                <div class=\"pull-left\">\n                                                    <div class=\"form-group m0\">\n                                                        <label class=\"control-label mb5\">&nbsp;</label>\n                                                        <div class=\"tdPad\">\n                                                            <div class=\"timepickerLine timePickerNoArrow\">\n                                                                <div uib-timepicker name=\"openAt\" ng-model=\"$ctrl.store.ExhibitionStartDate\" show-meridian=\"true\"></div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row\">\n                                    <div class=\"col-lg-12\">\n                                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-sm-12\">\n                                            <div class=\"clearfix\">\n                                                <div class=\"form-group m0\">\n                                                    <label class=\"control-label mb5\" translate=\"end_date_require\"></label>\n                                                    <div class=\"input-group hasHiddenBtn ui-datepicker\">\n                                                        <input type=\"text\" uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"$ctrl.store.ExhibitionEndDate\"\n                                                            is-open=\"endDate\" datepicker-options=\"$ctrl.dateEndOptions\" ng-change=\"$ctrl.changeStartDateMaxDate()\"\n                                                            close-text=\"{{::'close' | translate}}\" clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                                                            class=\"form-control\" readonly />\n                                                        <span class=\"input-group-btn\">\n                                                            <button type=\"button\" ng-click=\"$event.preventDefault(); $event.stopPropagation(); endDate = true; startDate = false\"\n                                                                class=\"btn btn-default\">\n                                                                <em class=\"fa fa-calendar\"></em>\n                                                            </button>\n                                                        </span>\n                                                    </div>\n                                                    <span ng-show=\"$ctrl.errorStoreExhibitionEndDate\" class=\"text-danger error-timepeacker\"\n                                                        ng-bind=\"$ctrl.errorStoreExhibitionEndDate\"></span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-5 col-md-5 col-sm-12 col-sm-12\">\n                                            <div class=\"clearfix\">\n                                                <div class=\"pull-left\">\n                                                    <div class=\"form-group m0\">\n                                                        <label class=\"control-label mb5\">&nbsp;</label>\n                                                        <div class=\"tdPad\">\n                                                            <div class=\"timepickerLine timePickerNoArrow\">\n                                                                <div uib-timepicker name=\"openAt\" ng-model=\"$ctrl.store.ExhibitionEndDate\" show-meridian=\"true\"></div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"edit-left\">\n                            <div class=\"row\" ng-class=\"{'withCheckBox':$ctrl.storeform.$visible && $ctrl.store.type.value === $ctrl.enumBusinessType.Restaurant}\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 col-sm-12\">\n                                    <div class=\"form-group m0\">\n                                        <label class=\"control-label\" translate=\"telephone\"></label>\n                                        <div class=\"posRel\">\n                                            <p class=\"form-control-static pb14\">\n                                                <span editable-tel=\"$ctrl.store.ContactPhoneNumber\" e-class=\"form-control\"\n                                                    e-name=\"storePhone\">{{ $ctrl.store.ContactPhoneNumber }}</span>\n                                            </p>\n                                            <span ng-show=\"$ctrl.errorStorePhone\" class=\"text-danger errorBottom\"\n                                                ng-bind=\"$ctrl.errorStorePhone\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"checkBoxBooking\" ng-show=\"$ctrl.storeform.$visible && $ctrl.store.type.value === $ctrl.enumBusinessType.Restaurant\">\n                                    <div class=\"form-group\">\n                                        <label class=\"switch switch-success\">\n                                            <input type=\"checkbox\" ng-model=\"$ctrl.store.BookingTableEnabled\"\n                                                ng-disabled=\"$ctrl.waiting || $ctrl.store.type.value !== $ctrl.enumBusinessType.Restaurant\" />\n                                            <span></span>\n                                        </label>\n                                        <span translate=\"enabled_or_disabled_table_booking\"  translate-value-enabled=\"{{ $ctrl.store.BookingTableEnabled ? 'Enabled':'Disabled' }}\"></span>\n                                        <span ng-show=\"$ctrl.errorBookingTable\" class=\"text-danger\" ng-bind=\"$ctrl.errorBookingTable\"></span>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"email\"></label>\n                                <div class=\"posRel\">\n                                    <p class=\"form-control-static pb14\">\n                                        <span editable-text=\"$ctrl.store.ContactEmail\" e-class=\"form-control\" e-name=\"storeEmail\">{{\n                                            $ctrl.store.ContactEmail }}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreEmail\" class=\"text-danger errorBottom\" ng-bind=\"$ctrl.errorStoreEmail\"></span>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"website\"></label>\n                                <div class=\"posRel\">\n                                    <p class=\"form-control-static pb14\">\n                                        <span editable-text=\"$ctrl.store.WebsiteUrl\" e-class=\"form-control\" e-name=\"storeWebsite\"\n                                            e-http-prefix>{{ $ctrl.store.WebsiteUrl }}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreWebsite\" class=\"text-danger errorBottom\" ng-bind=\"$ctrl.errorStoreWebsite\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-horizontal form-horintal-topBorder clearfix\">\n                        <div class=\"edit-left\">\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"address\"></label>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label label70\" translate=\"field_line1\"></label>\n                                <div class=\"posRel\">\n                                    <p class=\"form-control-static\">\n                                        <span editable-text=\"$ctrl.store.AddressLine1\" e-class=\"form-control\" e-name=\"storeAddressLine1\">{{\n                                            $ctrl.store.AddressLine1}}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreAddressLine1\" class=\"text-danger errorRight\" ng-bind=\"$ctrl.errorStoreAddressLine1\"></span>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label label70\" translate=\"field_line2\"></label>\n                                <div class=\"posRel\">\n                                    <p class=\"form-control-static\">\n                                        <span editable-text=\"$ctrl.store.AddressLine2\" e-class=\"form-control\" e-name=\"storeAddressLine2\">{{\n                                            $ctrl.store.AddressLine2}}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreAddressLine2\" class=\"text-danger errorRight\" ng-bind=\"$ctrl.errorStoreAddressLine2\"></span>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label label70\" translate=\"field_town\"></label>\n                                <div class=\"posRel\">\n                                    <p class=\"form-control-static\">\n                                        <span editable-text=\"$ctrl.store.Town\" e-class=\"form-control\" e-name=\"storeTown\">{{\n                                            $ctrl.store.Town}}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStoreTown\" class=\"text-danger errorRight\" ng-bind=\"$ctrl.errorStoreTown\"></span>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label ng-if=\"$ctrl.Country.Code !== 784\" class=\"control-label label70\" translate=\"field_postcode\"></label>\n                                <label ng-if=\"$ctrl.Country.Code === 784\" class=\"control-label label70\" translate=\"postcode\"></label>\n                                <div class=\"width120 posRel\">\n                                    <p class=\"form-control-static\">\n                                        <span editable-text=\"$ctrl.store.PostCode\" e-class=\"form-control\" e-name=\"storePostcode\">{{\n                                            $ctrl.store.PostCode}}</span>\n                                    </p>\n                                    <span ng-show=\"$ctrl.errorStorePostcode\" class=\"text-danger errorRight\" ng-bind=\"$ctrl.errorStorePostcode\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"edit-left\">\n                            <div class=\"form-group m0\">\n                                <span translate=\"mandatory_fields_note\"></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div>\n                        <label class=\"control-label\" translate=\"field_location\"></label>\n                    </div>\n                    <div ng-if=\"$ctrl.maps.optionsEdit && $ctrl.storeform.$visible\" class=\"containerGmap\">\n                        <div class=\"messageButton\">\n                            <div class=\"messageText\">{{$ctrl.maps.message}}</div>\n                            <button type=\"button\" class=\"btn btn-success\" ng-click=\"$ctrl.getLocationFromAdrress($event);\"\n                                translate=\"button_get_location_from_address\"></button>\n                        </div>\n                        <div ui-map-marker=\"$ctrl.maps.markerEdit\" ui-event=\"{'map-click': '$ctrl.openMarkerInfo($ctrl.maps.edit, $ctrl.maps.markerEdit)'}\"></div>\n                        <div ui-map-info-window=\"$ctrl.maps.infoWindow\"></div>\n                        <div id=\"map_canvas_edit\" ui-map=\"$ctrl.maps.edit\" ui-event=\"{'map-click': '$ctrl.setMarker($event, $params)', 'map-tilesloaded': '$ctrl.mapLoaded(\\'edit\\')', 'map-dragstart': '$ctrl.mapDragStart()', 'map-dragend': '$ctrl.mapDragend()'}\"\n                            ui-options=\"$ctrl.maps.optionsEdit\" class=\"gmap gmap450\"></div>\n                        <span ng-show=\"$ctrl.errorStoreMap\" class=\"text-danger\" ng-bind=\"$ctrl.errorStoreMap\"></span>\n\n                    </div>\n                </div>\n                <div class=\"form-horizontal row\" ng-if=\"!$ctrl.storeform.$visible\">\n                    <div class=\"col-lg-8\">\n                        <div ng-if=\"$ctrl.maps.optionsView && !$ctrl.storeform.$visible\" class=\"form-group m0 \">\n                            <div ui-map-marker=\"$ctrl.maps.markerView\" ui-event=\"{'map-click': '$ctrl.openMarkerInfo($ctrl.maps.view, $ctrl.maps.markerView)'}\"></div>\n                            <div ui-map-info-window=\"$ctrl.maps.infoWindow\"></div>\n                            <div id=\"map_canvas_view\" ui-map=\"$ctrl.maps.view\" ui-event=\"{'map-click': '$ctrl.setMarker($event, $params)', 'map-tilesloaded': '$ctrl.mapLoaded(\\'view\\')'}\"\n                                ui-options=\"$ctrl.maps.optionsView\" class=\"gmap gmap270 mb15\"></div>\n                        </div>\n                    </div>\n                    <div class=\"col-lg-4 mt-10\">\n                        <div class=\"form-group m0\">\n                            <div >\n                                <p class=\"form-control-static\">\n                                    <span ng-bind=\"$ctrl.store.AddressLine1\"></span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"form-group m0\" ng-show=\"$ctrl.store.AddressLine2\">\n                            <div >\n                                <p class=\"form-control-static\">\n                                    <span ng-bind=\"$ctrl.store.AddressLine2\"></span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"form-group m0\">\n                            <div >\n                                <p class=\"form-control-static\">\n                                    <span ng-bind-template=\"{{ $ctrl.store.Town }}\"></span>\n                                    <br />\n                                    <span ng-bind-template=\"{{ $ctrl.store.County ? '\\n' : ''}}\"></span>\n                                    <span ng-bind-template=\"{{ $ctrl.store.County }}\">\n                                        <>\n                                    </span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"form-group m0\">\n                            <div >\n                                <p class=\"form-control-static\">\n                                    <span ng-bind=\"$ctrl.store.PostCode\"></span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"form-group m0\" ng-show=\"$ctrl.store.type.value == $ctrl.enumBusinessType.Exhibition\">\n                            <div class=\"\">\n                                <p class=\"form-control-static\">\n                                    <span ng-bind=\"($ctrl.store.ExhibitionStartDate | date:'dd MMM') + ' - ' +  ($ctrl.store.ExhibitionEndDate | date:'dd MMM yyyy')\">\n                                        -\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"height20\"></div>\n                        <div class=\"form-group m0\" ng-show=\"$ctrl.store.ContactPhoneNumber || $ctrl.store.ContactEmail || $ctrl.store.WebsiteUrl\">\n                            <div class=\"form-group m0\" ng-show=\"$ctrl.store.ContactPhoneNumber\">\n                                <div >\n                                    <p class=\"form-control-static\">\n                                        <span ng-bind=\"$ctrl.store.ContactPhoneNumber\"></span>\n                                    </p>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\" ng-show=\"$ctrl.store.type.value === $ctrl.enumBusinessType.Restaurant\">\n                                <div >\n                                    <p class=\"form-control-static\">\n                                        <span class=\"fa\" ng-class=\"{'fa-check-circle': $ctrl.store.BookingTableEnabled, 'fa-close' : !$ctrl.store.BookingTableEnabled}\"></span>\n                                        <span translate=\"table_booking_state\" translate-value-state=\"{{$ctrl.store.BookingTableEnabled ? 'enabled':'disabled'}}\"></span>\n                                    </p>\n                                </div>\n                            </div>\n                            <div class=\"height20\"></div>\n                            <div class=\"form-group m0\" ng-show=\"$ctrl.store.ContactEmail\">\n                                <div >\n                                    <p class=\"form-control-static\">\n                                        <a href=\"mailto:{{$ctrl.store.ContactEmail}}\" ng-bind=\"$ctrl.store.ContactEmail\"></a>\n                                    </p>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\" ng-show=\"$ctrl.store.WebsiteUrl\">\n                                <div >\n                                    <p class=\"form-control-static\">\n                                        <a ng-href=\"{{$ctrl.store.WebsiteUrl}}\" target=\"_blank\" ng-bind=\"$ctrl.store.WebsiteUrl\"></a>\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"height20\"></div>\n                    </div>\n                    <div class=\"form-group col-lg-12 storeDescr\" ng-show=\"$ctrl.store.Description\">\n                        <div >\n                            <p class=\"form-control-static\">\n                                <span ng-bind=\"$ctrl.store.Description\"></span>\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-horizontal  clearfix textEditorPhone\" ng-if=\"$ctrl.storeform.$visible && $ctrl.store.type.value === $ctrl.enumBusinessType.Restaurant\">\n                    <div class=\"form-group mb0\">\n                        <label class=\"control-label\" translate=\"restaurant_menu\"></label>\n                        <div class=\"form-control-static pb0\">\n                            <div text-angular ta-resize-force-aspect-ratio=\"true\" ng-model=\"$ctrl.store.Menu\" ta-paste=\"$ctrl.pasteHandler($html)\"\n                                name=\"menu\" class=\"btn-group-small\"></div>\n                        </div>\n                    </div>\n                    <div class=\"phone\">\n                        <div class=\"textEditorPhoneScroll\">\n                            <div class=\"textEditorPhoneScrollInner phoneScrollSelector\" ng-bind-html=\"$ctrl.trustAsHtml($ctrl.store.Menu)\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"menuWithShadow\">\n            <div class=\"menuShadowInner phoneScrollSelector\" ng-bind-html=\"$ctrl.trustAsHtml($ctrl.store.Menu)\"></div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3\">\n    <div class=\"flexVerticalAlignParent\">\n        <span ng-class=\"{'activefilter': !vm.showActiveShop}\" ng-click=\"vm.showActiveShop = true\">\n            <span class=\"fs-20\" translate=\"places\"></span>\n        </span>\n        <span class=\"ml32 fs-20\" ng-hide=\"!vm.archivedShops || vm.archivedShops.length === 0\"\n            ng-class=\"{'activefilter': vm.showActiveShop}\" ng-click=\"vm.showActiveShop = false\"\n            translate=\"archived_places\">\n        </span>\n        <button ng-if=\"!vm.isNfrnRetailer\" type=\"button\" class=\"btn btn-success ml-auto add-btn\" ui-sref=\"app.create-shop\">\n            <span class=\"plus-icon icon24\"></span>\n            <span class=\"ml8 fs-14\" translate=\"add_a_place\"></span>\n        </button>\n    </div>\n    <p ng-show=\"vm.showActiveShop\" translate=\"shops_active_shops_hint\" class=\"fs-14\"></p>\n    <p ng-hide=\"vm.showActiveShop\" translate=\"shops_archived_shops_hint\" class=\"fs-14\"></p>\n\n    <div class=\"posRel searchInput mt24\">\n        <input type=\"text\" \n               class=\"form-control top-panel-input\" \n               ng-model=\"vm.storeName\"\n               ng-model-options=\"{  updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" \n               ng-change=\"vm.get()\"\n               translate-attr-placeholder=\"search_locations\" />\n        <span class=\"fa fa-search\"></span>\n    </div>\n</div>\n<div class=\"row row-shops\">\n    <div ng-show=\"vm.showActiveShop\">\n        <div class=\"width320Block\" ng-repeat=\"shop in vm.shops\">\n            <!-- START panel-->\n            <div class=\"panel\">\n                <div class=\"panel-heading\" ng-class=\"{'zIndex' : logoToggle}\">\n                    <div class=\"panel-link\" ui-sref=\"app.shop({id:shop.ID})\"></div>\n                    <img ng-show=\"shop.coverUrl\" ng-src=\"{{shop.coverUrl}}\" alt=\"\" />\n                    <div ng-show=\"!shop.coverUrl\" class=\"grayBg\"></div>\n                    <div class=\"gradient\"></div>\n                    <div class=\"inner\">\n                        <div class=\"typeIcon {{shop.businessType.iconClass}}\"></div>\n                        <div class=\"type\">{{shop.businessType.name}}</div>\n                        <h2 class=\"text-ellipsis\">{{shop.Name}}</h2>\n                        <p class=\"text-ellipsis\">{{shop.address}}</p>\n                        <div class=\"getImg\" off-click=\"coverToggle = false\" ng-show=\"shop.CoverID\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span class=\"getImg getImgSpan\" ng-click=\"coverToggle = !coverToggle\"\n                                ng-class=\"{'open' : coverToggle}\">\n                                <span translate=\"update_cover\"></span>\n                                <span class=\"exampleImg\" ng-bind=\"vm.tooltip.cover\"></span>\n                            </span>\n                            <span class=\"chooseVarProd\">\n                                <span ng-click=\"vm.uploadCover(shop)\" translate=\"upload_new_cover\"></span>\n                                <span ng-click=\"vm.removeCover(shop)\" translate=\"remove\"></span>\n                            </span>\n                        </div>\n                        <div class=\"getImg\" ng-hide=\"shop.CoverID\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span class=\"getImg getImgSpan\" ng-click=\"vm.uploadCover(shop)\">\n                                <span translate=\"add_cover\"></span>\n                                <span class=\"exampleImg\" ng-bind=\"vm.tooltip.cover\"></span>\n                            </span>\n                        </div>\n\n                    </div>\n                    <div class=\"iconLogo\" off-click=\"logoToggle = false\" ng-show=\"shop.LogoID\">\n                        <img ng-show=\"shop.logoUrl\" ng-src=\"{{shop.logoUrl}}\" alt=\"\" />\n                        <div class=\"tdAddLogo\" ng-click=\"logoToggle = !logoToggle\" ng-class=\"{'open' : logoToggle}\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span translate=\"update_logo\"></span>\n                            <span class=\"exampleImgWrap\">\n                                <span class=\"exampleImg\" ng-bind=\"vm.tooltip.logo\"></span>\n                            </span>\n                        </div>\n                        <span class=\"chooseVarProd\">\n                            <span ng-click=\"vm.uploadLogo(shop)\" translate=\"upload_new_logo\"></span>\n                            <span ng-click=\"vm.removeLogo(shop)\" translate=\"remove\"></span>\n                        </span>\n                    </div>\n                    <div class=\"iconLogo\" ng-hide=\"shop.LogoID\">\n                        <div class=\"tdAddLogo open\" ng-click=\"vm.uploadLogo(shop)\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span translate=\"add_logo\"></span>\n                            <span class=\"exampleImgWrap\">\n                                <span class=\"exampleImg\">Min 1200×600px, max 10MB</span>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"panel-body pb0\">\n                    <div class=\"clearfix pointLabels\" ng-class=\"{'hasWarn':shop.hasWarn}\">\n                        <!--ng-class={'hasWarn':......}-->\n                        <div class=\"pull-left\">\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"name\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"address\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"map\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                Email\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em ng-hide=\"shop.IsWebsiteUrlExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    tooltip-append-to-body=\"true\" uib-tooltip-html=\"vm.tooltip.websiteUrl\"\n                                    class=\"fa fa-exclamation-triangle\">\n                                </em>\n                                <em ng-show=\"shop.IsWebsiteUrlExist\" class=\"fa fa-check-circle\"> </em>\n                                URL\n                            </div>\n                        </div>\n                        <div class=\"pull-left\">\n                            <div class=\"pointLabel\">\n                                <em ng-hide=\"shop.IsDescriptionExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    uib-tooltip-html=\"vm.tooltip.description\" class=\"fa fa-exclamation-triangle\"> </em>\n                                <em ng-show=\"shop.IsDescriptionExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"desciption\"></span>\n                            </div>\n                            <div class=\"pointLabel\" ng-if=\"!vm.isNfrnRetailer\">\n                                <em ng-hide=\"shop.IsOpeningHoursExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    uib-tooltip-html=\"vm.tooltip.openingHours\" class=\"fa fa-exclamation-triangle\"> </em>\n                                <em ng-show=\"shop.IsOpeningHoursExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"opening_hours\"></span>\n                            </div>\n                            <div ng-if=\"vm.isShowInventory(shop.BusinessType) && !vm.isNfrnRetailer\" class=\"pointLabel\">\n                                <em ng-hide=\"shop.IsInventoryTypeExist\" tooltip-popup-delay=\"200\"\n                                    tooltip-placement=\"top\" uib-tooltip-html=\"vm.tooltip.inventoryType\"\n                                    class=\"fa fa-exclamation-triangle\">\n                                </em>\n                                <em ng-show=\"shop.IsInventoryTypeExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"inventory_type\"></span>\n                            </div>\n                            <div class=\"pointLabel\" ng-if=\"!vm.isNfrnRetailer\">\n                                <span ng-show=\"shop.CampaignsCount === 0\">\n                                    <em tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                        uib-tooltip-html=\"vm.tooltip.campaigns\" class=\"fa fa-exclamation-triangle\">\n                                    </em>\n                                    <span translate=\"first_marketing_campaign\"></span>\n                                </span>\n                                <span ng-hide=\"shop.CampaignsCount === 0\">\n                                    <em class=\"fa fa-check-circle\"></em>\n                                    <span translate=\"marketing_campaign_count\"\n                                        translate-values=\"{ COUNT: shop.CampaignsCount }\"\n                                        translate-interpolation=\"messageformat\"></span>\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"flexVerticalAlignParent pointLabels pt0\">\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-bookmark\"></em>\n                                <span> {{shop.FollowersCount}}</span> \n                                <span translate=\"followers_count\" ng-show=\"shop.FollowersCount>1||shop.FollowersCount==0 \"></span>\n                                <span translate=\"follower_count\" ng-show=\"shop.FollowersCount==1\"></span>\n                            </div>\n                            <div class=\"ml-auto pointLabel\">\n                                <span>jisp ID: {{shop.ID}}</span>\n                            </div>\n                        </div>\n                </div>\n            </div>\n            <!-- EN panel-->\n        </div>\n        <input type=\"file\" id=\"coverStore\" ng-disabled=\"vm.waiting\" img-filereader max-size-mb=\"vm.size.cover.file\"\n            min-width=\"vm.size.cover.w\" min-height=\"vm.size.cover.h\" style=\"display:none\" accept=\"image/*\"\n            ng-model=\"vm.file.cover\" callback=\"vm.uploadedCover()\" />\n        <input type=\"file\" id=\"logoStore\" ng-disabled=\"vm.waiting\" img-filereader max-size-mb=\"vm.size.logo.file\"\n            min-width=\"vm.size.logo.w\" min-height=\"vm.size.logo.h\" style=\"display:none\" accept=\"image/*\"\n            ng-model=\"vm.file.logo\" callback=\"vm.uploadedLogo()\" />\n    </div>\n    <div ng-hide=\"vm.showActiveShop\">\n        <div class=\"width320Block archive\" ng-repeat=\"shop in vm.archivedShops\">\n            <!-- START panel-->\n            <div class=\"panel panel-success\">\n                <div class=\"panel-link\" ui-sref=\"app.shop({id:shop.ID})\"></div>\n                <div class=\"panel-heading\">\n                    <img ng-show=\"shop.coverUrl\" ng-src=\"{{shop.coverUrl}}\" alt=\"\" />\n                    <div ng-show=\"!shop.coverUrl\" class=\"grayBg\"></div>\n                    <div class=\"gradient\"></div>\n                    <div class=\"inner\">\n                        <div class=\"typeIcon {{shop.businessType.iconClass}}\"></div>\n                        <div class=\"type\">{{shop.businessType.name}}</div>\n                        <h2>{{shop.Name}}</h2>\n                        <p>{{shop.Town}}</p>\n                        <div class=\"getImg\" off-click=\"coverToggle = false\" ng-show=\"shop.CoverID\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span class=\"getImg\" ng-click=\"coverToggle = !coverToggle\" ng-class=\"{'open' : coverToggle}\"\n                                translate=\"update_cover\">\n                            </span>\n                            <span class=\"chooseVarProd\">\n                                <span ng-click=\"vm.uploadCover(shop)\" translate=\"upload_new_cover\"></span>\n                                <span ng-click=\"vm.removeCover(shop)\" translate=\"remove\"></span>\n                            </span>\n                        </div>\n                        <div class=\"getImg\" ng-hide=\"shop.CoverID\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span class=\"getImg\" ng-click=\"vm.uploadCover(shop)\" translate=\"add_cover\"></span>\n                        </div>\n\n                    </div>\n                    <div class=\"iconLogo\" off-click=\"logoToggle = false\" ng-show=\"shop.LogoID\">\n                        <img ng-show=\"shop.logoUrl\" ng-src=\"{{shop.logoUrl}}\" alt=\"\" />\n                        <div class=\"tdAddLogo\" ng-click=\"logoToggle = !logoToggle\" ng-class=\"{'open' : logoToggle}\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span translate=\"update_logo\"></span>\n                        </div>\n                        <span class=\"chooseVarProd\">\n                            <span ng-click=\"vm.uploadLogo(shop)\" translate=\"upload_new_logo\"></span>\n                            <span ng-click=\"vm.removeLogo(shop)\" translate=\"remove\"></span>\n                        </span>\n                    </div>\n                    <div class=\"iconLogo\" ng-hide=\"shop.LogoID\">\n                        <div class=\"tdAddLogo open\" ng-click=\"vm.uploadLogo(shop)\">\n                            <span class=\"fa fa-picture-o\"></span>\n                            <span translate=\"add_logo\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"panel-body\">\n                    <div class=\"clearfix pointLabels\">\n                        <div class=\"pull-left\">\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"name\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"address\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"map\"></span>\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em class=\"fa fa-check-circle\"> </em>\n                                Email\n                            </div>\n                            <div class=\"pointLabel\">\n                                <em ng-hide=\"shop.IsWebsiteUrlExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    uib-tooltip-html=\"vm.tooltip.websiteUrl\" class=\"fa fa-exclamation-triangle\"> </em>\n                                <em ng-show=\"shop.IsWebsiteUrlExist\" class=\"fa fa-check-circle\"> </em>\n                                URL\n                            </div>\n                        </div>\n                        <div class=\"pull-left\">\n                            <div class=\"pointLabel\">\n                                <em ng-hide=\"shop.IsDescriptionExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    uib-tooltip-html=\"vm.tooltip.description\" class=\"fa fa-exclamation-triangle\"> </em>\n                                <em ng-show=\"shop.IsDescriptionExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"description\"></span>\n                            </div>\n                            <div class=\"pointLabel\" ng-if=\"!vm.isNfrnRetailer\">\n                                <em ng-hide=\"shop.IsOpeningHoursExist\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                    uib-tooltip-html=\"vm.tooltip.openingHours\" class=\"fa fa-exclamation-triangle\"> </em>\n                                <em ng-show=\"shop.IsOpeningHoursExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"opening_hours\"></span>\n                            </div>\n                            <div class=\"pointLabel\" ng-if=\"!vm.isNfrnRetailer\">\n                                <em ng-hide=\"shop.IsInventoryTypeExist\" tooltip-popup-delay=\"200\"\n                                    tooltip-placement=\"top\" uib-tooltip-html=\"vm.tooltip.inventoryType\"\n                                    class=\"fa fa-exclamation-triangle\">\n                                </em>\n                                <em ng-show=\"shop.IsInventoryTypeExist\" class=\"fa fa-check-circle\"> </em>\n                                <span translate=\"Inventory Type\"></span>\n                            </div>\n                            <div class=\"pointLabel\" ng-if=\"!vm.isNfrnRetailer\">\n                                <span ng-show=\"shop.CampaignsCount === 0\">\n                                    <em tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                        uib-tooltip-html=\"vm.tooltip.campaigns\" class=\"fa fa-exclamation-triangle\">\n                                    </em>\n                                    <span translate=\"first_marketing_campaign\"></span>\n                                </span>\n                                <span ng-hide=\"shop.CampaignsCount === 0\">\n                                    <em class=\"fa fa-check-circle\"></em>\n                                    <ng-pluralize count=\"shop.CampaignsCount\"\n                                        when=\"{ NaN: '', 1: '{} marketing campaign', 'other': '{} marketing campaigns'}\">\n                                    </ng-pluralize>\n                                </span>\n                            </div>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n            <!-- EN panel-->\n            <button class=\"btn btn-success\" ng-disabled=\"vm.waiting\" ng-click=\"vm.restore(shop.ID)\"\n                translate=\"restore\"></button>\n        </div>\n    </div>\n    \n</div>\n<div ng-show=\"vm.showActiveShop\" class=\"panel-footer footer-padinationSmaller pt15\"\n    ng-if=\"vm.settings.active.total > vm.settings.active.pageSize\">\n    <ul uib-pagination total-items=\"vm.settings.active.total\" items-per-page=\"vm.settings.active.pageSize\"\n        ng-model=\"vm.settings.active.page\" previous-text=\"«\" next-text=\"»\" max-size=\"10\" boundary-link-numbers=\"true\" />\n</div>\n<div ng-hide=\"vm.showActiveShop\" class=\"panel-footer footer-padinationSmaller pt15\"\n    ng-if=\"vm.settings.archived.total > vm.settings.archived.pageSize\">\n    <ul uib-pagination total-items=\"vm.settings.archived.total\" items-per-page=\"vm.settings.archived.pageSize\"\n        ng-model=\"vm.settings.archived.page\" previous-text=\"«\" next-text=\"»\" max-size=\"10\"\n        boundary-link-numbers=\"true\" />\n</div>\n\n<div fill-element>\n    <empty-list-state ng-show=\"vm.shops.length === 0\"\n                      title-message=\"'locations_list_empty_screen_title' | translate\"\n                      message=\"'locations_list_empty_screen_content' | translate\"\n                      ng-class=\"{'absolute-center-flex': vm.shops.length === 0}\"\n                      class=\"container-fh\">\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<form name=\"ctrl.form\" class=\"pr12 pl12 pb24 animated rotateInDownLeft\" ng-if=\"ctrl.printer\">\n\n    <!-- Breadcrumbs-->\n    <div class=\"mb4\">\n        <ol class=\"breadcrumb ns m0\">\n            <li><span ui-sref=\"app.printers.list\" translate=\"printers\" class=\"fs-20 fw-500 color-amethyst-smoke\"></span></li>\n            <li class=\"active\">\n                <span ng-if=\"ctrl.isNew\" translate=\"new\" class=\"fs-20 fw-500 color-black87\"></span>\n                <span ng-if=\"!ctrl.isNew\" translate=\"edit\" class=\"fs-20 fw-500 color-black87\"></span>\n            </li>\n        </ol>\n    </div>\n\n    <div class=\"fs-12 lh16 ls-031 color-black6 mb24\" translate=\"set_the_unique_path\"></div>\n\n    <!-- Location-->\n    <div class=\"panel panel-edit br4 mb8\">\n        <div class=\"panel-heading flexVerticalAlignParent border-bottom-gray pl16\">\n            <div class=\"fs-18 lh24 fw-500 color-black87\" translate=\"place\"></div>\n        </div>\n        <div class=\"panel-body pt16 pb16 pl24 pr24\">\n            <div ng-if=\"!ctrl.printer.PlaceDetails\" class=\"pt4 pb4\">\n                <button type=\"button\"\n                        ng-disabled=\"ctrl.waiting\"\n                        class=\"btn btn-success h40 btn-with-icon flexVerticalAlignParent\"\n                        ng-click=\"ctrl.selectLocation()\">\n                    <div class=\"plus-icon icon24 mr8\"></div>\n                    <span class=\"fs-14 fw-500 lh16 ls-031\" translate=\"select_location\"></span>\n                </button>\n            </div>\n            <div ng-if=\"ctrl.printer.PlaceDetails\" class=\"d-flex\">\n                <div class=\"mr16\">\n                    <img ng-if=\"ctrl.printer.PlaceDetails && ctrl.printer.PlaceDetails.IconId\"\n                         ng-src=\"{{ctrl.getLogoUrl(ctrl.printer.PlaceDetails.IconId)}}\"\n                         class=\"image-48 img-circle\"\n                         alt=\"\" />\n                    <div ng-if=\"!ctrl.printer.PlaceDetails || !ctrl.printer.PlaceDetails.IconId\"\n                         class=\"icon-store-placeholder\"></div>\n                </div>\n                <div class=\"d-flex flex-column flex-stretch pt4\">\n                    <span class=\"fs-14 lh16 ls-0146 mb8\" ng-bind=\"ctrl.printer.PlaceDetails.Name\"></span>\n                    <span class=\"fs-14 lh16 ls-0146 color-black6\">{{ctrl.printer.PlaceDetails.AddressLine1}},&nbsp;{{ctrl.printer.PlaceDetails.Town}}</span>\n                </div>\n                <div class=\"pt12 pr4\">\n                    <div class=\"close-icon--small opacity6 icon24 clickable\" ng-click=\"ctrl.removeLocation()\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Settings-->\n    <div class=\"panel panel-edit br4 mb24\">\n        <div class=\"panel-heading flexVerticalAlignParent border-bottom-gray pl16\">\n            <div class=\"fs-18 lh24 fw-500 color-black87\" translate=\"printer_settings\"></div>\n        </div>\n        <div class=\"panel-body pt16 pl24 pb24\">\n            <div class=\"d-flex align-items-start mb24\">\n                <div class=\"d-flex flex-column flex-stretch max-w344 mr24\">\n                    <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"PrinterPath\"\n                           translate=\"printer_path\"></label>\n                    <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 w-100 mb4\"\n                           id=\"PrinterPath\" name=\"PrinterPath\"\n                           ng-model=\"ctrl.printer.PrinterPath\"\n                           ng-model-options=\"{allowInvalid: true}\"\n                           required\n                           ng-maxlength=\"30\"\n                           ng-disabled=\"ctrl.waiting\">\n                    <div ng-if=\"ctrl.form.PrinterPath.$dirty && (ctrl.form.PrinterPath.$invalid || !ctrl.form.PrinterPath.$viewValue)\"\n                         class=\"fs-12 lh16 ls-031 text-danger\">\n                        <div ng-if=\"ctrl.form.PrinterPath.$error.required\" class=\"text-danger\" translate=\"field_is_required\"></div>\n                        <div ng-if=\"ctrl.form.PrinterPath.$error.maxlength\" class=\"text-danger\" >{{:: 'max_text_length_error' | translate : {count: 30} }}</div>\n                    </div>\n                </div>\n                <div class=\"d-flex flex-column flex-stretch max-w354\">\n                    <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"PrinterAccessID\"\n                           translate=\"printer_access_id\"></label>\n                    <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 w-100 mb4\"\n                           id=\"PrinterAccessID\" name=\"PrinterAccessID\"\n                           ng-model=\"ctrl.printer.PrinterAccessID\"\n                           ng-model-options=\"{allowInvalid: true}\"\n                           required\n                           ng-maxlength=\"20\"\n                           ng-disabled=\"ctrl.waiting\">\n                    <div ng-if=\"ctrl.form.PrinterAccessID.$dirty && (ctrl.form.PrinterAccessID.$invalid || !ctrl.form.PrinterAccessID.$viewValue)\"\n                         class=\"fs-12 lh16 ls-031 text-danger\">\n                        <div ng-if=\"ctrl.form.PrinterAccessID.$error.required\" class=\"text-danger\" translate=\"field_is_required\"></div>\n                        <div ng-if=\"ctrl.form.PrinterAccessID.$error.maxlength\" class=\"text-danger\" >{{:: 'max_text_length_error' | translate : {count: 20} }}</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"d-flex flex-column mb24\">\n                <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"CopyCount\"\n                       translate=\"printer_copies\"></label>\n                <ui-select class=\"fs-14 w148\" name=\"CopyCount\" id=\"CopyCount\"\n                           theme=\"bootstrap\"\n                           search-enabled=\"false\"\n                           skip-focusser=\"true\"\n                           ng-model=\"ctrl.printer.CopyCount\"\n                           ng-disabled=\"ctrl.waiting\">\n                    <ui-select-match class=\"ui-select-match add-product-ui-select-match\">\n                        {{ $select.selected }}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"value in ctrl.copyValues\">\n                        <div ng-bind=\"value\"></div>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div class=\"d-flex align-items-start\">\n                <div class=\"d-flex flex-column mr24\">\n                    <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"StartBuzzer\"\n                           translate=\"printer_buzz_before\"></label>\n                    <ui-select class=\"fs-14 w148\" name=\"StartBuzzer\" id=\"StartBuzzer\"\n                               theme=\"bootstrap\"\n                               search-enabled=\"false\"\n                               skip-focusser=\"true\"\n                               ng-model=\"ctrl.printer.StartBuzzer\"\n                               ng-disabled=\"ctrl.waiting\">\n                        <ui-select-match class=\"ui-select-match add-product-ui-select-match\">\n                            {{ $select.selected }}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"value in ctrl.buzzValues\">\n                            <div ng-bind=\"value\"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n                <div class=\"d-flex flex-column mr24\">\n                    <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"EndBuzzer\"\n                           translate=\"printer_buzz_after\"></label>\n                    <ui-select class=\"fs-14 w148\" name=\"EndBuzzer\" id=\"EndBuzzer\"\n                               theme=\"bootstrap\"\n                               search-enabled=\"false\"\n                               skip-focusser=\"true\"\n                               ng-model=\"ctrl.printer.EndBuzzer\"\n                               ng-disabled=\"ctrl.waiting\">\n                        <ui-select-match class=\"ui-select-match add-product-ui-select-match\">\n                            {{ $select.selected }}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"value in ctrl.buzzValues\">\n                            <div ng-bind=\"value\"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!-- Buttons -->\n    <div class=\"d-flex justify-content-end\">\n        <button type=\"submit\"\n                ng-disabled=\"ctrl.waiting || ctrl.form.$pristine || ctrl.form.$invalid || !ctrl.printer.PlaceDetails\"\n                ng-click=\"ctrl.save()\"\n                class=\"btn btn-success height40 btn-with-icon mr8\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\" class=\"fs-14 fw-500 lh16 ls-031\"></span>\n        </button>\n        <button type=\"button\"\n                ui-sref=\"app.printers.list\"\n                class=\"btn btn-danger height40 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"discard\" class=\"fs-14 fw-500 lh16 ls-031\"></span>\n        </button>\n    </div>\n\n</form>\n";

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pr12 pl12 pb24\">\n    <div class=\"mb24 flexVerticalAlignParent justify-content-between\">\n        <span class=\"fs-20 fw-500\" translate=\"printers\"></span>\n        <button ui-sref=\"app.printers.new\" class=\"btn btn-success add-btn height40\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span class=\"fw-500 fs-14 lh16 ls-031\" translate=\"printer_add\"></span>\n        </button>\n    </div>\n    <div ng-if=\"ctrl.printerList && ctrl.printerList.length > 0\">\n        <div ng-repeat=\"printer in ctrl.printerList\"\n             class=\"d-flex panel panel-info mb16 pt8 pl16 pr8 pb24\">\n            <div class=\"pl8 pt8 mr16\">\n                <img ng-if=\"printer.PlaceDetails && printer.PlaceDetails.IconId\"\n                     ng-src=\"{{ctrl.getLogoUrl(printer.PlaceDetails.IconId)}}\"\n                     class=\"image-48 img-circle\"\n                     alt=\"\" />\n                <div ng-if=\"!printer.PlaceDetails || !printer.PlaceDetails.IconId\"\n                     class=\"icon-store-placeholder\"></div>\n            </div>\n            <div class=\"flex-stretch d-flex flex-column pt10\">\n                <span class=\"fs-20 lh24 ls-0146 mb4\" ng-bind=\"printer.PlaceDetails.Name\"></span>\n                <span class=\"fs-14 lh16 ls-0146 mb26\">{{printer.PlaceDetails.AddressLine1}},&nbsp;{{printer.PlaceDetails.Town}}</span>\n                <div class=\"d-flex mb24\">\n                    <div class=\"d-flex flex-column mr32\">\n                        <span class=\"fs-14 lh16 ls-0146 color-black38 mb8\" translate=\"printer_path\"></span>\n                        <span class=\"fs-14 lh16 ls-0146 color-black87\" ng-bind=\"printer.PrinterPath\"></span>\n                    </div>\n                    <div class=\"d-flex flex-column mr32\">\n                        <span class=\"fs-14 lh16 ls-0146 color-black38 mb8\" translate=\"printer_access_id\"></span>\n                        <span class=\"fs-14 lh16 ls-0146 color-black87 \" ng-bind=\"printer.PrinterAccessID\"></span>\n                    </div>\n                </div>\n                <div class=\"fs-14 lh16 ls-0146 color-black38 mb8\" translate=\"printer_settings\"></div>\n                <div class=\"fs-14 lh16 ls-0146 mb8\">\n                    <span translate=\"printer_copies\"></span>:&nbsp;<span ng-bind=\"printer.CopyCount\"></span>\n                </div>\n                <div class=\"fs-14 lh16 ls-0146 mb24\">\n                    <span translate=\"printer_buzz_str\"\n                          translate-value-before=\"{{printer.StartBuzzer}}\"\n                          translate-value-after=\"{{printer.EndBuzzer}}\"></span>\n                </div>\n\n                <div class=\"d-flex align-items-center\">\n                    <button type=\"button\"\n                            class=\"btn btnWhitePurple d-flex align-items-center br4 color-purple pt8 pb8 pl8 pr16 mr24\"\n                            ng-class=\"{'opacity38': printer.IsTestPrinting}\"\n                            ng-click=\"ctrl.testPrinter(printer)\">\n                        <div class=\"icon-print icon24 mr8\"></div>\n                        <span class=\"fs-14 lh16 ls-031 fw-500\" translate=\"printer_test_print\"></span>\n                    </button>\n                    <div class=\"d-flex align-items-center\" ng-if=\"printer.IsTestPrinting\">\n                        <div class=\"icon-spinner--purple icon-spinner--animated icon24 mr8\"></div>\n                        <span class=\"fs-14 lh16 ls-0146\" translate=\"printer_sending_request\"></span>\n                    </div>\n                    <div class=\"d-flex align-items-center\" ng-if=\"printer.Status === ctrl.statuses.PrintingSuccess\">\n                        <div class=\"icon-check--green icon24 mr8\"></div>\n                        <span class=\"fs-14 lh16 ls-0146\" translate=\"printer_sent_successfully\"></span>\n                    </div>\n                    <div class=\"d-flex align-items-center\" ng-if=\"printer.Status === ctrl.statuses.PrintingError || printer.Status === ctrl.statuses.PrinterNotFound\">\n                        <div class=\"icon-error-rounded--red icon24 mr8\"></div>\n                        <span class=\"fs-14 lh16 ls-0146\" translate=\"printer_not_sent\" ng-if=\"printer.Status === ctrl.statuses.PrintingError\"></span>\n                        <span class=\"fs-14 lh16 ls-0146\" translate=\"printer_not_found\" ng-if=\"printer.Status === ctrl.statuses.PrinterNotFound\"></span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"d-flex align-items-start\">\n                <button class=\"btn btn-link btn-40 clickable\"\n                        ui-sref=\"app.printers.edit({printerID:printer.PrinterID, placeID: printer.PlaceDetails.PlaceID})\">\n                    <span class=\"fa icon24 edit-icon\"></span>\n                </button>\n                <button class=\"btn btn-link btn-40 clickable\"\n                        ng-click=\"ctrl.deletePrinterConfirm(printer)\">\n                    <span class=\"fa icon24 icon-trashcan-outline\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <empty-list-state ng-if=\"ctrl.printerList && ctrl.printerList.length === 0\"\n                      title-message=\"'printers_empty_screen_title' | translate\"\n                      message=\"'printers_empty_screen_content' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\" fill-element>\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb9 \">\n    <a ui-sref=\"app.products\" translate=\"products\"></a>\n    <span class=\"fa fa-angle-right\"></span>\n    <span ng-show=\"vm.state.isNew\" translate=\"new\"></span>\n    <span ng-show=\"vm.state.isCopy\" translate=\"copy\"></span>\n    <span ng-show=\"vm.state.isEdit\" translate=\"edit\"></span>\n</div>\n<div class=\"row row-store\">\n    <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12 pt6 mb16\" translate=\"required_fields_description\"\n        translate-value-html-b=\"<b>\" translate-value-html-b-close=\"</b>\"></div>\n    <div ng-show=\"vm.model.edit\" class=\"col-lg-12 fw\">\n        <div class=\"panel panel-products panel-edit panel-address-shop\">\n            <div class=\"panel-heading flex-align-start h-auto pr20\"\n                style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12);\">\n                <span class=\"fs-18 ml20 text-bold\" translate=\"setup\"></span>\n            </div>\n            <div class=\"panel-body overflowVisible advanced-product\">\n                <form name=\"vm.productForm\" novalidate role=\"form\">\n                    <div class=\"row form-horizontal mb10 extraPadForButton\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12 pt6 mb16 text-danger\"\n                            ng-show=\"vm.model.edit.error.summary\" ng-bind=\"vm.model.edit.error.summary\"></div>\n\n                        <div class=\" col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"field_title\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static\">\n                                        <input type=\"text\" ng-model=\"vm.model.edit.title\" ng-readonly=\"vm.waiting\"\n                                            class=\"form-control\" />\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.title\"\n                                        ng-bind=\"vm.model.edit.error.title\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\" ng-if=\"!vm.isPublisher\">\n                                <div>\n                                    <label class=\"control-label\" translate=\"field_short_description\">\n                                    </label>\n                                    <div class=\"posRel\">\n                                        <div class=\"form-control-static\">\n                                            <input type=\"text\" ng-model=\"vm.model.edit.shortDescription\"\n                                                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n                                            <div class=\"grayNote\" translate=\"max_48_characters\"></div>\n                                        </div>\n                                        <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.shortDescription\"\n                                            ng-bind=\"vm.model.edit.error.shortDescription\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <div>\n                                    <!--begin category-->\n                                    <div class=\"flexVerticalAlignParent\">\n                                        <div class=\"mr48\">\n                                            <label class=\"control-label\" translate=\"field_category\">\n                                            </label>\n                                            <div class=\"posRel\">\n                                                <div class=\"form-control-static\" ng-click=\"vm.selectCategory()\">\n                                                    <div\n                                                        class=\"caretNo tableSelect flexVerticalAlignParent pull-left dropdownWithNote dropdownHeight292  noPadBottom\">\n                                                        <div class=\"ui-select-bootstrap dropdown \"\n                                                            reset-search-input=\"true\">\n                                                            <div class=\"ui-select-match\">\n                                                                <input type=\"text\" class=\"form-control width400 h37\"\n                                                                    ng-disabled=\"vm.model.edit.category.FullName\"\n                                                                    placeholder=\"{{vm.model.edit.category.FullName}}\">\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <span ng-disabled=\"vm.waiting\"\n                                                        class=\"btn btnWhitePurple ml8 plr20 btnSelectList width124\"\n                                                        translate=\"button_select_category\">\n                                                </span>\n                                                </div>\n                                                <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.category\"\n                                                    ng-bind=\"vm.model.edit.error.category\"></div>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"fieldWithClose width310\">\n                                            <label class=\"control-label\" translate=\"field_item_type\"\n                                                ng-show=\"!vm.IsFoodProduct && !vm.isPublisher\">\n                                            </label>\n                                            <label class=\"control-label\" translate=\"field_item_type_food\"\n                                                ng-show=\"vm.IsFoodProduct || vm.isPublisher\">\n                                            </label>\n                                            <div class=\"posRel padRight \" style=\"max-width: 310px\">\n                                                <div class=\"form-control-static\"\n                                                    ng-class=\"{'disabled': !vm.model.edit.category}\">\n                                                    <ui-select class=\"fs-13\"\n                                                               name=\"itemTypes\"\n                                                               ng-model=\"vm.model.edit.itemType\"\n                                                               on-select=\"vm.productForm.$setDirty()\"\n                                                               theme=\"bootstrap\"\n                                                               uis-open-close=\"vm.paginatedItemTypes.resetVisibleList()\"\n                                                               reset-search-input=\"true\"\n                                                               ng-disabled=\"vm.waiting || !vm.model.edit.itemTypes || vm.model.edit.itemTypes.length === 0\">\n                                                        <ui-select-match class=\"ui-select-match add-product-ui-select-match\"\n                                                            placeholder=\"Select item type\">\n                                                            {{ $select.selected.PluralForm }}\n                                                        </ui-select-match>\n                                                        <ui-select-choices\n                                                            repeat=\"type in vm.paginatedItemTypes.getVisibleList()\"\n                                                            refresh=\"vm.paginatedItemTypes.setFilter($select.search)\"\n                                                            refresh-delay=\"0\"\n                                                            when-scrolled=\"vm.paginatedItemTypes.showMore()\">\n                                                            <div>\n                                                                <div\n                                                                    ng-bind-html=\"type.PluralForm | highlight: $select.search\">\n                                                                </div>\n                                                            </div>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                                <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                                                <span class=\"fa fa-close mt-extra\" ng-show=\"vm.model.edit.itemType\"\n                                                    ng-click=\"vm.model.edit.itemType = null\"></span>\n                                            </div>\n                                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.itemType\"\n                                                ng-bind=\"vm.model.edit.error.itemType\"></div>\n                                        </div>\n                                        <!--end itemType-->\n                                    </div>\n                                    <!--end category-->\n                                    <!--end itemType-->\n\n                                </div>\n                            </div>\n\n                            <div class=\"form-group m0\" ng-if=\"!vm.isPublisher\">\n                                <label class=\"control-label\" translate=\"field_brand\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static \">\n                                        <div ng-hide=\"vm.model.edit.category\"\n                                            class=\"disabledCustom selectSearchWrap caretNo flexVerticalAlignParent tableSelect pull-left dropdownWithNote dropdownHeight292  noPadBottom \">\n\n                                            <div class=\"ui-select-container ui-select-bootstrap dropdown mr0\"\n                                                reset-search-input=\"true\">\n                                                <div class=\"ui-select-match\">\n                                                    <button type=\"button\"\n                                                        class=\"btn btn-default  btn-block ui-select-toggle width400\"\n                                                        tabindex=\"-1\" ng-disabled=\"$select.disabled\"\n                                                        ng-click=\"$select.activate()\">\n                                                        <span class=\"ui-select-placeholder text-muted ng-binding\"\n                                                            translate=\"button_search_to_add_a_brand\"></span>\n                                                        <i class=\"caret pull-right\"></i>\n                                                    </button>\n                                                </div>\n                                            </div>\n                                            <button type=\"button\"\n                                                class=\"btn btnWhitePurple ml8 plr20 width124 ng-scope \"\n                                                translate=\"button_select_a_brand\">\n                                            </button>\n                                        </div>\n                                        <div ng-show=\"vm.model.edit.category\"\n                                            class=\"specColorFaBrand min-h37 advanced-product__brands\">\n                                            <brands-selector ng-show=\"vm.model.edit.category\" allow-add=\"true\"\n                                                single-select=\"true\" ng-if=\"vm.model.edit.category.ID\"\n                                                search-all-brands=\"true\" category-id=\"vm.model.edit.category.ID\"\n                                                model=\"vm.model.edit.brands\" on-change=\"vm.productForm.$setDirty()\">\n                                            </brands-selector>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.brand\"\n                                    ng-bind=\"vm.model.edit.error.brand\"></div>\n                            </div>\n                            <div class=\"form-group m0 fieldWithClose width400 gender-field\" ng-if=\"!vm.isPublisher\" ng-show=\"!vm.IsFoodProduct\">\n                                <label class=\"control-label\" translate=\"field_gender\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static\">\n                                        <div uib-dropdown class=\"wideSelect\">\n                                            <button type=\"button\" uib-dropdown-toggle\n                                                class=\"btn btn-default dropdown-toggle fw\" aria-haspopup=\"true\"\n                                                aria-expanded=\"false\">\n                                                <span class=\"caret\"></span>\n                                                <span ng-hide=\"vm.model.edit.genderItem\"\n                                                    translate=\"button_select_gender\"></span>\n                                                <span ng-show=\"vm.model.edit.genderItem\"\n                                                    ng-bind=\"vm.model.edit.genderItem.Name\"></span>\n                                            </button>\n                                            <ul class=\"dropdown-menu\">\n                                                <li ng-repeat=\"item in vm.model.edit.genderItems\"\n                                                    ng-click=\"vm.clearSizeValues(); vm.model.edit.genderItem = item; vm.productForm.$setDirty();\">\n                                                    <a href=\"#\">{{item.Name}}</a>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                    <span class=\"fa fa-close \" ng-show=\"vm.model.edit.genderItem\"\n                                        ng-click=\"vm.clearSizeValues();vm.model.edit.genderItem = null; vm.productForm.$setDirty();\"></span>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0 fieldWithClose width400 country-field\" ng-if=\"!vm.isPublisher\" ng-show=\"vm.IsFoodProduct\">\n                                <label class=\"control-label\" translate=\"field_country_of_origin\">\n                                </label>\n                                <div class=\"posRel padRight\">\n                                    <div class=\"form-control-static width400\">\n                                        <ui-select class=\"fs-13\" name=\"originCountry\"\n                                            ng-model=\"vm.model.edit.originCountry\"\n                                            on-select=\"vm.productForm.$setDirty()\" theme=\"bootstrap\"\n                                            reset-search-input=\"true\" ng-disabled=\"vm.waiting\">\n                                            <ui-select-match class=\"ui-select-match\"\n                                                placeholder=\"Select origin country\">\n                                                {{ $select.selected.Name }}\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat=\"item in vm.originCountryList | filter: $select.search\"\n                                                refresh-delay=\"0\">\n                                                <div>\n                                                    <div ng-bind-html=\"item.Name | highlight: $select.search\"></div>\n                                                </div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                                    <span class=\"fa fa-close mt-extra r26\" ng-show=\"vm.model.edit.originCountry\"\n                                        ng-click=\"vm.model.edit.originCountry = null\"></span>\n                                </div>\n                                <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.originCountry\"\n                                    ng-bind=\"vm.model.edit.error.originCountry\"></div>\n                            </div>\n                            <div class=\"form-group m0 fieldWithClose\" ng-if=\"!vm.isPublisher\" ng-show=\"vm.IsFoodProduct\">\n                                <div>\n                                    <label class=\"control-label\" translate=\"field_preparation\">\n                                    </label>\n                                    <div class=\"form-control-static\">\n                                        <input type=\"text\" id=\"productPreparation\" name=\"productPreparation\"\n                                            ng-model=\"vm.model.edit.preparation\" ng-readonly=\"vm.waiting\"\n                                            autocomplete=\"off\" class=\"form-control\" />\n                                        <div class=\"grayNote\" translate=\"max_250_characters\"></div>\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.preparation\"\n                                        ng-bind=\"vm.model.edit.error.preparation\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0 fieldWithClose\" ng-if=\"!vm.isPublisher\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                                <div>\n                                    <label class=\"control-label\" translate=\"field_ingredients\">\n                                    </label>\n                                    <div class=\"form-control-static\">\n                                        <textarea id=\"productIngredients\" name=\"productIngredients\"\n                                            ng-model=\"vm.model.edit.ingredients\" ng-readonly=\"vm.waiting\"\n                                            autocomplete=\"off\" class=\"form-control\" rows=\"3\"></textarea>\n                                        <div class=\"grayNote\" translate=\"max_2000_characters\"></div>\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.ingredients\"\n                                        ng-bind=\"vm.model.edit.error.ingredients\"></div>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\" ng-if=\"!vm.isPublisher\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                                <div class=\"col-lg-7\">\n                                    <preference-selector preferences=\"vm.model.edit.foodPreferences\"\n                                        component-title=\"vm.preferenceTitle\"\n                                        description='vm.commonPreferenceDescription'\n                                        on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                                    <preference-selector preferences=\"vm.model.edit.allergens\"\n                                        component-title=\"vm.allergenTitle\" description='vm.commonAllergenDescription'\n                                        on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                                </div>\n                            </div>\n                            <div class=\"form-group m0\">\n                                <label class=\"control-label\" translate=\"field_description\">\n                                </label>\n                                <div class=\"posRel\">\n                                    <div class=\"form-control-static textEditor200\">\n                                        <div text-angular ta-paste=\"vm.pasteHandler($html)\"\n                                            ng-model=\"vm.model.edit.description\" class=\"btn-group-small\"\n                                            ng-readonly=\"vm.waiting\"></div>\n                                    </div>\n                                    <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.description\"\n                                        ng-bind=\"vm.model.edit.error.description\"></div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-12 divided-group mr-5\" ng-if=\"!vm.isPublisher\">\n                            <div class=\"form-group pr5 p15\">\n                                <product-stickers-list items=\"vm.model.edit.nfcStickers\" stores=\"vm.stores\"\n                                    is-list-disabled=\"!vm.canEditStickers\" errors=\"vm.model.edit.error.stickers\"> >\n                                </product-stickers-list>\n                            </div>\n                        </div>\n\n                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 mr-5\" ng-class=\"{'divided-group': !vm.isPublisher}\">\n                            <div class=\"row socialLinkControl\">\n                                <div class=\"col-lg-12 col-md-12 col-sm-12 ml15 col-xs-12 pl0\">\n                                    <div class=\"form-group m0 bt0\">\n                                        <div class=\"dividing-line mb16\" ng-if=\"vm.isPublisher\"></div>\n                                        <label class=\"control-label mb8\" translate=\"product_links_and_social_networks\">\n                                        </label>\n                                        <div class=\"posRel padRight\" ng-repeat=\"link in vm.model.edit.links\">\n                                            <div class=\"form-control-static\">\n                                                <div class=\"campainInputProd  input-group\">\n                                                    <div uib-dropdown ng-class=\"{'error': link.error.type}\"\n                                                        class=\"input-group-btn\">\n                                                        <button type=\"button\" uib-dropdown-toggle\n                                                            class=\"btn btn-default dropdown-toggle\" aria-haspopup=\"true\"\n                                                            aria-expanded=\"false\">\n                                                            <span ng-hide=\"link.type\" translate=\"link_type\"></span>\n                                                            <span class=\"text-gray-dark\"\n                                                                ng-show=\"link.type\">{{link.type.Name}}</span>\n                                                            <span class=\"caret\"></span>\n                                                        </button>\n                                                        <ul class=\"dropdown-menu links-menu-right\">\n                                                            <li ng-repeat=\"type in vm.model.linkTypes\"\n                                                                ng-click=\"link.type = type; vm.productForm.$setDirty()\">\n                                                                <a href=\"#\">{{type.Name}}</a>\n                                                            </li>\n                                                        </ul>\n                                                    </div>\n                                                    <input type=\"text\" ng-model=\"link.Url\"\n                                                        ng-class=\"{'error': link.error.url}\" class=\"form-control error\"\n                                                        ng- placeholder=\"URL\" />\n                                                    <input type=\"text\" ng-model=\"link.Title\"\n                                                        ng-class=\"{'error': link.error.title}\" class=\"form-control\"\n                                                        placeholder=\"Title\" />\n                                                </div>\n                                            </div>\n                                            <span class=\"fa fa-close\" ng-click=\"vm.removeLink($index)\"></span>\n                                            <div class=\"text-danger mt-1\" ng-show=\"link.error.sum\"\n                                                ng-bind=\"link.error.sum\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"addElement\">\n                                        <span ng-click=\"vm.addLink()\" class=\"link\">\n                                            <em class=\"fa fa-plus\"></em>\n                                            <span translate=\"add_a_link\"></span>\n                                        </span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 col-sm-12  col-xs-12\" ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\">\n                            <div class=\"form-group m0\">\n                                <div class=\"clearfix radioGroup badgeCheck\">\n                                    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                        <label for=\"preOrder\">\n                                            <input type=\"checkbox\" ng-model=\"vm.model.edit.preOrder\" id=\"preOrder\">\n                                            <span class=\"fa fa-check\"></span>\n                                            <ng-container class=\"text-nowrap\" translate=\"field_pre-order_allowed\">\n                                            </ng-container>\n                                        </label>\n                                    </div>\n                                    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                        <label for=\"verificationRequired\">\n                                            <input type=\"checkbox\" ng-model=\"vm.model.edit.verificationRequired\"\n                                                id=\"verificationRequired\">\n                                            <span class=\"fa fa-check\"></span>\n                                            <ng-container class=\"text-nowrap\" translate=\"field_validation_required\">\n                                            </ng-container>\n                                        </label>\n                                    </div>\n                                    <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                        <label for=\"isInformation\">\n                                            <input type=\"checkbox\" ng-model=\"vm.model.edit.isInformation\"\n                                                id=\"isInformation\">\n                                            <span class=\"fa fa-check\"></span>\n                                            <ng-container class=\"text-nowrap\" translate=\"field_product_isInformation\">\n                                            </ng-container>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"dpp-product-details d-flex flex-column mb24\" ng-if=\"vm.isPublisher && vm.model.edit\" ng-repeat=\"variation in vm.model.edit.variations\">\n    <div class=\"dpp-header\" translate=\"product_details\"></div>\n    <div class=\"dpp-product-details-content d-flex\">\n        <div class=\"d-flex flex-column mr40\">\n            <div class=\"imgChoice \">\n                <div class=\"imgProducts\">\n                    <div class=\"imgProductsInner\" ng-if=\"variation.imagesID.length > 0\">\n                        <img ng-src=\"{{vm.getImageUrl(variation.imagesID)}}\" />\n                    </div>\n                    <div ng-if=\"variation.imagesID.length === 0\"\n                         onclick=\"document.getElementById('imageInput').click()\"\n                         class=\"empty-image-container d-flex align-items-center justify-content-center clickable\">\n                        <span class=\"empty-image\"></span>\n                    </div>\n                </div>\n                <div off-click=\"variation.showImagesPanel = false\" class=\"callTooltipImages posRel\">\n                                        <span class=\"addElement afterImage\"\n                                              ng-click=\"variation.showImagesPanel = !variation.showImagesPanel\">\n                                            <div class=\"fileLabel no-image d-flex align-items-center\">\n                                                <span class=\"camera-icon icon24 mr4\"></span>\n                                                <ng-pluralize class=\"no-image-text\" count=\"variation.imagesID.length\"\n                                                              when=\"{ NaN: 'No images', 0: 'No images', 1: '{} image', 'other': '{} images'}\">\n                                                </ng-pluralize>\n                                            </div>\n                                        </span>\n                        <choice-product-images ng-show=\"variation.showImagesPanel\"\n                                               server-images-id=\"vm.model.serverVariationImagesID[variation.id]\"\n                                               current-images-id=\"variation.imagesID\"\n                                               callback-update=\"vm.productForm.$setDirty()\"\n                                               class=\"tooltipImages clearfix bottom35\">\n\n                        </choice-product-images>\n                </div>\n                <div class=\"text-danger\" ng-show=\"variation.error.image\"\n                     ng-bind=\"variation.error.image\"></div>\n            </div>\n        </div>\n        <div class=\"d-flex flex-column\">\n            <div class=\"d-flex flex-column\">\n                <div class=\"d-flex align-items-center h40 mb24\">\n                    <button ng-if=\"!vm.getAttach()\" class=\"upload-content-button mr8\" ng-disabled=\"vm.waiting\" ng-click=\"vm.openAttachWindow()\">\n                        <div class=\"d-flex align-items-center justify-content-center\">\n                            <span class=\"upload-icon icon24 mr8\"></span>\n                            <span class=\"upload-text\" translate=\"upload_digital_content_file\"></span>\n                        </div>\n                    </button>\n                    <input id=\"attachInput\" style=\"visibility: hidden; display: none\" type=\"file\" accept=\".pdf, .epub\"/>\n                    <span ng-if=\"!vm.getAttach()\" class=\"help-icon icon24\" uib-tooltip=\"{{'pdf_or_epub_tooltip' | translate}}\" tooltip-placement=\"top\"></span>\n                    <div ng-if=\"vm.getAttach()\" class=\"d-flex align-items-center mr60\">\n                        <a ng-click=\"vm.downloadAttach()\" class=\"d-flex align-items-center clickable\" download>\n                            <span class=\"file-icon icon24 mr4\"></span>\n                            <span class=\"filename-text mr16\" ng-bind=\"vm.getAttach().FileName\"></span>\n                        </a>\n                        <span class=\"delete-icon icon24\" ng-click=\"vm.removeAttachment()\"></span>\n                    </div>\n                </div>\n                <div class=\"d-flex align-items-center h40\">\n                    <div class=\"d-flex align-items-center mr8\" ng-init=\"vm.setAccessibleOutOfSession()\">\n                        <input class=\"custom-checkbox\" type=\"checkbox\" id=\"unlimited\" ng-model=\"vm.model.edit.variations[0].isAccessibleOutOfSession\" ng-readonly=\"vm.waiting\" ng-change=\"vm.setDirty()\">\n                        <label class=\"checkbox-label\" for=\"unlimited\" translate=\"unlimited_reading_time\"></label>\n                    </div>\n                    <span class=\"help-icon icon24\" uib-tooltip=\"{{'unlimited_reading_tooltip' | translate}}\" tooltip-placement=\"top\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--Ingredients-->\n<div class=\"row row-store\" ng-if=\"vm.IsFoodProduct && !vm.isNfrnRetailer && !vm.isPublisher\">\n    <div ng-show=\"vm.model.edit\" class=\"col-lg-12 fw\">\n        <div class=\"panel panel-products panel-edit panel-address-shop\">\n            <div class=\"panel-heading flex-align-start h-auto pr20\"\n                 style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12);\">\n                <span class=\"fs-18 ml20 mr8 text-bold\"\n                      translate=\"ingredients_list_label\">\n                </span>\n                <span ng-click=\"vm.openIngredientsInfo()\"\n                      class=\"question-icon question-button clickable\">\n                </span>\n            </div>\n            <!--Ingredients-->\n            <div class=\"extras\">\n                <div class=\"row form-horizontal\">\n                    <div class=\"panel-body overflowVisible advanced-product\">\n                        <product-ingredients-list items=\"vm.model.edit.ingredientList\"\n                                                  on-item-add=\"vm.onAddNewIngredient(item)\"\n                                                  on-items-delete=\"vm.onDeleteIngredients(items)\"\n                                                  on-item-delete=\"vm.onDeleteIngredient(item)\">\n                        </product-ingredients-list>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--Variations-->\n<div class=\"row row-store\" ng-if=\"!vm.isPublisher\">\n    <div ng-show=\"vm.model.edit\" class=\"col-lg-12 fw\">\n        <div class=\"panel panel-products panel-edit panel-address-shop\">\n            <div class=\"panel-heading flex-align-start h-auto pr20\"\n                style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12); \">\n                <span class=\"fs-18 ml20 text-bold\" translate=\"product_variations\"></span>\n            </div>\n            <div class=\"panel-body overflowVisible\">\n                <button ng-click=\"vm.addVariation()\" ng-disabled=\"vm.waiting\" class=\"btn btn-success mb14\">\n                    <em class=\"fa fa-plus\"></em>\n                    <span translate=\"button_add_product_variation\"></span>\n                </button>\n                <div class=\"singleProducts\" ng-repeat=\"variation in  vm.model.edit.variations\"\n                    style=\"border-top:1px solid rgba(0,0,0,.08)\">\n                    <div class=\"row form-horizontal\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"clearfix\">\n                                <div class=\"imgChoice \">\n                                    <div class=\"imgProducts\">\n                                        <div ng-if=\"variation.imagesID.length > 0\"\n                                             class=\"imgProductsInner\">\n                                            <img ng-src=\"{{vm.getImageUrl(variation.imagesID)}}\" />\n                                        </div>\n                                        <div ng-if=\"variation.imagesID.length === 0\"\n                                             ng-click=\"vm.uploadImage($index)\"\n                                             class=\"empty-image-container d-flex align-items-center justify-content-center clickable\">\n                                            <span class=\"empty-image\"></span>\n                                        </div>\n                                    </div>\n                                    <div off-click=\"variation.showImagesPanel = false\" class=\"callTooltipImages\">\n                                        <span class=\"addElement afterImage\"\n                                            ng-click=\"variation.showImagesPanel = !variation.showImagesPanel\">\n                                            <span class=\"fileLabel\">\n                                                <span class=\"fa fa-camera\"></span>\n                                                <ng-pluralize count=\"variation.imagesID.length\"\n                                                    when=\"{ NaN: 'No images', 0: 'No images', 1: '{} image', 'other': '{} images'}\">\n                                                </ng-pluralize>\n                                            </span>\n                                        </span>\n                                        <div>\n                                            <choice-product-images ng-show=\"variation.showImagesPanel\"\n                                                server-images-id=\"vm.model.serverVariationImagesID[variation.id]\"\n                                                current-images-id=\"variation.imagesID\"\n                                                callback-update=\"vm.productForm.$setDirty()\"\n                                                image-input-id=\"$index\"\n                                                class=\"tooltipImages clearfix\">\n                                            </choice-product-images>\n                                        </div>\n                                    </div>\n                                    <div class=\"text-danger\" ng-show=\"variation.error.image\"\n                                        ng-bind=\"variation.error.image\"></div>\n                                </div>\n                                <div class=\"optionSelect\"\n                                    ng-class=\"{'optionSelectLessPad': vm.model.edit.variations.length == 1 }\">\n                                    <div class=\"row\">\n                                        <div class=\"d-flex col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n                                            ng-if=\"!vm.IsFoodProduct\">\n                                            <div class=\"width150 mr24\">\n                                                <div class=\"option\">\n                                                    <div class=\"flex-column\">\n                                                        <label class=\"w-auto common-label\" translate=\"field_price\"></label>\n                                                        <span class=\"mb10 {{vm.currencyCssClass}} t9 width150\">\n                                                            <input type=\"text\" only-decimal ng-model=\"variation.price\"\n                                                                ng-class=\"variation.error.price ? 'input-validation__field--invalid': ''\"\n                                                                ng-readonly=\"vm.waiting\" class=\"form-control\"\n                                                                ng-change=\"vm.productForm.$setDirty()\" />\n                                                        </span>\n                                                        <div class=\"text-danger mt-10 mb5 text-nowrap\"\n                                                            ng-show=\"variation.error.price\"\n                                                            ng-bind=\"variation.error.price\">\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"width150 mr24\">\n                                                <div class=\"option\">\n                                                    <div class=\"flex-column\">\n                                                        <label class=\"w-auto common-label\" translate=\"VAT\"></label>\n                                                        <span class=\"mb20 withPercent t9 width150\">\n                                                            <input type=\"text\" only-decimal min-value=\"0\"\n                                                                max-value=\"100\" ng-model=\"variation.vat\"\n                                                                ng-readonly=\"vm.waiting\" class=\"form-control\"\n                                                                ng-change=\"vm.productForm.$setDirty()\" />\n                                                        </span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"width150\">\n                                                <div class=\"option\">\n                                                    <div class=\"flex-column\">\n                                                        <label class=\"w-auto common-label\" translate=\"old_price\"></label>\n                                                        <span class=\"mb10 {{vm.currencyCssClass}} t9 width150\">\n                                                            <input type=\"text\" only-decimal\n                                                                   ng-model=\"variation.oldPrice\" ng-readonly=\"vm.waiting\"\n                                                                   class=\"form-control\"\n                                                                   ng-class=\"variation.error.oldPrice ? 'input-validation__field--invalid': ''\"\n                                                                   ng-change=\"vm.productForm.$setDirty()\" />\n                                                        </span>\n                                                        <div class=\"text-danger mt-10 text-nowrap\"\n                                                             ng-show=\"variation.error.oldPrice\"\n                                                             ng-bind=\"variation.error.oldPrice\"></div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"vm.IsFoodProduct\">\n                                            <div class=\"d-flex col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                                <div class=\"width150 mr24\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"w-auto common-label\" translate=\"takeaway_price\"></label>\n                                                            <span class=\"mb10 {{vm.currencyCssClass}} t9 width150\">\n                                                                <input type=\"text\"\n                                                                       only-decimal\n                                                                       ng-model=\"variation.price\"\n                                                                       ng-model-options=\"{ updateOn: 'blur' }\"\n                                                                       ng-readonly=\"vm.waiting\"\n                                                                       class=\"form-control\"\n                                                                       required\n                                                                       ng-class=\"variation.error.price ? 'input-validation__field--invalid': ''\"\n                                                                       ng-change=\"vm.showIngredientAttentionIfNeed(); vm.productForm.$setDirty()\" />\n                                                            </span>\n                                                            <div class=\"text-danger mt-10 mb5 text-nowrap\"\n                                                                ng-show=\"variation.error.price\"\n                                                                ng-bind=\"variation.error.price\">\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div class=\"width150 mr24\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"w-auto common-label\" translate=\"takeaway_VAT\"></label>\n                                                            <span class=\"mb20 withPercent t9 width150\">\n                                                                <input type=\"text\"\n                                                                       only-decimal\n                                                                       min-value=\"0\"\n                                                                       max-value=\"100\"\n                                                                       ng-model=\"variation.vat\"\n                                                                       ng-model-options=\"{ updateOn: 'blur' }\"\n                                                                       ng-readonly=\"vm.waiting\"\n                                                                       class=\"form-control\"\n                                                                       ng-change=\"vm.showIngredientAttentionIfNeed(); vm.productForm.$setDirty()\"\n                                                                       ng-disabled=\"!variation.price || variation.price == 0\"/>\n                                                            </span>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div class=\"width150\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"w-auto common-label\"\n                                                                translate=\"old_takeaway_price\"></label>\n                                                            <span class=\"mb20 {{vm.currencyCssClass}} t9 width150\">\n                                                                <input type=\"text\" only-decimal\n                                                                    ng-model=\"variation.oldPrice\"\n                                                                    ng-readonly=\"vm.waiting\" class=\"form-control\"\n                                                                    ng-class=\"variation.error.oldPrice ? 'input-validation__field--invalid': ''\"\n                                                                    ng-change=\"vm.productForm.$setDirty()\"\n                                                                    ng-disabled=\"!variation.price || variation.price == 0\"/>\n                                                            </span>\n                                                            <div class=\"text-danger mt-20 text-nowrap\"\n                                                                ng-show=\"variation.error.oldPrice\"\n                                                                ng-bind=\"variation.error.oldPrice\"></div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class=\"d-flex col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                                <div class=\"width150 mr24\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"w-auto common-label\" translate=\"eat_in_price\"></label>\n                                                            <span class=\"mb10 {{vm.currencyCssClass}} t9 width150\">\n                                                                <input type=\"text\"\n                                                                       only-decimal\n                                                                       ng-model=\"variation.insidePrice\"\n                                                                       ng-model-options=\"{ updateOn: 'blur' }\"\n                                                                       ng-readonly=\"vm.waiting\" class=\"form-control\"\n                                                                       ng-class=\"variation.error.takeawayGreatEatIn? 'input-validation__field--invalid': ''\"\n                                                                       ng-change=\"vm.showIngredientAttentionIfNeed(); vm.productForm.$setDirty(); variation.error.takeawayGreatEatIn &&  vm.clearEatInTakeawayError(variation)\"\n                                                                       ng-disabled=\"!variation.price || variation.price == 0\"  />\n                                                            </span>\n                                                            <div class=\"text-danger mt-10 mb5 text-nowrap\" ng-show=\"variation.error.takeawayGreatEatIn\"\n                                                            translate=\"eatIn_must_be_greater_takeAway\"></div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div class=\"width150 mr24\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"w-auto common-label\" translate=\"eat_in_VAT\"></label>\n                                                            <span class=\"mb10 withPercent t9 width150\">\n                                                                <input type=\"text\"\n                                                                       only-decimal\n                                                                       min-value=\"0\"\n                                                                       max-value=\"100\"\n                                                                       ng-model=\"variation.insideVAT\"\n                                                                       ng-model-options=\"{ updateOn: 'blur' }\"\n                                                                       ng-readonly=\"vm.waiting\" class=\"form-control\"\n                                                                       ng-disabled=\"!variation.insidePrice || variation.insidePrice == 0 || variation.error.takeawayGreatEatIn || !variation.price || variation.price == 0\"\n                                                                       ng-change=\"vm.showIngredientAttentionIfNeed(); vm.productForm.$setDirty()\" />\n                                                            </span>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"d-flex col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                            <div class=\"option width150 mr24\" ng-hide=\"!vm.model.edit.colourName\"\n                                                 ng-include=\"'variationColor'\">\n                                            </div>\n                                            <div class=\"option width150 mr24\" ng-hide=\"vm.model.edit.measurementEnable || !vm.model.edit.sizeName\"\n                                                ng-include=\"'variationSize'\">\n                                            </div>\n\n                                            <div class=\"option\">\n                                                <div class=\"flex-column\">\n                                                    <label class=\"common-label\" translate=\"field_sku\"></label>\n                                                    <span class=\"mb10\">\n                                                        <input type=\"text\" ng-model=\"variation.sku\"\n                                                            ng-readonly=\"vm.waiting\" class=\"form-control wd-xl\"\n                                                            ng-change=\"vm.productForm.$setDirty()\" />\n                                                    </span>\n                                                    <div class=\"text-danger mt-10 pl48\" ng-show=\"variation.error.sku\"\n                                                        ng-bind=\"variation.error.sku\"></div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"vm.IsFoodProduct\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                            <product-preparation type=\"variation.isHot\" time=\"variation.preparationTime\"\n                                                waiting=\"vm.waiting\" variation-id=\"variation.id\" error=\"variation.error.preparationTime\"\n                                                on-preparation-change=\"vm.changeVariationPreparationTime(preparationMessage)\">\n                                            </product-preparation>\n                                        </div>\n\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-4 col-sm-4 col-xs-4\"\n                                                    ng-repeat=\"type in vm.model.edit.measurementTypes\"\n                                                    ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeVisible[type.ID]\">\n                                                    <div class=\"option\">\n                                                        <div class=\"flex-column\">\n                                                            <label class=\"width61 common-label\">\n                                                                {{type.Name}}\n                                                            </label>\n                                                            <span class=\"mb20\">\n                                                                <ui-select class=\"buttonSize\"\n                                                                    name=\"measurementTypeSelect\"\n                                                                    ng-model=\"variation.measurementTypeItem[type.ID]\"\n                                                                    ng-disabled=\"vm.waiting\"\n                                                                    on-select=\"vm.selectMeasurementItem($item, type.ID, variation); vm.productForm.$setDirty();\"\n                                                                    ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                                                    theme=\"bootstrap\" reset-search-input=\"true\">\n                                                                    <ui-select-match class=\"ui-select-match\"\n                                                                        placeholder=\"{{ vm.model.edit.measurementItems[type.ID].length > 0 ? 'Search to set a size': 'Set size' }}\">\n                                                                        <span\n                                                                            ng-bind-html=\"$select.selected.Value | highlight: $select.search\"></span>\n                                                                        <a class=\"btn btn-xs btn-link pull-right pt0 pb0\"\n                                                                            ng-click=\"vm.clearMeasurementItem($event, $select, type.ID, variation)\">\n                                                                            <i class=\"fa fa-close\"></i>\n                                                                        </a>\n                                                                    </ui-select-match>\n                                                                    <ui-select-choices\n                                                                        repeat=\"item in (vm.model.edit.measurementItems[type.ID] | filter: { Value: $select.search } ) track by (item.ID + item.Value)\"\n                                                                        refresh=\"vm.refreshMeasurementTypeItem($select)\"\n                                                                        refresh-delay=\"0\">\n                                                                        <div ng-hide=\"item.forAdd\">\n                                                                            <div\n                                                                                ng-bind-html=\"item.Value | highlight: $select.search\">\n                                                                            </div>\n                                                                        </div>\n                                                                        <div ng-show=\"item.forAdd\" class=\"addLine\"\n                                                                            ng-click=\"vm.addNewMeasurementItem(item, type.ID, variation)\">\n                                                                            <span translate=\"set_custom_size\"\n                                                                                translate-value-search=\"{{$select.search}}\"></span>\n                                                                        </div>\n                                                                    </ui-select-choices>\n                                                                </ui-select>\n                                                                <input type=\"text\" ng-readonly=\"true\"\n                                                                    class=\"form-control\"\n                                                                    ng-hide=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                                                    ng-disabled=\"true\" />\n                                                            </span>\n                                                            <div class=\"text-danger\"\n                                                                ng-show=\"variation.error.sizes[type.ID]\"\n                                                                ng-bind=\"variation.error.sizes[type.ID]\"></div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 mb24\">\n                                            <div class=\"width150\">\n                                                <label class=\"common-label mr6 v-top\" translate=\"stock_level_label\"></label>\n                                                <span ng-click=\"vm.openStockLevelInfo()\" class=\"question-icon question-button clickable\">\n                                                </span>\n                                                <div>\n                                                    <input type=\"text\"\n                                                           class=\"form-control\"\n                                                           only-num\n                                                           is-number=\"true\"\n                                                           ng-model=\"variation.stockQuantity\"\n                                                           ng-change=\"vm.productForm.$setDirty()\"\n                                                           ng-readonly=\"vm.waiting\"/>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12 mb24\">\n                                            <div class=\"clearfix radioGroup badgeCheck disableRadioCheckbox\">\n                                                <div ng-repeat=\"badge in variation.badges | removeWith:{ key: 0 }\"\n                                                    class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                                    <label for=\"badge_{{$parent.$index}}_{{$index}}\" ng-class=\"{'cursor-not-allowed': vm.isBadgeDisabled(badge, variation.badges, variation.specialOffer)}\">\n                                                        <input type=\"checkbox\"\n                                                            name=\"badge_{{$parent.$index}}_{{$index}}\"\n                                                            ng-click=\"vm.badgeClick(badge, variation.badges);vm.productForm.$setDirty();\"\n                                                            id=\"badge_{{$parent.$index}}_{{$index}}\"\n                                                            ng-disabled=\"vm.isBadgeDisabled(badge, variation.badges, variation.specialOffer)\"\n                                                            ng-model=\"badge.selected\">\n                                                        <span class=\"fa fa-check\"></span>\n                                                        <i ng-bind=\"badge.name\"\n                                                           ng-style=\"{'background-color':badge.color}\"\n                                                           ng-class=\"{'opacity-05 cursor-not-allowed': vm.isBadgeDisabled(badge, variation.badges, variation.specialOffer)}\"\n                                                        ></i>\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"!vm.isNfrnRetailer\">\n                                            <product-discount discount=\"variation.discount\" variation-id=\"variation.id\"\n                                                              is-disabled=\"variation.specialOffer\"\n                                                              on-discount-change=\"vm.changeVariationStaffDiscount(discountMessage)\">\n                                            </product-discount>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.isNfrnRetailer || vm.model.edit.variations.length == 1\">\n                                            <product-special-offer special-offer=\"variation.specialOffer\"\n                                                                   old-price=\"variation.price\"\n                                                                   currency-class=\"vm.currencyCssClass\"\n                                                                   is-read-only=\"vm.waiting\"\n                                                                   is-disabled=\"variation.discount\"\n                                                                   variation-id=\"variation.id\"\n                                                                   on-special-offer-changed=\"vm.onChangeSpecialOffer(specialOfferMessage)\">\n                                            </product-special-offer>\n                                        </div>\n                                        <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"\n                                             ng-if=\"variation.ingredients && variation.ingredients.length > 0\">\n                                                <product-variation-ingredients-list items=\"variation.ingredients\"\n                                                                                    ingredients=\"vm.model.edit.ingredientList\"\n                                                                                    is-take-away-price-disabled=\"!variation.price\"\n                                                                                    is-eat-in-price-disabled=\"!variation.insidePrice\"\n                                                                                    currency-class=\"vm.currencyCssClass\"\n                                                                                    on-ingredient-changed=\"vm.onIngredientChanged(item, variation)\">\n                                                </product-variation-ingredients-list>\n                                        </div>\n                                        <button ng-click=\"vm.copyVariation(variation)\" ng-disabled=\"vm.waiting\"\n                                            tooltip-popup-delay=\"200\" tooltip-placement=\"top\" uib-tooltip-html=\"'Copy'\"\n                                            translate translate-attr-uib-tooltip-html=\"tooltip_copy\"\n                                            class=\"closeAreaProducts copy\">\n                                            <span class=\"icon-copy-grey  inline-block mt10\"></span>\n                                        </button>\n                                        <button ng-hide=\"vm.model.edit.variations.length == 1\"\n                                            ng-click=\"vm.removeVariation(variation)\" ng-disabled=\"vm.waiting\"\n                                            tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                            uib-tooltip-html=\"vm.getTooltipText(variation)\" class=\"closeAreaProducts\">\n                                            <span class=\"icon-delete-grey  inline-block mt10\"></span>\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <span class=\"text-danger\" ng-show=\"vm.model.edit.error.variations\"\n                    ng-bind=\"vm.model.edit.error.variations\"></span>\n            </div>\n        </div>\n    </div>\n</div>\n\n<!--Extras-->\n<div class=\"row row-store\" ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\">\n    <div ng-show=\"vm.model.edit\" class=\"col-lg-12 fw\">\n        <div class=\"panel panel-products panel-edit panel-address-shop\">\n            <div class=\"panel-heading flex-align-start h-auto pr20\"\n                style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.12);\">\n                <span class=\"fs-18 ml20 text-bold\" translate=\"extra_list_label\"></span>\n            </div>\n            <!--Extras-->\n            <div class=\"extras\">\n                <div class=\"row form-horizontal\">\n                    <div class=\"panel-body overflowVisible advanced-product\">\n                        <product-extras-list items=\"vm.model.edit.extras\"></product-extras-list>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"row row-store\" ng-if=\"vm.model.edit\">\n    <div class=\"bottomButton mr14\">\n        <div class=\"pull-right\">\n            <div class=\"d-flex\">\n                <button ng-disabled=\"(vm.waiting || vm.productForm.$pristine) && !(vm.waiting && vm.productForm.$pristine)\"\n                        ng-click=\"vm.save()\"\n                        class=\"btn btn-success btn-with-icon flexVerticalAlignParent mr8\">\n                    <span class=\"plus-icon--tiny icon24 mr8\"></span>\n                    <span ng-bind=\"vm.state.saveTitle\"></span>\n                </button>\n                <button class=\"btn btn-danger btn-with-icon flexVerticalAlignParent\" ng-disabled=\"vm.waiting\" ng-click=\"vm.discard()\">\n                    <span class=\"close-icon-white--tiny icon24 mr8\"></span>\n                    <span translate=\"button_discard\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"variationColor\">\n    <div ng-show=\"vm.model.edit.colourName\"  class=\"flex-column\" >\n        <label class=\"width61 common-label\" translate=\"{{vm.model.edit.colourName}}\"></label>\n        <span class=\"mb20\">\n            <input type=\"text\" ng-model=\"variation.color\" ng-readonly=\"vm.waiting\" class=\"form-control\" ng-change=\"vm.productForm.$setDirty();\" />\n        </span>\n        <div class=\"text-danger mt-20 pl48\" ng-show=\"variation.error.color\" ng-bind=\"variation.error.color\"></div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"variationSize\">\n    <div class=\"flex-column\">\n    <label class=\"width61 common-label\" translate=\"{{vm.model.edit.sizeName}}\">\n        </label>\n        <span class=\"mb20\">\n            <input type=\"text\" ng-model=\"variation.size\" ng-readonly=\"vm.waiting\" class=\"form-control\"  ng-change=\"vm.productForm.$setDirty();\"/>\n        </span>\n        <div class=\"text-danger\" ng-show=\"variation.error.size\" ng-bind=\"variation.error.size\"></div>\n    </div>\n</script>\n";

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<div class=\"imgProducts\">\n    <div class=\"imgProductsInner\">\n        <!-- ngIf: variation.imagesID.length > 0 -->\n        <img ng-if=\"vm.images.length > 0\" ng-src=\"{{vm.images[0].url}}\" class=\"ng-scope\" src=\"xxxHTMLLINKxxx0.78057294591923940.55172139487552xxx\"><!-- end ngIf: variation.imagesID.length > 0 -->\n    </div>\n</div>\n<div class=\"maxImagesCont\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.images\" ng-style=\"{width: vm.images.length*110}\">\n    <div ng-repeat=\"image in vm.images\"\n         dnd-draggable=\"image\"\n         dnd-effect-allowed=\"move\"\n         class=\"imgProducts smaller\">\n        <div class=\"imgProductsInner\">\n            <img ng-src=\"{{image.url}}\" alt=\"\" />\n        </div>\n        <span class=\"fa fa-chevron-left\"></span>\n        <span class=\"fa fa-chevron-right\"></span>\n        <span class=\"fa fa-trash\" ng-click=\"vm.deleteImage(image)\"></span>\n    </div>\n    <div class=\"addElement\">\n        <div class=\"mt8\">\n            <span>\n                <ng-container translate=\"add_a_photo\"></ng-container>\n                <em class=\"fa fa-plus\"></em>\n            </span>\n            <input type=\"file\" id=\"{{'imageInput' + vm.imageInputId}}\" ng-disabled=\"vm.waiting\" img-filereader max-size-mb=\"5\" min-width=\"120\" min-height=\"120\"  file-extensions=\"vm.fileExtensions\" accept=\".png,image/gif,image/jpeg\" multiple ng-model=\"vm.uploadedImages\" callback=\"vm.uploadImages()\" />\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "\n<div  ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.images\">\n    <div ng-repeat=\"image in vm.images\"\n         dnd-draggable=\"image\"\n         dnd-effect-allowed=\"move\"\n         class=\"imgProducts smaller imgProductsWizard\">\n        <div class=\"imgProductsInner\">\n            <img ng-src=\"{{image.url}}\" alt=\"\" />\n        </div>\n        <span class=\"fa fa-chevron-left\"></span>\n        <span class=\"fa fa-chevron-right\"></span>\n        <span class=\"fa fa-trash\" ng-click=\"vm.deleteImage(image)\"></span>\n    </div>\n    <div class=\"addElement\">\n        <div>\n            <span class=\"add-image-width-border-icon inline-block\"></span>\n            <input type=\"file\" ng-disabled=\"vm.waiting\" img-filereader max-size-mb=\"5\" min-width=\"120\"\n                min-height=\"120\" file-extensions=\"vm.fileExtensions\" accept=\".png,image/gif,image/jpeg\" multiple ng-model=\"vm.uploadedImages\" callback=\"vm.uploadImages()\" />\n         </div>\n    </div>\n</div>\n\n<style  type=\"text/css\">\n    /*fix of strange top position of draggable element */\n    body {\n        overflow-x: initial;\n    }\n</style>\n";

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dpp-info-dialog d-flex flex-column\" ng-if=\"ctrl.resolve\">\n    <div class=\"dpp-info-dialog-header\" ng-bind=\"ctrl.resolve.title\"></div>\n    <div class=\"dpp-info-dialog-content\" ng-bind=\"ctrl.resolve.message\"></div>\n    <div class=\"dpp-info-dialog-footer d-flex justify-content-end\">\n        <button translate=\"ok\" class=\"btn\" ng-click=\"ctrl.onClose()\"></button>\n    </div>\n</div>\n";

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dpp-info-dialog d-flex flex-column\">\n    <div class=\"dpp-info-dialog-header mb24\" translate=\"save_as_a_draft\"></div>\n    <div class=\"dpp-info-dialog-content mb8\">\n        <div class=\"mb16\" translate=\"the_product_will_be_saved_as_draft\"></div>\n        <ul class=\"pl16\">\n            <li class=\"mb16\" ng-repeat=\"item in ctrl.resolve.items\" ng-bind=\"item\"></li>\n        </ul>\n    </div>\n    <div class=\"dpp-info-dialog-drafts-footer d-flex justify-content-end\">\n        <button class=\"btn dpp-info-dialog-drafts-footer-gray-button mr8\" translate=\"complete_the_fields\" ng-click=\"ctrl.onClose()\"></button>\n        <button class=\"btn dpp-info-dialog-drafts-footer-green-button\" translate=\"save_draft\" ng-click=\"ctrl.onSave()\"></button>\n    </div>\n</div>\n";

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div class=\"editDiscountForm\">\n    <div class=\"chooseVarProd\">\n        <div class=\"editDiscountForm__body form-horizontal\">\n            <product-discount discount=\"vm.variation.discount\" variation-id=\"vm.variation.id\"\n                on-discount-change=\"vm.changeVariationStaffDiscount(discountMessage)\">\n            </product-discount>\n        </div>\n        <div class=\"editDiscountForm__footer\">\n            <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.cancelDiscount()\"\n                class=\"btn bg-dark12 btn-with-icon mr8 color-black54\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_cancel\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"vm.saveVariationStaffDiscount(product, variation)\" ng-disabled=\"vm.waiting\"\n                class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"button_save\"></span>\n            </button>\n        </div>\n    </div>\n</div>";

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "<div class=\"editPriceForm\">\n    <div class=\"chooseVarProd\" ng-class=\"{'sm-form': !vm.variation.isFoodType,\n        'md-form': vm.variation.isFoodType}\">\n        <div class=\"editPriceForm__body\" ng-if=\"!vm.variation.isFoodType\" ng-include=\"'nonFoodProductTemplate'\"></div>\n        <div class=\"editPriceForm__body\" ng-if=\"vm.variation.isFoodType\" ng-include=\"'foodProductTemplate'\"></div>\n        <div class=\"editPriceForm__footer\">\n            <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.cancelPrice()\"\n                class=\"btn bg-dark12 btn-with-icon mr8 color-black54\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_cancel\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"vm.changeVariationPrice()\" ng-disabled=\"vm.waiting\"\n                class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"button_save\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"foodProductTemplate\">\n    <div class=\"mb24 flex-column width148 mr24 posRel\">\n        <label class=\"form_group_label\" translate=\"takeaway_price\"></label>\n        <span class=\"{{vm.currentCurrencyClass}}\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.price\"\n                ng-class=\"vm.variation.error.noPrice? 'input-validation__field--invalid': ''\"\n                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n        </span>\n        <div class=\"text-danger text-nowrap mt-10\" ng-show=\"vm.variation.error.noPrice\"\n            translate=\"price_must_be_greater_than_0\"></div>\n    </div>\n    <div class=\"mb24 flex-column width148 mr24\">\n        <label class=\"form_group_label\" translate=\"takeaway_VAT\"></label>\n        <span class=\"withPercent\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.vat\" ng-readonly=\"vm.waiting\"\n                class=\"form-control\" />\n        </span>\n    </div>\n    <div class=\"mb24 flex-column width148 posRel\">\n        <label class=\"form_group_label\" translate=\"old_takeaway_price\"></label>\n        <span class=\"{{vm.currentCurrencyClass}}\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.oldPrice\"\n                ng-class=\"vm.variation.error.oldPriceIsSmall? 'input-validation__field--invalid': ''\"\n                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n        </span>\n        <div class=\"text-danger text-danger_fix mt-10\" ng-show=\"vm.variation.error.oldPriceIsSmall\"\n            translate=\"oldprice_must_be_greater_than_the_current_price\"\n            translate-values=\"{ priceType: 'takeaway' }\"></div>\n    </div>\n    <div class=\"mb24 flex-column width148 mr24 posRel\">\n        <label class=\"form_group_label\" translate=\"eat_in_price\"></label>\n        <span class=\"{{vm.currentCurrencyClass}}\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.insidePrice\"\n                ng-change=\"vm.variation.error.takeawayGreatEatIn && vm.clearEatInTakeawayError(vm.variation)\"\n                ng-class=\"vm.variation.error.takeawayGreatEatIn? 'input-validation__field--invalid': ''\"\n                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n        </span>\n        <div class=\"text-danger text-nowrap p0 m0\" ng-if=\"vm.variation.error.takeawayGreatEatIn\"\n            translate=\"eatIn_must_be_greater_takeAway\"></div>\n    </div>\n    <div class=\"mb24 flex-column width148\">\n        <label class=\"form_group_label\" translate=\"eat_in_VAT\"></label>\n        <span class=\"withPercent\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.insideVAT\" ng-disabled=\"vm.waiting || !vm.variation.insidePrice || vm.variation.insidePrice == 0\n                || vm.variation.error.takeawayGreatEatIn\" class=\"form-control\" />\n        </span>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"nonFoodProductTemplate\">\n    <div class=\"width148 mb24 flex-column mr24 posRel\">\n        <label class=\"form_group_label\" translate=\"field_price\"></label>\n        <span class=\"{{vm.currentCurrencyClass}}\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.price\"\n                ng-class=\"vm.variation.error.noPrice? 'input-validation__field--invalid': ''\"\n                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n        </span>\n        <div class=\"text-danger text-nowrap mt-10\" ng-show=\"vm.variation.error.noPrice\"\n            translate=\"price_must_be_greater_than_0\"></div>\n    </div>\n    <div class=\"width148 mb24 flex-column\">\n        <label class=\"form_group_label\" translate=\"VAT\"></label>\n        <span class=\"withPercent\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.vat\" ng-readonly=\"vm.waiting\"\n                class=\"form-control\" />\n        </span>\n    </div>\n    <div class=\"width148 mb24 flex-column posRel\">\n        <label class=\"form_group_label\" translate=\"old_price\"></label>\n        <span class=\"{{vm.currentCurrencyClass}}\">\n            <input type=\"text\" only-decimal ng-model=\"vm.variation.oldPrice\"\n                ng-class=\"vm.variation.error.oldPriceIsSmall? 'input-validation__field--invalid': ''\"\n                ng-readonly=\"vm.waiting\" class=\"form-control\" />\n        </span>\n        <div class=\"text-danger text-nowrap mt-10\" ng-show=\"vm.variation.error.oldPriceIsSmall\"\n            translate=\"oldprice_must_be_greater_than_the_current_price\"\n            translate-values=\"{ priceType: 'current' }\"></div>\n    </div>\n</script>";

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<div class=\"editStockLevelForm\">\n    <div class=\"chooseVarProd\">\n        <div class=\"editStockLevelForm__body\">\n            <label class=\"common-label mr6 v-top\" translate=\"stock_level_label\"></label>\n            <div>\n                <input type=\"text\"\n                       class=\"form-control\"\n                       only-num\n                       is-number=\"true\"\n                       ng-model=\"vm.stockLevel\"\n                       ng-readonly=\"vm.waiting\"/>\n            </div>\n        </div>\n        <div class=\"editStockLevelForm__footer\">\n            <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.cancel()\"\n                    class=\"btn bg-dark12 btn-with-icon mr8 color-black54\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_cancel\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"vm.waiting\"\n                    class=\"btn btn-success btn-with-icon\">\n                <em class=\"fa fa-check\"></em>\n                <span translate=\"button_save\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header black-header\">\n    <div class=\"pull-right\">\n        <div class=\"btn-form btn-form-header clearfix\">\n            <button type=\"button\" ng-click=\"$ctrl.confirm()\" class=\"btn btn-success btn-with-line\">\n                <em class=\"fa fa-check\"></em>\n                <span ng-show=\"$ctrl.getSelectedCount() < 1\" translate=\"button_add\"></span>\n                <span ng-show=\"$ctrl.getSelectedCount() > 0\"\n                    translate=\"button_add_count\"\n                    translate-value-count=\"{{ $ctrl.getSelectedCount() }}\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"$ctrl.dismiss()\" class=\"btn btn-danger btn-with-line\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_discard\"></span>\n            </button>\n        </div>\n    </div>\n    <div class=\"btn-form modal-title\" translate=\"add_product_title\">\n    </div>\n</div>\n\n<div class=\"modal-body panel-campaign-choice product-search\">\n    <div class=\"posRel searchInput z50 mt20 mb20\" ng-if=\"$ctrl.categories.enabled\">\n        <div class=\"w-100 fs-14 mb4\" translate=\"category\"></div>\n        <ui-select class=\"w-100 product-category-select\" ng-model=\"$ctrl.categories.selected\" reset-search-input=\"true\" theme=\"bootstrap\">\n            <ui-select-match>{{$select.selected.SingleForm }}</ui-select-match>\n            <ui-select-choices repeat=\"type in $ctrl.categories.list\">\n                {{type.SingleForm}}\n            </ui-select-choices>\n        </ui-select>\n    </div>\n\n    <!-- search -->\n    <div  class=\"mb10 mt10\">\n        <search placeholder-text=\"$ctrl.$translate.instant('search_for_product')\"\n                text=\"$ctrl.searchTerm\"\n                classes=\"'white-theme'\"\n                disabled=\"$ctrl.waiting\"\n                on-search-click=\"$ctrl.search(searchText)\"\n                on-clear-click=\"$ctrl.resetSearch()\">\n        </search>\n    </div>\n\n    <div class=\"pl5 pr5 product-search__wrap\">\n        <table class=\"full-width product-search__table\">\n            <tbody>\n                <tr ng-repeat=\"product in $ctrl.pagination.data\" class=\"clickable\" ng-click=\"$ctrl.selectProduct(product)\" ng-class=\"{ 'active': product.IsSelected }\">\n                    <td class=\"wd-xxs pr10 pb10 pt10 pl15\" height=\"80px\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded m0\">\n                            <label for=\"checkbox_{{::product.productId}}\">\n                                <input id=\"checkbox_{{::product.productId}}\" ng-checked=\"product.isSelected\" type=\"checkbox\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.selectProduct(product)\"/>\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                    </td>\n                    <td class=\"pr15 pb10 wd-xxs pt10 pl15 text-center\">\n                        <img ng-src=\"{{::product.imageUrl}}\"/>\n                    </td>\n                    <td width=\"100%\" class=\"pr15 pb10 pt10 pl15\">\n                        <div>{{::product.title}}</div>\n                    </td>\n                    <td class=\"wd-sd pb10 pt10 pl15 pr15 text-right\">\n                        <span ng-show=\"product.oldPrice\">\n                            <span class=\"text-nowrap inactiveProduct\">{{::product.oldPrice | formatCurrency:$ctrl.countryID}}</span>&nbsp;<span>{{::product.maxPrice | formatCurrency:$ctrl.countryID}}</span>\n                        </span>\n                        <span ng-show=\"!product.oldPrice\">\n                            <span class=\"text-nowrap\" ng-show=\"product.minPrice != product.maxPrice\">{{::product.minPrice | formatCurrency:$ctrl.countryID}} - {{::product.maxPrice | formatCurrency:$ctrl.countryID}}</span>\n                            <span class=\"text-nowrap\" ng-show=\"product.minPrice == product.maxPrice\">{{::product.minPrice | formatCurrency:$ctrl.countryID}}</span>\n                        </span>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class=\"panel-footer footer-padinationSmaller bt0 pt15 pb5\" ng-if=\"$ctrl.pagination.total > $ctrl.pagination.pageSize\">\n        <ul uib-pagination ng-disabled=\"$ctrl.waiting\" ng-change=\"$ctrl.loadData()\" total-items=\"$ctrl.pagination.total\" items-per-page=\"$ctrl.pagination.pageSize\" ng-model=\"$ctrl.pagination.page\" previous-text=\"«\" next-text=\"»\" max-size=\"5\" boundary-link-numbers=\"true\" />\n    </div>\n</div>\n";

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 ng-scope productHeader\">\n    <span ng-class=\"{'activefilter': vm.settings.productState !== vm.enums.PhysicalProductState.NotArchived}\"\n        ng-click=\"vm.settings.settingsClear(vm.enums.PhysicalProductState.NotArchived)\">\n        <span translate=\"products\"></span>\n    </span>\n    <span ng-if=\"!vm.isNfrnRetailer\" ng-class=\"{'activefilter': vm.settings.productState !== vm.enums.PhysicalProductState.Archived}\"\n        ng-show=\"vm.settings.isExistArchiveProducts\"\n        ng-click=\"vm.settings.settingsClear(vm.enums.PhysicalProductState.Archived)\" translate=\"archived_products\">\n    </span>\n    <span ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\" class=\"activefilter\" ng-click=\"vm.goToImport()\" translate=\"product_import\"></span>\n\n    <div class=\"export-csv-block\" ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\">\n        <button type=\"button\" ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\"\n                ng-disabled=\"vm.waiting\"\n                class=\"btn btn-success h40 btn-with-icon flexVerticalAlignParent exportCsv\"\n                ng-click=\"vm.exportcsv()\">\n            <div class=\"export-icon mr8\"></div>\n            <span class=\"divider\"></span>\n            <span class=\"fs-14 fw-500 lh16 ls-031\" translate=\"button_export_csv\"></span>\n        </button>\n    </div>\n\n    <button ng-if=\"vm.isPublisher && vm.settings.productState !== vm.enums.PhysicalProductState.Archived\" ui-sref=\"app.product.new\" type=\"button\" class=\"btn btn-success dpp-add-product-button\">\n        <div class=\"d-flex align-items-center\">\n            <span class=\"icon mr8\"></span>\n            <span class=\"text\" translate=\"add_a_product\"></span>\n        </div>\n    </button>\n    <div ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\" class=\"headerButton\">\n        <div class=\"choiceAddProduct pull-right \"\n            ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\">\n            <div uib-dropdown class=\"input-group-btn\">\n                <button type=\"button\" uib-dropdown-toggle ng-disabled=\"vm.waiting\"\n                    class=\"btn btn-success dropdown-toggle h40\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                    <span class=\"fs-14 fw-500 lh16 ls-031\" translate=\"button_add_a_product\"></span>\n                    <span class=\"caret\"></span>\n                </button>\n                <ul class=\"dropdown-menu\">\n                    <li>\n                        <a ui-sref=\"app.product.new-wizard\" translate=\"wizard\"></a>\n                    </li>\n                    <li>\n                        <a ui-sref=\"app.product.new\" translate=\"advanced\"></a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row  marginRowMinus\">\n    <div class=\"col-lg-12\">\n        <div class=\"productsSearch\" ng-show=\"vm.settings.isShowFilter()\">\n            <table>\n                <tr>\n                    <td>\n                        <search class=\"search-no-margin\" placeholder-text=\"'search_products' | translate\"\n                                text=\"vm.settings.productFilter\"\n                                on-search-click=\"vm.applyFilter(searchText)\"\n                                on-clear-click=\"vm.resetSearch()\">\n                        </search>\n                    </td>\n                    <td>\n                        <span class=\"sort-by-text mr8\" translate=\"sort_by\"></span>\n                    </td>\n                    <td class=\"selectSortProd\">\n                        <div uib-dropdown class=\"input-group-btn\" on-toggle=\"vm.filterExpanded = !vm.filterExpanded\">\n                            <button type=\"button\" uib-dropdown-toggle class=\"btn\"\n                                aria-haspopup=\"true\" aria-expanded=\"false\">\n                                <div class=\"button-content d-flex align-items-center justify-content-between\">\n                                    <div class=\"d-flex align-items-center\">\n                                        <span class=\"sort-icon-size mr8\" ng-class=\"vm.settings.sort.classSort\"></span>\n                                        <span ng-bind=\"vm.settings.sort.title\"></span>\n                                    </div>\n                                    <span class=\"arrow\" ng-class=\"{'arrow-rotated': vm.filterExpanded}\"></span>\n                                </div>\n                            </button>\n                            <ul class=\"dropdown-menu dropdown-menu-items\">\n                                <li ng-repeat=\"sort in vm.settings.sortSet\"\n                                    ng-click=\"vm.settings.sort = sort;vm.applyFilter(vm.settings.productFilter)\">\n                                    <div class=\"dropdown-item d-flex align-items-center\">\n                                        <span class=\"sort-icon-size mr8\" ng-class=\"sort.classSort\"></span>\n                                        <span class=\"dropdown-item-text\" ng-bind=\"sort.title\"></span>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n        <div class=\"panel panel-info mb20\" ng-repeat=\"product in vm.data.Items\">\n            <div class=\"panel-body\">\n                <div class=\"productsWrap\">\n                    <h2 ng-hide=\"product.Draft\" ng-bind=\"product.Title\" class=\"pr120\"></h2>\n                    <h2 ng-show=\"product.Draft\" class=\"colorOrange pr120\">\n                        <span class=\"draftProduct\" translate=\"draft\"></span>&nbsp;\n                        <span ng-bind=\"product.Title\"></span>\n                    </h2>\n                    <div class=\"text-right controlProducts\"\n                        ng-hide=\"vm.settings.productState === vm.enums.PhysicalProductState.Archived\">\n                        <span ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\" off-click=\"editToggle = false\" ng-class=\"{'open' : editToggle}\">\n                            <em ng-click=\"editToggle = !editToggle\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                translate-attr-uib-tooltip-html=\"tooltip_edit\" class=\"fa edit-icon icon24 opacity54\"></em>\n                            <span class=\"chooseVarProd\">\n                                <span ui-sref=\"app.product.edit-wizard({id:product.ID})\" translate=\"wizard\"></span>\n                                <span ui-sref=\"app.product.edit({id:product.ID})\" translate=\"advanced\"></span>\n                            </span>\n                        </span>\n                        <span ng-if=\"vm.isNfrnRetailer || vm.isPublisher\" class=\"fa edit-icon icon24 opacity54\" ui-sref=\"app.product.edit({id:product.ID})\"></span>\n                        <span ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\" off-click=\"copyToggle = false\" ng-class=\"{'open' : copyToggle}\">\n                            <em ng-click=\"copyToggle = !copyToggle\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                                translate-attr-uib-tooltip-html=\"tooltip_copy\" class=\"fa icon-files icon24\"></em>\n                            <span class=\"chooseVarProd\">\n                                <span ng-if=\"!vm.isPublisher\" ui-sref=\"app.product.copy-wizard({id:product.ID})\" translate=\"wizard\"></span>\n                                <span ui-sref=\"app.product.copy({id:product.ID})\" translate=\"advanced\"></span>\n                            </span>\n                        </span>\n                        <span ng-if=\"vm.isPublisher\" class=\"fa icon-files icon24\" ui-sref=\"app.product.copy({id:product.ID})\"></span>\n                        <em ng-if=\"!vm.isNfrnRetailer\" ng-click=\"vm.archive(product)\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n                            uib-tooltip-html=\"'Archive'\" translate-attr-uib-tooltip-html=\"tooltip_archive\"\n                            class=\"fa icon-trashcan-outline changePadToMarg icon24 opacity54\"></em>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"col-lg-12 col-md-12 col-sm-12  col-xs-12\">\n                            <div class=\"variationsWrap\" ng-show=\"product.ProductVariations.length > 0\">\n                                <table ng-repeat=\"variation in  product.ProductVariations\" class=\"tableProduct\">\n                                    <tr>\n                                        <td class=\"tableProdImg width1\">\n                                            <div class=\"tableProdImgInner\">\n                                                <img ng-if=\"variation.ImagesID.length > 0\"\n                                                    ng-src=\"{{vm.getImage(variation.ImagesID)}}\" alt=\"\" />\n                                            </div>\n                                        </td>\n                                        <td width=\"25%\">\n                                            <div>\n                                                <div class=\"clearfix\">\n                                                    <!--<div ng-show=\"variation.Size\" class=\"clearfix mb11  pull-left\"><b>Size</b> <span ng-bind=\"variation.Size\"></span></div>-->\n                                                    <div ng-show=\"product.ColourName && variation.Colour\"\n                                                        class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"{{product.ColourName}}\"></b>\n                                                        <span ng-bind=\"variation.Colour\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.SKU\" class=\"mb11\">\n                                                        <b translate=\"sku\"></b>\n                                                        <span class=\"variationSKU\" ng-bind=\"variation.SKU\"></span>\n                                                    </div>\n                                                </div>\n                                                <div ng-show=\"product.SizeName\" class=\"clearfix\">\n                                                    <div ng-show=\"variation.Size\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"{{product.SizeName}}\"></b>\n                                                        <span ng-bind=\"variation.Size\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.NeckSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"neck_size\"></b>\n                                                        <span ng-bind=\"variation.NeckSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.ChestSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"chest_size\"></b>\n                                                        <span ng-bind=\"variation.ChestSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.BustSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"bust_size\"></b>\n                                                        <span ng-bind=\"variation.BustSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.WaistSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"waist_size\"></b>\n                                                        <span ng-bind=\"variation.WaistSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.HipsSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"hips_size\"></b>\n                                                        <span ng-bind=\"variation.HipsSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.InsideLegSize\"\n                                                        class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"inside_leg_size\"></b>\n                                                        <span ng-bind=\"variation.InsideLegSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.ShoeSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"shoe_size\"></b>\n                                                        <span ng-bind=\"variation.ShoeSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.LegLengthSize\"\n                                                        class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"leg_length\"></b>\n                                                        <span ng-bind=\"variation.LegLengthSize\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.DressSize\" class=\"mb11\">\n                                                        <b class=\"width87\" translate=\"dress_size\"></b>\n                                                        <span ng-bind=\"variation.DressSize\"></span>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div ng-if=\"variation.badges && variation.badges.length > 0\">\n                                                <span ng-repeat=\"badge in variation.badges | removeWith:{ key: 0 }\">\n                                                    <span class=\"p2-5 badgeBlock\" ng-bind=\"badge.name\"\n                                                        ng-style=\"{'background-color':badge.color, 'color':badge.textcolor}\"></span>\n                                                </span>\n                                            </div>\n                                        </td>\n                                        <td class=\"priceTd\" width=\"20%\" ng-if=\"!vm.isPublisher\">\n                                            <product-edit-price\n                                                ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived && variation.isOpenEditPrice\"\n                                                variation=\"variation\" product=\"product\" waiting=\"vm.waiting\"\n                                                on-price-change=\"vm.savePrice(changedPrice)\"\n                                                on-cancel-price=\"vm.cancelPrice(value)\">\n                                            </product-edit-price>\n                                            <div class=\"mb12 text-nowrap\" translate=\"extra_list_column_price\"></div>\n                                            <div class=\"d-flex d-flex justify-content-between max-w140\">\n                                                <div class=\"mr15\">\n                                                    <div class=\"price\">\n                                                        <span class=\"text-nowrap\"\n                                                            ng-bind=\"variation.Price | formatCurrency:vm.countryID\"></span>\n                                                    </div>\n                                                    <div ng-show=\"variation.OldPrice\" class=\"oldPrice\">\n                                                        <span class=\"text-nowrap\"\n                                                            ng-bind=\"variation.OldPrice | formatCurrency:vm.countryID\"></span>\n                                                    </div>\n                                                </div>\n                                                <button ng-click=\"vm.openEditPrice(product, variation)\"\n                                                        ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived && !vm.isNfrnRetailer && !variation.SpecialOffer\"\n                                                        ng-hide=\"variation.IngredientsCount && variation.IngredientsCount > 0\"\n                                                        class=\"btn btn-link table_edit_btn\"\n                                                        ng-class=\"{'table_edit_btn__hover': variation.isOpenEditPrice}\">\n                                                    <span class=\"fa edit-icon icon24\"></span>\n                                                </button>\n                                            </div>\n                                        </td>\n                                        <td class=\"discountTd\" width=\"20%\" ng-if=\"!vm.isNfrnRetailer && !vm.isPublisher\">\n                                            <product-edit-discount\n                                                ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived && variation.isOpenEditDiscount \"\n                                                variation=\"variation\" product=\"product\" waiting=\"vm.waiting\"\n                                                on-discount-change=\"vm.saveDiscount(changedDiscount)\"\n                                                on-cancel-discount=\"vm.cancelDiscount(value)\">\n                                            </product-edit-discount>\n                                            <div uib-tooltip=\"{{::'incompatible_with_an_active_offer' | translate}}\"\n                                                tooltip-placement=\"top\"\n                                                tooltip-enable=\"variation.SpecialOffer\">\n                                                <div class=\"mb12 text-nowrap\" translate=\"product_discount_title\"></div>\n                                                <div class=\"d-flex justify-content-between width100\">\n                                                    <div class=\"price\">\n                                                        <span ng-show=\"!variation.Discount\" class=\"text-nowrap\"\n                                                            translate=\"product_discount_none\"></span>\n                                                        <span ng-show=\"variation.Discount === 100\" class=\"text-nowrap\"\n                                                            translate=\"product_discount_free\"></span>\n                                                        <span ng-show=\"variation.Discount && variation.Discount !== 100\"\n                                                            class=\"text-nowrap\"\n                                                            ng-bind-template=\"{{variation.Discount}} %\"></span>\n                                                    </div>\n                                                    <button ng-click=\"vm.openEditDiscount(variation)\"\n                                                        ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived && !variation.SpecialOffer\"\n                                                        class=\"btn btn-link table_edit_btn\"\n                                                        ng-class=\"{'table_edit_btn__hover': variation.isOpenEditDiscount}\">\n                                                        <span class=\"fa edit-icon icon24\"></span>\n                                                    </button>\n                                                </div>\n                                            </div>\n                                        </td>\n                                        <td class=\"stockLevel\" width=\"20%\" ng-if=\"!vm.isPublisher\">\n                                            <div ng-if=\"variation.StockQuantity != null\">\n                                                <product-edit-stock-level\n                                                    ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived && variation.isOpenEditStockLevel\"\n                                                    product-id=\"product.ID\"\n                                                    variation-id=\"variation.ID\"\n                                                    stock-level=\"variation.StockQuantity\"\n                                                    waiting=\"vm.waiting\"\n                                                    on-save=\"vm.saveStockLevel(productId, variationId, stockLevel)\"\n                                                    on-cancel=\"vm.cancelStockLevel()\">\n                                                </product-edit-stock-level>\n                                                <div class=\"mb12 text-nowrap\" translate=\"stock_level_label\"\n                                                     ng-class=\"{'color-red': variation.StockQuantity <= variation.StockLevelThreshold}\"></div>\n                                                <div class=\"d-flex justify-content-between width100\">\n                                                    <div class=\"price\" ng-class=\"{'color-red': variation.StockQuantity <= variation.StockLevelThreshold}\">\n                                                        <span class=\"text-nowrap\">{{variation.StockQuantity}}</span>\n                                                    </div>\n                                                    <button ng-click=\"vm.openEditStockLevel(variation)\"\n                                                            ng-if=\"vm.settings.productState != vm.enums.PhysicalProductState.Archived\"\n                                                            class=\"btn btn-link table_edit_btn\"\n                                                            ng-class=\"{'table_edit_btn__hover': variation.isOpenEditStockLevel}\">\n                                                        <span class=\"fa edit-icon icon24\"></span>\n                                                    </button>\n                                                </div>\n                                            </div>\n                                        </td>\n                                        <td width=\"18%\" ng-if=\"vm.isPublisher\"></td>\n                                        <td width=\"19%\" ng-if=\"vm.isPublisher\">\n                                            <div class=\"d-flex flex-column\">\n                                                <div class=\"dpp-price-title mb8\" translate=\"extra_editor_price\"></div>\n                                                <div class=\"dpp-price\" translate=\"extra_free_price\"></div>\n                                            </div>\n                                        </td>\n                                        <td ng-if=\"vm.isPublisher\">\n                                            <div class=\"d-flex flex-column\" ng-if=\"variation.IsAccessibleOutOfSession\">\n                                                <div class=\"mb24\"></div>\n                                                <div class=\"dpp-price\" translate=\"unlimited_reading_time\"></div>\n                                            </div>\n                                        </td>\n                                        <td class=\"descr\" align=\"right\">\n                                            <div ng-click=\"vm.restoreVariation(product, variation)\"\n                                                class=\"text-right controlProducts\"\n                                                ng-hide=\"vm.settings.productState !== vm.enums.PhysicalProductState.Archived\">\n                                                <span class=\"fs-13 \">\n                                                    <em class=\"fa fa-rotate-left\"></em>\n                                                    <span translate=\"restore\"></span>\n                                                </span>\n                                            </div>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </div>\n                            <!--<div ng-hide=\"product.ProductVariations.length > 0\" class=\"text-danger noneVariations\"><b>You do not have variations</b></div>-->\n                        </div>\n                    </div>\n                    <div ng-show=\"product.Description || product.ClassificationCategory\" class=\"row posRel showLess\">\n\n                        <div ng-class=\"showLess ? 'visible' : 'invisible'\">\n                            <div class=\"showMoreProduct\"\n                                ng-show=\"product.Brand || product.Description || product.ClassificationCategory || product.ProductLinks.length > 0 || product.ProductTags.length > 0\">\n                                <div>\n                                    <h2 ng-show=\"product.Draft\" class=\"colorOrange\">\n                                        <span class=\"draftProduct\" translate=\"draft\"></span>&nbsp;\n\n                                        <span ng-bind=\"product.Title\"></span>\n                                    </h2>\n                                    <div ng-show=\"product.Brand\" class=\"brandTittle clearfix\">\n                                        <b translate=\"brand\"></b>\n                                        <div>\n                                            <brand-status brand=\"product.Brand\"></brand-status>\n                                        </div>\n                                    </div>\n                                    <div ng-show=\"product.Description\" class=\"brandTittle clearfix\">\n                                        <b translate=\"description\"></b>\n                                        <div class=\" posRel\">\n                                            <div class=\"showmore_one wysiwyg__main\" ng-bind-html=\"product.Description\">\n\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div ng-show=\"product.ClassificationCategory\" class=\"brandTittle  clearfix\">\n                                        <b translate=\"category\"></b>\n                                        <div ng-bind=\"product.ClassificationCategory.FullName\"></div>\n                                    </div>\n                                    <div ng-show=\"product.ItemType\" class=\"brandTittle  clearfix\">\n                                        <b translate=\"item_type\"></b>\n                                        <div>{{product.ItemType}}</div>\n                                    </div>\n                                    <div ng-show=\"product.Gender\" class=\"brandTittle  clearfix\">\n                                        <b translate=\"gender\"></b>\n                                        <div>{{product.Gender}}</div>\n                                    </div>\n                                    <div ng-show=\"product.ProductLinks && product.ProductLinks.length > 0\"\n                                        class=\"brandTittle  clearfix\">\n                                        <b translate=\"product_links_and_social_networks\"></b>\n                                        <div class=\"socialLinkWrap\">\n                                            <div class=\"socialLinkSingle\" ng-repeat=\"link in product.ProductLinks\">\n                                                <span class=\"fa {{link.viewClass}}\"></span>\n                                                <div>{{link.Title}}</div>\n                                                <div>\n                                                    <a target=\"_blank\" ng-href=\"{{link.Url}}\">{{link.Url}}</a>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </div>\n\n                        <div ng-click=\"showLess = !showLess\" class=\"inline-block p10\">\n                            <span class=\"showLess__btn\" ng-class=\"showLess ? 'invisible' : 'visible'\">\n                                <span translate=\"show_more\"></span>\n                                <i class=\"fa fa-caret-down\"></i>\n                            </span>\n                            <span class=\"showLess__btn\" ng-class=\"showLess ? 'visible' : 'invisible'\">\n                                <span translate=\"show_less\"></span>\n                                <i class=\"fa fa-caret-up\"></i>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"table emptyMessage\" ng-style=\"{ 'height': (vm.viewport.height) -260 + 'px'}\"\n            ng-if=\"vm.settings.isExistActiveProducts != null && vm.settings.isExistArchiveProducts != null\"\n            ng-hide=\"vm.settings.isExistActiveProducts || vm.settings.isExistArchiveProducts\">\n            <div class=\"td\">\n                <h4 translate=\"have_no_products\"></h4>\n            </div>\n        </div>\n        <div class=\"table emptyMessage\" ng-style=\"{ 'height': (vm.viewport.height) -260 + 'px'}\"\n            ng-if=\"!vm.settings.isExistActiveProducts && vm.settings.isExistArchiveProducts && vm.settings.productState === vm.enums.PhysicalProductState.Archived \">\n            <div class=\"td\">\n                <h4 translate=\"have_no_active_products\"></h4>\n            </div>\n        </div>\n        <div class=\"panel-footer footer-padinationSmaller\" ng-if=\"vm.data.Total > vm.settings.pageSize\">\n            <ul uib-pagination total-items=\"vm.data.Total\" template-url=\"custompagination.html\"\n                items-per-page=\"vm.settings.pageSize\" ng-model=\"vm.settings.page\" previous-text=\"«\" next-text=\"»\"\n                max-size=\"10\" boundary-link-numbers=\"true\" ng-change=\"vm.search()\" />\n        </div>\n    </div>\n</div>\n<script id=\"custompagination.html\" type=\"text/ng-template\">\n    <ul class=\"pagination\">\n        <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious() || ngDisabled}\" class=\"pagination-first\"><a ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n        <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious() || ngDisabled}\" class=\"pagination-prev\"><a ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n        <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active, disabled: ngDisabled && !page.active}\" class=\"pagination-page\"><a ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n        <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext() || ngDisabled}\" class=\"pagination-next\"><a ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n        <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext() || ngDisabled}\" class=\"pagination-last\"><a ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n    </ul>\n</script>\n";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"vm.cancel()\">×</button>\n    <h4 class=\"modal-title\" translate=\"import_products\" ></h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"tags-panel \">\n        <button type=\"button\" ng-click=\"vm.openFile(vm.importType.category)\" ng-disabled=\"vm.waiting\" class=\"btn btn-success wd-auto\"\n            translate=\"button_upload_category_mapping\" ></button>\n        <br/>\n        <br/>\n\n        <button type=\"button\" ng-click=\"vm.openFile(vm.importType.product)\" ng-disabled=\"vm.waiting || vm.impossibleImportProduct()\" class=\"btn btn-success wd-auto\"\n            translate=\"button_upload_products\" ></button>\n        <span ng-if=\"vm.impossibleImportProduct()\" class=\"fa fa-warning ng-scope\" tooltip-popup-delay=\"200\" tooltip-placement=\"top\"\n        style=\"color:#fe9700;\"\n            tooltip-append-to-body=\"true\" tooltip-class=\"mlTooltip\" uib-tooltip-html=\"vm.importImpossibleTooltip\"></span>\n    </div>\n    <input type=\"file\" id=\"fileInput\" accept=\".csv\" class=\"hidden\" />\n</div>\n<div class=\"modal-footer\">\n    <div class=\"butLine\">\n        <button type=\"button\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.waiting\" class=\"btn btn-danger\" translate=\"button_cancel\" ></button>\n    </div>\n</div>\n<style>\n    .commonShadow {\n        position: fixed;\n        width: 10000px;\n        height: 10000px;\n        top: -5000px;\n        left: -1000px;\n        z-index: 10;\n    }\n</style>\n<div ng-show=\"waiting\" class=\"commonShadow\"></div>";

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "<label class=\"mb10 mt8 common-label fs-14 fw-500\" translate=\"product_discount_title\"></label>\n\n<div class=\"d-flex mb8 product-discount__row\">\n    <!--None-->\n    <label class=\"radio align-items-baseline mr24\">\n        <input type=\"radio\" ng-model=\"ctrl.selectedOption\" ng-disabled=\"ctrl.isDisabled\"\n            ng-change=\"ctrl.discount = null; ctrl.sendChangeDiscountMessage();\" ng-value=\"1\" class=\"radio__input\" />\n        <span class=\"radio__check\"></span>\n        <span class=\"radio__label\" translate=\"product_discount_none\"></span>\n    </label>\n    <!--Free-->\n    <label class=\"radio align-items-baseline mr24\">\n        <input type=\"radio\" ng-model=\"ctrl.selectedOption\" ng-disabled=\"ctrl.isDisabled\"\n            ng-change=\"ctrl.discount = 100; ctrl.sendChangeDiscountMessage();\" ng-value=\"2\" class=\"radio__input\" />\n        <span class=\"radio__check\"></span>\n        <span class=\"radio__label\" translate=\"product_discount_free\"></span>\n    </label>\n    <!--Value-->\n    <label class=\"radio align-items-baseline\">\n        <input type=\"radio\" ng-model=\"ctrl.selectedOption\" ng-disabled=\"ctrl.isDisabled\" ng-change=\"ctrl.changeDiscountValue()\" ng-value=\"3\"\n            class=\"radio__input\" />\n        <span class=\"radio__check\"></span>\n    </label>\n    <div class=\"withPercent width64\">\n        <input type=\"number\" only-num min-value=\"1\" max-value=\"99\" ng-disabled=\"ctrl.selectedOption !==3\"\n            ng-model=\"ctrl.value\" ng-model-options=\"{updateOn: 'blur'}\" ng-change=\"ctrl.changeDiscountValue()\"\n            class=\"form-control\" />\n    </div>\n</div>\n";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "<div>\n<!--    Add button-->\n    <button type=\"button\"\n            ng-click=\"ctrl.addExtra()\"\n            class=\"btn btn-success mb24 ml 16\">\n                <em class=\"fa fa-plus\"></em>\n                <span translate=\"extra_list_add_button\"></span>\n    </button>\n\n    <div ng-if=\"ctrl.items && ctrl.items.length > 0\" ng-form name=\"ctrl.extrasListForm\" novalidate class=\"tags-panel extras-list\">\n        <div class=\"tableTags\" ui-tree=\"ctrl.treeOptions\">\n            <div class=\"d-flex flex-row w-100 pb8 align-items-center\">\n                <div class=\"product_column title-text\" translate=\"extra_list_column_images\"></div>\n                <div class=\"price_column text-right ml32 title-text\" translate=\"extra_list_column_price\"></div>\n                <div class=\"quantity_column ml32 title-text\" translate=\"extra_list_column_max_quantity\"></div>   \n                <div class=\"delete_column ml32\"></div>            \n            </div>\n            <div ui-tree-nodes=\"\" ng-model=\"ctrl.items\">\n                <div class=\"d-flex flex-row w-100 align-items-center pt8 pb8 upper-line\" ng-repeat=\"extra in ctrl.items\" ui-tree-node>\n                    <div class=\"number_column\">\n                        <div class=\"d-flex flex-fill align-items-center justify-content-center\">\n                            <span ui-tree-handle class=\"drag-trigger icon-drag-drop--light icon24 clickable\"\n                                ng-class=\"{ 'icon-drag-drop--dark' : prod.isOnDrag }\">\n                            </span>\n                        </div>\n\n                    </div>\n                    <div class=\"image_column ml10\">\n                        <div class=\"width64 h64 absolute-center-flex\">\n                            <img ng-show=\"extra.ImageID\"\n                                ng-src=\"{{ctrl.getImage(extra.ImageID)}}\"\n                                class=\"max-w64\"\n                                alt=\"\">\n                            <div ng-show=\"!extra.ImageID\"\n                                class=\"image-placeholder icon-placeholder-gray\"></div>\n                        </div>\n                    </div>\n                    <div class=\"product_column ml10\">\n                        <span class=\"product-text\" ng-bind=\"::extra.Title\"></span>\n                    </div>\n                    <div class=\"price_column text-right ml32\">\n                        <span class=\"text-nowrap product-text\" ng-if=\"extra.Price\" ng-bind=\"::extra.Price | formatCurrency:ctrl.countryID\"></span>\n                        <span class=\"product-text\" ng-if=\"!extra.Price\" translate=\"extra_free_price\"></span>\n                    </div>\n                    <div class=\"quantity_column ml32\">\n                        <div class=\"inner input-validation\">\n                            <input type=\"text\"\n                                only-num\n                                min-Value=\"1\"\n                                class=\"form-control input-validation__field width88 \"\n                                ng-class=\"extra.QuantityError? 'input-validation__field--invalid': ''\"\n                                ng-model=\"extra.MaxAmount\"/>\n                            <span   ng-show=\"extra.QuantityError\"\n                                    class=\"text-danger input-validation__error fs-12\"\n                                    ng-bind=\"extra.QuantityError\">\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"delete_column ml32\">\n                        <em class=\"clickable fa icon-trashcan-outline icon24\"\n                            ng-click=\"ctrl.deleteExtra(extra)\"></em>\n                    </div>      \n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<div ng-form name=\"ctrl.selectExtrasForm\" novalidate>\n    <!-- header -->\n    <div class=\"modal-header black-header\">\n        <div class=\"pull-right\">\n            <div class=\"btn-form btn-form-header clearfix\">\n                <button type=\"button\"\n                        ng-click=\"ctrl.confirm()\"\n                        ng-disabled=\"!ctrl.total || ctrl.selectExtrasForm.$pristine || (ctrl.selectExtrasForm.$dirty && ctrl.getSelectedExtras().length === 0) \"\n                        class=\"btn btn-success btn-with-icon pl40 pr40\">\n                    <span translate=\"button_add\"></span>\n                </button>\n                <button type=\"button\"\n                        ng-click=\"ctrl.dismiss()\"\n                        class=\"btn btn-danger btn-with-icon\">\n                    <em class=\"fa fa-close\"></em>\n                    <span translate=\"button_discard\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"btn-form modal-title\" translate=\"add_extras_title\"></div>\n    </div>\n\n    <!-- body -->\n    <div class=\"modal-body panel-campaign-choice store-search pl15 pr15 wizard__selected-modal\">\n        <!-- search -->\n        <div class=\"posRel searchInput flex-input-container mb10 mt10 mr0\">\n            <input type=\"text\" class=\"form-control\"\n                   ng-model=\"ctrl.model.searchTerm\"\n                   ng-keypress=\"ctrl.searchKeyPressed($event)\"\n                   translate translate-attr-placeholder=\"search_for_extras\">\n            <span class=\"fa fa-search\"></span>\n        </div>\n        <div when-scrolled=\"ctrl.loadExtras()\" class=\"product-search__wrap\">\n            <table class=\"fw store-search__table extras-search__table fs-14 \">\n                <tbody>\n                <tr ng-repeat=\"extra in ctrl.model.extras\" class=\"clickable extra-item\"\n                    ng-click=\"ctrl.selectExtra(extra, $event)\"\n                    ng-class=\"{ 'active': extra.IsSelected }\">\n                    <td width=\"40px\" class=\"pb10 pt10 pl10\">\n                        <div class=\"checkbox c-checkbox m0\">\n                            <label for=\"checkbox_{{::extra.ID}}\" class=\"pl20\">\n                                <input id=\"checkbox_{{::extra.ID}}\"\n                                       ng-checked=\"extra.IsSelected\" type=\"checkbox\"\n                                       ng-disabled=\"ctrl.model.waiting\"\n                                       ng-model=\"extra.IsSelected\"/>\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                    </td>\n                    <td width=\"80px\">\n                        <div class=\"inner width64 h64 absolute-center-flex \"\n                             ng-if=\"extra.ImageID\">\n                            <img ng-show=\"extra.ImageID\"\n                                 ng-src=\"{{ctrl.getImage(extra.ImageID)}}\"\n                                 class=\"max-w48\"\n                                 alt=\"\">\n                        </div>\n                        <div ng-show=\"!extra.ImageID\"\n                             class=\"icon-placeholder-gray extra-empty-image  max-w48\"></div>\n                    </td>\n                    <td>\n                        <div class=\"inner\">\n                            <span ng-bind=\"extra.Title\"></span>\n                        </div>\n                    </td>\n                    <td>\n                        <div class=\"inner text-right pr20\">\n                            <span ng-if=\"extra.Price\" ng-bind=\"extra.Price | formatCurrency:ctrl.countryID\"></span>\n                            <span ng-if=\"!extra.Price\" translate=\"extra_free_price\"></span>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n            <div class =\"empty-extras\">\n                <empty-list-state class=\"icon-empty-list\"\n                                ng-if=\"ctrl.model.extras.length === 0 && !ctrl.isSearch\"\n                                title-message=\"ctrl.model.noExtrasTitle\"                            \n                                message=\"ctrl.model.noExtrasMessage\">\n                </empty-list-state>\n                <empty-list-state  image-class=\"'icon-empty-list-extras-search'\"\n                    ng-if=\"ctrl.model.extras.length === 0 && ctrl.isSearch\"\n                    title-message=\"ctrl.model.noExtrasTitle\"                            \n                    message=\"ctrl.model.noExtrasMessage\">\n                </empty-list-state>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <!--    Add button-->\n    <button type=\"button\"\n            ng-click=\"ctrl.addIngredient()\"\n            ng-disabled=\"ctrl.isDisabled\"\n            class=\"btn btn-success mb24 ml 16\">\n        <em class=\"fa fa-plus\"></em>\n        <span translate=\"ingredients_list_add_button\"></span>\n    </button>\n\n    <div ng-if=\"ctrl.items && ctrl.items.length > 0\"\n         ng-form name=\"ctrl.ingredientsListForm\"\n         novalidate class=\"tags-panel extras-list\">\n        <div class=\"tableTags\">\n            <div class=\"d-flex flex-row w-100 pb8 align-items-center\">\n                <div class=\"product_column title-text\"></div>\n                <div class=\"quantity_column ml32 title-text\" translate=\"ingredients_list_column_min_quantity\"></div>\n                <div class=\"delete_column ml32\"></div>\n            </div>\n            <div>\n                <div class=\"d-flex flex-row w-100 align-items-center pt8 pb8 upper-line\" ng-repeat=\"ingredient in ctrl.items\">\n<!--                    <div class=\"number_column\">-->\n<!--                        <div class=\"d-flex flex-fill align-items-center justify-content-center\">-->\n<!--                            <span ui-tree-handle class=\"drag-trigger icon-drag-drop&#45;&#45;light icon24 clickable\"-->\n<!--                                  ng-class=\"{ 'icon-drag-drop&#45;&#45;dark' : prod.isOnDrag }\">-->\n<!--                            </span>-->\n<!--                        </div>-->\n<!--                    </div>-->\n                    <div class=\"product_column ml10\">\n                        <span class=\"product-text\" ng-bind=\"::ingredient.Title\"></span>\n                    </div>\n                    <div class=\"quantity_column ml32\">\n                        <div class=\"inner input-validation\">\n                            <input type=\"text\"\n                                   name=\"minQuantity\"\n                                   only-num\n                                   required\n                                   is-Number=\"true\"\n                                   min-Value=\"0\"\n                                   class=\"form-control input-invalid-field width120\"\n                                   ng-class=\"ingredient.MinQuantity == null ? 'input-invalid-field--invalid': ''\"\n                                   ng-model=\"ingredient.MinQuantity\"/>\n                            <span ng-if=\"ingredient.MinQuantity == null\"\n                                  tooltip-placement=\"top\"\n                                  tooltip-append-to-body=\"true\"\n                                  uib-tooltip-html=\"ctrl.getMinQuantityErrorText()\"\n                                  tooltip-enable=\"!ingredient.MinQuantity\"\n                                  tooltip-class=\"variation-ingredient-error-tooltip\"\n                                  class=\"input-invalid-field--attention\">\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"delete_column ml32\">\n                        <em class=\"clickable fa icon-trashcan-outline icon24\"\n                            ng-click=\"ctrl.deleteIngredient(ingredient)\"></em>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "<div ng-form name=\"ctrl.selectIngredientsForm\" novalidate>\n    <!-- header -->\n    <div class=\"modal-header black-header\">\n        <div class=\"pull-right\">\n            <div class=\"btn-form btn-form-header clearfix\">\n                <button type=\"button\"\n                        ng-click=\"ctrl.confirm()\"\n                        ng-disabled=\"!ctrl.total || ctrl.selectIngredientsForm.$pristine ||\n                            (ctrl.selectIngredientsForm.$dirty && ctrl.selectedIngredients.size === 0) \"\n                        class=\"btn btn-success btn-with-icon pl40 pr40\">\n                    <span translate=\"ingredients_select_dialog_ok_button\"></span>\n                </button>\n                <button type=\"button\"\n                        ng-click=\"ctrl.dismiss()\"\n                        class=\"btn btn-danger btn-with-icon\">\n                    <em class=\"fa fa-close\"></em>\n                    <span translate=\"ingredients_select_dialog_cancel_button\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"btn-form modal-title\" translate=\"ingredients_select_dialog_title\"></div>\n    </div>\n\n    <!-- body -->\n    <div class=\"modal-body panel-campaign-choice store-search pl15 pr15 wizard__selected-modal\">\n        <div  class=\"mb10 mt10\">\n            <search placeholder-text=\"'ingredients_select_dialog_search_placeholder' | translate\"\n                    text=\"ctrl.model.searchTerm\"\n                    classes=\"'white-theme'\"\n                    disabled=\"ctrl.model.waiting\"\n                    on-search-click=\"ctrl.search(searchText)\"\n                    on-clear-click=\"ctrl.resetSearch()\">\n            </search>\n        </div>\n\n        <div when-scrolled=\"ctrl.loadIngredients()\" class=\"product-search__wrap\">\n            <table class=\"fw store-search__table extras-search__table fs-14 \">\n                <tbody>\n                <tr ng-repeat=\"ingredient in ctrl.model.ingredients\" class=\"clickable extra-item\"\n                    ng-click=\"ctrl.selectIngredient(ingredient, $event)\"\n                    ng-class=\"{ 'active': ingredient.IsSelected }\">\n                    <td width=\"20\" class=\"pb10 pt10 pl10\">\n                        <div class=\"checkbox c-checkbox m0\">\n                            <label for=\"checkbox_{{::ingredient.ID}}\" class=\"pl20\">\n                                <input id=\"checkbox_{{::ingredient.ID}}\"\n                                       ng-checked=\"ingredient.IsSelected\" type=\"checkbox\"\n                                       ng-disabled=\"ctrl.model.waiting\"\n                                       ng-model=\"ingredient.IsSelected\"/>\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                    </td>\n                    <td>\n                        <div class=\"inner pl10\">\n                            <span ng-bind=\"ingredient.Title\"></span>\n                        </div>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n            <div>\n                <empty-list-state class=\"empty-location\"\n                                  ng-if=\"!ctrl.model.waiting && ctrl.model.ingredients.length === 0 && !ctrl.isSearch\"\n                                  title-message=\"'ingredients_select_dialog_empty_screen_title' | translate\"\n                                  message=\"'ingredients_select_dialog_empty_screen_message' | translate\">\n                </empty-list-state>\n                <empty-list-state  class=\"empty-location\"\n                                   image-class=\"'icon-empty-list-extras-search'\"\n                                   ng-if=\"!ctrl.model.waiting && ctrl.model.ingredients.length === 0 && ctrl.isSearch\"\n                                   title-message=\"'ingredients_select_dialog_not_found_title' | translate\"\n                                   message=\"'ingredients_select_dialog_not_found_message' | translate: { search: ctrl.model.searchTermForEmptyScreen }\">\n                </empty-list-state>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex mb24\">\n    <div class=\"mr24\">\n        <label translate=\"product_preparation_type\" class=\"common-label\"></label>\n        <ui-select class=\"fs-13 width150 preparation-select\" name=\"itemTypes\"\n            ng-model=\"ctrl.selectedType\"\n            on-select=\"ctrl.onHCSelect($item)\"\n            theme=\"bootstrap\"\n            ng-disabled=\"ctrl.waiting\"\n            search-enabled=\"false\">\n            <ui-select-match class=\"ui-select-match\" placeholder=\"{{:: 'none ' | translate }}\">\n                {{ $select.selected.title | translate }}\n            </ui-select-match>\n            <ui-select-choices\n                repeat=\"type in ctrl.types\"\n                refresh-delay=\"0\">\n                <div>\n                    <div\n                        ng-bind-html=\"(type.title | translate) | highlight: $select.search\">\n                    </div>\n                </div>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n    <div>\n        <label translate=\"preparation_time\" class=\"common-label\"></label>\n        <div class=\"d-flex\">\n            <div class=\"flexVerticalAlignParent mr16\">\n                <input type=\"text\" only-decimal min-value=\"0\" max-value=\"24\" maxlength=\"2\" ng-disabled=\"ctrl.waiting\"\n                    ng-model=\"ctrl.convertedPreparationTime.hours\"\n                    ng-class=\"{'input-validation__field--invalid' : ctrl.emptyTimeError || ctrl.error }\"\n                    ng-change=\"ctrl.changePreparationTime()\" class=\"form-control width41 text-center\" />\n                <span class=\"ml8\" translate=\"preparation_hour\"></span>\n            </div>\n            <div class=\"flexVerticalAlignParent\">\n                <input type=\"text\" only-decimal min-value=\"0\" max-value=\"59\" maxlength=\"2\" ng-disabled=\"ctrl.waiting\"\n                    ng-class=\"{'input-validation__field--invalid' : ctrl.emptyTimeError || ctrl.error }\"\n                    ng-model=\"ctrl.convertedPreparationTime.minutes\" ng-change=\"ctrl.changePreparationTime()\"\n                    class=\"form-control width41 text-center\" />\n                <span class=\"ml8\" translate=\"preparation_min\"></span>\n            </div>\n        </div>\n        <div ng-if=\"ctrl.emptyTimeError\" class=\"mt4 text-danger\" translate=\"field_is_required\"></div>\n        <div ng-if=\"ctrl.error\" class=\"text-danger mt4 width170\" translate=\"preparation_time_is_greater_24hour\"></div>\n    </div>\n</div>\n";

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-special-offer\">\n    <div class=\"mb16 mt20 product-special-offer__toggle\">\n        <label class=\"common-label fs-20 fw-400\" translate=\"offer\"></label>\n        <label class=\"switch switch-primary\"\n               uib-tooltip=\"{{ctrl.disabledMessage}}\"\n               tooltip-placement=\"top\"\n               tooltip-enable=\"ctrl.isDisabled\">\n            <input type=\"checkbox\"\n                   name=\"switchOffer\"\n                   ng-model=\"ctrl.switchSpecialOffer\"\n                   ng-change=\"ctrl.offerSwitchChanged()\"\n                   ng-disabled=\"ctrl.isDisabled || ctrl.isReadOnly\"/>\n            <span></span>\n        </label>\n    </div>\n    <div class=\"mb24\" ng-if=\"ctrl.switchSpecialOffer\">\n        <div class=\"d-flex flex-wrap\">\n            <div class=\"flex-column width150 mr24 mb24 option\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"offer_type\"></label>\n                <ui-select class=\"fs-13\" name=\"OfferType\"\n                           theme=\"bootstrap\"\n                           search-enabled=\"false\"\n                           skip-focusser=\"true\"\n                           ng-model=\"ctrl.selectedType\"\n                           ng-change=\"ctrl.offerTypeChanged(); ctrl.onSpecialOfferChanged()\"\n                           ng-disabled=\"ctrl.isReadOnly\">\n                    <ui-select-match class=\"ui-select-match\">\n                        {{ $select.selected.name }}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"offer in ctrl.offerTypes\">\n                        <div ng-bind-html=\"offer.name\"></div>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 \">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"start_date\"></label>\n                <div class=\"input-group input-invalid-field wrapRelative datepicker--transparent\"\n                     ng-class=\"ctrl.specialOffer.error.startDate ? 'input-invalid-field--invalid':''\">\n                    <input type=\"text\"\n                            uib-datepicker-popup=\"dd MMM yyyy\"\n                            ng-model=\"ctrl.specialOffer.OfferValidFrom\"\n                            ng-model-options=\"{timezone: 'utc'}\"\n                            is-open=\"openedStartDate\"\n                            ng-focus=\"openedStartDate=!ctrl.isReadOnly;openedEndDate=false;\"\n                            datepicker-options=\"ctrl.startDateOptions\"\n                            ng-change=\"ctrl.onStartDateChanged();ctrl.onSpecialOfferChanged()\"\n                            close-text=\"{{::'close' | translate}}\"\n                            clear-text=\"{{::'clear' | translate}}\"\n                            current-text=\"{{::'today' | translate}}\"\n                            class=\"form-control\"\n                            readonly/>\n                        <span class=\"input-group-btn\">\n                            <button type=\"button\"\n                                    ng-disabled=\"ctrl.isReadOnly\"\n                                    ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedStartDate=!ctrl.isReadOnly;openedEndDate=false;\"\n                                    class=\"btn btn-default\"\n                                    style=\"padding: 0 4px\">\n                                <span class=\"icon-date icon24 inline-block opacity38 mt7\"></span>\n                            </button>\n                        </span>\n                </div>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.startDate\">\n                    {{ctrl.specialOffer.error.startDate}}\n                </div>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 input-validation\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"end_date\"></label>\n                <div class=\"input-group input-invalid-field wrapRelative datepicker--transparent\"\n                     ng-class=\"ctrl.isEndDateExpired || ctrl.specialOffer.error.endDate ? 'input-invalid-field--invalid':''\"\n                     uib-tooltip=\"{{ctrl.expiredMessage}}\"\n                     tooltip-placement=\"top\"\n                     tooltip-enable=\"ctrl.isEndDateExpired && !openedEndDate\">\n                    <input type=\"text\"\n                           uib-datepicker-popup=\"dd MMM yyyy\"\n                           ng-model=\"ctrl.specialOffer.OfferValidTo\"\n                           ng-model-options=\"{timezone: 'utc'}\"\n                           ng-change=\"ctrl.onEndDateChanged(); ctrl.onSpecialOfferChanged()\"\n                           is-open=\"openedEndDate\"\n                           ng-focus=\"openedEndDate=!ctrl.isReadOnly;openedStartDate=false;\"\n                           datepicker-options=\"ctrl.endDateOptions\"\n                           close-text=\"{{::'close' | translate}}\"\n                           clear-text=\"{{::'clear' | translate}}\"\n                           current-text=\"{{::'today' | translate}}\"\n                           class=\"form-control\"\n                           readonly/>\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\"\n                                ng-disabled=\"ctrl.isReadOnly\"\n                                ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedEndDate=!ctrl.isReadOnly;openedStartDate=false;\"\n                                class=\"btn btn-default\"\n                                style=\"padding: 0 4px\">\n                            <span class=\"icon24 inline-block mt7\"\n                                ng-class=\"ctrl.isEndDateExpired?'icon-date--red':'icon-date opacity38'\"></span>\n                        </button>\n                    </span>\n                </div>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.endDate\">\n                    {{ctrl.specialOffer.error.endDate}}\n                </div>\n            </div>\n        </div>\n\n        <div class=\"d-flex flex-wrap\">\n            <div class=\"flex-column width150 mr24 mb24 option\" ng-if=\"ctrl.selectedType.templates\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"discount_template\"></label>\n                <ui-select class=\"fs-13\" name=\"DiscountType\"\n                           theme=\"bootstrap\"\n                           search-enabled=\"false\"\n                           skip-focusser=\"true\"\n                           ng-model=\"ctrl.selectedTemplate\"\n                           ng-change=\"ctrl.offerTemplateChanged(); ctrl.onSpecialOfferChanged()\"\n                           ng-disabled=\"ctrl.isReadOnly\">\n                    <ui-select-match class=\"ui-select-match\">\n                        {{ $select.selected.name }}\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"template in ctrl.selectedType.templates\">\n                        <div ng-bind-html=\"template.name\"></div>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.BuyXGetY\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"buy\"></label>\n                <input type=\"text\"\n                       class=\"form-control\"\n                       ng-class=\"ctrl.specialOffer.error.buyQuantity ? 'input-invalid-field--invalid' : ''\"\n                       only-num\n                       is-number=\"true\"\n                       min-value=\"1\"\n                       ng-model=\"ctrl.specialOffer.BuyXGetYOfferValues.Buy\"\n                       ng-change=\"ctrl.onSpecialOfferChanged()\"\n                       ng-readonly=\"ctrl.isReadOnly\"/>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.buyQuantity\">\n                    {{ctrl.specialOffer.error.buyQuantity}}\n                </div>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.BuyXGetY\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"get_for_free\"></label>\n                <input type=\"text\"\n                       class=\"form-control\"\n                       ng-class=\"ctrl.specialOffer.error.getQuantity ? 'input-invalid-field--invalid' : ''\"\n                       only-num\n                       is-number=\"true\"\n                       min-value=\"1\"\n                       ng-change=\"ctrl.onSpecialOfferChanged()\"\n                       ng-model=\"ctrl.specialOffer.BuyXGetYOfferValues.Get\"\n                       ng-readonly=\"ctrl.isReadOnly\"/>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.getQuantity\">\n                    {{ctrl.specialOffer.error.getQuantity}}\n                </div>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option input-validation\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.Discount\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"offer_price_required\"></label>\n                <span class=\"width150 {{ctrl.currencyClass}} t9\">\n                    <input type=\"text\"\n                           class=\"form-control\"\n                           ng-class=\"ctrl.specialOffer.error.price ? 'input-invalid-field--invalid' : ''\"\n                           only-decimal\n                           min-value=\"0\"\n                           ng-change=\"ctrl.onSpecialOfferChanged()\"\n                           ng-model=\"ctrl.specialOffer.DiscountPrice\"\n                           ng-readonly=\"ctrl.isReadOnly\"/>\n                </span>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.price\">\n                    {{ctrl.specialOffer.error.price}}\n                </div>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.Discount\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"special_offer_price\"></label>\n                <span class=\"width150 {{ctrl.currencyClass}} t9\">\n                    <input type=\"text\" ng-model=\"ctrl.oldPrice\" disabled class=\"form-control\"/>\n                </span>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.BuyXForY\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"buy\"></label>\n                <input type=\"text\"\n                       class=\"form-control\"\n                       ng-class=\"ctrl.specialOffer.error.buyQuantity ? 'input-invalid-field--invalid' : ''\"\n                       only-num\n                       is-number=\"true\"\n                       min-value=\"1\"\n                       ng-model=\"ctrl.specialOffer.BuyXForYSumYOfferValues.Buy\"\n                       ng-change=\"ctrl.onSpecialOfferChanged()\"\n                       ng-readonly=\"ctrl.isReadOnly\"/>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.buyQuantity\">\n                    {{ctrl.specialOffer.error.buyQuantity}}\n                </div>\n            </div>\n            <div class=\"flex-column width150 mr24 mb24 option input-validation\" ng-if=\"ctrl.selectedType.value === ctrl.SpecialOfferTypeEnum.BuyXForY\">\n                <label class=\"w-auto common-label fs-14 fw-500\" translate=\"offer_for_required\"></label>\n                <span class=\"width150 {{ctrl.currencyClass}} t9\">\n                    <input type=\"text\"\n                           class=\"form-control\"\n                           ng-class=\"ctrl.specialOffer.error.price ? 'input-invalid-field--invalid' : ''\"\n                           only-decimal\n                           min-value=\"0\"\n                           ng-change=\"ctrl.onSpecialOfferChanged()\"\n                           ng-model=\"ctrl.specialOffer.BuyXForYSumYOfferValues.Sum\"\n                           ng-readonly=\"ctrl.isReadOnly\"/>\n                </span>\n                <div class=\"text-danger text-nowrap\"\n                     ng-show=\"ctrl.specialOffer.error.price\">\n                    {{ctrl.specialOffer.error.price}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<div ng-form name=\"stickerForm\" class=\"container-fluid mb10\" novalidate>\n    <div class=\"row\">\n        <div class=\"col-md-3\" ng-class=\"{ 'width30per': !ctrl.hidePosition , 'width40per': ctrl.hidePosition }\">\n            <!--\nng-pattern=\"ctrl.pattern\"\nng-required=\"true\"\nng-model-options=\"{ updateOn: 'submit blur' }\"\n             -->\n            <input  placeholder=\"NFC sticker code\"\n                    class=\"form-control\"\n                    type=\"text\"\n                    ng-disabled=\"ctrl.isDisabled\"\n                    name=\"stickerNumber\"\n                    ng-change=\"ctrl.changeStickerNumber()\"\n                    ng-model=\"ctrl.stickerNumber\"\n                />\n            <span   ng-show=\"ctrl.stickerError && ctrl.stickerError.nfcNumber\"\n                    class=\"text-danger\"\n                    ng-bind=\"ctrl.stickerError.nfcNumber\">\n            </span>\n            <span   ng-show=\"ctrl.stickerNumberWasChanged\"\n                    class=\"text-danger\"\n                    translate=\"nfc_product_stickers_list_sticker_changed\">\n            </span>\n<!--             <span   ng-show=\"ctrl.stickerError && ctrl.stickerError.nfcNumber\"\n                    class=\"text-danger\"\n                    translate=\"nfc_product_stickers_list_sticker_required_error\">\n            </span> -->\n        </div>\n        <div class=\"col-md-3\" ng-class=\"{ 'width30per': !ctrl.hidePosition , 'width40per': ctrl.hidePosition }\">\n            <div>\n                <div uib-dropdown class=\"input-group-btn block fw wideSelect\">\n                    <!--  text-left fw flexVerticalAlignParent h37 -->\n                    <button type=\"button\"\n                            uib-dropdown-toggle\n                            ng-disabled=\"ctrl.isDisabled\"\n                            class=\"btn btn-default dropdown-toggle fw\"\n                            aria-haspopup=\"true\"\n                            aria-expanded=\"false\">\n                        <span ng-hide=\"ctrl.selectedStoreId\" translate=\"select_location\"></span>\n                        <span class=\"text-gray-dark text-ellipsis\"\n                                ng-model=\"ctrl.selectedStoreId\"\n                                ng-model-options=\"{ updateOn: 'blur' }\"\n                                name=\"selectedStore\"\n                                ng-required=\"true\"\n                                ng-show=\"ctrl.selectedStoreId\">\n                            {{(ctrl.storesDic[ctrl.selectedStoreId]).Name}}\n                        </span>\n                        <span class=\"caret ml-auto\"></span>\n                    </button>\n                    <ul class=\"dropdown-menu\">\n                        <li ng-repeat=\"store in ctrl.stores\" ng-click=\"ctrl.selectedStoreId = store.ID; stickerForm.$setDirty()\">\n                            <a href=\"#\" class=\"text-ellipsis\">{{::store.Name}}</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <span   ng-show=\"ctrl.stickerError && ctrl.stickerError.store\"\n                    class=\"text-danger\"\n                    ng-bind=\"ctrl.stickerError.store\">\n            </span>\n        </div>\n        <div class=\"col-md-3 width30per\" ng-hide=\"ctrl.hidePosition\">\n            <div >\n                <input type=\"text\"\n                        ng-model=\"ctrl.position\"\n                        ng-model-options=\"{ updateOn: 'blur' }\"\n                        ng-disabled=\"ctrl.isDisabled\"\n                        maxlength=\"10\"\n                        placeholder=\"Position\"\n                        class=\"form-control\"/>\n            </div>\n        </div>\n        <div class=\"col-md-1\">\n            <div class=\"align-middle\">\n                <button class=\"delete-btn mb-auto mt6\"\n                        ng-disabled=\"ctrl.isDisabled\"\n                        ng-click=\"ctrl.onDeleteItem({itemIndex:ctrl.itemId})\">\n                    <span class=\"icon24 inline-block delete-icon opacity6\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "<div ng-form name=\"ctrl.stickerListForm\" novalidate>\n    <label class=\"control-label mb8\" translate=\"nfc_product_list_label\"></label>\n    <div ng-repeat=\"item in ctrl.items\" >\n        <product-stickers-list-item item-id=\"$index\"\n                                    is-disabled=\"ctrl.isListDisabled\"\n                                    sticker-number=\"item.StickerNumber\"\n                                    selected-store-id=\"item.PlaceID\"\n                                    stores=\"ctrl.stores\"\n                                    position=\"item.Position\"\n                                    hide-position=\"ctrl.hidePosition\"\n                                    on-delete-item=\"ctrl.deleteStickerItem(itemIndex)\"\n                                    sticker-errors=\"ctrl.errors\">\n        </product-stickers-list-item>\n    </div>\n\n    <div class=\"addElement pb5 mb12\">\n        <span ng-click=\"ctrl.stickerListForm.$valid && !ctrl.isListDisabled && ctrl.addStickerItem()\" class=\"link\">\n            <em class=\"fa fa-plus\"></em>\n            <span translate=\"nfc_product_list_add_button\"></span>\n        </span>\n    </div>\n</div>\n\n\n\n";

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex flex-row w-100 align-items-center pt8 pb8 upper-line\" ng-form name=\"ctrl.form\">\n    <div class=\"title_column ml10 text-ellipsis\">\n        <span class=\"title-text\" ng-bind=\"::ctrl.item.Title\"></span>\n    </div>\n    <div class=\"takeaway_price_column ml32\">\n        <div class=\"inner input-validation\">\n            <div class=\"t9 {{ctrl.currencyClass}}\">\n                <input type=\"text\"\n                       name=\"price\"\n                       only-decimal\n                       is-Number=\"true\"\n                       min-value=\"0\"\n                       class=\"form-control input-invalid-field width120\"\n                       required\n                       ng-disabled=\"ctrl.isTakeAwayPriceDisabled\"\n                       ng-class=\"ctrl.form.price.$invalid && !ctrl.isTakeAwayPriceDisabled ? 'input-invalid-field--invalid': ''\"\n                       ng-model=\"ctrl.item.Price\"\n                       ng-change=\"ctrl.validateFields()\"\n                       ng-model-options=\"{ allowInvalid: true }\"/>\n                <span ng-if=\"ctrl.form.price.$invalid && !ctrl.isTakeAwayPriceDisabled\"\n                      tooltip-placement=\"top\"\n                      uib-tooltip-html=\"ctrl.getPriceErrorText()\"\n                      tooltip-enable= \"ctrl.form.price.$invalid\"\n                      tooltip-class=\"variation-ingredient-error-tooltip\"\n                      class=\"input-invalid-field--attention\">\n                </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"eat_in_price_column ml32\">\n        <div class=\"inner input-validation\">\n            <div class=\"t9 {{ctrl.currencyClass}}\">\n                <input type=\"text\"\n                       only-decimal\n                       is-Number=\"true\"\n                       min-value=\"0\"\n                       ng-disabled=\"ctrl.isEatInPriceDisabled\"\n                       class=\"form-control input-invalid-field width120\"\n                       ng-class=\"ctrl.form.insidePrice.$invalid && !ctrl.isEatInPriceDisabled ? 'input-invalid-field--invalid': ''\"\n                       name=\"insidePrice\"\n                       required\n                       ng-model=\"ctrl.item.InsidePrice\"\n                       ng-change=\"ctrl.validateFields()\"\n                       ng-model-options=\"{ allowInvalid: true}\"/>\n                <span ng-if=\"ctrl.form.insidePrice.$invalid && !ctrl.isEatInPriceDisabled\"\n                      tooltip-placement=\"top\"\n                      uib-tooltip-html=\"ctrl.getInsidePriceErrorText()\"\n                      tooltip-enable=\"ctrl.form.insidePrice.$invalid\"\n                      tooltip-class=\"variation-ingredient-error-tooltip\"\n                      class=\"input-invalid-field--attention\">\n                </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"default_quantity_column ml32\">\n        <div class=\"inner input-validation\">\n            <input type=\"text\"\n                   name=\"defaultQuantity\"\n                   only-num\n                   is-Number=\"true\"\n                   min-value=\"0\"\n                   class=\"form-control input-invalid-field width120\"\n                   required\n                   ng-class=\"ctrl.form.defaultQuantity.$invalid ? 'input-invalid-field--invalid': ''\"\n                   ng-model=\"ctrl.item.DefaultQuantity\"\n                   ng-change=\"ctrl.validateFields()\"\n                   ng-model-options=\"{ allowInvalid: true }\"/>\n            <span ng-if=\"ctrl.form.defaultQuantity.$invalid\"\n                  tooltip-placement=\"top\"\n                  uib-tooltip-html=\"ctrl.getDefaultQuantityErrorText()\"\n                  tooltip-enable= \"ctrl.form.defaultQuantity.$invalid\"\n                  tooltip-class=\"variation-ingredient-error-tooltip\"\n                  class=\"input-invalid-field--attention\">\n            </span>\n        </div>\n    </div>\n    <div class=\"max_quantity_column ml32\">\n        <div class=\"inner input-validation\">\n            <input type=\"text\"\n                   only-num\n                   is-Number=\"true\"\n                   min-value=\"0\"\n                   class=\"form-control input-invalid-field width120\"\n                   ng-class=\"ctrl.form.maxQuantity.$invalid ? 'input-invalid-field--invalid': ''\"\n                   name=\"maxQuantity\"\n                   required\n                   ng-model=\"ctrl.item.MaxQuantity\"\n                   ng-change=\"ctrl.validateFields()\"\n                   ng-model-options=\"{ allowInvalid: true}\"/>\n            <span ng-if=\"ctrl.form.maxQuantity.$invalid\"\n                  tooltip-placement=\"top\"\n                  uib-tooltip-html=\"ctrl.getMaxQuantityErrorText()\"\n                  tooltip-append-to-body=\"true\"\n                  tooltip-enable=\"ctrl.form.maxQuantity.$invalid\"\n                  tooltip-class=\"variation-ingredient-error-tooltip\"\n                  class=\"input-invalid-field--attention\">\n            </span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<div  class=\"variation-ingredients-list\"\n      ng-if=\"ctrl.items.length > 0\">\n    <label class=\"title mb18\">\n        <span translate=\"variation_ingredient_list_title\"></span>\n        <span ng-click=\"ctrl.openVariationIngredientsInfo()\"\n              class=\"question-icon question-button clickable\">\n        </span>\n    </label>\n    <div class=\"variation-ingredients-table\">\n        <div class=\"d-flex pb8 pr12 pl12\">\n            <div class=\"title-text\"\n                 translate=\"variation_ingredient_list_column_name\"></div>\n            <div class=\"ml-auto d-flex\">\n                <div class=\"title-text\"\n                     style=\"margin-right: 45px\"\n                     translate=\"variation_ingredient_list_column_takeaway_price\"></div>\n                <div class=\"title-text\"\n                     style=\"margin-right: 77px\"\n                     translate=\"variation_ingredient_list_column_eat_in_price\"></div>\n                <div class=\"title-text\"\n                     style=\"margin-right: 45px\"\n                     translate=\"variation_ingredient_list_column_default_quantity\"></div>\n                <div class=\"title-text\"\n                     style=\"margin-right: 28px\"\n                     translate=\"variation_ingredient_list_column_max_quantity\"></div>\n            </div>\n        </div>\n        <div class=\"pr12\">\n            <div>\n                <product-variation-ingredient ng-repeat=\"ingredient in ctrl.items\"\n                                              item=\"ingredient\"\n                                              is-eat-in-price-disabled=\"ctrl.isEatInPriceDisabled\"\n                                              is-take-away-price-disabled=\"ctrl.isTakeAwayPriceDisabled\"\n                                              currency-class=\"ctrl.currencyClass\"\n                                              on-ingredient-changed=\"ctrl.ingredientChange({item: item})\"\n                                              min-quantity=\"ctrl.getMinQuantity(ingredient)\">\n                </product-variation-ingredient>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb9 \">\n    <a class=\"underline\" ui-sref=\"app.products\" translate=\"products\"></a>\n    <span class=\"fa fa-angle-right\"></span>\n    <span ng-show=\"vm.state.isNew\" translate=\"new\"></span>\n    <span ng-show=\"vm.state.isCopy\" translate=\"copy\"></span>\n    <span ng-show=\"vm.state.isEdit\" translate=\"edit\"></span>\n</div>\n<div class=\"panel panelWizard\">\n    <form name=\"vm.productForm\" novalidate role=\"form\" ng-if=\"!vm.isNfrnRetailer\">\n        <div class=\"productWizard clearfix \">\n            <div class=\"productWizardPoint\">\n                <div ng-class=\"{'active': vm.wizard.step === 1}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            1\n                            <span ng-show=\"vm.wizard.step > 1\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_info\"></div>\n                </div>\n            </div>\n            <div class=\"productWizardPoint\">\n                <div ng-class=\"{'active': vm.wizard.step === 2}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            2\n                            <span ng-show=\"vm.wizard.step > 2\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_ingredients\"></div>\n                </div>\n            </div>\n            <div class=\"productWizardPoint\">\n                <div ng-class=\"{'active': vm.wizard.step === 3}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            3\n                            <span ng-show=\"vm.wizard.step > 3\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_variation\"></div>\n                </div>\n            </div>\n            <div class=\"productWizardPoint\">\n                <div ng-class=\"{'active': vm.wizard.step === 4}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            4\n                            <span ng-show=\"vm.wizard.step > 4\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_extras\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"clearfix wrapWizardStep\">\n            <div ng-show=\"vm.wizard.step !==4\" class=\"pull-left phoneWrapWizard\">\n                <div class=\"titleHeader\" ng-bind=\"vm.model.edit.title\"></div>\n                <div class=\"textHeader\" translate=\"jisp_store\"></div>\n                <div class=\"phoneWrapWizardInner\">\n                    <div class=\"wizardScrollPhone\">\n                        <!--variation image-->\n                        <div class=\"mt3\">\n                            <div class=\"img\">\n                                <span ng-if=\"vm.variationPreview.imageID\"></span>\n                                <div ng-hide=\"vm.variationPreview.imageID\" class=\"placeholderImg fa fa-picture-o\">\n                                </div>\n                                <img ng-if=\"vm.variationPreview.imageID\"\n                                    ng-src=\"{{vm.getImageUrl(vm.variationPreview.imageID)}}\" />\n                            </div>\n                            <div class=\"listOfImages\" ng-show=\"vm.variationPreview.images.length > 1\">\n                                <span ng-repeat=\"image in vm.variationPreview.images\"\n                                    ng-click=\"vm.variationPreview.selectImage(image)\"\n                                    ng-class=\"{'active': image.selected }\"></span>\n                            </div>\n                        </div>\n                        <!--brand-->\n                        <div class=\"categBrand\">\n                            <span\n                                ng-bind=\"vm.model.edit.brands && vm.model.edit.brands[0] ? vm.model.edit.brands[0].Name : '' \"></span>\n                        </div>\n                        <!--title-->\n                        <div class=\"title\">\n                            <span ng-bind=\"vm.model.edit.title\"></span>\n                        </div>\n                        <!--country-->\n                        <div class=\"country\" ng-show=\"vm.IsFoodProduct\">\n                            <span ng-bind=\"vm.model.edit.originCountry.Name\"></span>\n                        </div>\n                        <!--variation prices-->\n                        <div ng-show=\"vm.variationPreview.price\" class=\"pricePhoneBlock\">\n                            <span ng-bind=\"vm.variationPreview.price | formatCurrency:vm.countryID \"></span>\n                            &nbsp;\n                            <span ng-show=\"vm.variationPreview.oldPrice\" class=\"old\">\n                                <span ng-bind=\"vm.variationPreview.oldPrice| formatCurrency:vm.countryID\"></span>\n                            </span>\n                        </div>\n                        <!--variation badges-->\n                        <div class=\"phoneBadges\" ng-show=\"vm.variationPreview.badges.length > 0\">\n                            <span ng-repeat=\"badge in vm.variationPreview.badges\">\n                                <span class=\"p2-5 badgeBlock\" ng-bind=\"badge.name\"\n                                    ng-style=\"{'background-color':badge.color, 'color':badge.textcolor}\"></span>\n                            </span>\n                        </div>\n                        <!--variation size-->\n                        <div ng-show=\"vm.variationPreview.size\" class=\"wrapSelectImit\">\n                            <span class=\"labelGray\" translate=\"{{vm.model.edit.sizeName}}\"></span>\n                            <span ng-bind=\"vm.variationPreview.size\"></span>\n                        </div>\n                        <!--variation color-->\n                        <div ng-show=\"vm.variationPreview.color\" class=\"wrapSelectImit\">\n                            <span class=\"labelGray\" translate=\"colour_caption\" ng-show=\"!vm.IsFoodProduct\"></span>\n                            <span class=\"labelGray\" translate=\"choose_caption\" ng-show=\"vm.IsFoodProduct\"></span>\n                            <span ng-bind=\"vm.variationPreview.color\"></span>\n                        </div>\n                        <!--add to basket-->\n                        <div>\n                            <img ng-src=\"/assets/images/addToCartCountImg.svg\" width=\"231\" height=\"31\" />\n                        </div>\n                        <!--links-->\n                        <div class=\"phoneSocLink\">\n                            <div class=\"socialLinkWrap\">\n                                <div class=\"socialLinkSingle\" ng-repeat=\"link in vm.model.edit.links\">\n                                    <span class=\"fa {{link.type.viewClass}}\"></span>\n                                    <span>{{link.Title}}&nbsp;</span>\n                                </div>\n                            </div>\n                        </div>\n                        <!--description-->\n                        <div class=\"phoneDescr\" ng-if=\"vm.model.edit.description\">\n                            <span class=\"subtitle\" translate=\"field_description\"></span>\n                            <span ng-bind-html=\"vm.model.edit.description\"></span>\n                        </div>\n                        <!--allergens-->\n                        <div class=\"phoneDescr\"\n                            ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && (vm.model.edit.allergens  | filter: IsSelected=true).length > 0\">\n                            <span class=\"subtitle\" translate=\"allergens_title\"></span>\n                            <span ng-repeat=\"allergen in vm.model.edit.allergens  | filter: IsSelected=true\">\n                                <span ng-bind=\"allergen.Name\"></span>{{ $last ? '' : ', ' }}\n                            </span>\n                        </div>\n                        <!--foodPreferences-->\n                        <div class=\"phoneDescr\"\n                            ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && (vm.model.edit.foodPreferences  | filter: IsSelected=true).length > 0\">\n                            <span class=\"subtitle\" translate=\"foodPreference_title\"></span>\n                            <span ng-repeat=\"pereference in vm.model.edit.foodPreferences  | filter: IsSelected=true\">\n                                <span ng-bind=\"pereference.Name\"></span>{{ $last ? '' : ', ' }}\n                            </span>\n                        </div>\n                        <!--ingredients-->\n                        <div class=\"phoneDescr\" ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && vm.model.edit.ingredients\">\n                            <span class=\"subtitle\" translate=\"field_ingredients\"></span>\n                            <span ng-bind=\"vm.model.edit.ingredients\"></span>\n                        </div>\n                        <!--preparation-->\n                        <div class=\"phoneDescr\" ng-if=\"vm.IsFoodProduct && vm.model.edit.preparation\">\n                            <span class=\"subtitle\" translate=\"field_preparation\"></span>\n                            <span ng-bind=\"vm.model.edit.preparation\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"afterPhone\">\n                <!--/*step1*/-->\n                <div ng-show=\"vm.wizard.step == 1\">\n                    <div class=\"lh16 pt6 mb11\">\n                        <p translate=\"product_wizard_step1_desciption\"\n                            translate-value-sizecolor=\"{{vm.getTextSizeColorForDescription()}}\">\n                        </p>\n                        <p class=\"mb0\" translate=\"required_fields_hint\"></p>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_title\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" ng-disabled=\"vm.waiting\" ng-model=\"vm.model.edit.title\"\n                                    class=\"form-control\" name=\"title\">\n                            </div>\n                            <div class=\"text-danger mt-15  mb10\" ng-show=\"vm.model.edit.error.title\"\n                                ng-bind=\"vm.model.edit.error.title\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_short_description\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" id=\"productShortDescription\" name=\"productShortDescription\"\n                                    ng-model=\"vm.model.edit.shortDescription\" ng-readonly=\"vm.waiting\"\n                                    autocomplete=\"off\" class=\"form-control\" />\n                                <div class=\"grayNote\" translate=\"max_48_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.shortDescription\"\n                                ng-bind=\"vm.model.edit.error.shortDescription\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_category\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div\n                                    class=\"caretNo tableSelect chooseCategory pull-left dropdownWithNote dropdownHeight292  noPadBottom\">\n                                    <div class=\"ui-select-bootstrap dropdown \" reset-search-input=\"true\">\n                                        <div class=\"ui-select-match\">\n                                            <button type=\"button\" class=\"btn btn-default btn-block ui-select-toggle\"\n                                                tabindex=\"-1\" ng-disabled=\"vm.model.edit.category.FullName\"\n                                                ng-click=\"vm.selectCategory()\">\n                                                <span\n                                                    class=\"ui-select-placeholder text-muted ng-binding\">{{vm.model.edit.category.FullName}}</span>\n                                                <i class=\"caret pull-right\"></i>\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <span ng-disabled=\"vm.waiting\" ng-click=\"vm.selectCategory()\"\n                                    class=\"btn btnWhitePurple ml8 plr20 btnSelectList\"\n                                    translate=\"button_select_category\">\n                                </span>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.category\"\n                                ng-bind=\"vm.model.edit.error.category\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\">\n                        <label class=\"control-label\" translate=\"field_item_type\"></label><span\n                            ng-show=\"vm.IsFoodProduct\">*</span>\n                        <div class=\"posRel padRight\">\n                            <div class=\"form-control-static\" ng-class=\"{'disabled': !vm.model.edit.category}\">\n                                <ui-select class=\"fs-13\"\n                                           name=\"itemTypes\"\n                                           ng-model=\"vm.model.edit.itemType\"\n                                           on-select=\"vm.productForm.$setDirty()\"\n                                           theme=\"bootstrap\"\n                                           uis-open-close=\"vm.paginatedItemTypes.resetVisibleList()\"\n                                           reset-search-input=\"true\"\n                                           ng-disabled=\"vm.waiting || !vm.model.edit.itemTypes || vm.model.edit.itemTypes.length === 0\">\n                                    <ui-select-match class=\"ui-select-match\" placeholder=\"Select item type\">\n                                        {{ $select.selected.PluralForm }}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat=\"type in vm.paginatedItemTypes.getVisibleList()\"\n                                        refresh=\"vm.paginatedItemTypes.setFilter($select.search)\"\n                                        refresh-delay=\"0\"\n                                        when-scrolled=\"vm.paginatedItemTypes.showMore()\">\n                                        <div>\n                                            <div ng-bind-html=\"type.PluralForm | highlight: $select.search\"></div>\n                                        </div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                            <span class=\"fa fa-close\" ng-show=\"vm.model.edit.itemType\"\n                                ng-click=\"vm.model.edit.itemType = null\"></span>\n                        </div>\n                        <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.itemType\"\n                            ng-bind=\"vm.model.edit.error.itemType\"></div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_brand\">\n                        </label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div class=\"min-h37\" ng-hide=\"vm.model.edit.category\">\n                                    <div\n                                        class=\"disabledCustom selectSearchWrap caretNo tableSelect width444 pull-left dropdownWithNote dropdownHeight292  noPadBottom\">\n                                        <button type=\"button\" class=\"btn btn-default btnSelectList\"\n                                            translate=\"button_select_a_brand_from_list\">\n                                        </button>\n                                        <div class=\"ui-select-container ui-select-bootstrap dropdown\"\n                                            reset-search-input=\"true\">\n                                            <div class=\"ui-select-match\">\n                                                <button type=\"button\" class=\"btn btn-default btn-block ui-select-toggle\"\n                                                    tabindex=\"-1\" ng-disabled=\"$select.disabled\"\n                                                    ng-click=\"$select.activate()\">\n                                                    <span class=\"ui-select-placeholder text-muted ng-binding\"\n                                                        translate=\"search_to_add_a_brand\"></span>\n                                                    <i class=\"caret pull-right\"></i>\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-show=\"vm.model.edit.category\" class=\"specColorFaBrand wizard__brand min-h37\">\n                                    <brands-selector allow-add=\"true\" ng-disabled=\"vm.waiting\" single-select=\"true\"\n                                        ng-if=\"vm.model.edit.category.ID\" search-all-brands=\"true\"\n                                        category-id=\"vm.model.edit.category.ID\" model=\"vm.model.edit.brands\"\n                                        on-change=\"vm.productForm.$setDirty()\"></brands-selector>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"text-danger mt-15 mb10\" ng-show=\"vm.model.edit.error.brand\"\n                            ng-bind=\"vm.model.edit.error.brand\"></div>\n                    </div>\n\n                    <div class=\"form-group m0 fieldWithClose width400 gender-field\" ng-show=\"!vm.IsFoodProduct\">\n                        <label class=\"control-label\" translate=\"gender\">\n                        </label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div uib-dropdown class=\"wideSelect\">\n                                    <button type=\"button\" uib-dropdown-toggle class=\"btn btn-default dropdown-toggle fw\"\n                                        aria-haspopup=\"true\" aria-expanded=\"false\">\n                                        <span class=\"caret\"></span>\n                                        <span ng-hide=\"vm.model.edit.genderItem\"\n                                            translate=\"button_select_gender\"></span>\n                                        <span ng-show=\"vm.model.edit.genderItem\"\n                                            ng-bind=\"vm.model.edit.genderItem.Name\"></span>\n                                    </button>\n                                    <ul class=\"dropdown-menu\">\n                                        <li ng-repeat=\"item in vm.model.edit.genderItems\"\n                                            ng-click=\"vm.clearSizeValues();vm.model.edit.genderItem = item; vm.productForm.$setDirty();\">\n                                            <a href=\"#\">{{item.Name}}</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                            <span class=\"fa fa-close\" ng-show=\"vm.model.edit.genderItem\"\n                                ng-click=\"vm.model.edit.genderItem = null\"></span>\n\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct\">\n                        <label class=\"control-label\" translate=\"field_country_of_origin\">\n                        </label>\n                        <div class=\"posRel padRight\">\n                            <div class=\"form-control-static\">\n                                <ui-select class=\"fs-13\" name=\"originCountry\" ng-model=\"vm.model.edit.originCountry\"\n                                    on-select=\"vm.productForm.$setDirty()\" theme=\"bootstrap\" reset-search-input=\"true\"\n                                    ng-disabled=\"vm.waiting\">\n                                    <ui-select-match class=\"ui-select-match\" placeholder=\"Select origin country\">\n                                        {{ $select.selected.Name }}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"item in vm.originCountryList | filter: $select.search\"\n                                        refresh-delay=\"0\">\n                                        <div>\n                                            <div ng-bind-html=\"item.Name | highlight: $select.search\"></div>\n                                        </div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                            <span class=\"fa fa-close mt-extra\" ng-show=\"vm.model.edit.originCountry\"\n                                ng-click=\"vm.model.edit.originCountry = null\"></span>\n                        </div>\n                        <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.originCountry\"\n                            ng-bind=\"vm.model.edit.error.originCountry\">\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_preparation\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" id=\"productPreparation\" name=\"productPreparation\"\n                                    ng-model=\"vm.model.edit.preparation\" ng-readonly=\"vm.waiting\" autocomplete=\"off\"\n                                    class=\"form-control\" />\n                                <div class=\"grayNote\" translate=\"max_250_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.preparation\"\n                                ng-bind=\"vm.model.edit.error.preparation\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_ingredients\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <textarea id=\"productIngredients\" name=\"productIngredients\"\n                                    ng-model=\"vm.model.edit.ingredients\" ng-readonly=\"vm.waiting\" autocomplete=\"off\"\n                                    class=\"form-control\" rows=\"3\"></textarea>\n                                <div class=\"grayNote\" translate=\"max_2000_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.ingredients\"\n                                ng-bind=\"vm.model.edit.error.ingredients\"></div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 form-group m0  preferenceSection\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                        <div class=\"col-lg-7\">\n                            <preference-selector preferences=\"vm.model.edit.foodPreferences\"\n                                component-title=\"vm.preferenceTitle\" description='vm.commonPreferenceDescription'\n                                on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                            <preference-selector preferences=\"vm.model.edit.allergens\"\n                                component-title=\"vm.allergenTitle\" description='vm.commonAllergenDescription'\n                                on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"description\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static  textEditor200\">\n                                <div text-angular ta-paste=\"vm.pasteHandler($html)\" ng-model=\"vm.model.edit.description\"\n                                    class=\"btn-group-small\" ng-readonly=\"vm.waiting\"></div>\n                            </div>\n                            <div class=\"text-danger mt-15  mb10\" ng-show=\"vm.model.edit.error.description\"\n                                ng-bind=\"vm.model.edit.error.description\"></div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 divided-group mr-5\">\n                        <div class=\"form-group m0 mt8\">\n                            <product-stickers-list items=\"vm.model.edit.nfcStickers\" stores=\"vm.stores\"\n                                is-list-disabled=\"!vm.canEditStickers\" errors=\"vm.model.edit.error.stickers\">\n                            </product-stickers-list>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 divided-group mr-5\">\n                        <div class=\"form-group m0 mt8  socialLinkControl socialLinkControlWizard\">\n                            <label class=\"control-label mb8\" translate=\"product_links_and_social_networks\"></label>\n                            <div class=\"posRel padRight\" ng-repeat=\"link in vm.model.edit.links\">\n                                <div class=\"form-control-static\">\n                                    <div class=\"campainInputProd  input-group\">\n                                        <div uib-dropdown ng-class=\"{'error': link.error.type}\" class=\"input-group-btn\">\n                                            <button type=\"button\" uib-dropdown-toggle\n                                                class=\"btn btn-default dropdown-toggle\" aria-haspopup=\"true\"\n                                                aria-expanded=\"false\">\n                                                <span ng-hide=\"link.type\" translate=\"link_type\"></span>\n                                                <span class=\"text-gray-dark\"\n                                                    ng-show=\"link.type\">{{link.type.Name}}</span>\n                                                <span class=\"caret\"></span>\n                                            </button>\n                                            <ul class=\"dropdown-menu\">\n                                                <li ng-repeat=\"type in vm.model.linkTypes\"\n                                                    ng-click=\"link.type = type; vm.productForm.$setDirty()\">\n                                                    <a href=\"#\">{{type.Name}}</a>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                        <input type=\"text\" ng-model=\"link.Url\" ng-class=\"{'error': link.error.url}\"\n                                            class=\"form-control error\" ng- placeholder=\"URL\" />\n                                        <input type=\"text\" ng-model=\"link.Title\" ng-class=\"{'error': link.error.title}\"\n                                            class=\"form-control\" placeholder=\"Title\" />\n                                    </div>\n                                </div>\n                                <span class=\"fa fa-close\" ng-click=\"vm.removeLink($index)\"></span>\n                                <div class=\"text-danger mt-5\" ng-show=\"link.error.sum\" ng-bind=\"link.error.sum\"></div>\n                            </div>\n                            <div class=\"addElement\">\n                                <span ng-click=\"vm.addLink()\" class=\"link\">\n                                    <em class=\"fa fa-plus\"></em>\n                                    <span translate=\"add_a_link\"></span>\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 mr-5\">\n                        <div class=\"form-group m0 mt8\">\n\n                            <div class=\"clearfix radioGroup badgeCheck mb15\">\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox  mb15 pr90\">\n                                    <label for=\"preOrder\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.preOrder\" id=\"preOrder\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"field_pre-order_allowed\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox mt0  mb15 pr90\">\n                                    <label for=\"verificationRequired\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.verificationRequired\"\n                                            id=\"verificationRequired\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"validation_required\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox  mb15 pr90\">\n                                    <label for=\"isInformation\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.isInformation\"\n                                            id=\"isInformation\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"field_product_isInformation\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"text-danger\"></div>\n                </div>\n\n                <!--/*step2*/-->\n                <div ng-show=\"vm.wizard.step == 2\">\n                    <div>\n                        <div class=\"lh16 pt6 mb16\">\n                            <p translate=\"add_or_edit_product_ingredients\"></p>\n                        </div>\n                        <product-ingredients-list items=\"vm.model.edit.ingredientList\"\n                                                  is-disabled=\"!vm.IsFoodProduct\"\n                                                  on-item-add=\"vm.onAddNewIngredient(item)\"\n                                                  on-items-delete=\"vm.onDeleteIngredients(items)\"\n                                                  on-item-delete=\"vm.onDeleteIngredient(item)\">\n                        </product-ingredients-list>\n                    </div>\n                </div>\n\n                <!--step3-->\n                <div ng-show=\"vm.wizard.step == 3\">\n                    <div ng-show=\"vm.wizard.step == 3 && vm.variation\" class=\"noteTop\" translate=\"product_wizard_note\"></div>\n                    <div ng-show=\"vm.variation\">\n                        <div class=\"lh16 pt6 mb11\" translate=\"enter_size_colour_sku_hint\"\n                            translate-value-sizecolor=\"{{vm.getTextSizeColor()}}\"></div>\n                        <div class=\"row chooseOption\">\n                            <div ng-show=\"vm.model.edit.colourName\" class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 width180\">\n                                <div class=\"form-group m0\">\n                                    <label class=\"control-label\" translate=\"{{vm.model.edit.colourName}}\"></label>\n                                    <div class=\"posRel\">\n                                        <div class=\"form-control-static \">\n                                            <input type=\"text\" class=\"form-control\" ng-model=\"vm.variation.color\"\n                                                   ng-readonly=\"vm.waiting\">\n                                        </div>\n                                        <div class=\"text-danger mt-15\" ng-show=\"vm.variation.error.color\"\n                                             ng-bind=\"vm.variation.error.color\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 width180 mb16 mr4\"\n                                ng-hide=\"vm.model.edit.measurementEnable\">\n                                <div class=\"option\">\n                                    <label class=\"control-label\" translate=\"{{vm.model.edit.sizeName}}\">\n                                    </label>\n                                    <input type=\"text\" ng-model=\"vm.variation.size\" ng-readonly=\"vm.waiting\"\n                                        class=\"form-control\" />\n                                    <div class=\"text-danger\" ng-show=\"vm.variation.error.size\"\n                                        ng-bind=\"variation.error.size\"></div>\n                                </div>\n                            </div>\n\n                            <div class=\"row chooseOption overflowVisible\">\n                                <div class=\"col-lg-4 col-md-4 col-sm-6  col-xs-12 mb16 width180\"\n                                    ng-repeat=\"type in vm.model.edit.measurementTypes\"\n                                    ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeVisible[type.ID]\">\n                                    <div class=\"option\">\n                                        <label class=\"control-label\">\n                                            {{type.Name}}\n                                        </label>\n\n                                        <ui-select class=\"buttonSize\" name=\"measurementTypeSelect\"\n                                            ng-model=\"vm.variation.measurementTypeItem[type.ID]\"\n                                            on-select=\"vm.selectMeasurementItem($item, type.ID, vm.variation); vm.productForm.$setDirty();\"\n                                            ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                            theme=\"bootstrap\" reset-search-input=\"true\">\n                                            <ui-select-match class=\"ui-select-match\"\n                                                placeholder=\"{{ vm.model.edit.measurementItems[type.ID].length > 0 ? 'Search to set a size': 'Set size' }}\">\n                                                <span\n                                                    ng-bind-html=\"$select.selected.Value | highlight: $select.search\"></span>\n                                                <a class=\"btn btn-xs btn-link pull-right pt0 pb0\"\n                                                    ng-click=\"clearMeasurementItem($event, $select, type.ID, vm.variation)\">\n                                                    <i class=\"fa fa-close\"></i>\n                                                </a>\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat=\"item in (vm.model.edit.measurementItems[type.ID] | filter: { Value: $select.search } ) track by (item.ID + item.Value)\"\n                                                refresh=\"vm.refreshMeasurementTypeItem($select)\" refresh-delay=\"0\">\n                                                <div ng-hide=\"item.forAdd\">\n                                                    <div ng-bind-html=\"item.Value | highlight: $select.search\"></div>\n                                                </div>\n                                                <div ng-show=\"item.forAdd\" class=\"addLine\"\n                                                    ng-click=\"vm.addNewMeasurementItem(item, type.ID, variation)\">\n                                                    <span translate=\"set_cusom_size\"\n                                                        translate-value-search=\"{{ $select.search }}\"></span>\n                                                </div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <input type=\"text\" ng-readonly=\"true\" class=\"form-control\"\n                                            ng-hide=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                            ng-disabled=\"true\" />\n                                        <div class=\"text-danger\" ng-show=\"vm.variation.error.sizes[type.ID]\"\n                                            ng-bind=\"vm.variation.error.sizes[type.ID]\"></div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs12 wd-auto\">\n                                <div class=\"form-group m0\">\n                                    <label class=\"control-label\" translate=\"sku\"></label>\n                                    <div class=\"posRel\">\n                                        <div class=\"form-control-static \">\n                                            <input type=\"text\" class=\"form-control width384\" ng-model=\"vm.variation.sku\"\n                                                ng-readonly=\"vm.waiting\">\n                                        </div>\n                                        <div class=\"text-danger mt-15\" ng-show=\"vm.variation.error.sku\"\n                                            ng-bind=\"vm.variation.error.sku\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <hr class=\"mt5 mb11\" />\n                        <div class=\"lh16 pt6 mb16\" translate=\"upload_product_images_hint\"></div>\n                        <choice-product-images ng-if=\"vm.variation\" wizard ng-show=\"true\"\n                            server-images-id=\"vm.model.serverVariationImagesID[vm.variation.id]\"\n                            current-images-id=\"vm.variation.imagesID\" callback-update=\"vm.productForm.$setDirty()\"\n                            class=\"tooltipImages tooltipImagesWizard clearfix\">\n                        </choice-product-images>\n                        <div class=\"text-danger\" ng-show=\"variation.error.image\" ng-bind=\"variation.error.image\"></div>\n\n                        <hr class=\"mt0 mb11\" />\n                        <div class=\"lh16 pt6 mb11\" translate=\"enter_price_or_old_price_for_product_or_variation\"\n                            translate-value-html-span-text-through=\"<span class='text-through'>\"\n                            translate-value-html-span-close=\"</span>\" translate-currency-Sign=\"vm.currencySign\">\n                        </div>\n                        <div class=\"posRel mb24\">\n                            <div ng-if=\"!vm.IsFoodProduct\" class=\"no-scroll\">\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"field_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                ng-model=\"vm.variation.price\" ng-readonly=\"vm.waiting\"\n                                                ng-class=\"vm.variation.error.price ? 'input-validation__field--invalid': ''\">\n                                                <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.price\"\n                                                ng-bind=\"vm.variation.error.price\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal min-value=\"0\"\n                                                max-value=\"100\" ng-model=\"vm.variation.vat\" ng-readonly=\"vm.waiting\">\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"old_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                   ng-model=\"vm.variation.oldPrice\" ng-readonly=\"vm.waiting\"\n                                                   ng-class=\"vm.variation.error.oldPrice ? 'input-validation__field--invalid': ''\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.oldPrice\"\n                                                 ng-bind=\"vm.variation.error.oldPrice\"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"vm.IsFoodProduct\">\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"takeaway_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   ng-class=\"vm.variation.error.price ? 'input-validation__field--invalid': ''\"\n                                                   ng-model=\"vm.variation.price\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.price\"\n                                                ng-bind=\"vm.variation.error.price\"></div>\n                                        </div>\n\n                                    </div>\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"takeaway_VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   min-value=\"0\"\n                                                   max-value=\"100\"\n                                                   ng-model=\"vm.variation.vat\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\"\n                                                   ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"old_takeaway_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                ng-model=\"vm.variation.oldPrice\" ng-readonly=\"vm.waiting\"\n                                                ng-class=\"vm.variation.error.oldPrice ? 'input-validation__field--invalid': ''\"\n                                                ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.oldPrice\"\n                                                ng-bind=\"vm.variation.error.oldPrice\"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"eat_in_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   ng-class=\"vm.variation.error.takeawayGreatEatIn? 'input-validation__field--invalid': ''\"\n                                                   ng-model=\"vm.variation.insidePrice\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\"\n                                                   ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.takeawayGreatEatIn\"\n                                                translate=\"eatIn_must_be_greater_takeAway\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"eat_in_VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   min-value=\"0\"\n                                                   max-value=\"100\"\n                                                   ng-model=\"vm.variation.insideVAT\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-disabled=\"!vm.variation.insidePrice || vm.variation.insidePrice == 0 || vm.variation.error.takeawayGreatEatIn\n                                                || !vm.variation.price || vm.variation.price == 0\"\n                                                   ng-readonly=\"vm.waiting\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"vm.IsFoodProduct\" class=\"form-control-static pb0\">\n                                <product-preparation type=\"vm.variation.isHot\" time=\"vm.variation.preparationTime\"\n                                    waiting=\"vm.waiting\" variation-id=\"variation.id\" error=\"vm.variation.error.preparationTime\"\n                                    on-preparation-change=\"vm.changeVariationPreparationTime(preparationMessage)\">\n                                </product-preparation>\n                            </div>\n                            <div class=\"d-flex mb24\">\n                                <div class=\"width150\">\n                                    <label class=\"common-label mr6 v-top\" translate=\"stock_level_label\"></label>\n                                    <span ng-click=\"vm.openStockLevelInfo()\" class=\"question-icon question-button clickable\">\n                                                </span>\n                                    <div>\n                                        <input type=\"text\"\n                                               class=\"form-control\"\n                                               only-num\n                                               is-number=\"true\"\n                                               ng-model=\"vm.variation.stockQuantity\"\n                                               ng-readonly=\"vm.waiting\"/>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"wizard__product-discount mb24\">\n                            <product-discount discount=\"vm.variation.discount\" variation-id=\"vm.variation.id\"\n                                              is-disabled=\"vm.variation.specialOffer\"\n                                              on-discount-change=\"vm.changeVariationDiscount(discountMessage)\">\n                            </product-discount>\n                        </div>\n\n                        <div class=\"clearfix radioGroup badgeCheck flexVerticalAlignParent flex-wrap disableRadioCheckbox\">\n                            <div ng-repeat=\"badge in vm.filterBadges(vm.variation.badges)\"\n                                class=\"styleRadioCheckboxWrap checkbox c-checkbox mb30\">\n                                <label for=\"badge{{$index}}\">\n                                    <input type=\"checkbox\" name=\"badge{{$index}}\"\n                                        ng-click=\"vm.badgeClick(badge, vm.variation.badges)\" id=\"badge{{$index}}\"\n                                        ng-disabled=\"vm.isBadgeDisabled(badge, vm.variation.badges, vm.variation.specialOffer)\"\n                                        ng-model=\"badge.selected\" class=\"ng-pristine ng-untouched ng-valid\">\n                                    <span class=\"fa fa-check\"></span>\n                                    <i ng-bind=\"badge.name\" ng-style=\"{'background-color':badge.color}\"></i>\n                                </label>\n                            </div>\n                        </div>\n\n                        <product-special-offer ng-if=\"vm.model.edit.variations.length == 1\"\n                                               special-offer=\"vm.variation.specialOffer\"\n                                               old-price=\"vm.variation.price\"\n                                               currency-class=\"vm.currencyCssClass\"\n                                               is-read-only=\"vm.waiting\"\n                                               is-disabled=\"vm.variation.discount\"\n                                               variation-id=\"vm.variation.id\"\n                                               on-special-offer-changed=\"vm.onChangeSpecialOffer(specialOfferMessage)\">\n                        </product-special-offer>\n\n                        <product-variation-ingredients-list ng-if=\"vm.variation.ingredients && vm.variation.ingredients.length > 0\"\n                                                            on-ingredient-changed=\"vm.onIngredientChanged(item, vm.variation)\"\n                                                            is-take-away-price-disabled=\"!vm.variation.price\"\n                                                            is-eat-in-price-disabled=\"!vm.variation.insidePrice\"\n                                                            currency-class=\"vm.currencyCssClass\"\n                                                            ingredients=\"vm.model.edit.ingredientList\"\n                                                            items=\"vm.variation.ingredients\">\n                        </product-variation-ingredients-list>\n\n                        <div class=\"text-danger\" ng-show=\"vm.variation.error.variations\"\n                            ng-bind=\"vm.variation.error.variations\"></div>\n                    </div>\n                    <div ng-hide=\"vm.variation\">\n                        <div class=\"lh16 pt6 mb16\">\n                            <p translate=\"add_or_edit_product_variation_or_images_prices_and_skus\"></p>\n                            <p class=\"mb0\" translate=\"product_wizard_fields_description\"></p>\n                        </div>\n                        <button type=\"button\" ng-click=\"vm.addVariation()\" class=\"btn btn-success  btn-with-line\">\n                            <span class=\"fa fa-plus\"></span>\n                            <span translate=\"button_add_varioation_or_price_or_image\"></span>\n                        </button>\n                        <div class=\"text-danger pt30 pb5\" ng-show=\"vm.model.edit.error.variations\"\n                            ng-bind=\"vm.model.edit.error.variations\"></div>\n                        <div class=\"ml-10 mt10\">\n                            <table class=\"wizardProductsTable\">\n                                <tr ng-repeat=\"variation in  vm.model.edit.variations\">\n                                    <td class=\"width1 align-top\">\n                                        <div class=\"imgWraper\">\n                                            <img ng-if=\"variation.imagesID.length > 0\"\n                                                ng-src=\"{{vm.getImageUrl(variation.imagesID)}}\" />\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.image\"\n                                            ng-bind=\"variation.error.image\"></span>\n\n                                    </td>\n                                    <td class=\"width1 align-top\">\n                                        <div class=\"option\">\n                                            <div class=\"clearfix\" ng-show=\"variation.size\">\n                                                <label class=\"width87\" translate=\"{{vm.model.edit.sizeName}}\"></label>\n                                                <span ng-bind=\"variation.size\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.size\"\n                                                ng-bind=\"variation.error.size\"></span>\n\n                                            <div ng-repeat=\"type in vm.model.edit.measurementTypes\">\n                                                <div class=\"clearfix \"\n                                                    ng-show=\"variation.measurementTypeItem[type.ID] \">\n                                                    <label class=\"width87\">\n                                                        {{type.Name}}\n                                                    </label>\n                                                    <span\n                                                        ng-bind=\"variation.measurementTypeItem[type.ID] ? variation.measurementTypeItem[type.ID].Value : null\"></span>\n                                                </div>\n                                                <span class=\"text-danger\" ng-show=\"variation.error.sizes[type.ID]\"\n                                                    ng-bind=\"variation.error.sizes[type.ID]\"></span>\n                                            </div>\n\n                                            <div class=\"clearfix\" ng-show=\"variation.color\">\n                                                <label class=\"width87\" translate=\"colour\"\n                                                    ng-show=\"!vm.IsFoodProduct\"></label>\n                                                <label class=\"width87\" translate=\"choose\"\n                                                    ng-show=\"vm.IsFoodProduct\"></label>\n                                                <span ng-bind=\"variation.color\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.color\"\n                                                ng-bind=\"variation.error.color\"></span>\n                                        </div>\n                                    </td>\n                                    <td class=\"priceTd width1 align-top\">\n                                        <div class=\"price\">\n                                            <span ng-bind=\"variation.price | formatCurrency:vm.countryID \"></span>\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.price\"\n                                            ng-bind=\"variation.error.price\"></span>\n                                        <div ng-show=\"variation.oldPrice\" class=\"oldPrice\">\n                                            <span ng-bind=\"variation.oldPrice | formatCurrency:vm.countryID\"></span>\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.oldPrice\"\n                                            ng-bind=\"variation.error.oldPrice\"></span>\n                                    </td>\n                                    <td class=\"align-top\">\n                                        <div class=\"option \">\n                                            <div class=\"clearfix  mb9\" ng-show=\"variation.sku\">\n                                                <b translate=\"sku_caption\"></b>\n                                                <span ng-bind=\"variation.sku\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.sku\"\n                                                ng-bind=\"variation.error.sku\"></span>\n                                        </div>\n                                        <div class=\"badgeLabel \">\n                                            <span ng-repeat=\"badge in vm.filterBadges(variation.badges, true)\">\n                                                <span class=\"p2-5 badgeBlock\" ng-bind=\"badge.name\"\n                                                    ng-style=\"{'background-color':badge.color, 'color':badge.textcolor}\"></span>\n                                            </span>\n                                        </div>\n                                    </td>\n                                    <td class=\"align-top\">\n                                        <div class=\"option\">\n                                            <div class=\"clearfix\">\n                                                <b translate=\"discount_caption\"></b>\n                                                <span ng-if=\"!variation.discount\"\n                                                    translate=\"discount_staff_none\"></span>\n                                                <span ng-if=\"variation.discount && variation.discount === 100\"\n                                                    translate=\"discount_staff_free\"></span>\n                                                <span ng-if=\"variation.discount && variation.discount < 100\">\n                                                    {{::variation.discount}}\n                                                    <span translate=\"discount_staff_percent\"></span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </td>\n                                    <td class=\"descr width1\">\n                                        <div class=\"text-right controlProducts\">\n                                            <em ng-click=\"vm.editVariation(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" translate\n                                                translate-attr-uib-tooltip-html=\"tooltip_edit\"\n                                                class=\"icon-edit-grey  inline-block mt10 mr10\"></em>\n                                            <em ng-click=\"vm.copyVariation(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" translate\n                                                translate-attr-uib-tooltip-html=\"tooltip_copy\"\n                                                class=\"icon-copy-grey  inline-block mt10 mr10\"></em>\n                                            <em ng-hide=\"vm.model.edit.variations.length == 1\"\n                                                ng-click=\"vm.removeVariationWizard(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" uib-tooltip-html=\"vm.getTooltipText(variation)\"\n                                                class=\"icon-delete-grey  inline-block mt10 mr10\"></em>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-show=\"vm.wizard.step == 4\" class=\"extrasWrapper\">\n                <div>\n                    <div class=\"lh16 pt6 mb16\">\n                        <p translate=\"add_or_edit_product_extras\"></p>\n                    </div>\n                    <product-extras-list items=\"vm.model.edit.extras\"></product-extras-list>\n                </div>\n            </div>\n        </div>\n        <div class=\"wizardBottomButton clearfix\">\n            <div class=\"pull-left\">\n                <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.discardWizard()\"\n                    class=\"btn btnWhitePurple plr20 btnSelectList pull-left\" translate=\"button_discard\">\n                </button>\n                <button type=\"button\" ng-class=\"{'hidden':vm.wizard.step === 3}\"\n                    ng-disabled=\"vm.waiting || vm.productForm.$pristine\" ng-click=\"vm.saveWizard()\"\n                    class=\"btn btnWhitePurple plr20 btnSelectList btn-with-line  pull-left\">\n                    <em class=\"fa fa-save\"></em>\n                    <span class=\"inner\" translate=\"button_save\"></span>\n                </button>\n            </div>\n            <div class=\"pull-right\">\n                <button type=\"button\" ng-click=\"vm.cancelVariation(vm.variation)\"\n                    ng-class=\"{'show':vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4), 'hidden': !(vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4))}\"\n                    class=\"btn btnWhitePurple pull-left\" translate=\"button_cancel\">\n                </button>\n                <button type=\"button\" ng-click=\"vm.saveVariation(vm.variation)\"\n                    ng-class=\"{'show':vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4), 'hidden': !(vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4))}\"\n                    class=\"btn btn-success pull-left\" translate=\"button_save_variation\">\n                </button>\n                <button type=\"button\" ng-click=\"vm.copyVariation(vm.variation)\"\n                    ng-class=\"{'show':vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4), 'hidden': !(vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4))}\"\n                    class=\"btn btn-success pull-left\" translate=\"button_save_and_copy\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting\"\n                    ng-class=\"{'hidden':vm.wizard.step <= 1 || (vm.variation  && (vm.wizard.step == 3 || vm.wizard.step == 4))}\"\n                    ng-click=\"vm.wizard.back()\" class=\"btn btnWhitePurple pull-left\" translate=\"button_back\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting || vm.variation\"\n                    ng-class=\"{'hidden':vm.wizard.step >= 4 || (vm.variation  && vm.wizard.step == 4)}\"\n                    ng-click=\"vm.wizard.next()\" class=\"btn btn-success pull-right\" translate=\"button_next\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting || vm.productForm.$pristine\"\n                    ng-class=\"{'hidden':vm.wizard.step !== 4}\" ng-click=\"vm.saveWizard()\"\n                    class=\"btn btn-success pull-right\" translate=\"button_finish\">\n                </button>\n            </div>\n        </div>\n    </form>\n    <form name=\"vm.productForm\" novalidate role=\"form\" ng-if=\"vm.isNfrnRetailer\">\n        <div class=\"productWizard clearfix \">\n            <div class=\"productWizardPoint\" style=\"width: 50%\">\n                <div ng-class=\"{'active': vm.nfrnWizard.step === 1}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            1\n                            <span ng-show=\"vm.nfrnWizard.step > 1\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_info\"></div>\n                </div>\n            </div>\n            <div class=\"productWizardPoint\" style=\"width: 50%\">\n                <div ng-class=\"{'active': vm.nfrnWizard.step === 2}\">\n                    <div class=\"numberStep\">\n                        <span class=\"posRel\">\n                            2\n                            <span ng-show=\"vm.nfrnWizard.step > 2\" class=\"fa fa-check-circle\"></span>\n                        </span>\n                    </div>\n                    <div class=\"titleStep\" translate=\"product_variation\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"clearfix wrapWizardStep\">\n            <div ng-show=\"vm.nfrnWizard.step !==2\" class=\"pull-left phoneWrapWizard\">\n                <div class=\"titleHeader\" ng-bind=\"vm.model.edit.title\"></div>\n                <div class=\"textHeader\" translate=\"jisp_store\"></div>\n                <div class=\"phoneWrapWizardInner\">\n                    <div class=\"wizardScrollPhone\">\n                        <!--variation image-->\n                        <div class=\"mt3\">\n                            <div class=\"img\">\n                                <span ng-if=\"vm.variationPreview.imageID\"></span>\n                                <div ng-hide=\"vm.variationPreview.imageID\" class=\"placeholderImg fa fa-picture-o\">\n                                </div>\n                                <img ng-if=\"vm.variationPreview.imageID\"\n                                     ng-src=\"{{vm.getImageUrl(vm.variationPreview.imageID)}}\" />\n                            </div>\n                            <div class=\"listOfImages\" ng-show=\"vm.variationPreview.images.length > 1\">\n                                <span ng-repeat=\"image in vm.variationPreview.images\"\n                                      ng-click=\"vm.variationPreview.selectImage(image)\"\n                                      ng-class=\"{'active': image.selected }\"></span>\n                            </div>\n                        </div>\n                        <!--brand-->\n                        <div class=\"categBrand\">\n                            <span\n                                    ng-bind=\"vm.model.edit.brands && vm.model.edit.brands[0] ? vm.model.edit.brands[0].Name : '' \"></span>\n                        </div>\n                        <!--title-->\n                        <div class=\"title\">\n                            <span ng-bind=\"vm.model.edit.title\"></span>\n                        </div>\n                        <!--country-->\n                        <div class=\"country\" ng-show=\"vm.IsFoodProduct\">\n                            <span ng-bind=\"vm.model.edit.originCountry.Name\"></span>\n                        </div>\n                        <!--variation prices-->\n                        <div ng-show=\"vm.variationPreview.price\" class=\"pricePhoneBlock\">\n                            <span ng-bind=\"vm.variationPreview.price | formatCurrency:vm.countryID \"></span>\n                            &nbsp;\n                            <span ng-show=\"vm.variationPreview.oldPrice\" class=\"old\">\n                                <span ng-bind=\"vm.variationPreview.oldPrice| formatCurrency:vm.countryID\"></span>\n                            </span>\n                        </div>\n                        <!--variation badges-->\n                        <div class=\"phoneBadges\" ng-show=\"vm.variationPreview.badges.length > 0\">\n                            <span ng-repeat=\"badge in vm.variationPreview.badges\">\n                                <span class=\"p2-5 badgeBlock\" ng-bind=\"badge.name\"\n                                      ng-style=\"{'background-color':badge.color, 'color':badge.textcolor}\"></span>\n                            </span>\n                        </div>\n                        <!--variation size-->\n                        <div ng-show=\"vm.variationPreview.size\" class=\"wrapSelectImit\">\n                            <span class=\"labelGray\" translate=\"{{vm.model.edit.sizeName}}\"></span>\n                            <span ng-bind=\"vm.variationPreview.size\"></span>\n                        </div>\n                        <!--variation color-->\n                        <div ng-show=\"vm.variationPreview.color\" class=\"wrapSelectImit\">\n                            <span class=\"labelGray\" translate=\"colour_caption\" ng-show=\"!vm.IsFoodProduct\"></span>\n                            <span class=\"labelGray\" translate=\"choose_caption\" ng-show=\"vm.IsFoodProduct\"></span>\n                            <span ng-bind=\"vm.variationPreview.color\"></span>\n                        </div>\n                        <!--add to basket-->\n                        <div>\n                            <img ng-src=\"/assets/images/addToCartCountImg.svg\" width=\"231\" height=\"31\" />\n                        </div>\n                        <!--links-->\n                        <div class=\"phoneSocLink\">\n                            <div class=\"socialLinkWrap\">\n                                <div class=\"socialLinkSingle\" ng-repeat=\"link in vm.model.edit.links\">\n                                    <span class=\"fa {{link.type.viewClass}}\"></span>\n                                    <span>{{link.Title}}&nbsp;</span>\n                                </div>\n                            </div>\n                        </div>\n                        <!--description-->\n                        <div class=\"phoneDescr\" ng-if=\"vm.model.edit.description\">\n                            <span class=\"subtitle\" translate=\"field_description\"></span>\n                            <span ng-bind-html=\"vm.model.edit.description\"></span>\n                        </div>\n                        <!--allergens-->\n                        <div class=\"phoneDescr\"\n                             ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && (vm.model.edit.allergens  | filter: IsSelected=true).length > 0\">\n                            <span class=\"subtitle\" translate=\"allergens_title\"></span>\n                            <span ng-repeat=\"allergen in vm.model.edit.allergens  | filter: IsSelected=true\">\n                                <span ng-bind=\"allergen.Name\"></span>{{ $last ? '' : ', ' }}\n                            </span>\n                        </div>\n                        <!--foodPreferences-->\n                        <div class=\"phoneDescr\"\n                             ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && (vm.model.edit.foodPreferences  | filter: IsSelected=true).length > 0\">\n                            <span class=\"subtitle\" translate=\"foodPreference_title\"></span>\n                            <span ng-repeat=\"pereference in vm.model.edit.foodPreferences  | filter: IsSelected=true\">\n                                <span ng-bind=\"pereference.Name\"></span>{{ $last ? '' : ', ' }}\n                            </span>\n                        </div>\n                        <!--ingredients-->\n                        <div class=\"phoneDescr\" ng-if=\"(vm.IsFoodProduct || vm.isGroceryProduct) && vm.model.edit.ingredients\">\n                            <span class=\"subtitle\" translate=\"field_ingredients\"></span>\n                            <span ng-bind=\"vm.model.edit.ingredients\"></span>\n                        </div>\n                        <!--preparation-->\n                        <div class=\"phoneDescr\" ng-if=\"vm.IsFoodProduct && vm.model.edit.preparation\">\n                            <span class=\"subtitle\" translate=\"field_preparation\"></span>\n                            <span ng-bind=\"vm.model.edit.preparation\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"afterPhone\">\n                <!--/*step1*/-->\n                <div ng-show=\"vm.nfrnWizard.step == 1\">\n                    <div class=\"lh16 pt6 mb11\">\n                        <p translate=\"product_wizard_step1_desciption\"\n                           translate-value-sizecolor=\"{{vm.getTextSizeColorForDescription()}}\">\n                        </p>\n                        <p class=\"mb0\" translate=\"required_fields_hint\"></p>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_title\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" ng-disabled=\"vm.waiting\" ng-model=\"vm.model.edit.title\"\n                                       class=\"form-control\" name=\"title\">\n                            </div>\n                            <div class=\"text-danger mt-15  mb10\" ng-show=\"vm.model.edit.error.title\"\n                                 ng-bind=\"vm.model.edit.error.title\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_short_description\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" id=\"productShortDescription\" name=\"productShortDescription\"\n                                       ng-model=\"vm.model.edit.shortDescription\" ng-readonly=\"vm.waiting\"\n                                       autocomplete=\"off\" class=\"form-control\" />\n                                <div class=\"grayNote\" translate=\"max_48_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.shortDescription\"\n                                 ng-bind=\"vm.model.edit.error.shortDescription\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_category\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div\n                                        class=\"caretNo tableSelect chooseCategory pull-left dropdownWithNote dropdownHeight292  noPadBottom\">\n                                    <div class=\"ui-select-bootstrap dropdown \" reset-search-input=\"true\">\n                                        <div class=\"ui-select-match\">\n                                            <button type=\"button\" class=\"btn btn-default btn-block ui-select-toggle\"\n                                                    tabindex=\"-1\" ng-disabled=\"vm.model.edit.category.FullName\"\n                                                    ng-click=\"vm.selectCategory()\">\n                                                <span\n                                                        class=\"ui-select-placeholder text-muted ng-binding\">{{vm.model.edit.category.FullName}}</span>\n                                                <i class=\"caret pull-right\"></i>\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <span ng-disabled=\"vm.waiting\" ng-click=\"vm.selectCategory()\"\n                                      class=\"btn btnWhitePurple ml8 plr20 btnSelectList\"\n                                      translate=\"button_select_category\">\n                                </span>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.category\"\n                                 ng-bind=\"vm.model.edit.error.category\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\">\n                        <label class=\"control-label\" translate=\"field_item_type\"></label><span\n                            ng-show=\"vm.IsFoodProduct\">*</span>\n                        <div class=\"posRel padRight\">\n                            <div class=\"form-control-static\" ng-class=\"{'disabled': !vm.model.edit.category}\">\n                                <ui-select class=\"fs-13\" name=\"itemTypes\" ng-model=\"vm.model.edit.itemType\"\n                                           on-select=\"vm.productForm.$setDirty()\" theme=\"bootstrap\" reset-search-input=\"true\"\n                                           ng-disabled=\"vm.waiting || !vm.model.edit.itemTypes || vm.model.edit.itemTypes.length === 0\">\n                                    <ui-select-match class=\"ui-select-match\" placeholder=\"Select item type\">\n                                        {{ $select.selected.SingleForm }}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"type in vm.model.edit.itemTypes | filter: $select.search\"\n                                                       refresh-delay=\"0\">\n                                        <div>\n                                            <div ng-bind-html=\"type.SingleForm | highlight: $select.search\"></div>\n                                        </div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                            <span class=\"fa fa-close\" ng-show=\"vm.model.edit.itemType\"\n                                  ng-click=\"vm.model.edit.itemType = null\"></span>\n                        </div>\n                        <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.itemType\"\n                             ng-bind=\"vm.model.edit.error.itemType\"></div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"field_brand\">\n                        </label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div class=\"min-h37\" ng-hide=\"vm.model.edit.category\">\n                                    <div\n                                            class=\"disabledCustom selectSearchWrap caretNo tableSelect width444 pull-left dropdownWithNote dropdownHeight292  noPadBottom\">\n                                        <button type=\"button\" class=\"btn btn-default btnSelectList\"\n                                                translate=\"button_select_a_brand_from_list\">\n                                        </button>\n                                        <div class=\"ui-select-container ui-select-bootstrap dropdown\"\n                                             reset-search-input=\"true\">\n                                            <div class=\"ui-select-match\">\n                                                <button type=\"button\" class=\"btn btn-default btn-block ui-select-toggle\"\n                                                        tabindex=\"-1\" ng-disabled=\"$select.disabled\"\n                                                        ng-click=\"$select.activate()\">\n                                                    <span class=\"ui-select-placeholder text-muted ng-binding\"\n                                                          translate=\"search_to_add_a_brand\"></span>\n                                                    <i class=\"caret pull-right\"></i>\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-show=\"vm.model.edit.category\" class=\"specColorFaBrand wizard__brand min-h37\">\n                                    <brands-selector allow-add=\"true\" ng-disabled=\"vm.waiting\" single-select=\"true\"\n                                                     ng-if=\"vm.model.edit.category.ID\" search-all-brands=\"true\"\n                                                     category-id=\"vm.model.edit.category.ID\" model=\"vm.model.edit.brands\"\n                                                     on-change=\"vm.productForm.$setDirty()\"></brands-selector>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"text-danger mt-15 mb10\" ng-show=\"vm.model.edit.error.brand\"\n                             ng-bind=\"vm.model.edit.error.brand\"></div>\n                    </div>\n\n                    <div class=\"form-group m0 fieldWithClose width400 gender-field\" ng-show=\"!vm.IsFoodProduct\">\n                        <label class=\"control-label\" translate=\"gender\">\n                        </label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <div uib-dropdown class=\"wideSelect\">\n                                    <button type=\"button\" uib-dropdown-toggle class=\"btn btn-default dropdown-toggle fw\"\n                                            aria-haspopup=\"true\" aria-expanded=\"false\">\n                                        <span class=\"caret\"></span>\n                                        <span ng-hide=\"vm.model.edit.genderItem\"\n                                              translate=\"button_select_gender\"></span>\n                                        <span ng-show=\"vm.model.edit.genderItem\"\n                                              ng-bind=\"vm.model.edit.genderItem.Name\"></span>\n                                    </button>\n                                    <ul class=\"dropdown-menu\">\n                                        <li ng-repeat=\"item in vm.model.edit.genderItems\"\n                                            ng-click=\"vm.clearSizeValues();vm.model.edit.genderItem = item; vm.productForm.$setDirty();\">\n                                            <a href=\"#\">{{item.Name}}</a>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                            <span class=\"fa fa-close\" ng-show=\"vm.model.edit.genderItem\"\n                                  ng-click=\"vm.model.edit.genderItem = null\"></span>\n\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct\">\n                        <label class=\"control-label\" translate=\"field_country_of_origin\">\n                        </label>\n                        <div class=\"posRel padRight\">\n                            <div class=\"form-control-static\">\n                                <ui-select class=\"fs-13\" name=\"originCountry\" ng-model=\"vm.model.edit.originCountry\"\n                                           on-select=\"vm.productForm.$setDirty()\" theme=\"bootstrap\" reset-search-input=\"true\"\n                                           ng-disabled=\"vm.waiting\">\n                                    <ui-select-match class=\"ui-select-match\" placeholder=\"Select origin country\">\n                                        {{ $select.selected.Name }}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"item in vm.originCountryList | filter: $select.search\"\n                                                       refresh-delay=\"0\">\n                                        <div>\n                                            <div ng-bind-html=\"item.Name | highlight: $select.search\"></div>\n                                        </div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"\" ng-bind=\"\"></div>\n                            <span class=\"fa fa-close mt-extra\" ng-show=\"vm.model.edit.originCountry\"\n                                  ng-click=\"vm.model.edit.originCountry = null\"></span>\n                        </div>\n                        <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.originCountry\"\n                             ng-bind=\"vm.model.edit.error.originCountry\">\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_preparation\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" id=\"productPreparation\" name=\"productPreparation\"\n                                       ng-model=\"vm.model.edit.preparation\" ng-readonly=\"vm.waiting\" autocomplete=\"off\"\n                                       class=\"form-control\" />\n                                <div class=\"grayNote\" translate=\"max_250_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.preparation\"\n                                 ng-bind=\"vm.model.edit.error.preparation\"></div>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0 fieldWithClose\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                        <div>\n                            <label class=\"control-label\" translate=\"field_ingredients\">\n                            </label>\n                            <div class=\"form-control-static\">\n                                <textarea id=\"productIngredients\" name=\"productIngredients\"\n                                          ng-model=\"vm.model.edit.ingredients\" ng-readonly=\"vm.waiting\" autocomplete=\"off\"\n                                          class=\"form-control\" rows=\"3\"></textarea>\n                                <div class=\"grayNote\" translate=\"max_2000_characters\"></div>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\" ng-show=\"vm.model.edit.error.ingredients\"\n                                 ng-bind=\"vm.model.edit.error.ingredients\"></div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 form-group m0  preferenceSection\" ng-show=\"vm.IsFoodProduct || vm.isGroceryProduct\">\n                        <div class=\"col-lg-7\">\n                            <preference-selector preferences=\"vm.model.edit.foodPreferences\"\n                                                 component-title=\"vm.preferenceTitle\" description='vm.commonPreferenceDescription'\n                                                 on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                            <preference-selector preferences=\"vm.model.edit.allergens\"\n                                                 component-title=\"vm.allergenTitle\" description='vm.commonAllergenDescription'\n                                                 on-change=\"vm.productForm.$setDirty()\"></preference-selector>\n                        </div>\n                    </div>\n                    <div class=\"form-group m0\">\n                        <label class=\"control-label\" translate=\"description\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static  textEditor200\">\n                                <div text-angular ta-paste=\"vm.pasteHandler($html)\" ng-model=\"vm.model.edit.description\"\n                                     class=\"btn-group-small\" ng-readonly=\"vm.waiting\"></div>\n                            </div>\n                            <div class=\"text-danger mt-15  mb10\" ng-show=\"vm.model.edit.error.description\"\n                                 ng-bind=\"vm.model.edit.error.description\"></div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 divided-group mr-5\">\n                        <div class=\"form-group m0 mt8\">\n                            <product-stickers-list items=\"vm.model.edit.nfcStickers\" stores=\"vm.stores\"\n                                                   is-list-disabled=\"!vm.canEditStickers\" errors=\"vm.model.edit.error.stickers\">\n                            </product-stickers-list>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 divided-group mr-5\">\n                        <div class=\"form-group m0 mt8  socialLinkControl socialLinkControlWizard\">\n                            <label class=\"control-label mb8\" translate=\"product_links_and_social_networks\"></label>\n                            <div class=\"posRel padRight\" ng-repeat=\"link in vm.model.edit.links\">\n                                <div class=\"form-control-static\">\n                                    <div class=\"campainInputProd  input-group\">\n                                        <div uib-dropdown ng-class=\"{'error': link.error.type}\" class=\"input-group-btn\">\n                                            <button type=\"button\" uib-dropdown-toggle\n                                                    class=\"btn btn-default dropdown-toggle\" aria-haspopup=\"true\"\n                                                    aria-expanded=\"false\">\n                                                <span ng-hide=\"link.type\" translate=\"link_type\"></span>\n                                                <span class=\"text-gray-dark\"\n                                                      ng-show=\"link.type\">{{link.type.Name}}</span>\n                                                <span class=\"caret\"></span>\n                                            </button>\n                                            <ul class=\"dropdown-menu\">\n                                                <li ng-repeat=\"type in vm.model.linkTypes\"\n                                                    ng-click=\"link.type = type; vm.productForm.$setDirty()\">\n                                                    <a href=\"#\">{{type.Name}}</a>\n                                                </li>\n                                            </ul>\n                                        </div>\n                                        <input type=\"text\" ng-model=\"link.Url\" ng-class=\"{'error': link.error.url}\"\n                                               class=\"form-control error\" ng- placeholder=\"URL\" />\n                                        <input type=\"text\" ng-model=\"link.Title\" ng-class=\"{'error': link.error.title}\"\n                                               class=\"form-control\" placeholder=\"Title\" />\n                                    </div>\n                                </div>\n                                <span class=\"fa fa-close\" ng-click=\"vm.removeLink($index)\"></span>\n                                <div class=\"text-danger mt-5\" ng-show=\"link.error.sum\" ng-bind=\"link.error.sum\"></div>\n                            </div>\n                            <div class=\"addElement\">\n                                <span ng-click=\"vm.addLink()\" class=\"link\">\n                                    <em class=\"fa fa-plus\"></em>\n                                    <span translate=\"add_a_link\"></span>\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-12 mr-5\" ng-if=\"!vm.isNfrnRetailer\">\n                        <div class=\"form-group m0 mt8\">\n\n                            <div class=\"clearfix radioGroup badgeCheck mb15\">\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox  mb15 pr90\">\n                                    <label for=\"preOrder\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.preOrder\" id=\"preOrder\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"field_pre-order_allowed\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox mt0  mb15 pr90\">\n                                    <label for=\"verificationRequired\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.verificationRequired\"\n                                               id=\"verificationRequired\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"validation_required\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox  mb15 pr90\">\n                                    <label for=\"isInformation\">\n                                        <input type=\"checkbox\" ng-model=\"vm.model.edit.isInformation\"\n                                               id=\"isInformation\">\n                                        <span class=\"fa fa-check\"></span>\n                                        <b translate=\"field_product_isInformation\" class=\"text-nowrap\"></b>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"text-danger\"></div>\n                </div>\n\n                <!--step2-->\n                <div ng-show=\"vm.nfrnWizard.step == 2\">\n                    <div ng-show=\"vm.wizard.step == 2 && vm.variation\" class=\"noteTop\" translate=\"product_wizard_note\"></div>\n                    <div ng-show=\"vm.variation\">\n                        <div class=\"lh16 pt6 mb11\" translate=\"enter_size_colour_sku_hint\"\n                             translate-value-sizecolor=\"{{vm.getTextSizeColor()}}\"></div>\n                        <div class=\"row chooseOption\">\n                            <div ng-show=\"vm.model.edit.colourName\" class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 width180\">\n                                <div class=\"form-group m0\">\n                                    <label class=\"control-label\" translate=\"{{vm.model.edit.colourName}}\"></label>\n                                    <div class=\"posRel\">\n                                        <div class=\"form-control-static\">\n                                            <input type=\"text\" class=\"form-control\" ng-model=\"vm.variation.color\"\n                                                   ng-readonly=\"vm.waiting\">\n                                        </div>\n                                        <div class=\"text-danger mt-15\" ng-show=\"vm.variation.error.color\"\n                                             ng-bind=\"vm.variation.error.color\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-lg-4 col-md-4 col-sm-12  col-xs-12 wd-auto mb16 mr4\"\n                                 ng-hide=\"vm.model.edit.measurementEnable\">\n                                <div class=\"option\">\n                                    <label class=\"control-label\" translate=\"{{vm.model.edit.sizeName}}\">\n                                    </label>\n                                    <input type=\"text\" ng-model=\"vm.variation.size\" ng-readonly=\"vm.waiting\"\n                                           class=\"form-control width180\" />\n                                    <div class=\"text-danger\" ng-show=\"vm.variation.error.size\"\n                                         ng-bind=\"variation.error.size\"></div>\n                                </div>\n                            </div>\n\n                            <div class=\"row chooseOption overflowVisible\">\n                                <div class=\"col-lg-4 col-md-4 col-sm-6  col-xs-12 mb16 width180\"\n                                     ng-repeat=\"type in vm.model.edit.measurementTypes\"\n                                     ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeVisible[type.ID]\">\n                                    <div class=\"option\">\n                                        <label class=\"control-label\">\n                                            {{type.Name}}\n                                        </label>\n\n                                        <ui-select class=\"buttonSize\" name=\"measurementTypeSelect\"\n                                                   ng-model=\"vm.variation.measurementTypeItem[type.ID]\"\n                                                   on-select=\"vm.selectMeasurementItem($item, type.ID, vm.variation); vm.productForm.$setDirty();\"\n                                                   ng-show=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                                   theme=\"bootstrap\" reset-search-input=\"true\">\n                                            <ui-select-match class=\"ui-select-match\"\n                                                             placeholder=\"{{ vm.model.edit.measurementItems[type.ID].length > 0 ? 'Search to set a size': 'Set size' }}\">\n                                                <span\n                                                        ng-bind-html=\"$select.selected.Value | highlight: $select.search\"></span>\n                                                <a class=\"btn btn-xs btn-link pull-right pt0 pb0\"\n                                                   ng-click=\"clearMeasurementItem($event, $select, type.ID, vm.variation)\">\n                                                    <i class=\"fa fa-close\"></i>\n                                                </a>\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                    repeat=\"item in (vm.model.edit.measurementItems[type.ID] | filter: { Value: $select.search } ) track by (item.ID + item.Value)\"\n                                                    refresh=\"vm.refreshMeasurementTypeItem($select)\" refresh-delay=\"0\">\n                                                <div ng-hide=\"item.forAdd\">\n                                                    <div ng-bind-html=\"item.Value | highlight: $select.search\"></div>\n                                                </div>\n                                                <div ng-show=\"item.forAdd\" class=\"addLine\"\n                                                     ng-click=\"vm.addNewMeasurementItem(item, type.ID, variation)\">\n                                                    <span translate=\"set_cusom_size\"\n                                                          translate-value-search=\"{{ $select.search }}\"></span>\n                                                </div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <input type=\"text\" ng-readonly=\"true\" class=\"form-control\"\n                                               ng-hide=\"vm.model.edit.measurementEnable && vm.model.edit.measurementTypeEnable[type.ID]\"\n                                               ng-disabled=\"true\" />\n                                        <div class=\"text-danger\" ng-show=\"vm.variation.error.sizes[type.ID]\"\n                                             ng-bind=\"vm.variation.error.sizes[type.ID]\"></div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"col-lg-6 col-md-6 col-sm-12 col-xs12 wd-auto\">\n                                <div class=\"form-group m0\">\n                                    <label class=\"control-label\" translate=\"sku\"></label>\n                                    <div class=\"posRel\">\n                                        <div class=\"form-control-static \">\n                                            <input type=\"text\" class=\"form-control width384\" ng-model=\"vm.variation.sku\"\n                                                   ng-readonly=\"vm.waiting\">\n                                        </div>\n                                        <div class=\"text-danger mt-15\" ng-show=\"vm.variation.error.sku\"\n                                             ng-bind=\"vm.variation.error.sku\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <hr class=\"mt5 mb11\" />\n                        <div class=\"lh16 pt6 mb16\" translate=\"upload_product_images_hint\"></div>\n                        <choice-product-images ng-if=\"vm.variation\" wizard ng-show=\"true\"\n                                               server-images-id=\"vm.model.serverVariationImagesID[vm.variation.id]\"\n                                               current-images-id=\"vm.variation.imagesID\" callback-update=\"vm.productForm.$setDirty()\"\n                                               class=\"tooltipImages tooltipImagesWizard clearfix\">\n                        </choice-product-images>\n                        <div class=\"text-danger\" ng-show=\"variation.error.image\" ng-bind=\"variation.error.image\"></div>\n\n                        <hr class=\"mt0 mb11\" />\n                        <div class=\"lh16 pt6 mb11\" translate=\"enter_price_or_old_price_for_product_or_variation\"\n                             translate-value-html-span-text-through=\"<span class='text-through'>\"\n                             translate-value-html-span-close=\"</span>\" translate-currency-Sign=\"vm.currencySign\">\n                        </div>\n                        <div class=\"posRel mb24\">\n                            <div ng-if=\"!vm.IsFoodProduct\" class=\"no-scroll\">\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"field_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}}\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                   ng-model=\"vm.variation.price\" ng-readonly=\"vm.waiting\"\n                                                   ng-class=\"vm.variation.error.price ? 'input-validation__field--invalid': ''\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.price\"\n                                                 ng-bind=\"vm.variation.error.price\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal min-value=\"0\"\n                                                   max-value=\"100\" ng-model=\"vm.variation.vat\" ng-readonly=\"vm.waiting\">\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"old_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                   ng-model=\"vm.variation.oldPrice\" ng-readonly=\"vm.waiting\"\n                                                   ng-class=\"vm.variation.error.oldPrice ? 'input-validation__field--invalid': ''\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.oldPrice\"\n                                                 ng-bind=\"vm.variation.error.oldPrice\"></div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"vm.IsFoodProduct\">\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"takeaway_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   ng-class=\"vm.variation.error.price ? 'input-validation__field--invalid': ''\"\n                                                   ng-model=\"vm.variation.price\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.price\"\n                                                 ng-bind=\"vm.variation.error.price\"></div>\n                                        </div>\n\n                                    </div>\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"takeaway_VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   min-value=\"0\"\n                                                   max-value=\"100\"\n                                                   ng-model=\"vm.variation.vat\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\"\n                                                   ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"old_takeaway_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\" class=\"form-control\" only-decimal\n                                                   ng-model=\"vm.variation.oldPrice\" ng-readonly=\"vm.waiting\"\n                                                   ng-class=\"vm.variation.error.oldPrice ? 'input-validation__field--invalid': ''\"\n                                                   ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.oldPrice\"\n                                                 ng-bind=\"vm.variation.error.oldPrice\"></div>\n                                        </div>\n\n                                    </div>\n                                </div>\n                                <div class=\"d-flex\">\n                                    <div class=\"form-group m0 width150 mr24\">\n                                        <label class=\"control-label\" translate=\"eat_in_price\"></label>\n                                        <div class=\"form-control-static {{vm.currencyCssClass}} t15\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   ng-class=\"vm.variation.error.takeawayGreatEatIn? 'input-validation__field--invalid': ''\"\n                                                   ng-model=\"vm.variation.insidePrice\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-readonly=\"vm.waiting\"\n                                                   ng-disabled=\"!vm.variation.price || vm.variation.price == 0\">\n                                            <div class=\"text-danger text-nowrap\" ng-show=\"vm.variation.error.takeawayGreatEatIn\"\n                                                 translate=\"eatIn_must_be_greater_takeAway\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group m0 width150\">\n                                        <label class=\"control-label\" translate=\"eat_in_VAT\"></label>\n                                        <div class=\"form-control-static withPercent\">\n                                            <input type=\"text\"\n                                                   class=\"form-control\"\n                                                   only-decimal\n                                                   min-value=\"0\"\n                                                   max-value=\"100\"\n                                                   ng-model=\"vm.variation.insideVAT\"\n                                                   ng-model-options=\"{ updateOn: 'blur' }\"\n                                                   ng-change=\"vm.showIngredientAttentionIfNeed()\"\n                                                   ng-disabled=\"!vm.variation.insidePrice || vm.variation.insidePrice == 0 || vm.variation.error.takeawayGreatEatIn\n                                                || !vm.variation.price || vm.variation.price == 0\"\n                                                   ng-readonly=\"vm.waiting\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div ng-if=\"vm.IsFoodProduct\" class=\"form-control-static pb0\">\n                                <product-preparation type=\"vm.variation.isHot\" time=\"vm.variation.preparationTime\"\n                                                     waiting=\"vm.waiting\" variation-id=\"variation.id\" error=\"vm.variation.error.preparationTime\"\n                                                     on-preparation-change=\"vm.changeVariationPreparationTime(preparationMessage)\">\n                                </product-preparation>\n                            </div>\n\n                        </div>\n\n                        <div class=\"clearfix radioGroup badgeCheck flexVerticalAlignParent flex-wrap disableRadioCheckbox\">\n                            <div ng-repeat=\"badge in vm.filterBadges(vm.variation.badges)\"\n                                 class=\"styleRadioCheckboxWrap checkbox c-checkbox mb30\">\n                                <label for=\"badge{{$index}}\">\n                                    <input type=\"checkbox\" name=\"badge{{$index}}\"\n                                           ng-click=\"vm.badgeClick(badge, vm.variation.badges)\" id=\"badge{{$index}}\"\n                                           ng-disabled=\"vm.isBadgeDisabled(badge, vm.variation.badges, vm.variation.specialOffer)\"\n                                           ng-model=\"badge.selected\" class=\"ng-pristine ng-untouched ng-valid\">\n                                    <span class=\"fa fa-check\"></span>\n                                    <i ng-bind=\"badge.name\" ng-style=\"{'background-color':badge.color}\"></i>\n                                </label>\n                            </div>\n                        </div>\n\n                        <product-special-offer special-offer=\"vm.variation.specialOffer\"\n                                               old-price=\"vm.variation.price\"\n                                               currency-class=\"vm.currencyCssClass\"\n                                               is-read-only=\"vm.waiting\"\n                                               is-disabled=\"vm.variation.discount\"\n                                               variation-id=\"vm.variation.id\"\n                                               on-special-offer-changed=\"vm.onChangeSpecialOffer(specialOfferMessage)\">\n                        </product-special-offer>\n\n                        <product-variation-ingredients-list ng-if=\"vm.variation.ingredients && vm.variation.ingredients.length > 0\"\n                                                            on-ingredient-changed=\"vm.onIngredientChanged(item, vm.variation)\"\n                                                            is-take-away-price-disabled=\"!vm.variation.price\"\n                                                            is-eat-in-price-disabled=\"!vm.variation.insidePrice\"\n                                                            currency-class=\"vm.currencyCssClass\"\n                                                            ingredients=\"vm.model.edit.ingredientList\"\n                                                            items=\"vm.variation.ingredients\">\n                        </product-variation-ingredients-list>\n\n                        <div class=\"text-danger\" ng-show=\"vm.variation.error.variations\"\n                             ng-bind=\"vm.variation.error.variations\"></div>\n                    </div>\n                    <div ng-hide=\"vm.variation\">\n                        <div class=\"lh16 pt6 mb16\">\n                            <p translate=\"add_or_edit_product_variation_or_images_prices_and_skus\"></p>\n                            <p class=\"mb0\" translate=\"product_wizard_fields_description\"></p>\n                        </div>\n                        <button type=\"button\" ng-click=\"vm.addVariation()\" class=\"btn btn-success  btn-with-line\">\n                            <span class=\"fa fa-plus\"></span>\n                            <span translate=\"button_add_varioation_or_price_or_image\"></span>\n                        </button>\n                        <div class=\"text-danger pt30 pb5\" ng-show=\"vm.model.edit.error.variations\"\n                             ng-bind=\"vm.model.edit.error.variations\"></div>\n                        <div class=\"ml-10 mt10\">\n                            <table class=\"wizardProductsTable\">\n                                <tr ng-repeat=\"variation in  vm.model.edit.variations\">\n                                    <td class=\"width1 align-top\">\n                                        <div class=\"imgWraper\">\n                                            <img ng-if=\"variation.imagesID.length > 0\"\n                                                 ng-src=\"{{vm.getImageUrl(variation.imagesID)}}\" />\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.image\"\n                                              ng-bind=\"variation.error.image\"></span>\n\n                                    </td>\n                                    <td class=\"width1 align-top\">\n                                        <div class=\"option\">\n                                            <div class=\"clearfix\" ng-show=\"variation.size\">\n                                                <label class=\"width87\" translate=\"{{vm.model.edit.sizeName}}\"></label>\n                                                <span ng-bind=\"variation.size\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.size\"\n                                                  ng-bind=\"variation.error.size\"></span>\n\n                                            <div ng-repeat=\"type in vm.model.edit.measurementTypes\">\n                                                <div class=\"clearfix \"\n                                                     ng-show=\"variation.measurementTypeItem[type.ID] \">\n                                                    <label class=\"width87\">\n                                                        {{type.Name}}\n                                                    </label>\n                                                    <span\n                                                            ng-bind=\"variation.measurementTypeItem[type.ID] ? variation.measurementTypeItem[type.ID].Value : null\"></span>\n                                                </div>\n                                                <span class=\"text-danger\" ng-show=\"variation.error.sizes[type.ID]\"\n                                                      ng-bind=\"variation.error.sizes[type.ID]\"></span>\n                                            </div>\n\n                                            <div class=\"clearfix\" ng-show=\"variation.color\">\n                                                <label class=\"width87\" translate=\"colour\"\n                                                       ng-show=\"!vm.IsFoodProduct\"></label>\n                                                <label class=\"width87\" translate=\"choose\"\n                                                       ng-show=\"vm.IsFoodProduct\"></label>\n                                                <span ng-bind=\"variation.color\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.color\"\n                                                  ng-bind=\"variation.error.color\"></span>\n                                        </div>\n                                    </td>\n                                    <td class=\"priceTd width1 align-top\">\n                                        <div class=\"price\">\n                                            <span ng-bind=\"variation.price | formatCurrency:vm.countryID \"></span>\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.price\"\n                                              ng-bind=\"variation.error.price\"></span>\n                                        <div ng-show=\"variation.oldPrice\" class=\"oldPrice\">\n                                            <span ng-bind=\"variation.oldPrice | formatCurrency:vm.countryID\"></span>\n                                        </div>\n                                        <span class=\"text-danger\" ng-show=\"variation.error.oldPrice\"\n                                              ng-bind=\"variation.error.oldPrice\"></span>\n                                    </td>\n                                    <td class=\"align-top\">\n                                        <div class=\"option \">\n                                            <div class=\"clearfix  mb9\" ng-show=\"variation.sku\">\n                                                <b translate=\"sku_caption\"></b>\n                                                <span ng-bind=\"variation.sku\"></span>\n                                            </div>\n                                            <span class=\"text-danger\" ng-show=\"variation.error.sku\"\n                                                  ng-bind=\"variation.error.sku\"></span>\n                                        </div>\n                                        <div class=\"badgeLabel \">\n                                            <span ng-repeat=\"badge in vm.filterBadges(variation.badges, true)\">\n                                                <span class=\"p2-5 badgeBlock\" ng-bind=\"badge.name\"\n                                                      ng-style=\"{'background-color':badge.color, 'color':badge.textcolor}\"></span>\n                                            </span>\n                                        </div>\n                                    </td>\n                                    <td class=\"align-top\">\n                                        <div class=\"option\">\n                                            <div class=\"clearfix\">\n                                                <b translate=\"discount_caption\"></b>\n                                                <span ng-if=\"!variation.discount\"\n                                                      translate=\"discount_staff_none\"></span>\n                                                <span ng-if=\"variation.discount && variation.discount === 100\"\n                                                      translate=\"discount_staff_free\"></span>\n                                                <span ng-if=\"variation.discount && variation.discount < 100\">\n                                                    {{::variation.discount}}\n                                                    <span translate=\"discount_staff_percent\"></span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </td>\n                                    <td class=\"descr width1\">\n                                        <div class=\"text-right controlProducts\">\n                                            <em ng-click=\"vm.editVariation(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" translate\n                                                translate-attr-uib-tooltip-html=\"tooltip_edit\"\n                                                class=\"icon-edit-grey  inline-block mt10 mr10\"></em>\n                                            <em ng-click=\"vm.copyVariation(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" translate\n                                                translate-attr-uib-tooltip-html=\"tooltip_copy\"\n                                                class=\"icon-copy-grey  inline-block mt10 mr10\"></em>\n                                            <em ng-hide=\"vm.model.edit.variations.length == 1\"\n                                                ng-click=\"vm.removeVariationWizard(variation)\" tooltip-popup-delay=\"200\"\n                                                tooltip-placement=\"top\" uib-tooltip-html=\"vm.getTooltipText(variation)\"\n                                                class=\"icon-delete-grey  inline-block mt10 mr10\"></em>\n                                        </div>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"wizardBottomButton clearfix\">\n            <div class=\"pull-left\">\n                <button type=\"button\" ng-disabled=\"vm.waiting\" ng-click=\"vm.discardWizard()\"\n                        class=\"btn btnWhitePurple plr20 btnSelectList pull-left\" translate=\"button_discard\">\n                </button>\n                <button type=\"button\" ng-class=\"{'hidden':vm.nfrnWizard.step === 2}\"\n                        ng-disabled=\"vm.waiting || vm.productForm.$pristine\" ng-click=\"vm.saveWizard()\"\n                        class=\"btn btnWhitePurple plr20 btnSelectList btn-with-line  pull-left\">\n                    <em class=\"fa fa-save\"></em>\n                    <span class=\"inner\" translate=\"button_save\"></span>\n                </button>\n            </div>\n            <div class=\"pull-right\">\n                <button type=\"button\" ng-click=\"vm.cancelVariation(vm.variation)\"\n                        ng-class=\"{'show':vm.variation  && vm.nfrnWizard.step == 2, 'hidden': !(vm.variation  && vm.nfrnWizard.step == 2)}\"\n                        class=\"btn btnWhitePurple pull-left\" translate=\"button_cancel\">\n                </button>\n                <button type=\"button\" ng-click=\"vm.saveVariation(vm.variation)\"\n                        ng-class=\"{'show':vm.variation  && vm.nfrnWizard.step == 2, 'hidden': !(vm.variation  && vm.nfrnWizard.step == 2)}\"\n                        class=\"btn btn-success pull-left\" translate=\"button_save_variation\">\n                </button>\n                <button type=\"button\" ng-click=\"vm.copyVariation(vm.variation)\"\n                        ng-class=\"{'show':vm.variation  && vm.nfrnWizard.step == 2, 'hidden': !(vm.variation  && vm.nfrnWizard.step == 2)}\"\n                        class=\"btn btn-success pull-left\" translate=\"button_save_and_copy\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting\"\n                        ng-class=\"{'hidden':vm.nfrnWizard.step <= 1 || (vm.variation  && vm.nfrnWizard.step == 2)}\"\n                        ng-click=\"vm.nfrnWizard.back()\" class=\"btn btnWhitePurple pull-left\" translate=\"button_back\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting || vm.variation\"\n                        ng-class=\"{'hidden':vm.nfrnWizard.step >= 2 || (vm.variation && vm.nfrnWizard.step == 2)}\"\n                        ng-click=\"vm.nfrnWizard.next()\" class=\"btn btn-success pull-right\" translate=\"button_next\">\n                </button>\n                <button type=\"button\" ng-disabled=\"vm.waiting || vm.productForm.$pristine\"\n                        ng-class=\"{'hidden':vm.nfrnWizard.step !== 2 || vm.variation}\" ng-click=\"vm.saveWizard()\"\n                        class=\"btn btn-success pull-right\" translate=\"button_finish\">\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n";

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<form class=\"publisher-settings pr12 pl12 pb24\" name=\"ctrl.form\">\n    <div class=\"mb24\">\n        <span class=\"fs-20 fw-500\" translate=\"publisher_settings\"></span>\n    </div>\n    <div class=\"panel panel-edit mb8\">\n        <div class=\"panel-heading panel-heading--bordered\">\n            <h4 class=\"panel-title fs-18 fw-500 color-black87\" translate=\"publisher_details\"></h4>\n        </div>\n        <div class=\"panel-body d-flex align-items-center\">\n            <label ng-if=\"ctrl.logoImage\"\n                   ng-click=\"ctrl.showLogoPopup = true\"\n                   off-click=\"ctrl.showLogoPopup = false\"\n                   class=\"posRel pt6 pl6 mr24 mb0 clickable\n                        publisher-settings-upload-image\"\n                   ng-class=\"{'active': ctrl.showLogoPopup}\">\n                <img src=\"{{ctrl.logoImage}}\" alt=\"\" class=\"logo\">\n                <div class=\"change-logo logo flex-column align-items-center justify-content-center\">\n                    <div class=\"icon-add-photo-placeholder opacity6 w48 h48 mb8\"></div>\n                    <span class=\"fs-14 fw-500 lh16 ls-031 color-black6\" translate=\"change_logo\"></span>\n                </div>\n                <span class=\"chooseVarProd publisher-settings-logo-popup fw-400 color-blue\" ng-show=\"ctrl.showLogoPopup\">\n                    <span ng-click=\"ctrl.addImage()\" translate=\"upload_new_logo\" class=\"clickable\"></span>\n                    <span ng-click=\"ctrl.removeLogo()\" translate=\"remove\" class=\"clickable\"></span>\n                </span>\n            </label>\n            <label ng-if=\"!ctrl.logoImage\" ng-click=\"ctrl.addImage()\"\n                 class=\"publisher-settings-upload-image pt6 pl6 mr24 mb0 clickable\">\n                <div class=\"logo bg-dark08 flex-column align-items-center justify-content-center\">\n                    <div class=\"icon-add-photo-placeholder opacity38 w48 h48\"></div>\n                </div>\n            </label>\n            <div class=\"flex-column flex-stretch\">\n                <label class=\"fs-14 fw-500 lh16 ls-031 color-black6\" for=\"CompanyName\" translate=\"publisher_settings_business_name\"></label>\n                <input type=\"text\" class=\"form-control fs-14 lh16 ls-031 color-black87 mb4\"\n                       id=\"CompanyName\" name=\"CompanyName\"\n                       ng-disabled=\"ctrl.waiting\"\n                       ng-model=\"ctrl.businessName\"\n                       ng-minlength=\"3\"\n                       ng-maxlength=\"100\">\n                <div ng-if=\"ctrl.form.CompanyName.$dirty && (ctrl.form.CompanyName.$invalid || !ctrl.form.CompanyName.$viewValue)\"\n                    class=\"text-danger lh16\">\n                    <span ng-if=\"!ctrl.form.CompanyName.$viewValue\" translate=\"field_is_required\"></span>\n                    <span ng-if=\"ctrl.form.CompanyName.$viewValue && ctrl.form.CompanyName.$error.minlength\">\n                        {{:: 'min_text_length_error' | translate : {count: 3} }}</span>\n                    <span ng-if=\"ctrl.form.CompanyName.$error.maxlength\">\n                        {{:: 'max_text_length_error' | translate : {count: 100} }}</span>\n                </div>\n                <span ng-if=\"ctrl.form.CompanyName.$pristine || ctrl.businessName && ctrl.form.CompanyName.$valid\"\n                      class=\"fs-12 lh16 ls-031 color-black38\"\n                      translate=\"publisher_settings_business_name_hint\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"d-flex justify-content-end\">\n        <button type=\"submit\"\n                ng-disabled=\"ctrl.waiting || ctrl.form.$pristine || !ctrl.isFormValid()\"\n                ng-click=\"ctrl.save()\"\n                class=\"btn btn-success height40 btn-with-icon\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\"></span>\n        </button>\n    </div>\n</form>\n";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"$ctrl.cancel()\">×</button>\n    <h4 class=\"modal-title\" translate=\"new_referral_account\" ></h4>\n</div>\n<div class=\"modal-body\">\n    <div class=\"form-group m0 clearfix\">\n        <label class=\"control-label big\" translate=\"referral_code\" >\n        </label>\n        <div class=\"posRel clearfix text-nowrap\">\n\n            <input class=\"form-control small\" type=\"text\" ng-model=\"$ctrl.data.referralCode\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" />\n            <span ng-if=\"!$ctrl.waiting && $ctrl.error\" class=\"text-danger pl5\" ng-bind=\"$ctrl.error\"></span>\n            <span ng-if=\"$ctrl.data.shopper\" class=\"pl5 grayName\" ng-bind=\"$ctrl.data.shopper.FullName\"></span>\n        </div>\n        </div>\n\n    <div class=\"form-group m0 clearfix\">\n        <label class=\"control-label big\" translate=\"referred_place\" >\n        </label>\n        <div class=\"posRel clearfix\">\n\n            <ui-select ng-model=\"$ctrl.data.storeID\" reset-search-input=\"true\" theme=\"bootstrap\" ng-disabled=\"$ctrl.waiting\">\n                <ui-select-match placeholder=\"Place\">{{$select.selected.Name }}</ui-select-match>\n                <ui-select-choices repeat=\"store.ID as store in $ctrl.resolve.stores | filter:$select.search\">{{store.Name}}</ui-select-choices>\n            </ui-select>\n        </div>\n        </div>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"butLine\">\n        <button type=\"button\" ng-click=\"$ctrl.save()\" ng-disabled=\"$ctrl.waiting || !$ctrl.data.shopper || !$ctrl.data.storeID\" class=\"btn btn-success\"\n            translate=\"button_save\" >Save</button>\n        <button type=\"button\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-danger\" translate=\"button_cancel\" ></button>\n    </div>\n</div>\n<style>\n    .commonShadow {\n        position: fixed;\n        width: 10000px;\n        height: 10000px;\n        top: -5000px;\n        left: -1000px;\n        z-index: 10;\n    }\n</style>\n<div ng-show=\"waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header mt-9 mb-3\">\n    <span translate=\"referral_accounts\" ></span>\n</div>\n<div class=\"noteReferal\" translate=\"referral_accounts_subtitle\" ></div>\n<div class=\"row\">\n    <div class=\"col-lg-12\">\n        <div class=\"panel panel-info tags-panel\">\n            <div class=\"panel-body\">\n                <table class=\"tagsTopForm\">\n                    <tr>\n                        <td class=\"width1\">\n                            <div class=\"posRel searchInput\">\n                                <input class=\"form-control width313\" ng-model=\"vm.settings.filter.keywords\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                                    translate translate-attr-placeholder=\"name_or_referral_code\"  />\n                                <span class=\"fa fa-search\"></span>\n                            </div>\n                        </td>\n                        <td class=\"width2000 pr28\">\n                            <div class=\"form-control-static placeSelect\" ng-class=\"'hello': vm.stores.length > 0\">\n                                <span>{{filterStores.length}}</span>\n                                <ui-select ng-model=\"vm.settings.filter.storeID\" \n                                           reset-search-input=\"true\" \n                                           theme=\"bootstrap\" \n                                           ng-disabled=\"vm.waiting || vm.filterStores.length > 0\">\n                                    <ui-select-match placeholder=\"{{::'place' | translate}}\">{{$select.selected.Name }}</ui-select-match>\n                                    <ui-select-choices repeat=\"store.ID as store in vm.filterStores | filter:$select.search\">{{store.Name}}</ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </td>\n                        <td class=\"width1\">\n                            <button type=\"button\" ng-disabled=\"vm.waiting || !vm.shoppersSelected || vm.settings.isOpenForm\" ng-click=\"vm.removeSelected()\" class=\"btn btnWhiteRed  btn-with-line\">\n                                <em class=\"fa fa-trash\"></em>\n                                <span translate=\"button_remove\" ></span>\n                            </button>\n                        </td>\n                        <td class=\"width1\">\n                            <button type=\"button\" ng-click=\"vm.add()\" ng-disabled=\"vm.waiting || vm.settings.isOpenForm\" class=\"btn btn-success btn-with-line width180\">\n                                <em class=\"fa fa-plus\"></em>\n                                <span translate=\"button_add_an_account\" ></span>\n                            </button>\n                        </td>\n                    </tr>\n                </table>\n                <div ng-hide=\"!vm.data.Total\" class=\"tableTags\">\n                    <div class=\"tr tableTagsHeader\">\n                        <div class=\"td width1\">\n                            <div class=\"inner\">\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\">\n                                    <label for=\"allCheckbox\" class=\"m0\">\n                                        <input type=\"checkbox\" name=\"allCheckbox\" ng-disabled=\"vm.waiting || vm.settings.isOpenForm\" ng-model=\"vm.allShoppersSelected\" ng-change=\"vm.onAllShoppersSelected()\" id=\"allCheckbox\">\n                                        <span class=\"fa fa-check\"></span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"td width1\" ng-click=\"vm.sort('ShopperName')\">\n                            <div class=\"inner width170 pl10 pr10\">\n                                <span translate=\"name\" ></span>\n                                <span>\n                                    <span class=\"fa fa-caret-up\" ng-show=\"vm.settings.filter.sortOrder === 'ascending' && vm.settings.filter.sortColumn === 'ShopperName'\"></span>\n                                    <span class=\"fa fa-caret-down\" ng-show=\"vm.settings.filter.sortOrder === 'descending' && vm.settings.filter.sortColumn === 'ShopperName'\"></span>\n                                </span>\n                            </div>\n                        </div>\n                        <div class=\"td width1\">\n                            <div class=\"inner width100 pl10 pr10\" translate=\"referral_code\" ></div>\n                        </div>\n                        <div class=\"td width2000 pl15 pr10\">\n                            <div class=\"inner\" ng-click=\"vm.sort('StoreName')\">\n                                <span translate=\"place\" ></span>\n                                <span ng-show=\"!vm.settings.filter.place || !vm.settings.filter.place.ID\">\n                                    <span class=\"fa fa-caret-up\" ng-show=\"vm.settings.filter.sortOrder === 'ascending' && vm.settings.filter.sortColumn === 'StoreName'\"></span>\n                                    <span class=\"fa fa-caret-down\" ng-show=\"vm.settings.filter.sortOrder === 'descending' && vm.settings.filter.sortColumn === 'StoreName'\"></span>\n                                </span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"tr\" ng-class=\"{'isOpenForm': vm.settings.isOpenForm}\" ng-repeat=\"shopper in vm.data.Items\">\n                        <div class=\"td\">\n                            <div class=\"inner\">\n                                <div class=\"styleRadioCheckboxWrap checkbox c-checkbox c-checkbox-rounded\">\n                                    <label>\n                                        <input type=\"checkbox\" ng-disabled=\"vm.waiting || vm.settings.isOpenForm\" ng-model=\"shopper.selected\" ng-click=\"vm.onShopperSelected()\">\n                                        <span class=\"fa fa-check\"></span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"td\">\n                            <div class=\"inner\">\n                                <span class=\"editable\" ng-bind=\"shopper.FullName\"></span>\n                            </div>\n                        </div>\n                        <div class=\"td\">\n                            <div class=\"inner\">\n                                <span class=\"editable\" ng-bind=\"shopper.ReferralCode\"></span>\n                            </div>\n                        </div>\n                        <div class=\"td\">\n                            <div class=\"inner placeSelect\">\n                                <span editable-ui-select=\"shopper.Store\"\n                                      e-form=\"placeform\"\n                                      e-name=\"place\"\n                                      name=\"place\"\n                                      theme=\"bootstrap\"\n                                      e-ng-model=\"shopper.Store\">\n                                    {{ shopper.Store.Name }}\n                                    <editable-ui-select-match  placeholder=\"Place\">\n                                        {{$select.selected.Name}}\n                                    </editable-ui-select-match>\n                                    <editable-ui-select-choices repeat=\"store in vm.stores | filter: $select.search track by $index\">\n                                        {{store.Name}}\n                                    </editable-ui-select-choices>\n                                </span>\n                            </div>\n                        </div>\n                        <div class=\"td posRel\">\n                            <form class=\"form-buttons form-inline clearfix formEditButtons\"\n                                  editable-form name=\"placeform\"\n                                  onaftersave=\"vm.save(shopper);\"\n                                  oncancel=\"vm.cancelEdit()\" ng-show=\"placeform.$visible\" novalidate>\n                                <button type=\"submit\" ng-disabled=\"placeform.$vm.waiting\" class=\"btn btn-success pull-left\">\n                                    <span class=\"fa fa-check\"></span>\n                                </button>\n                                <button type=\"button\" ng-disabled=\"placeform.$vm.waiting\" ng-click=\"placeform.$cancel()\" class=\"btn btn-danger pull-left\">\n                                    <span class=\"fa fa-close\"></span>\n                                </button>\n                            </form>\n                            <div class=\"inner width450\">\n                                <div class=\"prodDescrEll\" ng-if=\"!vm.editing && !vm.waiting\">\n                                    <div class=\"controlRowTags\">\n                                        <span ng-click=\"vm.edit(placeform)\"\n                                              tooltip-popup-delay=\"200\"\n                                              tooltip-placement=\"top\"\n                                              uib-tooltip-html=\"'Edit'\"\n                                              translate translate-attr-uib-tooltip-html=\"tooltip_edit\"\n                                              class=\"fa fa-pencil\"></span>\n                                        <span ng-click=\"vm.remove(shopper)\"\n                                              tooltip-popup-delay=\"200\"\n                                              tooltip-placement=\"top\"\n                                              uib-tooltip-html=\"'Delete'\"\n                                              translate translate-attr-uib-tooltip-html=\"tooltip_delete\"\n                                              class=\"fa fa-close\"></span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.data.Total > vm.settings.filter.pageSize\" style=\"width:900px\" class=\"tableTagsFooter\">\n                    <ul uib-pagination boundary-links=\"true\"\n                        total-items=\"vm.data.Total\"\n                        items-per-page=\"vm.settings.filter.pageSize\"\n                        first-text=\"first\" last-text=\"last\"\n                        ng-model=\"vm.settings.filter.page\"\n                        previous-text=\"&laquo;\"\n                        next-text=\"&raquo;\"\n                        max-size=\"10\">\n                    </ul>\n                </div>\n            </div>\n        </div>\n        <empty-list-state class=\"absolute-center-flex\"\n                          title-message=\"'no_referal_accounts' | translate\"\n                          ng-if=\"!vm.waiting && !vm.data.Total\">\n        </empty-list-state>\n    </div>\n</div>\n";

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb10 flexVerticalAlignParent\">\n    <span class=\"activefilter mr0 fs-20 fw-500\" ui-sref=\"app.activeServices\">\n        <span translate=\"services_tab\" class=\"\"></span>\n    </span>\n    <span class=\"icon-chevron-right icon24 opacity38 mr0\"></span>\n    <span class=\"fs-20 fw-500\" ng-show=\"ctrl.isNew\" translate=\"new\"></span>\n    <span class=\"fs-20 fw-500\" ng-show=\"!ctrl.isNew\" translate=\"edit\"></span>\n</div>\n<p class=\"service-fields-mandatory\" translate=\"fields_mandatory\"></p>\n<form name=\"ctrl.serviceForm\">\n    <div class=\"panel panel-edit panel\">\n        <div class=\"panel-heading flex-align-start panel-heading--bordered color-black pl16\">\n            <b class=\"fs-18 fw-500\" translate=\"service\"></b>\n        </div>\n        <div class=\"panel-body overflowVisible pt24 pr24 pb24 pl16\">\n            <div class=\"d-flex align-items-start\">\n                <div class=\"d-flex flex-column mr40\">\n                    <label class=\"common-label color-black6 fs-14 fw-500 mb14\" translate=\"extra_editor_image\"></label>\n                    <div ng-if=\"!ctrl.imageSrc\" class=\"service-no-image \" ng-click=\"ctrl.uploadLogo()\"></div>\n                    <div ng-if=\"ctrl.imageSrc\" class=\"service-image-container d-flex align-items-center justify-content-center mb8 clickable\">\n                        <img src=\"{{ctrl.imageSrc}}\" ng-click=\"ctrl.uploadLogo()\" alt=\"\"/>\n                    </div>\n                    <div ng-if=\"ctrl.imageSrc\" class=\"d-flex align-items-center clickable\" ng-click=\"ctrl.removeImage()\">\n                        <div class=\"service-delete-icon-blue mr4\"></div>\n                        <div class=\"service-remove-image\" translate=\"remove_image\"></div>\n                    </div>\n                </div>\n                <div>\n                    <div class=\"pt6 mb16 text-danger\" ng-show=\"ctrl.showErrors\"\n                         translate=\"form_has_error\"></div>\n                    <div class=\"form-group mb15\">\n                        <label class=\"common-label color-black6 fs-14 fw-500\" translate=\"field_title\"></label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static\">\n                                <input type=\"text\" name=\"title\" ng-model=\"ctrl.item.Title\"\n                                       ng-model-options=\"{ allowInvalid: true }\" class=\"form-control\" ng-readonly=\"ctrl.waiting\"\n                                       required ng-maxlength=\"64\">\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.title.$error.maxlength\"\n                                 translate=\"title_too_long\"></div>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group m0\">\n                        <label class=\"common-label color-black6 fs-14 fw-500\" translate=\"services_description\">\n                        </label>\n                        <div class=\"posRel\">\n                            <div class=\"form-control-static textEditor200 text-editor p0\">\n                                <text-angular ng-model=\"ctrl.item.Description\" class=\"btn-group-small\"\n                                              ng-disabled=\"ctrl.waiting\" ng-model-options=\"{ allowInvalid: true }\" ta-max-text=\"30000\"\n                                              ta-toolbar=\"{{ctrl.toolbar}}\"></text-angular>\n                            </div>\n                            <div class=\"text-danger mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.item.Description.length > 30000\"\n                                 translate=\"description_too_long_30000\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"panel panel-edit panel\">\n        <div class=\"panel-heading flex-align-start panel-heading--bordered color-black pl16\">\n            <b class=\"fs-18 fw-500\" translate=\"extra_editor_price\"></b>\n        </div>\n        <div class=\"panel-body overflowVisible pt32 pb32 pl24\">\n            <div class=\"d-flex mb35 product-discount__row\">\n                <!--Fixed price-->\n                <label class=\"radio align-items-baseline mr24\">\n                    <input type=\"radio\" ng-model=\"ctrl.item.PriceType\" ng-readonly=\"ctrl.waiting\"\n                           ng-checked=\"ctrl.item.PriceType === 0\"\n                           ng-value=\"0\" class=\"radio__input\"/>\n                    <span class=\"radio__check\"></span>\n                    <span class=\"radio__label\" translate=\"fixed_price\"></span>\n                </label>\n                <!--Editable price-->\n                <label class=\"radio align-items-baseline mr15\">\n                    <input type=\"radio\" ng-model=\"ctrl.item.PriceType\" ng-readonly=\"ctrl.waiting\"\n                           ng-checked=\"ctrl.item.PriceType === 1\"\n                           ng-value=\"1\" class=\"radio__input\"/>\n                    <span class=\"radio__check\"></span>\n                    <span class=\"radio__label\" translate=\"editable_price\"></span>\n                </label>\n                <span ng-click=\"ctrl.showEditablePriceInfo()\"\n                      class=\"question-icon--black6 question-button icon24 mt-3 clickable\">\n            </span>\n            </div>\n\n            <div class=\"d-flex mb35\" ng-if=\"ctrl.item.PriceType === 0\">\n                <div class=\"width150 mr24\">\n                    <div class=\"option\">\n                        <div class=\"flex-column\">\n                            <label class=\"w-auto common-label color-black6 fs-14 fw-500\" translate=\"service_price_required\"></label>\n                            <div class=\"{{::ctrl.currencyCssClass}} t10 mb10\">\n                                <input type=\"text\"\n                                       name=\"price\"\n                                       only-decimal\n                                       is-number=\"true\"\n                                       maxchar=\"7\"\n                                       ng-model-options=\"{ allowInvalid: true }\"\n                                       ng-model=\"ctrl.item.Price\"\n                                       ng-readonly=\"ctrl.waiting\"\n                                       class=\"form-control width148 height40\"\n                                       ng-class=\"{'input-validation__field--invalid': ctrl.showErrors && ctrl.serviceForm.price.$error.fixedPrice }\"\n                                       required/>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.price.$error.fixedPrice\"\n                                 translate=\"must_be_greater_than_0\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"d-flex mb35\" ng-if=\"ctrl.item.PriceType === 1\">\n                <div class=\"width150 mr24\">\n                    <div class=\"option\">\n                        <div class=\"flex-column\">\n                            <label class=\"w-auto common-label color-black6 fs-14 fw-500\" translate=\"services_min_price\"></label>\n                            <div class=\"{{::ctrl.currencyCssClass}} t10 mb10\">\n                                <input type=\"text\"\n                                       name=\"minPrice\"\n                                       only-decimal\n                                       is-number=\"true\"\n                                       maxchar=\"7\"\n                                       ng-model-options=\"{ allowInvalid: true }\"\n                                       ng-model=\"ctrl.item.MinPrice\"\n                                       ng-readonly=\"ctrl.waiting\"\n                                       class=\"form-control width148 height40\"\n                                       ng-class=\"{'input-validation__field--invalid': ctrl.showErrors && (ctrl.serviceForm.minPrice.$error.minPrice || ctrl.serviceForm.minPrice.$error.minPriceLower) }\"/>\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.minPrice.$error.minPrice\"\n                                 translate=\"must_be_greater_than_0\"></div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.minPrice.$error.minPriceLower\"\n                                 translate=\"service_less_or_equal_error\"></div>\n                            </div>\n                        </div>\n                    </div>\n                \n                <div class=\"width150 mr24\">\n                    <div class=\"option\">\n                        <div class=\"flex-column\">\n                            <label class=\"w-auto common-label color-black6 fs-14 fw-500\" translate=\"service_default_price_required\"></label>\n                            <div class=\"{{::ctrl.currencyCssClass}} t10 mb10\">\n                                <input type=\"text\"\n                                       name=\"defaultPrice\"\n                                       only-decimal\n                                       is-number=\"true\"\n                                       ng-model=\"ctrl.item.Price\"\n                                       maxchar=\"7\"\n                                       ng-model-options=\"{ allowInvalid: true }\"\n                                       ng-readonly=\"ctrl.waiting\"\n                                       class=\"form-control width148 height40\"\n                                       ng-class=\"{'input-validation__field--invalid': ctrl.showErrors && ctrl.serviceForm.defaultPrice.$error.minPrice }\"\n                                       required\n                                />\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.defaultPrice.$error.minPrice\"\n                                 translate=\"must_be_greater_than_0\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"width150\">\n                    <div class=\"option\">\n                        <div class=\"flex-column\">\n                            <label class=\"w-auto common-label color-black6 fs-14 fw-500\" translate=\"services_max_price\"></label>\n                            <div class=\"{{::ctrl.currencyCssClass}} t10 mb10\">\n                                <input type=\"text\"\n                                       name=\"maxPrice\"\n                                       only-decimal\n                                       is-number=\"true\"\n                                       maxchar=\"7\"\n                                       ng-model-options=\"{ allowInvalid: true }\"\n                                       ng-model=\"ctrl.item.MaxPrice\"\n                                       ng-readonly=\"ctrl.waiting\"\n                                       class=\"form-control width148 height40\"\n                                       ng-class=\"{'input-validation__field--invalid': ctrl.showErrors && ( ctrl.serviceForm.maxPrice.$error.minPrice || ctrl.serviceForm.maxPrice.$error.maxPriceLower )  }\"\n                                />\n                                <!-- ng-class=\"{'input-validation__field--invalid': ctrl.item.DefaultPrice < ctrl.item.MinPrice}\" -->\n                            </div>\n                            <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.maxPrice.$error.minPrice\"\n                                 translate=\"must_be_greater_than_0\"></div>\n                                \n                                 <div class=\"text-danger mt-9 mb4\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.maxPrice.$error.maxPriceLower\"\n                                 translate=\"service_greater_or_equal_error\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"mb35 d-flex flex-column\">\n                <div class=\"d-flex\" ng-if=\"ctrl.giftAidVisible\">\n                    <div class=\"checkbox c-checkbox days-checkbox mt0 mb26\">\n                        <label>\n                            <input type=\"checkbox\" ng-model=\"ctrl.item.GiftAid\" ng-disabled=\"ctrl.waiting\"/>\n                            <span class=\"fa fa-check\"></span>\n                            <ng-content class=\"mr10\" translate=\"enable_gift_aid_option\"></ng-content>\n                        </label>\n\n                    </div>\n                    <span ng-click=\"ctrl.showGiftAidInfo()\"\n                          class=\"question-icon--black6 question-button icon24 mt-3 clickable\">\n                </span>\n                </div>\n\n                <!--Add for all Vendors by default is POSTPONED feature -->\n                <!-- <div class=\"checkbox c-checkbox days-checkbox mt0 mb16\">\n                    <label>\n                        <input type=\"checkbox\"   />\n                        <span class=\"fa fa-check\"></span>\n                        <ng-content translate=\"assign_to_all_vendors_by_default\"></ng-content>\n                    </label>\n                </div> -->\n\n                <div class=\"checkbox c-checkbox days-checkbox mt0 mb16\">\n                    <label>\n                        <input type=\"checkbox\" ng-model=\"ctrl.item.DisplayedInReceipt\" ng-disabled=\"ctrl.waiting\"/>\n                        <span class=\"fa fa-check\"></span>\n                        <ng-content translate=\"show_service_link_in_the_receipt\"></ng-content>\n                    </label>\n                </div>\n\n                <div class=\"width150 ml30\" ng-if=\"ctrl.item.DisplayedInReceipt\">\n                    <div class=\"option\">\n                        <div class=\"flex-column\">\n                            <label class=\"w-auto common-label color-black6 fs-14 fw-500\" translate=\"link_title\"></label>\n                            <span class=\"mb10 t9 width150\">\n                            <input type=\"text\"\n                                   name=\"linkTitle\"\n                                   ng-model=\"ctrl.item.LinkTitle\"\n                                   ng-readonly=\"ctrl.waiting\"\n                                   class=\"form-control width456 height40\"\n                                   ng-model-options=\"{ allowInvalid: true }\"\n                                   required\n                                   ng-maxlength=\"40\"\n                            />\n                        </span>\n                            <div class=\"text-danger mt-9 mb4 text-nowrap\"\n                                 ng-show=\"ctrl.showErrors && ctrl.serviceForm.linkTitle.$error.maxlength\"\n                                 translate=\"link_title_too_long_40\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Fee recepient is POSTPONED feature. Now Retailer selected by default -->\n            <!-- <div class=\"mb35 d-flex flex-column\" ng-if=\"ctrl.item.PriceType === 0\">\n\n                <label translate=\"fee_recepient\" class=\"mb16\"></label>\n\n                <div class=\"d-flex mb8 product-discount__row\">\n                    <label class=\"radio align-items-baseline mr24\">\n                        <input type=\"radio\"  ng-model=\"ctrl.item.FeeRecipient\" ng-checked=\"ctrl.item.FeeRecipient === 0\"\n                        ng-value=\"0\" class=\"radio__input\" />\n                        <span class=\"radio__check\"></span>\n                        <span class=\"radio__label\" translate=\"retailer\"></span>\n                    </label>\n\n                    <label class=\"radio align-items-baseline mr24\">\n                        <input type=\"radio\"  ng-model=\"ctrl.item.FeeRecipient\" ng-checked=\"ctrl.item.FeeRecipient === 1\"\n                        ng-value=\"1\" class=\"radio__input\" />\n                        <span class=\"radio__check\"></span>\n                        <span class=\"radio__label\" translate=\"vendor\"></span>\n                    </label>\n                </div>\n\n            </div> -->\n\n\n        </div>\n    </div>\n\n\n    <div class=\"d-flex justify-content-end mt24 pb10\">\n        <button ng-if=\"ctrl.idParam\" ng-disabled=\"ctrl.saveButtonDisabled() || ctrl.waiting\"\n                ng-click=\"ctrl.createService()\"\n                class=\"btn btn-success btn-with-icon flexVerticalAlignParent mr8\">\n            <span class=\"plus-icon--tiny icon24 mr8\"></span>\n            <span translate=\"save\"></span>\n        </button>\n        <button ng-if=\"!ctrl.idParam\" ng-disabled=\"ctrl.saveButtonDisabled() || ctrl.waiting\"\n                ng-click=\"ctrl.createService()\"\n                class=\"btn btn-success btn-with-icon flexVerticalAlignParent mr8\">\n            <span class=\"plus-icon--tiny icon24 mr8\"></span>\n            <span translate=\"create\"></span>\n        </button>\n        <button class=\"btn btn-danger btn-with-icon flexVerticalAlignParent\" ng-click=\"ctrl.discard()\">\n            <span class=\"close-icon-white--tiny icon24 mr8\"></span>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n</form>\n";

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex\">\n    <div class=\"app-view-header tab-campaings mt0 mb16 header-tablist\">\n        <span ng-class=\"{'header-tablist__item--active': ctrl.isActive}\" ng-click=\"ctrl.setTab(true)\"\n              class=\"header-tablist__item clickable mr0\">\n            <span class=\"mr25 fs-20 fw-500\" translate=\"services_tab\"></span>\n        </span>\n        <span ng-class=\"{'header-tablist__item--active': !ctrl.isActive}\" ng-click=\"ctrl.setTab(false)\"\n              class=\"header-tablist__item clickable\">\n            <span class=\"fs-20 fw-500\" translate=\"archived_services_tab\"></span>\n        </span>\n    </div>\n    <button ui-sref=\"app.serviceCreate\" type=\"button\" class=\"btn btn-success ml-auto add-btn ml-auto height40\"\n            ng-if=\"ctrl.isActive\">\n        <span class=\"plus-icon icon24\"></span>\n        <span class=\"ml8 fs-14 ng-scope\" translate=\"add_service\"></span>\n    </button>\n</div>\n\n<!--Search-->\n\n<search placeholder-text=\"'search_services' | translate\"\n        text=\"ctrl.search.text\"\n        on-search-click=\"ctrl.applySearch(searchText)\"\n        on-clear-click=\"ctrl.resetSearch()\">\n</search>\n\n\n<!--ng-infinite-scroll load-more=\"ctrl.loadData(true)\"-->\n<div class=\"services d-flex flex-column\" ng-infinite-scroll=\"\" load-more=\"ctrl.loadData()\">\n    <div class=\"service d-flex flex-column\" ng-repeat=\"service in ctrl.services\">\n        <div class=\"d-flex align-items-center justify-content-between mb8\">\n            <div class=\"service-title\" ng-bind=\"service.Title\"></div>\n            <div class=\"d-flex align-items-center\">\n                <div ng-if=\"ctrl.isActive\" class=\"edit-icon\" ng-click=\"ctrl.onEdit(service)\"></div>\n                <div ng-if=\"ctrl.isActive\" class=\"archive-icon\" ng-click=\"ctrl.deleteService(service)\"></div>\n                <div ng-if=\"!ctrl.isActive\" class=\"restore-icon\" ng-click=\"ctrl.restoreService(service)\"></div>\n            </div>\n        </div>\n        <div class=\"d-flex align-items-start\">\n            <div ng-if=\"service.ImageID\" class=\"image-container mr32\">\n                <img src=\"{{ctrl.getImageUrl(service)}}\">\n            </div>\n            <div class=\"d-flex flex-column pt4\">\n                <div class=\"d-flex align-items-start\" ng-class=\"{'mb24': service.LinkTitle || service.ShowMore, 'mb20': !service.LinkTitle && !service.ShowMore}\">\n                    <div class=\"d-flex mr32\">\n                        <div class=\"d-flex flex-column\">\n                            <div class=\"field-title mb8\" translate=\"services_price_type\"></div>\n                            <div class=\"field-value\" ng-bind=\"ctrl.getPriceTypeText(service.PriceType)\"></div>\n                        </div>\n                    </div>\n                    <div ng-if=\"service.PriceType === 0\" class=\"d-flex flex-column mr32\">\n                        <div class=\"field-title mb8\" translate=\"special_offer_price\"></div>\n                        <div class=\"field-value\" ng-bind=\"service.Price.FixedPrice | formatCurrency: ctrl.countryID\"></div>\n                    </div>\n                    <div ng-if=\"service.PriceType === 1\" class=\"d-flex flex-column mr32\">\n                        <div class=\"field-title mb8\" translate=\"services_default_price\"></div>\n                        <div class=\"field-value\"\n                             ng-bind=\"service.Price.EditablePrice.DefaultPrice | formatCurrency: ctrl.countryID\"></div>\n                    </div>\n                    <div ng-if=\"service.PriceType === 1\" class=\"d-flex flex-column mr32\">\n                        <div class=\"field-title mb8\" translate=\"services_min_price\"></div>\n                        <div ng-if=\"service.Price.EditablePrice.MinPrice\" class=\"field-value\"\n                             ng-bind=\"service.Price.EditablePrice.MinPrice | formatCurrency: ctrl.countryID\"></div>\n                        <div ng-if=\"!service.Price.EditablePrice.MinPrice\" class=\"field-value\">–</div>\n                    </div>\n                    <div ng-if=\"service.PriceType === 1\" class=\"d-flex flex-column mr32\">\n                        <div class=\"field-title mb8\" translate=\"services_max_price\"></div>\n                        <div ng-if=\"service.Price.EditablePrice.MaxPrice\" class=\"field-value\"\n                             ng-bind=\"service.Price.EditablePrice.MaxPrice | formatCurrency: ctrl.countryID\"></div>\n                        <div ng-if=\"!service.Price.EditablePrice.MaxPrice\" class=\"field-value\">–</div>\n                    </div>\n                    <div ng-if=\"service.GiftAid\" class=\"gift-aid-badge\"></div>\n                </div>\n                <div ng-if=\"service.LinkTitle\" class=\"d-flex flex-column\" ng-class=\"{'mb20': !service.ShowMore, 'mb24': service.ShowMore}\">\n                    <div class=\"field-title mb8\" translate=\"service_link_title\"></div>\n                    <div class=\"field-value\" ng-bind=\"service.LinkTitle\"></div>\n                </div>\n                <div ng-if=\"service.ShowMore\" class=\"d-flex flex-column mb16\">\n                    <div class=\"field-title mb8\" translate=\"Description\"></div>\n                    <div class=\"field-value\" ng-bind-html=\"service.Description\"></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"d-flex align-items-center clickable\" ng-click=\"service.ShowMore = !service.ShowMore\">\n            <div ng-if=\"!service.ShowMore\" class=\"show-more\" translate=\"show_more\"></div>\n            <div ng-if=\"service.ShowMore\" class=\"show-more\" translate=\"show_less\"></div>\n            <div class=\"show-more-arrow\" ng-class=\"{'show-more-arrow-rotate': service.ShowMore}\"></div>\n        </div>\n    </div>\n</div>\n\n<div class=\"absolute-center-flex\">\n    <empty-list-state style=\"word-break: break-word; height: calc(100vh - 206px) !important;\"\n                      ng-show=\"ctrl.total === 0 && !ctrl.waiting\"\n                      ng-if=\"!ctrl.forSearch && ctrl.isActive\"\n                      title-message=\"'services_list_empty_screen_title' | translate\"\n                      message=\"'services_list_empty_screen_content' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\">\n    </empty-list-state>\n    <empty-list-state style=\"word-break: break-word; height: calc(100vh - 206px) !important;\"\n                      ng-show=\"ctrl.total === 0 && !ctrl.waiting\"\n                      ng-if=\"!ctrl.forSearch && !ctrl.isActive\"\n                      title-message=\"'services_message_empty_archived_title' | translate\"\n                      class=\"absolute-center-flex empty-reading-location\">\n    </empty-list-state>\n</div>\n<div class=\"absolute-center-flex\"\n     ng-if=\"ctrl.total === 0 && ctrl.forSearch && !ctrl.waiting\">\n    <empty-list-state\n            image-class=\"'icon-empty-list-search'\"\n            title-message=\"'services_list_not_found_screen_title' | translate\"\n            message=\"ctrl.searchMessageContent\"\n            class=\"services-not-found empty-reading-location\">\n    </empty-list-state>\n</div>\n\n\n";

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<!-- header -->\n<div class=\"modal-header black-header\">\n    <div class=\"flexVerticalAlignParent justify-content-between\">\n        <div class=\"modal-title fs-20 lh37 fw-500 color-black\" translate=\"add_single_store_title\"></div>\n        <div class=\"d-flex\">\n            <button type=\"button\"\n                    ng-click=\"ctrl.confirm()\"\n                    ng-disabled=\"!ctrl.total || !ctrl.model.location\"\n                    class=\"btn btn-success h40 w102 mr8 flexVerticalAlignParent justify-content-center text-white\">\n                <span translate=\"select_single_location_button\" class=\"fw-500 fs-14 lh16 ls-031\"></span>\n            </button>\n            <button type=\"button\" ng-click=\"ctrl.dismiss()\"\n                    class=\"btn btn-danger btn-with-icon h40 w102 text-white flexVerticalAlignParent justify-content-center\">\n                <em class=\"fa fa-close\"></em>\n                <span translate=\"button_cancel\" class=\"fw-500 fs-14 ls-031\"></span>\n            </button>\n        </div>\n    </div>\n</div>\n\n<!-- body -->\n<div class=\"modal-body panel-campaign-choice store-search pl16 pr0 wizard__selected-modal\">\n    <!-- search -->\n    <div  class=\"mb24 mt16 pr16\">\n        <search placeholder-text=\"ctrl.$translate.instant('search_location_by_name')\"\n                text=\"ctrl.model.searchTerm\"\n                classes=\"'white-theme color-black87 fs-14 lh16 ls-0146'\"\n                disabled=\"ctrl.model.waiting\"\n                on-search-click=\"ctrl.search(searchText)\"\n                on-clear-click=\"ctrl.resetSearch()\">\n        </search>\n    </div>\n\n    <div when-scrolled=\"ctrl.loadLocations()\" class=\"custom-scrollbar h470\">\n        <table class=\"fw store-search__table\">\n            <tbody>\n            <tr ng-repeat=\"location in ctrl.locations\"\n                class=\"clickable bordered--bottom\"\n                ng-class=\"{ 'active': location.IsSelected }\">\n                <td class=\"pb16 pt8 pr16\">\n                    <div class=\"styleRadioCheckboxWrap ml10\">\n                        <label for=\"checkbox_{{::location.ID}}\" class=\"radio pl0\">\n                            <input id=\"checkbox_{{::location.ID}}\"\n                                   type=\"radio\"\n                                   ng-value=\"location\"\n                                   ng-checked=\"location.IsSelected\"\n                                   name=\"locationItem\"\n                                   ng-disabled=\"ctrl.model.waiting\"\n                                   ng-model=\"ctrl.model.location\"\n                                   class=\"radio__input\" />\n                            <span class=\"radio__check mt14\"></span>\n                            <div class=\"mr16\">\n                                <img ng-if=\"location.LogoID\"\n                                     ng-src=\"{{ctrl.getLogoUrl(location.LogoID)}}\"\n                                     class=\"image-48 img-circle\"\n                                     alt=\"\" />\n                                <div ng-if=\"!location.LogoID\"\n                                     class=\"icon-store-placeholder\"></div>\n                            </div>\n                            <div class=\"radio__label d-flex flex-column pt8\">\n                                <div class=\"fs-14 lh16 ls-0146 color-black87 mb8\">{{location.Name}}</div>\n                                <div class=\"fs-14 lh16 ls-0146 color-black6\">\n                                    <span>{{location.Address}}</span><span ng-if=\"location.Town\">,&nbsp;{{location.Town}}</span>\n                                </div>\n                            </div>\n                        </label>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <empty-list-state class=\"empty-location empty-reading-location\"\n                          ng-if=\"ctrl.locations.length === 0 && !ctrl.model.waiting\"\n                          title-message=\"(ctrl.model.searchTerm ? 'location_not_found_title' : 'no_locations_yet') | translate\"\n                          message=\"(ctrl.model.searchTerm ? 'nothing_found_for_parameters' : 'created_locations_will_appear_here') | translate\"\n                          image-class=\"(ctrl.model.searchTerm ? 'icon-empty-list-search' : 'icon-empty-list') | translate\">\n        </empty-list-state>\n    </div>\n</div>\n";

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span class=\"activefilter mr0 fs-20 fs-500\" ui-sref=\"app.analytics\" translate=\"homescreen_analytics\"></span>\n    <span class=\"icon24 icon-chevron-right opacity38 mr8 mb-2\"></span>\n    <span class=\"activefilter mr0 fs-20 fs-500\" ui-sref=\"app.staff-ratings\" translate=\"staff_rating\"></span>\n    <span class=\"icon24 icon-chevron-right opacity38 mr8 mb-2\"></span>\n    <span class=\"fs-20 fw-500\">{{vm.dataSummary.FirstName}} {{vm.dataSummary.LastName}}</span>\n</div>\n\n<!-- START rating person -->\n<div class=\"analytics__person-rating\">\n    <div class=\"person-rating__top panel pt14 pl20 pb18 mt24\">\n        <div class=\"flexVerticalAlignParent \">\n            <div class=\"person-rating__pic mr24\">\n                <span class=\"user-icon--big inline-block\" ng-show=\"!vm.dataSummary.AvatarUrl\" ng-class=\"{'half-opacity' : vm.dataSummary.IsArchive}\"></span>\n                <img ng-src=\"{{::vm.dataSummary.AvatarUrl}}\" class=\"circle half-opacity\"  ng-show=\"vm.dataSummary.AvatarUrl && vm.dataSummary.IsArchive\"/>\n                <img ng-src=\"{{::vm.dataSummary.AvatarUrl}}\" class=\"circle\"  ng-show=\"vm.dataSummary.AvatarUrl && !vm.dataSummary.IsArchive\"/>\n            </div>\n            <div class=\"flex-column\">\n                <div class=\"flex-column person-rating__info\">\n                    <span class=\"person-rating__position fs-14\" translate=\"manager\"></span>\n                    <span class=\"person-rating__name fw-500\">{{vm.dataSummary.FirstName}}\n                        {{vm.dataSummary.LastName}}</span>\n                </div>\n                <div class=\"rating person-rating__rating\">\n                    <span class=\"rating__caption mb3 fs-14\" translate=\"average_staff_rating\"></span>\n                    <rating-stars rating=\"vm.dataSummary.FeedbackStats.AverageRating\" stars-count=\"vm.dataSummary.FeedbackStats.StarsCount\" show-label=\"true\"></rating-stars>\n                </div>\n            </div>\n            <div class=\"feedback flex-column mt-auto\">\n                <span class=\"feedback__caption mb10 fs-14\" translate=\"feedback\"></span>\n                <span class=\"feedback__number fs-14 fw-500\">{{vm.dataSummary.FeedbackStats.FeedbackCount || 0}}</span>\n            </div>\n            <div class=\"ml-auto mb-auto\">\n                <span class=\"feedback__caption mb10 fs-14 colorRed label fw-500 pr23\" translate=\"archived_staff_label\" ng-show=\"vm.dataSummary.IsArchive\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"person-rating__bottom buyers-feedback panel\">\n        <div class=\"panel-head pl24\">\n            <div class=\"panel-title\" translate=\"buyers_feedback\"></div>\n        </div>\n        <div class=\"buyers-feedback__actions flexVerticalAlignParent pl24 pr24\">\n            <span class=\"buyers-feedback__comments fs-14\">{{vm.total}} <span class=\"fs-14\"\n                    translate=\"comments\"></span></span>\n            <span class=\"mr6 fs-14\" translate=\"date_range\"></span>\n            <div class=\"posRel\">\n                <div class=\"input-group wrapRelative datepicker--transparent width150\">\n                    <input type=\"text\" name=\"dateFrom\" uib-datepicker-popup=\"dd MMM yyyy\"\n                        ng-model=\"vm.settings.dateFrom\" datepicker-options=\"vm.dateOptions\"\n                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                        close-text=\"Close\" clear-text=\"Clear\" current-text=\"Today\" is-open=\"dateFromOpened\"\n                        ng-change=\"vm.onDateChange()\"\n                        class=\"form-control pl12 fs-14 pr0 ng-pristine ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-valid-date\">\n                    <div uib-datepicker-popup-wrap=\"\" ng-model=\"date\"\n                        template-url=\"uib/template/datepickerPopup/popup.html\"\n                        class=\"ng-pristine ng-untouched ng-valid ng-scope ng-not-empty\">\n                    </div>\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); dateFromOpened = true; dateToOpened = false;\"\n                            class=\"btn btn-default p0 pt7 fs-14\">\n                            <span class=\"icon-date icon24 inline-block opacity38\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n            <div class=\"dash\"></div>\n            <div class=\"posRel mr30\">\n                <div class=\"input-group wrapRelative datepicker--transparent width150\">\n                    <input type=\"text\" name=\"dateTo\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"vm.settings.dateTo\"\n                        datepicker-options=\"vm.dateOptionsMax\"\n                        ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\"\n                        close-text=\"Close\" clear-text=\"Clear\" current-text=\"Today\" is-open=\"dateToOpened\"\n                        ng-change=\"vm.onDateChange()\"\n                        class=\"form-control fs-14 ng-pristine ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-valid-date\">\n                    <div uib-datepicker-popup-wrap=\"\" ng-model=\"date\"\n                        template-url=\"uib/template/datepickerPopup/popup.html\"\n                        class=\"ng-pristine ng-untouched ng-valid ng-scope ng-not-empty\">\n                    </div>\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\"\n                            ng-click=\"$event.preventDefault(); $event.stopPropagation(); dateToOpened = true; dateFromOpened = false;\"\n                            class=\"btn btn-default p0 pt7\">\n                            <span class=\"icon-date icon24 inline-block opacity38 fs-14\"></span>\n                        </button>\n                    </span>\n                </div>\n            </div>\n            <span class=\"mr6 fs-14\" translate=\"sort_by\"></span>\n            <div class=\"form-control-static width140 mr30 buyers-feedback__sort\">\n                <div uib-dropdown class=\"input-group-btn width140\">\n                    <button type=\"button\" uib-dropdown-toggle\n                        class=\"btn btn-default dropdown-toggle rounded text-left pl12 fs-14\" aria-haspopup=\"true\"\n                        aria-expanded=\"false\">\n                        <span>{{vm.sort.title}}\n                            <span class=\"fa fa-sort-{{vm.sort.class}}\"></span>\n                        </span>\n                        <span class=\"caret\"></span>\n                    </button>\n                    <ul class=\"dropdown-menu\">\n                        <li ng-repeat=\"sort in vm.sortItems\" ng-click=\"vm.setSortOrder(sort)\">\n                            <a href=\"#\">{{sort.title}}\n                                <span class=\"fa fa-sort-{{sort.class}}\"></span>\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <button class=\"btn btn-primary fs-14\" ng-click=\"vm.showComments()\" translate=\"button_show\"></button>\n        </div>\n        <div class=\"buyers-feedback__inner\" ng-repeat=\"item in vm.data\" ng-infinite-scroll load-more=\"vm.loadMore()\"\n            threshold=\"150\">\n            <div class=\"flexVerticalAlignParent pl24 pr24\">\n                <span class=\"user-icon mr6\" ng-show=\"!item.AvatarUrl\"></span>\n                <img ng-src=\"{{::item.AvatarUrl}}\" class=\"buyers-feedback__shopper-avatar circle mr6\"\n                    ng-show=\"item.AvatarUrl\" />\n                <div class=\"flex-column mt20\">\n                    <span class=\"buyers-feedback__shopper-name fs-14 fw-500 mb5 mr16\">{{item.ShopperFirstName}}\n                        {{item.ShopperLastName}}</span>\n                    <div class=\"rating mb10\">\n                        <rating-stars rating=\"item.Rating\" stars-count=\"item.Rating\" show-label=\"false\"></rating-stars>\n                    </div>\n                </div>\n                <div class=\"flex-column ml-auto color-black54\">\n                    <span\n                        class=\"buyers-feedack__shopper-date text-right\">{{item.FeedbackLeftDateUTC | date:'dd.MM.yyyy'}}</span>\n                    <b class=\"buyers-feedback__shopper-order text-right\"><span\n                            translate=\"order_number\"></span>{{item.OrderID}}</b>\n                </div>\n            </div>\n            <div class=\"word-break-word pr24 pl0 buyers-feedback__message fs-14\">\n                {{item.Comment}}\n            </div>\n        </div>\n    </div>\n</div>\n\n<!-- END rating person -->\n";

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "\n<div class=\"app-view-header tab-campaings mt-9 mb-3 productHeader flexVerticalAlignParent\">\n    <span ng-class=\"{'activefilter': !vm.settings.filter.isActive}\" ng-click=\"vm.settings.filter.isActive = true\" translate=\"staff_rating\" class=\"fw-500 fs-20\">\n    </span>\n    <span ng-hide=\"!vm.settings.isStaffAny.archived\"\n        ng-class=\"{'activefilter': vm.settings.filter.isActive}\"\n        ng-click=\"vm.settings.filter.isActive = false\"\n        translate=\"archived_staff_label\"\n        class=\"fw-500 fs-20\">\n    </span>\n</div>\n\n<!-- START rating panel all -->\n<div class=\"analytics__staff-rating\">\n    <div class=\"staff-rating__top panel mb8 mt24\">\n        <table class=\"fw\">\n            <tr>\n                <td class=\"pl24 pt20 pb20\" width=\"45%\">\n                    <div class=\"rating\" ng-show=\" vm.settings.filter.isActive\">\n                        <span class=\"rating__caption mb3 fs-14\" translate=\"average_staff_rating\"></span>\n                        <rating-stars rating=\"vm.dataSummary.AverageRating\" stars-count=\"vm.dataSummary.StarsCount\" show-label=\"true\"></rating-stars>\n                    </div>\n                    <div class=\"flex-column\" ng-show=\"!vm.settings.filter.isActive\">\n                        <span class=\"rating__caption mb3 fs-14\" translate=\"archive_staff_count\"></span>\n                        <span class=\"fw-500 fs-14\">{{vm.total}}</span>\n                    </div>\n                </td>\n                <td width=\"20\">\n                    <div class=\"feedback flex-column\">\n                        <span class=\"feedback__caption mb10 fs-14\" translate=\"feedback\"></span>\n                        <span class=\"feedback__number fs-14 fw-500\">{{vm.dataSummary.FeedbackCount}}</span>\n                    </div>\n                </td>\n                <td width=\"20\">\n                    <div class=\"flex-column\">\n                        <span class=\"mb10 fs-14\" translate=\"display_for_buyers\"></span>\n                        <span class=\"fw-500 fs-14\" ng-show=\"vm.dataSummary.AllowViewRating\" translate=\"yes\">  </span>\n                        <span class=\"fw-500 fs-14\" ng-show=\"!vm.dataSummary.AllowViewRating\" translate=\"no\">  </span>\n                    </div>\n                </td>\n                <td class=\"pr20\" width=\"1\">\n                    <button class=\"btn btn-with-icon btn-success flexVerticalAlignParent pull-right\"  ng-click=\"vm.exportCsv()\">\n                        <span class=\"icon24 icon-export\"></span>\n                        <span translate=\"export\"></span>\n                    </button>\n                </td>\n            </tr>\n        </table>\n    </div>\n    <div class=\"tableTags\">\n        <div class=\"staff-rating__bottom panel tags-panel\" ng-infinite-scroll load-more=\"vm.loadMore()\" threshold=\"150\">\n            <table class=\"fw tableTags basic-table table-white m0\">\n                <tr class=\"tableTagsHeader\">\n                    <th class=\"pl72 pt16 pb16 rounded-top fs-12\" translate=\"name\"></th>\n                    <th><div class=\"fs-12\" ng-click=\"vm.settings.sort.set('AverageRating')\"  translate=\"average_rating\"></div></th>\n                    <th><div class=\"fs-12\" ng-click=\"vm.settings.sort.set('FeedbackCount')\" translate=\"number_of_reviews\"></div></th>\n                    <th><div class=\"fs-12\" ng-click=\"vm.settings.sort.set('LastUpdateUTC')\" translate=\"column_updated\"></div></th>\n                    <th ng-show=\"!vm.settings.filter.isActive\"><div class=\"fs-12\"  translate=\"column_archived_date\"></div></th>\n                </tr>\n                <tr ng-repeat=\"item in vm.data\" ui-sref=\"app.staff-rating.details({id:item.ID})\">\n                    <td class=\"pl24 pt8 pb8\" width=\"45%\">\n                        <div class=\"flexVerticalAlignParent\">\n                            <span class=\"user-icon inline-block mr16\" ng-show=\"!item.AvatarUrl\"></span>\n                            <img ng-src=\"{{::item.AvatarUrl}}\" class=\"circle mr16\" ng-show=\"item.AvatarUrl && vm.settings.filter.isActive\" />\n                            <img ng-src=\"{{::item.AvatarUrl}}\" class=\"circle mr16\" style=\"opacity: 0.5\" ng-show=\"item.AvatarUrl && !vm.settings.filter.isActive\" />\n                            <span class=\"fs-14\">{{item.FirstName}} {{item.LastName}}</span>\n                        </div>\n                    </td>\n                    <td width=\"20\" class=\"pl0 fs-14\">{{(item.FeedbackStats.AverageRating |number : 1) || 0}}</td>\n                    <td width=\"20\" class=\"fs-14 pl0\">{{item.FeedbackStats.FeedbackCount || 0}}</td>\n                    <td class=\"pr20 rounded-top fs-14\" width=\"1\">{{item.FeedbackStats.LastUpdateUTC | date:'dd.MM.yyyy'}}</td>\n                    <td ng-show=\"!vm.settings.filter.isActive\" class=\"pr20 rounded-top fs-14\" width=\"1\">{{item.ArchivedDateUTC | date:'dd.MM.yyyy'}}</td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</div>\n<!-- END rating panel all -->\n";

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"rating__group\">\n    <li class=\"rating__star\" ng-class=\"vm.starsCount >= 1 ? 'rating__star--full' : 'rating__star--empty'\"></li>\n    <li class=\"rating__star\" ng-class=\"vm.starsCount >= 2 ? 'rating__star--full' : 'rating__star--empty'\"></li>\n    <li class=\"rating__star\" ng-class=\"vm.starsCount >= 3 ? 'rating__star--full' : 'rating__star--empty'\"></li>\n    <li class=\"rating__star\" ng-class=\"vm.starsCount >= 4 ? 'rating__star--full' : 'rating__star--empty'\"></li>\n    <li class=\"rating__star\" ng-class=\"vm.starsCount == 5 ? 'rating__star--full' : 'rating__star--empty'\"></li>\n    <li class=\"rating__average pt1\" ng-show=\"vm.showLabel\">{{vm.rating ? (vm.rating|number : 1) : 0}}</li>\n</ul>\n";

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header bb0\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-disabled=\"$ctrl.waiting\" class=\"close full-opacity\" ng-click=\"$ctrl.close()\">\n    <span class=\"icon-close--small inline-block\"></span>\n    </button>\n    <!-- <h4 class=\"modal-title\" ng-bind=\"$ctrl.data.title\"></h4> -->\n</div>\n<!-- <div class=\"modal-body\"> -->\n<div class=\"add-account__modal\">\n    <div class=\"form-group m0 clearfix\">\n        <!--         <label class=\"control-label\" translate=\"name\" ></label> -->\n        <div class=\"posRel clearfix\">\n            <div class=\"fform-control-static width208 m0 p0 pull-left\">\n                <input type=\"text\" ng-model=\"$ctrl.data.model.FirstName\" ng-disabled=\"$ctrl.waiting\"\n                translate translate-attr-placeholder=\"first_name\"\n                class=\"form-control \">\n            </div>\n\n            <div class=\"form-control-static width208 m0 p0 pull-right\">\n                <input type=\"text\" ng-model=\"$ctrl.data.model.LastName\" ng-disabled=\"$ctrl.waiting\"\n                translate translate-attr-placeholder=\"last_name\"\n                class=\"form-control \">\n            </div>\n            <span class=\"text-danger\" ng-bind=\"$ctrl.data.error.firstName\"></span><br />\n            <span class=\"text-danger\" ng-bind=\"$ctrl.data.error.lastName\"></span>\n        </div>\n    </div>\n    <div class=\"form-group m0 clearfix\">\n        <!-- <label class=\"control-label\">Email</label> -->\n        <div class=\"posRel\">\n            <div class=\"form-control-static m0 p0\">\n                <input type=\"email\" ng-model=\"$ctrl.data.model.Email\" ng-disabled=\"$ctrl.waiting\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" placeholder=\"Email\" class=\"form-control \">\n            </div>\n            <span class=\"text-danger\" ng-bind=\"$ctrl.data.error.email\"></span>\n        </div>\n    </div>\n    <div class=\"form-group m0 clearfix\">\n        <!-- <label class=\"control-label\" translate=\"password\" ></label> -->\n        <div class=\"posRel\">\n            <div ng-hide=\"$ctrl.data.isPasswordExist\" class=\"form-control-static m0 p0 passwordField \" ng-class=\"{'showPassword': !$ctrl.data.showPassword}\">\n                <input type=\"password\" autocapitalize=\"off\" ng-model=\"$ctrl.data.model.Password\" ng-disabled=\"$ctrl.waiting\" placeholder=\"{{$ctrl.data.password}}\" class=\"form-control\">\n                <input type=\"text\" ng-model=\"$ctrl.data.model.Password\" ng-disabled=\"$ctrl.waiting\" placeholder=\"{{$ctrl.data.password}}\" class=\"form-control\">\n                <span ng-click=\"$ctrl.data.showPassword = !$ctrl.data.showPassword\" class=\"show-pass\">\n                    <span class=\"eye-icon--purple icon24 inline-block\"></span>\n                </span>\n            </div>\n            <div ng-show=\"$ctrl.data.isPasswordExist\" class=\"form-control-static m0 p0 editPass\">\n                <span ng-bind=\"$ctrl.data.password\"></span>\n                <button ng-click=\"$ctrl.data.isPasswordExist = false\" ng-disabled=\"$ctrl.waiting\" class=\"btnChange\" translate=\"button_change\" ></button>\n            </div>\n            <span class=\"text-danger\" ng-bind=\"$ctrl.data.error.password\"></span>\n        </div>\n    </div>\n    <div class=\"form-group m0 clearfix\">\n        <span translate=\"access_to_stores\" class=\"fs-14 access-stores\"></span>\n        <div class=\"posRel\">\n            <div class=\"form-control-static m0 p0\">\n                <div class=\"borderChoiceFieldInner manager-stores__wrap pl0\">\n                    <div class=\"fieldCheckSelect\" ng-repeat=\"place in $ctrl.data.places\">\n                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                            <label for=\"placeCheckbox{{$index}}\" class=\"m0\">\n                                <input type=\"checkbox\" ng-model=\"place.selected\" ng-change=\"$ctrl.changePlaces()\" ng-disabled=\"$ctrl.waiting || (!place.IsActive && !place.selected)\" name=\"placeCheckbox{{$index}}\"  id=\"placeCheckbox{{$index}}\">\n                                <span class=\"fa fa-check\"></span>\n                            </label>\n                        </div>\n                        <div class=\"adress lh18 fs-14\" title=\"{{place.info}}\" ng-class=\"{'inactiveStore': !place.IsActive}\" ng-bind=\"place.info\"></div>\n                    </div>\n                </div>\n            </div>\n            <span class=\"text-danger\" ng-bind=\"$ctrl.data.error.places\"></span>\n        </div>\n    </div>\n</div>\n</div>\n<div class=\"modal-footer bt0\">\n<div class=\"butLine\">\n    <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.save()\" class=\"btn btn-success btn-with-icon\">\n    <em class=\"fa fa-check\"></em>\n    <span ng-bind=\"$ctrl.data.textBtn\"></span>\n    </button>\n    <button type=\"button\" ng-disabled=\"$ctrl.waiting\" ng-click=\"$ctrl.close()\" class=\"btn btn-danger btn-with-icon\"  >\n    <em class=\"fa fa-times\"></em>\n    <span translate=\"button_cancel\"></span>\n    </button>\n</div>\n</div>\n<style>\n.commonShadow {\nposition: fixed;\nwidth: 10000px;\nheight: 10000px;\ntop: -5000px;\nleft: -1000px;\nz-index: 10;\n}\n</style>\n<div ng-show=\"$ctrl.waiting\" class=\"commonShadow\"></div>\n";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "<div class=\"accounts block\">\n    <div class=\"accounts__filter\">\n        <span ng-class=\"{'activefilter': !vm.settings.filter.isActive}\" ng-click=\"vm.settings.filter.isActive = true\"\n            translate=\"store_manager_accounts\" class=\"fw-500 fs-24\">\n        </span>\n        <span ng-hide=\"!vm.settings.isStaffAny.archived\" ng-class=\"{'activefilter': vm.settings.filter.isActive}\"\n            ng-click=\"vm.settings.filter.isActive = false\" translate=\"archived_accounts\" class=\"fw-500 fs-24\">\n        </span>\n    </div>\n    <p ng-show=\"vm.settings.filter.isActive\" class=\"accounts__hint\" translate=\"add_accounts_for_your_managers\"></p>\n    <p ng-hide=\"vm.settings.filter.isActive\" class=\"accounts__hint\" translate=\"list_of_archived_staff_accounts\"></p>\n    <div class=\"mt30\">\n        <div ng-if=\"vm.settings.places.length > 1\" class=\"flexVerticalAlignParent\">\n            <div class=\"posRel searchInput flex-stretch max-w466\">\n                <input class=\"form-control top-panel-input\" ng-model=\"vm.settings.filter.keyword\"\n                    ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" translate\n                    translate-attr-placeholder=\"name_or_email\" />\n                <span class=\"fa fa-search\"></span>\n            </div>\n            <div class=\"form-control-static placeSelect ml15\">\n                <ui-select ng-model=\"vm.settings.filter.place\" reset-search-input=\"true\" theme=\"bootstrap\"\n                    on-select=\"vm.settings.isAllStaffSelected = false; vm.settings.setCheckboxes()\"\n                    ng-disabled=\"vm.waiting\" class=\"top-panel-select--no-bg place-select\">\n                    <ui-select-match placeholder=\"All locations\">{{$select.selected.Name }}</ui-select-match>\n                    <ui-select-choices repeat=\"place in vm.settings.places | filter:$select.search\">\n                        {{place.Name}}\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div ng-if=\"vm.settings.filter.isActive\" class=\"ml-auto\">\n                <button ng-click=\"vm.archiveStaff()\" ng-show=\"!vm.waiting && vm.settings.isStaffSelected()\"\n                    class=\"btn btn-danger btn-with-icon\">\n                    <em class=\"fa fa-trash\"></em>\n                    <span translate=\"button_archive\"></span>\n                </button>\n            </div>\n            <div ng-show=\"vm.settings.filter.isActive && !vm.settings.isStaffSelected()\" class=\"ml-auto\">\n                <button ng-click=\"vm.setStaff()\" ng-disabled=\"vm.waiting\" class=\"btn btn-success height40 btn-with-icon\">\n                    <em class=\"fa fa-plus\"></em>\n                    <span translate=\"button_add_an_account\"></span>\n                </button>\n            </div>\n            <div ng-if=\"!vm.settings.filter.isActive\" class=\"ml-auto\">\n                <button ng-click=\"vm.restoreStaff()\" ng-disabled=\"vm.waiting || !vm.settings.isStaffSelected()\"\n                    class=\"btn btn-success btn-with-icon\">\n                    <em class=\"fa fa-rotate-left\"></em>\n                    <span translate=\"button_restore\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"panel\" ng-class=\"{'show': vm.settings.showPanel(), 'hidden': !vm.settings.showPanel()}\">\n            <div class=\"panel-body p0\">\n                <div class=\"tags-panel\">\n                    <div class=\"tableTags ml0 mr0 mt0\">\n                        <div class=\"tableTags ml0 mr0 mt0\">\n                            <div class=\"tr tableTagsHeader\">\n                                <div class=\"td width1 pt14 pb14 pl24\">\n                                    <div class=\"inner\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                            <label for=\"allCheckbox\" class=\"m0\">\n                                                <input type=\"checkbox\" name=\"allCheckbox\" ng-disabled=\"vm.waiting\"\n                                                    ng-model=\"vm.settings.isAllStaffSelected\"\n                                                    ng-change=\"vm.settings.setCheckboxes()\"\n                                                    class=\"ng-pristine ng-untouched ng-valid\" id=\"allCheckbox\" />\n                                                <span class=\"fa fa-check\"></span>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"td width1 pl16 pt14 pb14\" ng-click=\"vm.settings.sort.set('FirstName')\">\n                                    <div class=\"inner \">\n                                        <span translate=\"name\"></span>\n                                        <span ng-if=\"!vm.settings.sort.isSelected('FirstName')\" class=\"caret-up-down\">\n                                        </span>\n                                        <span ng-if=\"vm.settings.sort.isSelected('FirstName')\">\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"td width1 pl16 pt14 pb14\" ng-click=\"vm.settings.sort.set('Email')\">\n                                    <div class=\"inner text-nowrap\">\n                                        <span translate=\"email\"></span>\n                                        <span ng-if=\"!vm.settings.sort.isSelected('Email')\" class=\"caret-up-down\">\n                                        </span>\n                                        <span ng-if=\"vm.settings.sort.isSelected('Email')\">\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"td width2000 pl16 pt14 pb14\">\n                                    <div class=\"inner\" translate=\"location_th\"></div>\n                                </div>\n                            </div>\n\n                            <div class=\"tr ng-scope\" ng-repeat=\"item in vm.staff.Items\">\n                                <div class=\"td text-nowrap width1 pl24\">\n                                    <div class=\"inner\">\n                                        <div class=\"styleRadioCheckboxWrap checkbox c-checkbox\">\n                                            <label for=\"checkbox{{$index}}\" class=\"m0\">\n                                                <input type=\"checkbox\" name=\"checkbox{{$index}}\"\n                                                    ng-model=\"item.selected\"\n                                                    ng-change=\"vm.settings.changeSelected(item)\"\n                                                    id=\"checkbox{{$index}}\" />\n                                                <span class=\"fa fa-check\"></span>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"td text-nowrap pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"item.FirstName\"></span>&#32;\n                                        <span ng-bind=\"item.LastName\"></span>\n                                    </div>\n                                </div>\n                                <div class=\"td pl16\">\n                                    <div class=\"inner\">\n                                        <span ng-bind=\"item.Email\"></span>\n                                    </div>\n                                </div>\n\n                                <div class=\"td posRel pl16\">\n                                    <div class=\"inner \">\n                                        <div class=\"prodDescrEll\">\n                                            <div class=\"text flexVerticalAlignParent\" ng-repeat=\"place in item.places\">\n                                                <span class=\"marker-icon icon24 inline-block\"></span>\n                                                <span ng-class=\"{'inactiveStore': !place.isActive}\"\n                                                    ng-bind=\"place.info\"></span>\n                                            </div>\n                                            <div ng-if=\"vm.settings.filter.isActive\" class=\"controlRowTags\">\n                                                <span ng-click=\"vm.setStaff(item)\" class=\"fa fa-pencil\"></span>\n                                                <span ng-click=\"vm.archiveStaff(item)\" class=\"fa fa-close\"></span>\n                                            </div>\n                                            <div ng-if=\"!vm.settings.filter.isActive\" class=\"controlRowTags\">\n                                                <span ng-click=\"vm.restoreStaff(item)\" class=\"fs-13 \">\n                                                    <em class=\"fa fa-rotate-left\"></em>\n                                                    <span translate=\"restore\"></span>\n                                                </span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-show=\"vm.staff.Total > vm.settings.pageSize\"\n            class=\"panel-footer footer-padinationSmaller bt0 pt5 pb20 pl20 pr20\">\n            <ul uib-pagination boundary-links=\"true\" total-items=\"vm.staff.Total\" items-per-page=\"vm.settings.pageSize\"\n                ng-model=\"vm.settings.page\" first-text=\"first\" last-text=\"last\" previous-text=\"&laquo;\"\n                next-text=\"&raquo;\" max-size=\"10\" />\n        </div>\n    </div>\n\n    <div class=\"absolute-center-flex max-h440 no-scroll\"\n        ng-show=\"(vm.settings.places.length === 0 || vm.settings.places.length === 1) || (vm.staff.Items.length === 0 && vm.settings.places.length > 1)\">\n        <empty-list-state ng-if=\"vm.settings.places.length === 0 || vm.settings.places.length === 1\"\n            title-message=\"'you_currently_have_no_shopping_places' | translate\">\n        </empty-list-state>\n        <empty-list-state ng-if=\"vm.staff.Items.length === 0 && vm.settings.places.length > 1\"\n            title-message=\"'have_no_active_manager_accounts' | translate\">\n        </empty-list-state>\n    </div>\n</div>";

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "<label class=\"control-label w227\">\n    <span class=\"gray-text-bold\" ng-bind=\"ctrl.header\"></span>\n</label>\n<div ng-repeat=\"item in ctrl.stickers\" class=\"clearfix mb12 w227\">\n    <div>\n        <input type=\"text\"\n               ng-if=\"!ctrl.isReadOnly\"\n               ng-model=\"item.Code\"\n               ng-model-options=\"{ updateOn: 'submit blur', debounce: { submit: 0, blur: 0 } }\"\n               ng-change=\"ctrl.onStickerCodeChanged($index)\"\n               placeholder=\"{{ctrl.getPlaceholder()}}\"\n               class=\"wd-sd form-control inline-block sticker-input\" />\n        <span class=\"gray-text\" ng-if=\"ctrl.isReadOnly\"\n              ng-bind=\"item.Code\">\n        </span>\n        <button type=\"button\"\n                ng-if=\"!ctrl.isReadOnly || ctrl.isDeleteEnable\"\n                ng-hide=\"ctrl.stickers.length == 1 && !item.Code\"\n                ng-click=\"ctrl.onDeleteSticker({item: item})\"\n                ng-disabled=\"ctrl.isDisabled\"\n                class=\"deleteBtn p0 ml3\">\n            <em tooltip-popup-delay=\"200\"\n                tooltip-placement=\"top\"\n                uib-tooltip-html=\"'Delete'\"\n                class=\"fa fa-close\"></em>\n        </button>\n        <span class=\"text-danger asBlock\" ng-show=\"item.error\" ng-bind=\"item.error\"></span>\n        <span class=\"text-danger asBlock\" ng-show=\"ctrl.changesMap[$index]\" translate=\"nfc_product_stickers_list_sticker_changed\"></span>\n    </div>\n</div>\n<div class=\"addElement\" ng-if=\"!ctrl.isReadOnly\">\n    <button type=\"button\"\n            ng-click=\"ctrl.onAddSticker()\"\n            ng-disabled=\"ctrl.isDisabled\"\n            class=\"d-flex align-items-center link pl0\">\n        <span class=\"add-sticker-icon\"></span>\n        <span class=\"mt4\" translate=\"button_add_a_sticker\"></span>\n    </button>\n</div>\n";

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "<!--Read mode-->\n<div class=\"food-monitor-link food-monitor\" ng-if=\"!ctrl.editMode && ctrl.key && ctrl.isEnabled\">\n        <div class=\"copy-line d-flex align-items-center justify-content-between\" ng-if=\"ctrl.key\">\n            <input type=\"text\"\n                   class=\"form-control top-panel-input inline-block text-ellipsis input-link ml16\"\n                   ng-model=\"ctrl.url\"\n                   ng-readonly=\"true\">\n            <span translate=\"food_monitor_link_url_copy_title\"\n                  class=\"clickable copy-button mr16\"\n                  ng-click=\"ctrl.copyUrlToClipBoard()\">\n            </span>\n        </div>\n</div>\n\n<!--Edit mode-->\n<div class=\"food-monitor-link food-monitor\" ng-if=\"ctrl.editMode\">\n    <div>\n        <!--    Title-->\n        <label class=\"pt0 wd-auto food-monitor-title mb10\"  translate=\"food_monitor_link_title\">\n        </label>\n        <!--    Enabled button-->\n        <div class=\"posRel switcher mb24\">\n            <div class=\"form-control-static pt0 pb0\">\n                <label class=\"switch switch-default mb0\"\n                       ng-click=\"ctrl.changeMonitorEnable($event)\">\n                    <input type=\"checkbox\" ng-model=\"ctrl.isEnabled\">\n                    <span></span>\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"ctrl.isEnabled\">\n        <label class=\"gray-text-bold mb8\">\n            <span translate=\"food_monitor_link_url_title_edit\"></span>\n        </label>\n\n        <div class=\"copy-line d-flex align-items-center justify-content-between mb16\"\n             ng-if=\"ctrl.key\">\n            <input type=\"text\"\n                   class=\"form-control top-panel-input inline-block text-ellipsis input-link ml16\"\n                   ng-model=\"ctrl.url\">\n            <span translate=\"food_monitor_link_url_copy_title\"\n                  class=\"clickable copy-button mr16\"\n                  ng-click=\"ctrl.copyUrlToClipBoard()\">\n            </span>\n        </div>\n\n        <div class=\"generate-link d-flex align-items-center clickable mb35\" ng-click=\"ctrl.generateNewUrl()\">\n            <span class=\"generate-icon mr8\"></span>\n            <span class=\"generate-text\" translate=\"food_monitor_link_generate_title\"></span>\n        </div>\n        <div class=\"d-flex align-items-center mb8 ml3\">\n            <input class=\"custom-checkbox\" type=\"checkbox\" id=\"hideMonitor\" ng-model=\"ctrl.hideMonitor\" ng-change=\"ctrl.addOrDeleteHideParam()\">\n            <label class=\"base-text\" for=\"hideMonitor\" translate=\"food_monitor_link_url_hide_monitor\"></label>\n        </div>\n\n    </div>\n</div>\n";

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "<div class=\"d-flex flex-column\">\n    <span class=\"page-title mb24\" translate=\"order_settings\"></span>\n    <div class=\"d-flex flex-wrap\" ng-show=\"ctrl.isPlacesAny === true\">\n        <div class=\"order-settings-panel\" ng-repeat=\"place in ctrl.places\">\n            <form ng-if=\"place.isOpenEdit\"\n                  class=\"edit-panel d-flex flex-column\"\n                  ng-submit=\"ctrl.save(place)\"\n                  autocomplete=\"off\"\n                  novalidate\n            >\n                <div class=\"header d-flex align-items-center justify-content-between\">\n                    <div class=\"d-flex flex-column mr16\">\n                        <span class=\"mb4 place-name\" ng-bind=\"ctrl.getPlaceNameWithAddress(place)\"></span>\n                        <span ng-bind=\"place.Town\"></span>\n                    </div>\n                    <div class=\"d-flex\">\n                        <button type=\"button\" ng-click=\"ctrl.cancelEdit(place)\" ng-disabled=\"ctrl.waiting\"\n                                class=\"btn btn-danger mr10\" translate=\"button_cancel\"></button>\n                        <button type=\"submit\"\n                                class=\"btn btn-success\" translate=\"button_save\"></button>\n                    </div>\n                </div>\n                <div class=\"d-flex flex-column panel-form\">\n                    <div class=\"d-flex mb24\">\n                        <div class=\"flows d-flex flex-column mr32\">\n                            <span class=\"title mb10\" translate=\"store_payment_method\"></span>\n                            <div class=\"check-row d-flex align-items-center mb20\"\n                                 uib-tooltip=\"{{ctrl.jispGoAndInStoreTooltip}}\"\n                                 tooltip-placement=\"top-left\"\n                                 tooltip-enable=\"ctrl.edit.model.ShoppingFlows.InStore.Enabled\"\n                            >\n                                <input class=\"custom-checkbox\" type=\"checkbox\" id=\"jispGo_preorder\"\n                                       ng-model=\"ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\"\n                                       ng-change=\"ctrl.onPaymentMethodChanged()\"\n                                       ng-disabled=\"!ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Available || ctrl.edit.model.ShoppingFlows.InStore.Enabled\"\n                                >\n                                <label for=\"jispGo_preorder\" translate=\"store_payment_method_jispgo\"></label>\n                            </div>\n                            <div class=\"d-flex flex-column ml36\" \n                                ng-show=\"ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Available && ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\">\n                                <div class=\"check-row d-flex align-items-center mb20\">\n                                    <input class=\"custom-radio\"\n                                           type=\"radio\"\n                                           name=\"scanning\"\n                                           id=\"nfc\"\n                                           ng-model=\"ctrl.edit.model.ShoppingScanMethod\"\n                                           ng-value=\"1\"\n                                           ng-disabled=\"!ctrl.nfcScanningAllowed()\"\n                                    >\n                                    <label for=\"nfc\" translate=\"nfc_scanning\"></label>\n                                </div>\n                                <div class=\"check-row d-flex align-items-center mb20\">\n                                    <input class=\"custom-radio\"\n                                           type=\"radio\"\n                                           name=\"scanning\"\n                                           id=\"barcode\"\n                                           ng-model=\"ctrl.edit.model.ShoppingScanMethod\"\n                                           ng-value=\"2\"\n                                           ng-disabled=\"!ctrl.barcodeScanningAllowed()\"\n                                    >\n                                    <label for=\"barcode\" translate=\"barcode_scanning\"></label>\n                                </div>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center mb20\"\n                                 uib-tooltip=\"{{ctrl.jispGoAndInStoreTooltip}}\"\n                                 tooltip-placement=\"top-left\"\n                                 tooltip-enable=\"ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\"\n                            >\n                                <input class=\"custom-checkbox\" type=\"checkbox\" id=\"inStore\"\n                                       ng-model=\"ctrl.edit.model.ShoppingFlows.InStore.Enabled\"\n                                       ng-change=\"ctrl.onPaymentMethodChanged()\"\n                                       ng-disabled=\"!ctrl.edit.model.ShoppingFlows.InStore.Available || ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\"\n                                >\n                                <label for=\"inStore\" translate=\"buyInStore\"></label>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center mb20\"\n                                 uib-tooltip=\"{{ctrl.tapTapTooltip}}\"\n                                 tooltip-placement=\"top-left\"\n                                 tooltip-enable=\"ctrl.tapTapChecked()\"\n                            >\n                                <input class=\"custom-checkbox\" type=\"checkbox\" id=\"clickAndCollect\"\n                                       ng-model=\"ctrl.edit.model.ShoppingFlows.ClickCollect.Enabled\"\n                                       ng-change=\"ctrl.onPaymentMethodChanged()\"\n                                       ng-disabled=\"!ctrl.edit.model.ShoppingFlows.ClickCollect.Available || ctrl.tapTapChecked()\"\n                                >\n                                <label for=\"clickAndCollect\" translate=\"click_and_collect\"></label>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center\"\n                                 uib-tooltip=\"{{ctrl.tapTapTooltip}}\"\n                                 tooltip-placement=\"top-left\"\n                                 tooltip-enable=\"ctrl.tapTapChecked()\"\n                            >\n                                <input class=\"custom-checkbox\" type=\"checkbox\" id=\"delivery\"\n                                       ng-model=\"ctrl.edit.model.ShoppingFlows.Delivery.Enabled\"\n                                       ng-change=\"ctrl.onPaymentMethodChanged()\"\n                                       ng-disabled=\"!ctrl.edit.model.ShoppingFlows.Delivery.Available || ctrl.tapTapChecked()\"\n                                >\n                                <label for=\"delivery\" translate=\"delivery\"></label>\n                            </div>\n                        </div>\n                        <div class=\"d-flex flex-column\" ng-show=\"ctrl.showDetailsVisible()\">\n                            <span class=\"title mb10\" translate=\"jisp_stickers_action\"></span>\n                            <div class=\"check-row d-flex align-items-center mb20\"\n                                 ng-show=\"ctrl.addToCardVisible()\">\n                                <input class=\"custom-radio\"\n                                       type=\"radio\"\n                                       name=\"radio\"\n                                       id=\"add\"\n                                       ng-model=\"ctrl.edit.model.DefaultProductScanAction\"\n                                       ng-value=\"ctrl.scanAction.AddToCart\"\n                                >\n                                <label for=\"add\" translate=\"add_product_to_basket\"></label>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center mb20\" ng-show=\"ctrl.showDetailsVisible()\">\n                                <input class=\"custom-radio\"\n                                       type=\"radio\"\n                                       name=\"radio\"\n                                       id=\"info\"\n                                       ng-model=\"ctrl.edit.model.DefaultProductScanAction\"\n                                       ng-value=\"ctrl.scanAction.ShowDetails\"\n                                >\n                                <label for=\"info\" translate=\"view_product_info\"></label>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center mb20\" ng-show=\"ctrl.showCardsVisible()\">\n                                <input class=\"custom-radio\"\n                                       type=\"radio\"\n                                       name=\"radio\"\n                                       id=\"cards\"\n                                       ng-model=\"ctrl.edit.model.DefaultProductScanAction\"\n                                       ng-value=\"ctrl.scanAction.FlickeringCards\"\n                                >\n                                <label for=\"cards\" translate=\"shows_product_cards\"></label>\n                            </div>\n                            <div class=\"check-row d-flex align-items-center\"\n                                 ng-show=\"ctrl.tapTapVisible()\"\n                                 uib-tooltip=\"{{ctrl.tapTapTooltip}}\"\n                                 tooltip-placement=\"top-left\"\n                                 tooltip-enable=\"!ctrl.tapTapAllowed()\"\n                            >\n                                <input class=\"custom-radio\"\n                                       type=\"radio\"\n                                       name=\"radio\"\n                                       id=\"taptap\"\n                                       ng-model=\"ctrl.edit.model.DefaultProductScanAction\"\n                                       ng-value=\"ctrl.scanAction.TapTap\"\n                                       ng-disabled=\"!ctrl.tapTapAllowed()\"\n                                >\n                                <label for=\"taptap\" translate=\"taptap\"></label>\n                            </div>\n                        </div>\n                        <div class=\"d-flex non-shopping-flows pt32\" ng-show=\"!ctrl.showDetailsVisible()\">\n                            <span class=\"warning-icon mr8\"></span>\n                            <div class=\"message\" translate=\"non_flow_message\"></div>\n                        </div>\n                    </div>\n                    <div class=\"d-flex mb32\" ng-show=\"ctrl.edit.model.ShoppingScanMethod === 2 && ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\">\n                        <span class=\"info-icon mr12\"></span>\n                        <span class=\"text-gray-12 w442\" translate=\"for_barcode_scanning\"></span>\n                    </div>\n                    <div class=\"d-flex flex-column mb24\" ng-if=\"ctrl.edit.model.ShoppingFlows.Delivery.Enabled && ctrl.bagFee\">\n                        <span class=\"title mb14\" translate=\"bag_fee\"></span>\n                        <div class=\"d-flex\">\n                            <label class=\"switch switch-default posRel mr16\" name=\"takeBagFeeEnabled{{$index}}\">\n                                <input type=\"checkbox\" ng-disabled=\"ctrl.waiting\"\n                                       name=\"takeBagFeeEnabled{{$index}}\"\n                                       ng-model=\"ctrl.edit.model.CarrierBagEnabled\">\n                                <span></span>\n                            </label>\n                            <span class=\"gray-text\" translate=\"take_20_bag_fee\" translate-value-sum=\"{{ctrl.bagFee}}\"></span>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column mb24\" ng-if=\"ctrl.edit.model.ShoppingFlows.ClickCollect.Enabled || ctrl.edit.model.ShoppingFlows.InStore.Enabled\">\n                        <span class=\"title mb14\" translate=\"manual_set_as_paid\"></span>\n                        <div class=\"d-flex\">\n                            <label class=\"switch switch-default posRel mr16\" name=\"setAsPaidEnabled{{$index}}\">\n                                <input type=\"checkbox\" ng-disabled=\"ctrl.waiting\"\n                                       name=\"setAsPaidEnabled{{$index}}\"\n                                       ng-model=\"ctrl.edit.model.PayOutsideJispEnabled\">\n                                <span></span>\n                            </label>\n                            <span class=\"gray-text mt3\" translate=\"allow_to_take_payments_outside\"></span>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column\" ng-if=\"ctrl.edit.model.ShoppingFlows.JispGoOrPreOrder.Enabled\">\n                        <div class=\"d-flex flex-column mb24\">\n                            <span class=\"title mb14\" translate=\"manual_mark_as_collected_label\"></span>\n                            <div class=\"d-flex\">\n                                <label class=\"switch switch-default posRel mr16\" name=\"modelCollectedEnabled{{$index}}\"\n                                       ng-click=\"ctrl.changeModelCollectedEnabled($event);\">\n                                    <input type=\"checkbox\" ng-disabled=\"ctrl.waiting\"\n                                           name=\"modelCollectedEnabled{{$index}}\"\n                                           ng-model=\"ctrl.edit.model.CollectWithoutPincode\">\n                                    <span></span>\n                                </label>\n                                <span class=\"gray-text mt3\" translate=\"store_order_collect\"></span>\n                            </div>\n                        </div>\n                        <div class=\"d-flex flex-column mb24\">\n                            <span class=\"title mb8\"\n                                  translate=\"pin_for_access_to_check_in_and_check_out_terminals\"></span>\n                            <div class=\"d-flex align-items-center\">\n                                <input ng-model=\"ctrl.edit.model.PinCode\" maxlength=\"4\" type=\"text\" name=\"staff-pin\"\n                                       class=\"form-control inline-block mr8 pin-input\">\n                                <span class=\"gray-text\" translate=\"max_4_digits\"></span>\n                            </div>\n                        </div>\n                        <div class=\"d-flex flex-column mb24\" ng-show=\"ctrl.edit.model.ShoppingScanMethod === 1\">\n                            <span class=\"title mb8\" translate=\"nfc_stickers_tap_n_go_label\"></span>\n                            <span class=\"text-gray-12 mb12\" translate=\"would_like_make_checking\"></span>\n                            <div class=\"d-flex justify-content-between\">\n                                <div class=\"d-flex justify-content-center\">\n                                    <check-stickers header=\"ctrl.checkInStickersTitle\"\n                                                    stickers=\"ctrl.edit.newCheckInNfcStickers\" is-waiting=\"ctrl.waiting\"\n                                                    is-read-only=\"false\" on-add-sticker=\"ctrl.addCheckInCode()\"\n                                                    on-delete-sticker=\"ctrl.deleteCheckInCode(item)\">\n                                    </check-stickers>\n                                </div>\n                                <div class=\"d-flex justify-content-center\">\n                                    <check-stickers header=\"ctrl.checkOutStickersTitle\"\n                                                    stickers=\"ctrl.edit.newCheckOutNfcStickers\"\n                                                    is-waiting=\"ctrl.waiting\"\n                                                    is-read-only=\"false\"\n                                                    on-add-sticker=\"ctrl.addCheckOutCode(ctrl.edit.oldCheckOutCode)\"\n                                                    on-delete-sticker=\"ctrl.deleteCheckOutCode(item)\">\n                                    </check-stickers>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"d-flex flex-column mb24\">\n                            <span class=\"title mb10\" translate=\"store_paynow\"></span>\n                            <div class=\"d-flex a\">\n                                <div class=\"posRel mr16\">\n                                    <div class=\"form-control-static m0 pt0 pb0\">\n                                        <label class=\"switch switch-default posRel\" name=\"modelPayNowEnabled{{$index}}\">\n                                            <input type=\"checkbox\" ng-disabled=\"ctrl.waiting\"\n                                                   name=\"modelPayNowEnabled{{$index}}\"\n                                                   ng-model=\"ctrl.edit.model.PayNowEnabled\" class=\"\">\n                                            <span></span>\n                                        </label>\n                                    </div>\n                                </div>\n                                <span class=\"gray-text mt3\" translate=\"store_paynow_description\"></span>\n                            </div>\n                        </div>\n                        <div class=\"bug-check d-flex flex-column mb24\">\n                            <span class=\"title mb10\" translate=\"random_check_enabled\"></span>\n                            <div class=\"d-flex flex-column\">\n                                <div class=\"posRel bug-check-switch mb8\">\n                                    <div class=\"form-control-static pt0 pb0\">\n                                        <label class=\"switch switch-default posRel mb0\"\n                                               name=\"modelBagCheckSettingsEnabled{{$index}}\">\n                                            <input type=\"checkbox\" ng-disabled=\"ctrl.waiting\"\n                                                   name=\"modelBagCheckSettingsEnabled{{$index}}\"\n                                                   ng-model=\"ctrl.edit.model.BagCheckSettings.Enabled\" class=\"\">\n                                            <span></span>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class=\"d-flex flex-column\" ng-show=\"ctrl.edit.model.BagCheckSettings.Enabled\">\n                                    <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_chance\"></span>\n                                        <div>\n                                            <input type=\"text\" only-decimal maxchar=\"3\" min-value=\"0.1\"\n                                                   max-value=\"100\" maxchar-decimal=\"1\"\n                                                   ng-model=\"ctrl.edit.model.BagCheckSettings.Chance\"\n                                                   ng-readonly=\"ctrl.waiting || !ctrl.edit.model.BagCheckSettings.Enabled\"\n                                                   autocomplete=\"off\"\n                                                   class=\"form-control inline-block bug-check-input mr8\"/>\n                                            <span>%</span>\n                                            <span class=\"text-danger asBlock bug-check-error\"\n                                                  ng-show=\"ctrl.edit.error.bagCheckSettingsChance\"\n                                                  ng-bind=\"ctrl.edit.error.bagCheckSettingsChance\"></span>\n                                        </div>\n                                    </div>\n                                    <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_daily_limit\"></span>\n                                        <input type=\"text\" only-num min-value=\"1\" maxchar=\"6\"\n                                               ng-model=\"ctrl.edit.model.BagCheckSettings.DailyLimit\"\n                                               ng-readonly=\"ctrl.waiting || !ctrl.edit.model.BagCheckSettings.Enabled\"\n                                               autocomplete=\"off\" class=\"form-control inline-block bug-check-input\"/>\n                                    </div>\n                                    <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_minimum_amount\"></span>\n                                        <span class=\"bug-check-blocked-icon mr8\"></span>\n                                        <span class=\"text-gray\">Coming soon</span>\n                                    </div>\n                                    <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_minimum_total\"></span>\n                                        <span class=\"bug-check-blocked-icon mr8\"></span>\n                                        <span class=\"text-gray\">Coming soon</span>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"d-flex flex-column\">\n                            <food-monitor-url-generator edit-mode=\"true\" key=\"ctrl.edit.model.MonitorKey\"\n                                                        hide-monitor=\"ctrl.edit.model.HideMonitor\"\n                                                        is-enabled=\"ctrl.edit.model.FoodMonitor\"\n                                                        on-key-changed=\"ctrl.monitorKeyChanged(monitorState)\">\n                            </food-monitor-url-generator>\n                        </div>\n                    </div>\n                </div>\n            </form>\n            <div ng-if=\"!place.isOpenEdit\" class=\"view-panel\">\n                <div class=\"head d-flex justify-content-between mb24\">\n                    <div class=\"d-flex flex-column mr16\">\n                        <span class=\"head-title mb4\" ng-bind=\"ctrl.getPlaceNameWithAddress(place)\"></span>\n                        <span class=\"subtitle\" ng-bind=\"place.Town\"></span>\n                    </div>\n                    <button ng-click=\"ctrl.placeEdit(place)\" ng-disabled=\"ctrl.waiting || ctrl.edit.isOpenEdit\"\n                            class=\"edit-icon ml-auto\"></button>\n                </div>\n                <div class=\"d-flex flex-column mb24\" ng-show=\"ctrl.showDetailsVisible(place)\">\n                    <span class=\"title mb4\" translate=\"store_payment_method\"></span>\n                    <span class=\"base-text\" ng-bind=\"ctrl.getShoppingFlows(place)\"></span>\n                </div>\n                <div class=\"d-flex flex-column mb24\" ng-show=\"ctrl.showDetailsVisible(place)\">\n                    <span class=\"title mb4\" translate=\"jisp_stickers_action\"></span>\n                    <span ng-show=\"place.DefaultProductScanAction == 1\" translate=\"add_product_to_basket\"></span>\n                    <span ng-show=\"place.DefaultProductScanAction == 3\" translate=\"shows_product_cards\"></span>\n                    <span ng-show=\"place.DefaultProductScanAction == 2\" translate=\"view_product_info\"></span>\n                    <span ng-show=\"place.DefaultProductScanAction == 4\" translate=\"taptap\"></span>\n                </div>\n                <div class=\"d-flex flex-column\" ng-show=\"place.ShoppingFlows.Delivery.Enabled && ctrl.bagFee\">\n                    <div class=\"d-flex flex-column mb24\">\n                        <span class=\"title mb14\" translate=\"bag_fee\"></span>\n                        <div class=\"d-flex\">\n                            <label class=\"switch switch-default posRel mr16\" name=\"takeBagFeeEnabled{{$index}}\">\n                                <input type=\"checkbox\" ng-disabled=\"true\"\n                                       name=\"takeBagFeeEnabled{{$index}}\"\n                                       ng-model=\"place.CarrierBagEnabled\">\n                                <span></span>\n                            </label>\n                            <span class=\"gray-text\" translate=\"take_20_bag_fee\" translate-value-sum=\"{{ctrl.bagFee}}\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"d-flex flex-column mb24\" ng-if=\"place.ShoppingFlows.ClickCollect.Enabled || place.ShoppingFlows.InStore.Enabled\">\n                    <span class=\"title mb14\" translate=\"manual_set_as_paid\"></span>\n                    <div class=\"d-flex\">\n                        <label class=\"switch switch-default posRel mr16\" name=\"setAsPaidEnabled{{$index}}\">\n                            <input type=\"checkbox\" ng-disabled=\"true\"\n                                   name=\"setAsPaidEnabled{{$index}}\"\n                                   ng-model=\"place.PayOutsideJispEnabled\">\n                            <span></span>\n                        </label>\n                        <span class=\"gray-text mt3\" translate=\"allow_to_take_payments_outside\"></span>\n                    </div>\n                </div>\n                <div class=\"d-flex flex-column\" ng-show=\"place.ShoppingFlows.JispGoOrPreOrder.Enabled\">\n                    <div class=\"d-flex flex-column mb24\">\n                            <span class=\"title mb8\"\n                                  translate=\"pin_for_access_to_check_in_and_check_out_terminals\"></span>\n                        <div class=\"d-flex align-items-center\">\n                            <div class=\"pin-show-hide\">\n                            <span ng-hide=\"place.showPassword\" ng-click=\"place.showPassword = true;\"\n                                  class=\"pin-show-hide__item active\">\n                                <i class=\"fa fa-eye mr10 clickable\"></i>\n                                <span>••••</span>\n                            </span>\n                                <span ng-show=\"place.showPassword\" ng-click=\"place.showPassword = false;\">\n                                <i class=\"fa fa-eye-slash mr10 clickable\"></i>\n                                <span ng-bind=\"place.PinCode\"></span>\n                            </span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column mb24\">\n                        <span class=\"title mb14\" translate=\"manual_mark_as_collected_label\"></span>\n                        <div class=\"d-flex\">\n                            <label class=\"switch switch-default posRel mr16\" name=\"modelCollectedEnabled{{$index}}\">\n                                <input type=\"checkbox\" ng-disabled=\"true\"\n                                       name=\"modelCollectedEnabled{{$index}}\"\n                                       ng-model=\"place.CollectWithoutPincode\">\n                                <span></span>\n                            </label>\n                            <span class=\"gray-text mt3\" translate=\"store_order_collect\"></span>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column mb24\">\n                        <span class=\"title mb10\" translate=\"store_paynow\"></span>\n                        <div class=\"d-flex a\">\n                            <div class=\"posRel mr16\">\n                                <div class=\"form-control-static m0 pt0 pb0\">\n                                    <label class=\"switch switch-default posRel\" name=\"modelPayNowEnabled{{$index}}\">\n                                        <input type=\"checkbox\" ng-disabled=\"true\"\n                                               name=\"modelPayNowEnabled{{$index}}\"\n                                               ng-model=\"place.PayNowEnabled\" class=\"\">\n                                        <span></span>\n                                    </label>\n                                </div>\n                            </div>\n                            <span class=\"gray-text mt3\" translate=\"store_paynow_description\"></span>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column mb16\" ng-show=\"place.ShoppingScanMethod === 1\">\n                        <span class=\"title mb12\" translate=\"nfc_stickers_tap_n_go_label\"></span>\n                        <div class=\"d-flex\">\n                            <div class=\"d-flex flex-column w227 mr24\">\n                                <span translate=\"check_in_stickers\" class=\"gray-text-bold mb12\"></span>\n                                <div class=\"mb8 gray-text\" ng-repeat=\"code in place.CheckInNfcStickers\" ng-bind=\"code\"></div>\n                            </div>\n                            <div class=\"d-flex flex-column w227\">\n                                <span translate=\"check_out_stickers\" class=\"gray-text-bold mb12\"></span>\n                                <div class=\"mb8 gray-text\" ng-repeat=\"code in place.CheckOutNfcStickers\" ng-bind=\"code\"></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"bug-check d-flex flex-column\">\n                        <span class=\"title mb10\" translate=\"random_check_enabled\"></span>\n                        <div class=\"d-flex flex-column\">\n                            <div class=\"posRel bug-check-switch mb8\">\n                                <div class=\"form-control-static pt0 pb0\">\n                                    <label class=\"switch switch-default posRel mb0\"\n                                           name=\"modelBagCheckSettingsEnabled{{$index}}\">\n                                        <input type=\"checkbox\" ng-disabled=\"true\"\n                                               name=\"modelBagCheckSettingsEnabled{{$index}}\"\n                                               ng-model=\"place.RandomCheckEnabled\" class=\"\">\n                                        <span></span>\n                                    </label>\n                                </div>\n                            </div>\n                            <div class=\"d-flex flex-column\" ng-show=\"place.RandomCheckEnabled\">\n                                <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_chance\"></span>\n                                    <div>\n                                        <input type=\"text\" only-decimal maxchar=\"3\" min-value=\"0.1\"\n                                               max-value=\"100\" maxchar-decimal=\"1\"\n                                               ng-model=\"place.RandomCheckChance\"\n                                               ng-readonly=\"true\"\n                                               autocomplete=\"off\"\n                                               class=\"form-control inline-block bug-check-input mr8\"/>\n                                        <span>%</span>\n                                    </div>\n                                </div>\n                                <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_daily_limit\"></span>\n                                    <input type=\"text\" only-num min-value=\"1\" maxchar=\"6\"\n                                           ng-model=\"place.RandomCheckDayLimit\"\n                                           ng-readonly=\"true\"\n                                           autocomplete=\"off\" class=\"form-control inline-block bug-check-input\"/>\n                                </div>\n                                <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_minimum_amount\"></span>\n                                    <span class=\"bug-check-blocked-icon mr8\"></span>\n                                    <span class=\"text-gray\">Coming soon</span>\n                                </div>\n                                <div class=\"d-flex align-items-center mb16\">\n                                        <span class=\"gray-text-bold bug-check-label mr24\"\n                                              translate=\"random_check_minimum_total\"></span>\n                                    <span class=\"bug-check-blocked-icon mr8\"></span>\n                                    <span class=\"text-gray\">Coming soon</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"d-flex flex-column mt24\" ng-if=\"place.FoodMonitor\">\n                        <span class=\"title mb4\" translate=\"food_monitor_link_url_title_read\"></span>\n                        <food-monitor-url-generator edit-mode=\"false\" hide-monitor=\"place.HideMonitor\"\n                                                    key=\"place.MonitorKey\" is-enabled=\"place.FoodMonitor\"\n                                                    on-key-changed=\"ctrl.monitorKeyChanged()\">\n                        </food-monitor-url-generator>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <empty-list-state class=\"absolute-center-flex\"\n                      title-message=\"'no_shopping_places' | translate\" message=\"'no_shopping_places_hint' | translate\"\n                      ng-show=\"ctrl.isPlacesAny === false\">\n     </empty-list-state>\n</div>\n";

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<back-to-dashboard fixed=\"true\"></back-to-dashboard>\n\n<toaster-container toaster-options=\"{'position-class': 'toast-top-center', 'close-button':true}\"></toaster-container>\n<toaster-container toaster-options=\"{'position-class': 'toast-top-center', 'close-button':true, 'toaster-id': 'waiting'}\"></toaster-container>\n<!-- top navbar-->\n<header ng-class=\"app.theme.topbar\"><top-navbar></top-navbar></header>\n<!-- Sidebar-->\n<div class=\"leftBarPadd\" ng-if=\"hasWarnings()\" ng-class=\"{'message1': userData.retailerStatus == enums.RetailerStatus.Unverified }\"></div>\n<aside ng-class=\"app.theme.sidebar\"><sidebar></sidebar></aside>\n<!--Main-->\n<section>\n    <!-- Content-->\n    <div ui-view=\"\" autoscroll=\"false\" ng-class=\"$stateParams.no_anim || app.views.animation\" class=\"app pb0\"></div>\n</section>\n<!-- Page footer-->\n<footer class=\"app-footer\">\n    <app-footer></app-footer>\n</footer>\n";

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pr12 pl12 pb24 animated rotateInDownLeft \">\n    <!-- Breadcrumbs-->\n    <div class=\"mb24\">\n        <ol class=\"breadcrumb ns m0\">\n            <li><span ui-sref=\"app.vouchers.list\" translate=\"vouchers\" class=\"fs-20 fw-500 color-amethyst-smoke\"></span>\n            </li>\n            <li class=\"active\">\n                <span ng-if=\"!ctrl.editMode\" translate=\"create_voucher_title\" class=\"fs-20 fw-500 color-black87\"></span>\n                <span ng-if=\"ctrl.editMode && !ctrl.isPublished\" translate=\"edit_voucher_title\"\n                      class=\"fs-20 fw-500 color-black87\"></span>\n                <span ng-if=\"ctrl.editMode && ctrl.isPublished\" translate=\"edit_active_voucher_title\"\n                      class=\"fs-20 fw-500 color-black87\"></span>\n            </li>\n        </ol>\n    </div>\n\n    <!-- Voucher details-->\n    <div class=\"panel panel-edit br4 mb8\">\n        <div class=\"panel-heading flexVerticalAlignParent border-bottom-gray pl16 pt12 pb12\">\n            <div class=\"fs-18 lh24 fw-500 color-black87\" translate=\"details\"></div>\n        </div>\n        <div class=\"panel-body pt16 pl16 pb24 d-flex flex-column\">\n            <p ng-if=\"!ctrl.isPublished\" class=\"fs-12 lh16 ls-031 color-black6 mb16\"\n               translate=\"voucher_dialog_hint\"></p>\n            <form name=\"ctrl.voucherForm\">\n                <div class=\"flex-align-start mb16\">\n                    <div class=\"flex-column width220 mr24 pt0 pb0 option\">\n                        <label class=\"control-label fw-500 fs-14 lh16 ls-031 color-black6\"\n                               translate=\"vouchers_type\"></label>\n                        <ui-select class=\"height40 voucher-type\" name=\"voucherType\" theme=\"bootstrap\"\n                                   search-enabled=\"false\"\n                                   skip-focusser=\"true\" ng-model=\"ctrl.model.VoucherType\" ng-disabled=\"ctrl.waiting\">\n                            <ui-select-match class=\"ui-select-match height40\"\n                                             placeholder=\"{{'select_voucher_type' | translate}}\">\n                                <div ng-if=\"$select.selected === ctrl.voucherTypesEnum.FixedAmount\"\n                                     translate=\"voucher_order_discount\"></div>\n                                <span ng-if=\"$select.selected === ctrl.voucherTypesEnum.FreeDelivery\"\n                                      translate=\"voucher_delivery\"></span>\n                                <span ng-if=\"$select.selected === ctrl.voucherTypesEnum.Percent\"\n                                      translate=\"voucher_percent_discount\"></span>\n                            </ui-select-match>\n                            <ui-select-choices repeat=\"item in ctrl.voucherTypes\">\n                                <span ng-if=\"item === ctrl.voucherTypesEnum.FixedAmount\"\n                                      translate=\"voucher_order_discount\"></span>\n                                <span ng-if=\"item === ctrl.voucherTypesEnum.FreeDelivery\"\n                                      translate=\"voucher_delivery\"></span>\n                                <span ng-if=\"item === ctrl.voucherTypesEnum.Percent\"\n                                      translate=\"voucher_percent_discount\"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.typeRequired\"\n                              translate=\"field_is_required\"></span>\n                    </div>\n                    <div class=\"flex-column\">\n                        <label class=\"fw-500 fs-14 lh16 ls-031 color-black6\" translate=\"min_order_price\"></label>\n                        <div class=\"{{ctrl.currencyCssClass}} t11 width220\">\n                            <input type=\"text\" only-decimal ng-model=\"ctrl.model.MinOrderPrice\"\n                                   ng-readonly=\"ctrl.waiting\" class=\"form-control height40\" name=\"minOrderPrice\"/>\n                        </div>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.minOrderPriceEqualZero\"\n                              translate=\"must_be_greater_than_0\"></span>\n                        <span class=\"text-danger width220\" ng-show=\"ctrl.voucherErrors.minOrderPriceOverLimit\">\n                            {{'not_greater_than' | translate: {field: ('min_order_price' | translate), value: 999999.99}\n                            }}</span>\n                    </div>\n                </div>\n                <div\n                    ng-if=\"ctrl.model.VoucherType === ctrl.voucherTypesEnum.Percent || ctrl.model.VoucherType === ctrl.voucherTypesEnum.FixedAmount\"\n                    class=\"mb16 flex-column\">\n                    <label class=\"font-normal fw-500 fs-14 lh16 ls-031 color-black6\"\n                           translate=\"voucher_discount\"></label>\n                    <div ng-if=\"ctrl.model.VoucherType === ctrl.voucherTypesEnum.Percent\"\n                         class=\"width220 withPercent t10\">\n                        <input type=\"text\" only-num ng-model=\"ctrl.model.DiscountValue\"\n                               ng-readonly=\"ctrl.waiting\" class=\"form-control height40\" name=\"discountPercent\"/>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountPercentRequired\"\n                              translate=\"field_is_required\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountEqualZero\"\n                              translate=\"must_be_greater_than_0\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountOverLimit\">\n                            {{'not_greater_than' | translate: {field: ('voucher_discount' | translate), value: 100}\n                            }}</span>\n                    </div>\n                    <div ng-if=\"ctrl.model.VoucherType === ctrl.voucherTypesEnum.FixedAmount\" class=\"width220 t11\"\n                         ng-class=\"{ {{ctrl.currencyCssClass}}: ctrl.model.VoucherType === ctrl.voucherTypesEnum.FixedAmount}\">\n                        <input type=\"text\" only-decimal ng-model=\"ctrl.model.DiscountValue\" ng-readonly=\"ctrl.waiting\"\n                               class=\"form-control height40\" name=\"discountAmount\"/>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountAmountRequired\"\n                              translate=\"field_is_required\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountEqualZero\"\n                              translate=\"must_be_greater_than_0\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.discountOverLimit\">\n                            {{'not_greater_than' | translate: {\n                            field: ('voucher_discount' | translate),\n                            value: 999999.99\n                        } }}</span>\n                    </div>\n                </div>\n                <div class=\"flex-align-start mb16\">\n                    <div>\n                        <label class=\"control-label fw-500 fs-14 lh16 ls-031 color-black6\"\n                               translate=\"start_date\"></label>\n                        <div class=\"width220 height40 mr24 input-group wrapRelative datepicker--transparent\">\n                            <input type=\"text\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"ctrl.model.StartDate\"\n                                   ng-model-options=\"{timezone: 'utc'}\"\n                                   is-open=\"openedStartDate\" ng-focus=\"openedStartDate=true; openedEndDate=false;\"\n                                   datepicker-options=\"ctrl.startDateOptions\" close-text=\"{{::'close' | translate}}\"\n                                   clear-text=\"{{::'clear' | translate}}\" current-text=\"{{::'today' | translate}}\"\n                                   readonly\n                                   class=\"form-control\" name=\"startDate\" required/>\n                            <div class=\"input-group-btn\">\n                                <button type=\"button\"\n                                        ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedStartDate=true; openedEndDate=false;\"\n                                        class=\"btn btn-default btn-icon24 flexVerticalAlignParent\">\n                                    <span class=\"icon-calendar icon24\"></span>\n                                </button>\n                            </div>\n                        </div>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.startDateRequired\"\n                              translate=\"field_is_required\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.startDateInPast\"\n                              translate=\"date_in_past_error\"></span>\n                    </div>\n                    <div class=\"w238\">\n                        <label class=\"control-label fw-500 fs-14 lh16 ls-031 color-black6\" translate=\"end_date\"></label>\n                        <div class=\"width220 height40 input-group wrapRelative datepicker--transparent\">\n                            <input type=\"text\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"ctrl.model.EndDate\"\n                                   ng-model-options=\"{timezone: 'utc'}\"\n                                   is-open=\"openedEndDate\" datepicker-options=\"ctrl.endDateOptions\"\n                                   close-text=\"{{::'close' | translate}}\" clear-text=\"{{::'clear' | translate}}\"\n                                   ng-focus=\"openedEndDate=true; openedStartDate=false;\"\n                                   current-text=\"{{::'today' | translate}}\"\n                                   readonly class=\"form-control\" name=\"endDate\" required/>\n                            <div class=\"input-group-btn\">\n                                <button type=\"button\"\n                                        ng-click=\"$event.preventDefault(); $event.stopPropagation(); openedEndDate=true; openedStartDate=false\"\n                                        class=\"btn btn-default btn-icon24 flexVerticalAlignParent\">\n                                    <span class=\"icon-calendar icon24\"></span>\n                                </button>\n                            </div>\n                        </div>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.endDateRequired\"\n                              translate=\"field_is_required\"></span>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.endDateGreaterStartDate\"\n                              translate=\"end_date_error\"></span>\n                    </div>\n                </div>\n                <div>\n                    <label class=\"font-normal fw-500 fs-14 lh16 ls-031 color-black6\" translate=\"voucher_code\"></label>\n                    <div class=\"posRel\">\n                        <input type=\"text\" class=\"form-control height40 width464\" ng-model=\"ctrl.model.VoucherCode\" translate\n                               translate-attr-placeholder=\"voucher_code_example\" name=\"code\" ng-readonly=\"ctrl.waiting\"\n                               required>\n                        <span class=\"text-danger\" ng-show=\"ctrl.voucherErrors.codeRequired\"\n                              translate=\"field_is_required\"></span>\n                        <span class=\"text-danger\"\n                              ng-show=\"ctrl.voucherErrors.codeMinLengthError\">{{:: 'min_text_length_error' | translate: {count: 3}\n                            }}</span>\n                        <span class=\"text-danger\"\n                              ng-show=\"ctrl.voucherErrors.codeMaxLengthError\">{{:: 'max_text_length_error' | translate: {count: 20}\n                            }}</span>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    <!-- Excluded categories-->\n    <div class=\"panel panel-edit br4 mb24\">\n        <div class=\"panel-heading flexVerticalAlignParent border-bottom-gray pl16 pt12 pb12\">\n            <div class=\"fs-18 lh24 fw-500 color-black87\" translate=\"excluded_categories\"></div>\n        </div>\n        <div class=\"panel-body pt16 pl16 pb24 d-flex flex-column\">\n            <p class=\"fs-12 lh16 ls-031 color-black6 mb16\" translate=\"categories_not_eligible\"></p>\n            <div class=\"d-flex align-items-start\">\n                <div\n                    class=\"flex-stretch pt12 pb12 pl12 pr12 min-h37 top-panel-select--bordered bg-f7f7f7 fs-14 lh16 ls-0146 color-black38 mr16\">\n                    {{ctrl.getExcludedCategoriesNames()}}\n                </div>\n                <button type=\"button\"\n                        class=\"btn btnWhitePurple br4 width120 h40\"\n                        ng-click=\"ctrl.selectCategories()\">\n                    <span translate=\"edit\" class=\"fs-14 lh16 ls-0146\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <!-- Buttons -->\n    <div class=\"d-flex justify-content-end\">\n        <button type=\"submit\"\n                ng-disabled=\"ctrl.waiting || voucherForm.$pristine ||!ctrl.isFormFilled()\"\n                ng-click=\"ctrl.validateBeforeSave()\"\n                class=\"btn btn-success height40 btn-with-icon mr8\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\"></span>\n        </button>\n        <button type=\"button\"\n                ui-sref=\"app.vouchers.list\"\n                class=\"btn btn-danger height40 btn-with-icon\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"discard\"></span>\n        </button>\n    </div>\n\n</div>\n";

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header bb\">\n    <button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"close\" ng-click=\"ctrl.close()\">\n        <span class=\"close-icon inline-block\"></span>\n    </button>\n    <h4 class=\"fs-20 lh24 fw-400 ls-0146 color-black87 m0\" translate=\"edit_excluded_categories\"></h4>\n</div>\n\n<!--Body-->\n<div class=\"modal-body--redesign d-flex \" ng-form name=\"voucherForm\" role=\"form\">\n    <div class=\"d-flex flex-column flex-stretch mr16 pt20 pb8\"\n         ng-repeat=\"column in ctrl.columns\">\n        <div ng-repeat=\"item in column\"\n             class=\"checkbox c-checkbox pl10 m0\">\n            <label class=\"flexVerticalAlignParent mb20\">\n                <input type=\"checkbox\"\n                       ng-click=\"ctrl.setSelected(item.ID, !ctrl.categorySelected(item.ID))\"\n                       ng-disabled=\"ctrl.categoryDisabled(item.ID)\"\n                       ng-checked=\"ctrl.categorySelected(item.ID)\">\n                <span class=\"fa mr15 fa-check\"></span>\n                <div ng-bind=\"item.Name\" class=\"fs-14 lh16 ls-0146\"></div>\n            </label>\n        </div>\n    </div>\n</div>\n\n<!--Footer-->\n<div class=\"modal-footer--redesign gray-footer flexVerticalAlignParent\">\n    <div class=\"ml-auto\">\n\n        <button type=\"button\" ng-click=\"ctrl.close()\" class=\"btn btn-with-icon btn-in-popup-footer height40 width102 mr8\">\n            <em class=\"fa fa-close\"></em>\n            <span translate=\"cancel\" class=\"fs-14 fw-500 lh16 color-black6\"></span>\n        </button>\n        <button type=\"submit\" ng-click=\"ctrl.save()\"\n                class=\"btn btn-success height40 btn-with-icon width88\">\n            <em class=\"fa fa-check\"></em>\n            <span translate=\"save\" class=\"fs-14 fw-500 lh16\"></span>\n        </button>\n    </div>\n</div>\n";

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pr12 pl12 pb24\">\n    <div class=\"mb16 flexVerticalAlignParent justify-content-between\">\n        <span class=\"fs-20 fw-500\" translate=\"vouchers\"></span>\n        <button ui-sref=\"app.vouchers.new\" class=\"btn btn-success add-btn height40 width160\">\n            <span class=\"plus-icon icon24 mr8\"></span>\n            <span class=\"fw-500 fs-14 lh16 ls-031\" translate=\"create_voucher\"></span>\n        </button>\n    </div>\n    <div ng-if=\"ctrl.total !== 0\" class=\"panel panel-info mb16\" ng-repeat=\"voucher in ctrl.vouchersList\"\n        ng-infinite-scroll load-more=\"ctrl.loadData()\">\n        <div class=\"panel-body vouchers pt16 pl16 pb16 pr90\">\n            <h4 class=\"fw-500 fs-18 lh21 mb6 mt0\" ng-class=\"{ expired_text: voucher.IsExpired }\">{{voucher.VoucherCode}}\n            </h4>\n            <p class=\"vouchers-text fs-14 lh16 mb19\" ng-class=\"{ expired_text: voucher.IsExpired }\">\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.FixedAmount\">\n                    {{voucher.DiscountValue | formatCurrency:ctrl.countryID}}\n                    <span translate=\"{{voucher.MinOrderPrice ? 'voucher_for_orders_over' : 'vouchers_for_orders'}}\"></span>\n                    <span ng-if=\"voucher.MinOrderPrice\">{{voucher.MinOrderPrice | formatCurrency:ctrl.countryID}}</span>\n                    <span translate=\"vouchers_until\"></span>\n                    {{voucher.EndDate | date:ctrl.dateFormat:'utc'}}\n                </span>\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.FreeDelivery\">\n                    <span translate=\"vouchers_free_delivery\"></span>\n                    <span\n                        translate=\"{{voucher.MinOrderPrice ? 'vouchers_free_delivery_for_orders_over' : 'vouchers_free_delivery_for_orders'}}\"></span>\n                    <span ng-if=\"voucher.MinOrderPrice\">{{voucher.MinOrderPrice | formatCurrency:ctrl.countryID}}</span>\n                    <span translate=\"vouchers_until\"></span>\n                    {{voucher.EndDate | date:ctrl.dateFormat:'utc'}}\n                </span>\n                </span>\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.Percent\">\n                    {{(voucher.DiscountValue * 100).toFixed()}}%\n                    <span translate=\"{{voucher.MinOrderPrice ? 'voucher_for_orders_over' : 'vouchers_for_orders'}}\"></span>\n                    <span ng-if=\"voucher.MinOrderPrice\">{{voucher.MinOrderPrice | formatCurrency:ctrl.countryID}}</span>\n                    <span translate=\"vouchers_until\"></span>\n                    {{voucher.EndDate | date:ctrl.dateFormat:'utc'}}\n                </span>\n            </p>\n            <p class=\"vouchers-hint fs-12 lh14 mb6\" ng-class=\"{ expired_text: voucher.IsExpired }\">\n                <span translate=\"voucher_type\"></span>\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.FixedAmount\"\n                    translate=\"voucher_order_discount\"></span>\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.FreeDelivery\"\n                    translate=\"voucher_delivery\"></span>\n                <span ng-if=\"voucher.VoucherType === ctrl.voucherTypesEnum.Percent\"\n                    translate=\"voucher_percent_discount\"></span>\n            </p>\n            <p class=\"vouchers-hint fs-12 lh14 mb0\" ng-class=\"{ 'text-danger': voucher.IsExpired }\">\n                <span translate=\"voucher_start\"></span> {{voucher.StartDate | date:ctrl.dateFormat:'utc'}}, <span\n                    translate=\"voucher_end\"></span> {{voucher.EndDate | date:ctrl.dateFormat:'utc'}}</p>\n            <p class=\"vouchers-hint fs-12 lh16 mb0 pt6\" ng-if=\"voucher.RestrictedCategoriesIDs && voucher.RestrictedCategoriesIDs.length > 0\">\n                <span translate=\"excluded_categories\"></span>: {{ctrl.getExcludedCategoriesNames(voucher)}}\n            </p>\n            <div ng-if=\"voucher.Status === ctrl.voucherStatusEnum.Draft || ctrl.isAdmin\" class=\"flexVerticalAlignParent\"\n                ng-class=\"{ 'justify-content-end': voucher.Status === ctrl.voucherStatusEnum.Published,\n                'justify-content-between pt19': voucher.Status === ctrl.voucherStatusEnum.Draft}\">\n                <button ng-if=\"voucher.Status === ctrl.voucherStatusEnum.Draft\"\n                    ng-click=\"ctrl.publishVoucherConfirm(voucher)\" class=\"btn-gradient pr12 pl12 h40 ls-031 width80\"\n                    translate=\"voucher_publish\"></button>\n                <div class=\"flexVerticalAlignParent vouchers-controls\">\n                    <button ui-sref=\"app.vouchers.edit({id:voucher.VoucherID})\" class=\"btn btn-link vouchers-btn\">\n                        <span class=\"fa edit-icon icon24\"></span>\n                    </button>\n                    <button ng-click=\"ctrl.deleteVoucherConfirm(voucher)\" class=\"btn btn-link vouchers-btn\">\n                        <span class=\"fa icon-trashcan-outline icon24\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <empty-list-state ng-if=\"ctrl.total === 0 && !ctrl.waiting\"\n        title-message=\"'vouchers_empty_screen_title' | translate\" message=\"'vouchers_empty_screen_content' | translate\"\n        class=\"absolute-center-flex empty-vouchers-state\" fill-element>\n    </empty-list-state>\n</div>\n";

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "<div class=\"warnings\">\n    <ul class=\"warnings__list\">\n        <li class=\"warnings__item\">All warnings <span class=\"warnings__number\">&nbsp;8</span></li>\n        <li class=\"warnings__item\">Campaigns <span class=\"warnings__number\">&nbsp;2</span></li>\n        <li class=\"warnings__item\">Stores <span class=\"warnings__number\">&nbsp;1</span></li>\n        <li class=\"warnings__item\">jispGO <span class=\"warnings__number\">&nbsp;3</span></li>\n        <li class=\"warnings__item\">Stickers <span class=\"warnings__number\">&nbsp;</span></li>\n    </ul>\n    <div class=\"warnings__cards\">\n        <ul class=\"warnings__cards-list\">\n            <li class=\"warnings__cards-item\">\n                <span class=\"warnings__cards-icon--tapgo\"></span>\n                <div class=\"warnings__cards-text\">\n                    <span class=\"warnings__cards-text--big\">Price not matching</span>\n                    <span class=\"warnings__cards-text--small\">Deep Red Women’s Tonnerro: £250 - £320</span>\n                </div>\n                <span class=\"warnings__cards-time\">2 hours ago</span>\n            </li>\n            <li class=\"warnings__cards-item\">\n                <span class=\"warnings__cards-icon--campaigns\"></span>\n                <div class=\"warnings__cards-text\">\n                    <span class=\"warnings__cards-text--big\">The “GET 3 FOR 2” campaign ends in 2 days</span>\n                    <span class=\"warnings__cards-text--small\">Hammerschmidt Shop</span>\n                </div>\n                <span class=\"warnings__cards-time\">4 hours ago</span>\n            </li>\n            <li class=\"warnings__cards-item\">\n                <span class=\"warnings__cards-icon--stores\"></span>\n                <div class=\"warnings__cards-text\">\n                    <span class=\"warnings__cards-text--big\">Store has no campaign</span>\n                    <span class=\"warnings__cards-text--small\">Hobbycraft</span>\n                </div>\n                <span class=\"warnings__cards-time\">2 days ago</span>\n            </li>\n            <li class=\"warnings__cards-item\">\n                <span class=\"warnings__cards-icon--campaigns\"></span>\n                <div class=\"warnings__cards-text\">\n                    <span class=\"warnings__cards-text--big\">The “Free bottle” campaign ends in 7 days</span>\n                    <span class=\"warnings__cards-text--small\">Angel Central</span>\n                </div>\n                <span class=\"warnings__cards-time\">3 days ago</span>\n            </li>\n        </ul>\n    </div>\n    <div class=\"soon-overlay\">\n        <div class=\"soon-overlay__inner text-center\">\n            <div class=\"soon-overlay__icon\">\n                <div class=\"soon-overlay__icon-inner\">\n                    <span class=\"soon-overlay-icon inline-block\"></span>\n            </div>\n        </div>\n        <div class=\"soon-overlay__text\">\n            Coming soon\n        </div>\n    </div>\n</div>\n</div>\n";

/***/ }),
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var AccountService = /** @class */ (function () {
    function AccountService($rootScope, // TODO
        $localStorage, http, retailerService, $timeout, $window, $translate) {
        this.$rootScope = $rootScope;
        this.$localStorage = $localStorage;
        this.http = http;
        this.retailerService = retailerService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$translate = $translate;
        this.userData = {
            id: null,
            isAuth: false,
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: {
                PhoneNumber: null,
                CountryPhoneCodeID: null
            },
            whatsAppNumber: {
                PhoneNumber: null,
                CountryPhoneCodeID: null
            },
            retailerStatus: null,
            showGetStarted: null,
            permission: null,
            viewedPrivacyNotification: null,
            currencyID: null,
            currencySign: null,
            countryID: null,
            countryName: null,
            languageID: null,
            retailerType: null,
            isEmpty: function () {
                return this.email === null || this.firstName === null || this.showGetStarted === undefined;
            },
            cleanUp: function () {
                this.isAuth = false;
                this.firstName = '';
                this.lastName = '';
                this.email = '';
                this.phone = '';
                this.retailerStatus = null;
                this.showGetStarted = null;
                this.permission = null;
                this.id = null;
                this.viewedPrivacyNotification = null;
                this.currencyID = null;
                this.currencySign = null;
                this.countryID = null;
                this.countryName = null;
                this.languageID = null;
            }
        };
        this.homePage = '/business';
        this.loginPageState = 'account.login';
    }
    AccountService.prototype.logOut = function (redirectToHomepage) {
        var _this = this;
        this.clearAuthData();
        this.$rootScope.$broadcast('LogOut');
        if (redirectToHomepage) {
            this.$timeout(function () {
                _this.$window.location.href = _this.homePage;
            }, 100);
        }
        else {
            this.$rootScope.$state.go(this.loginPageState);
        }
    };
    AccountService.prototype.clearAuthData = function () {
        delete this.$localStorage.retailerAuthorizationData;
        delete this.$localStorage.recentlyUsedClassificationCategories;
        this.userData.cleanUp();
    };
    AccountService.prototype.logIn = function (loginData) {
        var _this = this;
        var params = '';
        if (loginData.adminLogin) {
            params = "grant_type=admin_token&email=" + encodeURIComponent(loginData.userName) + "&token=" + encodeURIComponent(this.$localStorage.adminAuthorizationData.token);
        }
        else {
            params = "grant_type=password&username=" + encodeURIComponent(loginData.userName) + "&password=" + encodeURIComponent(loginData.password);
        }
        return this.http.post(this.retailerService.auth(), params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
            .then(function (response) {
            if (response === 'cancel') {
                return null;
            }
            _this.$localStorage.retailerAuthorizationData = { token: response.access_token };
            _this.$localStorage.recentlyUsedClassificationCategories = [];
            _this.userData.isAuth = true;
            _this.$rootScope.$broadcast('Login');
            return response;
        });
    };
    AccountService.prototype.isLoggedInAsAdmin = function () {
        return this.http.get(this.retailerService.loggedInAsAdmin());
    };
    AccountService.prototype.getProfile = function () {
        var _this = this;
        return this.http.get(this.retailerService.profile()).then(function (profile) {
            _this.$localStorage.retailerAuthorizationData = {
                token: _this.$localStorage.retailerAuthorizationData.token,
                id: profile.ID,
                firstName: profile.FirstName,
                lastName: profile.LastName,
                permission: profile.Permission,
                countryID: profile.CountryID
            };
            _this.$localStorage.BusinessUnionType = profile.BusinessUnionType;
            _this.userData.id = profile.ID;
            _this.userData.firstName = profile.FirstName;
            _this.userData.lastName = profile.LastName;
            _this.userData.retailerStatus = profile.RetailerStatus;
            _this.userData.email = profile.Email;
            _this.userData.phoneNumber = profile.PhoneNumber;
            _this.userData.whatsAppNumber = profile.WhatsAppNumber;
            _this.userData.isAuth = true;
            _this.userData.showGetStarted = profile.ShowGetStarted;
            _this.userData.permission = profile.Permission;
            _this.userData.viewedPrivacyNotification = profile.ViewedPrivacyNotification;
            _this.userData.currencySign = profile.CurrencySign;
            _this.userData.currencyID = profile.CurrencyID;
            _this.userData.countryID = profile.CountryID;
            _this.userData.countryName = profile.CountryName;
            _this.userData.languageID = profile.LanguageID;
            _this.userData.retailerType = profile.RetailerType;
            if (profile.LanguageID) {
                _this.setLocalization(profile.LanguageID);
            }
            return profile;
        });
    };
    AccountService.prototype.setLocalization = function (languageID) {
        var _this = this;
        this.getLanguages()
            .then(function (languages) {
            var userLanguage = languages.find(function (x) { return x.ID === languageID; });
            _this.$translate.use(userLanguage.IsoCode)["catch"](function () { return console.log('invalid language code'); });
        })["catch"](function (e) { return console.log(e); });
    };
    AccountService.prototype.getLanguages = function () {
        return this.http.get(this.retailerService.languages());
    };
    AccountService.prototype.updateProfile = function (profile) {
        var _this = this;
        return this.http.put(this.retailerService.profile(), profile).then(function () {
            _this.$localStorage.retailerAuthorizationData = {
                id: profile.ID,
                token: _this.$localStorage.retailerAuthorizationData.token,
                firstName: profile.FirstName,
                lastName: profile.LastName,
                permission: profile.Permission,
                countryID: profile.CountryID
            };
            _this.userData.firstName = profile.FirstName;
            _this.userData.lastName = profile.LastName;
            _this.userData.languageID = profile.LanguageID;
        });
    };
    AccountService.prototype.updateViewedPrivacyNotification = function () {
        return this.http.get(this.retailerService.viewedPrivacyNotification());
    };
    AccountService.prototype.getEmail = function () {
        return this.http.get(this.retailerService.profileEmail());
    };
    AccountService.prototype.updateEmail = function (model) {
        return this.http.put(this.retailerService.profileEmail(), model);
    };
    AccountService.prototype.forgotPassword = function (model) {
        return this.http.post(this.retailerService.forgotPassword(), model);
    };
    AccountService.prototype.resetPassword = function (model) {
        return this.http.post(this.retailerService.resetPassword(), model);
    };
    AccountService.prototype.updatePassword = function (model) {
        return this.http.put(this.retailerService.profilePassword(), model);
    };
    AccountService.prototype.updateRetailerToken = function (tokenData) {
        this.$localStorage.retailerAuthorizationData = { token: tokenData };
        this.$localStorage.recentlyUsedClassificationCategories = [];
        this.userData.isAuth = true;
    };
    AccountService.prototype.fillAuthData = function () {
        var authData = this.$localStorage.retailerAuthorizationData;
        if (angular.isDefined(authData)) {
            this.userData.isAuth = true;
        }
    };
    AccountService.prototype.isRetailerTokenPresents = function () {
        var authData = this.$localStorage.retailerAuthorizationData;
        return angular.isDefined(authData);
    };
    AccountService.prototype.getRetailerToken = function () {
        return this.$localStorage.retailerAuthorizationData.token;
    };
    AccountService.prototype.addProfileImage = function () {
        return this.retailerService.setProfileImage();
    };
    AccountService.prototype.getProfileImage = function (imageId, width, height) {
        return this.retailerService.getProfileImage(imageId, width, height);
    };
    AccountService.prototype.deleteProfileImage = function (imageId) {
        return this.http["delete"](this.retailerService.deleteProfileImage(imageId));
    };
    AccountService.$inject = ['$rootScope', '$localStorage', 'http', 'retailerService', '$timeout', '$window', '$translate'];
    return AccountService;
}());
exports.AccountService = AccountService;
angular.module('naut').service('accountService', AccountService);


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ForgotPasswordController = /** @class */ (function () {
    function ForgotPasswordController(accountService, notificationService, definitionsService, $translate, $state) {
        var _this = this;
        this.accountService = accountService;
        this.notificationService = notificationService;
        this.definitionsService = definitionsService;
        this.$translate = $translate;
        this.$state = $state;
        this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var model, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (this.forgotPasswordForm.$invalid) {
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        model = { Email: this.email };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.accountService.forgotPassword(model)];
                    case 2:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.$state.go('account.resetSuccess');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.email = null;
        this.waiting = false;
        this.submitted = false;
        this.emailPattern = definitionsService.regexEmail;
    }
    ForgotPasswordController.$inject = ['accountService', 'notificationService', 'definitionsService', '$translate', '$state'];
    return ForgotPasswordController;
}());
exports.ForgotPasswordController = ForgotPasswordController;
angular.module('naut')
    .component('forgotPassword', {
    template: __webpack_require__(700),
    controller: ForgotPasswordController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var LoginController = /** @class */ (function () {
    function LoginController($state, accountService, jispPayAccountService, $timeout, notificationService, $translate, $q, $stateParams) {
        this.$state = $state;
        this.accountService = accountService;
        this.jispPayAccountService = jispPayAccountService;
        this.$timeout = $timeout;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.email = null;
        this.password = null;
        this.waiting = false;
        this.submitted = false;
        this.sellerLogged = true;
        this.retailerLogged = true;
        this.isAccountBlocked = false;
    }
    LoginController.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var p1, _a, _b, p2, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.submitted = true;
                        this.checkForAutoFilledValues();
                        if (this.loginForm.$invalid) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        this.sellerLogged = true;
                        this.retailerLogged = true;
                        _b = (_a = Promise).resolve;
                        return [4 /*yield*/, this.loginRetailer()];
                    case 1:
                        p1 = _b.apply(_a, [_e.sent()]);
                        _d = (_c = Promise).resolve;
                        return [4 /*yield*/, this.loginSeller()];
                    case 2:
                        p2 = _d.apply(_c, [_e.sent()]);
                        Promise.all([p1, p2])["catch"](function (err) { return console.log('Catch', err); })
                            .then(function () {
                            if (_this.retailerLogged) {
                                _this.jispPayAccountService.reset();
                                _this.$timeout(function () {
                                    /*                         if (this.$stateParams.url) {
                                                                window.open(this.$stateParams.url, '_self');
                                                            } else {
                                                                this.$state.go('home.screen');
                                                            } */
                                    _this.$state.go('home.screen');
                                }, 1500);
                                return;
                            }
                            if (_this.sellerLogged) {
                                /*                     if (this.$stateParams.url) {
                                                        window.open(this.$stateParams.url, '_self');
                                                    } else {
                                                        this.jispPayAccountService.navigateToDefault();
                                                    } */
                                var referer = document.referrer;
                                if (referer && referer.match('/jisppay/deliveryDetails')) {
                                    location.href = document.referrer;
                                }
                                else {
                                    _this.jispPayAccountService.navigateToDefault();
                                }
                                return;
                            }
                            if (!_this.retailerLogged && !_this.sellerLogged) {
                                angular.element('input[name="email"]').removeClass('ng-valid');
                                angular.element('input[name="email"]').addClass('ng-invalid');
                                angular.element('input[name="password"]').removeClass('ng-valid');
                                angular.element('input[name="password"]').addClass('ng-invalid');
                                _this.$timeout(function () {
                                    angular.element('input[name="email"]').removeClass('ng-invalid');
                                    angular.element('input[name="password"]').removeClass('ng-invalid');
                                }, 3000);
                                _this.notificationService.showErrorMessage(_this.loginError);
                                _this.waiting = false;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginController.prototype.loginRetailer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var model, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        model = { adminLogin: false, userName: this.email, password: this.password };
                        return [4 /*yield*/, this.accountService.logIn(model)];
                    case 1:
                        response = _a.sent();
                        if (response == null) {
                            this.retailerLogged = false;
                            return [2 /*return*/, false];
                        }
                        this.showSuccessLoggedInMessage();
                        return [4 /*yield*/, this.accountService.fillAuthData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        error_1 = _a.sent();
                        this.loginError = error_1;
                        this.retailerLogged = false;
                        this.isAccountBlocked = false;
                        if (error_1.error === 'account_blocked') {
                            this.isAccountBlocked = true;
                            this.loginError = error_1.error_description;
                        }
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginController.prototype.loginSeller = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, stores, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 9, , 10]);
                        return [4 /*yield*/, this.jispPayAccountService.logIn({
                                email: this.email,
                                password: this.password
                            })];
                    case 1:
                        response = _b.sent();
                        if (response == null) {
                            this.sellerLogged = false;
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.jispPayAccountService.getStores()];
                    case 2:
                        stores = _b.sent();
                        _a = stores.length;
                        switch (_a) {
                            case 0: return [3 /*break*/, 3];
                            case 1: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        this.jispPayAccountService.reset();
                        throw this.$translate.instant('no_permissions_to_any_store');
                    case 4: return [4 /*yield*/, this.jispPayAccountService.storeLogIn(stores[0].ID)];
                    case 5:
                        _b.sent();
                        this.showSuccessLoggedInMessage();
                        return [4 /*yield*/, this.$timeout(1500)];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        this.notificationService.clearAll();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, true];
                    case 9:
                        error_2 = _b.sent();
                        if (!this.isAccountBlocked) {
                            this.loginError = error_2;
                        }
                        this.sellerLogged = false;
                        this.isAccountBlocked = false;
                        return [2 /*return*/, false];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    LoginController.prototype.checkForAutoFilledValues = function () {
        var inputEmail = document.getElementsByName('email')[0].value;
        var inputPassword = document.getElementsByName('password')[0].value;
        if (this.loginForm.$pristine && inputEmail && inputEmail.length > 0 && inputPassword && inputPassword.length > 0) {
            this.setAutoFilledValues(this.loginForm);
        }
    };
    LoginController.prototype.setAutoFilledValues = function (form) {
        angular.forEach(form, function (control, name) {
            if (typeof name === 'string' && name.charAt(0) !== '$') {
                var value = document.getElementsByName(name)[0].value;
                control.$setViewValue(value);
                control.$validate();
            }
        });
    };
    LoginController.prototype.showSuccessLoggedInMessage = function () {
        this.notificationService.showSuccessMessage({
            title: this.$translate.instant('welcome'),
            body: this.$translate.instant('welcome_logged_in'),
            timeout: 3000
        });
    };
    LoginController.$inject = ['$state', 'accountService', 'jispPayAccountService', '$timeout', 'notificationService', '$translate', '$q', '$stateParams'];
    return LoginController;
}());
exports.LoginController = LoginController;
angular.module('naut')
    .component('login', {
    template: __webpack_require__(701),
    controller: LoginController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ChangeRetailerEmail = /** @class */ (function () {
    function ChangeRetailerEmail(notificationService, popupService, accountService, definitionsService) {
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.accountService = accountService;
        this.definitionsService = definitionsService;
        this.currentEmail = null;
        this.confirmEmail = null;
        this.confirmPassword = null;
        this.changeEmail = {
            Email: null,
            Password: null
        };
        this.emailPattern = this.definitionsService.regexEmail;
        this.modalInstance = this;
    }
    ChangeRetailerEmail.prototype.$onDestroy = function () {
        this.confirmEmail = null;
        this.changeEmail = null;
    };
    ChangeRetailerEmail.prototype.changeEmailModel = function () {
        this.changeEmailForm.confirmEmail.$setValidity('match', this.changeEmail.Email === this.confirmEmail);
    };
    ChangeRetailerEmail.prototype.closeDialog = function () {
        this.modalInstance.close();
    };
    ChangeRetailerEmail.prototype.updateEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.changeEmailForm.$dirty && this.changeEmailForm.$invalid) {
                            this.changeEmailForm.$setPristine();
                            return [2 /*return*/];
                        }
                        else if (this.changeEmailForm.$dirty && this.changeEmailForm.$invalid) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.accountService.updateEmail(this.changeEmail)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close({ $value: this.changeEmail.Email });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeRetailerEmail.$inject = ['notificationService', 'popupService', 'accountService', 'definitionsService'];
    return ChangeRetailerEmail;
}());
angular.module('naut').component('changeRetailerEmail', {
    template: __webpack_require__(702),
    controller: ChangeRetailerEmail,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ChangeRetailerPassword = /** @class */ (function () {
    function ChangeRetailerPassword(notificationService, accountService) {
        this.notificationService = notificationService;
        this.accountService = accountService;
        this.waiting = false;
        this.confirmPassword = null;
        this.changePassword = {
            Password: null,
            NewPassword: null
        };
        this.modalInstance = this;
    }
    ChangeRetailerPassword.prototype.$onDestroy = function () {
        this.confirmPassword = null;
        this.changePassword = null;
        this.changePasswordForm = null;
    };
    ChangeRetailerPassword.prototype.closeDialog = function () {
        this.modalInstance.close();
    };
    ChangeRetailerPassword.prototype.changePasswordModel = function () {
        this.changePasswordForm.confirmPassword.$setValidity('match', this.changePassword.NewPassword === this.confirmPassword);
    };
    ChangeRetailerPassword.prototype.submitChangePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.changePasswordForm.$dirty && this.changePasswordForm.$invalid) {
                            this.changePasswordForm.$setPristine();
                            return [2 /*return*/];
                        }
                        else if (this.changePasswordForm.$dirty && this.changePasswordForm.$invalid) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.accountService.updatePassword(this.changePassword)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ChangeRetailerPassword.$inject = ['notificationService', 'accountService'];
    return ChangeRetailerPassword;
}());
angular.module('naut').component('changeRetailerPassword', {
    template: __webpack_require__(703),
    controller: ChangeRetailerPassword,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '=',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ProfileController = /** @class */ (function () {
    function ProfileController(blobService, definitionsService, enumService, accountService, notificationService, jispPayService, $uibModal, $translate) {
        this.blobService = blobService;
        this.definitionsService = definitionsService;
        this.enumService = enumService;
        this.accountService = accountService;
        this.notificationService = notificationService;
        this.jispPayService = jispPayService;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.permissionType = this.enumService.RetailerPermission;
        this.waiting = false;
        this.profileLoaded = false;
        this.profile = {
            ID: null,
            FirstName: null,
            LastName: null,
            CompanyName: null,
            phone: null,
            PhoneNumber: {
                PhoneNumber: null,
                CountryPhoneCodeID: null
            },
            WhatsAppNumber: {
                PhoneNumber: null,
                CountryPhoneCodeID: null
            },
            Email: null,
            CountryID: null,
            CurrencySign: null,
            CurrencyID: null,
            LanguageID: null,
            LogoID: null,
            Story: null,
            LoyaltyProgramEnabled: false
        };
        this.languages = [];
        this.selectedLanguage = null;
        this.selectedBusinessType = null;
        this.minSize = {
            w: 500,
            h: 500
        };
        this.thumbSize = {
            w: 152,
            h: 152
        };
    }
    ProfileController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b, _c, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        _a = this;
                        return [4 /*yield*/, this.accountService.getProfile()];
                    case 2:
                        _a.profile = _d.sent();
                        if (this.profile.PhoneNumber) {
                            this.phoneNumberControl = this.profile.PhoneNumber.PhoneNumberWithoutCode;
                        }
                        this.whatsAppNumberControl = this.profile.WhatsAppNumber ?
                            this.profile.WhatsAppNumber.PhoneNumberWithoutCode
                            : null;
                        _b = this;
                        return [4 /*yield*/, this.accountService.getLanguages()];
                    case 3:
                        _b.languages = _d.sent();
                        this.selectedLanguage = this.languages.find(function (language) { return language.ID === _this.profile.LanguageID; });
                        this.profileLoaded = true;
                        this.notificationService.clearAll();
                        _c = this;
                        return [4 /*yield*/, this.getImage()];
                    case 4:
                        _c.profileImage = _d.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _d.sent();
                        console.log(error_1);
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProfileController.prototype.setLoyaltyProgram = function (currentValue) {
        this.profile.LoyaltyProgramEnabled = !currentValue;
    };
    ProfileController.prototype.deleteProfileImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.profileImage = null;
                this.profileForm.$setDirty();
                return [2 /*return*/];
            });
        });
    };
    ProfileController.prototype.openChangePasswordDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'changeRetailerPassword',
                                resolve: {},
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileController.prototype.openChangeEmailDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newEmail, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'changeRetailerEmail',
                                resolve: {},
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 1:
                        newEmail = _a.sent();
                        if (newEmail) {
                            this.profile.Email = newEmail;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileController.prototype.updateProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logoID, tempProfile, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        this.profile.LanguageID = this.selectedLanguage.ID;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, 9, 10]);
                        if (!(this.profile && this.profile.LogoID)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.accountService.deleteProfileImage(this.profile.LogoID.toString())];
                    case 2:
                        _b.sent();
                        this.profile.LogoID = null;
                        _b.label = 3;
                    case 3:
                        if (!this.profileImage) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.jispPayService.uploadImage({ dataUri: this.profileImage }, this.accountService.addProfileImage())];
                    case 4:
                        logoID = _b.sent();
                        if (logoID) {
                            this.profile.LogoID = logoID;
                        }
                        _b.label = 5;
                    case 5:
                        tempProfile = __assign({}, this.profile, { PhoneNumber: {
                                CountryPhoneCodeID: this.profile.PhoneNumber.CountryPhoneCodeID,
                                PhoneNumber: this.profile.PhoneNumber.PhoneNumberWithoutCode
                            }, WhatsAppNumber: this.profile.WhatsAppNumber.PhoneNumberWithoutCode ? {
                                CountryPhoneCodeID: this.profile.WhatsAppNumber.CountryPhoneCodeID,
                                PhoneNumber: this.profile.WhatsAppNumber.PhoneNumberWithoutCode
                            } : null });
                        return [4 /*yield*/, this.accountService.updateProfile(tempProfile)];
                    case 6:
                        _b.sent();
                        this.notificationService.showSuccessMessage();
                        this.accountService.getProfile();
                        _a = this;
                        return [4 /*yield*/, this.getImage()];
                    case 7:
                        _a.profileImage = _b.sent();
                        this.profileForm.$setPristine();
                        return [3 /*break*/, 10];
                    case 8:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 10];
                    case 9:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    ProfileController.prototype.addImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var image, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return _this.profile.LogoID; },
                                    title: function () { return _this.$translate.instant('profile_photo'); },
                                    sizeText: function () {
                                        return _this.$translate.instant('profile_photo_min_size_hint');
                                    },
                                    getUrl: function () {
                                        return _this.profile.LogoID === null ||
                                            _this.getImage();
                                    },
                                    imageSize: function () { return _this.minSize; }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        image = _a.sent();
                        if (image) {
                            this.profileImage = image;
                            this.profileForm.$setDirty();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProfileController.prototype.getImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentImage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.profile.LogoID) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.blobService.getDataImageByUrl(this.accountService.getProfileImage(this.profile.LogoID))];
                    case 2:
                        currentImage = _a.sent();
                        return [2 /*return*/, currentImage.dataUri];
                    case 3:
                        error_4 = _a.sent();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    ProfileController.$inject = [
        'blobService',
        'definitionsService',
        'enumService',
        'accountService',
        'notificationService',
        'jispPayService',
        '$uibModal',
        '$translate'
    ];
    return ProfileController;
}());
exports.ProfileController = ProfileController;
angular.module('naut').component('profile', {
    template: __webpack_require__(704),
    controller: ProfileController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ReportSupervisorController = /** @class */ (function () {
    function ReportSupervisorController($translate) {
        this.$translate = $translate;
    }
    ReportSupervisorController.$inject = ['$translate'];
    return ReportSupervisorController;
}());
exports.ReportSupervisorController = ReportSupervisorController;
angular.module('naut')
    .component('reportSupervisor', {
    template: __webpack_require__(705),
    controller: ReportSupervisorController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ResetPasswordController = /** @class */ (function () {
    function ResetPasswordController($state, $location, $timeout, accountService, notificationService, $translate, enumService, siteRetailerHomeUrl) {
        var _this = this;
        this.$state = $state;
        this.$location = $location;
        this.$timeout = $timeout;
        this.accountService = accountService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.enumService = enumService;
        this.siteRetailerHomeUrl = siteRetailerHomeUrl;
        this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var model, reset_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (this.resetPasswordForm.$invalid) {
                            this.showErrorForm();
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        model = {
                            ID: this.id,
                            PasswordKey: this.passwordKey,
                            NewPassword: this.password,
                            ConfirmPassword: this.confirmPassword
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.accountService.resetPassword(model)];
                    case 2:
                        reset_1 = _a.sent();
                        this.notificationService.showSuccessMessage({
                            title: this.$translate.instant('password_changed'),
                            body: this.$translate.instant('redirect_to_login_page'),
                            timeout: 3000
                        });
                        this.$timeout(function () {
                            if (reset_1.Permission === _this.enumService.RetailerPermission.Nfrn) {
                                window.open(_this.siteRetailerHomeUrl + "/login", '_self');
                            }
                            else {
                                _this.$state.go('account.login');
                            }
                        }, 3000);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        this.waiting = false;
                        return [2 /*return*/];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.waiting = false;
        this.id = this.$state.params.id;
        this.passwordKey = this.$state.params.key;
        if (this.id === null || this.passwordKey === null) {
            $location.path('/');
        }
    }
    ResetPasswordController.prototype.showErrorForm = function () {
        if (this.resetPasswordForm.password.$error) {
            if (this.resetPasswordForm.password.$error.required) {
                this.errorPassword = this.$translate.instant('password_is_required');
            }
            else if (this.resetPasswordForm.password.$error.maxlength) {
                this.errorPassword = this.$translate.instant('password_must_be_less_20');
            }
            else if (this.resetPasswordForm.password.$error.minlength) {
                this.errorPassword = this.$translate.instant('password_must_be_atleast_8');
            }
            else {
                this.errorPassword = this.$translate.instant('password_isnt_valid');
            }
            if (this.resetPasswordForm.confirmPassword.$error) {
                if (this.resetPasswordForm.confirmPassword.$error.match) {
                    this.errorConfirmPassword = this.$translate.instant('passwords_dont_match');
                }
                else if (this.resetPasswordForm.confirmPassword.$error.required) {
                    this.errorConfirmPassword = this.$translate.instant('type_confirmation_password');
                }
                else {
                    this.errorConfirmPassword = this.$translate.instant('password_isnt_valid');
                }
            }
        }
    };
    ResetPasswordController.$inject = ['$state', '$location', '$timeout', 'accountService', 'notificationService', '$translate', 'enumService', 'siteRetailerHomeUrl'];
    return ResetPasswordController;
}());
exports.ResetPasswordController = ResetPasswordController;
angular.module('naut')
    .component('resetPassword', {
    template: __webpack_require__(706),
    controller: ResetPasswordController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ResetSuccessController = /** @class */ (function () {
    function ResetSuccessController($translate) {
        this.$translate = $translate;
    }
    ResetSuccessController.$inject = ['$translate'];
    return ResetSuccessController;
}());
exports.ResetSuccessController = ResetSuccessController;
angular.module('naut')
    .component('resetSuccess', {
    template: __webpack_require__(707),
    controller: ResetSuccessController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var SelectRoleController = /** @class */ (function () {
    function SelectRoleController(accountService, notificationService, definitionsService, $translate) {
        var _this = this;
        this.accountService = accountService;
        this.notificationService = notificationService;
        this.definitionsService = definitionsService;
        this.$translate = $translate;
        this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var model, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (this.forgotPasswordForm.$invalid) {
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        model = { Email: this.email };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.accountService.forgotPassword(model)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage({
                            title: this.$translate.instant('reset_link_sent'),
                            body: this.$translate.instant('reset_link_hint'),
                            timeout: 8000
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.email = null;
        this.waiting = false;
        this.submitted = false;
        this.emailPattern = definitionsService.regexEmail;
    }
    SelectRoleController.$inject = ['accountService', 'notificationService', 'definitionsService', '$translate'];
    return SelectRoleController;
}());
exports.SelectRoleController = SelectRoleController;
angular.module('naut')
    .component('selectRole', {
    template: __webpack_require__(708),
    controller: SelectRoleController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AuthStatus;
(function (AuthStatus) {
    AuthStatus[AuthStatus["notAuthenticated"] = 0] = "notAuthenticated";
    AuthStatus[AuthStatus["storeNotSelected"] = 1] = "storeNotSelected";
    AuthStatus[AuthStatus["authenticated"] = 2] = "authenticated";
})(AuthStatus = exports.AuthStatus || (exports.AuthStatus = {}));
var RedirectPageSaller;
(function (RedirectPageSaller) {
    RedirectPageSaller[RedirectPageSaller["DELIVERY"] = 1] = "DELIVERY";
})(RedirectPageSaller = exports.RedirectPageSaller || (exports.RedirectPageSaller = {}));
var JispPayAccountService = /** @class */ (function () {
    function JispPayAccountService($rootScope, $localStorage, $httpParamSerializer, http, jispPayService, jispPayServiceUrl, $state) {
        this.$rootScope = $rootScope;
        this.$localStorage = $localStorage;
        this.$httpParamSerializer = $httpParamSerializer;
        this.http = http;
        this.jispPayService = jispPayService;
        this.jispPayServiceUrl = jispPayServiceUrl;
        this.$state = $state;
        this.userData = {
            isAuth: AuthStatus.notAuthenticated
        };
        this.setIsAuth();
    }
    JispPayAccountService.prototype.reset = function () {
        delete this.$localStorage.sellerAuthorizationData;
        this.setIsAuth();
    };
    JispPayAccountService.prototype.logIn = function (loginData) {
        return __awaiter(this, void 0, void 0, function () {
            var params, header, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = "grant_type=sales_assistant_auth&email=" + encodeURIComponent(loginData.email) + "&password=" + encodeURIComponent(loginData.password);
                        header = { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' } };
                        return [4 /*yield*/, this.http.post(this.getAuthUrl(), params, header)];
                    case 1:
                        response = _a.sent();
                        if (response.toString() === 'cancel') {
                            return [2 /*return*/, null];
                        }
                        this.$localStorage.sellerAuthorizationData = {
                            token: response.access_token,
                            type: AuthStatus.storeNotSelected
                        };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    JispPayAccountService.prototype.logInByLoginCode = function (loginCode) {
        return __awaiter(this, void 0, void 0, function () {
            var params, header, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        delete this.$localStorage.sellerAuthorizationData;
                        params = "grant_type=sales_assistant_one_time_login_code_auth&login_code=" + loginCode;
                        header = { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' } };
                        return [4 /*yield*/, this.http.post(this.getAuthUrl(), params, header)];
                    case 1:
                        response = _a.sent();
                        if (response.toString() === 'cancel') {
                            return [2 /*return*/, null];
                        }
                        this.$localStorage.sellerAuthorizationData = {
                            token: response.access_token,
                            type: AuthStatus.authenticated
                        };
                        return [2 /*return*/, response];
                }
            });
        });
    };
    JispPayAccountService.prototype.storeLogIn = function (storeID) {
        return __awaiter(this, void 0, void 0, function () {
            var data, params, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            grant_type: 'sales_assistant_store_auth',
                            store_id: storeID,
                            token: this.$localStorage.sellerAuthorizationData.token
                        };
                        params = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
                        return [4 /*yield*/, this.http.post(this.getAuthUrl(), this.$httpParamSerializer(data), params)];
                    case 1:
                        response = _a.sent();
                        this.$localStorage.sellerAuthorizationData = {
                            token: response.access_token,
                            type: AuthStatus.authenticated
                        };
                        this.setIsAuth();
                        this.$rootScope.$broadcast('Login');
                        return [2 /*return*/];
                }
            });
        });
    };
    JispPayAccountService.prototype.getUserData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setIsAuth();
                return [2 /*return*/, this.userData];
            });
        });
    };
    JispPayAccountService.prototype.getStores = function () {
        return this.http.get(this.getStoresUrl(), { params: 'authKey=sellerAuthorizationData' });
    };
    JispPayAccountService.prototype.getStore = function () {
        return this.http.get(this.jispPayService.store());
    };
    JispPayAccountService.prototype.navigateToDefault = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setIsAuth();
                this.$state.go(this.getDefaultRoute());
                return [2 /*return*/];
            });
        });
    };
    JispPayAccountService.prototype.navigateTo = function (tabId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setIsAuth();
                this.$state.go(this.getDefaultRoute(tabId));
                return [2 /*return*/];
            });
        });
    };
    JispPayAccountService.prototype.isSellerTokenPresents = function () {
        var token = this.$localStorage.sellerAuthorizationData;
        return angular.isDefined(token);
    };
    JispPayAccountService.prototype.getDefaultRoute = function (tabId) {
        switch (this.userData.isAuth) {
            case AuthStatus.notAuthenticated:
                return 'account.login';
            case AuthStatus.authenticated:
                if (tabId) {
                    switch (tabId) {
                        case RedirectPageSaller.DELIVERY:
                            return 'jisppay.delivery';
                        default:
                            return 'jisppay.default';
                    }
                }
                else {
                    return 'jisppay.default';
                }
        }
    };
    JispPayAccountService.prototype.setIsAuth = function () {
        var authData = this.$localStorage.sellerAuthorizationData;
        this.userData.isAuth = authData ? AuthStatus.authenticated : AuthStatus.notAuthenticated;
    };
    JispPayAccountService.prototype.getAuthUrl = function () {
        return this.getUrl('auth/token');
    };
    JispPayAccountService.prototype.getUrl = function (url) {
        return this.jispPayServiceUrl + url;
    };
    JispPayAccountService.prototype.getStoresUrl = function () {
        return this.getUrl('stores');
    };
    JispPayAccountService.$inject = [
        '$rootScope',
        '$localStorage',
        '$httpParamSerializer',
        'http',
        'jispPayService',
        'jispPayServiceUrl',
        '$state'
    ];
    return JispPayAccountService;
}());
exports.JispPayAccountService = JispPayAccountService;
angular.module('naut').service('jispPayAccountService', JispPayAccountService);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
function uniqueEmail($rootScope, http, enumService, retailerService) {
    var _this = this;
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, element, attrs, ctrl) {
            element.on('blur', function () { return __awaiter(_this, void 0, void 0, function () {
                var isManager, isExist, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(!ctrl.$invalid || ctrl.$error.isunique)) return [3 /*break*/, 7];
                            isManager = $rootScope.userData.permission === $rootScope.enums.RetailerPermission.StoreManager;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, , 7]);
                            isExist = void 0;
                            if (!isManager) return [3 /*break*/, 3];
                            return [4 /*yield*/, http.get(retailerService.storeManagerAccountEmailExist(ctrl.$viewValue))];
                        case 2:
                            isExist = _a.sent();
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, http.post(retailerService.emailExist(ctrl.$viewValue), {})];
                        case 4:
                            isExist = _a.sent();
                            _a.label = 5;
                        case 5:
                            ctrl.$setValidity('isunique', !isExist);
                            return [3 /*break*/, 7];
                        case 6:
                            error_1 = _a.sent();
                            console.warn('uniqueEmail error -', error_1);
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
}
uniqueEmail.$inject = ['$rootScope', 'http', 'enumService', 'retailerService'];
angular
    .module('app.common')
    .directive('uniqueEmail', uniqueEmail);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(http, $filter, retailerService, $translate) {
        this.http = http;
        this.$filter = $filter;
        this.retailerService = retailerService;
        this.$translate = $translate;
        this.dateFilter = $filter('serverDate');
    }
    AnalyticsService.prototype.getStoreCampaignAnalytics = function (id, filter) {
        var _this = this;
        return this.http.get(this.retailerService.storeCampaignAnalytics(id), this.getFilter(filter)).then(function (data) { return _this.convertFromAnaliticsData(data); });
    };
    AnalyticsService.prototype.getStoreVisitsAnalytics = function (id, filter) {
        var _this = this;
        return this.http.get(this.retailerService.storeVisitsAnalytics(id), this.getFilter(filter)).then(function (data) { return _this.convertFromAnaliticsData(data); });
    };
    AnalyticsService.prototype.getCampaignAnalytics = function (id, filter) {
        var _this = this;
        return this.http.get(this.retailerService.campaignAnalytics(id), this.getFilter(filter)).then(function (data) { return _this.convertFromAnaliticsData(data); });
    };
    AnalyticsService.prototype.getStoreImpressionAnalytics = function (id, filter) {
        return this.http.get(this.retailerService.storeImpressionAnalytics(id), this.getFilter(filter)).then(this.convertFromListItemsData);
    };
    AnalyticsService.prototype.convertFromAnaliticsData = function (data) {
        var _this = this;
        return _.pairs(data.Summary).map(function (pair) {
            var key = pair[0];
            var total = pair[1];
            var keyTranslate = key.toLowerCase().replace(' ', '_') + "_label";
            var keyLabel = _this.$translate.instant(keyTranslate);
            return {
                total: total,
                label: keyTranslate === keyLabel ? key : keyLabel,
                data: data.Data.map(function (item) {
                    return [new Date(item.Date.toString()).getTime(), item.Values[key]];
                }),
                color: null,
                selected: false
            };
        });
    };
    AnalyticsService.prototype.convertFromListItemsData = function (data) {
        return _.pairs(data[0].Values).map(function (pair) {
            var key = pair[0];
            var total = _.reduce(data, function (subtotal, item) {
                return subtotal + item.Values[key];
            }, 0);
            return {
                total: total,
                label: key,
                data: data.map(function (item) {
                    return [new Date(item.Date.toString()).getTime(), item.Values[key]];
                }),
                color: null,
                selected: false
            };
        });
    };
    AnalyticsService.prototype.getFilter = function (filter) {
        return {
            params: _.object(_.map(filter, function (value, key) {
                if (key === 'startDate' || key === 'endDate') {
                    value = (new Date(value)).toISOString();
                }
                return [key, value];
            }))
        };
    };
    AnalyticsService.$inject = ['http', '$filter', 'retailerService', '$translate'];
    return AnalyticsService;
}());
exports.AnalyticsService = AnalyticsService;
angular
    .module('naut')
    .service('analyticsService', AnalyticsService);


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var viewport_typed_controller_1 = __webpack_require__(4);
var AnalyticsController = /** @class */ (function (_super) {
    __extends(AnalyticsController, _super);
    function AnalyticsController($scope, $translate) {
        var _this = _super.call(this, $scope) || this;
        _this.$scope = $scope;
        _this.$translate = $translate;
        return _this;
    }
    AnalyticsController.$inject = ['$scope', '$translate'];
    return AnalyticsController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut')
    .component('analytics', {
    template: __webpack_require__(709),
    controller: AnalyticsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var AnalyticsChartComponent = /** @class */ (function () {
    function AnalyticsChartComponent($scope) {
        var _this = this;
        this.$scope = $scope;
        this.options = {
            grid: {
                hoverable: true,
                clickable: true,
                borderWidth: 0,
                color: '#8394a9'
            },
            legend: {
                show: false
            },
            tooltip: true,
            tooltipOpts: {
                content: this.tooltipFormat,
                xDateFormat: this.timeFormat
            },
            xaxis: {
                tickColor: '#f1f2f3',
                mode: 'time',
                timeformat: this.timeFormat,
                ticks: null
            },
            yaxis: {
                min: 0,
                minTickSize: 1,
                tickDecimals: 0,
                tickFormatter: function (number) {
                    return number.toString();
                }
            },
            shadowSize: 0,
            series: {
                lines: {
                    show: true
                },
                points: {
                    show: true,
                    radius: 4
                }
            },
            colors: ['#e6194b', '#3cb44b', '#ffe119', '#0082c8', '#f58231', '#911eb4', '#000000', '#f032e6', '#d2f53c', '#fabebe', '#008080', '#e6beff',
                '#aa6e28', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000080', '#808080', '#000000', '#46f0f0']
        };
        $scope.$watch('vm.dataset', function (dataset) {
            if (dataset) {
                var numberOfItems = dataset[0].data.length;
                _this.options.series.points.show = numberOfItems <= 20;
                _this.options.tooltipOpts.xDateFormat = _this.options.xaxis.timeformat = _this.timeFormat;
                _this.options.xaxis.ticks = Math.min(10, numberOfItems);
                _this.dataset = dataset;
                for (var i = 0; i < dataset.length; i++) {
                    dataset[i].color = _this.options.colors[i];
                }
                _.first(dataset, 5).forEach(function (item) {
                    item.selected = true;
                });
                _this.changeLegend();
            }
        });
    }
    AnalyticsChartComponent.prototype.changeLegend = function () {
        this.filteredDataset = _.where(this.dataset, { selected: true });
    };
    AnalyticsChartComponent.$inject = ['$scope'];
    return AnalyticsChartComponent;
}());
angular.module('naut').component('analyticsChart', {
    template: __webpack_require__(710),
    controller: AnalyticsChartComponent,
    controllerAs: 'vm',
    bindings: {
        dataset: '=',
        timeFormat: '=',
        tooltipFormat: '='
    }
});


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var AnalyticsFilterComponent = /** @class */ (function () {
    function AnalyticsFilterComponent() {
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
    }
    return AnalyticsFilterComponent;
}());
angular.module('naut').component('analyticsFilter', {
    template: __webpack_require__(711),
    controller: AnalyticsFilterComponent,
    controllerAs: 'vm',
    bindings: {
        filter: '=',
        breakdowns: '='
    }
});


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var analyticsBase_1 = __webpack_require__(63);
var CampaignAnalyticsComponent = /** @class */ (function (_super) {
    __extends(CampaignAnalyticsComponent, _super);
    function CampaignAnalyticsComponent($scope, $stateParams, $filter, analiticsService, $translate) {
        var _this = _super.call(this, $scope, $stateParams, $filter, analiticsService, $translate) || this;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$filter = $filter;
        _this.analiticsService = analiticsService;
        _this.$translate = $translate;
        return _this;
    }
    CampaignAnalyticsComponent.prototype.getData = function (id, filter) {
        return this.analiticsService.getCampaignAnalytics(this.id, this.filter);
    };
    CampaignAnalyticsComponent.prototype.$onInit = function () {
        this.setFilterExtension();
    };
    CampaignAnalyticsComponent.prototype.setFilterExtension = function () {
        if (!this.schedule) {
            return;
        }
        if (this.schedule.hasStartDate) {
            this.filter.startDate = new Date(this.schedule.startDate.toString()).setHours(0, 0, 0, 0);
        }
        if (this.schedule.hasEndDate) {
            this.filter.endDate = new Date(this.schedule.endDate.toString()).setHours(0, 0, 0, 0);
        }
    };
    CampaignAnalyticsComponent.$inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];
    return CampaignAnalyticsComponent;
}(analyticsBase_1.AnalyticsBase));
angular.module('naut').component('campaignAnalytics', {
    template: __webpack_require__(712),
    controller: CampaignAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {
        schedule: '<'
    }
});


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var analyticsBase_1 = __webpack_require__(63);
var ShopCampaignAnalyticsComponent = /** @class */ (function (_super) {
    __extends(ShopCampaignAnalyticsComponent, _super);
    function ShopCampaignAnalyticsComponent($scope, $stateParams, $filter, analiticsService, $translate) {
        var _this = _super.call(this, $scope, $stateParams, $filter, analiticsService, $translate) || this;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$filter = $filter;
        _this.analiticsService = analiticsService;
        _this.$translate = $translate;
        return _this;
    }
    ShopCampaignAnalyticsComponent.prototype.getData = function (id, filter) {
        return this.analiticsService.getStoreCampaignAnalytics(this.id, this.filter);
    };
    ShopCampaignAnalyticsComponent.prototype.setFilterExtension = function () {
        return;
    };
    ShopCampaignAnalyticsComponent.$inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];
    return ShopCampaignAnalyticsComponent;
}(analyticsBase_1.AnalyticsBase));
angular.module('naut').component('shopCampaignAnalytics', {
    template: __webpack_require__(713),
    controller: ShopCampaignAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {}
});


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var analyticsBase_1 = __webpack_require__(63);
var ShopImpressionAnalyticsComponent = /** @class */ (function (_super) {
    __extends(ShopImpressionAnalyticsComponent, _super);
    function ShopImpressionAnalyticsComponent($scope, $stateParams, $filter, analiticsService, $translate) {
        var _this = _super.call(this, $scope, $stateParams, $filter, analiticsService, $translate) || this;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$filter = $filter;
        _this.analiticsService = analiticsService;
        _this.$translate = $translate;
        return _this;
    }
    ShopImpressionAnalyticsComponent.prototype.getData = function (id, filter) {
        return this.analiticsService.getStoreImpressionAnalytics(this.id, this.filter);
    };
    ShopImpressionAnalyticsComponent.prototype.setFilterExtension = function () {
        return;
    };
    ShopImpressionAnalyticsComponent.$inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];
    return ShopImpressionAnalyticsComponent;
}(analyticsBase_1.AnalyticsBase));
angular.module('naut').component('shopImpressionAnalytics', {
    template: __webpack_require__(714),
    controller: ShopImpressionAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {}
});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var analyticsBase_1 = __webpack_require__(63);
var ShopVisitsAnalyticsComponent = /** @class */ (function (_super) {
    __extends(ShopVisitsAnalyticsComponent, _super);
    function ShopVisitsAnalyticsComponent($scope, $stateParams, $filter, analiticsService, $translate) {
        var _this = _super.call(this, $scope, $stateParams, $filter, analiticsService, $translate) || this;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$filter = $filter;
        _this.analiticsService = analiticsService;
        _this.$translate = $translate;
        return _this;
    }
    ShopVisitsAnalyticsComponent.prototype.switchTab = function (tab) {
        this.filter.group = tab;
    };
    ShopVisitsAnalyticsComponent.prototype.setFilterExtension = function () {
        this.filter = angular.extend(this.filter, { group: this.tabs[0] });
    };
    ShopVisitsAnalyticsComponent.prototype.getData = function (id, filter) {
        return this.analiticsService.getStoreVisitsAnalytics(this.id, this.filter);
    };
    ShopVisitsAnalyticsComponent.$inject = ['$scope', '$stateParams', '$filter', 'analyticsService', '$translate'];
    return ShopVisitsAnalyticsComponent;
}(analyticsBase_1.AnalyticsBase));
angular.module('naut').component('shopVisitsAnalytics', {
    template: __webpack_require__(715),
    controller: ShopVisitsAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {}
});


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var StaffRatingAnalyticsComponent = /** @class */ (function () {
    function StaffRatingAnalyticsComponent($localStorage, accountService, $scope, $stateParams, $filter, staffRatingService, $translate) {
        var _this = this;
        this.$localStorage = $localStorage;
        this.accountService = accountService;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.staffRatingService = staffRatingService;
        this.$translate = $translate;
        this.viewModel = {
            AllowViewRating: false,
            AverageRating: 0,
            FeedbackCount: 0,
            LastUpdateUTC: null
        };
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.CheckIsAdmin()];
                    case 1:
                        _a.isRetailer = _b.sent();
                        this.getStaffRatingSummary();
                        return [2 /*return*/];
                }
            });
        }); };
        this.init();
    }
    StaffRatingAnalyticsComponent.prototype.getStaffRatingSummary = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staffRatingService.getStaffRatingSummary(false)];
                    case 1:
                        data = _a.sent();
                        this.viewModel = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingAnalyticsComponent.prototype.switchStaffRatingDisplay = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staffRatingService.setStaffRatingSettings({ AllowViewRating: this.viewModel.AllowViewRating })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingAnalyticsComponent.prototype.CheckIsAdmin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.$localStorage.retailerAuthorizationData.permission) {
                    this.accountService.getProfile();
                }
                return [2 /*return*/, this.$localStorage.retailerAuthorizationData.permission === 1];
            });
        });
    };
    StaffRatingAnalyticsComponent.$inject = ['$localStorage', 'accountService', '$scope', '$stateParams', '$filter', 'staffRatingService', '$translate'];
    return StaffRatingAnalyticsComponent;
}());
angular.module('naut').component('staffRatingAnalytics', {
    template: __webpack_require__(716),
    controller: StaffRatingAnalyticsComponent,
    controllerAs: 'vm',
    bindings: {}
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var retailer_service_1 = __webpack_require__(22);
var RetailerService = /** @class */ (function (_super) {
    __extends(RetailerService, _super);
    function RetailerService(retailerServiceUrl, siteAddressUrl, jispPayServiceUrl, apiCDNUrlRetailer) {
        var _this = _super.call(this, retailerServiceUrl, siteAddressUrl, apiCDNUrlRetailer) || this;
        _this.jispPayServiceUrl = jispPayServiceUrl;
        return _this;
    }
    RetailerService.prototype.checkStickersAvailable = function () {
        return this.getUrl('Products/CheckStickersAvailable');
    };
    RetailerService.prototype.checkCanEditStickers = function () {
        return this.getUrl('NfcStickers/CheckCanEditStickers');
    };
    RetailerService.prototype.activeStickers = function () {
        return this.getUrl('NfcStickers/Active');
    };
    RetailerService.prototype.deletedStickers = function () {
        return this.getUrl('NfcStickers/Deleted');
    };
    RetailerService.prototype.deleteSticker = function () {
        return this.getUrl('NfcStickers');
    };
    RetailerService.prototype.freeStickersCount = function () {
        return this.getUrl('NfcStickers/FreeStickers');
    };
    RetailerService.prototype.exportCSV = function () {
        return this.getUrl('NfcStickers/Export');
    };
    RetailerService.prototype.getOperations = function () {
        return this.getUrl('NfcStickers/Operations');
    };
    RetailerService.prototype.createOperation = function () {
        return this.getUrl('NfcStickers/Operations');
    };
    RetailerService.prototype.validateProductsAndCategories = function () {
        return this.getUrl('NfcStickers/ValidateProductsAndCategories');
    };
    RetailerService.prototype.validatePlaces = function () {
        return this.getUrl('NfcStickers/ValidatePlaces');
    };
    RetailerService.prototype.restoreSticker = function () {
        return this.getUrl('NfcStickers/Restore');
    };
    RetailerService.prototype.getCategoriesWithItemTypes = function () {
        return this.retailerServiceUrl + "products/CategoriesWithItemTypes";
    };
    RetailerService.prototype.getClassificationDictionary = function () {
        return this.retailerServiceUrl + "products/CategoriesWithItemTypesAndMeasurementses";
    };
    RetailerService.prototype.getOperationUrl = function (id) {
        return this.getOperationListUrl() + "/" + encodeURIComponent(id);
    };
    RetailerService.prototype.getOperationListUrl = function () {
        return this.retailerServiceUrl + 'operations';
    };
    RetailerService.prototype.getImportFileUrl = function (replace) {
        return this.retailerServiceUrl + 'products/import?replaceExisting=' + (replace ? 'true' : 'false');
    };
    RetailerService.prototype.getSignalREndpoint = function () {
        return this.retailerServiceUrl + 'signalr/v1.0';
    };
    RetailerService.prototype.viewedPrivacyNotification = function () {
        return this.getUrl('profile/viewedPrivacyNotification');
    };
    RetailerService.prototype.profile = function () {
        return this.getUrl('profile');
    };
    RetailerService.prototype.languages = function () {
        return this.getUrl('Languages');
    };
    RetailerService.prototype.profileEmail = function () {
        return this.getUrl('profile/email');
    };
    RetailerService.prototype.profilePassword = function () {
        return this.getUrl('profile/password');
    };
    RetailerService.prototype.emailExist = function (email) {
        return this.getUrl('account/emailExist?email=' + encodeURIComponent(email));
    };
    RetailerService.prototype.forgotPassword = function () {
        return this.getUrl('account/forgotpassword');
    };
    RetailerService.prototype.resetPassword = function () {
        return this.getUrl('account/resetpassword');
    };
    RetailerService.prototype.loggedInAsAdmin = function () {
        return this.getUrl('account/adminpermission');
    };
    RetailerService.prototype.stores = function () {
        return this.getUrl('stores');
    };
    RetailerService.prototype.findStores = function () {
        return this.getUrl('stores/find');
    };
    RetailerService.prototype.fetchAllPlaces = function () {
        return this.getUrl('stores/fetchAll');
    };
    RetailerService.prototype.storesForFilter = function () {
        return this.getUrl('stores/forFilter');
    };
    RetailerService.prototype.storesForRules = function () {
        return this.getUrl('stores/forRules');
    };
    RetailerService.prototype.store = function (id) {
        if (id) {
            return this.getUrl('stores/' + id);
        }
        else {
            return this.getUrl('stores');
        }
    };
    RetailerService.prototype.archiveStore = function (id) {
        return this.getUrl('stores/' + id + '/archive');
    };
    RetailerService.prototype.restoreStore = function (id) {
        return this.getUrl('stores/' + id + '/restore');
    };
    RetailerService.prototype.storeExist = function (name) {
        return this.getUrl('stores/shopexist/' + encodeURIComponent(name));
    };
    RetailerService.prototype.storeBusinessTypes = function () {
        return this.getUrl('stores/businessTypes');
    };
    RetailerService.prototype.getStoreCoverUrl = function (id, width, height) {
        if (width && height) {
            return this.getUrl('stores/cover/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getUrl('stores/cover/' + id);
        }
    };
    RetailerService.prototype.getStoreLogoUrl = function (id, width, height) {
        if (width && height) {
            return this.getCDNUrl('stores/logo/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getCDNUrl('stores/logo/' + id);
        }
    };
    RetailerService.prototype.storeCover = function (id) {
        return this.getUrl('stores/' + id + '/cover');
    };
    RetailerService.prototype.storeLogo = function (id) {
        return this.getUrl('stores/' + id + '/logo');
    };
    RetailerService.prototype.jisppayPlaces = function (offset, limit) {
        if (offset == null) {
            offset = 0;
        }
        if (limit == null) {
            return this.getUrl("jisppayPlaces?offset=" + offset);
        }
        else {
            return this.getUrl("jisppayPlaces?offset=" + offset + "&limit=" + limit);
        }
    };
    RetailerService.prototype.jisppayPlace = function (id) {
        return this.getUrl("jisppayPlaces/" + id);
    };
    RetailerService.prototype.jisppayPlacesAny = function () {
        return this.getUrl('jisppayPlaces/any');
    };
    RetailerService.prototype.jispPayEnable = function () {
        return this.getUrl("jisppayPlaces/enable");
    };
    RetailerService.prototype.jispPayMerchants = function () {
        return this.getUrl('jisppayPlaces/merchants');
    };
    RetailerService.prototype.jispPayDefaultMerchants = function () {
        return this.getUrl("jisppayPlaces/defaultMerchants");
    };
    RetailerService.prototype.jisppayStaff = function () {
        return this.getUrl('jisppayStaff');
    };
    RetailerService.prototype.jisppayShopper = function () {
        return this.jispPayServiceUrl + "shopper";
    };
    RetailerService.prototype.retailerShopper = function () {
        return this.retailerServiceUrl + "shoppers";
    };
    RetailerService.prototype.jisppayUploadAvatar = function () {
        return this.jisppayStaff() + "/uploadAvatar";
    };
    RetailerService.prototype.jisppayAccount = function (id) {
        if (id) {
            return this.getUrl("jisppayStaff/" + id);
        }
        return this.getUrl('jisppayStaff');
    };
    RetailerService.prototype.jisppayAccountRestore = function () {
        return this.getUrl('jisppayStaff/restore');
    };
    RetailerService.prototype.jisppayStaffAny = function (isActive) {
        isActive = isActive === undefined || isActive === null ? true : isActive;
        return this.getUrl("jisppayStaff/" + encodeURIComponent(isActive) + "/any");
    };
    RetailerService.prototype.storesForJispPay = function () {
        return this.getUrl('stores/forJisppay');
    };
    RetailerService.prototype.storesForManager = function () {
        return this.getUrl('stores/forManager');
    };
    RetailerService.prototype.jisppayStaffLoginExist = function (email) {
        return this.getUrl("jisppayStaff/LoginExist?login=" + encodeURIComponent(email));
    };
    RetailerService.prototype.openingHours = function (id) {
        return this.getUrl("stores/" + id + "/openingHours");
    };
    RetailerService.prototype.storeCampaigns = function (id) {
        return this.getUrl("stores/" + id + "/campaigns");
    };
    RetailerService.prototype.storeCampaignAnalytics = function (id) {
        return this.getUrl("stores/" + id + "/campaignAnalytics");
    };
    RetailerService.prototype.storeImpressionAnalytics = function (id) {
        return this.getUrl("stores/" + id + "/impressionAnalytics");
    };
    RetailerService.prototype.storeVisitsAnalytics = function (id) {
        return this.getUrl("stores/" + id + "/visitsAnalytics");
    };
    RetailerService.prototype.campaignAnalytics = function (id) {
        return this.getUrl("campaigns/" + id + "/analytics");
    };
    RetailerService.prototype.retailerCampaigns = function (offset, limit, sorting) {
        var column = '';
        var order = '';
        for (var c in sorting) {
            if (sorting.hasOwnProperty(c)) {
                column = c;
                order = sorting[c];
            }
        }
        return this.getUrl("campaigns/retailers?offset=" + offset + "&limit=" + limit + "&SortOrder=" + order + "&SortColumn=" + column);
    };
    RetailerService.prototype.retailerCampaign = function (id) {
        return this.getUrl("campaigns/retailers/" + id);
    };
    RetailerService.prototype.campaign = function (id) {
        if (id) {
            return this.getUrl("campaigns/" + id);
        }
        else {
            return this.getUrl('campaigns');
        }
    };
    RetailerService.prototype.campaignImage = function () {
        return this.getUrl('campaigns/image');
    };
    RetailerService.prototype.campaignVideo = function () {
        return this.getUrl('campaigns/video');
    };
    RetailerService.prototype.campaignVideoDelete = function (id) {
        return this.getUrl("campaigns/video/" + id);
    };
    RetailerService.prototype.campaignVideoGet = function (id) {
        return this.getUrl("campaigns/video/" + id);
    };
    RetailerService.prototype.campaignState = function (id) {
        return this.getUrl("campaigns/" + id + "/state");
    };
    RetailerService.prototype.brands = function () {
        return this.getUrl('brands');
    };
    RetailerService.prototype.brandsInventory = function () {
        return this.getUrl('brands/inventory');
    };
    RetailerService.prototype.brandsClassification = function () {
        return this.getUrl('brands/classification');
    };
    RetailerService.prototype.brandsSiblingCategories = function (id, level) {
        return this.getUrl("brands/" + id + "/sibling/" + level);
    };
    RetailerService.prototype.dictionaryBrands = function () {
        return this.getUrl('brands/dictionary');
    };
    RetailerService.prototype.approvedBrands = function () {
        return this.getUrl('brands/approved');
    };
    RetailerService.prototype.inventory = function (shopID) {
        return this.getUrl("stores/" + shopID + "/inventory");
    };
    RetailerService.prototype.classificationCategories = function () {
        return this.getUrl('classificationcategories');
    };
    RetailerService.prototype.classificationCategoriesForRules = function () {
        return this.getUrl('classificationcategories/forRules');
    };
    RetailerService.prototype.classificationCategoriesForRetailer = function () {
        return this.getUrl('classificationcategories/forRetailer');
    };
    RetailerService.prototype.paymentCards = function () {
        return this.getUrl('billing/cards');
    };
    RetailerService.prototype.paymentCard = function (id) {
        return this.getUrl('billing/cards/' + id);
    };
    RetailerService.prototype.setDefaultPaymentCard = function (id) {
        return this.getUrl("billing/cards/" + id + "/setDefault");
    };
    RetailerService.prototype.billingStatements = function () {
        return this.getUrl('billing/statements');
    };
    RetailerService.prototype.billingStatementsExist = function () {
        return this.getUrl('billing/statements/exist');
    };
    RetailerService.prototype.invoices = function () {
        return this.getUrl('billing/invoices');
    };
    RetailerService.prototype.withdrawalPayPalAccount = function () {
        return this.getUrl('withdrawalPayPalAccount');
    };
    RetailerService.prototype.profileUpdateShowGetStarted = function (show) {
        return this.getUrl('profile/' + encodeURIComponent(show.toString()) + '/getStarted');
    };
    RetailerService.prototype.designRequest = function (sessionID) {
        if (sessionID) {
            return this.getUrl('designRequest/' + sessionID);
        }
        else {
            return this.getUrl('designRequest');
        }
    };
    RetailerService.prototype.designRequestFile = function (sessionID) {
        return this.getUrl("designRequest/" + sessionID + "/file");
    };
    RetailerService.prototype.getProducts = function () {
        return this.getUrl('products');
    };
    RetailerService.prototype.findProducts = function () {
        return this.getUrl('products/find');
    };
    RetailerService.prototype.fetchProducts = function () {
        return this.getUrl('products/fetch');
    };
    RetailerService.prototype.fetchAllProducts = function () {
        return this.getUrl('products/fetchAll');
    };
    RetailerService.prototype.variationImage = function (id) {
        if (id) {
            return this.getCDNUrl('products/image/' + id);
        }
        else {
            return this.getCDNUrl('products/image');
        }
    };
    RetailerService.prototype.variationImageCopy = function () {
        return this.getUrl('products/image/copy');
    };
    RetailerService.prototype.getProductImageUrl = function (id, width, height) {
        if (width && height) {
            return this.getCDNUrl('products/image/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            if (height) {
                return this.getCDNUrl('products/image/' + id + '?height=' + height);
            }
            else {
                return this.getCDNUrl('products/image/' + id);
            }
        }
    };
    RetailerService.prototype.attachment = function (id) {
        if (id) {
            return this.getUrl("Products/Attachment/" + id);
        }
        else {
            return this.getUrl('Products/Attachment');
        }
    };
    RetailerService.prototype.product = function (id) {
        if (id) {
            return this.getUrl('products/' + id);
        }
        else {
            return this.getUrl('products');
        }
    };
    RetailerService.prototype.exportCsvProduct = function () {
        return this.getUrl('/Products/Export');
    };
    RetailerService.prototype.productPrice = function (id) {
        return this.getUrl("products/" + id + "/price");
    };
    RetailerService.prototype.productPriceWithVat = function (id) {
        return this.getUrl("Products/" + id + "/PriceWithVat");
    };
    RetailerService.prototype.productDiscount = function (id) {
        return this.getUrl("Products/" + id + "/Discount");
    };
    RetailerService.prototype.productStockQuantity = function (id) {
        return this.getUrl("Products/" + id + "/StockQuantity");
    };
    RetailerService.prototype.productLinkTypes = function () {
        return this.getUrl('products/linkTypes');
    };
    RetailerService.prototype.archiveProduct = function (id) {
        return this.getUrl("products/" + id + "/archive");
    };
    RetailerService.prototype.restoreProduct = function (productID, variationID) {
        if (variationID) {
            return this.getUrl("products/" + productID + "/restore/" + variationID);
        }
        else {
            return this.getUrl("products/" + productID + "/restore");
        }
    };
    RetailerService.prototype.existProducts = function (state) {
        return this.getUrl("products/" + state + "/exist");
    };
    RetailerService.prototype.productVariationTwins = function (productID, variationID) {
        return this.getUrl("products/" + productID + "/twins/" + variationID);
    };
    RetailerService.prototype.productItemTypes = function (categoryID, gender) {
        return this.getUrl("products/itemTypes/" + categoryID + "?Gender=" + (gender || ''));
    };
    RetailerService.prototype.getMenus = function (isArchived) {
        return this.getUrl("menu?settings.isArchived=" + isArchived.toString());
    };
    RetailerService.prototype.createMenu = function () {
        return this.getUrl('menu');
    };
    RetailerService.prototype.getMenu = function (ID) {
        return this.getUrl("menu/" + ID);
    };
    RetailerService.prototype.createMenuImage = function () {
        return this.getUrl('menu/image');
    };
    RetailerService.prototype.getMenuImage = function (imageId, width, height) {
        return this.getCDNUrl("menu/image/" + imageId + "?thumbnail.width=" + (width ? width : '') + "&thumbnail.height=" + (height ? height : ''));
    };
    RetailerService.prototype.setEnabledMenu = function (ID, value) {
        return this.getUrl("menu/" + ID + "/" + (value ? 'enable' : 'disable'));
    };
    RetailerService.prototype.setArchivedMenu = function (ID, value) {
        return this.getUrl("menu/" + ID + "/" + (value ? 'archive' : 'restore'));
    };
    // extras
    RetailerService.prototype.activeExtras = function () {
        return this.getUrl('extras/active');
    };
    RetailerService.prototype.extras = function (id) {
        return id ? this.getUrl("extras/" + id) : this.getUrl('extras');
    };
    RetailerService.prototype.archiveExtra = function (id) {
        return this.getUrl("extras/" + id + "/archive");
    };
    RetailerService.prototype.restoreExtra = function (id) {
        return this.getUrl("extras/" + id + "/restore");
    };
    RetailerService.prototype.uploadExtraImage = function () {
        return this.getUrl('extras/image');
    };
    RetailerService.prototype.createExtraImage = function () {
        return this.getUrl('extras/image');
    };
    RetailerService.prototype.getExtraImage = function (id) {
        return this.getCDNUrl("extras/image/" + id);
    };
    RetailerService.prototype.checkTitle = function (title, extraID) {
        if (extraID) {
            return this.getUrl('extras/checkTitle?title=' + title + '&extraID=' + extraID);
        }
        else {
            return this.getUrl('extras/checkTitle?title=' + title);
        }
    };
    RetailerService.prototype.referralAccounts = function (shopperID) {
        return this.getUrl('referralAccounts/' + (shopperID || ''));
    };
    RetailerService.prototype.shopperByReferralCode = function () {
        return this.getUrl('referralAccounts/shopperByCode');
    };
    RetailerService.prototype.measurements = function (gender) {
        if (!gender) {
            gender = '';
        }
        return this.getUrl('measurements/regular?Gender=' + gender);
    };
    RetailerService.prototype.smlMeasurements = function (gender) {
        if (!gender) {
            gender = '';
        }
        return this.getUrl('measurements/sml?Gender=' + gender);
    };
    RetailerService.prototype.storeManagers = function () {
        return this.getUrl('storeManagers');
    };
    RetailerService.prototype.storeManagerAny = function (isActive) {
        isActive = isActive === undefined ? true : isActive;
        return this.getUrl("storeManagers/" + encodeURIComponent(isActive) + "/any");
    };
    RetailerService.prototype.storeManagerAccount = function (id) {
        if (id) {
            return this.getUrl('storeManagers/' + id);
        }
        return this.getUrl('storeManagers');
    };
    RetailerService.prototype.storeManagerAccountRestore = function () {
        return this.getUrl('storeManagers/restore');
    };
    RetailerService.prototype.storeManagerAccountEmailExist = function (email) {
        return this.getUrl('storeManagers/emailExist?email=' + encodeURIComponent(email));
    };
    RetailerService.prototype.loyaltyPrograms = function (id) {
        if (id) {
            return this.getUrl("loyaltyPrograms/" + id);
        }
        else {
            return this.getUrl('loyaltyPrograms');
        }
    };
    RetailerService.prototype.loyaltyProgramsThresholds = function () {
        return this.getUrl('loyaltyPrograms/Thresholds');
    };
    RetailerService.prototype.inLoyaltyProgram = function (town) {
        return this.getUrl("loyaltyPrograms/" + encodeURIComponent(town) + "/inProgram");
    };
    RetailerService.prototype.tapAndGoPlaces = function () {
        return this.getUrl("OrderSettings");
    };
    RetailerService.prototype.tapAndGoPlace = function (id) {
        return this.getUrl("OrderSettings/" + id);
    };
    RetailerService.prototype.generateMonitorKey = function () {
        return this.getUrl("OrderSettings/generateMonitorKey");
    };
    RetailerService.prototype.categoryMappingExist = function () {
        return this.getUrl('products/categoryMapping/exist');
    };
    RetailerService.prototype.categoryMappingImport = function () {
        return this.getUrl('products/categoryMapping/import');
    };
    RetailerService.prototype.productsImport = function () {
        return this.getUrl('products/import');
    };
    RetailerService.prototype.productsImportQueued = function () {
        return this.getUrl('products/import/queued');
    };
    RetailerService.prototype.productsMetadata = function () {
        return this.getUrl('products/metadata');
    };
    RetailerService.prototype.getInformationCards = function () {
        return this.getUrl('informationCards');
    };
    RetailerService.prototype.searchInformationCards = function () {
        return this.getUrl('InformationCards/Find');
    };
    RetailerService.prototype.getInformationCardImageUrl = function (id, width, height) {
        if (width && height) {
            return this.getCDNUrl('informationCards/images/' + id + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getCDNUrl('informationCards/images/' + id);
        }
    };
    RetailerService.prototype.informationCardImage = function (id) {
        if (id) {
            return this.getCDNUrl('informationCards/image/' + id);
        }
        else {
            return this.getCDNUrl('informationCards/image');
        }
    };
    RetailerService.prototype.informationCard = function (id) {
        if (id) {
            return this.getUrl('informationCards/' + id);
        }
        else {
            return this.getUrl('informationCards');
        }
    };
    RetailerService.prototype.archiveInformationCard = function (id) {
        return this.getUrl("informationCards/" + id + "/archive");
    };
    RetailerService.prototype.restoreInformationCard = function (id) {
        return this.getUrl("informationCards/" + id + "/restore");
    };
    RetailerService.prototype.informationCardLinkTypes = function () {
        return this.getUrl('informationCards/linkTypes');
    };
    RetailerService.prototype.existInformationCards = function (state) {
        return this.getUrl("informationCards/" + state + "/exist");
    };
    RetailerService.prototype.informationCardImageCopy = function () {
        return this.getUrl('informationCards/image/copy');
    };
    RetailerService.prototype.storesCampaigns = function () {
        return this.getUrl('stores/campaigns');
    };
    RetailerService.prototype.staffRatingSummary = function (isArchived) {
        return this.getUrl("SalesAssistantsRating/Summary?isArchived=" + isArchived);
    };
    RetailerService.prototype.staffRatingSummaryByID = function (id) {
        return this.getUrl("SalesAssistantsRating/" + id);
    };
    RetailerService.prototype.staffRatingData = function (offset, limit, sortColumn, sortOrder, isActive) {
        var url = "SalesAssistantsRating?offset=" + offset + "&limit=" + limit + "&sortColumn=" + sortColumn + "&sortOrder=" + sortOrder + "&isArchive=" + !isActive;
        return this.getUrl(url);
    };
    RetailerService.prototype.staffRatingDataByID = function (id, offset, limit, sortColumn, sortOrder, startDate, endDate) {
        var url = "SalesAssistantsRating/" + id + "/RatingHistory?offset=" + offset + "&limit=" + limit + "&sortColumn=" + sortColumn + "&sortOrder=" + sortOrder;
        if (startDate) {
            url += "&startDate=" + startDate;
        }
        if (endDate) {
            url += "&endDate=" + endDate;
        }
        return this.getUrl(url);
    };
    RetailerService.prototype.staffRatingSettings = function () {
        return this.getUrl('SalesAssistantsRating/RatingSettings');
    };
    RetailerService.prototype.staffRatingSettingsByStaffID = function (id) {
        return this.getUrl("SalesAssistantsRating/RatingSettings/" + id);
    };
    RetailerService.prototype.exportSalesAssistant = function () {
        return this.getUrl("SalesAssistantsRating/export");
    };
    RetailerService.prototype.campaignAudience = function () {
        return this.getUrl('campaigns/audience');
    };
    RetailerService.prototype.foodPreference = function () {
        return this.getUrl('Preferences/FoodPreferences');
    };
    RetailerService.prototype.foodAllergens = function () {
        return this.getUrl('Preferences/Allergens');
    };
    RetailerService.prototype.countryOrigins = function () {
        return this.getUrl('products/CountryOrigins');
    };
    RetailerService.prototype.shopperStaffs = function () {
        return this.getUrl('ShopperStaffs');
    };
    RetailerService.prototype.createStaffDiscount = function () {
        return this.getUrl('ShopperStaffs/Discount');
    };
    RetailerService.prototype.editStaffDiscount = function (discountID) {
        return this.getUrl("ShopperStaffs/Discount/" + discountID);
    };
    RetailerService.prototype.findStaff = function () {
        return this.getUrl('Shoppers/FindByEmail');
    };
    RetailerService.prototype.transactionsHistorySummary = function () {
        return this.getUrl('ShopperStaffs/Transactions/Summary');
    };
    RetailerService.prototype.allTransactionsHistory = function () {
        return this.getUrl('ShopperStaffs/Transactions');
    };
    RetailerService.prototype.transactionHistory = function (transactionID) {
        return this.getUrl("ShopperStaffs/Transaction/" + transactionID);
    };
    RetailerService.prototype.checkPassword = function () {
        return this.getUrl('Account');
    };
    RetailerService.prototype.archiveStaff = function (discountID) {
        return this.getUrl("/ShopperStaffs/Discount/" + discountID);
    };
    RetailerService.prototype.companyInfoUrl = function () {
        return this.getUrl("Profile/CompanyInformation");
    };
    RetailerService.prototype.tablesEnabled = function (shopID) {
        return this.getUrl("stores/" + shopID + "/Tables/Settings");
    };
    RetailerService.prototype.setTablesEnabled = function (shopID) {
        return this.getUrl("stores/" + shopID + "/Tables/Enable");
    };
    RetailerService.prototype.setTablesMandatory = function (shopID) {
        return this.getUrl("stores/" + shopID + "/Tables/Mandatory");
    };
    RetailerService.prototype.tableExist = function (shopID, name) {
        return this.getUrl("stores/" + shopID + "/Tables/Exists?name=" + name);
    };
    RetailerService.prototype.tables = function (shopID) {
        return this.getUrl("stores/" + shopID + "/Tables");
    };
    RetailerService.prototype.table = function (shopID, tableID) {
        return this.getUrl("stores/" + shopID + "/Tables/" + tableID);
    };
    RetailerService.prototype.setProfileImage = function () {
        return this.getUrl('Profile/Logo');
    };
    RetailerService.prototype.getProfileImage = function (imageId, width, height) {
        if (width && height) {
            return this.getCDNUrl('profile/logo/' + imageId + '?width=' + width + '&height=' + height);
        }
        else {
            return this.getCDNUrl('profile/logo/' + imageId);
        }
    };
    RetailerService.prototype.deleteProfileImage = function (imageId) {
        return this.getUrl("Profile/Logo/" + imageId);
    };
    RetailerService.prototype.retailerAdvertsDefault = function () {
        return this.getUrl('RetailerAdverts/Default');
    };
    RetailerService.prototype.retailerAdvertsImage = function (advertImageID, width, height) {
        var url = "RetailerAdverts/Image/" + advertImageID;
        if (width && height) {
            url += "/thumbnail?width=" + width + "&height=" + height;
        }
        return this.getCDNUrl(url);
    };
    RetailerService.prototype.addRetailerAdvertsImage = function () {
        return this.getUrl('RetailerAdverts/Image');
    };
    RetailerService.prototype.retailerAdverts = function (advertID) {
        if (advertID) {
            return this.getUrl("RetailerAdverts/" + advertID);
        }
        else {
            return this.getUrl('RetailerAdverts');
        }
    };
    RetailerService.prototype.getRetailerAdvertsImageUrl = function (advertImageID, width, height) {
        return this.retailerAdvertsImage(advertImageID, width, height);
    };
    RetailerService.prototype.getIngredients = function () {
        return this.getUrl('Ingredients');
    };
    RetailerService.prototype.getIngredient = function (id) {
        return this.getUrl("Ingredients/" + id);
    };
    RetailerService.prototype.getCheckIngredients = function () {
        return this.getUrl('Ingredients/CheckTitle');
    };
    RetailerService.prototype.archiveIngredient = function (id) {
        return this.getUrl("Ingredients/" + id + "/Archive");
    };
    RetailerService.prototype.restoreIngredient = function (id) {
        return this.getUrl("Ingredients/" + id + "/Restore");
    };
    // ingredients
    RetailerService.prototype.ingredients = function (id) {
        return id ? this.getUrl("ingredients/" + id) : this.getUrl('ingredients');
    };
    // vendors
    RetailerService.prototype.getVendors = function () {
        return this.getUrl('Vendors');
    };
    RetailerService.prototype.getVendor = function (id) {
        return this.getUrl("Vendors/" + id);
    };
    RetailerService.prototype.archiveVendor = function (id) {
        return this.getUrl("Vendors/" + id + "/Archive");
    };
    RetailerService.prototype.restoreVendors = function (id) {
        return this.getUrl("Vendors/" + id + "/Restore");
    };
    RetailerService.prototype.createVendorImage = function () {
        return this.getUrl('vendors/image');
    };
    RetailerService.prototype.getVendorImage = function (id) {
        return this.getCDNUrl("vendors/image/" + id);
    };
    RetailerService.prototype.getServices = function () {
        return this.getUrl('Services/fetch');
    };
    RetailerService.prototype.getService = function (id) {
        return this.getUrl("Services/" + id);
    };
    RetailerService.prototype.getCheckServices = function () {
        return this.getUrl('Services/CheckTitle');
    };
    RetailerService.prototype.archiveService = function (id) {
        return this.getUrl("Services/" + id + "/Archive");
    };
    RetailerService.prototype.restoreService = function (id) {
        return this.getUrl("Services/" + id + "/Restore");
    };
    RetailerService.prototype.createService = function () {
        return this.getUrl('Service');
    };
    // vouchers
    RetailerService.prototype.vouchers = function () {
        return this.getUrl('Vouchers');
    };
    RetailerService.prototype.getVoucherById = function (id) {
        return this.getUrl("Vouchers/" + id);
    };
    RetailerService.prototype.publishVoucher = function () {
        return this.getUrl('Vouchers/Publish');
    };
    // publisher settings
    RetailerService.prototype.accessSettings = function () {
        return this.getUrl('DppAccessSettings');
    };
    RetailerService.prototype.allStores = function () {
        return this.getUrl('Stores/GetAll');
    };
    RetailerService.prototype.savePublisher = function (id) {
        return this.getUrl("Stores/" + id + "/Publisher");
    };
    // reading locations
    RetailerService.prototype.readingLocationsList = function () {
        return this.getUrl('ReadingLocations/Fetch');
    };
    RetailerService.prototype.readingLocation = function () {
        return this.getUrl('/ReadingLocations');
    };
    RetailerService.prototype.readingLocationById = function (readingLocationID) {
        return this.getUrl("/ReadingLocations/" + readingLocationID);
    };
    RetailerService.prototype.readingLocationArchive = function (readingLocationID) {
        return this.getUrl("ReadingLocations/" + readingLocationID + "/Archive");
    };
    RetailerService.prototype.readingLocationRestore = function (readingLocationID) {
        return this.getUrl("ReadingLocations/" + readingLocationID + "/Restore");
    };
    RetailerService.prototype.readingLocationDeepLink = function (readingLocationID) {
        return this.getUrl("ReadingLocations/" + readingLocationID + "/Deeplink");
    };
    RetailerService.prototype.readingLocationCheckName = function (readingLocationName) {
        return this.getUrl("/ReadingLocations/CheckName?name=" + readingLocationName);
    };
    RetailerService.prototype.variationsReport = function () {
        return this.getUrl('DppAnalytics/Variations');
    };
    RetailerService.prototype.bundles = function () {
        return this.getUrl('Bundles');
    };
    RetailerService.prototype.bundleItem = function (bundleId) {
        return this.getUrl("Bundles/" + bundleId);
    };
    RetailerService.prototype.storeBundleImage = function () {
        return this.getUrl('Bundles/Image');
    };
    RetailerService.prototype.bundleImage = function (id, width, height) {
        var url = "Bundles/Image/" + id;
        if (width && height) {
            url += "?width=" + width + "&height=" + height;
        }
        return this.getCDNUrl(url);
    };
    RetailerService.prototype.serviceImage = function (imageId, width, height) {
        var url = "Services/Image/" + imageId;
        if (width && height) {
            url += "?width=" + width + "&height=" + height;
        }
        return this.getCDNUrl(url);
    };
    RetailerService.prototype.uploadServiceImage = function () {
        return this.getUrl("Services/Image");
    };
    RetailerService.prototype.printerSettings = function () {
        return this.getUrl('Printing/PrinterSettings');
    };
    RetailerService.prototype.printerSettingsByPrinter = function () {
        return this.getUrl('Printing/PrinterSettings/ByPrinter');
    };
    RetailerService.prototype.testPrinting = function () {
        return this.getUrl('Printing/TestPrint');
    };
    RetailerService.prototype.categoriesForVouchers = function () {
        return this.getUrl('ClassificationCategories/ForVouchers');
    };
    RetailerService.prototype.getVoucherRestrictedCategories = function () {
        return this.getUrl('Vouchers/RestrictedCategories');
    };
    RetailerService.$inject = ['retailerServiceUrl', 'siteAddressUrl', 'jispPayServiceUrl', 'apiCDNUrlRetailer'];
    return RetailerService;
}(retailer_service_1.RetailerServiceBase));
exports.RetailerService = RetailerService;
angular
    .module('naut')
    .service('retailerService', RetailerService);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var BrandsService = /** @class */ (function () {
    function BrandsService($q, http, retailerService, enumService) {
        var _this = this;
        this.$q = $q;
        this.http = http;
        this.retailerService = retailerService;
        this.enumService = enumService;
        this.statuses = {
            pending: this.enumService.ClassificationCategoryBrandStatus.Pending,
            rejected: this.enumService.ClassificationCategoryBrandStatus.Rejected,
            approved: this.enumService.ClassificationCategoryBrandStatus.Approved
        };
        this.regWord = new RegExp('^[a-z]', 'i');
        this.anchors = [];
        this.anchorChar = 'char';
        this.levelDefault = 3;
        this.approvedBrands = null;
        this.getBrandAnchors = function () {
            return {
                anchors: _this.anchors,
                char: _this.anchorChar,
                regWord: _this.regWord
            };
        };
        this.getByClassificationCategoryID = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var brands, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.get(this.retailerService.brandsClassification(), { params: { cID: id } })];
                    case 1:
                        brands = _a.sent();
                        brands.map(this.toApproved);
                        return [2 /*return*/, this.$q.when(brands)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, this.$q.reject(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getCategoryBrands = function (id) {
            return _this.http.get(_this.retailerService.dictionaryBrands(), { params: { cID: id } });
        };
        this.getApprovedBrands = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!(this.approvedBrands == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.retailerService.approvedBrands())];
                    case 1:
                        _a.approvedBrands = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.$q.when(this.approvedBrands)];
                    case 3:
                        error_2 = _b.sent();
                        return [2 /*return*/, this.$q.reject(error_2)];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.brandsSiblingCategories = function (id, level) { return __awaiter(_this, void 0, void 0, function () {
            var brands, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.get(this.retailerService.brandsSiblingCategories(id, level ? level : this.levelDefault))];
                    case 1:
                        brands = _a.sent();
                        brands.map(this.toPending);
                        return [2 /*return*/, this.$q.when(brands)];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/, this.$q.reject(error_3)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.toApproved = function (brand) {
            brand.Status = _this.statuses.approved;
        };
        this.toPending = function (brand) {
            brand.Status = _this.statuses.pending;
        };
        _.forEach('abcdefghijklmnopqrstuvwxyz#'.toUpperCase().split(''), function (name, index) {
            _this.anchors.push({
                name: name,
                value: name === '#' ? _this.anchorChar : name,
                selected: false,
                disabled: false
            });
        });
    }
    BrandsService.$inject = ['$q', 'http', 'retailerService', 'enumService'];
    return BrandsService;
}());
exports.BrandsService = BrandsService;
angular
    .module('naut')
    .service('brandsService', BrandsService);


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var BrandStatusComponent = /** @class */ (function () {
    function BrandStatusComponent(enumService, $translate) {
        this.enumService = enumService;
        this.$translate = $translate;
        this.brandStatus = this.enumService.ClassificationCategoryBrandStatus;
        this.htmlTooltip = {
            awaitingApproval: this.$translate.instant('this_brand_is_waiting_approval'),
            rejected: this.$translate.instant('this_brand_was_rejected')
        };
    }
    BrandStatusComponent.prototype.isPending = function () {
        return this.brand.Status === this.brandStatus.Pending;
    };
    BrandStatusComponent.prototype.isRejected = function () {
        return this.brand.Status === this.brandStatus.Rejected;
    };
    BrandStatusComponent.$inject = ['enumService', '$translate'];
    return BrandStatusComponent;
}());
angular.module('naut').component('brandStatus', {
    template: __webpack_require__(717),
    controller: BrandStatusComponent,
    controllerAs: '$ctrl',
    bindings: {
        brand: '<'
    }
});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var popupServiceCancel_1 = __webpack_require__(5);
var BrandsSelectorComponent = /** @class */ (function () {
    function BrandsSelectorComponent($q, $uibModal, brandsService, notificationService, $translate) {
        var _this = this;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.brandsService = brandsService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.all = []; // all approved brands for specified categories
        this.available = []; // all brands expect already selected
        this.pending = []; // all pending brands for neighboring categories  by current live category
        this.filtered = []; // available brands with search applied
        this.top = []; // top filtered brands
        this.brandStatus = this.brandsService.statuses;
        this.htmlTooltip = {
            awaitingApproval: this.$translate.instant('this_brand_is_waiting_approval'),
            rejected: this.$translate.instant('this_brand_was_rejected'),
            unknown: this.$translate.instant('brand.unknow')
        };
        this.newBrand = null;
        this.errorBrand = null;
        this.allApprovedBrands = [];
        this.brandsForSearch = [];
        this.topCount = 10;
        this.$onInit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.brandsService.getApprovedBrands()];
                    case 1:
                        _a.allApprovedBrands = _b.sent();
                        this.setBrandsForSearch();
                        this.refreshFiltered();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.warn(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.showModalBrands = function ($event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var brands, selectedsAbsent, brandAnchors, anchors, groups, keys, startAnchor, anchorNoChar, selectedBrands_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        brands = angular.copy(this.all);
                        Array.prototype.push.apply(brands, angular.copy(this.pending));
                        selectedsAbsent = [];
                        _.forEach(this.model, function (brand) {
                            if (brand.Status !== _this.brandStatus.rejected && _.all(brands, function (cb) {
                                return cb.ID !== brand.ID;
                            })) {
                                selectedsAbsent.push(brand);
                            }
                        });
                        Array.prototype.push.apply(brands, selectedsAbsent);
                        brandAnchors = this.brandsService.getBrandAnchors();
                        _.forEach(brands, function (brand) {
                            var char = brand.Name.trim()[0];
                            brand.anchor = brandAnchors.regWord.test(char) ? char.toUpperCase() : brandAnchors.char;
                            brand.selected = _.any(_this.model, function (cb) {
                                return cb.ID === brand.ID;
                            });
                        });
                        anchors = angular.copy(brandAnchors.anchors);
                        groups = _.groupBy(brands, 'anchor');
                        keys = _.keys(groups);
                        keys = keys.sort();
                        _.forEach(anchors, function (anchor) {
                            anchor.disabled = !_.any(keys, function (key) {
                                return key === anchor.value;
                            });
                            anchor.selected = false;
                        });
                        startAnchor = _.findWhere(anchors, { value: keys[0] });
                        anchorNoChar = brandAnchors.char;
                        if ($event) {
                            $event.preventDefault();
                            $event.stopPropagation();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'choiceBrands',
                                resolve: {
                                    brandStatus: function () { return _this.brandStatus; },
                                    htmlTooltip: function () { return _this.htmlTooltip; },
                                    brands: function () { return groups; },
                                    anchors: function () { return anchors; },
                                    startAnchor: function () { return startAnchor; },
                                    anchorNoChar: function () { return anchorNoChar; },
                                    singleSelect: function () { return _this.singleSelect; }
                                },
                                size: 'lg',
                                windowClass: 'wrapBrandsPopup'
                            }).result];
                    case 2:
                        selectedBrands_1 = _a.sent();
                        _.forEach(selectedBrands_1, function (brand) {
                            if (_.all(_this.model, function (mb) {
                                return mb.ID !== brand.ID;
                            })) {
                                _this.onSelect(brand);
                            }
                        });
                        _.forEach(this.model, function (mb) {
                            if (!_.any(selectedBrands_1, function (brand) { return mb.ID === brand.ID; })) {
                                _this["delete"](mb);
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.updateData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var cID, id, call, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cID = _.isArray(this.categoryId) ? this.categoryId : [this.categoryId];
                        id = _.first(cID);
                        call = [this.brandsService.getByClassificationCategoryID(cID), this.$q.when([])];
                        return [4 /*yield*/, this.$q.all(call)];
                    case 1:
                        result = _a.sent();
                        this.all = result[0];
                        this.pending = _.reject(result[1], function (pending) {
                            return _.any(_this.all, function (approved) { return pending.ID === approved.ID; });
                        });
                        this.setBrandsForSearch();
                        this.refreshAvailable();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    BrandsSelectorComponent.prototype.$onChanges = function (changes) {
        if (changes.categoryId && (changes.categoryId.previousValue !== changes.categoryId.currentValue)) {
            this.updateData();
        }
    };
    BrandsSelectorComponent.prototype.refreshFiltered = function (search) {
        var _this = this;
        // _.forEach($scope.available, function (brand) { brand.last = false; });
        var keywords = search || null;
        var offeredBrands = [];
        if (keywords && keywords.length > 0) {
            var reg_1 = new RegExp('^.*' + keywords + '.*', 'i');
            this.filtered = _.filter(this.available, function (brand) {
                return reg_1.test(brand.Name);
            });
            var countMissing = this.topCount - this.filtered.length;
            if (countMissing > 0) {
                var _loop_1 = function (c) {
                    if (reg_1.test(this_1.brandsForSearch[c].Name) && !_.any(this_1.model, function (brand2) {
                        return _this.brandsForSearch[c].ID === brand2.ID;
                    })) {
                        var brand = angular.copy(this_1.brandsForSearch[c]);
                        brand.Status = this_1.brandStatus.pending;
                        offeredBrands.push(brand);
                    }
                    if (offeredBrands.length === countMissing) {
                        return "break";
                    }
                };
                var this_1 = this;
                for (var c = 0; c < this.brandsForSearch.length; c++) {
                    var state_1 = _loop_1(c);
                    if (state_1 === "break")
                        break;
                }
            }
        }
        else {
            this.filtered = this.available;
        }
        this.top = _.first(_.sortBy(_.union(this.filtered, offeredBrands), 'Name'), this.topCount);
        if (!_.isArray(this.top)) {
            this.top = [];
        }
        _.forEach(this.available, function (brand) { brand.last = false; });
        if (this.top.length > 0) {
            var last = _.last(this.top);
            last.last = true;
        }
        var alreadyexists = [];
        Array.prototype.push.apply(alreadyexists, this.model);
        Array.prototype.push.apply(alreadyexists, this.top);
        if ((keywords) && _.any(alreadyexists, function (brand) { return brand.Name.toLowerCase() === keywords.toLowerCase(); })) {
            this.newBrand = '';
        }
        else {
            this.newBrand = keywords;
        }
        if (this.validateBrandName()) {
            this.top.push({ Name: '', forApproval: true });
        }
    };
    BrandsSelectorComponent.prototype.getFilteredPlaceholder = function () {
        if (this.filtered.length) {
            return this.$translate.instant('search_to_add_a_brand');
        }
        return this.$translate.instant('add_brand');
    };
    BrandsSelectorComponent.prototype["delete"] = function (brand) {
        this.model = _.reject(this.model, function (mb) {
            return mb === brand;
        });
        this.onChange();
        this.refreshAvailable();
    };
    BrandsSelectorComponent.prototype.onSelect = function (brand) {
        if (brand.forApproval) {
            return;
        }
        if (_.all(this.model, function (mb) {
            return mb.ID !== brand.ID;
        })) {
            if (this.singleSelect) {
                this.model = [brand];
            }
            else {
                this.model.push(brand);
            }
        }
        this.onChange();
        this.refreshAvailable();
    };
    BrandsSelectorComponent.prototype.onSelectAll = function () {
        var _this = this;
        var flag = false;
        _.forEach(this.all, function (brand) {
            if (!_.any(_this.model, function (mb) {
                return mb.ID === brand.ID;
            })) {
                _this.model.push(brand);
                flag = true;
            }
        });
        if (flag) {
            this.onChange();
            this.refreshAvailable();
        }
    };
    BrandsSelectorComponent.prototype.onClearSelected = function () {
        this.model = [];
        this.onChange();
        this.refreshAvailable();
    };
    BrandsSelectorComponent.prototype.addNew = function () {
        if (this.validateBrandName()) {
            if (this.singleSelect) {
                this.model = [];
            }
            this.model.push({
                ID: null,
                Name: this.newBrand,
                Status: this.brandStatus.pending
            });
            this.onChange();
        }
        else {
            this.notificationService.showErrorMessage({
                body: this.errorBrand
            });
        }
    };
    BrandsSelectorComponent.prototype.setBrandsForSearch = function () {
        var _this = this;
        this.brandsForSearch = _.reject(this.allApprovedBrands, function (brand1) {
            return _.any(_this.all, function (brand2) {
                return brand1.ID === brand2.ID;
            });
        });
    };
    BrandsSelectorComponent.prototype.validateBrandName = function () {
        var _this = this;
        this.errorBrand = null;
        if (!this.newBrand) {
            return null;
        }
        this.newBrand = this.newBrand.trim();
        if (this.newBrand.length > 100) {
            this.errorBrand = 'Brand name must be less than 100 characters';
        }
        else if (this.newBrand.length < 2) {
            this.errorBrand = 'Brand name must be at least 2 characters long';
        }
        else if (_.any(this.model, function (brand) { return brand.Name.toLowerCase() === _this.newBrand.toLowerCase(); })) {
            this.errorBrand = 'Brand name is already selected';
        }
        return this.errorBrand == null;
    };
    BrandsSelectorComponent.prototype.refreshAvailable = function () {
        var _this = this;
        this.available = _.reject(this.all, function (brand1) {
            return _.any(_this.model, function (brand2) {
                return brand1.ID === brand2.ID;
            });
        });
        this.refreshFiltered();
    };
    BrandsSelectorComponent.$inject = ['$q', '$uibModal', 'brandsService', 'notificationService', '$translate'];
    return BrandsSelectorComponent;
}());
angular.module('naut').component('brandsSelector', {
    template: __webpack_require__(718),
    controller: BrandsSelectorComponent,
    controllerAs: '$ctrl',
    bindings: {
        allowAdd: '<',
        categoryId: '<',
        searchAllBrands: '<',
        model: '=',
        singleSelect: '<',
        onChange: '&'
    }
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ChoiceBrandsComponent = /** @class */ (function () {
    function ChoiceBrandsComponent() {
        var _this = this;
        this.modalInstance = this;
        this.brandsFiltered = {};
        this.isPristineData = true;
        this.countSelected = {
            pending: 0,
            approved: 0
        };
        this.pageSize = 52;
        this.goToAnchorBrand = function (anchor) {
            if (anchor.disabled) {
                return;
            }
            _.forEach(_this.resolve.anchors, function (item) {
                item.selected = false;
            });
            anchor.selected = true;
            _this.brandsFiltered = {};
            _this.brandsFiltered[anchor.value] = _.sortBy(_this.resolve.brands[anchor.value], function (item) {
                return item.Name.toLowerCase();
            });
            _this.settings = {
                total: _this.brandsFiltered[anchor.value].length,
                pageSize: _this.pageSize,
                page: 1
            };
        };
        this.changeState = function (brand) {
            var selectedBrands = [];
            if (brand.selected && _this.resolve.singleSelect) {
                _this.unSelectBrands(brand);
                selectedBrands = [brand];
            }
            else {
                selectedBrands = _this.getSelectedBrands();
            }
            _this.updateCountSelectedBrands(selectedBrands);
            _this.isPristineData = selectedBrands.length === _this.initialSelectedBrands.length;
            if (_this.isPristineData) {
                _this.isPristineData = _.all(selectedBrands, function (selected) {
                    return _.contains(_this.initialSelectedBrands, selected);
                });
            }
        };
    }
    ChoiceBrandsComponent.prototype.$onInit = function () {
        this.brandsFiltered[this.resolve.startAnchor.value] = _.sortBy(this.resolve.brands[this.resolve.startAnchor.value], function (item) {
            return item.Name.toLowerCase();
        });
        this.initialSelectedBrands = this.getSelectedBrands();
        this.updateCountSelectedBrands(this.initialSelectedBrands);
        this.settings = {
            total: this.brandsFiltered[this.resolve.startAnchor.value].length,
            pageSize: this.pageSize,
            page: 1
        };
    };
    ChoiceBrandsComponent.prototype.add = function () {
        this.modalInstance.close({ $value: this.getSelectedBrands() });
    };
    ChoiceBrandsComponent.prototype.discard = function () {
        this.modalInstance.dismiss({ $value: 'cancel' });
    };
    ChoiceBrandsComponent.prototype.getSelectedBrands = function () {
        var selectedBrands = [];
        _.forEach(_.values(this.resolve.brands), function (brands) {
            selectedBrands = _.union(selectedBrands, _.where(brands, { 'selected': true }));
        });
        return selectedBrands;
    };
    ChoiceBrandsComponent.prototype.unSelectBrands = function (brand) {
        _.forEach(_.values(this.resolve.brands), function (brands) {
            _.forEach(brands, function (item) {
                item.selected = item.ID === brand.ID;
            });
        });
    };
    ChoiceBrandsComponent.prototype.updateCountSelectedBrands = function (selectedBrands) {
        var _this = this;
        if (_.isArray(selectedBrands)) {
            this.countSelected = _.countBy(selectedBrands, function (brand) {
                return brand.Status === _this.resolve.brandStatus.approved ? 'approved' : 'pending';
            });
        }
    };
    ChoiceBrandsComponent.prototype.popupBrandsHeight = function () {
        $('.containerBrandList').css('height', ($(window).height() - $('.containerAlphabet ').height() - 117) + 'px');
    };
    return ChoiceBrandsComponent;
}());
angular.module('naut').component('choiceBrands', {
    template: __webpack_require__(719),
    controller: ChoiceBrandsComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddItemsPopupComponent = /** @class */ (function () {
    function AddItemsPopupComponent(notification, bundlesService, productsService) {
        this.notification = notification;
        this.bundlesService = bundlesService;
        this.productsService = productsService;
        this.checkAllDisabled = false;
        this.defaultCategoryFilter = {
            filter: 0
        };
        this.defaultProductsFilter = {
            sortColumn: 'Title',
            sortOrder: 0,
            filterByItemType: true
        };
        this.modalInstance = this;
    }
    AddItemsPopupComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resultSelectedItems = this.resolve.selectedItems ? this.resolve.selectedItems.slice() : [];
                        return [4 /*yield*/, this.loadCategories()];
                    case 1:
                        _a.sent();
                        this.updateAllCounters();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.search = function (text) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searchTerm = text;
                        this.itemList = [];
                        this.checkboxChecked = false;
                        this.checkboxIndeterminate = false;
                        return [4 /*yield*/, this.loadCategories()];
                    case 1:
                        _a.sent();
                        if (!this.searchTerm) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.openCategoryAndItemListAfterSearch()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searchTerm = '';
                        return [4 /*yield*/, this.search(this.searchTerm)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.add = function () {
        if (this.waiting) {
            return;
        }
        this.modalInstance.close({ $value: this.resultSelectedItems });
    };
    AddItemsPopupComponent.prototype.close = function () {
        if (this.waiting) {
            return;
        }
        this.modalInstance.dismiss();
    };
    AddItemsPopupComponent.prototype.selectItemTypeAndCategory = function (itemType, category) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, selected;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.selectedItemType = itemType;
                        this.selectedCategory = category;
                        _a = this;
                        return [4 /*yield*/, this.loadProducts()];
                    case 1:
                        _a.itemList = _b.sent();
                        this.checkAllDisabled = this.itemList.every(function (item) { return item.Disabled; });
                        selected = this.itemList.filter(function (item) { return item.Selected; });
                        this.checkboxChecked = selected.length && selected.length === this.itemList.length;
                        this.checkboxIndeterminate = selected.length > 0 && !this.checkboxChecked;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.getVariationImage = function (id) {
        return this.bundlesService.getVariationImageUrl(id);
    };
    AddItemsPopupComponent.prototype.allCheckboxClicked = function () {
        var _this = this;
        if (this.waiting) {
            return;
        }
        this.checkboxChecked = !this.checkboxChecked;
        this.checkboxIndeterminate = false;
        this.itemList.forEach(function (item) { return _this.changeItemSelection(item, _this.checkboxChecked); });
        this.selectedItemType.Counter = this.getCounterForItemType(this.selectedItemType.ID, this.selectedCategory.ID);
        this.selectedCategory.Counter = this.getCounterForCategory(this.selectedCategory);
    };
    AddItemsPopupComponent.prototype.onItemClick = function (item) {
        if (this.waiting || item.Disabled) {
            return;
        }
        this.changeItemSelection(item, !item.Selected);
        if (this.selectedItemType) {
            this.selectedItemType.Counter += item.Selected ? 1 : -1;
        }
        this.selectedCategory.Counter += item.Selected ? 1 : -1;
        var selected = this.itemList.filter(function (value) { return value.Selected; });
        this.checkboxChecked = selected.length === this.itemList.length;
        this.checkboxIndeterminate = selected.length > 0 && !this.checkboxChecked;
    };
    AddItemsPopupComponent.prototype.itemDisabled = function (variationID) {
        return !!this.resolve.disabledVariationIDs.find(function (id) { return id === variationID; });
    };
    AddItemsPopupComponent.prototype.loadProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filter, data, items, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notification.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        filter = __assign({}, this.defaultProductsFilter, { productName: this.searchTerm ? this.searchTerm : '', categoryID: this.selectedCategory.ID, itemTypeID: this.selectedItemType.ID, productState: 0 });
                        return [4 /*yield*/, this.productsService.getProducts(filter)];
                    case 2:
                        data = _a.sent();
                        items = data.Items.reduce(function (list, product) {
                            product.ProductVariations.forEach(function (variation) {
                                list.push({
                                    Selected: _this.resultSelectedItems.find(function (item) { return item.VariationID === variation.ID; }) != null,
                                    Disabled: _this.itemDisabled(variation.ID),
                                    ImageID: variation.ImagesID[0],
                                    Title: product.Title,
                                    Price: variation.Price,
                                    StockLevel: variation.StockQuantity,
                                    ItemTypeID: _this.selectedItemType.ID,
                                    CategoryID: _this.selectedCategory.ID,
                                    ProductID: product.ID,
                                    VariationID: variation.ID,
                                    SizeName: product.SizeName,
                                    ColourName: product.ColourName,
                                    Size: variation.Size,
                                    Colour: variation.Colour
                                });
                            });
                            return list;
                        }, []);
                        this.waiting = false;
                        this.notification.clearAll();
                        return [2 /*return*/, items];
                    case 3:
                        error_1 = _a.sent();
                        this.waiting = false;
                        this.notification.showErrorMessage(error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.loadCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filter, categories, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notification.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        filter = this.searchTerm ? __assign({}, this.defaultCategoryFilter, { searchTerm: this.searchTerm }) :
                            this.defaultCategoryFilter;
                        return [4 /*yield*/, this.bundlesService.getCategories(filter)];
                    case 2:
                        categories = _a.sent();
                        this.categoryList = categories.Items.map(function (category) {
                            var newCategory = __assign({}, category, { ItemTypes: category.ItemTypes.map(function (itemType) {
                                    return __assign({}, itemType, { Name: itemType.ID === null ? 'Other' : itemType.Name, Counter: _this.getCounterForItemType(itemType.ID, category.ID) });
                                }), Counter: 0 });
                            newCategory.Counter = _this.getCounterForCategory(newCategory);
                            return newCategory;
                        }).sort(function (a, b) { return a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0; });
                        this.waiting = false;
                        this.notification.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.waiting = false;
                        this.notification.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.prototype.getCounterForCategory = function (category) {
        return category.ItemTypes.reduce(function (sum, itemType) { return sum + itemType.Counter; }, 0);
    };
    AddItemsPopupComponent.prototype.getCounterForItemType = function (itemTypeID, categoryID) {
        return this.resultSelectedItems.filter(function (item) { return item.ItemTypeID === itemTypeID && item.CategoryID === categoryID; }).length;
    };
    AddItemsPopupComponent.prototype.updateAllCounters = function () {
        var _this = this;
        this.categoryList.forEach(function (category) {
            category.ItemTypes.forEach(function (itemType) {
                itemType.Counter = _this.getCounterForItemType(itemType.ID, category.ID);
            });
            category.Counter = _this.getCounterForCategory(category);
        });
    };
    AddItemsPopupComponent.prototype.changeItemSelection = function (item, value) {
        if (item.Selected === value || item.Disabled) {
            return;
        }
        item.Selected = value;
        if (item.Selected) {
            this.resultSelectedItems.push(item);
        }
        else {
            this.resultSelectedItems = this.resultSelectedItems.filter(function (innerItem) { return innerItem.VariationID !== item.VariationID; });
        }
    };
    AddItemsPopupComponent.prototype.openCategoryAndItemListAfterSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.categoryList.length === 1)) return [3 /*break*/, 2];
                        this.categoryList[0].IsOpen = true;
                        if (!(this.categoryList[0].ItemTypes.length === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.selectItemTypeAndCategory(this.categoryList[0].ItemTypes[0], this.categoryList[0])];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AddItemsPopupComponent.$inject = [
        'notificationService',
        'bundlesService',
        'productsService'
    ];
    return AddItemsPopupComponent;
}());
angular.module('naut')
    .component('addItemsPopupComponent', {
    template: __webpack_require__(720),
    controller: AddItemsPopupComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '=',
        close: '&'
    }
});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var BundleDetailsComponent = /** @class */ (function () {
    function BundleDetailsComponent($localStorage, notificationService, bundlesService, $state, $translate, popupService, productService) {
        this.$localStorage = $localStorage;
        this.notificationService = notificationService;
        this.bundlesService = bundlesService;
        this.$state = $state;
        this.$translate = $translate;
        this.popupService = popupService;
        this.productService = productService;
        this.waiting = false;
        this.dateFormat = 'dd/MM/yyyy';
    }
    BundleDetailsComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.bundleID = parseInt(this.$state.params.id, 10);
                        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                        return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BundleDetailsComponent.prototype.getLogoImage = function (logoID) {
        return logoID ? this.bundlesService.getLogoImageUrl(logoID, 240, 120) : '';
    };
    BundleDetailsComponent.prototype.getVariationImage = function (id) {
        return this.bundlesService.getVariationImageUrl(id);
    };
    BundleDetailsComponent.prototype.confirmDeleteBundle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        this.waiting = true;
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('bundle_delete_title'),
                                content: "<span style=\"word-break: break-word\">" + this.$translate.instant('bundle_delete_content', { name: this.bundle.Name }) + "</span>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('delete'),
                                hasIcon: true,
                                thinTitle: true
                            })];
                    case 2:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 4];
                        this.waiting = false;
                        return [4 /*yield*/, this.deleteBundle()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.waiting = false;
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BundleDetailsComponent.prototype.deleteBundle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bundlesService.deleteBundle(this.bundleID)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.waiting = false;
                        this.$state.go('app.bundles');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.waiting = false;
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BundleDetailsComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.productService.getMetadata()];
                    case 2:
                        metadata = _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.bundlesService.getBundle(this.bundleID)];
                    case 3:
                        _a.bundle = _b.sent();
                        this.bundlesService.fillSizeAndColourNames(this.bundle, metadata);
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        this.waiting = false;
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BundleDetailsComponent.$inject = [
        '$localStorage',
        'notificationService',
        'bundlesService',
        '$state',
        '$translate',
        'popupService',
        'productsService'
    ];
    return BundleDetailsComponent;
}());
angular.module('naut').component('bundleDetailsComponent', {
    template: __webpack_require__(721),
    controller: BundleDetailsComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var models_1 = __webpack_require__(82);
var BundleListComponent = /** @class */ (function () {
    function BundleListComponent($localStorage, notificationService, bundlesService) {
        this.$localStorage = $localStorage;
        this.notificationService = notificationService;
        this.bundlesService = bundlesService;
        this.waiting = false;
        this.bundleList = [];
        this.dateFormat = 'dd/MM/yyyy';
        this.bundleTypeEnum = models_1.BundleTypeEnum;
    }
    BundleListComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                        return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BundleListComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting || this.bundleList && this.bundleList.length >= this.total) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        filter = {
                            limit: 10,
                            offset: this.bundleList ? this.bundleList.length : 0,
                            sortOrder: '1',
                            sortColumn: 'ID'
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bundlesService.getBundleList(filter)];
                    case 2:
                        data = _a.sent();
                        this.total = data.Total;
                        this.bundleList = this.bundleList.concat(data.Items);
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.waiting = false;
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BundleListComponent.prototype.getLogoImage = function (logoID) {
        return this.bundlesService.getLogoImageUrl(logoID, 240, 120);
    };
    BundleListComponent.$inject = [
        '$localStorage',
        'notificationService',
        'bundlesService'
    ];
    return BundleListComponent;
}());
angular.module('naut').component('bundleListComponent', {
    template: __webpack_require__(722),
    controller: BundleListComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var core_1 = __webpack_require__(59);
var angular = __webpack_require__(0);
var fabric_1 = __webpack_require__(526);
var CreateTemplateDialog = /** @class */ (function () {
    function CreateTemplateDialog($timeout) {
        this.$timeout = $timeout;
        this.textList = [
            'Bundle Deal',
            'Meal Deal',
            'MUST HAVE',
            'SAVER'
        ];
        this.iconList = [
            'chilled-meats',
            'vape-liquids',
            'confectionary',
            'ready-meal',
            'beer-ale',
            'crisps',
            'fizzy-drink'
        ];
        this.colorList = [
            '#189CD8',
            '#CD4B4D',
            '#F6B817',
            '#7EAC69'
        ];
        this.svgPath = '/assets/images/bundles';
        this.modalInstance = this;
        this.svgElementMap = new Map();
    }
    CreateTemplateDialog.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.selectedText = this.textList[0];
                this.selectedIcon = this.iconList[0];
                this.selectedColor = this.colorList[0];
                this.$timeout(function () {
                    _this.prepareCanvas();
                    _this.redrawTemplate();
                }, 100);
                return [2 /*return*/];
            });
        });
    };
    CreateTemplateDialog.prototype.closeDialog = function () {
        this.modalInstance.dismiss();
    };
    CreateTemplateDialog.prototype.getIconSrcByName = function (filename) {
        return this.svgPath + "/icons/" + filename + ".svg";
    };
    CreateTemplateDialog.prototype.selectText = function (text) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedText === text) {
                            return [2 /*return*/];
                        }
                        this.selectedText = text;
                        return [4 /*yield*/, this.redrawTemplate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateTemplateDialog.prototype.selectIcon = function (icon) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedIcon === icon) {
                            return [2 /*return*/];
                        }
                        this.selectedIcon = icon;
                        return [4 /*yield*/, this.redrawTemplate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateTemplateDialog.prototype.selectColor = function (color) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedColor === color) {
                            return [2 /*return*/];
                        }
                        this.selectedColor = color;
                        return [4 /*yield*/, this.redrawTemplate()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateTemplateDialog.prototype.save = function () {
        var zoom = 1032 / this.fabricCanvas.getWidth();
        this.fabricCanvas.setWidth(1032);
        this.fabricCanvas.setHeight(516);
        this.fabricCanvas.setZoom(zoom);
        var data = this.fabricCanvas.toDataURL();
        this.modalInstance.close({ $value: data });
    };
    CreateTemplateDialog.prototype.redrawTemplate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, textSvg, iconSvg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fabricCanvas.clear();
                        this.fabricCanvas.backgroundColor = this.selectedColor;
                        return [4 /*yield*/, core_1.$q.all({
                                text: this.getTextImage(this.selectedText),
                                icon: this.getIconImage(this.selectedIcon)
                            })];
                    case 1:
                        response = _a.sent();
                        textSvg = response.text;
                        iconSvg = response.icon;
                        this.fabricCanvas.add(textSvg);
                        textSvg.centerV();
                        textSvg.left = 24;
                        this.fabricCanvas.add(iconSvg);
                        iconSvg.scale(2.5);
                        iconSvg.centerV();
                        iconSvg.originX = 'center';
                        iconSvg.left = 190;
                        this.fabricCanvas.renderAll();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateTemplateDialog.prototype.prepareCanvas = function () {
        this.fabricCanvas = new fabric_1.fabric.StaticCanvas('templateCanvas', {
            width: 240,
            height: 120,
            isDrawingMode: false
        });
    };
    CreateTemplateDialog.prototype.getTextImage = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        if (_this.svgElementMap.has(name)) {
                            resolve(_this.svgElementMap.get(name));
                        }
                        else {
                            var fileName = _this.selectedText.toLocaleLowerCase().replace(' ', '-');
                            var path = _this.svgPath + "/texts/" + fileName + ".svg";
                            fabric_1.fabric.loadSVGFromURL(path, function (objects) {
                                var group = fabric_1.fabric.util.groupSVGElements(objects);
                                _this.svgElementMap.set(name, group);
                                resolve(group);
                            });
                        }
                    })];
            });
        });
    };
    CreateTemplateDialog.prototype.getIconImage = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        if (_this.svgElementMap.has(name)) {
                            resolve(_this.svgElementMap.get(name));
                        }
                        else {
                            var path = _this.getIconSrcByName(name);
                            fabric_1.fabric.loadSVGFromURL(path, function (objects) {
                                objects.forEach(function (val) {
                                    val.fill = 'white';
                                });
                                var group = fabric_1.fabric.util.groupSVGElements(objects);
                                _this.svgElementMap.set(name, group);
                                resolve(group);
                            });
                        }
                    })];
            });
        });
    };
    CreateTemplateDialog.$inject = [
        '$timeout'
    ];
    return CreateTemplateDialog;
}());
angular.module('naut').component('createTemplateDialog', {
    template: __webpack_require__(723),
    controller: CreateTemplateDialog,
    controllerAs: 'ctrl',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var models_1 = __webpack_require__(82);
var EditBundleDetailsFormComponent = /** @class */ (function () {
    function EditBundleDetailsFormComponent($localStorage, notificationService, accountService, bundlesService, $uibModal, $translate) {
        this.$localStorage = $localStorage;
        this.notificationService = notificationService;
        this.accountService = accountService;
        this.bundlesService = bundlesService;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.dateFormat = 'dd/MM/yy';
        this.utcToday = moment.utc(new Date()).utc(true).startOf('day').toDate();
        this.startDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: this.utcToday
        };
        this.endDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: this.utcToday
        };
        this.needGradient = false;
        this.bundleTypeExpanded = false;
        this.bundleTypes = [models_1.BundleTypeEnum.Fixed, models_1.BundleTypeEnum.Discount];
        this.bundleTypesEnum = models_1.BundleTypeEnum;
        this.maxFileSize = 5;
        this.fileExtensions = ['jpeg', 'jpg', 'png', 'bmp', 'gif'];
        this.minSize = {
            w: 1032,
            h: 516
        };
        this.aspectRatio = (this.minSize.w / this.minSize.h).toFixed(2);
    }
    EditBundleDetailsFormComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var price, discount;
            return __generator(this, function (_a) {
                this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                this.currencyCssClass = this.getCurrencyCssClass(this.accountService.userData.currencySign);
                this.resetState();
                price = this.bundle.BundleValue.Price;
                discount = this.bundle.BundleValue.DiscountPercent;
                if (price) {
                    this.currentBundleType = models_1.BundleTypeEnum.Fixed;
                    this.savedBundleValue = price;
                }
                else if (discount) {
                    this.currentBundleType = models_1.BundleTypeEnum.Discount;
                    this.savedBundleValue = discount;
                }
                else {
                    this.currentBundleType = models_1.BundleTypeEnum.Fixed;
                    this.savedBundleValue = price;
                }
                return [2 /*return*/];
            });
        });
    };
    EditBundleDetailsFormComponent.prototype.$onChanges = function (onChangesObj) {
        this.resetState();
    };
    EditBundleDetailsFormComponent.prototype.useTemplate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var image, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'createTemplateDialog',
                                windowClass: 'modal512',
                                backdrop: 'static'
                            }).result];
                    case 2:
                        image = _a.sent();
                        if (!image) return [3 /*break*/, 4];
                        this.form.$setDirty();
                        return [4 /*yield*/, this.saveImage(image)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EditBundleDetailsFormComponent.prototype.uploadLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var image, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return _this.bundle ? _this.bundle.LogoImageID : null; },
                                    title: function () { return _this.$translate.instant('bundle_image'); },
                                    sizeText: function () { return _this.$translate.instant('store_photo_min_size_hint', { width: 1032, height: 516 }); },
                                    getUrl: function () { return _this.bundle && _this.bundle.LogoImageID ? _this.bundlesService.getLogoImageUrl(_this.bundle.LogoImageID) : null; },
                                    imageSize: function () { return _this.minSize; },
                                    maxFileSizeMb: function () { return _this.maxFileSize; },
                                    aspectRatio: function () { return _this.aspectRatio; },
                                    fileExtensions: function () { return _this.fileExtensions; }
                                },
                                backdrop: 'static',
                                windowClass: 'crop-image-dialog'
                            }).result];
                    case 2:
                        image = _a.sent();
                        if (!image) return [3 /*break*/, 4];
                        this.needGradient = true;
                        this.form.$setDirty();
                        return [4 /*yield*/, this.saveImage(image)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    EditBundleDetailsFormComponent.prototype.deleteImage = function () {
        this.form.$setDirty();
        this.imageSrc = '';
        this.bundle.LogoImageID = null;
        this.needGradient = false;
    };
    EditBundleDetailsFormComponent.prototype.validateRequired = function (control, value) {
        control.$setValidity('required', !!value);
    };
    EditBundleDetailsFormComponent.prototype.openValidFromDatepicker = function () {
        this.openedValidFrom = !this.waiting;
        this.openedValidTo = false;
    };
    EditBundleDetailsFormComponent.prototype.openValidToDatepicker = function () {
        this.openedValidFrom = false;
        this.openedValidTo = !this.waiting;
    };
    EditBundleDetailsFormComponent.prototype.validateValidFrom = function () {
        this.updateMinEndDate();
        var isValid = this.originalValidFrom && moment.utc(this.bundle.ValidFrom).isSame(this.originalValidFrom) ||
            !this.bundle.ValidFrom || moment.utc(this.bundle.ValidFrom).isSameOrAfter(this.utcToday);
        this.form.ValidFrom.$setValidity('valid-from-error', isValid);
        this.validateValidTo();
    };
    EditBundleDetailsFormComponent.prototype.validateValidTo = function () {
        var isValid = !this.bundle.ValidTo || moment.utc(this.bundle.ValidTo).isSameOrAfter(this.endDateOptions.minDate);
        this.form.ValidTo.$setValidity('valid-to-error', isValid);
    };
    EditBundleDetailsFormComponent.prototype.validatePrice = function () {
        this.form.Price.$setValidity('required', !!this.bundle.BundleValue.Price || this.bundle.BundleValue.Price === 0);
        this.form.Price.$setValidity('min', this.bundle.BundleValue.Price !== 0);
        this.form.Price.$setValidity('max', !this.bundle.BundleValue.Price || this.bundle.BundleValue.Price <= 9999.99);
    };
    EditBundleDetailsFormComponent.prototype.validateDiscount = function () {
        this.form.DiscountPercent.$setValidity('required', !!this.bundle.BundleValue.DiscountPercent || this.bundle.BundleValue.DiscountPercent === 0);
        this.form.DiscountPercent.$setValidity('min', this.bundle.BundleValue.DiscountPercent !== 0);
        this.form.DiscountPercent.$setValidity('max', !this.bundle.BundleValue.DiscountPercent || this.bundle.BundleValue.DiscountPercent <= 100);
        this.form.DiscountPercent.$setValidity('integer', Number.isInteger(this.bundle.BundleValue.DiscountPercent) || Number.isNaN(this.bundle.BundleValue.DiscountPercent));
    };
    EditBundleDetailsFormComponent.prototype.getBundleTypeName = function (bundleType) {
        switch (bundleType) {
            case models_1.BundleTypeEnum.Fixed:
                return this.$translate.instant('fixed_price');
            case models_1.BundleTypeEnum.Discount:
                return this.$translate.instant('percentage_discount');
        }
    };
    EditBundleDetailsFormComponent.prototype.changeBundleType = function (bundleType) {
        this.currentBundleType = bundleType;
        if (bundleType === models_1.BundleTypeEnum.Fixed) {
            this.savedBundleValue = this.bundle.BundleValue.DiscountPercent;
            this.bundle.BundleValue.DiscountPercent = null;
        }
        else {
            this.savedBundleValue = this.bundle.BundleValue.Price;
            this.bundle.BundleValue.Price = null;
        }
    };
    EditBundleDetailsFormComponent.prototype.getCurrentTypeName = function () {
        return this.getBundleTypeName(this.currentBundleType);
    };
    EditBundleDetailsFormComponent.prototype.resetState = function () {
        this.imageSrc = this.bundle && this.bundle.LogoImageID ? this.bundlesService.getLogoImageUrl(this.bundle.LogoImageID, 428, 214) : null;
        if (this.bundle) {
            this.bundle.ValidFrom = this.bundle.ValidFrom ? moment.utc(new Date(this.bundle.ValidFrom)).startOf('day').toDate() : null;
            this.bundle.ValidTo = this.bundle.ValidTo ? moment.utc(new Date(this.bundle.ValidTo)).startOf('day').toDate() : null;
        }
        this.originalValidFrom = this.bundle ? this.bundle.ValidFrom : null;
        this.originalValidTo = this.bundle ? this.bundle.ValidTo : null;
        this.updateMinEndDate();
    };
    EditBundleDetailsFormComponent.prototype.updateMinEndDate = function () {
        this.endDateOptions.minDate = this.bundle && this.bundle.ValidFrom && moment.utc(this.bundle.ValidFrom).isSameOrAfter(this.utcToday) ?
            moment.utc(this.bundle.ValidFrom).startOf('day').toDate() : this.utcToday;
    };
    EditBundleDetailsFormComponent.prototype.getCurrencyCssClass = function (sign) {
        switch (sign) {
            case '£':
                return 'withPound';
            case 'kr':
                return 'withKrona';
            case '$':
                return 'withDollar';
            case '€':
                return 'withEuro';
            case 'د.إ':
                return 'withDirham';
            default:
                return '';
        }
    };
    EditBundleDetailsFormComponent.prototype.saveImage = function (imageFileData) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.bundle;
                        return [4 /*yield*/, this.bundlesService.uploadLogoImage(imageFileData)];
                    case 1:
                        _a.LogoImageID = _b.sent();
                        this.imageSrc = this.bundlesService.getLogoImageUrl(this.bundle.LogoImageID, 428, 214);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EditBundleDetailsFormComponent.$inject = [
        '$localStorage',
        'notificationService',
        'accountService',
        'bundlesService',
        '$uibModal',
        '$translate'
    ];
    return EditBundleDetailsFormComponent;
}());
angular.module('naut').component('editBundleDetailsFormComponent', {
    template: __webpack_require__(724),
    controller: EditBundleDetailsFormComponent,
    controllerAs: 'ctrl',
    bindings: {
        bundle: '<',
        waiting: '<'
    },
    require: {
        form: '^form'
    }
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var EditBundleItemsComponent = /** @class */ (function () {
    function EditBundleItemsComponent(bundlesService, $localStorage, $uibModal) {
        this.bundlesService = bundlesService;
        this.$localStorage = $localStorage;
        this.$uibModal = $uibModal;
        this.treeOptions = {
            dropped: this.dropped.bind(this)
        };
        this.defaultComponent = {
            Name: null,
            Quantity: 1,
            Variations: []
        };
    }
    EditBundleItemsComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                return [2 /*return*/];
            });
        });
    };
    EditBundleItemsComponent.prototype.getVariationImage = function (id) {
        return this.bundlesService.getVariationImageUrl(id);
    };
    EditBundleItemsComponent.prototype.nameChanged = function (control, component) {
        control.$setValidity('required', !!component.Name);
        if (component.errors) {
            component.errors.name = !component.Name;
        }
    };
    EditBundleItemsComponent.prototype.quantityChanged = function (control, value) {
        control.$setValidity('required', !isNaN(value));
        control.$setValidity('min', isNaN(value) || value > 0);
        control.$setValidity('max', isNaN(value) || value <= 30);
    };
    EditBundleItemsComponent.prototype.removeItem = function (variation, component) {
        component.Variations = component.Variations.filter(function (variant) { return variant !== variation; });
        this.form.$setDirty();
    };
    EditBundleItemsComponent.prototype.addItems = function (component, index) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var products, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'addItemsPopupComponent',
                                resolve: {
                                    selectedItems: function () { return component.Variations.slice(); },
                                    componentName: function () { return component.Name; },
                                    countryID: function () { return _this.countryID; },
                                    disabledVariationIDs: function () { return _this.getDisabledVariationIDs(index); }
                                },
                                backdrop: 'static',
                                windowClass: 'modal984 modal-design-v2'
                            }).result];
                    case 1:
                        products = _a.sent();
                        if (products) {
                            component.Variations = products;
                        }
                        if (component.errors && component.errors.noVariations) {
                            component.errors.noVariations = component.Variations.length === 0;
                        }
                        this.form.$setDirty();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EditBundleItemsComponent.prototype.removeComponent = function (component) {
        this.componentList = this.componentList.filter(function (item) { return item !== component; });
        this.form.$setDirty();
    };
    EditBundleItemsComponent.prototype.addComponent = function () {
        this.componentList.push(__assign({}, this.defaultComponent, { Variations: [] }));
        this.form.$setDirty();
    };
    EditBundleItemsComponent.prototype.dropped = function (event) {
        if (event.source.index !== event.dest.index) {
            this.form.$setDirty();
        }
    };
    EditBundleItemsComponent.prototype.getDisabledVariationIDs = function (excludedComponentIndex) {
        if (this.componentList.length > 1) {
            return this.componentList
                .filter(function (component, index) { return index !== excludedComponentIndex; })
                .map(function (component) { return component.Variations; })
                .reduce(function (previousValue, currentValue) { return previousValue.concat(currentValue); })
                .map(function (variation) { return variation.VariationID; });
        }
        else {
            return [];
        }
    };
    EditBundleItemsComponent.$inject = [
        'bundlesService',
        '$localStorage',
        '$uibModal'
    ];
    return EditBundleItemsComponent;
}());
angular.module('naut').component('editBundleItemsComponent', {
    template: __webpack_require__(725),
    controller: EditBundleItemsComponent,
    controllerAs: 'ctrl',
    bindings: {
        componentList: '=',
        waiting: '<'
    },
    require: {
        form: '^form'
    }
});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var NewEditBundleComponent = /** @class */ (function () {
    function NewEditBundleComponent($localStorage, notificationService, bundlesService, $state, $translate, productService) {
        this.$localStorage = $localStorage;
        this.notificationService = notificationService;
        this.bundlesService = bundlesService;
        this.$state = $state;
        this.$translate = $translate;
        this.productService = productService;
        this.waiting = false;
        this.defaultBundle = {
            Components: [{
                    Name: null,
                    Quantity: 1,
                    Variations: []
                }],
            Description: null,
            LogoImageID: null,
            Name: null,
            BundleValue: {
                Price: null,
                DiscountPercent: null
            },
            ValidFrom: null,
            ValidTo: null,
            ID: null
        };
    }
    NewEditBundleComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = parseInt(this.$state.params.id, 10);
                        this.isNew = isNaN(id);
                        if (!!this.isNew) return [3 /*break*/, 2];
                        this.bundleID = id;
                        return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.bundle = __assign({}, this.defaultBundle);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NewEditBundleComponent.prototype.isBundleValid = function () {
        var _this = this;
        var logoCorrect = this.bundle.LogoImageID != null;
        var correctComponentFound = this.bundle.Components.find(function (item) { return !!item.Name && item.Variations.length > 0; }) != null;
        var noComponentWithErrors = this.bundle.Components.length > 0 && this.bundle.Components.find(function (item) { return !_this.isValidComponent(item); }) == null;
        var formValid = this.form.$valid && this.bundle.Name &&
            (this.bundle.BundleValue.Price || this.bundle.BundleValue.DiscountPercent)
            && this.bundle.Description;
        return formValid && logoCorrect && noComponentWithErrors && correctComponentFound;
    };
    NewEditBundleComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var savingBundle, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.validForSave()) {
                            this.notificationService.showErrorMessage(this.$translate.instant('form_has_errors'));
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, , 9]);
                        if (!(!this.isNew && this.originalBundle.LogoImageID !== this.bundle.LogoImageID)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.bundlesService.removeLogoImage(this.originalBundle.LogoImageID)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        savingBundle = this.getSavingBundle();
                        if (!this.isNew) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bundlesService.createBundle(savingBundle)];
                    case 4:
                        _a = _b.sent();
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.bundlesService.updateBundle(this.bundleID, savingBundle)];
                    case 6:
                        _a = _b.sent();
                        _b.label = 7;
                    case 7:
                        _a;
                        this.notificationService.showSuccessMessage();
                        this.waiting = false;
                        this.$state.go('app.bundles');
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _b.sent();
                        this.waiting = false;
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    NewEditBundleComponent.prototype.restore = function () {
        var bundleToRestore = this.isNew ? __assign({}, this.defaultBundle) : __assign({}, this.originalBundle);
        this.bundle = angular.copy(bundleToRestore);
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    };
    NewEditBundleComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var metadata, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.productService.getMetadata()];
                    case 2:
                        metadata = _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.bundlesService.getBundle(this.bundleID)];
                    case 3:
                        _a.originalBundle = _b.sent();
                        this.bundlesService.fillSizeAndColourNames(this.originalBundle, metadata);
                        this.restore();
                        this.notificationService.clearAll();
                        this.waiting = false;
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        this.waiting = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    NewEditBundleComponent.prototype.validForSave = function () {
        var _this = this;
        if (this.waiting || !this.isBundleValid()) {
            return false;
        }
        return this.bundle.Components.reduce(function (checkValue, component) {
            component.errors = {
                name: !component.Name,
                noVariations: component.Variations.length === 0
            };
            return checkValue && _this.isValidComponent(component);
        }, true);
    };
    NewEditBundleComponent.prototype.isValidComponent = function (component) {
        return !(component.errors &&
            (component.errors.name ||
                component.errors.noVariations));
    };
    NewEditBundleComponent.prototype.getSavingBundle = function () {
        return {
            Name: this.bundle.Name,
            LogoImageID: this.bundle.LogoImageID,
            BundleValue: {
                Price: this.bundle.BundleValue.Price,
                DiscountPercent: this.bundle.BundleValue.DiscountPercent
            },
            Description: this.bundle.Description,
            ValidTo: this.bundle.ValidTo ? this.bundle.ValidTo : null,
            ValidFrom: this.bundle.ValidFrom ? this.bundle.ValidFrom : null,
            Components: this.bundle.Components.map(function (component) {
                return {
                    Name: component.Name,
                    Quantity: component.Quantity,
                    VariationIDs: component.Variations.map(function (variation) { return variation.VariationID; })
                };
            })
        };
    };
    NewEditBundleComponent.$inject = [
        '$localStorage',
        'notificationService',
        'bundlesService',
        '$state',
        '$translate',
        'productsService'
    ];
    return NewEditBundleComponent;
}());
angular.module('naut').component('newEditBundleComponent', {
    template: __webpack_require__(726),
    controller: NewEditBundleComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var BundlesService = /** @class */ (function () {
    function BundlesService(http, retailerService, blobService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.blobService = blobService;
        this.uploadLogoImage = function (dataUri) {
            var fd = new FormData();
            fd.append('FileImage', _this.blobService.dataUriToBlob(dataUri));
            return _this.http.post(_this.retailerService.storeBundleImage(), fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };
    }
    BundlesService.prototype.getBundleList = function (filter) {
        return this.http.get(this.retailerService.bundles(), { params: filter });
    };
    BundlesService.prototype.getBundle = function (bundleID) {
        return this.http.get(this.retailerService.bundleItem(bundleID));
    };
    BundlesService.prototype.getLogoImageUrl = function (logoID, width, height) {
        return this.retailerService.bundleImage(logoID, width, height);
    };
    BundlesService.prototype.removeLogoImage = function (logoID) {
        return this.http["delete"](this.retailerService.bundleImage(logoID));
    };
    BundlesService.prototype.getVariationImageUrl = function (id) {
        return this.retailerService.getProductImageUrl(id, 48, 48);
    };
    BundlesService.prototype.createBundle = function (bundle) {
        return this.http.post(this.retailerService.bundles(), bundle);
    };
    BundlesService.prototype.updateBundle = function (id, bundle) {
        return this.http.put(this.retailerService.bundleItem(id), bundle);
    };
    BundlesService.prototype.deleteBundle = function (id) {
        return this.http["delete"](this.retailerService.bundleItem(id));
    };
    BundlesService.prototype.getCategories = function (filter) {
        return this.http.get(this.retailerService.getCategoriesWithItemTypes(), { params: filter });
    };
    BundlesService.prototype.fillSizeAndColourNames = function (bundle, metadata) {
        if (bundle) {
            bundle.Components.forEach(function (component) {
                component.Variations.forEach(function (variation) {
                    var names = metadata.CategoryVariantFieldsNames[variation.CategoryID];
                    if (!names) {
                        names = metadata.DefaultVariantFieldsName;
                    }
                    variation.SizeName = names.SizeName ? names.SizeName : null;
                    variation.ColourName = names.ColourName ? names.ColourName : null;
                });
            });
        }
    };
    BundlesService.$inject = [
        'http',
        'retailerService',
        'blobService'
    ];
    return BundlesService;
}());
exports.BundlesService = BundlesService;
angular
    .module('naut')
    .service('bundlesService', BundlesService);


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var AudienceViewComponent = /** @class */ (function () {
    function AudienceViewComponent($translate) {
        this.$translate = $translate;
        this.rules = [];
        this.or = this.$translate.instant('op_or');
        this.and = this.$translate.instant('op_and');
        this.simpleTemplate = 'simpleAudienceView';
        this.ageTemplate = 'ageAudienceView';
        this.title = 'title';
        this.name = 'name';
        this.model = {
            ages: {
                template: this.ageTemplate,
                title: {
                    over: this.$translate.instant('op_is_aged_over'),
                    under: this.$translate.instant('op_is_aged_under')
                },
                operator: this.and,
                items: [],
                comparator: this.or
            },
            genders: {
                template: this.simpleTemplate,
                operator: this.and,
                title: this.$translate.instant('op_is_gender'),
                items: [],
                comparator: this.or
            },
            interests: {
                template: this.simpleTemplate,
                operator: this.and,
                comparator: this.or,
                title: this.$translate.instant('op_likes_interest'),
                items: []
            },
            categories: {
                template: this.simpleTemplate,
                operator: this.and,
                comparator: this.or,
                title: this.$translate.instant('op_is_in_category'),
                items: []
            },
            places: {
                template: this.simpleTemplate,
                operator: this.and,
                comparator: this.or,
                title: this.$translate.instant('op_is_in_place'),
                items: []
            }
        };
        this.ages = [
            { id: 1, min: null, max: 17 },
            { id: 2, min: 18, max: 20 },
            { id: 3, min: 21, max: 29 },
            { id: 4, min: 30, max: 39 },
            { id: 5, min: 40, max: 50 },
            { id: 6, min: 51, max: null }
        ];
        this.overAges = this.getOverAges();
        this.underAges = this.getUnderAges();
    }
    AudienceViewComponent.prototype.$onChanges = function (changes) {
        if ((changes.change || changes.audience && changes.audience.currentValue) && this.audience) {
            this.mapModel();
        }
    };
    AudienceViewComponent.prototype.mapModel = function () {
        this.rules = [];
        this.model.interests.items = this.mapGroup(this.audience.interests, false);
        this.model.genders.items = this.mapGroup(this.audience.genders, false);
        this.model.categories.items = this.mapCategoriesGroup(this.audience.categories, true);
        this.model.places.items = this.mapPlacesGroup(this.audience.places, true);
        this.model.ages.items = this.mapAgeGroup(this.audience.ages);
        if (!_.isEmpty(this.model.interests.items)) {
            this.rules.push(this.model.interests);
        }
        if (!_.isEmpty(this.model.genders.items)) {
            this.rules.push(this.model.genders);
        }
        if (!_.isEmpty(this.model.ages.items)) {
            this.rules.push(this.model.ages);
        }
        if (!_.isEmpty(this.model.places.items)) {
            this.rules.push(this.model.places);
        }
        if (!_.isEmpty(this.model.categories.items)) {
            this.rules.push(this.model.categories);
        }
    };
    AudienceViewComponent.prototype.mapGroup = function (group, showAll) {
        if (group.enabled) {
            var selected = _.where(group.items, { selected: true });
            return showAll ? _.pluck(selected, this.title) : _.size(selected) === _.size(group.items) ? [] : _.pluck(selected, this.title);
        }
        return [];
    };
    AudienceViewComponent.prototype.mapCategoriesGroup = function (group, showAll) {
        if (group.enabled) {
            var selected = _.where(group.items, { selected: true });
            return showAll ? _.pluck(selected, this.title) : _.size(selected) === _.size(group.items) ? [] : _.pluck(selected, this.title);
        }
        return [];
    };
    AudienceViewComponent.prototype.mapPlacesGroup = function (group, showAll) {
        if (group.enabled) {
            var selected = _.where(group.items, { selected: true });
            var maps = _.map(selected, function (item) { return item.title + " (" + item.town + ")"; });
            return showAll ? maps : _.size(selected) === _.size(group.items) ? [] : maps;
        }
        return [];
    };
    AudienceViewComponent.prototype.mapAgeGroup = function (audience) {
        var _this = this;
        var items = [];
        var genderIDs = [];
        if (audience.enabled) {
            var selected = _.where(audience.items, { selected: true });
            genderIDs = _.size(selected) === _.size(audience.items) ? [] : _.pluck(selected, 'id');
        }
        if (_.isEmpty(genderIDs)) {
            return items;
        }
        var ages = _.map(genderIDs, function (id) { return _.findWhere(_this.ages, { id: id }); });
        var groups = [];
        var group = [];
        var prev = 0;
        for (var i = 0; i < ages.length; i++) {
            var age = ages[i];
            if (_.size(group) === 0 || prev + 1 === age.id) {
                group.push(age.id);
            }
            else {
                groups.push(group);
                group = [age.id];
            }
            prev = age.id;
        }
        groups.push(group);
        var ageAudienceArray = [];
        _.forEach(groups, function (group) {
            ageAudienceArray.push(_this.getAgeAudienceGroup(group));
        });
        items = _.map(ageAudienceArray, function (ageAudience) {
            return _.map(ageAudience, function (age) {
                return {
                    title: age.title,
                    item: age.item
                };
            });
        });
        return items;
    };
    AudienceViewComponent.prototype.getAgeAudienceGroup = function (group) {
        var min = _.first(group), max = _.last(group);
        var hasGtRule = min >= _.first(this.underAges).id, hasLtRule = max <= _.last(this.overAges).id;
        min--;
        max++;
        if (hasGtRule && hasLtRule) {
            return [_.findWhere(this.overAges, { id: min }), _.findWhere(this.underAges, { id: max })];
        }
        else if (hasGtRule) {
            return [_.findWhere(this.overAges, { id: min })];
        }
        else if (hasLtRule) {
            return [_.findWhere(this.underAges, { id: max })];
        }
        else {
            throw new Error('Invalid age rule group');
        }
    };
    AudienceViewComponent.prototype.getOverAges = function () {
        var _this = this;
        return _.map(_.filter(this.ages, function (age) { return age.max; }), function (age) {
            return {
                id: age.id,
                item: age.max + " " + _this.$translate.instant('years'),
                title: _this.$translate.instant('op_is_aged_over')
            };
        });
    };
    AudienceViewComponent.prototype.getUnderAges = function () {
        var _this = this;
        return _.map(_.filter(this.ages, function (age) { return age.min; }), function (age) {
            return {
                id: age.id,
                item: age.min + " " + _this.$translate.instant('years'),
                title: _this.$translate.instant('op_is_aged_under')
            };
        });
    };
    AudienceViewComponent.$inject = ['$translate'];
    return AudienceViewComponent;
}());
angular.module('naut').component('audienceView', {
    template: __webpack_require__(727),
    controller: AudienceViewComponent,
    controllerAs: '$vm',
    bindings: {
        audience: '<',
        change: '<'
    }
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CampaignDescriptionController = /** @class */ (function () {
    function CampaignDescriptionController($localStorage) {
        this.$localStorage = $localStorage;
        this.campaign = null;
    }
    CampaignDescriptionController.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    CampaignDescriptionController.prototype.isNotDraft = function (item) {
        return !item.isDraft;
    };
    CampaignDescriptionController.$inject = ['$localStorage'];
    return CampaignDescriptionController;
}());
exports.CampaignDescriptionController = CampaignDescriptionController;
angular
    .module('naut')
    .component('campaignDescription', {
    template: __webpack_require__(728),
    controller: CampaignDescriptionController,
    bindings: {
        campaign: '<'
    }
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var CampaignsOverviewController = /** @class */ (function () {
    function CampaignsOverviewController($rootScope, campaignsService, notificationService, $translate) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.campaignsService = campaignsService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.isAdvertising = this.$rootScope.$state.current.name === 'app.advertising.overview';
        this.isRetailing = this.$rootScope.$state.current.name === 'app.marketing-campaigns.overview';
        this.waiting = true;
        this.loading = false;
        this.campaignType = this.$rootScope.enums.CampaignType;
        this.runningFilters = null;
        this.archivedFilters = null;
        this.storeFilter = {
            stores: [],
            store: null
        };
        this.campaigns = {
            running: [],
            runningFiltered: [],
            archived: [],
            archivedFiltered: [],
            isShowRunning: true,
            setData: function (campaigns) {
                var $self = _this.campaigns;
                var filtered = _.where(campaigns, { archived: false });
                $self.running = _.isUndefined(filtered) ? [] : filtered;
                filtered = _.where(campaigns, { archived: true });
                $self.archived = _.isUndefined(filtered) ? [] : filtered;
                $self.runningFiltered = $self.running;
                $self.archivedFiltered = $self.archived;
                _.forEach(_this.runningFilters, function (filter) {
                    if (filter.value) {
                        filter.show = _.any($self.running, function (c) {
                            return c.Status === filter.value;
                        });
                        return;
                    }
                    if (filter.isExclusiveOffer) {
                        filter.show = _.any($self.running, function (c) {
                            return c.IsExclusiveOffer;
                        });
                        return;
                    }
                    filter.show = $self.running.length > 0;
                });
                _.forEach(_this.archivedFilters, function (filter) {
                    if (filter.value) {
                        filter.show = _.any($self.archived, function (campaign) {
                            return campaign.Status === filter.value;
                        });
                    }
                    else {
                        filter.show = $self.archived.length > 0;
                    }
                });
            },
            setRunningFiltered: function (filter) {
                var $self = _this.campaigns;
                _.forEach(_this.runningFilters, function (runningFilter) {
                    runningFilter.active = false;
                });
                filter.active = true;
                var filterObj = _this.parseFilter(filter);
                $self.runningFiltered = filterObj ? _.where($self.running, filterObj) : $self.running;
                $self.runningFiltered = _this.getFilteredByStore($self.runningFiltered);
            },
            setArchivedFiltered: function (filter) {
                var $self = _this.campaigns;
                if (filter.value) {
                    $self.archivedFiltered = _.where($self.archived, { Status: filter.value });
                }
                else {
                    $self.archivedFiltered = $self.archived;
                }
                _.forEach(_this.archivedFilters, function (runningFilter) {
                    runningFilter.active = false;
                });
                filter.active = true;
                $self.archivedFiltered = _this.getFilteredByStore($self.archivedFiltered);
            }
        };
        this.campaignStatus = this.$rootScope.enums.CampaignStatus;
        this.gotoView = function (campaignID, $event) {
            $event.preventDefault();
            _this.waiting = true;
            _this.notificationService.showWaitingMessage();
            if (_this.isAdvertising) {
                _this.$rootScope.$state.go('app.advertising.campaign.view', { id: campaignID });
            }
            else if (_this.isRetailing) {
                _this.$rootScope.$state.go('app.marketing-campaigns.view', { id: campaignID });
            }
        };
        this.toggleShow = function (value) {
            _this.campaigns.isShowRunning = value;
        };
        this.addCampaign = function () {
            _this.waiting = true;
            _this.campaignsService.setEditableCampaign(null, false);
            if (_this.isAdvertising) {
                _this.$rootScope.$state.go('app.advertising.campaign.new');
            }
            else if (_this.isRetailing) {
                _this.$rootScope.$state.go('app.marketing-campaigns.new-branded');
            }
        };
        this.applyRunningFilter = function (filter) {
            _this.campaigns.setRunningFiltered(filter);
        };
        this.applyArchivedFilter = function (filter) {
            _this.campaigns.setArchivedFiltered(filter);
        };
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var campaigns, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, (this.campaignsService.getRetailCampaignsPreview())];
                    case 2:
                        campaigns = _b.sent();
                        _a = this.storeFilter;
                        return [4 /*yield*/, this.campaignsService.getStoresCampaigns()];
                    case 3:
                        _a.stores = _b.sent();
                        this.campaigns.setData(campaigns);
                        this.campaigns.isShowRunning = true; // $scope.campaigns.running.length > 0 || $scope.campaigns.archived.length === 0;
                        this.campaigns.setRunningFiltered(_.findWhere(this.runningFilters, { active: true }));
                        this.loading = true;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.runningFilters = [
            { key: this.$translate.instant('all'), value: null, active: false, show: false },
            { key: this.$translate.instant('exclusive_offer'), value: null, active: false, show: false, isExclusiveOffer: true },
            { key: this.$translate.instant('scheduled'), value: this.campaignStatus.Scheduled, active: false, show: false },
            { key: this.$translate.instant('active'), value: this.campaignStatus.Running, active: true, show: false },
            { key: this.$translate.instant('draft'), value: this.campaignStatus.Draft, active: false, show: false },
            { key: this.$translate.instant('ad_submission'), value: this.campaignStatus.AdSubmission, active: false, show: false },
            { key: this.$translate.instant('quality_control'), value: this.campaignStatus.QualityControl, active: false, show: false },
            { key: this.$translate.instant('disabled'), value: this.campaignStatus.Disabled, active: false, show: false },
            { key: this.$translate.instant('warning'), value: this.campaignStatus.Warning, active: false, show: false },
            { key: this.$translate.instant('error'), value: this.campaignStatus.Error, active: false, show: false }
        ];
        this.archivedFilters = [
            { key: this.$translate.instant('all'), value: null, active: true, show: false },
            { key: this.$translate.instant('archived'), value: this.campaignStatus.Archived, active: false, show: false },
            { key: this.$translate.instant('completed'), value: this.campaignStatus.Completed, active: false, show: false }
        ];
        this.init();
        $rootScope.$on('CampaignVideoProcessingFinish', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
        $rootScope.$on('CampaignVideoProcessingError', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
    }
    CampaignsOverviewController.prototype.applyStoreFilter = function () {
        var runningFilter = _.findWhere(this.runningFilters, { active: true });
        var archivedFilter = _.findWhere(this.archivedFilters, { active: true });
        if (runningFilter) {
            this.campaigns.setRunningFiltered(runningFilter);
        }
        if (archivedFilter) {
            this.campaigns.setArchivedFiltered(archivedFilter);
        }
    };
    CampaignsOverviewController.prototype.getFilteredByStore = function (campaigns) {
        var _this = this;
        if (this.storeFilter.store) {
            return _.filter(campaigns, function (campaign) {
                return _.any(_this.storeFilter.store.CampaignIDs, function (id) { return id === campaign.ID; });
            });
        }
        return campaigns;
    };
    CampaignsOverviewController.prototype.parseFilter = function (filter) {
        if (filter.value) {
            return { Status: filter.value };
        }
        if (filter.isExclusiveOffer) {
            return { IsExclusiveOffer: true };
        }
        return null;
    };
    CampaignsOverviewController.prototype.onUpdateCampaignVideoProcessing = function (event, data) {
        return __awaiter(this, void 0, void 0, function () {
            var itemRunning, itemRunningFiltered, newItem, error_2, indexRunning, indexRunningFiltered;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.CampaignID) {
                            return [2 /*return*/];
                        }
                        itemRunning = _.find(this.campaigns.running, function (element) {
                            return element.ID === data.CampaignID;
                        });
                        itemRunningFiltered = _.find(this.campaigns.runningFiltered, function (element) {
                            return element.ID === data.CampaignID;
                        });
                        if (!(itemRunning || itemRunningFiltered)) return [3 /*break*/, 5];
                        newItem = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.campaignsService.getRetailCampaign(data.CampaignID)];
                    case 2:
                        newItem = (_a.sent());
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        if (newItem) {
                            indexRunning = this.campaigns.running.indexOf(itemRunning);
                            if (indexRunning > 0) {
                                this.campaigns.running.splice(indexRunning, 1, newItem);
                            }
                            indexRunningFiltered = this.campaigns.runningFiltered.indexOf(itemRunningFiltered);
                            if (indexRunningFiltered > 0) {
                                this.campaigns.runningFiltered.splice(indexRunningFiltered, 1, newItem);
                            }
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CampaignsOverviewController.$inject = ['$rootScope', 'campaignsService', 'notificationService', '$translate'];
    return CampaignsOverviewController;
}());
exports.CampaignsOverviewController = CampaignsOverviewController;
angular
    .module('naut').component('campaignsOverview', {
    template: __webpack_require__(729),
    controller: CampaignsOverviewController,
    controllerAs: 'vm'
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var DesignRequestModalInstanceController = /** @class */ (function () {
    function DesignRequestModalInstanceController($timeout, FileUploader, designRequestService, popupService, notificationService, definitionsService, accountService, $translate) {
        var _this = this;
        this.$timeout = $timeout;
        this.FileUploader = FileUploader;
        this.designRequestService = designRequestService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.definitionsService = definitionsService;
        this.accountService = accountService;
        this.$translate = $translate;
        this.uploader = null;
        this.model = null;
        this.sessionID = null;
        this.waiting = false;
        this.result = false;
        this.modalInstance = this;
        this.maxQueueSize = 10;
        this.maxFileSizeMb = 50;
        this.queueSizeFilterName = 'queueSizeFilter';
        this.fileSizeFilterName = 'fileSizeFilter';
        this.uploaderFilterErrors = {
            fileSize: [],
            queueSize: [],
            clear: function () {
                var i = _this.uploaderFilterErrors;
                i.fileSize = [];
                i.queueSize = [];
            }
        };
        this.fileThumbs = {};
        this.getFileThumb = function (fileItem) {
            var name = fileItem.file && fileItem.file.name ? fileItem.file.name : '';
            name = name.substr(name.lastIndexOf('.') + 1);
            var classThumb = _this.fileThumbs[name];
            return _.isUndefined(classThumb) ? 'fa fa-file-o' : classThumb;
        };
        this.$onDestroy = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.result) {
                    this.designRequestService.deleteFiles(this.sessionID);
                }
                return [2 /*return*/];
            });
        }); };
        this.model = {
            Name: accountService.userData.firstName + " " + accountService.userData.lastName,
            Phone: accountService.userData.phoneNumber.PhoneNumber,
            Email: accountService.userData.email,
            Description: null,
            AttachedFilesID: null
        };
        this.getSessionID();
        this.initUploader();
        this.initFileThumbs();
    }
    DesignRequestModalInstanceController.prototype.ok = function () {
        if (this.isValidForm()) {
            this.submit();
        }
    };
    DesignRequestModalInstanceController.prototype.cancel = function () {
        this.modalInstance.dismiss({ $value: 'cancel' });
    };
    DesignRequestModalInstanceController.prototype.openMultipleInputup = function () {
        var el = $(angular.element('#multipleInputup'));
        this.$timeout(function () { el.click(); });
    };
    DesignRequestModalInstanceController.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.attachedFilesID();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.designRequestService.needHelp(this.sessionID, this.model)];
                    case 2:
                        _a.sent();
                        this.result = true;
                        this.notificationService.showSuccessMessage({
                            title: this.$translate.instant('design_request_thank_you'),
                            body: this.$translate.instant('design_request_sent')
                        });
                        this.$timeout(function () { _this.modalInstance.close({ $value: _this.result }); }, 500);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DesignRequestModalInstanceController.prototype.attachedFilesID = function () {
        this.model.AttachedFilesID = _.filter(_.pluck(this.uploader.queue, 'serverSideID'), function (id) { return _.isNumber(id); });
    };
    DesignRequestModalInstanceController.prototype.isValidForm = function () {
        this.model.Name = this.model.Name ? this.model.Name.trim() : '';
        this.model.Phone = this.model.Phone ? this.model.Phone.trim() : '';
        this.model.Email = this.model.Email ? this.model.Email.trim() : '';
        this.model.Description = this.model.Description ? this.model.Description.trim() : '';
        // name
        this.needHelpForm.name.$setValidity('required', this.model.Name.length > 0);
        if (!this.needHelpForm.name.$error.required) {
            this.needHelpForm.name.$setValidity('length', this.model.Name.length >= 3 && this.model.Name.length <= 40);
        }
        else {
            this.needHelpForm.name.$setValidity('length', true);
        }
        // phone
        this.needHelpForm.phone.$setValidity('required', this.model.Phone.length > 0);
        if (!this.needHelpForm.phone.$error.required) {
            this.needHelpForm.phone.$setValidity('length', this.model.Phone.length >= 6 && this.model.Phone.length <= 20);
        }
        else {
            this.needHelpForm.phone.$setValidity('length', true);
        }
        // email
        this.needHelpForm.email.$setValidity('required', this.model.Email.length > 0);
        if (!this.needHelpForm.email.$error.required) {
            this.needHelpForm.email.$setValidity('email', this.definitionsService.regexEmail.test(this.model.Email));
        }
        else {
            this.needHelpForm.email.$setValidity('email', true);
        }
        // description
        this.needHelpForm.description.$setValidity('required', this.model.Description.length > 0);
        return this.needHelpForm.$valid;
    };
    DesignRequestModalInstanceController.prototype.getSessionID = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.designRequestService.getSessionID()];
                    case 2:
                        _a.sessionID = _b.sent();
                        this.uploader.url = this.designRequestService.getUploaderUrl(this.sessionID);
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.needHelpForm.$setPristine();
                        return [2 /*return*/];
                }
            });
        });
    };
    DesignRequestModalInstanceController.prototype.initUploader = function () {
        var _this = this;
        var i = this;
        this.uploader = new this.FileUploader({
            headers: this.designRequestService.getAuthorizationBearer(),
            autoUpload: true
        });
        // filters
        this.uploader.filters.push({
            name: this.queueSizeFilterName,
            fn: function (item /* {File|FileLikeObject} */, options) {
                return this.queue.length < i.maxQueueSize;
            }
        });
        this.uploader.filters.push({
            name: this.fileSizeFilterName,
            fn: function (item /* {File|FileLikeObject} */, options) {
                return item.size / 1024 / 1024 < i.maxFileSizeMb;
            }
        });
        // events
        this.uploader.onSuccessItem = function (fileItem, id, status, headers) {
            fileItem.serverSideID = id;
            fileItem.errorMessage = null;
        };
        this.uploader.onProgressAll = function (progress) {
            _this.waiting = progress !== 100;
        };
        this.uploader.onErrorItem = function (fileItem, response, status, headers) {
            if (_.isNumber(status) && status > 0) {
                fileItem.errorMessage = 'Upload failed';
            }
            else {
                fileItem.errorMessage = 'Upload failed';
            }
        };
        this.uploader.onAfterAddingAll = function (addedItems) { return __awaiter(_this, void 0, void 0, function () {
            var listFile_1, aDropbox, aGoogleDrive, popupTitle, popupContent, popupTitle, popupContent, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.uploader.queue = _.filter(this.uploader.queue, function (item) {
                            return !item.excludeFromQueue;
                        });
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!(this.uploaderFilterErrors.fileSize.length > 0)) return [3 /*break*/, 3];
                        listFile_1 = '<div class="mb10">';
                        _.forEach(this.uploaderFilterErrors.fileSize, function (name) {
                            listFile_1 += '<div>' + name + '</div>';
                        });
                        listFile_1 += '</div>';
                        aDropbox = '<a href="https://www.dropbox.com/home"  target="_blank">Dropbox</a>';
                        aGoogleDrive = '<a href="https://drive.google.com/drive/my-drive"  target="_blank">Google Drive</a>';
                        popupTitle = this.$translate.instant('max_file_size_is', { maxFileSizeMb: this.maxFileSizeMb });
                        popupContent = "<div>" + this.$translate.instant('following_files_are_too_large', { maxFileSizeMb: this.maxFileSizeMb }) + "</div>" + listFile_1 + "<div>" + this.$translate.instant('please_use_storage_services', { dropbox: aDropbox, googleDrive: aGoogleDrive }) + "</div>";
                        return [4 /*yield*/, this.popupService.alert({
                                classPopup: 'width308',
                                title: popupTitle,
                                content: popupContent
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        if (!(this.uploaderFilterErrors.queueSize.length > 0)) return [3 /*break*/, 5];
                        popupTitle = this.$translate.instant('too_many_files');
                        popupContent = this.$translate.instant('too_many_files_details', { maxQueueSize: this.maxQueueSize })
                            || "<p>You can attach up to " + this.maxQueueSize + " files to this request.</p>";
                        return [4 /*yield*/, this.popupService.alert({
                                classPopup: 'width308',
                                title: popupTitle,
                                content: popupContent
                            })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_3 = _a.sent();
                        this.waiting = false;
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        this.uploaderFilterErrors.clear();
                        return [2 /*return*/];
                }
            });
        }); };
        this.uploader.onWhenAddingFileFailed = function (file /* {File|FileLikeObject} */, filter, options) {
            file.excludeFromQueue = true;
            if (filter.name === _this.queueSizeFilterName) {
                _this.uploaderFilterErrors.queueSize.push(file.name);
                _this.uploader.queue.push(file);
            }
            else if (filter.name === _this.fileSizeFilterName) {
                _this.uploaderFilterErrors.fileSize.push(file.name);
                _this.uploader.queue.push(file);
            }
        };
    };
    DesignRequestModalInstanceController.prototype.setFileThumbs = function (filesExtension, classExtension) {
        var _this = this;
        _.forEach(filesExtension.split(','), function (extension) {
            _this.fileThumbs[extension.trim()] = classExtension;
        });
    };
    DesignRequestModalInstanceController.prototype.initFileThumbs = function () {
        var archive = 'zip, rar, 7z, cab, gz, tar';
        this.setFileThumbs(archive, 'fa fa-file-archive-o');
        var img = 'ai, eps, psd, psb, jpg, jpeg, gif, png, cdr, svg, bmp, raw, cr2, nef, tga, tif, tiff, wmf';
        this.setFileThumbs(img, 'fa fa-file-image-o');
        var excel = 'xls, xlsx';
        this.setFileThumbs(excel, 'fa fa-file-excel-o');
        var word = 'doc, docx, rtf';
        this.setFileThumbs(word, 'fa fa-file-word-o');
        var powerpoint = 'ppt, pptx';
        this.setFileThumbs(powerpoint, 'fa fa-file-powerpoint-o');
        var text = 'txt, htm, html';
        this.setFileThumbs(text, 'fa fa-file-text-o');
        var pdf = 'pdf';
        this.setFileThumbs(pdf, 'fa fa-file-pdf-o');
    };
    DesignRequestModalInstanceController.$inject = ['$timeout', 'FileUploader', 'designRequestService', 'popupService', 'notificationService', 'definitionsService', 'accountService', '$translate'];
    return DesignRequestModalInstanceController;
}());
angular.module('naut').component('designRequest', {
    template: __webpack_require__(730),
    controller: DesignRequestModalInstanceController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var core_1 = __webpack_require__(56);
var createEditCampaignBase_controller_1 = __webpack_require__(240);
var CreateEditMarketingCampaignController = /** @class */ (function (_super) {
    __extends(CreateEditMarketingCampaignController, _super);
    function CreateEditMarketingCampaignController($rootScope, $scope, $timeout, commonCampaignsService, campaignsService, popupService, notificationService, htmlService, taOptions, wysiwygService, $q, shopService, classificationCategoriesService, $uibModal, $translate, retailerService, fileUploaderFactory, // FileUploaderFactory
        http, blobService, nfcRetailerStickersService, $localStorage, informationCardsService) {
        var _this = _super.call(this, $rootScope, $scope, $timeout, commonCampaignsService, campaignsService, popupService, notificationService, htmlService, taOptions, wysiwygService, $translate, retailerService, fileUploaderFactory, $q, http, blobService) || this;
        _this.shopService = shopService;
        _this.classificationCategoriesService = classificationCategoriesService;
        _this.$uibModal = $uibModal;
        _this.nfcRetailerStickersService = nfcRetailerStickersService;
        _this.$localStorage = $localStorage;
        _this.informationCardsService = informationCardsService;
        _this.isRetailerCampaign = true;
        _this.isCopy = null;
        _this.isEdit = null;
        _this.isNew = null;
        _this.htmlTooltip = {
            jispExclusivity: _this.$translate.instant('tooltip_jisp_exclusivity'),
            campaignType: _this.$translate.instant('tooltip_campaign_type'),
            geoTargeting: _this.$translate.instant('tooltip_geo_targeting'),
            referralOffer: _this.$translate.instant('tooltip_referral_offer'),
            videoProcessingTooltip: _this.$translate.instant('tooltip_video_process')
        };
        _this.audienceResource = null;
        _this.isLaunchCampaign = function () {
            return _this.campaign.statusModel.status === _this.campaignStatus.Running && !_this.isEdit;
        };
        _this.isValidMandatoryFields = function () {
            if (!_this.campaign) {
                return true;
            }
            // name
            if (!_this.campaign.name || _this.campaign.name.length === 0) {
                return false;
            }
            // design
            if (_this.campaign.campaignContentType !== 1 && !_this.imageCropped.croppedImage && !_this.video.videoID) {
                return false;
            }
            else if (_this.imageCropped.croppedImage !== null && _this.campaignForm && _this.campaignForm.useTemplate) {
                _this.validateCampaignImageSize();
                if (_this.campaignForm.useTemplate.$error.imageMinAreaSize) {
                    return false;
                }
            }
            return true;
        };
        _this.getErrorCampaignModel = function () {
            if (_this.isErrorDesignCampaignModel() || !_this.audienceService.validate.audiencePlaceGroup() || !_this.audienceService.validate.incompleteGroup()) {
                _this.campaign.statusModel.set(_this.campaignStatus.Error);
                return _this.campaign.statusModel;
            }
            _this.campaign.statusModel.set(_this.campaignStatus.Undefined);
            return _this.campaign.statusModel;
        };
        _this.getWarningCampaignModel = function () {
            // $scope.statusModel.set($scope.campaignStatus.Warning);
            _this.campaign.statusModel.set(_this.campaignStatus.Undefined);
            return _this.campaign.statusModel;
        };
        _this.isScheduledCampaign = function () {
            if (_this.isScheduledCampaignModel()) {
                _this.campaign.statusModel.set(_this.campaignStatus.Scheduled);
                return _this.campaign.statusModel;
            }
            _this.campaign.statusModel.set(_this.campaignStatus.Undefined);
            return _this.campaign.statusModel;
        };
        _this.isVideoProcessingCampaign = function () {
            if (_this.video && _this.video.videoID > 0) {
                if ((_this.video.campaignStatus === _this.campaignStatus.VideoProcessing) ||
                    (_this.video.campaignStatus === _this.campaignStatus.VideoProcessingError)) {
                    _this.campaign.statusModel.set(_this.video.campaignStatus);
                    return _this.campaign.statusModel;
                }
                else {
                    if (_this.campaign.videoStatus !== _this.videoStatus.Processed) {
                        if ((_this.campaign.videoStatus === _this.videoStatus.Added) ||
                            (_this.campaign.videoStatus === _this.videoStatus.Uploaded) ||
                            (_this.campaign.videoStatus === _this.videoStatus.Processing)) {
                            _this.campaign.statusModel.set(_this.campaignStatus.VideoProcessing);
                            return _this.campaign.statusModel;
                        }
                        else {
                            if (_this.campaign.videoStatus === _this.videoStatus.ProcessingError) {
                                _this.campaign.statusModel.set(_this.campaignStatus.VideoProcessingError);
                                return _this.campaign.statusModel;
                            }
                        }
                    }
                }
            }
            return _this.campaign.statusModel;
        };
        _this.setDefaultSchedule = function () {
            _this.campaign.schedule = _this.campaignsService.getDefaultCampaignSchedule();
        };
        _this.validateCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.campaignForm.$pristine = false;
                        this.validateCampaignImage();
                        this.validateCampaignName();
                        this.validateDate();
                        this.timeValidation();
                        this.validateWeeksday();
                        this.validateCampaignKeyword();
                        return [4 /*yield*/, this.validateStickers()];
                    case 1:
                        if (_a.sent()) {
                            this.campaignForm.$invalid = true;
                        }
                        if (this.isValidCampaignAudience()) {
                            this.campaign.offerAudience = this.audienceService.getOfferAudience();
                        }
                        this.updateAccordionState();
                        if (this.campaignForm.$invalid) {
                            this.campaignsService.scrollTop();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.validateDraftCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            var areStickersValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.campaignForm.$pristine = false;
                        // validate image
                        this.campaignForm.useTemplate.$setValidity('imageRequired', true);
                        this.campaignForm.useTemplate.$setValidity('imageMinAreaSize', true);
                        this.campaignForm.useTemplate.$setValidity('imageRequired', true);
                        if (this.imageCropped.croppedImage !== null) {
                            this.validateCampaignImageSize();
                        }
                        // campaign.name
                        this.validateCampaignName();
                        // validate template
                        this.campaignForm.useTemplate.$setValidity('templateRequired', true);
                        this.campaignForm.useTemplate.$setValidity('overflow', true);
                        // date
                        this.validateDate();
                        // time
                        this.timeValidation();
                        // weeksday
                        this.validateWeeksday();
                        // audience
                        if (this.isValidCampaignAudience()) {
                            this.campaign.offerAudience = this.audienceService.getOfferAudience();
                        }
                        this.updateAccordionState();
                        return [4 /*yield*/, this.validateStickers()];
                    case 1:
                        areStickersValid = _a.sent();
                        if (!areStickersValid) {
                            this.campaignForm.$invalid = true;
                        }
                        if (this.campaignForm.$invalid) {
                            this.campaignsService.scrollTop();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.validateStickers = function () {
            _this.stickersErrors = [];
            if (!_this.campaign.nfcStickers || (_this.campaign.nfcStickers && _this.campaign.nfcStickers.length === 0)) {
                return _this.$q.when(true);
            }
            var STICKER_NUMBER_PATTERN = new RegExp('[A-Z]{1}\\d{12}$');
            var stickersError = false;
            var duplicatesMap = _.groupBy(_this.campaign.nfcStickers, function (item) { return item.StickerNumber; });
            _this.campaign.nfcStickers.forEach(function (sticker, index) {
                var stickerHasError = false;
                var stickerError = {
                    id: index,
                    nfcNumber: null,
                    store: null
                };
                if (!sticker.StickerNumber) {
                    stickerHasError = true;
                    stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_required_error');
                }
                if (sticker.StickerNumber) {
                    if (!STICKER_NUMBER_PATTERN.test(sticker.StickerNumber)) {
                        stickerHasError = true;
                        stickerError.nfcNumber = _this.$translate.instant('nfc_product_stickers_list_sticker_format_error');
                    }
                    else {
                        var duplicates = duplicatesMap[sticker.StickerNumber];
                        if (duplicates && duplicates.length > 1) {
                            stickerHasError = true;
                            stickerError.nfcNumber = _this.$translate.instant('sticker_is_already_used');
                        }
                    }
                }
                if (!sticker.PlaceID) {
                    stickerHasError = true;
                    stickerError.store = _this.$translate.instant('nfc_product_stickers_list_location_required_error');
                }
                if (stickerHasError) {
                    _this.stickersErrors.push(stickerError);
                    stickersError = true;
                }
            });
            if (stickersError) {
                return _this.$q.when(false);
            }
            return _this.$q.when(true);
        };
        _this.updateAccordionState = function () {
            // errors groups
            var form = _this.campaignForm;
            var accordion = _this.accordionOptions;
            accordion.setupGroupError = form.campaignName.$invalid;
            accordion.designGroupError = form.useTemplate.$invalid;
            accordion.scheduleGroupError = (form.campaignStartDate.$invalid
                || form.campaignStartTime.$invalid
                || form.campaignEndDate.$invalid
                || form.campaignAlertDate.$invalid
                || form.campaignEndTime.$invalid
                || form.datesHasDaily.$invalid);
            accordion.audienceGroupError = form.rules.$invalid;
            accordion.keywordsGroupError = form.keywords.$invalid;
            if (accordion.setupGroupError) {
                accordion.setupGroupOpen = true;
            }
            if (accordion.designGroupError) {
                accordion.designGroupOpen = true;
            }
            if (accordion.scheduleGroupError) {
                accordion.scheduleGroupOpen = true;
            }
            if (accordion.audienceGroupError) {
                accordion.audienceGroupOpen = true;
            }
            if (accordion.keywordsGroupError) {
                accordion.keywordsGroupOpen = true;
            }
        };
        _this.timeValidation = function () {
            if (!_this.campaign.schedule.allDayStart && !_this.campaign.schedule.startTime) {
                _this.campaignForm.campaignStartTime.$setValidity('invalidTime', false);
            }
            else {
                _this.campaignForm.campaignStartTime.$setValidity('invalidTime', true);
            }
            if (!_this.campaign.schedule.allDayEnd && !_this.campaign.schedule.endTime) {
                _this.campaignForm.campaignEndTime.$setValidity('invalidTime', false);
            }
            else {
                _this.campaignForm.campaignEndTime.$setValidity('invalidTime', true);
            }
            if (!_this.campaign.schedule.allDayStart && !_this.campaign.schedule.allDayEnd && !_this.campaignForm.campaignStartTime.$error.invalidTime && !_this.campaignForm.campaignEndTime.$error.invalidTime) {
                var validTime = new Date(_this.campaign.schedule.startTime.toString()).setSeconds(0, 0) !== new Date(_this.campaign.schedule.endTime.toString()).setSeconds(0, 0);
                _this.campaignForm.campaignStartTime.$setValidity('invalidTime', validTime);
                _this.campaignForm.campaignEndTime.$setValidity('invalidTime', validTime);
            }
        };
        _this.isCopy = !!_this.ID && $rootScope.$state.current.name === 'app.marketing-campaigns.copy';
        _this.isEdit = !!_this.ID && $rootScope.$state.current.name === 'app.marketing-campaigns.edit';
        _this.isNew = $rootScope.$state.current.name === 'app.marketing-campaigns.new-branded' || $rootScope.$state.current.name === 'app.marketing-campaigns.new-templated';
        $rootScope.$on('CampaignVideoProcessingFinish', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
        $rootScope.$on('CampaignVideoProcessingError', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
        return _this;
    }
    CreateEditMarketingCampaignController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var checkCanEditStickers, result, promise, imgData, time, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        checkCanEditStickers = this.nfcRetailerStickersService.checkCanEditStickers();
                        return [4 /*yield*/, this.$q.all([
                                this.isNew ? this.campaignsService.getDefaultCampaignModel(this.$rootScope.enums.CampaignType.Promotion) : this.campaignsService.getEditableCampaign(this.ID),
                                this.campaignsService.getAudience(),
                                this.nfcRetailerStickersService.getLocations({}),
                                checkCanEditStickers
                            ])];
                    case 2:
                        result = _a.sent();
                        this.notificationService.clearAll();
                        this.campaign = result[0];
                        this.audienceResource = result[1];
                        this.stores = result[2].Items;
                        this.canEditStickers = result[3];
                        this.audienceService.model = this.campaignsService.getAudienceModel(this.audienceResource, this.campaign.offerAudience);
                        promise = this.campaignsService.getCountry();
                        promise.then(function (result) {
                            _this.campaign.currencySign = result.CurrencySign;
                        });
                        if (!(this.campaign.image && this.campaign.campaignContentType === 2 || this.campaign.campaignContentType === 4)) return [3 /*break*/, 5];
                        this.imageCropped.isGif = this.campaign.campaignContentType === 4;
                        this.imageCropped.imageUrl = this.campaign.image.imageUrl;
                        if (!this.imageCropped.isGif) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.blobService.getDataImageByUrl(this.campaign.image.imageUrl)];
                    case 3:
                        imgData = _a.sent();
                        this.setImageCropped(imgData);
                        return [3 /*break*/, 5];
                    case 4:
                        this.imageCropped.src = this.campaign.image.imageUrl;
                        _a.label = 5;
                    case 5:
                        if (this.campaign.video && this.campaign.campaignContentType === 3) {
                            this.video = this.campaign.video;
                            this.videos.push(this.video);
                            this.videoManager.processing = ((this.campaign.videoStatus === this.videoStatus.Added) ||
                                (this.campaign.videoStatus === this.videoStatus.Uploaded) ||
                                (this.campaign.videoStatus === this.videoStatus.Processing));
                            this.videoManager.processed = this.campaign.videoStatus === this.videoStatus.Processed;
                            this.videoManager.processingError = this.campaign.videoStatus === this.videoStatus.ProcessingError;
                        }
                        if (this.campaign.statusModel.status === this.campaignStatus.Error) {
                            this.campaignForm.$setDirty();
                        }
                        else {
                            this.campaignForm.$setPristine();
                        }
                        if (this.isEdit && this.campaign.entityStatus === core_1.Campaign.EntityStatusEnum.NUMBER_5) {
                            this.waiting = true;
                            time = 3000;
                            this.notificationService.showErrorMessage({
                                body: this.$translate.instant('campaing_is_archived'),
                                timeout: time
                            });
                            this.$timeout(function () {
                                if (window.history.state) {
                                    window.history.back();
                                }
                                else {
                                    _this.$rootScope.$state.go('app.marketing-campaigns.overview');
                                }
                            }, time);
                            this.waiting = true;
                        }
                        this.setHeightPanel();
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(_.isString(error_1) ? error_1 : error_1.message);
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        this.setHeightPanel();
                        this.$scope.$watch('vm.isValidMandatoryFields()', function (value, old) {
                            if (!value && old) {
                                _this.campaign.entityStatus = core_1.Campaign.EntityStatusEnum.NUMBER_1;
                            }
                        });
                        this.$scope.$watch('vm.getCropImageDivWidth()', function (width) {
                            if (width) {
                                _this.imageCropped.maxWidth = width;
                            }
                        });
                        this.$scope.$watch('vm.imageCropped.croppedImage', function (value) {
                            _this.$timeout(function () { _this.campaignsService.resizeFont(); });
                            if (_this.campaign && _this.campaign.statusModel) {
                                _this.campaign.statusModel = _this.getCampaignStatusModel();
                            }
                        });
                        this.$scope.$watch('vm.video.videoID', function (value) {
                            _this.$timeout(function () { _this.campaignsService.resizeFont(); });
                            if (_this.campaign && _this.campaign.statusModel) {
                                _this.campaign.statusModel = _this.getCampaignStatusModel();
                            }
                        });
                        this.$scope.$watch('vm.campaign.type', function (value) {
                            _this.accordionOptions.scheduleGroupShow = !_this.campaign.isExclusiveOffer && value !== _this.campaignType.SpecialEvent;
                        });
                        this.$scope.$watch('vm.campaign.isExclusiveOffer', function (value) {
                            _this.accordionOptions.scheduleGroupShow = !value && _this.campaign.type !== _this.campaignType.SpecialEvent;
                        });
                        this.$scope.$watch('vm.campaign', function () {
                            if (_this.campaign && _this.campaign.statusModel) {
                                _this.campaign.statusModel = _this.getCampaignStatusModel();
                            }
                        }, true);
                        this.$scope.$watch('vm.accordion.designGroupOpen', function (value) {
                            if (value === undefined) {
                                return;
                            }
                            if (_this.campaignForm.$pristine) {
                                _this.campaignForm.$setPristine();
                            }
                            if (value) {
                                _this.campaignsService.resizeFontWithTimeOut();
                            }
                        });
                        this.initWatch();
                        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.addProductLinks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var promise, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.$uibModal.open({
                            component: 'productSearch',
                            resolve: {
                                items: function () { return _this.campaign.campaignProductLinks; }
                            }
                        });
                        return [4 /*yield*/, promise
                                .result["catch"](angular.noop)];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            return [2 /*return*/];
                        }
                        this.campaign.campaignProductLinks = result;
                        this.campaignForm.$setDirty();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.addInfotagLinks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var promise, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.$uibModal.open({
                            component: 'infoCardSearch',
                            resolve: {
                                items: function () { return _this.campaign.campaignInformationCardLinks; }
                            }
                        });
                        return [4 /*yield*/, promise
                                .result["catch"](angular.noop)];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            return [2 /*return*/];
                        }
                        this.campaign.campaignInformationCardLinks = result.map(function (item) { return ({
                            ImageID: item.ImageID,
                            InformationCardID: item.ID,
                            Title: item.Title
                        }); });
                        this.campaignForm.$setDirty();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.getImageUrl = function (imageID) {
        return this.informationCardsService.getImageUrl(imageID, 60);
    };
    CreateEditMarketingCampaignController.prototype.removeProductLink = function (link) {
        this.campaign.campaignProductLinks = _.reject(this.campaign.campaignProductLinks, function (l) { return l.productId === link.productId; });
        this.campaignForm.$setDirty();
    };
    CreateEditMarketingCampaignController.prototype.removeInfotagLink = function (link) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.popupService.confirm({
                            classPopup: 'alert--redesign',
                            title: this.$translate.instant('delete_infotag_title'),
                            content: "<p class=\"fs-14\">" + this.$translate.instant('delete_infotag_content') + "</p>"
                        })];
                    case 1:
                        _a.sent();
                        this.campaign.campaignInformationCardLinks = _.reject(this.campaign.campaignInformationCardLinks, function (l) { return l.ID === link.ID; });
                        this.campaignForm.$setDirty();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var draftStatusList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.accordionOptions.scheduleGroupShow) {
                            this.setDefaultSchedule();
                        }
                        draftStatusList = [core_1.Campaign.EntityStatusEnum.NUMBER_1,
                            core_1.Campaign.EntityStatusEnum.NUMBER_2, core_1.Campaign.EntityStatusEnum.NUMBER_3];
                        if (!(draftStatusList.indexOf(this.campaign.entityStatus) > -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateDraftCampaign()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.validateCampaign()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.campaignForm.$invalid) {
                            $('html, body').animate({ scrollTop: 0 }, 500);
                            return [2 /*return*/];
                        }
                        this.saveCampaign();
                        this.instanceWysiwygService.deleteRemovedTokens(this.campaign.additionalInfo);
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.saveCampaign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var campaignID, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        campaignID = void 0;
                        if (!this.isEdit) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.updateCampaign()];
                    case 2:
                        campaignID = _a.sent();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.createCampaign()];
                    case 4:
                        campaignID = _a.sent();
                        this.notificationService.showSuccessMessage(this.$translate.instant('camapign_created'));
                        return [4 /*yield*/, this.$timeout(500)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.$rootScope.$state.go('app.marketing-campaigns.view', { id: campaignID });
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 8];
                    case 8:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateEditMarketingCampaignController.prototype.getCampaignStatusModel = function () {
        this.campaign.statusModel.clear();
        if (this.waiting) {
            return this.campaign.statusModel;
        }
        if (!this.campaign) {
            return null;
        }
        switch (this.campaign.entityStatus) {
            case core_1.Campaign.EntityStatusEnum.NUMBER_1:
                this.campaign.statusModel.set(this.campaignStatus.Draft);
                return this.campaign.statusModel;
            case core_1.Campaign.EntityStatusEnum.NUMBER_2:
                this.campaign.statusModel.set(this.campaignStatus.AdSubmission);
                return this.campaign.statusModel;
            case core_1.Campaign.EntityStatusEnum.NUMBER_3:
                this.campaign.statusModel.set(this.campaignStatus.QualityControl);
                return this.campaign.statusModel;
        }
        if (this.isCompletedCampaignModel()) {
            this.campaign.statusModel.set(this.campaignStatus.Completed);
            return this.campaign.statusModel;
        }
        this.campaign.statusModel = this.getErrorCampaignModel();
        if (this.campaign.statusModel.status === this.campaignStatus.Error) {
            return this.campaign.statusModel;
        }
        this.campaign.statusModel = this.getWarningCampaignModel();
        if (this.campaign.statusModel.status === this.campaignStatus.Warning) {
            return this.campaign.statusModel;
        }
        this.campaign.statusModel = this.isScheduledCampaign();
        if (this.campaign.statusModel.status === this.campaignStatus.Scheduled) {
            return this.campaign.statusModel;
        }
        this.campaign.statusModel = this.isVideoProcessingCampaign();
        if ((this.campaign.statusModel.status === this.campaignStatus.VideoProcessingError) ||
            (this.campaign.statusModel.status === this.campaignStatus.VideoProcessing)) {
            return this.campaign.statusModel;
        }
        this.campaign.statusModel.set(this.campaignStatus.Running);
        return this.campaign.statusModel;
    };
    CreateEditMarketingCampaignController.prototype.onUpdateCampaignVideoProcessing = function (event, data) {
        return __awaiter(this, void 0, void 0, function () {
            var doRefresh;
            return __generator(this, function (_a) {
                if (this.video && this.video.videoID === data.CampaignVideoID) {
                    doRefresh = false;
                    if (event.name === 'CampaignVideoProcessingFinish') {
                        this.notificationService.showSuccessMessage(this.$translate.instant('campaign_video_processed_successfully'));
                        this.video.campaignStatus = this.campaignStatus.Running;
                        this.campaign.videoStatus = this.videoStatus.Processed;
                        this.videoManager.processing = false;
                        this.videoManager.processed = true;
                        doRefresh = true;
                    }
                    else if (event.name === 'CampaignVideoProcessingError') {
                        this.notificationService.showErrorMessage(this.$translate.instant('campaign_video_processed_error'));
                        this.video.campaignStatus = this.campaignStatus.VideoProcessingError;
                        this.campaign.videoStatus = this.videoStatus.ProcessingError;
                        this.videoManager.processing = false;
                        this.videoManager.processingError = false;
                        doRefresh = true;
                    }
                    if (doRefresh && this.campaign && this.campaign.statusModel) {
                        this.campaign.statusModel = this.getCampaignStatusModel();
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    CreateEditMarketingCampaignController.$inject = [
        '$rootScope', '$scope', '$timeout', 'commonCampaignsService',
        'campaignsService', 'popupService', 'notificationService',
        'htmlService', 'appWysiwygOptions', 'wysiwygService', '$q', 'shopService',
        'classificationCategoriesService', '$uibModal', '$translate', 'retailerService',
        'FileUploader', 'http', 'blobService', 'nfcRetailerStickersService', '$localStorage', 'informationCardsService'
    ];
    return CreateEditMarketingCampaignController;
}(createEditCampaignBase_controller_1.CreateEditCampaignBase));
exports.CreateEditMarketingCampaignController = CreateEditMarketingCampaignController;
angular.module('naut').component('marketingCampaign', {
    template: __webpack_require__(731),
    controller: CreateEditMarketingCampaignController,
    controllerAs: 'vm'
});


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var core_1 = __webpack_require__(56);
var MarketingViewCampaignController = /** @class */ (function () {
    function MarketingViewCampaignController($scope, $state, campaignsService, commonCampaignsService, notificationService, $rootScope, $timeout, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$state = $state;
        this.campaignsService = campaignsService;
        this.commonCampaignsService = commonCampaignsService;
        this.notificationService = notificationService;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.campaign = null;
        this.videos = [];
        this.isRetailing = true;
        this.customScroll = this.campaignsService.customScrollView;
        this.isArchived = false;
        this.shopID = null;
        this.copyCampaign = function () {
            _this.campaignsService.setEditableCampaign(_this.campaign, true);
            _this.$state.go('app.marketing-campaigns.copy', { id: _this.shopID });
        };
        this.editCampaign = function () {
            _this.campaignsService.setEditableCampaign(_this.campaign, false);
            _this.$state.go('app.marketing-campaigns.edit', { id: _this.shopID });
        };
        this.$onInit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.shopID = this.$state.params.id;
                        return [4 /*yield*/, this.refreshCampaign()];
                    case 1:
                        _a.sent();
                        promise = this.campaignsService.getCountry();
                        promise.then(function (result) {
                            _this.currencySign = result.CurrencySign;
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.refreshCampaign = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, audienceResource, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        this.notificationService.showWaitingMessage();
                        _a = this;
                        return [4 /*yield*/, this.campaignsService.getCampaign(this.shopID)];
                    case 1:
                        _a.campaign = _b.sent();
                        this.campaign.currencySign = this.currencySign;
                        this.isArchived = this.campaign.entityStatus === core_1.Campaign.EntityStatusEnum.NUMBER_5;
                        if (!this.campaign.video) return [3 /*break*/, 3];
                        this.videos = [];
                        return [4 /*yield*/, this.$timeout(0)];
                    case 2:
                        _b.sent();
                        this.videos.push(this.campaign.video);
                        _b.label = 3;
                    case 3: return [4 /*yield*/, this.campaignsService.getAudience()];
                    case 4:
                        audienceResource = _b.sent();
                        this.audienceOffer = this.campaignsService.getAudienceModel(audienceResource, this.campaign.offerAudience);
                        this.campaignsService.resizeFontWithTimeOut();
                        this.$scope.$emit('campaignsPanelChanged');
                        this.customScroll();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        $scope.$on('$includeContentRequested', function (event, url) {
            notificationService.showWaitingMessage();
        });
        $scope.$on('$includeContentLoaded', function (event, url) {
            notificationService.clearAll();
        });
        $scope.$on('$includeContentError', function (event, url) {
            notificationService.showErrorMessage();
        });
        $rootScope.$on('CampaignVideoProcessingFinish', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
        $rootScope.$on('CampaignVideoProcessingError', function (event, data) { return _this.onUpdateCampaignVideoProcessing(event, data); });
    }
    MarketingViewCampaignController.prototype.onUpdateCampaignVideoProcessing = function (event, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.CampaignID) {
                            return [2 /*return*/];
                        }
                        if (!(data.CampaignID === this.shopID)) return [3 /*break*/, 2];
                        // if (event.name === 'CampaignVideoProcessingFinish') {
                        //     this.notificationService.showSuccessMessage(this.$translate.instant('campaign_video_processed_successfully'));
                        // } else if (event.name === 'CampaignVideoProcessingError') {
                        //     this.notificationService.showErrorMessage(this.$translate.instant('campaign_video_processed_error'));
                        // }
                        return [4 /*yield*/, this.refreshCampaign()];
                    case 1:
                        // if (event.name === 'CampaignVideoProcessingFinish') {
                        //     this.notificationService.showSuccessMessage(this.$translate.instant('campaign_video_processed_successfully'));
                        // } else if (event.name === 'CampaignVideoProcessingError') {
                        //     this.notificationService.showErrorMessage(this.$translate.instant('campaign_video_processed_error'));
                        // }
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    MarketingViewCampaignController.$inject = ['$scope', '$state', 'campaignsService', 'commonCampaignsService', 'notificationService', '$rootScope', '$timeout', '$translate'];
    return MarketingViewCampaignController;
}());
exports.MarketingViewCampaignController = MarketingViewCampaignController;
angular
    .module('naut')
    .component('viewCampaign', {
    template: __webpack_require__(732),
    controller: MarketingViewCampaignController,
    controllerAs: 'vm'
});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
angular.module('naut').directive('imageonload', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('load', function () {
                // call the function that was passed
                if (attrs.imageonload) {
                    scope.$apply(attrs.imageonload);
                }
            });
        }
    };
});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var _ = __webpack_require__(1);
var core_1 = __webpack_require__(56);
var CampaignsService = /** @class */ (function () {
    function CampaignsService($timeout, http, $q, $uibModal, retailerService, shopService, commonCampaignsService, enumService, blobService, urlService, accountService) {
        var _this = this;
        this.$timeout = $timeout;
        this.http = http;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.shopService = shopService;
        this.commonCampaignsService = commonCampaignsService;
        this.enumService = enumService;
        this.blobService = blobService;
        this.urlService = urlService;
        this.accountService = accountService;
        this.initialCampaignImageData = null;
        this.editableCampaign = null;
        this.campaignModel = {
            id: null,
            name: null,
            additionalInfo: null,
            nfcStickers: [],
            entityStatus: core_1.Campaign.EntityStatusEnum.NUMBER_1,
            campaignContentType: 1,
            simpleAudienceMode: true,
            jispExclusive: false,
            geoTargeting: false,
            pushNotification: null,
            type: this.enumService.CampaignType.Offer,
            image: null,
            video: null,
            videoStatus: null,
            audience: {
                mode: '',
                groups: null,
                rules: null
            },
            schedule: this.getDefaultCampaignSchedule(),
            statusModel: this.getDefaultStatusModel(),
            createDate: null,
            isExclusiveOffer: false,
            keywords: [],
            campaignProductLinks: [],
            currencySign: '',
            offerAudience: this.getClientAudience(null),
            campaignInformationCardLinks: []
        };
        this.getRetailerCampaigns = function (offset, limit, sorting) {
            return _this.http.get(_this.retailerService.retailerCampaigns(offset, limit, sorting));
        };
        this.getStoresCampaigns = function () {
            return _this.http.get(_this.retailerService.storesCampaigns());
        };
        this.getRetailCampaignsPreview = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getCampaignsPreview(this.retailerService.retailerCampaigns(0, 0, { ID: 'ascending' }))];
            });
        }); };
        this.getRetailCampaign = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var campaign;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.retailerService.retailerCampaign(id))];
                    case 1:
                        campaign = _a.sent();
                        this.commonCampaignsService.adaptCampaignData(campaign);
                        return [2 /*return*/, campaign];
                }
            });
        }); };
        this.getCampaign = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var campaign;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.retailerService.campaign(id))];
                    case 1:
                        campaign = _a.sent();
                        this.initialCampaignImageData = null;
                        return [2 /*return*/, this.toClientCampaign(id, campaign)];
                }
            });
        }); };
        this.createCampaign = function (campaign, image, video) { return __awaiter(_this, void 0, void 0, function () {
            var uploadedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isNeedUploadImage(campaign.campaignContentType, image)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.uploadImage(image)];
                    case 1:
                        uploadedImage = _a.sent();
                        campaign.image = {
                            imageID: uploadedImage.ID,
                            imageUrl: this.retailerService.getCampaignImageUrl(uploadedImage.ID),
                            croppedImage: null,
                            fileName: null,
                            isGif: uploadedImage.Type === core_1.UploadedCampaignImage.TypeEnum.NUMBER_4
                        };
                        image.imageID = campaign.image.imageID;
                        image.imageUrl = campaign.image.imageUrl;
                        campaign.campaignContentType = uploadedImage.Type;
                        _a.label = 2;
                    case 2:
                        if (campaign.campaignContentType === this.enumService.CampaignContentType.Video && this.isSetCampaingVideo(video)) {
                            campaign.video = {
                                ID: video.ID,
                                VideoUrl: video.VideoUrl,
                                TeaserUrl: null,
                                ThumbnailUrl: video.ThumbnailUrl,
                                Width: video.Width,
                                Height: video.Height,
                                videoID: video.videoID,
                                campaignStatus: video.campaignStatus
                            };
                        }
                        return [4 /*yield*/, this.http.post(this.retailerService.campaign(), this.toServerCampaign(campaign))];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.toServerCampaign = function (model) {
            return {
                Name: model.name,
                NfcStickers: model.nfcStickers,
                PushNotification: model.pushNotification,
                StartDate: model.schedule.hasStartDate ? _this.asUtc(_this.commonCampaignsService.getDateTime(model.schedule.startDate.toString(), '00:00')) : null,
                EndDate: model.schedule.hasEndDate ? _this.asUtc(_this.commonCampaignsService.getDateTime(model.schedule.endDate.toString(), '00:00')) : null,
                AlertDate: model.schedule.hasAlertDate ? _this.asUtc(_this.commonCampaignsService.getDateTime(model.schedule.alertDate.toString(), '00:00')) : null,
                Description: _this.replaceTags(model.additionalInfo),
                EntityStatus: model.entityStatus,
                ImageID: model.campaignContentType === _this.enumService.CampaignContentType.Video ? null : model.image ? model.image.imageID : null,
                VideoID: model.campaignContentType !== _this.enumService.CampaignContentType.Video ? null : model.video ? model.video.videoID : null,
                DailyStartTime: model.schedule.allDayStart && model.schedule.allDayEnd ? null : _this.commonCampaignsService.getTimeString(model.schedule.allDayStart, new Date(model.schedule.startTime.toString())),
                DailyEndTime: model.schedule.allDayEnd && model.schedule.allDayStart ? null : _this.commonCampaignsService.getTimeString(model.schedule.allDayEnd, new Date(model.schedule.endTime.toString())),
                DaysOfWeek: model.schedule.hasDaily ? null : model.schedule.daysOfWeekInt,
                Type: model.type,
                JispExclusive: model.jispExclusive,
                GeoTargeting: model.geoTargeting,
                SimpleAudienceMode: model.simpleAudienceMode,
                IsExclusiveOffer: model.isExclusiveOffer,
                Keywords: _.map(model.keywords, function (item) {
                    return {
                        Keyword: item.keyword,
                        ID: item.id
                    };
                }),
                CampaignProductLinks: _.map(model.campaignProductLinks, function (link) {
                    return {
                        ID: link.id,
                        ProductID: link.productId
                    };
                }),
                CampaignInformationCardLinks: model.campaignInformationCardLinks,
                ContentType: model.campaignContentType,
                Audience: {
                    Ages: model.offerAudience.ages,
                    Genders: model.offerAudience.genders,
                    Interests: model.offerAudience.interests,
                    PlaceIDs: model.offerAudience.placeIDs,
                    CategoryIDs: model.offerAudience.categoryIDs
                }
            };
        };
        this.toClientCampaign = function (id, campaign) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var campaignInformationCardLinks, model;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignInformationCardLinks = angular.copy(campaign.CampaignInformationCardLinks);
                        return [4 /*yield*/, this.getDefaultCampaignModel(campaign.Type)];
                    case 1:
                        model = _a.sent();
                        model.id = id;
                        model.additionalInfo = campaign.Description;
                        model.name = campaign.Name;
                        model.nfcStickers = campaign.NfcStickers;
                        model.geoTargeting = campaign.GeoTargeting;
                        model.jispExclusive = campaign.JispExclusive;
                        model.pushNotification = campaign.PushNotification;
                        model.statusModel.set(campaign.Status, campaign.StatusMessage);
                        model.entityStatus = campaign.EntityStatus;
                        model.isExclusiveOffer = campaign.IsExclusiveOffer;
                        model.campaignProductLinks = _.map(campaign.CampaignProductLinks, function (link) {
                            return {
                                id: link.ID,
                                productId: link.ProductID,
                                title: link.Title,
                                imageId: link.ImageID,
                                minPrice: link.MinPrice,
                                maxPrice: link.MaxPrice,
                                imageUrl: _this.retailerService.getProductImageUrl(link.ImageID, 60, 60),
                                isDraft: link.IsDraft,
                                currencySign: link.CurrencySign
                            };
                        });
                        model.campaignInformationCardLinks = campaignInformationCardLinks;
                        model.keywords = _.map(campaign.Keywords, function (item) {
                            return {
                                id: item.ID,
                                keyword: item.Keyword,
                                error: null
                            };
                        });
                        if (campaign.ImageID) {
                            model.image = {
                                imageID: campaign.ImageID,
                                imageUrl: this.retailerService.getCampaignImageUrl(campaign.ImageID),
                                croppedImage: null,
                                fileName: null,
                                isGif: campaign.ContentType === core_1.UploadedCampaignImage.TypeEnum.NUMBER_4
                            };
                        }
                        if (campaign.VideoID && campaign.Video) {
                            model.video = {
                                ID: campaign.VideoID.toString(),
                                VideoUrl: campaign.Video.VideoUrl || this.retailerService.getCampaignVideoContentUrl(campaign.VideoID),
                                TeaserUrl: null,
                                ThumbnailUrl: this.retailerService.getCampaignThumbnailImageUrl(campaign.VideoID),
                                Width: campaign.Video.Width,
                                Height: campaign.Video.Height,
                                videoID: campaign.VideoID,
                                campaignStatus: campaign.Status
                            };
                            model.videoStatus = campaign.VideoStatus;
                        }
                        model.simpleAudienceMode = campaign.SimpleAudienceMode;
                        this.setSchedule(model.schedule, campaign);
                        model.createDate = campaign.CreateDate;
                        model.campaignContentType = campaign.ContentType;
                        model.offerAudience = this.getClientAudience(campaign.Audience);
                        return [2 /*return*/, model];
                }
            });
        }); };
        this.getDefaultCampaignModel = function (type) { return __awaiter(_this, void 0, void 0, function () {
            var defaultCampaign;
            return __generator(this, function (_a) {
                defaultCampaign = angular.copy(this.campaignModel);
                defaultCampaign.campaignContentType = 2;
                if (type) {
                    defaultCampaign.type = type;
                }
                return [2 /*return*/, defaultCampaign];
            });
        }); };
        this.updateCampaign = function (id, campaign, image, video) { return __awaiter(_this, void 0, void 0, function () {
            var uploadedImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isNeedUploadImage(campaign.campaignContentType, image)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.uploadImage(image)];
                    case 1:
                        uploadedImage = _a.sent();
                        campaign.image = {
                            imageID: uploadedImage.ID,
                            imageUrl: this.retailerService.getCampaignImageUrl(uploadedImage.ID),
                            croppedImage: null,
                            fileName: null,
                            isGif: uploadedImage.Type === core_1.UploadedCampaignImage.TypeEnum.NUMBER_4
                        };
                        image.imageID = campaign.image.imageID;
                        image.imageUrl = campaign.image.imageUrl;
                        campaign.campaignContentType = uploadedImage.Type;
                        _a.label = 2;
                    case 2:
                        if (campaign.campaignContentType === this.enumService.CampaignContentType.Video && this.isSetCampaingVideo(video)) {
                            campaign.video = {
                                ID: video.ID,
                                VideoUrl: video.VideoUrl,
                                TeaserUrl: null,
                                ThumbnailUrl: video.ThumbnailUrl,
                                Width: video.Width,
                                Height: video.Height,
                                videoID: video.videoID,
                                campaignStatus: video.campaignStatus
                            };
                        }
                        return [4 /*yield*/, this.http.put(this.retailerService.campaign(id), this.toServerCampaign(campaign))];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.setInitialCampaignImageData = function (imageID, base64Img) {
            if (_this.initialCampaignImageData == null || _this.initialCampaignImageData.id !== imageID) {
                _this.initialCampaignImageData = {
                    id: imageID,
                    base64: base64Img
                };
            }
        };
        this.deleteCampaign = function (id) {
            return _this.http["delete"](_this.retailerService.campaign(id));
        };
        this.getCampaignVideoMetadata = function (id) {
            return _this.http.get(_this.retailerService.campaignVideoGet(id));
        };
        this.deleteCampaignVideo = function (id) {
            return _this.http["delete"](_this.retailerService.campaignVideoDelete(id));
        };
        this.getImageUrl = function (id) {
            return _this.retailerService.getCampaignImageUrl(id);
        };
        this.getEditableCampaign = function (id) {
            if (_this.editableCampaign && (!id || _this.editableCampaign.id === id)) {
                return _this.$q.when(_this.editableCampaign);
            }
            else if (id) {
                return _this.$q.when(_this.getCampaign(id));
            }
            else {
                return _this.$q.when(angular.copy(_this.campaignModel));
            }
        };
        this.setEditableCampaign = function (value, isCopy) {
            if (value == null) {
                _this.editableCampaign = value;
            }
            else {
                var campaign = angular.copy(value);
                if (isCopy) {
                    campaign.name += ' (copy)';
                    campaign.nfcStickers = [];
                    campaign.entityStatus = core_1.Campaign.EntityStatusEnum.NUMBER_1;
                    if (campaign.schedule.endDate && (new Date(campaign.schedule.endDate.toDateString()).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0))) {
                        campaign.schedule.endDate = null;
                    }
                }
                _this.editableCampaign = campaign;
            }
        };
        this.getImageByID = function (id, responseType) {
            if (responseType) {
                return _this.http.get(_this.retailerService.getCampaignImageUrl(id), { responseType: responseType });
            }
            else {
                return _this.http.get(_this.retailerService.getCampaignImageUrl(id));
            }
        };
        this.resizeFont = function () {
            var areaWidth = $('.template-table').width();
            if (areaWidth != null) {
                $('.template-table, .paddingTemlate').css('font-size', 0.1 * areaWidth);
            }
            var areaWidthImg = $('.widthSelector').width();
            if (areaWidthImg != null) {
                $('.widthSelector').css('font-size', 0.1 * areaWidthImg);
            }
        };
        this.resizeFontWithTimeOut = function () {
            _this.$timeout(_this.resizeFont, 500);
            _this.$timeout(_this.resizeFont, 1000);
            _this.$timeout(_this.resizeFont, 1500);
        };
        this.customScrollView = function () {
            _this.$timeout(function () {
                $('.wrapPhoneInner').slimScroll({
                    height: '417px',
                    size: '4px',
                    alwaysVisible: true
                });
            }, 600);
        };
        this.setState = function (campaignID, draft) {
            return _this.http.put(_this.retailerService.campaignState(campaignID), draft);
        };
        this.scrollTop = function () {
            $('body').animate({ scrollTop: 0 }, 400);
            $('.panel-body').animate({ scrollTop: 0 }, 400);
            $('.overflow-quick-camp').animate({ scrollTop: 0 }, 400);
        };
        this.needHelp = function () {
            return _this.$uibModal.open({
                component: 'designRequest',
                resolve: {},
                size: 'lg',
                windowClass: 'help-design'
            }).result;
        };
        this.replaceTags = function (html) {
            if (html) {
                return html.replace(/<font [^\>]*>/g, '').replace(/<\/font>/g, '').replace(/<span [^\>]*>/g, '<span>');
            }
            else {
                return html;
            }
        };
        this.uploadImage = function (image) { return __awaiter(_this, void 0, void 0, function () {
            var blob, fd;
            return __generator(this, function (_a) {
                if (!image || !image.croppedImage) {
                    return [2 /*return*/, this.$q.reject('Cropped image is error')];
                }
                blob = this.blobService.dataUriToBlob(image.croppedImage);
                if (blob == null) {
                    return [2 /*return*/, this.$q.reject('Cropped image is error')];
                }
                fd = new FormData();
                fd.append('FileImage', blob, image.fileName);
                return [2 /*return*/, this.http.post(this.retailerService.campaignImage(), fd, {
                        transformRequest: angular.identity,
                        headers: { 'Content-Type': undefined }
                    })];
            });
        }); };
        this.convertFileToDataURLviaFileReader = function (url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };
        this.getCampaignsPreview = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var pagingResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.get(url)];
                    case 1:
                        pagingResult = _a.sent();
                        _.forEach(pagingResult.Items, function (campaign) {
                            _this.commonCampaignsService.adaptCampaignData(campaign);
                        });
                        return [2 /*return*/, pagingResult.Items];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, this.$q.reject(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        $(window).resize(this.resizeFont);
    }
    CampaignsService.prototype.getAuthorizationBearer = function () {
        return { Authorization: 'Bearer ' + this.accountService.getRetailerToken() };
    };
    CampaignsService.prototype.getUploadVideoUrl = function () {
        return this.retailerService.campaignVideo();
    };
    CampaignsService.prototype.getDefaultCampaignSchedule = function () {
        var getBitArrayByNumber = this.commonCampaignsService.getBitArrayByNumber;
        var getTimeString = this.commonCampaignsService.getTimeString;
        var startTime = this.commonCampaignsService.getDateTime(null, '09:00');
        var endTime = this.commonCampaignsService.getDateTime(null, '18:00');
        var startDate = this.commonCampaignsService.getDateTime(null, '00:00');
        var endDate = moment(startDate).add(1, 'd').toDate();
        return {
            hasStartDate: false,
            hasEndDate: false,
            hasAlertDate: false,
            allDayStart: true,
            allDayEnd: true,
            startDate: startDate,
            alertDate: endDate,
            startTime: startTime,
            endDate: endDate,
            endTime: endTime,
            hasDaily: true,
            daysOfWeek: angular.copy(this.commonCampaignsService.getDaysOfWeek()),
            daysOfWeekInt: null,
            setDaysOfWeek: function (flag) {
                angular.forEach(this.daysOfWeek, function (day) {
                    day.selected = flag;
                });
                this.daysOfWeekInt = 0;
            },
            changeWeeksday: function () {
                var bit = '';
                angular.forEach(angular.copy(this.daysOfWeek).reverse(), function (day) {
                    bit += day.selected ? '1' : '0';
                });
                this.daysOfWeekInt = parseInt(bit, 2);
            },
            setSelectedDaysOfWeek: function (number) {
                var numberBit = getBitArrayByNumber(number).split('').reverse().join('');
                for (var c = 0; c < numberBit.length; c++) {
                    this.daysOfWeek[c].selected = numberBit[c] === '1';
                }
            },
            getStartDate: function () {
                return this.hasStartDate ? this.startDate : null;
            },
            getEndDate: function () {
                return this.hasEndDate ? this.endDate : null;
            },
            getDailyStartTime: function () {
                return this.allDayStart ? null : getTimeString(false, this.startTime);
            },
            getDailyEndTime: function () {
                return this.allDayEnd ? null : getTimeString(false, this.endTime);
            },
            updateState: function () {
                this.startTime = this.allDayStart ? startTime : this.startTime;
                this.endTime = this.allDayEnd ? endTime : this.endTime;
            }
        };
    };
    CampaignsService.prototype.getCountry = function () {
        return this.http.get(this.retailerService.country()).then(function (country) {
            return country;
        });
    };
    CampaignsService.prototype.getAudience = function () {
        return this.http.get(this.retailerService.campaignAudience());
    };
    CampaignsService.prototype.getAudienceModel = function (audience, offerAudience) {
        var model = {
            ages: this.getSimpleAudienceModel(audience.Age, offerAudience.ages, this.enumService.OfferAudienceMapping.ages),
            genders: this.getSimpleAudienceModel(audience.Gender, offerAudience.genders, this.enumService.OfferAudienceMapping.genders),
            interests: this.getSimpleAudienceModel(audience.Interest, offerAudience.interests, this.enumService.OfferAudienceMapping.interests),
            places: this.getPlaceAudienceModel(audience.Places, offerAudience.placeIDs),
            categories: this.getCategoryAudienceModel(audience.Categories, offerAudience.categoryIDs)
        };
        return model;
    };
    CampaignsService.prototype.getSimpleAudienceModel = function (resource, selected, dictionary) {
        var items = _.map(resource, function (item) {
            return {
                id: item.ID,
                title: dictionary ? dictionary[item.ID] : _.isEmpty(item.Title) ? item.Name : item.Title,
                selected: _.isEmpty(selected) ? true : _.contains(selected, item.ID)
            };
        });
        return {
            enabled: !_.isEmpty(selected),
            selected: _.all(items, function (item) { return item.selected; }),
            items: items
        };
    };
    CampaignsService.prototype.getPlaceAudienceModel = function (resource, selected) {
        var items = _.map(resource, function (item) {
            return {
                id: item.ID,
                title: item.Name,
                town: item.Town,
                categoryIDs: item.CategoryIDs,
                isArchived: item.IsArchived,
                selected: _.isEmpty(selected) ? true : _.contains(selected, item.ID)
            };
        });
        return {
            enabled: !_.isEmpty(selected),
            selected: _.all(items, function (item) { return item.selected; }),
            items: items
        };
    };
    CampaignsService.prototype.getCategoryAudienceModel = function (resource, selected) {
        var items = _.map(resource, function (item) {
            return {
                id: item.ID,
                title: item.FullName,
                name: item.Name,
                placeIDs: item.PlaceIDs,
                selected: _.isEmpty(selected) ? true : _.contains(selected, item.ID)
            };
        });
        return {
            enabled: !_.isEmpty(selected),
            selected: _.all(items, function (item) { return item.selected; }),
            items: items
        };
    };
    CampaignsService.prototype.isNewCampaingImage = function (image) {
        var isImageCropped = image != null && !_.isEmpty(image.croppedImage);
        var isCampaignImage = this.initialCampaignImageData != null && this.initialCampaignImageData.base64 != null;
        return (isImageCropped && !isCampaignImage) || (isImageCropped && isCampaignImage && this.initialCampaignImageData.base64 !== image.croppedImage);
    };
    CampaignsService.prototype.isSetCampaingVideo = function (video) {
        return video != null && video.videoID > 0;
    };
    CampaignsService.prototype.asUtc = function (local) {
        return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes()));
    };
    CampaignsService.prototype.setSchedule = function (schedule, campaign) {
        var startTime = campaign.DailyStartTime ? this.commonCampaignsService.getDateTime(null, campaign.DailyStartTime) : schedule.startTime;
        var endTime = campaign.DailyEndTime ? this.commonCampaignsService.getDateTime(null, campaign.DailyEndTime) : schedule.endTime;
        schedule.hasStartDate = !!campaign.StartDate,
            schedule.hasEndDate = !!campaign.EndDate,
            schedule.hasAlertDate = !!campaign.AlertDate,
            schedule.startDate = this.commonCampaignsService.getDateTime(campaign.StartDate ? campaign.StartDate.toString() : null, '00:00'),
            schedule.endDate = this.commonCampaignsService.getDateTime(campaign.EndDate ? campaign.EndDate.toString() : null, '00:00'),
            schedule.alertDate = this.commonCampaignsService.getDateTime(schedule.hasAlertDate ? campaign.AlertDate.toString() : null, '00:00'),
            schedule.allDayStart = campaign.DailyStartTime == null || (startTime.getHours() === 0 && startTime.getMinutes() === 0),
            schedule.allDayEnd = campaign.DailyEndTime == null || (endTime.getHours() === 0 && endTime.getMinutes() === 0),
            schedule.startTime = startTime,
            schedule.endTime = endTime,
            schedule.hasDaily = campaign.DaysOfWeek == null,
            schedule.daysOfWeek = angular.copy(this.commonCampaignsService.getDaysOfWeek()),
            schedule.daysOfWeekInt = campaign.DaysOfWeek ? campaign.DaysOfWeek : 0;
        if (schedule.hasDaily) {
            schedule.setDaysOfWeek(true);
        }
        else {
            schedule.setSelectedDaysOfWeek(campaign.DaysOfWeek);
        }
    };
    CampaignsService.prototype.getDefaultStatusModel = function () {
        var statusUndefined = this.enumService.CampaignStatus.Undefined;
        return {
            status: statusUndefined,
            message: null,
            set: function (status, message) {
                this.status = status ? status : statusUndefined;
                this.message = message ? message : null;
            },
            clear: function () {
                this.status = statusUndefined;
                this.message = null;
            }
        };
    };
    CampaignsService.prototype.isNeedUploadImage = function (campaignContentType, image) {
        return (campaignContentType === this.enumService.CampaignContentType.Image || campaignContentType === this.enumService.CampaignContentType.Gif) && !_.isEmpty(image.croppedImage) && this.isNewCampaingImage(image);
    };
    CampaignsService.prototype.getClientAudience = function (audience) {
        if (audience) {
            return {
                ages: audience.Ages ? audience.Ages : [],
                genders: audience.Genders ? audience.Genders : [],
                interests: audience.Interests ? audience.Interests : [],
                placeIDs: audience.PlaceIDs ? audience.PlaceIDs : [],
                categoryIDs: audience.CategoryIDs ? audience.CategoryIDs : []
            };
        }
        return {
            ages: [],
            genders: [],
            interests: [],
            placeIDs: [],
            categoryIDs: []
        };
    };
    CampaignsService.$inject = ['$timeout', 'http', '$q', '$uibModal', 'retailerService', 'shopService',
        'commonCampaignsService', 'enumService', 'blobService', 'urlService', 'accountService'];
    return CampaignsService;
}());
exports.CampaignsService = CampaignsService;
angular
    .module('naut')
    .service('campaignsService', CampaignsService);


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DesignRequestService = /** @class */ (function () {
    function DesignRequestService($q, http, accountService, retailerService) {
        var _this = this;
        this.$q = $q;
        this.http = http;
        this.accountService = accountService;
        this.retailerService = retailerService;
        this.needHelp = function (sessionID, data) {
            return _this.http.post(_this.retailerService.designRequest(sessionID), data);
        };
    }
    DesignRequestService.prototype.deleteFiles = function (sessionID) {
        return this.http["delete"](this.retailerService.designRequest(sessionID));
    };
    DesignRequestService.prototype.getAuthorizationBearer = function () {
        return { 'Authorization': 'Bearer ' + this.accountService.getRetailerToken() };
    };
    DesignRequestService.prototype.getSessionID = function () {
        return this.http.post(this.retailerService.designRequest(), null);
    };
    DesignRequestService.prototype.getUploaderUrl = function (sessionID) {
        return this.retailerService.designRequestFile(sessionID);
    };
    DesignRequestService.$inject = ['$q', 'http', 'accountService', 'retailerService'];
    return DesignRequestService;
}());
exports.DesignRequestService = DesignRequestService;
angular
    .module('naut')
    .service('designRequestService', DesignRequestService);


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CategoriesSelectorService = /** @class */ (function () {
    function CategoriesSelectorService($uibModal, classificationCategoriesService, accountService) {
        var _this = this;
        this.$uibModal = $uibModal;
        this.classificationCategoriesService = classificationCategoriesService;
        this.accountService = accountService;
        this.selectClassificationCategoriesTree = function (excludedIDs, selectedIDs, showPrices, leafOnly, singleSelect) {
            return _this.$uibModal.open({
                component: 'selectClassificationCategoriesTree',
                size: 'md',
                windowClass: 'categories-selector-popup',
                resolve: {
                    options: function () {
                        return {
                            showPrices: showPrices,
                            excludedIDs: excludedIDs,
                            selectedIDs: selectedIDs,
                            leafOnly: leafOnly,
                            singleSelect: singleSelect,
                            recentlyUsedCategories: []
                        };
                    },
                    languageId: function () {
                        return _this.accountService.userData.languageID;
                    }
                }
            }).result;
        };
        this.selectClassificationCategories = function (selectedCategories, businessType, singleSelect, isOnlyStoreCategories, subcategoryId) {
            return _this.$uibModal.open({
                component: 'selectClassificationCategories',
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            singleSelect: singleSelect,
                            selectedCategories: selectedCategories,
                            businessType: businessType,
                            isOnlyStoreCategories: isOnlyStoreCategories,
                            subcategoryId: subcategoryId
                        };
                    },
                    languageId: function () {
                        return _this.accountService.userData.languageID;
                    }
                }
            }).result;
        };
    }
    CategoriesSelectorService.$inject = ['$uibModal', 'classificationCategoriesService', 'accountService'];
    return CategoriesSelectorService;
}());
exports.CategoriesSelectorService = CategoriesSelectorService;
angular.module('naut').service('categoriesSelectorService', CategoriesSelectorService);


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var viewport_typed_controller_1 = __webpack_require__(4);
var ClickAndDeliverController = /** @class */ (function (_super) {
    __extends(ClickAndDeliverController, _super);
    function ClickAndDeliverController($scope, $translate) {
        var _this = _super.call(this, $scope) || this;
        _this.$scope = $scope;
        _this.$translate = $translate;
        return _this;
    }
    ClickAndDeliverController.$inject = ['$scope', '$translate'];
    return ClickAndDeliverController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut')
    .component('clickAndDeliver', {
    template: __webpack_require__(733),
    controller: ClickAndDeliverController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SidebarController = /** @class */ (function () {
    function SidebarController($rootScope, anchorSmoothScroll, $translate, accountService, navigationService, $state, backToDashboardService) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.anchorSmoothScroll = anchorSmoothScroll;
        this.$translate = $translate;
        this.accountService = accountService;
        this.navigationService = navigationService;
        this.$state = $state;
        this.backToDashboardService = backToDashboardService;
        var unwatch = $rootScope.$watch('userData', function (userData) {
            if (userData && userData.permission) {
                unwatch();
                _this.menu = !$state.current.name.startsWith('app.help') ? navigationService.getMenu() : navigationService.getHelpMenu(false);
            }
            else {
                _this.menu = $state.current.name.startsWith('app.help') ? navigationService.getHelpMenu(true) : [];
            }
        }, true);
    }
    SidebarController.prototype.isOpenLink = function (menuItem) {
        return menuItem.url && menuItem.url.length > 0;
    };
    SidebarController.prototype.clickRoot = function (menuItem) {
        if (menuItem.url !== 'app.advertising.info' && menuItem.url !== 'app.marketing-campaigns.info') {
            menuItem.isOpen = !menuItem.isOpen;
        }
    };
    SidebarController.prototype.isActive = function (menuItem) {
        var _this = this;
        var current = this.$rootScope.$state.current.name;
        return current.startsWith(menuItem.url)
            || current.startsWith(menuItem.urlBase)
            || menuItem.relatedUrls && _.any(menuItem.relatedUrls, function (url) {
                return current.startsWith(url);
            })
            || menuItem.submenu && _.any(menuItem.submenu, function (menu) {
                return _this.isActive(menu);
            });
    };
    SidebarController.prototype.logOff = function (redirectToHomepage) {
        this.accountService.logOut(redirectToHomepage);
    };
    SidebarController.prototype.canNavigateBack = function () {
        return !!this.backToDashboardService.dashboardLink;
    };
    SidebarController.$inject = ['$rootScope', 'anchorSmoothScroll', '$translate', 'accountService', 'navigationService', '$state', 'backToDashboardService'];
    return SidebarController;
}());
exports.SidebarController = SidebarController;
angular.module('naut')
    .component('sidebar', {
    template: __webpack_require__(734),
    controller: SidebarController,
    controllerAs: 'vm'
});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var HeaderController = /** @class */ (function () {
    function HeaderController($transitions, accountService, $translate) {
        this.$transitions = $transitions;
        this.accountService = accountService;
        this.$translate = $translate;
        /*  $transitions.onStart({}, (transition: Transition) => {
             this.headerMenuCollapsed = true;
         }); */
    }
    HeaderController.prototype.toggleHeaderMenu = function () {
        this.headerMenuCollapsed = !this.headerMenuCollapsed;
    };
    HeaderController.prototype.logOff = function (redirectToHomepage) {
        this.accountService.logOut(redirectToHomepage);
    };
    HeaderController.$inject = ['$transitions', 'accountService', '$translate'];
    return HeaderController;
}());
exports.HeaderController = HeaderController;
angular.module('naut')
    .component('topNavbar', {
    template: __webpack_require__(735),
    controller: HeaderController,
    controllerAs: 'vm'
});


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function filterFunction($filter) {
    return function (input) {
        if (input.getHours() === 0 && input.getMinutes() === 0) {
            return '(All day)';
        }
        else {
            return $filter('date')(input, 'hh-mm a');
        }
    };
}
angular.module('naut')
    .filter('campaignTime', ['$filter', filterFunction]);


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function filterFunction() {
    return function (input) {
        if (input.getHours() === 0 && input.getMinutes() === 0) {
            var date = new Date(input.toString());
            date.setDate(input.getDate() - 1);
            return date;
        }
        return input;
    };
}
angular.module('naut')
    .filter('endDate', filterFunction);


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function filterFunction($filter) {
    var dateFilter = $filter('date');
    return function (input) {
        return input
            ? dateFilter(new Date(input), 'yyyy-MM-dd')
            : null;
    };
}
angular.module('naut')
    .filter('serverDate', ['$filter', filterFunction]);


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function filterFunction() {
    function filterFilter(params) {
        params = (params === undefined || params === null) ? '' : params;
        return params.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
            return ch.toUpperCase();
        });
    }
}
angular.module('naut')
    .filter('titlecase', filterFunction);


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AuthService = /** @class */ (function () {
    function AuthService($state, $q, accountService, jispPayAccountService, enumService, notificationService, $translate, $window) {
        this.$state = $state;
        this.$q = $q;
        this.accountService = accountService;
        this.jispPayAccountService = jispPayAccountService;
        this.enumService = enumService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.$window = $window;
        this.loginState = 'account.login';
        this.storesState = 'app.shops';
        this.redirectStates = [
            'jisppay.loyalty', 'jisppay.sessionsList', 'jisppay.orders', 'jisppay.select-store', 'jisppay.default', 'jisppay.delivery'
        ];
    }
    AuthService.prototype.checkAccess = function (cancel, toState) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var userData, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    /* Redirect state */
                                    if (this.redirectStates.indexOf(toState.name) > -1) {
                                        this.$window.location.href = toState.url;
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    // handling of public routes
                                    if (toState.data && !toState.data.auth) {
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    /* Redirect from nfrn */
                                    if (toState.name.startsWith('nfrn')) {
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    userData = this.accountService.userData;
                                    /* if retailer or store maanger logged and requested login page */
                                    if (userData.isAuth && toState.name === 'account.login') {
                                        this.$state.go('home.screen');
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    if (!this.accountService.isRetailerTokenPresents()) return [3 /*break*/, 9];
                                    if (!(toState.data && toState.data.auth !== undefined)) return [3 /*break*/, 7];
                                    if (!(toState.data.auth && !userData.isAuth)) return [3 /*break*/, 1];
                                    if (cancel) {
                                        cancel();
                                    }
                                    /* Cleanup retailer token and data */
                                    console.log('Not auth');
                                    this.accountService.clearAuthData();
                                    this.$state.go(this.loginState);
                                    resolve();
                                    return [2 /*return*/];
                                case 1:
                                    if (!(toState.data.auth && userData.isAuth)) return [3 /*break*/, 6];
                                    if (!userData.email) return [3 /*break*/, 2];
                                    this.retailerAccess(toState.data.onlyRetailer, userData.permission, cancel);
                                    resolve();
                                    return [2 /*return*/];
                                case 2:
                                    this.notificationService.showWaitingMessage();
                                    _a.label = 3;
                                case 3:
                                    _a.trys.push([3, 5, , 6]);
                                    return [4 /*yield*/, this.accountService.getProfile()];
                                case 4:
                                    _a.sent();
                                    this.notificationService.clearAll();
                                    this.retailerAccess(toState.data.onlyRetailer, userData.permission, cancel);
                                    resolve();
                                    return [2 /*return*/];
                                case 5:
                                    error_1 = _a.sent();
                                    if (cancel) {
                                        cancel();
                                    }
                                    this.notificationService.showErrorMessage({
                                        title: this.$translate.instant('error'),
                                        body: this.$translate.instant('failed_to_get_profile')
                                    });
                                    /* Cleanup retailer token and data */
                                    console.log('Error');
                                    this.accountService.clearAuthData();
                                    this.$state.go(this.loginState);
                                    resolve();
                                    return [2 /*return*/];
                                case 6: return [3 /*break*/, 8];
                                case 7:
                                    resolve();
                                    return [2 /*return*/];
                                case 8: return [3 /*break*/, 10];
                                case 9:
                                    if (this.jispPayAccountService.isSellerTokenPresents()) {
                                        if (cancel) {
                                            cancel();
                                        }
                                        this.jispPayAccountService.navigateToDefault();
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    else {
                                        console.log('No tokens');
                                        this.accountService.clearAuthData();
                                        this.$state.go(this.loginState);
                                        resolve();
                                        return [2 /*return*/];
                                    }
                                    _a.label = 10;
                                case 10: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    AuthService.prototype.retailerAccess = function (isOnlyRatailer, permission, cancel) {
        if (!isOnlyRatailer || (isOnlyRatailer === true && permission && permission === this.enumService.RetailerPermission.Retailer)) {
            return;
        }
        else {
            if (cancel) {
                cancel();
            }
            this.$state.go(this.storesState);
        }
    };
    AuthService.$inject = [
        '$state',
        '$q',
        'accountService',
        'jispPayAccountService',
        'enumService',
        'notificationService',
        '$translate',
        '$window'
    ];
    return AuthService;
}());
exports.AuthService = AuthService;
angular.module('app.common').service('authService', AuthService);


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var IngredientsService = /** @class */ (function () {
    function IngredientsService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    IngredientsService.prototype.getIngredients = function (filter) {
        return this.http.get(this.retailerService.getIngredients(), { params: filter });
    };
    IngredientsService.prototype.getIngredient = function (id) {
        return this.http.get(this.retailerService.getIngredient(id));
    };
    IngredientsService.prototype.addIngredient = function (ingredientTitle) {
        return this.http.post(this.retailerService.getIngredients(), { Title: ingredientTitle });
    };
    IngredientsService.prototype.checkTitleForExist = function (ingredientTitle, ingredientID) {
        return this.http.get(this.retailerService.getCheckIngredients(), { params: { title: ingredientTitle, ingredientID: ingredientID } });
    };
    IngredientsService.prototype.editIngredient = function (id, ingredientTitle) {
        return this.http.put(this.retailerService.getIngredient(id), { Title: ingredientTitle });
    };
    IngredientsService.prototype.archiveIngredient = function (id) {
        return this.http.put(this.retailerService.archiveIngredient(id), null);
    };
    IngredientsService.prototype.restoreIngredient = function (id) {
        return this.http.put(this.retailerService.restoreIngredient(id), null);
    };
    IngredientsService.$inject = ['http', 'retailerService', '$localStorage', '$uibModal', '$timeout'];
    return IngredientsService;
}());
exports.IngredientsService = IngredientsService;
angular
    .module('naut')
    .service('ingredientsService', IngredientsService);


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var NavigationService = /** @class */ (function () {
    function NavigationService($rootScope, $translate, accountService) {
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.accountService = accountService;
        this.homeMenu = {
            title: this.$translate.instant('menu_home'),
            isOpen: false,
            url: 'app.dashboard'
        };
        this.placesMenu = {
            title: this.$translate.instant('menu_places'),
            isOpen: false,
            urlBase: 'app.shop',
            relatedUrls: ['app.create-shop', 'app.inventory'],
            url: 'app.shops',
            description: this.$translate.instant('menu_places_description'),
            icon: 'icon-sidebar-location'
        };
        this.productsForNfrnMenu = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: 'app.products',
            icon: 'icon-sidebar-products'
        };
        /* Products and bundles submenus */
        var productsMenu = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: 'app.products'
        };
        var bundlesMuenu = {
            title: this.$translate.instant('menu_bundles'),
            isOpen: false,
            url: 'app.bundles'
        };
        var servicesMenu = {
            title: this.$translate.instant('services_menu_item'),
            isOpen: false,
            url: 'app.activeServices',
            relatedUrls: [
                'app.activeServices',
                'app.archivedServices',
                'app.editService',
                'app.serviceCreate'
            ]
        };
        var menusMuenu = {
            title: this.$translate.instant('menu_menus'),
            isOpen: false,
            url: 'app.menus',
            relatedUrls: [
                'app.create-menu',
                'app.edit-menu',
                'app.extras.archived'
            ]
        };
        var ingredientsMenu = {
            title: this.$translate.instant('ingredients'),
            isOpen: false,
            url: 'app.activeIngredients',
            relatedUrls: [
                'app.activeIngredients',
                'app.archivedIngredients'
            ]
        };
        var extrasMenu = {
            title: this.$translate.instant('menu_extras'),
            isOpen: false,
            url: 'app.extras.active',
            relatedUrls: [
                'app.extras.edit',
                'app.extras.new',
                'app.extras.archived'
            ]
        };
        this.productAndBundlessMenuItems = {
            title: this.$translate.instant('menu_products_and_bundles'),
            urlBase: 'app.productsAndBundles',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-products',
            submenu: [productsMenu, servicesMenu, menusMuenu, ingredientsMenu, extrasMenu]
        };
        /*  */
        this.nfcMenu = {
            title: this.$translate.instant('menu_nfc'),
            isOpen: false,
            urlBase: 'app.nfcs.active',
            relatedUrls: [
                'app.nfc.active',
                'app.nfc.deleted',
                'app.nfc.history',
                'app.nfc.export',
                'app.nfc.wizard'
            ],
            url: 'app.nfcs.active',
            icon: 'icon-sidebar-nfc'
        };
        this.informationCardsMenu = {
            title: this.$translate.instant('menu_information_cards'),
            isOpen: false,
            urlBase: 'app.information-card',
            relatedUrls: [
                'app.information-card.edit',
                'app.information-card.new'
            ],
            url: 'app.information-cards',
            icon: 'icon-sidebar-infotags'
        };
        var marketingCampaignsMenu = {
            title: this.$translate.instant('menu_marketing_campaigns'),
            isOpen: false,
            url: 'app.marketing-campaigns.overview'
        };
        var marketPlaceMenu = {
            title: this.$translate.instant('menu_marketplace'),
            isOpen: false,
            url: 'app.marketplace'
        };
        this.campaignsMenu = {
            title: this.$translate.instant('menu_campaigns'),
            urlBase: 'app.marketing-campaigns.overview',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-campaigns',
            submenu: [marketingCampaignsMenu, marketPlaceMenu]
        };
        this.analyticsMenu = {
            title: this.$translate.instant('menu_analytics'),
            isOpen: false,
            url: 'app.analytics',
            urlBase: 'app.analytics',
            icon: 'icon-sidebar-analytics'
        };
        this.warningsMenu = {
            title: this.$translate.instant('menu_warnings'),
            isOpen: false,
            url: 'app.warnings',
            urlBase: 'app.warnings',
            icon: 'icon-sidebar-warnings'
        };
        this.vouchersMenu = {
            title: this.$translate.instant('vouchers'),
            isOpen: false,
            urlBase: 'app.vouchers.list',
            url: 'app.vouchers.list',
            icon: 'icon-sidebar-vouchers'
        };
        this.bundlesMenu = {
            title: this.$translate.instant('bundles'),
            isOpen: false,
            urlBase: 'app.bundles',
            url: 'app.bundles',
            icon: 'icon-sidebar-bundles'
        };
        this.printersMenu = {
            title: this.$translate.instant('printers'),
            isOpen: false,
            urlBase: 'app.printers.list',
            url: 'app.printers.list',
            icon: 'icon-sidebar-printers'
        };
        // Admin menu items
        var jispPayPlacesMenuItem = {
            title: this.$translate.instant('menu_admin_jispPay'),
            isOpen: false,
            url: 'app.jisppay.places'
        };
        var orderSettingsMenuItem = {
            title: this.$translate.instant('menu_admin_orderSettings'),
            isOpen: false,
            url: 'app.orderSettings.locations'
        };
        var discountForStaffMenuItem = {
            title: this.$translate.instant('menu_admin_discountForStaff'),
            isOpen: false,
            url: 'app.discountForStaffs',
            relatedUrls: [
                'app.discountForStaffs.special.active',
                'app.discountForStaffs.special.archived',
                'app.discountForStaffs.transaction.withDiscount',
                'app.discountForStaffs.transaction.export',
                'app.discountForStaffs.transaction.singleTransaction'
            ]
        };
        var clickAndDeliverMenuItem = {
            title: this.$translate.instant('menu_click_and_deliver'),
            isOpen: false,
            url: 'app.clickAndDeliver'
        };
        var loyaltyMenuItem = {
            title: this.$translate.instant('menu_admin_loyalty_program'),
            isOpen: false,
            url: 'app.loyalty.program'
        };
        var referralAccountsMenuItem = {
            title: this.$translate.instant('menu_admin_referral_accounts'),
            isOpen: false,
            url: 'app.referral-accounts'
        };
        this.retailerStaffMenu = {
            title: this.$translate.instant('menu_admin_staff_accounts'),
            isOpen: false,
            url: 'app.jisppay.staff',
            icon: 'icon-sidebar-admin'
        };
        var adminManagerMenuItem = {
            title: this.$translate.instant('menu_admin_manager_accounts'),
            isOpen: false,
            url: 'app.managers.accounts'
        };
        this.retailerAdminMenuItems = {
            title: 'Admin',
            urlBase: 'app.admin',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-admin',
            submenu: [
                jispPayPlacesMenuItem,
                orderSettingsMenuItem,
                discountForStaffMenuItem,
                clickAndDeliverMenuItem,
                referralAccountsMenuItem,
                this.retailerStaffMenu,
                adminManagerMenuItem
            ]
        };
        this.managerAdminMenuItems = {
            title: 'Admin',
            urlBase: 'app.admin',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-admin',
            submenu: [
                jispPayPlacesMenuItem,
                orderSettingsMenuItem,
                discountForStaffMenuItem,
                clickAndDeliverMenuItem,
                referralAccountsMenuItem,
                this.retailerStaffMenu
            ]
        };
        this.helpMenu = {
            title: this.$translate.instant('menu_help'),
            additionalClass: 'menu-help',
            isOpen: false,
            url: null,
            icon: null
        };
        var importFormatMenuItem = {
            title: this.$translate.instant('menu_file_format_and_properties'),
            isOpen: false,
            url: 'app.help.manual',
            additionalClass: 'pl35'
        };
        var categoryMenuItem = {
            title: this.$translate.instant('menu_categories_and_item_types'),
            isOpen: false,
            url: 'app.help.dictionary',
            additionalClass: 'pl35'
        };
        var countriesMenuItem = {
            title: this.$translate.instant('menu_countries'),
            isOpen: false,
            url: 'app.help.countries',
            additionalClass: 'pl35'
        };
        var preferenceMenuItem = {
            title: this.$translate.instant('menu_food_preferences_and_allergens'),
            isOpen: false,
            url: 'app.help.preferences',
            additionalClass: 'pl35'
        };
        this.productImportHelpMenu = {
            title: this.$translate.instant('menu_product_import'),
            urlBase: 'app.help.manual',
            isOpen: false,
            url: null,
            icon: null,
            submenu: [
                importFormatMenuItem,
                categoryMenuItem,
                countriesMenuItem,
                preferenceMenuItem
            ]
        };
        this.productsForPublisher = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: null,
            urlBase: 'app.products',
            icon: 'icon-sidebar-products',
            submenu: [productsMenu]
        };
        var downloads = {
            title: this.$translate.instant('downloads'),
            isOpen: false,
            url: 'app.downloads'
        };
        this.dppAnalytics = {
            title: this.$translate.instant('menu_analytics'),
            isOpen: false,
            url: null,
            urlBase: 'app.downloads',
            icon: 'icon-sidebar-analytics',
            submenu: [downloads]
        };
        this.publisherSettings = {
            title: this.$translate.instant('publisher_settings'),
            isOpen: false,
            urlBase: 'app.publisherSettings',
            url: 'app.publisherSettings',
            icon: 'icon-sidebar-publisher-settings'
        };
    }
    NavigationService.prototype.getMenu = function () {
        this.$rootScope.userData = this.accountService.userData;
        if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Retailer) {
            return [
                this.placesMenu,
                this.campaignsMenu,
                this.productAndBundlessMenuItems,
                this.bundlesMenu,
                this.vouchersMenu,
                this.nfcMenu,
                this.informationCardsMenu,
                this.printersMenu,
                this.analyticsMenu,
                this.warningsMenu,
                this.retailerAdminMenuItems
            ];
        }
        else if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn) {
            return [
                this.placesMenu,
                this.productsForNfrnMenu,
                this.retailerStaffMenu
            ];
        }
        else if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Publisher) {
            return [
                this.productsForPublisher,
                this.dppAnalytics,
                this.publisherSettings
            ];
        }
        else {
            return [
                this.placesMenu,
                this.campaignsMenu,
                this.productAndBundlessMenuItems,
                this.informationCardsMenu,
                this.analyticsMenu,
                this.warningsMenu,
                this.managerAdminMenuItems
            ];
        }
    };
    NavigationService.prototype.getAdminMenu = function () {
        if (this.$rootScope.userData.permission ===
            this.$rootScope.enums.RetailerPermission.Retailer) {
            return this.retailerAdminMenuItems;
        }
        else {
            return this.managerAdminMenuItems;
        }
    };
    NavigationService.prototype.getHelpMenu = function (isAnon) {
        if (isAnon === void 0) { isAnon = false; }
        this.$rootScope.userData = isAnon ? null : this.accountService.userData;
        return [this.helpMenu, this.productImportHelpMenu];
    };
    NavigationService.$inject = ['$rootScope', '$translate', 'accountService'];
    return NavigationService;
}());
exports.NavigationService = NavigationService;
angular.module('app.common').service('navigationService', NavigationService);


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ServicesService = /** @class */ (function () {
    function ServicesService(http, retailerService, blobService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.blobService = blobService;
        this.uploadServiceImage = function (dataUri) {
            var fd = new FormData();
            fd.append('FileImage', _this.blobService.dataUriToBlob(dataUri));
            return _this.http.post(_this.retailerService.uploadServiceImage(), fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };
    }
    ServicesService.prototype.getServices = function (filter) {
        return this.http.get(this.retailerService.getServices(), { params: filter });
    };
    ServicesService.prototype.getService = function (id) {
        return this.http.get(this.retailerService.getService(id));
    };
    ServicesService.prototype.archiveService = function (id) {
        return this.http.put(this.retailerService.archiveService(id), null);
    };
    ServicesService.prototype.restoreService = function (id) {
        return this.http.put(this.retailerService.restoreService(id), null);
    };
    ServicesService.prototype.saveService = function (item, id) {
        if (!id) {
            return this.http.post(this.retailerService.createService(), item);
        }
        else {
            return this.http.put(this.retailerService.getService(id), item);
        }
    };
    ServicesService.$inject = ['http', 'retailerService', 'blobService'];
    return ServicesService;
}());
exports.ServicesService = ServicesService;
angular
    .module('naut')
    .service('servicesService', ServicesService);


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var CoreController = /** @class */ (function () {
    function CoreController($rootScope, $state, accountService, anchorSmoothScroll, $translate, signalRHubProxyFactory, $localStorage, notificationService, popupService, retailerService, appCueService) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.accountService = accountService;
        this.anchorSmoothScroll = anchorSmoothScroll;
        this.$translate = $translate;
        this.signalRHubProxyFactory = signalRHubProxyFactory;
        this.$localStorage = $localStorage;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.retailerService = retailerService;
        this.appCueService = appCueService;
        this.showPrivacyNotificationIfNeed = function () { return __awaiter(_this, void 0, void 0, function () {
            var onButtonAction, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.$rootScope.userData && this.$rootScope.userData.viewedPrivacyNotification === false)) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.popupService.showPrivacyNotification({
                                title: this.$translate.instant('privacy_policy_title'),
                                content: "<p>" + this.$translate.instant('privacy_policy_text') + "\n                              <a href = \"" + this.$translate.instant('privacy_policy_link') + "\" target = \"_blank\"> " + this.$translate.instant('privacy_policy_link_text') + " </a>\n                              </p>",
                                okTxt: 'OK',
                                okClass: 'btn-gradient',
                                closeButton: false
                            })];
                    case 2:
                        onButtonAction = _a.sent();
                        if (!(onButtonAction === 'closed')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.accountService.updateViewedPrivacyNotification()];
                    case 3:
                        _a.sent();
                        this.$rootScope.userData.viewedPrivacyNotification = true;
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.errorHandler = function (error) {
            _this.notificationService.clearAll();
            _this.notificationService.showErrorMessage(error);
        };
        this.onLogin = function () {
            var token = _this.$localStorage.retailerAuthorizationData
                ? _this.$localStorage.retailerAuthorizationData.token
                : null;
            var unwatch = _this.$rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var isNfrnRetailer, isPublisherRetailer;
                return __generator(this, function (_a) {
                    if (userData.permission) {
                        unwatch();
                        isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                        isPublisherRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Publisher;
                        if (!isNfrnRetailer && !isPublisherRetailer && !this.signalRHubProxy) {
                            this.signalRHubProxy = this.signalRHubProxyFactory(this.retailerService.getSignalREndpoint(), 'RetailerHub');
                            this.signalRHubProxy.on('CampaignVideoProcessingFinish', function (campaignVideoID, campaignID) {
                                _this.$rootScope.$broadcast('CampaignVideoProcessingFinish', { CampaignVideoID: campaignVideoID, CampaignID: campaignID });
                            });
                            this.signalRHubProxy.on('CampaignVideoProcessingError', function (campaignVideoID, campaignID) {
                                _this.$rootScope.$broadcast('CampaignVideoProcessingError', { CampaignVideoID: campaignVideoID, CampaignID: campaignID });
                            });
                            this.signalRHubProxy.start(token, this.errorHandler);
                        }
                    }
                    return [2 /*return*/];
                });
            }); }, true);
        };
        this.onLogout = function () {
            if (_this.signalRHubProxy) {
                _this.signalRHubProxy.stop();
                _this.signalRHubProxy = null;
            }
        };
        $rootScope.userData = accountService.userData;
        $rootScope.hasWarnings = function () {
            if (!$rootScope.userData) {
                return true;
            }
            return $rootScope.userData.retailerStatus === $rootScope.enums.RetailerStatus.Unverified;
        };
        $rootScope.$watch('userData.id', function (userId) { return __awaiter(_this, void 0, void 0, function () {
            var isAdmin, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(userId && $rootScope.userData)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.accountService.isLoggedInAsAdmin()];
                    case 1:
                        isAdmin = _a.sent();
                        if (!!isAdmin) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.showPrivacyNotificationIfNeed()];
                    case 2:
                        _a.sent();
                        id = $rootScope.userData.permission === $rootScope.enums.RetailerPermission.StoreManager ? 'manager_' + userId : 'retailer_' + userId;
                        appCueService.setUserData(id);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        appCueService.resetUserData();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); }, true);
        $rootScope.cancel = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        };
        $rootScope.pageTitle = function () {
            var data = $state.$current.data;
            if (data) {
                return _.isEmpty(data.translateKey) ? data.title : $translate.instant(data.translateKey);
            }
            else {
                return $rootScope.app.name + "  " + $rootScope.app.description;
            }
        };
        $rootScope.gotoAnchor = function (name) {
            anchorSmoothScroll.scrollTo(name, 20);
        };
        $rootScope.$on('Login', this.onLogin);
        $rootScope.$on('LogOut', this.onLogout);
        if ($localStorage.retailerAuthorizationData) {
            this.onLogin();
        }
    }
    CoreController.$inject = ['$rootScope', '$state', 'accountService', 'anchorSmoothScroll', '$translate', 'signalRHubProxy', '$localStorage', 'notificationService', 'popupService', 'retailerService', 'appCueService'];
    return CoreController;
}());
exports.CoreController = CoreController;
angular
    .module('naut')
    .controller('CoreController', CoreController);


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function appRun($rootScope, $state, $stateParams, $localStorage, settingsService, accountService, enumService, urlService) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$storage = $localStorage;
    settingsService.init();
    accountService.fillAuthData();
    $rootScope.getContentHtmlUrl = urlService.getRetailersHtmlUrl;
    $rootScope.currentYear = new Date().getFullYear();
    $rootScope.enums = enumService;
}
angular.module('naut').run(appRun);
appRun.$inject = ['$rootScope', '$state', '$stateParams', '$localStorage', 'settingsService', 'accountService', 'enumService', 'urlService'];


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffService = /** @class */ (function () {
    function DiscountForStaffService(http, retailerService, $localStorage, $uibModal, $timeout) {
        this.http = http;
        this.retailerService = retailerService;
        this.$localStorage = $localStorage;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.accessKey = 'mayModify';
    }
    DiscountForStaffService.prototype.getActiveStaffs = function (query) {
        return this.http.get(this.retailerService.shopperStaffs(), { params: query });
    };
    DiscountForStaffService.prototype.createStaff = function (query) {
        return this.http.post(this.retailerService.createStaffDiscount(), query);
    };
    DiscountForStaffService.prototype.getStaff = function (discountID) {
        return this.http.get(this.retailerService.editStaffDiscount(discountID));
    };
    DiscountForStaffService.prototype.editStaff = function (discountID, query) {
        return this.http.put(this.retailerService.editStaffDiscount(discountID), query);
    };
    DiscountForStaffService.prototype.findStaffByEmail = function (query) {
        return this.http.get(this.retailerService.findStaff(), { params: query });
    };
    DiscountForStaffService.prototype.getTransactionsWithDiscount = function (query) {
        return this.http.get(this.retailerService.allTransactionsHistory(), { params: query });
    };
    DiscountForStaffService.prototype.getTransaction = function (transactionID) {
        return this.http.get(this.retailerService.transactionHistory(transactionID));
    };
    DiscountForStaffService.prototype.getTransactionsSummary = function (query) {
        return this.http.get(this.retailerService.transactionsHistorySummary(), { params: query });
    };
    DiscountForStaffService.prototype.archiveStaff = function (discountID) {
        return this.http["delete"](this.retailerService.archiveStaff(discountID));
    };
    DiscountForStaffService.prototype.checkAccess = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$localStorage[this.accessKey]) return [3 /*break*/, 1];
                        return [2 /*return*/, true];
                    case 1: return [4 /*yield*/, this.$uibModal.open({
                            component: 'discountForStaffConfirmPassword',
                            resolve: {},
                            backdrop: 'static',
                            size: 'sm',
                            windowClass: 'modal360 password-modal'
                        }).result];
                    case 2:
                        operationResult = _a.sent();
                        if (operationResult === 'ok') {
                            this.$localStorage[this.accessKey] = true;
                            this.destroyTimeout = this.$timeout(function () { return _this.deleteAccessKey(); }, 360000);
                            return [2 /*return*/, true];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    DiscountForStaffService.prototype.deleteAccessKey = function () {
        delete this.$localStorage[this.accessKey];
        this.$timeout.cancel(this.destroyTimeout);
    };
    DiscountForStaffService.prototype.checkPassword = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.http.post(this.retailerService.checkPassword(), password)];
            });
        });
    };
    DiscountForStaffService.$inject = ['http', 'retailerService', '$localStorage', '$uibModal', '$timeout'];
    return DiscountForStaffService;
}());
exports.DiscountForStaffService = DiscountForStaffService;
angular
    .module('naut')
    .service('discountForStaffService', DiscountForStaffService);


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffHistoryTab = /** @class */ (function () {
    function DiscountForStaffHistoryTab() {
    }
    return DiscountForStaffHistoryTab;
}());
angular.module('naut').component('discountForStaffHistoryTab', {
    template: __webpack_require__(736),
    controller: DiscountForStaffHistoryTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var AddOrEditStaff = /** @class */ (function () {
    function AddOrEditStaff($translate, definitionsService, notificationService, discountForStaffService) {
        this.$translate = $translate;
        this.definitionsService = definitionsService;
        this.notificationService = notificationService;
        this.discountForStaffService = discountForStaffService;
        this.modalInstance = this;
        this.emailPattern = this.definitionsService.regexEmail;
        this.model = {
            dialogTitle: '',
            email: '',
            staffID: null,
            firstName: '',
            lastName: '',
            date: null,
            canEdit: false,
            clickSearch: false,
            isSuccessSearch: true,
            isAlreadyExist: false,
            isEditMode: false
        };
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: new Date()
        };
        this.requiredDateError = false;
    }
    AddOrEditStaff.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.resolve.discountID) return [3 /*break*/, 2];
                        this.model.isEditMode = true;
                        this.model.canEdit = false;
                        return [4 /*yield*/, this.findStaff(this.model.isEditMode)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditStaff.prototype.clearEmailAndReset = function () {
        this.model.email = null;
        this.model.canEdit = false;
        this.model.firstName = null;
        this.model.lastName = null;
        this.model.date = null;
        this.model.clickSearch = false;
        this.model.isSuccessSearch = true;
        this.model.isAlreadyExist = false;
    };
    AddOrEditStaff.prototype.resetErrors = function () {
        this.model.isSuccessSearch = true;
        this.model.isAlreadyExist = false;
        this.model.clickSearch = false;
    };
    AddOrEditStaff.prototype.getSearchClass = function () {
        return this.model.email ? 'fa-search--active' : '';
    };
    AddOrEditStaff.prototype.findStaff = function (isEditMode) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.model.clickSearch = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        if (!isEditMode) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadAndSetStaffByID()];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.loadAndSetStaffByEmail()];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        _a;
                        this.model.isSuccessSearch = true;
                        this.model.canEdit = true;
                        return [3 /*break*/, 8];
                    case 6:
                        error_1 = _b.sent();
                        this.model.isSuccessSearch = false;
                        this.model.canEdit = false;
                        return [3 /*break*/, 8];
                    case 7:
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditStaff.prototype.addOrEditStaff = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.model.date) {
                            this.requiredDateError = true;
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        query = {
                            ShopperID: this.model.staffID,
                            FirstName: this.model.firstName,
                            LastName: this.model.lastName,
                            DiscountExpirationDate: moment(this.model.date).utc(true).startOf('day').toDate()
                        };
                        if (!this.model.isEditMode) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.discountForStaffService.editStaff(this.model.staffID, query)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.discountForStaffService.createStaff(query)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close({ $value: 'ok' });
                        return [3 /*break*/, 8];
                    case 6:
                        error_2 = _a.sent();
                        error_2.includes('Discount for employe already exist')
                            ? (this.model.isAlreadyExist = true)
                            : this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 8];
                    case 7:
                        this.notificationService.clearAll();
                        this.requiredDateError = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditStaff.prototype.close = function () {
        this.modalInstance.close();
    };
    AddOrEditStaff.prototype.loadAndSetStaffByEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, staff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = {
                            Email: this.model.email
                        };
                        return [4 /*yield*/, this.discountForStaffService.findStaffByEmail(query)];
                    case 1:
                        staff = _a.sent();
                        this.model.firstName = staff.FirstName;
                        this.model.lastName = staff.LastName;
                        this.model.staffID = staff.ID;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditStaff.prototype.loadAndSetStaffByID = function () {
        return __awaiter(this, void 0, void 0, function () {
            var staff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.discountForStaffService.getStaff(this.resolve.discountID)];
                    case 1:
                        staff = _a.sent();
                        this.model.firstName = staff.FirstName;
                        this.model.lastName = staff.LastName;
                        this.model.date = new Date(staff.DiscountExpirationDate);
                        this.model.email = staff.Email;
                        this.model.staffID = this.resolve.discountID;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditStaff.$inject = [
        '$translate',
        'definitionsService',
        'notificationService',
        'discountForStaffService'
    ];
    return AddOrEditStaff;
}());
angular.module('naut').component('addOrEditStaff', {
    template: __webpack_require__(737),
    controller: AddOrEditStaff,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffConfirmPassword = /** @class */ (function () {
    function DiscountForStaffConfirmPassword($scope, $translate, $timeout, notificationService, discountForStaffService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.notificationService = notificationService;
        this.discountForStaffService = discountForStaffService;
        this.modalInstance = this;
        this.confirmPassword = '';
        this.hasError = false;
        this.ok = function () {
            var passwordCheck = {
                Password: _this.confirmPassword
            };
            _this.notificationService.showWaitingMessage();
            _this.discountForStaffService.checkPassword(passwordCheck)
                .then(function (result) {
                if (result) {
                    _this.modalInstance.close({
                        $value: 'ok'
                    });
                }
                else {
                    _this.hasError = true;
                }
            })["catch"](function (error) {
                _this.notificationService.showErrorMessage(error);
            })
                .then(function () { return _this.notificationService.clearAll(); });
        };
        this.close = function () {
            _this.modalInstance.close({
                $value: 'close'
            });
        };
        this.showHidePassword = function () {
            return {
                require: 'ngModel',
                restrict: 'A',
                link: function (scope, element, attr, ctrl) {
                    scope.$watch(attr.showPassword, function (newVal, oldVal) {
                        if (newVal) {
                            element.attr('type', 'text');
                        }
                        else {
                            element.attr('type', 'password');
                        }
                    });
                }
            };
        };
    }
    DiscountForStaffConfirmPassword.prototype.clearPassword = function () {
        this.confirmPassword = '';
    };
    DiscountForStaffConfirmPassword.$inject = ['$scope', '$translate', '$timeout', 'notificationService', 'discountForStaffService'];
    return DiscountForStaffConfirmPassword;
}());
angular.module('naut').component('discountForStaffConfirmPassword', {
    template: __webpack_require__(738),
    controller: DiscountForStaffConfirmPassword,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var IActiveStaffsFilter_1 = __webpack_require__(91);
var DiscountForStaffSpecialActiveTab = /** @class */ (function () {
    function DiscountForStaffSpecialActiveTab($scope, $translate, $uibModal, notificationService, discountForStaffService, $state, $timeout, popupService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.notificationService = notificationService;
        this.discountForStaffService = discountForStaffService;
        this.$state = $state;
        this.$timeout = $timeout;
        this.popupService = popupService;
        this.waiting = false;
        this.total = 0;
        this.items = [];
        this.itemsLimit = 20;
        this.canLoadMore = true;
        this.isArchived = false;
        this.search = {
            text: ''
        };
        this.openStaffDialog = function (staff) { return __awaiter(_this, void 0, void 0, function () {
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.discountForStaffService.checkAccess()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'addOrEditStaff',
                                resolve: {
                                    discountID: function () { return staff ? staff.ID : null; }
                                },
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 2:
                        operationResult = _a.sent();
                        if (operationResult === 'ok') {
                            this.applySearch();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.archiveDiscount = function (staff) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.discountForStaffService.checkAccess()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('close'),
                                okClass: 'btn bg-dark12 btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('button_delete'),
                                cancelClass: 'btn btn-with-background-icon btn-danger icon-trashcan-outline-white',
                                title: this.$translate.instant('delete_staff_title'),
                                content: this.$translate.instant('delete_staff_body', { staff: staff.FullName }),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })
                                .then(function () {
                                _this.notificationService.showWaitingMessage();
                                _this.discountForStaffService.archiveStaff(staff.ID)
                                    .then(function () {
                                    _this.notificationService.showSuccessMessage();
                                    _this.applySearch();
                                })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () { return _this.$timeout(function () { return _this.notificationService.clearAll(); }, 3000); });
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    DiscountForStaffSpecialActiveTab.prototype.$onInit = function () {
        this.isArchived = this.$state.current.name === 'app.discountForStaffs.special.archived';
        this.loadData();
        this.currentDate = new Date();
    };
    DiscountForStaffSpecialActiveTab.prototype.loadData = function () {
        var _this = this;
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;
        var filter = {
            Keyword: this.search.text,
            Archive: this.isArchived,
            Limit: this.itemsLimit,
            Offset: this.items.length,
            SortColumn: 'DiscountExpirationDate',
            SortOrder: IActiveStaffsFilter_1.SortOrderEnum.Ascending
        };
        this.notificationService.showWaitingMessage();
        this.discountForStaffService.getActiveStaffs(filter)
            .then(function (response) {
            _this.total = response.Total;
            Array.prototype.push.apply(_this.items, response.Items);
            _this.canLoadMore = response.Items.length === _this.itemsLimit;
        })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
        })["finally"](function () {
            _this.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    DiscountForStaffSpecialActiveTab.prototype.applySearch = function () {
        this.canLoadMore = true;
        this.items = [];
        this.total = 0;
        this.loadData();
    };
    DiscountForStaffSpecialActiveTab.$inject = ['$scope', '$translate', '$uibModal', 'notificationService', 'discountForStaffService', '$state', '$timeout', 'popupService'];
    return DiscountForStaffSpecialActiveTab;
}());
angular.module('naut').component('discountForStaffSpecialActiveTab', {
    template: __webpack_require__(739),
    controller: DiscountForStaffSpecialActiveTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffSpecialTab = /** @class */ (function () {
    function DiscountForStaffSpecialTab(discountForStaffService) {
        this.discountForStaffService = discountForStaffService;
    }
    DiscountForStaffSpecialTab.prototype.$onDestroy = function () {
        this.discountForStaffService.deleteAccessKey();
    };
    DiscountForStaffSpecialTab.$inject = ['discountForStaffService'];
    return DiscountForStaffSpecialTab;
}());
angular.module('naut').component('discountForStaffSpecialTab', {
    template: __webpack_require__(740),
    controller: DiscountForStaffSpecialTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffTabList = /** @class */ (function () {
    function DiscountForStaffTabList() {
    }
    return DiscountForStaffTabList;
}());
angular.module('naut').component('discountForStaffTabList', {
    template: __webpack_require__(741),
    controller: DiscountForStaffTabList,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var DiscountForStaffSingleTransaction = /** @class */ (function () {
    function DiscountForStaffSingleTransaction($stateParams, notificationService, $rootScope, discountForStaffService) {
        this.$stateParams = $stateParams;
        this.notificationService = notificationService;
        this.$rootScope = $rootScope;
        this.discountForStaffService = discountForStaffService;
        this.dataReady = false;
        this.getIngerdientQuantityDifference = function (defaultQuantity, quantity) {
            return Math.abs(quantity - defaultQuantity);
        };
        this.getDifferenceQuantity = function (ingredient) {
            return (ingredient.Quantity - ingredient.DefaultQuantity);
        };
        this.getIngredientTotalPrice = function (ingredient) {
            return ingredient.Price * (ingredient.Quantity - ingredient.DefaultQuantity);
        };
        this.isFreeIngredientPrice = function (ingredient) {
            return ingredient.Price === 0 || (ingredient.Quantity < ingredient.DefaultQuantity && ingredient.Quantity !== 0);
        };
    }
    DiscountForStaffSingleTransaction.prototype.$onInit = function () {
        if (!this.$rootScope.userData) {
            return;
        }
        this.countryID = this.$rootScope.userData.countryID;
        var id = parseInt(this.$stateParams.id, 10);
        if (id) {
            this.getSingleTransaction(id);
        }
    };
    DiscountForStaffSingleTransaction.prototype.getSingleTransaction = function (transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        _a = this;
                        return [4 /*yield*/, this.discountForStaffService.getTransaction(transactionId)];
                    case 1:
                        _a.model = _b.sent();
                        this.dataReady = true;
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DiscountForStaffSingleTransaction.$inject = [
        '$stateParams',
        'notificationService',
        '$rootScope',
        'discountForStaffService'
    ];
    return DiscountForStaffSingleTransaction;
}());
angular.module('naut').component('discountForStaffSingleTransaction', {
    template: __webpack_require__(742),
    controller: DiscountForStaffSingleTransaction,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var TransactionExportHistoryTab = /** @class */ (function () {
    TransactionExportHistoryTab.$inject = ["$scope"];
    function TransactionExportHistoryTab($scope) {
        this.$scope = $scope;
    }
    return TransactionExportHistoryTab;
}());
angular.module('naut').component('transactionExportHistoryTab', {
    template: __webpack_require__(743),
    controller: TransactionExportHistoryTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var TransactionDiscountFilter = /** @class */ (function () {
    function TransactionDiscountFilter($scope, $translate, $uibModal, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.model = {
            selectedLocations: [],
            selectedLocationsCount: 0,
            isAllLocationsSelected: false,
            dateFrom: null,
            dateTo: null
        };
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        this.dateFromChange = function () {
            if (moment(_this.model.dateFrom).isSameOrAfter(_this.model.dateTo, 'day')) {
                _this.model.dateTo = moment(_this.model.dateTo).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateTo).startOf('day').toDate();
            }
        };
        this.dateToChange = function () {
            if (moment(_this.model.dateTo).isSameOrBefore(_this.model.dateFrom, 'day')) {
                _this.model.dateTo = moment(_this.model.dateFrom).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateFrom).startOf('day').toDate();
            }
        };
        this.onFilterApply = function () {
            _this.onApply({ filter: _this.model });
        };
        this.selectLocations = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'selectLocations',
                            resolve: { options: function () {
                                    return {
                                        selectedLocations: _this.model.selectedLocations,
                                        isAllSelected: _this.model.isAllLocationsSelected
                                    };
                                } },
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult.status === 'ok') {
                            if (operationResult.isAllSelected) {
                                this.model.isAllLocationsSelected = true;
                                this.nfcRetailerStickersService.getAllLocations()
                                    .then(function (locations) {
                                    _this.model.selectedLocationsCount = locations.length;
                                    return _this.model.selectedLocations = locations;
                                })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
                            }
                            else {
                                this.model.isAllLocationsSelected = false;
                                this.model.selectedLocations = operationResult.selectedLocations;
                                this.model.selectedLocationsCount = this.model.selectedLocations.length;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    TransactionDiscountFilter.prototype.$onChanges = function (onChangesObj) {
        if (onChangesObj
            && onChangesObj.filterModel.currentValue) {
            this.model.selectedLocations = onChangesObj.filterModel.currentValue.selectedLocations;
            this.model.selectedLocationsCount = onChangesObj.filterModel.currentValue.selectedLocations.length;
            this.model.dateFrom = onChangesObj.filterModel.currentValue.dateFrom;
            this.model.dateTo = onChangesObj.filterModel.currentValue.dateTo;
        }
    };
    TransactionDiscountFilter.$inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService'];
    return TransactionDiscountFilter;
}());
angular.module('naut').component('transactionDiscountFilter', {
    template: __webpack_require__(744),
    controller: TransactionDiscountFilter,
    controllerAs: 'ctrl',
    bindings: {
        filterModel: '<',
        onApply: '&',
        onAllClear: '&'
    }
});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var TransactionDiscountInformationBox = /** @class */ (function () {
    TransactionDiscountInformationBox.$inject = ["$localStorage"];
    function TransactionDiscountInformationBox($localStorage) {
        this.$localStorage = $localStorage;
        this.$inject = ['$localStorage'];
        this.summary = null;
        this.exportInProcess = false;
    }
    TransactionDiscountInformationBox.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    TransactionDiscountInformationBox.prototype.exportCSV = function () {
        this.exportInProcess = true;
    };
    return TransactionDiscountInformationBox;
}());
angular.module('naut').component('transactionDiscountInformationBox', {
    template: __webpack_require__(745),
    controller: TransactionDiscountInformationBox,
    controllerAs: 'ctrl',
    bindings: {
        summary: '<'
    }
});


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var IActiveStaffsFilter_1 = __webpack_require__(91);
var IShopperStaffDiscountTransactionListItem_1 = __webpack_require__(310);
var TransactionWithDiscountTab = /** @class */ (function () {
    function TransactionWithDiscountTab($scope, $translate, discountForStaffService, notificationService, $state, $localStorage) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.discountForStaffService = discountForStaffService;
        this.notificationService = notificationService;
        this.$state = $state;
        this.$localStorage = $localStorage;
        this.items = [];
        this.enumStatus = IShopperStaffDiscountTransactionListItem_1.IShopperStaffDiscountTransactionStatus;
        this.search = {
            placeholder: '',
            text: ''
        };
        this.messages = {
            searchMessageTitle: '',
            searchMessageContent: '',
            emptyListMessageTitle: '',
            emptyListMessageContent: ''
        };
        this.filter = {
            isActive: false,
            isApplied: false,
            data: {
                selectedLocations: [],
                dateFrom: moment(new Date()).add(-30, 'days').toDate(),
                dateTo: new Date()
            },
            clear: function () {
                _this.filter.isApplied = false;
                _this.filter.data = {
                    selectedLocations: [],
                    dateFrom: moment(new Date()).add(-30, 'days').toDate(),
                    dateTo: new Date()
                };
            },
            toggle: function () {
                _this.filter.isActive = !_this.filter.isActive;
                if (!_this.filter.isActive) {
                    _this.clearFilter();
                }
            },
            set: function (newFilterSettings) {
                _this.filter.isApplied = true;
                _this.filter.data = {
                    selectedLocations: newFilterSettings.selectedLocations,
                    dateFrom: newFilterSettings.dateFrom,
                    dateTo: newFilterSettings.dateTo
                };
            }
        };
        this.itemsLimit = 20;
        this.canLoadMore = true;
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
    }
    TransactionWithDiscountTab.prototype.$onInit = function () {
        var _this = this;
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
        this.loadData(false);
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    TransactionWithDiscountTab.prototype.applySearch = function (searchText) {
        if (!this.validateFilter()) {
            return;
        }
        this.search.text = searchText;
        this.resetHistoryItemsList();
        this.loadData(searchText.length > 0);
    };
    TransactionWithDiscountTab.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.search.text = '';
                this.applySearch('');
                return [2 /*return*/];
            });
        });
    };
    TransactionWithDiscountTab.prototype.toggleFilter = function () {
        this.filter.toggle();
    };
    TransactionWithDiscountTab.prototype.applyFilter = function (newFilterSetting) {
        this.filter.set(newFilterSetting);
        this.applySearch(this.search.text);
    };
    TransactionWithDiscountTab.prototype.clearFilter = function () {
        if (this.filter.isApplied) {
            this.filter.clear();
            this.applySearch('');
        }
        else {
            this.filter.clear();
        }
    };
    TransactionWithDiscountTab.prototype.openTransactionDetails = function (id) {
        this.$state.go('app.discountForStaffs.transaction.singleTransaction', { id: id });
    };
    TransactionWithDiscountTab.prototype.loadData = function (forSearch) {
        var _this = this;
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.forSearch = forSearch;
        this.waiting = true;
        var filter = {
            From: this.filter.isApplied ?
                (this.filter.data.dateFrom ?
                    moment(this.filter.data.dateFrom).utc(true).startOf('day').toDate() :
                    null) :
                moment(new Date()).add(-30, 'days').utc(true).startOf('day').toDate(),
            To: this.filter.isApplied ?
                (this.filter.data.dateTo ?
                    moment(this.filter.data.dateTo).utc(true).startOf('day').toDate() :
                    null) :
                moment(new Date()).utc(true).startOf('day').toDate(),
            Limit: 20,
            Offset: this.items.length,
            SortColumn: 'DateTime',
            SortOrder: IActiveStaffsFilter_1.SortOrderEnum.Descending,
            Keyword: this.search.text,
            PlacesID: this.filter.isApplied ? this.filter.data.selectedLocations.map(function (x) { return x.ID; }) : null
        };
        this.notificationService.showWaitingMessage();
        this.discountForStaffService.getTransactionsSummary(filter)
            .then(function (response) {
            _this.transactionsSummary = response;
        })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
        });
        return this.discountForStaffService.getTransactionsWithDiscount(filter)
            .then(function (response) {
            _this.total = response.Total;
            Array.prototype.push.apply(_this.items, response.Items);
            if (_this.items && _this.items.length === 0) {
                if (_this.forSearch) {
                    _this.messages.searchMessageContent = _this.$translate.instant('transaction_history_search_empty_content', { search: _this.search.text });
                }
            }
            _this.canLoadMore = response.Items.length === _this.itemsLimit;
        })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
        })["finally"](function () {
            _this.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    TransactionWithDiscountTab.prototype.getFilterPeriod = function () {
        return moment(this.filter.data.dateTo).utc(true).diff(moment(this.filter.data.dateFrom).utc(true), 'days').toString();
    };
    TransactionWithDiscountTab.prototype.validateFilter = function () {
        var dateFrom = this.filter.data.dateFrom;
        var dateTo = this.filter.data.dateTo;
        if (!dateFrom && !dateTo) {
            return true;
        }
        if (!dateFrom) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_from_is_requierd_error'));
            return false;
        }
        if (!dateTo) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_to_is_required_error'));
            return false;
        }
        var datesDiff = moment(dateTo).diff(dateFrom, 'seconds');
        if (datesDiff < 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('invalid_date_range_error'));
            return false;
        }
        return true;
    };
    TransactionWithDiscountTab.prototype.resetHistoryItemsList = function () {
        this.waiting = false;
        this.canLoadMore = true;
        this.items = [];
        this.total = 0;
    };
    TransactionWithDiscountTab.$inject = ['$scope', '$translate', 'discountForStaffService', 'notificationService', '$state', '$localStorage'];
    return TransactionWithDiscountTab;
}());
angular.module('naut').component('transactionWithDiscountTab', {
    template: __webpack_require__(746),
    controller: TransactionWithDiscountTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var base_analytics_1 = __webpack_require__(80);
var variations_report_filter_enum_1 = __webpack_require__(314);
var DownloadsComponent = /** @class */ (function (_super) {
    __extends(DownloadsComponent, _super);
    function DownloadsComponent(dppExportCsvService, translate, notificationService, retailerService, dppAnalyticsService) {
        var _this = _super.call(this, dppExportCsvService, translate) || this;
        _this.notificationService = notificationService;
        _this.retailerService = retailerService;
        _this.dppAnalyticsService = dppAnalyticsService;
        _this.filters = [variations_report_filter_enum_1.VariationsReportFilterEnum.ALL, variations_report_filter_enum_1.VariationsReportFilterEnum.LIMITED, variations_report_filter_enum_1.VariationsReportFilterEnum.UNLIMITED];
        _this.selectedFilter = variations_report_filter_enum_1.VariationsReportFilterEnum.ALL;
        _this.filterExpanded = false;
        _this.exportHeaders = ['Product', 'Product type', 'Downloads', 'Unique Users'];
        return _this;
    }
    DownloadsComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadReports();
                return [2 /*return*/];
            });
        });
    };
    DownloadsComponent.prototype.exportCSV = function () {
        var _this = this;
        if (this.variationsStatistics) {
            var prefix = this.translate.instant('downloads');
            var items = this.variationsStatistics.VariationStatistics.map(function (item) {
                return {
                    Title: item.Title,
                    Free: item.Free ? _this.translate.instant('free_title') : _this.translate.instant('time_limited'),
                    ViewsCount: item.ViewsCount,
                    ShoppersCount: item.ShoppersCount
                };
            });
            this["export"](items, prefix);
        }
    };
    DownloadsComponent.prototype.getImageUrl = function (report) {
        if (report.ImageIDs && report.ImageIDs.length > 0) {
            return this.retailerService.getProductImageUrl(report.ImageIDs[0], 46, 46);
        }
        else {
            return null;
        }
    };
    DownloadsComponent.prototype.getFilterName = function (filter) {
        switch (filter) {
            case variations_report_filter_enum_1.VariationsReportFilterEnum.ALL:
                return this.translate.instant('all_content_type');
            case variations_report_filter_enum_1.VariationsReportFilterEnum.LIMITED:
                return this.translate.instant('limited_reading_time');
            case variations_report_filter_enum_1.VariationsReportFilterEnum.UNLIMITED:
                return this.translate.instant('unlimited_reading_time');
        }
    };
    DownloadsComponent.prototype.onChangeFilter = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (filter !== this.selectedFilter) {
                    this.selectedFilter = filter;
                    this.loadReports();
                }
                return [2 /*return*/];
            });
        });
    };
    DownloadsComponent.prototype.loadReports = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.dppAnalyticsService.getVariationsReport({
                                From: this.from,
                                To: this.to,
                                ReadingTypeFilter: this.selectedFilter
                            })];
                    case 2:
                        response = _a.sent();
                        this.nothingToShowYet = response.status === 204;
                        if (!this.nothingToShowYet) {
                            this.variationsStatistics = response.data;
                            this.noResults = this.variationsStatistics.VariationStatistics.length === 0;
                        }
                        this.notificationService.clearAll();
                        this.loadedOnce = true;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.notificationService.showErrorMessage(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    DownloadsComponent.$inject = ['dppExportCsvService', '$translate', 'notificationService', 'retailerService', 'dppAnalyticsService'];
    return DownloadsComponent;
}(base_analytics_1.BaseAnalytics));
exports.DownloadsComponent = DownloadsComponent;
angular
    .module('naut')
    .component('downloads', {
    template: __webpack_require__(747),
    controller: DownloadsComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DppAnalyticsService = /** @class */ (function () {
    function DppAnalyticsService(retailerService, http, transferFileService, enumService, $http) {
        this.retailerService = retailerService;
        this.http = http;
        this.transferFileService = transferFileService;
        this.enumService = enumService;
        this.$http = $http;
    }
    DppAnalyticsService.prototype.getVariationsReport = function (body) {
        return this.$http.post(this.retailerService.variationsReport(), body);
    };
    DppAnalyticsService.prototype.exportToCsv = function (rows, fileName) {
        var csvContent = '';
        rows.forEach(function (rowArray) {
            var row = rowArray.join(';');
            csvContent += row + '\r\n';
        });
        this.transferFileService.transferFile(csvContent, fileName, this.enumService.ExportFileType.CSV);
    };
    DppAnalyticsService.$inject = ['retailerService', 'http', 'transferFileService', 'enumService', '$http'];
    return DppAnalyticsService;
}());
exports.DppAnalyticsService = DppAnalyticsService;
angular
    .module('naut')
    .service('dppAnalyticsService', DppAnalyticsService);


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ActiveExtras = /** @class */ (function () {
    function ActiveExtras($scope, $translate, notificationService, extrasService, $state, popupService) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.extrasService = extrasService;
        this.$state = $state;
        this.popupService = popupService;
        this.model = {
            extras: [],
            searchTerm: null,
            searchTermForEmptyScreen: null,
            waiting: false
        };
        this.total = 0;
        this.isSearch = false;
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
    }
    ActiveExtras.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadActiveExtras()];
                    case 1:
                        _a.sent();
                        this.bindWindowEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActiveExtras.prototype.loadActiveExtras = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, extrasResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.model.waiting) {
                            return [2 /*return*/];
                        }
                        if (this.total && this.model.extras.length === this.total) {
                            return [2 /*return*/];
                        }
                        this.model.waiting = true;
                        filter = {
                            SearchTerm: this.model.searchTerm,
                            Limit: 20,
                            SearchAfterID: this.model.extras.length ? _.last(this.model.extras).ID : null,
                            Archived: false
                        };
                        this.model.searchTermForEmptyScreen = this.model.searchTerm;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.extrasService.getExtras(filter)];
                    case 2:
                        extrasResponse = _a.sent();
                        this.total = extrasResponse.Total;
                        Array.prototype.push.apply(this.model.extras, extrasResponse.Items);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.model.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ActiveExtras.prototype.search = function (searchText) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.total = 0;
                        this.model.extras = [];
                        this.model.searchTerm = searchText;
                        return [4 /*yield*/, this.loadActiveExtras()];
                    case 1:
                        _a.sent();
                        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '';
                        return [2 /*return*/];
                }
            });
        });
    };
    ActiveExtras.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.model.searchTerm = '';
                this.search(this.model.searchTerm);
                return [2 /*return*/];
            });
        });
    };
    ActiveExtras.prototype.archiveExtra = function (extra) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('extras_archive_dialog_cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('extras_archive_dialog_ok'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('extras_archive_dialog_title'),
                                content: this.$translate.instant('extras_archive_dialog_content'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.notificationService.showWaitingMessage();
                        this.model.waiting = true;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 7, 8, 9]);
                        return [4 /*yield*/, this.extrasService.archiveExtra(extra.ID)];
                    case 5:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.resetExtrasList();
                        return [4 /*yield*/, this.loadActiveExtras()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 9];
                    case 8:
                        this.notificationService.clearAll();
                        this.model.waiting = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ActiveExtras.prototype.editExtra = function (extra) {
        this.$state.go('app.extras.edit', {
            id: extra.ID
        });
    };
    ActiveExtras.prototype.resetExtrasList = function () {
        this.model.waiting = false;
        this.model.extras = [];
        this.total = 0;
    };
    ActiveExtras.prototype.bindWindowEvents = function () {
        var _this = this;
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    ActiveExtras.$inject = [
        '$scope',
        '$translate',
        'notificationService',
        'extrasService',
        '$state',
        'popupService'
    ];
    return ActiveExtras;
}());
angular.module('naut').component('activeExtras', {
    template: __webpack_require__(748),
    controller: ActiveExtras,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddOrEditExtraItem = /** @class */ (function () {
    function AddOrEditExtraItem($rootScope, $scope, $stateParams, $state, notificationService, popupService, accountService, retailerService, foodPreferencesService, scheduleService, extrasService, $uibModal, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.accountService = accountService;
        this.retailerService = retailerService;
        this.foodPreferencesService = foodPreferencesService;
        this.scheduleService = scheduleService;
        this.extrasService = extrasService;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.waiting = false;
        this.showTitleError = false;
        this.titleErrorText = '';
        this.item = {
            Title: null,
            Price: null,
            SKU: null,
            Allergens: [],
            FoodPreferences: [],
            ImageID: null,
            CurrencyCode: null,
            CurrencySign: null,
            VAT: null,
            InsidePrice: null,
            InsideVAT: null
        };
        this.loadFoodPreferenceInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.allergenTitle = this.$translate.instant('allergens_title');
                        this.preferenceTitle = this.$translate.instant('foodPreference_title');
                        _a = this;
                        return [4 /*yield*/, this.foodPreferencesService.getAllergens()];
                    case 1:
                        _a.allAllergens = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.foodPreferencesService.getFoodPreference()];
                    case 2:
                        _b.allPreference = _c.sent();
                        this.commonAllergenDescription = this.bindDescription(this.allAllergens);
                        this.commonPreferenceDescription = this.bindDescription(this.allPreference);
                        return [2 /*return*/];
                }
            });
        }); };
    }
    AddOrEditExtraItem.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.titleErrorText = this.$translate.instant('extra_editor_title_error');
                        this.idParam = this.$stateParams.id;
                        this.isNew = !this.idParam;
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        if (!this.idParam) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadExtraItem()];
                    case 2:
                        _a.sent();
                        this.prepaidData();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setCurrency();
                        _a.label = 4;
                    case 4:
                        this.setAddImageWatcher();
                        return [4 /*yield*/, this.loadFoodPreferenceInfo()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditExtraItem.prototype.loadExtraItem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.extrasService.getExtraItem(this.idParam)];
                    case 1:
                        _a.item = _b.sent();
                        this.currencyCssClass = this.getCurrencyCssClass(this.item.CurrencySign);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditExtraItem.prototype.prepaidData = function () {
        var _this = this;
        this.item.FoodPreferences.forEach(function (x) {
            var item = _this.foodPreferences.find(function (i) { return i.ID === x.ID; });
            item.IsSelected = true;
        });
        this.item.Allergens.forEach(function (x) {
            var item = _this.foodAllergens.find(function (i) { return i.ID === x.ID; });
            item.IsSelected = true;
        });
    };
    AddOrEditExtraItem.prototype.setCurrency = function () {
        this.item.CurrencySign = this.accountService.userData.currencySign;
        this.currencyCssClass = this.getCurrencyCssClass(this.item.CurrencySign);
    };
    AddOrEditExtraItem.prototype.getCurrencyCssClass = function (sign) {
        switch (sign) {
            case '£': return 'withPound';
            case 'kr': return 'withKrona';
            case '$': return 'withDollar';
            case '€': return 'withEuro';
            case 'د.إ': return 'withDirham';
            default: return '';
        }
    };
    AddOrEditExtraItem.prototype.getImage = function (item) {
        return this.extrasService.getExtraImageUrl(item.ImageID.toString());
    };
    AddOrEditExtraItem.prototype.saveData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, requestModel, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.item.InsidePrice && this.item.Price) {
                            this.isEatInGreaterTakeaway = (Number(this.item.Price) !== Number(this.item.InsidePrice)) &&
                                (Number(this.item.InsidePrice) < Number(this.item.Price));
                        }
                        else {
                            this.isEatInGreaterTakeaway = false;
                        }
                        if (!this.item.Title || this.isEatInGreaterTakeaway) {
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        this.showTitleError = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.extrasService.checkExtraAlreadyExist(this.item.Title, this.item.ID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.showTitleError = true;
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [2 /*return*/];
                    case 4:
                        requestModel = this.getRequestModel();
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, 8, 9]);
                        return [4 /*yield*/, this.extrasService.createOrUpdateExtra(requestModel, this.idParam)];
                    case 6:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.notificationService.showSuccessMessage();
                        this.$state.go('app.extras.active');
                        return [3 /*break*/, 9];
                    case 7:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 9];
                    case 8:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditExtraItem.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$state.go('app.extras.active');
                return [2 /*return*/];
            });
        });
    };
    AddOrEditExtraItem.prototype.clearEatInTakeawayError = function () {
        this.isEatInGreaterTakeaway = false;
    };
    AddOrEditExtraItem.prototype.addImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var imageID, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                scope: this.$scope.$new(true),
                                resolve: {
                                    avatarId: function () { return _this.item.ImageID; },
                                    title: function () { return _this.$translate.instant('extra_photo'); },
                                    getUrl: function () {
                                        return _this.item.ImageID == null ||
                                            _this.extrasService.getExtraImageUrl(_this.item.ImageID.toString());
                                    },
                                    saveUrl: function () { return _this.extrasService.saveExtraImageUrl(); }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        imageID = _a.sent();
                        if (imageID) {
                            this.item.ImageID = imageID;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditExtraItem.prototype.bindDescription = function (preference) {
        var result = '';
        result += '<table class="preferenceDescription">';
        var counter = 0;
        preference
            .sort(function (a, b) {
            return a.Description.length > b.Description.length
                ? -1
                : b.Description.length > a.Description.length
                    ? 1
                    : 0;
        })
            .forEach(function (c) {
            if (counter % 3 === 0) {
                result += '<tr>';
            }
            result +=
                '<td><h3>' +
                    c.Name +
                    '</h3>' +
                    c.Description +
                    '</br></td>';
            counter++;
            if (counter % 3 === 0) {
                result += '</tr>';
            }
        });
        result += '</table>';
        return result;
    };
    AddOrEditExtraItem.prototype.getRequestModel = function () {
        return {
            Title: this.item.Title,
            Price: this.item.Price,
            SKU: this.item.SKU,
            AllergenIDs: this.foodAllergens.filter(function (x) { return x.IsSelected; }).map(function (x) { return x.ID; }),
            FoodPreferenceIDs: this.foodPreferences.filter(function (x) { return x.IsSelected; }).map(function (x) { return x.ID; }),
            ImageID: this.item.ImageID,
            VAT: this.item.Price ? this.item.VAT : null,
            InsidePrice: this.item.Price ? this.item.InsidePrice : null,
            InsideVAT: this.item.InsidePrice && this.item.Price ? this.item.InsideVAT : null
        };
    };
    AddOrEditExtraItem.prototype.setAddImageWatcher = function () {
        var _this = this;
        this.$scope.$watch(function () { return _this.item.ImageID; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.extraEditorForm.$setDirty();
            }
        });
    };
    AddOrEditExtraItem.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, error_5;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, this.extrasService.getFoodPreferences()];
                    case 2:
                        _a.foodPreferences = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.extrasService.getAllergens()];
                    case 3:
                        _b.foodAllergens = _c.sent();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 5];
                    case 4:
                        error_5 = _c.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditExtraItem.$inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$state',
        'notificationService',
        'popupService',
        'accountService',
        'retailerService',
        'foodPreferenceService',
        'scheduleService',
        'extrasService',
        '$uibModal',
        '$translate'
    ];
    return AddOrEditExtraItem;
}());
angular.module('naut').component('addOrEditExtraItem', {
    template: __webpack_require__(749),
    controller: AddOrEditExtraItem,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ArchivedExtras = /** @class */ (function () {
    function ArchivedExtras($scope, $translate, notificationService, extrasService, popupService) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.extrasService = extrasService;
        this.popupService = popupService;
        this.model = {
            extras: [],
            searchTerm: null,
            searchTermForEmptyScreen: null,
            waiting: false
        };
        this.total = 0;
        this.isSearch = false;
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
    }
    ArchivedExtras.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadArchivedExtras()];
                    case 1:
                        _a.sent();
                        this.bindWindowEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchivedExtras.prototype.loadArchivedExtras = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, extrasResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.model.waiting) {
                            return [2 /*return*/];
                        }
                        if (this.total && this.model.extras.length === this.total) {
                            return [2 /*return*/];
                        }
                        this.model.waiting = true;
                        filter = {
                            SearchTerm: this.model.searchTerm,
                            Limit: 20,
                            SearchAfterID: this.model.extras.length ? _.last(this.model.extras).ID : null,
                            Archived: true
                        };
                        this.model.searchTermForEmptyScreen = this.model.searchTerm;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.extrasService.getExtras(filter)];
                    case 2:
                        extrasResponse = _a.sent();
                        this.total = extrasResponse.Total;
                        Array.prototype.push.apply(this.model.extras, extrasResponse.Items);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.model.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ArchivedExtras.prototype.search = function (searchText) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.total = 0;
                        this.model.extras = [];
                        this.model.searchTerm = searchText;
                        return [4 /*yield*/, this.loadArchivedExtras()];
                    case 1:
                        _a.sent();
                        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '';
                        return [2 /*return*/];
                }
            });
        });
    };
    ArchivedExtras.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.model.searchTerm = '';
                this.search(this.model.searchTerm);
                return [2 /*return*/];
            });
        });
    };
    ArchivedExtras.prototype.restoreExtra = function (extra) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('restore'),
                                cancelClass: 'btn btn-with-background-icon icon-time-restore--white btn-success',
                                title: this.$translate.instant('restore_extras_title'),
                                content: this.$translate.instant('restore_extras_content'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.notificationService.showWaitingMessage();
                        this.model.waiting = true;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 7, 8, 9]);
                        return [4 /*yield*/, this.extrasService.restoreExtra(extra.ID)];
                    case 5:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.resetExtrasList();
                        return [4 /*yield*/, this.loadArchivedExtras()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 9];
                    case 8:
                        this.notificationService.clearAll();
                        this.model.waiting = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ArchivedExtras.prototype.resetExtrasList = function () {
        this.model.waiting = false;
        this.model.extras = [];
        this.total = 0;
    };
    ArchivedExtras.prototype.bindWindowEvents = function () {
        var _this = this;
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    ArchivedExtras.$inject = [
        '$scope',
        '$translate',
        'notificationService',
        'extrasService',
        'popupService'
    ];
    return ArchivedExtras;
}());
angular.module('naut').component('archivedExtras', {
    template: __webpack_require__(750),
    controller: ArchivedExtras,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ExtraItemCard = /** @class */ (function () {
    function ExtraItemCard(extrasService, $localStorage) {
        this.extrasService = extrasService;
        this.$localStorage = $localStorage;
    }
    ExtraItemCard.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    ExtraItemCard.prototype.getImage = function (imageID) {
        return this.extrasService.getExtraImageUrl(imageID);
    };
    ExtraItemCard.$inject = ['extrasService', '$localStorage'];
    return ExtraItemCard;
}());
angular.module('naut').component('extraItemCard', {
    template: __webpack_require__(751),
    controller: ExtraItemCard,
    controllerAs: 'ctrl',
    bindings: {
        itemId: '<',
        itemTitle: '<',
        price: '<',
        imageId: '<',
        isArchived: '<',
        sku: '<',
        onEdit: '&',
        onDelete: '&',
        onRestore: '&'
    }
});


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ExtrasService = /** @class */ (function () {
    function ExtrasService(http, retailerService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.getActiveExtras = function (query) {
            return _this.http.get(_this.retailerService.activeExtras(), { params: query });
        };
        this.getExtraItem = function (extraID) {
            return _this.http.get(_this.retailerService.extras(extraID), null);
        };
        this.getFoodPreferences = function () {
            return _this.http.get(_this.retailerService.foodPreference());
        };
        this.getAllergens = function () {
            return _this.http.get(_this.retailerService.foodAllergens());
        };
        this.getExtras = function (query) {
            return _this.http.get(_this.retailerService.extras(), { params: query });
        };
        this.createExtra = function (query) {
            return _this.http.post(_this.retailerService.extras(), query);
        };
        this.updateExtra = function (extraID, extraModel) {
            return _this.http.put(_this.retailerService.extras(extraID), extraModel);
        };
        this.archiveExtra = function (extraID) {
            return _this.http.put(_this.retailerService.archiveExtra(extraID), null);
        };
        this.restoreExtra = function (extraID) {
            return _this.http.put(_this.retailerService.restoreExtra(extraID), null);
        };
        this.saveExtraImageUrl = function () {
            return _this.retailerService.createExtraImage();
        };
        this.getExtraImageUrl = function (imageID) {
            return _this.retailerService.getExtraImage(imageID);
        };
    }
    ExtrasService.prototype.createOrUpdateExtra = function (extraModel, extraID) {
        if (extraID == null) {
            return this.createExtra(extraModel);
        }
        else {
            return this.updateExtra(extraID, extraModel);
        }
    };
    ExtrasService.prototype.checkExtraAlreadyExist = function (title, extraID) {
        return this.http.get(this.retailerService.checkTitle(title, extraID));
    };
    ExtrasService.$inject = ['http', 'retailerService'];
    return ExtrasService;
}());
exports.ExtrasService = ExtrasService;
angular
    .module('naut')
    .service('extrasService', ExtrasService);


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CheckboxesGroupList = /** @class */ (function () {
    function CheckboxesGroupList() {
    }
    return CheckboxesGroupList;
}());
angular.module('naut').component('checkboxesGroupList', {
    template: __webpack_require__(752),
    controller: CheckboxesGroupList,
    controllerAs: 'ctrl',
    bindings: {
        items: '='
    }
});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var Search = /** @class */ (function () {
    function Search() {
    }
    Search.prototype.clear = function () {
        this.text = '';
        this.onClearClick();
    };
    return Search;
}());
angular.module('naut').component('search', {
    template: __webpack_require__(753),
    controller: Search,
    controllerAs: 'ctrl',
    bindings: {
        placeholderText: '<',
        disabled: '<',
        text: '<',
        classes: '<',
        onSearchClick: '&',
        onClearClick: '&'
    }
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var PreferenceSelector = /** @class */ (function () {
    function PreferenceSelector(popupService, $translate) {
        this.popupService = popupService;
        this.$translate = $translate;
    }
    PreferenceSelector.prototype.ShowTooltip = function (message) {
        this.popupService.alert({
            title: this.componentTitle,
            okTxt: this.$translate.instant('close'),
            okClass: 'btn-success',
            content: message,
            classPopup: 'preferencePopup'
        });
    };
    PreferenceSelector.$inject = ['popupService', '$translate'];
    return PreferenceSelector;
}());
angular.module('naut').component('preferenceSelector', {
    template: __webpack_require__(754),
    controller: PreferenceSelector,
    controllerAs: 'vm',
    bindings: {
        'preferences': '<',
        'componentTitle': '<',
        'description': '<',
        'onChange': '&'
    }
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var FoodPreferenceService = /** @class */ (function () {
    function FoodPreferenceService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    FoodPreferenceService.prototype.getAllergens = function () {
        return this.http.get(this.retailerService.foodAllergens());
    };
    FoodPreferenceService.prototype.getFoodPreference = function () {
        return this.http.get(this.retailerService.foodPreference());
    };
    FoodPreferenceService.$inject = ['http', 'retailerService'];
    return FoodPreferenceService;
}());
exports.FoodPreferenceService = FoodPreferenceService;
angular.module('naut').service('foodPreferenceService', FoodPreferenceService);


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var HomeScreenController = /** @class */ (function () {
    function HomeScreenController($rootScope, $scope, $translate, accountService, navigationService, backToDashboardService, $state) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$translate = $translate;
        this.accountService = accountService;
        this.navigationService = navigationService;
        this.backToDashboardService = backToDashboardService;
        this.$state = $state;
        this.getWarnings();
        var unwatch = $rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userData.permission) {
                    unwatch();
                    this.adminMenu = navigationService.getAdminMenu();
                    this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                    if (userData.permission === this.$rootScope.enums.RetailerPermission.Publisher) {
                        this.$state.go('app.products');
                    }
                }
                return [2 /*return*/];
            });
        }); }, true);
    }
    HomeScreenController.prototype.logOff = function (redirectToHomepage) {
        this.accountService.logOut(redirectToHomepage);
    };
    HomeScreenController.prototype.canNavigateBack = function () {
        return !!this.backToDashboardService.dashboardLink;
    };
    HomeScreenController.prototype.getWarnings = function () {
        var _this = this;
        // Fake retrieving warnings count from api
        var warningsCount = 0;
        var promise = new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(warningsCount);
            }, 500);
        });
        promise.then(function (result) {
            _this.warningsCount = result.toString();
        });
    };
    HomeScreenController.$inject = ['$rootScope', '$scope', '$translate', 'accountService', 'navigationService', 'backToDashboardService', '$state'];
    return HomeScreenController;
}());
angular
    .module('naut')
    .component('homeScreen', {
    template: __webpack_require__(755),
    controller: HomeScreenController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var ChoiceInformationCardImagesComponent = /** @class */ (function () {
    function ChoiceInformationCardImagesComponent($scope, $q, informationCardsService, popupService, notificationService, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.informationCardsService = informationCardsService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.uploadedImages = null;
        this.images = [];
        this.waiting = false;
        this.sortableOptions = {};
        this.uploadImages = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var failImages, validImages, promises, imageIDs, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uploadedImages) {
                            return [2 /*return*/];
                        }
                        failImages = _.reject(this.uploadedImages, this.emptyErrorImage);
                        validImages = _.filter(this.uploadedImages, this.emptyErrorImage);
                        if (_.size(validImages) === 0) {
                            this.showFail(failImages);
                            this.uploadedImages = null;
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        promises = [];
                        _.forEach(validImages, function (image) {
                            promises.push(_this.informationCardsService.uploadImage(image));
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all(promises)];
                    case 2:
                        imageIDs = _a.sent();
                        _.forEach(imageIDs, function (imageID) {
                            if (imageID) {
                                _this.images.push(_this.getImageModel(imageID));
                            }
                        }, 0);
                        if (_.size(failImages) === 0) {
                            this.notificationService.showSuccessMessage();
                        }
                        else {
                            this.showFail(failImages);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.uploadedImages = null;
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteImage = function (image) {
            _this.images = _.reject(_this.images, function (item) {
                return item.id === image.id;
            });
            _this.deleteNoServerImage(image.id);
        };
        this.close = function () {
            _.forEach(_this.images, function (image) {
                _this.deleteNoServerImage(image.id);
            });
        };
        this.deleteNoServerImage = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var imageID, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageID = id;
                        if ((imageID) || _.contains(this.serverImagesId, imageID)) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.informationCardsService.deleteImage(imageID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.warn(error_2 + ' image with id ' + imageID + ' is not removed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.showFail = function (failImages) {
            _this.notificationService.clearAll();
            if (_.size(failImages) === 0) {
                return;
            }
            var li = '';
            _.forEach(failImages, function (image) {
                li += '<li>' + image.name + '</li>';
            });
            var ul = '<ul class="pl15">' + li + '</ul>';
            _this.popupService.alert({
                title: _this.$translate.instant('cant_upload_photos') || 'Can\'t upload photos',
                content: "<p>" + _this.$translate.instant('cant_upload_photos_description') + "</p>" + ul
            })["catch"](function () { return; });
        };
        this.getImageModel = function (id) {
            return {
                id: id,
                url: _this.informationCardsService.getImageUrl(id)
            };
        };
        this.updateModel = function () {
            _this.currentImagesId = _.pluck(_this.images, 'id');
            if (_.isFunction(_this.callbackUpdate)) {
                _this.callbackUpdate();
            }
        };
        this.init = function () {
            _this.uploadedImages = null;
            _this.images = [];
            _this.currentImagesId = _this.currentImagesId ? _this.currentImagesId : [];
            _this.serverImagesId = _this.serverImagesId ? _this.serverImagesId : [];
            if (_.isArray(_this.currentImagesId)) {
                _.forEach(_this.currentImagesId, function (id) {
                    _this.images.push(_this.getImageModel(id));
                });
            }
        };
        this.$scope.$watch('vm.currentImagesId', function (n, o) {
            if (n) {
                _this.init();
            }
        }, true);
        this.$scope.$watch('vm.images', function (n, o) {
            if (n) {
                _this.updateModel();
            }
        }, true);
    }
    ChoiceInformationCardImagesComponent.prototype.emptyErrorImage = function (image) {
        return image.error == null || image.error === '';
    };
    ChoiceInformationCardImagesComponent.$inject = ['$scope', '$q', 'informationCardsService', 'popupService', 'notificationService', '$translate'];
    return ChoiceInformationCardImagesComponent;
}());
angular.module('naut').component('choiceInformationCardImages', {
    template: ['$attrs', function ($attrs) {
            return _.isUndefined($attrs.wizard) ? __webpack_require__(113) : __webpack_require__(113);
        }],
    controller: ChoiceInformationCardImagesComponent,
    controllerAs: 'vm',
    bindings: {
        currentImagesId: '=',
        serverImagesId: '=',
        callbackUpdate: '&?'
    }
});


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var informationCardBase_controller_1 = __webpack_require__(241);
var InformationCardController = /** @class */ (function (_super) {
    __extends(InformationCardController, _super);
    function InformationCardController($rootScope, $scope, $q, $stateParams, $timeout, $previousState, informationCardsService, categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService, wysiwygService, notificationService, $translate, nfcRetailerStickersService) {
        var _this = _super.call(this, $rootScope, $scope, $q, $stateParams, $timeout, $previousState, informationCardsService, categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService, wysiwygService, notificationService, $translate, nfcRetailerStickersService) || this;
        _this.loadedModel = function () {
            if (_this.productForm) {
                _this.$timeout(function () {
                    _this.productForm.$setPristine();
                });
            }
            $('.wrapUlTags.overflowY').slimScroll({
                height: '374px'
            });
            $('.textAreaCustScroll').slimScroll({
                height: '105px'
            });
        };
        _this.model.loadedModel = _this.loadedModel;
        return _this;
    }
    InformationCardController.$inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'informationCardsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService', 'definitionsService',
        'wysiwygService', 'notificationService', '$translate', 'nfcRetailerStickersService'
    ];
    return InformationCardController;
}(informationCardBase_controller_1.InformationCardBaseController));
angular
    .module('naut').component('informationCard', {
    template: __webpack_require__(756),
    controller: InformationCardController,
    controllerAs: 'vm'
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var InfoTagSearchController = /** @class */ (function () {
    function InfoTagSearchController($scope, informationCardsService, notification) {
        var _this = this;
        this.informationCardsService = informationCardsService;
        this.notification = notification;
        this.pagination = {
            data: [],
            page: 1,
            pageSize: 10,
            total: 0
        };
        this.waiting = false;
        this.selectedProducts = {};
        this.modalInstance = this;
        this.getImageUrl = function (imageID) {
            if (!imageID) {
                return null;
            }
            return _this.informationCardsService.getImageUrl(imageID, 60);
        };
    }
    InfoTagSearchController.prototype.$onInit = function () {
        var _this = this;
        if (this.resolve.items && this.resolve.items.length > 0) {
            this.resolve.items.map(function (item) { return ({
                ID: item.InformationCardID,
                Title: item.Title,
                ImageID: item.ImageID
            }); }).forEach(function (item) { return _this.selectProduct(item); });
        }
        this.loadData();
    };
    InfoTagSearchController.prototype.confirm = function () {
        this.modalInstance.close({
            $value: this.getSelectedProducts()
        });
    };
    InfoTagSearchController.prototype.getSelectedCount = function () {
        return this.getSelectedProducts().length;
    };
    InfoTagSearchController.prototype.selectProduct = function (product) {
        if (!this.selectedProducts[product.ID]) {
            this.selectedProducts[product.ID] = product;
            return;
        }
        this.selectedProducts[product.ID] = null;
    };
    InfoTagSearchController.prototype.resetSearch = function () {
        this.searchTerm = '';
        this.search(this.searchTerm);
    };
    InfoTagSearchController.prototype.search = function (text) {
        this.searchTerm = text;
        this.loadData();
    };
    InfoTagSearchController.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notification.showWaitingMessage();
                        this.waiting = true;
                        filter = {
                            searchTerm: this.searchTerm,
                            limit: this.pagination.pageSize,
                            offset: (this.pagination.page - 1) * this.pagination.pageSize,
                            sortColumn: 'Title',
                            sortOrder: 0
                        };
                        return [4 /*yield*/, this.informationCardsService.searchInformationCards(filter)];
                    case 1:
                        result = _a.sent();
                        this.pagination.data = result.Items;
                        this.pagination.total = result.Total;
                        this.notification.clearAll();
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoTagSearchController.prototype.getSelectedProducts = function () {
        return _.filter(this.selectedProducts, function (v) { return v || false; });
    };
    InfoTagSearchController.$inject = ['$scope', 'informationCardsService', 'notificationService'];
    return InfoTagSearchController;
}());
angular.module('naut').component('infoCardSearch', {
    template: __webpack_require__(757),
    controller: InfoTagSearchController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var popupServiceCancel_1 = __webpack_require__(5);
var viewport_typed_controller_1 = __webpack_require__(4);
var core_1 = __webpack_require__(56);
var InformationCardsController = /** @class */ (function (_super) {
    __extends(InformationCardsController, _super);
    function InformationCardsController($rootScope, $scope, $stateParams, $q, $timeout, informationCardsService, popupService, notificationService, enums, $translate) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.$timeout = $timeout;
        _this.informationCardsService = informationCardsService;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.enums = enums;
        _this.$translate = $translate;
        _this.waiting = false;
        _this.data = {
            Items: [],
            Total: 0
        };
        _this.settings = {
            pageSize: 5,
            page: 1,
            sortSet: _this.informationCardsService.getSortSet(),
            sort: null,
            productFilter: '',
            productState: null,
            isExistActiveProducts: null,
            isExistArchiveProducts: null,
            getFilter: function () {
                var i = _this.settings;
                var search = i.productFilter ? i.productFilter.trim() : '';
                return {
                    Limit: i.pageSize,
                    Offset: (i.page - 1) * i.pageSize,
                    SortColumn: i.sort.column,
                    SortOrder: i.getSortOrder(i.sort.order),
                    CardName: search,
                    CardID: '',
                    State: i.productState
                };
            },
            getSortOrder: function (sortOrder) {
                return sortOrder === 'ascending' ? core_1.InformationCardFilter.SortOrderEnum.NUMBER_0 : core_1.InformationCardFilter.SortOrderEnum.NUMBER_1;
            },
            getStateParams: function () {
                var i = _this.settings;
                var search = i.productFilter ? i.productFilter.trim() : '';
                return {
                    page: encodeURIComponent(i.page.toString()),
                    column: encodeURIComponent(i.sort.column),
                    order: encodeURIComponent(i.sort.order),
                    state: encodeURIComponent(i.productState.toString()),
                    search: encodeURIComponent(search),
                    sort: null
                };
            },
            settingsClear: function (state) {
                var i = _this.settings;
                i.page = 1;
                i.sort = _this.informationCardsService.getSort();
                i.productFilter = '';
                i.productState = _.isUndefined(state) ? _this.productState.Active : state;
            },
            isShowFilter: function () {
                var i = _this.settings;
                return (_this.productState.Archived === i.productState && i.isExistArchiveProducts === true) ||
                    (_this.productState.Active === i.productState && i.isExistActiveProducts === true);
            }
        };
        _this.linkTypes = [];
        _this.productState = _this.$rootScope.enums.PhysicalProductState;
        _this.params = null;
        _this.applyFilter = function () {
            _this.settings.page = 1;
            _this.reload();
        };
        _this.getImageUrl = function (imageIDs, width, height) {
            if (!imageIDs) {
                return null;
            }
            if (_.isArray(imageIDs)) {
                return _this.informationCardsService.getImageUrl(_.first(imageIDs), width, height);
            }
            else {
                return _this.informationCardsService.getImageUrl(imageIDs, width, height);
            }
        };
        _this.archive = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var popupTitle, popupContent, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        popupTitle = this.$translate.instant('archive_information_card');
                        popupContent = this.$translate.instant('archive_information_card_confirm');
                        return [4 /*yield*/, this.popupService.confirm({
                                title: popupTitle,
                                content: popupContent,
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                cancelClass: 'btn-success',
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this.archiveProductInternal(product);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.restore = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var popupTitle, popupContent, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        popupTitle = this.$translate.instant('restore_information_card');
                        popupContent = this.$translate.instant('restore_information_card_confirm');
                        return [4 /*yield*/, this.popupService.confirm({
                                title: popupTitle,
                                content: popupContent,
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                cancelClass: 'btn-success',
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this.restoreProductInternal(product);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([
                                this.informationCardsService.getInformationCards(this.settings.getFilter()),
                                this.informationCardsService.getLinkTypes(),
                                this.informationCardsService.isExistInformationCards(this.productState.Active),
                                this.informationCardsService.isExistInformationCards(this.productState.Archived)
                            ])];
                    case 2:
                        response = _a.sent();
                        this.notificationService.clearAll();
                        this.data = response[0];
                        this.linkTypes = response[1];
                        this.settings.isExistActiveProducts = response[2];
                        this.settings.isExistArchiveProducts = response[3];
                        this.adaptData();
                        if (this.data.Total === 0 && !_.isEmpty(this.settings.productFilter)) {
                            this.notificationService.showInfoMessage(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.archiveProductInternal = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var id, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.informationCardsService.archiveInformationCard(product.ID)];
                    case 2:
                        id = _a.sent();
                        this.settings.settingsClear(this.productState.Archived);
                        if (this.settings.productState !== this.productState.Archived) {
                            this.settings.settingsClear(this.productState.Archived);
                        }
                        else {
                            this.getData();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.restoreProductInternal = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var id, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.informationCardsService.restoreInformationCard(product.ID)];
                    case 2:
                        id = _a.sent();
                        this.settings.settingsClear(this.productState.Archived);
                        if (this.settings.productState !== this.productState.Archived) {
                            this.settings.settingsClear(this.productState.Archived);
                        }
                        else {
                            this.getData();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.params = {
            page: parseInt($stateParams.page, 10),
            search: decodeURIComponent($stateParams.search),
            sort: informationCardsService.getSort(decodeURIComponent($stateParams.column), decodeURIComponent($stateParams.order)),
            state: parseInt(decodeURIComponent($stateParams.state), 10)
        };
        _this.params.page = _this.params.page ? _this.params.page : 1;
        _this.params.sort = _this.params.sort ? _this.params.sort : _this.informationCardsService.getSort();
        _this.params.state = _this.params.state ? _this.params.state : _this.productState.Active;
        _this.settings.page = _this.params.page;
        _this.settings.sort = _this.params.sort;
        _this.settings.productFilter = _this.params.search;
        _this.settings.productState = _this.params.state;
        $scope.$watchGroup(['vm.settings.productState', 'vm.settings.page'], function (n, o) {
            if (n !== o) {
                _this.reload();
            }
        });
        _this.getData();
        return _this;
    }
    InformationCardsController.prototype.onSearchFilterKeyPress = function ($event) {
        if ($event.which === 13) {
            return this.applyFilter();
        }
        return 0;
    };
    InformationCardsController.prototype.adaptData = function () {
        var _this = this;
        _.forEach(this.data.Items, function (product) {
            _.forEach(product.Links, function (link) {
                link.viewClass = _.findWhere(_this.linkTypes, { ID: link.Type }).viewClass;
            });
        });
        this.$timeout(function () {
            $('.wrapUlTags.overflowY').slimScroll({
                height: 'auto'
            });
            $('.wysiwyg__main').mCustomScrollbar({
                axis: 'y',
                theme: 'minimal-dark'
            });
        });
    };
    InformationCardsController.prototype.reload = function () {
        this.$rootScope.$state.go('app.information-cards', this.settings.getStateParams());
    };
    InformationCardsController.$inject = ['$rootScope', '$scope', '$stateParams', '$q', '$timeout',
        'informationCardsService', 'popupService', 'notificationService', 'enumService', '$translate'];
    return InformationCardsController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut').component('informationCards', {
    template: __webpack_require__(758),
    controller: InformationCardsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var InformationCardsService = /** @class */ (function () {
    function InformationCardsService($rootScope, http, $q, $uibModal, retailerService, blobService, popupService, $translate) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.http = http;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.blobService = blobService;
        this.popupService = popupService;
        this.$translate = $translate;
        this.importType = {
            product: 1,
            category: 2
        };
        this.asc = 'ascending';
        this.desc = 'descending';
        this.sortSet = [
            {
                column: 'CreateDate',
                order: this.asc,
                title: this.$translate.instant('create_date'),
                classSort: 'amount-asc'
            }, {
                column: 'CreateDate',
                order: this.desc,
                title: this.$translate.instant('create_date'),
                classSort: 'amount-desc'
            }, {
                column: 'Title',
                order: this.asc,
                title: this.$translate.instant('information_card_name'),
                classSort: 'alpha-asc'
            }, {
                column: 'Title',
                order: this.desc,
                title: this.$translate.instant('information_card_name'),
                classSort: 'alpha-desc'
            }
        ];
        this.linkViewClasses = {
            video: 'fa-youtube-play',
            document: 'fa-file-pdf-o',
            website: 'fa-globe',
            facebook: 'fa-facebook-official',
            twitter: 'fa-twitter',
            instagram: 'fa-instagram',
            pinterest: 'fa-pinterest',
            "default": 'fa-external-link-square'
        };
        this.linkTypes = null;
        this.defaultProduct = {
            title: '',
            description: '',
            links: [],
            imagesID: [],
            error: {},
            nfcStickers: []
        };
        this.getLinkTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var types;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!_.isArray(this.linkTypes)) return [3 /*break*/, 1];
                        return [2 /*return*/, this.$q.when(this.linkTypes)];
                    case 1: return [4 /*yield*/, this.http.get(this.retailerService.informationCardLinkTypes())];
                    case 2:
                        types = _a.sent();
                        _.forEach(types, function (type) {
                            var viewClass = _this.linkViewClasses[type.Name.toLowerCase()];
                            type.viewClass = viewClass ? viewClass : _this.linkViewClasses["default"];
                        });
                        this.linkTypes = types;
                        return [2 /*return*/, this.$q.when(this.linkTypes)];
                }
            });
        }); };
        this.getInformationCardModel = function (productID, edit) { return __awaiter(_this, void 0, void 0, function () {
            var serverModel, imagesID, exchange;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.retailerService.informationCard(productID))];
                    case 1:
                        serverModel = _a.sent();
                        imagesID = [];
                        if (!edit) {
                            _.forEach(serverModel.ImagesID, function (id) { imagesID.push(id); });
                        }
                        if (!_.isEmpty(imagesID)) return [3 /*break*/, 2];
                        return [2 /*return*/, this.toClientInformationCardModel(serverModel, imagesID, edit)];
                    case 2: return [4 /*yield*/, this.copyImage(imagesID)];
                    case 3:
                        exchange = _a.sent();
                        return [2 /*return*/, this.toClientInformationCardModel(serverModel, exchange, edit)];
                }
            });
        }); };
    }
    InformationCardsService.prototype.getDefaultProductModel = function () {
        var product = angular.copy(this.defaultProduct);
        return this.$q.when(product);
    };
    InformationCardsService.prototype.getInformationCards = function (filter) {
        return this.http.get(this.retailerService.getInformationCards(), { params: filter });
    };
    InformationCardsService.prototype.searchInformationCards = function (filter) {
        return this.http.get(this.retailerService.searchInformationCards(), { params: filter });
    };
    InformationCardsService.prototype.getImageUrl = function (imageID, width, height) {
        return this.retailerService.getInformationCardImageUrl(imageID, width, height || width);
    };
    InformationCardsService.prototype.getSort = function (column, order) {
        if (column && order) {
            return _.findWhere(this.sortSet, { column: column, order: order });
        }
        else {
            return this.sortSet[1];
        }
    };
    InformationCardsService.prototype.getSortSet = function () {
        return this.sortSet;
    };
    InformationCardsService.prototype.uploadImage = function (file) {
        if (!file) {
            return this.$q.when(null);
        }
        var fd = new FormData();
        fd.append('FileImage', this.blobService.dataUriToBlob(file.dataUri), file.name);
        return this.http.post(this.retailerService.informationCardImage(), fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };
    InformationCardsService.prototype.deleteImage = function (imageID) {
        return this.http["delete"](this.retailerService.informationCardImage(imageID));
    };
    InformationCardsService.prototype.copyImage = function (imagesID) {
        return this.http.post(this.retailerService.informationCardImageCopy(), imagesID);
    };
    InformationCardsService.prototype.updateInformationCard = function (cardID, model) {
        return this.http.put(this.retailerService.informationCard(cardID), this.toServerInformationCardModel(model));
    };
    InformationCardsService.prototype.createInformationCard = function (model) {
        return this.http.post(this.retailerService.informationCard(), this.toServerInformationCardModel(model));
    };
    InformationCardsService.prototype.archiveInformationCard = function (cardID) {
        return this.http.post(this.retailerService.archiveInformationCard(cardID), null);
    };
    InformationCardsService.prototype.restoreInformationCard = function (cardID) {
        return this.http.post(this.retailerService.restoreInformationCard(cardID), null);
    };
    InformationCardsService.prototype.isExistInformationCards = function (state) {
        return this.http.get(this.retailerService.existInformationCards(state));
    };
    InformationCardsService.prototype.showSaveChangesDialog = function () {
        var title = this.$translate.instant('save_changes_in_a_product_copy');
        var message = this.$translate.instant('save_changes_in_a_product_copy_confirm');
        return this.popupService.confirm({
            title: title,
            content: message
        });
    };
    InformationCardsService.prototype.toServerInformationCardModel = function (model) {
        return {
            Title: model.title,
            NfcStickers: model.nfcStickers,
            Description: model.description,
            Links: _.map(model.links, this.toServerLink),
            ImagesID: model.imagesID
        };
    };
    InformationCardsService.prototype.uploadImportFile = function (file, importType) {
        if (!file) {
            return this.$q.when(null);
        }
        var url = importType === this.importType.category ? this.retailerService.categoryMappingImport() : this.retailerService.productsImport();
        var fd = new FormData();
        fd.append('file', file, file.name);
        return this.http.post(url, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };
    InformationCardsService.prototype.toClientInformationCardModel = function (serverProduct, exchangeImages, edit) {
        var product = angular.copy(this.defaultProduct);
        product.title = serverProduct.Title;
        product.nfcStickers = serverProduct.NfcStickers;
        product.description = serverProduct.Description;
        product.draft = serverProduct.Draft;
        product.links = serverProduct.Links;
        product.imagesID = edit ? serverProduct.ImagesID : _.map(serverProduct.ImagesID, function (id) { return exchangeImages[id]; });
        return product;
    };
    InformationCardsService.prototype.toServerLink = function (link) {
        return {
            Type: link.type.ID,
            Title: link.Title,
            Url: link.Url
        };
    };
    InformationCardsService.$inject = ['$rootScope', 'http', '$q', '$uibModal', 'retailerService', 'blobService', 'popupService', '$translate'];
    return InformationCardsService;
}());
exports.InformationCardsService = InformationCardsService;
angular
    .module('naut')
    .service('informationCardsService', InformationCardsService);


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var IngredientDialog = /** @class */ (function () {
    function IngredientDialog($translate, notificationService, ingredientsService) {
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.ingredientsService = ingredientsService;
        this.modalInstance = this;
        this.item = {
            Archived: null,
            ID: null,
            Title: null
        };
        this.isNew = true;
        this.showUniqueNameError = false;
        this.showLongNameError = false;
        this.MAX_NAME_LENGTH = 64;
    }
    IngredientDialog.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.resolve.ingredient) {
                    this.item = {
                        Archived: this.resolve.ingredient.Archived,
                        ID: this.resolve.ingredient.ID,
                        Title: this.resolve.ingredient.Title
                    };
                }
                this.isNew = !this.resolve.ingredient;
                return [2 /*return*/];
            });
        });
    };
    IngredientDialog.prototype.titleChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.showUniqueNameError = false;
                this.showLongNameError = false;
                return [2 /*return*/];
            });
        });
    };
    IngredientDialog.prototype.updateIngredient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isIngredientUnique, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLongName()) {
                            this.showLongNameError = true;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.isIngredientUnique()];
                    case 1:
                        isIngredientUnique = _a.sent();
                        if (!isIngredientUnique) {
                            this.showUniqueNameError = true;
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, 8, 9]);
                        this.waiting = true;
                        if (!this.isNew) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.ingredientsService.addIngredient(this.item.Title)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.ingredientsService.editIngredient(this.resolve.ingredient.ID, this.item.Title)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.modalInstance.close({ $value: { status: 'ok' } });
                        return [3 /*break*/, 9];
                    case 7:
                        e_1 = _a.sent();
                        this.notificationService.showErrorMessage(e_1);
                        return [3 /*break*/, 9];
                    case 8:
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    IngredientDialog.prototype.closeDialog = function () {
        this.modalInstance.dismiss({ $value: { status: 'cancel' } });
    };
    IngredientDialog.prototype.isLongName = function () {
        return this.item.Title.length > this.MAX_NAME_LENGTH;
    };
    IngredientDialog.prototype.isIngredientUnique = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.waiting = true;
                        return [4 /*yield*/, this.ingredientsService.checkTitleForExist(this.item.Title, this.isNew ? null : this.item.ID)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 3:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IngredientDialog.$inject = [
        '$translate',
        'notificationService',
        'ingredientsService'
    ];
    return IngredientDialog;
}());
angular.module('naut').component('ingredientDialog', {
    template: __webpack_require__(759),
    controller: IngredientDialog,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var IngredientsTabs = /** @class */ (function () {
    function IngredientsTabs($uibModal, $state, $translate, notificationService, popupService, ingredientsService) {
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.ingredientsService = ingredientsService;
        this.search = {
            placeholder: '',
            text: ''
        };
        this.waiting = false;
        this.canLoadMore = true;
        this.ingredients = [];
        this.total = 0;
        this.forSearch = false;
        this.searchMessageContent = '';
        this.itemsLimit = 20;
        this.isActive = true;
        this.isActive = $state.params.isActive;
    }
    IngredientsTabs.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadData(false);
                return [2 /*return*/];
            });
        });
    };
    IngredientsTabs.prototype.loadData = function (forSearch) {
        var _this = this;
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.forSearch = forSearch;
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        var filter = {
            archived: !this.isActive,
            searchTerm: this.search.text,
            limit: this.itemsLimit,
            searchAfterID: this.ingredients.length ? _.last(this.ingredients).ID : null
        };
        this.ingredientsService.getIngredients(filter)
            .then(function (ingredientsResponse) {
            _this.total = ingredientsResponse.Total;
            var ingredients = ingredientsResponse.Items;
            Array.prototype.push.apply(_this.ingredients, ingredients);
            _this.waiting = false;
            _this.canLoadMore = ingredientsResponse.Items.length === _this.itemsLimit;
            if (_this.ingredients.length > 0) {
                return;
            }
            if (_this.search.text && forSearch) {
                _this.searchMessageContent = _this.$translate.instant('ingredients_list_not_found_screen_content', { search: _this.search.text });
            }
            _this.notificationService.clearAll();
        })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
            _this.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    IngredientsTabs.prototype.deleteIngredient = function (ingredient) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('archive_ingredient'),
                                content: "<span style=\"word-break: break-all\">" + this.$translate.instant('archive_ingredient_content', { ingredientTitle: ingredient.Title }) + "</span>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('button_archive'),
                                hasIcon: true
                            })];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.ingredientsService.archiveIngredient(ingredient.ID)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage();
                        return [3 /*break*/, 5];
                    case 5:
                        this.resetList();
                        this.loadData(false);
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _a.sent();
                        this.waiting = false;
                        return [2 /*return*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    IngredientsTabs.prototype.openIngredientDialog = function (ingredient) {
        return __awaiter(this, void 0, void 0, function () {
            var operationResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'ingredientDialog',
                                resolve: {
                                    ingredient: function () { return ingredient; }
                                },
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult && operationResult.status === 'ok') {
                            this.resetList();
                            this.loadData(false);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    IngredientsTabs.prototype.applySearch = function (searchText) {
        this.search.text = searchText;
        this.resetList();
        this.loadData(searchText.length > 0);
    };
    IngredientsTabs.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.search.text = '';
                this.applySearch('');
                return [2 /*return*/];
            });
        });
    };
    IngredientsTabs.prototype.restoreIngredient = function (ingredient) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_3, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, 7, 8]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('ingredient_restore_title'),
                                content: "<span style=\"word-break: break-all\">" + this.$translate.instant('ingredient_restore_content') + "</span>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-with-icon--before-restore btn-success flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('restore'),
                                hasIcon: true
                            })];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.ingredientsService.restoreIngredient(ingredient.ID)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage();
                        return [3 /*break*/, 5];
                    case 5:
                        this.resetList();
                        this.loadData(false);
                        return [3 /*break*/, 8];
                    case 6:
                        error_4 = _a.sent();
                        this.waiting = false;
                        return [2 /*return*/];
                    case 7:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    IngredientsTabs.prototype.setTab = function (tabName) {
        this.isActive = tabName === 'active';
        this.resetList();
        this.resetSearch();
        if (this.isActive) {
            this.$state.go('app.activeIngredients', { isActive: true });
        }
        else {
            this.$state.go('app.archivedIngredients', { isActive: false });
        }
    };
    IngredientsTabs.prototype.resetList = function () {
        this.canLoadMore = true;
        this.total = 0;
        this.ingredients = [];
    };
    IngredientsTabs.$inject = [
        '$uibModal',
        '$state',
        '$translate',
        'notificationService',
        'popupService',
        'ingredientsService',
    ];
    return IngredientsTabs;
}());
exports.IngredientsTabs = IngredientsTabs;
angular.module('naut').component('ingredientsTabs', {
    template: __webpack_require__(760),
    controller: IngredientsTabs,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ChooseCategoryModalInstanceController = /** @class */ (function () {
    function ChooseCategoryModalInstanceController() {
        var _this = this;
        this.modalInstance = this;
        this.categories = [];
        this.pagination = {
            data: [],
            page: 1,
            pageSize: 10,
            total: 0,
            filter: '',
            setDefault: function () {
                var i = _this.pagination;
                i.page = 1;
                i.filter = '';
            },
            setData: function () {
                var i = _this.pagination;
                var filtered = i.applyFilter();
                i.total = _.size(filtered);
                i.data = filtered.slice(i.pageSize * (i.page - 1), i.pageSize * i.page);
            },
            applyFilter: function () {
                var i = _this.pagination;
                var keyword = i.filter.trim();
                var regex = new RegExp('\\b' + keyword + '.*', 'i');
                if (i.filter.trim()) {
                    return _.filter(_this.categories, function (category) {
                        return regex.test(category.CategoryFullName);
                    });
                }
                else {
                    return _this.categories;
                }
            }
        };
    }
    ChooseCategoryModalInstanceController.prototype.$onInit = function () {
        this.categories = this.resolve.categories || [];
        this.pagination.setData();
    };
    ChooseCategoryModalInstanceController.prototype.ok = function (category) {
        this.modalInstance.close({ $value: category });
    };
    ChooseCategoryModalInstanceController.prototype.cancel = function () {
        this.modalInstance.dismiss({ $value: 'cancel' });
    };
    return ChooseCategoryModalInstanceController;
}());
angular.module('naut').component('chooseCategory', {
    template: __webpack_require__(761),
    controller: ChooseCategoryModalInstanceController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var HelpCountriesController = /** @class */ (function () {
    function HelpCountriesController(productsService, notificationServcie, $state, $translate, $location) {
        this.productsService = productsService;
        this.notificationServcie = notificationServcie;
        this.$state = $state;
        this.$translate = $translate;
        this.$location = $location;
    }
    HelpCountriesController.prototype.goToProductsImport = function () {
        this.$state.go('app.operations');
    };
    HelpCountriesController.prototype.goToHelp = function () {
        this.$state.go('app.help.manual');
    };
    HelpCountriesController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.productsService.GetCountryOrigins()];
                    case 2:
                        _a.items = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.notificationServcie.showErrorMessage(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HelpCountriesController.$inject = ['productsService', 'notificationService', '$state', '$translate', '$location'];
    return HelpCountriesController;
}());
angular
    .module('naut')
    .component('helpCountries', {
    controller: HelpCountriesController,
    template: __webpack_require__(762)
});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var HelpDictionaryController = /** @class */ (function () {
    function HelpDictionaryController(inventoryService, notificationServcie, $state, $translate, $location) {
        this.inventoryService = inventoryService;
        this.notificationServcie = notificationServcie;
        this.$state = $state;
        this.$translate = $translate;
        this.$location = $location;
    }
    HelpDictionaryController.prototype.goToProductsImport = function () {
        this.$state.go('app.operations');
    };
    HelpDictionaryController.prototype.goToHelp = function () {
        this.$state.go('app.help.manual');
    };
    HelpDictionaryController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.inventoryService.getClassificationDictionary()];
                    case 2:
                        response = _a.sent();
                        this.items = response;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.notificationServcie.showErrorMessage(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HelpDictionaryController.$inject = ['inventoryService', 'notificationService', '$state', '$translate', '$location'];
    return HelpDictionaryController;
}());
angular
    .module('naut')
    .component('helpDictionary', {
    controller: HelpDictionaryController,
    template: __webpack_require__(763)
});


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var HelpPageController = /** @class */ (function () {
    function HelpPageController($state, retailerApiUrl) {
        this.$state = $state;
        this.exampleCsvUrl = retailerApiUrl + "content/products_example.csv";
        this.templateCsvUrl = retailerApiUrl + "content/products_template.csv";
        this.exampleCsvUrl_food_bev = retailerApiUrl + "content/products_example_food_bev.csv";
        this.templateCsvUrl_food_bev = retailerApiUrl + "content/products_template_food_bev.csv";
    }
    HelpPageController.prototype.goToProductsImport = function () {
        this.$state.go('app.operations');
    };
    HelpPageController.$inject = ['$state', 'retailerServiceUrl'];
    return HelpPageController;
}());
angular
    .module('naut')
    .component('helpPage', {
    controller: HelpPageController,
    template: __webpack_require__(764)
});


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var HelpPreferencesController = /** @class */ (function () {
    function HelpPreferencesController(popupService, foodPreferencesService, notificationServcie, $state, $translate, $location) {
        this.popupService = popupService;
        this.foodPreferencesService = foodPreferencesService;
        this.notificationServcie = notificationServcie;
        this.$state = $state;
        this.$translate = $translate;
        this.$location = $location;
    }
    HelpPreferencesController.prototype.goToProductsImport = function () {
        this.$state.go('app.operations');
    };
    HelpPreferencesController.prototype.goToHelp = function () {
        this.$state.go('app.help.manual');
    };
    HelpPreferencesController.prototype.ShowTooltip = function (title, message) {
        this.popupService.alert({
            title: title,
            okTxt: this.$translate.instant('close'),
            okClass: 'btn-success',
            content: message,
            classPopup: 'preferencePopup'
        });
    };
    HelpPreferencesController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
                        this.waiting = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        _a = this;
                        return [4 /*yield*/, this.foodPreferencesService.getAllergens()];
                    case 2:
                        _a.allergens = _c.sent();
                        this.allergensDescription = this.bindDescription(this.allergens);
                        _b = this;
                        return [4 /*yield*/, this.foodPreferencesService.getFoodPreference()];
                    case 3:
                        _b.foodPreferences = _c.sent();
                        this.foodPreferenceDescription = this.bindDescription(this.foodPreferences);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        this.notificationServcie.showErrorMessage(e_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HelpPreferencesController.prototype.bindDescription = function (preference) {
        var result = '';
        result += '<table class="preferenceDescription">';
        var counter = 0;
        preference.sort(function (a, b) { return (a.Description.length > b.Description.length) ? -1 : ((b.Description.length > a.Description.length) ? 1 : 0); })
            .forEach(function (c) {
            if (counter % 3 === 0) {
                result += '<tr>';
            }
            result += '<td><h3>' + c.Name + '</h3>' + c.Description + '</br></td>';
            counter++;
            if (counter % 3 === 0) {
                result += '</tr>';
            }
        });
        result += '</table>';
        return result;
    };
    HelpPreferencesController.$inject = ['popupService', 'foodPreferenceService', 'notificationService', '$state', '$translate', '$location'];
    return HelpPreferencesController;
}());
angular
    .module('naut')
    .component('helpPreferences', {
    controller: HelpPreferencesController,
    template: __webpack_require__(765)
});


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ImportErrorsListController = /** @class */ (function () {
    function ImportErrorsListController() {
    }
    return ImportErrorsListController;
}());
angular.module('naut').component('importErrorsList', {
    controller: ImportErrorsListController,
    template: __webpack_require__(766),
    bindings: {
        errors: '<'
    }
});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var tooltip_state_1 = __webpack_require__(74);
var ImportTabComponent = /** @class */ (function () {
    function ImportTabComponent(productsService, enumService, operationService, notificationService, $q, $translate, $state) {
        this.productsService = productsService;
        this.enumService = enumService;
        this.operationService = operationService;
        this.notificationService = notificationService;
        this.$q = $q;
        this.$translate = $translate;
        this.$state = $state;
        this.tooltipState = tooltip_state_1.TooltipState.None;
        this.uploadDefer = $q.defer();
        this.uploadPromise = this.uploadDefer.promise;
    }
    ImportTabComponent.prototype.$onInit = function () {
        var _this = this;
        this.fileInput = angular.element('#input')[0];
        this.productsService.isExistProducts(this.enumService.PhysicalProductState.Archived)
            .then(function (response) { return _this.hasArchivedProducts = response; });
    };
    ImportTabComponent.prototype.$onDestroy = function () {
        this.uploadDefer.reject();
        if (this.inputDefer) {
            this.inputDefer.reject();
        }
    };
    ImportTabComponent.prototype.goToHelp = function () {
        this.$state.go('app.help.manual');
    };
    ImportTabComponent.prototype.goToProducts = function (state) {
        this.$state.go('app.products', { state: state });
    };
    ImportTabComponent.prototype.selectFile = function (replaceExisting) {
        var _this = this;
        if (this.inputDefer) {
            this.inputDefer.reject();
        }
        this.inputDefer = this.inputToDefer(this.fileInput);
        this.inputDefer.promise
            .then(function (file) {
            return _this.uploadFile(file, replaceExisting);
        })
            .then(function () {
            return _this.fileInput.value = '';
        })["catch"](angular.noop);
        this.fileInput.click();
    };
    ImportTabComponent.prototype.uploadFile = function (file, replaceExisting) {
        var _this = this;
        this.notificationService.clearAll();
        this.tooltipMessage = this.$translate.instant('uploading_file_tooltip', { fileName: file.name });
        this.tooltipState = tooltip_state_1.TooltipState.Loading;
        this.waiting = true;
        this.errors = null;
        this.operationService.importFile(file, replaceExisting)
            .then(function (response) {
            _this.errors = response;
            if (response.Success) {
                _this.tooltipState = tooltip_state_1.TooltipState.Done;
                _this.tooltipMessage = _this.$translate.instant('file_uploaded_tooltip', { fileName: file.name });
                _this.uploadDefer.notify(response.OperationModel);
                return response;
            }
            _this.tooltipState = tooltip_state_1.TooltipState.None;
            _this.notificationService.showErrorMessage('Errors occurred during importing');
            return response;
        })["finally"](function () { return _this.waiting = false; })["catch"](function (e) {
            _this.notificationService.showErrorMessage(e);
            _this.errors = null;
            _this.tooltipState = tooltip_state_1.TooltipState.None;
        });
    };
    ImportTabComponent.prototype.inputToDefer = function (input) {
        var deferred = this.$q.defer();
        input.addEventListener('change', onInputChanged);
        deferred.promise["catch"](angular.noop)["finally"](function () { return input.removeEventListener('change', onInputChanged); });
        return deferred;
        function onInputChanged() {
            deferred.resolve(input.files[0]);
        }
    };
    ImportTabComponent.$inject = ['productsService', 'enumService', 'operationService', 'notificationService', '$q', '$translate', '$state'];
    return ImportTabComponent;
}());
angular
    .module('naut')
    .component('importTab', {
    controller: ImportTabComponent,
    template: __webpack_require__(767)
});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var TooltipComponent = /** @class */ (function () {
    function TooltipComponent() {
    }
    return TooltipComponent;
}());
angular
    .module('naut')
    .component('tooltip', {
    controller: TooltipComponent,
    bindings: {
        'state': '<',
        'message': '<'
    },
    template: __webpack_require__(768)
});


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var InventoryController = /** @class */ (function () {
    function InventoryController($rootScope, $stateParams, $q, $timeout, inventoryService, classificationCategoriesService, shopService, notificationService, enumService, $translate, accountService) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.$timeout = $timeout;
        this.inventoryService = inventoryService;
        this.classificationCategoriesService = classificationCategoriesService;
        this.shopService = shopService;
        this.notificationService = notificationService;
        this.enumService = enumService;
        this.$translate = $translate;
        this.accountService = accountService;
        this.model = null;
        this.waiting = true;
        this.contentLoaded = false;
        this.data = {
            shopID: parseInt(this.$stateParams.shopId, 10),
            shop: this.$stateParams.shop,
            inventory: null,
            inventoryTemp: null,
            classificationCategoriesErrors: null,
            isShopping: false,
            init: function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var i, response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = this.data;
                            if (isNaN(i.shopID)) {
                                this.notificationService.showErrorMessage();
                                this.waiting = false;
                                return [2 /*return*/];
                            }
                            this.notificationService.showWaitingMessage();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.$q.all([this.inventoryService.get(i.shopID), this.shopService.getStore(i.shopID)])];
                        case 2:
                            response = _a.sent();
                            i.inventory = response[0];
                            i.shop = response[1];
                            i.inventoryTemp = angular.copy(i.inventory);
                            i.adaptData();
                            this.$timeout(function () {
                                _this.notificationService.clearAll();
                                _this.contentLoaded = true;
                            }, 1800);
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            this.notificationService.showErrorMessage();
                            return [3 /*break*/, 4];
                        case 4:
                            this.waiting = false;
                            return [2 /*return*/];
                    }
                });
            }); },
            adaptData: function () {
                var i = _this.data;
                i.isShopping = i.inventoryTemp.BusinessType === _this.enumService.BusinessType.Shop;
            },
            changeClassificationCategory: function () {
                return;
            },
            isValidInventory: function () {
                var i = _this.data;
                if (_this.data.classificationCategoriesErrors && !_.isEmpty(_this.data.classificationCategoriesErrors.selectedNoLiveCategories)) {
                    var invalidnames = _this.data.classificationCategoriesErrors.selectedNoLiveCategories;
                    var size = _.size(invalidnames);
                    var strName = (size === 1) ? _.first(invalidnames) : _.first(invalidnames, size - 1).join(', ') + _this.$translate.instant('and') + _.last(invalidnames);
                    var errorMassage = _this.$translate.instant('please_select_at_least_one_category_for') + strName;
                    _this.notificationService.showErrorMessage({ body: errorMassage });
                    return false;
                }
                return true;
            }
        };
        this.saveInventory = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.data.isValidInventory()) return [3 /*break*/, 4];
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.inventoryService.save(this.data.shopID, this.data.inventoryTemp)];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.$timeout(function () {
                            _this.$rootScope.$state.go('app.shop', { id: _this.data.shopID });
                        }, 1000);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.data.init()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.languageId = accountService.userData.languageID;
    }
    InventoryController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.init();
                return [2 /*return*/];
            });
        });
    };
    InventoryController.$inject = ['$rootScope', '$stateParams', '$q', '$timeout',
        'inventoryService', 'classificationCategoriesService', 'shopService',
        'notificationService', 'enumService', '$translate', 'accountService'];
    return InventoryController;
}());
angular.module('naut').component('inventory', {
    template: __webpack_require__(769),
    controller: InventoryController,
    controllerAs: 'vm'
});


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var models_1 = __webpack_require__(75);
var _ = __webpack_require__(1);
var itemsLimit = 50;
var OperationListComponent = /** @class */ (function () {
    function OperationListComponent(operationService, notificationService, $state, $translate) {
        this.operationService = operationService;
        this.notificationService = notificationService;
        this.$state = $state;
        this.$translate = $translate;
        this.filterOptions = [
            { name: this.$translate.instant('all_statuses'), value: null },
            { name: this.$translate.instant('enqueued'), value: 'enqueued' },
            { name: this.$translate.instant('processing'), value: 'processing' },
            { name: this.$translate.instant('processed'), value: 'processed' }
        ];
        this.items = [];
        this.filterMap = (_a = {},
            _a['enqueued'] = models_1.OperationMessageStatus.Enqueued,
            _a['processing'] = models_1.OperationMessageStatus.Processing,
            _a['processed'] = models_1.OperationMessageStatus.Processed,
            _a);
        this.canLoadMore = true;
        this.page = 1;
        this.from = moment().add(-7, 'days').startOf('day').toDate();
        this.to = moment().endOf('day').toDate();
        this.filter = this.filterOptions[0];
        var _a;
    }
    OperationListComponent.prototype.$onInit = function () {
        var _this = this;
        this.loadData();
        if (this.onFileUploadPromise) {
            this.onFileUploadPromise.then(angular.noop, angular.noop, function (operation) { return _this.items.unshift(operation); });
        }
    };
    OperationListComponent.prototype.openOperation = function (id) {
        this.$state.go('app.operation', { id: id });
    };
    OperationListComponent.prototype.goToHelp = function () {
        this.$state.go('app.help.manual');
    };
    OperationListComponent.prototype.refresh = function () {
        this.items = [];
        this.canLoadMore = true;
        this.loadData();
    };
    OperationListComponent.prototype.loadData = function () {
        var _this = this;
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;
        var status = this.filter ? this.filter.value : undefined;
        var pageParams = this.getPageParams();
        var lastItem = _.last(this.items);
        var lastItemId = lastItem ? lastItem.RequestTimeStamp : undefined;
        var filter = {
            from: pageParams.from,
            to: pageParams.to,
            searchAfter: moment(lastItemId).toISOString(),
            limit: itemsLimit,
            status: this.filterMap[status]
        };
        this.notificationService.showWaitingMessage();
        return this.operationService.getOperationList(filter)
            .then(function (response) {
            _this.total = response.Total;
            Array.prototype.push.apply(_this.items, response.Items);
            _this.canLoadMore = response.Items.length === itemsLimit;
        })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
            _this.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    OperationListComponent.prototype.getPageParams = function () {
        var filter = this.filter ? this.filter.value : undefined;
        return {
            page: this.page,
            filter: filter,
            from: moment(this.from).startOf('day').toISOString(),
            to: moment(this.to).endOf('day').toISOString()
        };
    };
    OperationListComponent.$inject = ['operationService', 'notificationService', '$state', '$translate'];
    return OperationListComponent;
}());
exports.OperationListComponent = OperationListComponent;
angular
    .module('naut')
    .component('operationList', {
    template: __webpack_require__(770),
    controller: OperationListComponent,
    bindings: {
        'onFileUploadPromise': '<'
    }
});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var models_1 = __webpack_require__(75);
var OperationStatusComponent = /** @class */ (function () {
    function OperationStatusComponent() {
    }
    OperationStatusComponent.prototype.$onInit = function () {
        switch (this.operation.Status) {
            case models_1.OperationMessageStatus.Enqueued:
                this.cssClass = 'icon-time opacity54';
                this.hint = 'Pending';
                return;
            case models_1.OperationMessageStatus.Processing:
                this.cssClass = 'icon-processing opacity54';
                this.hint = 'Processing';
                return;
        }
        switch (this.operation.Result) {
            case models_1.OperationMessageResult.Error:
                this.cssClass = 'icon-error-rounded--red';
                this.hint = 'Error';
                return;
            case models_1.OperationMessageResult.Warning:
                this.cssClass = 'icon-warning-rounded--red';
                this.hint = 'Warning';
                return;
            case models_1.OperationMessageResult.Success:
                this.cssClass = 'icon-check-rounded--green';
                this.hint = 'Success';
                return;
        }
    };
    return OperationStatusComponent;
}());
angular
    .module('naut')
    .component('operationStatus', {
    controller: OperationStatusComponent,
    bindings: {
        operation: '<',
        showHint: '<'
    },
    template: '<i class="icon24 inline-block {{::$ctrl.cssClass}}" title="{{$ctrl.hint}}"></i>&nbsp;<span ng-show="$ctrl.showHint">{{::$ctrl.hint}}</span>'
});


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var OperationComponent = /** @class */ (function () {
    function OperationComponent(operationService, notificationService, $stateParams, $state) {
        this.operationService = operationService;
        this.notificationService = notificationService;
        this.$state = $state;
        this.opeartionId = $stateParams.id;
    }
    OperationComponent.prototype.$onInit = function () {
        this.loadOperation();
    };
    OperationComponent.prototype.goToProductImport = function () {
        this.$state.go('app.operations');
    };
    OperationComponent.prototype.loadOperation = function () {
        var _this = this;
        this.notificationService.showWaitingMessage();
        this.error = undefined;
        this.operationService.getOperation(this.opeartionId)
            .then(function (response) { return _this.operation = response; })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
            _this.error = error;
        })["finally"](function () { return _this.notificationService.clearAll(); });
    };
    OperationComponent.$inject = ['operationService', 'notificationService', '$stateParams', '$state'];
    return OperationComponent;
}());
angular
    .module('naut')
    .component('operationComponent', {
    controller: OperationComponent,
    template: __webpack_require__(771)
});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var InventoryService = /** @class */ (function () {
    function InventoryService(http, $uibModal, retailerService) {
        var _this = this;
        this.http = http;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.get = function (shopID) {
            return _this.http.get(_this.retailerService.inventory(shopID));
        };
        this.save = function (shopID, model) {
            return _this.http.post(_this.retailerService.inventory(shopID), _this.toServerModel(model));
        };
        this.chooseCategory = function (categories) {
            return _this.$uibModal.open({
                component: 'chooseCategory',
                resolve: {
                    categories: function () { return categories; }
                },
                size: 'lg'
            }).result;
        };
        this.toServerModel = function (model) {
            return {
                ClassificationCategories: _.map(model.ClassificationCategories, _this.toItemModel)
            };
        };
        this.toItemModel = function (inventory) {
            return {
                CategoryID: inventory.CategoryID
            };
        };
    }
    InventoryService.prototype.getClassificationDictionary = function () {
        return this.http.get(this.retailerService.getClassificationDictionary());
    };
    InventoryService.prototype.newBrand = function (brand) {
        return !_.isNumber(brand.ID);
    };
    InventoryService.prototype.existingBrand = function (brand) {
        return _.isNumber(brand.ID);
    };
    InventoryService.$inject = ['http', '$uibModal', 'retailerService'];
    return InventoryService;
}());
exports.InventoryService = InventoryService;
angular
    .module('naut')
    .service('inventoryService', InventoryService);


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var models_1 = __webpack_require__(75);
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var _ = __webpack_require__(1);
var OperationService = /** @class */ (function () {
    function OperationService(http, retailerService, $translate) {
        this.http = http;
        this.retailerService = retailerService;
        this.$translate = $translate;
        this.sourceNames = (_a = {},
            _a[models_1.OperationMessageSource.API] = 'API',
            _a[models_1.OperationMessageSource.CSV] = 'CSV',
            _a);
        this.operationKindNames = (_b = {},
            _b[models_1.OperationMessageKind.FullUpdate] = this.$translate.instant('full_update'),
            _b[models_1.OperationMessageKind.PriceUpdate] = this.$translate.instant('price_update'),
            _b[models_1.OperationMessageKind.VariationArchive] = this.$translate.instant('archive_variants'),
            _b[models_1.OperationMessageKind.FullUpdateReplace] = this.$translate.instant('update_and_replace'),
            _b[models_1.OperationMessageKind.StockQuantityUpdate] = this.$translate.instant('stock_quantity_update'),
            _b[models_1.OperationMessageKind.ProductsImportBySku] = this.$translate.instant('import_by_sku'),
            _b);
        var _a, _b;
    }
    OperationService.prototype.getOperation = function (id) {
        var _this = this;
        return this.http
            .get(this.retailerService.getOperationUrl(id))
            .then(function (response) {
            var result = _this.mapOperationStatistics(response);
            result.Errors = response.Errors;
            return result;
        });
    };
    OperationService.prototype.getOperationList = function (filter) {
        var _this = this;
        return this.http
            .get(this.retailerService.getOperationListUrl(), { params: filter })
            .then(function (response) { return _this.mapOperationStatisticsPagingResult(response); });
    };
    OperationService.prototype.importFile = function (file, replace) {
        var _this = this;
        var form = new FormData();
        form.append('file', file, file.name);
        return this.http.post(this.retailerService.getImportFileUrl(replace), form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        })
            .then(function (response) {
            if (response.Success && response.Operation) {
                response.OperationModel = _this.mapOperationStatistics(response.Operation);
            }
            return response;
        });
    };
    OperationService.prototype.mapOperationStatisticsPagingResult = function (source) {
        var _this = this;
        return {
            Total: source.Total,
            Items: _.map(source.Items, function (value) { return _this.mapOperationStatistics(value); })
        };
    };
    OperationService.prototype.mapOperationStatistics = function (source) {
        var start = moment(source.RequestTimeStamp);
        var duration = moment.duration(source.Duration).asMilliseconds();
        var end = duration ? moment(start).add(duration, 'ms').toDate() : null;
        return {
            ID: source.ID,
            RetailerID: source.RetailerID,
            ClientID: source.ClientID,
            RequestTimeStamp: start.toDate(),
            FinishedAt: end,
            Source: this.sourceNames[source.Source],
            Kind: this.operationKindNames[source.Kind],
            Status: source.Status,
            Result: source.Result,
            ItemsCount: source.ItemsCount,
            ItemsUpdatedCount: source.ItemsUpdatedCount,
            ItemsAddedCount: source.ItemsAddedCount,
            ErrorsCount: source.ErrorsCount,
            ConflictsCount: source.ConflictsCount
        };
    };
    OperationService.$inject = ['http', 'retailerService', '$translate'];
    return OperationService;
}());
exports.OperationService = OperationService;
angular
    .module('naut')
    .service('operationService', OperationService);


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var business_union_type_enum_1 = __webpack_require__(64);
var JispPayAccountComponent = /** @class */ (function () {
    function JispPayAccountComponent($timeout, jispPayService, notificationService, $translate, $q, $modal, $localStorage) {
        this.$timeout = $timeout;
        this.jispPayService = jispPayService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.$q = $q;
        this.$modal = $modal;
        this.$localStorage = $localStorage;
        this.modalInstance = this;
        this.data = {
            title: this.$translate.instant('staff_account'),
            textBtn: '',
            avatarUrl: '',
            showPassword: false,
            isPasswordExist: false,
            isEditStaff: false,
            password: 'Password',
            places: [],
            staffLogin: '',
            model: null,
            staffID: null
        };
        this.businessUnionTypeEnum = business_union_type_enum_1.BusinessUnionTypeEnum;
    }
    JispPayAccountComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    JispPayAccountComponent.prototype.changePlaces = function () {
        this.data.model.PlacesID = _.pluck(_.where(this.data.places, { selected: true }), 'ID');
        this.form.$setDirty();
    };
    JispPayAccountComponent.prototype.imageClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var avatarID, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.$modal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    title: function () { return _this.$translate.instant('staff_photo_title'); },
                                    getUrl: function () { return _this.jispPayService.getAvatarUrl(_this.data.model.AvatarID, null, null); },
                                    avatarId: function () { return _this.data.model.AvatarID; },
                                    saveUrl: function () { return _this.jispPayService.getAvatarUploadUrl(); }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        avatarID = _b.sent();
                        if (!avatarID) return [3 /*break*/, 3];
                        this.form.$setDirty();
                        this.data.model.AvatarID = avatarID;
                        _a = this.data;
                        return [4 /*yield*/, this.jispPayService.getAvatarUrl(avatarID, 124, 124)];
                    case 2:
                        _a.avatarUrl = _b.sent();
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    JispPayAccountComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.form.$invalid) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (this.data.isEditStaff ? this.jispPayService.updateStaff(this.data.staffID, this.data.model) :
                                this.jispPayService.createStaff(this.data.model))];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close({ $value: true });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    JispPayAccountComponent.prototype.close = function () {
        this.modalInstance.close({ $value: false });
    };
    JispPayAccountComponent.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var txtSave, txtCreate, i, loginModel, passwordModel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        txtSave = this.$translate.instant('button_save_staff_member');
                        txtCreate = this.$translate.instant('button_create_staff_member');
                        i = this.data;
                        i.textBtn = this.resolve.staff ? txtSave : txtCreate;
                        i.isPasswordExist = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
                        i.isEditStaff = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
                        i.places = this.resolve.places ? _.filter(_.map(this.resolve.places, function (place) {
                            place.selected = _this.resolve.staff ? _.contains(_this.resolve.staff.PlacesID, place.ID) : false;
                            return place;
                        }), function (place) {
                            return place.selected || (place.IsActive && !place.IsBanned);
                        }) : [];
                        i.avatarUrl = (this.resolve.staff && this.resolve.staff.AvatarID)
                            ? this.jispPayService.getAvatarUrl(this.resolve.staff.AvatarID, 124, 124)
                            : '';
                        i.staffLogin = this.resolve.staff ? this.resolve.staff.Login : '';
                        i.model = {
                            FirstName: this.resolve.staff ? this.resolve.staff.FirstName : '',
                            LastName: this.resolve.staff ? this.resolve.staff.LastName : '',
                            Login: this.resolve.staff ? this.resolve.staff.Login : '',
                            Password: '',
                            Interests: this.resolve.staff ? this.resolve.staff.Interests : '',
                            LovedProducts: this.resolve.staff ? this.resolve.staff.LovedProducts : '',
                            WorkingInfo: this.resolve.staff ? this.resolve.staff.WorkingInfo : '',
                            PlacesID: this.resolve.staff ? this.resolve.staff.PlacesID : [],
                            AvatarID: (this.resolve.staff && this.resolve.staff.AvatarID)
                                ? this.resolve.staff.AvatarID
                                : null,
                            WholesaleDeliveryDriver: this.resolve.staff ? this.resolve.staff.WholesaleDeliveryDriver : false
                        };
                        i.staffID = this.resolve.staff ? this.resolve.staff.ID : null;
                        loginModel = this.form.login;
                        loginModel.$asyncValidators.isInUse = this.validateLogin.bind(this);
                        passwordModel = this.form.password;
                        passwordModel.$validators.password = this.validatePassword.bind(this);
                        this.businessUnionType = this.$localStorage.BusinessUnionType;
                        return [2 /*return*/];
                }
            });
        });
    };
    JispPayAccountComponent.prototype.validatePassword = function (modelValue) {
        var password = this.jispPayService.trim(modelValue);
        var isEmpty = _.size(password) < 1;
        if (this.data.isEditStaff && isEmpty) {
            return true;
        }
        return !isEmpty;
    };
    JispPayAccountComponent.prototype.validateLogin = function (modelValue, viewValue) {
        var _this = this;
        if (_.isEmpty(modelValue)) {
            return this.$q.resolve();
        }
        // do not validate login if user edits member
        if (this.data.isEditStaff && viewValue === this.data.staffLogin) {
            return this.$q.resolve();
        }
        var result = this.$q.defer();
        this.jispPayService.jisppayStaffLoginExist(viewValue)
            .then(function (response) { return response ? result.reject() : result.resolve(); })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
            result.resolve();
        });
        return result.promise;
    };
    JispPayAccountComponent.$inject = [
        '$timeout',
        'jispPayService',
        'notificationService',
        '$translate',
        '$q',
        '$uibModal',
        '$localStorage'
    ];
    return JispPayAccountComponent;
}());
angular.module('naut').component('jispPayAccount', {
    template: __webpack_require__(772),
    controller: JispPayAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ArchiveConfirmationDialog = /** @class */ (function () {
    function ArchiveConfirmationDialog() {
        this.modalInstance = this;
    }
    ArchiveConfirmationDialog.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.title = this.resolve.title;
                this.message = this.resolve.message;
                this.accounts = this.resolve.accounts;
                return [2 /*return*/];
            });
        });
    };
    ArchiveConfirmationDialog.prototype.closeDialog = function () {
        this.modalInstance.close({ $value: false });
    };
    ArchiveConfirmationDialog.prototype.confirm = function () {
        this.modalInstance.close({ $value: true });
    };
    return ArchiveConfirmationDialog;
}());
angular.module('naut').component('archiveConfirmationDialog', {
    template: __webpack_require__(773),
    controller: ArchiveConfirmationDialog,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var popupServiceCancel_1 = __webpack_require__(5);
var models_1 = __webpack_require__(243);
var IJispPayAccount_1 = __webpack_require__(242);
var JispPayStaffController = /** @class */ (function () {
    function JispPayStaffController($rootScope, $scope, $q, jispPayService, shopService, popupService, notificationService, $translate, vendorsService, $uibModal) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$q = $q;
        this.jispPayService = jispPayService;
        this.shopService = shopService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.vendorsService = vendorsService;
        this.$uibModal = $uibModal;
        this.waiting = false;
        this.staff = null;
        this.accountTypes = models_1.AccountTypeEnum;
        this.defaultAccountType = { name: 'Vendor', type: IJispPayAccount_1.IJispPayAccountTypeEnum.Vendor };
        this.settings = {
            pageSize: 10,
            page: 1,
            places: [],
            accountTypes: [{ name: 'Vendor', type: IJispPayAccount_1.IJispPayAccountTypeEnum.Vendor }, { name: 'Staff', type: IJispPayAccount_1.IJispPayAccountTypeEnum.Staff }],
            isStaffAny: {
                active: null,
                archived: false
            },
            isAllAccountsSelected: false,
            filter: {
                account: this.defaultAccountType,
                place: null,
                keyword: null,
                isActive: true
            },
            isVendorTypeTable: false,
            sort: this.jispPayService.getColumnSort(),
            getStaffFilter: function () {
                var i = _this.settings;
                var placeID = i.filter.place ? i.filter.place.ID : '';
                var keyword = i.filter.keyword ? i.filter.keyword.trim() : '';
                return {
                    limit: i.pageSize,
                    offset: (i.page - 1) * i.pageSize,
                    sortColumn: i.sort.column,
                    sortOrder: i.sort.order,
                    placeID: placeID,
                    keyword: keyword,
                    isActive: i.filter.isActive
                };
            },
            getVendorFilter: function () {
                return {
                    searchTerm: _this.settings.filter.keyword,
                    limit: 20,
                    archived: !_this.settings.filter.isActive
                };
            },
            setPlaces: function (places) {
                var i = _this.settings;
                i.places = places.length !== 0 ? angular.copy(places) : [];
                i.places.unshift({
                    ID: null,
                    Name: _this.$translate.instant('all_locations')
                });
            },
            setTableData: function () {
                _this.tableData = _this.staff.Items;
                _this.tableTotal = _this.staff.Total;
                // this.tableData = this.settings.isVendorTypeTable ?
                //     this.vendors.Items as IVendorTableItem[] :
                //     this.staff.Items as ISalesAssistantListItem[];
                // this.tableTotal = this.settings.isVendorTypeTable ?
                //     this.vendors.Total :
                //     this.staff.Total;
            },
            setCheckboxes: function () {
                var i = _this.settings;
                if (_this.tableData) {
                    var currentAccounts = _this.getCurrentTableData();
                    currentAccounts.forEach(function (account) { return account.selected = i.isAllAccountsSelected; });
                }
            },
            setTableType: function () {
                _this.settings.isVendorTypeTable = _this.settings.filter.account.type === _this.defaultAccountType.type;
            },
            changeSelected: function () {
                var currentAccounts = _this.getCurrentTableData();
                _this.settings.isAllAccountsSelected = currentAccounts.every(function (account) { return account.selected; });
            },
            isAccountSelected: function () {
                if (_this.tableData) {
                    var currentAccounts = _this.getCurrentTableData();
                    return currentAccounts.some(function (account) { return account.selected; });
                }
                return false;
            },
            showPanel: function () {
                var i = _this.settings;
                return (i.filter.isActive && i.isStaffAny.active) || (!i.filter.isActive && i.isStaffAny.archived);
            },
            isPlacesAny: function () {
                return _this.placesModel.active && _this.placesModel.active.length !== 0;
            }
        };
        this.placesModel = {
            all: [],
            banned: [],
            active: [],
            archived: [],
            set: function (places) {
                var i = _this.placesModel;
                i.all = places;
                i.all.forEach(function (place) { return place.info = place.Name + ', ' + place.Town + ', ' + place.Address; });
                i.active = places.filter(function (place) {
                    if (place.IsActive && !place.IsBanned) {
                        return true;
                    }
                });
                i.archived = places.filter(function (place) { return !place.IsActive; });
                i.banned = places.filter(function (place) { return place.IsBanned; });
            }
        };
        this.archiveAccount = function (staff) { return __awaiter(_this, void 0, void 0, function () {
            var selectedStaff, size, message, title, li, ul, ids, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedStaff = [];
                        if (staff) {
                            selectedStaff = [staff];
                        }
                        else {
                            selectedStaff = _.where(this.staff.Items, { selected: true });
                        }
                        size = _.size(selectedStaff);
                        if (size === 0) {
                            return [2 /*return*/];
                        }
                        message = size > 1
                            ? "<p>" + this.$translate.instant('archive_selected_accounts_confirm') + "</p>"
                            : "<p>" + this.$translate.instant('archive_a_selected_account_confirm') + "</p>";
                        title = size > 1
                            ? this.$translate.instant('archive_selected_accounts')
                            : this.$translate.instant('archive_a_selected_account');
                        li = '';
                        _.forEach(selectedStaff, function (staff) {
                            li += "<li>" + staff.FirstName + " " + staff.LastName + " </li>";
                        });
                        ul = "<ul>" + li + "</ul>";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: title,
                                content: message + ul,
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                cancelClass: 'btn-success',
                                invertAction: true
                            })];
                    case 2:
                        _a.sent();
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        ids = _.pluck(selectedStaff, 'ID');
                        return [4 /*yield*/, this.jispPayService.archiveStaff(ids)];
                    case 3:
                        _a.sent();
                        this.getStaff();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // public archiveAccount = async (account: ISalesAssistantListItem | IVendorTableItem) => {
        //     let selectedAccounts = [];
        //     const currentAccounts: Array<ISalesAssistantListItem | IVendorTableItem> = this.getCurrentTableData();
        //     if (account) {
        //         selectedAccounts = [account];
        //     } else {
        //         selectedAccounts = currentAccounts.filter((accountItem) => accountItem.selected);
        //     }
        //     const size = selectedAccounts.length;
        //     if (size === 0) {
        //         return;
        //     }
        //     const ids = selectedAccounts.map((accountItem) => accountItem.ID);
        //     const message = size > 1 ? 'archive_selected_accounts_confirm' : 'archive_a_selected_account_confirm';
        //     let titleText;
        //     if (size > 1) {
        //         titleText = this.settings.isVendorTypeTable ? 'archive_vendors_title' : 'archive_selected_accounts';
        //     } else {
        //         titleText = this.settings.isVendorTypeTable ? 'archive_vendor_title' : 'archive_a_selected_account';
        //     }
        //     try {
        //         const isArchiveApproved = await this.$uibModal.open({
        //             component: 'archiveConfirmationDialog',
        //             resolve: {
        //                 title: () => titleText,
        //                 message: () => message,
        //                 accounts: () =>  selectedAccounts.map((accountItem) => `${accountItem.FirstName} ${accountItem.LastName}`)
        //             },
        //             size: 'md',
        //             windowClass: 'archiveDialog',
        //             backdrop: 'static'
        //         }).result;
        //         if (isArchiveApproved) {
        //             this.waiting = true;
        //             // const currentArchiveMethod = this.settings.isVendorTypeTable ? null : await this.jispPayService.archiveStaff(ids);
        //             await this.jispPayService.archiveStaff(ids);
        //             this.notificationService.showWaitingMessage();
        //             this.getStaff();
        //         }
        //     } catch (error) {
        //         if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
        //             this.notificationService.showErrorMessage(error);
        //         }
        //     }
        // }
        this.restoreAccount = function (account) { return __awaiter(_this, void 0, void 0, function () {
            var selectedAccounts, currentAccounts, ids, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedAccounts = [];
                        currentAccounts = this.getCurrentTableData();
                        if (account) {
                            selectedAccounts = [account];
                        }
                        else {
                            selectedAccounts = currentAccounts.filter(function (accountItem) { return accountItem.selected; });
                        }
                        ids = selectedAccounts.map(function (accountItem) { return accountItem.ID; });
                        if (ids.length === 0) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jispPayService.restoreStaff(ids)];
                    case 2:
                        _a.sent();
                        // const currentRestoreMethod = this.settings.isVendorTypeTable ? null : await this.jispPayService.restoreStaff(ids);
                        this.settings.filter.isActive = true;
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.setAccount = function (type, account) { return __awaiter(_this, void 0, void 0, function () {
            var currentEditMethod, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.jispPayService.openAccountManager(account, this.placesModel.all)];
                    case 1:
                        currentEditMethod = _a.sent();
                        // const currentEditMethod = type === this.accountTypes.vendor ?
                        //     await this.jispPayService.openVendorEditor(this.placesModel.all, account as IVendorTableItem) :
                        //     await this.jispPayService.openAccountManager(account as ISalesAssistantListItem, this.placesModel.all);
                        if (currentEditMethod) {
                            this.getStaff();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_3)) {
                            this.notificationService.showErrorMessage(error_3);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getStaff = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([this.jispPayService.getStaff(this.settings.getStaffFilter()),
                                this.jispPayService.isStaffAny(true),
                                this.jispPayService.isStaffAny(false),
                            ])];
                    case 2:
                        response = _a.sent();
                        this.staff = response[0];
                        this.settings.isStaffAny.active = response[1];
                        this.settings.isStaffAny.archived = response[2];
                        // this.vendors = response[3];
                        // this.vendors = {
                        //     Items: this.data as IVendorTableItem[],
                        //     Total: this.data.length
                        // };
                        this.staff.Items.forEach(function (account) {
                            account.avatarUrl = _this.getAvatarUrl(account.AvatarID);
                            account.places = [];
                            account.isContainsBanned = false;
                            _this.setAccountPlaces(account);
                        });
                        this.settings.setTableData();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var places, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.shopService.getStoresForJispPay()];
                    case 2:
                        places = _a.sent();
                        this.placesModel.set(places);
                        this.getStaff();
                        this.settings.setPlaces(this.placesModel.active);
                        this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.keyword',
                            'vm.settings.filter.place', 'vm.settings.page', 'vm.settings.filter.isActive'], function (n, o) {
                            _this.settings.isAllAccountsSelected = false;
                            _this.settings.setCheckboxes();
                            if (n && n !== o) {
                                _this.getStaff();
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.init();
    }
    JispPayStaffController.prototype.getAvatarUrl = function (id) {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 48, 48)
            : '';
    };
    JispPayStaffController.prototype.getCurrentEditedType = function () {
        return this.accountTypes.staff;
        // this.settings.isVendorTypeTable ? this.accountTypes.vendor : this.accountTypes.staff;
    };
    JispPayStaffController.prototype.setAccountPlaces = function (account) {
        var _this = this;
        account.PlacesID.forEach(function (placeId) {
            var place = _this.placesModel.all.find(function (placeItem) { return placeItem.ID === placeId; });
            if (place) {
                account.places.push({
                    id: place.ID,
                    info: place.info,
                    isActive: place.IsActive,
                    isBanned: place.IsBanned
                });
                account.isContainsBanned = place.IsBanned ? place.IsBanned : account.isContainsBanned;
            }
        });
    };
    JispPayStaffController.prototype.getCurrentTableData = function () {
        return this.staff.Items;
        // this.settings.isVendorTypeTable =
        // this.vendors.Items as IVendorTableItem[] :
        // this.staff.Items as ISalesAssistantListItem[];
    };
    JispPayStaffController.$inject = ['$rootScope', '$scope', '$q', 'jispPayService', 'shopService', 'popupService', 'notificationService', '$translate', 'vendorsMockService', '$uibModal'];
    return JispPayStaffController;
}());
angular.module('naut').component('jispPayStaff', {
    template: __webpack_require__(774),
    controller: JispPayStaffController,
    controllerAs: 'vm'
});


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var popupServiceCancel_1 = __webpack_require__(5);
var jispPayPlacesBase_controller_1 = __webpack_require__(18);
var JispPayPlacesController = /** @class */ (function (_super) {
    __extends(JispPayPlacesController, _super);
    function JispPayPlacesController(notificationService, $rootScope, jispPayService, $scope, $translate, $uibModal) {
        var _this = _super.call(this, $translate) || this;
        _this.notificationService = notificationService;
        _this.$rootScope = $rootScope;
        _this.jispPayService = jispPayService;
        _this.$scope = $scope;
        _this.$translate = $translate;
        _this.$uibModal = $uibModal;
        _this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
        _this.placeEnabled = function (place) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!place.IsRefundPasswordExist) return [3 /*break*/, 5];
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jispPayService.setJispPayEnable({
                                Enable: place.Enabled,
                                StoreID: place.ID
                            })];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.edit.isOpenEdit = false;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.placeEdit(place, true);
                        _a.label = 6;
                    case 6:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.save = function (place) { return __awaiter(_this, void 0, void 0, function () {
            var password, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isValidEditModel(place)) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        password = this.edit.model.RefundPassword;
                        _a = this.edit.model;
                        return [4 /*yield*/, this.jispPayService.passwordConfirmation(place.ID)];
                    case 2:
                        _a.VerificationPassword = _b.sent();
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        this.edit.model.RefundPassword = password;
                        return [4 /*yield*/, this.jispPayService.setPlace(place.ID, this.edit.model)];
                    case 3:
                        _b.sent();
                        this.updateAfterSave(place);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _b.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.openSetInfoDialog = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'paymentSettingsPopUp',
                            resolve: {
                                currentCompanyInfo: function () { return angular.copy(_this.model); }
                            },
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult === 'ok') {
                            this.getCompanyInfo();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.jispPayService.getJispPayMerchants()];
                    case 2:
                        _a.jispPayMerchants = _b.sent();
                        this.getPlaces();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getPlaces = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var pagingResult, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jispPayService.getPlaces()];
                    case 2:
                        pagingResult = _a.sent();
                        this.places = pagingResult.Items;
                        this.isPlacesAny = pagingResult.Total > 0;
                        _.forEach(this.places, function (place) {
                            var merchant = _.find(_this.jispPayMerchants, function (singleMerchant) {
                                return singleMerchant.ID === place.JispPayMerchantID;
                            });
                            place.merchantID = merchant ? merchant.MerchantID : '';
                        });
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.edit.isOpenEdit = false;
                        return [2 /*return*/];
                }
            });
        }); };
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            $scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            $scope.$apply();
        });
        _this.init();
        return _this;
    }
    JispPayPlacesController.prototype.$onInit = function () {
        this.getCompanyInfo();
    };
    JispPayPlacesController.prototype.getCompanyInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.jispPayService.getCompanyInfo()];
                    case 2:
                        _a.model = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_5 = _b.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 5];
                    case 4:
                        this.notificationService.clearAll();
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    JispPayPlacesController.prototype.updateAfterSave = function (place) {
        this.edit.model.VerificationPassword = null;
        place.merchantID = this.edit.model.selectedMerchant ? this.edit.model.selectedMerchant.MerchantID : null;
        place.JispPayMerchantID = this.edit.model.selectedMerchant ? this.edit.model.selectedMerchant.ID : null;
        place.refundPassword = this.edit.model.RefundPassword;
        this.edit.isOpenEdit = false;
        place.isOpenEdit = false;
    };
    JispPayPlacesController.$inject = [
        'notificationService',
        '$rootScope',
        'jispPayService',
        '$scope',
        '$translate',
        '$uibModal'
    ];
    return JispPayPlacesController;
}(jispPayPlacesBase_controller_1.JispPayPlacesBase));
angular.module('naut').component('jispPayPlaces', {
    template: __webpack_require__(775),
    controller: JispPayPlacesController,
    controllerAs: 'vm'
});


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var PaymentSettingsPopUp = /** @class */ (function () {
    function PaymentSettingsPopUp(definitionsService, notificationService, $rootScope, jispPayService, $translate) {
        this.definitionsService = definitionsService;
        this.notificationService = notificationService;
        this.$rootScope = $rootScope;
        this.jispPayService = jispPayService;
        this.$translate = $translate;
        this.modalInstance = this;
        this.pattern = this.definitionsService.regexNumbersAndLetters;
    }
    PaymentSettingsPopUp.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.resolve.currentCompanyInfo) {
                    this.model = this.resolve.currentCompanyInfo;
                }
                return [2 /*return*/];
            });
        });
    };
    PaymentSettingsPopUp.prototype.close = function () {
        this.modalInstance.close();
    };
    PaymentSettingsPopUp.prototype.saveForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sortNumberError = false;
                        this.bankAccountError = false;
                        if (!!this.isFormInvalid()) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.jispPayService.putCompanyInfo(this.model)];
                    case 2:
                        _a.sent();
                        this.modalInstance.close({ $value: 'ok' });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PaymentSettingsPopUp.prototype.isFormInvalid = function () {
        var hasErrors = false;
        if (this.model.SortCode && this.model.SortCode.length < 6) {
            this.sortNumberError = true;
            hasErrors = true;
        }
        if (this.model.BankAccount && this.model.BankAccount.length < 8) {
            this.bankAccountError = true;
            hasErrors = true;
        }
        return hasErrors;
    };
    PaymentSettingsPopUp.$inject = [
        'definitionsService',
        'notificationService',
        '$rootScope',
        'jispPayService',
        '$translate'
    ];
    return PaymentSettingsPopUp;
}());
angular.module('naut').component('paymentSettingsPopUp', {
    template: __webpack_require__(776),
    controller: PaymentSettingsPopUp,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var PasswordConfirmationController = /** @class */ (function () {
    function PasswordConfirmationController($translate) {
        var _this = this;
        this.$translate = $translate;
        this.modalInstance = this;
        this.confirm = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.isValidModel()) {
                    return [2 /*return*/];
                }
                this.waiting = true;
                this.modalInstance.close({ $value: this.password });
                return [2 /*return*/];
            });
        }); };
        this.cancel = function () {
            _this.modalInstance.dismiss({ $value: 'cancel' });
        };
    }
    PasswordConfirmationController.prototype.isValidModel = function () {
        this.password = this.password ? this.password.trim() : '';
        return this.password.length > 0;
    };
    PasswordConfirmationController.$inject = ['jispPayService', 'notificationService', '$translate'];
    return PasswordConfirmationController;
}());
angular.module('naut').component('passwordConfirmation', {
    template: __webpack_require__(777),
    controller: PasswordConfirmationController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddOrEditVendorItem = /** @class */ (function () {
    function AddOrEditVendorItem($scope, $uibModal, $translate, notificationService, vendorsService, $timeout, googleMapService, $rootScope, popupService) {
        var _this = this;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.vendorsService = vendorsService;
        this.$timeout = $timeout;
        this.googleMapService = googleMapService;
        this.$rootScope = $rootScope;
        this.popupService = popupService;
        this.waiting = false;
        this.showVendorNameError = false;
        this.isMapShown = true;
        this.isMapReady = false;
        this.modalInstance = this;
        this.vendor = {
            ID: null,
            FirstName: null,
            LastName: null,
            UserName: null,
            ImageID: null,
            Age: null,
            Street: null,
            Password: null,
            Description: null,
            ShortDescription: null,
            PlacesID: null,
            Latitude: null,
            Longitude: null,
            Interviewer: {
                InterviewerName: null,
                InterviewerImg: null
            }
        };
        this.maps = {
            optionsEdit: null,
            edit: null,
            markerEdit: null,
            infoWindow: null,
            defaultLatLng: { lat: 51.500152, lng: -0.126236 },
            loadedEdit: false,
            validDistance: 500,
            zoom: 16
        };
        this.isViewChanged = false;
        this.googleMaps = null;
        this.minImageSize = {
            w: 210,
            h: 210
        };
        this.mapdragstart = function () {
            _this.maps.edit.setOptions({ draggingCursor: 'move' });
        };
        this.mapdragend = function () {
            _this.maps.edit.setOptions({ draggingCursor: 'default' });
        };
        this.setMarker = function ($event, $params) {
            if (!_this.maps.edit) {
                _this.resizeGoogleMaps();
                return;
            }
            if (_this.maps.markerEdit) {
                _this.maps.markerEdit.setMap(null);
            }
            _this.maps.markerEdit = new _this.googleMaps.Marker({
                map: _this.maps.edit,
                position: $params[0].latLng,
                title: _this.fullAddress,
                draggable: true
            });
            _this.maps.edit.setCenter($params[0].latLng);
        };
        this.maploaded = function () {
            if (_this.isMapShown && !_this.maps.loadedEdit) {
                _this.maps.loadedEdit = true;
                _this.refreshGoogleMaps();
            }
        };
        this.openMarkerInfo = function (map, marker) {
            new _this.googleMaps.Geocoder().geocode({ location: marker.getPosition() }, function (results, status) {
                if (status === _this.googleMaps.GeocoderStatus.OK) {
                    _this.maps.infoWindow.setContent(results[0].formatted_address);
                    _this.maps.infoWindow.open(map, marker);
                }
            });
        };
        this.getLocationFromAddress = function ($event) {
            if (_this.isViewChanged && _this.vendor.PlacesID) {
                _this.vendor.PlacesID = null;
                _this.selectedAddress = null;
                _this.isViewChanged = false;
            }
            var currentSelectedAddress = _this.fullAddress;
            var geocoder = new _this.googleMaps.Geocoder();
            geocoder.geocode({
                address: currentSelectedAddress
            }, function (results, status) {
                if (status === _this.googleMaps.GeocoderStatus.OK) {
                    _this.setMarker(null, [
                        { latLng: results[0].geometry.location }
                    ]);
                    _this.maps.edit.setZoom(_this.maps.zoom);
                    var position = _this.maps.markerEdit.getPosition();
                    _this.vendor.Latitude = position.lat();
                    _this.vendor.Longitude = position.lng();
                    _this.setGoogleMaps(_this.vendor.Latitude, _this.vendor.Longitude);
                    console.log(_this.vendor);
                }
                else {
                    _this.popupService
                        .alert({
                        title: _this.$translate.instant('cant_determine_location'),
                        content: "<p>" + _this.$translate.instant('cant_determine_location_description') + "</p>"
                    })
                        .then(function () {
                        return;
                    })["catch"](function () {
                        return;
                    });
                }
            });
            $event.preventDefault();
            $event.stopPropagation();
        };
        this.resizeGoogleMaps = function () {
            _this.$timeout(function () {
                if (_this.isMapShown && !_this.maps.edit) {
                    _this.googleMaps.event.trigger(_this.maps.edit, 'resize');
                }
            }, 300)["finally"](function () { return _this.isMapReady = true; });
        };
        this.refreshGoogleMaps = function () {
            if (_this.isMapShown) {
                if (!_this.vendor.Longitude && !_this.vendor.Latitude) {
                    _this.maps.edit.setCenter(_this.maps.optionsEdit.center);
                }
                else {
                    if (_this.maps.markerEdit !== null) {
                        _this.maps.markerEdit.setMap(null);
                    }
                    _this.maps.markerEdit = new _this.googleMaps.Marker({
                        map: _this.maps.edit,
                        position: _this.maps.optionsEdit.center,
                        title: _this.fullAddress,
                        draggable: true
                    });
                    _this.maps.edit.setCenter(_this.maps.optionsEdit.center);
                }
            }
        };
    }
    AddOrEditVendorItem.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.idParam = this.resolve.vendorId;
                        this.locations = this.resolve.places;
                        this.isNew = !this.idParam;
                        this.country = this.$rootScope.userData.countryID;
                        this.setDefaultMapLocation();
                        if (!!this.isNew) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadVendor()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getMapData()];
                    case 2:
                        _a.sent();
                        this.setAddImageWatcher();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.getMapData()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.setViewWatcher();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.closeDialog = function () {
        this.modalInstance.close({ $value: false });
    };
    AddOrEditVendorItem.prototype.setDefaultUsername = function () {
        this.vendor.UserName = [this.vendor.FirstName, this.vendor.LastName].join('');
    };
    AddOrEditVendorItem.prototype.setSelectedVendorLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.vendor.PlacesID = [this.selectedAddress.ID];
                        if (!(this.isViewChanged && this.vendor.Latitude && this.vendor.Longitude)) return [3 /*break*/, 2];
                        this.vendor.Latitude = null;
                        this.vendor.Longitude = null;
                        this.fullAddress = null;
                        return [4 /*yield*/, this.getMapData()];
                    case 1:
                        _a.sent();
                        this.isViewChanged = false;
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.isViewChanged && !this.vendor.Latitude && !this.vendor.Longitude && this.fullAddress) {
                            this.fullAddress = null;
                            this.isViewChanged = false;
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.isFullAddressFiledValid = function () {
        if (this.isMapShown) {
            return Boolean(this.fullAddress && this.vendor.Latitude && this.vendor.Longitude);
        }
        else {
            return Boolean(this.vendor.PlacesID);
        }
    };
    AddOrEditVendorItem.prototype.saveVendorForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var model, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(this.vendor);
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        if (!this.vendor.PlacesID && this.vendor.Longitude && this.vendor.Latitude) {
                            model = {
                                address: this.fullAddress,
                                name: this.vendor.Street,
                                latitude: this.vendor.Latitude,
                                longitude: this.vendor.Longitude
                            };
                            // this.vendor.PlacesID = await createVendorLocation(model)
                        }
                        return [4 /*yield*/, this.vendorsService.createOrUpdateVendor(this.vendor, this.idParam ? this.idParam : null)];
                    case 2:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close({ $value: true });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.addImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var imageID, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return _this.vendor.ImageID; },
                                    title: function () { return _this.$translate.instant('vendor_photo'); },
                                    sizeText: function () {
                                        return _this.$translate.instant('store_photo_min_size_hint', { width: 210, height: 210 });
                                    },
                                    getUrl: function () {
                                        return _this.vendor.ImageID == null ||
                                            _this.vendorsService.getVendorImageUrl(_this.vendor.ImageID);
                                    },
                                    saveUrl: function () { return _this.vendorsService.saveVendorImageUrl(); },
                                    imageSize: function () { return _this.minImageSize; }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        imageID = _a.sent();
                        if (imageID) {
                            this.vendor.ImageID = imageID;
                            this.avatarUrl = this.vendorsService.getVendorImageUrl(this.vendor.ImageID);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.loadVendor = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.vendorsService.getVendor(this.idParam)];
                    case 2:
                        _a.vendor = _b.sent();
                        this.selectedAddress = this.locations.find(function (location) { return location.ID === _this.vendor.PlacesID[0]; });
                        this.isMapShown = Boolean(this.vendor.Latitude && this.vendor.Longitude);
                        this.fullAddress = this.isMapShown ? this.selectedAddress.info : null;
                        this.avatarUrl = this.vendor.ImageID ? this.vendorsService.getVendorImageUrl(this.vendor.ImageID) : null;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.setAddImageWatcher = function () {
        var _this = this;
        this.$scope.$watch(function () { return _this.vendor.ImageID; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.vendorEditorForm.$setDirty();
            }
        });
    };
    AddOrEditVendorItem.prototype.setViewWatcher = function () {
        var _this = this;
        this.$scope.$watch(function () { return _this.isMapShown; }, function (newValue, oldValue) {
            if (newValue !== oldValue && !_this.isViewChanged) {
                _this.isViewChanged = true;
            }
            else if (newValue !== oldValue && newValue && _this.isViewChanged) {
                if (_this.vendor.Longitude && _this.vendor.Latitude) {
                    _this.refreshGoogleMaps();
                }
            }
        });
    };
    AddOrEditVendorItem.prototype.setDefaultMapLocation = function () {
        // 2 = Norway, 1 = UK, 3 = USA, 4 = Ireland
        switch (this.country) {
            case 2: {
                this.maps.defaultLatLng = { lat: 59.9145019, lng: 10.7566006 };
                break;
            }
            case 1: {
                this.maps.defaultLatLng = { lat: 51.500152, lng: -0.126236 };
                break;
            }
            case 3: {
                this.maps.defaultLatLng = { lat: 40.7127, lng: -74.0059 };
                break;
            }
            case 4: {
                this.maps.defaultLatLng = { lat: 53.342754, lng: -6.271849 };
                break;
            }
        }
    };
    AddOrEditVendorItem.prototype.getMapData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.googleMapService.getGoogleMaps()];
                    case 1:
                        _a.googleMaps = _b.sent();
                        console.log(this.vendor.Latitude, this.vendor.Longitude);
                        this.setGoogleMaps(this.vendor.Latitude, this.vendor.Longitude);
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVendorItem.prototype.setGoogleMaps = function (lat, lng) {
        var position;
        if (!lat || !lng) {
            position = new this.googleMaps.LatLng(this.maps.defaultLatLng.lat, this.maps.defaultLatLng.lng);
        }
        else {
            position = new this.googleMaps.LatLng(lat, lng);
        }
        this.maps.optionsEdit = {
            center: position,
            zoom: this.maps.zoom,
            mapTypeId: this.googleMaps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: false,
            disableDefaultUI: true,
            disableDoubleClickZoom: false,
            scaleControl: true,
            draggableCursor: 'default',
            draggingCursor: 'default'
        };
        this.maps.infoWindow = new this.googleMaps.InfoWindow();
        this.resizeGoogleMaps();
    };
    AddOrEditVendorItem.$inject = [
        '$scope',
        '$uibModal',
        '$translate',
        'notificationService',
        'vendorsMockService',
        '$timeout',
        'googleMapService',
        '$rootScope',
        'popupService'
    ];
    return AddOrEditVendorItem;
}());
angular.module('naut').component('addOrEditVendorItem', {
    template: __webpack_require__(778),
    controller: AddOrEditVendorItem,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var VendorsMockService = /** @class */ (function () {
    function VendorsMockService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
        this.data = [
            {
                ID: 1,
                FirstName: 'Name 1',
                LastName: 'Surname',
                ImageID: null,
                UserName: 'Name 1 Surname',
                Street: 'street 1',
                PlacesID: [2],
                places: [{
                        id: 2,
                        info: 'John\'s place, London, St.James\'s Park',
                        isActive: true,
                        isBanned: false
                    }]
            },
            {
                ID: 2,
                FirstName: 'Name 2',
                LastName: 'Surname',
                ImageID: null,
                UserName: 'Name 2 Surname',
                Street: 'street 2',
                PlacesID: [2],
                places: [{
                        id: 2,
                        info: 'John\'s place, London, St.James\'s Park',
                        isActive: true,
                        isBanned: false
                    }]
            },
            {
                ID: 3,
                FirstName: 'Name 3',
                LastName: 'Surname',
                ImageID: null,
                UserName: 'Name 3 Surname',
                Street: 'street 3',
                PlacesID: [2],
                places: [{
                        id: 2,
                        info: 'John\'s place, London, St.James\'s Park',
                        isActive: true,
                        isBanned: false
                    }]
            }
        ];
    }
    VendorsMockService.prototype.getVendors = function (filter) {
        var vendors = {
            Items: this.data.slice(),
            Total: 3
        };
        return Promise.resolve(vendors);
    };
    VendorsMockService.prototype.getVendor = function (vendorID) {
        var vendor = {
            ID: 1,
            FirstName: 'Name',
            LastName: 'Surname',
            UserName: 'NameSurname',
            ImageID: null,
            Age: 22,
            Street: 'Some street',
            Password: '12345678',
            Description: 'DescriptionTextDescriptionTextDescriptionText',
            ShortDescription: 'DescriptionText',
            PlacesID: [1],
            Latitude: 51.50155141535449,
            Longitude: -0.13463923862309457,
            // Latitude: null,
            // Longitude: null,
            Interviewer: {
                InterviewerName: 'Author name',
                InterviewerImg: 'Some img'
            }
        };
        return Promise.resolve(vendor);
    };
    VendorsMockService.prototype.createOrUpdateVendor = function (vendor, vendorID) {
        if (vendorID == null) {
            return Promise.resolve();
            // return this.http.post<number>(this.retailerService.getVendors(), vendor);
        }
        else {
            return Promise.resolve();
            // return this.http.put(this.retailerService.getVendor(vendorID), vendor);
        }
    };
    VendorsMockService.prototype.archiveVendor = function (vendorID) {
        // return this.http.put(this.retailerService.archiveVendor(vendorID), null);
    };
    VendorsMockService.prototype.restoreVendor = function (vendorID) {
        // return this.http.put(this.retailerService.restoreVendors(vendorID), null);
    };
    VendorsMockService.prototype.saveVendorImageUrl = function () {
        // return this.retailerService.createVendorImage();
    };
    VendorsMockService.prototype.getVendorImageUrl = function (imageID) {
        return;
    };
    VendorsMockService.$inject = ['http', 'retailerService'];
    return VendorsMockService;
}());
exports.VendorsMockService = VendorsMockService;
angular
    .module('naut')
    .service('vendorsMockService', VendorsMockService);


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var VendorsService = /** @class */ (function () {
    function VendorsService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    VendorsService.prototype.getVendors = function (filter) {
        return this.http.get(this.retailerService.getVendors(), { params: filter });
    };
    VendorsService.prototype.getVendor = function (vendorID) {
        return this.http.get(this.retailerService.getVendor(vendorID));
    };
    VendorsService.prototype.createOrUpdateVendor = function (vendor, vendorID) {
        if (vendorID == null) {
            return this.http.post(this.retailerService.getVendors(), vendor);
        }
        else {
            return this.http.put(this.retailerService.getVendor(vendorID), vendor);
        }
    };
    VendorsService.prototype.archiveVendor = function (vendorID) {
        return this.http.put(this.retailerService.archiveVendor(vendorID), null);
    };
    VendorsService.prototype.restoreVendor = function (vendorID) {
        return this.http.put(this.retailerService.restoreVendors(vendorID), null);
    };
    VendorsService.prototype.saveVendorImageUrl = function () {
        return this.retailerService.createVendorImage();
    };
    VendorsService.prototype.getVendorImageUrl = function (imageID) {
        return;
        // return this.retailerService.getExtraImage(imageID);
    };
    VendorsService.$inject = ['http', 'retailerService'];
    return VendorsService;
}());
exports.VendorsService = VendorsService;
angular
    .module('naut')
    .service('vendorsService', VendorsService);


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var JispPayService = /** @class */ (function () {
    function JispPayService(http, blobService, retailerService, $serializer, $uibModal, avatarService) {
        var _this = this;
        this.http = http;
        this.blobService = blobService;
        this.retailerService = retailerService;
        this.$serializer = $serializer;
        this.$uibModal = $uibModal;
        this.avatarService = avatarService;
        this.jispPayMerchants = [];
        this.getJispPayMerchants = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.retailerService.jispPayMerchants())];
                    case 1:
                        _a.jispPayMerchants = _b.sent();
                        return [2 /*return*/, this.jispPayMerchants];
                }
            });
        }); };
        this.openAccountManager = function (staff, places) {
            return _this.$uibModal.open({
                component: 'jispPayAccount',
                resolve: {
                    staff: function () { return staff; },
                    places: function () { return places; }
                },
                size: 'lg',
                windowClass: 'staffPopup',
                backdrop: 'static'
            }).result;
        };
    }
    JispPayService.prototype.getPlaces = function (offset, limit) {
        return this.http.get(this.retailerService.jisppayPlaces(offset, limit));
    };
    JispPayService.prototype.setPlace = function (id, model) {
        return this.http.put(this.retailerService.jisppayPlace(id), model);
    };
    JispPayService.prototype.setJispPayEnable = function (model) {
        return this.http.put(this.retailerService.jispPayEnable(), model);
    };
    JispPayService.prototype.getDefaultMerchants = function () {
        return this.http.get(this.retailerService.jispPayDefaultMerchants());
    };
    JispPayService.prototype.isStaffAny = function (isActive) {
        return this.http.get(this.retailerService.jisppayStaffAny(isActive));
    };
    JispPayService.prototype.getStaff = function (filter) {
        return this.http.get(this.retailerService.jisppayStaff(), { params: filter });
    };
    JispPayService.prototype.getAvatarUrl = function (id, width, height) {
        var baseUrl = this.retailerService.jisppayStaff();
        var params = this.$serializer({ id: id, width: width, height: height });
        return baseUrl + "/avatar?" + params;
    };
    JispPayService.prototype.getAvatarUploadUrl = function () {
        return this.retailerService.jisppayUploadAvatar();
    };
    JispPayService.prototype.createStaff = function (staff) {
        return this.http.post(this.retailerService.jisppayAccount(), staff);
    };
    JispPayService.prototype.updateStaff = function (id, staff) {
        return this.http.put(this.retailerService.jisppayAccount(id), staff);
    };
    JispPayService.prototype.archiveStaff = function (ids) {
        return this.http["delete"](this.retailerService.jisppayAccount(), {
            params: { id: ids }
        });
    };
    JispPayService.prototype.restoreStaff = function (ids) {
        return this.http.post(this.retailerService.jisppayAccountRestore(), ids);
    };
    JispPayService.prototype.jisppayStaffLoginExist = function (email) {
        return this.http.get(this.retailerService.jisppayStaffLoginExist(email));
    };
    JispPayService.prototype.getColumnSort = function (name, isAsc) {
        return {
            column: name ? name : 'ID',
            order: 'ascending',
            asc: 'ascending',
            desc: 'descending',
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            set: function (name, isAsc) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                }
                else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'ID';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort: function (list, field, asc) {
                return asc
                    ? _.sortBy(list, field)
                    : _.sortBy(list, field).reverse();
            },
            isSelected: function (field) {
                return this.column === field;
            }
        };
    };
    JispPayService.prototype.uploadImage = function (file, url) {
        if (url === void 0) { url = null; }
        return this.avatarService.uploadImage(file, url ? url : this.retailerService.jisppayUploadAvatar());
    };
    JispPayService.prototype.trim = function (str) {
        return str ? str.trim() : '';
    };
    // public openVendorEditor = (places: IStoreForShopingListItem[], account?: IVendorTableItem) => {
    //     return this.$uibModal.open({
    //         component: 'addOrEditVendorItem',
    //         resolve: {
    //             vendorId: () => account ? account.ID : null,
    //             places: () => places
    //         },
    //         size: 'lg',
    //         windowClass: 'staffPopup',
    //         backdrop: 'static'
    //     }).result;
    // }
    JispPayService.prototype.passwordConfirmation = function (id) {
        return this.$uibModal.open({
            component: 'passwordConfirmation',
            size: 'sm',
            windowClass: 'jisppayPopup jisppayPopupSmaller'
        }).result;
    };
    JispPayService.prototype.getCompanyInfo = function () {
        return this.http.get(this.retailerService.companyInfoUrl());
    };
    JispPayService.prototype.putCompanyInfo = function (model) {
        return this.http.put(this.retailerService.companyInfoUrl(), model);
    };
    JispPayService.$inject = [
        'http',
        'blobService',
        'retailerService',
        '$httpParamSerializer',
        '$uibModal',
        'avatarService'
    ];
    return JispPayService;
}());
exports.JispPayService = JispPayService;
angular.module('naut').service('jispPayService', JispPayService);


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var LoyaltyProgramService = /** @class */ (function () {
    function LoyaltyProgramService(http, retailerService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.thresholds = [];
        this.getThresholds = function () { return __awaiter(_this, void 0, void 0, function () {
            var thresholds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.thresholds || _.isEmpty(this.thresholds))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.http.get(this.retailerService.loyaltyProgramsThresholds())];
                    case 1:
                        thresholds = _a.sent();
                        this.thresholds = _.map(thresholds, this.getClientThreshold);
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.thresholds];
                }
            });
        }); };
    }
    LoyaltyProgramService.prototype.getStoreLoyaltyPrograms = function (filter) {
        return this.http.get(this.retailerService.loyaltyPrograms(), { params: filter });
    };
    LoyaltyProgramService.prototype.updateStoreLoyaltyProgram = function (id, model) {
        return this.http.put(this.retailerService.loyaltyPrograms(id), model);
    };
    LoyaltyProgramService.prototype.getClientThreshold = function (threshold) {
        if (threshold) {
            return {
                value: threshold,
                title: threshold * 100 + " %"
            };
        }
        else {
            return null;
        }
    };
    LoyaltyProgramService.prototype.getCountryAndCurrency = function () {
        return this.http.get(this.retailerService.country()).then(function (country) {
            return country;
        });
    };
    LoyaltyProgramService.$inject = ['http', 'retailerService'];
    return LoyaltyProgramService;
}());
exports.LoyaltyProgramService = LoyaltyProgramService;
angular
    .module('naut')
    .service('loyaltyProgramService', LoyaltyProgramService);


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AdForMarketplaceController = /** @class */ (function () {
    function AdForMarketplaceController($translate, notificationService, marketPlaceService, $uibModal, accountService, popupService, retailerService, $transitions, $state) {
        var _this = this;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.marketPlaceService = marketPlaceService;
        this.$uibModal = $uibModal;
        this.accountService = accountService;
        this.popupService = popupService;
        this.retailerService = retailerService;
        this.$transitions = $transitions;
        this.$state = $state;
        this.model = null;
        this.backupImage = {
            src: null,
            data: null,
            loading: false,
            valid: false,
            dirty: false,
            id: null,
            serverImgLength: null
        };
        this.waiting = false;
        this.firstImgLoad = true;
        this.image = {
            src: null,
            data: null,
            loading: false,
            valid: false,
            dirty: false,
            id: null,
            serverImgLength: null
        };
        this.imageMinSize = {
            w: 640,
            h: 360
        };
        this.imageOptions = { ratio: '16:9' };
        this.error = {
            imageMinSize: false,
            fileType: false,
            imageFileSizeMinSize: false,
            fileSize: false,
            imageRequired: false,
            imageMinAreaSize: false
        };
        this.firstDiscardChangeRequest = true;
        $transitions.onBefore({}, function (transition) {
            var toStateName = transition.to().name;
            if (_this.firstDiscardChangeRequest && _this.pageHasChanges()) {
                return _this.openDiscardChangesDialog()
                    .then(function () {
                    _this.firstDiscardChangeRequest = false;
                    return transition.router.stateService.target(toStateName);
                }, function () {
                    transition.abort();
                });
            }
        });
    }
    AdForMarketplaceController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadAdvert();
                return [2 /*return*/];
            });
        });
    };
    AdForMarketplaceController.prototype.$postLink = function () {
        this.advertForm.location.$validators.locationModel = this.validateLocationModel.bind(this);
        this.advertForm.image.$validators.imageModel = this.validateImageModel.bind(this);
    };
    AdForMarketplaceController.prototype.createOrUpdateRetailerAdverts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var model, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isValidModel()) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        this.waiting = true;
                        model = {
                            PlaceID: this.model.selectedLocation.ID,
                            ImageID: this.model.retailerAdvert.Advert.ImageID
                        };
                        if (!this.model.retailerAdvert.Advert.ID) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.marketPlaceService.updateAdvert(this.model.retailerAdvert.Advert.ID, model, this.image.data)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.marketPlaceService.createAdvert(model, this.image.data)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, this.loadAdvert()];
                    case 6:
                        _a.sent();
                        this.advertForm.$setPristine();
                        this.firstImgLoad = true;
                        this.model.isNew = false;
                        this.notificationService.showSuccessMessage();
                        return [3 /*break*/, 9];
                    case 7:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 9];
                    case 8:
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    AdForMarketplaceController.prototype.pageHasChanges = function () {
        if (!this.model && !this.backupModel) {
            return false;
        }
        return this.backupModel.selectedLocation.ID !== this.model.selectedLocation.ID ||
            this.backupModel.linkOption !== this.model.linkOption ||
            this.backupImage && this.image && this.backupImage.src !== this.image.src;
    };
    AdForMarketplaceController.prototype.openDiscardChangesDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.popupService.confirm({
                        cancelClass: 'btn btn-with-background-icon icon-check--white btn-success',
                        cancelTxt: this.$translate.instant('discard_continue'),
                        okClass: 'btn btn-with-background-icon close-icon--tiny24',
                        okTxt: this.$translate.instant('discard_cancel'),
                        title: this.$translate.instant('discard_changes_title'),
                        content: this.$translate.instant('discard_changes_promt'),
                        invertAction: true
                    })];
            });
        });
    };
    AdForMarketplaceController.prototype.openSelectLocationDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'selectSingleLocation',
                            resolve: { options: function () {
                                    return {
                                        selectedLocationID: _this.model.selectedLocation ? _this.model.selectedLocation.ID : null
                                    };
                                } },
                            size: 'md',
                            backdrop: 'static',
                            windowClass: 'modal-design-v2'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult.status === 'ok') {
                            this.model.selectedLocation = {
                                ID: operationResult.selectedLocation.ID,
                                Name: operationResult.selectedLocation.Name,
                                Address: operationResult.selectedLocation.Address,
                                Active: operationResult.selectedLocation.Active
                            };
                            this.model.retailerAdvert.Advert.PlaceID = operationResult.selectedLocation.ID;
                            this.advertForm.location.$validate();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AdForMarketplaceController.prototype.changeLinkOption = function (linkOption) {
        if (linkOption === 0 && this.model.selectedLocation) {
            this.model.selectedLocation.ID = null;
            this.model.selectedLocation.Name = null;
            this.model.selectedLocation.Active = null;
            this.model.selectedLocation.Address = null;
            this.model.retailerAdvert.Advert.PlaceID = null;
            this.model.retailerAdvert.Advert.Place = null;
        }
    };
    AdForMarketplaceController.prototype.openDeleteDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('ad_retailer_delete_dialog_content_cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('ad_retailer_delete_dialog_content_ok'),
                                cancelClass: 'btn btn-with-background-icon icon-check--white btn-success',
                                title: this.$translate.instant('ad_retailer_delete_dialog_title'),
                                content: this.$translate.instant('ad_retailer_delete_dialog_content'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.marketPlaceService.deleteRetailerAdverts(this.model.retailerAdvert.Advert.ID)];
                    case 5:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.model = this.getDefaultAdvertModel();
                        this.image = {
                            src: null,
                            data: null,
                            loading: false,
                            valid: false,
                            dirty: false,
                            id: null,
                            serverImgLength: null
                        };
                        return [3 /*break*/, 7];
                    case 6:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AdForMarketplaceController.prototype.imageOnload = function (event) {
        if (this.firstImgLoad && !this.model.isNew) {
            this.advertForm.$setPristine();
            this.firstImgLoad = false;
        }
    };
    AdForMarketplaceController.prototype.isValidModel = function () {
        return this.image.data && (this.model.linkOption === 0 || this.model.linkOption === 1 && this.model.selectedLocation.ID);
    };
    AdForMarketplaceController.prototype.validateLocationModel = function () {
        if (this.model) {
            return this.model.linkOption === 0 || (this.model.linkOption === 1 && this.model.selectedLocation.ID != null);
        }
    };
    AdForMarketplaceController.prototype.validateImageModel = function () {
        if (this.image) {
            return this.image.data !== null && this.image.data.length > 0 &&
                this.error.imageMinAreaSize === false &&
                this.error.imageMinSize === false &&
                this.error.imageFileSizeMinSize === false &&
                this.error.fileSize === false &&
                this.error.fileType === false;
        }
    };
    AdForMarketplaceController.prototype.loadAdvert = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.marketPlaceService.getRetailerAdverts()];
                    case 2:
                        response = _a.sent();
                        this.model = response.Advert ? this.getClientAdvertModel(response) : this.getDefaultAdvertModel();
                        this.backupModel = response.Advert ? this.getClientAdvertModel(response) : this.getDefaultAdvertModel();
                        if (this.model.imageID) {
                            this.image.src = this.retailerService.getRetailerAdvertsImageUrl(this.model.imageID);
                            this.image.id = this.model.imageID;
                            this.backupImage.src = this.retailerService.getRetailerAdvertsImageUrl(this.model.imageID);
                            this.backupImage.id = this.model.imageID;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AdForMarketplaceController.prototype.getClientAdvertModel = function (advert) {
        var retailerAdvert = advert;
        var location = {};
        if (advert.Advert.Place && advert.Advert.PlaceID) {
            location = {
                ID: advert.Advert.PlaceID,
                Name: advert.Advert.Place.Name,
                Active: true,
                Address: advert.Advert.Place.Address
            };
        }
        else {
            location = {
                ID: null,
                Name: null,
                Active: null,
                Address: null
            };
        }
        return {
            retailerAdvert: retailerAdvert,
            selectedLocation: location,
            imageID: advert.Advert.ImageID,
            isNew: false,
            linkOption: advert.Advert.PlaceID ? 1 : 0
        };
    };
    AdForMarketplaceController.prototype.getDefaultAdvertModel = function () {
        var retailerAdvert = {
            Advert: { ID: null, ImageID: null, Place: null, PlaceID: null },
            CurrentOpennings: 0,
            CurrentViews: 0,
            TotalOpennings: 0,
            TotalViews: 0
        };
        var selectedLocation = {
            ID: null,
            Name: null,
            Active: null,
            Address: null
        };
        return {
            retailerAdvert: retailerAdvert,
            selectedLocation: selectedLocation,
            imageID: null,
            isNew: true,
            linkOption: 0
        };
    };
    AdForMarketplaceController.$inject = [
        '$translate',
        'notificationService',
        'marketPlaceService',
        '$uibModal',
        'accountService',
        'popupService',
        'retailerService',
        '$transitions',
        '$state'
    ];
    return AdForMarketplaceController;
}());
exports.AdForMarketplaceController = AdForMarketplaceController;
angular.module('naut').component('adForMarketplace', {
    template: __webpack_require__(779),
    controller: AdForMarketplaceController,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var minWidth = 640;
var maxWidth = 1200;
var AdImageSelectorComponent = /** @class */ (function () {
    function AdImageSelectorComponent($scope, $timeout, campaignsService) {
        var _this = this;
        this.$timeout = $timeout;
        this.campaignsService = campaignsService;
        this.imageCropped = {
            src: null,
            selector: {},
            minSize: null,
            maxSize: null,
            croppedImage: null,
            maxWidth: 600,
            scale: 1,
            aspectRatio: 2
        };
        this.error = {
            imageMinSize: false,
            fileType: false,
            imageFileSizeMinSize: false,
            fileSize: false,
            imageRequired: false,
            imageMinAreaSize: false
        };
        this.onLoadImgCrop = function () {
            _this.state.loading = false;
            _this.$timeout();
        };
        this.needHelp = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.campaignsService.needHelp()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        $scope.$watch(function () { return $('.imgcrop-area').width(); }, function (width) {
            if (width) {
                _this.imageCropped.maxWidth = width;
            }
        });
        $scope.$watch(function () { return _this.state.src; }, function (value) {
            if (value) {
                _this.state.loading = true;
            }
            else {
                _this.error.imageRequired = true;
            }
        });
    }
    AdImageSelectorComponent.prototype.$onInit = function () {
        var _this = this;
        angular.element(document.querySelector('#fileInputCropped')).on('change', function (evt) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var file, reader, element;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        file = evt.currentTarget.files[0];
                        this.state.src = null;
                        this.error.fileSize = false;
                        this.error.imageMinSize = false;
                        this.error.fileType = false;
                        if (!file) {
                            this.state.valid = false;
                            return [2 /*return*/];
                        }
                        if (!file.size || file.size > 5 * 1024 * 1024) {
                            this.error.fileSize = true;
                            this.state.valid = true;
                            return [2 /*return*/];
                        }
                        this.state.loading = true;
                        reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function (evtreader) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            var target, image;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        target = evtreader.target;
                                        return [4 /*yield*/, this.$timeout(0)];
                                    case 1:
                                        _a.sent();
                                        image = new Image();
                                        image.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, this.$timeout(0)];
                                                    case 1:
                                                        _a.sent();
                                                        if (image.width < this.imageCropped.minSize.w || image.height < this.imageCropped.minSize.h) {
                                                            this.state.src = null;
                                                            this.state.loading = false;
                                                            this.error.imageMinSize = true;
                                                            this.state.valid = false;
                                                        }
                                                        else {
                                                            this.state.src = target.result;
                                                            this.state.valid = true;
                                                            this.form.$setDirty();
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); };
                                        image.onerror = function () { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, this.$timeout(0)];
                                                    case 1:
                                                        _a.sent();
                                                        this.state.loading = false;
                                                        this.error.fileType = true;
                                                        this.state.valid = false;
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); };
                                        image.src = target.result;
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        element = evt.target;
                        element.value = '';
                        return [2 /*return*/];
                }
            });
        }); });
    };
    AdImageSelectorComponent.prototype.$onChanges = function () {
        this.options = __assign({ ratio: '2:1' }, this.options);
        var ratio = this.options.ratio.split(':').map(function (i) { return parseInt(i, 10); }).reduce(function (a, b) { return a / b; });
        this.imageCropped.aspectRatio = ratio;
        this.imageCropped.minSize = {
            w: minWidth,
            h: minWidth / ratio
        };
        this.imageCropped.maxSize = {
            w: maxWidth,
            h: maxWidth / ratio
        };
    };
    AdImageSelectorComponent.prototype.onCropped = function (cropped) {
        if (!this.state.loading && cropped !== this.state.data) {
            this.form.$setDirty();
        }
        this.state.data = cropped || null;
        if (this.imageCropped.selector.imageSize) {
            this.validateSize();
        }
        if (this.state.id && (!this.state.serverImgLength || this.state.serverImgLength === 0)) {
            this.state.serverImgLength = _.size(cropped);
        }
        this.state.loading = false;
        this.state.dirty = this.state.serverImgLength !== _.size(cropped);
    };
    AdImageSelectorComponent.prototype.clearCropped = function () {
        this.state.data = null;
        this.imageCropped.selector.clear();
    };
    AdImageSelectorComponent.prototype.validate = function () {
        this.validateSize();
        this.error.imageRequired = !this.state.data;
    };
    AdImageSelectorComponent.prototype.validateSize = function () {
        this.error.imageRequired = false;
        this.error.imageMinAreaSize = false;
        if (this.state.data != null && this.imageCropped.selector.size) {
            var w = this.imageCropped.selector.size.w ? this.imageCropped.selector.size.w : this.imageCropped.selector.imageSize.w;
            this.error.imageMinAreaSize = !(w >= this.imageCropped.minSize.w);
        }
        else if (this.state.data == null && this.state.src) {
            var validSelectorSize = angular.isDefined(this.imageCropped.selector.x1);
            this.error.imageMinAreaSize = !validSelectorSize;
            if (!validSelectorSize && this.imageCropped.selector.size) {
                this.imageCropped.selector.size.w = null;
            }
        }
        this.state.valid = !this.error.imageMinAreaSize;
    };
    AdImageSelectorComponent.$inject = ['$scope', '$timeout', 'campaignsService'];
    return AdImageSelectorComponent;
}());
angular.module('naut').component('adImageSelector', {
    template: __webpack_require__(780),
    controller: AdImageSelectorComponent,
    controllerAs: 'ctrl',
    bindings: {
        state: '=',
        options: '=?',
        waiting: '<',
        error: '='
    },
    require: {
        form: '^form'
    }
});


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var MarketPlaceService = /** @class */ (function () {
    function MarketPlaceService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    MarketPlaceService.prototype.getRetailerAdverts = function () {
        return this.http.get(this.retailerService.retailerAdvertsDefault());
    };
    MarketPlaceService.prototype.deleteRetailerAdverts = function (advertID) {
        return this.http["delete"](this.retailerService.retailerAdverts(advertID));
    };
    MarketPlaceService.prototype.updateRetailerAdverts = function (advertID, model) {
        return this.http.put(this.retailerService.retailerAdverts(advertID), model);
    };
    MarketPlaceService.prototype.createAdvert = function (model, image) {
        var _this = this;
        return this.uploadAdvertImage(image)
            .then(function (imageID) {
            model.ImageID = imageID;
            return _this.createRetailerAdvert(model);
        });
    };
    MarketPlaceService.prototype.updateAdvert = function (advertID, model, image) {
        var _this = this;
        return this.uploadAdvertImage(image)
            .then(function (imageID) {
            model.ImageID = imageID;
            return _this.updateRetailerAdverts(advertID, model);
        });
    };
    MarketPlaceService.prototype.createRetailerAdvert = function (model) {
        return this.http.post(this.retailerService.retailerAdverts(), model);
    };
    MarketPlaceService.prototype.uploadAdvertImage = function (dataUri) {
        return this.http.postFile(this.retailerService.addRetailerAdvertsImage(), dataUri);
    };
    MarketPlaceService.$inject = ['http', 'retailerService'];
    return MarketPlaceService;
}());
exports.MarketPlaceService = MarketPlaceService;
angular
    .module('naut')
    .service('marketPlaceService', MarketPlaceService);


/***/ }),
/* 1352 */
/***/ (function(module, exports) {



/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var MenuCardController = /** @class */ (function () {
    function MenuCardController($rootScope, $scope, $translate, scheduleService, popupService, menuService, notificationService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$translate = $translate;
        this.scheduleService = scheduleService;
        this.popupService = popupService;
        this.menuService = menuService;
        this.notificationService = notificationService;
        this.dateFormat = 'DD MMM YYYY';
    }
    MenuCardController.prototype.toShortTime = function (time) {
        var t = moment(time, 'hh:mm:ss');
        return t.isValid() ? t.format('hh:mm A') : '';
    };
    MenuCardController.prototype.getImage = function () {
        return this.menuService.getMenuImageUrl(this.item.ImageID.toString(), 350, 350);
    };
    MenuCardController.prototype.duplicateMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('duplicate'),
                                cancelClass: 'btn btn-with-background-icon icon-copy--white btn-success',
                                title: this.$translate.instant('duplicate_menu_title'),
                                content: this.$translate.instant('duplicate_menu_prompt'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.$rootScope.$state.go('app.edit-menu', { id: this.item.ID, duplicate: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    MenuCardController.prototype.setArchivedMenu = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, error_3, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isArchived) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('restore'),
                                cancelClass: 'btn btn-with-background-icon icon-time-restore--white btn-success',
                                title: this.$translate.instant('restore_menu_title'),
                                content: this.$translate.instant('restore_menu_prompt'),
                                classPopup: 'popup--redesign modal360',
                                invertAction: true
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('archive_menu'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('archive_menu_title'),
                                content: this.$translate.instant('archive_menu_prompt'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 8:
                        this.notificationService.showWaitingMessage();
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.menuService.setArchivedMenu(this.item.ID.toString(), !this.isArchived)];
                    case 10:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.$scope.$emit('updateData');
                        return [3 /*break*/, 12];
                    case 11:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    MenuCardController.$inject = ['$rootScope', '$scope', '$translate', 'scheduleService', 'popupService', 'menuService', 'notificationService'];
    return MenuCardController;
}());
angular.module('naut').component('menuCard', {
    template: __webpack_require__(781),
    controller: MenuCardController,
    controllerAs: 'vm',
    bindings: {
        item: '<',
        isArchived: '<',
        image: '<'
    }
});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var viewport_typed_controller_1 = __webpack_require__(4);
var MenuEditorController = /** @class */ (function (_super) {
    __extends(MenuEditorController, _super);
    function MenuEditorController($localStorage, notificationService, popupService, retailerService, productsService, menuService, scheduleService, $rootScope, $scope, $stateParams, $uibModal, $translate, $state) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$localStorage = $localStorage;
        _this.notificationService = notificationService;
        _this.popupService = popupService;
        _this.retailerService = retailerService;
        _this.productsService = productsService;
        _this.menuService = menuService;
        _this.scheduleService = scheduleService;
        _this.$scope = $scope;
        _this.$uibModal = $uibModal;
        _this.$translate = $translate;
        _this.$state = $state;
        _this.htmlTooltip = _this.$translate.instant('tooltip_menu_products');
        _this.treeOptions = {
            accept: function (sourceNodeScope, destNodesScope) {
                return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID ? true : false;
            },
            dragStart: function (event) {
                event.elements.dragging[0].classList.add('drag-item');
            },
            dropped: function (event) {
                event.elements.dragging[0].classList.remove('drag-item');
            }
        };
        _this.NameMaxLength = 64;
        _this.daysToTranslate = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday'
        ];
        _this.waiting = false;
        _this.item = {
            Name: '',
            PredeterminedSorting: false,
            DisplayInApp: false,
            ID: null,
            ImageID: null,
            StartDate: null,
            EndDate: null,
            StartTime: null,
            EndTime: null,
            DaysOfWeek: 0,
            Places: [],
            Products: []
        };
        _this.isDuplicating = false;
        _this.checkboxes = {
            startTime: true,
            endTime: true,
            endDate: true,
            disable: function () {
                this.startTime = false;
                this.endTime = false;
                this.endDate = false;
            }
        };
        _this.errors = {
            title: '',
            startDate: '',
            days: '',
            endDate: '',
            startTime: '',
            endTime: '',
            clear: function () {
                this.startDate = '';
                this.title = '';
                this.days = '';
                this.endDate = '';
                this.startTime = '';
                this.endTime = '';
            },
            any: function () {
                return (this.endTime !== '' ||
                    this.startTime !== '' ||
                    this.startDate !== '' ||
                    this.endDate !== '' ||
                    this.title !== '' ||
                    this.days !== '');
            }
        };
        _this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: new Date()
        };
        _this.idParam = $stateParams.id;
        _this.isDuplicating = $stateParams.duplicate;
        $scope.$watch('vm.checkboxes.startTime', function (changes) {
            if (_this.schedule == null) {
                return;
            }
            if (!_this.checkboxes.startTime) {
                _this.checkboxes.endTime = false;
            }
            _this.schedule.startTime = !_this.checkboxes.startTime
                ? null
                : new Date();
        }, true);
        $scope.$watch('vm.checkboxes.endTime', function (changes) {
            if (_this.schedule == null) {
                return;
            }
            _this.schedule.endTime = !_this.checkboxes.endTime
                ? null
                : new Date();
        }, true);
        $scope.$watch('vm.checkboxes.endDate', function (changes, old) {
            if (_this.schedule == null) {
                return;
            }
            _this.schedule.endDate = !_this.checkboxes.endDate
                ? null
                : new Date();
        }, true);
        $scope.$watch('vm.item.Products', function () {
            if (_this.item == null) {
                return;
            }
            _this.item.ProductsGroups = _this.item.Products.reduce(function (groups, item) {
                var val = item.ItemTypeName ? item.ItemTypeName : '';
                groups[val] = groups[val] || [];
                groups[val].push(item);
                return groups;
            }, {});
        }, true);
        if (!_this.idParam && !_this.isDuplicating) {
            _this.schedule = _this.scheduleService.getFromMenuItem(_this.item);
            _this.checkboxes.disable();
            _this.schedule.setDays(true);
            _this.schedule.startDate = new Date();
        }
        else {
            _this.getData();
        }
        return _this;
    }
    MenuEditorController.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    MenuEditorController.prototype.setUsersOrder = function (value) {
        this.item.PredeterminedSorting = !value;
    };
    MenuEditorController.prototype.getImage = function (item) {
        return this.menuService.getMenuImageUrl(item.ImageID.toString(), 142, 142);
    };
    MenuEditorController.prototype.isAllFilled = function () {
        return (this.item.Name !== '' &&
            this.item.Name.length <= this.NameMaxLength &&
            // Places
            this.item.Places.length > 0 &&
            // Products
            this.item.Products.length > 0 &&
            // Dates
            this.schedule.startDate !== null &&
            // Time
            (!this.checkboxes.startTime ||
                moment(this.schedule.startTime).isValid()) &&
            (!this.checkboxes.endTime ||
                moment(this.schedule.endTime).isValid()) &&
            // Days
            this.schedule.anyDays());
    };
    MenuEditorController.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.menuService.getMenu(this.idParam)];
                    case 2:
                        _a.item = _b.sent();
                        this.checkboxes.startTime = this.item.StartTime != null;
                        this.checkboxes.endTime = this.item.EndTime != null;
                        this.checkboxes.endDate = this.item.EndDate != null;
                        this.updateProductModels();
                        this.schedule = this.scheduleService.getFromMenuItem(this.item);
                        if (this.isDuplicating) {
                            this.item.ImageID = null;
                            this.item.ID = null;
                            this.item.DisplayInApp = false;
                        }
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.updateProductModels = function () {
        var _this = this;
        if (!this.item.Products) {
            this.item.Products = [];
        }
        this.item.Products.forEach(function (element) {
            element.MinPrice = element.Variants.reduce(function (prev, cur) { return (cur.Price < prev ? cur.Price : prev); }, element.Variants[0].Price);
            element.MaxPrice = element.Variants.reduce(function (prev, cur) { return (cur.Price > prev ? cur.Price : prev); }, element.Variants[0].Price);
            element.ImageID = _this.retailerService.getProductImageUrl(element.Variants[0].ImageIDs[0], null, 64);
            element.IsArchived = !element.Variants.some(function (x) { return !x.IsArchived; });
        });
    };
    MenuEditorController.prototype.getPreparedData = function () {
        var i = angular.copy(this.item);
        if (i.EndTime instanceof Date) {
            i.EndTime = i.EndTime.toLocaleTimeString();
        }
        if (i.StartTime instanceof Date) {
            i.StartTime = i.StartTime.toLocaleTimeString();
        }
        i.PlaceIDs = i.Places.map(function (x) { return x.ID; });
        i.ProductIDs = Object.keys(i.ProductsGroups).reduce(function (accumulator, key) {
            return accumulator.concat(i.ProductsGroups[key].map(function (product) { return product.productId ? product.productId : product.ID; }));
        }, []);
        if (i.ImageID < 1) {
            i.ImageID = null;
        }
        i.Products = undefined;
        i.Places = undefined;
        this.scheduleService.updateMenuItemSchedule(this.schedule, i);
        return i;
    };
    MenuEditorController.prototype.validate = function () {
        this.errors.clear();
        if (!moment(this.schedule.startDate).isValid()) {
            this.errors.startDate = this.$translate.instant('invalid_date');
        }
        if (this.checkboxes.endDate &&
            (!moment(this.schedule.endDate).isValid() ||
                this.schedule.endDate == null)) {
            this.errors.endDate = this.$translate.instant('invalid_date');
        }
        if (moment(this.schedule.startDate) > moment(this.schedule.endDate)) {
            this.errors.endDate = this.$translate.instant('invalid_end_date');
        }
        if (moment(this.schedule.startTime) > moment(this.schedule.endTime)) {
            this.errors.endTime = this.$translate.instant('invalid_end_time');
        }
        return !this.errors.any();
    };
    MenuEditorController.prototype.saveData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prepared, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.validate()) {
                            return [2 /*return*/];
                        }
                        prepared = this.getPreparedData();
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.menuService.saveMenu(prepared)];
                    case 2:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.notificationService.showSuccessMessage();
                        this.$state.go('app.menus', { archived: this.item.IsArchived });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.setArchivedMenu = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('archive_menu'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('archive_menu_title'),
                                content: this.$translate.instant('archive_menu_prompt'),
                                invertAction: true,
                                classPopup: 'popup--redesign'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.menuService.setArchivedMenu(this.idParam, value)];
                    case 5:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.notificationService.showSuccessMessage();
                        this.$state.go('app.menus');
                        return [3 /*break*/, 7];
                    case 6:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.addLocations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.item;
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectLocations',
                                resolve: {
                                    options: function () {
                                        return {
                                            fullName: true,
                                            selectedLocations: _this.item.Places
                                        };
                                    }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        _a.Places = (_b.sent()).selectedLocations;
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.addProducts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var products, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'productSearch',
                                resolve: {
                                    categories: function () { return 228; } /* CATEGORY_FOOD_ROOT_ID */,
                                    items: function () {
                                        return _this.item.Products.map(function (x) {
                                            return ({
                                                productId: x.ID,
                                                currencySign: x.CurrencySign,
                                                imageUrl: x.ImageID,
                                                isSelected: true,
                                                title: x.Title,
                                                maxPrice: x.MaxPrice,
                                                minPrice: x.MinPrice,
                                                variants: x.Variants,
                                                itemTypeName: x.ItemTypeName,
                                                itemTypeID: x.ItemTypeID
                                            });
                                        });
                                    }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        products = _a.sent();
                        this.item.Products = products.map(function (x) {
                            return ({
                                ID: x.productId,
                                Title: x.title,
                                ImageID: x.imageUrl,
                                MinPrice: x.minPrice,
                                MaxPrice: x.maxPrice,
                                IsArchived: false,
                                Variants: x.variants,
                                ItemTypeName: x.itemTypeName,
                                ItemTypeID: x.itemTypeID,
                                CurrencySign: x.currencySign
                            });
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.addImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var image, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                scope: this.$scope.$new(true),
                                resolve: {
                                    avatarId: function () { return _this.item.ImageID; },
                                    title: function () { return _this.$translate.instant('menu_photo'); },
                                    getUrl: function () {
                                        return _this.item.ImageID == null ||
                                            _this.menuService.getMenuImageUrl(_this.item.ImageID.toString());
                                    },
                                    saveUrl: function () { return _this.menuService.saveMenuImageUrl(); }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        image = _a.sent();
                        if (image) {
                            this.item.ImageID = image;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.removeLocation = function (locationID) {
        return __awaiter(this, void 0, void 0, function () {
            var error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('delete'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('remove_location'),
                                content: this.$translate.instant('remove_location_from_menu'),
                                invertAction: true,
                                classPopup: 'popup--redesign'
                            })];
                    case 1:
                        _a.sent();
                        this.item.Places = this.item.Places.filter(function (x) { return x.ID !== locationID; });
                        return [3 /*break*/, 3];
                    case 2:
                        error_8 = _a.sent();
                        console.log('remove place', error_8);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.removeProduct = function (productID) {
        return __awaiter(this, void 0, void 0, function () {
            var error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('delete'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('remove_product'),
                                content: this.$translate.instant('remove_product_from_menu'),
                                invertAction: true,
                                classPopup: 'popup--redesign'
                            })];
                    case 1:
                        _a.sent();
                        this.item.Products = this.item.Products.filter(function (x) { return x.ID !== productID; });
                        return [3 /*break*/, 3];
                    case 2:
                        error_9 = _a.sent();
                        console.log('remove product', error_9);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('discard'),
                                cancelClass: 'btn btn-with-background-icon icon-undo btn-danger',
                                title: this.$translate.instant('discard_changes_title'),
                                content: this.$translate.instant('discard_changes'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 1:
                        _a.sent();
                        this.$state.go('app.menus');
                        return [3 /*break*/, 3];
                    case 2:
                        error_10 = _a.sent();
                        console.log('cancel');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MenuEditorController.$inject = [
        '$localStorage',
        'notificationService',
        'popupService',
        'retailerService',
        'productsService',
        'menuService',
        'scheduleService',
        '$rootScope',
        '$scope',
        '$stateParams',
        '$uibModal',
        '$translate',
        '$state',
    ];
    return MenuEditorController;
}(viewport_typed_controller_1.ViewportController));
angular.module('naut').component('menu.editor', {
    template: __webpack_require__(782),
    controller: MenuEditorController,
    controllerAs: 'vm'
});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var MenuScheduleRenderController = /** @class */ (function () {
    function MenuScheduleRenderController($scope, $translate, scheduleService) {
        var _this = this;
        this.$translate = $translate;
        this.scheduleService = scheduleService;
        this.dateFormat = 'DD MMM YYYY';
        this.timeFormat = 'hh:mm A';
        this.rendered = '';
        $scope.$watch('vm.item', function (changes) {
            if (!changes) {
                _this.item = {
                    days: {
                        friday: false,
                        monday: false,
                        saturday: false,
                        sunday: false,
                        thursday: false,
                        tuesday: false,
                        wednesday: false
                    },
                    startDate: null,
                    endDate: null,
                    startTime: null,
                    endTime: null
                };
                _this.rendered = '';
                return;
            }
            var dates = _this.renderDate();
            var time = _this.renderTime();
            _this.rendered = "" + time + (time ? '<br />' : '') + dates;
        }, true);
    }
    MenuScheduleRenderController.prototype.renderTime = function () {
        var days = this.scheduleService.renderDaysOfWeek(this.scheduleService.packDaysOfWeek(this.item.days).toString());
        var startTime = moment(this.item.startTime);
        var endTime = moment(this.item.endTime);
        if (!startTime.isValid() && !endTime.isValid()) {
            return days ? (this.$translate.instant('active') + ' ' + days) : '';
        }
        return this.$translate.instant(endTime.isValid() ? 'active_on_between' : 'active_on_from', {
            days: days,
            start: startTime.format(this.timeFormat),
            end: endTime.format(this.timeFormat)
        });
    };
    MenuScheduleRenderController.prototype.renderDate = function () {
        var startDate = moment(this.item.startDate);
        var endDate = moment(this.item.endDate);
        if (startDate.isValid() && endDate.isValid()) {
            return this.$translate.instant('from_until', {
                start: startDate.format(this.dateFormat),
                end: endDate.format(this.dateFormat)
            });
        }
        if (startDate.isValid()) {
            return this.$translate.instant('from', {
                start: startDate.format(this.dateFormat)
            });
        }
        if (endDate.isValid()) {
            return this.$translate.instant('until', {
                end: endDate.format(this.dateFormat)
            });
        }
        return '';
    };
    MenuScheduleRenderController.$inject = ['$scope', '$translate', 'scheduleService'];
    return MenuScheduleRenderController;
}());
angular.module('naut').component('menuScheduleRender', {
    template: __webpack_require__(783),
    controller: MenuScheduleRenderController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var viewport_typed_controller_1 = __webpack_require__(4);
var MenusController = /** @class */ (function (_super) {
    __extends(MenusController, _super);
    function MenusController($rootScope, $localStorage, $scope, $stateParams, menuService, definitionsService, notificationService) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$rootScope = $rootScope;
        _this.$localStorage = $localStorage;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.menuService = menuService;
        _this.definitionsService = definitionsService;
        _this.notificationService = notificationService;
        _this.fakeMenu = [
            {
                data: {
                    ID: 0,
                    Name: 'Breakfast menu',
                    StartTime: '9',
                    EndTime: '12',
                    StartDate: new Date(2019, 8, 20),
                    EndDate: null,
                    DaysOfWeek: 62,
                    ImageID: null,
                    DisplayInApp: false,
                    CreateDateUTC: new Date(2019, 8, 20),
                    Places: [
                        {
                            ID: null,
                            Name: 'Honeyland Rivers',
                            Town: '...',
                            PostCode: '',
                            AddressLine1: '155 Victoria street',
                            AddressLine2: ''
                        }
                    ],
                    FoodPreferences: null,
                    Allergens: null
                },
                image: '/assets/images/fake_menu_2.jpg'
            },
            {
                data: {
                    ID: 0,
                    Name: 'Launch menu',
                    StartTime: '9',
                    EndTime: '3',
                    StartDate: new Date(2019, 8, 20),
                    EndDate: null,
                    DaysOfWeek: 126,
                    ImageID: null,
                    DisplayInApp: true,
                    CreateDateUTC: new Date(2019, 8, 20),
                    Places: [
                        {
                            ID: null,
                            Name: 'Honeyland Rivers',
                            Town: '...',
                            PostCode: '',
                            AddressLine1: '155 Victoria street',
                            AddressLine2: ''
                        }
                    ],
                    FoodPreferences: null,
                    Allergens: null
                },
                image: '/assets/images/fake_menu_1.jpg'
            }
        ];
        _this.businessTypes = _this.definitionsService.businessTypes;
        _this.isArchived = false;
        _this.waiting = false;
        _this.data = [];
        _this.isArchived = decodeURIComponent($stateParams.archived) === 'true';
        $scope.$watchGroup(['vm.isArchived'], function (n, o) {
            _this.getData();
        });
        $scope.$on('updateData', function () { return _this.getData(); });
        return _this;
    }
    MenusController.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.menuService.getMenus(this.isArchived)];
                    case 2:
                        _a.data = _b.sent();
                        this.notificationService.clearAll();
                        if (this.data.length === 0) {
                            this.notificationService.showInfoMessage(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MenusController.$inject = [
        '$rootScope',
        '$localStorage',
        '$scope',
        '$stateParams',
        'menuService',
        'definitionsService',
        'notificationService'
    ];
    return MenusController;
}(viewport_typed_controller_1.ViewportController));
angular.module('naut').component('menus', {
    template: __webpack_require__(784),
    controller: MenusController,
    controllerAs: 'vm'
});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var MenuService = /** @class */ (function () {
    function MenuService($rootScope, http, $q, retailerService) {
        this.$rootScope = $rootScope;
        this.http = http;
        this.$q = $q;
        this.retailerService = retailerService;
    }
    MenuService.prototype.getMenus = function (isArchived) {
        return this.http.get(this.retailerService.getMenus(isArchived));
    };
    MenuService.prototype.getMenu = function (ID) {
        return this.http.get(this.retailerService.getMenu(ID));
    };
    MenuService.prototype.saveMenuImageUrl = function () {
        return this.retailerService.createMenuImage();
    };
    MenuService.prototype.getMenuImageUrl = function (imageId, width, height) {
        return this.retailerService.getMenuImage(imageId, width, height);
    };
    MenuService.prototype.saveMenu = function (item) {
        if (item.ID == null) {
            return this.http.post(this.retailerService.createMenu(), item);
        }
        else {
            return this.http.put(this.retailerService.getMenu(item.ID.toString()), item);
        }
    };
    MenuService.prototype.setEnabledMenu = function (ID, value) {
        return this.http.post(this.retailerService.setEnabledMenu(ID, value), {});
    };
    MenuService.prototype.setArchivedMenu = function (ID, value) {
        return this.http.post(this.retailerService.setArchivedMenu(ID, value), {});
    };
    MenuService.$inject = [
        '$rootScope',
        'http',
        '$q',
        'retailerService'
    ];
    return MenuService;
}());
exports.MenuService = MenuService;
angular.module('naut').service('menuService', MenuService);


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var ScheduleService = /** @class */ (function () {
    function ScheduleService($translate) {
        this.$translate = $translate;
    }
    ScheduleService.prototype.packDaysOfWeek = function (days) {
        var value = 0;
        var keys = Object.keys(days);
        for (var i = 0; i < keys.length; i++) {
            if (days[keys[i]]) {
                value += Math.pow(2, i);
            }
        }
        return value;
    };
    ScheduleService.prototype.unpackDaysOfWeek = function (days) {
        return parseInt(days, 10)
            .toString(2)
            .split('')
            .reverse()
            .map(function (x) { return x === '1'; });
    };
    ScheduleService.prototype.renderDaysOfWeek = function (days, isShort) {
        if (isShort === void 0) { isShort = false; }
        var bits = this.unpackDaysOfWeek(days);
        var translate = [
            'sunday',
            'monday ',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday'
        ];
        if (!bits.some(function (x) { return !x; }) && bits.length === 7) {
            return this.$translate.instant('all_week');
        }
        var result = '';
        var isSkipping = false;
        for (var i = 0; i < bits.length; i++) {
            var bit = bits[i];
            var haveSkip = !!bits[i - 1] && bit && !!bits[i + 1];
            if (haveSkip) {
                result += isSkipping ? '' : ' - ';
                isSkipping = true;
                continue;
            }
            if (bit) {
                if (result !== '' && !isSkipping) {
                    result += ', ';
                }
                result += this.$translate.instant(translate[i] + (isShort ? '_short' : ''));
            }
            else {
                isSkipping = false;
            }
        }
        return result;
    };
    ScheduleService.prototype.renderActiveDates = function (startDate, endDate, format) {
        if (format === void 0) { format = 'DD MMM YYYY'; }
        if (startDate !== null && endDate !== null) {
            if (moment(startDate).date() === moment(endDate).date()) {
                if (moment(startDate).date() === moment().date()) {
                    return this.$translate.instant('run_today');
                }
                return this.$translate.instant('run_only', {
                    date: moment(startDate).format(format)
                });
            }
            return this.$translate.instant('run_from_to', {
                start: moment(startDate).format(format),
                end: moment(endDate).format(format)
            });
        }
        if (startDate !== null) {
            return this.$translate.instant('run_from', {
                date: moment(startDate).format(format)
            });
        }
        return '';
    };
    ScheduleService.prototype.getFromMenuItem = function (item) {
        var unpackedDays = this.unpackDaysOfWeek(item.DaysOfWeek.toString());
        return {
            days: {
                sunday: !!unpackedDays[0],
                monday: !!unpackedDays[1],
                tuesday: !!unpackedDays[2],
                wednesday: !!unpackedDays[3],
                thursday: !!unpackedDays[4],
                friday: !!unpackedDays[5],
                saturday: !!unpackedDays[6]
            },
            anyDays: function () {
                return this.days.sunday || this.days.monday || this.days.tuesday || this.days.wednesday ||
                    this.days.thursday || this.days.friday || this.days.saturday;
            },
            setDays: function (value) {
                for (var p in this.days) {
                    if (this.days.hasOwnProperty(p)) {
                        this.days[p] = value;
                    }
                }
            },
            startDate: item.StartDate == null ? null : moment(item.StartDate).toDate(),
            endDate: item.EndDate == null ? null : moment(item.EndDate).toDate(),
            startTime: item.StartTime == null
                ? null
                : moment(item.StartTime, 'HH:mm:ss').toDate(),
            endTime: item.EndTime == null
                ? null
                : moment(item.EndTime, 'HH:mm:ss').toDate()
        };
    };
    ScheduleService.prototype.updateMenuItemSchedule = function (schedule, item) {
        item.StartDate = schedule.startDate;
        item.EndDate = schedule.endDate;
        item.StartTime = moment(schedule.startTime).isValid()
            ? moment(schedule.startTime).format('HH:mm')
            : null;
        item.EndTime = moment(schedule.endTime).isValid()
            ? moment(schedule.endTime).format('HH:mm')
            : null;
        item.DaysOfWeek = this.packDaysOfWeek(schedule.days);
    };
    ScheduleService.$inject = ['$translate'];
    return ScheduleService;
}());
exports.ScheduleService = ScheduleService;
angular.module('naut').service('scheduleService', ScheduleService);


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var ActiveStickersFilter = /** @class */ (function () {
    function ActiveStickersFilter($scope, $translate, $uibModal, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.model = {
            selectedLocations: [],
            selectedLocationsCount: 0,
            isAllLocationsSelected: false,
            stickerType: null,
            dateFrom: null,
            dateTo: null
        };
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        this.stickerTypes = {
            0: this.$translate.instant('sticker_type_all'),
            1: this.$translate.instant('sticker_type_product'),
            2: this.$translate.instant('sticker_type_information_card'),
            3: this.$translate.instant('sticker_type_offer'),
            4: this.$translate.instant('sticker_type_checkin') + '/' + this.$translate.instant('sticker_type_checkout')
        };
        this.dateFromChange = function () {
            if (moment(_this.model.dateFrom).isSameOrAfter(_this.model.dateTo, 'day')) {
                _this.model.dateTo = moment(_this.model.dateTo).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateTo).startOf('day').toDate();
            }
        };
        this.dateToChange = function () {
            if (moment(_this.model.dateTo).isSameOrBefore(_this.model.dateFrom, 'day')) {
                _this.model.dateTo = moment(_this.model.dateFrom).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateFrom).startOf('day').toDate();
            }
        };
        this.onFilterApply = function () {
            _this.onApply({ filter: _this.model });
        };
        this.selectLocations = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'selectLocations',
                            resolve: { options: function () {
                                    return {
                                        selectedLocations: _this.model.selectedLocations,
                                        isAllSelected: _this.model.isAllLocationsSelected
                                    };
                                } },
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult.status === 'ok') {
                            if (operationResult.isAllSelected) {
                                this.model.isAllLocationsSelected = true;
                                this.nfcRetailerStickersService.getAllLocations()
                                    .then(function (locations) {
                                    _this.model.selectedLocationsCount = locations.length;
                                    return _this.model.selectedLocations = locations;
                                })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
                            }
                            else {
                                this.model.isAllLocationsSelected = false;
                                this.model.selectedLocations = operationResult.selectedLocations;
                                this.model.selectedLocationsCount = this.model.selectedLocations.length;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    ActiveStickersFilter.prototype.$onChanges = function (onChangesObj) {
        if (onChangesObj
            && onChangesObj.filterModel.currentValue) {
            this.model.selectedLocations = onChangesObj.filterModel.currentValue.selectedLocations;
            this.model.selectedLocationsCount = onChangesObj.filterModel.currentValue.selectedLocations.length;
            this.model.dateFrom = onChangesObj.filterModel.currentValue.dateFrom;
            this.model.dateTo = onChangesObj.filterModel.currentValue.dateTo;
            this.model.stickerType = onChangesObj.filterModel.currentValue.type;
        }
    };
    ActiveStickersFilter.$inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService'];
    return ActiveStickersFilter;
}());
angular.module('naut').component('activeStickersFilter', {
    template: __webpack_require__(785),
    controller: ActiveStickersFilter,
    controllerAs: 'ctrl',
    bindings: {
        filterModel: '<',
        onApply: '&',
        onAllClear: '&'
    }
});


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var _ = __webpack_require__(1);
var NfcRetailerActiveTab = /** @class */ (function () {
    function NfcRetailerActiveTab($scope, $translate, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.items = [];
        this.search = {
            text: ''
        };
        this.filter = {
            isActive: false,
            isApplied: false,
            data: {
                selectedLocations: [],
                type: null,
                dateFrom: null,
                dateTo: null
            },
            clear: function () {
                _this.filter.isApplied = false;
                _this.filter.data = {
                    selectedLocations: [],
                    type: null,
                    dateFrom: null,
                    dateTo: null
                };
            },
            toggle: function () {
                _this.filter.isActive = !_this.filter.isActive;
                if (!_this.filter.isActive) {
                    _this.clearFilter();
                }
            },
            set: function (newFilterSettings) {
                _this.filter.isApplied = true;
                _this.filter.data = {
                    selectedLocations: newFilterSettings.selectedLocations,
                    type: newFilterSettings.stickerType,
                    dateFrom: newFilterSettings.dateFrom,
                    dateTo: newFilterSettings.dateTo
                };
            }
        };
        this.itemsLimit = 20;
        this.freeStickersCount = 0;
        this.canLoadMore = true;
        this.stickerTypes = {
            1: this.$translate.instant('sticker_type_product'),
            2: this.$translate.instant('sticker_type_information_card'),
            3: this.$translate.instant('sticker_type_offer'),
            4: this.$translate.instant('sticker_type_checkout'),
            5: this.$translate.instant('sticker_type_checkin')
        };
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
        this.applySearch = function () {
            if (!_this.validateFilter()) {
                return;
            }
            _this.canLoadMore = true;
            _this.items = [];
            _this.total = 0;
            _this.loadData();
        };
        this.toggleFilter = function () {
            _this.filter.toggle();
        };
        this.applyFilter = function (newFilterSetting) {
            newFilterSetting.stickerType = +newFilterSetting.stickerType;
            _this.filter.set(newFilterSetting);
            _this.applySearch();
        };
        this.clearFilter = function () {
            if (_this.filter.isApplied) {
                _this.filter.clear();
                _this.applySearch();
            }
            else {
                _this.filter.clear();
            }
        };
        this.loadData = function () {
            if (_this.waiting || !_this.canLoadMore) {
                return;
            }
            _this.waiting = true;
            var lastItem = _.last(_this.items);
            var lastStickerNumber = lastItem ? lastItem.ID : undefined;
            var filter = {
                SearchAfterStickerID: lastStickerNumber,
                SearchTerm: _this.search.text,
                Limit: _this.itemsLimit
            };
            if (_this.filter.isActive) {
                filter.NfcStickerType = _this.filter.data.type === 0 ? null : _this.filter.data.type;
                filter.PlaceIDs = _this.filter.data.selectedLocations.map(function (x) { return x.ID; });
                filter.DateFrom = _this.filter.data.dateFrom ? moment(_this.filter.data.dateFrom).startOf('day').toDate() : null;
                filter.DateTo = _this.filter.data.dateTo ? moment(_this.filter.data.dateTo).endOf('day').toDate() : null;
            }
            _this.notificationService.showWaitingMessage();
            _this.nfcRetailerStickersService.getFreeStickersCount()
                .then(function (response) {
                _this.freeStickersCount = response;
            })["catch"](function (error) {
                _this.notificationService.showErrorMessage(error);
            });
            return _this.nfcRetailerStickersService.getActiveStickers(filter)
                .then(function (response) {
                _this.total = response.Total;
                Array.prototype.push.apply(_this.items, response.Items);
                if (_this.items.length === 0) {
                    _this.setEmptyMessage(filter);
                }
                _this.canLoadMore = response.Items.length === _this.itemsLimit;
            })["catch"](function (error) {
                _this.notificationService.showErrorMessage(error);
            })["finally"](function () {
                _this.waiting = false;
                _this.notificationService.clearAll();
            });
        };
        this.setEmptyMessage = function (filter) {
            _this.emptyStickerMessageTitle = _this.$translate.instant('nfc_active_tab_empty_such_stickers_message_title');
            _this.emptyStickerMessage = _this.$translate.instant('nfc_active_tab_empty_such_stickers_message');
        };
    }
    NfcRetailerActiveTab.prototype.$onInit = function () {
        var _this = this;
        this.loadData();
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    NfcRetailerActiveTab.prototype.validateFilter = function () {
        var dateFrom = this.filter.data.dateFrom;
        var dateTo = this.filter.data.dateTo;
        if (!dateFrom && !dateTo) {
            return true;
        }
        if (!dateFrom) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_from_is_requierd_error'));
            return false;
        }
        if (!dateTo) {
            this.notificationService.showErrorMessage(this.$translate.instant('date_to_is_required_error'));
            return false;
        }
        var datesDiff = moment(dateTo).diff(dateFrom, 'seconds');
        if (datesDiff < 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('invalid_date_range_error'));
            return false;
        }
        return true;
    };
    NfcRetailerActiveTab.$inject = ['$scope', '$translate', 'nfcRetailerStickersService', 'notificationService'];
    return NfcRetailerActiveTab;
}());
angular.module('naut').component('nfcRetailerActiveTab', {
    template: __webpack_require__(786),
    controller: NfcRetailerActiveTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var AddDeletedSticker = /** @class */ (function () {
    function AddDeletedSticker($scope, $translate, $timeout, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.modalInstance = this;
        this.$onInit = function () {
            _this.stickerNumber = '';
        };
        this.close = function () {
            _this.modalInstance.close({ $value: 'close' });
        };
        this["delete"] = function () {
            var modelIsValid = _this.validateStickerNumberFormat(_this.stickerNumber);
            if (!modelIsValid) {
                var stickerIDModel_1 = _this.form.stickerID;
                stickerIDModel_1.$setValidity('stickerID', modelIsValid);
                _this.$timeout(function () { return stickerIDModel_1.$setValidity('stickerID', true); }, 2000);
                return;
            }
            var request = { StickerNumber: _this.stickerNumber };
            _this.waiting = true;
            return _this.nfcRetailerStickersService.deleteSticker(request)
                .then(function (response) {
                _this.modalInstance.close({ $value: 'ok' });
            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
                _this.waiting = false;
                _this.notificationService.clearAll();
            });
        };
    }
    AddDeletedSticker.prototype.validateStickerNumberFormat = function (modelValue) {
        var pattern = /[A-Z]{1}\d{12}$/;
        return pattern.test(modelValue);
    };
    AddDeletedSticker.$inject = ['$scope', '$translate', '$timeout', 'nfcRetailerStickersService', 'notificationService'];
    return AddDeletedSticker;
}());
angular.module('naut').component('addDeletedSticker', {
    template: __webpack_require__(787),
    controller: AddDeletedSticker,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var NfcRetailerDeletedTab = /** @class */ (function () {
    function NfcRetailerDeletedTab($scope, $translate, $uibModal, nfcRetailerStickersService, notificationService, popupService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.items = [];
        this.itemsLimit = 20;
        this.canLoadMore = true;
        this.noDeletedStickersMessage = this.$translate.instant('nfc_deleted_tab_empty_stickers_message');
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
        this.addDeletedSticker = function () { return __awaiter(_this, void 0, void 0, function () {
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'addDeletedSticker',
                            resolve: {},
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult === 'ok') {
                            this.applyFilter();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.restoreSticker = function (sticker) { return __awaiter(_this, void 0, void 0, function () {
            var e_1, requestToRestore, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okClass: 'btn btn-with-icon btn-with-icon--before-close color-black54 bg-dark12',
                                okTxt: this.$translate.instant('restore_deleted_sticker_dialog_cancel'),
                                cancelClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                                cancelTxt: this.$translate.instant('restore_deleted_sticker_dialog_ok'),
                                classPopup: 'alert--redesign modal360',
                                title: this.$translate.instant('restore_deleted_sticker_dialog_title'),
                                content: this.$translate.instant('restore_deleted_sticker_dialog_content'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        _a.trys.push([3, 5, 6, 7]);
                        requestToRestore = { StickerNumber: sticker.ID };
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.nfcRetailerStickersService.restoreSticker(requestToRestore)];
                    case 4:
                        _a.sent();
                        this.items.splice(this.items.indexOf(sticker), 1);
                        this.total -= 1;
                        return [3 /*break*/, 7];
                    case 5:
                        e_2 = _a.sent();
                        this.notificationService.showErrorMessage(e_2);
                        return [3 /*break*/, 7];
                    case 6:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this.applyFilter = function () {
            _this.canLoadMore = true;
            _this.items = [];
            _this.total = 0;
            _this.loadData();
        };
        this.loadData = function () {
            if (_this.waiting || !_this.canLoadMore) {
                return;
            }
            _this.waiting = true;
            var lastItem = _.last(_this.items);
            var lastStickerNumber = lastItem ? lastItem.ID : undefined;
            var filter = {
                SearchAfterStickerID: lastStickerNumber,
                SearchTerm: _this.filter,
                Limit: _this.itemsLimit
            };
            _this.notificationService.showWaitingMessage();
            return _this.nfcRetailerStickersService.getDeletedStickers(filter)
                .then(function (response) {
                _this.total = response.Total;
                Array.prototype.push.apply(_this.items, response.Items);
                _this.canLoadMore = response.Items.length === _this.itemsLimit;
            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
                _this.waiting = false;
                _this.notificationService.clearAll();
            });
        };
    }
    NfcRetailerDeletedTab.prototype.$onInit = function () {
        var _this = this;
        this.filter = '';
        this.loadData();
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    NfcRetailerDeletedTab.$inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService', 'popupService'];
    return NfcRetailerDeletedTab;
}());
angular.module('naut').component('nfcRetailerDeletedTab', {
    template: __webpack_require__(788),
    controller: NfcRetailerDeletedTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var NfcExport = /** @class */ (function () {
    function NfcExport($rootScope, $state, $scope, $translate, $uibModal, categoriesSelectorService, classificationCategoriesService, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.categoriesSelectorService = categoriesSelectorService;
        this.classificationCategoriesService = classificationCategoriesService;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.modalInstance = this;
        this.isCategoryButtonDisabled = true;
        this.nfcStickerOptions = [
            { ID: 0, Title: this.$translate.instant('sticker_type_all') },
            { ID: 1, Title: this.$translate.instant('sticker_type_product') },
            { ID: 2, Title: this.$translate.instant('sticker_type_information_card') },
            { ID: 3, Title: this.$translate.instant('sticker_type_offer') },
            { ID: 4, Title: this.$translate.instant('sticker_type_checkin') + '/' + this.$translate.instant('sticker_type_checkout') }
        ];
        this.model = {
            dateFrom: new Date(new Date().getFullYear(), 0, 1),
            dateTo: new Date(),
            stickerType: null,
            selectedCategories: [],
            isAllCategoriesSelected: false,
            groupByLocations: false
        };
        this.dateFromOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        this.dateToOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: this.model.dateFrom
        };
        this.dateFromChange = function () {
            if (moment(_this.model.dateFrom).isSameOrAfter(_this.model.dateTo, 'day')) {
                _this.model.dateTo = moment(_this.model.dateTo).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateTo).startOf('day').toDate();
            }
        };
        this.dateToChange = function () {
            if (moment(_this.model.dateTo).isSameOrBefore(_this.model.dateFrom, 'day')) {
                _this.model.dateTo = moment(_this.model.dateFrom).endOf('day').toDate();
                _this.model.dateFrom = moment(_this.model.dateFrom).startOf('day').toDate();
            }
        };
        this.close = function () {
            _this.modalInstance.close();
        };
        this.confirm = function () {
            var categoriesIds = _this.model.selectedCategories.map(function (x) { return x.CategoryID; });
            var request = {
                AssignFrom: _this.model.dateFrom,
                AssignTo: _this.model.dateTo,
                Type: _this.model.stickerType && _this.model.stickerType.ID !== 0 ? _this.model.stickerType.ID : undefined,
                CategoryIDs: _this.model.stickerType && _this.model.stickerType.ID === 1 ? categoriesIds : [],
                GroupByStores: _this.model.groupByLocations
            };
            _this.nfcRetailerStickersService.exportCSV(request)
                .then(function (response) {
                _this.notificationService.showSuccessMessage(response);
                _this.$state.go('app.nfcs.history', {}, { reload: true });
                _this.modalInstance.close();
            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
        };
        this.selectCategory = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectProductCategory',
                                resolve: {
                                    options: function () {
                                        return {
                                            singleSelect: false,
                                            selectedCategories: _this.model.selectedCategories,
                                            businessType: _this.$rootScope.enums.BusinessType.All,
                                            isOnlyStoreCategories: false,
                                            needAllSelect: true,
                                            isAllSelected: _this.model.isAllCategoriesSelected,
                                            getCategoriesTree: function () { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, this.nfcRetailerStickersService.getClassificationCategoriesForRetailer()];
                                                        case 1: return [2 /*return*/, _a.sent()];
                                                    }
                                                });
                                            }); }
                                        };
                                    }
                                },
                                size: 'lg'
                            }).result];
                    case 1:
                        operationResult = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        if (operationResult.status === 'ok') {
                            if (operationResult.isAllSelected) {
                                this.model.isAllCategoriesSelected = true;
                            }
                            else {
                                this.model.isAllCategoriesSelected = false;
                                this.model.selectedCategories = operationResult.selectedCategories;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        $scope.$watch('ctrl.model.stickerType', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.isCategoryButtonDisabled = _this.model.stickerType && _this.model.stickerType.ID !== 1;
            }
        });
    }
    NfcExport.$inject = ['$rootScope', '$state', '$scope', '$translate', '$uibModal', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService'];
    return NfcExport;
}());
angular.module('naut').component('nfcExport', {
    template: __webpack_require__(789),
    controller: NfcExport,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var NfcHistoryExportItem = /** @class */ (function () {
    function NfcHistoryExportItem() {
    }
    return NfcHistoryExportItem;
}());
angular.module('naut').component('nfcHistoryExportItem', {
    template: __webpack_require__(790),
    controller: NfcHistoryExportItem,
    controllerAs: 'ctrl',
    bindings: {
        'operationId': '<',
        'status': '<',
        'items': '<',
        'date': '<',
        'exportResult': '<'
    }
});


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var NfcHistoryItem = /** @class */ (function () {
    function NfcHistoryItem($translate) {
        this.$translate = $translate;
    }
    NfcHistoryItem.$inject = ['$translate'];
    return NfcHistoryItem;
}());
angular.module('naut').component('nfcHistoryItem', {
    template: __webpack_require__(791),
    controller: NfcHistoryItem,
    controllerAs: 'ctrl',
    bindings: {
        'status': '<',
        'stores': '<',
        'items': '<',
        'assigned': '<',
        'date': '<'
    }
});


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var NfcRetailerHistoryTab = /** @class */ (function () {
    function NfcRetailerHistoryTab($scope, $translate, nfcRetailerStickersService, notificationService, retailerUrl) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.retailerUrl = retailerUrl;
        this.filter = {
            from: new Date(new Date().getFullYear(), 0, 1),
            to: new Date()
        };
        this.items = [];
        this.noHistoryItemsMessage = this.$translate.instant('nfc_history_tab_empty_list_message');
        this.dateFromOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        this.dateToOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: this.filter.from
        };
        this.viewport = {
            width: $(window).width(),
            height: $(window).height(),
            scrollTop: 0
        };
        this.dateChange = function () {
            if (_this.filter.from != null && _this.filter.to != null) {
                _this.loadData();
            }
        };
        this.dateFromChange = function () {
            if (moment(_this.filter.from).isSameOrAfter(_this.filter.to, 'day')) {
                _this.filter.to = moment(_this.filter.to).endOf('day').toDate();
                _this.filter.from = moment(_this.filter.to).startOf('day').toDate();
            }
            _this.loadData();
        };
        this.dateToChange = function () {
            if (moment(_this.filter.to).isSameOrBefore(_this.filter.from, 'day')) {
                _this.filter.to = moment(_this.filter.from).endOf('day').toDate();
                _this.filter.from = moment(_this.filter.from).startOf('day').toDate();
            }
            _this.loadData();
        };
        this.loadData = function () {
            if (_this.waiting) {
                return;
            }
            _this.waiting = true;
            var filter = {
                From: _this.filter.from,
                To: _this.filter.to
            };
            _this.notificationService.showWaitingMessage();
            _this.nfcRetailerStickersService.getOperations(filter)
                .then(function (response) {
                _this.total = response.Total;
                _this.items = response.Items;
                angular.forEach(_this.items, function (historyItem) {
                    if (historyItem.ExportResult && historyItem.ExportResult.length) {
                        angular.forEach(historyItem.ExportResult, function (exportResult) {
                            exportResult.Url = _this.retailerUrl + "nfcStickers/results/csv/" + historyItem.ID + "/" + exportResult.PlaceID;
                        });
                    }
                });
            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
                _this.waiting = false;
                _this.notificationService.clearAll();
            });
        };
        this.waiting = false;
    }
    NfcRetailerHistoryTab.prototype.$onInit = function () {
        var _this = this;
        this.loadData();
        $(window).resize(function () {
            _this.viewport.width = $(window).width();
            _this.viewport.height = $(window).height();
            _this.$scope.$apply();
        });
        $(window).scroll(function () {
            _this.viewport.scrollTop = $(document).scrollTop();
            _this.$scope.$apply();
        });
    };
    NfcRetailerHistoryTab.$inject = ['$scope', '$translate', 'nfcRetailerStickersService', 'notificationService', 'retailerServiceUrl'];
    return NfcRetailerHistoryTab;
}());
angular.module('naut').component('nfcRetailerHistoryTab', {
    template: __webpack_require__(792),
    controller: NfcRetailerHistoryTab,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var NfcRetailerStickersService = /** @class */ (function () {
    function NfcRetailerStickersService(http, retailerService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.checkCanEditStickers = function () {
            return _this.http.get(_this.retailerService.checkCanEditStickers());
        };
        this.getActiveStickers = function (query) {
            return _this.http.get(_this.retailerService.activeStickers(), { params: query });
        };
        this.getDeletedStickers = function (query) {
            return _this.http.get(_this.retailerService.deletedStickers(), { params: query });
        };
        this.deleteSticker = function (query) {
            return _this.http["delete"](_this.retailerService.deleteSticker(), { params: query });
        };
        this.restoreSticker = function (query) {
            return _this.http.post(_this.retailerService.restoreSticker(), null, { params: query });
        };
        this.getFreeStickersCount = function () {
            return _this.http.get(_this.retailerService.freeStickersCount());
        };
        this.getOperations = function (query) {
            return _this.http.get(_this.retailerService.getOperations(), { params: query });
        };
        this.createOperation = function (query) {
            return _this.http.post(_this.retailerService.createOperation(), query);
        };
        this.validateProductsAndCategories = function (productIDs, categoryIDs) {
            var request = {
                productIDs: productIDs,
                categoryIDs: categoryIDs
            };
            return _this.http.get(_this.retailerService.validateProductsAndCategories(), { params: request });
        };
        this.validateLocations = function (placesIDs) {
            return _this.http.get(_this.retailerService.validatePlaces(), { params: placesIDs });
        };
        this.getLocations = function (settings) {
            return _this.http.get(_this.retailerService.findStores(), { params: settings });
        };
        this.getAllLocations = function () {
            return _this.http.get(_this.retailerService.fetchAllPlaces());
        };
        this.getAllProducts = function () {
            return _this.http.get(_this.retailerService.fetchAllProducts());
        };
        this.getClassificationCategoriesForRetailer = function () {
            return _this.http.get(_this.retailerService.classificationCategoriesForRetailer());
        };
        this.exportCSV = function (query) {
            return _this.http.post(_this.retailerService.exportCSV(), query);
        };
    }
    NfcRetailerStickersService.prototype.checkStickersAvailable = function (stickerNumberList, entityID) {
        return this.http.post(this.retailerService.checkStickersAvailable(), { stickerNumberList: stickerNumberList, entityID: entityID });
    };
    NfcRetailerStickersService.prototype.getProducts = function (filter) {
        return this.http.get(this.retailerService.findProducts(), { params: filter });
    };
    NfcRetailerStickersService.$inject = ['http', 'retailerService'];
    return NfcRetailerStickersService;
}());
exports.NfcRetailerStickersService = NfcRetailerStickersService;
angular
    .module('naut')
    .service('nfcRetailerStickersService', NfcRetailerStickersService);


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var Chips = /** @class */ (function () {
    function Chips() {
    }
    return Chips;
}());
angular.module('naut').component('chips', {
    template: __webpack_require__(793),
    controller: Chips,
    controllerAs: 'ctrl',
    bindings: {
        onClick: '&',
        items: '=',
        displayField: '<',
        isDisabled: '<'
    }
});


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SelectLocations = /** @class */ (function () {
    function SelectLocations($translate, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$translate = $translate;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.modalInstance = this;
        this.model = {
            addButtonText: 'Add',
            locations: [],
            searchTerm: null,
            waiting: true,
            isAllSelected: false,
            noLocationMessage: this.$translate.instant('nfc_select_location_empty_list_message')
        };
        this.total = 0;
        this.canSelectAll = true;
        this.getSelectedLocations = function () { return _this.model.locations.filter(function (location) { return location.IsSelected; }); };
        this.dismiss = function () { return _this.modalInstance.close({ $value: { status: 'close' } }); };
    }
    SelectLocations.prototype.$onInit = function () {
        var _this = this;
        this.loadLocations()
            .then(function () { return _this.canSelectAll = _this.total > 0; });
    };
    SelectLocations.prototype.searchKeyPressed = function ($event) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search(this.model.searchTerm);
        }
    };
    SelectLocations.prototype.confirm = function () {
        var selectionResult = {
            status: 'ok',
            isAllSelected: false,
            selectedLocations: []
        };
        if (this.model.isAllSelected) {
            selectionResult.selectedLocations = this.model.locations;
            selectionResult.isAllSelected = true;
            this.modalInstance.close({ $value: selectionResult });
            return;
        }
        selectionResult.selectedLocations = this.getSelectedLocations();
        this.modalInstance.close({ $value: selectionResult });
    };
    SelectLocations.prototype.search = function (text) {
        this.total = 0;
        this.model.locations = [];
        this.model.searchTerm = text;
        this.loadLocations();
    };
    SelectLocations.prototype.resetSearch = function () {
        this.model.searchTerm = '';
        this.search(this.model.searchTerm);
    };
    SelectLocations.prototype.loadLocations = function () {
        var _this = this;
        var selectedLocations = this.resolve.options.selectedLocations;
        if (this.total && this.model.locations.length === this.total) {
            return;
        }
        var filter = {
            SearchTerm: this.model.searchTerm,
            Limit: 20,
            SearchAfterName: this.model.locations.length ? _.last(this.model.locations).Name : null
        };
        this.model.waiting = true;
        this.notificationService.showWaitingMessage();
        return this.nfcRetailerStickersService.getLocations(filter)
            .then(function (response) {
            _this.total = response.Total;
            var locations = response.Items;
            locations.forEach(function (location) {
                var foundLocation = _.find(selectedLocations, { ID: location.ID });
                location.IsSelected = !!foundLocation;
            });
            Array.prototype.push.apply(_this.model.locations, locations);
            _this.model.waiting = false;
            _this.model.isAllSelected = _this.resolve.options.isAllSelected;
            if (_this.model.locations.length) {
                return;
            }
            _this.model.noLocationMessage = _this.model.searchTerm && _this.model.searchTerm.length
                ? _this.$translate.instant('location_was_not_found', { search: _this.model.searchTerm })
                : _this.$translate.instant('nfc_select_location_empty_list_message');
        })["catch"](function (e) { return _this.notificationService.showErrorMessage(e); })["finally"](function () { return _this.notificationService.clearAll(); });
    };
    SelectLocations.prototype.setAddButtonText = function () {
        var addbtn = this.$translate.instant('button_add');
        if (this.model.isAllSelected) {
            this.model.addButtonText = addbtn + ' (' + this.$translate.instant('all') + ')';
        }
        else {
            var selectedLocationCount = this.getSelectedLocations().length;
            this.model.addButtonText = selectedLocationCount > 0 ? addbtn + ' (' + selectedLocationCount + ')' : addbtn;
        }
    };
    SelectLocations.$inject = ['$translate', 'nfcRetailerStickersService', 'notificationService'];
    return SelectLocations;
}());
angular.module('naut').component('selectLocations', {
    template: __webpack_require__(794),
    controller: SelectLocations,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var SelectProductCategory = /** @class */ (function () {
    function SelectProductCategory(popupService, $translate) {
        var _this = this;
        this.popupService = popupService;
        this.$translate = $translate;
        this.modalInstance = this;
        this.isAllSelected = false;
        this.needAllSelect = false;
        this.deleteChips = function (item) {
            _this.resolve.options.selectedCategories = _this.resolve.options.selectedCategories.filter(function (x) { return x.CategoryID !== item.CategoryID; });
        };
        this.select = function () { return __awaiter(_this, void 0, void 0, function () {
            var selectionResult;
            return __generator(this, function (_a) {
                selectionResult = {
                    status: 'ok',
                    isAllSelected: false,
                    selectedCategories: []
                };
                if (this.isAllSelected) {
                    selectionResult.isAllSelected = true;
                    this.modalInstance.close({ $value: selectionResult });
                }
                else {
                    selectionResult.selectedCategories = this.resolve.options.selectedCategories;
                }
                this.modalInstance.close({ $value: selectionResult });
                return [2 /*return*/];
            });
        }); };
        this.discard = function () {
            _this.modalInstance.dismiss({ $value: { status: 'cancel' } });
        };
    }
    SelectProductCategory.prototype.$onChanges = function (changes) {
        if (changes.resolve) {
            this.startSelectedCategories = this.resolve.options.selectedCategories;
            this.isAllSelected = this.resolve.options.isAllSelected;
            this.needAllSelect = this.resolve.options.needAllSelect;
        }
    };
    SelectProductCategory.prototype.changeClassificationCategory = function (item) {
        if (!item.selected) {
            this.resolve.options.selectedCategories = this.resolve.options.selectedCategories.filter(function (x) { return x.CategoryID !== item.ID; });
        }
    };
    SelectProductCategory.$inject = ['popupService', '$translate'];
    return SelectProductCategory;
}());
angular.module('app.retailes.common').component('selectProductCategory', {
    template: __webpack_require__(795),
    controller: SelectProductCategory,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var classification_categories_base_component_1 = __webpack_require__(7);
var SelectProductClassificationCategories = /** @class */ (function (_super) {
    __extends(SelectProductClassificationCategories, _super);
    function SelectProductClassificationCategories(classificationCategoriesService, popupService, $timeout, enumService) {
        return _super.call(this, classificationCategoriesService, popupService, $timeout, enumService) || this;
    }
    SelectProductClassificationCategories.prototype.getCategoriesTree = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.classificationCategoriesService.getTree(this.languageId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SelectProductClassificationCategories.$inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    return SelectProductClassificationCategories;
}(classification_categories_base_component_1.ClassificationCategoriesBase));
angular
    .module('app.retailes.common')
    .component('selectProductClassificationCategories', {
    template: __webpack_require__(796),
    controller: SelectProductClassificationCategories,
    controllerAs: 'vm',
    bindings: {
        selectedCategories: '<',
        businessType: '<',
        singleSelect: '<',
        waiting: '<',
        errors: '=',
        externalConfirm: '@',
        changeCategory: '&',
        hideTitles: '<',
        isDisabled: '<',
        languageId: '<'
    }
});


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SelectProducts = /** @class */ (function () {
    function SelectProducts($translate, productService, notificationService) {
        var _this = this;
        this.$translate = $translate;
        this.productService = productService;
        this.notificationService = notificationService;
        this.total = 0;
        this.selectedProducts = {};
        this.modalInstance = this;
        this.model = {
            addButtonText: 'Add',
            products: [],
            searchTerm: null,
            waiting: true,
            isAllSelected: false,
            noProductMessage: this.$translate.instant('nfc_select_product_empty_list_message')
        };
        this.dismiss = function () { return _this.modalInstance.close({ $value: { status: 'close' } }); };
    }
    SelectProducts.prototype.$onInit = function () {
        var _this = this;
        angular.forEach(this.resolve.options.selectedProducts, function (product) { return _this.selectedProducts[product.ID] = product; });
        this.model.isAllSelected = this.resolve.options.isAllSelected;
        this.loadProducts();
    };
    SelectProducts.prototype.searchKeyPressed = function ($event) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search();
        }
    };
    SelectProducts.prototype.loadProducts = function () {
        var _this = this;
        if (this.total && this.model.products.length === this.total) {
            return;
        }
        var filter = {
            searchTerm: this.model.searchTerm,
            limit: 10,
            searchAfterId: this.model.products.length ? _.last(this.model.products).ID : null
        };
        this.productService.fetchProducts(filter)
            .then(function (productsResponse) {
            _this.total = productsResponse.Total;
            var products = productsResponse.Items;
            products.forEach(function (product) {
                product.ImageUrl = _this.productService.getImageUrl(product.ImageID, 60);
                product.IsSelected = !!_this.selectedProducts[product.ID] || _this.model.isAllSelected;
            });
            Array.prototype.push.apply(_this.model.products, products);
            _this.model.waiting = false;
            if (_this.model.products.length) {
                return;
            }
            _this.model.noProductMessage = _this.model.searchTerm && _this.model.searchTerm.length
                ? _this.$translate.instant('product_was_not_found')
                : _this.$translate.instant('nfc_select_product_empty_list_message');
        })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
    };
    SelectProducts.prototype.search = function () {
        this.total = 0;
        this.model.products = [];
        this.loadProducts();
    };
    SelectProducts.prototype.selectProduct = function (product) {
        product.IsSelected = !product.IsSelected;
        this.setAddButtonText();
    };
    SelectProducts.prototype.setAddButtonText = function () {
        if (this.model.isAllSelected) {
            this.model.products.forEach(function (item) { return item.IsSelected = true; });
            this.model.addButtonText = 'Add (All)';
            this.resolve.options.isAllSelected = true;
            return;
        }
        this.resolve.options.isAllSelected = false;
        var selectedProductsCount = this.getSelectedProducts().length;
        this.model.addButtonText = selectedProductsCount > 0 ? "Add (" + selectedProductsCount + ")" : 'Add';
    };
    SelectProducts.prototype.getSelectedProducts = function () {
        return this.model.products.filter(function (item) { return item.IsSelected; });
    };
    SelectProducts.prototype.confirm = function () {
        var selectionResult = {
            status: 'ok',
            isAllSelected: false,
            selectedProducts: []
        };
        if (this.model.isAllSelected) {
            selectionResult.isAllSelected = true;
            this.modalInstance.close({ $value: selectionResult });
        }
        selectionResult.selectedProducts = this.getSelectedProducts();
        this.modalInstance.close({ $value: selectionResult });
    };
    SelectProducts.$inject = ['$translate', 'productsService', 'notificationService'];
    return SelectProducts;
}());
angular.module('naut').component('selectProducts', {
    template: __webpack_require__(797),
    controller: SelectProducts,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var SelectedList = /** @class */ (function () {
    function SelectedList() {
    }
    return SelectedList;
}());
angular.module('naut').component('selectedList', {
    template: __webpack_require__(798),
    controller: SelectedList,
    controllerAs: 'ctrl',
    bindings: {
        onDelete: '&',
        items: '<',
        header: '<',
        displayField: '<'
    }
});


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function sticky($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs, ctrl) {
            var height = element.offset().top;
            var stickyClass = attrs.stickyClass;
            var window = angular.element($window);
            window.bind('scroll', function () {
                var scrollY = window[0].pageYOffset;
                scrollY > height ? element.addClass(stickyClass) : element.removeClass(stickyClass);
            });
        }
    };
}
angular
    .module('naut')
    .directive('sticky', sticky);
sticky.$inject = ['$window'];


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var NfcRetailerTabList = /** @class */ (function () {
    function NfcRetailerTabList($scope, $translate, $uibModal) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this["export"] = function () { return __awaiter(_this, void 0, void 0, function () {
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'nfcExport',
                            resolve: {},
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    NfcRetailerTabList.$inject = ['$scope', '$translate', '$uibModal'];
    return NfcRetailerTabList;
}());
angular.module('naut').component('nfcRetailerTabList', {
    template: __webpack_require__(799),
    controller: NfcRetailerTabList,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var WizardDiscardPopup = /** @class */ (function () {
    function WizardDiscardPopup($scope, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.modalInstance = this;
        this.close = function () {
            _this.modalInstance.close({ $value: 'close' });
        };
        this["delete"] = function () {
            _this.modalInstance.close({ $value: 'ok' });
        };
    }
    WizardDiscardPopup.$inject = ['$scope', '$translate'];
    return WizardDiscardPopup;
}());
angular.module('naut').component('wizardDiscardPopup', {
    template: __webpack_require__(800),
    controller: WizardDiscardPopup,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var NfcWizard = /** @class */ (function () {
    function NfcWizard($scope, $translate, $rootScope, $timeout, categoriesSelectorService, classificationCategoriesService, nfcRetailerStickersService, notificationService, $state) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.categoriesSelectorService = categoriesSelectorService;
        this.classificationCategoriesService = classificationCategoriesService;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.$state = $state;
        this.model = {
            wizardNextStepButtonDisabled: false,
            assignNewStickers: true,
            step: 1,
            selectedLocations: [],
            isAllLocationsSelected: false,
            selectedProductsAndCategories: [],
            isAllProductsSelected: false,
            isAllCategoriesSelected: false,
            firstStickerNumber: '',
            assignType: 1
        };
        this.resetAssign = function () {
            _this.model = null;
            _this.$state.go('app.nfcs.active');
        };
        this.createOperation = function () {
            var locationIDs = _this.model.selectedLocations.map(function (x) { return x.ID; });
            var productIDs = _this.model.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('ID'); }).map(function (x) { return x.ID; });
            var categoriesIDs = _this.model.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('CategoryID'); }).map(function (x) { return x.CategoryID; });
            var assignType = _this.model.assignType;
            var firstStickerNumber = _this.model.firstStickerNumber;
            var request = {
                PlaceIDs: locationIDs,
                ProductIDs: productIDs,
                CategoryIDs: categoriesIDs,
                AssignType: assignType,
                FirstStickerNumber: firstStickerNumber
            };
            _this.nfcRetailerStickersService.createOperation(request)
                .then(function (response) {
                if (!response.HasErrors) {
                    _this.notificationService.showSuccessMessage();
                    _this.$state.go('app.nfcs.history');
                    return;
                }
                if (response.StickerNumberError) {
                    _this.notificationService.showErrorMessage(response.StickerNumberError);
                }
                if (response.InvalidProducts && response.InvalidProducts.length > 0) {
                    var message = 'Products ' + response.InvalidProducts.map(function (x) { return x.Title; }).join(', ') + ' are invalid';
                    _this.notificationService.showErrorMessage(message);
                }
                if (response.InvalidPlaces && response.InvalidPlaces.length > 0) {
                    var message = 'Locations ' + response.InvalidPlaces.map(function (x) { return x.Title; }).join(', ') + ' are invalid';
                    _this.notificationService.showErrorMessage(message);
                }
            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
        };
        this.productAndCategoriesIsInvalid = function () {
            if (_this.model.selectedProductsAndCategories.length === 0) {
                return true;
            }
            var categories = _this.model.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('CategoryID'); }).map(function (x) { return x.CategoryID; });
            var productsWithSameCategory = _this.model.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('ID') && categories.some(function (r) { return r === x.ClassificationCategoryID; }); })
                .map(function (x) { return x.Title; });
            if (productsWithSameCategory && productsWithSameCategory.length > 0) {
                var invalidProductsText = productsWithSameCategory.join(', ');
                var notificationText = productsWithSameCategory.length === 1
                    ? _this.$translate.instant('invalid_product_with_same_category', { product: invalidProductsText })
                    : _this.$translate.instant('invalid_products_with_same_category', { products: invalidProductsText });
                _this.notificationService.showErrorMessage(notificationText);
                _this.$timeout(function () { return _this.notificationService.clearAll(); }, 5000);
                return true;
            }
            _this.notificationService.clearAll();
            return false;
        };
        $scope.$watch(function () { return _this.model.step; }, function () {
            _this.changeWizardNextButtonEnabledIfNeed();
        });
        $scope.$watch(function () { return _this.model.selectedLocations; }, function () {
            _this.changeWizardNextButtonEnabledIfNeed();
        });
        $scope.$watch(function () { return _this.model.firstStickerNumber; }, function () {
            _this.changeWizardNextButtonEnabledIfNeed();
        });
        $scope.$watchCollection(function () { return _this.model.selectedProductsAndCategories; }, function () {
            _this.changeWizardNextButtonEnabledIfNeed();
        });
    }
    NfcWizard.prototype.changeWizardNextButtonEnabledIfNeed = function () {
        if (this.model.step === 1 && this.model.selectedLocations.length === 0) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }
        if (this.model.step === 2 && this.productAndCategoriesIsInvalid()) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }
        if (this.model.step === 3 && this.model.firstStickerNumber.length < 1) {
            this.model.wizardNextStepButtonDisabled = true;
            return;
        }
        this.model.wizardNextStepButtonDisabled = false;
    };
    NfcWizard.$inject = ['$scope', '$translate', '$rootScope', '$timeout', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService', '$state'];
    return NfcWizard;
}());
angular.module('naut').component('nfcWizard', {
    template: __webpack_require__(801),
    controller: NfcWizard,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var WizardAssignStep = /** @class */ (function () {
    function WizardAssignStep() {
        this.pattern = '[A-Z]{1}\\d{12}$';
    }
    return WizardAssignStep;
}());
angular.module('naut').component('wizardAssignStep', {
    template: __webpack_require__(802),
    controller: WizardAssignStep,
    controllerAs: 'ctrl',
    bindings: {
        assignType: '=',
        firstStickerNumber: '='
    }
});


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var WizardLocationsStep = /** @class */ (function () {
    function WizardLocationsStep($scope, $translate, $uibModal, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.addLocations = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectLocations',
                                resolve: {
                                    options: function () {
                                        return {
                                            selectedLocations: _this.selectedLocations,
                                            isAllSelected: _this.isAllLocationsSelected
                                        };
                                    }
                                },
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 1:
                        operationResult = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        if (operationResult && operationResult.status === 'ok') {
                            if (operationResult.isAllSelected) {
                                this.isAllLocationsSelected = true;
                                this.nfcRetailerStickersService.getAllLocations()
                                    .then(function (locations) {
                                    return _this.selectedLocations = locations;
                                })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
                            }
                            else {
                                this.isAllLocationsSelected = false;
                                this.selectedLocations = operationResult.selectedLocations;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteLocation = function (item) {
            _this.selectedLocations = _this.selectedLocations.filter(function (x) { return x.ID !== item.ID; });
            _this.isAllLocationsSelected = false;
        };
    }
    WizardLocationsStep.prototype.$onInit = function () {
        this.listHeader = this.$translate.instant('nfc_wizard_locations_step_list_header');
        this.listEmptyMessage = this.$translate.instant('nfc_wizard_locations_step_not_selected');
    };
    WizardLocationsStep.$inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService'];
    return WizardLocationsStep;
}());
angular.module('naut').component('wizardLocationsStep', {
    template: __webpack_require__(803),
    controller: WizardLocationsStep,
    controllerAs: 'ctrl',
    bindings: {
        selectedLocations: '=',
        isAllLocationsSelected: '='
    }
});


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var WizardProductAndCategoryList = /** @class */ (function () {
    function WizardProductAndCategoryList($translate) {
        this.$translate = $translate;
    }
    WizardProductAndCategoryList.$inject = ['$translate'];
    return WizardProductAndCategoryList;
}());
angular.module('naut').component('wizardProductAndCategoryList', {
    template: __webpack_require__(804),
    controller: WizardProductAndCategoryList,
    controllerAs: 'ctrl',
    bindings: {
        onDelete: '&',
        items: '<',
        header: '<'
    }
});


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var WizardProductsStep = /** @class */ (function () {
    function WizardProductsStep($scope, $translate, $uibModal, $rootScope, categoriesSelectorService, classificationCategoriesService, nfcRetailerStickersService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.categoriesSelectorService = categoriesSelectorService;
        this.classificationCategoriesService = classificationCategoriesService;
        this.nfcRetailerStickersService = nfcRetailerStickersService;
        this.notificationService = notificationService;
        this.selectedProductsAndCategories = [];
        this.addProduct = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var selectedProducts, operationResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedProducts = this.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('Title'); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectProducts',
                                resolve: {
                                    options: function () {
                                        return {
                                            selectedProducts: selectedProducts,
                                            isAllSelected: _this.isAllProductsSelected
                                        };
                                    }
                                },
                                size: 'md',
                                backdrop: 'static'
                            }).result];
                    case 2:
                        operationResult = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        if (operationResult && operationResult.status !== 'ok') {
                            return [2 /*return*/];
                        }
                        if (operationResult && operationResult.isAllSelected) {
                            this.isAllProductsSelected = true;
                            this.nfcRetailerStickersService.getAllProducts()
                                .then(function (allProducts) {
                                return _this.updateProductsOrCategories(allProducts, 'ID');
                            })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); });
                            return [2 /*return*/];
                        }
                        this.isAllProductsSelected = false;
                        this.updateProductsOrCategories(operationResult.selectedProducts, 'ID');
                        return [2 /*return*/];
                }
            });
        }); };
        this.updateProductsOrCategories = function (items, idFieldName) {
            var currentItems = _this.selectedProductsAndCategories;
            var changedItemsMap = _.indexBy(items, idFieldName);
            for (var i = currentItems.length - 1; i >= 0; i--) {
                var currentItem = currentItems[i];
                if (!currentItem.hasOwnProperty(idFieldName)) {
                    continue;
                }
                if (changedItemsMap[currentItem[idFieldName]]) {
                    delete changedItemsMap[currentItem[idFieldName]];
                }
                else {
                    currentItems.splice(i, 1);
                }
            }
            var itemsToAdd = _.map(changedItemsMap, function (i) { return i; });
            itemsToAdd.forEach(function (item) { return currentItems.push(item); });
        };
        this.addCategory = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var selectedCategories, operationResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedCategories = this.selectedProductsAndCategories.filter(function (x) { return x.hasOwnProperty('CategoryFullName'); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectProductCategory',
                                resolve: {
                                    options: function () {
                                        return {
                                            singleSelect: false,
                                            selectedCategories: selectedCategories,
                                            businessType: _this.$rootScope.enums.BusinessType.All,
                                            isOnlyStoreCategories: false,
                                            needAllSelect: false,
                                            isAllSelected: angular.copy(_this.isAllCategoriesSelected),
                                            getCategoriesTree: function () { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, this.nfcRetailerStickersService.getClassificationCategoriesForRetailer()];
                                                        case 1: return [2 /*return*/, _a.sent()];
                                                    }
                                                });
                                            }); }
                                        };
                                    }
                                },
                                size: 'lg'
                            }).result];
                    case 2:
                        operationResult = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        if (operationResult && operationResult.status !== 'ok') {
                            return [2 /*return*/];
                        }
                        if (operationResult && operationResult.isAllSelected) {
                            this.isAllCategoriesSelected = true;
                            return [2 /*return*/];
                        }
                        this.isAllCategoriesSelected = false;
                        this.updateProductsOrCategories(operationResult.selectedCategories, 'CategoryID');
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteItem = function (item) {
            var index = _this.selectedProductsAndCategories.indexOf(item);
            _this.selectedProductsAndCategories.splice(index, 1);
            if (item.ID) {
                _this.isAllProductsSelected = false;
            }
        };
    }
    WizardProductsStep.prototype.$onInit = function () {
        this.listHeader = this.$translate.instant('nfc_wizard_products_step_list_header');
        this.itemsNotSelected = this.$translate.instant('nfc_wizard_products_step_not_selected');
    };
    WizardProductsStep.$inject = ['$scope', '$translate', '$uibModal', '$rootScope', 'categoriesSelectorService',
        'classificationCategoriesService', 'nfcRetailerStickersService', 'notificationService'];
    return WizardProductsStep;
}());
angular.module('naut').component('wizardProductsStep', {
    template: __webpack_require__(805),
    controller: WizardProductsStep,
    controllerAs: 'ctrl',
    bindings: {
        selectedProductsAndCategories: '=',
        isAllProductsSelected: '=',
        isAllCategoriesSelected: '='
    }
});


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var WizardSteps = /** @class */ (function () {
    function WizardSteps($translate, $uibModal) {
        var _this = this;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.$onInit = function () {
            _this.step = 1;
        };
        this.nextStep = function () {
            if (_this.step !== 3) {
                _this.step++;
            }
            else {
                _this.onAssign();
            }
        };
        this.backStep = function () { return _this.step--; };
        this.discard = function () { return __awaiter(_this, void 0, void 0, function () {
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'wizardDiscardPopup',
                            resolve: {
                                options: angular.noop
                            },
                            size: 'sm',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult === 'ok') {
                            this.onDiscard();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    WizardSteps.$inject = ['$translate', '$uibModal'];
    return WizardSteps;
}());
angular.module('naut').component('wizardSteps', {
    template: __webpack_require__(806),
    controller: WizardSteps,
    controllerAs: 'ctrl',
    bindings: {
        step: '=',
        onAssign: '&',
        onDiscard: '&',
        nextButtonDisabled: '<'
    }
});


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddOrEditTable = /** @class */ (function () {
    function AddOrEditTable(shopService) {
        this.shopService = shopService;
        this.modalInstance = this;
        this.model = {
            dialogTitle: '',
            tableID: null,
            tableName: '',
            tableDescription: '',
            isEditMode: false,
            oldName: '',
            tableNameIsAlreadyExist: false
        };
        this.requiredDateError = false;
    }
    AddOrEditTable.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.model.isEditMode = this.resolve.isEditMode;
                this.model.tableID = this.resolve.tableID;
                this.model.tableName = this.resolve.tableName;
                this.model.tableDescription = this.resolve.tableDescription;
                this.model.oldName = angular.copy(this.resolve.tableName);
                return [2 /*return*/];
            });
        });
    };
    AddOrEditTable.prototype.validateTableOnExist = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.model.tableName) {
                            return [2 /*return*/];
                        }
                        this.model.tableNameIsAlreadyExist = false;
                        if (!!this.model.isEditMode) return [3 /*break*/, 3];
                        _a = this.existTableInLocalTables(this.model.tableName);
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.existTableInRemoteTables(this.model.tableName)];
                    case 1:
                        _a = (_c.sent());
                        _c.label = 2;
                    case 2:
                        if (_a) {
                            this.model.tableNameIsAlreadyExist = true;
                        }
                        return [2 /*return*/];
                    case 3:
                        if (!(this.model.tableName !== this.model.oldName)) return [3 /*break*/, 6];
                        _b = this.existTableInLocalTables(this.model.tableName);
                        if (_b) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.existTableInRemoteTables(this.model.tableName)];
                    case 4:
                        _b = (_c.sent());
                        _c.label = 5;
                    case 5:
                        if (_b) {
                            this.model.tableNameIsAlreadyExist = true;
                        }
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditTable.prototype.save = function () {
        var model = {
            ID: this.model.tableID,
            Name: this.model.tableName,
            Description: this.model.tableDescription,
            OldName: this.model.oldName
        };
        this.modalInstance.close({ $value: model });
    };
    AddOrEditTable.prototype.close = function () {
        this.modalInstance.close();
    };
    AddOrEditTable.prototype.existTableInLocalTables = function (tableName) {
        return this.resolve.existsTables.some(function (table) { return table.Name === tableName; });
    };
    AddOrEditTable.prototype.existTableInRemoteTables = function (tableName) {
        return __awaiter(this, void 0, void 0, function () {
            var exist, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        exist = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.shopService.isTableExist(this.resolve.shopID, tableName)];
                    case 2:
                        exist = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/, exist];
                }
            });
        });
    };
    AddOrEditTable.$inject = [
        'shopService'
    ];
    return AddOrEditTable;
}());
angular.module('naut').component('addOrEditTable', {
    template: __webpack_require__(807),
    controller: AddOrEditTable,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var models_1 = __webpack_require__(244);
var ShopTables = /** @class */ (function () {
    function ShopTables(shopService, $state, $scope) {
        var _this = this;
        this.shopService = shopService;
        this.$state = $state;
        this.$scope = $scope;
        this.tableSettings = { TableOrderEnabled: false, TableSelectionMandatory: false };
        this.waiting = false;
        this.tableSettingsOptions = models_1.TableSettingEnum;
        this.tables = [];
        this.pagination = {
            data: [],
            page: 1,
            pageSize: 5,
            total: 0,
            setData: function () {
                _this.pagination.total = _this.total;
                _this.pagination.data = _this.tables.slice(_this.pagination.pageSize * (_this.pagination.page - 1), _this.pagination.pageSize * _this.pagination.page);
                while (_this.pagination.total > 0 && _.size(_this.pagination.data) === 0) {
                    _this.pagination.page--;
                    _this.pagination.data = _this.tables.slice(_this.pagination.pageSize * (_this.pagination.page - 1), _this.pagination.pageSize * _this.pagination.page);
                }
            }
        };
    }
    ShopTables.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadTablesEnabled().then();
                this.loadTables().then();
                return [2 /*return*/];
            });
        });
    };
    ShopTables.prototype.loadTablesEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.shopService.getTablesEnabled(this.shopId)];
                    case 2:
                        _a.tableSettings = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.log(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ShopTables.prototype.loadTables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.shopService.getTables(this.shopId)];
                    case 2:
                        response = _a.sent();
                        this.tables = response.Items;
                        this.total = response.Total;
                        this.$scope.$watchGroup(['ctrl.pagination.page'], function (value) {
                            if (value) {
                                _this.pagination.setData();
                            }
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ShopTables.prototype.addTable = function () {
        this.$state.go('app.shopTables', { id: this.shopId, shopName: this.shopName, openAddTable: true, shopTown: this.shopTown });
    };
    ShopTables.prototype.changeTableSettings = function (settingsValue, parameter) {
        return __awaiter(this, void 0, void 0, function () {
            var currentParameter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentParameter = !parameter;
                        if (!(settingsValue === this.tableSettingsOptions.TableService)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setTablesEnabled(currentParameter)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.setTablesMandatory(currentParameter)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(settingsValue === this.tableSettingsOptions.TableService)) return [3 /*break*/, 7];
                        this.tableSettings.TableOrderEnabled = currentParameter;
                        if (!(!this.tableSettings.TableOrderEnabled && this.tableSettings.TableSelectionMandatory)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.setTablesMandatory(false)];
                    case 5:
                        _a.sent();
                        this.tableSettings.TableSelectionMandatory = false;
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (settingsValue === this.tableSettingsOptions.TableMandatorySelection) {
                            this.tableSettings.TableSelectionMandatory = currentParameter;
                        }
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ShopTables.prototype.openTablesList = function () {
        this.$state.go('app.shopTables', { id: this.shopId, shopName: this.shopName, shopTown: this.shopTown });
    };
    ShopTables.prototype.setTablesEnabled = function (isEnabled) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.waiting = true;
                        return [4 /*yield*/, this.shopService.setTablesEnabled(this.shopId, isEnabled)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3 /*break*/, 4];
                    case 3:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShopTables.prototype.setTablesMandatory = function (isMandatory) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.waiting = true;
                        return [4 /*yield*/, this.shopService.setTablesMandatory(this.shopId, isMandatory)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        console.log(error_4);
                        return [3 /*break*/, 4];
                    case 3:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShopTables.$inject = ['shopService', '$state', '$scope'];
    return ShopTables;
}());
exports.ShopTables = ShopTables;
angular.module('naut').component('shopTables', {
    template: __webpack_require__(808),
    controller: ShopTables,
    controllerAs: 'ctrl',
    bindings: {
        shopId: '<',
        shopName: '<',
        shopTown: '<'
    }
});


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ShopTablesList = /** @class */ (function () {
    function ShopTablesList(shopService, $state, $stateParams, $uibModal, popupService, $translate, notificationService) {
        this.shopService = shopService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.popupService = popupService;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.shopName = null;
        this.shopTown = null;
        this.tableEnable = false;
        this.waiting = false;
        this.tables = [];
        this.tablesIDsToDelete = [];
    }
    ShopTablesList.prototype.$onInit = function () {
        var _this = this;
        if (this.$state.params.id) {
            this.shopID = this.$stateParams.id;
            this.shopName = this.$stateParams.shopName;
            this.shopTown = this.$stateParams.shopTown;
            this.loadTables().then(function () {
                if (_this.$stateParams.openAddTable) {
                    _this.openAddTableDialog();
                }
            });
        }
    };
    ShopTablesList.prototype.loadTables = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.shopService.getTables(this.shopID)];
                    case 2:
                        response = _a.sent();
                        this.tables = response.Items;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ShopTablesList.prototype.deleteTable = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, tableIndexToDelete;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okTxt: this.$translate.instant('table_delete_dialog_cancel'),
                                okClass: 'btn btn-with-background-icon close-icon--tiny24',
                                cancelTxt: this.$translate.instant('table_delete_dialog_ok'),
                                cancelClass: 'btn btn-with-background-icon icon-trashcan-outline-white btn-danger',
                                title: this.$translate.instant('table_delete_dialog_title'),
                                content: this.$translate.instant('table_delete_dialog_content'),
                                invertAction: true,
                                classPopup: 'popup--redesign modal360'
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.waiting = true;
                        try {
                            this.tablesIDsToDelete.push(table.ID);
                            tableIndexToDelete = this.tables.findIndex(function (t) { return t.ID === table.ID; });
                            this.tables.splice(tableIndexToDelete, 1);
                        }
                        catch (error) {
                            console.log(error);
                        }
                        finally {
                            this.waiting = false;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopTablesList.prototype.openAddTableDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var preparedTable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'addOrEditTable',
                            resolve: {
                                shopID: function () { return _this.shopID; },
                                isEditMode: function () { return false; },
                                existsTables: function () { return _this.tables; }
                            },
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        preparedTable = _a.sent();
                        if (preparedTable) {
                            this.tables.push(preparedTable);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopTablesList.prototype.openEditTableDialog = function (table) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var preparedTable, existTable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'addOrEditTable',
                            resolve: {
                                shopID: function () { return _this.shopID; },
                                tableID: function () { return table.ID; },
                                tableName: function () { return table.Name; },
                                tableDescription: function () { return table.Description; },
                                existsTables: function () { return _this.tables; },
                                isEditMode: function () { return true; }
                            },
                            size: 'md',
                            backdrop: 'static'
                        }).result];
                    case 1:
                        preparedTable = _a.sent();
                        if (preparedTable) {
                            existTable = this.tables.find(function (t) { return t.Name === preparedTable.OldName; });
                            existTable.Name = preparedTable.Name;
                            existTable.Description = preparedTable.Description;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopTablesList.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, this.shopService.addOrUpdateTables(this.shopID, this.tables)];
                    case 2:
                        _a.sent();
                        if (!(this.tablesIDsToDelete.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.shopService.deleteTables(this.shopID, this.tablesIDsToDelete)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.$state.go('app.shop', { id: this.shopID });
                        return [3 /*break*/, 7];
                    case 5:
                        error_3 = _a.sent();
                        console.log(error_3);
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 7];
                    case 6:
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ShopTablesList.prototype.discard = function () {
        this.$state.go('app.shop', { id: this.shopID });
    };
    ShopTablesList.$inject = [
        'shopService',
        '$state',
        '$stateParams',
        '$uibModal',
        'popupService',
        '$translate',
        'notificationService'
    ];
    return ShopTablesList;
}());
exports.ShopTablesList = ShopTablesList;
angular.module('naut').component('shopTablesList', {
    template: __webpack_require__(809),
    controller: ShopTablesList,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var popupServiceCancel_1 = __webpack_require__(5);
var open360BusinessLogicRetailersStoresBEStore_1 = __webpack_require__(92);
var ShopController = /** @class */ (function () {
    function ShopController($scope, $state, shopService, popupService, notificationService, $translate, $rootScope) {
        var _this = this;
        this.$state = $state;
        this.shopService = shopService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.waiting = false;
        this.shopID = null;
        this.businessTypeEnum = open360BusinessLogicRetailersStoresBEStore_1.Open360BusinessLogicRetailersStoresBEStore.BusinessTypeEnum;
        this.archiveStore = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('archive_place'),
                                content: "<p>" + this.$translate.instant('archive_place_confirm') + "</p>",
                                cancelClass: 'btn-success',
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        this.shopService.archiveStore(this.shopID).then(function (response) {
                            _this.$state.go('app.shops');
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 3];
                    case 3:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        var id = parseInt($state.params.id, 10);
        this.shopID = null;
        if (!isNaN(id)) {
            this.shopID = id;
        }
        this.manager = {
            openForm: {
                openingHours: false,
                store: false
            },
            store: null,
            isNew: this.shopID == null,
            isShowInventory: function () {
                if (_this.manager.store) {
                    return _this.shopService.isShowInventory(_this.manager.store.BusinessType);
                }
                return false;
            }
        };
        $scope.$on('openOpeningHours', function (event, isOpen) {
            _this.manager.openForm.openingHours = isOpen;
        });
        $scope.$on('openStore', function (event, isOpen) {
            _this.manager.openForm.store = isOpen;
        });
        $scope.$on('setStore', function (event, store) {
            _this.manager.store = store;
        });
        var unwatch = $rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userData.permission) {
                    unwatch();
                    this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                }
                return [2 /*return*/];
            });
        }); }, true);
    }
    ShopController.$inject = ['$scope', '$state', 'shopService', 'popupService', 'notificationService', '$translate', '$rootScope'];
    return ShopController;
}());
exports.ShopController = ShopController;
angular.module('naut').component('shop', {
    template: __webpack_require__(810),
    controller: ShopController,
    controllerAs: 'vm'
});


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var _ = __webpack_require__(1);
var angular = __webpack_require__(0);
var ShopCampaignsController = /** @class */ (function () {
    function ShopCampaignsController(shopService, campaignsService, commonCampaignsService, retailerService, notificationService) {
        var _this = this;
        this.shopService = shopService;
        this.campaignsService = campaignsService;
        this.commonCampaignsService = commonCampaignsService;
        this.retailerService = retailerService;
        this.notificationService = notificationService;
        this.waiting = false;
        this.campaigns = [];
        this.filter = {
            from: null,
            to: null,
            selectedStatus: null,
            statuses: [],
            dateOptions: {
                formatYear: 'yyyy',
                startingDay: 0
            }
        };
        this.allCampaigns = [];
        this.previewImgSize = {
            w: 64,
            h: 32
        };
        this.campaignsLoaded = false;
        this.shopID = null;
        this.allStatuses = {
            key: 'All',
            value: null
        };
        this.status = this.commonCampaignsService.getCampaignStatus();
        this.applyFilter = function () {
            _this.campaigns = _this.allCampaigns;
            if (_this.filter.selectedStatus.key !== _this.allStatuses.key) {
                _this.campaigns = _.where(_this.campaigns, { 'Status': _this.filter.selectedStatus.value });
            }
            if (_this.filter.from) {
                _this.campaigns = _.filter(_this.campaigns, function (campaign) {
                    return campaign.StartDate && new Date(campaign.StartDate.toString()).setHours(0, 0, 0) <= new Date(_this.filter.from.toString()).setHours(0, 0, 0);
                });
            }
            if (_this.filter.to) {
                _this.campaigns = _.filter(_this.campaigns, function (campaign) {
                    return campaign.EndDate && new Date(campaign.EndDate.toString()).setHours(0, 0, 0) >= new Date(_this.filter.to.toString()).setHours(0, 0, 0);
                });
            }
        };
        this.setState = function (campaign) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.campaignsService.setState(campaign.ID, !campaign.enabled)];
                    case 2:
                        _a.sent();
                        this.notificationService.clearAll();
                        return [4 /*yield*/, this.getCampaigns(this.shopID)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        campaign.enabled = !campaign.enabled;
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.setCampaignState = function (campaign) {
            campaign.enabled = campaign.Status !== _this.status.Draft;
            campaign.hideState = campaign.Status === _this.status.Archived;
        };
        this.getCampaigns = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var pagingResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.shopService.getStoreCampaigns(id)];
                    case 1:
                        pagingResult = _a.sent();
                        this.allCampaigns = pagingResult.Items;
                        _.forEach(this.allCampaigns, function (campaign) {
                            campaign.StartDate = campaign.StartDate ? new Date(campaign.StartDate.toString()) : null;
                            campaign.EndDate = campaign.EndDate ? new Date(campaign.EndDate.toString()) : null;
                            campaign.image = campaign.ImageID ? _this.retailerService.getCampaignImageUrl(campaign.ImageID, _this.previewImgSize.w, _this.previewImgSize.h) : null;
                            campaign.video = campaign.VideoID ? _this.retailerService.getCampaignThumbnailImageUrl(campaign.VideoID, _this.previewImgSize.w, _this.previewImgSize.h) : null;
                            _this.setCampaignState(campaign);
                        });
                        this.applyFilter();
                        this.campaignsLoaded = true;
                        this.campaignsService.resizeFontWithTimeOut();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var statuses = [this.allStatuses];
        for (var key in this.status) {
            if (this.status.hasOwnProperty(key) && !_.isFunction(this.status[key]) && key.toLowerCase() !== 'undefined' &&
                this.status[key] !== this.status.Warning && this.status[key] !== this.status.Disabled) {
                statuses.push({
                    key: key,
                    value: this.status[key]
                });
            }
        }
        this.filter.statuses = statuses;
        this.filter.selectedStatus = this.allStatuses;
    }
    ShopCampaignsController.prototype.$onChanges = function (changes) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.getCampaigns(this.shopID);
        }
    };
    ShopCampaignsController.$inject = ['shopService', 'campaignsService', 'commonCampaignsService', 'retailerService', 'notificationService'];
    return ShopCampaignsController;
}());
exports.ShopCampaignsController = ShopCampaignsController;
angular.module('naut').component('shopCampaigns', {
    template: __webpack_require__(811),
    controller: ShopCampaignsController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<'
    }
});


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ShopInventoryController = /** @class */ (function () {
    function ShopInventoryController($scope, inventoryService, notificationService, $translate, accountService, classificationCategoriesService) {
        var _this = this;
        this.$scope = $scope;
        this.inventoryService = inventoryService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.accountService = accountService;
        this.classificationCategoriesService = classificationCategoriesService;
        this.waiting = false;
        this.htmlTooltip = {
            awaitingApproval: this.$translate.instant('this_brand_is_awaiting_approval'),
            rejected: 'This brand was rejected'
        };
        this.pagination = {
            data: [],
            page: 1,
            pageSize: 10,
            total: 0,
            filter: '',
            setData: function () {
                var filtered = _this.pagination.applyFilter();
                _this.pagination.total = _.size(filtered);
                _this.pagination.data = filtered.slice(_this.pagination.pageSize * (_this.pagination.page - 1), _this.pagination.pageSize * _this.pagination.page);
                while (_this.pagination.total > 0 && _.size(_this.pagination.data) === 0) {
                    _this.pagination.page--;
                    _this.pagination.data = filtered.slice(_this.pagination.pageSize * (_this.pagination.page - 1), _this.pagination.pageSize * _this.pagination.page);
                }
            },
            applyFilter: function () {
                var keyword = _this.pagination.filter.trim();
                var regex = new RegExp('\\b' + keyword + '.*', 'i');
                if (_this.pagination.filter.trim()) {
                    return _.filter(_this.data.ClassificationCategories, function (category) {
                        return regex.test(category.CategoryFullName);
                    });
                }
                else {
                    return _this.data.ClassificationCategories;
                }
            }
        };
        this.shopID = null;
        this.getInventory = function (shopID) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.inventoryService.get(shopID)];
                    case 2:
                        response = _a.sent();
                        if (response === 'cancel') {
                            return [2 /*return*/];
                        }
                        this.data = response;
                        this.data.inventory = this.data.ClassificationCategories && !_.isEmpty(this.data.ClassificationCategories);
                        this.$scope.$watchGroup(['$ctrl.pagination.page', '$ctrl.pagination.filter'], function (value, oldValue) {
                            if (value) {
                                _this.pagination.setData();
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1 ? error_1 : null);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
    }
    ShopInventoryController.prototype.$onChanges = function (changes) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.getInventory(this.shopID);
            this.loadCategories();
        }
    };
    ShopInventoryController.prototype.loadCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.accountService.userData.languageID;
                        return [4 /*yield*/, this.classificationCategoriesService.getTree(id)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopInventoryController.$inject = ['$scope', 'inventoryService', 'notificationService', '$translate', 'accountService', 'classificationCategoriesService'];
    return ShopInventoryController;
}());
exports.ShopInventoryController = ShopInventoryController;
angular.module('naut').component('shopInventory', {
    template: __webpack_require__(812),
    controller: ShopInventoryController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<'
    }
});


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ShopOpeningHoursController = /** @class */ (function () {
    function ShopOpeningHoursController($scope, $filter, $timeout, shopService, notificationService, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.shopService = shopService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0
        };
        this.shopID = null;
        this.dateDefault = 'Thu, 01 Jan 1970 ';
        this.serverData = null;
        this.timeout = 900;
        this.addInterval = function (item) {
            item.openingHours.push(_this.getDefaultOpeningTime());
            _this.openingform.$setDirty();
        };
        this.deleteInterval = function (item, opening) {
            item.openingHours = _.reject(item.openingHours, function (openingHour) {
                return openingHour.openAt === opening.openAt && openingHour.closedAt === opening.closedAt;
            });
        };
        this.addSpecialOpening = function () {
            var opening = {
                date: new Date(),
                open24Hours: false,
                openingHours: _this.setOpeningDateTime(null),
                closed: false,
                errors: {
                    openAt: null,
                    closedAt: null,
                    date: null,
                    ranges: null
                }
            };
            opening.date.setHours(0, 0, 0, 0);
            _this.specialOpeningHours.push(opening);
            _this.openingform.$setDirty();
        };
        this.removeSpecialOpening = function (opening) {
            _this.specialOpeningHours = _.reject(_this.specialOpeningHours, function (openingHour) {
                return openingHour.$$hashKey === opening.$$hashKey;
            });
            _this.openingform.$setDirty();
        };
        this.beforeSaveOpeningHours = function () {
            _this.clearErrors(_this.specialOpeningHours);
            _this.clearErrors(_this.normalOpeningHours);
            _this.validateDataBase();
            _this.openingform.$invalid = _this.isError(_this.specialOpeningHours) || _this.isError(_this.normalOpeningHours);
            if (!_this.openingform.$invalid) {
                _this.validateTimeGreaterThan(_this.specialOpeningHours);
                _this.validateTimeGreaterThan(_this.normalOpeningHours);
                _this.openingform.$invalid = _this.isError(_this.specialOpeningHours) || _this.isError(_this.normalOpeningHours);
            }
            if (!_this.openingform.$invalid) {
                _this.validateRangesTime(_this.specialOpeningHours);
                _this.validateRangesTime(_this.normalOpeningHours);
                _this.validateUniqueDate();
                _this.openingform.$invalid = _this.isError(_this.specialOpeningHours) || _this.isError(_this.normalOpeningHours);
            }
            if (!_this.openingform.$invalid) {
                _this.validateSpecialByNormal();
                _this.openingform.$invalid = _this.isError(_this.specialOpeningHours) || _this.isError(_this.normalOpeningHours);
            }
            if (_this.openingform.$invalid) {
                return 'invalid time';
            }
            else {
                _this.saveOpeningHours();
                return 'something';
            }
        };
        this.edit = function () {
            _this.openingform.opacity = true;
            _this.$timeout(_this.removeOpacity, 200);
            _this.openingform.$show();
            _this.$scope.$emit('openOpeningHours', true);
        };
        this.discard = function () {
            _this.openingform.$cancel();
            _this.openingform.$setPristine();
            if (_this.serverData) {
                _this.setClientModel(_this.serverData);
            }
            _this.$scope.$emit('openOpeningHours', false);
        };
        this.hideOpeningHours = function () {
            _this.$timeout(_this.removeOpacity, _this.timeout);
        };
        this.getServerModel = function () {
            var normalOpeningHoursList = _.map(_this.normalOpeningHours, function (item) {
                return {
                    DayOfWeek: item.day,
                    DayOfWeekString: item.dayOfWeek,
                    Open24Hours: item.open24Hours,
                    OpeningHours: _this.setServerOpeningTime(item)
                };
            });
            var specialOpeningHoursList = _.map(_this.specialOpeningHours, function (item) {
                return {
                    Date: _this.$filter('date')(item.date),
                    Open24Hours: item.open24Hours,
                    OpeningHours: _this.setServerOpeningTime(item)
                };
            });
            return {
                SpecialOpeningHoursList: specialOpeningHoursList,
                NormalOpeningHoursList: normalOpeningHoursList
            };
        };
        this.getTimeString = function (time, isClosedAt) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var seconds = time.getSeconds();
            if (isClosedAt && time.getTime() === _this.getDateTime('23:59:59').getTime()) {
                return (hours < 10 ? '0' + hours : hours) + ':' +
                    (minutes < 10 ? '0' + minutes : minutes) + ':' + seconds;
            }
            return (hours < 10 ? '0' + hours : hours) + ':' +
                (minutes < 10 ? '0' + minutes : minutes);
        };
        this.setServerOpeningTime = function (item) {
            if (item.closed || item.open24Hours) {
                return [];
            }
            var startDate = _this.getDateTime('00:00');
            return _.map(item.openingHours, function (openingHour) {
                return {
                    OpenAt: _this.getTimeString(openingHour.openAt),
                    ClosedAt: startDate.getTime() === openingHour.closedAt.getTime() ?
                        _this.getTimeString(_this.getDateTime('23:59:59'), true)
                        : _this.getTimeString(openingHour.closedAt)
                };
            });
        };
        this.setClientModel = function (data) {
            _this.normalOpeningHours = _.map(data.NormalOpeningHoursList, function (item) {
                return {
                    day: item.DayOfWeek,
                    dayOfWeek: item.DayOfWeekString,
                    open24Hours: item.Open24Hours,
                    openingHours: _this.setOpeningDateTime(item.OpeningHours),
                    closed: !_.any(item.OpeningHours) && !item.Open24Hours,
                    errors: {
                        openAt: null,
                        closedAt: null,
                        ranges: null,
                        date: null
                    }
                };
            });
            _this.specialOpeningHours = _.map(data.SpecialOpeningHoursList, function (item) {
                return {
                    date: new Date(item.Date.toString()),
                    open24Hours: item.Open24Hours,
                    openingHours: _this.setOpeningDateTime(item.OpeningHours),
                    closed: !_.any(item.OpeningHours) && !item.Open24Hours,
                    errors: {
                        openAt: null,
                        closedAt: null,
                        date: null,
                        ranges: null
                    }
                };
            });
        };
        this.setOpeningDateTime = function (openingHours) {
            var endOfDay = _this.getDateTime('23:59:59');
            if (_.isArray(openingHours) && _.any(openingHours)) {
                return _.map(openingHours, function (item) {
                    return {
                        openAt: _this.getDateTime(item.OpenAt),
                        closedAt: endOfDay.getTime() === _this.getDateTime(item.ClosedAt).getTime() ?
                            _this.getDateTime('00:00') : _this.getDateTime(item.ClosedAt)
                    };
                });
            }
            else {
                return [_this.getDefaultOpeningTime()];
            }
        };
        this.getDateTime = function (time) {
            return new Date(Date.parse(_this.dateDefault + (time ? time : '00:00')));
        };
        this.getDefaultOpeningTime = function () {
            return {
                openAt: _this.getDateTime('09:00'),
                closedAt: _this.getDateTime('18:00')
            };
        };
        this.clearErrors = function (data) {
            _.forEach(_.pluck(data, 'errors'), function (object) {
                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        object[key] = null;
                    }
                }
            });
        };
        this.isError = function (data) {
            var errors = _.pluck(data, 'errors');
            return _.any(errors, function (object) {
                for (var key in object) {
                    if (object.hasOwnProperty(key) && _.isString(object[key])) {
                        return true;
                    }
                }
                return false;
            });
        };
        this.validateTime = function (item) {
            var invalidTime = _this.$translate.instant('invalid_time');
            item.errors.openAt = _.any(_.pluck(item.openingHours, 'openAt'), function (datetime) {
                return !_.isDate(datetime);
            }) ? invalidTime : null;
            item.errors.closedAt = _.any(_.pluck(item.openingHours, 'closedAt'), function (datetime) {
                return !_.isDate(datetime);
            }) ? invalidTime : null;
        };
        this.validateDataBase = function () {
            var invalidDate = _this.$translate.instant('invalid_date');
            _.forEach(_this.specialOpeningHours, function (item) {
                item.errors.date = _.isDate(item.date) ? null : invalidDate;
                if (!item.open24Hours && !item.closed) {
                    _this.validateTime(item);
                }
            });
            _.forEach(_this.normalOpeningHours, function (item) {
                if (!item.open24Hours && !item.closed) {
                    _this.validateTime(item);
                }
            });
        };
        this.validateUniqueDate = function () {
            var invalidDate = _this.$translate.instant('date_must_be_unique');
            _.forEach(_this.specialOpeningHours, function (item) {
                var date = new Date(item.date.toString()).setHours(0, 0, 0, 0);
                item.errors.date = _.any(_this.specialOpeningHours, function (opening) {
                    return opening.$$hashKey !== item.$$hashKey
                        && date === new Date(opening.date.toString()).setHours(0, 0, 0, 0);
                }) ? invalidDate : null;
            });
        };
        this.validateRangesTime = function (items) {
            var invalidRanges = _this.$translate.instant('ranges_musnt_intersect');
            _.forEach(items, function (item) {
                if (!item.open24Hours && !item.closed) {
                    var openingHours = _.sortBy(item.openingHours, 'openAt');
                    var previous_1 = null;
                    _.forEach(openingHours, function (openingHour) {
                        if (previous_1 != null && (openingHour.openAt <= previous_1.openAt || openingHour.openAt <= previous_1.closedAt || openingHour.closedAt <= previous_1.closedAt)) {
                            item.errors.ranges = invalidRanges;
                        }
                        previous_1 = openingHour;
                    });
                }
            });
        };
        this.validateTimeGreaterThan = function (data) {
            var invalidGreaterThan = _this.$translate.instant('closing_time_error');
            _.forEach(data, function (item) {
                if (!item.open24Hours && !item.closed) {
                    item.errors.ranges = _.any(item.openingHours, function (interval) {
                        var startDate = _this.getDateTime('00:00');
                        if (startDate.getTime() === interval.closedAt.getTime()) {
                            return false;
                        }
                        return interval.openAt >= interval.closedAt;
                    }) ? invalidGreaterThan : null;
                }
            });
        };
        this.isEqualIntervals = function (normal, special) {
            if (normal.closed || special.closed) {
                return normal.closed && special.closed;
            }
            if (normal.open24Hours || special.open24Hours) {
                return normal.open24Hours && special.open24Hours;
            }
            if (_.size(normal.openingHours) !== _.size(special.openingHours)) {
                return false;
            }
            return _.all(normal.openingHours, function (normalInterval) {
                return _.any(special.openingHours, function (specialInterval) {
                    var nOpen = new Date(normalInterval.openAt.toString()).setSeconds(0, 0);
                    var nClosed = new Date(normalInterval.closedAt.toString()).setSeconds(0, 0);
                    var sOpen = new Date(specialInterval.openAt.toString()).setSeconds(0, 0);
                    var sClosed = new Date(specialInterval.closedAt.toString()).setSeconds(0, 0);
                    return nOpen === sOpen && nClosed === sClosed;
                });
            });
        };
        this.validateSpecialByNormal = function () {
            var equal = _this.$translate.instant('special_hours_error');
            _.forEach(_this.normalOpeningHours, function (normal) {
                var valid = true;
                _.forEach(_this.specialOpeningHours, function (special) {
                    if (normal.day === special.date.getDay() && _this.isEqualIntervals(normal, special)) {
                        normal.errors.date = '*';
                        special.errors.date = equal;
                    }
                });
            });
        };
        this.getOpeningHours = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.openingform) {
                            this.openingform.$waiting = true;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.shopService.getOpeningHours(id)];
                    case 2:
                        _a.serverData = _b.sent();
                        this.setClientModel(this.serverData);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (this.openingform) {
                            this.openingform.$waiting = false;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.saveOpeningHours = function () { return __awaiter(_this, void 0, void 0, function () {
            var model, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.openingform.$invalid) {
                            return [2 /*return*/, false];
                        }
                        this.notificationService.showWaitingMessage();
                        this.openingform.$waiting = true;
                        model = this.getServerModel();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.shopService.updateOpeningHours(this.shopID, model)];
                    case 2:
                        _a.sent();
                        this.$scope.$emit('openOpeningHours', false);
                        this.getOpeningHours(this.shopID);
                        this.openingform.$cancel();
                        this.openingform.$setPristine();
                        this.notificationService.showSuccessMessage();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.openingform.$waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.removeOpacity = function () {
            _this.openingform.opacity = false;
        };
        if (navigator.userAgent.toLowerCase().indexOf('chrome') === -1) {
            this.timeout = 1800;
        }
    }
    ShopOpeningHoursController.prototype.$onChanges = function (changes) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.getOpeningHours(this.shopID);
        }
    };
    ShopOpeningHoursController.$inject = ['$scope', '$filter', '$timeout', 'shopService', 'notificationService', '$translate'];
    return ShopOpeningHoursController;
}());
exports.ShopOpeningHoursController = ShopOpeningHoursController;
angular.module('naut').component('shopOpeningHours', {
    template: __webpack_require__(813),
    controller: ShopOpeningHoursController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<'
    }
});


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var wysiwygControllerBase_1 = __webpack_require__(61);
var popupServiceCancel_1 = __webpack_require__(5);
var ShopStoreController = /** @class */ (function (_super) {
    __extends(ShopStoreController, _super);
    function ShopStoreController($rootScope, $scope, $q, $sce, $document, $timeout, taOptions, shopService, notificationService, popupService, googleMapService, wysiwygService, definitionsService, $translate, $uibModal) {
        var _this = _super.call(this, $scope, taOptions, wysiwygService) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.$sce = $sce;
        _this.$document = $document;
        _this.$timeout = $timeout;
        _this.taOptions = taOptions;
        _this.shopService = shopService;
        _this.notificationService = notificationService;
        _this.popupService = popupService;
        _this.googleMapService = googleMapService;
        _this.wysiwygService = wysiwygService;
        _this.definitionsService = definitionsService;
        _this.$translate = $translate;
        _this.$uibModal = $uibModal;
        _this.store = null;
        _this.errorStoreName = null;
        _this.errorStoreDescription = null;
        _this.errorStoreAddressLine1 = null;
        _this.errorStoreAddressLine2 = null;
        _this.errorStoreTown = null;
        _this.errorStorePostcode = null;
        _this.errorStorePhone = null;
        _this.errorStoreEmail = null;
        _this.errorStoreWebsite = null;
        _this.errorStoreBusinessType = null;
        _this.errorStorDescription = null;
        _this.errorStoreMap = null;
        _this.maps = {
            optionsEdit: null,
            optionsView: null,
            edit: null,
            view: null,
            markerEdit: null,
            markerView: null,
            infoWindow: null,
            defaultLatLng: { lat: 51.500152, lng: -0.126236 },
            loadedEdit: false,
            loadedView: false,
            validDistance: 500,
            message: _this.$translate.instant('map_hint'),
            zoom: 16
        };
        _this.shopID = null;
        _this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: null
        };
        _this.dateEndOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: new Date()
        };
        _this.storeStandard = null;
        _this.googleMaps = null;
        _this.businessTypes = null;
        _this.defaultExhibitionDate = {
            start: new Date(),
            end: new Date(),
            getStart: function (date) {
                if (!date) {
                    date = new Date();
                }
                date.setHours(9, 0, 0);
                return date;
            },
            getEnd: function (date) {
                if (!date) {
                    date = new Date();
                }
                date.setHours(22, 0, 0);
                return date;
            }
        };
        _this.enumBusinessType = shopService.getEnumBusinessType();
        _this.defaultExhibitionDate.end.setMonth(_this.defaultExhibitionDate.end.getMonth() + 1);
        return _this;
    }
    ShopStoreController.prototype.$onChanges = function (changes) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.init();
        }
    };
    ShopStoreController.prototype.storeFormShow = function () {
        this.storeform.$show();
        this.maps.loadedEdit = false;
        this.$timeout(this.reloadGoogleMaps.bind(this));
        this.$scope.$emit('openStore', true);
        this.phoneScroll();
    };
    ShopStoreController.prototype.discardStore = function () {
        this.storeform.$cancel();
        this.storeform.$setPristine();
        if (!this.shopID) {
            this.$rootScope.$state.go('app.shops');
        }
        this.maps.loadedView = false;
        this.$scope.$emit('openStore', false);
        this.store = angular.copy(this.storeStandard);
        this.$timeout(this.reloadGoogleMaps.bind(this));
    };
    ShopStoreController.prototype.saveStore = function () {
        var _this = this;
        if (this.storeform.$invalid) {
            return 'error';
        }
        this.computeDistanceBetween().then(function (action) {
            action();
            if (_this.store.BusinessType === _this.enumBusinessType.Restaurant) {
                _this.instanceWysiwygService.deleteRemovedTokens(_this.store.Menu);
            }
        });
        return 'something';
    };
    ShopStoreController.prototype.archiveStore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('archive_place'),
                                content: "<p>" + this.$translate.instant('archive_place_confirm') + "</p>"
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.shopService.archiveStore(this.shopID)];
                    case 2:
                        _a.sent();
                        this.$rootScope.$state.go('app.shops');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShopStoreController.prototype.validateStoreForm = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.storeform.$invalid = false;
                        // -- validate store name
                        if (data.storeName == null || data.storeName.trim().length === 0) {
                            this.errorStoreName = this.$translate.instant('place_name_required');
                        }
                        else if (data.storeName.trim().length < 1) {
                            this.errorStoreName = this.$translate.instant('store_name_too_short');
                        }
                        else if (data.storeName.trim().length > 256) {
                            this.errorStoreName = this.$translate.instant('store_name_too_long');
                        }
                        else {
                            this.errorStoreName = null;
                        }
                        // -- validate business type
                        this.errorStoreBusinessType =
                            this.store.type == null
                                ? this.$translate.instant('business_type_required')
                                : null;
                        // -- validate store description
                        if (data.storeDescription == null) {
                            this.errorStorDescription = null;
                        }
                        else if (data.storeDescription.trim().length < 3 &&
                            data.storeDescription.trim().length > 0) {
                            this.errorStoreDescription = this.$translate.instant('description_too_short');
                        }
                        else if (data.storeDescription.trim().length > 1000) {
                            this.errorStoreDescription = this.$translate.instant('description_too_long', { maxLength: 1000 });
                        }
                        else {
                            this.errorStoreDescription = null;
                        }
                        // -- validate store AddressLine1
                        if (data.storeAddressLine1 == null ||
                            data.storeAddressLine1.trim().length === 0) {
                            this.errorStoreAddressLine1 = this.$translate.instant('address_line_required', { line: 'line1' });
                        }
                        else if (data.storeAddressLine1.trim().length < 3) {
                            this.errorStoreAddressLine1 = this.$translate.instant('address_line_too_short', { line: 'line1' });
                        }
                        else if (data.storeAddressLine1.trim().length > 128) {
                            this.errorStoreAddressLine1 = this.$translate.instant('address_line_too_long', { line: 'line1' });
                        }
                        else {
                            this.errorStoreAddressLine1 = null;
                        }
                        // --  validate store AddressLine2
                        if (data.storeAddressLine2 == null) {
                            this.errorStoreAddressLine2 = null;
                        }
                        else if (data.storeAddressLine2.trim().length < 3 &&
                            data.storeAddressLine2.trim().length > 0) {
                            this.errorStoreAddressLine2 = this.$translate.instant('address_line_too_short', { line: 'line2' });
                        }
                        else if (data.storeAddressLine2.trim().length > 128) {
                            this.errorStoreAddressLine2 = this.$translate.instant('address_line_too_long', { line: 'line2' });
                        }
                        else {
                            this.errorStoreAddressLine2 = null;
                        }
                        // -- validate store town
                        if (data.storeTown == null || data.storeTown.trim().length === 0) {
                            this.errorStoreTown = this.$translate.instant('town_is_required');
                        }
                        else if (data.storeTown.trim().length < 2) {
                            this.errorStoreTown = this.$translate.instant('town_too_short');
                        }
                        else if (data.storeTown.trim().length > 128) {
                            this.errorStoreTown = this.$translate.instant('town_too_long');
                        }
                        else {
                            this.errorStoreTown = null;
                        }
                        // -- validate store Postcode
                        if (this.Country.Code !== 784) {
                            if (data.storePostcode == null ||
                                data.storePostcode.trim().length === 0) {
                                this.errorStorePostcode = this.$translate.instant('postcode_is_required');
                            }
                            else if (data.storePostcode.trim().length < 3) {
                                this.errorStorePostcode = this.$translate.instant('postcode_too_short');
                            }
                            else if (data.storePostcode.trim().length > 128) {
                                this.errorStorePostcode = this.$translate.instant('postcode_too_long');
                            }
                            else {
                                this.errorStorePostcode = null;
                            }
                        }
                        // --  validate store phone
                        if (data.storePhone == null) {
                            this.errorStorePhone = null;
                        }
                        else if (data.storePhone.trim().length < 6 &&
                            data.storePhone.trim().length > 0) {
                            this.errorStorePhone = this.$translate.instant('phone_number_too_short');
                        }
                        else if (data.storePhone.trim().length > 50) {
                            this.errorStorePhone = this.$translate.instant('phone_number_too_long');
                        }
                        else {
                            this.errorStorePhone = null;
                        }
                        // --  validate store email
                        this.errorStoreEmail = null;
                        if (data.storeEmail) {
                            if (!this.definitionsService.regexEmail.test(data.storeEmail)) {
                                this.errorStoreEmail = this.$translate.instant('email_is_invalid');
                            }
                            else if (data.storeEmail.trim().length > 100) {
                                this.errorStoreEmail = this.$translate.instant('email_too_long');
                            }
                        }
                        // -- validate store Website
                        if (data.storeWebsite == null ||
                            data.storeWebsite.trim().length === 0) {
                            this.errorStoreWebsite = null;
                        }
                        else if (!this.definitionsService.regexUrl.test(data.storeWebsite)) {
                            this.errorStoreWebsite = this.$translate.instant('url_is_invalid');
                        }
                        else if (data.storeWebsite.trim().length > 256) {
                            this.errorStoreWebsite = this.$translate.instant('url_too_long');
                        }
                        else {
                            this.errorStoreWebsite = null;
                        }
                        this.storeform.$invalid =
                            this.errorStoreName != null ||
                                this.errorStoreDescription != null ||
                                this.errorStoreAddressLine1 != null ||
                                this.errorStoreAddressLine2 != null ||
                                this.errorStoreTown != null ||
                                this.errorStorePostcode != null ||
                                this.errorStorePhone != null ||
                                this.errorStoreEmail != null ||
                                this.errorStoreWebsite != null ||
                                this.errorStoreBusinessType != null;
                        if (!(this.maps.markerEdit == null)) return [3 /*break*/, 3];
                        if (!!this.storeform.$invalid) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'positionIsNotSetDialogComponent',
                                windowClass: 'base-modal',
                                resolve: {
                                    contentTranslateKey: function () { return 'drop_a_pin_to_the'; }
                                }
                            }).result];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, 'something'];
                    case 3:
                        this.errorStoreMap = null;
                        _a.label = 4;
                    case 4:
                        if (this.storeform.$invalid) {
                            return [2 /*return*/, 'something'];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    ShopStoreController.prototype.storeFormCancel = function () {
        this.storeform.$invalid = false;
        this.errorStoreName = null;
        this.errorStoreDescription = null;
        this.errorStoreAddressLine1 = null;
        this.errorStoreAddressLine2 = null;
        this.errorStoreTown = null;
        this.errorStorePostcode = null;
        this.errorStorePhone = null;
        this.errorStoreEmail = null;
        this.errorStoreWebsite = null;
    };
    ShopStoreController.prototype.mapDragStart = function () {
        this.maps.edit.setOptions({ draggingCursor: 'move' });
    };
    ShopStoreController.prototype.mapDragend = function () {
        this.maps.edit.setOptions({ draggingCursor: 'default' });
    };
    ShopStoreController.prototype.setMarker = function ($event, $params) {
        if (this.maps.edit == null) {
            this.resizeGoogleMaps();
            return;
        }
        if (this.maps.markerEdit != null) {
            this.maps.markerEdit.setMap(null);
        }
        this.storeform.$pristine = false;
        this.maps.markerEdit = new this.googleMaps.Marker({
            map: this.maps.edit,
            position: $params[0].latLng,
            title: this.store.Name,
            draggable: true
        });
        this.maps.edit.setCenter($params[0].latLng);
    };
    ShopStoreController.prototype.mapLoaded = function (name) {
        if (this.storeform.$visible && !this.maps.loadedEdit) {
            this.maps.loadedEdit = true;
            this.reloadGoogleMaps();
        }
        else if (!this.storeform.$visible && !this.maps.loadedView) {
            this.maps.loadedView = true;
            this.reloadGoogleMaps();
        }
    };
    ShopStoreController.prototype.openMarkerInfo = function (map, marker) {
        var _this = this;
        new this.googleMaps.Geocoder().geocode({ location: marker.getPosition() }, function (results, status) {
            if (status === _this.googleMaps.GeocoderStatus.OK) {
                _this.maps.infoWindow.setContent(results[0].formatted_address);
                _this.maps.infoWindow.open(map, marker);
            }
        });
    };
    ShopStoreController.prototype.selectBusinessType = function ($item, $model) {
        this.phoneScroll();
    };
    ShopStoreController.prototype.trustAsHtml = function (html) {
        return this.$sce.trustAsHtml(html);
    };
    ShopStoreController.prototype.getLocationFromAdrress = function ($event) {
        var _this = this;
        var address = this.getAddressOfForm();
        var geocoder = new this.googleMaps.Geocoder();
        geocoder.geocode({
            address: address
        }, function (results, status) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(status === this.googleMaps.GeocoderStatus.OK)) return [3 /*break*/, 1];
                        this.setMarker(null, [
                            { latLng: results[0].geometry.location }
                        ]);
                        this.maps.edit.setZoom(this.maps.zoom);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.$uibModal.open({
                            component: 'cantDeterminePositionComponent',
                            windowClass: 'base-modal',
                            appendTo: this.$document.find('.containerGmap '),
                            resolve: {
                                contentTranslateKey: function () { return 'position_doesnt_coincide_of_location'; }
                            }
                        }).result];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        $event.preventDefault();
        $event.stopPropagation();
    };
    ShopStoreController.prototype.changeEndDateMinDate = function () {
        this.dateEndOptions.minDate = new Date(this.store.ExhibitionStartDate.toString());
    };
    ShopStoreController.prototype.changeStartDateMaxDate = function () {
        this.dateOptions.maxDate = new Date(this.store.ExhibitionEndDate.toString());
    };
    ShopStoreController.prototype.setDefaultMapLocation = function () {
        // 578 = Norway, 826 = UK, 840 = USA, 978 = Europe, 784 = UAE, 372 = Ireland
        switch (this.Country.Code) {
            case 578: {
                this.maps.defaultLatLng = { lat: 59.9145019, lng: 10.7566006 };
                break;
            }
            case 826: {
                this.maps.defaultLatLng = { lat: 51.500152, lng: -0.126236 };
                break;
            }
            case 840: {
                this.maps.defaultLatLng = { lat: 40.7127, lng: -74.0059 };
                break;
            }
            case 978: {
                this.maps.defaultLatLng = { lat: 50.8450465, lng: 4.3500418 };
                break;
            }
            case 784: {
                this.maps.defaultLatLng = { lat: 25.0657000, lng: 55.1712800 };
                break;
            }
            case 372: {
                this.maps.defaultLatLng = { lat: 53.342754, lng: -6.271849 };
                break;
            }
        }
    };
    ShopStoreController.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, response, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.shopService.getCountry()];
                    case 1:
                        _a.Country = _b.sent();
                        this.setDefaultMapLocation();
                        return [4 /*yield*/, this.$q.all([
                                this.shopService.getBusinessTypes(),
                                this.googleMapService.getGoogleMaps()
                            ])];
                    case 2:
                        response = _b.sent();
                        this.businessTypes = response[0];
                        this.googleMaps = response[1];
                        if (this.shopID == null) {
                            this.store = {
                                Name: null,
                                AddressLine1: null,
                                AddressLine2: null,
                                BusinessType: null,
                                ContactEmail: null,
                                ContactPhoneNumber: null,
                                County: this.Country.Name,
                                Description: null,
                                Latitude: null,
                                Longitude: null,
                                Town: null,
                                PostCode: null,
                                BookingTableEnabled: false,
                                LoyaltyProgramID: null,
                                ExhibitionStartDate: this.defaultExhibitionDate.getStart(),
                                ExhibitionEndDate: this.defaultExhibitionDate.getEnd(this.defaultExhibitionDate.end),
                                type: null
                            };
                            this.$scope.$emit('setStore', this.store);
                            this.storeform.$show();
                            this.setGoogleMaps(null, null);
                            this.dateOptions.maxDate = this.store.ExhibitionEndDate;
                            this.dateEndOptions.minDate = this.store.ExhibitionStartDate;
                        }
                        else {
                            this.getStore(this.shopID);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ShopStoreController.prototype.getStore = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.storeform.$waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.shopService.getStore(id)];
                    case 2:
                        _a.store = _b.sent();
                        this.store.ExhibitionStartDate = this.store.ExhibitionStartDate
                            ? this.getLocalDate(this.store.ExhibitionStartDate)
                            : this.defaultExhibitionDate.start;
                        this.store.ExhibitionEndDate = this.store.ExhibitionEndDate
                            ? this.getLocalDate(this.store.ExhibitionEndDate)
                            : this.defaultExhibitionDate.end;
                        this.store.type = _.findWhere(this.businessTypes, {
                            value: this.store.BusinessType
                        });
                        this.storeStandard = angular.copy(this.store);
                        this.$rootScope.app.description = this.store.Name;
                        this.$scope.$emit('setStore', this.store);
                        this.setGoogleMaps(this.store.Latitude, this.store.Longitude);
                        this.notificationService.clearAll();
                        this.dateOptions.maxDate = this.store.ExhibitionEndDate;
                        this.dateEndOptions.minDate = this.store.ExhibitionStartDate;
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.store = null;
                        this.shopID = null;
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.storeform.$waiting = false;
                        this.phoneScroll();
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopStoreController.prototype.getLocalDate = function (sourceDate) {
        var date = new Date(sourceDate.toString());
        date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
        return date;
    };
    ShopStoreController.prototype._saveStore = function () {
        if (this.shopID) {
            this.updateStore();
        }
        else {
            this.createStore();
        }
    };
    ShopStoreController.prototype.createStore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var id_1, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.storeform.$waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.shopService.createStore(this.getServerModel())];
                    case 2:
                        id_1 = _a.sent();
                        this.notificationService.showSuccessMessage({
                            body: this.$translate.instant('place_created')
                        });
                        this.$timeout(function () {
                            _this.$rootScope.$state.go('app.shop', { id: id_1 });
                        }, 1000);
                        this.storeStandard = angular.copy(this.store);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.notificationService.showErrorMessage(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        if (this.storeform) {
                            this.$timeout(function () {
                                _this.storeform.$waiting = false;
                            }, 1500);
                        }
                        return [2 /*return*/, 'something'];
                }
            });
        });
    };
    ShopStoreController.prototype.updateStore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.storeform.$waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        if (this.storeStandard.LoyaltyProgramID) {
                            if (this.storeStandard.Name.trim().toLowerCase() !==
                                this.store.Name.trim().toLowerCase()) {
                                throw new Error('Can\'t change store name, because loyalty program already running for this store.');
                            }
                            if (this.storeStandard.Town.trim().toLowerCase() !==
                                this.store.Town.trim().toLowerCase()) {
                                throw new Error('Can\'t change town, because loyalty program already running for this store.');
                            }
                        }
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.shopService.updateStore(this.shopID, this.getServerModel())];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.storeform.$cancel();
                        this.storeform.$setPristine();
                        this.$scope.$emit('openStore', false);
                        this.$scope.$emit('updateStore', this.store);
                        this.maps.optionsEdit.center = this.maps.markerEdit.getPosition();
                        this.maps.optionsView.center = this.maps.markerEdit.getPosition();
                        this.maps.loadedView = false;
                        this.storeStandard = angular.copy(this.store);
                        this.storeform.$waiting = false;
                        this.$timeout(this.reloadGoogleMaps.bind(this));
                        return [2 /*return*/, null];
                    case 3:
                        error_5 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_5)) {
                            this.notificationService.showErrorMessage(error_5);
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        this.storeform.$waiting = false;
                        return [2 /*return*/, 'something'];
                }
            });
        });
    };
    ShopStoreController.prototype.getServerModel = function () {
        var position = this.maps.markerEdit.getPosition();
        this.store.Latitude = position.lat();
        this.store.Longitude = position.lng();
        this.store.BusinessType = this.store.type.value;
        var model = angular.copy(this.store);
        if (model.BusinessType === this.enumBusinessType.Exhibition) {
            model.ExhibitionStartDate.setHours(model.ExhibitionStartDate.getHours() -
                model.ExhibitionStartDate.getTimezoneOffset() / 60);
            model.ExhibitionEndDate.setHours(model.ExhibitionEndDate.getHours() -
                model.ExhibitionEndDate.getTimezoneOffset() / 60);
        }
        else {
            model.ExhibitionEndDate = null;
            model.ExhibitionStartDate = null;
        }
        return model;
    };
    // google maps
    ShopStoreController.prototype.setGoogleMaps = function (lat, lng) {
        var position = null;
        if (lat === null || lng === null) {
            position = new this.googleMaps.LatLng(this.maps.defaultLatLng.lat, this.maps.defaultLatLng.lng);
        }
        else {
            position = new this.googleMaps.LatLng(lat, lng);
        }
        this.maps.optionsEdit = {
            center: position,
            zoom: this.maps.zoom,
            mapTypeId: this.googleMaps.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: true,
            disableDefaultUI: true,
            disableDoubleClickZoom: false,
            scaleControl: true,
            draggableCursor: 'default',
            draggingCursor: 'default'
        };
        this.maps.infoWindow = new this.googleMaps.InfoWindow();
        this.maps.optionsView = angular.copy(this.maps.optionsEdit);
        this.maps.optionsView.draggingCursor = 'move';
        this.resizeGoogleMaps();
    };
    ShopStoreController.prototype.resizeGoogleMaps = function () {
        var _this = this;
        this.$timeout(function () {
            if (!_this.storeform) {
                return;
            }
            if (_this.storeform.$visible && _this.maps.edit != null) {
                _this.googleMaps.event.trigger(_this.maps.edit, 'resize');
            }
            else if (_this.maps.view != null) {
                _this.googleMaps.event.trigger(_this.maps.view, 'resize');
            }
        }, 300);
    };
    ShopStoreController.prototype.reloadGoogleMaps = function () {
        var _this = this;
        if (this.storeform.$visible) {
            if (this.shopID == null && this.maps.edit != null) {
                this.maps.edit.setCenter(this.maps.optionsEdit.center);
            }
            else {
                if (this.maps.markerEdit != null) {
                    this.maps.markerEdit.setMap(null);
                }
                this.maps.markerEdit = new this.googleMaps.Marker({
                    map: this.maps.edit,
                    position: this.maps.optionsEdit.center,
                    title: this.store.Name,
                    draggable: true
                });
                this.maps.markerEdit.addListener('drag', function (event) {
                    _this.storeform.$pristine = false;
                });
                if (this.maps.edit != null) {
                    this.maps.edit.setCenter(this.maps.optionsEdit.center);
                }
            }
        }
        else if (!this.storeform.$visible && this.maps.view != null) {
            if (this.shopID === null) {
                this.maps.view.setCenter(this.maps.optionsView.center);
            }
            else {
                if (this.maps.markerView !== null) {
                    this.maps.markerView.setMap(null);
                }
                this.maps.markerView = new this.googleMaps.Marker({
                    map: this.maps.view,
                    position: this.maps.optionsView.center,
                    title: this.store.Name
                });
                this.maps.view.setCenter(this.maps.optionsView.center);
            }
        }
        this.resizeGoogleMaps();
    };
    ShopStoreController.prototype.computeDistanceBetween = function () {
        var _this = this;
        var deferred = this.$q.defer();
        if (this.isChangedLocation()) {
            var address = this.getAddressOfForm();
            var geocoder = new this.googleMaps.Geocoder();
            geocoder.geocode({ address: address }, function (results, status) {
                if (status === _this.googleMaps.GeocoderStatus.OK) {
                    var computeDistance = _this.googleMaps.geometry.spherical.computeDistanceBetween(_this.maps.markerEdit.getPosition(), results[0].geometry.location);
                    if (_.isNumber(computeDistance) &&
                        computeDistance <= _this.maps.validDistance) {
                        deferred.resolve(_this._saveStore.bind(_this));
                    }
                    else if (!_.isNumber(computeDistance)) {
                        deferred.resolve(_this.couldNotGetLocationDialog.bind(_this));
                    }
                    else if (_.isNumber(computeDistance) &&
                        computeDistance > _this.maps.validDistance) {
                        deferred.resolve(_this.placeNotCoincideAddressDialog.bind(_this));
                    }
                }
                else {
                    deferred.resolve(_this.couldNotGetLocationDialog.bind(_this));
                }
            });
        }
        else {
            return this.$q.when(this._saveStore.bind(this));
        }
        return deferred.promise;
    };
    ShopStoreController.prototype.placeNotCoincideAddressDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'positionDiffersDialogComponent',
                            windowClass: 'base-modal',
                            resolve: {
                                contentTranslateKey: function () { return 'position_doesnt_coincide_of_location'; }
                            }
                        }).result];
                    case 1:
                        res = _a.sent();
                        if (!res) {
                            this._saveStore();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShopStoreController.prototype.getAddressOfForm = function () {
        var _a = this.storeform, storeTown = _a.storeTown, storeAddressLine1 = _a.storeAddressLine1;
        var currentAddress;
        if (!storeTown.$$rawModelValue && !storeAddressLine1.$$rawModelValue) {
            currentAddress = '';
        }
        else {
            currentAddress = [
                storeTown.$$rawModelValue,
                storeAddressLine1.$$rawModelValue
            ].join(', ');
        }
        return currentAddress;
    };
    ShopStoreController.prototype.isChangedLocation = function () {
        if (this.store === null || this.maps.markerEdit === null) {
            return true;
        }
        else {
            var position = this.maps.markerEdit.getPosition();
            return (this.storeStandard == null ||
                this.store.AddressLine1 !== this.storeStandard.AddressLine1 ||
                this.store.Town !== this.storeStandard.Town ||
                this.store.County !== this.storeStandard.County ||
                this.store.Latitude !== position.lat() ||
                this.store.Longitude !== position.lng());
        }
    };
    ShopStoreController.prototype.couldNotGetLocationDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'positionDiffersDialogComponent',
                            windowClass: 'base-modal',
                            resolve: {
                                contentTranslateKey: function () { return 'cant_locate_your_address'; }
                            }
                        }).result];
                    case 1:
                        res = _a.sent();
                        if (!res) {
                            this._saveStore();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // others
    ShopStoreController.prototype.phoneScroll = function () {
        $('.phoneScrollSelector').slimScroll({
            height: 'auto',
            size: '6px',
            alwaysVisible: true
        });
    };
    ShopStoreController.$inject = [
        '$rootScope',
        '$scope',
        '$q',
        '$sce',
        '$document',
        '$timeout',
        'appWysiwygOptions',
        'shopService',
        'notificationService',
        'popupService',
        'googleMapService',
        'wysiwygService',
        'definitionsService',
        '$translate',
        '$uibModal'
    ];
    return ShopStoreController;
}(wysiwygControllerBase_1.WysiwygControllerBase));
exports.ShopStoreController = ShopStoreController;
angular.module('naut').component('shopStore', {
    template: __webpack_require__(814),
    controller: ShopStoreController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<'
    }
});


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var popupServiceCancel_1 = __webpack_require__(5);
var ShopsController = /** @class */ (function () {
    function ShopsController($rootScope, $scope, $q, $stateParams, $timeout, retailerService, shopService, notificationService, popupService, blobService, $translate, $uibModal) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.retailerService = retailerService;
        this.shopService = shopService;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.blobService = blobService;
        this.$translate = $translate;
        this.$uibModal = $uibModal;
        this.showActiveShop = decodeURIComponent(this.$stateParams.active).toLowerCase() !== 'false';
        this.waiting = false;
        this.storeName = '';
        this.file = {
            cover: null,
            logo: null
        };
        this.size = {
            cover: {
                thumb: { w: 320, h: 160 },
                w: 1200,
                h: 600,
                file: 10
            },
            logo: {
                thumb: { w: 66, h: 66 },
                w: 210,
                h: 210,
                file: 5
            }
        };
        this.settings = {
            active: {
                total: 0,
                pageSize: 8,
                page: 1
            },
            archived: {
                total: 0,
                pageSize: 8,
                page: 1
            },
            getPagingSettings: function (_active, _storeName) {
                return {
                    limit: _active ? _this.settings.active.pageSize : _this.settings.archived.pageSize,
                    offset: _active ? ((_this.settings.active.page - 1) * _this.settings.active.pageSize) : ((_this.settings.archived.page - 1) * _this.settings.archived.pageSize),
                    active: _active,
                    sortColumn: '',
                    sortOrder: '',
                    storeName: _storeName
                };
            }
        };
        this.tooltip = {
            websiteUrl: this.$translate.instant('add_website_url'),
            description: this.$translate.instant('enter_place_description'),
            openingHours: this.$translate.instant('opening_hours_tooltip'),
            inventoryType: this.$translate.instant('inventory_type_tooltip'),
            campaigns: this.$translate.instant('campaigns_tooltip'),
            cover: 'Min ' + this.size.cover.w + '×' + this.size.cover.w + 'px, max ' + this.size.cover.file + 'MB',
            logo: 'Min ' + this.size.logo.w + '×' + this.size.logo.w + 'px, max ' + this.size.logo.file + 'MB'
        };
        this.businessTypes = [];
        this.isOnLogoEdit = false;
        this.uploadCover = function (shop) {
            var el = angular.element('#coverStore');
            _this.$timeout(function () {
                _this.uploadedCover = function () { this._uploadedCover(shop); };
                el.click();
            });
        };
        this.uploadLogo = function (store) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var minSize, image, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isOnLogoEdit) {
                            return [2 /*return*/];
                        }
                        minSize = {
                            w: this.size.logo.w,
                            h: this.size.logo.h
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        this.isOnLogoEdit = true;
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return store.LogoID; },
                                    title: function () { return _this.$translate.instant('store_photo'); },
                                    sizeText: function () {
                                        return _this.$translate.instant('store_photo_min_size_hint', { width: 210, height: 210 });
                                    },
                                    getUrl: function () { return store.LogoID === null || _this.getImage(store.LogoID); },
                                    imageSize: function () { return minSize; }
                                },
                                backdrop: 'static'
                            }).result];
                    case 2:
                        image = _a.sent();
                        if (!image) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.afterUploadHandling(store, image)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 6:
                        this.isOnLogoEdit = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this.removeCover = function (shop) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('remove_cover'),
                                content: "<p>" + this.$translate.instant('remove_cover_confirm') + "</p>",
                                cancelClass: 'btn-success',
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this._removeCover(shop);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.removeLogo = function (shop) { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('remove_logo'),
                                content: "<p>" + this.$translate.instant('remove_logo_confirm') + "</p>",
                                cancelClass: 'btn-success',
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this._removeLogo(shop);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.restore = function (shopId) { return __awaiter(_this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('restore_place'),
                                content: "<p>" + this.$translate.instant('restore_place_promt') + "</p>",
                                cancelClass: 'btn-success',
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.shopService.restoreStore(shopId)];
                    case 2:
                        _a.sent();
                        this.notificationService.clearAll();
                        this.waiting = false;
                        this.$rootScope.$state.go('app.shop', { id: shopId });
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_4)) {
                            this.notificationService.showErrorMessage(error_4);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.$onInit = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get()];
                    case 1:
                        _a.sent();
                        this.$scope.$watchGroup(['vm.settings.active.page', 'vm.settings.archived.page'], this.get);
                        return [2 /*return*/];
                }
            });
        }); };
        this.get = function () { return __awaiter(_this, void 0, void 0, function () {
            var storeName, response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        storeName = this.storeName.trim();
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([this.shopService.getStores(this.settings.getPagingSettings(true, storeName)), this.shopService.getStores(this.settings.getPagingSettings(false, storeName)), this.$q.when(this.shopService.getBusinessTypes())])];
                    case 2:
                        response = _a.sent();
                        this.shops = response[0].Items;
                        this.archivedShops = response[1].Items;
                        this.settings.active.total = response[0].Total;
                        this.settings.archived.total = response[1].Total;
                        this.businessTypes = response[2];
                        if (this.settings.active.total === 0 && this.settings.archived.total === 0) {
                            this.showActiveShop = true;
                        }
                        this.setClientModel(this.shops, this.businessTypes);
                        this.setClientModel(this.archivedShops, this.businessTypes);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this._removeLogo = function (store) { return __awaiter(_this, void 0, void 0, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.shopService.removeLogo(store.LogoID)];
                    case 2:
                        if (_a.sent()) {
                            this.notificationService.showSuccessMessage();
                            store.logoUrl = null;
                            store.LogoID = null;
                        }
                        else {
                            this.notificationService.showErrorMessage();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        this.notificationService.showErrorMessage(error_6);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.setClientModel = function (shops, types) {
            _.forEach(shops, function (shop) {
                shop.businessType = _.findWhere(types, { value: shop.BusinessType });
                shop.coverUrl = shop.CoverID ? _this.retailerService.getStoreCoverUrl(shop.CoverID, _this.size.cover.thumb.w, _this.size.cover.thumb.h) : null;
                shop.logoUrl = shop.LogoID ? _this.retailerService.getStoreLogoUrl(shop.LogoID, _this.size.logo.thumb.w, _this.size.logo.thumb.h) : null;
                shop.address = shop.Address + ", " + shop.Town;
            });
        };
        this._uploadedCover = function (store) { return __awaiter(_this, void 0, void 0, function () {
            var imageID, image, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!store || !this.file.cover) {
                            return [2 /*return*/];
                        }
                        else if (this.file.cover.error) {
                            this.notificationService.showErrorMessage(this.file.cover.error);
                            this.file.cover = null;
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.shopService.uploadCover(store.ID, this.file.cover)];
                    case 2:
                        imageID = _a.sent();
                        this.notificationService.showSuccessMessage();
                        return [4 /*yield*/, this.blobService.getDataImageByUrl(this.retailerService.getStoreCoverUrl(imageID, this.size.cover.thumb.w, this.size.cover.thumb.h))];
                    case 3:
                        image = _a.sent();
                        store.coverUrl = image.dataUri;
                        store.CoverID = imageID;
                        this.file.cover = null;
                        return [3 /*break*/, 5];
                    case 4:
                        error_7 = _a.sent();
                        this.notificationService.showErrorMessage(error_7);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.afterUploadHandling = function (store, image) { return __awaiter(_this, void 0, void 0, function () {
            var logoId, imageData, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        if (!store.LogoID) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.shopService.removeLogo(store.LogoID)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.shopService.uploadLogo(store.ID, { name: '', dataUri: image })];
                    case 4:
                        logoId = _a.sent();
                        return [4 /*yield*/, this.blobService.getDataImageByUrl(this.retailerService.getStoreLogoUrl(logoId, this.size.logo.thumb.w, this.size.logo.thumb.h))];
                    case 5:
                        imageData = _a.sent();
                        store.logoUrl = imageData.dataUri;
                        store.LogoID = logoId;
                        this.file.logo = null;
                        this.notificationService.showSuccessMessage();
                        return [3 /*break*/, 8];
                    case 6:
                        error_8 = _a.sent();
                        this.notificationService.showErrorMessage(error_8);
                        return [3 /*break*/, 8];
                    case 7:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        this._removeCover = function (store) { return __awaiter(_this, void 0, void 0, function () {
            var error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.shopService.removeCover(store.CoverID)];
                    case 2:
                        if (_a.sent()) {
                            this.notificationService.showSuccessMessage();
                            store.coverUrl = null;
                            store.CoverID = null;
                        }
                        else {
                            this.notificationService.showErrorMessage();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        this.notificationService.showErrorMessage(error_9);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        var unwatch = $rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userData.permission) {
                    unwatch();
                    this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                }
                return [2 /*return*/];
            });
        }); }, true);
    }
    ShopsController.prototype.isShowInventory = function (type) {
        return this.shopService.isShowInventory(type);
    };
    ShopsController.prototype.getImage = function (logoId) {
        return __awaiter(this, void 0, void 0, function () {
            var currentImage, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!logoId) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.blobService.getDataImageByUrl(this.retailerService.getStoreLogoUrl(logoId))];
                    case 2:
                        currentImage = _a.sent();
                        return [2 /*return*/, currentImage.dataUri];
                    case 3:
                        error_10 = _a.sent();
                        this.notificationService.showErrorMessage(error_10);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    ShopsController.$inject = ['$rootScope', '$scope', '$q', '$stateParams', '$timeout', 'retailerService', 'shopService', 'notificationService', 'popupService', 'blobService', '$translate', '$uibModal'];
    return ShopsController;
}());
exports.ShopsController = ShopsController;
angular.module('naut').component('shops', {
    template: __webpack_require__(815),
    controller: ShopsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ShopService = /** @class */ (function () {
    function ShopService(http, retailerService, blobService, enumService, accountService) {
        var _this = this;
        this.http = http;
        this.retailerService = retailerService;
        this.blobService = blobService;
        this.enumService = enumService;
        this.accountService = accountService;
        this.getStores = function (settings) {
            return _this.http.get(_this.retailerService.stores(), { params: settings });
        };
        this.getStore = function (id) {
            return _this.http.get(_this.retailerService.store(id));
        };
        this.getStoresForRules = function () {
            return _this.http.get(_this.retailerService.storesForRules());
        };
        this.getOpeningHours = function (id) {
            return _this.http.get(_this.retailerService.openingHours(id));
        };
        this.storeExist = function (name, cb) {
            return _this.http.get(_this.retailerService.storeExist(name));
        };
        this.updateOpeningHours = function (id, data) {
            return _this.http.post(_this.retailerService.openingHours(id), data);
        };
        this.updateStore = function (id, store) {
            _this.prepareStoreBeforeSaving(store);
            return _this.http.put(_this.retailerService.store(id), store);
        };
        this.archiveStore = function (id) {
            return _this.http.post(_this.retailerService.archiveStore(id), null);
        };
        this.restoreStore = function (id) {
            return _this.http.post(_this.retailerService.restoreStore(id), null);
        };
        this.createStore = function (store) {
            _this.prepareStoreBeforeSaving(store);
            return _this.http.post(_this.retailerService.store(), store);
        };
        this.getStoreCampaigns = function (id) {
            return _this.http.get(_this.retailerService.storeCampaigns(id));
        };
        this.getBusinessTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var languageId, types, regex, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        languageId = this.accountService.userData.languageID;
                        if (!_.isEmpty(this.businessTypes[languageId])) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.http.get(this.retailerService.storeBusinessTypes())];
                    case 1:
                        types = _a.sent();
                        regex = new RegExp('\\W+', 'g');
                        this.businessTypes[languageId] = [];
                        for (key in types) {
                            if (types.hasOwnProperty(key)) {
                                this.businessTypes[languageId].push({
                                    name: key,
                                    value: types[key],
                                    iconClass: key.toLowerCase().replace(regex, '')
                                });
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.businessTypes[languageId]];
                }
            });
        }); };
        this.uploadCover = function (shopID, file) {
            if (!file) {
                throw new Error('The file is absent.');
            }
            var fd = new FormData();
            fd.append('FileImage', _this.blobService.dataUriToBlob(file.dataUri), file.name);
            return _this.http.post(_this.retailerService.storeCover(shopID), fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };
        this.uploadLogo = function (shopID, file) {
            if (!file) {
                throw new Error('The file is absent.');
            }
            var fd = new FormData();
            fd.append('FileImage', _this.blobService.dataUriToBlob(file.dataUri), file.name);
            return _this.http.post(_this.retailerService.storeLogo(shopID), fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };
        this.removeLogo = function (shopID) {
            return _this.http["delete"](_this.retailerService.storeLogo(shopID));
        };
        this.removeCover = function (shopID) {
            return _this.http["delete"](_this.retailerService.storeCover(shopID));
        };
        this.getStoresForJispPay = function () {
            return _this.http.get(_this.retailerService.storesForJispPay());
        };
        this.prepareStoreBeforeSaving = function (store) {
            if (store.AddressLine2 != null && (store.AddressLine2.length === 0 || !store.AddressLine2.trim())) {
                store.AddressLine2 = null;
            }
            if (store.ContactEmail != null && (store.ContactEmail.length === 0 || !store.ContactEmail.trim())) {
                store.ContactEmail = null;
            }
            if (store.ContactPhoneNumber != null && (store.ContactPhoneNumber.length === 0 || !store.ContactPhoneNumber.trim())) {
                store.ContactPhoneNumber = null;
            }
            if (store.WebsiteUrl != null && (store.WebsiteUrl.length === 0 || !store.WebsiteUrl.trim())) {
                store.WebsiteUrl = null;
            }
            if (store.Description != null && (store.Description.length === 0 || !store.Description.trim())) {
                store.Description = null;
            }
            if (store.Description != null && (store.Description.length === 0 || !store.Description.trim())) {
                store.Description = null;
            }
            if (store.type != null) {
                store.BusinessType = store.type.value;
            }
        };
        this.businessTypes = {};
    }
    ShopService.prototype.getStoresForManager = function () {
        return this.http.get(this.retailerService.storesForManager());
    };
    ShopService.prototype.isShowInventory = function (businessType) {
        var type = this.enumService.BusinessType;
        return businessType !== type.ShoppingCentre && businessType !== type.Exhibition && businessType !== type.Exhibitor;
    };
    ShopService.prototype.getEnumBusinessType = function () {
        return this.enumService.BusinessType;
    };
    ShopService.prototype.getStoresForFilter = function () {
        return this.http.get(this.retailerService.storesForFilter());
    };
    ShopService.prototype.getCountry = function () {
        return this.http.get(this.retailerService.country()).then(function (country) {
            return country;
        });
    };
    ShopService.prototype.getTablesEnabled = function (shopID) {
        return this.http.get(this.retailerService.tablesEnabled(shopID));
    };
    ShopService.prototype.setTablesEnabled = function (shopID, isEnabled) {
        var model = {
            Value: isEnabled
        };
        return this.http.post(this.retailerService.setTablesEnabled(shopID), model);
    };
    ShopService.prototype.setTablesMandatory = function (shopID, isMandatory) {
        var model = {
            Value: isMandatory
        };
        return this.http.post(this.retailerService.setTablesMandatory(shopID), model);
    };
    ShopService.prototype.getTables = function (shopID) {
        return this.http.get(this.retailerService.tables(shopID));
    };
    ShopService.prototype.addOrUpdateTables = function (shopID, tableModels) {
        var model = {
            Items: tableModels
        };
        return this.http.post(this.retailerService.tables(shopID), model);
    };
    ShopService.prototype.deleteTables = function (shopID, tableIDs) {
        var model = {
            ItemsId: tableIDs
        };
        var headers = {
            'Content-Type': 'application/json'
        };
        return this.http["delete"](this.retailerService.tables(shopID), { headers: headers, data: model });
    };
    ShopService.prototype.isTableExist = function (shopID, tableName) {
        return this.http.get(this.retailerService.tableExist(shopID, tableName));
    };
    ShopService.$inject = ['http', 'retailerService', 'blobService', 'enumService', 'accountService'];
    return ShopService;
}());
exports.ShopService = ShopService;
angular.module('naut').service('shopService', ShopService);


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddEditPrinterComponent = /** @class */ (function () {
    function AddEditPrinterComponent(notificationService, $state, $translate, printersService, retailerService, $uibModal) {
        this.notificationService = notificationService;
        this.$state = $state;
        this.$translate = $translate;
        this.printersService = printersService;
        this.retailerService = retailerService;
        this.$uibModal = $uibModal;
        this.waiting = false;
        this.copyValues = Array.from(Array(6).keys()).filter(function (item) { return item > 0; });
        this.buzzValues = Array.from(Array(4).keys());
        this.defaultPrinter = {
            PlaceDetails: null,
            PrinterID: null,
            PrinterPath: null,
            PrinterAccessID: null,
            CopyCount: 1,
            StartBuzzer: 1,
            EndBuzzer: 0
        };
    }
    AddEditPrinterComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var printerID, placeID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        printerID = parseInt(this.$state.params.printerID, 10);
                        placeID = parseInt(this.$state.params.placeID, 10);
                        this.isNew = isNaN(printerID) || isNaN(placeID);
                        if (!!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadData(printerID, placeID)];
                    case 1:
                        _a.sent();
                        this.originPlaceID = placeID;
                        return [3 /*break*/, 3];
                    case 2:
                        this.printer = __assign({}, this.defaultPrinter);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddEditPrinterComponent.prototype.getLogoUrl = function (iconId) {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    };
    AddEditPrinterComponent.prototype.selectLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var operationResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$uibModal.open({
                            component: 'selectSingleLocation',
                            resolve: { options: function () {
                                    return {
                                        selectedLocationID: _this.printer.PlaceDetails ? _this.printer.PlaceDetails.PlaceID : null,
                                        onlyWithoutPrinter: true
                                    };
                                } },
                            size: 'md',
                            backdrop: 'static',
                            windowClass: 'modal-design-v2'
                        }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult.status === 'ok') {
                            this.printer.PlaceDetails = {
                                PlaceID: operationResult.selectedLocation.ID,
                                Name: operationResult.selectedLocation.Name,
                                IconId: operationResult.selectedLocation.LogoID,
                                Town: operationResult.selectedLocation.Town,
                                AddressLine1: operationResult.selectedLocation.Address,
                                AddressLine2: null,
                                PostCode: null
                            };
                            this.form.$setDirty();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddEditPrinterComponent.prototype.removeLocation = function () {
        this.printer.PlaceDetails = null;
        this.form.$setDirty();
    };
    AddEditPrinterComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var savingData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.form.$valid || !this.printer.PlaceDetails) {
                            this.notificationService.showErrorMessage(this.$translate.instant('form_has_errors'));
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        savingData = this.getSavingData();
                        if (!this.isNew) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.printersService.createPrinter(savingData)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.printersService.updatePrinter(savingData)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.notificationService.showSuccessMessage();
                        this.waiting = false;
                        this.$state.go('app.printers.list');
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.waiting = false;
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AddEditPrinterComponent.prototype.loadData = function (printerID, placeID) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.printersService.getPrinter(printerID, placeID)];
                    case 2:
                        _a.printer = _b.sent();
                        this.notificationService.clearAll();
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.notificationService.showErrorMessage(error_2);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddEditPrinterComponent.prototype.getSavingData = function () {
        var data = {
            PrinterPath: this.printer.PrinterPath,
            PrinterAccessID: this.printer.PrinterAccessID,
            CopyCount: this.printer.CopyCount,
            StartBuzzer: this.printer.StartBuzzer,
            EndBuzzer: this.printer.EndBuzzer,
            PlaceID: this.printer.PlaceDetails.PlaceID
        };
        if (!this.isNew) {
            data.PrinterID = this.printer.PrinterID;
        }
        return data;
    };
    AddEditPrinterComponent.$inject = [
        'notificationService',
        '$state',
        '$translate',
        'printersService',
        'retailerService',
        '$uibModal'
    ];
    return AddEditPrinterComponent;
}());
angular.module('naut').component('addEditPrinterComponent', {
    template: __webpack_require__(816),
    controller: AddEditPrinterComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var models_1 = __webpack_require__(245);
var PrinterListComponent = /** @class */ (function () {
    function PrinterListComponent($translate, notificationService, printersService, popupService, retailerService) {
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.printersService = printersService;
        this.popupService = popupService;
        this.retailerService = retailerService;
        this.statuses = models_1.TestPrintStatusEnum;
    }
    PrinterListComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PrinterListComponent.prototype.getLogoUrl = function (iconId) {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    };
    PrinterListComponent.prototype.deletePrinterConfirm = function (printer) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('delete_printer_title'),
                                content: "<div style=\"word-break: break-all; padding-top: 8px;\">" + this.$translate.instant('delete_printer_content') + "</div>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('delete'),
                                hasIcon: true,
                                thinTitle: true
                            })];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.deletePrinterRequest(printer);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PrinterListComponent.prototype.testPrinter = function (printer) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        printer.IsTestPrinting = true;
                        printer.Status = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.printersService.testPrint(printer.PrinterID, printer.PlaceDetails.PlaceID)];
                    case 2:
                        response = _a.sent();
                        printer.Status = response.Status;
                        printer.IsTestPrinting = false;
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        printer.IsTestPrinting = false;
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PrinterListComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.printersService.getPrinterList()];
                    case 2:
                        _a.printerList = _b.sent();
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PrinterListComponent.prototype.deletePrinterRequest = function (printer) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.printersService.deletePrinter(printer.PrinterID, printer.PlaceDetails.PlaceID)];
                    case 2:
                        _a.sent();
                        this.waiting = false;
                        this.notificationService.showSuccessMessage();
                        this.printerList = this.printerList.filter(function (item) { return item.PrinterID !== printer.PrinterID; });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PrinterListComponent.$inject = [
        '$translate',
        'notificationService',
        'printersService',
        'popupService',
        'retailerService',
    ];
    return PrinterListComponent;
}());
angular.module('naut').component('printerListComponent', {
    template: __webpack_require__(817),
    controller: PrinterListComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var PrintersService = /** @class */ (function () {
    function PrintersService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    PrintersService.prototype.getPrinterList = function () {
        return this.http.get(this.retailerService.printerSettings());
    };
    PrintersService.prototype.getPrinter = function (printerID, placeID) {
        var params = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http.get(this.retailerService.printerSettingsByPrinter(), { params: params });
    };
    PrintersService.prototype.createPrinter = function (printer) {
        return this.http.post(this.retailerService.printerSettings(), printer);
    };
    PrintersService.prototype.updatePrinter = function (printer) {
        return this.http.put(this.retailerService.printerSettings(), printer);
    };
    PrintersService.prototype.deletePrinter = function (printerID, placeID) {
        var data = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http["delete"](this.retailerService.printerSettings(), {
            data: data,
            headers: { 'Content-Type': 'application/json' }
        });
    };
    PrintersService.prototype.testPrint = function (printerID, placeID) {
        var data = {
            PrinterID: printerID,
            PlaceID: placeID
        };
        return this.http.post(this.retailerService.testPrinting(), data);
    };
    PrintersService.$inject = [
        'http',
        'retailerService'
    ];
    return PrintersService;
}());
exports.PrintersService = PrintersService;
angular
    .module('naut')
    .service('printersService', PrintersService);


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var productBase_controller_1 = __webpack_require__(84);
var AdvancedProductController = /** @class */ (function (_super) {
    __extends(AdvancedProductController, _super);
    function AdvancedProductController($rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService, categoriesSelectorService, brandsService, popupService, options, htmlService, definitionsService, wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal, transferFileService, enumService) {
        var _this = _super.call(this, $rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService, categoriesSelectorService, brandsService, popupService, options, htmlService, definitionsService, wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal) || this;
        _this.transferFileService = transferFileService;
        _this.enumService = enumService;
        _this.allowedDppAttachFileSize = 200;
        _this.allowedDppAttachExtensions = ['pdf', 'epub'];
        _this.copyVariation = function (variation) { return __awaiter(_this, void 0, void 0, function () {
            var copy, dictionary_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.model.isValidVariation(variation)) {
                            return [2 /*return*/];
                        }
                        copy = angular.copy(variation);
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        copy.imagesID = [];
                        copy.id = null;
                        this.updateSelectedSizes(copy);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.copyImage(variation.imagesID)];
                    case 2:
                        dictionary_1 = _a.sent();
                        _.forEach(variation.imagesID, function (id) {
                            var newID = dictionary_1[id];
                            if (newID) {
                                copy.imagesID.push(newID);
                            }
                        });
                        this.notificationService.showSuccessMessage({
                            title: this.$translate.instant('success'),
                            body: this.$translate.instant('variation_was_copied')
                        });
                        this.model.edit.variations.unshift(copy);
                        this.productForm.$setDirty();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.loadedModel = function () {
            if (_this.state.isNew) {
                _this.addVariation();
            }
            if (_this.productForm) {
                _this.$timeout(function () {
                    _this.productForm.$setPristine();
                });
            }
            $('.wrapUlTags.overflowY').slimScroll({
                height: '374px'
            });
            $('.textAreaCustScroll').slimScroll({
                height: '105px'
            });
        };
        _this.model.loadedModel = _this.loadedModel;
        _this.countryID = _this.$localStorage.retailerAuthorizationData.countryID;
        return _this;
    }
    AdvancedProductController.prototype.$onDestroy = function () {
        if (this.dppAttachElement) {
            this.dppAttachElement.off('click');
        }
    };
    AdvancedProductController.prototype.openIngredientsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.info({
                                classPopup: 'alert--redesign modal520',
                                title: this.$translate.instant('ingredient_info_dialog_title'),
                                content: this.$translate.instant('ingredient_info_dialog_content')
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AdvancedProductController.prototype.showIngredientAttentionIfNeed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var needShowAttentions;
            return __generator(this, function (_a) {
                needShowAttentions = this.model.edit.variations.length > 0 &&
                    this.model.edit.variations.some(function (variation) { return variation.ingredients.length > 0; });
                if (needShowAttentions) {
                    _super.prototype.showIngredientAttentionDialog.call(this);
                }
                return [2 /*return*/];
            });
        });
    };
    AdvancedProductController.prototype.changeVariationStaffDiscount = function (discountMessage) {
        var foundVariation = this.model.edit.variations.find(function (variation) { return variation.id === discountMessage.variationID; });
        if (foundVariation) {
            foundVariation.discount = discountMessage.discount;
        }
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    };
    AdvancedProductController.prototype.onChangeSpecialOffer = function (message) {
        _super.prototype.onChangeSpecialOffer.call(this, message);
    };
    AdvancedProductController.prototype.changeVariationPreparationTime = function (preparationMessage) {
        var foundVariation = this.model.edit.variations.find(function (variation) { return variation.id === preparationMessage.variationID; });
        if (foundVariation) {
            foundVariation.isHot = preparationMessage.isHot;
            foundVariation.preparationTime = preparationMessage.preparationTime;
        }
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    };
    AdvancedProductController.prototype.onIngredientChanged = function (item, variation) {
        this.productForm.$setDirty();
    };
    AdvancedProductController.prototype.openAttachWindow = function () {
        var _this = this;
        this.$timeout(function () {
            if (!_this.dppAttachElement) {
                _this.dppAttachElement = angular.element('#attachInput');
                _this.dppAttachElement.on('change', _this.addAttachment.bind(_this));
            }
            _this.dppAttachElement.click();
        });
    };
    AdvancedProductController.prototype.addAttachment = function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var files, file, fileSize, splitted, fileExtension_1, extensionAllowed, id, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        files = element.target.files;
                        if (!(files && files.length > 0)) return [3 /*break*/, 6];
                        file = files[0];
                        fileSize = file.size / (1024 * 1024);
                        splitted = file.name.split('.');
                        fileExtension_1 = splitted[splitted.length - 1];
                        extensionAllowed = !!this.allowedDppAttachExtensions.find(function (ext) {
                            return ext === fileExtension_1;
                        });
                        if (!(fileSize > this.allowedDppAttachFileSize)) return [3 /*break*/, 1];
                        this.showDppInfoDialog(this.$translate.instant('file_is_too_large'), this.$translate.instant('file_size_should_not_exceed', { value: this.allowedDppAttachFileSize }));
                        return [3 /*break*/, 6];
                    case 1:
                        if (!!extensionAllowed) return [3 /*break*/, 2];
                        this.showDppInfoDialog(this.$translate.instant('wrong_file_type'), this.$translate.instant('dpp_allowed_types_message'));
                        return [3 /*break*/, 6];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.productsService.addAttachment(file)];
                    case 3:
                        id = _a.sent();
                        this.model.edit.variations[0].attachment = {
                            ID: id,
                            FileName: file.name,
                            FileSize: file.size
                        };
                        this.setDirty();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        this.notificationService.showErrorMessage(e_2);
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdvancedProductController.prototype.removeAttachment = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.attachmentsForRemove.push(this.getAttach().ID);
                this.model.edit.variations[0].attachment = null;
                this.setDirty();
                return [2 /*return*/];
            });
        });
    };
    AdvancedProductController.prototype.getAttach = function () {
        return this.model.edit.variations[0].attachment;
    };
    AdvancedProductController.prototype.downloadAttach = function () {
        return __awaiter(this, void 0, void 0, function () {
            var attach, fileData, splittedAttachName, ext, type, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        attach = this.getAttach();
                        return [4 /*yield*/, this.productsService.getAttachment(attach.ID)];
                    case 1:
                        fileData = _a.sent();
                        splittedAttachName = this.getAttach().FileName.split('.');
                        ext = splittedAttachName[splittedAttachName.length - 1];
                        type = void 0;
                        if (ext === 'pdf') {
                            type = this.enumService.ExportFileType.PDF;
                        }
                        if (ext === 'epub') {
                            type = this.enumService.ExportFileType.EPUB;
                        }
                        this.transferFileService.transferFile(fileData, fileData.Name, type);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        this.notificationService.showErrorMessage(e_3);
                        return [3 /*break*/, 3];
                    case 3:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    AdvancedProductController.prototype.setDirty = function () {
        this.productForm.$setDirty();
    };
    AdvancedProductController.prototype.setAccessibleOutOfSession = function () {
        if (this.state.isNew && this.isPublisher) {
            this.model.edit.variations[0].isAccessibleOutOfSession = false;
        }
    };
    AdvancedProductController.prototype.uploadImage = function (imageInputId) {
        this.$timeout(function () {
            document.getElementById('imageInput' + imageInputId).click();
        }, 0);
    };
    AdvancedProductController.prototype.showDppInfoDialog = function (title, message) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uibModal.open({
                            component: 'dppInfoDialog',
                            resolve: {
                                title: function () { return title; },
                                message: function () { return message; }
                            },
                            windowClass: 'dpp-info-dialog'
                        }).result];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdvancedProductController.$inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'productsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService',
        'definitionsService', 'wysiwygService', 'notificationService', 'accountService', '$translate', 'nfcRetailerStickersService',
        'foodPreferenceService', '$localStorage', 'offersService', '$uibModal', 'transferFileService', 'enumService'
    ];
    return AdvancedProductController;
}(productBase_controller_1.ProductBaseController));
angular
    .module('naut').component('advancedProduct', {
    template: __webpack_require__(818),
    controller: AdvancedProductController,
    controllerAs: 'vm'
});


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ChoiceProductImagesComponent = /** @class */ (function () {
    function ChoiceProductImagesComponent($scope, $q, productService, popupService, notificationService, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.productService = productService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.uploadedImages = null;
        this.images = [];
        this.waiting = false;
        this.sortableOptions = {};
        this.fileExtensions = ['png', 'gif', 'jpg', 'jpeg'];
        this.uploadImages = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var failImages, validImages, promises, imageIDs, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.uploadedImages) {
                            return [2 /*return*/];
                        }
                        failImages = _.reject(this.uploadedImages, this.emptyErrorImage);
                        validImages = _.filter(this.uploadedImages, this.emptyErrorImage);
                        if (_.size(validImages) === 0) {
                            this.showFail(failImages);
                            this.uploadedImages = null;
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        promises = [];
                        _.forEach(validImages, function (image) {
                            promises.push(_this.productService.uploadImage(image));
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all(promises)];
                    case 2:
                        imageIDs = _a.sent();
                        _.forEach(imageIDs, function (imageID) {
                            if (imageID) {
                                _this.images.push(_this.getImageModel(imageID));
                            }
                        }, 0);
                        if (_.size(failImages) === 0) {
                            this.notificationService.showSuccessMessage();
                        }
                        else {
                            this.showFail(failImages);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.uploadedImages = null;
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteImage = function (image) {
            _this.images = _.reject(_this.images, function (item) {
                return item.id === image.id;
            });
            _this.deleteNoServerImage(image.id);
        };
        this.close = function () {
            _.forEach(_this.images, function (image) {
                _this.deleteNoServerImage(image.id);
            });
        };
        this.deleteNoServerImage = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var imageID, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageID = id;
                        if (!(imageID) || _.contains(this.serverImagesId, imageID)) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productService.deleteImage(imageID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.warn(error_2 + ' image with id ' + imageID + ' is not removed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.showFail = function (failImages) {
            _this.notificationService.clearAll();
            if (_.size(failImages) === 0) {
                return;
            }
            var li = '';
            _.forEach(failImages, function (image) {
                li += '<li>' + image.name + '</li>';
            });
            var ul = '<ul class="pl15">' + li + '</ul>';
            _this.popupService.alert({
                title: _this.$translate.instant('cant_upload_photos') || 'Can\'t upload photos',
                content: "<p>" + _this.$translate.instant('cant_upload_photos_description') + "</p>" + ul
            })["catch"](function () { return; });
        };
        this.getImageModel = function (id) {
            return {
                id: id,
                url: _this.productService.getImageUrl(id)
            };
        };
        this.updateModel = function () {
            _this.currentImagesId = _.pluck(_this.images, 'id');
            if (_.isFunction(_this.callbackUpdate)) {
                _this.callbackUpdate();
            }
        };
        this.init = function () {
            _this.uploadedImages = null;
            _this.images = [];
            _this.currentImagesId = _this.currentImagesId ? _this.currentImagesId : [];
            _this.serverImagesId = _this.serverImagesId ? _this.serverImagesId : [];
            if (_.isArray(_this.currentImagesId)) {
                _.forEach(_this.currentImagesId, function (id) {
                    _this.images.push(_this.getImageModel(id));
                });
            }
        };
        this.$scope.$watch('vm.currentImagesId', function (n, o) {
            if (n) {
                _this.init();
            }
        }, true);
        this.$scope.$watch('vm.images', function (n, o) {
            if (n) {
                _this.updateModel();
            }
        }, true);
    }
    ChoiceProductImagesComponent.prototype.emptyErrorImage = function (image) {
        return image.error == null || image.error === '';
    };
    ChoiceProductImagesComponent.$inject = ['$scope', '$q', 'productsService', 'popupService', 'notificationService', '$translate'];
    return ChoiceProductImagesComponent;
}());
angular.module('naut').component('choiceProductImages', {
    template: ['$attrs', function ($attrs) {
            return _.isUndefined($attrs.wizard) ? __webpack_require__(819) : __webpack_require__(820);
        }],
    controller: ChoiceProductImagesComponent,
    controllerAs: 'vm',
    bindings: {
        currentImagesId: '=',
        serverImagesId: '=',
        callbackUpdate: '&?',
        imageInputId: '='
    }
});


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DppInfoDialogComponent = /** @class */ (function () {
    function DppInfoDialogComponent() {
        this.modalInstanceService = this;
    }
    DppInfoDialogComponent.prototype.onClose = function () {
        this.modalInstanceService.close();
    };
    return DppInfoDialogComponent;
}());
exports.DppInfoDialogComponent = DppInfoDialogComponent;
angular.module('naut').component('dppInfoDialog', {
    template: __webpack_require__(821),
    controller: DppInfoDialogComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&'
    }
});


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var DraftConfirmationDialogComponent = /** @class */ (function () {
    function DraftConfirmationDialogComponent() {
        this.modalInstanceService = this;
    }
    DraftConfirmationDialogComponent.prototype.onSave = function () {
        this.modalInstanceService.close({ $value: true });
    };
    DraftConfirmationDialogComponent.prototype.onClose = function () {
        this.modalInstanceService.close({ $value: false });
    };
    return DraftConfirmationDialogComponent;
}());
exports.DraftConfirmationDialogComponent = DraftConfirmationDialogComponent;
angular.module('naut').component('draftConfirmationDialog', {
    template: __webpack_require__(822),
    controller: DraftConfirmationDialogComponent,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&'
    }
});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductEditDiscount = /** @class */ (function () {
    function ProductEditDiscount() {
    }
    ProductEditDiscount.prototype.saveVariationStaffDiscount = function () {
        var message = {
            product: this.product,
            variation: this.variation
        };
        this.onDiscountChange({ changedDiscount: message });
    };
    ProductEditDiscount.prototype.changeVariationStaffDiscount = function (discountMessage) {
        this.variation.discount = discountMessage.discount;
    };
    ProductEditDiscount.prototype.cancelDiscount = function () {
        this.onCancelDiscount({ value: true });
    };
    return ProductEditDiscount;
}());
angular.module('naut').component('productEditDiscount', {
    template: __webpack_require__(823),
    controller: ProductEditDiscount,
    controllerAs: 'vm',
    bindings: {
        variation: '<',
        product: '<',
        waiting: '<',
        onDiscountChange: '&',
        onCancelDiscount: '&'
    }
});


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductEditPrice = /** @class */ (function () {
    function ProductEditPrice($rootScope, languageService) {
        this.$rootScope = $rootScope;
        this.languageService = languageService;
    }
    ProductEditPrice.prototype.$onInit = function () {
        this.countryID = this.$rootScope.userData.countryID;
        this.currentCurrencyClass = this.languageService.getLangCurrencyStyle(this.countryID);
    };
    ProductEditPrice.prototype.changeVariationPrice = function () {
        var message = {
            product: this.product,
            variation: this.variation
        };
        this.onPriceChange({ changedPrice: message });
    };
    ProductEditPrice.prototype.cancelPrice = function () {
        this.onCancelPrice({ value: true });
    };
    ProductEditPrice.prototype.clearEatInTakeawayError = function () {
        this.variation.error.takeawayGreatEatIn = null;
    };
    ProductEditPrice.$inject = ['$rootScope', 'languageService'];
    return ProductEditPrice;
}());
angular.module('naut').component('productEditPrice', {
    template: __webpack_require__(824),
    controller: ProductEditPrice,
    controllerAs: 'vm',
    bindings: {
        variation: '<',
        product: '<',
        waiting: '<',
        onPriceChange: '&',
        onCancelPrice: '&'
    }
});


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductEditStockLevel = /** @class */ (function () {
    function ProductEditStockLevel() {
    }
    ProductEditStockLevel.prototype.save = function () {
        this.onSave({
            productId: this.productId,
            variationId: this.variationId,
            stockLevel: this.stockLevel != null ? parseInt(this.stockLevel, 10) : null
        });
    };
    ProductEditStockLevel.prototype.cancel = function () {
        this.onCancel();
    };
    ProductEditStockLevel.$inject = [];
    return ProductEditStockLevel;
}());
angular.module('naut').component('productEditStockLevel', {
    template: __webpack_require__(825),
    controller: ProductEditStockLevel,
    controllerAs: 'vm',
    bindings: {
        productId: '<',
        variationId: '<',
        stockLevel: '<',
        waiting: '<',
        onSave: '&',
        onCancel: '&'
    }
});


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ProductSearchController = /** @class */ (function () {
    function ProductSearchController($scope, productsService, notification, $translate, $localStorage) {
        var _this = this;
        this.productsService = productsService;
        this.notification = notification;
        this.$translate = $translate;
        this.$localStorage = $localStorage;
        this.pagination = {
            data: [],
            page: 1,
            pageSize: 10,
            total: 0
        };
        this.waiting = false;
        this.resolve = {
            items: [],
            categories: null
        };
        this.categories = {
            selected: null,
            list: null,
            enabled: false
        };
        this.selectedProducts = {};
        this.modalInstance = this;
        $scope.$watch('$ctrl.categories.selected', function () {
            _this.loadData();
        });
    }
    ProductSearchController.prototype.$onInit = function () {
        var _this = this;
        if (this.resolve && !_.isEmpty(this.resolve.items)) {
            _.forEach(this.resolve.items, function (item) { return _this.selectedProducts[item.productId] = item; });
        }
        if (this.resolve.categories) {
            this.categories.enabled = true;
            this.loadCategories();
        }
        this.loadData();
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    ProductSearchController.prototype.selectProduct = function (product) {
        product.isSelected = !product.isSelected;
        if (product.isSelected) {
            this.selectedProducts[product.productId] = product;
            return;
        }
        this.selectedProducts[product.productId] = null;
    };
    ProductSearchController.prototype.getSelectedCount = function () {
        return this.getSelectedProducts().length;
    };
    ProductSearchController.prototype.confirm = function () {
        this.modalInstance.close({ $value: this.getSelectedProducts() });
    };
    ProductSearchController.prototype.onSearchInputKeyPress = function ($event) {
        if ($event.which === 13 && !this.waiting) {
            this.loadData();
        }
    };
    ProductSearchController.prototype.search = function (text) {
        this.searchTerm = text;
        this.loadData();
    };
    ProductSearchController.prototype.resetSearch = function () {
        this.searchTerm = '';
        this.search(this.searchTerm);
    };
    ProductSearchController.prototype.loadCategories = function () {
        var _this = this;
        this.productsService.getItemTypes(this.resolve.categories, null)
            .then(function (itemTypes) {
            _this.categories.list = Array.from(new Set(itemTypes.map(function (item) { return item.ID; }))).map(function (id) {
                return itemTypes.find(function (value) { return value.ID === id; });
            });
            _this.categories.list.unshift({ ID: null, SingleForm: _this.$translate.instant('all_categories') });
            _this.categories.selected = _this.categories.list[0];
        })["catch"](function (error) { return console.log(error); });
    };
    ProductSearchController.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = {
                            limit: this.pagination.pageSize,
                            offset: (this.pagination.page - 1) * this.pagination.pageSize,
                            searchTerm: this.searchTerm,
                            sortColumn: 'UpdateDate',
                            sortOrder: 'descending',
                            itemTypeID: this.categories.selected ?
                                this.categories.selected.ID : null,
                            categoryID: this.resolve.categories
                        };
                        this.notification.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.findProducts(filter)];
                    case 2:
                        result = _a.sent();
                        this.pagination.data = this.mapSearchResult(result);
                        this.pagination.total = result.Total;
                        this.notification.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.notification.showErrorMessage(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSearchController.prototype.mapSearchResult = function (result) {
        var _this = this;
        return _.map(result.Items, function (product) { return _this.mapSearchProduct(product); });
    };
    ProductSearchController.prototype.mapSearchProduct = function (source) {
        return {
            id: 0,
            productId: source.ID,
            imageId: source.ImageID,
            title: source.Title,
            minPrice: source.MinPrice,
            maxPrice: source.MaxPrice,
            oldPrice: source.OldPrice,
            imageUrl: this.productsService.getImageUrl(source.ImageID, 60),
            isSelected: this.selectedProducts[source.ID] != null,
            currencySign: source.CurrencySign,
            itemTypeName: source.ItemTypeName,
            itemTypeID: source.ItemTypeID,
            classificationCategoryID: source.ClassificationCategoryID,
            variants: source.Variants
        };
    };
    ProductSearchController.prototype.getSelectedProducts = function () {
        return _.filter(this.selectedProducts, function (v) { return v || false; });
    };
    ProductSearchController.$inject = ['$scope', 'productsService', 'notificationService', '$translate', '$localStorage'];
    return ProductSearchController;
}());
angular.module('naut').component('productSearch', {
    template: __webpack_require__(826),
    controller: ProductSearchController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var viewport_typed_controller_1 = __webpack_require__(4);
var popupServiceCancel_1 = __webpack_require__(5);
var ProductsController = /** @class */ (function (_super) {
    __extends(ProductsController, _super);
    function ProductsController($rootScope, $scope, $stateParams, $q, $timeout, productsService, popupService, notificationService, enums, $translate, $state, $localStorage, transferFileService) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.$timeout = $timeout;
        _this.productsService = productsService;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.enums = enums;
        _this.$translate = $translate;
        _this.$state = $state;
        _this.$localStorage = $localStorage;
        _this.transferFileService = transferFileService;
        _this.waiting = false;
        _this.data = {
            Items: [],
            Total: 0
        };
        _this.settings = {
            pageSize: 5,
            page: 1,
            sortSet: _this.productsService.getSortSet(),
            sort: null,
            productFilter: '',
            productState: null,
            isExistActiveProducts: null,
            isExistArchiveProducts: null,
            getFilter: function () {
                var i = _this.settings;
                var search = i.productFilter ? i.productFilter.trim() : '';
                return {
                    limit: i.pageSize,
                    offset: (i.page - 1) * i.pageSize,
                    sortColumn: i.sort.column,
                    sortOrder: i.sort.order,
                    productName: search,
                    productID: '',
                    productState: i.productState
                };
            },
            getStateParams: function () {
                var i = _this.settings;
                var search = i.productFilter ? i.productFilter.trim() : '';
                return {
                    page: encodeURIComponent(i.page.toString()),
                    column: encodeURIComponent(i.sort.column),
                    order: encodeURIComponent(i.sort.order),
                    state: encodeURIComponent(i.productState.toString()),
                    search: encodeURIComponent(search),
                    sort: null
                };
            },
            settingsClear: function (state) {
                var i = _this.settings;
                i.page = 1;
                i.sort = _this.productsService.getSort();
                i.productFilter = '';
                i.productState = _.isUndefined(state)
                    ? _this.productState.NotArchived
                    : state;
            },
            isShowFilter: function () {
                var i = _this.settings;
                return ((_this.productState.Archived === i.productState &&
                    i.isExistArchiveProducts === true) ||
                    (_this.productState.NotArchived === i.productState &&
                        i.isExistActiveProducts === true));
            }
        };
        _this.filterExpanded = false;
        _this.linkTypes = [];
        _this.productState = _this.$rootScope.enums.PhysicalProductState;
        _this.params = null;
        _this.foodCategoryName = '> Meals >';
        _this.getImage = function (imagesID, width, height) {
            if (_.isArray(imagesID) && !_.isEmpty(imagesID)) {
                return _this.productsService.getImageUrl(_.first(imagesID), width, height);
            }
            return '';
        };
        _this.archive = function (product) { return __awaiter(_this, void 0, void 0, function () {
            var isDelete, popupTitle, popupContent, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isDelete = _.size(product.ProductVariations) === 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        popupTitle = this.$translate.instant(isDelete ? 'delete_product' : 'archive_product');
                        popupContent = this.$translate.instant(isDelete ? 'delete_product_confirm' : 'archive_product_confirm');
                        return [4 /*yield*/, this.popupService.confirm({
                                title: popupTitle,
                                content: popupContent,
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                cancelClass: 'btn-success',
                                invertAction: true
                            })];
                    case 2:
                        _a.sent();
                        if (!this.isNeedSplitProduct(product)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.productsService.showSaveChangesDialog()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.archiveProductInternal(product, isDelete);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.restoreVariation = function (product, variation) { return __awaiter(_this, void 0, void 0, function () {
            var state, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        state = this.productState.NotArchived;
                        if (!this.isNeedSplitProduct(product)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.productsService.showSaveChangesDialog()];
                    case 1:
                        _a.sent();
                        state = this.productState.Unassigned;
                        _a.label = 2;
                    case 2:
                        this.restoreVariationInternal(product, variation, state);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.openEditPrice = function (product, variation) {
            if (_this.settings.productState === _this.productState.Archived) {
                return;
            }
            _this.setDefaultPrice();
            variation.isFoodType = _this.isFoodTypeProduct(product);
            variation.isOpenEditPrice = true;
        };
        _this.savePrice = function (changedPrice) { return __awaiter(_this, void 0, void 0, function () {
            var model, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.settings.productState === this.productState.Archived ||
                            !this.isValidPrice(changedPrice.variation)) {
                            return [2 /*return*/];
                        }
                        model = {
                            ID: changedPrice.variation.ID,
                            Price: parseFloat(changedPrice.variation.price),
                            OldPrice: _.isNaN(parseFloat(changedPrice.variation.oldPrice))
                                ? null
                                : parseFloat(changedPrice.variation.oldPrice),
                            InsidePrice: _.isNaN(parseFloat(changedPrice.variation.insidePrice))
                                ? null
                                : parseFloat(changedPrice.variation.insidePrice),
                            InsideVAT: _.isNaN(parseFloat(changedPrice.variation.insideVAT))
                                ? null
                                : parseFloat(changedPrice.variation.insideVAT),
                            VAT: _.isNaN(parseFloat(changedPrice.variation.vat))
                                ? null
                                : parseFloat(changedPrice.variation.vat)
                        };
                        if (!model.InsidePrice) {
                            model.InsideVAT = null;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!this.isNeedSplitProduct(changedPrice.product)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.productsService.showSaveChangesDialog()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.savePriceInternal(changedPrice.product, changedPrice.variation, model);
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        if (popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_3)) {
                            this.setDefaultPrice();
                        }
                        else {
                            this.notificationService.showErrorMessage(error_3);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.importProducts = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.productsService.productsImport()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_4)) {
                            this.notificationService.showErrorMessage(error_4);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([this.productsService.getProducts(this.settings.getFilter()), this.productsService.getLinkTypes(), this.productsService.isExistProducts(this.productState.NotArchived), this.productsService.isExistProducts(this.productState.Archived), this.productsService.isExistProducts(this.productState.Unassigned)])];
                    case 2:
                        response = _a.sent();
                        this.notificationService.clearAll();
                        this.data = response[0];
                        this.linkTypes = response[1];
                        this.settings.isExistActiveProducts = response[2];
                        this.settings.isExistArchiveProducts = response[3];
                        this.adaptData();
                        if (this.data.Total === 0 &&
                            !_.isEmpty(this.settings.productFilter)) {
                            this.notificationService.showInfoMessage(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.archiveProductInternal = function (product, isDelete) { return __awaiter(_this, void 0, void 0, function () {
            var id, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.archiveProduct(product.ID)];
                    case 2:
                        id = _a.sent();
                        if (isDelete &&
                            this.settings.productState !== this.productState.Archived) {
                            this.settings.settingsClear(this.productState.Archived);
                        }
                        else {
                            this.getData();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        this.notificationService.showErrorMessage(error_6);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.$restoreVariation = function (productID, variationID, productState) { return __awaiter(_this, void 0, void 0, function () {
            var id, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.restoreVariation(productID, variationID)];
                    case 2:
                        id = _a.sent();
                        this.settings.settingsClear(productState);
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        this.notificationService.showErrorMessage(error_7);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.restoreVariationInternal = function (product, variation, productState) { return __awaiter(_this, void 0, void 0, function () {
            var twins, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.productsService.getTwinsVariations(product.ID, variation.ID)];
                    case 2:
                        twins = _a.sent();
                        if (!!_.isEmpty(twins)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('override_variation'),
                                content: "<p>" + this.$translate.instant('override_variation_confirm') + "'</p>"
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.$restoreVariation(product.ID, variation.ID, productState)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_8 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_8)) {
                            this.notificationService.showErrorMessage(error_8);
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setDefaultPrice = function () {
            _.forEach(_.flatten(_.pluck(_this.data.Items, 'ProductVariations')), function (variation) {
                variation.price = variation.Price;
                variation.oldPrice = variation.OldPrice;
                variation.insidePrice = variation.InsidePrice;
                variation.insideVAT = variation.InsideVAT;
                variation.vat = variation.VAT;
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
                variation.error = null;
            });
        };
        _this.setDefaultDiscount = function () {
            _.forEach(_.flatten(_.pluck(_this.data.Items, 'ProductVariations')), function (variation) {
                variation.discount = variation.Discount;
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
            });
        };
        _this.setDefaultStockLevel = function () {
            _.forEach(_.flatten(_.pluck(_this.data.Items, 'ProductVariations')), function (variation) {
                variation.isOpenEditDiscount = false;
                variation.isOpenEditPrice = false;
                variation.isOpenEditStockLevel = false;
            });
        };
        _this.savePriceInternal = function (product, variation, model) { return __awaiter(_this, void 0, void 0, function () {
            var id, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.updatePriceWithVat(product.ID, model)];
                    case 2:
                        id = _a.sent();
                        if (product.ID === id) {
                            this.notificationService.showSuccessMessage();
                            variation.Price = model.Price;
                            variation.OldPrice = model.OldPrice;
                            variation.InsidePrice = model.InsidePrice;
                            variation.InsideVAT = model.InsideVAT;
                            variation.VAT = model.VAT;
                            variation.isOpenEditPrice = false;
                            this.setDefaultPrice();
                        }
                        else {
                            if (this.settings.productState === this.productState.Unassigned) {
                                this.getData();
                            }
                            else {
                                this.settings.settingsClear(this.productState.Unassigned);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        this.notificationService.showErrorMessage(error_9);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.params = {
            page: parseInt($stateParams.page, 10),
            search: decodeURIComponent($stateParams.search),
            sort: productsService.getSort(decodeURIComponent($stateParams.column), decodeURIComponent($stateParams.order)),
            state: parseInt(decodeURIComponent($stateParams.state), 10)
        };
        _this.params.page = _this.params.page ? _this.params.page : 1;
        _this.params.sort = _this.params.sort
            ? _this.params.sort
            : _this.productsService.getSort();
        _this.params.state = _this.params.state
            ? _this.params.state
            : _this.productState.NotArchived;
        _this.settings.page = _this.params.page;
        _this.settings.sort = _this.params.sort;
        _this.settings.productFilter = _this.params.search;
        _this.settings.productState = _this.params.state;
        $scope.$watchGroup(['vm.settings.productState', 'vm.settings.page'], function (n, o) {
            if (n !== o) {
                _this.reload();
            }
        });
        var unwatch = $rootScope.$watch('userData', function (userData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (userData.permission) {
                    unwatch();
                    this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
                    this.isPublisher = userData.permission === this.$rootScope.enums.RetailerPermission.Publisher;
                }
                return [2 /*return*/];
            });
        }); }, true);
        _this.getData();
        return _this;
    }
    ProductsController.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    ProductsController.prototype.goToImport = function () {
        this.$state.go('app.operations');
    };
    ProductsController.prototype.applyFilter = function (searchText) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.settings.productFilter = searchText;
                this.settings.page = 1;
                this.search();
                return [2 /*return*/];
            });
        });
    };
    ProductsController.prototype.exportcsv = function () {
        var _this = this;
        this.notificationService.showWaitingMessage();
        var query = {
            searchTerm: this.settings.productFilter,
            sortColumn: this.settings.sort.column,
            sortOrder: this.settings.sort.order
        };
        this.productsService.exportCsvProduct(query).then(function (response) {
            var contentDisposition = response.headers('content-disposition');
            var filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)[1];
            _this.transferFileService.transferFile(response.data, filenameMatch ? filenameMatch : "products.csv");
            _this.notificationService.clearAll();
        })["catch"](function (error) {
            _this.notificationService.showErrorMessage(error);
        });
    };
    ProductsController.prototype.openEditDiscount = function (variation) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.setDefaultDiscount();
        variation.isOpenEditDiscount = true;
    };
    ProductsController.prototype.openEditStockLevel = function (variation) {
        if (this.settings.productState === this.productState.Archived) {
            return;
        }
        this.setDefaultStockLevel();
        variation.isOpenEditStockLevel = true;
    };
    ProductsController.prototype.changeVariationStaffDiscount = function (discountMessage) {
        _.forEach(_.flatten(_.pluck(this.data.Items, 'ProductVariations')), function (variation) {
            variation.discount = discountMessage.discount;
        });
    };
    ProductsController.prototype.saveDiscount = function (changedDiscount) {
        return __awaiter(this, void 0, void 0, function () {
            var model, result, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.settings.productState === this.productState.Archived) {
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        model = {
                            ID: changedDiscount.variation.ID,
                            Discount: parseFloat(changedDiscount.variation.discount)
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.updateDiscount(changedDiscount.product.ID, model)];
                    case 2:
                        result = _a.sent();
                        if (changedDiscount.product.ID === result) {
                            this.notificationService.showSuccessMessage();
                            changedDiscount.variation.Discount = changedDiscount.variation.discount;
                            changedDiscount.variation.isOpenEditDiscount = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        this.notificationService.showErrorMessage(error_10);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductsController.prototype.saveStockLevel = function (productId, variationId, stockLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var model, result, product, variation, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.settings.productState === this.productState.Archived) {
                            return [2 /*return*/];
                        }
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        model = {
                            ID: variationId,
                            StockQuantity: stockLevel
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.updateStockLevel(productId, model)];
                    case 2:
                        result = _a.sent();
                        if (productId === result) {
                            product = this.data.Items.find(function (item) { return item.ID === productId; });
                            variation = product.ProductVariations.find(function (item) { return item.ID === variationId; });
                            variation.StockQuantity = stockLevel;
                            variation.isOpenEditStockLevel = false;
                            this.notificationService.showSuccessMessage();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        this.notificationService.showErrorMessage(error_11);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductsController.prototype.cancelPrice = function () {
        this.setDefaultPrice();
    };
    ProductsController.prototype.cancelDiscount = function () {
        this.setDefaultDiscount();
    };
    ProductsController.prototype.cancelStockLevel = function () {
        this.setDefaultStockLevel();
    };
    ProductsController.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.settings.productFilter = null;
                this.search();
                return [2 /*return*/];
            });
        });
    };
    ProductsController.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.notificationService.showWaitingMessage();
                        _a = this;
                        return [4 /*yield*/, this.productsService.getProducts(this.settings.getFilter())];
                    case 2:
                        _a.data = _b.sent();
                        this.adaptData();
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.notificationService.showErrorMessage(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductsController.prototype.setClientBadges = function (products) {
        var _this = this;
        var variations = _.flatten(_.pluck(products, 'ProductVariations'));
        _.forEach(variations, function (variation) {
            variation.badges = _this.productsService.getClientBadges(variation.Badges, true);
        });
    };
    ProductsController.prototype.adaptData = function () {
        var _this = this;
        this.setClientBadges(this.data.Items);
        _.forEach(this.data.Items, function (product) {
            _.forEach(product.ProductLinks, function (link) {
                link.viewClass = _.findWhere(_this.linkTypes, { ID: link.Type }).viewClass;
            });
        });
        this.$timeout(function () {
            $('.wrapUlTags.overflowY').slimScroll({
                height: 'auto'
            });
            $('.wysiwyg__main').mCustomScrollbar({
                axis: 'y',
                theme: 'minimal-dark'
            });
        });
    };
    ProductsController.prototype.reload = function () {
        this.$rootScope.$state.go('app.products', this.settings.getStateParams());
    };
    ProductsController.prototype.isNeedSplitProduct = function (product) {
        if (this.$rootScope.userData) {
            console.log(this.$rootScope.userData.permission);
            console.log(this.$rootScope.enums.RetailerPermission.Retailer);
        }
        return !(this.$rootScope.userData &&
            (this.$rootScope.userData.permission ===
                this.$rootScope.enums.RetailerPermission.Retailer ||
                this.$rootScope.userData.permission ===
                    this.$rootScope.enums.RetailerPermission.Publisher));
    };
    ProductsController.prototype.isValidPrice = function (variation) {
        variation.error = {
            noPrice: null,
            takeawayGreatEatIn: null,
            oldPriceIsSmall: null
        };
        if (_.isNaN(parseFloat(variation.price)) ||
            (!_.isNaN(parseFloat(variation.price)) &&
                variation.price <= 0)) {
            variation.error.noPrice = true;
        }
        else if (!_.isNaN(parseFloat(variation.oldPrice)) &&
            parseFloat(variation.oldPrice) <=
                parseFloat(variation.price)) {
            variation.error.oldPriceIsSmall = true;
        }
        else if (!_.isNaN(parseFloat(variation.price)) &&
            parseFloat(variation.insidePrice) !==
                parseFloat(variation.price) &&
            parseFloat(variation.insidePrice) <
                parseFloat(variation.price)) {
            variation.error.takeawayGreatEatIn = true;
        }
        else {
            variation.error.noPrice = null;
            variation.error.oldPriceIsSmall = null;
            variation.error.takeawayGreatEatIn = null;
        }
        return (variation.error.noPrice == null &&
            variation.error.takeawayGreatEatIn == null &&
            variation.error.oldPriceIsSmall == null);
    };
    ProductsController.prototype.isFoodTypeProduct = function (product) {
        return product.ClassificationCategory && product.ClassificationCategory.FullName &&
            product.ClassificationCategory.FullName.indexOf(this.foodCategoryName) > 0;
    };
    ProductsController.$inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$q',
        '$timeout',
        'productsService',
        'popupService',
        'notificationService',
        'enumService',
        '$translate',
        '$state',
        '$localStorage',
        'transferFileService'
    ];
    return ProductsController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut').component('products', {
    template: __webpack_require__(827),
    controller: ProductsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var popupServiceCancel_1 = __webpack_require__(5);
var ProductsImportModalInstance = /** @class */ (function () {
    function ProductsImportModalInstance($q, $timeout, productsService, popupService, notificationService, $translate) {
        var _this = this;
        this.$q = $q;
        this.$timeout = $timeout;
        this.productsService = productsService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.waiting = false;
        this.isCategoriesMappingExist = false;
        this.isQueuedProductsExist = false;
        this.importType = this.productsService.importType;
        this.modalInstance = this;
        this.changeFileInputup = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var element, file, key, type, report, line, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        element = e.target;
                        file = element.files[0];
                        if (!file) {
                            return [2 /*return*/];
                        }
                        key = 'type';
                        type = $(element).data[key];
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.productsService.uploadImportFile(file, type)];
                    case 2:
                        report = _a.sent();
                        this.notificationService.clearAll();
                        line = report.split('\n').length;
                        return [4 /*yield*/, this.popupService.alert({
                                title: this.$translate.instant(type === this.importType.category ? 'import_external_categories_result' : 'import_products_result'),
                                content: "<div " + (line > 4 ? 'style="height: 150px;overflow: auto"' : '') + "><pre>" + report + "</pre></div>"
                            })];
                    case 3:
                        _a.sent();
                        this.isPossibleImport();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_1)) {
                            this.notificationService.showErrorMessage(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        element.value = null;
                        return [2 /*return*/];
                }
            });
        }); };
        this.isPossibleImport = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([this.productsService.isExistCategoryMapping(), this.productsService.isProductsImportQueued()])];
                    case 2:
                        result = _a.sent();
                        this.isCategoriesMappingExist = result[0];
                        this.isQueuedProductsExist = result[1];
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.isPossibleImport();
    }
    ProductsImportModalInstance.prototype.$onInit = function () {
        this.inputFile = angular.element('#fileInput');
        this.inputFile.on('change', this.changeFileInputup);
    };
    ProductsImportModalInstance.prototype.openFile = function (type) {
        var _this = this;
        if (this.inputFile && this.inputFile.data) {
            var key = 'type';
            this.inputFile.data[key] = type;
            this.$timeout(function () { _this.inputFile.click(); });
        }
    };
    ProductsImportModalInstance.prototype.cancel = function () {
        this.modalInstance.dismiss({ $value: 'cancel' });
    };
    ProductsImportModalInstance.prototype.save = function () {
        this.modalInstance.close({ $value: '' });
    };
    ProductsImportModalInstance.prototype.impossibleImportProduct = function () {
        if (!this.isCategoriesMappingExist) {
            this.importImpossibleTooltip = this.$translate.instant('must_import_mapping_of_categories');
        }
        else if (this.isQueuedProductsExist) {
            this.importImpossibleTooltip = this.$translate.instant('import_is_not_possible');
        }
        else {
            this.importImpossibleTooltip = null;
        }
        return this.importImpossibleTooltip != null;
    };
    ProductsImportModalInstance.$inject = ['$q', '$timeout', 'productsService', 'popupService', 'notificationService', '$translate'];
    return ProductsImportModalInstance;
}());
angular.module('naut')
    .component('productsImport', {
    template: __webpack_require__(828),
    controller: ProductsImportModalInstance,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductDiscount = /** @class */ (function () {
    function ProductDiscount() {
        this.discount = null;
        this.selectedOption = 0;
        this.value = 1;
    }
    ProductDiscount.prototype.$onInit = function () {
        this.setState();
    };
    ProductDiscount.prototype.$onChanges = function (onChangesObj) {
        this.setState();
    };
    ProductDiscount.prototype.setState = function () {
        if (!this.discount) {
            this.selectedOption = 1;
        }
        if (this.discount && this.discount === 100) {
            this.selectedOption = 2;
        }
        if (this.discount && (this.discount > 0 && this.discount < 100)) {
            this.selectedOption = 3;
            this.value = this.discount;
        }
    };
    ProductDiscount.prototype.changeDiscountValue = function () {
        if (!this.value || (this.value > 99 || this.value < 1)) {
            this.value = 1;
            this.discount = this.value;
        }
        else {
            this.discount = parseInt(this.value.toString(), 10);
        }
        this.sendChangeDiscountMessage();
    };
    ProductDiscount.prototype.sendChangeDiscountMessage = function () {
        var message = {
            variationID: this.variationId,
            discount: this.discount
        };
        this.onDiscountChange({ discountMessage: message });
    };
    ProductDiscount.inject = [''];
    return ProductDiscount;
}());
angular.module('naut').component('productDiscount', {
    template: __webpack_require__(829),
    controller: ProductDiscount,
    controllerAs: 'ctrl',
    bindings: {
        variationId: '<',
        discount: '<',
        isDisabled: '<',
        onDiscountChange: '&'
    }
});


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ProductExtrasList = /** @class */ (function () {
    function ProductExtrasList($translate, popupService, $uibModal, notificationService, extrasService, $localStorage) {
        var _this = this;
        this.$translate = $translate;
        this.popupService = popupService;
        this.$uibModal = $uibModal;
        this.notificationService = notificationService;
        this.extrasService = extrasService;
        this.$localStorage = $localStorage;
        this.treeOptions = {
            accept: function (sourceNodeScope, destNodesScope) {
                return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID ? true : false;
            },
            dragStart: function (event) {
                event.elements.dragging[0].classList.add('drag-item');
            },
            dropped: function (event) {
                event.elements.dragging[0].classList.remove('drag-item');
            }
        };
        this.deleteExtra = function (deleteItem) { return __awaiter(_this, void 0, void 0, function () {
            var extraToDeleteIndex;
            return __generator(this, function (_a) {
                extraToDeleteIndex = this.items.findIndex(function (item) { return item.ID === deleteItem.ID; });
                if (extraToDeleteIndex > -1) {
                    this.items.splice(extraToDeleteIndex, 1);
                }
                return [2 /*return*/];
            });
        }); };
        this.addExtra = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var operationResult, error_1, selectedExtras, newSelectedExtras_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectExtras',
                                size: 'md',
                                resolve: {
                                    options: function () {
                                        return {
                                            selectedExtras: _this.items
                                        };
                                    }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        operationResult = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        if (operationResult && operationResult.status === 'ok') {
                            selectedExtras = operationResult.selectedExtras;
                            newSelectedExtras_1 = [];
                            selectedExtras.forEach(function (extra) {
                                var foundExtra = _.find(_this.items, function (item) {
                                    return item.ID === extra.ID;
                                });
                                if (foundExtra) {
                                    newSelectedExtras_1.push(foundExtra);
                                }
                                else {
                                    var productExtra = {
                                        ID: extra.ID,
                                        ImageID: extra.ImageID,
                                        Title: extra.Title,
                                        Price: extra.Price,
                                        MaxAmount: 1,
                                        CurrencySign: extra.CurrencySign
                                    };
                                    newSelectedExtras_1.push(productExtra);
                                }
                            });
                            this.items = newSelectedExtras_1;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    ProductExtrasList.prototype.$onInit = function () {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    ProductExtrasList.prototype.getImage = function (imageID) {
        return this.extrasService.getExtraImageUrl(imageID);
    };
    ProductExtrasList.$inject = ['$translate', 'popupService', '$uibModal', 'notificationService', 'extrasService', '$localStorage'];
    return ProductExtrasList;
}());
angular.module('naut').component('productExtrasList', {
    template: __webpack_require__(830),
    controller: ProductExtrasList,
    controllerAs: 'ctrl',
    bindings: {
        items: '='
    }
});


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var SelectExtras = /** @class */ (function () {
    function SelectExtras($translate, extrasService, notificationService, $localStorage) {
        var _this = this;
        this.$translate = $translate;
        this.extrasService = extrasService;
        this.notificationService = notificationService;
        this.$localStorage = $localStorage;
        this.selectedExtras = {};
        this.modalInstance = this;
        this.model = {
            extras: [],
            searchTerm: null,
            waiting: true,
            noExtrasTitle: this.$translate.instant('extra_select_empty_list_title'),
            noExtrasMessage: this.$translate.instant('extra_select_empty_list_message')
        };
        this.total = 0;
        this.canSelectAll = true;
        this.isSearch = false;
        this.confirm = function () {
            var selectionResult = {
                status: 'ok',
                isAllSelected: false,
                selectedExtras: []
            };
            selectionResult.selectedExtras = _this.getSelectedExtras();
            _this.modalInstance.close({ $value: selectionResult });
        };
        this.getSelectedExtras = function () { return _this.model.extras.filter(function (extra) { return extra.IsSelected; }); };
        this.dismiss = function () { return _this.modalInstance.close({ $value: { status: 'close' } }); };
    }
    SelectExtras.prototype.$onInit = function () {
        var _this = this;
        this.resolve.options.selectedExtras.forEach(function (extra) { return _this.selectedExtras[extra.ID] = extra; });
        this.loadExtras();
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    };
    SelectExtras.prototype.searchKeyPressed = function ($event) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search();
        }
    };
    SelectExtras.prototype.getImage = function (imageID) {
        return this.extrasService.getExtraImageUrl(imageID);
    };
    SelectExtras.prototype.selectExtra = function (extra, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        extra.IsSelected = !extra.IsSelected;
        this.selectExtrasForm.$setDirty();
        if (this.selectedExtras[extra.ID]) {
            delete this.selectedExtras[extra.ID];
        }
        else {
            this.selectedExtras[extra.ID] = extra;
        }
    };
    SelectExtras.prototype.search = function () {
        this.total = 0;
        this.loadExtras(true);
        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '';
    };
    SelectExtras.prototype.loadExtras = function (searchByTerm) {
        var _this = this;
        if (this.total && this.model.extras.length === this.total) {
            return;
        }
        var filter = {
            SearchTerm: this.model.searchTerm,
            Limit: 20,
            SearchAfterID: this.model.extras.length && !searchByTerm ? _.last(this.model.extras).ID : null
        };
        this.model.waiting = true;
        this.notificationService.showWaitingMessage();
        return this.extrasService.getActiveExtras(filter)
            .then(function (response) {
            _this.total = response.Total;
            var extras = response.Items;
            extras.forEach(function (extra) {
                extra.IsSelected = !!_this.selectedExtras[extra.ID];
            });
            if (searchByTerm) {
                _this.model.extras = extras;
            }
            else {
                Array.prototype.push.apply(_this.model.extras, extras);
            }
            _this.model.waiting = false;
            if (_this.model.extras.length) {
                return;
            }
            _this.model.noExtrasTitle = _this.model.searchTerm && _this.model.searchTerm.length
                ? _this.$translate.instant('extras_not_found_title')
                : _this.$translate.instant('extra_select_empty_list_title');
            _this.model.noExtrasMessage = _this.model.searchTerm && _this.model.searchTerm.length
                ? _this.$translate.instant('extras_not_found_message', { search: _this.model.searchTerm })
                : _this.$translate.instant('extra_select_empty_list_message');
        })["catch"](function (e) { return _this.notificationService.showErrorMessage(e); })["finally"](function () { return _this.notificationService.clearAll(); });
    };
    SelectExtras.$inject = ['$translate', 'extrasService', 'notificationService', '$localStorage'];
    return SelectExtras;
}());
angular.module('naut').component('selectExtras', {
    template: __webpack_require__(831),
    controller: SelectExtras,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ProductIngredientsList = /** @class */ (function () {
    function ProductIngredientsList($translate, popupService, $uibModal, $interpolate) {
        this.$translate = $translate;
        this.popupService = popupService;
        this.$uibModal = $uibModal;
        this.$interpolate = $interpolate;
        // public treeOptions = {
        //     accept(sourceNodeScope: any, destNodesScope: any) {
        //         return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID;
        //     },
        //     dragStart(event: any) {
        //         event.elements.dragging[0].classList.add('drag-item');
        //     },
        //     dropped(event: any) {
        //         event.elements.dragging[0].classList.remove('drag-item');
        //     }
        // };
        this.minQuantityErrorList = {
            required: 'variation_ingredient_max_quantity_required_error',
            parse: 'variation_ingredient_max_quantity_required_error',
            number: 'variation_ingredient_max_quantity_required_error'
        };
    }
    ProductIngredientsList.prototype.deleteIngredient = function (deleteItem) {
        return __awaiter(this, void 0, void 0, function () {
            var itemToDeleteIndex;
            return __generator(this, function (_a) {
                itemToDeleteIndex = this.items.findIndex(function (item) { return item.ID === deleteItem.ID; });
                if (itemToDeleteIndex > -1) {
                    this.items.splice(itemToDeleteIndex, 1);
                }
                this.onItemDelete({ item: deleteItem });
                return [2 /*return*/];
            });
        });
    };
    ProductIngredientsList.prototype.addIngredient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var operationResult, error_1, selectedItems, _a, existItems, newItems, existIngredients, newIngredients, destItems_1, itemsToRemove;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'productSelectIngredients',
                                size: 'md',
                                resolve: {
                                    options: function () {
                                        return {
                                            selectedIngredients: _this.items
                                        };
                                    }
                                },
                                backdrop: 'static'
                            }).result];
                    case 1:
                        operationResult = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        return [2 /*return*/];
                    case 3:
                        if (operationResult && operationResult.status === 'ok') {
                            selectedItems = operationResult.selectedIngredients;
                            _a = _(selectedItems).partition(function (selectedItem) {
                                return _this.items.some(function (item) { return item.ID === selectedItem.ID; });
                            }), existItems = _a[0], newItems = _a[1];
                            existIngredients = existItems.map(function (existItem) {
                                return _this.items.find(function (item) { return item.ID === existItem.ID; });
                            });
                            newIngredients = newItems.map(function (item) {
                                var newItem = {
                                    ID: item.ID,
                                    Title: item.Title,
                                    MinQuantity: 0
                                };
                                _this.onItemAdd({ item: newItem });
                                return newItem;
                            });
                            destItems_1 = existIngredients.concat(newIngredients);
                            itemsToRemove = this.items.filter(function (item) {
                                return !destItems_1.find(function (destItem) { return destItem.ID === item.ID; });
                            });
                            if (this.onItemsDelete && itemsToRemove.length > 0) {
                                this.onItemsDelete({ items: itemsToRemove });
                            }
                            destItems_1.sort(function (a, b) { return a.Title.localeCompare(b.Title); });
                            this.items = destItems_1;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductIngredientsList.prototype.getMinQuantityErrorText = function () {
        var errorKeys = [this.minQuantityErrorList.parse];
        return this.getErrorString(errorKeys);
    };
    ProductIngredientsList.prototype.getErrorString = function (errorKeys) {
        var template = '{{ error | translate}}';
        var exp = this.$interpolate(template);
        var resultError = '';
        errorKeys.forEach(function (key) {
            resultError += '<i class="fa fa-exclamation-circle mr3"></i>' + exp({ error: key }) + '<br>';
        });
        return resultError;
    };
    ProductIngredientsList.$inject = [
        '$translate',
        'popupService',
        '$uibModal',
        '$interpolate'
    ];
    return ProductIngredientsList;
}());
angular.module('naut').component('productIngredientsList', {
    template: __webpack_require__(832),
    controller: ProductIngredientsList,
    controllerAs: 'ctrl',
    bindings: {
        onItemDelete: '&',
        onItemsDelete: '&',
        onItemAdd: '&',
        isDisabled: '<',
        items: '='
    }
});


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ProductSelectIngredients = /** @class */ (function () {
    function ProductSelectIngredients($translate, ingredientsService, notificationService) {
        this.$translate = $translate;
        this.ingredientsService = ingredientsService;
        this.notificationService = notificationService;
        this.selectedIngredients = new Map();
        this.modalInstance = this;
        this.model = {
            ingredients: [],
            searchTerm: null,
            searchTermForEmptyScreen: null,
            waiting: false
        };
        this.total = 0;
        this.isSearch = false;
    }
    ProductSelectIngredients.prototype.$onInit = function () {
        var _this = this;
        this.resolve.options.selectedIngredients.forEach(function (ingredient) {
            _this.selectedIngredients.set(ingredient.ID, ingredient);
        });
        this.loadIngredients();
    };
    ProductSelectIngredients.prototype.selectIngredient = function (ingredient, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        ingredient.IsSelected = !ingredient.IsSelected;
        this.selectIngredientsForm.$setDirty();
        if (this.selectedIngredients.has(ingredient.ID)) {
            this.selectedIngredients["delete"](ingredient.ID);
        }
        else {
            this.selectedIngredients.set(ingredient.ID, ingredient);
        }
    };
    ProductSelectIngredients.prototype.search = function (text) {
        this.total = 0;
        this.model.ingredients = [];
        this.model.searchTerm = text;
        this.loadIngredients();
        this.isSearch = this.model.searchTerm !== null && this.model.searchTerm !== '';
    };
    ProductSelectIngredients.prototype.resetSearch = function () {
        this.model.searchTerm = '';
        this.search(this.model.searchTerm);
    };
    ProductSelectIngredients.prototype.loadIngredients = function () {
        var _this = this;
        if (this.model.waiting) {
            return;
        }
        if (this.total && this.model.ingredients.length === this.total) {
            return;
        }
        this.model.waiting = true;
        var filter = {
            searchTerm: this.model.searchTerm,
            limit: 20,
            searchAfterID: this.model.ingredients.length ? _.last(this.model.ingredients).ID : null,
            archived: false
        };
        this.model.searchTermForEmptyScreen = this.model.searchTerm;
        this.notificationService.showWaitingMessage();
        return this.ingredientsService.getIngredients(filter)
            .then(function (response) {
            _this.total = response.Total;
            var ingredients = response.Items;
            ingredients.forEach(function (ingredient) {
                ingredient.IsSelected = !!_this.selectedIngredients.has(ingredient.ID);
            });
            Array.prototype.push.apply(_this.model.ingredients, ingredients);
        })["catch"](function (e) { return _this.notificationService.showErrorMessage(e); })["finally"](function () {
            _this.model.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    ProductSelectIngredients.prototype.confirm = function () {
        var selectionResult = {
            status: 'ok',
            selectedIngredients: []
        };
        selectionResult.selectedIngredients = Array.from(this.selectedIngredients.values());
        this.modalInstance.close({ $value: selectionResult });
    };
    ProductSelectIngredients.prototype.dismiss = function () {
        this.modalInstance.close({ $value: { status: 'close' } });
    };
    ProductSelectIngredients.$inject = [
        '$translate',
        'ingredientsService',
        'notificationService',
        '$localStorage'
    ];
    return ProductSelectIngredients;
}());
angular.module('naut').component('productSelectIngredients', {
    template: __webpack_require__(833),
    controller: ProductSelectIngredients,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductPreparation = /** @class */ (function () {
    function ProductPreparation() {
        this.types = [
            { value: null, title: 'preparation_type_not_selected' },
            { value: true, title: 'preparation_hot' },
            { value: false, title: 'preparation_cold' },
        ];
        this.selectedType = this.types[0];
        this.convertedPreparationTime = { hours: '0', minutes: '0' };
        this.time = 0;
        this.emptyTimeError = false;
    }
    ProductPreparation.prototype.$onInit = function () {
        this.setDefaults();
    };
    ProductPreparation.prototype.$onChanges = function () {
        this.setDefaults();
    };
    ProductPreparation.prototype.changePreparationTime = function () {
        if (this.convertedPreparationTime.hours.length === 0 &&
            this.convertedPreparationTime.minutes.length === 0) {
            this.time = 0;
            this.emptyTimeError = true;
        }
        else {
            this.time =
                Number(this.convertedPreparationTime.hours) * 60 +
                    Number(this.convertedPreparationTime.minutes);
            this.emptyTimeError = false;
            this.changePreparationMessage();
        }
    };
    ProductPreparation.prototype.changePreparationMessage = function () {
        var message = {
            variationID: this.variationId,
            preparationTime: this.time,
            isHot: this.type
        };
        this.onPreparationChange({ preparationMessage: message });
    };
    ProductPreparation.prototype.onHCSelect = function (item) {
        this.type = item.value;
        this.changePreparationMessage();
    };
    ProductPreparation.prototype.setDefaults = function () {
        var _this = this;
        if (this.time) {
            if (this.time >= 60) {
                this.convertedPreparationTime = {
                    hours: (Math.trunc(this.time / 60)).toString(),
                    minutes: this.time % 60 === 0 ? '0' : (this.time % 60).toString()
                };
            }
            else {
                this.convertedPreparationTime.minutes = this.time.toString();
            }
        }
        this.selectedType = this.types.find(function (item) { return item.value === _this.type; });
    };
    ProductPreparation.inject = [''];
    return ProductPreparation;
}());
angular.module('naut').component('productPreparation', {
    template: __webpack_require__(834),
    controller: ProductPreparation,
    controllerAs: 'ctrl',
    bindings: {
        variationId: '<',
        type: '<',
        time: '<',
        waiting: '<',
        error: '<',
        onPreparationChange: '&'
    }
});


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var models_1 = __webpack_require__(83);
var ProductSpecialOffer = /** @class */ (function () {
    ProductSpecialOffer.$inject = ["$translate", "offersService"];
    function ProductSpecialOffer($translate, offersService) {
        this.$translate = $translate;
        this.offersService = offersService;
        this.SpecialOfferTypeEnum = models_1.SpecialOfferTypeEnum;
        this.isEndDateExpired = false;
        this.expiredMessage = this.$translate.instant('the_offer_has_expired');
        this.disabledMessage = this.$translate.instant('incompatible_with_staff_discount');
        this.utcToday = moment(new Date()).utc(true).startOf('day').toDate();
        this.startDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: this.utcToday
        };
        this.endDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: moment(this.utcToday).add(1, 'days').toDate()
        };
        this.offerTypes = this.offersService.getOfferTypes();
    }
    ProductSpecialOffer.prototype.$onInit = function () {
        this.setState();
    };
    ProductSpecialOffer.prototype.$onChanges = function (onChangesObj) {
        this.setState();
    };
    ProductSpecialOffer.prototype.setState = function () {
        var _this = this;
        if (this.specialOffer) {
            this.switchSpecialOffer = this.specialOffer.Type !== models_1.SpecialOfferTypeEnum.None;
            this.selectedType = this.offerTypes.find(function (type) { return type.value === _this.specialOffer.Type; });
            if (this.selectedType && this.selectedType.templates) {
                if (!this.specialOffer.TemplateType) {
                    this.specialOffer.TemplateType = this.selectedType.templates[0].value;
                }
                this.selectedTemplate = this.selectedType.templates.find(function (item) { return item.value === _this.specialOffer.TemplateType; });
            }
            this.isEndDateExpired = moment.utc(this.utcToday).isAfter(moment.utc(this.specialOffer.OfferValidTo), 'date');
            this.specialOffer.error = {};
        }
    };
    ProductSpecialOffer.prototype.offerSwitchChanged = function () {
        if (this.switchSpecialOffer) {
            this.selectedType = this.offerTypes[0];
            this.selectedTemplate = this.selectedType.templates[0];
            this.specialOffer = {
                Type: this.selectedType.value,
                TemplateType: this.selectedTemplate.value,
                OfferValidFrom: this.utcToday,
                OfferValidTo: moment(this.utcToday).add(1, 'days').toDate(),
                BuyXGetYOfferValues: {},
                BuyXForYSumYOfferValues: {},
                error: {}
            };
        }
        else {
            this.specialOffer = null;
        }
        var message = {
            variationID: this.variationId,
            badgeValue: this.specialOffer !== null
        };
        this.onSpecialOfferChanged({ specialOfferMessage: message });
    };
    ProductSpecialOffer.prototype.offerTypeChanged = function () {
        this.specialOffer.Type = this.selectedType.value;
        this.selectedTemplate = this.selectedType.templates ? this.selectedType.templates[0] : null;
        this.specialOffer.TemplateType = this.selectedTemplate ? this.selectedTemplate.value : models_1.OfferTemplateTypeEnum.None;
        this.specialOffer.DiscountPrice = this.selectedType.value === models_1.SpecialOfferTypeEnum.Discount ? null : 0;
        this.specialOffer.BuyXGetYOfferValues = {};
        this.specialOffer.BuyXForYSumYOfferValues = {};
        this.specialOffer.error = {};
    };
    ProductSpecialOffer.prototype.offerTemplateChanged = function () {
        this.specialOffer.TemplateType = this.selectedTemplate.value;
    };
    ProductSpecialOffer.prototype.onStartDateChanged = function () {
        this.endDateOptions.minDate = moment(this.specialOffer.OfferValidFrom).add(1, 'days').toDate();
    };
    ProductSpecialOffer.prototype.onEndDateChanged = function () {
        this.isEndDateExpired = moment(this.utcToday).isAfter(this.specialOffer.OfferValidTo, 'date');
    };
    ProductSpecialOffer.inject = ['$translate', 'offerService'];
    return ProductSpecialOffer;
}());
angular.module('naut').component('productSpecialOffer', {
    template: __webpack_require__(835),
    controller: ProductSpecialOffer,
    controllerAs: 'ctrl',
    bindings: {
        specialOffer: '=',
        oldPrice: '<',
        currencyClass: '<',
        isDisabled: '<',
        isReadOnly: '<',
        variationId: '<',
        onSpecialOfferChanged: '&'
    }
});


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductStickersListItem = /** @class */ (function () {
    function ProductStickersListItem() {
        var _this = this;
        this.stickerNumberWasChanged = false;
        this.pattern = '[A-Z]{1}\\d{12}$';
        this.changeStickerNumber = function () {
            if (!_this.backupStickerNumber) {
                return;
            }
            _this.stickerNumberWasChanged = _this.stickerNumber !== _this.backupStickerNumber;
        };
    }
    ProductStickersListItem.prototype.$onInit = function () {
        if (this.stickerNumber) {
            this.backupStickerNumber = this.stickerNumber;
        }
        if (this.itemId) {
            this.formName = 'sticker_' + this.itemId;
        }
    };
    ProductStickersListItem.prototype.$onChanges = function (onChangesObj) {
        var _this = this;
        if (onChangesObj.stores && onChangesObj.stores.currentValue) {
            var dict_1 = {};
            this.stores.forEach(function (store) { dict_1[store.ID] = store; });
            this.storesDic = dict_1;
        }
        if (onChangesObj.stickerErrors && onChangesObj.stickerErrors.currentValue) {
            this.stickerError = this.stickerErrors.filter(function (r) { return r.id === _this.itemId; })[0];
        }
    };
    ProductStickersListItem.$inject = [];
    return ProductStickersListItem;
}());
angular.module('naut').component('productStickersListItem', {
    template: __webpack_require__(836),
    controller: ProductStickersListItem,
    controllerAs: 'ctrl',
    bindings: {
        itemId: '<',
        stickerNumber: '=',
        selectedStoreId: '=',
        position: '=',
        stores: '<',
        hidePosition: '<',
        isDisabled: '<',
        onDeleteItem: '&',
        stickerErrors: '<'
    }
});


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductStickersList = /** @class */ (function () {
    function ProductStickersList($translate, popupService) {
        var _this = this;
        this.$translate = $translate;
        this.popupService = popupService;
        this.pattern = '[A-Z]{1}\\d{12}$';
        this.deleteStickerItem = function (itemIndex) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okClass: 'btn btn-with-icon btn-with-icon--before-close color-black54 bg-dark12',
                                okTxt: this.$translate.instant('delete_sticker_dialog_content_cancel'),
                                cancelClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                                cancelTxt: this.$translate.instant('delete_sticker_dialog_content_ok'),
                                classPopup: 'alert--redesign modal360',
                                title: this.$translate.instant('delete_sticker_dialog_title'),
                                content: this.$translate.instant('delete_sticker_dialog_content'),
                                invertAction: true
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3:
                        this.items.splice(itemIndex, 1);
                        this.stickerListForm.$setDirty();
                        return [2 /*return*/];
                }
            });
        }); };
        this.addStickerItem = function () {
            var newStickerItem = _this.hidePosition ? { StickerNumber: null, PlaceID: null } : { StickerNumber: null, PlaceID: null, Position: null };
            _this.items.push(newStickerItem);
        };
    }
    ProductStickersList.prototype.$onInit = function () {
        this.items = [];
        this.stores = [];
    };
    ProductStickersList.$inject = ['$translate', 'popupService'];
    return ProductStickersList;
}());
angular.module('naut').component('productStickersList', {
    template: __webpack_require__(837),
    controller: ProductStickersList,
    controllerAs: 'ctrl',
    bindings: {
        items: '=',
        stores: '<',
        hidePosition: '<',
        isListDisabled: '<',
        errors: '<'
    }
});


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductVariationIngredient = /** @class */ (function () {
    function ProductVariationIngredient($scope, $interpolate) {
        this.$scope = $scope;
        this.$interpolate = $interpolate;
        this.priceErrorList = {
            number: 'variation_ingredient_takeaway_price_required_error',
            parse: 'variation_ingredient_default_quantity_required_error',
            required: 'variation_ingredient_default_quantity_required_error',
            priceMustBeLessOrEqualInsidePriceModel: 'variation_ingredient_takeaway_price_less_eat_in_price_error'
        };
        this.insidePriceErrorList = {
            number: 'variation_ingredient_takeaway_price_required_error',
            parse: 'variation_ingredient_default_quantity_required_error',
            required: 'variation_ingredient_default_quantity_required_error',
            insidePriceMustBeGreaterOrEqualPriceModel: 'variation_ingredient_takeaway_price_greater_eat_in_price_error'
        };
        this.defaultQuantityErrorList = {
            required: 'variation_ingredient_default_quantity_required_error',
            parse: 'variation_ingredient_default_quantity_required_error',
            number: 'variation_ingredient_default_quantity_required_error',
            defaultQuantityMustBeGreaterMinQuantityModel: 'variation_ingredient_default_quantity_greater_min_error',
            defaultQuantityMustBeLessMaxQuantityModel: 'variation_ingredient_default_quantity_less_max_error'
        };
        this.maxQuantityErrorList = {
            required: 'variation_ingredient_max_quantity_required_error',
            parse: 'variation_ingredient_max_quantity_required_error',
            number: 'variation_ingredient_max_quantity_required_error',
            maxQuantityMustBeGreaterDefaultQuantityModel: 'variation_ingredient_max_quantity_greater_default_error',
            maxQuantityMustBeGreaterMinQuantityModel: 'variation_ingredient_max_quantity_greater_min_error'
        };
        this.isError = true;
    }
    ProductVariationIngredient.prototype.$onInit = function () {
        var _this = this;
        this.$scope.$watch('ctrl.minQuantity', function (n, o) {
            if (n != null) {
                _this.validateFields();
            }
        });
    };
    ProductVariationIngredient.prototype.$postLink = function () {
        this.form.defaultQuantity.$validators.defaultQuantityMustBeGreaterMinQuantityModel = this.defaultQuantityMustBeGreaterMinQuantity.bind(this);
        this.form.defaultQuantity.$validators.defaultQuantityMustBeLessMaxQuantityModel = this.defaultQuantityMustBeLessMaxQuantity.bind(this);
        this.form.maxQuantity.$validators.maxQuantityMustBeGreaterDefaultQuantityModel = this.maxQuantityMustBeGreaterDefaultQuantity.bind(this);
        this.form.maxQuantity.$validators.maxQuantityMustBeGreaterMinQuantityModel = this.maxQuantityMustBeGreaterMinQuantity.bind(this);
        this.form.insidePrice.$validators.insidePriceMustBeGreaterOrEqualPriceModel = this.insidePriceMustBeGreaterOrEqualPriceModel.bind(this);
        this.form.price.$validators.priceMustBeLessOrEqualInsidePriceModel = this.priceMustBeLessOrEqualInsidePriceModel.bind(this);
    };
    ProductVariationIngredient.prototype.getPriceErrorText = function () {
        var _this = this;
        var errorKeys = Object.keys(this.form.price.$error).map(function (key) { return _this.priceErrorList[key]; });
        return this.getErrorString(errorKeys);
    };
    ProductVariationIngredient.prototype.getInsidePriceErrorText = function () {
        var _this = this;
        var errorKeys = Object.keys(this.form.insidePrice.$error).map(function (key) { return _this.insidePriceErrorList[key]; });
        return this.getErrorString(errorKeys);
    };
    ProductVariationIngredient.prototype.getDefaultQuantityErrorText = function () {
        var _this = this;
        var errorKeys = Object.keys(this.form.defaultQuantity.$error).map(function (key) { return _this.defaultQuantityErrorList[key]; });
        return this.getErrorString(errorKeys);
    };
    ProductVariationIngredient.prototype.getMaxQuantityErrorText = function () {
        var _this = this;
        var errorKeys = Object.keys(this.form.maxQuantity.$error).map(function (key) { return _this.maxQuantityErrorList[key]; });
        return this.getErrorString(errorKeys);
    };
    ProductVariationIngredient.prototype.validateFields = function () {
        if (this.onIngredientChanged) {
            this.onIngredientChanged({ item: this.item });
        }
        this.form.price.$validate();
        this.form.insidePrice.$validate();
        this.form.defaultQuantity.$validate();
        this.form.maxQuantity.$validate();
    };
    ProductVariationIngredient.prototype.getErrorString = function (errorKeys) {
        var template = '{{ error | translate}}';
        var exp = this.$interpolate(template);
        var resultError = '';
        errorKeys.forEach(function (key) {
            resultError += '<i class="fa fa-exclamation-circle mr3"></i>' + exp({ error: key }) + '<br>';
        });
        return resultError;
    };
    ProductVariationIngredient.prototype.defaultQuantityMustBeGreaterMinQuantity = function (defaultQuantity) {
        if (this.minQuantity === null || this.minQuantity === undefined) {
            return false;
        }
        return defaultQuantity >= this.minQuantity;
    };
    ProductVariationIngredient.prototype.defaultQuantityMustBeLessMaxQuantity = function (defaultQuantity) {
        if (this.minQuantity === null || this.minQuantity === undefined) {
            return false;
        }
        return defaultQuantity <= this.item.MaxQuantity;
    };
    ProductVariationIngredient.prototype.maxQuantityMustBeGreaterDefaultQuantity = function (maxQuantity) {
        if (this.minQuantity === null || this.minQuantity === undefined) {
            return false;
        }
        return maxQuantity >= this.item.DefaultQuantity;
    };
    ProductVariationIngredient.prototype.maxQuantityMustBeGreaterMinQuantity = function (maxQuantity) {
        if (this.minQuantity === null || this.minQuantity === undefined) {
            return false;
        }
        return maxQuantity >= this.minQuantity;
    };
    ProductVariationIngredient.prototype.insidePriceMustBeGreaterOrEqualPriceModel = function (insidePrice) {
        var isTakeawayPriceNotAvailable = this.item.Price === null || this.item.Price === undefined ||
            Number.isNaN(this.item.Price) || this.isTakeAwayPriceDisabled;
        if (isTakeawayPriceNotAvailable) {
            return true;
        }
        var isEatInPriceNotAvailable = insidePrice === null || insidePrice === undefined ||
            Number.isNaN(insidePrice) || this.isEatInPriceDisabled;
        if (isEatInPriceNotAvailable) {
            return true;
        }
        return insidePrice >= this.item.Price;
    };
    ProductVariationIngredient.prototype.priceMustBeLessOrEqualInsidePriceModel = function (price) {
        var isTakeawayPriceNotAvailable = price === null || price === undefined || Number.isNaN(price) ||
            this.isTakeAwayPriceDisabled;
        if (isTakeawayPriceNotAvailable) {
            return true;
        }
        var isEatInPriceNotAvailable = this.item.InsidePrice === null || this.item.InsidePrice === undefined ||
            Number.isNaN(this.item.InsidePrice) || this.isEatInPriceDisabled;
        if (isEatInPriceNotAvailable) {
            return true;
        }
        return price <= this.item.InsidePrice;
    };
    ProductVariationIngredient.$inject = [
        '$scope',
        '$interpolate'
    ];
    return ProductVariationIngredient;
}());
angular.module('naut').component('productVariationIngredient', {
    template: __webpack_require__(838),
    controller: ProductVariationIngredient,
    controllerAs: 'ctrl',
    bindings: {
        item: '=',
        minQuantity: '<',
        onIngredientChanged: '&?',
        isTakeAwayPriceDisabled: '<',
        isEatInPriceDisabled: '<',
        currencyClass: '<'
    }
});


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ProductVariationIngredientsList = /** @class */ (function () {
    function ProductVariationIngredientsList(popupService, notificationService, $translate) {
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
    }
    ProductVariationIngredientsList.prototype.openVariationIngredientsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.info({
                                classPopup: 'alert--redesign modal520',
                                title: this.$translate.instant('variation_ingredient_list_title'),
                                content: this.$translate.instant('variation_ingredient_info_dialog_content')
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProductVariationIngredientsList.prototype.getMinQuantity = function (ingredient) {
        var foundIngredient = this.ingredients.find(function (item) { return item.ID === ingredient.ID; });
        return foundIngredient ? foundIngredient.MinQuantity : null;
    };
    ProductVariationIngredientsList.prototype.ingredientChange = function (ingredient) {
        if (this.onIngredientChanged) {
            this.onIngredientChanged({ item: ingredient });
        }
    };
    ProductVariationIngredientsList.$inject = [
        'popupService',
        'notificationService',
        '$translate'
    ];
    return ProductVariationIngredientsList;
}());
angular.module('naut').component('productVariationIngredientsList', {
    template: __webpack_require__(839),
    controller: ProductVariationIngredientsList,
    controllerAs: 'ctrl',
    bindings: {
        items: '=',
        ingredients: '<',
        isTakeAwayPriceDisabled: '<',
        isEatInPriceDisabled: '<',
        currencyClass: '<',
        onIngredientChanged: '&?'
    }
});


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var productBase_controller_1 = __webpack_require__(84);
var WizardProductController = /** @class */ (function (_super) {
    __extends(WizardProductController, _super);
    function WizardProductController($rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService, categoriesSelectorService, brandsService, popupService, 
        // tslint:disable-next-line:no-shadowed-variable
        taOptions, htmlService, definitionsService, wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal) {
        var _this = _super.call(this, $rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService, categoriesSelectorService, brandsService, popupService, taOptions, htmlService, definitionsService, wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal) || this;
        _this.wizard = {
            step: 1,
            next: function () { return __awaiter(_this, void 0, void 0, function () {
                var wizard, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            wizard = this.wizard;
                            if (!(wizard.step === 1 || wizard.step === 2)) return [3 /*break*/, 2];
                            _a = wizard;
                            return [4 /*yield*/, this.model.isValidProduct(false)];
                        case 1:
                            _a.step = (_b.sent()) ? wizard.step + 1 : wizard.step;
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.model.isValidModel(true)];
                        case 3:
                            if (_b.sent()) {
                                wizard.step++;
                            }
                            _b.label = 4;
                        case 4:
                            wizard.step = wizard.step > 4 ? 1 : wizard.step;
                            if (wizard.step === 1) {
                                $('html, body').animate({ scrollTop: 0 }, 500);
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            back: function () {
                var i = _this.wizard;
                if (i.step > 1) {
                    i.step--;
                }
                _this.variation = null;
            }
        };
        _this.nfrnWizard = {
            step: 1,
            next: function () { return __awaiter(_this, void 0, void 0, function () {
                var nfrnWizard, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nfrnWizard = this.nfrnWizard;
                            if (!(nfrnWizard.step === 1)) return [3 /*break*/, 2];
                            _a = nfrnWizard;
                            return [4 /*yield*/, this.model.isValidProduct(false)];
                        case 1:
                            _a.step = (_b.sent()) ? nfrnWizard.step + 1 : nfrnWizard.step;
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.model.isValidModel(true)];
                        case 3:
                            if (_b.sent()) {
                                nfrnWizard.step++;
                            }
                            _b.label = 4;
                        case 4:
                            nfrnWizard.step = nfrnWizard.step > 2 ? 1 : nfrnWizard.step;
                            if (nfrnWizard.step === 1) {
                                $('html, body').animate({ scrollTop: 0 }, 500);
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            back: function () {
                var i = _this.nfrnWizard;
                if (i.step > 1) {
                    i.step--;
                }
                _this.variation = null;
            }
        };
        _this.variationPreview = {
            imageID: null,
            images: [],
            price: null,
            badges: [],
            oldPrice: null,
            size: '',
            color: '',
            set: function (variation) {
                var i = _this.variationPreview;
                i.imageID = variation ? _.first(variation.imagesID) : null;
                i.price = variation ? variation.price : null;
                i.oldPrice = variation ? variation.oldPrice : null;
                i.size = variation ? variation.size : '';
                i.color = variation ? variation.color : '';
                i.color = variation ? variation.color : '';
                i.badges = variation ? _this.filterBadges(variation.badges, true) : [];
                i.images = variation ? _.map(variation.imagesID, function (imageID) {
                    return {
                        id: imageID,
                        selected: false
                    };
                }) : [];
                var image = _.first(i.images);
                if (image) {
                    image.selected = true;
                }
            },
            selectImage: function (image) {
                var i = _this.variationPreview;
                _.forEach(i.images, function (img) {
                    img.selected = false;
                });
                image.selected = true;
                i.imageID = image.id;
            }
        };
        _this.editVariation = function (variation) {
            variation.error = null;
            _this.variation = angular.copy(variation);
        };
        _this.addVariation = function () {
            var defaultVariation = _this.productsService.getDefaultVariationModel();
            var ingredientList = _this.model.edit.ingredientList;
            if (ingredientList.length > 0) {
                ingredientList.forEach(function (item) {
                    var ingredient = {
                        ID: item.ID,
                        Title: item.Title,
                        Price: null,
                        InsidePrice: null,
                        DefaultQuantity: item.MinQuantity,
                        MaxQuantity: 1
                    };
                    defaultVariation.ingredients.push(ingredient);
                });
            }
            _this.variation = defaultVariation;
            _this.variation.uniqueId = _this.getUniqueId();
        };
        _this.saveVariation = function (variation) {
            if (_this.model.isValidVariation(variation)) {
                if (_this.productForm) {
                    _this.productForm.$setDirty();
                }
                _this.updateVariation(variation);
                _this.model.isValidArrayVariations();
                _this.variation = null;
            }
        };
        _this.copyVariation = function (variation) { return __awaiter(_this, void 0, void 0, function () {
            var copy, dictionary_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.model.isValidVariation(variation)) {
                            return [2 /*return*/];
                        }
                        copy = angular.copy(variation);
                        copy.id = null;
                        copy.imagesID = [];
                        copy.uniqueId = this.getUniqueId();
                        this.updateSelectedSizes(copy);
                        this.notificationService.showWaitingMessage();
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.productsService.copyImage(variation.imagesID)];
                    case 2:
                        dictionary_1 = _a.sent();
                        this.notificationService.showSuccessMessage({
                            title: this.$translate.instant('success'),
                            body: this.$translate.instant('variation_was_copied')
                        });
                        copy.id = null;
                        copy.uniqueId = this.getUniqueId();
                        _.forEach(variation.imagesID, function (id) {
                            var newID = dictionary_1[id];
                            if (newID) {
                                copy.imagesID.push(newID);
                            }
                        });
                        this.updateVariation(variation);
                        this.variation = copy;
                        this.model.isValidArrayVariations();
                        this.productForm.$setDirty();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.saveWizard = function () {
            var saveVariation = _this.isNfrnRetailer ? _this.nfrnWizard.step === 1 : _this.wizard.step === 2;
            if (saveVariation && _this.variation) {
                _this.saveVariation(_this.variation);
                if (_this.variation) {
                    return;
                }
            }
            _this.save();
        };
        _this.removeVariationWizard = function (variation) {
            if (_.size(_this.model.edit.variations) === 1) {
                return;
            }
            _this.removeVariation(variation, function () {
                _this.model.isValidArrayVariations();
                _this.variation = null;
            });
        };
        _this.discardWizard = function () {
            var variationsImages = _this.model.getClientImagesID();
            var currentVariationImages = [];
            if (_this.variation && _.size(_this.variation.imagesID) > 0) {
                currentVariationImages = _this.variation.imagesID;
            }
            _.forEach(_.union(variationsImages, currentVariationImages), function (id) {
                _this.deleteImage(id);
            });
            _this.productForm.$setDirty();
            _this.back();
        };
        _this.filterBadges = function (badges, selected) {
            if (_.isUndefined(selected)) {
                return _.reject(badges, function (badge) {
                    return badge.key === 0;
                });
            }
            return _.reject(badges, function (badge) {
                return badge.key === 0 || badge.selected !== selected;
            });
        };
        _this.updateVariationPreview = function () {
            if (_this.model.edit == null) {
                return;
            }
            if (_this.variation) {
                _this.variationPreview.set(_this.variation);
            }
            else {
                var applicant = _.find(_this.model.edit.variations, function (variation) {
                    return _.size(variation.imagesID) > 0;
                });
                if (_.isUndefined(applicant)) {
                    applicant = _.first(_this.model.edit.variations);
                }
                _this.variationPreview.set(applicant);
                _this.phoneScroll();
                _this.textAreaCustScroll();
                _this.srollTableTag();
            }
        };
        _this.updateVariation = function (variation) {
            var index = -1;
            if (variation.id) {
                index = _.findIndex(_this.model.edit.variations, { id: variation.id });
            }
            else if (variation.uniqueId) {
                index = _.findIndex(_this.model.edit.variations, { uniqueId: variation.uniqueId });
            }
            if (index === -1) {
                _this.model.edit.variations.unshift(variation);
            }
            else {
                _this.model.edit.variations[index] = variation;
            }
        };
        _this.loadedModel = function () {
            _.forEach(_this.model.edit.variations, function (variation) {
                if (!variation.id) {
                    variation.uniqueId = _this.getUniqueId();
                }
            });
            _this.updateVariationPreview();
        };
        _this.variation = null;
        _this.model.loadedModel = _this.loadedModel;
        _this.countryID = _this.$localStorage.retailerAuthorizationData.countryID;
        return _this;
    }
    WizardProductController.prototype.cancelVariation = function () {
        var _this = this;
        if (this.variation) {
            _.forEach(this.variation.imagesID, function (id) {
                _this.deleteImage(id);
            });
        }
        this.variation = null;
    };
    WizardProductController.prototype.changeVariationDiscount = function (discountMessage) {
        this.variation.discount = discountMessage.discount;
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    };
    WizardProductController.prototype.changeVariationPreparationTime = function (preparationMessage) {
        this.variation.isHot = preparationMessage.isHot;
        this.variation.preparationTime = preparationMessage.preparationTime;
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    };
    WizardProductController.prototype.onChangeSpecialOffer = function (message) {
        _super.prototype.onChangeSpecialOffer.call(this, message);
    };
    WizardProductController.prototype.showIngredientAttentionIfNeed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var needShowAttentions;
            return __generator(this, function (_a) {
                needShowAttentions = this.variation.ingredients.length > 0;
                if (needShowAttentions) {
                    _super.prototype.showIngredientAttentionDialog.call(this);
                }
                return [2 /*return*/];
            });
        });
    };
    WizardProductController.prototype.onIngredientChanged = function (item, variation) {
        this.productForm.$setDirty();
    };
    WizardProductController.prototype.openIngredientsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.info({
                                title: this.$translate.instant('ingredient_info_dialog_title'),
                                content: this.$translate.instant('ingredient_info_dialog_content')
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WizardProductController.prototype.openVariationIngredientsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.info({
                                title: this.$translate.instant('variation_ingredient_list_title'),
                                content: this.$translate.instant('variation_ingredient_info_dialog_content')
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WizardProductController.prototype.getTextSizeColor = function () {
        var caseFunction = String.prototype.toUpperCase;
        if (this.IsFoodProduct) {
            return this.getSizeNameAndColorText('SIZE, CHOOSE', caseFunction);
        }
        else {
            return this.getSizeNameAndColorText('SIZE, COLOR', caseFunction);
        }
    };
    WizardProductController.prototype.getTextSizeColorForDescription = function () {
        var caseFunction = String.prototype.toLowerCase;
        if (this.IsFoodProduct) {
            return this.getSizeNameAndColorText('size/choose', caseFunction);
        }
        else {
            return this.getSizeNameAndColorText('size/color', caseFunction);
        }
    };
    WizardProductController.prototype.getSizeNameAndColorText = function (title, caseFunction) {
        var editModel = this.model.edit;
        if (!editModel || !editModel.sizeName) {
            return title;
        }
        title = caseFunction.apply(editModel.sizeName);
        if (editModel.colourName) {
            title += "/" + caseFunction.apply(editModel.colourName);
        }
        return title;
    };
    WizardProductController.prototype.getUniqueId = function () {
        return _.uniqueId('temp');
    };
    WizardProductController.prototype.phoneScroll = function () {
        $('.wizardScrollPhone').slimScroll({
            height: 'auto'
        });
    };
    WizardProductController.prototype.textAreaCustScroll = function () {
        $('.textAreaCustScroll').slimScroll({
            height: '150px'
        });
    };
    WizardProductController.prototype.srollTableTag = function () {
        $('.srollTableTag').slimScroll({
            height: '446px',
            alwaysVisible: true
        });
    };
    WizardProductController.$inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'productsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService',
        'definitionsService', 'wysiwygService', 'notificationService', 'accountService', '$translate', 'nfcRetailerStickersService',
        'foodPreferenceService', '$localStorage', 'offersService', '$uibModal'
    ];
    return WizardProductController;
}(productBase_controller_1.ProductBaseController));
angular
    .module('naut').component('wizardProduct', {
    template: __webpack_require__(840),
    controller: WizardProductController,
    controllerAs: 'vm'
});


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var core_1 = __webpack_require__(56);
var ProductsService = /** @class */ (function () {
    function ProductsService($rootScope, http, $q, $uibModal, retailerService, blobService, popupService, $translate) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.http = http;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.blobService = blobService;
        this.popupService = popupService;
        this.$translate = $translate;
        this.importType = {
            product: 1,
            category: 2
        };
        this.asc = 'ascending';
        this.desc = 'descending';
        this.sortSet = [
            {
                column: 'ID',
                order: this.asc,
                title: this.$translate.instant('creation_date'),
                classSort: 'sort-amount-asc'
            }, {
                column: 'ID',
                order: this.desc,
                title: this.$translate.instant('creation_date'),
                classSort: 'sort-amount-desc'
            }, {
                column: 'Title',
                order: this.asc,
                title: this.$translate.instant('product_name_upper'),
                classSort: 'sort-alpha-asc'
            }, {
                column: 'Title',
                order: this.desc,
                title: this.$translate.instant('product_name_upper'),
                classSort: 'sort-alpha-desc'
            }
        ];
        this.linkViewClasses = {
            video: 'fa-youtube-play',
            document: 'fa-file-pdf-o',
            website: 'fa-globe',
            facebook: 'fa-facebook-official',
            twitter: 'fa-twitter',
            instagram: 'fa-instagram',
            pinterest: 'fa-pinterest',
            "default": 'fa-external-link-square'
        };
        this.linkTypes = null;
        this.badges = [
            { key: 0, name: this.$translate.instant('no_badge'), selected: false, order: 0, color: 'transparent', textcolor: '#585f69' },
            { key: 1, name: this.$translate.instant('new'), selected: false, order: 1, color: '#ffc107', textcolor: '#fff' },
            { key: 2, name: this.$translate.instant('limited_offer'), selected: false, order: 4, color: '#4bac4e', textcolor: '#fff' },
            { key: 4, name: this.$translate.instant('hot_deal'), selected: false, order: 5, color: '#fe9700', textcolor: '#fff' },
            { key: 8, name: this.$translate.instant('sale_ending_soon'), selected: false, order: 7, color: '#6d2077', textcolor: '#fff' },
            { key: 16, name: this.$translate.instant('clearence_sale'), selected: false, order: 8, color: '#f34235', textcolor: '#fff' },
            { key: 32, name: this.$translate.instant('new_collection'), selected: false, order: 2, color: '#ffc107', textcolor: '#fff' },
            { key: 64, name: this.$translate.instant('sale'), selected: false, order: 6, color: '#6d2077', textcolor: '#fff' },
            { key: 128, name: this.$translate.instant('offer'), selected: false, order: 3, color: '#f34235', textcolor: '#fff' },
        ];
        this.genders = [
            { ID: this.$rootScope.enums.Gender.Male, Name: this.$translate.instant('male') },
            { ID: this.$rootScope.enums.Gender.Female, Name: this.$translate.instant('female') }
        ];
        this.measurementTypes = [
            { ID: this.$rootScope.enums.MeasurementType.Neck, Name: this.$translate.instant('neck'), SelectText: this.$translate.instant('select_neck_size') },
            { ID: this.$rootScope.enums.MeasurementType.Chest, Name: this.$translate.instant('chest'), SelectText: this.$translate.instant('select_chest_size') },
            { ID: this.$rootScope.enums.MeasurementType.Bust, Name: this.$translate.instant('bust'), SelectText: this.$translate.instant('select_bust_size') },
            { ID: this.$rootScope.enums.MeasurementType.Waist, Name: this.$translate.instant('waist'), SelectText: this.$translate.instant('select_waist_size') },
            { ID: this.$rootScope.enums.MeasurementType.Hips, Name: this.$translate.instant('hips'), SelectText: this.$translate.instant('select_hips_size') },
            { ID: this.$rootScope.enums.MeasurementType.InsideLeg, Name: this.$translate.instant('inside_leg'), SelectText: this.$translate.instant('select_inside_leg_size') },
            { ID: this.$rootScope.enums.MeasurementType.Shoe, Name: this.$translate.instant('shoe'), SelectText: this.$translate.instant('select_shoe_size') },
            { ID: this.$rootScope.enums.MeasurementType.LegLength, Name: this.$translate.instant('leg_length'), SelectText: this.$translate.instant('select_leg_length') },
            { ID: this.$rootScope.enums.MeasurementType.Dress, Name: this.$translate.instant('dress'), SelectText: this.$translate.instant('select_dress_size') }
        ];
        this.defaultProduct = {
            title: '',
            brands: [],
            category: null,
            description: '',
            shortDescription: '',
            links: [],
            itemTypeID: null,
            gender: null,
            variations: [],
            error: {},
            measurementItems: {},
            measurementTypeEnable: {},
            measurementTypeVisible: {},
            measurementEnable: false,
            nfcStickers: [],
            allergens: [],
            extras: [],
            ingredientList: [],
            foodPreferences: [],
            originCountry: null,
            preparation: '',
            ingredients: ''
        };
        this.defaultVariation = {
            id: null,
            color: '',
            size: '',
            sku: '',
            badges: this.getClientBadges(0, false),
            price: '',
            oldPrice: '',
            vat: null,
            insidePrice: null,
            insideVAT: null,
            measurementItemValues: {},
            measurementTypeItem: {},
            imagesID: [],
            ingredients: [],
            imageID: null,
            error: {},
            discount: null,
            specialOffer: null,
            attachment: null,
            isAccessibleOutOfSession: null
        };
        this.exportCsvProduct = function (query) {
            return _this.http.getAllResponse(_this.retailerService.exportCsvProduct(), {
                params: query,
                responseType: 'text'
            });
        };
        this.getLinkTypes = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var types;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!_.isArray(this.linkTypes)) return [3 /*break*/, 1];
                        return [2 /*return*/, this.$q.when(this.linkTypes)];
                    case 1: return [4 /*yield*/, this.http.get(this.retailerService.productLinkTypes())];
                    case 2:
                        types = _a.sent();
                        _.forEach(types, function (type) {
                            var viewClass = _this.linkViewClasses[type.Name.toLowerCase()];
                            type.viewClass = viewClass ? viewClass : _this.linkViewClasses["default"];
                        });
                        this.linkTypes = types;
                        return [2 /*return*/, this.$q.when(this.linkTypes)];
                }
            });
        }); };
        this.getProductModel = function (productID, edit) { return __awaiter(_this, void 0, void 0, function () {
            var serverModel, imagesID, exchange;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.retailerService.product(productID))];
                    case 1:
                        serverModel = _a.sent();
                        imagesID = [];
                        if (!edit) {
                            serverModel.NfcStickers = [];
                            _.forEach(serverModel.Variations, function (variation) {
                                _.forEach(variation.ImagesID, function (id) {
                                    imagesID.push(id);
                                });
                            });
                        }
                        if (!_.isEmpty(imagesID)) return [3 /*break*/, 2];
                        return [2 /*return*/, this.toClientProductModel(serverModel, imagesID, edit)];
                    case 2: return [4 /*yield*/, this.copyImage(imagesID)];
                    case 3:
                        exchange = _a.sent();
                        return [2 /*return*/, this.toClientProductModel(serverModel, exchange, edit)];
                }
            });
        }); };
        this.toServerVariation = function (variation) {
            var measurementType = _this.$rootScope.enums.MeasurementType;
            return {
                ID: variation.id,
                Size: variation.size,
                Color: variation.color,
                ImagesID: variation.imagesID,
                Price: variation.price,
                OldPrice: variation.oldPrice,
                SKU: variation.sku,
                Badges: _this.getServerBadges(variation.badges),
                Discount: variation.discount,
                VAT: variation.vat,
                InsidePrice: variation.insidePrice,
                InsideVAT: variation.insideVAT,
                IsHot: variation.isHot,
                PreparationTime: variation.preparationTime,
                Ingredients: variation.ingredients,
                SpecialOffer: _this.toServerSpecialOffer(variation.specialOffer),
                StockQuantity: variation.stockQuantity,
                NeckSize: variation.measurementTypeItem[measurementType.Neck] ? variation.measurementTypeItem[measurementType.Neck].Value : null,
                ChestSize: variation.measurementTypeItem[measurementType.Chest] ? variation.measurementTypeItem[measurementType.Chest].Value : null,
                BustSize: variation.measurementTypeItem[measurementType.Bust] ? variation.measurementTypeItem[measurementType.Bust].Value : null,
                WaistSize: variation.measurementTypeItem[measurementType.Waist] ? variation.measurementTypeItem[measurementType.Waist].Value : null,
                HipsSize: variation.measurementTypeItem[measurementType.Hips] ? variation.measurementTypeItem[measurementType.Hips].Value : null,
                InsideLegSize: variation.measurementTypeItem[measurementType.InsideLeg] ? variation.measurementTypeItem[measurementType.InsideLeg].Value : null,
                ShoeSize: variation.measurementTypeItem[measurementType.Shoe] ? variation.measurementTypeItem[measurementType.Shoe].Value : null,
                LegLengthSize: variation.measurementTypeItem[measurementType.LegLength] ? variation.measurementTypeItem[measurementType.LegLength].Value : null,
                DressSize: variation.measurementTypeItem[measurementType.Dress] ? variation.measurementTypeItem[measurementType.Dress].Value : null,
                Attachment: variation.attachment ? variation.attachment : null,
                IsAccessibleOutOfSession: variation.isAccessibleOutOfSession
            };
        };
    }
    ProductsService.prototype.getDefaultProductModel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product, md;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        product = angular.copy(this.defaultProduct);
                        product.allergens = [];
                        product.foodPreferences = [];
                        product.variations = [];
                        return [4 /*yield*/, this.getMetadata()];
                    case 1:
                        md = _a.sent();
                        product.sizeName = md.DefaultVariantFieldsName.SizeName;
                        product.colourName = md.DefaultVariantFieldsName.ColourName;
                        return [2 /*return*/, product];
                }
            });
        });
    };
    ProductsService.prototype.getDefaultVariationModel = function () {
        return angular.copy(this.defaultVariation);
    };
    ProductsService.prototype.getProducts = function (filter) {
        return this.http.get(this.retailerService.getProducts(), { params: filter });
    };
    ProductsService.prototype.findProducts = function (filter) {
        return this.http.get(this.retailerService.findProducts(), { params: filter });
    };
    ProductsService.prototype.fetchProducts = function (filter) {
        return this.http.get(this.retailerService.fetchProducts(), { params: filter });
    };
    ProductsService.prototype.getImageUrl = function (imageID, width, height) {
        return this.retailerService.getProductImageUrl(imageID, width, height || width);
    };
    ProductsService.prototype.getSort = function (column, order) {
        if (column && order) {
            return _.findWhere(this.sortSet, { column: column, order: order });
        }
        else {
            return this.sortSet[1];
        }
    };
    ProductsService.prototype.getSortSet = function () {
        return this.sortSet;
    };
    ProductsService.prototype.uploadImage = function (file) {
        if (!file) {
            return this.$q.when(null);
        }
        var fd = new FormData();
        fd.append('FileImage', this.blobService.dataUriToBlob(file.dataUri), file.name);
        return this.http.post(this.retailerService.variationImage(), fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };
    ProductsService.prototype.deleteImage = function (imageID) {
        return this.http["delete"](this.retailerService.variationImage(imageID));
    };
    ProductsService.prototype.copyImage = function (imagesID) {
        return this.http.post(this.retailerService.variationImageCopy(), imagesID);
    };
    ProductsService.prototype.updateProduct = function (productID, model) {
        return this.http.put(this.retailerService.product(productID), this.toServerProductModel(model));
    };
    ProductsService.prototype.createProduct = function (model) {
        return this.http.post(this.retailerService.product(), this.toServerProductModel(model));
    };
    ProductsService.prototype.archiveProduct = function (productID) {
        return this.http.post(this.retailerService.archiveProduct(productID), null);
    };
    ProductsService.prototype.restoreProduct = function (productID) {
        return this.http.post(this.retailerService.restoreProduct(productID), null);
    };
    ProductsService.prototype.restoreVariation = function (productID, variationID) {
        return this.http.post(this.retailerService.restoreProduct(productID, variationID), null);
    };
    ProductsService.prototype.getGenders = function () {
        return angular.copy(this.genders);
    };
    ProductsService.prototype.isExistProducts = function (state) {
        return this.http.get(this.retailerService.existProducts(state));
    };
    ProductsService.prototype.getTwinsVariations = function (productID, variationID) {
        return this.http.get(this.retailerService.productVariationTwins(productID, variationID));
    };
    ProductsService.prototype.getItemTypes = function (categoryID, gender) {
        return this.http.get(this.retailerService.productItemTypes(categoryID, gender));
    };
    ProductsService.prototype.getMeasurements = function (gender) {
        return this.http.get(this.retailerService.measurements(gender));
    };
    ProductsService.prototype.getSmlMeasurements = function (gender) {
        return this.http.get(this.retailerService.smlMeasurements(gender));
    };
    ProductsService.prototype.getMeasurementTypes = function () {
        return angular.copy(this.measurementTypes);
    };
    ProductsService.prototype.updatePrice = function (productID, model) {
        return this.http.put(this.retailerService.productPrice(productID), model);
    };
    ProductsService.prototype.updatePriceWithVat = function (productID, model) {
        return this.http.put(this.retailerService.productPriceWithVat(productID), model);
    };
    ProductsService.prototype.updateDiscount = function (productID, model) {
        return this.http.put(this.retailerService.productDiscount(productID), model);
    };
    ProductsService.prototype.updateStockLevel = function (productID, model) {
        return this.http.put(this.retailerService.productStockQuantity(productID), model);
    };
    ProductsService.prototype.showSaveChangesDialog = function () {
        var title = this.$translate.instant('save_changes_in_a_product_copy');
        var message = this.$translate.instant('save_changes_in_a_product_copy_confirm');
        return this.popupService.confirm({
            title: title,
            content: message
        });
    };
    ProductsService.prototype.getClientBadges = function (number, onlySelected) {
        var badges = this.getBadges();
        if (number === 0) {
            badges[0].selected = true;
        }
        else {
            var numberBit = this.getBitStringByNumber(number);
            for (var c = 0; c < numberBit.length; c++) {
                badges[c + 1].selected = numberBit[c] === '1';
            }
        }
        badges = _.sortBy(badges, 'order');
        if (onlySelected) {
            badges = _.where(badges, { selected: true });
        }
        return badges;
    };
    ProductsService.prototype.toServerProductModel = function (model) {
        var _this = this;
        var brand = model.brands[0];
        return {
            Title: model.title,
            NfcStickers: model.nfcStickers,
            VerificationRequired: model.verificationRequired,
            IsInformation: model.isInformation,
            Description: model.description,
            ShortDescription: model.shortDescription,
            Brand: brand ? {
                ID: brand.ID,
                Name: brand.Name,
                Status: brand.Status
            } : null,
            Gender: model.genderItem ? (model.genderItem.ID === 1 ? core_1.PhysicalProduct.GenderEnum.NUMBER_1 : core_1.PhysicalProduct.GenderEnum.NUMBER_2) : null,
            ClassificationCategory: model.category ? {
                ID: model.category.ID,
                Name: model.category.Name,
                FullName: model.category.FullName
            } : null,
            Links: _.map(model.links, this.toServerLink),
            // Tags: <PhysicalProductTagListItem[]>model.tags,
            ItemTypeID: model.itemType ? model.itemType.ID : null,
            Variations: _.map(model.variations, function (variation) {
                if (model.measurementEnable) {
                    variation.size = null;
                }
                else {
                    variation.measurementTypeItem = {};
                }
                return _this.toServerVariation(variation);
            }),
            Allergens: model.allergens && model.allergens.length > 0 ? _.map(_.filter(model.allergens, function (allergen) {
                return allergen.IsSelected === true;
            }), function (allergen) {
                return allergen.ID;
            }) : null,
            FoodPreferences: model.foodPreferences && model.foodPreferences.length > 0 ? _.map(_.filter(model.foodPreferences, function (allergen) {
                return allergen.IsSelected === true;
            }), function (allergen) {
                return allergen.ID;
            }) : null,
            Extras: model.extras,
            IngredientList: model.ingredientList,
            Preparation: model.preparation,
            Ingredients: model.ingredients,
            Source: model.originCountry ? model.originCountry.ID : null,
            PreOrder: model.preOrder
        };
    };
    ProductsService.prototype.uploadImportFile = function (file, importType) {
        if (!file) {
            return this.$q.when(null);
        }
        var url = importType === this.importType.category ? this.retailerService.categoryMappingImport() : this.retailerService.productsImport();
        var fd = new FormData();
        fd.append('file', file, file.name);
        return this.http.post(url, fd, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };
    ProductsService.prototype.isExistCategoryMapping = function () {
        return this.http.get(this.retailerService.categoryMappingExist());
    };
    ProductsService.prototype.isProductsImportQueued = function () {
        return this.http.get(this.retailerService.productsImportQueued());
    };
    ProductsService.prototype.productsImport = function () {
        return this.$uibModal.open({
            component: 'productsImport',
            resolve: {},
            size: 'sm'
        }).result;
    };
    ProductsService.prototype.getMetadata = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.metadata) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.retailerService.productsMetadata())];
                    case 1:
                        _a.metadata = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.metadata];
                }
            });
        });
    };
    ProductsService.prototype.GetCountryOrigins = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.retailerService.countryOrigins())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProductsService.prototype.getCategoryFieldNames = function (categoryID) {
        return __awaiter(this, void 0, void 0, function () {
            var md, fieldNames, search;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMetadata()];
                    case 1:
                        md = _a.sent();
                        fieldNames = md.DefaultVariantFieldsName;
                        if (categoryID) {
                            search = md.CategoryVariantFieldsNames[categoryID];
                            if (search) {
                                return [2 /*return*/, search];
                            }
                        }
                        return [2 /*return*/, fieldNames];
                }
            });
        });
    };
    ProductsService.prototype.addAttachment = function (file) {
        var formData = new FormData();
        formData.append('File', file);
        return this.http.post(this.retailerService.attachment(), formData, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        });
    };
    ProductsService.prototype.deleteAttachment = function (id) {
        return this.http["delete"](this.retailerService.attachment(id));
    };
    ProductsService.prototype.getAttachment = function (id) {
        return this.http.get(this.retailerService.attachment(id), { responseType: 'arraybuffer' });
    };
    ProductsService.prototype.getBadges = function () {
        return _.sortBy(angular.copy(this.badges), 'key');
    };
    ProductsService.prototype.getBitStringByNumber = function (number) {
        // needed since toString does not zero fill on left
        var template = '';
        for (var c = 1; c < _.size(this.badges); c++) {
            template += '0';
        }
        // toString converts a number to a bitstring
        var bit = number.toString(2).split('').reverse().join('');
        return bit + template.substring(0, template.length - bit.length);
    };
    ProductsService.prototype.toClientVariation = function (serverVariation, exchangeImages, edit) {
        var variation = this.getDefaultVariationModel();
        variation.color = serverVariation.Color;
        variation.size = serverVariation.Size;
        variation.sku = serverVariation.SKU;
        variation.price = serverVariation.Price;
        variation.oldPrice = serverVariation.OldPrice;
        variation.discount = serverVariation.Discount;
        variation.vat = serverVariation.VAT;
        variation.insidePrice = serverVariation.InsidePrice;
        variation.insideVAT = serverVariation.InsideVAT;
        variation.isHot = serverVariation.IsHot;
        variation.preparationTime = serverVariation.PreparationTime;
        variation.attachment = serverVariation.Attachment;
        variation.isAccessibleOutOfSession = serverVariation.IsAccessibleOutOfSession;
        if (!serverVariation.Price) {
            serverVariation.Ingredients.forEach(function (ingredient) { return ingredient.Price = null; });
        }
        if (!serverVariation.InsidePrice) {
            serverVariation.Ingredients.forEach(function (ingredient) { return ingredient.InsidePrice = null; });
        }
        variation.ingredients = serverVariation.Ingredients;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Neck] = serverVariation.NeckSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Chest] = serverVariation.ChestSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Bust] = serverVariation.BustSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Waist] = serverVariation.WaistSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Hips] = serverVariation.HipsSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.InsideLeg] = serverVariation.InsideLegSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Shoe] = serverVariation.ShoeSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.LegLength] = serverVariation.LegLengthSize;
        variation.measurementItemValues[this.$rootScope.enums.MeasurementType.Dress] = serverVariation.DressSize;
        variation.imagesID = edit ? serverVariation.ImagesID : _.map(serverVariation.ImagesID, function (id) { return exchangeImages[id]; });
        variation.badges = this.getClientBadges(serverVariation.Badges, false);
        variation.id = edit ? serverVariation.ID : null;
        variation.specialOffer = serverVariation.SpecialOffer;
        if (variation.specialOffer && variation.specialOffer.OfferValidFrom) {
            variation.specialOffer.OfferValidFrom = new Date(variation.specialOffer.OfferValidFrom.toString());
        }
        if (variation.specialOffer && variation.specialOffer.OfferValidTo) {
            variation.specialOffer.OfferValidTo = new Date(variation.specialOffer.OfferValidTo.toString());
        }
        variation.stockQuantity = serverVariation.StockQuantity;
        return variation;
    };
    ProductsService.prototype.toClientProductModel = function (serverProduct, exchangeImages, edit) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var product, fieldNames;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        product = angular.copy(this.defaultProduct);
                        product.title = serverProduct.Title;
                        product.nfcStickers = serverProduct.NfcStickers;
                        product.verificationRequired = serverProduct.VerificationRequired;
                        product.isInformation = serverProduct.IsInformation;
                        product.brands = serverProduct.Brand ? [serverProduct.Brand] : [];
                        product.category = serverProduct.ClassificationCategory;
                        product.description = serverProduct.Description;
                        product.shortDescription = serverProduct.ShortDescription;
                        product.draft = serverProduct.Draft;
                        product.links = serverProduct.Links;
                        product.itemTypeID = serverProduct.ItemTypeID;
                        product.gender = serverProduct.Gender;
                        product.variations = _.map(serverProduct.Variations, function (variation) {
                            return _this.toClientVariation(variation, exchangeImages, edit);
                        });
                        return [4 /*yield*/, this.getCategoryFieldNames(product.category ? product.category.ID : null)];
                    case 1:
                        fieldNames = _a.sent();
                        product.sizeName = fieldNames.SizeName;
                        product.colourName = fieldNames.ColourName;
                        if (serverProduct.Allergens) {
                            product.allergens = _.map(serverProduct.Allergens, function (id) {
                                var all = { ID: id, IsSelected: true };
                                return all;
                            });
                        }
                        if (serverProduct.FoodPreferences) {
                            product.foodPreferences = _.map(serverProduct.FoodPreferences, function (id) {
                                var pref = { ID: id, IsSelected: true };
                                return pref;
                            });
                        }
                        product.extras = _.map(serverProduct.Extras, function (extr) {
                            var extra = {
                                ID: extr.ID,
                                ImageID: extr.ImageID,
                                Title: extr.Title,
                                Price: extr.Price,
                                MaxAmount: extr.MaxAmount,
                                CurrencySign: extr.CurrencySign,
                                QuantityError: null
                            };
                            return extra;
                        });
                        product.ingredientList = _.map(serverProduct.IngredientList, function (ingredient) {
                            var item = {
                                ID: ingredient.ID,
                                MinQuantity: ingredient.MinQuantity,
                                Title: ingredient.Title
                            };
                            return item;
                        });
                        product.ingredients = serverProduct.Ingredients;
                        product.preparation = serverProduct.Preparation;
                        if (serverProduct.Source) {
                            product.originCountry = { ID: serverProduct.Source };
                        }
                        product.preOrder = serverProduct.PreOrder;
                        return [2 /*return*/, product];
                }
            });
        });
    };
    ProductsService.prototype.getServerBadges = function (badges) {
        var number = 0;
        _.forEach(badges, function (badge) {
            if (badge.selected) {
                number += badge.key;
            }
        });
        return number;
    };
    ProductsService.prototype.toServerLink = function (link) {
        return {
            Type: link.type.ID,
            Title: link.Title,
            Url: link.Url
        };
    };
    ProductsService.prototype.toServerSpecialOffer = function (specialOffer) {
        if (specialOffer) {
            var copy = angular.copy(specialOffer);
            delete copy.error;
            return copy;
        }
        return null;
    };
    ProductsService.$inject = ['$rootScope', 'http', '$q', '$uibModal', 'retailerService', 'blobService', 'popupService', '$translate'];
    return ProductsService;
}());
exports.ProductsService = ProductsService;
angular
    .module('naut')
    .service('productsService', ProductsService);


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var models_1 = __webpack_require__(83);
var OffersService = /** @class */ (function () {
    function OffersService($translate, accountService, languageService) {
        this.$translate = $translate;
        this.accountService = accountService;
        this.languageService = languageService;
    }
    OffersService.prototype.getOfferTypes = function () {
        return this.generateOfferTypes();
    };
    OffersService.prototype.isValidOffer = function (offer, price) {
        offer.error = {};
        var offerTypes = this.generateOfferTypes();
        var offerType = offerTypes.find(function (type) { return type.value === offer.Type; });
        return offerType.validators.reduce(function (prevValue, func) {
            return func(offer, price) && prevValue;
        }, true);
    };
    OffersService.prototype.checkIfDatesCorrect = function (offer) {
        if (!offer.OfferValidFrom) {
            offer.error.startDate = this.$translate.instant('field_is_required');
            return false;
        }
        if (!offer.OfferValidFrom) {
            offer.error.startDate = this.$translate.instant('field_is_required');
            return false;
        }
        if (offer.OfferValidFrom >= offer.OfferValidTo) {
            offer.error.endDate = this.$translate.instant('invalid_end_date');
            return false;
        }
        return true;
    };
    OffersService.prototype.checkIfDiscountCorrect = function (offer, oldPrice) {
        var discount = parseFloat(offer.DiscountPrice);
        var price = parseFloat(oldPrice);
        if (_.isNaN(discount) || discount <= 0) {
            offer.error.price = this.$translate.instant('must_be_greater_than_0');
            return false;
        }
        if (!_.isNaN(price) && price <= discount) {
            offer.error.price = this.$translate.instant('must_be_less_than_the_old_price');
            return false;
        }
        var diff = Number.parseFloat((price - discount).toFixed(2));
        var countryID = this.accountService.userData.countryID;
        if (offer.TemplateType === models_1.OfferTemplateTypeEnum.SaveXX && diff < 1 && diff > 0) {
            offer.error.price = this.$translate.instant('not_pound_offer', { countryID: countryID });
            return false;
        }
        if (offer.TemplateType === models_1.OfferTemplateTypeEnum.SaveXXp && diff > 0.99) {
            offer.error.price = this.$translate.instant('not_pence_offer', { countryID: countryID });
            return false;
        }
        if ((offer.TemplateType === models_1.OfferTemplateTypeEnum.NowOnlyXX || offer.TemplateType === models_1.OfferTemplateTypeEnum.OnlyXX) && offer.DiscountPrice < 1) {
            offer.error.price = this.$translate.instant('price_must_be_not_less_pound', { countryID: countryID });
            return false;
        }
        if (offer.TemplateType === models_1.OfferTemplateTypeEnum.NowOnlyXXp && offer.DiscountPrice >= 1) {
            offer.error.price = this.$translate.instant('price_must_be_less_pound', { countryID: countryID });
            return false;
        }
        return true;
    };
    OffersService.prototype.checkIfBuyXGetYCorrect = function (offer) {
        var result = true;
        if (!offer.BuyXGetYOfferValues.Buy || offer.BuyXGetYOfferValues.Buy < 1) {
            offer.error.buyQuantity = this.$translate.instant('must_be_greater_than_0');
            result = false;
        }
        if (!offer.BuyXGetYOfferValues.Get || offer.BuyXGetYOfferValues.Get < 1) {
            offer.error.getQuantity = this.$translate.instant('must_be_greater_than_0');
            result = false;
        }
        return result;
    };
    OffersService.prototype.checkIfBuyYForYCorrect = function (offer) {
        var result = true;
        var countryID = this.accountService.userData.countryID;
        if (!offer.BuyXForYSumYOfferValues.Buy || offer.BuyXForYSumYOfferValues.Buy < 1) {
            offer.error.buyQuantity = this.$translate.instant('must_be_greater_than_0');
            result = false;
        }
        var sum = parseFloat(offer.BuyXForYSumYOfferValues.Sum);
        if (_.isNaN(sum) || sum <= 0) {
            offer.error.price = this.$translate.instant('must_be_greater_than_0');
            result = false;
        }
        if (offer.TemplateType === models_1.OfferTemplateTypeEnum.BuyXForY && offer.BuyXForYSumYOfferValues.Sum < 1) {
            offer.error.price = this.$translate.instant('price_must_be_not_less_pound', { countryID: countryID });
            result = false;
        }
        if (offer.TemplateType === models_1.OfferTemplateTypeEnum.BuyXForYp && offer.BuyXForYSumYOfferValues.Sum >= 1) {
            offer.error.price = this.$translate.instant('price_must_be_less_pound', { countryID: countryID });
            result = false;
        }
        return result;
    };
    OffersService.prototype.generateOfferTypes = function () {
        var settings = this.languageService.getLangSettingsOrDefault(this.accountService.userData.countryID);
        var wholeSign = settings.currencySign + settings.currencySeparator;
        var fracSign = settings.currencySeparator + settings.currencyFracSign;
        return [
            {
                name: this.$translate.instant('discount'),
                value: models_1.SpecialOfferTypeEnum.Discount,
                validators: [
                    this.checkIfDatesCorrect.bind(this),
                    this.checkIfDiscountCorrect.bind(this)
                ],
                templates: [
                    {
                        name: this.$translate.instant('template_type_save_xx', { sign: wholeSign }),
                        value: models_1.OfferTemplateTypeEnum.SaveXX
                    },
                    {
                        name: this.$translate.instant('template_type_save_xx_p', { sign: fracSign }),
                        value: models_1.OfferTemplateTypeEnum.SaveXXp
                    },
                    {
                        name: this.$translate.instant('template_type_now_only_xx', { sign: wholeSign }),
                        value: models_1.OfferTemplateTypeEnum.NowOnlyXX
                    },
                    {
                        name: this.$translate.instant('template_type_now_only_xx_p', { sign: fracSign }),
                        value: models_1.OfferTemplateTypeEnum.NowOnlyXXp
                    },
                    {
                        name: this.$translate.instant('template_type_only_xx', { sign: wholeSign }),
                        value: models_1.OfferTemplateTypeEnum.OnlyXX
                    }
                ]
            },
            {
                name: this.$translate.instant('buy_x_get_y'),
                value: models_1.SpecialOfferTypeEnum.BuyXGetY,
                validators: [
                    this.checkIfDatesCorrect.bind(this),
                    this.checkIfBuyXGetYCorrect.bind(this)
                ]
            },
            {
                name: this.$translate.instant('buy_x_for_y'),
                value: models_1.SpecialOfferTypeEnum.BuyXForY,
                validators: [
                    this.checkIfDatesCorrect.bind(this),
                    this.checkIfBuyYForYCorrect.bind(this)
                ],
                templates: [
                    {
                        name: this.$translate.instant('template_type_buy_x_for_y', { sign: wholeSign }),
                        value: models_1.OfferTemplateTypeEnum.BuyXForY
                    },
                    {
                        name: this.$translate.instant('template_type_buy_x_for_y_p', { sign: fracSign }),
                        value: models_1.OfferTemplateTypeEnum.BuyXForYp
                    }
                ]
            }
        ];
    };
    OffersService.$inject = [
        '$translate',
        'accountService',
        'languageService'
    ];
    return OffersService;
}());
exports.OffersService = OffersService;
angular
    .module('naut')
    .service('offersService', OffersService);


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var core_1 = __webpack_require__(59);
var angular = __webpack_require__(0);
var PublisherSettingsComponent = /** @class */ (function () {
    function PublisherSettingsComponent($translate, retailerService, publisherSettingsService, notificationService, $uibModal) {
        this.$translate = $translate;
        this.retailerService = retailerService;
        this.publisherSettingsService = publisherSettingsService;
        this.notificationService = notificationService;
        this.$uibModal = $uibModal;
        this.waiting = false;
        this.maxSessionDuration = 1440;
        this.maxPeriodDuration = 168;
        this.maxLimit = 10079;
        this.showLogoPopup = false;
        this.minSize = {
            w: 210,
            h: 210
        };
        this.imageChanged = false;
    }
    PublisherSettingsComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.fetchFormData()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PublisherSettingsComponent.prototype.addImage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var image, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showLogoPopup = false;
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return _this.logoImage != null; },
                                    title: function () { return _this.$translate.instant('store_photo'); },
                                    sizeText: function () { return _this.$translate.instant('store_photo_min_size_hint', { width: 210, height: 210 }); },
                                    getUrl: function () {
                                        if (_this.imageChanged) {
                                            return _this.logoImage;
                                        }
                                        else if (_this.originalStore.IconID) {
                                            return _this.retailerService.getStoreLogoUrl(_this.originalStore.IconID);
                                        }
                                        else {
                                            return null;
                                        }
                                    },
                                    imageSize: function () { return _this.minSize; }
                                },
                                backdrop: 'static'
                            }).result];
                    case 2:
                        image = _a.sent();
                        if (image) {
                            this.logoImage = image;
                            this.imageChanged = true;
                            this.form.$setDirty();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PublisherSettingsComponent.prototype.removeLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.showLogoPopup = false;
                this.logoImage = null;
                this.imageChanged = true;
                this.form.$setDirty();
                return [2 /*return*/];
            });
        });
    };
    PublisherSettingsComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requests, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        if (!this.isFormValid()) {
                            this.form.$$controls.map(function (control) { return control.$setDirty(); });
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        requests = [];
                        if (this.originalStore.Name !== this.businessName) {
                            requests.push(this.publisherSettingsService.savePublisherName(this.originalStore.ID, this.businessName));
                        }
                        if (!this.imageChanged) return [3 /*break*/, 4];
                        if (!this.originalStore.IconID) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.publisherSettingsService.deleteLogo(this.originalStore.IconID)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (this.logoImage) {
                            requests.push(this.publisherSettingsService.uploadImage(this.originalStore.ID, this.logoImage));
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, core_1.$q.all(requests)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.fetchFormData()];
                    case 6:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        return [3 /*break*/, 9];
                    case 7:
                        e_2 = _a.sent();
                        this.notificationService.showErrorMessage(e_2);
                        return [3 /*break*/, 9];
                    case 8:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PublisherSettingsComponent.prototype.isFormValid = function () {
        return this.businessName && this.form.CompanyName.$valid;
    };
    PublisherSettingsComponent.prototype.fetchFormData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stores;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publisherSettingsService.getStores()];
                    case 1:
                        stores = _a.sent();
                        if (stores && stores[0]) {
                            this.originalStore = stores[0];
                            this.businessName = stores[0].Name;
                            this.logoImage = stores[0].IconID ? this.retailerService.getStoreLogoUrl(stores[0].IconID, 124, 124) : null;
                        }
                        this.imageChanged = false;
                        this.form.$setPristine();
                        return [2 /*return*/];
                }
            });
        });
    };
    PublisherSettingsComponent.$inject = [
        '$translate',
        'retailerService',
        'publisherSettingsService',
        'notificationService',
        '$uibModal'
    ];
    return PublisherSettingsComponent;
}());
angular.module('naut').component('publisherSettings', {
    template: __webpack_require__(841),
    controller: PublisherSettingsComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var PublisherSettingsService = /** @class */ (function () {
    function PublisherSettingsService(http, retailerService, blobService) {
        this.http = http;
        this.retailerService = retailerService;
        this.blobService = blobService;
    }
    PublisherSettingsService.prototype.getStores = function () {
        return this.http.get(this.retailerService.allStores());
    };
    PublisherSettingsService.prototype.savePublisherName = function (storeId, name) {
        return this.http.put(this.retailerService.savePublisher(storeId), { Name: name });
    };
    PublisherSettingsService.prototype.deleteLogo = function (logoId) {
        return this.http["delete"](this.retailerService.storeLogo(logoId));
    };
    PublisherSettingsService.prototype.uploadImage = function (storeId, dataUri) {
        var form = new FormData();
        form.append('FileImage', this.blobService.dataUriToBlob(dataUri));
        var config = {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        };
        return this.http.post(this.retailerService.storeLogo(storeId), form, config);
    };
    PublisherSettingsService.$inject = ['http', 'retailerService', 'blobService'];
    return PublisherSettingsService;
}());
exports.PublisherSettingsService = PublisherSettingsService;
angular
    .module('naut')
    .service('publisherSettingsService', PublisherSettingsService);


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ReferralAccountComponent = /** @class */ (function () {
    function ReferralAccountComponent($scope, $timeout, referralAccountsService, notificationService) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.referralAccountsService = referralAccountsService;
        this.notificationService = notificationService;
        this.modalInstance = this;
        this.data = {
            shopper: null,
            referralCode: '',
            storeID: null
        };
        this.error = null;
        this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.referralAccountsService.add({
                                ShopperID: this.data.shopper.ID,
                                StoreID: this.data.storeID
                            })];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.cancel = function () {
            _this.modalInstance.dismiss({ $value: 'cancel' });
        };
        this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        this.$scope.$watch('$ctrl.data.referralCode', function (n, o) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, error_2;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!n || n === o) {
                                            return [2 /*return*/];
                                        }
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        _a = this.data;
                                        return [4 /*yield*/, this.referralAccountsService.searchByReferralCode(n)];
                                    case 2:
                                        _a.shopper = _b.sent();
                                        this.error = null;
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_2 = _b.sent();
                                        this.error = error_2;
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); };
        this.init();
    }
    ReferralAccountComponent.$inject = ['$scope', '$timeout', 'referralAccountsService', 'notificationService'];
    return ReferralAccountComponent;
}());
angular.module('naut').component('referralAccount', {
    template: __webpack_require__(842),
    controller: ReferralAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var viewport_typed_controller_1 = __webpack_require__(4);
var popupServiceCancel_1 = __webpack_require__(5);
var ReferralAccountsController = /** @class */ (function (_super) {
    __extends(ReferralAccountsController, _super);
    function ReferralAccountsController($scope, $q, referralAccountsService, shopService, popupService, notificationService, $translate) {
        var _this = _super.call(this, $scope) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.referralAccountsService = referralAccountsService;
        _this.shopService = shopService;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.$translate = $translate;
        _this.waiting = false;
        _this.stores = [];
        _this.filterStores = [];
        _this.data = null;
        _this.shoppersSelected = false;
        _this.allShoppersSelected = false;
        _this.editing = false;
        _this.settings = {
            filter: {
                pageSize: 10,
                page: 1,
                sortOrder: 'ascending',
                sortColumn: 'ShopperName',
                keywords: null,
                storeID: null
            },
            getPaginationFilter: function () {
                var filter = _this.settings.filter;
                return {
                    limit: filter.pageSize,
                    offset: (filter.page - 1) * filter.pageSize,
                    sortColumn: filter.sortColumn,
                    sortOrder: filter.sortOrder,
                    keywords: filter.keywords,
                    storeID: filter.storeID
                };
            }
        };
        _this.asc = 'ascending';
        _this.desc = 'descending';
        _this.add = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.referralAccountsService.openAccountManager(this.stores)];
                    case 1:
                        _a.sent();
                        this.refreshList();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_1)) {
                            this.notificationService.showErrorMessage();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.edit = function (form) {
            _this.editing = true;
            form.$show();
        };
        _this.save = function (shopper) { return __awaiter(_this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.cancelEdit();
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.referralAccountsService.update({
                                ShopperID: shopper.ID,
                                StoreID: shopper.Store.ID
                            })];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.remove = function (shopper) { return __awaiter(_this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('remove_referral_account'),
                                content: this.$translate.instant('remove_referral_account_confirm')
                            })];
                    case 1:
                        _a.sent();
                        this.removeShoppers([shopper.ID]);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_3)) {
                            this.notificationService.showErrorMessage(error_3);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.removeSelected = function () { return __awaiter(_this, void 0, void 0, function () {
            var shopperIDs, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('remove_selected_referral_account'),
                                content: this.$translate.instant('remove_selected_referral_account_confirm')
                            })];
                    case 1:
                        _a.sent();
                        shopperIDs = this.getSelectedShoppers().map(function (shopper) {
                            return shopper.ID;
                        });
                        this.removeShoppers(shopperIDs);
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_4)) {
                            this.notificationService.showErrorMessage(error_4);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onShopperSelected = function () {
            var selectedShoppers = _this.getSelectedShoppers();
            _this.shoppersSelected = selectedShoppers.length !== 0;
            _this.allShoppersSelected = _this.shoppersSelected && _.size(selectedShoppers) === _.size(_this.data.Items);
        };
        _this.onAllShoppersSelected = function () {
            _this.data.Items.forEach(function (shopper) {
                shopper.selected = _this.allShoppersSelected;
            });
            _this.onShopperSelected();
        };
        _this.cancelEdit = function () {
            _this.editing = false;
        };
        _this.sort = function (column) {
            var filter = _this.settings.filter;
            if (filter.sortColumn === column) {
                filter.sortOrder = filter.sortOrder !== _this.asc ? _this.asc : _this.desc;
            }
            else {
                filter.sortColumn = column;
                filter.sortOrder = _this.asc;
            }
        };
        _this.getSelectedShoppers = function () {
            return _.where(_this.data.Items, { selected: true });
        };
        _this.removeShoppers = function (shopperIDs) { return __awaiter(_this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.referralAccountsService.remove(shopperIDs)];
                    case 2:
                        _a.sent();
                        this.refreshList();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.refreshList = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.referralAccountsService.list(this.settings.getPaginationFilter())];
                    case 2:
                        _a.data = _b.sent();
                        this.shoppersSelected = false;
                        this.allShoppersSelected = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _b.sent();
                        this.notificationService.showErrorMessage(error_6);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var result, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([
                                this.shopService.getStoresForFilter(),
                                this.refreshList()
                            ])];
                    case 2:
                        result = (_a.sent());
                        this.stores = result[0];
                        this.filterStores = this.stores.slice();
                        this.filterStores.unshift({
                            ID: null,
                            Name: 'All'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        this.notificationService.showErrorMessage(error_7);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.$scope.$watch('vm.settings.filter', function (n, o) {
                            if (n !== o) {
                                _this.refreshList();
                            }
                        }, true);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.init();
        return _this;
    }
    ReferralAccountsController.$inject = ['$scope', '$q', 'referralAccountsService', 'shopService', 'popupService', 'notificationService', '$translate'];
    return ReferralAccountsController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut')
    .component('referralAccounts', {
    template: __webpack_require__(843),
    controller: ReferralAccountsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var ReferralAccountsService = /** @class */ (function () {
    function ReferralAccountsService(http, $uibModal, retailerService) {
        var _this = this;
        this.http = http;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.openAccountManager = function (stores) {
            return _this.$uibModal.open({
                component: 'referralAccount',
                resolve: {
                    stores: function () { return stores; }
                },
                size: 'md',
                windowClass: 'staffPopup'
            }).result;
        };
    }
    ReferralAccountsService.prototype.searchByReferralCode = function (code) {
        return this.http.get(this.retailerService.shopperByReferralCode(), {
            params: { code: code }
        });
    };
    ReferralAccountsService.prototype.list = function (settings) {
        return this.http.get(this.retailerService.referralAccounts(), {
            params: settings
        });
    };
    ReferralAccountsService.prototype.add = function (model) {
        return this.http.post(this.retailerService.referralAccounts(), model);
    };
    ReferralAccountsService.prototype.update = function (model) {
        return this.http.put(this.retailerService.referralAccounts(), model);
    };
    ReferralAccountsService.prototype.remove = function (shopperIDs) {
        return this.http["delete"](this.retailerService.referralAccounts(), {
            params: { id: shopperIDs }
        });
    };
    ReferralAccountsService.$inject = ['http', '$uibModal', 'retailerService'];
    return ReferralAccountsService;
}());
exports.ReferralAccountsService = ReferralAccountsService;
angular
    .module('naut')
    .service('referralAccountsService', ReferralAccountsService);


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, $uiRouterProvider /* TODO */) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
    $urlRouterProvider.otherwise(function ($injector) {
        $injector.get('$state').go('errors.notfound');
    });
    // homepage
    /*     $stateProvider
            .state('homepage', {
                url: '/'
            }); */
    // jispPay dashboards routes | "redirect routes" - these states will be redirected to url in "hard" way: this.$window.location.href = ...
    // see auth.service.ts checkIfRedirectState()
    $stateProvider.state('jisppay', {
        abstract: true
    }).state('jisppay.loyalty', {
        url: '/jisppay/loyalty'
    }).state('jisppay.sessionsList', {
        url: '/jisppay/jispgo'
    }).state('jisppay.orders', {
        url: '/jisppay/orders'
    }).state('jisppay.select-store', {
        url: '/seller/select-store'
    }).state('jisppay.default', {
        url: '/jisppay'
    }).state('jisppay.delivery', {
        url: '/jisppay/delivery/orders'
    });
    var defaultTemplate = '<div ui-view></div>';
    function redirect(state) {
        return ['$state', 'accountService', function ($state, accountService) {
                if (accountService.userData.isAuth) {
                    $state.go(state);
                }
                else {
                    $state.go('account.login');
                }
            }];
    }
    $urlRouterProvider.when('/', redirect('home.screen'));
    $urlRouterProvider.when('/account', redirect('app.shops'));
    $urlRouterProvider.when('/dashboard', redirect('home.screen'));
    $urlRouterProvider.when('/dashboard/product', redirect('app.products'));
    $urlRouterProvider.when('/dashboard/marketing-campaigns', redirect('app.marketing-campaigns.overview'));
    $urlRouterProvider.when('/dashboard/account', redirect('app.account.statements'));
    $urlRouterProvider.when('/dashboard/jisppay', redirect('app.jisppay.places'));
    $urlRouterProvider.when('/dashboard/managers', redirect('app.managers.accounts'));
    $urlRouterProvider.when('/dashboard/discountForStaff', redirect('app.discountForStaffs.special.active'));
    $urlRouterProvider.when('/dashboard/bundle', redirect('app.bundles'));
    $urlRouterProvider.when('/dashboard/printers', redirect('app.printers.list'));
    $urlRouterProvider.when('/dashboard/vouchers', redirect('app.vouchers.list'));
    // retailer dashboard
    $stateProvider
        .state('home', {
        url: '/dashboard',
        abstract: true,
        template: __webpack_require__(78),
        data: {
            auth: true
        }
    })
        .state('home.screen', {
        url: '/home',
        component: 'homeScreen',
        data: {
            auth: true,
            title: 'jisp Dashboard',
            translateKey: 'dashboard_title'
        }
    })
        .state('app', {
        url: '/dashboard',
        abstract: true,
        template: __webpack_require__(855),
        data: {
            auth: true
        }
    }).state('app.profile', {
        url: '/profile',
        component: 'profile',
        data: {
            auth: true,
            title: 'Profile',
            translateKey: 'profile'
        }
    }).state('app.shops', {
        url: '/places?active',
        component: 'shops',
        params: {
            active: { value: 'true', squash: true }
        },
        data: {
            auth: true,
            title: 'Places',
            translateKey: 'places'
        }
    })
        .state('app.shop', {
        url: '/shop/:id',
        component: 'shop',
        data: {
            auth: true,
            title: 'Place',
            translateKey: 'place'
        }
    })
        .state('app.shopTables', {
        url: '/shop/:id/tables',
        component: 'shopTablesList',
        params: {
            shopName: '',
            shopTown: '',
            openAddTable: false
        },
        data: {
            auth: true,
            title: 'Place',
            translateKey: 'place'
        }
    })
        .state('app.create-shop', {
        url: '/shop/new',
        component: 'shop',
        data: {
            auth: true,
            title: 'Place',
            translateKey: 'place'
        }
    })
        .state('app.product', {
        abstract: true,
        template: defaultTemplate,
        url: '/product',
        data: {
            auth: true
        }
    })
        .state('app.products', {
        url: '/products?page&column&order&state&search',
        component: 'products',
        params: {
            page: { value: '1', squash: false },
            column: { value: 'ID', squash: false },
            order: { value: 'descending', squash: false },
            state: { value: '1', squash: false },
            search: { value: '', squash: true }
        },
        data: {
            auth: true,
            title: 'Products',
            translateKey: 'products'
        }
    })
        .state('app.product.edit', {
        url: '/{id}/edit',
        component: 'advancedProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.product.copy', {
        url: '/{id}/copy',
        component: 'advancedProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.product.new', {
        url: '/new',
        component: 'advancedProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.product.new-wizard', {
        url: '/new-wizard',
        component: 'wizardProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.product.copy-wizard', {
        url: '/{id}/copy-wizard',
        component: 'wizardProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.product.edit-wizard', {
        url: '/{id}/edit-wizard',
        component: 'wizardProduct',
        data: {
            auth: true,
            title: 'Product',
            translateKey: 'product'
        }
    })
        .state('app.extras', {
        abstract: true,
        template: defaultTemplate,
        url: '/extras',
        data: {
            auth: true
        }
    })
        .state('app.extras.active', {
        url: '/active',
        component: 'activeExtras',
        data: {
            auth: true,
            title: 'Extras',
            translateKey: 'extras'
        }
    })
        .state('app.extras.archived', {
        url: '/archived',
        component: 'archivedExtras',
        data: {
            auth: true,
            title: 'Extras',
            translateKey: 'extras'
        }
    })
        .state('app.extras.new', {
        url: '/new',
        component: 'addOrEditExtraItem',
        data: {
            auth: true,
            title: 'Extras',
            translateKey: 'extras'
        }
    })
        .state('app.extras.edit', {
        url: '/{id}/edit',
        component: 'addOrEditExtraItem',
        data: {
            auth: true,
            title: 'Extras',
            translateKey: 'extras'
        }
    })
        .state('app.nfc', {
        abstract: true,
        template: defaultTemplate,
        url: '/nfc',
        data: {
            auth: true
        }
    })
        .state('app.nfcs', {
        url: '/nfc',
        component: 'nfcRetailerTabList',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.nfcs.active', {
        url: '/active',
        component: 'nfcRetailerActiveTab',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.nfcs.deleted', {
        url: '/deleted',
        component: 'nfcRetailerDeletedTab',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.nfcs.history', {
        url: '/history',
        component: 'nfcRetailerHistoryTab',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.nfcs.export', {
        url: '/export',
        component: 'NfcExport',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.nfc.wizard', {
        url: '/wizard',
        component: 'nfcWizard',
        data: {
            auth: true,
            title: 'NFC Assignment',
            translateKey: 'nfc_assignment'
        }
    })
        .state('app.staff-rating', {
        abstract: true,
        template: defaultTemplate,
        url: '/staffRating',
        data: {
            auth: true
        }
    })
        .state('app.staff-ratings', {
        url: '/staffRatings?column&order',
        component: 'staffRatingList',
        params: {
            column: { value: 'Name', squash: false },
            order: { value: 'descending', squash: false }
        },
        data: {
            auth: true,
            title: 'Staff rating',
            translateKey: 'staff_rating'
        }
    })
        .state('app.staff-rating.details', {
        url: '/{id}',
        component: 'staffRatingDetails',
        params: {
            id: { value: '1', squash: false }
        },
        data: {
            auth: true,
            title: 'Staff rating',
            translateKey: 'staff_rating'
        }
    })
        .state('app.information-card', {
        abstract: true,
        template: defaultTemplate,
        url: '/infotag',
        data: {
            auth: true
        }
    })
        .state('app.information-cards', {
        url: '/infotags?page&column&order&state&search',
        component: 'informationCards',
        params: {
            page: { value: '1', squash: false },
            column: { value: 'ID', squash: false },
            order: { value: 'descending', squash: false },
            state: { value: '1', squash: false },
            search: { value: '', squash: true }
        },
        data: {
            auth: true,
            title: 'InfoTags',
            translateKey: 'information_cards'
        }
    })
        .state('app.information-card.edit', {
        url: '/{id}/edit',
        component: 'informationCard',
        data: {
            auth: true,
            title: 'InfoTag',
            translateKey: 'information_card'
        }
    })
        .state('app.information-card.new', {
        url: '/new',
        component: 'informationCard',
        data: {
            auth: true,
            title: 'InfoTag',
            translateKey: 'information_card'
        }
    })
        .state('app.help', {
        url: '/help',
        abstract: true,
        template: defaultTemplate
    })
        .state('app.help.manual', {
        url: '/manual',
        component: 'helpPage',
        data: {
            auth: false,
            title: 'Help',
            translateKey: 'help'
        }
    })
        .state('app.help.dictionary', {
        url: '/dictionary',
        component: 'helpDictionary',
        data: {
            auth: false,
            title: 'List of categories and item types',
            translateKey: 'list_of_categories'
        }
    })
        .state('app.help.preferences', {
        url: '/preferences',
        component: 'helpPreferences',
        data: {
            auth: false,
            title: 'List of food preferences and allergens',
            translateKey: 'list_of_preferences'
        }
    })
        .state('app.help.countries', {
        url: '/countries',
        component: 'helpCountries',
        data: {
            auth: false,
            title: 'List of origin countries',
            translateKey: 'list_of_countries'
        }
    })
        .state('app.menus', {
        url: '/menus?archived',
        component: 'menus',
        data: {
            auth: true,
            title: 'Menus',
            translateKey: 'menus'
        }
    })
        .state('app.create-menu', {
        url: '/menu/new',
        component: 'menu.editor',
        data: {
            auth: true,
            title: 'Menu',
            translateKey: 'menus'
        }
    })
        .state('app.edit-menu', {
        url: '/menu/{id}?duplicate',
        component: 'menu.editor',
        data: {
            auth: true,
            title: 'Menu',
            translateKey: 'menus'
        }
    })
        .state('app.activeIngredients', {
        url: '/ingredients/active',
        component: 'ingredientsTabs',
        params: {
            isActive: { value: true }
        },
        data: {
            auth: true,
            title: 'Ingredients',
            translateKey: 'ingredients'
        }
    })
        .state('app.archivedIngredients', {
        url: '/ingredients/archived',
        component: 'ingredientsTabs',
        params: {
            isActive: { value: false }
        },
        data: {
            auth: true,
            title: 'Ingredients',
            translateKey: 'ingredients'
        }
    })
        .state('app.inventory', {
        url: '/shop/{shopId:int}/inventory',
        component: 'inventory',
        params: {
            shop: null
        },
        data: {
            auth: true,
            title: 'Inventory',
            translateKey: 'inventory'
        }
    })
        .state('app.operations', {
        url: '/operations?page&from&to&filter',
        component: 'importTab',
        data: {
            auth: true,
            title: 'Operations'
        },
        params: {
            page: { value: '1', squash: true, dynamic: true },
            from: { squash: true, dynamic: true },
            to: { squash: true, dynamic: true },
            filter: { squash: true, dynamic: true }
        }
    })
        .state('app.operation', {
        url: '/operation?:id',
        component: 'operationComponent',
        data: {
            auth: true,
            title: 'Operation'
        }
    })
        .state('app.marketing-campaigns', {
        abstract: true,
        template: defaultTemplate,
        url: '/marketing-campaigns',
        data: {
            auth: true
        }
    })
        .state('app.marketing-campaigns.new-templated', {
        url: '/new-templated/:name',
        component: 'marketingCampaign',
        data: {
            auth: true,
            title: 'Create a Marketing campaign',
            translateKey: 'create_a_marketing_campaign'
        }
    })
        .state('app.marketing-campaigns.new-branded', {
        url: '/new-branded',
        component: 'marketingCampaign',
        data: {
            auth: true,
            title: 'Create a Marketing campaign',
            translateKey: 'create_a_marketing_campaign'
        }
    })
        .state('app.marketing-campaigns.overview', {
        url: '/overview',
        component: 'campaignsOverview',
        data: {
            auth: true,
            title: 'Campaigns Overview',
            translateKey: 'campaigns_overview'
        }
    })
        .state('app.marketing-campaigns.view', {
        url: '/{id:int}',
        component: 'viewCampaign',
        data: {
            auth: true,
            title: 'Campaign view',
            translateKey: 'campaign_view'
        }
    })
        .state('app.marketing-campaigns.edit', {
        url: '/{id:int}/edit',
        component: 'marketingCampaign',
        data: {
            auth: true,
            title: 'Edit a Marketing campaign',
            translateKey: 'edit_a_marketing_campaign'
        }
    })
        .state('app.marketing-campaigns.copy', {
        url: '/{id:int}/copy',
        component: 'marketingCampaign',
        data: {
            auth: true,
            title: 'Copy a Marketing campaign',
            translateKey: 'copy_a_marketing_campaign'
        }
    })
        .state('app.marketplace', {
        url: '/marketplace',
        component: 'adForMarketplace',
        data: {
            auth: true,
            title: 'Ad for Marketplace',
            translateKey: 'ad_for_marketplace'
        }
    })
        .state('app.referral-accounts', {
        url: '/referral-accounts',
        component: 'referralAccounts',
        data: {
            auth: true,
            title: 'Referral Accounts',
            translateKey: 'menu_referral_accounts'
        },
        params: {
            page: { value: 1, squash: false },
            column: { value: 'ID', squash: false },
            order: { value: 'descending', squash: false },
            active: { value: 'true', squash: false },
            search: { value: '', squash: true }
        }
    })
        .state('app.jisppay', {
        url: '/jisppay',
        abstract: true,
        template: defaultTemplate,
        data: {
            auth: true
        }
    })
        .state('app.jisppay.places', {
        url: '/places',
        component: 'jispPayPlaces',
        data: {
            auth: true,
            title: 'jispPAY Places',
            translateKey: 'menu_jisp_pay_places'
        }
    })
        .state('app.jisppay.staff', {
        url: '/staff',
        component: 'jispPayStaff',
        data: {
            auth: true,
            title: 'Staff Accounts',
            translateKey: 'staff_accounts'
        }
    })
        .state('app.managers', {
        url: '/managers',
        abstract: true,
        template: defaultTemplate,
        data: {
            auth: true
        }
    })
        .state('app.managers.accounts', {
        url: '/accounts',
        component: 'storeManagerAccounts',
        data: {
            auth: true,
            title: 'Store manager accounts',
            translateKey: 'store_manager_accounts',
            onlyRetailer: true
        }
    })
        .state('app.orderSettings', {
        url: '/orderSettings',
        abstract: true,
        template: defaultTemplate,
        data: {
            auth: true
        }
    })
        .state('app.orderSettings.locations', {
        url: '/locations',
        component: 'orderSettingsLocations',
        data: {
            auth: true,
            title: 'Order settings',
            translateKey: 'menu_order_settings'
        }
    })
        .state('app.discountForStaff', {
        abstract: true,
        template: defaultTemplate,
        url: '/discountForStaff',
        data: {
            auth: true
        }
    })
        .state('app.discountForStaffs', {
        url: '/discountForStaff',
        component: 'discountForStaffTabList',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.special', {
        url: '/special',
        component: 'discountForStaffSpecialTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.special.active', {
        url: '/active',
        component: 'discountForStaffSpecialActiveTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.special.archived', {
        url: '/archived',
        component: 'discountForStaffSpecialActiveTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.transaction', {
        url: '/transaction',
        component: 'discountForStaffHistoryTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.transaction.with-discount', {
        url: '/withDiscount',
        component: 'transactionWithDiscountTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.transaction.export', {
        url: '/export',
        component: 'transactionExportHistoryTab',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.discountForStaffs.transaction.singleTransaction', {
        url: '/single-transaction/{id:int}',
        component: 'discountForStaffSingleTransaction',
        data: {
            auth: true,
            title: 'Special discount for employees',
            translateKey: 'discount-for-staff-active-title'
        }
    })
        .state('app.analytics', {
        url: '/analytics',
        component: 'analytics',
        params: {
            no_anim: { value: 'true' }
        },
        data: {
            auth: true,
            title: 'Analytics',
            translateKey: 'menu_analytics'
        }
    })
        .state('app.warnings', {
        url: '/warnings',
        component: 'warnings',
        params: {
            no_anim: { value: 'true' }
        },
        data: {
            auth: true,
            title: 'Warnings',
            translateKey: 'menu_warnings'
        }
    })
        .state('app.clickAndDeliver', {
        url: '/clickAndDeliver',
        component: 'clickAndDeliver',
        params: {
            no_anim: { value: 'true' }
        },
        data: {
            auth: true,
            title: 'Click & Deliver',
            translateKey: 'menu_click_and_deliver'
        }
    })
        .state('app.vouchers', {
        abstract: true,
        url: '/vouchers',
        template: defaultTemplate,
        data: {
            auth: true
        }
    })
        .state('app.vouchers.list', {
        component: 'vouchersListComponent',
        url: '',
        data: {
            title: 'Vouchers',
            translateKey: 'vouchers',
            auth: true
        }
    })
        .state('app.vouchers.edit', {
        component: 'addOrEditVoucher',
        url: '/{id:int}/edit',
        data: {
            title: 'Edit vouchers',
            translateKey: 'vouchers_edit',
            auth: true
        }
    })
        .state('app.vouchers.new', {
        component: 'addOrEditVoucher',
        url: '/new',
        data: {
            title: 'New vouchers',
            translateKey: 'vouchers_new',
            auth: true
        }
    })
        .state('app.bundle', {
        abstract: true,
        template: defaultTemplate,
        url: '/bundle',
        data: {
            auth: true
        }
    })
        .state('app.bundles', {
        component: 'bundleListComponent',
        url: '/bundles',
        data: {
            title: 'Bundles',
            translateKey: 'bundles',
            auth: true
        }
    })
        .state('app.bundle.details', {
        component: 'bundleDetailsComponent',
        url: '/{id:int}',
        data: {
            title: 'Bundle Details',
            translateKey: 'bundle_details',
            auth: true
        }
    })
        .state('app.bundle.new', {
        component: 'newEditBundleComponent',
        url: '/new',
        data: {
            title: 'New Bundle',
            translateKey: 'bundle_new',
            auth: true
        }
    })
        .state('app.bundle.edit', {
        component: 'newEditBundleComponent',
        url: '/{id:int}/edit',
        data: {
            title: 'Edit Bundle',
            translateKey: 'bundle_edit',
            auth: true
        }
    })
        .state('app.printers', {
        abstract: true,
        template: defaultTemplate,
        url: '/printers',
        data: {
            auth: true
        }
    })
        .state('app.printers.list', {
        component: 'printerListComponent',
        url: '/printers',
        data: {
            title: 'Printers',
            translateKey: 'printers',
            auth: true
        }
    })
        .state('app.printers.new', {
        component: 'addEditPrinterComponent',
        url: '/new',
        data: {
            title: 'New Printer',
            translateKey: 'printer_new',
            auth: true
        }
    })
        .state('app.printers.edit', {
        component: 'addEditPrinterComponent',
        url: '/{printerID:int}/{placeID:int}',
        data: {
            title: 'Edit Printer',
            translateKey: 'printer_edit',
            auth: true
        }
    });
    /* nfrn */
    $stateProvider
        .state('nfrn', {
        url: '/nfrn',
        abstract: true,
        template: defaultTemplate
    })
        .state('nfrn.applyToken', {
        url: '/applyToken?auth',
        params: {
            auth: { value: '', squash: false }
        },
        controller: ['$state', '$stateParams', '$localStorage', 'accountService', 'backToDashboardService', function ($state, $stateParams, $localStorage, accountService, backToDashboardService) {
                delete $localStorage.retailerAuthorizationData;
                accountService.updateRetailerToken($stateParams.auth);
                if (document.referrer) {
                    backToDashboardService.trySetLink(document.referrer);
                }
                $state.go('app.jisppay.staff');
            }],
        data: {
            auth: false
        }
    }).state('nfrn.seller', {
        url: '/seller?code&tabId',
        params: {
            code: { value: '', squash: false },
            tabId: { value: '', squash: false }
        },
        controller: ['$state', '$stateParams', 'jispPayAccountService', 'notificationService', 'siteRetailerHomeUrl', 'backToDashboardService',
            function ($state, $stateParams, jispPayAccountService, notificationService, siteRetailerHomeUrl, backToDashboardService) {
                notificationService.showWaitingMessage();
                jispPayAccountService.logInByLoginCode($stateParams.code)
                    .then(function (response) {
                    if (document.referrer) {
                        backToDashboardService.trySetLink(document.referrer);
                    }
                    if ($stateParams.tabId) {
                        jispPayAccountService.navigateTo(+$stateParams.tabId);
                    }
                    else {
                        jispPayAccountService.navigateToDefault();
                    }
                })["catch"](function (err) {
                    notificationService.showErrorMessage(err);
                    setTimeout(function () {
                        window.location.href = siteRetailerHomeUrl;
                    }, 5000);
                });
            }],
        data: {
            auth: false
        }
    });
    // help
    $stateProvider
        .state('help', {
        url: '/help',
        abstract: true
    })
        .state('help.dictionary', {
        url: '/dictionary',
        component: 'helpDictionary',
        data: {
            auth: false,
            title: 'List of categories and item types',
            translateKey: 'list_of_categories'
        }
    })
        .state('help.preferences', {
        url: '/preferences',
        component: 'helpPreferences',
        data: {
            auth: false,
            title: 'List of food preferences and allergens',
            translateKey: 'list_of_preferences'
        }
    })
        .state('help.countries', {
        url: '/countries',
        component: 'helpCountries',
        data: {
            auth: false,
            title: 'List of origin countries',
            translateKey: 'list_of_countries'
        }
    });
    // account management for unauth users
    $stateProvider
        .state('account', {
        url: '/account',
        abstract: true,
        template: __webpack_require__(78),
        data: {
            auth: false
        }
    })
        .state('account.login', {
        url: '/login',
        component: 'login',
        data: {
            auth: false,
            title: 'Log in',
            translateKey: 'log_in'
        }
    })
        .state('account.selectRole', {
        url: '/forgot',
        component: 'selectRole',
        data: {
            auth: false,
            title: 'Select your position',
            translateKey: 'forgot_password_str'
        }
    })
        .state('account.forgot', {
        url: '/forgot',
        component: 'forgotPassword',
        data: {
            auth: false,
            title: 'Forgot password',
            translateKey: 'forgot_password_str'
        }
    })
        .state('account.resetSuccess', {
        url: '/forgot',
        component: 'resetSuccess',
        data: {
            auth: false,
            title: 'Forgot password',
            translateKey: 'forgot_password_str'
        }
    })
        .state('account.reportSupervisor', {
        url: '/forgot',
        component: 'reportSupervisor',
        data: {
            auth: false,
            title: 'Report to your supervisor',
            translateKey: 'forgot_password_str'
        }
    })
        .state('account.reset', {
        url: '/reset/:id/:key',
        component: 'resetPassword',
        data: {
            auth: false,
            title: 'Reset password',
            translateKey: 'reset_password_str'
        }
    })
        .state('app.activeServices', {
        url: '/services/active',
        component: 'servicesTabs',
        params: {
            isActive: { value: true }
        },
        data: {
            auth: true,
            title: 'Services',
            translateKey: 'services_tab'
        }
    })
        .state('app.archivedServices', {
        url: '/services/archived',
        component: 'servicesTabs',
        params: {
            isActve: { value: false }
        },
        data: {
            auth: true,
            title: 'Services',
            translateKey: 'services_tab'
        }
    })
        .state('app.serviceCreate', {
        url: '/services/new',
        component: 'addOrEditService',
        data: {
            auth: true,
            title: 'Service',
            translateKey: 'services_tab'
        }
    })
        .state('app.editService', {
        url: '/services/{id}/edit',
        component: 'addOrEditService',
        data: {
            auth: true,
            title: 'Service',
            translateKey: 'services_tab'
        }
    })
        .state('app.downloads', {
        url: '/analytics/downloads',
        component: 'downloads',
        data: {
            auth: true,
            title: 'Downloads',
            translateKey: 'downloads'
        }
    })
        .state('app.publisherSettings', {
        url: '/publisher-settings',
        component: 'publisherSettings',
        data: {
            auth: true,
            title: 'Publisher Settings',
            translateKey: 'publisher_settings'
        }
    });
    // errors
    $stateProvider
        .state('errors', {
        url: '/errors',
        abstract: true,
        template: __webpack_require__(78)
    })
        .state('errors.notfound', {
        url: '/notfound',
        template: __webpack_require__(16)
    })
        .state('errors.forbidden', {
        url: '/forbidden',
        template: __webpack_require__(15)
    });
}
angular.module('naut').config(routesConfig);
routesConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$uiRouterProvider'];


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var AddOrEditServices = /** @class */ (function () {
    function AddOrEditServices($translate, notificationService, servicesService, accountService, popupService, $state, $stateParams, retailerService, $uibModal) {
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.servicesService = servicesService;
        this.accountService = accountService;
        this.popupService = popupService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.retailerService = retailerService;
        this.$uibModal = $uibModal;
        this.modalInstance = this;
        this.showMinPriceError = false;
        this.showMaxPriceError = false;
        this.showErrors = false;
        this.toolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'html']
        ];
        this.giftAidVisible = false;
        this.item = {
            Title: null,
            Description: null,
            PriceType: 0,
            Price: null,
            MinPrice: null,
            DefaultPrice: null,
            MaxPrice: null,
            AllowToEditPriceByShopper: false,
            GiftAid: false,
            FeeRecipient: 0,
            DisplayedInReceipt: false,
            LinkTitle: null
        };
        this.priceItem = {
            FixedPrice: 0,
            EditablePrice: {
                MinPrice: 0,
                DefaultPrice: 0,
                MaxPrice: 0
            },
            CurrencyCode: null,
            CurrencySign: null
        };
        this.readModel = null;
        this.minSize = {
            w: 1032,
            h: 702
        };
        this.maxFileSize = 5;
        this.fileExtensions = ['jpeg', 'jpg', 'png', 'bmp', 'gif'];
    }
    AddOrEditServices.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.idParam = this.$stateParams.id;
                        this.isNew = !this.idParam;
                        if (!this.idParam) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadServiceItem()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.setCurrency();
                        _a.label = 3;
                    case 3:
                        // 1 - UK
                        this.giftAidVisible = this.accountService.userData.countryID === 1;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.loadServiceItem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a = this;
                        return [4 /*yield*/, this.servicesService.getService(this.idParam)];
                    case 1:
                        _a.readModel = _b.sent();
                        this.item = this.transform(this.readModel);
                        this.imageSrc = this.item.ImageID ? this.retailerService.serviceImage(this.item.ImageID, 128, 128) : null;
                        this.priceItem = this.readModel.Price;
                        this.currencyCssClass = this.getCurrencyCssClass(this.priceItem.CurrencySign);
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        this.notificationService.clearAll();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.waiting = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.setCurrency = function () {
        this.currencyCssClass = this.getCurrencyCssClass(this.accountService.userData.currencySign);
    };
    AddOrEditServices.prototype.getCurrencyCssClass = function (sign) {
        switch (sign) {
            case '£':
                return 'withPound';
            case 'kr':
                return 'withKrona';
            case '$':
                return 'withDollar';
            case '€':
                return 'withEuro';
            case 'د.إ':
                return 'withDirham';
            default:
                return '';
        }
    };
    AddOrEditServices.prototype.showEditablePriceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                classPopup: 'popup--redesign modal360',
                                title: this.$translate.instant('service_editable_price_title'),
                                content: this.$translate.instant('service_editable_price_content'),
                                okClass: 'btn btn-success w80',
                                okTxt: this.$translate.instant('ok'),
                                noCancelButton: true
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.showGiftAidInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                classPopup: 'popup--redesign modal360',
                                title: this.$translate.instant('service_gift_aid_title'),
                                content: this.$translate.instant('service_gift_aid_content'),
                                okClass: 'btn btn-success w80',
                                okTxt: this.$translate.instant('ok'),
                                noCancelButton: true
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.createService = function () {
        var _this = this;
        this.validateFixedPrice();
        this.validatePrice();
        this.validateMinPrice();
        this.validateMaxPrice();
        if (this.serviceForm.$invalid) {
            this.showErrors = true;
            window.scrollTo(0, 0);
        }
        else {
            this.showErrors = false;
            this.notificationService.showWaitingMessage();
            this.item.DefaultPrice = this.item.PriceType === 1 ? this.item.Price : 0;
            this.servicesService.saveService(this.item, this.idParam)
                .then(function () {
                _this.notificationService.clearAll();
                _this.$state.go('app.activeServices', { isActive: true });
            })["catch"](function (error) {
                _this.notificationService.clearAll();
                _this.notificationService.showErrorMessage(error);
            });
        }
    };
    AddOrEditServices.prototype.saveButtonDisabled = function () {
        return !(this.item.Title && this.item.Description);
    };
    AddOrEditServices.prototype.discard = function () {
        this.$state.go('app.activeServices', { isActive: true });
    };
    AddOrEditServices.prototype.uploadLogo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var image, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'jispPayAvatar',
                                resolve: {
                                    avatarId: function () { return _this.item ? _this.item.ImageID : null; },
                                    title: function () { return _this.$translate.instant('service_image'); },
                                    sizeText: function () { return _this.$translate.instant('store_photo_min_size_hint', { width: _this.minSize.w, height: _this.minSize.h }); },
                                    getUrl: function () { return _this.item && _this.item.ImageID ? _this.retailerService.serviceImage(_this.item.ImageID) : null; },
                                    imageSize: function () { return _this.minSize; },
                                    maxFileSizeMb: function () { return _this.maxFileSize; },
                                    disableAspectRatio: function () { return true; },
                                    fileExtensions: function () { return _this.fileExtensions; }
                                },
                                backdrop: 'static',
                                windowClass: 'crop-image-dialog'
                            }).result];
                    case 2:
                        image = _a.sent();
                        if (!image) return [3 /*break*/, 4];
                        this.serviceForm.$setDirty();
                        return [4 /*yield*/, this.saveImage(image)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.removeImage = function () {
        this.imageSrc = '';
        this.item.ImageID = null;
    };
    AddOrEditServices.prototype.saveImage = function (imageFileData) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.item;
                        return [4 /*yield*/, this.servicesService.uploadServiceImage(imageFileData)];
                    case 1:
                        _a.ImageID = _b.sent();
                        this.imageSrc = this.retailerService.serviceImage(this.item.ImageID, 128, 128);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _b.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditServices.prototype.validateFixedPrice = function () {
        if (this.item.PriceType === 0 && this.serviceForm.price) {
            if (this.item.Price === null || this.item.Price === 0 || !this.item.Price) {
                this.serviceForm.price.$setValidity('fixedPrice', false);
            }
            else {
                this.serviceForm.price.$setValidity('fixedPrice', true);
            }
        }
    };
    AddOrEditServices.prototype.validatePrice = function () {
        if (this.item.PriceType === 1) {
            if (this.serviceForm.minPrice) {
                this.serviceForm.minPrice.$setValidity('minPrice', this.priceValid(this.item.MinPrice));
            }
            if (this.serviceForm.defaultPrice) {
                this.serviceForm.defaultPrice.$setValidity('minPrice', this.priceValid(this.item.Price));
            }
            if (this.serviceForm.maxPrice) {
                this.serviceForm.maxPrice.$setValidity('minPrice', this.priceValid(this.item.MaxPrice));
            }
        }
    };
    AddOrEditServices.prototype.validateMinPrice = function () {
        if (this.item.PriceType === 1 && this.serviceForm.minPrice) {
            if (this.item.MinPrice > this.item.Price) {
                this.serviceForm.minPrice.$setValidity('minPriceLower', false);
            }
            else {
                this.serviceForm.minPrice.$setValidity('minPriceLower', true);
            }
        }
    };
    AddOrEditServices.prototype.validateMaxPrice = function () {
        if (this.item.PriceType === 1 && this.serviceForm.maxPrice) {
            if (this.item.MaxPrice && this.item.MaxPrice < this.item.Price) {
                this.serviceForm.maxPrice.$setValidity('maxPriceLower', false);
            }
            else if (!this.item.MaxPrice) {
                this.serviceForm.maxPrice.$setValidity('maxPriceLower', true);
            }
            else {
                this.serviceForm.maxPrice.$setValidity('maxPriceLower', true);
            }
        }
    };
    AddOrEditServices.prototype.priceValid = function (price) {
        return price == null || parseFloat(price.toString()) !== 0;
    };
    AddOrEditServices.prototype.transform = function (readModel) {
        return {
            Title: readModel.Title,
            Description: readModel.Description,
            PriceType: readModel.PriceType,
            Price: readModel.Price.FixedPrice || readModel.Price.EditablePrice.DefaultPrice || 0,
            MinPrice: readModel.Price.EditablePrice ? readModel.Price.EditablePrice.MinPrice : null,
            DefaultPrice: readModel.Price.EditablePrice ? readModel.Price.EditablePrice.DefaultPrice : 0,
            MaxPrice: readModel.Price.EditablePrice ? readModel.Price.EditablePrice.MaxPrice : null,
            AllowToEditPriceByShopper: readModel.AllowToEditPriceByShopper,
            GiftAid: readModel.GiftAid,
            FeeRecipient: readModel.FeeRecipient,
            DisplayedInReceipt: readModel.DisplayedInReceipt,
            LinkTitle: readModel.LinkTitle,
            ImageID: readModel.ImageID
        };
    };
    AddOrEditServices.$inject = [
        '$translate',
        'notificationService',
        'servicesService',
        'accountService',
        'popupService',
        '$state',
        '$stateParams',
        'retailerService',
        '$uibModal'
    ];
    return AddOrEditServices;
}());
angular.module('naut').component('addOrEditService', {
    template: __webpack_require__(844),
    controller: AddOrEditServices,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var ServicesTabs = /** @class */ (function () {
    function ServicesTabs($uibModal, $state, $translate, notificationService, popupService, servicesService, $localStorage, retailerService) {
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.servicesService = servicesService;
        this.$localStorage = $localStorage;
        this.retailerService = retailerService;
        this.search = {
            placeholder: '',
            text: ''
        };
        this.waiting = false;
        this.canLoadMore = true;
        this.services = [];
        this.total = 0;
        this.forSearch = false;
        this.searchMessageContent = '';
        this.itemsLimit = 20;
        this.isActive = true;
        this.isActive = $state.params.isActive;
    }
    ServicesTabs.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                this.loadData(false);
                return [2 /*return*/];
            });
        });
    };
    ServicesTabs.prototype.deleteService = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('archive_service_title'),
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer w102',
                                content: "<span>" + this.$translate.instant('archive_service_message', { name: service.Title }) + "</span>",
                                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent w106',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('button_archive'),
                                hasIcon: true
                            })];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.servicesService.archiveService(service.ID)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage();
                        return [3 /*break*/, 5];
                    case 5:
                        this.resetList();
                        this.loadData(false);
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _a.sent();
                        this.waiting = false;
                        return [2 /*return*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ServicesTabs.prototype.onEdit = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$state.go('app.editService', { id: service.ID });
                return [2 /*return*/];
            });
        });
    };
    ServicesTabs.prototype.restoreService = function (service) {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_3, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, 7, 8]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('service_restore_title'),
                                content: "<span>" + this.$translate.instant('restore_service_message', { name: service.Title }) + "</span>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer w102',
                                okClass: 'btn btn-with-icon btn-with-icon--before-restore btn-success flexVerticalAlignParent w107',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('restore'),
                                hasIcon: true
                            })];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.servicesService.restoreService(service.ID)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage();
                        return [3 /*break*/, 5];
                    case 5:
                        this.resetList();
                        this.loadData(false);
                        return [3 /*break*/, 8];
                    case 6:
                        error_4 = _a.sent();
                        this.waiting = false;
                        return [2 /*return*/];
                    case 7:
                        this.notificationService.clearAll();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    ServicesTabs.prototype.loadData = function (forSearch) {
        var _this = this;
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;
        var filter = {
            IsArchive: !this.isActive,
            Limit: this.itemsLimit,
            SortColumn: 'name',
            SortOrder: 0,
            SearchAfterID: this.services.length ? _.last(this.services).ID : null,
            keyword: forSearch ? this.search.text : null
        };
        this.notificationService.showWaitingMessage();
        this.servicesService.getServices(filter)
            .then(function (result) {
            _this.forSearch = forSearch;
            _this.total = result.Total;
            var services = result.Items;
            Array.prototype.push.apply(_this.services, services);
            _this.waiting = false;
            _this.canLoadMore = result.Items.length === _this.itemsLimit;
            if (_this.services.length > 0) {
                return;
            }
            if (_this.search.text && forSearch) {
                _this.searchMessageContent = _this.$translate.instant('services_list_not_found_screen_content', { search: _this.search.text });
            }
            _this.notificationService.clearAll();
        })["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () {
            _this.waiting = false;
            _this.notificationService.clearAll();
        });
    };
    ServicesTabs.prototype.setTab = function (isActive) {
        this.isActive = isActive;
        this.resetList();
        this.resetSearch();
        if (this.isActive) {
            this.$state.go('app.activeServices', { isActive: true });
        }
        else {
            this.$state.go('app.archivedServices', { isActive: false });
        }
    };
    ServicesTabs.prototype.resetSearch = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.search.text = '';
                this.applySearch('');
                return [2 /*return*/];
            });
        });
    };
    ServicesTabs.prototype.applySearch = function (searchText) {
        this.search.text = searchText;
        this.resetList();
        this.loadData(searchText.length > 0);
    };
    ServicesTabs.prototype.getPriceTypeText = function (priceType) {
        if (priceType === 0) {
            return this.$translate.instant('services_fixed');
        }
        else {
            return this.$translate.instant('services_editable');
        }
    };
    ServicesTabs.prototype.getImageUrl = function (service) {
        return this.retailerService.serviceImage(service.ImageID, 48, 48);
    };
    ServicesTabs.prototype.resetList = function () {
        this.canLoadMore = true;
        this.total = 0;
        this.services = [];
    };
    ServicesTabs.$inject = [
        '$uibModal',
        '$state',
        '$translate',
        'notificationService',
        'popupService',
        'servicesService',
        '$localStorage',
        'retailerService'
    ];
    return ServicesTabs;
}());
exports.ServicesTabs = ServicesTabs;
angular.module('naut').component('servicesTabs', {
    template: __webpack_require__(845),
    controller: ServicesTabs,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var SelectLocations = /** @class */ (function () {
    function SelectLocations(notificationService, retailerService, shopService) {
        var _this = this;
        this.notificationService = notificationService;
        this.retailerService = retailerService;
        this.shopService = shopService;
        this.modalInstance = this;
        this.model = {
            location: null,
            searchTerm: null,
            waiting: false
        };
        this.locations = [];
        this.total = 0;
        this.dismiss = function () { return _this.modalInstance.close({ $value: { status: 'close' } }); };
    }
    SelectLocations.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadLocations()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SelectLocations.prototype.loadLocations = function () {
        var _this = this;
        var selectedLocation = this.resolve.options.selectedLocationID ? {
            ID: this.resolve.options.selectedLocationID
        } : null;
        if (this.model.waiting) {
            return;
        }
        if (this.total && this.locations.length === this.total) {
            return;
        }
        var filter = {
            active: true,
            storeName: this.model.searchTerm,
            limit: 10,
            offset: this.locations.length,
            sortColumn: '',
            sortOrder: ''
        };
        if (this.resolve.options.onlyWithoutPrinter != null) {
            filter.onlyWithoutPrinter = this.resolve.options.onlyWithoutPrinter;
        }
        this.model.waiting = true;
        this.notificationService.showWaitingMessage();
        return this.shopService
            .getStores(filter)
            .then(function (response) {
            _this.total = response.Total;
            var locations = response.Items;
            Array.prototype.push.apply(_this.locations, locations);
            if (selectedLocation) {
                var foundLocation = locations.find(function (location) { return location.ID === selectedLocation.ID; });
                if (foundLocation) {
                    _this.model.location = foundLocation;
                }
            }
            if (_this.model && _this.model.location) {
                var foundLocation = locations.find(function (location) { return location.ID === _this.model.location.ID; });
                if (foundLocation) {
                    _this.model.location = foundLocation;
                }
            }
            _this.model.waiting = false;
        })["catch"](function (e) { return _this.notificationService.showErrorMessage(e); })["finally"](function () { return _this.notificationService.clearAll(); });
    };
    SelectLocations.prototype.searchKeyPressed = function ($event) {
        if ($event.which === 13 && !this.model.waiting) {
            this.search(this.model.searchTerm);
        }
    };
    SelectLocations.prototype.confirm = function () {
        var selectionResult = {
            status: 'ok',
            selectedLocation: {}
        };
        selectionResult.selectedLocation = this.model.location;
        this.modalInstance.close({ $value: selectionResult });
    };
    SelectLocations.prototype.search = function (text) {
        this.total = 0;
        this.locations = [];
        this.model.searchTerm = text;
        this.loadLocations();
    };
    SelectLocations.prototype.resetSearch = function () {
        this.model.searchTerm = '';
        this.locations = [];
        this.search(this.model.searchTerm);
    };
    SelectLocations.prototype.getLogoUrl = function (iconId) {
        return this.retailerService.getStoreLogoUrl(iconId, 48, 48);
    };
    SelectLocations.$inject = [
        'notificationService',
        'retailerService',
        'shopService'
    ];
    return SelectLocations;
}());
angular.module('naut').component('selectSingleLocation', {
    template: __webpack_require__(846),
    controller: SelectLocations,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var viewport_typed_controller_1 = __webpack_require__(4);
var StaffRatingDetailsComponent = /** @class */ (function (_super) {
    __extends(StaffRatingDetailsComponent, _super);
    function StaffRatingDetailsComponent($rootScope, $scope, $stateParams, $q, $timeout, popupService, notificationService, enums, staffRatingService, jispPayService, $translate) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.$timeout = $timeout;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.enums = enums;
        _this.staffRatingService = staffRatingService;
        _this.jispPayService = jispPayService;
        _this.$translate = $translate;
        _this.data = [];
        _this.dataSummary = {};
        _this.isScrollLoad = true;
        _this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            maxDate: new Date()
        };
        _this.dateOptionsMax = {
            formatYear: 'yyyy',
            maxDate: new Date(),
            startingDay: 0,
            minDate: new Date(new Date().getTime() - (1000 * 60 * 60 * 24) * 30)
        };
        _this.sortItems = [
            {
                title: _this.$translate.instant('date'),
                "class": 'amount-desc',
                order: 1,
                column: 'FeedbackLeftDateUTC'
            },
            {
                title: _this.$translate.instant('date'),
                "class": 'amount-asc',
                order: 0,
                column: 'FeedbackLeftDateUTC'
            },
            {
                title: _this.$translate.instant('rating'),
                "class": 'amount-desc',
                order: 1,
                column: 'Rating'
            },
            {
                title: _this.$translate.instant('rating'),
                "class": 'amount-asc',
                order: 0,
                column: 'Rating'
            }
        ];
        _this.settings = {
            pageSize: 10,
            currentPage: 1,
            dateFrom: new Date(new Date().getTime() - (1000 * 60 * 60 * 24) * 30),
            dateTo: new Date(),
            sortColumn: { name: 'Date', value: 'FeedbackLeftDateUTC' },
            sortVariants: [{ name: 'Date', value: 'FeedbackLeftDateUTC' }, { name: 'Rating', value: 'Rating' }],
            orderVariants: ['ascending', 'descending'],
            getFilter: function () {
                var i = _this.settings;
                return {
                    Limit: i.pageSize,
                    Offset: (i.currentPage - 1) * i.pageSize,
                    SortColumn: _this.sort.column,
                    StartDate: _this.settings.dateFrom ? _this.settings.dateFrom : null,
                    EndDate: _this.settings.dateTo ? _this.settings.dateTo : null,
                    SortOrder: _this.sort.order
                };
            }
        };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.sort = this.sortItems[0];
                this.getData();
                this.getSummaryData();
                return [2 /*return*/];
            });
        }); };
        _this.loadMore = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.isScrollLoad = true;
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.staffID = _this.$stateParams.id;
        _this.isArchive = _this.$stateParams.isArchive;
        _this.init();
        return _this;
    }
    StaffRatingDetailsComponent.prototype.setSortOrder = function (sort) {
        if (sort === this.sort) {
            return;
        }
        this.sort = sort;
    };
    StaffRatingDetailsComponent.prototype.onDateChange = function () {
        this.dateOptions.maxDate = this.settings.dateTo;
        this.dateOptionsMax.minDate = this.settings.dateFrom;
    };
    StaffRatingDetailsComponent.prototype.getAvatarUrl = function (id) {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 120, 120)
            : '';
    };
    StaffRatingDetailsComponent.prototype.getShopperAvatarUrl = function (id) {
        return (id)
            ? this.staffRatingService.getShopperAvatarUrl(id, 48, 48)
            : '';
    };
    StaffRatingDetailsComponent.prototype.showComments = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.data = [];
                this.settings.currentPage = 1;
                if (this.waiting) {
                    return [2 /*return*/];
                }
                this.isScrollLoad = false;
                this.getData();
                return [2 /*return*/];
            });
        });
    };
    StaffRatingDetailsComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        filter = this.settings.getFilter();
                        return [4 /*yield*/, this.staffRatingService.getStaffRatingDataByID(this.staffID, filter)];
                    case 1:
                        data = _a.sent();
                        _.forEach(data.Items, function (shopperComment) {
                            shopperComment.AvatarUrl = _this.getShopperAvatarUrl(shopperComment.AvatarID);
                        });
                        if (this.isScrollLoad) {
                            this.data = this.data.concat(data.Items);
                        }
                        else {
                            this.data = data.Items;
                        }
                        this.settings.currentPage++;
                        this.total = data.Total;
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingDetailsComponent.prototype.getSummaryData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staffRatingService.getStaffRatingSummaryByID(this.staffID)];
                    case 1:
                        data = _a.sent();
                        data.AvatarUrl = this.getAvatarUrl(data.AvatarID);
                        this.dataSummary = data;
                        console.log(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingDetailsComponent.$inject = ['$rootScope', '$scope', '$stateParams', '$q', '$timeout',
        'popupService', 'notificationService', 'enumService', 'staffRatingService', 'jispPayService', '$translate'];
    return StaffRatingDetailsComponent;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut').component('staffRatingDetails', {
    template: __webpack_require__(847),
    controller: StaffRatingDetailsComponent,
    controllerAs: 'vm'
});


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var viewport_typed_controller_1 = __webpack_require__(4);
var StaffRatingListComponent = /** @class */ (function (_super) {
    __extends(StaffRatingListComponent, _super);
    function StaffRatingListComponent($rootScope, $scope, $window, $stateParams, $q, $timeout, popupService, notificationService, staffRatingService, enums, jispPayService, transferFileService, $translate) {
        var _this = _super.call(this, $rootScope) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$window = $window;
        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.$timeout = $timeout;
        _this.popupService = popupService;
        _this.notificationService = notificationService;
        _this.staffRatingService = staffRatingService;
        _this.enums = enums;
        _this.jispPayService = jispPayService;
        _this.transferFileService = transferFileService;
        _this.$translate = $translate;
        _this.data = [];
        _this.dataSummary = {};
        _this.isScrollLoad = true;
        _this.sortCounter = 0;
        _this.prevSortColumn = 'Name';
        _this.skipWatch = false;
        _this.settings = {
            pageSize: 10,
            currentPage: 0,
            sort: _this.staffRatingService.getColumnSort(),
            isStaffAny: {
                active: null,
                archived: false
            },
            filter: {
                isActive: true
            },
            getFilter: function () {
                var i = _this.settings;
                return {
                    Limit: i.pageSize,
                    Offset: (i.currentPage - 1) * i.pageSize,
                    SortColumn: i.sort.column,
                    SortOrder: i.sort.order,
                    IsActive: i.filter.isActive
                };
            }
        };
        _this.loadMore = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting) {
                            return [2 /*return*/];
                        }
                        this.isScrollLoad = true;
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.getData();
                this.getSummaryData();
                this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.isActive'], function (n, o) {
                    if (_this.skipWatch) {
                        _this.skipWatch = false;
                        return;
                    }
                    _this.settings.currentPage = 1;
                    _this.isScrollLoad = false;
                    if (_this.prevSortColumn !== n[0]) {
                        _this.sortCounter = 0;
                    }
                    if (_this.settings.sort.column !== 'Name') {
                        _this.sortCounter++;
                    }
                    if (_this.sortCounter === 3) {
                        _this.settings.sort.column = 'Name';
                        _this.settings.sort.order = _this.settings.sort.asc;
                        _this.sortCounter = 0;
                        _this.skipWatch = true;
                    }
                    _this.prevSortColumn = n[0];
                    if (n && n !== o) {
                        _this.getData();
                        _this.getSummaryData();
                    }
                });
                return [2 /*return*/];
            });
        }); };
        _this.init();
        return _this;
    }
    StaffRatingListComponent.prototype.getAvatarUrl = function (id) {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 48, 48)
            : '';
    };
    StaffRatingListComponent.prototype.exportCsv = function () {
        var _this = this;
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        var params = this.getParams(0, 0);
        var fileName = 'Staff-rating_' + this.getFormatedDate(new Date());
        var promise = this.staffRatingService.getSalesAssistantCsv(params);
        this.handlePromise(promise).then(function (file) {
            _this.transferFileService.transferFile(file, fileName, _this.enums.ExportFileType.CSV);
            _this.notificationService.clearAll();
        });
    };
    StaffRatingListComponent.prototype.getFormatedDate = function (date) {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear() + '-'
            + ('0' + date.getHours()).slice(-2) + '-' + ('0' + date.getMinutes()).slice(-2) + '-' + ('0' + date.getSeconds()).slice(-2);
    };
    StaffRatingListComponent.prototype.handlePromise = function (promise) {
        var _this = this;
        this.waiting = true;
        promise["catch"](function (error) { return _this.notificationService.showErrorMessage(error); })["finally"](function () { return _this.waiting = false; });
        return promise;
    };
    StaffRatingListComponent.prototype.getParams = function (offset, limit) {
        return {
            Offset: offset,
            Limit: limit,
            SortOrder: this.settings.sort.order,
            SortColumn: this.settings.sort.column,
            IsArchive: !this.settings.filter.isActive
        };
    };
    StaffRatingListComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var filter, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.jispPayService.isStaffAny(true).then(function (result) {
                            _this.settings.isStaffAny.active = result;
                        });
                        this.jispPayService.isStaffAny(false).then(function (result) {
                            _this.settings.isStaffAny.archived = result;
                        });
                        filter = this.settings.getFilter();
                        return [4 /*yield*/, this.staffRatingService.getStaffRatingData(filter)];
                    case 1:
                        data = _a.sent();
                        _.forEach(data.Items, function (staff) {
                            staff.AvatarUrl = _this.getAvatarUrl(staff.AvatarID);
                        });
                        if (this.isScrollLoad) {
                            this.data = this.data.concat(data.Items);
                        }
                        else {
                            this.data = data.Items;
                        }
                        console.log(this.data);
                        this.total = data.Total;
                        this.settings.currentPage++;
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingListComponent.prototype.getSummaryData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staffRatingService.getStaffRatingSummary(!this.settings.filter.isActive)];
                    case 1:
                        data = _a.sent();
                        this.dataSummary = data;
                        console.log(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    StaffRatingListComponent.$inject = ['$rootScope', '$scope', '$window', '$stateParams', '$q', '$timeout',
        'popupService', 'notificationService', 'staffRatingService', 'enumService', 'jispPayService', 'transferFileService', '$translate'];
    return StaffRatingListComponent;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut').component('staffRatingList', {
    template: __webpack_require__(848),
    controller: StaffRatingListComponent,
    controllerAs: 'vm'
});


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var RatingStarsComponent = /** @class */ (function () {
    function RatingStarsComponent($scope, $translate) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.showLabel = true;
    }
    RatingStarsComponent.$inject = ['$scope', '$translate'];
    return RatingStarsComponent;
}());
angular.module('naut').component('ratingStars', {
    template: __webpack_require__(849),
    controller: RatingStarsComponent,
    controllerAs: 'vm',
    bindings: {
        'rating': '<',
        'showLabel': '<',
        'starsCount': '<'
    }
});


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var StaffRatingService = /** @class */ (function () {
    function StaffRatingService(http, retailerService, $serializer) {
        this.http = http;
        this.retailerService = retailerService;
        this.$serializer = $serializer;
    }
    StaffRatingService.prototype.getColumnSort = function (name, isAsc) {
        return {
            column: name ? name : 'Name',
            order: 0,
            asc: 0,
            desc: 1,
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            set: function (name, isAsc) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                }
                else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'Name';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort: function (list, field, asc) {
                return asc ? _.sortBy(list, field) : _.sortBy(list, field).reverse();
            },
            isSelected: function (field) {
                return this.column === field;
            }
        };
    };
    StaffRatingService.prototype.getStaffRatingSummary = function (isArchived) {
        return this.http.get(this.retailerService.staffRatingSummary(isArchived));
    };
    StaffRatingService.prototype.getStaffRatingData = function (filter) {
        return this.http.get(this.retailerService.staffRatingData(filter.Offset, filter.Limit, filter.SortColumn, filter.SortOrder, filter.IsActive));
    };
    StaffRatingService.prototype.getStaffRatingSummaryByID = function (id) {
        return this.http.get(this.retailerService.staffRatingSummaryByID(id));
    };
    StaffRatingService.prototype.getStaffRatingDataByID = function (id, filter) {
        return this.http.get(this.retailerService.staffRatingDataByID(id, filter.Offset, filter.Limit, filter.SortColumn, filter.SortOrder, filter.StartDate ? filter.StartDate.toISOString() : null, filter.EndDate ? filter.EndDate.toISOString() : null));
    };
    StaffRatingService.prototype.setStaffRatingSettings = function (model) {
        return this.http.post(this.retailerService.staffRatingSettings(), model);
    };
    StaffRatingService.prototype.getShopperAvatarUrl = function (id, width, height) {
        var baseUrl = this.retailerService.retailerShopper();
        var params = this.$serializer({ width: width, height: height });
        return baseUrl + "/avatar/" + id + "?" + params;
    };
    StaffRatingService.prototype.getSalesAssistantCsv = function (query) {
        return this.http.get(this.retailerService.exportSalesAssistant(), { params: query });
    };
    StaffRatingService.$inject = ['http', 'retailerService', '$httpParamSerializer'];
    return StaffRatingService;
}());
exports.StaffRatingService = StaffRatingService;
angular
    .module('naut')
    .service('staffRatingService', StaffRatingService);


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var StoreManagerAccountComponent = /** @class */ (function () {
    function StoreManagerAccountComponent($scope, $timeout, storeManagerService, notificationService, definitionService, $translate) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.storeManagerService = storeManagerService;
        this.notificationService = notificationService;
        this.definitionService = definitionService;
        this.$translate = $translate;
        this.modalInstance = this;
        this.data = {
            title: this.$translate.instant('store_manager_account'),
            textBtn: '',
            showPassword: false,
            isPasswordExist: false,
            isEditStaff: false,
            password: '••••••••••••',
            places: null,
            staffEmail: '',
            model: null,
            staffID: null,
            error: {
                firstName: null,
                lastName: null,
                email: null,
                password: null,
                places: null,
                clean: function () {
                    var i = _this.data.error;
                    i.firstName = null;
                    i.lastName = null;
                    i.email = null;
                    i.password = null;
                    i.places = null;
                },
                isEmpty: function () {
                    var i = _this.data.error;
                    return _.isEmpty(i.firstName) && _.isEmpty(i.lastName) &&
                        _.isEmpty(i.email) && _.isEmpty(i.password) &&
                        _.isEmpty(i.places);
                }
            },
            isValidModel: function () {
                var i = _this.data;
                var required = _this.$translate.instant('required_field');
                var staff = i.model;
                var error = i.error;
                error.clean();
                // first name
                staff.FirstName = _this.trim(staff.FirstName);
                var size = _.size(staff.FirstName);
                if (size === 0) {
                    error.firstName = required;
                }
                else if (size < 3) {
                    error.firstName = _this.$translate.instant('first_name_too_short');
                }
                else if (size > 20) {
                    error.firstName = _this.$translate.instant('first_name_too_long');
                }
                // last name
                staff.LastName = _this.trim(staff.LastName);
                size = _.size(staff.LastName);
                if (size === 0) {
                    error.lastName = required;
                }
                else if (size < 3) {
                    error.lastName = _this.$translate.instant('last_name_too_short');
                }
                else if (size > 20) {
                    error.lastName = _this.$translate.instant('last_name_too_long');
                }
                // email
                staff.Email = _this.trim(staff.Email);
                size = _.size(staff.Email);
                if (size === 0) {
                    error.email = required;
                }
                else if (size > 100) {
                    error.email = _this.$translate.instant('email_too_long_100');
                }
                else if (!_this.definitionService.regexEmail.test(staff.Email)) {
                    error.email = _this.$translate.instant('email_is_invalid');
                }
                // password
                staff.Password = _this.trim(staff.Password);
                size = _.size(staff.Password);
                if (!i.isEditStaff && size === 0) {
                    error.password = required;
                }
                else if (size > 0 && size < 8) {
                    error.password = _this.$translate.instant('password_too_short_8');
                }
                else if (size > 20) {
                    error.password = _this.$translate.instant('password_too_long_20');
                }
                return error.isEmpty();
            }
        };
    }
    StoreManagerAccountComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountComponent.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.data.textBtn = this.$translate.instant(this.resolve.staff ? 'button_save' : 'button_create');
                        this.data.isPasswordExist = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
                        this.data.isEditStaff = this.resolve.staff && _.isNumber(this.resolve.staff.ID);
                        this.data.places = this.resolve.places ? _.filter(_.map(this.resolve.places, function (place) {
                            place.selected = _this.resolve.staff ? _.contains(_this.resolve.staff.PlacesID, place.ID) : false;
                            return place;
                        }), function (place) {
                            return place.selected || place.IsActive;
                        }) : [];
                        this.data.staffEmail = this.resolve.staff ? this.resolve.staff.Email : '';
                        this.data.model = {
                            FirstName: this.resolve.staff ? this.resolve.staff.FirstName : '',
                            LastName: this.resolve.staff ? this.resolve.staff.LastName : '',
                            Email: this.resolve.staff ? this.resolve.staff.Email : '',
                            Password: '',
                            PlacesID: this.resolve.staff ? this.resolve.staff.PlacesID : []
                        };
                        this.data.staffID = this.resolve.staff ? this.resolve.staff.ID : null;
                        this.$scope.$watch('$ctrl.data.model.Email', function (n, o) { return __awaiter(_this, void 0, void 0, function () {
                            var exist, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(n && n !== o && n.trim().toLowerCase() !== this.data.staffEmail.toLowerCase() && this.definitionService.regexEmail.test(this.data.model.Email))) return [3 /*break*/, 4];
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, this.storeManagerService.managerAccountEmailExist(n)];
                                    case 2:
                                        exist = _a.sent();
                                        if (exist) {
                                            this.data.error.email = this.$translate.instant('email_is_in_use');
                                        }
                                        else {
                                            this.data.error.email = null;
                                        }
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_1 = _a.sent();
                                        this.notificationService.showErrorMessage(error_1);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, this.$timeout(0)];
                    case 1:
                        _a.sent();
                        $('.manager-stores__wrap').slimScroll({
                            height: 'auto',
                            alwaysVisible: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountComponent.prototype.changePlaces = function () {
        this.data.model.PlacesID = _.pluck(_.where(this.data.places, { selected: true }), 'ID');
    };
    StoreManagerAccountComponent.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.data.isValidModel()) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (this.data.isEditStaff
                                ? this.storeManagerService.updateStaff(this.data.staffID, this.data.model)
                                : this.storeManagerService.createStaff(this.data.model))];
                    case 2:
                        _a.sent();
                        this.notificationService.showSuccessMessage();
                        this.modalInstance.close({ $value: true });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountComponent.prototype.close = function () {
        this.modalInstance.dismiss({ $value: 'cancel' });
    };
    StoreManagerAccountComponent.prototype.trim = function (str) {
        return str ? str.trim() : '';
    };
    StoreManagerAccountComponent.$inject = ['$scope', '$timeout', 'storeManagerService', 'notificationService', 'definitionsService', '$translate'];
    return StoreManagerAccountComponent;
}());
angular.module('naut').component('storeManagerAccount', {
    template: __webpack_require__(850),
    controller: StoreManagerAccountComponent,
    controllerAs: '$ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var popupServiceCancel_1 = __webpack_require__(5);
var StoreManagerAccountsController = /** @class */ (function () {
    function StoreManagerAccountsController($rootScope, $scope, $q, storeManagerService, shopService, popupService, notificationService, $translate) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$q = $q;
        this.storeManagerService = storeManagerService;
        this.shopService = shopService;
        this.popupService = popupService;
        this.notificationService = notificationService;
        this.$translate = $translate;
        this.waiting = false;
        this.staff = null;
        this.settings = {
            pageSize: 10,
            page: 1,
            places: [],
            isStaffAny: {
                active: null,
                archived: false
            },
            isAllStaffSelected: false,
            filter: {
                place: null,
                keyword: null,
                isActive: true
            },
            sort: this.storeManagerService.getColumnSort(),
            getFilter: function () {
                var i = _this.settings;
                var placeID = i.filter.place ? i.filter.place.ID : '';
                var keyword = i.filter.keyword ? i.filter.keyword.trim() : '';
                return {
                    limit: i.pageSize,
                    offset: (i.page - 1) * i.pageSize,
                    sortColumn: i.sort.column,
                    sortOrder: i.sort.order,
                    placeID: placeID,
                    keyword: keyword,
                    isActive: i.filter.isActive
                };
            },
            setPlaces: function (places) {
                var i = _this.settings;
                i.places = _.isArray(places) ? angular.copy(places) : [];
                i.places.unshift({
                    ID: null,
                    Name: _this.$translate.instant('all')
                });
            },
            setCheckboxes: function () {
                var i = _this.settings;
                if (_this.staff) {
                    _.forEach(_this.staff.Items, function (staff) {
                        staff.selected = i.isAllStaffSelected;
                    });
                }
            },
            changeSelected: function (staff) {
                _this.settings.isAllStaffSelected = _.all(_this.staff.Items, function (staff) {
                    return staff.selected;
                });
            },
            isStaffSelected: function () {
                return _this.staff ? _.any(_this.staff.Items, function (staff) {
                    return staff.selected;
                }) : false;
            },
            showPanel: function () {
                var i = _this.settings;
                return (i.filter.isActive && i.isStaffAny.active) || (!i.filter.isActive && i.isStaffAny.archived);
            },
            isPlacesAny: function () {
                return _.size(_this.placesModel.active) > 0;
            }
        };
        this.placesModel = {
            all: [],
            active: [],
            archived: [],
            set: function (places) {
                var i = _this.placesModel;
                i.all = places;
                _.forEach(i.all, function (place) {
                    place.info = place.Name + ', ' + place.Town + ', ' + place.Address;
                });
                i.active = _.where(places, { IsActive: true });
                i.archived = _.where(places, { IsActive: false });
            }
        };
    }
    StoreManagerAccountsController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var places, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.shopService.getStoresForManager()];
                    case 1:
                        places = _a.sent();
                        this.placesModel.set(places);
                        this.getManagers();
                        this.settings.setPlaces(this.placesModel.active);
                        this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.keyword',
                            'vm.settings.filter.place', 'vm.settings.page', 'vm.settings.filter.isActive'], function (n, o) {
                            _this.settings.isAllStaffSelected = false;
                            _this.settings.setCheckboxes();
                            if (n && n !== o) {
                                _this.getManagers();
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.prototype.archiveStaff = function (staff) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedStaff, size, popupContent, popupTitle, li_1, ul, ids, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedStaff = [];
                        if (staff) {
                            selectedStaff = [staff];
                        }
                        else {
                            selectedStaff = _.where(this.staff.Items, { selected: true });
                        }
                        size = _.size(selectedStaff);
                        if (size === 0) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        popupContent = "<p>" + this.$translate.instant(size > 1 ? 'archive_selected_accounts_confirm' : 'acrhive_a_selected_account_confirm') + "</p>";
                        popupTitle = this.$translate.instant(size > 1 ? 'archive_selected_accounts' : 'acrhive_a_selected_account');
                        li_1 = '';
                        _.forEach(selectedStaff, function (staff) {
                            li_1 += '<li>' + staff.FirstName + ' ' + staff.LastName + '</li>';
                        });
                        ul = '<ul>' + li_1 + '</ul>';
                        return [4 /*yield*/, this.popupService.confirm({
                                title: popupTitle,
                                content: popupContent + ul,
                                okTxt: this.$translate.instant('no'),
                                cancelTxt: this.$translate.instant('yes'),
                                cancelClass: 'btn-success',
                                invertAction: true
                            })];
                    case 2:
                        _a.sent();
                        this.notificationService.showWaitingMessage();
                        ids = _.pluck(selectedStaff, 'ID');
                        return [4 /*yield*/, this.storeManagerService.archiveAccount(ids)];
                    case 3:
                        _a.sent();
                        this.getManagers();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClickInstance(error_2)) {
                            this.notificationService.showErrorMessage(error_2);
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.prototype.restoreStaff = function (staff) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedStaff, ids, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedStaff = [];
                        if (staff) {
                            selectedStaff = [staff];
                        }
                        else {
                            selectedStaff = _.where(this.staff.Items, { selected: true });
                        }
                        ids = _.pluck(selectedStaff, 'ID');
                        if (_.size(ids) === 0) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storeManagerService.restoreAccount(ids)];
                    case 2:
                        _a.sent();
                        this.settings.filter.isActive = true;
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.prototype.setStaff = function (staff) {
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.storeManagerService.openAccountManager(staff, this.placesModel.all)];
                    case 1:
                        _a.sent();
                        this.getManagers();
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        if (!popupServiceCancel_1.PopupServiceCancel.isCancelOrBackdropClick(error_4)) {
                            this.notificationService.showErrorMessage(error_4);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.prototype.getManagers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.$q.all([this.storeManagerService.getAccounts(this.settings.getFilter()), this.storeManagerService.isAccountAny(true), this.storeManagerService.isAccountAny(false)])];
                    case 2:
                        response = _a.sent();
                        this.notificationService.clearAll();
                        this.staff = response[0];
                        this.settings.isStaffAny.active = response[1];
                        this.settings.isStaffAny.archived = response[2];
                        _.forEach(this.staff.Items, function (staff) {
                            staff.places = [];
                            _.forEach(staff.PlacesID, function (id) {
                                var place = _.findWhere(_this.placesModel.all, { ID: id });
                                if (place) {
                                    staff.places.push({
                                        id: place.ID,
                                        info: place.info,
                                        isActive: place.IsActive
                                    });
                                }
                            });
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.notificationService.showErrorMessage(error_5);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreManagerAccountsController.$inject = ['$rootScope', '$scope', '$q', 'storeManagerService',
        'shopService', 'popupService', 'notificationService', '$translate'];
    return StoreManagerAccountsController;
}());
angular
    .module('naut')
    .component('storeManagerAccounts', {
    template: __webpack_require__(851),
    controller: StoreManagerAccountsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var StoreManagerService = /** @class */ (function () {
    function StoreManagerService(http, $q, $uibModal, retailerService, $httpParamSerializer) {
        var _this = this;
        this.http = http;
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
        this.$httpParamSerializer = $httpParamSerializer;
        this.openAccountManager = function (staff, places) {
            return _this.$uibModal.open({
                component: 'storeManagerAccount',
                resolve: {
                    staff: function () { return staff; },
                    places: function () { return places; }
                },
                size: 'lg',
                windowClass: 'staffPopup',
                backdrop: 'static'
            }).result;
        };
    }
    StoreManagerService.prototype.getAccounts = function (filter) {
        return this.http.get(this.retailerService.storeManagers(), { params: filter });
    };
    StoreManagerService.prototype.isAccountAny = function (isActive) {
        return this.http.get(this.retailerService.storeManagerAny(isActive));
    };
    StoreManagerService.prototype.archiveAccount = function (ids) {
        return this.http["delete"](this.retailerService.storeManagerAccount(), { params: { id: ids } });
    };
    StoreManagerService.prototype.restoreAccount = function (ids) {
        return this.http.post(this.retailerService.storeManagerAccountRestore(), ids);
    };
    StoreManagerService.prototype.createStaff = function (staff) {
        return this.http.post(this.retailerService.storeManagerAccount(), staff);
    };
    StoreManagerService.prototype.updateStaff = function (id, staff) {
        return this.http.put(this.retailerService.storeManagerAccount(id), staff);
    };
    StoreManagerService.prototype.managerAccountEmailExist = function (email) {
        return this.http.get(this.retailerService.storeManagerAccountEmailExist(email));
    };
    StoreManagerService.prototype.getColumnSort = function (name, isAsc) {
        return {
            column: name ? name : 'ID',
            order: 'ascending',
            asc: 'ascending',
            desc: 'descending',
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            // tslint:disable-next-line: no-shadowed-variable
            set: function (name, isAsc) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                }
                else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'ID';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort: function (list, field, asc) {
                return asc ? _.sortBy(list, field) : _.sortBy(list, field).reverse();
            },
            isSelected: function (field) {
                return this.column === field;
            }
        };
    };
    StoreManagerService.$inject = ['http', '$q', '$uibModal', 'retailerService', '$httpParamSerializer'];
    return StoreManagerService;
}());
exports.StoreManagerService = StoreManagerService;
angular
    .module('naut')
    .service('storeManagerService', StoreManagerService);


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var CheckStickers = /** @class */ (function () {
    function CheckStickers($translate) {
        this.$translate = $translate;
        this.changesMap = [];
        this.initialValues = [];
    }
    CheckStickers.prototype.$onInit = function () {
        var _this = this;
        angular.forEach(this.stickers, function (item, index) { return _this.initialValues[index] = item.Code; });
    };
    CheckStickers.prototype.$onChanges = function (onChangesObj) {
        var changedObject = onChangesObj.stickers;
        if (!changedObject || !changedObject.currentValue || changedObject.currentValue.length === changedObject.previousValue.length
            || changedObject.currentValue.length > changedObject.previousValue.length) {
            return;
        }
        for (var i = 0; i < changedObject.previousValue.length; i++) {
            if (changedObject.previousValue[i] !== changedObject.currentValue[i]) {
                this.initialValues.splice(i, 1);
                this.changesMap.splice(i, 1);
                return;
            }
        }
    };
    CheckStickers.prototype.onStickerCodeChanged = function (index) {
        var initialValue = this.initialValues[index];
        if (!initialValue) {
            return;
        }
        this.changesMap[index] = this.stickers[index].Code !== initialValue;
    };
    CheckStickers.prototype.getPlaceholder = function () {
        return this.$translate.instant('sticker_placeholder');
    };
    CheckStickers.$inject = ['$translate'];
    return CheckStickers;
}());
angular.module('naut').component('checkStickers', {
    template: __webpack_require__(852),
    controller: CheckStickers,
    controllerAs: 'ctrl',
    bindings: {
        header: '<',
        stickers: '<',
        iconColorClass: '<',
        isWaiting: '<',
        isReadOnly: '<',
        onAddSticker: '&',
        onDeleteSticker: '&',
        isDeleteEnable: '<'
    }
});


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var ts_clipboard_1 = __webpack_require__(68);
var FoodMonitorUrlGenerator = /** @class */ (function () {
    FoodMonitorUrlGenerator.$inject = ["$translate", "$location", "orderSettingsService", "notificationService", "popupService"];
    function FoodMonitorUrlGenerator($translate, $location, orderSettingsService, notificationService, popupService) {
        this.$translate = $translate;
        this.$location = $location;
        this.orderSettingsService = orderSettingsService;
        this.notificationService = notificationService;
        this.popupService = popupService;
        this.hideMonitor = false;
    }
    FoodMonitorUrlGenerator.prototype.$onInit = function () {
        if (this.key) {
            this.url = this.createFullUrl(this.key, this.hideMonitor);
        }
    };
    FoodMonitorUrlGenerator.prototype.copyUrlToClipBoard = function () {
        ts_clipboard_1.Clipboard.copy(this.url);
        this.notificationService.showInfoMessage({
            title: this.$translate.instant('info'),
            body: this.$translate.instant('food_monitor_url_copy_message')
        });
        this.notificationService.clearAll();
    };
    FoodMonitorUrlGenerator.prototype.generateNewUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.orderSettingsService.generateMonitorKey()];
                    case 1:
                        _a.key = _b.sent();
                        this.url = this.createFullUrl(this.key, this.hideMonitor);
                        this.sendChangeEnable();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FoodMonitorUrlGenerator.prototype.addOrDeleteHideParam = function () {
        this.url = this.createFullUrl(this.key, this.hideMonitor);
        this.sendChangeEnable();
    };
    FoodMonitorUrlGenerator.prototype.changeMonitorEnable = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $event.preventDefault();
                        $event.stopPropagation();
                        if (!!this.key) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.generateNewUrl()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.isEnabled) {
                            this.isEnabled = true;
                            this.sendChangeEnable();
                            return [2 /*return*/];
                        }
                        if (!this.isEnabled) return [3 /*break*/, 6];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.popupService.confirm({
                                okClass: 'btn-new btn-new-cancel',
                                okTxt: this.$translate.instant('food_monitor_disable_dialog_cancel'),
                                cancelClass: 'btn-new btn-new-disable',
                                cancelTxt: this.$translate.instant('food_monitor_disable_dialog_ok'),
                                classPopup: 'popup--redesign modal360',
                                title: this.$translate.instant('food_monitor_disable_dialog_title'),
                                content: this.$translate.instant('food_monitor_disable_dialog_content'),
                                invertAction: true
                            })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 6:
                        this.isEnabled = false;
                        this.sendChangeEnable();
                        return [2 /*return*/];
                }
            });
        });
    };
    FoodMonitorUrlGenerator.prototype.sendChangeEnable = function () {
        var monitor = { isEnabled: this.isEnabled, key: this.key, hideMonitor: this.hideMonitor };
        this.onKeyChanged({ monitorState: monitor });
    };
    FoodMonitorUrlGenerator.prototype.createFullUrl = function (monitorKey, addHideMonitorParam) {
        var protocol = location.protocol === 'https:' ? 'https://' : 'http://';
        var hostName = location.host;
        return "" + protocol + hostName + "/fm?key=" + monitorKey + (addHideMonitorParam ? '&hideBody=1' : '');
    };
    FoodMonitorUrlGenerator.inject = ['$translate', '$location', 'orderSettingsService', 'notificationService'];
    return FoodMonitorUrlGenerator;
}());
angular.module('naut').component('foodMonitorUrlGenerator', {
    template: __webpack_require__(853),
    controller: FoodMonitorUrlGenerator,
    controllerAs: 'ctrl',
    bindings: {
        editMode: '<',
        key: '<',
        hideMonitor: '<',
        isEnabled: '<',
        onKeyChanged: '&'
    }
});


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var _ = __webpack_require__(1);
var viewport_typed_controller_1 = __webpack_require__(4);
var iUser_1 = __webpack_require__(239);
var models_1 = __webpack_require__(247);
var STICKER_PATTERN = '[A-Z]{1}\\d{12}$';
var OrderSettingsLocations = /** @class */ (function (_super) {
    __extends(OrderSettingsLocations, _super);
    function OrderSettingsLocations($scope, orderSettingsService, notificationService, $translate, enumService, $timeout, popupService, $rootScope, languageService) {
        var _this = _super.call(this, $scope) || this;
        _this.$scope = $scope;
        _this.orderSettingsService = orderSettingsService;
        _this.notificationService = notificationService;
        _this.$translate = $translate;
        _this.enumService = enumService;
        _this.$timeout = $timeout;
        _this.popupService = popupService;
        _this.$rootScope = $rootScope;
        _this.languageService = languageService;
        _this.checkInStickersTitle = '';
        _this.checkOutStickersTitle = '';
        _this.monitorState = null;
        _this.waiting = false;
        _this.places = null;
        _this.isPlacesAny = null;
        _this.scanAction = _this.enumService.ProductScanAction;
        _this.edit = {
            isOpenEdit: false,
            newCheckInCode: null,
            newCheckOutCode: null,
            newCheckInNfcStickers: [],
            newCheckOutNfcStickers: [],
            isGrocery: true,
            model: {
                DefaultProductScanAction: _this.scanAction.AddToCart,
                ShoppingScanMethod: models_1.EShoppingScanMethod.BARCODE,
                PinCode: null,
                CheckInNfcStickerCodes: [],
                CheckOutNfcStickerCodes: [],
                CheckInNfcStickers: [],
                CheckOutNfcStickers: [],
                BagCheckSettings: null,
                ShoppingFlows: {
                    JispGoOrPreOrder: {
                        Available: false,
                        Enabled: false
                    },
                    InStore: {
                        Available: false,
                        Enabled: false
                    },
                    ClickCollect: {
                        Available: false,
                        Enabled: false
                    },
                    Delivery: {
                        Available: false,
                        Enabled: false
                    }
                },
                PayNowEnabled: null,
                CollectWithoutPincode: null,
                MonitorKey: null,
                FoodMonitor: null,
                HideMonitor: null,
                PayOutsideJispEnabled: null,
                CarrierBagEnabled: false
            },
            error: {
                defaultProductScanAction: null,
                checkInNfcStickerCodes: null,
                checkOutNfcStickerCodes: null,
                checkInNfcStickers: null,
                checkOutNfcStickers: null,
                bagCheckSettingsChance: null,
                clean: function () {
                    var i = _this.edit.error;
                    i.defaultProductScanAction = null;
                    i.checkInNfcStickers = null;
                    i.checkOutNfcStickers = null;
                    i.bagCheckSettingsChance = null;
                },
                isEmpty: function () {
                    var i = _this.edit.error;
                    return _.isEmpty(i.defaultProductScanAction) &&
                        _.isEmpty(i.checkInNfcStickers) &&
                        _.isEmpty(i.checkOutNfcStickers) &&
                        _.isEmpty(i.bagCheckSettingsChance);
                }
            },
            setModel: function (place) {
                var editModel = _this.edit.model;
                editModel.DefaultProductScanAction = place ? place.DefaultProductScanAction : _this.defaultScanAction;
                editModel.PinCode = place ? place.PinCode : null;
                editModel.PayNowEnabled = place ? place.PayNowEnabled : null;
                editModel.CollectWithoutPincode = place ? place.CollectWithoutPincode : null;
                editModel.CarrierBagEnabled = place ? place.CarrierBagEnabled : _this.edit.model.CarrierBagEnabled;
                editModel.ShoppingFlows = place && place.ShoppingFlows ? __assign({}, place.ShoppingFlows) : editModel.ShoppingFlows;
                _this.edit.newCheckInNfcStickers = place && _.any(place.CheckInNfcStickers) ?
                    place.CheckInNfcStickers.map(function (item) { return _this.getStickerItem(item); }) : [_this.getStickerItem()];
                _this.edit.newCheckOutNfcStickers = place && _.any(place.CheckOutNfcStickers) ?
                    place.CheckOutNfcStickers.map(function (item) { return _this.getStickerItem(item); }) : [_this.getStickerItem()];
                _this.defaultScanAction = _this.$rootScope.userData.retailerType === iUser_1.IRetailerType.LIGHT ? _this.scanAction.AddToCart : _this.scanAction.ShowDetails;
                var flows = place ? place.ShoppingFlows : null;
                if (place) {
                    if (place.ShoppingScanMethod) {
                        editModel.ShoppingScanMethod = place.ShoppingScanMethod;
                    }
                    else {
                        editModel.ShoppingScanMethod = flows.InStore.Enabled ? models_1.EShoppingScanMethod.NFC : models_1.EShoppingScanMethod.BARCODE;
                    }
                }
                else {
                    editModel.ShoppingScanMethod = models_1.EShoppingScanMethod.BARCODE;
                }
                if (flows && !flows.JispGoOrPreOrder.Enabled) {
                    _this.edit.isGrocery = false;
                    if (!editModel.DefaultProductScanAction) {
                        editModel.DefaultProductScanAction = _this.scanAction.ShowDetails;
                    }
                }
                else {
                    _this.edit.isGrocery = true;
                    if (!editModel.DefaultProductScanAction) {
                        editModel.DefaultProductScanAction = _this.scanAction.AddToCart;
                    }
                }
                editModel.BagCheckSettings = {
                    Enabled: place ? place.RandomCheckEnabled : false,
                    Chance: place ? place.RandomCheckChance : null,
                    DailyLimit: place ? place.RandomCheckDayLimit : null
                };
                editModel.FoodMonitor = place ? place.FoodMonitor : null;
                editModel.MonitorKey = place ? place.MonitorKey : null;
                editModel.HideMonitor = place ? place.HideMonitor : null;
                editModel.PayOutsideJispEnabled = place ? place.PayOutsideJispEnabled : null;
                _this.edit.error.clean();
            },
            isEmptyStickersList: function (stickers) {
                return stickers && stickers.length > 0;
            },
            refreshScanAction: function () {
                var i = _this.edit.model;
                var stickers = _.filter(_this.edit.newCheckOutNfcStickers, function (item) { return !_.isEmpty(item.Code); });
                if (_.isEmpty(stickers)) {
                    _this.edit.isGrocery = false;
                    if (i.DefaultProductScanAction === _this.scanAction.AddToCart) {
                        i.DefaultProductScanAction = _this.scanAction.ShowDetails;
                    }
                }
                else {
                    _this.edit.isGrocery = true;
                    if (i.DefaultProductScanAction === _this.scanAction.FlickeringCards) {
                        i.DefaultProductScanAction = _this.scanAction.AddToCart;
                    }
                }
            }
        };
        _this.jispGoAndInStoreTooltip = _this.$translate.instant('jisp_go_and_in_store_message');
        _this.tapTapTooltip = _this.$translate.instant('tap_tap_tooltip');
        _this.maxLength = 64;
        _this.hideMonitorStatuses = new Map();
        _this.defaultScanAction = _this.scanAction.ShowDetails;
        return _this;
    }
    OrderSettingsLocations.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var countryID, langSettings, fracSign, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        countryID = this.$rootScope.userData.countryID;
                        langSettings = this.languageService.getLangSettingsOrDefault(countryID);
                        // uk or ireland
                        if (countryID === 1 || countryID === 4) {
                            fracSign = langSettings.currencyFracSign;
                            this.bagFee = '20' + fracSign;
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getPlaces()];
                    case 2:
                        _a.sent();
                        this.setCheckInAndCheckOutTitles();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.placeEdit = function (place) {
        place.isOpenEdit = true;
        this.edit.isOpenEdit = true;
        this.edit.newCheckInCode = null;
        this.edit.newCheckOutCode = null;
        this.edit.setModel(place);
    };
    OrderSettingsLocations.prototype.cancelEdit = function (place) {
        place.isOpenEdit = false;
        this.edit.isOpenEdit = false;
        this.edit.setModel();
    };
    OrderSettingsLocations.prototype.monitorKeyChanged = function (monitorState) {
        this.edit.model.MonitorKey = monitorState.key;
        this.edit.model.FoodMonitor = monitorState.isEnabled;
        this.edit.model.HideMonitor = monitorState.hideMonitor;
    };
    OrderSettingsLocations.prototype.save = function (place) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var newCheckInStickers, newCheckOutStickers, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newCheckInStickers = this.edit.newCheckInNfcStickers.map(function (item) { return item.Code; });
                        newCheckOutStickers = this.edit.newCheckOutNfcStickers.map(function (item) { return item.Code; });
                        this.edit.model.CheckInNfcStickerCodes = newCheckInStickers;
                        this.edit.model.CheckOutNfcStickerCodes = newCheckOutStickers;
                        if (!this.isValidEditModel()) {
                            return [2 /*return*/];
                        }
                        this.hideMonitorStatuses.set(place.ID, this.edit.model.HideMonitor);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this.notificationService.showWaitingMessage();
                        return [4 /*yield*/, this.orderSettingsService.setPlace(place.ID, this.toServerData(this.edit.model))];
                    case 2:
                        _a.sent();
                        this.$timeout(function () {
                            var currentPlace = _this.places.find(function (x) { return x.ID === place.ID; });
                            currentPlace.CheckInNfcStickers = newCheckInStickers;
                            currentPlace.CheckOutNfcStickers = newCheckOutStickers;
                        }, 100);
                        return [4 /*yield*/, this.getPlaces()];
                    case 3:
                        _a.sent();
                        this.restoreHideMonitorStatuses();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.addCheckInCode = function () {
        if (this.isValidStickers(this.edit.newCheckInNfcStickers)) {
            this.edit.newCheckInNfcStickers.push(this.getStickerItem());
        }
        this.edit.refreshScanAction();
    };
    OrderSettingsLocations.prototype.deleteCheckInCode = function (sticker) {
        return __awaiter(this, void 0, void 0, function () {
            var first, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.confirmDeleteSticker()];
                    case 1:
                        _b.sent();
                        if (_.size(this.edit.newCheckInNfcStickers) === 1) {
                            first = _.first(this.edit.newCheckInNfcStickers);
                            first.Code = '';
                            first.error = null;
                            return [2 /*return*/];
                        }
                        this.edit.newCheckInNfcStickers = _.reject(this.edit.newCheckInNfcStickers, function (item) { return item === sticker; });
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.addCheckOutCode = function () {
        if (this.isValidStickers(this.edit.newCheckOutNfcStickers)) {
            this.edit.newCheckOutNfcStickers.push(this.getStickerItem());
        }
        this.edit.refreshScanAction();
    };
    OrderSettingsLocations.prototype.deleteCheckOutCode = function (sticker) {
        return __awaiter(this, void 0, void 0, function () {
            var first, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.confirmDeleteSticker()];
                    case 1:
                        _b.sent();
                        if (_.size(this.edit.newCheckOutNfcStickers) === 1) {
                            first = _.first(this.edit.newCheckOutNfcStickers);
                            first.Code = '';
                            first.error = null;
                        }
                        else {
                            this.edit.newCheckOutNfcStickers = _.reject(this.edit.newCheckOutNfcStickers, function (item) { return item === sticker; });
                        }
                        this.edit.refreshScanAction();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.changeModelCollectedEnabled = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $event.preventDefault();
                        $event.stopPropagation();
                        if (this.edit.model.CollectWithoutPincode === true) {
                            this.edit.model.CollectWithoutPincode = false;
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.popupService.confirm({
                                cancelClass: 'btn btn-with-icon btn-with-icon--before-close btn-danger',
                                cancelTxt: this.$translate.instant('order_settings_collected_dialog_cancel'),
                                okClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                                okTxt: this.$translate.instant('order_settings_collected_dialog_ok'),
                                classPopup: 'alert--redesign modal360',
                                title: this.$translate.instant('order_settings_collected_dialog_header'),
                                content: this.$translate.instant('order_settings_collected_dialog_content'),
                                closeOnClickOutside: false
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 4:
                        this.edit.model.CollectWithoutPincode = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.onPaymentMethodChanged = function () {
        var _this = this;
        var flows = this.edit.model.ShoppingFlows;
        var actions = this.enumService.ProductScanAction;
        if (!flows.JispGoOrPreOrder.Enabled) {
            this.edit.model.PayNowEnabled = false;
            this.edit.model.FoodMonitor = false;
        }
        var showed = [actions.AddToCart, actions.FlickeringCards, actions.ShowDetails, actions.TapTap].filter(function (action) {
            switch (action) {
                case actions.AddToCart:
                    return _this.addToCardVisible();
                case actions.FlickeringCards:
                    return _this.showCardsVisible();
                case actions.ShowDetails:
                    return _this.showDetailsVisible();
                case actions.TapTap:
                    return _this.tapTapAllowed();
            }
        });
        if (showed.length === 0) {
            this.edit.model.DefaultProductScanAction = this.defaultScanAction;
        }
        else {
            if (showed.indexOf(this.defaultScanAction) !== -1) {
                this.edit.model.DefaultProductScanAction = this.defaultScanAction;
            }
            else {
                this.edit.model.DefaultProductScanAction = actions.ShowDetails;
            }
        }
        this.setShoppingScanMethod();
    };
    OrderSettingsLocations.prototype.nfcScanningAllowed = function () {
        var flows = this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled) && !(flows.ClickCollect.Enabled || flows.Delivery.Enabled);
    };
    OrderSettingsLocations.prototype.barcodeScanningAllowed = function () {
        var flows = this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Enabled || flows.ClickCollect.Enabled || flows.Delivery.Enabled) && !flows.InStore.Enabled;
    };
    OrderSettingsLocations.prototype.getShoppingFlows = function (place) {
        var res = '';
        var flows = place.ShoppingFlows;
        if (flows) {
            if (flows.JispGoOrPreOrder.Enabled) {
                res += this.$translate.instant('store_payment_method_jispgo') + ", ";
            }
            if (flows.InStore.Enabled) {
                res += this.$translate.instant('buyInStore') + ", ";
            }
            if (flows.ClickCollect.Enabled) {
                res += this.$translate.instant('click_and_collect') + ", ";
            }
            if (flows.Delivery.Enabled) {
                res += this.$translate.instant('delivery');
            }
        }
        return res.replace(/,\s*$/, '');
    };
    OrderSettingsLocations.prototype.getPlaceNameWithAddress = function (place) {
        return place.Name + ", " + place.AddressLine1;
    };
    OrderSettingsLocations.prototype.saveDisabled = function () {
        var flows = this.edit.model.ShoppingFlows;
        return !(flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled || flows.ClickCollect.Enabled || flows.Delivery.Enabled);
    };
    OrderSettingsLocations.prototype.addToCardVisible = function () {
        var flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled;
    };
    OrderSettingsLocations.prototype.showDetailsVisible = function (place) {
        var flows = place ? place.ShoppingFlows : this.edit.model.ShoppingFlows;
        return (flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled) ||
            (flows.ClickCollect.Available && flows.ClickCollect.Enabled) ||
            (flows.InStore.Available && flows.InStore.Enabled) ||
            (flows.Delivery.Available && flows.Delivery.Enabled);
    };
    OrderSettingsLocations.prototype.showCardsVisible = function () {
        var flows = this.edit.model.ShoppingFlows;
        return (flows.InStore || flows.ClickCollect) && !flows.JispGoOrPreOrder;
    };
    OrderSettingsLocations.prototype.tapTapVisible = function () {
        var flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Available && flows.JispGoOrPreOrder.Enabled;
    };
    OrderSettingsLocations.prototype.tapTapAllowed = function () {
        var flows = this.edit.model.ShoppingFlows;
        return flows.JispGoOrPreOrder.Enabled && !(flows.ClickCollect.Enabled || flows.Delivery.Enabled || flows.InStore.Enabled);
    };
    OrderSettingsLocations.prototype.tapTapChecked = function () {
        return this.edit.model.DefaultProductScanAction === this.enumService.ProductScanAction.TapTap;
    };
    OrderSettingsLocations.prototype.setShoppingScanMethod = function () {
        var flows = this.edit.model.ShoppingFlows;
        if (flows.JispGoOrPreOrder.Enabled) {
            this.edit.model.ShoppingScanMethod = models_1.EShoppingScanMethod.BARCODE;
        }
        else if ((flows.ClickCollect.Enabled || flows.Delivery.Enabled) && !(flows.JispGoOrPreOrder.Enabled || flows.InStore.Enabled)) {
            this.edit.model.ShoppingScanMethod = models_1.EShoppingScanMethod.BARCODE;
        }
        else if (flows.InStore.Enabled) {
            this.edit.model.ShoppingScanMethod = models_1.EShoppingScanMethod.NFC;
        }
        else {
            this.edit.model.ShoppingScanMethod = models_1.EShoppingScanMethod.BARCODE;
        }
    };
    OrderSettingsLocations.prototype.confirmDeleteSticker = function () {
        return this.popupService.confirm({
            cancelClass: 'btn btn-with-icon btn-with-icon--before-close btn-danger',
            cancelTxt: this.$translate.instant('delete_sticker_dialog_content_cancel'),
            okClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
            okTxt: this.$translate.instant('delete_sticker_dialog_content_ok'),
            classPopup: 'alert--redesign modal360',
            title: this.$translate.instant('delete_sticker_dialog_title'),
            content: this.$translate.instant('delete_sticker_dialog_content')
        });
    };
    OrderSettingsLocations.prototype.isValidEditModel = function () {
        var _this = this;
        var i = this.edit;
        i.error.clean();
        var flows = i.model.ShoppingFlows;
        if (flows.JispGoOrPreOrder.Enabled && i.model.ShoppingScanMethod === models_1.EShoppingScanMethod.NFC &&
            !i.model.PayNowEnabled && i.newCheckOutNfcStickers.filter(function (item) { return item.Code; }).length === 0) {
            this.notificationService.showErrorMessage(this.$translate.instant('checkout_stickers_pay_now_error'));
            return false;
        }
        if (!flows.JispGoOrPreOrder.Enabled) {
            return i.error.isEmpty();
        }
        if (i.model.BagCheckSettings.Enabled && !i.model.BagCheckSettings.Chance) {
            i.error.bagCheckSettingsChance = this.$translate.instant('required_field');
        }
        var checkInStickerAreValid = _.all(i.newCheckInNfcStickers, function (s) { return _.isEmpty(s.Code); })
            || this.isValidStickers(i.newCheckInNfcStickers);
        var checkOutStickerAreValid = flows.JispGoOrPreOrder.Enabled && i.model.ShoppingScanMethod === models_1.EShoppingScanMethod.NFC && !i.model.PayNowEnabled
            ? this.isValidStickers(i.newCheckOutNfcStickers)
            : _.all(i.newCheckOutNfcStickers, function (s) { return _.isEmpty(s.Code); }) || this.isValidStickers(i.newCheckOutNfcStickers);
        var validStickers = checkInStickerAreValid && checkOutStickerAreValid;
        var inNfcStickerCodes = _.reject(i.newCheckInNfcStickers, function (item) { return _.isEmpty(item.Code); });
        var outNfcStickerCodes = _.reject(i.newCheckOutNfcStickers, function (item) { return _.isEmpty(item.Code); });
        if (!_.isEmpty(inNfcStickerCodes) && !_.isEmpty(outNfcStickerCodes)) {
            _.forEach(inNfcStickerCodes, function (inSticker) {
                var outSticker = _.findWhere(outNfcStickerCodes, { Code: inSticker.Code });
                if (!_.isUndefined(outSticker)) {
                    outSticker.error = _this.$translate.instant('this_code_is_already_used');
                    inSticker.error = _this.$translate.instant('this_code_is_already_used');
                    validStickers = false;
                }
            });
        }
        return validStickers && i.error.isEmpty();
    };
    OrderSettingsLocations.prototype.isValidStickers = function (stickers) {
        var _this = this;
        _.forEach(stickers, function (item) {
            item.error = null;
            item.Code = item.Code ? item.Code.trim() : '';
            if (_.isEmpty(item.Code)) {
                item.error = _this.$translate.instant('required_field');
                return;
            }
            if (_.size(item.Code) > _this.maxLength) {
                item.error = _this.$translate.instant('sticker_code_too_long');
                return;
            }
            if (!(new RegExp(STICKER_PATTERN).test(item.Code))) {
                item.error = _this.$translate.instant('invalid_field_format');
                return;
            }
            var couple = _.filter(stickers, function (i) { return !_.isEmpty(i.Code) && i.Code.toLowerCase() === item.Code.toLowerCase(); });
            if (_.size(couple) > 1) {
                _.forEach(couple, function (p) { return p.error = _this.$translate.instant('sticker_code_already_exists'); });
            }
        });
        return _.all(stickers, function (item) { return _.isEmpty(item.error); });
    };
    OrderSettingsLocations.prototype.getPlaces = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pagingResult, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.orderSettingsService.getPlaces({})];
                    case 2:
                        pagingResult = _a.sent();
                        this.places = this.toClientData(pagingResult.Items);
                        this.isPlacesAny = pagingResult.Total > 0;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.waiting = false;
                        this.edit.isOpenEdit = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderSettingsLocations.prototype.toClientData = function (places) {
        var data = angular.copy(places);
        _.forEach(data, function (place) {
            place.RandomCheckChance = place.RandomCheckChance ? parseFloat((place.RandomCheckChance * 100).toFixed(1)) : null;
        });
        return data;
    };
    OrderSettingsLocations.prototype.toServerData = function (place) {
        var data = angular.copy(place);
        data.BagCheckSettings.Chance = data.BagCheckSettings.Chance ? data.BagCheckSettings.Chance / 100 : null;
        return data;
    };
    OrderSettingsLocations.prototype.getStickerItem = function (item) {
        return {
            ID: 0,
            Code: item ? item : null,
            error: null
        };
    };
    OrderSettingsLocations.prototype.setCheckInAndCheckOutTitles = function () {
        this.checkInStickersTitle = this.$translate.instant('check_in_stickers');
        this.checkOutStickersTitle = this.$translate.instant('check_out_stickers');
    };
    OrderSettingsLocations.prototype.restoreHideMonitorStatuses = function () {
        var _this = this;
        this.places.forEach(function (place) {
            if (_this.hideMonitorStatuses.has(place.ID) && place.MonitorKey) {
                place.HideMonitor = _this.hideMonitorStatuses.get(place.ID);
            }
        });
    };
    OrderSettingsLocations.$inject = ['$scope', 'orderSettingsService', 'notificationService', '$translate', 'enumService', '$timeout', 'popupService', '$rootScope', 'languageService'];
    return OrderSettingsLocations;
}(viewport_typed_controller_1.ViewportController));
angular.module('naut').component('orderSettingsLocations', {
    template: __webpack_require__(854),
    controller: OrderSettingsLocations,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var OrderSettingsService = /** @class */ (function () {
    function OrderSettingsService(http, $uibModal, retailerService) {
        this.http = http;
        this.$uibModal = $uibModal;
        this.retailerService = retailerService;
    }
    OrderSettingsService.prototype.getPlaces = function (query) {
        return this.http.get(this.retailerService.tapAndGoPlaces(), { params: query });
    };
    OrderSettingsService.prototype.setPlace = function (id, model) {
        return this.http.put(this.retailerService.tapAndGoPlace(id), model);
    };
    OrderSettingsService.prototype.generateMonitorKey = function () {
        return this.http.get(this.retailerService.generateMonitorKey());
    };
    OrderSettingsService.$inject = ['http', '$uibModal', 'retailerService'];
    return OrderSettingsService;
}());
exports.OrderSettingsService = OrderSettingsService;
angular
    .module('naut')
    .service('orderSettingsService', OrderSettingsService);


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var core_1 = __webpack_require__(59);
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var models_1 = __webpack_require__(19);
var AddOrEditVoucherController = /** @class */ (function () {
    function AddOrEditVoucherController(notificationService, accountService, vouchersService, $scope, $state, $uibModal) {
        this.notificationService = notificationService;
        this.accountService = accountService;
        this.vouchersService = vouchersService;
        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.voucherTypes = [];
        this.voucherTypesEnum = models_1.VoucherTypesEnum;
        this.startDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: moment(new Date())
                .utc(true)
                .startOf('day')
                .toDate()
        };
        this.endDateOptions = {
            formatYear: 'yyyy',
            startingDay: 0,
            minDate: moment(new Date())
                .utc(true)
                .startOf('day')
                .toDate()
        };
        this.model = {
            VoucherType: null,
            DiscountValue: null,
            MinOrderPrice: null,
            StartDate: moment(new Date()).toDate(),
            EndDate: moment(new Date()).toDate(),
            VoucherCode: null,
            RestrictedCategoriesIDs: []
        };
        this.voucherErrors = {
            typeRequired: null,
            discountAmountRequired: null,
            discountPercentRequired: null,
            discountEqualZero: null,
            discountOverLimit: null,
            startDateInPast: null,
            endDateGreaterStartDate: null,
            codeMinLengthError: null,
            codeMaxLengthError: null,
            codeRequired: null,
            startDateRequired: null,
            endDateRequired: null,
            minOrderPriceEqualZero: null,
            minOrderPriceOverLimit: null
        };
        this.isPublished = false;
        this.scopeWatchers = [];
        this.categories = [];
        this.restrictedCategoriesIds = [];
    }
    AddOrEditVoucherController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, voucher;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currencySign = this.accountService.userData.currencySign;
                        this.currencyCssClass = this.getCurrencyCssClass(this.currencySign);
                        this.initVoucherTypesList();
                        return [4 /*yield*/, this.initCategories()];
                    case 1:
                        _a.sent();
                        this.model.RestrictedCategoriesIDs = this.restrictedCategoriesIds.slice();
                        id = parseInt(this.$state.params.id, 10);
                        this.editMode = !isNaN(id);
                        if (!this.editMode) return [3 /*break*/, 3];
                        this.voucherID = id;
                        return [4 /*yield*/, this.vouchersService.getVoucher(id)];
                    case 2:
                        voucher = _a.sent();
                        this.setVoucher(voucher);
                        _a.label = 3;
                    case 3:
                        this.setStartDateWatcher();
                        this.setTypeWatcher();
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVoucherController.prototype.$onDestroy = function () {
        this.scopeWatchers.forEach(function (watcher) { return watcher(); });
    };
    AddOrEditVoucherController.prototype.validateBeforeSave = function () {
        if (this.isFormValid()) {
            this.editMode
                ? this.updateVoucher(__assign({}, this.formVoucherBeforeSave(), { VoucherID: this.voucherID }))
                : this.saveVoucher(this.formVoucherBeforeSave());
        }
    };
    AddOrEditVoucherController.prototype.getCurrencyCssClass = function (sign) {
        switch (sign) {
            case '£':
                return 'withPound';
            case 'kr':
                return 'withKrona';
            case '$':
                return 'withDollar';
            case '€':
                return 'withEuro';
            case 'د.إ':
                return 'withDirham';
            default:
                return '';
        }
    };
    AddOrEditVoucherController.prototype.isFormFilled = function () {
        return Boolean(this.model.VoucherType) &&
            Boolean(this.model.StartDate) &&
            Boolean(this.model.EndDate) &&
            Boolean(this.model.VoucherCode) &&
            Boolean(this.model.VoucherType === models_1.VoucherTypesEnum.FreeDelivery || Boolean(this.model.DiscountValue));
    };
    AddOrEditVoucherController.prototype.selectCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var operationResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$uibModal.open({
                                component: 'selectCategory',
                                resolve: {
                                    categories: function () { return _this.categories.slice(); },
                                    disabledCategoriesIDs: function () { return _this.restrictedCategoriesIds.slice(); },
                                    categoriesIDs: function () { return _this.model.RestrictedCategoriesIDs.slice(); }
                                },
                                windowClass: 'popup--redesign modal512',
                                backdrop: 'static'
                            }).result];
                    case 1:
                        operationResult = _a.sent();
                        if (operationResult) {
                            this.model.RestrictedCategoriesIDs = operationResult.slice();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVoucherController.prototype.getExcludedCategoriesNames = function () {
        var _this = this;
        return this.categories
            .filter(function (category) { return !!_this.model.RestrictedCategoriesIDs.find(function (id) { return id === category.ID; }); })
            .map(function (category) { return category.Name; })
            .join(', ');
    };
    AddOrEditVoucherController.prototype.formVoucherBeforeSave = function () {
        var formedVoucherData = {
            DiscountValue: this.model.DiscountValue
                ? this.model.VoucherType === this.voucherTypesEnum.Percent
                    ? Number(this.model.DiscountValue) / 100
                    : Number(this.model.DiscountValue)
                : null,
            MinOrderPrice: Number(this.model.MinOrderPrice),
            StartDate: moment.utc(this.model.StartDate)
                .startOf('day')
                .toDate(),
            EndDate: moment.utc(this.model.EndDate)
                .startOf('day')
                .toDate()
        };
        return __assign({}, this.model, formedVoucherData);
    };
    AddOrEditVoucherController.prototype.saveVoucher = function (voucher) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.vouchersService.createVoucher(voucher)];
                    case 2:
                        _a.sent();
                        this.waiting = false;
                        this.notificationService.showSuccessMessage();
                        this.$state.go('app.vouchers.list');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVoucherController.prototype.updateVoucher = function (voucher) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.vouchersService.updateVoucher(voucher)];
                    case 2:
                        _a.sent();
                        this.waiting = false;
                        this.notificationService.showSuccessMessage();
                        this.$state.go('app.vouchers.list');
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVoucherController.prototype.setStartDateWatcher = function () {
        var _this = this;
        var voucherStartDateWatcher = this.$scope.$watch('ctrl.model.StartDate', function () {
            if (!_this.model) {
                return;
            }
            _this.endDateOptions.minDate = moment(_this.model.StartDate)
                .startOf('day')
                .toDate();
        });
        this.scopeWatchers.push(voucherStartDateWatcher);
    };
    AddOrEditVoucherController.prototype.setTypeWatcher = function () {
        var _this = this;
        var voucherTypeWatcher = this.$scope.$watch('ctrl.model.VoucherType', function (newValue, oldValue) {
            if (!_this.model) {
                return;
            }
            if (oldValue && newValue !== oldValue) {
                _this.model.DiscountValue = null;
                _this.voucherErrors.discountAmountRequired = null;
                _this.voucherErrors.discountPercentRequired = null;
                _this.voucherErrors.discountEqualZero = null;
                _this.voucherErrors.discountOverLimit = null;
            }
        });
        this.scopeWatchers.push(voucherTypeWatcher);
    };
    AddOrEditVoucherController.prototype.isFormValid = function () {
        var _this = this;
        this.voucherErrors.codeMinLengthError = this.model.VoucherCode && this.model.VoucherCode.length < 3;
        this.voucherErrors.codeMaxLengthError = this.model.VoucherCode && this.model.VoucherCode.length > 20;
        this.voucherErrors.codeRequired = !this.model.VoucherCode;
        this.voucherErrors.startDateRequired = !this.model.StartDate;
        this.voucherErrors.endDateRequired = !this.model.EndDate;
        this.voucherErrors.typeRequired = !this.model.VoucherType;
        this.voucherErrors.minOrderPriceEqualZero =
            this.model.MinOrderPrice && Number(this.model.MinOrderPrice) === 0;
        this.voucherErrors.minOrderPriceOverLimit =
            this.model.MinOrderPrice && Number(this.model.MinOrderPrice) > 999999.99;
        this.voucherErrors.startDateInPast = !this.isPublished && moment(this.model.StartDate).isBefore(this.startDateOptions.minDate);
        this.voucherErrors.endDateGreaterStartDate =
            moment(this.model.StartDate) > moment(this.model.EndDate);
        this.voucherErrors.discountAmountRequired =
            this.discountHasRequiredError(models_1.VoucherTypesEnum.FixedAmount);
        this.voucherErrors.discountPercentRequired =
            this.discountHasRequiredError(models_1.VoucherTypesEnum.Percent);
        this.voucherErrors.discountEqualZero = this.isDiscountEqualZero();
        this.voucherErrors.discountOverLimit = this.isDiscountOverLimit();
        return (Object.keys(this.voucherErrors).every(function (error) { return !_this.voucherErrors[error]; }));
    };
    AddOrEditVoucherController.prototype.discountHasRequiredError = function (type) {
        return this.model.VoucherType && this.model.VoucherType === type
            ? !this.model.DiscountValue
            : false;
    };
    AddOrEditVoucherController.prototype.isDiscountEqualZero = function () {
        return ((this.model.VoucherType === models_1.VoucherTypesEnum.FixedAmount || this.model.VoucherType === models_1.VoucherTypesEnum.Percent) &&
            this.model.DiscountValue &&
            Number(this.model.DiscountValue) === 0);
    };
    AddOrEditVoucherController.prototype.isDiscountOverLimit = function () {
        return ((this.model.VoucherType === models_1.VoucherTypesEnum.FixedAmount && this.model.DiscountValue && Number(this.model.DiscountValue) > 999999.99) ||
            (this.model.VoucherType === models_1.VoucherTypesEnum.Percent && this.model.DiscountValue && Number(this.model.DiscountValue) > 100));
    };
    AddOrEditVoucherController.prototype.setVoucher = function (voucher) {
        this.model = voucher;
        this.model.MinOrderPrice = this.model.MinOrderPrice && this.model.MinOrderPrice > 0 ? this.model.MinOrderPrice : null;
        this.model.EndDate = moment(this.model.EndDate).toDate();
        this.model.StartDate = moment(this.model.StartDate).toDate();
        this.model.DiscountValue = this.getPercentDiscountValue(this.model.VoucherType, this.model.DiscountValue);
        this.isPublished = voucher.Status === models_1.VoucherStatusEnum.Published;
        if (!this.model.RestrictedCategoriesIDs || this.model.RestrictedCategoriesIDs.length === 0) {
            this.model.RestrictedCategoriesIDs = this.restrictedCategoriesIds.slice();
        }
    };
    AddOrEditVoucherController.prototype.getPercentDiscountValue = function (type, value) {
        return type === this.voucherTypesEnum.Percent
            ? Number((value * 100).toFixed())
            : value;
    };
    AddOrEditVoucherController.prototype.initVoucherTypesList = function () {
        var _this = this;
        Object.keys(models_1.VoucherTypesEnum).filter(function (key) {
            if (typeof models_1.VoucherTypesEnum[key] === 'number') {
                _this.voucherTypes.push(models_1.VoucherTypesEnum[key]);
            }
        });
    };
    AddOrEditVoucherController.prototype.initCategories = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, core_1.$q.all({
                            allCategories: this.vouchersService.getClassificationCategories(),
                            restrictedCategories: this.vouchersService.getVoucherRestrictedCategories()
                        })];
                    case 1:
                        response = _a.sent();
                        this.categories = response.allCategories.sort(function (a, b) { return a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0; });
                        this.restrictedCategoriesIds = response.restrictedCategories;
                        return [2 /*return*/];
                }
            });
        });
    };
    AddOrEditVoucherController.$inject = [
        'notificationService',
        'accountService',
        'vouchersService',
        '$scope',
        '$state',
        '$uibModal'
    ];
    return AddOrEditVoucherController;
}());
angular.module('naut').component('addOrEditVoucher', {
    template: __webpack_require__(856),
    controller: AddOrEditVoucherController,
    controllerAs: 'ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = __webpack_require__(0);
var SelectCategoryDialogController = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function SelectCategoryDialogController() {
        this.modalInstance = this;
    }
    SelectCategoryDialogController.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var half, rightColumn, leftColumn;
            return __generator(this, function (_a) {
                this.selectedIds = this.resolve.categoriesIDs.slice();
                this.disabledIds = this.resolve.disabledCategoriesIDs.slice();
                half = Math.ceil(this.resolve.categories.length / 2);
                rightColumn = this.resolve.categories.slice();
                leftColumn = rightColumn.splice(0, half);
                this.columns = [leftColumn, rightColumn];
                return [2 /*return*/];
            });
        });
    };
    SelectCategoryDialogController.prototype.close = function () {
        this.modalInstance.close();
    };
    SelectCategoryDialogController.prototype.save = function () {
        this.modalInstance.close({ $value: this.selectedIds });
    };
    SelectCategoryDialogController.prototype.categorySelected = function (id) {
        return !!this.selectedIds.find(function (selectedId) { return selectedId === id; });
    };
    SelectCategoryDialogController.prototype.categoryDisabled = function (id) {
        return !!this.disabledIds.find(function (disabledId) { return disabledId === id; });
    };
    SelectCategoryDialogController.prototype.setSelected = function (id, value) {
        if (value) {
            this.selectedIds.push(id);
        }
        else {
            this.selectedIds = this.selectedIds.filter(function (item) { return item !== id; });
        }
    };
    SelectCategoryDialogController.$inject = [];
    return SelectCategoryDialogController;
}());
angular.module('naut').component('selectCategory', {
    template: __webpack_require__(857),
    controller: SelectCategoryDialogController,
    controllerAs: 'ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var core_1 = __webpack_require__(59);
var angular = __webpack_require__(0);
var moment = __webpack_require__(2);
var models_1 = __webpack_require__(19);
var VouchersListComponent = /** @class */ (function () {
    function VouchersListComponent($translate, notificationService, vouchersService, $localStorage, popupService, accountService) {
        this.$translate = $translate;
        this.notificationService = notificationService;
        this.vouchersService = vouchersService;
        this.$localStorage = $localStorage;
        this.popupService = popupService;
        this.accountService = accountService;
        this.waiting = false;
        this.canLoadMore = true;
        this.total = 0;
        this.vouchersList = [];
        this.itemsLimit = 20;
        this.voucherTypesEnum = models_1.VoucherTypesEnum;
        this.voucherStatusEnum = models_1.VoucherStatusEnum;
        this.dateFormat = 'd MMMM yyyy';
        this.isAdmin = false;
        this.categories = [];
    }
    VouchersListComponent.prototype.$onInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, core_1.$q.all({
                            isAdmin: this.accountService.isLoggedInAsAdmin(),
                            allCategories: this.vouchersService.getClassificationCategories()
                        })];
                    case 1:
                        response = _a.sent();
                        this.isAdmin = response.isAdmin;
                        this.categories = response.allCategories.sort(function (a, b) { return a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0; });
                        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
                        return [4 /*yield*/, this.loadData()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var filter, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.waiting || !this.canLoadMore) {
                            return [2 /*return*/];
                        }
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        filter = {
                            limit: this.itemsLimit,
                            offset: this.vouchersList ? this.vouchersList.length : 0
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.vouchersService.getVouchersList(filter)];
                    case 2:
                        response = _a.sent();
                        this.total = response.Total;
                        this.vouchersList = this.getVoucherList(response.Items);
                        this.canLoadMore = response.Items.length === this.itemsLimit;
                        this.waiting = false;
                        this.notificationService.clearAll();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.notificationService.showErrorMessage(error_1);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.prototype.publishVoucherConfirm = function (voucher) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('publish_voucher_title'),
                                content: "<p style=\"word-break: break-all\">\n            <span>" + this.$translate.instant('publish_voucher_content', {
                                    voucher: voucher.VoucherCode
                                }) + "</span> <br>\n            <span>" + this.$translate.instant('voucher_publish_alert') + "\n            </span>\n          </p>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-success flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('voucher_publish'),
                                hasIcon: true,
                                thinTitle: true
                            })];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.publishVoucher(voucher.VoucherID);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.prototype.deleteVoucherConfirm = function (voucher) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.popupService.confirm({
                                title: this.$translate.instant('delete_voucher_title'),
                                content: "<span style=\"word-break: break-all\">" + this.$translate.instant('delete_voucher_content', { voucher: voucher.VoucherCode }) + "</span>",
                                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                                classPopup: 'popup--redesign modal360',
                                cancelTxt: this.$translate.instant('cancel'),
                                okTxt: this.$translate.instant('delete'),
                                hasIcon: true,
                                thinTitle: true
                            })];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.deleteVoucher(voucher.VoucherID);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.prototype.getExcludedCategoriesNames = function (voucher) {
        return this.categories
            .filter(function (category) { return !!voucher.RestrictedCategoriesIDs.find(function (id) { return id === category.ID; }); })
            .map(function (category) { return category.Name; })
            .join(', ');
    };
    VouchersListComponent.prototype.resetVouchersList = function () {
        this.canLoadMore = true;
        this.total = 0;
        this.vouchersList = [];
    };
    VouchersListComponent.prototype.getVoucherList = function (vouchersResponse) {
        var formedVouchersList = vouchersResponse.map(function (voucher) {
            voucher.IsExpired = moment
                .utc(voucher.EndDate)
                .isBefore(moment.utc(new Date()), 'date');
            return voucher;
        });
        return this.vouchersList.concat(formedVouchersList);
    };
    VouchersListComponent.prototype.publishVoucher = function (voucherId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.vouchersService.publishVoucher(voucherId)];
                    case 2:
                        _a.sent();
                        this.waiting = false;
                        this.notificationService.showSuccessMessage();
                        this.resetVouchersList();
                        this.loadData();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.notificationService.showErrorMessage(error_2);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.prototype.deleteVoucher = function (voucherId) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.waiting = true;
                        this.notificationService.showWaitingMessage();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.vouchersService.deleteVoucher(voucherId)];
                    case 2:
                        _a.sent();
                        this.waiting = false;
                        this.notificationService.showSuccessMessage();
                        this.resetVouchersList();
                        this.loadData();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.notificationService.showErrorMessage(error_3);
                        this.waiting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VouchersListComponent.$inject = [
        '$translate',
        'notificationService',
        'vouchersService',
        '$localStorage',
        'popupService',
        'accountService'
    ];
    return VouchersListComponent;
}());
angular.module('naut').component('vouchersListComponent', {
    template: __webpack_require__(858),
    controller: VouchersListComponent,
    controllerAs: 'ctrl'
});


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var angular = __webpack_require__(0);
var VouchersService = /** @class */ (function () {
    function VouchersService(http, retailerService) {
        this.http = http;
        this.retailerService = retailerService;
    }
    VouchersService.prototype.getVouchersList = function (filter) {
        return this.http.get(this.retailerService.vouchers(), { params: filter });
    };
    VouchersService.prototype.getVoucher = function (id) {
        return this.http.get(this.retailerService.getVoucherById(id));
    };
    VouchersService.prototype.createVoucher = function (voucher) {
        return this.http.post(this.retailerService.vouchers(), voucher);
    };
    VouchersService.prototype.updateVoucher = function (voucher) {
        return this.http.put(this.retailerService.vouchers(), voucher);
    };
    VouchersService.prototype.deleteVoucher = function (voucherId) {
        var voucher = { VoucherID: voucherId };
        return this.http["delete"](this.retailerService.vouchers(), { params: voucher });
    };
    VouchersService.prototype.publishVoucher = function (voucherId) {
        var voucher = { VoucherID: voucherId };
        return this.http.patch(this.retailerService.publishVoucher(), voucher);
    };
    VouchersService.prototype.getClassificationCategories = function () {
        return this.http.get(this.retailerService.categoriesForVouchers());
    };
    VouchersService.prototype.getVoucherRestrictedCategories = function () {
        return this.http.get(this.retailerService.getVoucherRestrictedCategories());
    };
    VouchersService.$inject = ['http', 'retailerService'];
    return VouchersService;
}());
exports.VouchersService = VouchersService;
angular
    .module('naut')
    .service('vouchersService', VouchersService);


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var angular = __webpack_require__(0);
var viewport_typed_controller_1 = __webpack_require__(4);
var WarningsController = /** @class */ (function (_super) {
    __extends(WarningsController, _super);
    function WarningsController($scope, $translate) {
        var _this = _super.call(this, $scope) || this;
        _this.$scope = $scope;
        _this.$translate = $translate;
        return _this;
    }
    WarningsController.$inject = ['$scope', '$translate'];
    return WarningsController;
}(viewport_typed_controller_1.ViewportController));
angular
    .module('naut')
    .component('warnings', {
    template: __webpack_require__(859),
    controller: WarningsController,
    controllerAs: 'vm'
});


/***/ }),
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.ShopperStaffDiscountItemStatusEnum = {
    None: 0,
    Active: 1,
    ExpiredSoon: 2,
    Expired: 3
};


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;
var Open360RetailerApiModelsCreateNfcOperationRequest;
(function (Open360RetailerApiModelsCreateNfcOperationRequest) {
    Open360RetailerApiModelsCreateNfcOperationRequest.AssignTypeEnum = {
        NUMBER_1: 1,
        NUMBER_2: 2
    };
})(Open360RetailerApiModelsCreateNfcOperationRequest = exports.Open360RetailerApiModelsCreateNfcOperationRequest || (exports.Open360RetailerApiModelsCreateNfcOperationRequest = {}));


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
exports.__esModule = true;


/***/ }),
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[238]);


// WEBPACK FOOTER //
// retailer-37ba14cd7c84fbf38dd2.js